import * as e from "react";
import t, { Component as n, Fragment as r, cloneElement as i, createContext as a, createElement as o, createRef as s, forwardRef as c, memo as l, useCallback as u, useContext as d, useDeferredValue as f, useEffect as p, useImperativeHandle as m, useLayoutEffect as h, useMemo as g, useReducer as _, useRef as v, useState as y } from "react";
import { ErrorBoundary as b, displayAllowedFileType as x, fileTypeValidation as S, getFileExtention as C, getFileSizeDisplay as w, getTextRequiredFieldIndicator as T, memoWithGenerics as E, mergeRefs as D, strictInput as O, validateMultipleFileSize as k, validateMultipleFileType as A } from "@reapitform/utils";
import { elBorderRadius as j, elFlex1 as M, elFlexAlignCenter as ee, elFlexAlignSelfCenter as te, elFlexAlignSelfStart as ne, elFlexJustifyBetween as re, elFlexNoWrap as ie, elFlexRow as ae, elHAuto as oe, elHFull as se, elMt3 as ce, elMt5 as le, elMy3 as N, elMy6 as P, elPx6 as ue, elPy2 as de, elPy6 as fe, elWFull as pe } from "@reapit/elements/deprecated/styles";
import { Fragment as me, jsx as F, jsxs as I } from "react/jsx-runtime";
import { Text as he } from "@reapit/elements/utils/text";
import { FlexContainer as L } from "@reapit/elements/deprecated/layout";
import { Dialog as ge } from "@reapit/elements/core/dialog";
import { MainContainer as _e } from "@reapit/elements/core/main-container";
import { Skeleton as ve } from "@reapit/elements/core/skeleton";
import { BodyText as ye, TextBase as be, TextSM as R, elBodyText as xe } from "@reapit/elements/deprecated/typography";
import { Button as z } from "@reapit/elements/core/button";
import { useNavigate as B } from "react-router";
import { PersonType as Se, RecipientActivity as Ce, RepresenteeActivity as we, getUrl as Te, useAttachment as Ee, useDebounce as De, useDragAndDrop as Oe, useHtmlValidation as ke, usePlatformGet as Ae, usePlatformUpdate as je } from "@reapitform/hooks";
import { ButtonGroup as Me } from "@reapit/elements/core/button-group";
import { FormSectionDivider as Ne, InputWrap as Pe } from "@reapit/elements/deprecated/form-layout";
import { CloseIcon as Fe } from "@reapit/elements/icons/close";
import { RefreshIcon as Ie } from "@reapit/elements/icons/refresh";
import { Loader as Le } from "@reapit/elements/deprecated/loader";
import { FormControl as Re } from "@reapit/elements/core/form-control";
import * as ze from "react-dom";
import Be, { createPortal as Ve, unstable_batchedUpdates as He } from "react-dom";
import { DragIndicatorIcon as Ue } from "@reapit/elements/icons/drag-indicator";
import { CheckIcon as We } from "@reapit/elements/icons/check";
import { elColGap2 as Ge, elColGap8 as Ke } from "@reapit/elements/deprecated/grid";
import { InfoIcon as qe } from "@reapit/elements/icons/info";
import { TextInput as Je } from "@reapit/elements/core/text-input";
import { DateTimeInput as Ye } from "@reapit/elements/core/date-time-input";
import { SearchInput as Xe } from "@reapit/elements/core/search-input";
import { Link as Ze, useSearchParams as Qe } from "react-router-dom";
import { Table as $e } from "@reapit/elements/core/table";
import { MoreIcon as et } from "@reapit/elements/icons/more";
import { Menu as tt } from "@reapit/elements/core/menu";
import { Tooltip as nt } from "@reapit/elements/core/tooltip";
import { Pagination as rt } from "@reapit/elements/core/pagination";
import { SectionMessage as it } from "@reapit/elements/core/section-message";
import { ErrorIcon as at } from "@reapit/elements/icons/error";
import { ChevronDownIcon as ot } from "@reapit/elements/icons/chevron-down";
import { ChevronUpIcon as st } from "@reapit/elements/icons/chevron-up";
import { Drawer as ct } from "@reapit/elements/core/drawer";
import { ArrowDownIcon as lt } from "@reapit/elements/icons/arrow-down";
import { ArrowUpIcon as ut } from "@reapit/elements/icons/arrow-up";
import { CalendarIcon as dt } from "@reapit/elements/icons/calendar";
import { FormLayout as ft } from "@reapit/elements/core/form-layout";
//#region \0rolldown/runtime.js
var pt = Object.create, mt = Object.defineProperty, ht = Object.getOwnPropertyDescriptor, gt = Object.getOwnPropertyNames, _t = Object.getPrototypeOf, vt = Object.prototype.hasOwnProperty, V = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), yt = (e, t) => {
	let n = {};
	for (var r in e) mt(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || mt(n, Symbol.toStringTag, { value: "Module" }), n;
}, bt = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = gt(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !vt.call(e, s) && s !== n && mt(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = ht(t, s)) || r.enumerable
	});
	return e;
}, xt = (e, t, n) => (n = e == null ? {} : pt(_t(e)), bt(t || !e || !e.__esModule ? mt(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), St = /* @__PURE__ */ ((e) => typeof require < "u" ? require : typeof Proxy < "u" ? new Proxy(e, { get: (e, t) => (typeof require < "u" ? require : e)[t] }) : e)(function(e) {
	if (typeof require < "u") return require.apply(this, arguments);
	throw Error("Calling `require` for \"" + e + "\" in an environment that doesn't expose the `require` function. See https://rolldown.rs/in-depth/bundling-cjs#require-external-modules for more details.");
}), Ct = function() {
	let e = Array.prototype.slice.call(arguments).filter(Boolean), t = {}, n = [];
	e.forEach((e) => {
		(e ? e.split(" ") : []).forEach((e) => {
			if (e.startsWith("atm_")) {
				let [, n] = e.split("_");
				t[n] = e;
			} else n.push(e);
		});
	});
	let r = [];
	for (let e in t) Object.prototype.hasOwnProperty.call(t, e) && r.push(t[e]);
	return r.push(...n), r.join(" ");
}, wt = ({ src: e, srcSet: t, className: n, ...r }) => /* @__PURE__ */ F(b, { children: /* @__PURE__ */ F("img", {
	...r,
	className: Ct(n, te, P, "c1n16whr"),
	src: e,
	srcSet: t
}) }), Tt = "data:image/png;base64,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", Et = ({ src: e = Tt }) => /* @__PURE__ */ F(b, { children: /* @__PURE__ */ I(L, {
	className: fe,
	isFlexColumn: !0,
	isFlexJustifyCenter: !0,
	isFlexAlignCenter: !0,
	children: [/* @__PURE__ */ F("img", {
		className: Ct(N, "c1f5pbu0"),
		src: e,
		alt: "reapit mark copyright"
	}), /* @__PURE__ */ F(he, {
		font: "text-2xs/regular",
		colour: "secondary",
		children: "© Reapit. All rights reserved."
	})]
}) });
//#endregion
//#region ../../node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
function Dt(e) {
	var t = Object.create(null);
	return function(n) {
		return t[n] === void 0 && (t[n] = e(n)), t[n];
	};
}
//#endregion
//#region ../../node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js
var Ot = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, kt = /* #__PURE__ */ Dt(function(e) {
	return Ot.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
}), At = (e) => e.toUpperCase() === e, jt = (e) => (t) => e.indexOf(t) === -1, Mt = (e, t) => {
	let n = {};
	return Object.keys(e).filter(jt(t)).forEach((t) => {
		n[t] = e[t];
	}), n;
};
function Nt(e, t, n) {
	let r = Mt(t, n);
	if (!e) {
		let e = typeof kt == "function" ? { default: kt } : kt;
		Object.keys(r).forEach((t) => {
			e.default(t) || delete r[t];
		});
	}
	return r;
}
function Pt(e) {
	return (t) => {
		let n = (n, r) => {
			let { as: i = e, class: a = "" } = n, s = Nt(t.propsAsIs === void 0 ? !(typeof i == "string" && i.indexOf("-") === -1 && !At(i[0])) : t.propsAsIs, n, ["as", "class"]);
			s.ref = r, s.className = t.atomic ? Ct(t.class, s.className || a) : Ct(s.className || a, t.class);
			let { vars: c } = t;
			if (c) {
				let e = {};
				for (let r in c) {
					let i = c[r], a = i[0], o = i[1] || "", s = typeof a == "function" ? a(n) : a;
					t.name, e[`--${r}`] = `${s}${o}`;
				}
				let r = s.style || {}, i = Object.keys(r);
				i.length > 0 && i.forEach((t) => {
					e[t] = r[t];
				}), s.style = e;
			}
			return e.__wyw_meta && e !== i ? (s.as = i, o(e, s)) : o(i, s);
		}, r = c ? c(n) : ((e) => n(Mt(e, ["innerRef"]), e.innerRef));
		return r.displayName = t.name, r.__wyw_meta = {
			className: t.class || "",
			extends: e
		}, r;
	};
}
var Ft = Pt, It = /*#__PURE__*/ Ft("div")({
	name: "Container",
	class: "c13c53t4",
	propsAsIs: !1
}), Lt = /*#__PURE__*/ Ft("canvas")({
	name: "SignatureCanvas",
	class: "sq2rslk",
	propsAsIs: !1
}), Rt = "var(--colour-text-action, #4e56ea)", zt = "var(--colour-text-primary, #222b33)", Bt = /*#__PURE__*/ Ft("span")({
	name: "ClearLink",
	class: "c1ii8rl8",
	propsAsIs: !1,
	vars: { "c1ii8rl8-0": [({ isActive: e }) => e ? Rt : zt] }
});
//#endregion
//#region src/canvas-signature/index.tsx
function Vt(e, t, n, r) {
	let i = n / e, a = n, o = t * i, s = r / t, c = r, l = e * s;
	return o <= r ? {
		scaledWidth: a,
		scaledHeight: o
	} : {
		scaledWidth: l,
		scaledHeight: c
	};
}
var Ht = ({ className: e, initialSignature: t, disabled: n, ...r }) => {
	let i = v(null), [a, o] = y(!!t), [s, c] = y(null), [l, u] = y(!1), [d, f] = y(0), [m, h] = y(0), g = v(!1);
	p(() => (S(), () => {
		c(null), u(!1);
	}), []), p(() => {
		t && (_(), x(t));
	}, [t]);
	let _ = () => {
		i.current && i.current.getContext("2d")?.clearRect(0, 0, i.current.width, i.current.height);
	}, x = (e) => {
		if (!i.current) return;
		let { naturalWidth: t, naturalHeight: n } = e, { width: r, height: a } = i.current.getBoundingClientRect(), { scaledWidth: o, scaledHeight: s } = Vt(t, n, r, a), c = i.current.getContext("2d"), l = r / 2 - o / 2, u = a / 2 - s / 2;
		c?.drawImage(e, l, u, o, s);
	}, S = () => {
		if (i.current) {
			let e = i.current.getContext("2d"), { width: t, height: n } = i.current.getBoundingClientRect();
			i.current.width = t, i.current.height = n, e && (e.strokeStyle = "#000", e.lineJoin = "round", e.lineCap = "round", e.lineWidth = 3, c(e));
		}
	}, C = (e) => {
		if (!i.current) return {
			offsetX: 0,
			offsetY: 0
		};
		let t = i.current.getBoundingClientRect(), n = i.current.width / t.width, r = i.current.height / t.height;
		return {
			offsetX: (e.clientX - t.left) * n,
			offsetY: (e.clientY - t.top) * r
		};
	}, w = (e, t) => {
		l && (s && (s.beginPath(), s.moveTo(d, m), s.lineTo(e, t), s.stroke()), g.current = !0, f(e), h(t));
	}, T = (e, t) => {
		l || u(!0), f(e), h(t);
	}, E = (e) => {
		if (n) return;
		let { offsetX: t, offsetY: r } = C(e);
		T(t, r);
	}, D = (e) => {
		if (n) return;
		let { offsetX: t, offsetY: r } = C(e);
		w(t, r);
	}, O = (e) => {
		if (n) return;
		let { offsetX: t, offsetY: r } = C(e.touches[0]);
		T(t, r);
	}, k = (e) => {
		if (n) return;
		let { offsetX: t, offsetY: r } = C(e.touches[0]);
		w(t, r);
	}, A = () => {
		n || (u(!1), g.current && o(!0), g.current = !1);
	}, j = () => {
		s && i.current && (s.clearRect(0, 0, i.current.width, i.current.height), c(s), o(!1), r.onChange?.(""));
	}, M = () => {
		if (!n) try {
			if (g.current && i.current) {
				let e = document.createElement("canvas");
				e.width = i.current.width, e.height = i.current.height;
				let t = e.getContext("2d");
				if (t) {
					t.drawImage(i.current, 0, 0);
					let n = e.toDataURL("image/png");
					r.onChange && r.onChange(n);
				}
			}
		} finally {
			A();
		}
	};
	return /* @__PURE__ */ F(b, { children: /* @__PURE__ */ I(It, {
		className: e,
		children: [/* @__PURE__ */ F(Lt, {
			role: "img",
			ref: i,
			onMouseMove: D,
			onMouseDown: E,
			onTouchMove: k,
			onTouchStart: O,
			onTouchEnd: A,
			onMouseUp: M,
			onTouchEndCapture: M
		}), !n && /* @__PURE__ */ F(Bt, {
			isActive: a,
			onClick: j,
			children: "Clear"
		})]
	}) });
}, Ut = /*#__PURE__*/ Ft("div")({
	name: "ResponsiveTitle",
	class: "r1gl63fv",
	propsAsIs: !1
}), Wt = ({ footer: e, hasCloseButton: t, children: n, className: r, handlerModalClose: i, isModalOpen: a, hasFullScreen: o, title: s, hasOverflowVisible: c }) => /* @__PURE__ */ F(b, { children: /* @__PURE__ */ I(ge, {
	isOpen: a,
	className: Ct(r, c && "demg6nx", o && "d1qm1qi8"),
	onClose: i,
	size: "medium",
	children: [
		/* @__PURE__ */ F(ge.Header, {
			action: t && /* @__PURE__ */ F(ge.HeaderCloseButton, {}),
			children: s && /* @__PURE__ */ F(Ut, { children: s })
		}),
		/* @__PURE__ */ F(ge.Body, { children: n }),
		e && /* @__PURE__ */ F(ge.Footer, { children: e })
	]
}) }), Gt = "p11d2r2m", Kt = ({ id: e, children: t, hasFullPage: n, className: r }) => {
	let i = n ? Ct(se) : oe;
	return /* @__PURE__ */ F(b, { children: /* @__PURE__ */ F(_e, {
		id: e,
		size: "wide",
		template: "single-column",
		className: Gt,
		children: /* @__PURE__ */ I(L, {
			isFlexAlignCenter: !0,
			isFlexColumn: !0,
			className: Ct(i, pe),
			children: [/* @__PURE__ */ F(L, {
				className: Ct(i, "c1rw9kmn", r),
				children: t
			}), /* @__PURE__ */ F(Et, {})]
		})
	}) });
}, qt = ({ variant: e = "rectangle", width: t = "100%", height: n = "1rem", borderRadius: r = "8px", ...i }) => /* @__PURE__ */ F(ve, {
	width: t,
	height: n,
	...i,
	borderRadius: e === "circle" ? "100%" : r
}), Jt = ({ data: e }) => /* @__PURE__ */ F("a", {
	className: "c1itkqo2",
	href: e,
	target: e ? "_blank" : void 0,
	rel: e ? "noreferrer" : void 0,
	children: /* @__PURE__ */ F(be, {
		hasMediumText: !0,
		intent: "primary",
		children: "View in maps"
	})
}), Yt = "e1x6ql5v", Xt = "e7nnrc7", Zt = "e1n8z4te", Qt = "e17yoc0l", $t = (e) => {
	let t = e.phoneNumbers?.map((e) => `TEL;TYPE=${e.type},VOICE:${e.phoneNumber}`).join("\n");
	return `BEGIN:VCARD\nVERSION:3.0\n${e.contactName ? `FN:${e.contactName}\n` : ""}${e.organisationName ? `ORG:${e.organisationName}\n` : ""}${t || ""}`;
}, en = ({ data: e }) => {
	if (!e) return null;
	let t = g(() => "s1j8gkk0", []), n = g(() => {
		let t = [];
		return e.workMobile && t.push({
			phoneNumber: e.workMobile,
			type: "CELL"
		}), e.workPhone && t.push({
			phoneNumber: e.workPhone,
			type: "WORK"
		}), t;
	}, [e.workMobile, e.workPhone]);
	return /* @__PURE__ */ F("a", {
		href: "#",
		role: "button",
		className: Ct(ne, Xt),
		onClick: (t) => {
			t.preventDefault();
			let r = $t({
				contactName: e.fullName,
				organisationName: e.companyName,
				phoneNumbers: n
			}), i = new Blob([r], { type: "text/vcard" }), a = URL.createObjectURL(i), o = document.createElement("a");
			o.download = `${e.fullName}.vcf`, o.textContent = e.fullName, o.href = a, o.click();
		},
		children: /* @__PURE__ */ F(be, {
			className: t,
			intent: "default",
			children: "Save to Contacts"
		})
	});
}, tn = (e, t, n) => {
	let r = B(), [i, a] = je({
		path: `/api/recipient/${e}/Status`,
		method: "PATCH",
		headers: {},
		isProtectedRoute: !1
	});
	return {
		isSubmitLoading: a,
		handleSubmitExit: () => async () => {
			await i({ activity: n === Se.Representee ? we.ExitedByRepresentee : Ce.Exited }) && r(`/broken-link?recId=${e}&orgId=${t}`);
		}
	};
}, nn = "r1p1c13p", rn = ({ className: e, ...t }) => /* @__PURE__ */ F(Me, {
	className: Ct(nn, e),
	...t
}), an = ({ alignment: e, width: t, ...n }) => /* @__PURE__ */ F(rn, {
	"data-alignment": e,
	"data-width": t,
	...n
}), on = ({ className: e, handlerModalClose: t, isModalOpen: n, organizationId: r, recipientId: i, personType: a }) => {
	let { handleSubmitExit: o, isSubmitLoading: s } = tn(i, r, a);
	return /* @__PURE__ */ F(b, { children: /* @__PURE__ */ F(Wt, {
		className: e,
		handlerModalClose: t,
		isModalOpen: n,
		title: "Exit Form",
		footer: /* @__PURE__ */ I(an, {
			alignment: "right",
			children: [/* @__PURE__ */ F(z, {
				size: "medium",
				variant: "secondary",
				disabled: s,
				onClick: t,
				children: "Cancel"
			}), /* @__PURE__ */ F(z, {
				size: "medium",
				isBusy: s,
				disabled: s,
				variant: "primary",
				onClick: o(),
				children: "Exit Form"
			})]
		}),
		children: /* @__PURE__ */ F(ye, { children: "Exiting this form will temporarily disable the link and the Agent will be notified. A new link will be issued shortly." })
	}) });
}, sn = (e) => e.type === "checkbox", cn = (e) => e instanceof Date, ln = (e) => e == null, un = (e) => typeof e == "object", dn = (e) => !ln(e) && !Array.isArray(e) && un(e) && !cn(e), fn = (e) => dn(e) && e.target ? sn(e.target) ? e.target.checked : e.target.value : e, pn = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, mn = (e, t) => e.has(pn(t)), hn = (e) => {
	let t = e.constructor && e.constructor.prototype;
	return dn(t) && t.hasOwnProperty("isPrototypeOf");
}, gn = typeof window < "u" && window.HTMLElement !== void 0 && typeof document < "u";
function _n(e) {
	let t, n = Array.isArray(e);
	if (e instanceof Date) t = new Date(e);
	else if (e instanceof Set) t = new Set(e);
	else if (!(gn && (e instanceof Blob || e instanceof FileList)) && (n || dn(e))) if (t = n ? [] : {}, !n && !hn(e)) t = e;
	else for (let n in e) e.hasOwnProperty(n) && (t[n] = _n(e[n]));
	else return e;
	return t;
}
var vn = (e) => Array.isArray(e) ? e.filter(Boolean) : [], yn = (e) => e === void 0, bn = (e, t, n) => {
	if (!t || !dn(e)) return n;
	let r = vn(t.split(/[,[\].]+?/)).reduce((e, t) => ln(e) ? e : e[t], e);
	return yn(r) || r === e ? yn(e[t]) ? n : e[t] : r;
}, xn = (e) => typeof e == "boolean", Sn = (e) => /^\w*$/.test(e), Cn = (e) => vn(e.replace(/["|']|\]/g, "").split(/\.|\[/)), wn = (e, t, n) => {
	let r = -1, i = Sn(t) ? [t] : Cn(t), a = i.length, o = a - 1;
	for (; ++r < a;) {
		let t = i[r], a = n;
		if (r !== o) {
			let n = e[t];
			a = dn(n) || Array.isArray(n) ? n : isNaN(+i[r + 1]) ? {} : [];
		}
		if (t === "__proto__") return;
		e[t] = a, e = e[t];
	}
	return e;
}, Tn = {
	BLUR: "blur",
	FOCUS_OUT: "focusout",
	CHANGE: "change"
}, En = {
	onBlur: "onBlur",
	onChange: "onChange",
	onSubmit: "onSubmit",
	onTouched: "onTouched",
	all: "all"
}, Dn = {
	max: "max",
	min: "min",
	maxLength: "maxLength",
	minLength: "minLength",
	pattern: "pattern",
	required: "required",
	validate: "validate"
}, On = t.createContext(null), kn = () => t.useContext(On), An = (e, t, n, r = !0) => {
	let i = { defaultValues: t._defaultValues };
	for (let a in e) Object.defineProperty(i, a, { get: () => {
		let i = a;
		return t._proxyFormState[i] !== En.all && (t._proxyFormState[i] = !r || En.all), n && (n[i] = !0), e[i];
	} });
	return i;
}, jn = (e) => dn(e) && !Object.keys(e).length, Mn = (e, t, n, r) => {
	n(e);
	let { name: i, ...a } = e;
	return jn(a) || Object.keys(a).length >= Object.keys(t).length || Object.keys(a).find((e) => t[e] === (!r || En.all));
}, Nn = (e) => Array.isArray(e) ? e : [e];
function Pn(e) {
	let n = t.useRef(e);
	n.current = e, t.useEffect(() => {
		let t = !e.disabled && n.current.subject && n.current.subject.subscribe({ next: n.current.next });
		return () => {
			t && t.unsubscribe();
		};
	}, [e.disabled]);
}
var Fn = (e) => typeof e == "string", In = (e, t, n, r, i) => Fn(e) ? (r && t.watch.add(e), bn(n, e, i)) : Array.isArray(e) ? e.map((e) => (r && t.watch.add(e), bn(n, e))) : (r && (t.watchAll = !0), n), Ln = (e, t, n, r, i) => t ? {
	...n[e],
	types: {
		...n[e] && n[e].types ? n[e].types : {},
		[r]: i || !0
	}
} : {}, Rn = () => {
	let e = typeof performance > "u" ? Date.now() : performance.now() * 1e3;
	return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (t) => {
		let n = (Math.random() * 16 + e) % 16 | 0;
		return (t == "x" ? n : n & 3 | 8).toString(16);
	});
}, zn = (e, t, n = {}) => n.shouldFocus || yn(n.shouldFocus) ? n.focusName || `${e}.${yn(n.focusIndex) ? t : n.focusIndex}.` : "", Bn = (e) => ({
	isOnSubmit: !e || e === En.onSubmit,
	isOnBlur: e === En.onBlur,
	isOnChange: e === En.onChange,
	isOnAll: e === En.all,
	isOnTouch: e === En.onTouched
}), Vn = (e, t, n) => !n && (t.watchAll || t.watch.has(e) || [...t.watch].some((t) => e.startsWith(t) && /^\.\w+/.test(e.slice(t.length)))), Hn = (e, t, n, r) => {
	for (let i of n || Object.keys(e)) {
		let n = bn(e, i);
		if (n) {
			let { _f: e, ...a } = n;
			if (e) {
				if (e.refs && e.refs[0] && t(e.refs[0], i) && !r || e.ref && t(e.ref, e.name) && !r) return !0;
				if (Hn(a, t)) break;
			} else if (dn(a) && Hn(a, t)) break;
		}
	}
}, Un = (e, t, n) => {
	let r = Nn(bn(e, n));
	return wn(r, "root", t[n]), wn(e, n, r), e;
}, Wn = (e) => e.type === "file", Gn = (e) => typeof e == "function", Kn = (e) => {
	if (!gn) return !1;
	let t = e ? e.ownerDocument : 0;
	return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, qn = (e) => Fn(e), Jn = (e) => e.type === "radio", Yn = (e) => e instanceof RegExp, Xn = {
	value: !1,
	isValid: !1
}, Zn = {
	value: !0,
	isValid: !0
}, Qn = (e) => {
	if (Array.isArray(e)) {
		if (e.length > 1) {
			let t = e.filter((e) => e && e.checked && !e.disabled).map((e) => e.value);
			return {
				value: t,
				isValid: !!t.length
			};
		}
		return e[0].checked && !e[0].disabled ? e[0].attributes && !yn(e[0].attributes.value) ? yn(e[0].value) || e[0].value === "" ? Zn : {
			value: e[0].value,
			isValid: !0
		} : Zn : Xn;
	}
	return Xn;
}, $n = {
	isValid: !1,
	value: null
}, er = (e) => Array.isArray(e) ? e.reduce((e, t) => t && t.checked && !t.disabled ? {
	isValid: !0,
	value: t.value
} : e, $n) : $n;
function tr(e, t, n = "validate") {
	if (qn(e) || Array.isArray(e) && e.every(qn) || xn(e) && !e) return {
		type: n,
		message: qn(e) ? e : "",
		ref: t
	};
}
var nr = (e) => dn(e) && !Yn(e) ? e : {
	value: e,
	message: ""
}, rr = async (e, t, n, r, i) => {
	let { ref: a, refs: o, required: s, maxLength: c, minLength: l, min: u, max: d, pattern: f, validate: p, name: m, valueAsNumber: h, mount: g, disabled: _ } = e._f, v = bn(t, m);
	if (!g || _) return {};
	let y = o ? o[0] : a, b = (e) => {
		r && y.reportValidity && (y.setCustomValidity(xn(e) ? "" : e || ""), y.reportValidity());
	}, x = {}, S = Jn(a), C = sn(a), w = S || C, T = (h || Wn(a)) && yn(a.value) && yn(v) || Kn(a) && a.value === "" || v === "" || Array.isArray(v) && !v.length, E = Ln.bind(null, m, n, x), D = (e, t, n, r = Dn.maxLength, i = Dn.minLength) => {
		let o = e ? t : n;
		x[m] = {
			type: e ? r : i,
			message: o,
			ref: a,
			...E(e ? r : i, o)
		};
	};
	if (i ? !Array.isArray(v) || !v.length : s && (!w && (T || ln(v)) || xn(v) && !v || C && !Qn(o).isValid || S && !er(o).isValid)) {
		let { value: e, message: t } = qn(s) ? {
			value: !!s,
			message: s
		} : nr(s);
		if (e && (x[m] = {
			type: Dn.required,
			message: t,
			ref: y,
			...E(Dn.required, t)
		}, !n)) return b(t), x;
	}
	if (!T && (!ln(u) || !ln(d))) {
		let e, t, r = nr(d), i = nr(u);
		if (!ln(v) && !isNaN(v)) {
			let n = a.valueAsNumber || v && +v;
			ln(r.value) || (e = n > r.value), ln(i.value) || (t = n < i.value);
		} else {
			let n = a.valueAsDate || new Date(v), o = (e) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + e), s = a.type == "time", c = a.type == "week";
			Fn(r.value) && v && (e = s ? o(v) > o(r.value) : c ? v > r.value : n > new Date(r.value)), Fn(i.value) && v && (t = s ? o(v) < o(i.value) : c ? v < i.value : n < new Date(i.value));
		}
		if ((e || t) && (D(!!e, r.message, i.message, Dn.max, Dn.min), !n)) return b(x[m].message), x;
	}
	if ((c || l) && !T && (Fn(v) || i && Array.isArray(v))) {
		let e = nr(c), t = nr(l), r = !ln(e.value) && v.length > +e.value, i = !ln(t.value) && v.length < +t.value;
		if ((r || i) && (D(r, e.message, t.message), !n)) return b(x[m].message), x;
	}
	if (f && !T && Fn(v)) {
		let { value: e, message: t } = nr(f);
		if (Yn(e) && !v.match(e) && (x[m] = {
			type: Dn.pattern,
			message: t,
			ref: a,
			...E(Dn.pattern, t)
		}, !n)) return b(t), x;
	}
	if (p) {
		if (Gn(p)) {
			let e = tr(await p(v, t), y);
			if (e && (x[m] = {
				...e,
				...E(Dn.validate, e.message)
			}, !n)) return b(e.message), x;
		} else if (dn(p)) {
			let e = {};
			for (let r in p) {
				if (!jn(e) && !n) break;
				let i = tr(await p[r](v, t), y, r);
				i && (e = {
					...i,
					...E(r, i.message)
				}, b(i.message), n && (x[m] = e));
			}
			if (!jn(e) && (x[m] = {
				ref: y,
				...e
			}, !n)) return x;
		}
	}
	return b(!0), x;
}, ir = (e, t) => [...e, ...Nn(t)], ar = (e) => Array.isArray(e) ? e.map(() => void 0) : void 0;
function or(e, t, n) {
	return [
		...e.slice(0, t),
		...Nn(n),
		...e.slice(t)
	];
}
var sr = (e, t, n) => Array.isArray(e) ? (yn(e[n]) && (e[n] = void 0), e.splice(n, 0, e.splice(t, 1)[0]), e) : [], cr = (e, t) => [...Nn(t), ...Nn(e)];
function lr(e, t) {
	let n = 0, r = [...e];
	for (let e of t) r.splice(e - n, 1), n++;
	return vn(r).length ? r : [];
}
var ur = (e, t) => yn(t) ? [] : lr(e, Nn(t).sort((e, t) => e - t)), dr = (e, t, n) => {
	[e[t], e[n]] = [e[n], e[t]];
};
function fr(e, t) {
	let n = t.slice(0, -1).length, r = 0;
	for (; r < n;) e = yn(e) ? r++ : e[t[r++]];
	return e;
}
function pr(e) {
	for (let t in e) if (e.hasOwnProperty(t) && !yn(e[t])) return !1;
	return !0;
}
function mr(e, t) {
	let n = Array.isArray(t) ? t : Sn(t) ? [t] : Cn(t), r = n.length === 1 ? e : fr(e, n), i = n.length - 1, a = n[i];
	return r && delete r[a], i !== 0 && (dn(r) && jn(r) || Array.isArray(r) && pr(r)) && mr(e, n.slice(0, -1)), e;
}
var hr = (e, t, n) => (e[t] = n, e);
function gr(e) {
	let n = kn(), { control: r = n.control, name: i, keyName: a = "id", shouldUnregister: o } = e, [s, c] = t.useState(r._getFieldArray(i)), l = t.useRef(r._getFieldArray(i).map(Rn)), u = t.useRef(s), d = t.useRef(i), f = t.useRef(!1);
	d.current = i, u.current = s, r._names.array.add(i), e.rules && r.register(i, e.rules), Pn({
		next: ({ values: e, name: t }) => {
			if (t === d.current || !t) {
				let t = bn(e, d.current);
				Array.isArray(t) && (c(t), l.current = t.map(Rn));
			}
		},
		subject: r._subjects.array
	});
	let p = t.useCallback((e) => {
		f.current = !0, r._updateFieldArray(i, e);
	}, [r, i]);
	return t.useEffect(() => {
		if (r._state.action = !1, Vn(i, r._names) && r._subjects.state.next({ ...r._formState }), f.current && (!Bn(r._options.mode).isOnSubmit || r._formState.isSubmitted)) if (r._options.resolver) r._executeSchema([i]).then((e) => {
			let t = bn(e.errors, i), n = bn(r._formState.errors, i);
			(n ? !t && n.type || t && (n.type !== t.type || n.message !== t.message) : t && t.type) && (t ? wn(r._formState.errors, i, t) : mr(r._formState.errors, i), r._subjects.state.next({ errors: r._formState.errors }));
		});
		else {
			let e = bn(r._fields, i);
			e && e._f && !(Bn(r._options.reValidateMode).isOnSubmit && Bn(r._options.mode).isOnSubmit) && rr(e, r._formValues, r._options.criteriaMode === En.all, r._options.shouldUseNativeValidation, !0).then((e) => !jn(e) && r._subjects.state.next({ errors: Un(r._formState.errors, e, i) }));
		}
		r._subjects.values.next({
			name: i,
			values: { ...r._formValues }
		}), r._names.focus && Hn(r._fields, (e, t) => {
			if (r._names.focus && t.startsWith(r._names.focus) && e.focus) return e.focus(), 1;
		}), r._names.focus = "", r._updateValid(), f.current = !1;
	}, [
		s,
		i,
		r
	]), t.useEffect(() => (!bn(r._formValues, i) && r._updateFieldArray(i), () => {
		(r._options.shouldUnregister || o) && r.unregister(i);
	}), [
		i,
		r,
		a,
		o
	]), {
		swap: t.useCallback((e, t) => {
			let n = r._getFieldArray(i);
			dr(n, e, t), dr(l.current, e, t), p(n), c(n), r._updateFieldArray(i, n, dr, {
				argA: e,
				argB: t
			}, !1);
		}, [
			p,
			i,
			r
		]),
		move: t.useCallback((e, t) => {
			let n = r._getFieldArray(i);
			sr(n, e, t), sr(l.current, e, t), p(n), c(n), r._updateFieldArray(i, n, sr, {
				argA: e,
				argB: t
			}, !1);
		}, [
			p,
			i,
			r
		]),
		prepend: t.useCallback((e, t) => {
			let n = Nn(_n(e)), a = cr(r._getFieldArray(i), n);
			r._names.focus = zn(i, 0, t), l.current = cr(l.current, n.map(Rn)), p(a), c(a), r._updateFieldArray(i, a, cr, { argA: ar(e) });
		}, [
			p,
			i,
			r
		]),
		append: t.useCallback((e, t) => {
			let n = Nn(_n(e)), a = ir(r._getFieldArray(i), n);
			r._names.focus = zn(i, a.length - 1, t), l.current = ir(l.current, n.map(Rn)), p(a), c(a), r._updateFieldArray(i, a, ir, { argA: ar(e) });
		}, [
			p,
			i,
			r
		]),
		remove: t.useCallback((e) => {
			let t = ur(r._getFieldArray(i), e);
			l.current = ur(l.current, e), p(t), c(t), r._updateFieldArray(i, t, ur, { argA: e });
		}, [
			p,
			i,
			r
		]),
		insert: t.useCallback((e, t, n) => {
			let a = Nn(_n(t)), o = or(r._getFieldArray(i), e, a);
			r._names.focus = zn(i, e, n), l.current = or(l.current, e, a.map(Rn)), p(o), c(o), r._updateFieldArray(i, o, or, {
				argA: e,
				argB: ar(t)
			});
		}, [
			p,
			i,
			r
		]),
		update: t.useCallback((e, t) => {
			let n = _n(t), a = hr(r._getFieldArray(i), e, n);
			l.current = [...a].map((t, n) => !t || n === e ? Rn() : l.current[n]), p(a), c([...a]), r._updateFieldArray(i, a, hr, {
				argA: e,
				argB: n
			}, !0, !1);
		}, [
			p,
			i,
			r
		]),
		replace: t.useCallback((e) => {
			let t = Nn(_n(e));
			l.current = t.map(Rn), p([...t]), c([...t]), r._updateFieldArray(i, [...t], (e) => e, {}, !0, !1);
		}, [
			p,
			i,
			r
		]),
		fields: t.useMemo(() => s.map((e, t) => ({
			...e,
			[a]: l.current[t] || Rn()
		})), [s, a])
	};
}
var _r = () => {
	let e = [];
	return {
		get observers() {
			return e;
		},
		next: (t) => {
			for (let n of e) n.next && n.next(t);
		},
		subscribe: (t) => (e.push(t), { unsubscribe: () => {
			e = e.filter((e) => e !== t);
		} }),
		unsubscribe: () => {
			e = [];
		}
	};
}, vr = (e) => ln(e) || !un(e);
function yr(e, t) {
	if (vr(e) || vr(t)) return e === t;
	if (cn(e) && cn(t)) return e.getTime() === t.getTime();
	let n = Object.keys(e), r = Object.keys(t);
	if (n.length !== r.length) return !1;
	for (let i of n) {
		let n = e[i];
		if (!r.includes(i)) return !1;
		if (i !== "ref") {
			let e = t[i];
			if (cn(n) && cn(e) || dn(n) && dn(e) || Array.isArray(n) && Array.isArray(e) ? !yr(n, e) : n !== e) return !1;
		}
	}
	return !0;
}
var br = (e) => e.type === "select-multiple", xr = (e) => Jn(e) || sn(e), Sr = (e) => Kn(e) && e.isConnected, Cr = (e) => {
	for (let t in e) if (Gn(e[t])) return !0;
	return !1;
};
function wr(e, t = {}) {
	let n = Array.isArray(e);
	if (dn(e) || n) for (let n in e) Array.isArray(e[n]) || dn(e[n]) && !Cr(e[n]) ? (t[n] = Array.isArray(e[n]) ? [] : {}, wr(e[n], t[n])) : ln(e[n]) || (t[n] = !0);
	return t;
}
function Tr(e, t, n) {
	let r = Array.isArray(e);
	if (dn(e) || r) for (let r in e) Array.isArray(e[r]) || dn(e[r]) && !Cr(e[r]) ? yn(t) || vr(n[r]) ? n[r] = Array.isArray(e[r]) ? wr(e[r], []) : { ...wr(e[r]) } : Tr(e[r], ln(t) ? {} : t[r], n[r]) : n[r] = !yr(e[r], t[r]);
	return n;
}
var Er = (e, t) => Tr(e, t, wr(t)), Dr = (e, { valueAsNumber: t, valueAsDate: n, setValueAs: r }) => yn(e) ? e : t ? e === "" ? NaN : e && +e : n && Fn(e) ? new Date(e) : r ? r(e) : e;
function Or(e) {
	let t = e.ref;
	if (!(e.refs ? e.refs.every((e) => e.disabled) : t.disabled)) return Wn(t) ? t.files : Jn(t) ? er(e.refs).value : br(t) ? [...t.selectedOptions].map(({ value: e }) => e) : sn(t) ? Qn(e.refs).value : Dr(yn(t.value) ? e.ref.value : t.value, e);
}
var kr = (e, t, n, r) => {
	let i = {};
	for (let n of e) {
		let e = bn(t, n);
		e && wn(i, n, e._f);
	}
	return {
		criteriaMode: n,
		names: [...e],
		fields: i,
		shouldUseNativeValidation: r
	};
}, Ar = (e) => yn(e) ? e : Yn(e) ? e.source : dn(e) ? Yn(e.value) ? e.value.source : e.value : e, jr = "AsyncFunction", Mr = (e) => (!e || !e.validate) && !!(Gn(e.validate) && e.validate.constructor.name === jr || dn(e.validate) && Object.values(e.validate).find((e) => e.constructor.name === jr)), Nr = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate);
function Pr(e, t, n) {
	let r = bn(e, n);
	if (r || Sn(n)) return {
		error: r,
		name: n
	};
	let i = n.split(".");
	for (; i.length;) {
		let r = i.join("."), a = bn(t, r), o = bn(e, r);
		if (a && !Array.isArray(a) && n !== r) return { name: n };
		if (o && o.type) return {
			name: r,
			error: o
		};
		i.pop();
	}
	return { name: n };
}
var Fr = (e, t, n, r, i) => i.isOnAll ? !1 : !n && i.isOnTouch ? !(t || e) : (n ? r.isOnBlur : i.isOnBlur) ? !e : (n ? r.isOnChange : i.isOnChange) ? e : !0, Ir = (e, t) => !vn(bn(e, t)).length && mr(e, t), Lr = {
	mode: En.onSubmit,
	reValidateMode: En.onChange,
	shouldFocusError: !0
};
function Rr(e = {}) {
	let t = {
		...Lr,
		...e
	}, n = {
		submitCount: 0,
		isDirty: !1,
		isLoading: Gn(t.defaultValues),
		isValidating: !1,
		isSubmitted: !1,
		isSubmitting: !1,
		isSubmitSuccessful: !1,
		isValid: !1,
		touchedFields: {},
		dirtyFields: {},
		validatingFields: {},
		errors: t.errors || {},
		disabled: t.disabled || !1
	}, r = {}, i = (dn(t.defaultValues) || dn(t.values)) && _n(t.defaultValues || t.values) || {}, a = t.shouldUnregister ? {} : _n(i), o = {
		action: !1,
		mount: !1,
		watch: !1
	}, s = {
		mount: /* @__PURE__ */ new Set(),
		unMount: /* @__PURE__ */ new Set(),
		array: /* @__PURE__ */ new Set(),
		watch: /* @__PURE__ */ new Set()
	}, c, l = 0, u = {
		isDirty: !1,
		dirtyFields: !1,
		validatingFields: !1,
		touchedFields: !1,
		isValidating: !1,
		isValid: !1,
		errors: !1
	}, d = {
		values: _r(),
		array: _r(),
		state: _r()
	}, f = Bn(t.mode), p = Bn(t.reValidateMode), m = t.criteriaMode === En.all, h = (e) => (t) => {
		clearTimeout(l), l = setTimeout(e, t);
	}, g = async (i) => {
		if (!e.disabled && (u.isValid || i)) {
			let e = t.resolver ? jn((await w()).errors) : await E(r, !0);
			e !== n.isValid && d.state.next({ isValid: e });
		}
	}, _ = (t, r) => {
		!e.disabled && (u.isValidating || u.validatingFields) && ((t || Array.from(s.mount)).forEach((e) => {
			e && (r ? wn(n.validatingFields, e, r) : mr(n.validatingFields, e));
		}), d.state.next({
			validatingFields: n.validatingFields,
			isValidating: !jn(n.validatingFields)
		}));
	}, v = (t, s = [], c, l, f = !0, p = !0) => {
		if (l && c && !e.disabled) {
			if (o.action = !0, p && Array.isArray(bn(r, t))) {
				let e = c(bn(r, t), l.argA, l.argB);
				f && wn(r, t, e);
			}
			if (p && Array.isArray(bn(n.errors, t))) {
				let e = c(bn(n.errors, t), l.argA, l.argB);
				f && wn(n.errors, t, e), Ir(n.errors, t);
			}
			if (u.touchedFields && p && Array.isArray(bn(n.touchedFields, t))) {
				let e = c(bn(n.touchedFields, t), l.argA, l.argB);
				f && wn(n.touchedFields, t, e);
			}
			u.dirtyFields && (n.dirtyFields = Er(i, a)), d.state.next({
				name: t,
				isDirty: O(t, s),
				dirtyFields: n.dirtyFields,
				errors: n.errors,
				isValid: n.isValid
			});
		} else wn(a, t, s);
	}, y = (e, t) => {
		wn(n.errors, e, t), d.state.next({ errors: n.errors });
	}, b = (e) => {
		n.errors = e, d.state.next({
			errors: n.errors,
			isValid: !1
		});
	}, x = (e, t, n, s) => {
		let c = bn(r, e);
		if (c) {
			let r = bn(a, e, yn(n) ? bn(i, e) : n);
			yn(r) || s && s.defaultChecked || t ? wn(a, e, t ? r : Or(c._f)) : j(e, r), o.mount && g();
		}
	}, S = (t, a, o, s, c) => {
		let l = !1, f = !1, p = { name: t };
		if (!e.disabled) {
			let e = !!(bn(r, t) && bn(r, t)._f && bn(r, t)._f.disabled);
			if (!o || s) {
				u.isDirty && (f = n.isDirty, n.isDirty = p.isDirty = O(), l = f !== p.isDirty);
				let r = e || yr(bn(i, t), a);
				f = !!(!e && bn(n.dirtyFields, t)), r || e ? mr(n.dirtyFields, t) : wn(n.dirtyFields, t, !0), p.dirtyFields = n.dirtyFields, l ||= u.dirtyFields && f !== !r;
			}
			if (o) {
				let e = bn(n.touchedFields, t);
				e || (wn(n.touchedFields, t, o), p.touchedFields = n.touchedFields, l ||= u.touchedFields && e !== o);
			}
			l && c && d.state.next(p);
		}
		return l ? p : {};
	}, C = (t, r, i, a) => {
		let o = bn(n.errors, t), s = u.isValid && xn(r) && n.isValid !== r;
		if (e.delayError && i ? (c = h(() => y(t, i)), c(e.delayError)) : (clearTimeout(l), c = null, i ? wn(n.errors, t, i) : mr(n.errors, t)), (i ? !yr(o, i) : o) || !jn(a) || s) {
			let e = {
				...a,
				...s && xn(r) ? { isValid: r } : {},
				errors: n.errors,
				name: t
			};
			n = {
				...n,
				...e
			}, d.state.next(e);
		}
	}, w = async (e) => {
		_(e, !0);
		let n = await t.resolver(a, t.context, kr(e || s.mount, r, t.criteriaMode, t.shouldUseNativeValidation));
		return _(e), n;
	}, T = async (e) => {
		let { errors: t } = await w(e);
		if (e) for (let r of e) {
			let e = bn(t, r);
			e ? wn(n.errors, r, e) : mr(n.errors, r);
		}
		else n.errors = t;
		return t;
	}, E = async (e, r, i = { valid: !0 }) => {
		for (let o in e) {
			let c = e[o];
			if (c) {
				let { _f: e, ...l } = c;
				if (e) {
					let l = s.array.has(e.name), d = c._f && Mr(c._f);
					d && u.validatingFields && _([o], !0);
					let f = await rr(c, a, m, t.shouldUseNativeValidation && !r, l);
					if (d && u.validatingFields && _([o]), f[e.name] && (i.valid = !1, r)) break;
					!r && (bn(f, e.name) ? l ? Un(n.errors, f, e.name) : wn(n.errors, e.name, f[e.name]) : mr(n.errors, e.name));
				}
				!jn(l) && await E(l, r, i);
			}
		}
		return i.valid;
	}, D = () => {
		for (let e of s.unMount) {
			let t = bn(r, e);
			t && (t._f.refs ? t._f.refs.every((e) => !Sr(e)) : !Sr(t._f.ref)) && le(e);
		}
		s.unMount = /* @__PURE__ */ new Set();
	}, O = (t, n) => !e.disabled && (t && n && wn(a, t, n), !yr(ie(), i)), k = (e, t, n) => In(e, s, { ...o.mount ? a : yn(t) ? i : Fn(e) ? { [e]: t } : t }, n, t), A = (t) => vn(bn(o.mount ? a : i, t, e.shouldUnregister ? bn(i, t, []) : [])), j = (e, t, n = {}) => {
		let i = bn(r, e), o = t;
		if (i) {
			let n = i._f;
			n && (!n.disabled && wn(a, e, Dr(t, n)), o = Kn(n.ref) && ln(t) ? "" : t, br(n.ref) ? [...n.ref.options].forEach((e) => e.selected = o.includes(e.value)) : n.refs ? sn(n.ref) ? n.refs.length > 1 ? n.refs.forEach((e) => (!e.defaultChecked || !e.disabled) && (e.checked = Array.isArray(o) ? !!o.find((t) => t === e.value) : o === e.value)) : n.refs[0] && (n.refs[0].checked = !!o) : n.refs.forEach((e) => e.checked = e.value === o) : Wn(n.ref) ? n.ref.value = "" : (n.ref.value = o, n.ref.type || d.values.next({
				name: e,
				values: { ...a }
			})));
		}
		(n.shouldDirty || n.shouldTouch) && S(e, o, n.shouldTouch, n.shouldDirty, !0), n.shouldValidate && re(e);
	}, M = (e, t, n) => {
		for (let i in t) {
			let a = t[i], o = `${e}.${i}`, c = bn(r, o);
			(s.array.has(e) || dn(a) || c && !c._f) && !cn(a) ? M(o, a, n) : j(o, a, n);
		}
	}, ee = (e, t, c = {}) => {
		let l = bn(r, e), f = s.array.has(e), p = _n(t);
		wn(a, e, p), f ? (d.array.next({
			name: e,
			values: { ...a }
		}), (u.isDirty || u.dirtyFields) && c.shouldDirty && d.state.next({
			name: e,
			dirtyFields: Er(i, a),
			isDirty: O(e, p)
		})) : l && !l._f && !ln(p) ? M(e, p, c) : j(e, p, c), Vn(e, s) && d.state.next({ ...n }), d.values.next({
			name: o.mount ? e : void 0,
			values: { ...a }
		});
	}, te = async (i) => {
		o.mount = !0;
		let l = i.target, h = l.name, v = !0, y = bn(r, h), b = () => l.type ? Or(y._f) : fn(i), x = (e) => {
			v = Number.isNaN(e) || cn(e) && isNaN(e.getTime()) || yr(e, bn(a, h, e));
		};
		if (y) {
			let o, l, T = b(), D = i.type === Tn.BLUR || i.type === Tn.FOCUS_OUT, O = !Nr(y._f) && !t.resolver && !bn(n.errors, h) && !y._f.deps || Fr(D, bn(n.touchedFields, h), n.isSubmitted, p, f), k = Vn(h, s, D);
			wn(a, h, T), D ? (y._f.onBlur && y._f.onBlur(i), c && c(0)) : y._f.onChange && y._f.onChange(i);
			let A = S(h, T, D, !1), j = !jn(A) || k;
			if (!D && d.values.next({
				name: h,
				type: i.type,
				values: { ...a }
			}), O) return u.isValid && (e.mode === "onBlur" ? D && g() : g()), j && d.state.next({
				name: h,
				...k ? {} : A
			});
			if (!D && k && d.state.next({ ...n }), t.resolver) {
				let { errors: e } = await w([h]);
				if (x(T), v) {
					let t = Pr(n.errors, r, h), i = Pr(e, r, t.name || h);
					o = i.error, h = i.name, l = jn(e);
				}
			} else _([h], !0), o = (await rr(y, a, m, t.shouldUseNativeValidation))[h], _([h]), x(T), v && (o ? l = !1 : u.isValid && (l = await E(r, !0)));
			v && (y._f.deps && re(y._f.deps), C(h, l, o, A));
		}
	}, ne = (e, t) => {
		if (bn(n.errors, t) && e.focus) return e.focus(), 1;
	}, re = async (e, i = {}) => {
		let a, o, c = Nn(e);
		if (t.resolver) {
			let t = await T(yn(e) ? e : c);
			a = jn(t), o = e ? !c.some((e) => bn(t, e)) : a;
		} else e ? (o = (await Promise.all(c.map(async (e) => {
			let t = bn(r, e);
			return await E(t && t._f ? { [e]: t } : t);
		}))).every(Boolean), !(!o && !n.isValid) && g()) : o = a = await E(r);
		return d.state.next({
			...!Fn(e) || u.isValid && a !== n.isValid ? {} : { name: e },
			...t.resolver || !e ? { isValid: a } : {},
			errors: n.errors
		}), i.shouldFocus && !o && Hn(r, ne, e ? c : s.mount), o;
	}, ie = (e) => {
		let t = { ...o.mount ? a : i };
		return yn(e) ? t : Fn(e) ? bn(t, e) : e.map((e) => bn(t, e));
	}, ae = (e, t) => ({
		invalid: !!bn((t || n).errors, e),
		isDirty: !!bn((t || n).dirtyFields, e),
		error: bn((t || n).errors, e),
		isValidating: !!bn(n.validatingFields, e),
		isTouched: !!bn((t || n).touchedFields, e)
	}), oe = (e) => {
		e && Nn(e).forEach((e) => mr(n.errors, e)), d.state.next({ errors: e ? n.errors : {} });
	}, se = (e, t, i) => {
		let a = (bn(r, e, { _f: {} })._f || {}).ref, { ref: o, message: s, type: c, ...l } = bn(n.errors, e) || {};
		wn(n.errors, e, {
			...l,
			...t,
			ref: a
		}), d.state.next({
			name: e,
			errors: n.errors,
			isValid: !1
		}), i && i.shouldFocus && a && a.focus && a.focus();
	}, ce = (e, t) => Gn(e) ? d.values.subscribe({ next: (n) => e(k(void 0, t), n) }) : k(e, t, !0), le = (e, o = {}) => {
		for (let c of e ? Nn(e) : s.mount) s.mount.delete(c), s.array.delete(c), o.keepValue || (mr(r, c), mr(a, c)), !o.keepError && mr(n.errors, c), !o.keepDirty && mr(n.dirtyFields, c), !o.keepTouched && mr(n.touchedFields, c), !o.keepIsValidating && mr(n.validatingFields, c), !t.shouldUnregister && !o.keepDefaultValue && mr(i, c);
		d.values.next({ values: { ...a } }), d.state.next({
			...n,
			...o.keepDirty ? { isDirty: O() } : {}
		}), !o.keepIsValid && g();
	}, N = ({ disabled: e, name: t, field: n, fields: r, value: i }) => {
		if (xn(e) && o.mount || e) {
			let o = e ? void 0 : yn(i) ? Or(n ? n._f : bn(r, t)._f) : i;
			wn(a, t, o), S(t, o, !1, !1, !0);
		}
	}, P = (n, a = {}) => {
		let c = bn(r, n), l = xn(a.disabled) || xn(e.disabled);
		return wn(r, n, {
			...c || {},
			_f: {
				...c && c._f ? c._f : { ref: { name: n } },
				name: n,
				mount: !0,
				...a
			}
		}), s.mount.add(n), c ? N({
			field: c,
			disabled: xn(a.disabled) ? a.disabled : e.disabled,
			name: n,
			value: a.value
		}) : x(n, !0, a.value), {
			...l ? { disabled: a.disabled || e.disabled } : {},
			...t.progressive ? {
				required: !!a.required,
				min: Ar(a.min),
				max: Ar(a.max),
				minLength: Ar(a.minLength),
				maxLength: Ar(a.maxLength),
				pattern: Ar(a.pattern)
			} : {},
			name: n,
			onChange: te,
			onBlur: te,
			ref: (e) => {
				if (e) {
					P(n, a), c = bn(r, n);
					let t = yn(e.value) && e.querySelectorAll && e.querySelectorAll("input,select,textarea")[0] || e, o = xr(t), s = c._f.refs || [];
					if (o ? s.find((e) => e === t) : t === c._f.ref) return;
					wn(r, n, { _f: {
						...c._f,
						...o ? {
							refs: [
								...s.filter(Sr),
								t,
								...Array.isArray(bn(i, n)) ? [{}] : []
							],
							ref: {
								type: t.type,
								name: n
							}
						} : { ref: t }
					} }), x(n, !1, void 0, t);
				} else c = bn(r, n, {}), c._f && (c._f.mount = !1), (t.shouldUnregister || a.shouldUnregister) && !(mn(s.array, n) && o.action) && s.unMount.add(n);
			}
		};
	}, ue = () => t.shouldFocusError && Hn(r, ne, s.mount), de = (e) => {
		xn(e) && (d.state.next({ disabled: e }), Hn(r, (t, n) => {
			let i = bn(r, n);
			i && (t.disabled = i._f.disabled || e, Array.isArray(i._f.refs) && i._f.refs.forEach((t) => {
				t.disabled = i._f.disabled || e;
			}));
		}, 0, !1));
	}, fe = (e, i) => async (o) => {
		let s;
		o && (o.preventDefault && o.preventDefault(), o.persist && o.persist());
		let c = _n(a);
		if (d.state.next({ isSubmitting: !0 }), t.resolver) {
			let { errors: e, values: t } = await w();
			n.errors = e, c = t;
		} else await E(r);
		if (mr(n.errors, "root"), jn(n.errors)) {
			d.state.next({ errors: {} });
			try {
				await e(c, o);
			} catch (e) {
				s = e;
			}
		} else i && await i({ ...n.errors }, o), ue(), setTimeout(ue);
		if (d.state.next({
			isSubmitted: !0,
			isSubmitting: !1,
			isSubmitSuccessful: jn(n.errors) && !s,
			submitCount: n.submitCount + 1,
			errors: n.errors
		}), s) throw s;
	}, pe = (e, t = {}) => {
		bn(r, e) && (yn(t.defaultValue) ? ee(e, _n(bn(i, e))) : (ee(e, t.defaultValue), wn(i, e, _n(t.defaultValue))), t.keepTouched || mr(n.touchedFields, e), t.keepDirty || (mr(n.dirtyFields, e), n.isDirty = t.defaultValue ? O(e, _n(bn(i, e))) : O()), t.keepError || (mr(n.errors, e), u.isValid && g()), d.state.next({ ...n }));
	}, me = (t, c = {}) => {
		let l = t ? _n(t) : i, f = _n(l), p = jn(t), m = p ? i : f;
		if (c.keepDefaultValues || (i = l), !c.keepValues) {
			if (c.keepDirtyValues) {
				let e = new Set([...s.mount, ...Object.keys(Er(i, a))]);
				for (let t of Array.from(e)) bn(n.dirtyFields, t) ? wn(m, t, bn(a, t)) : ee(t, bn(m, t));
			} else {
				if (gn && yn(t)) for (let e of s.mount) {
					let t = bn(r, e);
					if (t && t._f) {
						let e = Array.isArray(t._f.refs) ? t._f.refs[0] : t._f.ref;
						if (Kn(e)) {
							let t = e.closest("form");
							if (t) {
								t.reset();
								break;
							}
						}
					}
				}
				r = {};
			}
			a = e.shouldUnregister ? c.keepDefaultValues ? _n(i) : {} : _n(m), d.array.next({ values: { ...m } }), d.values.next({ values: { ...m } });
		}
		s = {
			mount: c.keepDirtyValues ? s.mount : /* @__PURE__ */ new Set(),
			unMount: /* @__PURE__ */ new Set(),
			array: /* @__PURE__ */ new Set(),
			watch: /* @__PURE__ */ new Set(),
			watchAll: !1,
			focus: ""
		}, o.mount = !u.isValid || !!c.keepIsValid || !!c.keepDirtyValues, o.watch = !!e.shouldUnregister, d.state.next({
			submitCount: c.keepSubmitCount ? n.submitCount : 0,
			isDirty: p ? !1 : c.keepDirty ? n.isDirty : !!(c.keepDefaultValues && !yr(t, i)),
			isSubmitted: c.keepIsSubmitted ? n.isSubmitted : !1,
			dirtyFields: p ? {} : c.keepDirtyValues ? c.keepDefaultValues && a ? Er(i, a) : n.dirtyFields : c.keepDefaultValues && t ? Er(i, t) : c.keepDirty ? n.dirtyFields : {},
			touchedFields: c.keepTouched ? n.touchedFields : {},
			errors: c.keepErrors ? n.errors : {},
			isSubmitSuccessful: c.keepIsSubmitSuccessful ? n.isSubmitSuccessful : !1,
			isSubmitting: !1
		});
	}, F = (e, t) => me(Gn(e) ? e(a) : e, t);
	return {
		control: {
			register: P,
			unregister: le,
			getFieldState: ae,
			handleSubmit: fe,
			setError: se,
			_executeSchema: w,
			_getWatch: k,
			_getDirty: O,
			_updateValid: g,
			_removeUnmounted: D,
			_updateFieldArray: v,
			_updateDisabledField: N,
			_getFieldArray: A,
			_reset: me,
			_resetDefaultValues: () => Gn(t.defaultValues) && t.defaultValues().then((e) => {
				F(e, t.resetOptions), d.state.next({ isLoading: !1 });
			}),
			_updateFormState: (e) => {
				n = {
					...n,
					...e
				};
			},
			_disableForm: de,
			_subjects: d,
			_proxyFormState: u,
			_setErrors: b,
			get _fields() {
				return r;
			},
			get _formValues() {
				return a;
			},
			get _state() {
				return o;
			},
			set _state(e) {
				o = e;
			},
			get _defaultValues() {
				return i;
			},
			get _names() {
				return s;
			},
			set _names(e) {
				s = e;
			},
			get _formState() {
				return n;
			},
			set _formState(e) {
				n = e;
			},
			get _options() {
				return t;
			},
			set _options(e) {
				t = {
					...t,
					...e
				};
			}
		},
		trigger: re,
		register: P,
		handleSubmit: fe,
		watch: ce,
		setValue: ee,
		getValues: ie,
		reset: F,
		resetField: pe,
		clearErrors: oe,
		unregister: le,
		setError: se,
		setFocus: (e, t = {}) => {
			let n = bn(r, e), i = n && n._f;
			if (i) {
				let e = i.refs ? i.refs[0] : i.ref;
				e.focus && (e.focus(), t.shouldSelect && e.select());
			}
		},
		getFieldState: ae
	};
}
function zr(e = {}) {
	let n = t.useRef(), r = t.useRef(), [i, a] = t.useState({
		isDirty: !1,
		isValidating: !1,
		isLoading: Gn(e.defaultValues),
		isSubmitted: !1,
		isSubmitting: !1,
		isSubmitSuccessful: !1,
		isValid: !1,
		submitCount: 0,
		dirtyFields: {},
		touchedFields: {},
		validatingFields: {},
		errors: e.errors || {},
		disabled: e.disabled || !1,
		defaultValues: Gn(e.defaultValues) ? void 0 : e.defaultValues
	});
	n.current ||= {
		...Rr(e),
		formState: i
	};
	let o = n.current.control;
	return o._options = e, Pn({
		subject: o._subjects.state,
		next: (e) => {
			Mn(e, o._proxyFormState, o._updateFormState, !0) && a({ ...o._formState });
		}
	}), t.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), t.useEffect(() => {
		if (o._proxyFormState.isDirty) {
			let e = o._getDirty();
			e !== i.isDirty && o._subjects.state.next({ isDirty: e });
		}
	}, [o, i.isDirty]), t.useEffect(() => {
		e.values && !yr(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((e) => ({ ...e }))) : o._resetDefaultValues();
	}, [e.values, o]), t.useEffect(() => {
		e.errors && o._setErrors(e.errors);
	}, [e.errors, o]), t.useEffect(() => {
		o._state.mount || (o._updateValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
	}), t.useEffect(() => {
		e.shouldUnregister && o._subjects.values.next({ values: o._getWatch() });
	}, [e.shouldUnregister, o]), t.useEffect(() => {
		n.current && (n.current.watch = n.current.watch.bind({}));
	}, [i]), n.current.formState = An(i, o), n.current;
}
//#endregion
//#region ../../node_modules/@hookform/resolvers/dist/resolvers.mjs
var Br = (e, t, n) => {
	if (e && "reportValidity" in e) {
		let r = bn(n, t);
		e.setCustomValidity(r && r.message || ""), e.reportValidity();
	}
}, Vr = (e, t) => {
	for (let n in t.fields) {
		let r = t.fields[n];
		r && r.ref && "reportValidity" in r.ref ? Br(r.ref, n, e) : r.refs && r.refs.forEach((t) => Br(t, n, e));
	}
}, Hr = (e, t) => {
	t.shouldUseNativeValidation && Vr(e, t);
	let n = {};
	for (let r in e) {
		let i = bn(t.fields, r), a = Object.assign(e[r] || {}, { ref: i && i.ref });
		if (Ur(t.names || Object.keys(e), r)) {
			let e = Object.assign({}, bn(n, r));
			wn(e, "root", a), wn(n, r, e);
		} else wn(n, r, a);
	}
	return n;
}, Ur = (e, t) => e.some((e) => e.startsWith(t + "."));
//#endregion
//#region ../../node_modules/@hookform/resolvers/yup/dist/yup.mjs
function Wr(e, t, n) {
	return t === void 0 && (t = {}), n === void 0 && (n = {}), function(r, i, a) {
		try {
			return Promise.resolve(function(o, s) {
				try {
					var c = (t.context, Promise.resolve(e[n.mode === "sync" ? "validateSync" : "validate"](r, Object.assign({ abortEarly: !1 }, t, { context: i }))).then(function(e) {
						return a.shouldUseNativeValidation && Vr({}, a), {
							values: n.raw ? r : e,
							errors: {}
						};
					}));
				} catch (e) {
					return s(e);
				}
				return c && c.then ? c.then(void 0, s) : c;
			}(0, function(e) {
				if (!e.inner) throw e;
				return {
					values: {},
					errors: Hr((t = e, n = !a.shouldUseNativeValidation && a.criteriaMode === "all", (t.inner || []).reduce(function(e, t) {
						if (e[t.path] || (e[t.path] = {
							message: t.message,
							type: t.type
						}), n) {
							var r = e[t.path].types, i = r && r[t.type];
							e[t.path] = Ln(t.path, n, e, t.type, i ? [].concat(i, t.message) : t.message);
						}
						return e;
					}, {})), a)
				};
				var t, n;
			}));
		} catch (e) {
			return Promise.reject(e);
		}
	};
}
//#endregion
//#region ../../node_modules/property-expr/index.js
var Gr = /* @__PURE__ */ V(((e, t) => {
	function n(e) {
		this._maxSize = e, this.clear();
	}
	n.prototype.clear = function() {
		this._size = 0, this._values = Object.create(null);
	}, n.prototype.get = function(e) {
		return this._values[e];
	}, n.prototype.set = function(e, t) {
		return this._size >= this._maxSize && this.clear(), e in this._values || this._size++, this._values[e] = t;
	};
	var r = /[^.^\]^[]+|(?=\[\]|\.\.)/g, i = /^\d+$/, a = /^\d/, o = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, s = /^\s*(['"]?)(.*?)(\1)\s*$/, c = 512, l = new n(c), u = new n(c), d = new n(c);
	t.exports = {
		Cache: n,
		split: p,
		normalizePath: f,
		setter: function(e) {
			var t = f(e);
			return u.get(e) || u.set(e, function(e, n) {
				for (var r = 0, i = t.length, a = e; r < i - 1;) {
					var o = t[r];
					if (o === "__proto__" || o === "constructor" || o === "prototype") return e;
					a = a[t[r++]];
				}
				a[t[r]] = n;
			});
		},
		getter: function(e, t) {
			var n = f(e);
			return d.get(e) || d.set(e, function(e) {
				for (var r = 0, i = n.length; r < i;) if (e != null || !t) e = e[n[r++]];
				else return;
				return e;
			});
		},
		join: function(e) {
			return e.reduce(function(e, t) {
				return e + (h(t) || i.test(t) ? "[" + t + "]" : (e ? "." : "") + t);
			}, "");
		},
		forEach: function(e, t, n) {
			m(Array.isArray(e) ? e : p(e), t, n);
		}
	};
	function f(e) {
		return l.get(e) || l.set(e, p(e).map(function(e) {
			return e.replace(s, "$2");
		}));
	}
	function p(e) {
		return e.match(r) || [""];
	}
	function m(e, t, n) {
		var r = e.length, i, a, o, s;
		for (a = 0; a < r; a++) i = e[a], i && (v(i) && (i = "\"" + i + "\""), s = h(i), o = !s && /^\d+$/.test(i), t.call(n, i, s, o, a, e));
	}
	function h(e) {
		return typeof e == "string" && e && ["'", "\""].indexOf(e.charAt(0)) !== -1;
	}
	function g(e) {
		return e.match(a) && !e.match(i);
	}
	function _(e) {
		return o.test(e);
	}
	function v(e) {
		return !h(e) && (g(e) || _(e));
	}
})), Kr = /* @__PURE__ */ V(((e, t) => {
	var n = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g, r = (e) => e.match(n) || [], i = (e) => e[0].toUpperCase() + e.slice(1), a = (e, t) => r(e).join(t).toLowerCase(), o = (e) => r(e).reduce((e, t) => `${e}${e ? t[0].toUpperCase() + t.slice(1).toLowerCase() : t.toLowerCase()}`, "");
	t.exports = {
		words: r,
		upperFirst: i,
		camelCase: o,
		pascalCase: (e) => i(o(e)),
		snakeCase: (e) => a(e, "_"),
		kebabCase: (e) => a(e, "-"),
		sentenceCase: (e) => i(a(e, " ")),
		titleCase: (e) => r(e).map(i).join(" ")
	};
})), qr = /* @__PURE__ */ V(((e, t) => {
	t.exports = function(e) {
		return n(r(e), e);
	}, t.exports.array = n;
	function n(e, t) {
		var n = e.length, r = Array(n), o = {}, s = n, c = i(t), l = a(e);
		for (t.forEach(function(e) {
			if (!l.has(e[0]) || !l.has(e[1])) throw Error("Unknown node. There is an unknown node in the supplied edges.");
		}); s--;) o[s] || u(e[s], s, /* @__PURE__ */ new Set());
		return r;
		function u(e, t, i) {
			if (i.has(e)) {
				var a;
				try {
					a = ", node was:" + JSON.stringify(e);
				} catch {
					a = "";
				}
				throw Error("Cyclic dependency" + a);
			}
			if (!l.has(e)) throw Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(e));
			if (!o[t]) {
				o[t] = !0;
				var s = c.get(e) || /* @__PURE__ */ new Set();
				if (s = Array.from(s), t = s.length) {
					i.add(e);
					do {
						var d = s[--t];
						u(d, l.get(d), i);
					} while (t);
					i.delete(e);
				}
				r[--n] = e;
			}
		}
	}
	function r(e) {
		for (var t = /* @__PURE__ */ new Set(), n = 0, r = e.length; n < r; n++) {
			var i = e[n];
			t.add(i[0]), t.add(i[1]);
		}
		return Array.from(t);
	}
	function i(e) {
		for (var t = /* @__PURE__ */ new Map(), n = 0, r = e.length; n < r; n++) {
			var i = e[n];
			t.has(i[0]) || t.set(i[0], /* @__PURE__ */ new Set()), t.has(i[1]) || t.set(i[1], /* @__PURE__ */ new Set()), t.get(i[0]).add(i[1]);
		}
		return t;
	}
	function a(e) {
		for (var t = /* @__PURE__ */ new Map(), n = 0, r = e.length; n < r; n++) t.set(e[n], n);
		return t;
	}
})), Jr = Gr(), Yr = Kr(), Xr = /* @__PURE__ */ xt(qr()), Zr = Object.prototype.toString, Qr = Error.prototype.toString, $r = RegExp.prototype.toString, ei = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", ti = /^Symbol\((.*)\)(.*)$/;
function ni(e) {
	return e == +e ? e === 0 && 1 / e < 0 ? "-0" : "" + e : "NaN";
}
function ri(e, t = !1) {
	if (e == null || e === !0 || e === !1) return "" + e;
	let n = typeof e;
	if (n === "number") return ni(e);
	if (n === "string") return t ? `"${e}"` : e;
	if (n === "function") return "[Function " + (e.name || "anonymous") + "]";
	if (n === "symbol") return ei.call(e).replace(ti, "Symbol($1)");
	let r = Zr.call(e).slice(8, -1);
	return r === "Date" ? isNaN(e.getTime()) ? "" + e : e.toISOString(e) : r === "Error" || e instanceof Error ? "[" + Qr.call(e) + "]" : r === "RegExp" ? $r.call(e) : null;
}
function ii(e, t) {
	let n = ri(e, t);
	return n === null ? JSON.stringify(e, function(e, n) {
		let r = ri(this[e], t);
		return r === null ? n : r;
	}, 2) : n;
}
function ai(e) {
	return e == null ? [] : [].concat(e);
}
var oi, si, ci, li = /\$\{\s*(\w+)\s*\}/g;
oi = Symbol.toStringTag;
var ui = class {
	constructor(e, t, n, r) {
		this.name = void 0, this.message = void 0, this.value = void 0, this.path = void 0, this.type = void 0, this.params = void 0, this.errors = void 0, this.inner = void 0, this[oi] = "Error", this.name = "ValidationError", this.value = t, this.path = n, this.type = r, this.errors = [], this.inner = [], ai(e).forEach((e) => {
			if (di.isError(e)) {
				this.errors.push(...e.errors);
				let t = e.inner.length ? e.inner : [e];
				this.inner.push(...t);
			} else this.errors.push(e);
		}), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
	}
};
si = Symbol.hasInstance, ci = Symbol.toStringTag;
var di = class e extends Error {
	static formatError(e, t) {
		let n = t.label || t.path || "this";
		return n !== t.path && (t = Object.assign({}, t, { path: n })), typeof e == "string" ? e.replace(li, (e, n) => ii(t[n])) : typeof e == "function" ? e(t) : e;
	}
	static isError(e) {
		return e && e.name === "ValidationError";
	}
	constructor(t, n, r, i, a) {
		let o = new ui(t, n, r, i);
		if (a) return o;
		super(), this.value = void 0, this.path = void 0, this.type = void 0, this.params = void 0, this.errors = [], this.inner = [], this[ci] = "Error", this.name = o.name, this.message = o.message, this.type = o.type, this.value = o.value, this.path = o.path, this.errors = o.errors, this.inner = o.inner, Error.captureStackTrace && Error.captureStackTrace(this, e);
	}
	static [si](e) {
		return ui[Symbol.hasInstance](e) || super[Symbol.hasInstance](e);
	}
}, fi = {
	default: "${path} is invalid",
	required: "${path} is a required field",
	defined: "${path} must be defined",
	notNull: "${path} cannot be null",
	oneOf: "${path} must be one of the following values: ${values}",
	notOneOf: "${path} must not be one of the following values: ${values}",
	notType: ({ path: e, type: t, value: n, originalValue: r }) => {
		let i = r != null && r !== n ? ` (cast from the value \`${ii(r, !0)}\`).` : ".";
		return t === "mixed" ? `${e} must match the configured type. The validated value was: \`${ii(n, !0)}\`` + i : `${e} must be a \`${t}\` type, but the final value was: \`${ii(n, !0)}\`` + i;
	}
}, pi = {
	length: "${path} must be exactly ${length} characters",
	min: "${path} must be at least ${min} characters",
	max: "${path} must be at most ${max} characters",
	matches: "${path} must match the following: \"${regex}\"",
	email: "${path} must be a valid email",
	url: "${path} must be a valid URL",
	uuid: "${path} must be a valid UUID",
	datetime: "${path} must be a valid ISO date-time",
	datetime_precision: "${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits",
	datetime_offset: "${path} must be a valid ISO date-time with UTC \"Z\" timezone",
	trim: "${path} must be a trimmed string",
	lowercase: "${path} must be a lowercase string",
	uppercase: "${path} must be a upper case string"
}, mi = {
	min: "${path} must be greater than or equal to ${min}",
	max: "${path} must be less than or equal to ${max}",
	lessThan: "${path} must be less than ${less}",
	moreThan: "${path} must be greater than ${more}",
	positive: "${path} must be a positive number",
	negative: "${path} must be a negative number",
	integer: "${path} must be an integer"
}, hi = {
	min: "${path} field must be later than ${min}",
	max: "${path} field must be at earlier than ${max}"
}, gi = { isValue: "${path} field must be ${value}" }, _i = { noUnknown: "${path} field has unspecified keys: ${unknown}" }, vi = {
	min: "${path} field must have at least ${min} items",
	max: "${path} field must have less than or equal to ${max} items",
	length: "${path} must have ${length} items"
}, yi = { notType: (e) => {
	let { path: t, value: n, spec: r } = e, i = r.types.length;
	if (Array.isArray(n)) {
		if (n.length < i) return `${t} tuple value has too few items, expected a length of ${i} but got ${n.length} for value: \`${ii(n, !0)}\``;
		if (n.length > i) return `${t} tuple value has too many items, expected a length of ${i} but got ${n.length} for value: \`${ii(n, !0)}\``;
	}
	return di.formatError(fi.notType, e);
} };
Object.assign(Object.create(null), {
	mixed: fi,
	string: pi,
	number: mi,
	date: hi,
	object: _i,
	array: vi,
	boolean: gi,
	tuple: yi
});
var bi = (e) => e && e.__isYupSchema__, xi = class e {
	static fromOptions(t, n) {
		if (!n.then && !n.otherwise) throw TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
		let { is: r, then: i, otherwise: a } = n, o = typeof r == "function" ? r : (...e) => e.every((e) => e === r);
		return new e(t, (e, t) => (o(...e) ? i : a)?.(t) ?? t);
	}
	constructor(e, t) {
		this.fn = void 0, this.refs = e, this.refs = e, this.fn = t;
	}
	resolve(e, t) {
		let n = this.refs.map((e) => e.getValue(t?.value, t?.parent, t?.context)), r = this.fn(n, e, t);
		if (r === void 0 || r === e) return e;
		if (!bi(r)) throw TypeError("conditions must return a schema object");
		return r.resolve(t);
	}
}, Si = {
	context: "$",
	value: "."
}, Ci = class {
	constructor(e, t = {}) {
		if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof e != "string") throw TypeError("ref must be a string, got: " + e);
		if (this.key = e.trim(), e === "") throw TypeError("ref must be a non-empty string");
		this.isContext = this.key[0] === Si.context, this.isValue = this.key[0] === Si.value, this.isSibling = !this.isContext && !this.isValue;
		let n = this.isContext ? Si.context : this.isValue ? Si.value : "";
		this.path = this.key.slice(n.length), this.getter = this.path && (0, Jr.getter)(this.path, !0), this.map = t.map;
	}
	getValue(e, t, n) {
		let r = this.isContext ? n : this.isValue ? e : t;
		return this.getter && (r = this.getter(r || {})), this.map && (r = this.map(r)), r;
	}
	cast(e, t) {
		return this.getValue(e, t?.parent, t?.context);
	}
	resolve() {
		return this;
	}
	describe() {
		return {
			type: "ref",
			key: this.key
		};
	}
	toString() {
		return `Ref(${this.key})`;
	}
	static isRef(e) {
		return e && e.__isYupRef;
	}
};
Ci.prototype.__isYupRef = !0;
var wi = (e) => e == null;
function Ti(e) {
	function t({ value: t, path: n = "", options: r, originalValue: i, schema: a }, o, s) {
		let { name: c, test: l, params: u, message: d, skipAbsent: f } = e, { parent: p, context: m, abortEarly: h = a.spec.abortEarly, disableStackTrace: g = a.spec.disableStackTrace } = r;
		function _(e) {
			return Ci.isRef(e) ? e.getValue(t, p, m) : e;
		}
		function v(e = {}) {
			let r = Object.assign({
				value: t,
				originalValue: i,
				label: a.spec.label,
				path: e.path || n,
				spec: a.spec,
				disableStackTrace: e.disableStackTrace || g
			}, u, e.params);
			for (let e of Object.keys(r)) r[e] = _(r[e]);
			let o = new di(di.formatError(e.message || d, r), t, r.path, e.type || c, r.disableStackTrace);
			return o.params = r, o;
		}
		let y = h ? o : s, b = {
			path: n,
			parent: p,
			type: c,
			from: r.from,
			createError: v,
			resolve: _,
			options: r,
			originalValue: i,
			schema: a
		}, x = (e) => {
			di.isError(e) ? y(e) : e ? s(null) : y(v());
		}, S = (e) => {
			di.isError(e) ? y(e) : o(e);
		};
		if (f && wi(t)) return x(!0);
		let C;
		try {
			if (C = l.call(b, t, b), typeof C?.then == "function") {
				if (r.sync) throw Error(`Validation test of type: "${b.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
				return Promise.resolve(C).then(x, S);
			}
		} catch (e) {
			S(e);
			return;
		}
		x(C);
	}
	return t.OPTIONS = e, t;
}
function Ei(e, t, n, r = n) {
	let i, a, o;
	return t ? ((0, Jr.forEach)(t, (s, c, l) => {
		let u = c ? s.slice(1, s.length - 1) : s;
		e = e.resolve({
			context: r,
			parent: i,
			value: n
		});
		let d = e.type === "tuple", f = l ? parseInt(u, 10) : 0;
		if (e.innerType || d) {
			if (d && !l) throw Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${o}" must contain an index to the tuple element, e.g. "${o}[0]"`);
			if (n && f >= n.length) throw Error(`Yup.reach cannot resolve an array item at index: ${s}, in the path: ${t}. because there is no value at that index. `);
			i = n, n &&= n[f], e = d ? e.spec.types[f] : e.innerType;
		}
		if (!l) {
			if (!e.fields || !e.fields[u]) throw Error(`The schema does not contain the path: ${t}. (failed at: ${o} which is a type: "${e.type}")`);
			i = n, n &&= n[u], e = e.fields[u];
		}
		a = u, o = c ? "[" + s + "]" : "." + s;
	}), {
		schema: e,
		parent: i,
		parentPath: a
	}) : {
		parent: i,
		parentPath: t,
		schema: e
	};
}
var Di = class e extends Set {
	describe() {
		let e = [];
		for (let t of this.values()) e.push(Ci.isRef(t) ? t.describe() : t);
		return e;
	}
	resolveAll(e) {
		let t = [];
		for (let n of this.values()) t.push(e(n));
		return t;
	}
	clone() {
		return new e(this.values());
	}
	merge(e, t) {
		let n = this.clone();
		return e.forEach((e) => n.add(e)), t.forEach((e) => n.delete(e)), n;
	}
};
function Oi(e, t = /* @__PURE__ */ new Map()) {
	if (bi(e) || !e || typeof e != "object") return e;
	if (t.has(e)) return t.get(e);
	let n;
	if (e instanceof Date) n = new Date(e.getTime()), t.set(e, n);
	else if (e instanceof RegExp) n = new RegExp(e), t.set(e, n);
	else if (Array.isArray(e)) {
		n = Array(e.length), t.set(e, n);
		for (let r = 0; r < e.length; r++) n[r] = Oi(e[r], t);
	} else if (e instanceof Map) {
		n = /* @__PURE__ */ new Map(), t.set(e, n);
		for (let [r, i] of e.entries()) n.set(r, Oi(i, t));
	} else if (e instanceof Set) {
		n = /* @__PURE__ */ new Set(), t.set(e, n);
		for (let r of e) n.add(Oi(r, t));
	} else if (e instanceof Object) {
		n = {}, t.set(e, n);
		for (let [r, i] of Object.entries(e)) n[r] = Oi(i, t);
	} else throw Error(`Unable to clone ${e}`);
	return n;
}
var ki = class {
	constructor(e) {
		this.type = void 0, this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this.internalTests = {}, this._whitelist = new Di(), this._blacklist = new Di(), this.exclusiveTests = Object.create(null), this._typeCheck = void 0, this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
			this.typeError(fi.notType);
		}), this.type = e.type, this._typeCheck = e.check, this.spec = Object.assign({
			strip: !1,
			strict: !1,
			abortEarly: !0,
			recursive: !0,
			disableStackTrace: !1,
			nullable: !1,
			optional: !0,
			coerce: !0
		}, e?.spec), this.withMutation((e) => {
			e.nonNullable();
		});
	}
	get _type() {
		return this.type;
	}
	clone(e) {
		if (this._mutate) return e && Object.assign(this.spec, e), this;
		let t = Object.create(Object.getPrototypeOf(this));
		return t.type = this.type, t._typeCheck = this._typeCheck, t._whitelist = this._whitelist.clone(), t._blacklist = this._blacklist.clone(), t.internalTests = Object.assign({}, this.internalTests), t.exclusiveTests = Object.assign({}, this.exclusiveTests), t.deps = [...this.deps], t.conditions = [...this.conditions], t.tests = [...this.tests], t.transforms = [...this.transforms], t.spec = Oi(Object.assign({}, this.spec, e)), t;
	}
	label(e) {
		let t = this.clone();
		return t.spec.label = e, t;
	}
	meta(...e) {
		if (e.length === 0) return this.spec.meta;
		let t = this.clone();
		return t.spec.meta = Object.assign(t.spec.meta || {}, e[0]), t;
	}
	withMutation(e) {
		let t = this._mutate;
		this._mutate = !0;
		let n = e(this);
		return this._mutate = t, n;
	}
	concat(e) {
		if (!e || e === this) return this;
		if (e.type !== this.type && this.type !== "mixed") throw TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${e.type}`);
		let t = this, n = e.clone();
		return n.spec = Object.assign({}, t.spec, n.spec), n.internalTests = Object.assign({}, t.internalTests, n.internalTests), n._whitelist = t._whitelist.merge(e._whitelist, e._blacklist), n._blacklist = t._blacklist.merge(e._blacklist, e._whitelist), n.tests = t.tests, n.exclusiveTests = t.exclusiveTests, n.withMutation((t) => {
			e.tests.forEach((e) => {
				t.test(e.OPTIONS);
			});
		}), n.transforms = [...t.transforms, ...n.transforms], n;
	}
	isType(e) {
		return e == null ? !!(this.spec.nullable && e === null || this.spec.optional && e === void 0) : this._typeCheck(e);
	}
	resolve(e) {
		let t = this;
		if (t.conditions.length) {
			let n = t.conditions;
			t = t.clone(), t.conditions = [], t = n.reduce((t, n) => n.resolve(t, e), t), t = t.resolve(e);
		}
		return t;
	}
	resolveOptions(e) {
		return Object.assign({}, e, {
			from: e.from || [],
			strict: e.strict ?? this.spec.strict,
			abortEarly: e.abortEarly ?? this.spec.abortEarly,
			recursive: e.recursive ?? this.spec.recursive,
			disableStackTrace: e.disableStackTrace ?? this.spec.disableStackTrace
		});
	}
	cast(e, t = {}) {
		let n = this.resolve(Object.assign({ value: e }, t)), r = t.assert === "ignore-optionality", i = n._cast(e, t);
		if (t.assert !== !1 && !n.isType(i)) {
			if (r && wi(i)) return i;
			let a = ii(e), o = ii(i);
			throw TypeError(`The value of ${t.path || "field"} could not be cast to a value that satisfies the schema type: "${n.type}". \n\nattempted value: ${a} \n` + (o === a ? "" : `result of cast: ${o}`));
		}
		return i;
	}
	_cast(e, t) {
		let n = e === void 0 ? e : this.transforms.reduce((t, n) => n.call(this, t, e, this), e);
		return n === void 0 && (n = this.getDefault(t)), n;
	}
	_validate(e, t = {}, n, r) {
		let { path: i, originalValue: a = e, strict: o = this.spec.strict } = t, s = e;
		o || (s = this._cast(s, Object.assign({ assert: !1 }, t)));
		let c = [];
		for (let e of Object.values(this.internalTests)) e && c.push(e);
		this.runTests({
			path: i,
			value: s,
			originalValue: a,
			options: t,
			tests: c
		}, n, (e) => {
			if (e.length) return r(e, s);
			this.runTests({
				path: i,
				value: s,
				originalValue: a,
				options: t,
				tests: this.tests
			}, n, r);
		});
	}
	runTests(e, t, n) {
		let r = !1, { tests: i, value: a, originalValue: o, path: s, options: c } = e, l = (e) => {
			r || (r = !0, t(e, a));
		}, u = (e) => {
			r || (r = !0, n(e, a));
		}, d = i.length, f = [];
		if (!d) return u([]);
		let p = {
			value: a,
			originalValue: o,
			path: s,
			options: c,
			schema: this
		};
		for (let e = 0; e < i.length; e++) {
			let t = i[e];
			t(p, l, function(e) {
				e && (Array.isArray(e) ? f.push(...e) : f.push(e)), --d <= 0 && u(f);
			});
		}
	}
	asNestedTest({ key: e, index: t, parent: n, parentPath: r, originalParent: i, options: a }) {
		let o = e ?? t;
		if (o == null) throw TypeError("Must include `key` or `index` for nested validations");
		let s = typeof o == "number", c = n[o], l = Object.assign({}, a, {
			strict: !0,
			parent: n,
			value: c,
			originalValue: i[o],
			key: void 0,
			[s ? "index" : "key"]: o,
			path: s || o.includes(".") ? `${r || ""}[${s ? o : `"${o}"`}]` : (r ? `${r}.` : "") + e
		});
		return (e, t, n) => this.resolve(l)._validate(c, l, t, n);
	}
	validate(e, t) {
		let n = this.resolve(Object.assign({}, t, { value: e })), r = t?.disableStackTrace ?? n.spec.disableStackTrace;
		return new Promise((i, a) => n._validate(e, t, (e, t) => {
			di.isError(e) && (e.value = t), a(e);
		}, (e, t) => {
			e.length ? a(new di(e, t, void 0, void 0, r)) : i(t);
		}));
	}
	validateSync(e, t) {
		let n = this.resolve(Object.assign({}, t, { value: e })), r, i = t?.disableStackTrace ?? n.spec.disableStackTrace;
		return n._validate(e, Object.assign({}, t, { sync: !0 }), (e, t) => {
			throw di.isError(e) && (e.value = t), e;
		}, (t, n) => {
			if (t.length) throw new di(t, e, void 0, void 0, i);
			r = n;
		}), r;
	}
	isValid(e, t) {
		return this.validate(e, t).then(() => !0, (e) => {
			if (di.isError(e)) return !1;
			throw e;
		});
	}
	isValidSync(e, t) {
		try {
			return this.validateSync(e, t), !0;
		} catch (e) {
			if (di.isError(e)) return !1;
			throw e;
		}
	}
	_getDefault(e) {
		let t = this.spec.default;
		return t == null ? t : typeof t == "function" ? t.call(this, e) : Oi(t);
	}
	getDefault(e) {
		return this.resolve(e || {})._getDefault(e);
	}
	default(e) {
		return arguments.length === 0 ? this._getDefault() : this.clone({ default: e });
	}
	strict(e = !0) {
		return this.clone({ strict: e });
	}
	nullability(e, t) {
		let n = this.clone({ nullable: e });
		return n.internalTests.nullable = Ti({
			message: t,
			name: "nullable",
			test(e) {
				return e === null ? this.schema.spec.nullable : !0;
			}
		}), n;
	}
	optionality(e, t) {
		let n = this.clone({ optional: e });
		return n.internalTests.optionality = Ti({
			message: t,
			name: "optionality",
			test(e) {
				return e === void 0 ? this.schema.spec.optional : !0;
			}
		}), n;
	}
	optional() {
		return this.optionality(!0);
	}
	defined(e = fi.defined) {
		return this.optionality(!1, e);
	}
	nullable() {
		return this.nullability(!0);
	}
	nonNullable(e = fi.notNull) {
		return this.nullability(!1, e);
	}
	required(e = fi.required) {
		return this.clone().withMutation((t) => t.nonNullable(e).defined(e));
	}
	notRequired() {
		return this.clone().withMutation((e) => e.nullable().optional());
	}
	transform(e) {
		let t = this.clone();
		return t.transforms.push(e), t;
	}
	test(...e) {
		let t;
		if (t = e.length === 1 ? typeof e[0] == "function" ? { test: e[0] } : e[0] : e.length === 2 ? {
			name: e[0],
			test: e[1]
		} : {
			name: e[0],
			message: e[1],
			test: e[2]
		}, t.message === void 0 && (t.message = fi.default), typeof t.test != "function") throw TypeError("`test` is a required parameters");
		let n = this.clone(), r = Ti(t), i = t.exclusive || t.name && n.exclusiveTests[t.name] === !0;
		if (t.exclusive && !t.name) throw TypeError("Exclusive tests must provide a unique `name` identifying the test");
		return t.name && (n.exclusiveTests[t.name] = !!t.exclusive), n.tests = n.tests.filter((e) => !(e.OPTIONS.name === t.name && (i || e.OPTIONS.test === r.OPTIONS.test))), n.tests.push(r), n;
	}
	when(e, t) {
		!Array.isArray(e) && typeof e != "string" && (t = e, e = ".");
		let n = this.clone(), r = ai(e).map((e) => new Ci(e));
		return r.forEach((e) => {
			e.isSibling && n.deps.push(e.key);
		}), n.conditions.push(typeof t == "function" ? new xi(r, t) : xi.fromOptions(r, t)), n;
	}
	typeError(e) {
		let t = this.clone();
		return t.internalTests.typeError = Ti({
			message: e,
			name: "typeError",
			skipAbsent: !0,
			test(e) {
				return this.schema._typeCheck(e) ? !0 : this.createError({ params: { type: this.schema.type } });
			}
		}), t;
	}
	oneOf(e, t = fi.oneOf) {
		let n = this.clone();
		return e.forEach((e) => {
			n._whitelist.add(e), n._blacklist.delete(e);
		}), n.internalTests.whiteList = Ti({
			message: t,
			name: "oneOf",
			skipAbsent: !0,
			test(e) {
				let t = this.schema._whitelist, n = t.resolveAll(this.resolve);
				return n.includes(e) ? !0 : this.createError({ params: {
					values: Array.from(t).join(", "),
					resolved: n
				} });
			}
		}), n;
	}
	notOneOf(e, t = fi.notOneOf) {
		let n = this.clone();
		return e.forEach((e) => {
			n._blacklist.add(e), n._whitelist.delete(e);
		}), n.internalTests.blacklist = Ti({
			message: t,
			name: "notOneOf",
			test(e) {
				let t = this.schema._blacklist, n = t.resolveAll(this.resolve);
				return n.includes(e) ? this.createError({ params: {
					values: Array.from(t).join(", "),
					resolved: n
				} }) : !0;
			}
		}), n;
	}
	strip(e = !0) {
		let t = this.clone();
		return t.spec.strip = e, t;
	}
	describe(e) {
		let t = (e ? this.resolve(e) : this).clone(), { label: n, meta: r, optional: i, nullable: a } = t.spec;
		return {
			meta: r,
			label: n,
			optional: i,
			nullable: a,
			default: t.getDefault(e),
			type: t.type,
			oneOf: t._whitelist.describe(),
			notOneOf: t._blacklist.describe(),
			tests: t.tests.map((e) => ({
				name: e.OPTIONS.name,
				params: e.OPTIONS.params
			})).filter((e, t, n) => n.findIndex((t) => t.name === e.name) === t)
		};
	}
};
ki.prototype.__isYupSchema__ = !0;
for (let e of ["validate", "validateSync"]) ki.prototype[`${e}At`] = function(t, n, r = {}) {
	let { parent: i, parentPath: a, schema: o } = Ei(this, t, n, r.context);
	return o[e](i && i[a], Object.assign({}, r, {
		parent: i,
		path: t
	}));
};
for (let e of ["equals", "is"]) ki.prototype[e] = ki.prototype.oneOf;
for (let e of ["not", "nope"]) ki.prototype[e] = ki.prototype.notOneOf;
var Ai = () => !0;
function ji(e) {
	return new Mi(e);
}
var Mi = class extends ki {
	constructor(e) {
		super(typeof e == "function" ? {
			type: "mixed",
			check: e
		} : Object.assign({
			type: "mixed",
			check: Ai
		}, e));
	}
};
ji.prototype = Mi.prototype;
function Ni() {
	return new Pi();
}
var Pi = class extends ki {
	constructor() {
		super({
			type: "boolean",
			check(e) {
				return e instanceof Boolean && (e = e.valueOf()), typeof e == "boolean";
			}
		}), this.withMutation(() => {
			this.transform((e, t, n) => {
				if (n.spec.coerce && !n.isType(e)) {
					if (/^(true|1)$/i.test(String(e))) return !0;
					if (/^(false|0)$/i.test(String(e))) return !1;
				}
				return e;
			});
		});
	}
	isTrue(e = gi.isValue) {
		return this.test({
			message: e,
			name: "is-value",
			exclusive: !0,
			params: { value: "true" },
			test(e) {
				return wi(e) || e === !0;
			}
		});
	}
	isFalse(e = gi.isValue) {
		return this.test({
			message: e,
			name: "is-value",
			exclusive: !0,
			params: { value: "false" },
			test(e) {
				return wi(e) || e === !1;
			}
		});
	}
	default(e) {
		return super.default(e);
	}
	defined(e) {
		return super.defined(e);
	}
	optional() {
		return super.optional();
	}
	required(e) {
		return super.required(e);
	}
	notRequired() {
		return super.notRequired();
	}
	nullable() {
		return super.nullable();
	}
	nonNullable(e) {
		return super.nonNullable(e);
	}
	strip(e) {
		return super.strip(e);
	}
};
Ni.prototype = Pi.prototype;
var Fi = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function Ii(e) {
	let t = Li(e);
	if (!t) return Date.parse ? Date.parse(e) : NaN;
	if (t.z === void 0 && t.plusMinus === void 0) return new Date(t.year, t.month, t.day, t.hour, t.minute, t.second, t.millisecond).valueOf();
	let n = 0;
	return t.z !== "Z" && t.plusMinus !== void 0 && (n = t.hourOffset * 60 + t.minuteOffset, t.plusMinus === "+" && (n = 0 - n)), Date.UTC(t.year, t.month, t.day, t.hour, t.minute + n, t.second, t.millisecond);
}
function Li(e) {
	let t = Fi.exec(e);
	return t ? {
		year: Ri(t[1]),
		month: Ri(t[2], 1) - 1,
		day: Ri(t[3], 1),
		hour: Ri(t[4]),
		minute: Ri(t[5]),
		second: Ri(t[6]),
		millisecond: t[7] ? Ri(t[7].substring(0, 3)) : 0,
		precision: t[7]?.length ?? void 0,
		z: t[8] || void 0,
		plusMinus: t[9] || void 0,
		hourOffset: Ri(t[10]),
		minuteOffset: Ri(t[11])
	} : null;
}
function Ri(e, t = 0) {
	return Number(e) || t;
}
var zi = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/, Bi = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i, Vi = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, Hi = /* @__PURE__ */ RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$"), Ui = (e) => wi(e) || e === e.trim(), Wi = {}.toString();
function Gi() {
	return new Ki();
}
var Ki = class extends ki {
	constructor() {
		super({
			type: "string",
			check(e) {
				return e instanceof String && (e = e.valueOf()), typeof e == "string";
			}
		}), this.withMutation(() => {
			this.transform((e, t, n) => {
				if (!n.spec.coerce || n.isType(e) || Array.isArray(e)) return e;
				let r = e != null && e.toString ? e.toString() : e;
				return r === Wi ? e : r;
			});
		});
	}
	required(e) {
		return super.required(e).withMutation((t) => t.test({
			message: e || fi.required,
			name: "required",
			skipAbsent: !0,
			test: (e) => !!e.length
		}));
	}
	notRequired() {
		return super.notRequired().withMutation((e) => (e.tests = e.tests.filter((e) => e.OPTIONS.name !== "required"), e));
	}
	length(e, t = pi.length) {
		return this.test({
			message: t,
			name: "length",
			exclusive: !0,
			params: { length: e },
			skipAbsent: !0,
			test(t) {
				return t.length === this.resolve(e);
			}
		});
	}
	min(e, t = pi.min) {
		return this.test({
			message: t,
			name: "min",
			exclusive: !0,
			params: { min: e },
			skipAbsent: !0,
			test(t) {
				return t.length >= this.resolve(e);
			}
		});
	}
	max(e, t = pi.max) {
		return this.test({
			name: "max",
			exclusive: !0,
			message: t,
			params: { max: e },
			skipAbsent: !0,
			test(t) {
				return t.length <= this.resolve(e);
			}
		});
	}
	matches(e, t) {
		let n = !1, r, i;
		return t && (typeof t == "object" ? {excludeEmptyString: n = !1, message: r, name: i} = t : r = t), this.test({
			name: i || "matches",
			message: r || pi.matches,
			params: { regex: e },
			skipAbsent: !0,
			test: (t) => t === "" && n || t.search(e) !== -1
		});
	}
	email(e = pi.email) {
		return this.matches(zi, {
			name: "email",
			message: e,
			excludeEmptyString: !0
		});
	}
	url(e = pi.url) {
		return this.matches(Bi, {
			name: "url",
			message: e,
			excludeEmptyString: !0
		});
	}
	uuid(e = pi.uuid) {
		return this.matches(Vi, {
			name: "uuid",
			message: e,
			excludeEmptyString: !1
		});
	}
	datetime(e) {
		let t = "", n, r;
		return e && (typeof e == "object" ? {message: t = "", allowOffset: n = !1, precision: r = void 0} = e : t = e), this.matches(Hi, {
			name: "datetime",
			message: t || pi.datetime,
			excludeEmptyString: !0
		}).test({
			name: "datetime_offset",
			message: t || pi.datetime_offset,
			params: { allowOffset: n },
			skipAbsent: !0,
			test: (e) => {
				if (!e || n) return !0;
				let t = Li(e);
				return t ? !!t.z : !1;
			}
		}).test({
			name: "datetime_precision",
			message: t || pi.datetime_precision,
			params: { precision: r },
			skipAbsent: !0,
			test: (e) => {
				if (!e || r == null) return !0;
				let t = Li(e);
				return t ? t.precision === r : !1;
			}
		});
	}
	ensure() {
		return this.default("").transform((e) => e === null ? "" : e);
	}
	trim(e = pi.trim) {
		return this.transform((e) => e == null ? e : e.trim()).test({
			message: e,
			name: "trim",
			test: Ui
		});
	}
	lowercase(e = pi.lowercase) {
		return this.transform((e) => wi(e) ? e : e.toLowerCase()).test({
			message: e,
			name: "string_case",
			exclusive: !0,
			skipAbsent: !0,
			test: (e) => wi(e) || e === e.toLowerCase()
		});
	}
	uppercase(e = pi.uppercase) {
		return this.transform((e) => wi(e) ? e : e.toUpperCase()).test({
			message: e,
			name: "string_case",
			exclusive: !0,
			skipAbsent: !0,
			test: (e) => wi(e) || e === e.toUpperCase()
		});
	}
};
Gi.prototype = Ki.prototype;
var qi = (e) => e != +e;
function Ji() {
	return new Yi();
}
var Yi = class extends ki {
	constructor() {
		super({
			type: "number",
			check(e) {
				return e instanceof Number && (e = e.valueOf()), typeof e == "number" && !qi(e);
			}
		}), this.withMutation(() => {
			this.transform((e, t, n) => {
				if (!n.spec.coerce) return e;
				let r = e;
				if (typeof r == "string") {
					if (r = r.replace(/\s/g, ""), r === "") return NaN;
					r = +r;
				}
				return n.isType(r) || r === null ? r : parseFloat(r);
			});
		});
	}
	min(e, t = mi.min) {
		return this.test({
			message: t,
			name: "min",
			exclusive: !0,
			params: { min: e },
			skipAbsent: !0,
			test(t) {
				return t >= this.resolve(e);
			}
		});
	}
	max(e, t = mi.max) {
		return this.test({
			message: t,
			name: "max",
			exclusive: !0,
			params: { max: e },
			skipAbsent: !0,
			test(t) {
				return t <= this.resolve(e);
			}
		});
	}
	lessThan(e, t = mi.lessThan) {
		return this.test({
			message: t,
			name: "max",
			exclusive: !0,
			params: { less: e },
			skipAbsent: !0,
			test(t) {
				return t < this.resolve(e);
			}
		});
	}
	moreThan(e, t = mi.moreThan) {
		return this.test({
			message: t,
			name: "min",
			exclusive: !0,
			params: { more: e },
			skipAbsent: !0,
			test(t) {
				return t > this.resolve(e);
			}
		});
	}
	positive(e = mi.positive) {
		return this.moreThan(0, e);
	}
	negative(e = mi.negative) {
		return this.lessThan(0, e);
	}
	integer(e = mi.integer) {
		return this.test({
			name: "integer",
			message: e,
			skipAbsent: !0,
			test: (e) => Number.isInteger(e)
		});
	}
	truncate() {
		return this.transform((e) => wi(e) ? e : e | 0);
	}
	round(e) {
		let t = [
			"ceil",
			"floor",
			"round",
			"trunc"
		];
		if (e = e?.toLowerCase() || "round", e === "trunc") return this.truncate();
		if (t.indexOf(e.toLowerCase()) === -1) throw TypeError("Only valid options for round() are: " + t.join(", "));
		return this.transform((t) => wi(t) ? t : Math[e](t));
	}
};
Ji.prototype = Yi.prototype;
var Xi = /* @__PURE__ */ new Date(""), Zi = (e) => Object.prototype.toString.call(e) === "[object Date]";
function Qi() {
	return new $i();
}
var $i = class e extends ki {
	constructor() {
		super({
			type: "date",
			check(e) {
				return Zi(e) && !isNaN(e.getTime());
			}
		}), this.withMutation(() => {
			this.transform((t, n, r) => !r.spec.coerce || r.isType(t) || t === null ? t : (t = Ii(t), isNaN(t) ? e.INVALID_DATE : new Date(t)));
		});
	}
	prepareParam(e, t) {
		let n;
		if (Ci.isRef(e)) n = e;
		else {
			let r = this.cast(e);
			if (!this._typeCheck(r)) throw TypeError(`\`${t}\` must be a Date or a value that can be \`cast()\` to a Date`);
			n = r;
		}
		return n;
	}
	min(e, t = hi.min) {
		let n = this.prepareParam(e, "min");
		return this.test({
			message: t,
			name: "min",
			exclusive: !0,
			params: { min: e },
			skipAbsent: !0,
			test(e) {
				return e >= this.resolve(n);
			}
		});
	}
	max(e, t = hi.max) {
		let n = this.prepareParam(e, "max");
		return this.test({
			message: t,
			name: "max",
			exclusive: !0,
			params: { max: e },
			skipAbsent: !0,
			test(e) {
				return e <= this.resolve(n);
			}
		});
	}
};
$i.INVALID_DATE = Xi, Qi.prototype = $i.prototype, Qi.INVALID_DATE = Xi;
function ea(e, t = []) {
	let n = [], r = /* @__PURE__ */ new Set(), i = new Set(t.map(([e, t]) => `${e}-${t}`));
	function a(e, t) {
		let a = (0, Jr.split)(e)[0];
		r.add(a), i.has(`${t}-${a}`) || n.push([t, a]);
	}
	for (let t of Object.keys(e)) {
		let n = e[t];
		r.add(t), Ci.isRef(n) && n.isSibling ? a(n.path, t) : bi(n) && "deps" in n && n.deps.forEach((e) => a(e, t));
	}
	return Xr.default.array(Array.from(r), n).reverse();
}
function ta(e, t) {
	let n = Infinity;
	return e.some((e, r) => {
		var i;
		if ((i = t.path) != null && i.includes(e)) return n = r, !0;
	}), n;
}
function na(e) {
	return (t, n) => ta(e, t) - ta(e, n);
}
var ra = (e, t, n) => {
	if (typeof e != "string") return e;
	let r = e;
	try {
		r = JSON.parse(e);
	} catch {}
	return n.isType(r) ? r : e;
};
function ia(e) {
	if ("fields" in e) {
		let t = {};
		for (let [n, r] of Object.entries(e.fields)) t[n] = ia(r);
		return e.setFields(t);
	}
	if (e.type === "array") {
		let t = e.optional();
		return t.innerType &&= ia(t.innerType), t;
	}
	return e.type === "tuple" ? e.optional().clone({ types: e.spec.types.map(ia) }) : "optional" in e ? e.optional() : e;
}
var aa = (e, t) => {
	let n = [...(0, Jr.normalizePath)(t)];
	if (n.length === 1) return n[0] in e;
	let r = n.pop(), i = (0, Jr.getter)((0, Jr.join)(n), !0)(e);
	return !!(i && r in i);
}, oa = (e) => Object.prototype.toString.call(e) === "[object Object]";
function sa(e, t) {
	let n = Object.keys(e.fields);
	return Object.keys(t).filter((e) => n.indexOf(e) === -1);
}
var ca = na([]);
function la(e) {
	return new ua(e);
}
var ua = class extends ki {
	constructor(e) {
		super({
			type: "object",
			check(e) {
				return oa(e) || typeof e == "function";
			}
		}), this.fields = Object.create(null), this._sortErrors = ca, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
			e && this.shape(e);
		});
	}
	_cast(e, t = {}) {
		let n = super._cast(e, t);
		if (n === void 0) return this.getDefault(t);
		if (!this._typeCheck(n)) return n;
		let r = this.fields, i = t.stripUnknown ?? this.spec.noUnknown, a = [].concat(this._nodes, Object.keys(n).filter((e) => !this._nodes.includes(e))), o = {}, s = Object.assign({}, t, {
			parent: o,
			__validating: t.__validating || !1
		}), c = !1;
		for (let e of a) {
			let a = r[e], l = e in n;
			if (a) {
				let r, i = n[e];
				s.path = (t.path ? `${t.path}.` : "") + e, a = a.resolve({
					value: i,
					context: t.context,
					parent: o
				});
				let l = a instanceof ki ? a.spec : void 0, u = l?.strict;
				if (l != null && l.strip) {
					c ||= e in n;
					continue;
				}
				r = !t.__validating || !u ? a.cast(n[e], s) : n[e], r !== void 0 && (o[e] = r);
			} else l && !i && (o[e] = n[e]);
			(l !== e in o || o[e] !== n[e]) && (c = !0);
		}
		return c ? o : n;
	}
	_validate(e, t = {}, n, r) {
		let { from: i = [], originalValue: a = e, recursive: o = this.spec.recursive } = t;
		t.from = [{
			schema: this,
			value: a
		}, ...i], t.__validating = !0, t.originalValue = a, super._validate(e, t, n, (e, i) => {
			if (!o || !oa(i)) {
				r(e, i);
				return;
			}
			a ||= i;
			let s = [];
			for (let e of this._nodes) {
				let n = this.fields[e];
				!n || Ci.isRef(n) || s.push(n.asNestedTest({
					options: t,
					key: e,
					parent: i,
					parentPath: t.path,
					originalParent: a
				}));
			}
			this.runTests({
				tests: s,
				value: i,
				originalValue: a,
				options: t
			}, n, (t) => {
				r(t.sort(this._sortErrors).concat(e), i);
			});
		});
	}
	clone(e) {
		let t = super.clone(e);
		return t.fields = Object.assign({}, this.fields), t._nodes = this._nodes, t._excludedEdges = this._excludedEdges, t._sortErrors = this._sortErrors, t;
	}
	concat(e) {
		let t = super.concat(e), n = t.fields;
		for (let [e, t] of Object.entries(this.fields)) {
			let r = n[e];
			n[e] = r === void 0 ? t : r;
		}
		return t.withMutation((t) => t.setFields(n, [...this._excludedEdges, ...e._excludedEdges]));
	}
	_getDefault(e) {
		if ("default" in this.spec) return super._getDefault(e);
		if (!this._nodes.length) return;
		let t = {};
		return this._nodes.forEach((n) => {
			var r;
			let i = this.fields[n], a = e;
			(r = a) != null && r.value && (a = Object.assign({}, a, {
				parent: a.value,
				value: a.value[n]
			})), t[n] = i && "getDefault" in i ? i.getDefault(a) : void 0;
		}), t;
	}
	setFields(e, t) {
		let n = this.clone();
		return n.fields = e, n._nodes = ea(e, t), n._sortErrors = na(Object.keys(e)), t && (n._excludedEdges = t), n;
	}
	shape(e, t = []) {
		return this.clone().withMutation((n) => {
			let r = n._excludedEdges;
			return t.length && (Array.isArray(t[0]) || (t = [t]), r = [...n._excludedEdges, ...t]), n.setFields(Object.assign(n.fields, e), r);
		});
	}
	partial() {
		let e = {};
		for (let [t, n] of Object.entries(this.fields)) e[t] = "optional" in n && n.optional instanceof Function ? n.optional() : n;
		return this.setFields(e);
	}
	deepPartial() {
		return ia(this);
	}
	pick(e) {
		let t = {};
		for (let n of e) this.fields[n] && (t[n] = this.fields[n]);
		return this.setFields(t, this._excludedEdges.filter(([t, n]) => e.includes(t) && e.includes(n)));
	}
	omit(e) {
		let t = [];
		for (let n of Object.keys(this.fields)) e.includes(n) || t.push(n);
		return this.pick(t);
	}
	from(e, t, n) {
		let r = (0, Jr.getter)(e, !0);
		return this.transform((i) => {
			if (!i) return i;
			let a = i;
			return aa(i, e) && (a = Object.assign({}, i), n || delete a[e], a[t] = r(i)), a;
		});
	}
	json() {
		return this.transform(ra);
	}
	noUnknown(e = !0, t = _i.noUnknown) {
		typeof e != "boolean" && (t = e, e = !0);
		let n = this.test({
			name: "noUnknown",
			exclusive: !0,
			message: t,
			test(t) {
				if (t == null) return !0;
				let n = sa(this.schema, t);
				return !e || n.length === 0 || this.createError({ params: { unknown: n.join(", ") } });
			}
		});
		return n.spec.noUnknown = e, n;
	}
	unknown(e = !0, t = _i.noUnknown) {
		return this.noUnknown(!e, t);
	}
	transformKeys(e) {
		return this.transform((t) => {
			if (!t) return t;
			let n = {};
			for (let r of Object.keys(t)) n[e(r)] = t[r];
			return n;
		});
	}
	camelCase() {
		return this.transformKeys(Yr.camelCase);
	}
	snakeCase() {
		return this.transformKeys(Yr.snakeCase);
	}
	constantCase() {
		return this.transformKeys((e) => (0, Yr.snakeCase)(e).toUpperCase());
	}
	describe(e) {
		let t = (e ? this.resolve(e) : this).clone(), n = super.describe(e);
		n.fields = {};
		for (let [i, a] of Object.entries(t.fields)) {
			var r;
			let t = e;
			(r = t) != null && r.value && (t = Object.assign({}, t, {
				parent: t.value,
				value: t.value[i]
			})), n.fields[i] = a.describe(t);
		}
		return n;
	}
};
la.prototype = ua.prototype;
function da(e) {
	return new fa(e);
}
var fa = class extends ki {
	constructor(e) {
		super({
			type: "array",
			spec: { types: e },
			check(e) {
				return Array.isArray(e);
			}
		}), this.innerType = void 0, this.innerType = e;
	}
	_cast(e, t) {
		let n = super._cast(e, t);
		if (!this._typeCheck(n) || !this.innerType) return n;
		let r = !1, i = n.map((e, n) => {
			let i = this.innerType.cast(e, Object.assign({}, t, { path: `${t.path || ""}[${n}]` }));
			return i !== e && (r = !0), i;
		});
		return r ? i : n;
	}
	_validate(e, t = {}, n, r) {
		let i = this.innerType, a = t.recursive ?? this.spec.recursive;
		t.originalValue != null && t.originalValue, super._validate(e, t, n, (o, s) => {
			if (!a || !i || !this._typeCheck(s)) {
				r(o, s);
				return;
			}
			let c = Array(s.length);
			for (let n = 0; n < s.length; n++) c[n] = i.asNestedTest({
				options: t,
				index: n,
				parent: s,
				parentPath: t.path,
				originalParent: t.originalValue ?? e
			});
			this.runTests({
				value: s,
				tests: c,
				originalValue: t.originalValue ?? e,
				options: t
			}, n, (e) => r(e.concat(o), s));
		});
	}
	clone(e) {
		let t = super.clone(e);
		return t.innerType = this.innerType, t;
	}
	json() {
		return this.transform(ra);
	}
	concat(e) {
		let t = super.concat(e);
		return t.innerType = this.innerType, e.innerType && (t.innerType = t.innerType ? t.innerType.concat(e.innerType) : e.innerType), t;
	}
	of(e) {
		let t = this.clone();
		if (!bi(e)) throw TypeError("`array.of()` sub-schema must be a valid yup schema not: " + ii(e));
		return t.innerType = e, t.spec = Object.assign({}, t.spec, { types: e }), t;
	}
	length(e, t = vi.length) {
		return this.test({
			message: t,
			name: "length",
			exclusive: !0,
			params: { length: e },
			skipAbsent: !0,
			test(t) {
				return t.length === this.resolve(e);
			}
		});
	}
	min(e, t) {
		return t ||= vi.min, this.test({
			message: t,
			name: "min",
			exclusive: !0,
			params: { min: e },
			skipAbsent: !0,
			test(t) {
				return t.length >= this.resolve(e);
			}
		});
	}
	max(e, t) {
		return t ||= vi.max, this.test({
			message: t,
			name: "max",
			exclusive: !0,
			params: { max: e },
			skipAbsent: !0,
			test(t) {
				return t.length <= this.resolve(e);
			}
		});
	}
	ensure() {
		return this.default(() => []).transform((e, t) => this._typeCheck(e) ? e : t == null ? [] : [].concat(t));
	}
	compact(e) {
		let t = e ? (t, n, r) => !e(t, n, r) : (e) => !!e;
		return this.transform((e) => e == null ? e : e.filter(t));
	}
	describe(e) {
		let t = (e ? this.resolve(e) : this).clone(), n = super.describe(e);
		if (t.innerType) {
			var r;
			let i = e;
			(r = i) != null && r.value && (i = Object.assign({}, i, {
				parent: i.value,
				value: i.value[0]
			})), n.innerType = t.innerType.describe(i);
		}
		return n;
	}
};
da.prototype = fa.prototype;
function pa(e) {
	return new ma(e);
}
var ma = class extends ki {
	constructor(e) {
		super({
			type: "tuple",
			spec: { types: e },
			check(e) {
				let t = this.spec.types;
				return Array.isArray(e) && e.length === t.length;
			}
		}), this.withMutation(() => {
			this.typeError(yi.notType);
		});
	}
	_cast(e, t) {
		let { types: n } = this.spec, r = super._cast(e, t);
		if (!this._typeCheck(r)) return r;
		let i = !1, a = n.map((e, n) => {
			let a = e.cast(r[n], Object.assign({}, t, { path: `${t.path || ""}[${n}]` }));
			return a !== r[n] && (i = !0), a;
		});
		return i ? a : r;
	}
	_validate(e, t = {}, n, r) {
		let i = this.spec.types;
		super._validate(e, t, n, (a, o) => {
			if (!this._typeCheck(o)) {
				r(a, o);
				return;
			}
			let s = [];
			for (let [n, r] of i.entries()) s[n] = r.asNestedTest({
				options: t,
				index: n,
				parent: o,
				parentPath: t.path,
				originalParent: t.originalValue ?? e
			});
			this.runTests({
				value: o,
				tests: s,
				originalValue: t.originalValue ?? e,
				options: t
			}, n, (e) => r(e.concat(a), o));
		});
	}
	describe(e) {
		let t = (e ? this.resolve(e) : this).clone(), n = super.describe(e);
		return n.innerType = t.spec.types.map((t, n) => {
			var r;
			let i = e;
			return (r = i) != null && r.value && (i = Object.assign({}, i, {
				parent: i.value,
				value: i.value[n]
			})), t.describe(i);
		}), n;
	}
};
pa.prototype = ma.prototype;
//#endregion
//#region src/dialog/dialog-signature/signature-validation-schema.ts
/* istanbul ignore file */
var ha = la().shape({
	personID: Gi().required("Person ID is a required field"),
	personType: ji().oneOf(Object.values(Se), "Person Type is invalid").required("Person Type is a required field"),
	ipAddress: Gi().required("IP Address is a required field"),
	browser: Gi().required("Browser is a required field"),
	browserUserAgent: Gi().required("Browser User Agent is a required field"),
	dateSignedUTC: Gi().required("Date Signed UTC is a required field"),
	timeZoneSignedIANA: Gi().required("Time Zone is a required field"),
	dataUri: Gi().required("Signature data is required")
}), ga = (e, t) => {
	let n = window.navigator;
	return {
		personID: e,
		personType: t,
		ipAddress: "ip",
		browser: n.platform,
		browserUserAgent: n.userAgent,
		dateSignedUTC: (/* @__PURE__ */ new Date()).toISOString(),
		timeZoneSignedIANA: _a(),
		dataUri: ""
	};
}, _a = () => {
	let e = (/* @__PURE__ */ new Date()).getTimezoneOffset(), t = Math.floor(Math.abs(e) / 60), n = Math.abs(e) % 60;
	return `UTC${e > 0 ? "-" : "+"}${String(t).padStart(2, "0")}:${String(n).padStart(2, "0")}`;
}, va = (e) => {
	let { handleSubmit: t, register: n, trigger: r, setValue: i, formState: a } = zr({
		resolver: Wr(ha),
		defaultValues: ga(e.recipientId, e.personType)
	}), [o, s] = je({
		path: "/api/Signature",
		method: e.isAddNewSignature ? "POST" : "PUT",
		headers: e.headers,
		isProtectedRoute: e.isProtected
	});
	return {
		trigger: r,
		onCanvaschange: (e) => {
			i("dataUri", e), r("dataUri");
		},
		isValid: () => a.isValid,
		register: n,
		isSubmitLoading: s,
		handleSubmitSignature: () => t(async (t) => {
			let n = { ...t };
			if (e.lazyApiCall) return e.onSignatureSubmitted?.(t.dataUri, t, () => o(n));
			let r = await o(n);
			if (r) {
				e.handlerModalClose();
				try {
					await e.onSignatureSubmitted?.(t.dataUri, r);
				} catch (e) {
					console.error("Error in onSignatureSubmitted:", e);
				}
			}
		}),
		formState: a
	};
}, ya = "ci3l3zk", ba = "s13wsogi", xa = ({ className: e, ...t }) => /* @__PURE__ */ F(z, {
	className: Ct(ya, e),
	...t
}), Sa = ({ className: e, ...t }) => /* @__PURE__ */ F(z, {
	className: Ct(ba, e),
	...t
}), Ca = ({ handlerModalClose: e, isValid: t, isSubmitLoading: n, handleSubmitSignature: r, submitButtonText: i }) => /* @__PURE__ */ F(b, { children: /* @__PURE__ */ I(me, { children: [/* @__PURE__ */ F(xa, {
	size: "medium",
	name: "submit-cancel",
	variant: "secondary",
	disabled: n,
	onClick: e,
	children: "Cancel"
}), /* @__PURE__ */ F(Sa, {
	size: "medium",
	role: "button",
	name: "submit-btn",
	disabled: !t() || n,
	variant: "primary",
	isBusy: n,
	onClick: r(),
	children: i
})] }) }), wa = ({ className: e, handlerModalClose: t, isModalOpen: n, initialSignature: r, isAddNewSignature: i, onSignatureSubmitted: a, recipientId: o, personType: s, headers: c = {}, isProtected: l = !1, isLazyApiCall: u = !1, submitButtonText: d = "Adopt Signature" }) => {
	let { onCanvaschange: f, register: p, isValid: m, handleSubmitSignature: h, isSubmitLoading: g } = va({
		recipientId: o,
		personType: s,
		handlerModalClose: t,
		onSignatureSubmitted: a,
		isAddNewSignature: i,
		headers: c,
		isProtected: l,
		lazyApiCall: u
	});
	return /* @__PURE__ */ F(b, { children: /* @__PURE__ */ F(Wt, {
		hasFullScreen: !0,
		hasCloseButton: !0,
		isModalOpen: n,
		className: e,
		handlerModalClose: t,
		title: "Add your signature",
		footer: /* @__PURE__ */ F(Ca, {
			handlerModalClose: t,
			handleSubmitSignature: h,
			isSubmitLoading: g,
			isValid: m,
			submitButtonText: d
		}),
		children: /* @__PURE__ */ I(L, {
			hasMaxWidth: !0,
			isFlexColumn: !0,
			className: Ct(se, M),
			children: [/* @__PURE__ */ F(ye, { children: "Draw your signature in the space provided. If you would like to redo the signature, tap ‘Clear’ and try again." }), /* @__PURE__ */ F(Pe, {
				className: Ct(le),
				children: /* @__PURE__ */ F(Ht, {
					initialSignature: r,
					...p("dataUri"),
					onChange: (e) => f(e)
				})
			})]
		})
	}) });
}, Ta = "c6pq5ho", Ea = /*#__PURE__*/ Ft("div")({
	name: "ContentContainer",
	class: "c1vo00t0",
	propsAsIs: !1
}), Da = /*#__PURE__*/ Ft("div")({
	name: "AgreementMessage",
	class: "az3zsje",
	propsAsIs: !1
}), Oa = /*#__PURE__*/ Ft("div")({
	name: "ChangeRequestList",
	class: "c4w9j6i",
	propsAsIs: !1
}), ka = /*#__PURE__*/ Ft("div")({
	name: "ChangeRequestItem",
	class: "c1t4vtcu",
	propsAsIs: !1
}), Aa = /*#__PURE__*/ Ft("div")({
	name: "DesktopButtonGroupWrapper",
	class: "d5jchms",
	propsAsIs: !1
}), ja = "mipfoam", Ma = ({ className: e, ...t }) => /* @__PURE__ */ F(z, {
	className: Ct(ja, e),
	...t
}), Na = (e, t, n, r) => {
	let i = B(), [a, o] = je({
		path: `/api/recipient/${e}/Status`,
		method: "PATCH",
		headers: {},
		isProtectedRoute: !1
	}), s = () => r === Se.Representee ? n ? we.ChangeRequestedByRepresentee : we.RepresenteeSigned : n ? Ce.ChangeRequested : Ce.RecipientSigned;
	return {
		isSubmitLoading: o,
		handleSubmitAgreement: async () => {
			await a({ activity: s() }) && i(`/success/${n ? "changed-request" : "submitted"}?recId=${e}&orgId=${t}`);
		}
	};
}, Pa = ({ className: e, handlerModalClose: t, handleSubmitAgreement: n, isModalOpen: r, changeRequested: i, isLoading: a }) => i?.length ? /* @__PURE__ */ F(b, { children: /* @__PURE__ */ F(Wt, {
	hasFullScreen: !0,
	hasCloseButton: !0,
	className: e,
	handlerModalClose: t,
	isModalOpen: r,
	title: "Submit change request",
	footer: /* @__PURE__ */ I(me, { children: [/* @__PURE__ */ F(Aa, { children: /* @__PURE__ */ F(an, {
		alignment: "right",
		children: /* @__PURE__ */ F(z, {
			size: "large",
			isBusy: a,
			disabled: a,
			variant: "primary",
			onClick: n,
			children: "Submit Request"
		})
	}) }), /* @__PURE__ */ F(Ma, {
		size: "large",
		isBusy: a,
		disabled: a,
		variant: "primary",
		onClick: n,
		children: "Submit Request"
	})] }),
	children: /* @__PURE__ */ I(Ea, { children: [
		/* @__PURE__ */ F(Da, { children: "You have made a change request to:" }),
		/* @__PURE__ */ F(Oa, { children: i.map((e, t) => /* @__PURE__ */ F(ka, {
			className: Ta,
			children: e
		}, t)) }),
		/* @__PURE__ */ F(Da, { children: "Unfortunately you are unable to proceed with the lease signing at this time. We’ll review your request and issue a revised agreement." })
	] })
}) }) : null, Fa = ({ className: e, title: t, message: n, onCancel: r, onClose: i, onConfirm: a, isOpen: o, isLoading: s, cancelButtonText: c = "Cancel", confirmButtonText: l = "Confirm", intent: u = "primary" }) => {
	let d = ((e) => e === "neutral" || e === "default" ? {
		variant: "secondary",
		isDestructive: void 0
	} : e === "danger" ? {
		variant: "primary",
		isDestructive: !0
	} : {
		variant: e,
		isDestructive: void 0
	})(u);
	return /* @__PURE__ */ F(b, { children: /* @__PURE__ */ F(Wt, {
		className: e,
		handlerModalClose: i,
		isModalOpen: o,
		title: t,
		footer: /* @__PURE__ */ I(an, {
			alignment: "right",
			children: [/* @__PURE__ */ F(z, {
				size: "medium",
				variant: "secondary",
				disabled: s,
				onClick: r,
				children: c
			}), /* @__PURE__ */ F(z, {
				size: "medium",
				variant: d.variant,
				isDestructive: d.isDestructive,
				isBusy: s,
				disabled: s,
				onClick: a,
				children: l
			})]
		}),
		children: /* @__PURE__ */ F("div", {
			className: xe,
			children: n
		})
	}) });
}, Ia = e.createContext(void 0), La = (t) => {
	let n = e.useContext(Ia);
	if (t) return t;
	if (!n) throw Error("No QueryClient set, use QueryClientProvider to set one");
	return n;
}, Ra = (e) => {
	let [t, n] = y(!1), [r, i] = y(), [a] = De((e) => {
		let t = new Image();
		t.crossOrigin = "anonymous", t.src = e, t.onload = () => {
			i(t), n(!1);
		}, t.onerror = () => {
			n(!1);
		};
	}, { startImmediately: !0 });
	return p(() => {
		if (e) return n(!0), a(e), () => i(void 0);
	}, [e]), {
		image: r,
		isLoading: t
	};
}, za = ({ data: e, personType: t, queryClient: n, cardId: r, index: i, recipientId: a, stepsId: o, dataKey: s = "cardDisplayDataBody" }) => {
	let [c, l] = y(e?.dataUri), [u, d] = y(!1), f = La(n), m = g(Te(`/api/recipient/${a}/Card`, {
		step: o,
		cardNum: r
	}), [
		a,
		o,
		r
	]), h = g(() => [
		"step",
		a,
		o
	], [a, o]);
	if (p(() => {
		e.dataUri && l(e.dataUri);
	}, [e.dataUri]), !e) return null;
	let { image: _, isLoading: v } = Ra(c);
	return e?.dataUri && !_ || v ? /* @__PURE__ */ F(qt, {
		className: P,
		width: "100%",
		height: "120px",
		role: "progressbar"
	}) : /* @__PURE__ */ I(me, { children: [/* @__PURE__ */ I(L, {
		className: Ct("c86x3ub", P, _ ? "with-data" : ""),
		onClick: () => d(!0),
		children: [/* @__PURE__ */ F(Ht, {
			disabled: !0,
			initialSignature: _
		}), !_ && /* @__PURE__ */ F(R, {
			className: Ct("description", ue),
			intent: "primary",
			hasBoldText: !0,
			hasCenteredText: !0,
			children: "Tap here to add your signature"
		})]
	}), /* @__PURE__ */ F(wa, {
		handlerModalClose: () => d(!1),
		initialSignature: _,
		isModalOpen: u,
		onSignatureSubmitted: async (e, t) => {
			e && (l(e), f.setQueryData([m], (e) => {
				let n = [...e[s]];
				return n[i].data = t, {
					...e,
					[s]: n
				};
			}), f.setQueryData(h, (e) => ({
				...e,
				continueButtonEnabled: !0
			})));
		},
		recipientId: a,
		personType: t,
		isAddNewSignature: !e?.dataUri && (!e?.browser || !e?.browserUserAgent)
	})] });
}, Ba = /*#__PURE__*/ Ft("div")({
	name: "StyledCard",
	class: "s13sja2g",
	propsAsIs: !1
}), Va = /*#__PURE__*/ Ft("div")({
	name: "CardHeaderContainer",
	class: "c1i58dto",
	propsAsIs: !1
}), Ha = /*#__PURE__*/ Ft("div")({
	name: "CardBodyWrapperContainer",
	class: "c2ea4b9",
	propsAsIs: !1
}), Ua = /*#__PURE__*/ Ft("div")({
	name: "CardBodySectionContainer",
	class: "c1wm8bfo",
	propsAsIs: !1
}), Wa = ({ Icon: e, title: t, className: n, ...r }) => /* @__PURE__ */ I(Va, {
	className: n,
	...r,
	children: [e, t && /* @__PURE__ */ F(he, {
		font: "text-base/regular",
		colour: "secondary",
		children: t
	})]
}), Ga = ({ className: e, ...t }) => /* @__PURE__ */ F(Ha, {
	className: e,
	...t
}), Ka = ({ className: e, ...t }) => /* @__PURE__ */ F(Ua, {
	className: e,
	...t
}), qa = (e) => /* @__PURE__ */ F(he, {
	font: "text-xl/bold",
	colour: "primary",
	...e
}), Ja = (e) => /* @__PURE__ */ F(he, {
	font: "text-base/regular",
	colour: "primary",
	...e
}), Ya = (e) => /* @__PURE__ */ F(he, {
	font: "text-xs/regular",
	colour: "secondary",
	...e
}), Xa = ({ className: e, ...t }) => /* @__PURE__ */ F(Ba, {
	className: e,
	...t
}), Za = ({ action: e, data: t, personType: n, queryClient: r, cardId: i, index: a, recipientId: o, stepsId: s, dataKey: c }) => {
	switch (e) {
		case "saveToContacts": return /* @__PURE__ */ F(en, { data: t });
		case "viewInMaps": return /* @__PURE__ */ F(Jt, { data: t });
		case "signature": return /* @__PURE__ */ F(za, {
			index: a,
			data: t,
			personType: n,
			queryClient: r,
			cardId: i,
			recipientId: o,
			stepsId: s,
			dataKey: c
		});
		default: return null;
	}
}, Qa = (e, t, n) => {
	let r = t.lastIndexOf("?"), i = e[r === -1 || r < t.lastIndexOf("/") ? t : t.slice(0, r)];
	return i ? typeof i == "function" ? i() : Promise.resolve(i) : new Promise((e, r) => {
		(typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(r.bind(null, /* @__PURE__ */ Error("Unknown variable dynamic import: " + t + (t.split("/").length === n ? "" : ". Note that variables only represent file names one level deep."))));
	});
}, $a = {
	add: "add",
	check: "check",
	close: "close",
	copy: "copy",
	delete: "delete",
	edit: "edit",
	export: "export",
	info: "info",
	more: "more",
	search: "search",
	settings: "settings",
	trash: "trash",
	warning: "warning",
	chevronDown: "chevron-down",
	chevronUp: "chevron-up",
	chevronLeft: "chevron-left",
	chevronRight: "chevron-right",
	arrowDown: "arrow-down",
	arrowUp: "arrow-up",
	arrowLeft: "arrow-left",
	arrowRight: "arrow-right"
}, eo = /*#__PURE__*/ Ft("div")({
	name: "FormIconContainer",
	class: "f1ff97qc",
	propsAsIs: !1
}), to = ({ iconName: e, intent: t, rounded: n, size: r, noPadding: i }) => {
	let { SvgIcon: a, loading: o } = no(e), { ReapitIcon: s, loading: c } = ro(e), l = o || c, u = a ? /* @__PURE__ */ F(a, {}) : s ? /* @__PURE__ */ F(s, { color: "inherit" }) : null;
	return !u && !l ? null : /* @__PURE__ */ I(eo, {
		className: Ct(t && `intent-${t}`, n && "icon-rounded", r && `size-${r}`, i && "no-padding"),
		children: [l && /* @__PURE__ */ F("div", { style: {
			height: "1em",
			width: "1em"
		} }), !l && u]
	});
};
function no(e) {
	let [t, n] = y(null), [r, i] = y(!0), [a, o] = y(null);
	return p(() => {
		(async () => {
			if (i(!0), o(null), !e) {
				n(null), o(/* @__PURE__ */ Error("Icon: not-found")), i(!1);
				return;
			}
			try {
				let t = await Qa(/* #__PURE__ */ Object.assign({
					"../assets/icons/address.svg": () => import("./address-CsAXb3dU.js"),
					"../assets/icons/agreement.svg": () => import("./agreement-CtG3g_2q.js"),
					"../assets/icons/bond.svg": () => import("./bond-BoqgRMO2.js"),
					"../assets/icons/bylaws.svg": () => import("./bylaws-mnvRgTPK.js"),
					"../assets/icons/calendar.svg": () => import("./calendar-DZsLW-8D.js"),
					"../assets/icons/ceiling-insulation.svg": () => import("./ceiling-insulation-CQlGjveF.js"),
					"../assets/icons/electricity.svg": () => import("./electricity-BCDvkxZ4.js"),
					"../assets/icons/emergencymaintenance.svg": () => import("./emergencymaintenance--heKh0SJ.js"),
					"../assets/icons/gas.svg": () => import("./gas-DKIQCt5K.js"),
					"../assets/icons/glasses-invisible.svg": () => import("./glasses-invisible-0zwy_Qta.js"),
					"../assets/icons/healthy-homes.svg": () => import("./healthy-homes-HCN0_1Qh.js"),
					"../assets/icons/inclusion.svg": () => import("./inclusion-Ivo9rLct.js"),
					"../assets/icons/insurance.svg": () => import("./insurance-w3k875Xc.js"),
					"../assets/icons/lock.svg": () => import("./lock-CHIhhnL_.js"),
					"../assets/icons/not-found.svg": () => import("./not-found-DdANaOJJ.js"),
					"../assets/icons/occupants.svg": () => import("./occupants-B0D26NSD.js"),
					"../assets/icons/otherRepairs.svg": () => import("./otherRepairs-flwGeRmn.js"),
					"../assets/icons/owners.svg": () => import("./owners-Bw_dMS-4.js"),
					"../assets/icons/payment.svg": () => import("./payment-Dsv02L1h.js"),
					"../assets/icons/pencil-edit-square.svg": () => import("./pencil-edit-square-5Irk-UuK.js"),
					"../assets/icons/person.svg": () => import("./person-CCUMYztE.js"),
					"../assets/icons/pet.svg": () => import("./pet-BdE4RJKF.js"),
					"../assets/icons/phone.svg": () => import("./phone-BTAsMhC5.js"),
					"../assets/icons/plumbing.svg": () => import("./plumbing-CgsJNyHJ.js"),
					"../assets/icons/rent.svg": () => import("./rent-BFfEMKcW.js"),
					"../assets/icons/settings.svg": () => import("./settings-DjRhazXd.js"),
					"../assets/icons/signature.svg": () => import("./signature-ii0YNcww.js"),
					"../assets/icons/smokealarm.svg": () => import("./smokealarm-3ewN4xHF.js"),
					"../assets/icons/trash.svg": () => import("./trash-acXvZo75.js"),
					"../assets/icons/underfloor-insulation.svg": () => import("./underfloor-insulation-BYK1B8tM.js"),
					"../assets/icons/wall-insulation.svg": () => import("./wall-insulation-DSNFjYqY.js"),
					"../assets/icons/water.svg": () => import("./water-DSyJ1CL0.js")
				}), `../assets/icons/${e}.svg?react`, 4);
				n(() => t.ReactComponent || t.default);
			} catch {
				n(null), o(/* @__PURE__ */ Error(`Local icon not found: ${e}`));
			} finally {
				i(!1);
			}
		})();
	}, [e]), {
		SvgIcon: t,
		loading: r,
		error: a
	};
}
function ro(e) {
	let [t, n] = y(null), [r, i] = y(!0), [a, o] = y(null);
	return p(() => {
		(async () => {
			if (i(!0), o(null), !e) {
				n(null), i(!1);
				return;
			}
			let t = $a[e] || e.replace(/([A-Z])/g, "-$1").toLowerCase().replace(/^-/, "");
			try {
				let e = await import(`@reapit/elements/icons/${t}`), r = Object.keys(e).find((e) => e.endsWith("Icon"));
				if (r) n(() => e[r]);
				else throw Error("No icon component found in module");
			} catch {
				n(null), o(/* @__PURE__ */ Error(`Reapit icon not found: ${e}`));
			} finally {
				i(!1);
			}
		})();
	}, [e]), {
		ReapitIcon: t,
		loading: r,
		error: a
	};
}
//#endregion
//#region src/render-html/index.tsx
var io = "dqyey9s", ao = ({ htmlString: e }) => /* @__PURE__ */ F("div", {
	className: io,
	dangerouslySetInnerHTML: { __html: e }
}), oo = "e1fne3kq", so = "e1rue5y3", co = "eek5nfc", lo = "e10lbyoz", uo = "ery5b1i", fo = "eelr47z", po = "e1js7psk", mo = "e1yxk2zh", ho = "e8cvq5i", go = "e1lijjb4", _o = "eq6op9c", vo = "ehj0fi9", yo = "elo5z3c", bo = "enmtyfk", xo = "e9kvf4c", So = "ecasyoh", Co = "e1uflo5q", wo = "e1o0r473", To = "eyrvftq", Eo = "e14lhmxe", Do = "eqly08y", Oo = "e1nuo1z5", ko = "e16a3b8o", Ao = "epthliq", jo = "e1ix9686", Mo = "e1ti7f2i", No = "e9gkaod", Po = "eo4m7vs", Fo = "eu6t2ld", Io = "e101kdyx", Lo = "epx8z64", Ro = /*#__PURE__*/ Ft("div")({
	name: "FileInformationContainer",
	class: "fwp76zs",
	propsAsIs: !1
}), zo = /*#__PURE__*/ Ft("span")({
	name: "FileInformationName",
	class: "f1dmypcs",
	propsAsIs: !1
}), Bo = /*#__PURE__*/ Ft("span")({
	name: "FileInformationSize",
	class: "fp5y5zx",
	propsAsIs: !1
}), Vo = /*#__PURE__*/ Ft("div")({
	name: "InputFileWrapper",
	class: "i1clzgo8",
	propsAsIs: !1
}), Ho = /*#__PURE__*/ Ft("div")({
	name: "FileExtention",
	class: "f2o5oot",
	propsAsIs: !1
}), Uo = /*#__PURE__*/ Ft("div")({
	name: "FileInformationListContainer",
	class: "fq52g4w",
	propsAsIs: !1
}), Wo = ({ index: e, onDeleteFile: t, onRetry: n, internalStatus: r, fileName: i, fileSize: a, fileId: o }) => {
	let s = r === "PENDING", c = r === "ERROR";
	return /* @__PURE__ */ I(Ro, {
		"aria-invalid": c,
		children: [
			/* @__PURE__ */ F(Ho, { children: C(i) }),
			/* @__PURE__ */ F(zo, { children: i }),
			s && /* @__PURE__ */ F(Le, {}),
			!s && !c && /* @__PURE__ */ I(me, { children: [/* @__PURE__ */ F(Bo, { children: w(a) }), /* @__PURE__ */ F(z, {
				"aria-label": "Remove File",
				iconLeft: /* @__PURE__ */ F(Fe, {}),
				size: "small",
				variant: "tertiary",
				onClick: () => t?.(e, o)
			})] }),
			c && /* @__PURE__ */ F(z, {
				onClick: () => n?.(e),
				variant: "tertiary",
				iconRight: /* @__PURE__ */ F(Ie, {}),
				hasNoPadding: !0,
				size: "small",
				children: "Retry"
			})
		]
	});
};
//#endregion
//#region src/input-ui/input-file/index.tsx
function Go({ label: e, required: n, errorMessage: r, allowMultiple: i, defaultData: a, onChange: o, disabled: s, acceptedFileType: c, minimumFileSize: l, maximumFileSize: u, disableDeleteActualFile: d, organizationId: f }) {
	let p = t.useRef(null), [m, h] = t.useState(), [g, _] = t.useState(), [v, y] = t.useState(), [b, C] = t.useState(a ? Array.isArray(a) ? a : [a] : []), { upload: w, archiveFiles: E } = Ee({ organizationId: f }), { childHandler: D, isDragOverZone: O, registerMainHandler: j } = Oe(), M = b.length, ee = (e) => {
		o?.(e);
	}, te = async (e, t) => {
		if (!e.fileId) return;
		let n;
		try {
			await E(e.fileId);
		} catch {
			n = "ERROR";
		}
		C((e) => {
			let r = [...e], a = r.splice(t, 1);
			return n === "ERROR" && r.splice(t, 0, {
				...a[0],
				internalStatus: "ERROR"
			}), ee?.(i ? r : r[0]), r;
		});
	}, ne = async (e) => {
		let t, n;
		try {
			n = await w(e), t = "NEW";
		} catch {
			y(e), t = "ERROR";
		}
		C((r) => {
			let a = r.map((r) => r.fileName === e.name ? {
				...r,
				fileId: n?.fileId,
				internalStatus: t
			} : r);
			return ee?.(i ? a : a[0]), a;
		});
	}, re = (e) => {
		if (Number.isNaN(e) || e < 0 || e >= M) return;
		let t = [...b], n = t.splice(e, 1)[0];
		!n.internalStatus && n.fileId && !d && (te(n, e), t.splice(e, 0, {
			...n,
			internalStatus: "PENDING"
		})), p.current && (p.current.value = ""), C(t), ee?.(i ? t : t[0]);
	}, ie = (e) => {
		C((t) => {
			let n = [...e].reduce((e, n) => {
				if (t.find((e) => e.fileName === n.name)) return e;
				let r = {
					fileName: n.name,
					fileSize: n.size,
					internalStatus: "PENDING"
				};
				return ne(n), [...e, r];
			}, []);
			if (n.length === 0) return t;
			let r = [...t, ...n];
			return ee?.(i ? r : n[0]), [...t, ...n];
		});
	}, ae = async (e, t = b[0]) => {
		let n = t && !t?.internalStatus, r = {
			fileName: e.name,
			fileSize: e.size,
			internalStatus: "PENDING"
		};
		if (C([r]), ee(r), n && t.fileId) try {
			await E(t.fileId);
		} catch {
			y({
				...t,
				file: e
			}), C([{
				...r,
				internalStatus: "ERROR"
			}]);
			return;
		}
		ne(e);
	}, oe = (e) => {
		h(!1), _(!1);
		let t = Array.isArray(e) ? e : e.target.files;
		if (!(!t || !t.length)) return A(t, c) ? k(t, l, u) ? i ? ie(t) : ae(t[0]) : _(!0) : h(!0);
	}, se = async (e) => {
		let t = b[e];
		C((t) => t.map((t, n) => n === e ? {
			...t,
			internalStatus: "PENDING"
		} : t));
		let n = v && !(v instanceof File), r = v instanceof File;
		if (t.fileId !== void 0) return re(e);
		if (r) return ne(v);
		if (n) return ae(v.file, v);
	}, ce = t.useMemo(() => !l && !u ? "" : l ? u ? `File size should be atleast ${l} and can't exceed ${u}` : `File size should be atleast ${l}` : `File size can't exceed ${u}`, [l, u]), le = t.useMemo(() => !l && !u ? "" : l ? u ? `**Minimum file size is ${l} and maximum file size is ${u}` : `**Minimum file size is ${l}` : `**Maximum file size is ${u}`, [l, u]), N = t.useMemo(() => c ? `*File type should be ${x[c]}` : "", [c]);
	return /* @__PURE__ */ I(Re, { children: [
		e && /* @__PURE__ */ F(Re.Label, { children: T(e, n) }),
		/* @__PURE__ */ I(Vo, {
			className: Ct(O && "drag-over"),
			"aria-disabled": s,
			"aria-invalid": !!r,
			onClick: () => p.current?.click(),
			...j(oe),
			children: [/* @__PURE__ */ F("input", {
				ref: p,
				accept: c ? S[c]?.join(",") : "*",
				onChange: oe,
				type: "file",
				multiple: i,
				...D
			}), /* @__PURE__ */ I(he, {
				font: "text-sm/regular",
				colour: "primary",
				...D,
				children: [!O && /* @__PURE__ */ I(me, { children: [
					"Drag and drop or",
					" ",
					/* @__PURE__ */ F("span", {
						className: "action-text",
						...D,
						children: "browse files"
					})
				] }), O && "Drop here to upload"]
			})]
		}),
		(N || le) && /* @__PURE__ */ I(me, { children: [N && /* @__PURE__ */ F(Re.HelpText, {
			id: "file-type-guide",
			children: N
		}), le && /* @__PURE__ */ F(Re.HelpText, {
			id: "file-size-guide",
			children: le
		})] }),
		!!b.length && /* @__PURE__ */ F(Uo, { children: b.map((e, t) => /* @__PURE__ */ F(Wo, {
			index: t,
			onRetry: se,
			onDeleteFile: re,
			...e
		}, t)) }),
		m && /* @__PURE__ */ F(Re.ErrorText, {
			id: "invalid-file-type",
			children: "Please add a valid file type!"
		}),
		g && /* @__PURE__ */ F(Re.ErrorText, {
			id: "invalid-file-size",
			children: ce
		}),
		r && /* @__PURE__ */ F(Re.ErrorText, {
			id: "error-upload-file",
			children: r
		})
	] });
}
//#endregion
//#region src/form-section-divider/index.tsx
var Ko = "f1dttf61", qo = ({ size: e = "normal", className: t, ...n }) => /* @__PURE__ */ F(Ne, {
	className: Ct(Ko, `form-section-divider-${e}`, t),
	...n
}), Jo = ({ title: e, description: t, children: n, className: r, disableLineSeparator: i = !1 }) => /* @__PURE__ */ I(L, {
	isFlexWrap: !0,
	isFlexColumn: !0,
	children: [
		(e || t) && /* @__PURE__ */ I(L, {
			isFlexColumn: !0,
			className: de,
			children: [e && /* @__PURE__ */ F(he, {
				font: "text-sm/bold",
				colour: "primary",
				children: e
			}), t && /* @__PURE__ */ F(he, {
				font: "text-sm/regular",
				colour: "primary",
				className: Ct(ce),
				children: t
			})]
		}),
		n && /* @__PURE__ */ F(L, {
			isFlexColumn: !0,
			className: Ct(pe, r),
			isFlexWrap: !0,
			children: n
		}),
		!i && /* @__PURE__ */ F(qo, {})
	]
});
//#endregion
//#region ../../node_modules/@dnd-kit/utilities/dist/utilities.esm.js
function Yo() {
	var e = [...arguments];
	return g(() => (t) => {
		e.forEach((e) => e(t));
	}, e);
}
var Xo = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0;
function Zo(e) {
	let t = Object.prototype.toString.call(e);
	return t === "[object Window]" || t === "[object global]";
}
function Qo(e) {
	return "nodeType" in e;
}
function $o(e) {
	return e ? Zo(e) ? e : Qo(e) ? e.ownerDocument?.defaultView ?? window : window : window;
}
function es(e) {
	let { Document: t } = $o(e);
	return e instanceof t;
}
function ts(e) {
	return Zo(e) ? !1 : e instanceof $o(e).HTMLElement;
}
function ns(e) {
	return e instanceof $o(e).SVGElement;
}
function rs(e) {
	return e ? Zo(e) ? e.document : Qo(e) ? es(e) ? e : ts(e) || ns(e) ? e.ownerDocument : document : document : document;
}
var is = Xo ? h : p;
function as(e) {
	let t = v(e);
	return is(() => {
		t.current = e;
	}), u(function() {
		var e = [...arguments];
		return t.current == null ? void 0 : t.current(...e);
	}, []);
}
function os() {
	let e = v(null);
	return [u((t, n) => {
		e.current = setInterval(t, n);
	}, []), u(() => {
		e.current !== null && (clearInterval(e.current), e.current = null);
	}, [])];
}
function ss(e, t) {
	t === void 0 && (t = [e]);
	let n = v(e);
	return is(() => {
		n.current !== e && (n.current = e);
	}, t), n;
}
function cs(e, t) {
	let n = v();
	return g(() => {
		let t = e(n.current);
		return n.current = t, t;
	}, [...t]);
}
function ls(e) {
	let t = as(e), n = v(null);
	return [n, u((e) => {
		e !== n.current && t?.(e, n.current), n.current = e;
	}, [])];
}
function us(e) {
	let t = v();
	return p(() => {
		t.current = e;
	}, [e]), t.current;
}
var ds = {};
function fs(e, t) {
	return g(() => {
		if (t) return t;
		let n = ds[e] == null ? 0 : ds[e] + 1;
		return ds[e] = n, e + "-" + n;
	}, [e, t]);
}
function ps(e) {
	return function(t) {
		return [...arguments].slice(1).reduce((t, n) => {
			let r = Object.entries(n);
			for (let [n, i] of r) {
				let r = t[n];
				r != null && (t[n] = r + e * i);
			}
			return t;
		}, { ...t });
	};
}
var ms = /*#__PURE__*/ ps(1), hs = /*#__PURE__*/ ps(-1);
function gs(e) {
	return "clientX" in e && "clientY" in e;
}
function _s(e) {
	if (!e) return !1;
	let { KeyboardEvent: t } = $o(e.target);
	return t && e instanceof t;
}
function vs(e) {
	if (!e) return !1;
	let { TouchEvent: t } = $o(e.target);
	return t && e instanceof t;
}
function ys(e) {
	if (vs(e)) {
		if (e.touches && e.touches.length) {
			let { clientX: t, clientY: n } = e.touches[0];
			return {
				x: t,
				y: n
			};
		} else if (e.changedTouches && e.changedTouches.length) {
			let { clientX: t, clientY: n } = e.changedTouches[0];
			return {
				x: t,
				y: n
			};
		}
	}
	return gs(e) ? {
		x: e.clientX,
		y: e.clientY
	} : null;
}
var bs = /*#__PURE__*/ Object.freeze({
	Translate: { toString(e) {
		if (!e) return;
		let { x: t, y: n } = e;
		return "translate3d(" + (t ? Math.round(t) : 0) + "px, " + (n ? Math.round(n) : 0) + "px, 0)";
	} },
	Scale: { toString(e) {
		if (!e) return;
		let { scaleX: t, scaleY: n } = e;
		return "scaleX(" + t + ") scaleY(" + n + ")";
	} },
	Transform: { toString(e) {
		if (e) return [bs.Translate.toString(e), bs.Scale.toString(e)].join(" ");
	} },
	Transition: { toString(e) {
		let { property: t, duration: n, easing: r } = e;
		return t + " " + n + "ms " + r;
	} }
}), xs = "a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]";
function Ss(e) {
	return e.matches(xs) ? e : e.querySelector(xs);
}
//#endregion
//#region ../../node_modules/@dnd-kit/accessibility/dist/accessibility.esm.js
var Cs = { display: "none" };
function ws(e) {
	let { id: n, value: r } = e;
	return t.createElement("div", {
		id: n,
		style: Cs
	}, r);
}
function Ts(e) {
	let { id: n, announcement: r, ariaLiveType: i = "assertive" } = e;
	return t.createElement("div", {
		id: n,
		style: {
			position: "fixed",
			top: 0,
			left: 0,
			width: 1,
			height: 1,
			margin: -1,
			border: 0,
			padding: 0,
			overflow: "hidden",
			clip: "rect(0 0 0 0)",
			clipPath: "inset(100%)",
			whiteSpace: "nowrap"
		},
		role: "status",
		"aria-live": i,
		"aria-atomic": !0
	}, r);
}
function Es() {
	let [e, t] = y("");
	return {
		announce: u((e) => {
			e != null && t(e);
		}, []),
		announcement: e
	};
}
//#endregion
//#region ../../node_modules/@dnd-kit/core/dist/core.esm.js
var Ds = /*#__PURE__*/ a(null);
function Os(e) {
	let t = d(Ds);
	p(() => {
		if (!t) throw Error("useDndMonitor must be used within a children of <DndContext>");
		return t(e);
	}, [e, t]);
}
function ks() {
	let [e] = y(() => /* @__PURE__ */ new Set()), t = u((t) => (e.add(t), () => e.delete(t)), [e]);
	return [u((t) => {
		let { type: n, event: r } = t;
		e.forEach((e) => e[n]?.call(e, r));
	}, [e]), t];
}
var As = { draggable: "\n    To pick up a draggable item, press the space bar.\n    While dragging, use the arrow keys to move the item.\n    Press space again to drop the item in its new position, or press escape to cancel.\n  " }, js = {
	onDragStart(e) {
		let { active: t } = e;
		return "Picked up draggable item " + t.id + ".";
	},
	onDragOver(e) {
		let { active: t, over: n } = e;
		return n ? "Draggable item " + t.id + " was moved over droppable area " + n.id + "." : "Draggable item " + t.id + " is no longer over a droppable area.";
	},
	onDragEnd(e) {
		let { active: t, over: n } = e;
		return n ? "Draggable item " + t.id + " was dropped over droppable area " + n.id : "Draggable item " + t.id + " was dropped.";
	},
	onDragCancel(e) {
		let { active: t } = e;
		return "Dragging was cancelled. Draggable item " + t.id + " was dropped.";
	}
};
function Ms(e) {
	let { announcements: n = js, container: r, hiddenTextDescribedById: i, screenReaderInstructions: a = As } = e, { announce: o, announcement: s } = Es(), c = fs("DndLiveRegion"), [l, u] = y(!1);
	if (p(() => {
		u(!0);
	}, []), Os(g(() => ({
		onDragStart(e) {
			let { active: t } = e;
			o(n.onDragStart({ active: t }));
		},
		onDragMove(e) {
			let { active: t, over: r } = e;
			n.onDragMove && o(n.onDragMove({
				active: t,
				over: r
			}));
		},
		onDragOver(e) {
			let { active: t, over: r } = e;
			o(n.onDragOver({
				active: t,
				over: r
			}));
		},
		onDragEnd(e) {
			let { active: t, over: r } = e;
			o(n.onDragEnd({
				active: t,
				over: r
			}));
		},
		onDragCancel(e) {
			let { active: t, over: r } = e;
			o(n.onDragCancel({
				active: t,
				over: r
			}));
		}
	}), [o, n])), !l) return null;
	let d = t.createElement(t.Fragment, null, t.createElement(ws, {
		id: i,
		value: a.draggable
	}), t.createElement(Ts, {
		id: c,
		announcement: s
	}));
	return r ? Ve(d, r) : d;
}
var Ns;
(function(e) {
	e.DragStart = "dragStart", e.DragMove = "dragMove", e.DragEnd = "dragEnd", e.DragCancel = "dragCancel", e.DragOver = "dragOver", e.RegisterDroppable = "registerDroppable", e.SetDroppableDisabled = "setDroppableDisabled", e.UnregisterDroppable = "unregisterDroppable";
})(Ns ||= {});
function Ps() {}
function Fs(e, t) {
	return g(() => ({
		sensor: e,
		options: t ?? {}
	}), [e, t]);
}
function Is() {
	var e = [...arguments];
	return g(() => [...e].filter((e) => e != null), [...e]);
}
var Ls = /*#__PURE__*/ Object.freeze({
	x: 0,
	y: 0
});
function Rs(e, t) {
	return Math.sqrt((e.x - t.x) ** 2 + (e.y - t.y) ** 2);
}
function zs(e, t) {
	let { data: { value: n } } = e, { data: { value: r } } = t;
	return n - r;
}
function Bs(e, t) {
	let { data: { value: n } } = e, { data: { value: r } } = t;
	return r - n;
}
function Vs(e, t) {
	if (!e || e.length === 0) return null;
	let [n] = e;
	return t ? n[t] : n;
}
function Hs(e, t, n) {
	return t === void 0 && (t = e.left), n === void 0 && (n = e.top), {
		x: t + e.width * .5,
		y: n + e.height * .5
	};
}
var Us = (e) => {
	let { collisionRect: t, droppableRects: n, droppableContainers: r } = e, i = Hs(t, t.left, t.top), a = [];
	for (let e of r) {
		let { id: t } = e, r = n.get(t);
		if (r) {
			let n = Rs(Hs(r), i);
			a.push({
				id: t,
				data: {
					droppableContainer: e,
					value: n
				}
			});
		}
	}
	return a.sort(zs);
};
function Ws(e, t) {
	let n = Math.max(t.top, e.top), r = Math.max(t.left, e.left), i = Math.min(t.left + t.width, e.left + e.width), a = Math.min(t.top + t.height, e.top + e.height), o = i - r, s = a - n;
	if (r < i && n < a) {
		let n = t.width * t.height, r = e.width * e.height, i = o * s, a = i / (n + r - i);
		return Number(a.toFixed(4));
	}
	return 0;
}
var Gs = (e) => {
	let { collisionRect: t, droppableRects: n, droppableContainers: r } = e, i = [];
	for (let e of r) {
		let { id: r } = e, a = n.get(r);
		if (a) {
			let n = Ws(a, t);
			n > 0 && i.push({
				id: r,
				data: {
					droppableContainer: e,
					value: n
				}
			});
		}
	}
	return i.sort(Bs);
};
function Ks(e, t, n) {
	return {
		...e,
		scaleX: t && n ? t.width / n.width : 1,
		scaleY: t && n ? t.height / n.height : 1
	};
}
function qs(e, t) {
	return e && t ? {
		x: e.left - t.left,
		y: e.top - t.top
	} : Ls;
}
function Js(e) {
	return function(t) {
		return [...arguments].slice(1).reduce((t, n) => ({
			...t,
			top: t.top + e * n.y,
			bottom: t.bottom + e * n.y,
			left: t.left + e * n.x,
			right: t.right + e * n.x
		}), { ...t });
	};
}
var Ys = /*#__PURE__*/ Js(1);
function Xs(e) {
	if (e.startsWith("matrix3d(")) {
		let t = e.slice(9, -1).split(/, /);
		return {
			x: +t[12],
			y: +t[13],
			scaleX: +t[0],
			scaleY: +t[5]
		};
	} else if (e.startsWith("matrix(")) {
		let t = e.slice(7, -1).split(/, /);
		return {
			x: +t[4],
			y: +t[5],
			scaleX: +t[0],
			scaleY: +t[3]
		};
	}
	return null;
}
function Zs(e, t, n) {
	let r = Xs(t);
	if (!r) return e;
	let { scaleX: i, scaleY: a, x: o, y: s } = r, c = e.left - o - (1 - i) * parseFloat(n), l = e.top - s - (1 - a) * parseFloat(n.slice(n.indexOf(" ") + 1)), u = i ? e.width / i : e.width, d = a ? e.height / a : e.height;
	return {
		width: u,
		height: d,
		top: l,
		right: c + u,
		bottom: l + d,
		left: c
	};
}
var Qs = { ignoreTransform: !1 };
function $s(e, t) {
	t === void 0 && (t = Qs);
	let n = e.getBoundingClientRect();
	if (t.ignoreTransform) {
		let { transform: t, transformOrigin: r } = $o(e).getComputedStyle(e);
		t && (n = Zs(n, t, r));
	}
	let { top: r, left: i, width: a, height: o, bottom: s, right: c } = n;
	return {
		top: r,
		left: i,
		width: a,
		height: o,
		bottom: s,
		right: c
	};
}
function ec(e) {
	return $s(e, { ignoreTransform: !0 });
}
function tc(e) {
	let t = e.innerWidth, n = e.innerHeight;
	return {
		top: 0,
		left: 0,
		right: t,
		bottom: n,
		width: t,
		height: n
	};
}
function nc(e, t) {
	return t === void 0 && (t = $o(e).getComputedStyle(e)), t.position === "fixed";
}
function rc(e, t) {
	t === void 0 && (t = $o(e).getComputedStyle(e));
	let n = /(auto|scroll|overlay)/;
	return [
		"overflow",
		"overflowX",
		"overflowY"
	].some((e) => {
		let r = t[e];
		return typeof r == "string" ? n.test(r) : !1;
	});
}
function ic(e, t) {
	let n = [];
	function r(i) {
		if (t != null && n.length >= t || !i) return n;
		if (es(i) && i.scrollingElement != null && !n.includes(i.scrollingElement)) return n.push(i.scrollingElement), n;
		if (!ts(i) || ns(i) || n.includes(i)) return n;
		let a = $o(e).getComputedStyle(i);
		return i !== e && rc(i, a) && n.push(i), nc(i, a) ? n : r(i.parentNode);
	}
	return e ? r(e) : n;
}
function ac(e) {
	let [t] = ic(e, 1);
	return t ?? null;
}
function oc(e) {
	return !Xo || !e ? null : Zo(e) ? e : Qo(e) ? es(e) || e === rs(e).scrollingElement ? window : ts(e) ? e : null : null;
}
function sc(e) {
	return Zo(e) ? e.scrollX : e.scrollLeft;
}
function cc(e) {
	return Zo(e) ? e.scrollY : e.scrollTop;
}
function lc(e) {
	return {
		x: sc(e),
		y: cc(e)
	};
}
var uc;
(function(e) {
	e[e.Forward = 1] = "Forward", e[e.Backward = -1] = "Backward";
})(uc ||= {});
function dc(e) {
	return !Xo || !e ? !1 : e === document.scrollingElement;
}
function fc(e) {
	let t = {
		x: 0,
		y: 0
	}, n = dc(e) ? {
		height: window.innerHeight,
		width: window.innerWidth
	} : {
		height: e.clientHeight,
		width: e.clientWidth
	}, r = {
		x: e.scrollWidth - n.width,
		y: e.scrollHeight - n.height
	};
	return {
		isTop: e.scrollTop <= t.y,
		isLeft: e.scrollLeft <= t.x,
		isBottom: e.scrollTop >= r.y,
		isRight: e.scrollLeft >= r.x,
		maxScroll: r,
		minScroll: t
	};
}
var pc = {
	x: .2,
	y: .2
};
function mc(e, t, n, r, i) {
	let { top: a, left: o, right: s, bottom: c } = n;
	r === void 0 && (r = 10), i === void 0 && (i = pc);
	let { isTop: l, isBottom: u, isLeft: d, isRight: f } = fc(e), p = {
		x: 0,
		y: 0
	}, m = {
		x: 0,
		y: 0
	}, h = {
		height: t.height * i.y,
		width: t.width * i.x
	};
	return !l && a <= t.top + h.height ? (p.y = uc.Backward, m.y = r * Math.abs((t.top + h.height - a) / h.height)) : !u && c >= t.bottom - h.height && (p.y = uc.Forward, m.y = r * Math.abs((t.bottom - h.height - c) / h.height)), !f && s >= t.right - h.width ? (p.x = uc.Forward, m.x = r * Math.abs((t.right - h.width - s) / h.width)) : !d && o <= t.left + h.width && (p.x = uc.Backward, m.x = r * Math.abs((t.left + h.width - o) / h.width)), {
		direction: p,
		speed: m
	};
}
function hc(e) {
	if (e === document.scrollingElement) {
		let { innerWidth: e, innerHeight: t } = window;
		return {
			top: 0,
			left: 0,
			right: e,
			bottom: t,
			width: e,
			height: t
		};
	}
	let { top: t, left: n, right: r, bottom: i } = e.getBoundingClientRect();
	return {
		top: t,
		left: n,
		right: r,
		bottom: i,
		width: e.clientWidth,
		height: e.clientHeight
	};
}
function gc(e) {
	return e.reduce((e, t) => ms(e, lc(t)), Ls);
}
function _c(e) {
	return e.reduce((e, t) => e + sc(t), 0);
}
function vc(e) {
	return e.reduce((e, t) => e + cc(t), 0);
}
function yc(e, t) {
	if (t === void 0 && (t = $s), !e) return;
	let { top: n, left: r, bottom: i, right: a } = t(e);
	ac(e) && (i <= 0 || a <= 0 || n >= window.innerHeight || r >= window.innerWidth) && e.scrollIntoView({
		block: "center",
		inline: "center"
	});
}
var bc = [[
	"x",
	["left", "right"],
	_c
], [
	"y",
	["top", "bottom"],
	vc
]], xc = class {
	constructor(e, t) {
		this.rect = void 0, this.width = void 0, this.height = void 0, this.top = void 0, this.bottom = void 0, this.right = void 0, this.left = void 0;
		let n = ic(t), r = gc(n);
		this.rect = { ...e }, this.width = e.width, this.height = e.height;
		for (let [e, t, i] of bc) for (let a of t) Object.defineProperty(this, a, {
			get: () => {
				let t = i(n), o = r[e] - t;
				return this.rect[a] + o;
			},
			enumerable: !0
		});
		Object.defineProperty(this, "rect", { enumerable: !1 });
	}
}, Sc = class {
	constructor(e) {
		this.target = void 0, this.listeners = [], this.removeAll = () => {
			this.listeners.forEach((e) => this.target?.removeEventListener(...e));
		}, this.target = e;
	}
	add(e, t, n) {
		var r;
		(r = this.target) == null || r.addEventListener(e, t, n), this.listeners.push([
			e,
			t,
			n
		]);
	}
};
function eee(e) {
	let { EventTarget: t } = $o(e);
	return e instanceof t ? e : rs(e);
}
function Cc(e, t) {
	let n = Math.abs(e.x), r = Math.abs(e.y);
	return typeof t == "number" ? Math.sqrt(n ** 2 + r ** 2) > t : "x" in t && "y" in t ? n > t.x && r > t.y : "x" in t ? n > t.x : "y" in t ? r > t.y : !1;
}
var wc;
(function(e) {
	e.Click = "click", e.DragStart = "dragstart", e.Keydown = "keydown", e.ContextMenu = "contextmenu", e.Resize = "resize", e.SelectionChange = "selectionchange", e.VisibilityChange = "visibilitychange";
})(wc ||= {});
function Tc(e) {
	e.preventDefault();
}
function Ec(e) {
	e.stopPropagation();
}
var Dc;
(function(e) {
	e.Space = "Space", e.Down = "ArrowDown", e.Right = "ArrowRight", e.Left = "ArrowLeft", e.Up = "ArrowUp", e.Esc = "Escape", e.Enter = "Enter", e.Tab = "Tab";
})(Dc ||= {});
var Oc = {
	start: [Dc.Space, Dc.Enter],
	cancel: [Dc.Esc],
	end: [
		Dc.Space,
		Dc.Enter,
		Dc.Tab
	]
}, tee = (e, t) => {
	let { currentCoordinates: n } = t;
	switch (e.code) {
		case Dc.Right: return {
			...n,
			x: n.x + 25
		};
		case Dc.Left: return {
			...n,
			x: n.x - 25
		};
		case Dc.Down: return {
			...n,
			y: n.y + 25
		};
		case Dc.Up: return {
			...n,
			y: n.y - 25
		};
	}
}, kc = class {
	constructor(e) {
		this.props = void 0, this.autoScrollEnabled = !1, this.referenceCoordinates = void 0, this.listeners = void 0, this.windowListeners = void 0, this.props = e;
		let { event: { target: t } } = e;
		this.props = e, this.listeners = new Sc(rs(t)), this.windowListeners = new Sc($o(t)), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleCancel = this.handleCancel.bind(this), this.attach();
	}
	attach() {
		this.handleStart(), this.windowListeners.add(wc.Resize, this.handleCancel), this.windowListeners.add(wc.VisibilityChange, this.handleCancel), setTimeout(() => this.listeners.add(wc.Keydown, this.handleKeyDown));
	}
	handleStart() {
		let { activeNode: e, onStart: t } = this.props, n = e.node.current;
		n && yc(n), t(Ls);
	}
	handleKeyDown(e) {
		if (_s(e)) {
			let { active: t, context: n, options: r } = this.props, { keyboardCodes: i = Oc, coordinateGetter: a = tee, scrollBehavior: o = "smooth" } = r, { code: s } = e;
			if (i.end.includes(s)) {
				this.handleEnd(e);
				return;
			}
			if (i.cancel.includes(s)) {
				this.handleCancel(e);
				return;
			}
			let { collisionRect: c } = n.current, l = c ? {
				x: c.left,
				y: c.top
			} : Ls;
			this.referenceCoordinates ||= l;
			let u = a(e, {
				active: t,
				context: n.current,
				currentCoordinates: l
			});
			if (u) {
				let t = hs(u, l), r = {
					x: 0,
					y: 0
				}, { scrollableAncestors: i } = n.current;
				for (let n of i) {
					let i = e.code, { isTop: a, isRight: s, isLeft: c, isBottom: l, maxScroll: d, minScroll: f } = fc(n), p = hc(n), m = {
						x: Math.min(i === Dc.Right ? p.right - p.width / 2 : p.right, Math.max(i === Dc.Right ? p.left : p.left + p.width / 2, u.x)),
						y: Math.min(i === Dc.Down ? p.bottom - p.height / 2 : p.bottom, Math.max(i === Dc.Down ? p.top : p.top + p.height / 2, u.y))
					}, h = i === Dc.Right && !s || i === Dc.Left && !c, g = i === Dc.Down && !l || i === Dc.Up && !a;
					if (h && m.x !== u.x) {
						let e = n.scrollLeft + t.x, a = i === Dc.Right && e <= d.x || i === Dc.Left && e >= f.x;
						if (a && !t.y) {
							n.scrollTo({
								left: e,
								behavior: o
							});
							return;
						}
						a ? r.x = n.scrollLeft - e : r.x = i === Dc.Right ? n.scrollLeft - d.x : n.scrollLeft - f.x, r.x && n.scrollBy({
							left: -r.x,
							behavior: o
						});
						break;
					} else if (g && m.y !== u.y) {
						let e = n.scrollTop + t.y, a = i === Dc.Down && e <= d.y || i === Dc.Up && e >= f.y;
						if (a && !t.x) {
							n.scrollTo({
								top: e,
								behavior: o
							});
							return;
						}
						a ? r.y = n.scrollTop - e : r.y = i === Dc.Down ? n.scrollTop - d.y : n.scrollTop - f.y, r.y && n.scrollBy({
							top: -r.y,
							behavior: o
						});
						break;
					}
				}
				this.handleMove(e, ms(hs(u, this.referenceCoordinates), r));
			}
		}
	}
	handleMove(e, t) {
		let { onMove: n } = this.props;
		e.preventDefault(), n(t);
	}
	handleEnd(e) {
		let { onEnd: t } = this.props;
		e.preventDefault(), this.detach(), t();
	}
	handleCancel(e) {
		let { onCancel: t } = this.props;
		e.preventDefault(), this.detach(), t();
	}
	detach() {
		this.listeners.removeAll(), this.windowListeners.removeAll();
	}
};
kc.activators = [{
	eventName: "onKeyDown",
	handler: (e, t, n) => {
		let { keyboardCodes: r = Oc, onActivation: i } = t, { active: a } = n, { code: o } = e.nativeEvent;
		if (r.start.includes(o)) {
			let t = a.activatorNode.current;
			return t && e.target !== t ? !1 : (e.preventDefault(), i?.({ event: e.nativeEvent }), !0);
		}
		return !1;
	}
}];
function Ac(e) {
	return !!(e && "distance" in e);
}
function jc(e) {
	return !!(e && "delay" in e);
}
var Mc = class {
	constructor(e, t, n) {
		n === void 0 && (n = eee(e.event.target)), this.props = void 0, this.events = void 0, this.autoScrollEnabled = !0, this.document = void 0, this.activated = !1, this.initialCoordinates = void 0, this.timeoutId = null, this.listeners = void 0, this.documentListeners = void 0, this.windowListeners = void 0, this.props = e, this.events = t;
		let { event: r } = e, { target: i } = r;
		this.props = e, this.events = t, this.document = rs(i), this.documentListeners = new Sc(this.document), this.listeners = new Sc(n), this.windowListeners = new Sc($o(i)), this.initialCoordinates = ys(r) ?? Ls, this.handleStart = this.handleStart.bind(this), this.handleMove = this.handleMove.bind(this), this.handleEnd = this.handleEnd.bind(this), this.handleCancel = this.handleCancel.bind(this), this.handleKeydown = this.handleKeydown.bind(this), this.removeTextSelection = this.removeTextSelection.bind(this), this.attach();
	}
	attach() {
		let { events: e, props: { options: { activationConstraint: t, bypassActivationConstraint: n } } } = this;
		if (this.listeners.add(e.move.name, this.handleMove, { passive: !1 }), this.listeners.add(e.end.name, this.handleEnd), e.cancel && this.listeners.add(e.cancel.name, this.handleCancel), this.windowListeners.add(wc.Resize, this.handleCancel), this.windowListeners.add(wc.DragStart, Tc), this.windowListeners.add(wc.VisibilityChange, this.handleCancel), this.windowListeners.add(wc.ContextMenu, Tc), this.documentListeners.add(wc.Keydown, this.handleKeydown), t) {
			if (n != null && n({
				event: this.props.event,
				activeNode: this.props.activeNode,
				options: this.props.options
			})) return this.handleStart();
			if (jc(t)) {
				this.timeoutId = setTimeout(this.handleStart, t.delay), this.handlePending(t);
				return;
			}
			if (Ac(t)) {
				this.handlePending(t);
				return;
			}
		}
		this.handleStart();
	}
	detach() {
		this.listeners.removeAll(), this.windowListeners.removeAll(), setTimeout(this.documentListeners.removeAll, 50), this.timeoutId !== null && (clearTimeout(this.timeoutId), this.timeoutId = null);
	}
	handlePending(e, t) {
		let { active: n, onPending: r } = this.props;
		r(n, e, this.initialCoordinates, t);
	}
	handleStart() {
		let { initialCoordinates: e } = this, { onStart: t } = this.props;
		e && (this.activated = !0, this.documentListeners.add(wc.Click, Ec, { capture: !0 }), this.removeTextSelection(), this.documentListeners.add(wc.SelectionChange, this.removeTextSelection), t(e));
	}
	handleMove(e) {
		let { activated: t, initialCoordinates: n, props: r } = this, { onMove: i, options: { activationConstraint: a } } = r;
		if (!n) return;
		let o = ys(e) ?? Ls, s = hs(n, o);
		if (!t && a) {
			if (Ac(a)) {
				if (a.tolerance != null && Cc(s, a.tolerance)) return this.handleCancel();
				if (Cc(s, a.distance)) return this.handleStart();
			}
			if (jc(a) && Cc(s, a.tolerance)) return this.handleCancel();
			this.handlePending(a, s);
			return;
		}
		e.cancelable && e.preventDefault(), i(o);
	}
	handleEnd() {
		let { onAbort: e, onEnd: t } = this.props;
		this.detach(), this.activated || e(this.props.active), t();
	}
	handleCancel() {
		let { onAbort: e, onCancel: t } = this.props;
		this.detach(), this.activated || e(this.props.active), t();
	}
	handleKeydown(e) {
		e.code === Dc.Esc && this.handleCancel();
	}
	removeTextSelection() {
		var e;
		(e = this.document.getSelection()) == null || e.removeAllRanges();
	}
}, Nc = {
	cancel: { name: "pointercancel" },
	move: { name: "pointermove" },
	end: { name: "pointerup" }
}, Pc = class extends Mc {
	constructor(e) {
		let { event: t } = e, n = rs(t.target);
		super(e, Nc, n);
	}
};
Pc.activators = [{
	eventName: "onPointerDown",
	handler: (e, t) => {
		let { nativeEvent: n } = e, { onActivation: r } = t;
		return !n.isPrimary || n.button !== 0 ? !1 : (r?.({ event: n }), !0);
	}
}];
var Fc = {
	move: { name: "mousemove" },
	end: { name: "mouseup" }
}, Ic;
(function(e) {
	e[e.RightClick = 2] = "RightClick";
})(Ic ||= {});
var Lc = class extends Mc {
	constructor(e) {
		super(e, Fc, rs(e.event.target));
	}
};
Lc.activators = [{
	eventName: "onMouseDown",
	handler: (e, t) => {
		let { nativeEvent: n } = e, { onActivation: r } = t;
		return n.button === Ic.RightClick ? !1 : (r?.({ event: n }), !0);
	}
}];
var Rc = {
	cancel: { name: "touchcancel" },
	move: { name: "touchmove" },
	end: { name: "touchend" }
}, zc = class extends Mc {
	constructor(e) {
		super(e, Rc);
	}
	static setup() {
		return window.addEventListener(Rc.move.name, e, {
			capture: !1,
			passive: !1
		}), function() {
			window.removeEventListener(Rc.move.name, e);
		};
		function e() {}
	}
};
zc.activators = [{
	eventName: "onTouchStart",
	handler: (e, t) => {
		let { nativeEvent: n } = e, { onActivation: r } = t, { touches: i } = n;
		return i.length > 1 ? !1 : (r?.({ event: n }), !0);
	}
}];
var Bc;
(function(e) {
	e[e.Pointer = 0] = "Pointer", e[e.DraggableRect = 1] = "DraggableRect";
})(Bc ||= {});
var Vc;
(function(e) {
	e[e.TreeOrder = 0] = "TreeOrder", e[e.ReversedTreeOrder = 1] = "ReversedTreeOrder";
})(Vc ||= {});
function nee(e) {
	let { acceleration: t, activator: n = Bc.Pointer, canScroll: r, draggingRect: i, enabled: a, interval: o = 5, order: s = Vc.TreeOrder, pointerCoordinates: c, scrollableAncestors: l, scrollableAncestorRects: d, delta: f, threshold: m } = e, h = iee({
		delta: f,
		disabled: !a
	}), [_, y] = os(), b = v({
		x: 0,
		y: 0
	}), x = v({
		x: 0,
		y: 0
	}), S = g(() => {
		switch (n) {
			case Bc.Pointer: return c ? {
				top: c.y,
				bottom: c.y,
				left: c.x,
				right: c.x
			} : null;
			case Bc.DraggableRect: return i;
		}
	}, [
		n,
		i,
		c
	]), C = v(null), w = u(() => {
		let e = C.current;
		if (!e) return;
		let t = b.current.x * x.current.x, n = b.current.y * x.current.y;
		e.scrollBy(t, n);
	}, []), T = g(() => s === Vc.TreeOrder ? [...l].reverse() : l, [s, l]);
	p(() => {
		if (!a || !l.length || !S) {
			y();
			return;
		}
		for (let e of T) {
			if (r?.(e) === !1) continue;
			let n = d[l.indexOf(e)];
			if (!n) continue;
			let { direction: i, speed: a } = mc(e, n, S, t, m);
			for (let e of ["x", "y"]) h[e][i[e]] || (a[e] = 0, i[e] = 0);
			if (a.x > 0 || a.y > 0) {
				y(), C.current = e, _(w, o), b.current = a, x.current = i;
				return;
			}
		}
		b.current = {
			x: 0,
			y: 0
		}, x.current = {
			x: 0,
			y: 0
		}, y();
	}, [
		t,
		w,
		r,
		y,
		a,
		o,
		JSON.stringify(S),
		JSON.stringify(h),
		_,
		l,
		T,
		d,
		JSON.stringify(m)
	]);
}
var ree = {
	x: {
		[uc.Backward]: !1,
		[uc.Forward]: !1
	},
	y: {
		[uc.Backward]: !1,
		[uc.Forward]: !1
	}
};
function iee(e) {
	let { delta: t, disabled: n } = e, r = us(t);
	return cs((e) => {
		if (n || !r || !e) return ree;
		let i = {
			x: Math.sign(t.x - r.x),
			y: Math.sign(t.y - r.y)
		};
		return {
			x: {
				[uc.Backward]: e.x[uc.Backward] || i.x === -1,
				[uc.Forward]: e.x[uc.Forward] || i.x === 1
			},
			y: {
				[uc.Backward]: e.y[uc.Backward] || i.y === -1,
				[uc.Forward]: e.y[uc.Forward] || i.y === 1
			}
		};
	}, [
		n,
		t,
		r
	]);
}
function aee(e, t) {
	let n = t == null ? void 0 : e.get(t), r = n ? n.node.current : null;
	return cs((e) => t == null ? null : r ?? e ?? null, [r, t]);
}
function oee(e, t) {
	return g(() => e.reduce((e, n) => {
		let { sensor: r } = n, i = r.activators.map((e) => ({
			eventName: e.eventName,
			handler: t(e.handler, n)
		}));
		return [...e, ...i];
	}, []), [e, t]);
}
var Hc;
(function(e) {
	e[e.Always = 0] = "Always", e[e.BeforeDragging = 1] = "BeforeDragging", e[e.WhileDragging = 2] = "WhileDragging";
})(Hc ||= {});
var Uc;
(function(e) {
	e.Optimized = "optimized";
})(Uc ||= {});
var Wc = /*#__PURE__*/ new Map();
function Gc(e, t) {
	let { dragging: n, dependencies: r, config: i } = t, [a, o] = y(null), { frequency: s, measure: c, strategy: l } = i, d = v(e), f = b(), m = ss(f), h = u(function(e) {
		e === void 0 && (e = []), !m.current && o((t) => t === null ? e : t.concat(e.filter((e) => !t.includes(e))));
	}, [m]), g = v(null), _ = cs((t) => {
		if (f && !n) return Wc;
		if (!t || t === Wc || d.current !== e || a != null) {
			let t = /* @__PURE__ */ new Map();
			for (let n of e) {
				if (!n) continue;
				if (a && a.length > 0 && !a.includes(n.id) && n.rect.current) {
					t.set(n.id, n.rect.current);
					continue;
				}
				let e = n.node.current, r = e ? new xc(c(e), e) : null;
				n.rect.current = r, r && t.set(n.id, r);
			}
			return t;
		}
		return t;
	}, [
		e,
		a,
		n,
		f,
		c
	]);
	return p(() => {
		d.current = e;
	}, [e]), p(() => {
		f || h();
	}, [n, f]), p(() => {
		a && a.length > 0 && o(null);
	}, [JSON.stringify(a)]), p(() => {
		f || typeof s != "number" || g.current !== null || (g.current = setTimeout(() => {
			h(), g.current = null;
		}, s));
	}, [
		s,
		f,
		h,
		...r
	]), {
		droppableRects: _,
		measureDroppableContainers: h,
		measuringScheduled: a != null
	};
	function b() {
		switch (l) {
			case Hc.Always: return !1;
			case Hc.BeforeDragging: return n;
			default: return !n;
		}
	}
}
function Kc(e, t) {
	return cs((n) => e ? n || (typeof t == "function" ? t(e) : e) : null, [t, e]);
}
function qc(e, t) {
	return Kc(e, t);
}
function Jc(e) {
	let { callback: t, disabled: n } = e, r = as(t), i = g(() => {
		if (n || typeof window > "u" || window.MutationObserver === void 0) return;
		let { MutationObserver: e } = window;
		return new e(r);
	}, [r, n]);
	return p(() => () => i?.disconnect(), [i]), i;
}
function Yc(e) {
	let { callback: t, disabled: n } = e, r = as(t), i = g(() => {
		if (n || typeof window > "u" || window.ResizeObserver === void 0) return;
		let { ResizeObserver: e } = window;
		return new e(r);
	}, [n]);
	return p(() => () => i?.disconnect(), [i]), i;
}
function Xc(e) {
	return new xc($s(e), e);
}
function Zc(e, t, n) {
	t === void 0 && (t = Xc);
	let [r, i] = y(null);
	function a() {
		i((r) => {
			if (!e) return null;
			if (e.isConnected === !1) return r ?? n ?? null;
			let i = t(e);
			return JSON.stringify(r) === JSON.stringify(i) ? r : i;
		});
	}
	let o = Jc({ callback(t) {
		if (e) for (let n of t) {
			let { type: t, target: r } = n;
			if (t === "childList" && r instanceof HTMLElement && r.contains(e)) {
				a();
				break;
			}
		}
	} }), s = Yc({ callback: a });
	return is(() => {
		a(), e ? (s?.observe(e), o?.observe(document.body, {
			childList: !0,
			subtree: !0
		})) : (s?.disconnect(), o?.disconnect());
	}, [e]), r;
}
function Qc(e) {
	return qs(e, Kc(e));
}
var $c = [];
function el(e) {
	let t = v(e), n = cs((n) => e ? n && n !== $c && e && t.current && e.parentNode === t.current.parentNode ? n : ic(e) : $c, [e]);
	return p(() => {
		t.current = e;
	}, [e]), n;
}
function tl(e) {
	let [t, n] = y(null), r = v(e), i = u((e) => {
		let t = oc(e.target);
		t && n((e) => e ? (e.set(t, lc(t)), new Map(e)) : null);
	}, []);
	return p(() => {
		let t = r.current;
		if (e !== t) {
			a(t);
			let o = e.map((e) => {
				let t = oc(e);
				return t ? (t.addEventListener("scroll", i, { passive: !0 }), [t, lc(t)]) : null;
			}).filter((e) => e != null);
			n(o.length ? new Map(o) : null), r.current = e;
		}
		return () => {
			a(e), a(t);
		};
		function a(e) {
			e.forEach((e) => {
				oc(e)?.removeEventListener("scroll", i);
			});
		}
	}, [i, e]), g(() => e.length ? t ? Array.from(t.values()).reduce((e, t) => ms(e, t), Ls) : gc(e) : Ls, [e, t]);
}
function nl(e, t) {
	t === void 0 && (t = []);
	let n = v(null);
	return p(() => {
		n.current = null;
	}, t), p(() => {
		let t = e !== Ls;
		t && !n.current && (n.current = e), !t && n.current && (n.current = null);
	}, [e]), n.current ? hs(e, n.current) : Ls;
}
function rl(e) {
	p(() => {
		if (!Xo) return;
		let t = e.map((e) => {
			let { sensor: t } = e;
			return t.setup == null ? void 0 : t.setup();
		});
		return () => {
			for (let e of t) e?.();
		};
	}, e.map((e) => {
		let { sensor: t } = e;
		return t;
	}));
}
function il(e, t) {
	return g(() => e.reduce((e, n) => {
		let { eventName: r, handler: i } = n;
		return e[r] = (e) => {
			i(e, t);
		}, e;
	}, {}), [e, t]);
}
function al(e) {
	return g(() => e ? tc(e) : null, [e]);
}
var ol = [];
function see(e, t) {
	t === void 0 && (t = $s);
	let [n] = e, r = al(n ? $o(n) : null), [i, a] = y(ol);
	function o() {
		a(() => e.length ? e.map((e) => dc(e) ? r : new xc(t(e), e)) : ol);
	}
	let s = Yc({ callback: o });
	return is(() => {
		s?.disconnect(), o(), e.forEach((e) => s?.observe(e));
	}, [e]), i;
}
function cee(e) {
	if (!e) return null;
	if (e.children.length > 1) return e;
	let t = e.children[0];
	return ts(t) ? t : e;
}
function lee(e) {
	let { measure: t } = e, [n, r] = y(null), i = Yc({ callback: u((e) => {
		for (let { target: n } of e) if (ts(n)) {
			r((e) => {
				let r = t(n);
				return e ? {
					...e,
					width: r.width,
					height: r.height
				} : r;
			});
			break;
		}
	}, [t]) }), [a, o] = ls(u((e) => {
		let n = cee(e);
		i?.disconnect(), n && i?.observe(n), r(n ? t(n) : null);
	}, [t, i]));
	return g(() => ({
		nodeRef: a,
		rect: n,
		setRef: o
	}), [
		n,
		a,
		o
	]);
}
var uee = [{
	sensor: Pc,
	options: {}
}, {
	sensor: kc,
	options: {}
}], dee = { current: {} }, sl = {
	draggable: { measure: ec },
	droppable: {
		measure: ec,
		strategy: Hc.WhileDragging,
		frequency: Uc.Optimized
	},
	dragOverlay: { measure: $s }
}, cl = class extends Map {
	get(e) {
		return e == null ? void 0 : super.get(e) ?? void 0;
	}
	toArray() {
		return Array.from(this.values());
	}
	getEnabled() {
		return this.toArray().filter((e) => {
			let { disabled: t } = e;
			return !t;
		});
	}
	getNodeFor(e) {
		return this.get(e)?.node.current ?? void 0;
	}
}, fee = {
	activatorEvent: null,
	active: null,
	activeNode: null,
	activeNodeRect: null,
	collisions: null,
	containerNodeRect: null,
	draggableNodes: /*#__PURE__*/ new Map(),
	droppableRects: /*#__PURE__*/ new Map(),
	droppableContainers: /*#__PURE__*/ new cl(),
	over: null,
	dragOverlay: {
		nodeRef: { current: null },
		rect: null,
		setRef: Ps
	},
	scrollableAncestors: [],
	scrollableAncestorRects: [],
	measuringConfiguration: sl,
	measureDroppableContainers: Ps,
	windowRect: null,
	measuringScheduled: !1
}, ll = /*#__PURE__*/ a({
	activatorEvent: null,
	activators: [],
	active: null,
	activeNodeRect: null,
	ariaDescribedById: { draggable: "" },
	dispatch: Ps,
	draggableNodes: /*#__PURE__*/ new Map(),
	over: null,
	measureDroppableContainers: Ps
}), ul = /*#__PURE__*/ a(fee);
function pee() {
	return {
		draggable: {
			active: null,
			initialCoordinates: {
				x: 0,
				y: 0
			},
			nodes: /* @__PURE__ */ new Map(),
			translate: {
				x: 0,
				y: 0
			}
		},
		droppable: { containers: new cl() }
	};
}
function mee(e, t) {
	switch (t.type) {
		case Ns.DragStart: return {
			...e,
			draggable: {
				...e.draggable,
				initialCoordinates: t.initialCoordinates,
				active: t.active
			}
		};
		case Ns.DragMove: return e.draggable.active == null ? e : {
			...e,
			draggable: {
				...e.draggable,
				translate: {
					x: t.coordinates.x - e.draggable.initialCoordinates.x,
					y: t.coordinates.y - e.draggable.initialCoordinates.y
				}
			}
		};
		case Ns.DragEnd:
		case Ns.DragCancel: return {
			...e,
			draggable: {
				...e.draggable,
				active: null,
				initialCoordinates: {
					x: 0,
					y: 0
				},
				translate: {
					x: 0,
					y: 0
				}
			}
		};
		case Ns.RegisterDroppable: {
			let { element: n } = t, { id: r } = n, i = new cl(e.droppable.containers);
			return i.set(r, n), {
				...e,
				droppable: {
					...e.droppable,
					containers: i
				}
			};
		}
		case Ns.SetDroppableDisabled: {
			let { id: n, key: r, disabled: i } = t, a = e.droppable.containers.get(n);
			if (!a || r !== a.key) return e;
			let o = new cl(e.droppable.containers);
			return o.set(n, {
				...a,
				disabled: i
			}), {
				...e,
				droppable: {
					...e.droppable,
					containers: o
				}
			};
		}
		case Ns.UnregisterDroppable: {
			let { id: n, key: r } = t, i = e.droppable.containers.get(n);
			if (!i || r !== i.key) return e;
			let a = new cl(e.droppable.containers);
			return a.delete(n), {
				...e,
				droppable: {
					...e.droppable,
					containers: a
				}
			};
		}
		default: return e;
	}
}
function hee(e) {
	let { disabled: t } = e, { active: n, activatorEvent: r, draggableNodes: i } = d(ll), a = us(r), o = us(n?.id);
	return p(() => {
		if (!t && !r && a && o != null) {
			if (!_s(a) || document.activeElement === a.target) return;
			let e = i.get(o);
			if (!e) return;
			let { activatorNode: t, node: n } = e;
			if (!t.current && !n.current) return;
			requestAnimationFrame(() => {
				for (let e of [t.current, n.current]) {
					if (!e) continue;
					let t = Ss(e);
					if (t) {
						t.focus();
						break;
					}
				}
			});
		}
	}, [
		r,
		t,
		i,
		o,
		a
	]), null;
}
function gee(e, t) {
	let { transform: n, ...r } = t;
	return e != null && e.length ? e.reduce((e, t) => t({
		transform: e,
		...r
	}), n) : n;
}
function _ee(e) {
	return g(() => ({
		draggable: {
			...sl.draggable,
			...e?.draggable
		},
		droppable: {
			...sl.droppable,
			...e?.droppable
		},
		dragOverlay: {
			...sl.dragOverlay,
			...e?.dragOverlay
		}
	}), [
		e?.draggable,
		e?.droppable,
		e?.dragOverlay
	]);
}
function vee(e) {
	let { activeNode: t, measure: n, initialRect: r, config: i = !0 } = e, a = v(!1), { x: o, y: s } = typeof i == "boolean" ? {
		x: i,
		y: i
	} : i;
	is(() => {
		if (!o && !s || !t) {
			a.current = !1;
			return;
		}
		if (a.current || !r) return;
		let e = t?.node.current;
		if (!e || e.isConnected === !1) return;
		let i = qs(n(e), r);
		if (o || (i.x = 0), s || (i.y = 0), a.current = !0, Math.abs(i.x) > 0 || Math.abs(i.y) > 0) {
			let t = ac(e);
			t && t.scrollBy({
				top: i.y,
				left: i.x
			});
		}
	}, [
		t,
		o,
		s,
		r,
		n
	]);
}
var dl = /*#__PURE__*/ a({
	...Ls,
	scaleX: 1,
	scaleY: 1
}), fl;
(function(e) {
	e[e.Uninitialized = 0] = "Uninitialized", e[e.Initializing = 1] = "Initializing", e[e.Initialized = 2] = "Initialized";
})(fl ||= {});
var yee = /*#__PURE__*/ l(function(e) {
	let { id: n, accessibility: r, autoScroll: i = !0, children: a, sensors: o = uee, collisionDetection: s = Gs, measuring: c, modifiers: l, ...d } = e, [f, m] = _(mee, void 0, pee), [h, b] = ks(), [x, S] = y(fl.Uninitialized), C = x === fl.Initialized, { draggable: { active: w, nodes: T, translate: E }, droppable: { containers: D } } = f, O = w == null ? null : T.get(w), k = v({
		initial: null,
		translated: null
	}), A = g(() => w == null ? null : {
		id: w,
		data: O?.data ?? dee,
		rect: k
	}, [w, O]), j = v(null), [M, ee] = y(null), [te, ne] = y(null), re = ss(d, Object.values(d)), ie = fs("DndDescribedBy", n), ae = g(() => D.getEnabled(), [D]), oe = _ee(c), { droppableRects: se, measureDroppableContainers: ce, measuringScheduled: le } = Gc(ae, {
		dragging: C,
		dependencies: [E.x, E.y],
		config: oe.droppable
	}), N = aee(T, w), P = g(() => te ? ys(te) : null, [te]), ue = Fe(), de = qc(N, oe.draggable.measure);
	vee({
		activeNode: w == null ? null : T.get(w),
		config: ue.layoutShiftCompensation,
		initialRect: de,
		measure: oe.draggable.measure
	});
	let fe = Zc(N, oe.draggable.measure, de), pe = Zc(N ? N.parentElement : null), me = v({
		activatorEvent: null,
		active: null,
		activeNode: N,
		collisionRect: null,
		collisions: null,
		droppableRects: se,
		draggableNodes: T,
		draggingNode: null,
		draggingNodeRect: null,
		droppableContainers: D,
		over: null,
		scrollableAncestors: [],
		scrollAdjustedTranslate: null
	}), F = D.getNodeFor(me.current.over?.id), I = lee({ measure: oe.dragOverlay.measure }), he = I.nodeRef.current ?? N, L = C ? I.rect ?? fe : null, ge = !!(I.nodeRef.current && I.rect), _e = Qc(ge ? null : fe), ve = al(he ? $o(he) : null), ye = el(C ? F ?? N : null), be = see(ye), R = gee(l, {
		transform: {
			x: E.x - _e.x,
			y: E.y - _e.y,
			scaleX: 1,
			scaleY: 1
		},
		activatorEvent: te,
		active: A,
		activeNodeRect: fe,
		containerNodeRect: pe,
		draggingNodeRect: L,
		over: me.current.over,
		overlayNodeRect: I.rect,
		scrollableAncestors: ye,
		scrollableAncestorRects: be,
		windowRect: ve
	}), xe = P ? ms(P, E) : null, z = tl(ye), B = nl(z), Se = nl(z, [fe]), Ce = ms(R, B), we = L ? Ys(L, R) : null, Te = A && we ? s({
		active: A,
		collisionRect: we,
		droppableRects: se,
		droppableContainers: ae,
		pointerCoordinates: xe
	}) : null, Ee = Vs(Te, "id"), [De, Oe] = y(null), ke = Ks(ge ? R : ms(R, Se), De?.rect ?? null, fe), Ae = v(null), je = u((e, t) => {
		let { sensor: n, options: r } = t;
		if (j.current == null) return;
		let i = T.get(j.current);
		if (!i) return;
		let a = e.nativeEvent;
		Ae.current = new n({
			active: j.current,
			activeNode: i,
			event: a,
			options: r,
			context: me,
			onAbort(e) {
				if (!T.get(e)) return;
				let { onDragAbort: t } = re.current, n = { id: e };
				t?.(n), h({
					type: "onDragAbort",
					event: n
				});
			},
			onPending(e, t, n, r) {
				if (!T.get(e)) return;
				let { onDragPending: i } = re.current, a = {
					id: e,
					constraint: t,
					initialCoordinates: n,
					offset: r
				};
				i?.(a), h({
					type: "onDragPending",
					event: a
				});
			},
			onStart(e) {
				let t = j.current;
				if (t == null) return;
				let n = T.get(t);
				if (!n) return;
				let { onDragStart: r } = re.current, i = {
					activatorEvent: a,
					active: {
						id: t,
						data: n.data,
						rect: k
					}
				};
				He(() => {
					r?.(i), S(fl.Initializing), m({
						type: Ns.DragStart,
						initialCoordinates: e,
						active: t
					}), h({
						type: "onDragStart",
						event: i
					}), ee(Ae.current), ne(a);
				});
			},
			onMove(e) {
				m({
					type: Ns.DragMove,
					coordinates: e
				});
			},
			onEnd: o(Ns.DragEnd),
			onCancel: o(Ns.DragCancel)
		});
		function o(e) {
			return async function() {
				let { active: t, collisions: n, over: r, scrollAdjustedTranslate: i } = me.current, o = null;
				if (t && i) {
					let { cancelDrop: s } = re.current;
					o = {
						activatorEvent: a,
						active: t,
						collisions: n,
						delta: i,
						over: r
					}, e === Ns.DragEnd && typeof s == "function" && await Promise.resolve(s(o)) && (e = Ns.DragCancel);
				}
				j.current = null, He(() => {
					m({ type: e }), S(fl.Uninitialized), Oe(null), ee(null), ne(null), Ae.current = null;
					let t = e === Ns.DragEnd ? "onDragEnd" : "onDragCancel";
					if (o) {
						let e = re.current[t];
						e?.(o), h({
							type: t,
							event: o
						});
					}
				});
			};
		}
	}, [T]), Me = oee(o, u((e, t) => (n, r) => {
		let i = n.nativeEvent, a = T.get(r);
		if (j.current !== null || !a || i.dndKit || i.defaultPrevented) return;
		let o = { active: a };
		e(n, t.options, o) === !0 && (i.dndKit = { capturedBy: t.sensor }, j.current = r, je(n, t));
	}, [T, je]));
	rl(o), is(() => {
		fe && x === fl.Initializing && S(fl.Initialized);
	}, [fe, x]), p(() => {
		let { onDragMove: e } = re.current, { active: t, activatorEvent: n, collisions: r, over: i } = me.current;
		if (!t || !n) return;
		let a = {
			active: t,
			activatorEvent: n,
			collisions: r,
			delta: {
				x: Ce.x,
				y: Ce.y
			},
			over: i
		};
		He(() => {
			e?.(a), h({
				type: "onDragMove",
				event: a
			});
		});
	}, [Ce.x, Ce.y]), p(() => {
		let { active: e, activatorEvent: t, collisions: n, droppableContainers: r, scrollAdjustedTranslate: i } = me.current;
		if (!e || j.current == null || !t || !i) return;
		let { onDragOver: a } = re.current, o = r.get(Ee), s = o && o.rect.current ? {
			id: o.id,
			rect: o.rect.current,
			data: o.data,
			disabled: o.disabled
		} : null, c = {
			active: e,
			activatorEvent: t,
			collisions: n,
			delta: {
				x: i.x,
				y: i.y
			},
			over: s
		};
		He(() => {
			Oe(s), a?.(c), h({
				type: "onDragOver",
				event: c
			});
		});
	}, [Ee]), is(() => {
		me.current = {
			activatorEvent: te,
			active: A,
			activeNode: N,
			collisionRect: we,
			collisions: Te,
			droppableRects: se,
			draggableNodes: T,
			draggingNode: he,
			draggingNodeRect: L,
			droppableContainers: D,
			over: De,
			scrollableAncestors: ye,
			scrollAdjustedTranslate: Ce
		}, k.current = {
			initial: L,
			translated: we
		};
	}, [
		A,
		N,
		Te,
		we,
		T,
		he,
		L,
		se,
		D,
		De,
		ye,
		Ce
	]), nee({
		...ue,
		delta: E,
		draggingRect: we,
		pointerCoordinates: xe,
		scrollableAncestors: ye,
		scrollableAncestorRects: be
	});
	let Ne = g(() => ({
		active: A,
		activeNode: N,
		activeNodeRect: fe,
		activatorEvent: te,
		collisions: Te,
		containerNodeRect: pe,
		dragOverlay: I,
		draggableNodes: T,
		droppableContainers: D,
		droppableRects: se,
		over: De,
		measureDroppableContainers: ce,
		scrollableAncestors: ye,
		scrollableAncestorRects: be,
		measuringConfiguration: oe,
		measuringScheduled: le,
		windowRect: ve
	}), [
		A,
		N,
		fe,
		te,
		Te,
		pe,
		I,
		T,
		D,
		se,
		De,
		ce,
		ye,
		be,
		oe,
		le,
		ve
	]), Pe = g(() => ({
		activatorEvent: te,
		activators: Me,
		active: A,
		activeNodeRect: fe,
		ariaDescribedById: { draggable: ie },
		dispatch: m,
		draggableNodes: T,
		over: De,
		measureDroppableContainers: ce
	}), [
		te,
		Me,
		A,
		fe,
		m,
		ie,
		T,
		De,
		ce
	]);
	return t.createElement(Ds.Provider, { value: b }, t.createElement(ll.Provider, { value: Pe }, t.createElement(ul.Provider, { value: Ne }, t.createElement(dl.Provider, { value: ke }, a)), t.createElement(hee, { disabled: r?.restoreFocus === !1 })), t.createElement(Ms, {
		...r,
		hiddenTextDescribedById: ie
	}));
	function Fe() {
		let e = M?.autoScrollEnabled === !1, t = typeof i == "object" ? i.enabled === !1 : i === !1, n = C && !e && !t;
		return typeof i == "object" ? {
			...i,
			enabled: n
		} : { enabled: n };
	}
}), bee = /*#__PURE__*/ a(null), pl = "button", xee = "Draggable";
function See(e) {
	let { id: t, data: n, disabled: r = !1, attributes: i } = e, a = fs(xee), { activators: o, activatorEvent: s, active: c, activeNodeRect: l, ariaDescribedById: u, draggableNodes: f, over: p } = d(ll), { role: m = pl, roleDescription: h = "draggable", tabIndex: _ = 0 } = i ?? {}, v = c?.id === t, y = d(v ? dl : bee), [b, x] = ls(), [S, C] = ls(), w = il(o, t), T = ss(n);
	return is(() => (f.set(t, {
		id: t,
		key: a,
		node: b,
		activatorNode: S,
		data: T
	}), () => {
		let e = f.get(t);
		e && e.key === a && f.delete(t);
	}), [f, t]), {
		active: c,
		activatorEvent: s,
		activeNodeRect: l,
		attributes: g(() => ({
			role: m,
			tabIndex: _,
			"aria-disabled": r,
			"aria-pressed": v && m === pl ? !0 : void 0,
			"aria-roledescription": h,
			"aria-describedby": u.draggable
		}), [
			r,
			m,
			_,
			v,
			h,
			u.draggable
		]),
		isDragging: v,
		listeners: r ? void 0 : w,
		node: b,
		over: p,
		setNodeRef: x,
		setActivatorNodeRef: C,
		transform: y
	};
}
function Cee() {
	return d(ul);
}
var wee = "Droppable", ml = { timeout: 25 };
function hl(e) {
	let { data: t, disabled: n = !1, id: r, resizeObserverConfig: i } = e, a = fs(wee), { active: o, dispatch: s, over: c, measureDroppableContainers: l } = d(ll), f = v({ disabled: n }), m = v(!1), h = v(null), g = v(null), { disabled: _, updateMeasurementsFor: y, timeout: b } = {
		...ml,
		...i
	}, x = ss(y ?? r), S = Yc({
		callback: u(() => {
			if (!m.current) {
				m.current = !0;
				return;
			}
			g.current != null && clearTimeout(g.current), g.current = setTimeout(() => {
				l(Array.isArray(x.current) ? x.current : [x.current]), g.current = null;
			}, b);
		}, [b]),
		disabled: _ || !o
	}), [C, w] = ls(u((e, t) => {
		S && (t && (S.unobserve(t), m.current = !1), e && S.observe(e));
	}, [S])), T = ss(t);
	return p(() => {
		!S || !C.current || (S.disconnect(), m.current = !1, S.observe(C.current));
	}, [C, S]), p(() => (s({
		type: Ns.RegisterDroppable,
		element: {
			id: r,
			key: a,
			disabled: n,
			node: C,
			rect: h,
			data: T
		}
	}), () => s({
		type: Ns.UnregisterDroppable,
		key: a,
		id: r
	})), [r]), p(() => {
		n !== f.current.disabled && (s({
			type: Ns.SetDroppableDisabled,
			id: r,
			key: a,
			disabled: n
		}), f.current.disabled = n);
	}, [
		r,
		a,
		n,
		s
	]), {
		active: o,
		rect: h,
		isOver: c?.id === r,
		node: C,
		over: c,
		setNodeRef: w
	};
}
//#endregion
//#region ../../node_modules/@dnd-kit/sortable/dist/sortable.esm.js
function gl(e, t, n) {
	let r = e.slice();
	return r.splice(n < 0 ? r.length + n : n, 0, r.splice(t, 1)[0]), r;
}
function _l(e, t) {
	return e.reduce((e, n, r) => {
		let i = t.get(n);
		return i && (e[r] = i), e;
	}, Array(e.length));
}
function vl(e) {
	return e !== null && e >= 0;
}
function yl(e, t) {
	if (e === t) return !0;
	if (e.length !== t.length) return !1;
	for (let n = 0; n < e.length; n++) if (e[n] !== t[n]) return !1;
	return !0;
}
function bl(e) {
	return typeof e == "boolean" ? {
		draggable: e,
		droppable: e
	} : e;
}
var xl = (e) => {
	let { rects: t, activeIndex: n, overIndex: r, index: i } = e, a = gl(t, r, n), o = t[i], s = a[i];
	return !s || !o ? null : {
		x: s.left - o.left,
		y: s.top - o.top,
		scaleX: s.width / o.width,
		scaleY: s.height / o.height
	};
}, Sl = {
	scaleX: 1,
	scaleY: 1
}, Cl = (e) => {
	let { activeIndex: t, activeNodeRect: n, index: r, rects: i, overIndex: a } = e, o = i[t] ?? n;
	if (!o) return null;
	if (r === t) {
		let e = i[a];
		return e ? {
			x: 0,
			y: t < a ? e.top + e.height - (o.top + o.height) : e.top - o.top,
			...Sl
		} : null;
	}
	let s = wl(i, r, t);
	return r > t && r <= a ? {
		x: 0,
		y: -o.height - s,
		...Sl
	} : r < t && r >= a ? {
		x: 0,
		y: o.height + s,
		...Sl
	} : {
		x: 0,
		y: 0,
		...Sl
	};
};
function wl(e, t, n) {
	let r = e[t], i = e[t - 1], a = e[t + 1];
	return r ? n < t ? i ? r.top - (i.top + i.height) : a ? a.top - (r.top + r.height) : 0 : a ? a.top - (r.top + r.height) : i ? r.top - (i.top + i.height) : 0 : 0;
}
var Tl = "Sortable", El = /*#__PURE__*/ t.createContext({
	activeIndex: -1,
	containerId: Tl,
	disableTransforms: !1,
	items: [],
	overIndex: -1,
	useDragOverlay: !1,
	sortedRects: [],
	strategy: xl,
	disabled: {
		draggable: !1,
		droppable: !1
	}
});
function Dl(e) {
	let { children: n, id: r, items: i, strategy: a = xl, disabled: o = !1 } = e, { active: s, dragOverlay: c, droppableRects: l, over: u, measureDroppableContainers: d } = Cee(), f = fs(Tl, r), m = c.rect !== null, h = g(() => i.map((e) => typeof e == "object" && "id" in e ? e.id : e), [i]), _ = s != null, y = s ? h.indexOf(s.id) : -1, b = u ? h.indexOf(u.id) : -1, x = v(h), S = !yl(h, x.current), C = b !== -1 && y === -1 || S, w = bl(o);
	is(() => {
		S && _ && d(h);
	}, [
		S,
		h,
		_,
		d
	]), p(() => {
		x.current = h;
	}, [h]);
	let T = g(() => ({
		activeIndex: y,
		containerId: f,
		disabled: w,
		disableTransforms: C,
		items: h,
		overIndex: b,
		useDragOverlay: m,
		sortedRects: _l(h, l),
		strategy: a
	}), [
		y,
		f,
		w.draggable,
		w.droppable,
		C,
		h,
		b,
		l,
		m,
		a
	]);
	return t.createElement(El.Provider, { value: T }, n);
}
var Ol = (e) => {
	let { id: t, items: n, activeIndex: r, overIndex: i } = e;
	return gl(n, r, i).indexOf(t);
}, kl = (e) => {
	let { containerId: t, isSorting: n, wasDragging: r, index: i, items: a, newIndex: o, previousItems: s, previousContainerId: c, transition: l } = e;
	return !l || !r || s !== a && i === o ? !1 : n ? !0 : o !== i && t === c;
}, Al = {
	duration: 200,
	easing: "ease"
}, jl = "transform", Ml = /*#__PURE__*/ bs.Transition.toString({
	property: jl,
	duration: 0,
	easing: "linear"
}), Nl = { roleDescription: "sortable" };
function Pl(e) {
	let { disabled: t, index: n, node: r, rect: i } = e, [a, o] = y(null), s = v(n);
	return is(() => {
		if (!t && n !== s.current && r.current) {
			let e = i.current;
			if (e) {
				let t = $s(r.current, { ignoreTransform: !0 }), n = {
					x: e.left - t.left,
					y: e.top - t.top,
					scaleX: e.width / t.width,
					scaleY: e.height / t.height
				};
				(n.x || n.y) && o(n);
			}
		}
		n !== s.current && (s.current = n);
	}, [
		t,
		n,
		r,
		i
	]), p(() => {
		a && o(null);
	}, [a]), a;
}
function Fl(e) {
	let { animateLayoutChanges: t = kl, attributes: n, disabled: r, data: i, getNewIndex: a = Ol, id: o, strategy: s, resizeObserverConfig: c, transition: l = Al } = e, { items: u, containerId: f, activeIndex: m, disabled: h, disableTransforms: _, sortedRects: y, overIndex: b, useDragOverlay: x, strategy: S } = d(El), C = Il(r, h), w = u.indexOf(o), T = g(() => ({
		sortable: {
			containerId: f,
			index: w,
			items: u
		},
		...i
	}), [
		f,
		i,
		w,
		u
	]), E = g(() => u.slice(u.indexOf(o)), [u, o]), { rect: D, node: O, isOver: k, setNodeRef: A } = hl({
		id: o,
		data: T,
		disabled: C.droppable,
		resizeObserverConfig: {
			updateMeasurementsFor: E,
			...c
		}
	}), { active: j, activatorEvent: M, activeNodeRect: ee, attributes: te, setNodeRef: ne, listeners: re, isDragging: ie, over: ae, setActivatorNodeRef: oe, transform: se } = See({
		id: o,
		data: T,
		attributes: {
			...Nl,
			...n
		},
		disabled: C.draggable
	}), ce = Yo(A, ne), le = !!j, N = le && !_ && vl(m) && vl(b), P = !x && ie, ue = N ? (P && N ? se : null) ?? (s ?? S)({
		rects: y,
		activeNodeRect: ee,
		activeIndex: m,
		overIndex: b,
		index: w
	}) : null, de = vl(m) && vl(b) ? a({
		id: o,
		items: u,
		activeIndex: m,
		overIndex: b
	}) : w, fe = j?.id, pe = v({
		activeId: fe,
		items: u,
		newIndex: de,
		containerId: f
	}), me = u !== pe.current.items, F = t({
		active: j,
		containerId: f,
		isDragging: ie,
		isSorting: le,
		id: o,
		index: w,
		items: u,
		newIndex: pe.current.newIndex,
		previousItems: pe.current.items,
		previousContainerId: pe.current.containerId,
		transition: l,
		wasDragging: pe.current.activeId != null
	}), I = Pl({
		disabled: !F,
		index: w,
		node: O,
		rect: D
	});
	return p(() => {
		le && pe.current.newIndex !== de && (pe.current.newIndex = de), f !== pe.current.containerId && (pe.current.containerId = f), u !== pe.current.items && (pe.current.items = u);
	}, [
		le,
		de,
		f,
		u
	]), p(() => {
		if (fe === pe.current.activeId) return;
		if (fe != null && pe.current.activeId == null) {
			pe.current.activeId = fe;
			return;
		}
		let e = setTimeout(() => {
			pe.current.activeId = fe;
		}, 50);
		return () => clearTimeout(e);
	}, [fe]), {
		active: j,
		activeIndex: m,
		attributes: te,
		data: T,
		rect: D,
		index: w,
		newIndex: de,
		items: u,
		isOver: k,
		isSorting: le,
		isDragging: ie,
		listeners: re,
		node: O,
		overIndex: b,
		over: ae,
		setNodeRef: ce,
		setActivatorNodeRef: oe,
		setDroppableNodeRef: A,
		setDraggableNodeRef: ne,
		transform: I ?? ue,
		transition: he()
	};
	function he() {
		if (I || me && pe.current.newIndex === w) return Ml;
		if (!(P && !_s(M) || !l) && (le || F)) return bs.Transition.toString({
			...l,
			property: jl
		});
	}
}
function Il(e, t) {
	return typeof e == "boolean" ? {
		draggable: e,
		droppable: !1
	} : {
		draggable: e?.draggable ?? t.draggable,
		droppable: e?.droppable ?? t.droppable
	};
}
Dc.Down, Dc.Right, Dc.Up, Dc.Left;
//#endregion
//#region src/input-ui/input-array/style.ts
var Ll = /*#__PURE__*/ Ft("div")({
	name: "ButtonMargin",
	class: "bg37lzj",
	propsAsIs: !1
}), Rl = /*#__PURE__*/ Ft("div")({
	name: "LineSpacerDash",
	class: "l12veqdq",
	propsAsIs: !1
}), zl = /*#__PURE__*/ Ft("div")({
	name: "InputArrayHeader",
	class: "i1sfoodv",
	propsAsIs: !1
}), Bl = /*#__PURE__*/ Ft("h1")({
	name: "InputArrayHeaderTitle",
	class: "ifu7exx",
	propsAsIs: !1
}), Vl = /*#__PURE__*/ Ft("p")({
	name: "InputArrayHeaderDescription",
	class: "ibzdmbt",
	propsAsIs: !1
}), Hl = /*#__PURE__*/ Ft("div")({
	name: "InputArrayListContainer",
	class: "ipfmzuy",
	propsAsIs: !1
}), Ul = /*#__PURE__*/ Ft("div")({
	name: "InputArrayItemHeaderContainer",
	class: "i1bv7oa4",
	propsAsIs: !1
}), Wl = /*#__PURE__*/ Ft("div")({
	name: "InputArrayItemContentContainer",
	class: "i1cjtbbt",
	propsAsIs: !1
}), Gl = /*#__PURE__*/ Ft("div")({
	name: "InputArrayItemContainer",
	class: "i13gqzd0",
	propsAsIs: !1
}), Kl = ({ children: e, index: t, title: n, showRemoveButton: r, listSeparatorStyle: i, hasError: a, onRemove: o }) => {
	let s = a && i === "none";
	return /* @__PURE__ */ I(Gl, { children: [
		n && /* @__PURE__ */ I(Ul, { children: [/* @__PURE__ */ I(he, {
			font: "text-sm/bold",
			colour: "primary",
			children: [
				n,
				" ",
				t + 1
			]
		}), r && /* @__PURE__ */ F(z, {
			variant: "tertiary",
			type: "button",
			hasNoPadding: !0,
			isDestructive: !0,
			onClick: () => o?.(t),
			children: "Remove"
		})] }),
		/* @__PURE__ */ F(Wl, { children: e }),
		r && /* @__PURE__ */ F(Ll, { children: /* @__PURE__ */ F(z, {
			variant: "tertiary",
			type: "button",
			hasNoPadding: !0,
			isDestructive: !0,
			onClick: () => o?.(t),
			children: "Remove"
		}) }),
		!n && !s && /* @__PURE__ */ F(Rl, {})
	] });
}, ql = /*#__PURE__*/ Ft("div")({
	name: "DraggableItemWrapper",
	class: "d1ahc6p8",
	propsAsIs: !1
}), Jl = /*#__PURE__*/ Ft("div")({
	name: "DragHandle",
	class: "d1d3y99q",
	propsAsIs: !1
}), Yl = ({ children: e, id: t, index: n, showRemoveButton: r, onRemove: i }) => {
	let { attributes: a, listeners: o, setNodeRef: s, transform: c, transition: l, isDragging: u } = Fl({ id: t });
	return /* @__PURE__ */ I(ql, {
		ref: s,
		style: {
			transform: bs.Transform.toString(c),
			transition: l,
			opacity: u ? .5 : 1,
			zIndex: u ? 1e3 : void 0
		},
		children: [
			/* @__PURE__ */ F(Jl, {
				...o,
				...a,
				children: /* @__PURE__ */ F(Ue, {
					color: "primary",
					size: "md"
				})
			}),
			/* @__PURE__ */ F(Wl, { children: e }),
			r && /* @__PURE__ */ F(z, {
				variant: "tertiary",
				type: "button",
				hasNoPadding: !0,
				size: "medium",
				onClick: () => i?.(n),
				iconLeft: /* @__PURE__ */ F(Fe, {})
			})
		]
	});
}, Xl = ({ formFieldDefaultValue: e, formControl: t, addButtonText: n = "Add", fieldName: r, title: i, description: a, isRequired: o, minLength: s = 0, RenderArrayFeld: c, formFieldTitle: l, errorMessage: u, draggable: d }) => {
	let f = o && !s ? 1 : s, { fields: p, append: m, remove: h, move: g } = gr({
		name: r,
		control: t,
		rules: {
			required: o,
			minLength: f
		}
	}), _ = Is(Fs(Pc, { activationConstraint: { distance: 5 } })), v = async () => {
		m(e);
	}, y = (e) => async () => {
		h(e);
	}, b = (e) => {
		let { active: t, over: n } = e;
		if (n && t.id !== n.id) {
			let e = p.findIndex((e) => e.id === t.id), r = p.findIndex((e) => e.id === n.id);
			e !== -1 && r !== -1 && g(e, r);
		}
	}, x = () => /* @__PURE__ */ F(Hl, { children: p?.map?.((e, t) => {
		let n = p.length > f, i = t === p.length - 1;
		return d ? /* @__PURE__ */ F(Yl, {
			id: e.id,
			index: t,
			showRemoveButton: n,
			onRemove: y(t),
			children: /* @__PURE__ */ F(c, {
				append: m,
				fieldName: `${r}.${t}`,
				index: t,
				remove: h
			})
		}, e.id) : /* @__PURE__ */ F(Kl, {
			index: t,
			title: l,
			hasError: !!u,
			showRemoveButton: n,
			listSeparatorStyle: u && i ? "none" : "dashed",
			onRemove: y(t),
			children: /* @__PURE__ */ F(c, {
				append: m,
				fieldName: `${r}.${t}`,
				index: t,
				remove: h
			})
		}, e.id);
	}) });
	return /* @__PURE__ */ I(Re, { children: [
		(i || a) && /* @__PURE__ */ I(zl, { children: [i && /* @__PURE__ */ F(Bl, { children: i }), a && /* @__PURE__ */ F(Vl, { children: a })] }),
		d ? /* @__PURE__ */ F(yee, {
			sensors: _,
			collisionDetection: Us,
			onDragEnd: b,
			children: /* @__PURE__ */ F(Dl, {
				items: p.map((e) => e.id),
				strategy: Cl,
				children: x()
			})
		}) : x(),
		u && /* @__PURE__ */ F(Re.ErrorText, {
			id: u,
			children: u
		}),
		(u || d) && /* @__PURE__ */ F(Rl, {}),
		/* @__PURE__ */ F(an, {
			width: "fit",
			children: /* @__PURE__ */ F(z, {
				variant: "tertiary",
				useLinkStyle: !0,
				hasNoPadding: !0,
				onClick: v,
				type: "button",
				children: n
			})
		})
	] });
};
//#endregion
//#region ../../node_modules/@babel/runtime/helpers/esm/typeof.js
function Zl(e) {
	"@babel/helpers - typeof";
	return Zl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, Zl(e);
}
//#endregion
//#region ../../node_modules/@babel/runtime/helpers/esm/toPrimitive.js
function Ql(e, t) {
	if (Zl(e) != "object" || !e) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if (Zl(r) != "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
//#endregion
//#region ../../node_modules/@babel/runtime/helpers/esm/toPropertyKey.js
function $l(e) {
	var t = Ql(e, "string");
	return Zl(t) == "symbol" ? t : t + "";
}
//#endregion
//#region ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
function eu(e, t, n) {
	return (t = $l(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
//#endregion
//#region ../../node_modules/@babel/runtime/helpers/esm/objectSpread2.js
function tu(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function nu(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? tu(Object(n), !0).forEach(function(t) {
			eu(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : tu(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
//#endregion
//#region ../../node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function ru(e) {
	if (Array.isArray(e)) return e;
}
//#endregion
//#region ../../node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function iu(e, t) {
	var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n != null) {
		var r, i, a, o, s = [], c = !0, l = !1;
		try {
			if (a = (n = n.call(e)).next, t === 0) {
				if (Object(n) !== n) return;
				c = !1;
			} else for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0);
		} catch (e) {
			l = !0, i = e;
		} finally {
			try {
				if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
			} finally {
				if (l) throw i;
			}
		}
		return s;
	}
}
//#endregion
//#region ../../node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function au(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
//#endregion
//#region ../../node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
function ou(e, t) {
	if (e) {
		if (typeof e == "string") return au(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? au(e, t) : void 0;
	}
}
//#endregion
//#region ../../node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function su() {
	throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
//#endregion
//#region ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js
function cu(e, t) {
	return ru(e) || iu(e, t) || ou(e, t) || su();
}
//#endregion
//#region ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function lu(e, t) {
	if (e == null) return {};
	var n = {};
	for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
		if (t.indexOf(r) !== -1) continue;
		n[r] = e[r];
	}
	return n;
}
//#endregion
//#region ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
function uu(e, t) {
	if (e == null) return {};
	var n, r, i = lu(e, t);
	if (Object.getOwnPropertySymbols) {
		var a = Object.getOwnPropertySymbols(e);
		for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) === -1 && {}.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
	}
	return i;
}
//#endregion
//#region ../../node_modules/react-select/dist/useStateManager-7e1e8489.esm.js
var du = [
	"defaultInputValue",
	"defaultMenuIsOpen",
	"defaultValue",
	"inputValue",
	"menuIsOpen",
	"onChange",
	"onInputChange",
	"onMenuClose",
	"onMenuOpen",
	"value"
];
function fu(e) {
	var t = e.defaultInputValue, n = t === void 0 ? "" : t, r = e.defaultMenuIsOpen, i = r === void 0 ? !1 : r, a = e.defaultValue, o = a === void 0 ? null : a, s = e.inputValue, c = e.menuIsOpen, l = e.onChange, d = e.onInputChange, f = e.onMenuClose, p = e.onMenuOpen, m = e.value, h = uu(e, du), g = cu(y(s === void 0 ? n : s), 2), _ = g[0], v = g[1], b = cu(y(c === void 0 ? i : c), 2), x = b[0], S = b[1], C = cu(y(m === void 0 ? o : m), 2), w = C[0], T = C[1], E = u(function(e, t) {
		typeof l == "function" && l(e, t), T(e);
	}, [l]), D = u(function(e, t) {
		var n;
		typeof d == "function" && (n = d(e, t)), v(n === void 0 ? e : n);
	}, [d]), O = u(function() {
		typeof p == "function" && p(), S(!0);
	}, [p]), k = u(function() {
		typeof f == "function" && f(), S(!1);
	}, [f]), A = s === void 0 ? _ : s, j = c === void 0 ? x : c, M = m === void 0 ? w : m;
	return nu(nu({}, h), {}, {
		inputValue: A,
		menuIsOpen: j,
		onChange: E,
		onInputChange: D,
		onMenuClose: k,
		onMenuOpen: O,
		value: M
	});
}
//#endregion
//#region ../../node_modules/@babel/runtime/helpers/esm/extends.js
function pu() {
	return pu = Object.assign ? Object.assign.bind() : function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, pu.apply(null, arguments);
}
//#endregion
//#region ../../node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function mu(e, t) {
	if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
}
//#endregion
//#region ../../node_modules/@babel/runtime/helpers/esm/createClass.js
function hu(e, t) {
	for (var n = 0; n < t.length; n++) {
		var r = t[n];
		r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, $l(r.key), r);
	}
}
function Tee(e, t, n) {
	return t && hu(e.prototype, t), n && hu(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
//#endregion
//#region ../../node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function gu(e, t) {
	return gu = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
		return e.__proto__ = t, e;
	}, gu(e, t);
}
//#endregion
//#region ../../node_modules/@babel/runtime/helpers/esm/inherits.js
function Eee(e, t) {
	if (typeof t != "function" && t !== null) throw TypeError("Super expression must either be null or a function");
	e.prototype = Object.create(t && t.prototype, { constructor: {
		value: e,
		writable: !0,
		configurable: !0
	} }), Object.defineProperty(e, "prototype", { writable: !1 }), t && gu(e, t);
}
//#endregion
//#region ../../node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _u(e) {
	return _u = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
		return e.__proto__ || Object.getPrototypeOf(e);
	}, _u(e);
}
//#endregion
//#region ../../node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function vu() {
	try {
		var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
	} catch {}
	return (vu = function() {
		return !!e;
	})();
}
//#endregion
//#region ../../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function Dee(e) {
	if (e === void 0) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
	return e;
}
//#endregion
//#region ../../node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
function Oee(e, t) {
	if (t && (Zl(t) == "object" || typeof t == "function")) return t;
	if (t !== void 0) throw TypeError("Derived constructors may only return object or undefined");
	return Dee(e);
}
//#endregion
//#region ../../node_modules/@babel/runtime/helpers/esm/createSuper.js
function kee(e) {
	var t = vu();
	return function() {
		var n, r = _u(e);
		if (t) {
			var i = _u(this).constructor;
			n = Reflect.construct(r, arguments, i);
		} else n = r.apply(this, arguments);
		return Oee(this, n);
	};
}
//#endregion
//#region ../../node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js
function Aee(e) {
	if (Array.isArray(e)) return au(e);
}
//#endregion
//#region ../../node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function jee(e) {
	if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
//#endregion
//#region ../../node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function Mee() {
	throw TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
//#endregion
//#region ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js
function yu(e) {
	return Aee(e) || jee(e) || ou(e) || Mee();
}
//#endregion
//#region ../../node_modules/@emotion/sheet/dist/emotion-sheet.esm.js
var Nee = !1;
function Pee(e) {
	if (e.sheet) return e.sheet;
	/* istanbul ignore next */
	for (var t = 0; t < document.styleSheets.length; t++) if (document.styleSheets[t].ownerNode === e) return document.styleSheets[t];
}
function Fee(e) {
	var t = document.createElement("style");
	return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var Iee = /*#__PURE__*/ function() {
	function e(e) {
		var t = this;
		this._insertTag = function(e) {
			var n = t.tags.length === 0 ? t.insertionPoint ? t.insertionPoint.nextSibling : t.prepend ? t.container.firstChild : t.before : t.tags[t.tags.length - 1].nextSibling;
			t.container.insertBefore(e, n), t.tags.push(e);
		}, this.isSpeedy = e.speedy === void 0 ? !Nee : e.speedy, this.tags = [], this.ctr = 0, this.nonce = e.nonce, this.key = e.key, this.container = e.container, this.prepend = e.prepend, this.insertionPoint = e.insertionPoint, this.before = null;
	}
	var t = e.prototype;
	return t.hydrate = function(e) {
		e.forEach(this._insertTag);
	}, t.insert = function(e) {
		this.ctr % (this.isSpeedy ? 65e3 : 1) == 0 && this._insertTag(Fee(this));
		var t = this.tags[this.tags.length - 1];
		if (this.isSpeedy) {
			var n = Pee(t);
			try {
				n.insertRule(e, n.cssRules.length);
			} catch {}
		} else t.appendChild(document.createTextNode(e));
		this.ctr++;
	}, t.flush = function() {
		this.tags.forEach(function(e) {
			return e.parentNode?.removeChild(e);
		}), this.tags = [], this.ctr = 0;
	}, e;
}(), bu = "-ms-", xu = "-moz-", Su = "-webkit-", Cu = "comm", wu = "rule", Tu = "decl", Lee = "@import", Eu = "@keyframes", Ree = "@layer", zee = Math.abs, Du = String.fromCharCode, Bee = Object.assign;
function Vee(e, t) {
	return ju(e, 0) ^ 45 ? (((t << 2 ^ ju(e, 0)) << 2 ^ ju(e, 1)) << 2 ^ ju(e, 2)) << 2 ^ ju(e, 3) : 0;
}
function Ou(e) {
	return e.trim();
}
function Hee(e, t) {
	return (e = t.exec(e)) ? e[0] : e;
}
function ku(e, t, n) {
	return e.replace(t, n);
}
function Au(e, t) {
	return e.indexOf(t);
}
function ju(e, t) {
	return e.charCodeAt(t) | 0;
}
function Mu(e, t, n) {
	return e.slice(t, n);
}
function Nu(e) {
	return e.length;
}
function Pu(e) {
	return e.length;
}
function Fu(e, t) {
	return t.push(e), e;
}
function Uee(e, t) {
	return e.map(t).join("");
}
//#endregion
//#region ../../node_modules/stylis/src/Tokenizer.js
var Iu = 1, Lu = 1, Ru = 0, zu = 0, Bu = 0, Vu = "";
function Hu(e, t, n, r, i, a, o) {
	return {
		value: e,
		root: t,
		parent: n,
		type: r,
		props: i,
		children: a,
		line: Iu,
		column: Lu,
		length: o,
		return: ""
	};
}
function Uu(e, t) {
	return Bee(Hu("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function Wu() {
	return Bu;
}
function Gu() {
	return Bu = zu > 0 ? ju(Vu, --zu) : 0, Lu--, Bu === 10 && (Lu = 1, Iu--), Bu;
}
function Ku() {
	return Bu = zu < Ru ? ju(Vu, zu++) : 0, Lu++, Bu === 10 && (Lu = 1, Iu++), Bu;
}
function qu() {
	return ju(Vu, zu);
}
function Ju() {
	return zu;
}
function Yu(e, t) {
	return Mu(Vu, e, t);
}
function Xu(e) {
	switch (e) {
		case 0:
		case 9:
		case 10:
		case 13:
		case 32: return 5;
		case 33:
		case 43:
		case 44:
		case 47:
		case 62:
		case 64:
		case 126:
		case 59:
		case 123:
		case 125: return 4;
		case 58: return 3;
		case 34:
		case 39:
		case 40:
		case 91: return 2;
		case 41:
		case 93: return 1;
	}
	return 0;
}
function Zu(e) {
	return Iu = Lu = 1, Ru = Nu(Vu = e), zu = 0, [];
}
function Qu(e) {
	return Vu = "", e;
}
function $u(e) {
	return Ou(Yu(zu - 1, nd(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function ed(e) {
	for (; (Bu = qu()) && Bu < 33;) Ku();
	return Xu(e) > 2 || Xu(Bu) > 3 ? "" : " ";
}
function td(e, t) {
	for (; --t && Ku() && !(Bu < 48 || Bu > 102 || Bu > 57 && Bu < 65 || Bu > 70 && Bu < 97););
	return Yu(e, Ju() + (t < 6 && qu() == 32 && Ku() == 32));
}
function nd(e) {
	for (; Ku();) switch (Bu) {
		case e: return zu;
		case 34:
		case 39:
			e !== 34 && e !== 39 && nd(Bu);
			break;
		case 40:
			e === 41 && nd(e);
			break;
		case 92:
			Ku();
			break;
	}
	return zu;
}
function rd(e, t) {
	for (; Ku() && e + Bu !== 57 && !(e + Bu === 84 && qu() === 47););
	return "/*" + Yu(t, zu - 1) + "*" + Du(e === 47 ? e : Ku());
}
function id(e) {
	for (; !Xu(qu());) Ku();
	return Yu(e, zu);
}
//#endregion
//#region ../../node_modules/stylis/src/Parser.js
function ad(e) {
	return Qu(od("", null, null, null, [""], e = Zu(e), 0, [0], e));
}
function od(e, t, n, r, i, a, o, s, c) {
	for (var l = 0, u = 0, d = o, f = 0, p = 0, m = 0, h = 1, g = 1, _ = 1, v = 0, y = "", b = i, x = a, S = r, C = y; g;) switch (m = v, v = Ku()) {
		case 40: if (m != 108 && ju(C, d - 1) == 58) {
			Au(C += ku($u(v), "&", "&\f"), "&\f") != -1 && (_ = -1);
			break;
		}
		case 34:
		case 39:
		case 91:
			C += $u(v);
			break;
		case 9:
		case 10:
		case 13:
		case 32:
			C += ed(m);
			break;
		case 92:
			C += td(Ju() - 1, 7);
			continue;
		case 47:
			switch (qu()) {
				case 42:
				case 47:
					Fu(cd(rd(Ku(), Ju()), t, n), c);
					break;
				default: C += "/";
			}
			break;
		case 123 * h: s[l++] = Nu(C) * _;
		case 125 * h:
		case 59:
		case 0:
			switch (v) {
				case 0:
				case 125: g = 0;
				case 59 + u:
					_ == -1 && (C = ku(C, /\f/g, "")), p > 0 && Nu(C) - d && Fu(p > 32 ? ld(C + ";", r, n, d - 1) : ld(ku(C, " ", "") + ";", r, n, d - 2), c);
					break;
				case 59: C += ";";
				default: if (Fu(S = sd(C, t, n, l, u, i, s, y, b = [], x = [], d), a), v === 123) if (u === 0) od(C, t, S, S, b, a, d, s, x);
				else switch (f === 99 && ju(C, 3) === 110 ? 100 : f) {
					case 100:
					case 108:
					case 109:
					case 115:
						od(e, S, S, r && Fu(sd(e, S, S, 0, 0, i, s, y, i, b = [], d), x), i, x, d, s, r ? b : x);
						break;
					default: od(C, S, S, S, [""], x, 0, s, x);
				}
			}
			l = u = p = 0, h = _ = 1, y = C = "", d = o;
			break;
		case 58: d = 1 + Nu(C), p = m;
		default:
			if (h < 1) {
				if (v == 123) --h;
				else if (v == 125 && h++ == 0 && Gu() == 125) continue;
			}
			switch (C += Du(v), v * h) {
				case 38:
					_ = u > 0 ? 1 : (C += "\f", -1);
					break;
				case 44:
					s[l++] = (Nu(C) - 1) * _, _ = 1;
					break;
				case 64:
					qu() === 45 && (C += $u(Ku())), f = qu(), u = d = Nu(y = C += id(Ju())), v++;
					break;
				case 45: m === 45 && Nu(C) == 2 && (h = 0);
			}
	}
	return a;
}
function sd(e, t, n, r, i, a, o, s, c, l, u) {
	for (var d = i - 1, f = i === 0 ? a : [""], p = Pu(f), m = 0, h = 0, g = 0; m < r; ++m) for (var _ = 0, v = Mu(e, d + 1, d = zee(h = o[m])), y = e; _ < p; ++_) (y = Ou(h > 0 ? f[_] + " " + v : ku(v, /&\f/g, f[_]))) && (c[g++] = y);
	return Hu(e, t, n, i === 0 ? wu : s, c, l, u);
}
function cd(e, t, n) {
	return Hu(e, t, n, Cu, Du(Wu()), Mu(e, 2, -2), 0);
}
function ld(e, t, n, r) {
	return Hu(e, t, n, Tu, Mu(e, 0, r), Mu(e, r + 1, -1), r);
}
//#endregion
//#region ../../node_modules/stylis/src/Serializer.js
function ud(e, t) {
	for (var n = "", r = Pu(e), i = 0; i < r; i++) n += t(e[i], i, e, t) || "";
	return n;
}
function dd(e, t, n, r) {
	switch (e.type) {
		case Ree: if (e.children.length) break;
		case Lee:
		case Tu: return e.return = e.return || e.value;
		case Cu: return "";
		case Eu: return e.return = e.value + "{" + ud(e.children, r) + "}";
		case wu: e.value = e.props.join(",");
	}
	return Nu(n = ud(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
//#endregion
//#region ../../node_modules/stylis/src/Middleware.js
function fd(e) {
	var t = Pu(e);
	return function(n, r, i, a) {
		for (var o = "", s = 0; s < t; s++) o += e[s](n, r, i, a) || "";
		return o;
	};
}
function pd(e) {
	return function(t) {
		t.root || (t = t.return) && e(t);
	};
}
//#endregion
//#region ../../node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js
var md = function(e, t, n) {
	for (var r = 0, i = 0; r = i, i = qu(), r === 38 && i === 12 && (t[n] = 1), !Xu(i);) Ku();
	return Yu(e, zu);
}, hd = function(e, t) {
	var n = -1, r = 44;
	do
		switch (Xu(r)) {
			case 0:
				r === 38 && qu() === 12 && (t[n] = 1), e[n] += md(zu - 1, t, n);
				break;
			case 2:
				e[n] += $u(r);
				break;
			case 4: if (r === 44) {
				e[++n] = qu() === 58 ? "&\f" : "", t[n] = e[n].length;
				break;
			}
			default: e[n] += Du(r);
		}
	while (r = Ku());
	return e;
}, gd = function(e, t) {
	return Qu(hd(Zu(e), t));
}, _d = /* #__PURE__ */ new WeakMap(), vd = function(e) {
	if (!(e.type !== "rule" || !e.parent || e.length < 1)) {
		for (var t = e.value, n = e.parent, r = e.column === n.column && e.line === n.line; n.type !== "rule";) if (n = n.parent, !n) return;
		if (!(e.props.length === 1 && t.charCodeAt(0) !== 58 && !_d.get(n)) && !r) {
			_d.set(e, !0);
			for (var i = [], a = gd(t, i), o = n.props, s = 0, c = 0; s < a.length; s++) for (var l = 0; l < o.length; l++, c++) e.props[c] = i[s] ? a[s].replace(/&\f/g, o[l]) : o[l] + " " + a[s];
		}
	}
}, yd = function(e) {
	if (e.type === "decl") {
		var t = e.value;
		t.charCodeAt(0) === 108 && t.charCodeAt(2) === 98 && (e.return = "", e.value = "");
	}
};
function bd(e, t) {
	switch (Vee(e, t)) {
		case 5103: return Su + "print-" + e + e;
		case 5737:
		case 4201:
		case 3177:
		case 3433:
		case 1641:
		case 4457:
		case 2921:
		case 5572:
		case 6356:
		case 5844:
		case 3191:
		case 6645:
		case 3005:
		case 6391:
		case 5879:
		case 5623:
		case 6135:
		case 4599:
		case 4855:
		case 4215:
		case 6389:
		case 5109:
		case 5365:
		case 5621:
		case 3829: return Su + e + e;
		case 5349:
		case 4246:
		case 4810:
		case 6968:
		case 2756: return Su + e + xu + e + bu + e + e;
		case 6828:
		case 4268: return Su + e + bu + e + e;
		case 6165: return Su + e + bu + "flex-" + e + e;
		case 5187: return Su + e + ku(e, /(\w+).+(:[^]+)/, Su + "box-$1$2" + bu + "flex-$1$2") + e;
		case 5443: return Su + e + bu + "flex-item-" + ku(e, /flex-|-self/, "") + e;
		case 4675: return Su + e + bu + "flex-line-pack" + ku(e, /align-content|flex-|-self/, "") + e;
		case 5548: return Su + e + bu + ku(e, "shrink", "negative") + e;
		case 5292: return Su + e + bu + ku(e, "basis", "preferred-size") + e;
		case 6060: return Su + "box-" + ku(e, "-grow", "") + Su + e + bu + ku(e, "grow", "positive") + e;
		case 4554: return Su + ku(e, /([^-])(transform)/g, "$1" + Su + "$2") + e;
		case 6187: return ku(ku(ku(e, /(zoom-|grab)/, Su + "$1"), /(image-set)/, Su + "$1"), e, "") + e;
		case 5495:
		case 3959: return ku(e, /(image-set\([^]*)/, Su + "$1$`$1");
		case 4968: return ku(ku(e, /(.+:)(flex-)?(.*)/, Su + "box-pack:$3" + bu + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Su + e + e;
		case 4095:
		case 3583:
		case 4068:
		case 2532: return ku(e, /(.+)-inline(.+)/, Su + "$1$2") + e;
		case 8116:
		case 7059:
		case 5753:
		case 5535:
		case 5445:
		case 5701:
		case 4933:
		case 4677:
		case 5533:
		case 5789:
		case 5021:
		case 4765:
			if (Nu(e) - 1 - t > 6) switch (ju(e, t + 1)) {
				case 109: if (ju(e, t + 4) !== 45) break;
				case 102: return ku(e, /(.+:)(.+)-([^]+)/, "$1" + Su + "$2-$3$1" + xu + (ju(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
				case 115: return ~Au(e, "stretch") ? bd(ku(e, "stretch", "fill-available"), t) + e : e;
			}
			break;
		case 4949: if (ju(e, t + 1) !== 115) break;
		case 6444:
			switch (ju(e, Nu(e) - 3 - (~Au(e, "!important") && 10))) {
				case 107: return ku(e, ":", ":" + Su) + e;
				case 101: return ku(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Su + (ju(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Su + "$2$3$1" + bu + "$2box$3") + e;
			}
			break;
		case 5936:
			switch (ju(e, t + 11)) {
				case 114: return Su + e + bu + ku(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
				case 108: return Su + e + bu + ku(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
				case 45: return Su + e + bu + ku(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
			}
			return Su + e + bu + e + e;
	}
	return e;
}
var xd = [function(e, t, n, r) {
	if (e.length > -1 && !e.return) switch (e.type) {
		case Tu:
			e.return = bd(e.value, e.length);
			break;
		case Eu: return ud([Uu(e, { value: ku(e.value, "@", "@" + Su) })], r);
		case wu: if (e.length) return Uee(e.props, function(t) {
			switch (Hee(t, /(::plac\w+|:read-\w+)/)) {
				case ":read-only":
				case ":read-write": return ud([Uu(e, { props: [ku(t, /:(read-\w+)/, ":" + xu + "$1")] })], r);
				case "::placeholder": return ud([
					Uu(e, { props: [ku(t, /:(plac\w+)/, ":" + Su + "input-$1")] }),
					Uu(e, { props: [ku(t, /:(plac\w+)/, ":" + xu + "$1")] }),
					Uu(e, { props: [ku(t, /:(plac\w+)/, bu + "input-$1")] })
				], r);
			}
			return "";
		});
	}
}], Sd = function(e) {
	var t = e.key;
	if (t === "css") {
		var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
		Array.prototype.forEach.call(n, function(e) {
			e.getAttribute("data-emotion").indexOf(" ") !== -1 && (document.head.appendChild(e), e.setAttribute("data-s", ""));
		});
	}
	var r = e.stylisPlugins || xd, i = {}, a, o = [];
	a = e.container || document.head, Array.prototype.forEach.call(document.querySelectorAll("style[data-emotion^=\"" + t + " \"]"), function(e) {
		for (var t = e.getAttribute("data-emotion").split(" "), n = 1; n < t.length; n++) i[t[n]] = !0;
		o.push(e);
	});
	var s, c = [vd, yd], l, u = [dd, pd(function(e) {
		l.insert(e);
	})], d = fd(c.concat(r, u)), f = function(e) {
		return ud(ad(e), d);
	};
	s = function(e, t, n, r) {
		l = n, f(e ? e + "{" + t.styles + "}" : t.styles), r && (p.inserted[t.name] = !0);
	};
	var p = {
		key: t,
		sheet: new Iee({
			key: t,
			container: a,
			nonce: e.nonce,
			speedy: e.speedy,
			prepend: e.prepend,
			insertionPoint: e.insertionPoint
		}),
		nonce: e.nonce,
		inserted: i,
		registered: {},
		insert: s
	};
	return p.sheet.hydrate(o), p;
}, Cd = /* @__PURE__ */ V(((e) => {
	var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, h = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
	function b(e) {
		if (typeof e == "object" && e) {
			var t = e.$$typeof;
			switch (t) {
				case n: switch (e = e.type, e) {
					case l:
					case u:
					case i:
					case o:
					case a:
					case f: return e;
					default: switch (e &&= e.$$typeof, e) {
						case c:
						case d:
						case h:
						case m:
						case s: return e;
						default: return t;
					}
				}
				case r: return t;
			}
		}
	}
	function x(e) {
		return b(e) === u;
	}
	e.AsyncMode = l, e.ConcurrentMode = u, e.ContextConsumer = c, e.ContextProvider = s, e.Element = n, e.ForwardRef = d, e.Fragment = i, e.Lazy = h, e.Memo = m, e.Portal = r, e.Profiler = o, e.StrictMode = a, e.Suspense = f, e.isAsyncMode = function(e) {
		return x(e) || b(e) === l;
	}, e.isConcurrentMode = x, e.isContextConsumer = function(e) {
		return b(e) === c;
	}, e.isContextProvider = function(e) {
		return b(e) === s;
	}, e.isElement = function(e) {
		return typeof e == "object" && !!e && e.$$typeof === n;
	}, e.isForwardRef = function(e) {
		return b(e) === d;
	}, e.isFragment = function(e) {
		return b(e) === i;
	}, e.isLazy = function(e) {
		return b(e) === h;
	}, e.isMemo = function(e) {
		return b(e) === m;
	}, e.isPortal = function(e) {
		return b(e) === r;
	}, e.isProfiler = function(e) {
		return b(e) === o;
	}, e.isStrictMode = function(e) {
		return b(e) === a;
	}, e.isSuspense = function(e) {
		return b(e) === f;
	}, e.isValidElementType = function(e) {
		return typeof e == "string" || typeof e == "function" || e === i || e === u || e === o || e === a || e === f || e === p || typeof e == "object" && !!e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === s || e.$$typeof === c || e.$$typeof === d || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === y || e.$$typeof === g);
	}, e.typeOf = b;
})), wd = /* @__PURE__ */ V(((e, t) => {
	t.exports = Cd();
})), Td = /* @__PURE__ */ V(((e, t) => {
	var n = wd(), r = {
		childContextTypes: !0,
		contextType: !0,
		contextTypes: !0,
		defaultProps: !0,
		displayName: !0,
		getDefaultProps: !0,
		getDerivedStateFromError: !0,
		getDerivedStateFromProps: !0,
		mixins: !0,
		propTypes: !0,
		type: !0
	}, i = {
		name: !0,
		length: !0,
		prototype: !0,
		caller: !0,
		callee: !0,
		arguments: !0,
		arity: !0
	}, a = {
		$$typeof: !0,
		render: !0,
		defaultProps: !0,
		displayName: !0,
		propTypes: !0
	}, o = {
		$$typeof: !0,
		compare: !0,
		defaultProps: !0,
		displayName: !0,
		propTypes: !0,
		type: !0
	}, s = {};
	s[n.ForwardRef] = a, s[n.Memo] = o;
	function c(e) {
		return n.isMemo(e) ? o : s[e.$$typeof] || r;
	}
	var l = Object.defineProperty, u = Object.getOwnPropertyNames, d = Object.getOwnPropertySymbols, f = Object.getOwnPropertyDescriptor, p = Object.getPrototypeOf, m = Object.prototype;
	function h(e, t, n) {
		if (typeof t != "string") {
			if (m) {
				var r = p(t);
				r && r !== m && h(e, r, n);
			}
			var a = u(t);
			d && (a = a.concat(d(t)));
			for (var o = c(e), s = c(t), g = 0; g < a.length; ++g) {
				var _ = a[g];
				if (!i[_] && !(n && n[_]) && !(s && s[_]) && !(o && o[_])) {
					var v = f(t, _);
					try {
						l(e, _, v);
					} catch {}
				}
			}
		}
		return e;
	}
	t.exports = h;
})), Ed = !0;
function Dd(e, t, n) {
	var r = "";
	return n.split(" ").forEach(function(n) {
		e[n] === void 0 ? n && (r += n + " ") : t.push(e[n] + ";");
	}), r;
}
var Od = function(e, t, n) {
	var r = e.key + "-" + t.name;
	(n === !1 || Ed === !1) && e.registered[r] === void 0 && (e.registered[r] = t.styles);
}, kd = function(e, t, n) {
	Od(e, t, n);
	var r = e.key + "-" + t.name;
	if (e.inserted[t.name] === void 0) {
		var i = t;
		do
			e.insert(t === i ? "." + r : "", i, e.sheet, !0), i = i.next;
		while (i !== void 0);
	}
};
//#endregion
//#region ../../node_modules/@emotion/hash/dist/emotion-hash.esm.js
function Ad(e) {
	for (var t = 0, n, r = 0, i = e.length; i >= 4; ++r, i -= 4) n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= n >>> 24, t = (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
	switch (i) {
		case 3: t ^= (e.charCodeAt(r + 2) & 255) << 16;
		case 2: t ^= (e.charCodeAt(r + 1) & 255) << 8;
		case 1: t ^= e.charCodeAt(r) & 255, t = (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
	}
	return t ^= t >>> 13, t = (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
//#endregion
//#region ../../node_modules/@emotion/unitless/dist/emotion-unitless.esm.js
var jd = {
	animationIterationCount: 1,
	aspectRatio: 1,
	borderImageOutset: 1,
	borderImageSlice: 1,
	borderImageWidth: 1,
	boxFlex: 1,
	boxFlexGroup: 1,
	boxOrdinalGroup: 1,
	columnCount: 1,
	columns: 1,
	flex: 1,
	flexGrow: 1,
	flexPositive: 1,
	flexShrink: 1,
	flexNegative: 1,
	flexOrder: 1,
	gridRow: 1,
	gridRowEnd: 1,
	gridRowSpan: 1,
	gridRowStart: 1,
	gridColumn: 1,
	gridColumnEnd: 1,
	gridColumnSpan: 1,
	gridColumnStart: 1,
	msGridRow: 1,
	msGridRowSpan: 1,
	msGridColumn: 1,
	msGridColumnSpan: 1,
	fontWeight: 1,
	lineHeight: 1,
	opacity: 1,
	order: 1,
	orphans: 1,
	scale: 1,
	tabSize: 1,
	widows: 1,
	zIndex: 1,
	zoom: 1,
	WebkitLineClamp: 1,
	fillOpacity: 1,
	floodOpacity: 1,
	stopOpacity: 1,
	strokeDasharray: 1,
	strokeDashoffset: 1,
	strokeMiterlimit: 1,
	strokeOpacity: 1,
	strokeWidth: 1
}, Md = !1, Nd = /[A-Z]|^ms/g, Pd = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Fd = function(e) {
	return e.charCodeAt(1) === 45;
}, Id = function(e) {
	return e != null && typeof e != "boolean";
}, Ld = /* #__PURE__ */ Dt(function(e) {
	return Fd(e) ? e : e.replace(Nd, "-$&").toLowerCase();
}), Rd = function(e, t) {
	switch (e) {
		case "animation":
		case "animationName": if (typeof t == "string") return t.replace(Pd, function(e, t, n) {
			return Ud = {
				name: t,
				styles: n,
				next: Ud
			}, t;
		});
	}
	return jd[e] !== 1 && !Fd(e) && typeof t == "number" && t !== 0 ? t + "px" : t;
}, zd = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Bd(e, t, n) {
	if (n == null) return "";
	var r = n;
	if (r.__emotion_styles !== void 0) return r;
	switch (typeof n) {
		case "boolean": return "";
		case "object":
			var i = n;
			if (i.anim === 1) return Ud = {
				name: i.name,
				styles: i.styles,
				next: Ud
			}, i.name;
			var a = n;
			if (a.styles !== void 0) {
				var o = a.next;
				if (o !== void 0) for (; o !== void 0;) Ud = {
					name: o.name,
					styles: o.styles,
					next: Ud
				}, o = o.next;
				return a.styles + ";";
			}
			return Vd(e, t, n);
		case "function":
			if (e !== void 0) {
				var s = Ud, c = n(e);
				return Ud = s, Bd(e, t, c);
			}
			break;
	}
	var l = n;
	if (t == null) return l;
	var u = t[l];
	return u === void 0 ? l : u;
}
function Vd(e, t, n) {
	var r = "";
	if (Array.isArray(n)) for (var i = 0; i < n.length; i++) r += Bd(e, t, n[i]) + ";";
	else for (var a in n) {
		var o = n[a];
		if (typeof o != "object") {
			var s = o;
			t != null && t[s] !== void 0 ? r += a + "{" + t[s] + "}" : Id(s) && (r += Ld(a) + ":" + Rd(a, s) + ";");
		} else {
			if (a === "NO_COMPONENT_SELECTOR" && Md) throw Error(zd);
			if (Array.isArray(o) && typeof o[0] == "string" && (t == null || t[o[0]] === void 0)) for (var c = 0; c < o.length; c++) Id(o[c]) && (r += Ld(a) + ":" + Rd(a, o[c]) + ";");
			else {
				var l = Bd(e, t, o);
				switch (a) {
					case "animation":
					case "animationName":
						r += Ld(a) + ":" + l + ";";
						break;
					default: r += a + "{" + l + "}";
				}
			}
		}
	}
	return r;
}
var Hd = /label:\s*([^\s;{]+)\s*(;|$)/g, Ud;
function Wd(e, t, n) {
	if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0) return e[0];
	var r = !0, i = "";
	Ud = void 0;
	var a = e[0];
	a == null || a.raw === void 0 ? (r = !1, i += Bd(n, t, a)) : i += a[0];
	for (var o = 1; o < e.length; o++) i += Bd(n, t, e[o]), r && (i += a[o]);
	Hd.lastIndex = 0;
	for (var s = "", c; (c = Hd.exec(i)) !== null;) s += "-" + c[1];
	return {
		name: Ad(i) + s,
		styles: i,
		next: Ud
	};
}
//#endregion
//#region ../../node_modules/@emotion/use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.browser.esm.js
var Gd = function(e) {
	return e();
}, Kd = e.useInsertionEffect ? e.useInsertionEffect : !1, qd = Kd || Gd;
Kd || e.useLayoutEffect;
var Jd = /* #__PURE__ */ e.createContext(typeof HTMLElement < "u" ? /* #__PURE__ */ Sd({ key: "css" }) : null);
Jd.Provider;
var Yd = function(e) {
	return /*#__PURE__*/ c(function(t, n) {
		return e(t, d(Jd), n);
	});
}, Xd = /* #__PURE__ */ e.createContext({}), Zd = {}.hasOwnProperty, Qd = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", $d = function(e, t) {
	var n = {};
	for (var r in t) Zd.call(t, r) && (n[r] = t[r]);
	return n[Qd] = e, n;
}, ef = function(e) {
	var t = e.cache, n = e.serialized, r = e.isStringTag;
	return Od(t, n, r), qd(function() {
		return kd(t, n, r);
	}), null;
}, tf = /* @__PURE__ */ Yd(function(t, n, r) {
	var i = t.css;
	typeof i == "string" && n.registered[i] !== void 0 && (i = n.registered[i]);
	var a = t[Qd], o = [i], s = "";
	typeof t.className == "string" ? s = Dd(n.registered, o, t.className) : t.className != null && (s = t.className + " ");
	var c = Wd(o, void 0, e.useContext(Xd));
	s += n.key + "-" + c.name;
	var l = {};
	for (var u in t) Zd.call(t, u) && u !== "css" && u !== Qd && (l[u] = t[u]);
	return l.className = s, r && (l.ref = r), /*#__PURE__*/ e.createElement(e.Fragment, null, /*#__PURE__*/ e.createElement(ef, {
		cache: n,
		serialized: c,
		isStringTag: typeof a == "string"
	}), /*#__PURE__*/ e.createElement(a, l));
});
Td();
var nf = function(t, n) {
	var r = arguments;
	if (n == null || !Zd.call(n, "css")) return e.createElement.apply(void 0, r);
	var i = r.length, a = Array(i);
	a[0] = tf, a[1] = $d(t, n);
	for (var o = 2; o < i; o++) a[o] = r[o];
	return e.createElement.apply(null, a);
};
(function(e) {
	var t;
	t ||= e.JSX ||= {};
})(nf ||= {});
function rf() {
	return Wd([...arguments]);
}
function af() {
	var e = rf.apply(void 0, arguments), t = "animation-" + e.name;
	return {
		name: t,
		styles: "@keyframes " + t + "{" + e.styles + "}",
		anim: 1,
		toString: function() {
			return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
		}
	};
}
//#endregion
//#region ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
function of(e, t) {
	return t ||= e.slice(0), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
//#endregion
//#region ../../node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var sf = Math.min, cf = Math.max, lf = Math.round, uf = Math.floor, df = (e) => ({
	x: e,
	y: e
}), ff = {
	left: "right",
	right: "left",
	bottom: "top",
	top: "bottom"
}, pf = {
	start: "end",
	end: "start"
};
function mf(e, t, n) {
	return cf(e, sf(t, n));
}
function hf(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function gf(e) {
	return e.split("-")[0];
}
function _f(e) {
	return e.split("-")[1];
}
function vf(e) {
	return e === "x" ? "y" : "x";
}
function yf(e) {
	return e === "y" ? "height" : "width";
}
var bf = /*#__PURE__*/ new Set(["top", "bottom"]);
function xf(e) {
	return bf.has(gf(e)) ? "y" : "x";
}
function Sf(e) {
	return vf(xf(e));
}
function Cf(e, t, n) {
	n === void 0 && (n = !1);
	let r = _f(e), i = Sf(e), a = yf(i), o = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
	return t.reference[a] > t.floating[a] && (o = Mf(o)), [o, Mf(o)];
}
function wf(e) {
	let t = Mf(e);
	return [
		Tf(e),
		t,
		Tf(t)
	];
}
function Tf(e) {
	return e.replace(/start|end/g, (e) => pf[e]);
}
var Ef = ["left", "right"], Df = ["right", "left"], Of = ["top", "bottom"], kf = ["bottom", "top"];
function Af(e, t, n) {
	switch (e) {
		case "top":
		case "bottom": return n ? t ? Df : Ef : t ? Ef : Df;
		case "left":
		case "right": return t ? Of : kf;
		default: return [];
	}
}
function jf(e, t, n, r) {
	let i = _f(e), a = Af(gf(e), n === "start", r);
	return i && (a = a.map((e) => e + "-" + i), t && (a = a.concat(a.map(Tf)))), a;
}
function Mf(e) {
	return e.replace(/left|right|bottom|top/g, (e) => ff[e]);
}
function Nf(e) {
	return {
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		...e
	};
}
function Pf(e) {
	return typeof e == "number" ? {
		top: e,
		right: e,
		bottom: e,
		left: e
	} : Nf(e);
}
function Ff(e) {
	let { x: t, y: n, width: r, height: i } = e;
	return {
		width: r,
		height: i,
		top: n,
		left: t,
		right: t + r,
		bottom: n + i,
		x: t,
		y: n
	};
}
//#endregion
//#region ../../node_modules/@floating-ui/dom/node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function If(e, t, n) {
	let { reference: r, floating: i } = e, a = xf(t), o = Sf(t), s = yf(o), c = gf(t), l = a === "y", u = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, f = r[s] / 2 - i[s] / 2, p;
	switch (c) {
		case "top":
			p = {
				x: u,
				y: r.y - i.height
			};
			break;
		case "bottom":
			p = {
				x: u,
				y: r.y + r.height
			};
			break;
		case "right":
			p = {
				x: r.x + r.width,
				y: d
			};
			break;
		case "left":
			p = {
				x: r.x - i.width,
				y: d
			};
			break;
		default: p = {
			x: r.x,
			y: r.y
		};
	}
	switch (_f(t)) {
		case "start":
			p[o] -= f * (n && l ? -1 : 1);
			break;
		case "end":
			p[o] += f * (n && l ? -1 : 1);
			break;
	}
	return p;
}
var Lf = async (e, t, n) => {
	let { placement: r = "bottom", strategy: i = "absolute", middleware: a = [], platform: o } = n, s = a.filter(Boolean), c = await (o.isRTL == null ? void 0 : o.isRTL(t)), l = await o.getElementRects({
		reference: e,
		floating: t,
		strategy: i
	}), { x: u, y: d } = If(l, r, c), f = r, p = {}, m = 0;
	for (let n = 0; n < s.length; n++) {
		let { name: a, fn: h } = s[n], { x: g, y: _, data: v, reset: y } = await h({
			x: u,
			y: d,
			initialPlacement: r,
			placement: f,
			strategy: i,
			middlewareData: p,
			rects: l,
			platform: o,
			elements: {
				reference: e,
				floating: t
			}
		});
		u = g ?? u, d = _ ?? d, p = {
			...p,
			[a]: {
				...p[a],
				...v
			}
		}, y && m <= 50 && (m++, typeof y == "object" && (y.placement && (f = y.placement), y.rects && (l = y.rects === !0 ? await o.getElementRects({
			reference: e,
			floating: t,
			strategy: i
		}) : y.rects), {x: u, y: d} = If(l, f, c)), n = -1);
	}
	return {
		x: u,
		y: d,
		placement: f,
		strategy: i,
		middlewareData: p
	};
};
async function Rf(e, t) {
	t === void 0 && (t = {});
	let { x: n, y: r, platform: i, rects: a, elements: o, strategy: s } = e, { boundary: c = "clippingAncestors", rootBoundary: l = "viewport", elementContext: u = "floating", altBoundary: d = !1, padding: f = 0 } = hf(t, e), p = Pf(f), m = o[d ? u === "floating" ? "reference" : "floating" : u], h = Ff(await i.getClippingRect({
		element: await (i.isElement == null ? void 0 : i.isElement(m)) ?? !0 ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(o.floating)),
		boundary: c,
		rootBoundary: l,
		strategy: s
	})), g = u === "floating" ? {
		x: n,
		y: r,
		width: a.floating.width,
		height: a.floating.height
	} : a.reference, _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(o.floating)), v = await (i.isElement == null ? void 0 : i.isElement(_)) && await (i.getScale == null ? void 0 : i.getScale(_)) || {
		x: 1,
		y: 1
	}, y = Ff(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
		elements: o,
		rect: g,
		offsetParent: _,
		strategy: s
	}) : g);
	return {
		top: (h.top - y.top + p.top) / v.y,
		bottom: (y.bottom - h.bottom + p.bottom) / v.y,
		left: (h.left - y.left + p.left) / v.x,
		right: (y.right - h.right + p.right) / v.x
	};
}
var zf = (e) => ({
	name: "arrow",
	options: e,
	async fn(t) {
		let { x: n, y: r, placement: i, rects: a, platform: o, elements: s, middlewareData: c } = t, { element: l, padding: u = 0 } = hf(e, t) || {};
		if (l == null) return {};
		let d = Pf(u), f = {
			x: n,
			y: r
		}, p = Sf(i), m = yf(p), h = await o.getDimensions(l), g = p === "y", _ = g ? "top" : "left", v = g ? "bottom" : "right", y = g ? "clientHeight" : "clientWidth", b = a.reference[m] + a.reference[p] - f[p] - a.floating[m], x = f[p] - a.reference[p], S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(l)), C = S ? S[y] : 0;
		(!C || !await (o.isElement == null ? void 0 : o.isElement(S))) && (C = s.floating[y] || a.floating[m]);
		let w = b / 2 - x / 2, T = C / 2 - h[m] / 2 - 1, E = sf(d[_], T), D = sf(d[v], T), O = E, k = C - h[m] - D, A = C / 2 - h[m] / 2 + w, j = mf(O, A, k), M = !c.arrow && _f(i) != null && A !== j && a.reference[m] / 2 - (A < O ? E : D) - h[m] / 2 < 0, ee = M ? A < O ? A - O : A - k : 0;
		return {
			[p]: f[p] + ee,
			data: {
				[p]: j,
				centerOffset: A - j - ee,
				...M && { alignmentOffset: ee }
			},
			reset: M
		};
	}
}), Bf = function(e) {
	return e === void 0 && (e = {}), {
		name: "flip",
		options: e,
		async fn(t) {
			var n;
			let { placement: r, middlewareData: i, rects: a, initialPlacement: o, platform: s, elements: c } = t, { mainAxis: l = !0, crossAxis: u = !0, fallbackPlacements: d, fallbackStrategy: f = "bestFit", fallbackAxisSideDirection: p = "none", flipAlignment: m = !0, ...h } = hf(e, t);
			if ((n = i.arrow) != null && n.alignmentOffset) return {};
			let g = gf(r), _ = xf(o), v = gf(o) === o, y = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), b = d || (v || !m ? [Mf(o)] : wf(o)), x = p !== "none";
			!d && x && b.push(...jf(o, m, p, y));
			let S = [o, ...b], C = await Rf(t, h), w = [], T = i.flip?.overflows || [];
			if (l && w.push(C[g]), u) {
				let e = Cf(r, a, y);
				w.push(C[e[0]], C[e[1]]);
			}
			if (T = [...T, {
				placement: r,
				overflows: w
			}], !w.every((e) => e <= 0)) {
				let e = (i.flip?.index || 0) + 1, t = S[e];
				if (t && (!(u === "alignment" && _ !== xf(t)) || T.every((e) => xf(e.placement) === _ ? e.overflows[0] > 0 : !0))) return {
					data: {
						index: e,
						overflows: T
					},
					reset: { placement: t }
				};
				let n = T.filter((e) => e.overflows[0] <= 0).sort((e, t) => e.overflows[1] - t.overflows[1])[0]?.placement;
				if (!n) switch (f) {
					case "bestFit": {
						let e = T.filter((e) => {
							if (x) {
								let t = xf(e.placement);
								return t === _ || t === "y";
							}
							return !0;
						}).map((e) => [e.placement, e.overflows.filter((e) => e > 0).reduce((e, t) => e + t, 0)]).sort((e, t) => e[1] - t[1])[0]?.[0];
						e && (n = e);
						break;
					}
					case "initialPlacement":
						n = o;
						break;
				}
				if (r !== n) return { reset: { placement: n } };
			}
			return {};
		}
	};
}, Vf = /*#__PURE__*/ new Set(["left", "top"]);
async function Hf(e, t) {
	let { placement: n, platform: r, elements: i } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = gf(n), s = _f(n), c = xf(n) === "y", l = Vf.has(o) ? -1 : 1, u = a && c ? -1 : 1, d = hf(t, e), { mainAxis: f, crossAxis: p, alignmentAxis: m } = typeof d == "number" ? {
		mainAxis: d,
		crossAxis: 0,
		alignmentAxis: null
	} : {
		mainAxis: d.mainAxis || 0,
		crossAxis: d.crossAxis || 0,
		alignmentAxis: d.alignmentAxis
	};
	return s && typeof m == "number" && (p = s === "end" ? m * -1 : m), c ? {
		x: p * u,
		y: f * l
	} : {
		x: f * l,
		y: p * u
	};
}
var Wee = function(e) {
	return e === void 0 && (e = 0), {
		name: "offset",
		options: e,
		async fn(t) {
			var n;
			let { x: r, y: i, placement: a, middlewareData: o } = t, s = await Hf(t, e);
			return a === o.offset?.placement && (n = o.arrow) != null && n.alignmentOffset ? {} : {
				x: r + s.x,
				y: i + s.y,
				data: {
					...s,
					placement: a
				}
			};
		}
	};
}, Gee = function(e) {
	return e === void 0 && (e = {}), {
		name: "shift",
		options: e,
		async fn(t) {
			let { x: n, y: r, placement: i } = t, { mainAxis: a = !0, crossAxis: o = !1, limiter: s = { fn: (e) => {
				let { x: t, y: n } = e;
				return {
					x: t,
					y: n
				};
			} }, ...c } = hf(e, t), l = {
				x: n,
				y: r
			}, u = await Rf(t, c), d = xf(gf(i)), f = vf(d), p = l[f], m = l[d];
			if (a) {
				let e = f === "y" ? "top" : "left", t = f === "y" ? "bottom" : "right", n = p + u[e], r = p - u[t];
				p = mf(n, p, r);
			}
			if (o) {
				let e = d === "y" ? "top" : "left", t = d === "y" ? "bottom" : "right", n = m + u[e], r = m - u[t];
				m = mf(n, m, r);
			}
			let h = s.fn({
				...t,
				[f]: p,
				[d]: m
			});
			return {
				...h,
				data: {
					x: h.x - n,
					y: h.y - r,
					enabled: {
						[f]: a,
						[d]: o
					}
				}
			};
		}
	};
};
//#endregion
//#region ../../node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function Uf() {
	return typeof window < "u";
}
function Wf(e) {
	return qf(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Gf(e) {
	var t;
	return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Kf(e) {
	return ((qf(e) ? e.ownerDocument : e.document) || window.document)?.documentElement;
}
function qf(e) {
	return Uf() ? e instanceof Node || e instanceof Gf(e).Node : !1;
}
function Jf(e) {
	return Uf() ? e instanceof Element || e instanceof Gf(e).Element : !1;
}
function Yf(e) {
	return Uf() ? e instanceof HTMLElement || e instanceof Gf(e).HTMLElement : !1;
}
function Xf(e) {
	return !Uf() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Gf(e).ShadowRoot;
}
var Kee = /*#__PURE__*/ new Set(["inline", "contents"]);
function Zf(e) {
	let { overflow: t, overflowX: n, overflowY: r, display: i } = np(e);
	return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !Kee.has(i);
}
var qee = /*#__PURE__*/ new Set([
	"table",
	"td",
	"th"
]);
function Jee(e) {
	return qee.has(Wf(e));
}
var Yee = [":popover-open", ":modal"];
function Qf(e) {
	return Yee.some((t) => {
		try {
			return e.matches(t);
		} catch {
			return !1;
		}
	});
}
var Xee = [
	"transform",
	"translate",
	"scale",
	"rotate",
	"perspective"
], Zee = [
	"transform",
	"translate",
	"scale",
	"rotate",
	"perspective",
	"filter"
], Qee = [
	"paint",
	"layout",
	"strict",
	"content"
];
function $f(e) {
	let t = ep(), n = Jf(e) ? np(e) : e;
	return Xee.some((e) => n[e] ? n[e] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || Zee.some((e) => (n.willChange || "").includes(e)) || Qee.some((e) => (n.contain || "").includes(e));
}
function $ee(e) {
	let t = ip(e);
	for (; Yf(t) && !tp(t);) {
		if ($f(t)) return t;
		if (Qf(t)) return null;
		t = ip(t);
	}
	return null;
}
function ep() {
	return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
var ete = /*#__PURE__*/ new Set([
	"html",
	"body",
	"#document"
]);
function tp(e) {
	return ete.has(Wf(e));
}
function np(e) {
	return Gf(e).getComputedStyle(e);
}
function rp(e) {
	return Jf(e) ? {
		scrollLeft: e.scrollLeft,
		scrollTop: e.scrollTop
	} : {
		scrollLeft: e.scrollX,
		scrollTop: e.scrollY
	};
}
function ip(e) {
	if (Wf(e) === "html") return e;
	let t = e.assignedSlot || e.parentNode || Xf(e) && e.host || Kf(e);
	return Xf(t) ? t.host : t;
}
function ap(e) {
	let t = ip(e);
	return tp(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Yf(t) && Zf(t) ? t : ap(t);
}
function op(e, t, n) {
	t === void 0 && (t = []), n === void 0 && (n = !0);
	let r = ap(e), i = r === e.ownerDocument?.body, a = Gf(r);
	if (i) {
		let e = sp(a);
		return t.concat(a, a.visualViewport || [], Zf(r) ? r : [], e && n ? op(e) : []);
	}
	return t.concat(r, op(r, [], n));
}
function sp(e) {
	return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
//#endregion
//#region ../../node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function cp(e) {
	let t = np(e), n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0, i = Yf(e), a = i ? e.offsetWidth : n, o = i ? e.offsetHeight : r, s = lf(n) !== a || lf(r) !== o;
	return s && (n = a, r = o), {
		width: n,
		height: r,
		$: s
	};
}
function lp(e) {
	return Jf(e) ? e : e.contextElement;
}
function up(e) {
	let t = lp(e);
	if (!Yf(t)) return df(1);
	let n = t.getBoundingClientRect(), { width: r, height: i, $: a } = cp(t), o = (a ? lf(n.width) : n.width) / r, s = (a ? lf(n.height) : n.height) / i;
	return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
		x: o,
		y: s
	};
}
var tte = /*#__PURE__*/ df(0);
function dp(e) {
	let t = Gf(e);
	return !ep() || !t.visualViewport ? tte : {
		x: t.visualViewport.offsetLeft,
		y: t.visualViewport.offsetTop
	};
}
function nte(e, t, n) {
	return t === void 0 && (t = !1), !n || t && n !== Gf(e) ? !1 : t;
}
function fp(e, t, n, r) {
	t === void 0 && (t = !1), n === void 0 && (n = !1);
	let i = e.getBoundingClientRect(), a = lp(e), o = df(1);
	t && (r ? Jf(r) && (o = up(r)) : o = up(e));
	let s = nte(a, n, r) ? dp(a) : df(0), c = (i.left + s.x) / o.x, l = (i.top + s.y) / o.y, u = i.width / o.x, d = i.height / o.y;
	if (a) {
		let e = Gf(a), t = r && Jf(r) ? Gf(r) : r, n = e, i = sp(n);
		for (; i && r && t !== n;) {
			let e = up(i), t = i.getBoundingClientRect(), r = np(i), a = t.left + (i.clientLeft + parseFloat(r.paddingLeft)) * e.x, o = t.top + (i.clientTop + parseFloat(r.paddingTop)) * e.y;
			c *= e.x, l *= e.y, u *= e.x, d *= e.y, c += a, l += o, n = Gf(i), i = sp(n);
		}
	}
	return Ff({
		width: u,
		height: d,
		x: c,
		y: l
	});
}
function pp(e, t) {
	let n = rp(e).scrollLeft;
	return t ? t.left + n : fp(Kf(e)).left + n;
}
function mp(e, t) {
	let n = e.getBoundingClientRect();
	return {
		x: n.left + t.scrollLeft - pp(e, n),
		y: n.top + t.scrollTop
	};
}
function rte(e) {
	let { elements: t, rect: n, offsetParent: r, strategy: i } = e, a = i === "fixed", o = Kf(r), s = t ? Qf(t.floating) : !1;
	if (r === o || s && a) return n;
	let c = {
		scrollLeft: 0,
		scrollTop: 0
	}, l = df(1), u = df(0), d = Yf(r);
	if ((d || !d && !a) && ((Wf(r) !== "body" || Zf(o)) && (c = rp(r)), Yf(r))) {
		let e = fp(r);
		l = up(r), u.x = e.x + r.clientLeft, u.y = e.y + r.clientTop;
	}
	let f = o && !d && !a ? mp(o, c) : df(0);
	return {
		width: n.width * l.x,
		height: n.height * l.y,
		x: n.x * l.x - c.scrollLeft * l.x + u.x + f.x,
		y: n.y * l.y - c.scrollTop * l.y + u.y + f.y
	};
}
function ite(e) {
	return Array.from(e.getClientRects());
}
function ate(e) {
	let t = Kf(e), n = rp(e), r = e.ownerDocument.body, i = cf(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = cf(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight), o = -n.scrollLeft + pp(e), s = -n.scrollTop;
	return np(r).direction === "rtl" && (o += cf(t.clientWidth, r.clientWidth) - i), {
		width: i,
		height: a,
		x: o,
		y: s
	};
}
var hp = 25;
function ote(e, t) {
	let n = Gf(e), r = Kf(e), i = n.visualViewport, a = r.clientWidth, o = r.clientHeight, s = 0, c = 0;
	if (i) {
		a = i.width, o = i.height;
		let e = ep();
		(!e || e && t === "fixed") && (s = i.offsetLeft, c = i.offsetTop);
	}
	let l = pp(r);
	if (l <= 0) {
		let e = r.ownerDocument, t = e.body, n = getComputedStyle(t), i = e.compatMode === "CSS1Compat" && parseFloat(n.marginLeft) + parseFloat(n.marginRight) || 0, o = Math.abs(r.clientWidth - t.clientWidth - i);
		o <= hp && (a -= o);
	} else l <= hp && (a += l);
	return {
		width: a,
		height: o,
		x: s,
		y: c
	};
}
var ste = /*#__PURE__*/ new Set(["absolute", "fixed"]);
function cte(e, t) {
	let n = fp(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, a = Yf(e) ? up(e) : df(1);
	return {
		width: e.clientWidth * a.x,
		height: e.clientHeight * a.y,
		x: i * a.x,
		y: r * a.y
	};
}
function gp(e, t, n) {
	let r;
	if (t === "viewport") r = ote(e, n);
	else if (t === "document") r = ate(Kf(e));
	else if (Jf(t)) r = cte(t, n);
	else {
		let n = dp(e);
		r = {
			x: t.x - n.x,
			y: t.y - n.y,
			width: t.width,
			height: t.height
		};
	}
	return Ff(r);
}
function _p(e, t) {
	let n = ip(e);
	return n === t || !Jf(n) || tp(n) ? !1 : np(n).position === "fixed" || _p(n, t);
}
function lte(e, t) {
	let n = t.get(e);
	if (n) return n;
	let r = op(e, [], !1).filter((e) => Jf(e) && Wf(e) !== "body"), i = null, a = np(e).position === "fixed", o = a ? ip(e) : e;
	for (; Jf(o) && !tp(o);) {
		let t = np(o), n = $f(o);
		!n && t.position === "fixed" && (i = null), (a ? !n && !i : !n && t.position === "static" && i && ste.has(i.position) || Zf(o) && !n && _p(e, o)) ? r = r.filter((e) => e !== o) : i = t, o = ip(o);
	}
	return t.set(e, r), r;
}
function ute(e) {
	let { element: t, boundary: n, rootBoundary: r, strategy: i } = e, a = [...n === "clippingAncestors" ? Qf(t) ? [] : lte(t, this._c) : [].concat(n), r], o = a[0], s = a.reduce((e, n) => {
		let r = gp(t, n, i);
		return e.top = cf(r.top, e.top), e.right = sf(r.right, e.right), e.bottom = sf(r.bottom, e.bottom), e.left = cf(r.left, e.left), e;
	}, gp(t, o, i));
	return {
		width: s.right - s.left,
		height: s.bottom - s.top,
		x: s.left,
		y: s.top
	};
}
function dte(e) {
	let { width: t, height: n } = cp(e);
	return {
		width: t,
		height: n
	};
}
function fte(e, t, n) {
	let r = Yf(t), i = Kf(t), a = n === "fixed", o = fp(e, !0, a, t), s = {
		scrollLeft: 0,
		scrollTop: 0
	}, c = df(0);
	function l() {
		c.x = pp(i);
	}
	if (r || !r && !a) if ((Wf(t) !== "body" || Zf(i)) && (s = rp(t)), r) {
		let e = fp(t, !0, a, t);
		c.x = e.x + t.clientLeft, c.y = e.y + t.clientTop;
	} else i && l();
	a && !r && i && l();
	let u = i && !r && !a ? mp(i, s) : df(0);
	return {
		x: o.left + s.scrollLeft - c.x - u.x,
		y: o.top + s.scrollTop - c.y - u.y,
		width: o.width,
		height: o.height
	};
}
function vp(e) {
	return np(e).position === "static";
}
function yp(e, t) {
	if (!Yf(e) || np(e).position === "fixed") return null;
	if (t) return t(e);
	let n = e.offsetParent;
	return Kf(e) === n && (n = n.ownerDocument.body), n;
}
function bp(e, t) {
	let n = Gf(e);
	if (Qf(e)) return n;
	if (!Yf(e)) {
		let t = ip(e);
		for (; t && !tp(t);) {
			if (Jf(t) && !vp(t)) return t;
			t = ip(t);
		}
		return n;
	}
	let r = yp(e, t);
	for (; r && Jee(r) && vp(r);) r = yp(r, t);
	return r && tp(r) && vp(r) && !$f(r) ? n : r || $ee(e) || n;
}
var pte = async function(e) {
	let t = this.getOffsetParent || bp, n = this.getDimensions, r = await n(e.floating);
	return {
		reference: fte(e.reference, await t(e.floating), e.strategy),
		floating: {
			x: 0,
			y: 0,
			width: r.width,
			height: r.height
		}
	};
};
function mte(e) {
	return np(e).direction === "rtl";
}
var hte = {
	convertOffsetParentRelativeRectToViewportRelativeRect: rte,
	getDocumentElement: Kf,
	getClippingRect: ute,
	getOffsetParent: bp,
	getElementRects: pte,
	getClientRects: ite,
	getDimensions: dte,
	getScale: up,
	isElement: Jf,
	isRTL: mte
};
function xp(e, t) {
	return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function gte(e, t) {
	let n = null, r, i = Kf(e);
	function a() {
		var e;
		clearTimeout(r), (e = n) == null || e.disconnect(), n = null;
	}
	function o(s, c) {
		s === void 0 && (s = !1), c === void 0 && (c = 1), a();
		let l = e.getBoundingClientRect(), { left: u, top: d, width: f, height: p } = l;
		if (s || t(), !f || !p) return;
		let m = uf(d), h = uf(i.clientWidth - (u + f)), g = uf(i.clientHeight - (d + p)), _ = uf(u), v = {
			rootMargin: -m + "px " + -h + "px " + -g + "px " + -_ + "px",
			threshold: cf(0, sf(1, c)) || 1
		}, y = !0;
		function b(t) {
			let n = t[0].intersectionRatio;
			if (n !== c) {
				if (!y) return o();
				n ? o(!1, n) : r = setTimeout(() => {
					o(!1, 1e-7);
				}, 1e3);
			}
			n === 1 && !xp(l, e.getBoundingClientRect()) && o(), y = !1;
		}
		try {
			n = new IntersectionObserver(b, {
				...v,
				root: i.ownerDocument
			});
		} catch {
			n = new IntersectionObserver(b, v);
		}
		n.observe(e);
	}
	return o(!0), a;
}
function Sp(e, t, n, r) {
	r === void 0 && (r = {});
	let { ancestorScroll: i = !0, ancestorResize: a = !0, elementResize: o = typeof ResizeObserver == "function", layoutShift: s = typeof IntersectionObserver == "function", animationFrame: c = !1 } = r, l = lp(e), u = i || a ? [...l ? op(l) : [], ...op(t)] : [];
	u.forEach((e) => {
		i && e.addEventListener("scroll", n, { passive: !0 }), a && e.addEventListener("resize", n);
	});
	let d = l && s ? gte(l, n) : null, f = -1, p = null;
	o && (p = new ResizeObserver((e) => {
		let [r] = e;
		r && r.target === l && p && (p.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
			var e;
			(e = p) == null || e.observe(t);
		})), n();
	}), l && !c && p.observe(l), p.observe(t));
	let m, h = c ? fp(e) : null;
	c && g();
	function g() {
		let t = fp(e);
		h && !xp(h, t) && n(), h = t, m = requestAnimationFrame(g);
	}
	return n(), () => {
		var e;
		u.forEach((e) => {
			i && e.removeEventListener("scroll", n), a && e.removeEventListener("resize", n);
		}), d?.(), (e = p) == null || e.disconnect(), p = null, c && cancelAnimationFrame(m);
	};
}
var Cp = Wee, _te = Gee, wp = Bf, Tp = zf, Ep = (e, t, n) => {
	let r = /* @__PURE__ */ new Map(), i = {
		platform: hte,
		...n
	}, a = {
		...i.platform,
		_c: r
	};
	return Lf(e, t, {
		...i,
		platform: a
	});
}, Dp = h, vte = [
	"className",
	"clearValue",
	"cx",
	"getStyles",
	"getClassNames",
	"getValue",
	"hasValue",
	"isMulti",
	"isRtl",
	"options",
	"selectOption",
	"selectProps",
	"setValue",
	"theme"
], Op = function() {};
function yte(e, t) {
	return t ? t[0] === "-" ? e + t : e + "__" + t : e;
}
function bte(e, t) {
	var n = [...arguments].slice(2), r = [].concat(n);
	if (t && e) for (var i in t) t.hasOwnProperty(i) && t[i] && r.push(`${yte(e, i)}`);
	return r.filter(function(e) {
		return e;
	}).map(function(e) {
		return String(e).trim();
	}).join(" ");
}
var kp = function(e) {
	return qp(e) ? e.filter(Boolean) : Zl(e) === "object" && e !== null ? [e] : [];
}, Ap = function(e) {
	return e.className, e.clearValue, e.cx, e.getStyles, e.getClassNames, e.getValue, e.hasValue, e.isMulti, e.isRtl, e.options, e.selectOption, e.selectProps, e.setValue, e.theme, nu({}, uu(e, vte));
}, jp = function(e, t, n) {
	var r = e.cx, i = e.getStyles, a = e.getClassNames, o = e.className;
	return {
		css: i(t, e),
		className: r(n ?? {}, a(t, e), o)
	};
};
function Mp(e) {
	return [
		document.documentElement,
		document.body,
		window
	].indexOf(e) > -1;
}
function xte(e) {
	return Mp(e) ? window.innerHeight : e.clientHeight;
}
function Np(e) {
	return Mp(e) ? window.pageYOffset : e.scrollTop;
}
function Pp(e, t) {
	if (Mp(e)) {
		window.scrollTo(0, t);
		return;
	}
	e.scrollTop = t;
}
function Fp(e) {
	var t = getComputedStyle(e), n = t.position === "absolute", r = /(auto|scroll)/;
	if (t.position === "fixed") return document.documentElement;
	for (var i = e; i = i.parentElement;) if (t = getComputedStyle(i), !(n && t.position === "static") && r.test(t.overflow + t.overflowY + t.overflowX)) return i;
	return document.documentElement;
}
function Ip(e, t, n, r) {
	return n * ((e = e / r - 1) * e * e + 1) + t;
}
function Lp(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Op, i = Np(e), a = t - i, o = 10, s = 0;
	function c() {
		s += o, Pp(e, Ip(s, i, a, n)), s < n ? window.requestAnimationFrame(c) : r(e);
	}
	c();
}
function Rp(e, t) {
	var n = e.getBoundingClientRect(), r = t.getBoundingClientRect(), i = t.offsetHeight / 3;
	r.bottom + i > n.bottom ? Pp(e, Math.min(t.offsetTop + t.clientHeight - e.offsetHeight + i, e.scrollHeight)) : r.top - i < n.top && Pp(e, Math.max(t.offsetTop - i, 0));
}
function zp(e) {
	var t = e.getBoundingClientRect();
	return {
		bottom: t.bottom,
		height: t.height,
		left: t.left,
		right: t.right,
		top: t.top,
		width: t.width
	};
}
function Bp() {
	try {
		return document.createEvent("TouchEvent"), !0;
	} catch {
		return !1;
	}
}
function Vp() {
	try {
		return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	} catch {
		return !1;
	}
}
var Hp = !1, Up = { get passive() {
	return Hp = !0;
} }, Wp = typeof window < "u" ? window : {};
Wp.addEventListener && Wp.removeEventListener && (Wp.addEventListener("p", Op, Up), Wp.removeEventListener("p", Op, !1));
var Gp = Hp;
function Kp(e) {
	return e != null;
}
function qp(e) {
	return Array.isArray(e);
}
function Jp(e, t, n) {
	return e ? t : n;
}
function Yp(e) {
	return e;
}
function Xp(e) {
	return e;
}
var Zp = function(e) {
	var t = [...arguments].slice(1);
	return Object.entries(e).filter(function(e) {
		var n = cu(e, 1)[0];
		return !t.includes(n);
	}).reduce(function(e, t) {
		var n = cu(t, 2), r = n[0];
		return e[r] = n[1], e;
	}, {});
}, Qp = ["children", "innerProps"], $p = ["children", "innerProps"];
function em(e) {
	var t = e.maxHeight, n = e.menuEl, r = e.minHeight, i = e.placement, a = e.shouldScroll, o = e.isFixedPosition, s = e.controlHeight, c = Fp(n), l = {
		placement: "bottom",
		maxHeight: t
	};
	if (!n || !n.offsetParent) return l;
	var u = c.getBoundingClientRect().height, d = n.getBoundingClientRect(), f = d.bottom, p = d.height, m = d.top, h = n.offsetParent.getBoundingClientRect().top, g = o ? window.innerHeight : xte(c), _ = Np(c), v = parseInt(getComputedStyle(n).marginBottom, 10), y = parseInt(getComputedStyle(n).marginTop, 10), b = h - y, x = g - m, S = b + _, C = u - _ - m, w = f - g + _ + v, T = _ + m - y, E = 160;
	switch (i) {
		case "auto":
		case "bottom":
			if (x >= p) return {
				placement: "bottom",
				maxHeight: t
			};
			if (C >= p && !o) return a && Lp(c, w, E), {
				placement: "bottom",
				maxHeight: t
			};
			if (!o && C >= r || o && x >= r) return a && Lp(c, w, E), {
				placement: "bottom",
				maxHeight: o ? x - v : C - v
			};
			if (i === "auto" || o) {
				var D = t, O = o ? b : S;
				return O >= r && (D = Math.min(O - v - s, t)), {
					placement: "top",
					maxHeight: D
				};
			}
			if (i === "bottom") return a && Pp(c, w), {
				placement: "bottom",
				maxHeight: t
			};
			break;
		case "top":
			if (b >= p) return {
				placement: "top",
				maxHeight: t
			};
			if (S >= p && !o) return a && Lp(c, T, E), {
				placement: "top",
				maxHeight: t
			};
			if (!o && S >= r || o && b >= r) {
				var k = t;
				return (!o && S >= r || o && b >= r) && (k = o ? b - y : S - y), a && Lp(c, T, E), {
					placement: "top",
					maxHeight: k
				};
			}
			return {
				placement: "bottom",
				maxHeight: t
			};
		default: throw Error(`Invalid placement provided "${i}".`);
	}
	return l;
}
function tm(e) {
	return e ? {
		bottom: "top",
		top: "bottom"
	}[e] : "bottom";
}
var nm = function(e) {
	return e === "auto" ? "bottom" : e;
}, rm = function(e, t) {
	var n, r = e.placement, i = e.theme, a = i.borderRadius, o = i.spacing, s = i.colors;
	return nu((n = { label: "menu" }, eu(n, tm(r), "100%"), eu(n, "position", "absolute"), eu(n, "width", "100%"), eu(n, "zIndex", 1), n), t ? {} : {
		backgroundColor: s.neutral0,
		borderRadius: a,
		boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
		marginBottom: o.menuGutter,
		marginTop: o.menuGutter
	});
}, im = /*#__PURE__*/ a(null), am = function(e) {
	var t = e.children, n = e.minMenuHeight, r = e.maxMenuHeight, i = e.menuPlacement, a = e.menuPosition, o = e.menuShouldScrollIntoView, s = e.theme, c = (d(im) || {}).setPortalPlacement, l = v(null), u = cu(y(r), 2), f = u[0], p = u[1], m = cu(y(null), 2), h = m[0], g = m[1], _ = s.spacing.controlHeight;
	return Dp(function() {
		var e = l.current;
		if (e) {
			var t = a === "fixed", s = em({
				maxHeight: r,
				menuEl: e,
				minHeight: n,
				placement: i,
				shouldScroll: o && !t,
				isFixedPosition: t,
				controlHeight: _
			});
			p(s.maxHeight), g(s.placement), c?.(s.placement);
		}
	}, [
		r,
		i,
		a,
		o,
		n,
		c,
		_
	]), t({
		ref: l,
		placerProps: nu(nu({}, e), {}, {
			placement: h || nm(i),
			maxHeight: f
		})
	});
}, om = function(e) {
	var t = e.children, n = e.innerRef, r = e.innerProps;
	return nf("div", pu({}, jp(e, "menu", { menu: !0 }), { ref: n }, r), t);
}, sm = function(e, t) {
	var n = e.maxHeight, r = e.theme.spacing.baseUnit;
	return nu({
		maxHeight: n,
		overflowY: "auto",
		position: "relative",
		WebkitOverflowScrolling: "touch"
	}, t ? {} : {
		paddingBottom: r,
		paddingTop: r
	});
}, cm = function(e) {
	var t = e.children, n = e.innerProps, r = e.innerRef, i = e.isMulti;
	return nf("div", pu({}, jp(e, "menuList", {
		"menu-list": !0,
		"menu-list--is-multi": i
	}), { ref: r }, n), t);
}, lm = function(e, t) {
	var n = e.theme, r = n.spacing.baseUnit, i = n.colors;
	return nu({ textAlign: "center" }, t ? {} : {
		color: i.neutral40,
		padding: `${r * 2}px ${r * 3}px`
	});
}, um = lm, dm = lm, fm = function(e) {
	var t = e.children, n = t === void 0 ? "No options" : t, r = e.innerProps;
	return nf("div", pu({}, jp(nu(nu({}, uu(e, Qp)), {}, {
		children: n,
		innerProps: r
	}), "noOptionsMessage", {
		"menu-notice": !0,
		"menu-notice--no-options": !0
	}), r), n);
}, pm = function(e) {
	var t = e.children, n = t === void 0 ? "Loading..." : t, r = e.innerProps;
	return nf("div", pu({}, jp(nu(nu({}, uu(e, $p)), {}, {
		children: n,
		innerProps: r
	}), "loadingMessage", {
		"menu-notice": !0,
		"menu-notice--loading": !0
	}), r), n);
}, mm = function(e) {
	var t = e.rect, n = e.offset, r = e.position;
	return {
		left: t.left,
		position: r,
		top: n,
		width: t.width,
		zIndex: 1
	};
}, hm = function(e) {
	var t = e.appendTo, n = e.children, r = e.controlElement, i = e.innerProps, a = e.menuPlacement, o = e.menuPosition, s = v(null), c = v(null), l = cu(y(nm(a)), 2), d = l[0], f = l[1], p = g(function() {
		return { setPortalPlacement: f };
	}, []), m = cu(y(null), 2), h = m[0], _ = m[1], b = u(function() {
		if (r) {
			var e = zp(r), t = o === "fixed" ? 0 : window.pageYOffset, n = e[d] + t;
			(n !== h?.offset || e.left !== h?.rect.left || e.width !== h?.rect.width) && _({
				offset: n,
				rect: e
			});
		}
	}, [
		r,
		o,
		d,
		h?.offset,
		h?.rect.left,
		h?.rect.width
	]);
	Dp(function() {
		b();
	}, [b]);
	var x = u(function() {
		typeof c.current == "function" && (c.current(), c.current = null), r && s.current && (c.current = Sp(r, s.current, b, { elementResize: "ResizeObserver" in window }));
	}, [r, b]);
	Dp(function() {
		x();
	}, [x]);
	var S = u(function(e) {
		s.current = e, x();
	}, [x]);
	if (!t && o !== "fixed" || !h) return null;
	var C = nf("div", pu({ ref: S }, jp(nu(nu({}, e), {}, {
		offset: h.offset,
		position: o,
		rect: h.rect
	}), "menuPortal", { "menu-portal": !0 }), i), n);
	return nf(im.Provider, { value: p }, t ? /*#__PURE__*/ Ve(C, t) : C);
}, gm = function(e) {
	var t = e.isDisabled;
	return {
		label: "container",
		direction: e.isRtl ? "rtl" : void 0,
		pointerEvents: t ? "none" : void 0,
		position: "relative"
	};
}, _m = function(e) {
	var t = e.children, n = e.innerProps, r = e.isDisabled, i = e.isRtl;
	return nf("div", pu({}, jp(e, "container", {
		"--is-disabled": r,
		"--is-rtl": i
	}), n), t);
}, vm = function(e, t) {
	var n = e.theme.spacing, r = e.isMulti, i = e.hasValue, a = e.selectProps.controlShouldRenderValue;
	return nu({
		alignItems: "center",
		display: r && i && a ? "flex" : "grid",
		flex: 1,
		flexWrap: "wrap",
		WebkitOverflowScrolling: "touch",
		position: "relative",
		overflow: "hidden"
	}, t ? {} : { padding: `${n.baseUnit / 2}px ${n.baseUnit * 2}px` });
}, ym = function(e) {
	var t = e.children, n = e.innerProps, r = e.isMulti, i = e.hasValue;
	return nf("div", pu({}, jp(e, "valueContainer", {
		"value-container": !0,
		"value-container--is-multi": r,
		"value-container--has-value": i
	}), n), t);
}, bm = function() {
	return {
		alignItems: "center",
		alignSelf: "stretch",
		display: "flex",
		flexShrink: 0
	};
}, xm = function(e) {
	var t = e.children, n = e.innerProps;
	return nf("div", pu({}, jp(e, "indicatorsContainer", { indicators: !0 }), n), t);
}, Sm, Cm = ["size"], wm = [
	"innerProps",
	"isRtl",
	"size"
], Tm = {
	name: "8mmkcg",
	styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
}, Em = function(e) {
	var t = e.size, n = uu(e, Cm);
	return nf("svg", pu({
		height: t,
		width: t,
		viewBox: "0 0 20 20",
		"aria-hidden": "true",
		focusable: "false",
		css: Tm
	}, n));
}, Dm = function(e) {
	return nf(Em, pu({ size: 20 }, e), nf("path", { d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z" }));
}, Om = function(e) {
	return nf(Em, pu({ size: 20 }, e), nf("path", { d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z" }));
}, km = function(e, t) {
	var n = e.isFocused, r = e.theme, i = r.spacing.baseUnit, a = r.colors;
	return nu({
		label: "indicatorContainer",
		display: "flex",
		transition: "color 150ms"
	}, t ? {} : {
		color: n ? a.neutral60 : a.neutral20,
		padding: i * 2,
		":hover": { color: n ? a.neutral80 : a.neutral40 }
	});
}, Am = km, jm = function(e) {
	var t = e.children, n = e.innerProps;
	return nf("div", pu({}, jp(e, "dropdownIndicator", {
		indicator: !0,
		"dropdown-indicator": !0
	}), n), t || nf(Om, null));
}, Mm = km, Nm = function(e) {
	var t = e.children, n = e.innerProps;
	return nf("div", pu({}, jp(e, "clearIndicator", {
		indicator: !0,
		"clear-indicator": !0
	}), n), t || nf(Dm, null));
}, Pm = function(e, t) {
	var n = e.isDisabled, r = e.theme, i = r.spacing.baseUnit, a = r.colors;
	return nu({
		label: "indicatorSeparator",
		alignSelf: "stretch",
		width: 1
	}, t ? {} : {
		backgroundColor: n ? a.neutral10 : a.neutral20,
		marginBottom: i * 2,
		marginTop: i * 2
	});
}, Fm = function(e) {
	var t = e.innerProps;
	return nf("span", pu({}, t, jp(e, "indicatorSeparator", { "indicator-separator": !0 })));
}, Im = af(Sm ||= of(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"])), Lm = function(e, t) {
	var n = e.isFocused, r = e.size, i = e.theme, a = i.colors, o = i.spacing.baseUnit;
	return nu({
		label: "loadingIndicator",
		display: "flex",
		transition: "color 150ms",
		alignSelf: "center",
		fontSize: r,
		lineHeight: 1,
		marginRight: r,
		textAlign: "center",
		verticalAlign: "middle"
	}, t ? {} : {
		color: n ? a.neutral60 : a.neutral20,
		padding: o * 2
	});
}, Rm = function(e) {
	var t = e.delay, n = e.offset;
	return nf("span", { css: /*#__PURE__*/ rf({
		animation: `${Im} 1s ease-in-out ${t}ms infinite;`,
		backgroundColor: "currentColor",
		borderRadius: "1em",
		display: "inline-block",
		marginLeft: n ? "1em" : void 0,
		height: "1em",
		verticalAlign: "top",
		width: "1em"
	}, "", "") });
}, zm = function(e) {
	var t = e.innerProps, n = e.isRtl, r = e.size, i = r === void 0 ? 4 : r;
	return nf("div", pu({}, jp(nu(nu({}, uu(e, wm)), {}, {
		innerProps: t,
		isRtl: n,
		size: i
	}), "loadingIndicator", {
		indicator: !0,
		"loading-indicator": !0
	}), t), nf(Rm, {
		delay: 0,
		offset: n
	}), nf(Rm, {
		delay: 160,
		offset: !0
	}), nf(Rm, {
		delay: 320,
		offset: !n
	}));
}, Bm = function(e, t) {
	var n = e.isDisabled, r = e.isFocused, i = e.theme, a = i.colors, o = i.borderRadius, s = i.spacing;
	return nu({
		label: "control",
		alignItems: "center",
		cursor: "default",
		display: "flex",
		flexWrap: "wrap",
		justifyContent: "space-between",
		minHeight: s.controlHeight,
		outline: "0 !important",
		position: "relative",
		transition: "all 100ms"
	}, t ? {} : {
		backgroundColor: n ? a.neutral5 : a.neutral0,
		borderColor: n ? a.neutral10 : r ? a.primary : a.neutral20,
		borderRadius: o,
		borderStyle: "solid",
		borderWidth: 1,
		boxShadow: r ? `0 0 0 1px ${a.primary}` : void 0,
		"&:hover": { borderColor: r ? a.primary : a.neutral30 }
	});
}, Vm = function(e) {
	var t = e.children, n = e.isDisabled, r = e.isFocused, i = e.innerRef, a = e.innerProps, o = e.menuIsOpen;
	return nf("div", pu({ ref: i }, jp(e, "control", {
		control: !0,
		"control--is-disabled": n,
		"control--is-focused": r,
		"control--menu-is-open": o
	}), a, { "aria-disabled": n || void 0 }), t);
}, Hm = ["data"], Um = function(e, t) {
	var n = e.theme.spacing;
	return t ? {} : {
		paddingBottom: n.baseUnit * 2,
		paddingTop: n.baseUnit * 2
	};
}, Wm = function(e) {
	var t = e.children, n = e.cx, r = e.getStyles, i = e.getClassNames, a = e.Heading, o = e.headingProps, s = e.innerProps, c = e.label, l = e.theme, u = e.selectProps;
	return nf("div", pu({}, jp(e, "group", { group: !0 }), s), nf(a, pu({}, o, {
		selectProps: u,
		theme: l,
		getStyles: r,
		getClassNames: i,
		cx: n
	}), c), nf("div", null, t));
}, Gm = function(e, t) {
	var n = e.theme, r = n.colors, i = n.spacing;
	return nu({
		label: "group",
		cursor: "default",
		display: "block"
	}, t ? {} : {
		color: r.neutral40,
		fontSize: "75%",
		fontWeight: 500,
		marginBottom: "0.25em",
		paddingLeft: i.baseUnit * 3,
		paddingRight: i.baseUnit * 3,
		textTransform: "uppercase"
	});
}, Km = function(e) {
	var t = Ap(e);
	t.data;
	var n = uu(t, Hm);
	return nf("div", pu({}, jp(e, "groupHeading", { "group-heading": !0 }), n));
}, qm = Wm, Jm = [
	"innerRef",
	"isDisabled",
	"isHidden",
	"inputClassName"
], Ym = function(e, t) {
	var n = e.isDisabled, r = e.value, i = e.theme, a = i.spacing, o = i.colors;
	return nu(nu({
		visibility: n ? "hidden" : "visible",
		transform: r ? "translateZ(0)" : ""
	}, Zm), t ? {} : {
		margin: a.baseUnit / 2,
		paddingBottom: a.baseUnit / 2,
		paddingTop: a.baseUnit / 2,
		color: o.neutral80
	});
}, Xm = {
	gridArea: "1 / 2",
	font: "inherit",
	minWidth: "2px",
	border: 0,
	margin: 0,
	outline: 0,
	padding: 0
}, Zm = {
	flex: "1 1 auto",
	display: "inline-grid",
	gridArea: "1 / 1 / 2 / 3",
	gridTemplateColumns: "0 min-content",
	"&:after": nu({
		content: "attr(data-value) \" \"",
		visibility: "hidden",
		whiteSpace: "pre"
	}, Xm)
}, Qm = function(e) {
	return nu({
		label: "input",
		color: "inherit",
		background: 0,
		opacity: +!e,
		width: "100%"
	}, Xm);
}, $m = function(e) {
	var t = e.cx, n = e.value, r = Ap(e), i = r.innerRef, a = r.isDisabled, o = r.isHidden, s = r.inputClassName, c = uu(r, Jm);
	return nf("div", pu({}, jp(e, "input", { "input-container": !0 }), { "data-value": n || "" }), nf("input", pu({
		className: t({ input: !0 }, s),
		ref: i,
		style: Qm(o),
		disabled: a
	}, c)));
}, eh = function(e, t) {
	var n = e.theme, r = n.spacing, i = n.borderRadius, a = n.colors;
	return nu({
		label: "multiValue",
		display: "flex",
		minWidth: 0
	}, t ? {} : {
		backgroundColor: a.neutral10,
		borderRadius: i / 2,
		margin: r.baseUnit / 2
	});
}, th = function(e, t) {
	var n = e.theme, r = n.borderRadius, i = n.colors, a = e.cropWithEllipsis;
	return nu({
		overflow: "hidden",
		textOverflow: a || a === void 0 ? "ellipsis" : void 0,
		whiteSpace: "nowrap"
	}, t ? {} : {
		borderRadius: r / 2,
		color: i.neutral80,
		fontSize: "85%",
		padding: 3,
		paddingLeft: 6
	});
}, nh = function(e, t) {
	var n = e.theme, r = n.spacing, i = n.borderRadius, a = n.colors, o = e.isFocused;
	return nu({
		alignItems: "center",
		display: "flex"
	}, t ? {} : {
		borderRadius: i / 2,
		backgroundColor: o ? a.dangerLight : void 0,
		paddingLeft: r.baseUnit,
		paddingRight: r.baseUnit,
		":hover": {
			backgroundColor: a.dangerLight,
			color: a.danger
		}
	});
}, rh = function(e) {
	var t = e.children, n = e.innerProps;
	return nf("div", n, t);
}, ih = rh, ah = rh;
function oh(e) {
	var t = e.children, n = e.innerProps;
	return nf("div", pu({ role: "button" }, n), t || nf(Dm, { size: 14 }));
}
var sh = function(e) {
	var t = e.children, n = e.components, r = e.data, i = e.innerProps, a = e.isDisabled, o = e.removeProps, s = e.selectProps, c = n.Container, l = n.Label, u = n.Remove;
	return nf(c, {
		data: r,
		innerProps: nu(nu({}, jp(e, "multiValue", {
			"multi-value": !0,
			"multi-value--is-disabled": a
		})), i),
		selectProps: s
	}, nf(l, {
		data: r,
		innerProps: nu({}, jp(e, "multiValueLabel", { "multi-value__label": !0 })),
		selectProps: s
	}, t), nf(u, {
		data: r,
		innerProps: nu(nu({}, jp(e, "multiValueRemove", { "multi-value__remove": !0 })), {}, { "aria-label": `Remove ${t || "option"}` }, o),
		selectProps: s
	}));
}, ch = function(e, t) {
	var n = e.isDisabled, r = e.isFocused, i = e.isSelected, a = e.theme, o = a.spacing, s = a.colors;
	return nu({
		label: "option",
		cursor: "default",
		display: "block",
		fontSize: "inherit",
		width: "100%",
		userSelect: "none",
		WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
	}, t ? {} : {
		backgroundColor: i ? s.primary : r ? s.primary25 : "transparent",
		color: n ? s.neutral20 : i ? s.neutral0 : "inherit",
		padding: `${o.baseUnit * 2}px ${o.baseUnit * 3}px`,
		":active": { backgroundColor: n ? void 0 : i ? s.primary : s.primary50 }
	});
}, lh = function(e) {
	var t = e.children, n = e.isDisabled, r = e.isFocused, i = e.isSelected, a = e.innerRef, o = e.innerProps;
	return nf("div", pu({}, jp(e, "option", {
		option: !0,
		"option--is-disabled": n,
		"option--is-focused": r,
		"option--is-selected": i
	}), {
		ref: a,
		"aria-disabled": n
	}, o), t);
}, uh = function(e, t) {
	var n = e.theme, r = n.spacing, i = n.colors;
	return nu({
		label: "placeholder",
		gridArea: "1 / 1 / 2 / 3"
	}, t ? {} : {
		color: i.neutral50,
		marginLeft: r.baseUnit / 2,
		marginRight: r.baseUnit / 2
	});
}, dh = function(e) {
	var t = e.children, n = e.innerProps;
	return nf("div", pu({}, jp(e, "placeholder", { placeholder: !0 }), n), t);
}, fh = function(e, t) {
	var n = e.isDisabled, r = e.theme, i = r.spacing, a = r.colors;
	return nu({
		label: "singleValue",
		gridArea: "1 / 1 / 2 / 3",
		maxWidth: "100%",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap"
	}, t ? {} : {
		color: n ? a.neutral40 : a.neutral80,
		marginLeft: i.baseUnit / 2,
		marginRight: i.baseUnit / 2
	});
}, ph = {
	ClearIndicator: Nm,
	Control: Vm,
	DropdownIndicator: jm,
	DownChevron: Om,
	CrossIcon: Dm,
	Group: qm,
	GroupHeading: Km,
	IndicatorsContainer: xm,
	IndicatorSeparator: Fm,
	Input: $m,
	LoadingIndicator: zm,
	Menu: om,
	MenuList: cm,
	MenuPortal: hm,
	LoadingMessage: pm,
	NoOptionsMessage: fm,
	MultiValue: sh,
	MultiValueContainer: ih,
	MultiValueLabel: ah,
	MultiValueRemove: oh,
	Option: lh,
	Placeholder: dh,
	SelectContainer: _m,
	SingleValue: function(e) {
		var t = e.children, n = e.isDisabled, r = e.innerProps;
		return nf("div", pu({}, jp(e, "singleValue", {
			"single-value": !0,
			"single-value--is-disabled": n
		}), r), t);
	},
	ValueContainer: ym
}, mh = function(e) {
	return nu(nu({}, ph), e.components);
}, hh = Number.isNaN || function(e) {
	return typeof e == "number" && e !== e;
};
function gh(e, t) {
	return !!(e === t || hh(e) && hh(t));
}
function _h(e, t) {
	if (e.length !== t.length) return !1;
	for (var n = 0; n < e.length; n++) if (!gh(e[n], t[n])) return !1;
	return !0;
}
function vh(e, t) {
	t === void 0 && (t = _h);
	var n = null;
	function r() {
		var r = [...arguments];
		if (n && n.lastThis === this && t(r, n.lastArgs)) return n.lastResult;
		var i = e.apply(this, r);
		return n = {
			lastResult: i,
			lastArgs: r,
			lastThis: this
		}, i;
	}
	return r.clear = function() {
		n = null;
	}, r;
}
for (var yh = {
	name: "7pg0cj-a11yText",
	styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
}, bh = function(e) {
	return nf("span", pu({ css: yh }, e));
}, xh = {
	guidance: function(e) {
		var t = e.isSearchable, n = e.isMulti, r = e.tabSelectsValue, i = e.context, a = e.isInitialFocus;
		switch (i) {
			case "menu": return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${r ? ", press Tab to select the option and exit the menu" : ""}.`;
			case "input": return a ? `${e["aria-label"] || "Select"} is focused ${t ? ",type to refine list" : ""}, press Down to open the menu, ${n ? " press left to focus selected values" : ""}` : "";
			case "value": return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
			default: return "";
		}
	},
	onChange: function(e) {
		var t = e.action, n = e.label, r = n === void 0 ? "" : n, i = e.labels, a = e.isDisabled;
		switch (t) {
			case "deselect-option":
			case "pop-value":
			case "remove-value": return `option ${r}, deselected.`;
			case "clear": return "All selected options have been cleared.";
			case "initial-input-focus": return `option${i.length > 1 ? "s" : ""} ${i.join(",")}, selected.`;
			case "select-option": return a ? `option ${r} is disabled. Select another option.` : `option ${r}, selected.`;
			default: return "";
		}
	},
	onFocus: function(e) {
		var t = e.context, n = e.focused, r = e.options, i = e.label, a = i === void 0 ? "" : i, o = e.selectValue, s = e.isDisabled, c = e.isSelected, l = e.isAppleDevice, u = function(e, t) {
			return e && e.length ? `${e.indexOf(t) + 1} of ${e.length}` : "";
		};
		return t === "value" && o ? `value ${a} focused, ${u(o, n)}.` : t === "menu" && l ? `${a}${`${c ? " selected" : ""}${s ? " disabled" : ""}`}, ${u(r, n)}.` : "";
	},
	onFilter: function(e) {
		var t = e.inputValue;
		return `${e.resultsMessage}${t ? " for search term " + t : ""}.`;
	}
}, Sh = function(e) {
	var t = e.ariaSelection, n = e.focusedOption, i = e.focusedValue, a = e.focusableOptions, o = e.isFocused, s = e.selectValue, c = e.selectProps, l = e.id, u = e.isAppleDevice, d = c.ariaLiveMessages, f = c.getOptionLabel, p = c.inputValue, m = c.isMulti, h = c.isOptionDisabled, _ = c.isSearchable, v = c.menuIsOpen, y = c.options, b = c.screenReaderStatus, x = c.tabSelectsValue, S = c.isLoading, C = c["aria-label"], w = c["aria-live"], T = g(function() {
		return nu(nu({}, xh), d || {});
	}, [d]), E = g(function() {
		var e = "";
		if (t && T.onChange) {
			var n = t.option, r = t.options, i = t.removedValue, a = t.removedValues, o = t.value, c = i || n || function(e) {
				return Array.isArray(e) ? null : e;
			}(o), l = c ? f(c) : "", u = r || a || void 0, d = u ? u.map(f) : [], p = nu({
				isDisabled: c && h(c, s),
				label: l,
				labels: d
			}, t);
			e = T.onChange(p);
		}
		return e;
	}, [
		t,
		T,
		h,
		s,
		f
	]), D = g(function() {
		var e = "", t = n || i, r = !!(n && s && s.includes(n));
		if (t && T.onFocus) {
			var o = {
				focused: t,
				label: f(t),
				isDisabled: h(t, s),
				isSelected: r,
				options: a,
				context: t === n ? "menu" : "value",
				selectValue: s,
				isAppleDevice: u
			};
			e = T.onFocus(o);
		}
		return e;
	}, [
		n,
		i,
		f,
		h,
		T,
		a,
		s,
		u
	]), O = g(function() {
		var e = "";
		if (v && y.length && !S && T.onFilter) {
			var t = b({ count: a.length });
			e = T.onFilter({
				inputValue: p,
				resultsMessage: t
			});
		}
		return e;
	}, [
		a,
		p,
		v,
		T,
		y,
		b,
		S
	]), k = t?.action === "initial-input-focus", A = g(function() {
		var e = "";
		if (T.guidance) {
			var t = i ? "value" : v ? "menu" : "input";
			e = T.guidance({
				"aria-label": C,
				context: t,
				isDisabled: n && h(n, s),
				isMulti: m,
				isSearchable: _,
				tabSelectsValue: x,
				isInitialFocus: k
			});
		}
		return e;
	}, [
		C,
		n,
		i,
		m,
		h,
		_,
		v,
		T,
		s,
		x,
		k
	]), j = nf(r, null, nf("span", { id: "aria-selection" }, E), nf("span", { id: "aria-focused" }, D), nf("span", { id: "aria-results" }, O), nf("span", { id: "aria-guidance" }, A));
	return nf(r, null, nf(bh, { id: l }, k && j), nf(bh, {
		"aria-live": w,
		"aria-atomic": "false",
		"aria-relevant": "additions text",
		role: "log"
	}, o && !k && j));
}, Ch = [
	{
		base: "A",
		letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
	},
	{
		base: "AA",
		letters: "Ꜳ"
	},
	{
		base: "AE",
		letters: "ÆǼǢ"
	},
	{
		base: "AO",
		letters: "Ꜵ"
	},
	{
		base: "AU",
		letters: "Ꜷ"
	},
	{
		base: "AV",
		letters: "ꜸꜺ"
	},
	{
		base: "AY",
		letters: "Ꜽ"
	},
	{
		base: "B",
		letters: "BⒷＢḂḄḆɃƂƁ"
	},
	{
		base: "C",
		letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
	},
	{
		base: "D",
		letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
	},
	{
		base: "DZ",
		letters: "ǱǄ"
	},
	{
		base: "Dz",
		letters: "ǲǅ"
	},
	{
		base: "E",
		letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
	},
	{
		base: "F",
		letters: "FⒻＦḞƑꝻ"
	},
	{
		base: "G",
		letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
	},
	{
		base: "H",
		letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
	},
	{
		base: "I",
		letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
	},
	{
		base: "J",
		letters: "JⒿＪĴɈ"
	},
	{
		base: "K",
		letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
	},
	{
		base: "L",
		letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
	},
	{
		base: "LJ",
		letters: "Ǉ"
	},
	{
		base: "Lj",
		letters: "ǈ"
	},
	{
		base: "M",
		letters: "MⓂＭḾṀṂⱮƜ"
	},
	{
		base: "N",
		letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
	},
	{
		base: "NJ",
		letters: "Ǌ"
	},
	{
		base: "Nj",
		letters: "ǋ"
	},
	{
		base: "O",
		letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
	},
	{
		base: "OI",
		letters: "Ƣ"
	},
	{
		base: "OO",
		letters: "Ꝏ"
	},
	{
		base: "OU",
		letters: "Ȣ"
	},
	{
		base: "P",
		letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
	},
	{
		base: "Q",
		letters: "QⓆＱꝖꝘɊ"
	},
	{
		base: "R",
		letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
	},
	{
		base: "S",
		letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
	},
	{
		base: "T",
		letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
	},
	{
		base: "TZ",
		letters: "Ꜩ"
	},
	{
		base: "U",
		letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
	},
	{
		base: "V",
		letters: "VⓋＶṼṾƲꝞɅ"
	},
	{
		base: "VY",
		letters: "Ꝡ"
	},
	{
		base: "W",
		letters: "WⓌＷẀẂŴẆẄẈⱲ"
	},
	{
		base: "X",
		letters: "XⓍＸẊẌ"
	},
	{
		base: "Y",
		letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
	},
	{
		base: "Z",
		letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
	},
	{
		base: "a",
		letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
	},
	{
		base: "aa",
		letters: "ꜳ"
	},
	{
		base: "ae",
		letters: "æǽǣ"
	},
	{
		base: "ao",
		letters: "ꜵ"
	},
	{
		base: "au",
		letters: "ꜷ"
	},
	{
		base: "av",
		letters: "ꜹꜻ"
	},
	{
		base: "ay",
		letters: "ꜽ"
	},
	{
		base: "b",
		letters: "bⓑｂḃḅḇƀƃɓ"
	},
	{
		base: "c",
		letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
	},
	{
		base: "d",
		letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
	},
	{
		base: "dz",
		letters: "ǳǆ"
	},
	{
		base: "e",
		letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
	},
	{
		base: "f",
		letters: "fⓕｆḟƒꝼ"
	},
	{
		base: "g",
		letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
	},
	{
		base: "h",
		letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
	},
	{
		base: "hv",
		letters: "ƕ"
	},
	{
		base: "i",
		letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
	},
	{
		base: "j",
		letters: "jⓙｊĵǰɉ"
	},
	{
		base: "k",
		letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
	},
	{
		base: "l",
		letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
	},
	{
		base: "lj",
		letters: "ǉ"
	},
	{
		base: "m",
		letters: "mⓜｍḿṁṃɱɯ"
	},
	{
		base: "n",
		letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
	},
	{
		base: "nj",
		letters: "ǌ"
	},
	{
		base: "o",
		letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
	},
	{
		base: "oi",
		letters: "ƣ"
	},
	{
		base: "ou",
		letters: "ȣ"
	},
	{
		base: "oo",
		letters: "ꝏ"
	},
	{
		base: "p",
		letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
	},
	{
		base: "q",
		letters: "qⓠｑɋꝗꝙ"
	},
	{
		base: "r",
		letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
	},
	{
		base: "s",
		letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
	},
	{
		base: "t",
		letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
	},
	{
		base: "tz",
		letters: "ꜩ"
	},
	{
		base: "u",
		letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
	},
	{
		base: "v",
		letters: "vⓥｖṽṿʋꝟʌ"
	},
	{
		base: "vy",
		letters: "ꝡ"
	},
	{
		base: "w",
		letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
	},
	{
		base: "x",
		letters: "xⓧｘẋẍ"
	},
	{
		base: "y",
		letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
	},
	{
		base: "z",
		letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
	}
], wh = RegExp("[" + Ch.map(function(e) {
	return e.letters;
}).join("") + "]", "g"), Th = {}, Eh = 0; Eh < Ch.length; Eh++) for (var Dh = Ch[Eh], Oh = 0; Oh < Dh.letters.length; Oh++) Th[Dh.letters[Oh]] = Dh.base;
var kh = function(e) {
	return e.replace(wh, function(e) {
		return Th[e];
	});
}, Ah = vh(kh), jh = function(e) {
	return e.replace(/^\s+|\s+$/g, "");
}, Mh = function(e) {
	return `${e.label} ${e.value}`;
}, Nh = function(e) {
	return function(t, n) {
		if (t.data.__isNew__) return !0;
		var r = nu({
			ignoreCase: !0,
			ignoreAccents: !0,
			stringify: Mh,
			trim: !0,
			matchFrom: "any"
		}, e), i = r.ignoreCase, a = r.ignoreAccents, o = r.stringify, s = r.trim, c = r.matchFrom, l = s ? jh(n) : n, u = s ? jh(o(t)) : o(t);
		return i && (l = l.toLowerCase(), u = u.toLowerCase()), a && (l = Ah(l), u = kh(u)), c === "start" ? u.substr(0, l.length) === l : u.indexOf(l) > -1;
	};
}, Ph = ["innerRef"];
function Fh(e) {
	var t = e.innerRef, n = Zp(uu(e, Ph), "onExited", "in", "enter", "exit", "appear");
	return nf("input", pu({ ref: t }, n, { css: /*#__PURE__*/ rf({
		label: "dummyInput",
		background: 0,
		border: 0,
		caretColor: "transparent",
		fontSize: "inherit",
		gridArea: "1 / 1 / 2 / 3",
		outline: 0,
		padding: 0,
		width: 1,
		color: "transparent",
		left: -100,
		opacity: 0,
		position: "relative",
		transform: "scale(.01)"
	}, "", "") }));
}
var Ih = function(e) {
	e.cancelable && e.preventDefault(), e.stopPropagation();
};
function Lh(e) {
	var t = e.isEnabled, n = e.onBottomArrive, r = e.onBottomLeave, i = e.onTopArrive, a = e.onTopLeave, o = v(!1), s = v(!1), c = v(0), l = v(null), d = u(function(e, t) {
		if (l.current !== null) {
			var c = l.current, u = c.scrollTop, d = c.scrollHeight, f = c.clientHeight, p = l.current, m = t > 0, h = d - f - u, g = !1;
			h > t && o.current && (r && r(e), o.current = !1), m && s.current && (a && a(e), s.current = !1), m && t > h ? (n && !o.current && n(e), p.scrollTop = d, g = !0, o.current = !0) : !m && -t > u && (i && !s.current && i(e), p.scrollTop = 0, g = !0, s.current = !0), g && Ih(e);
		}
	}, [
		n,
		r,
		i,
		a
	]), f = u(function(e) {
		d(e, e.deltaY);
	}, [d]), m = u(function(e) {
		c.current = e.changedTouches[0].clientY;
	}, []), h = u(function(e) {
		d(e, c.current - e.changedTouches[0].clientY);
	}, [d]), g = u(function(e) {
		if (e) {
			var t = Gp ? { passive: !1 } : !1;
			e.addEventListener("wheel", f, t), e.addEventListener("touchstart", m, t), e.addEventListener("touchmove", h, t);
		}
	}, [
		h,
		m,
		f
	]), _ = u(function(e) {
		e && (e.removeEventListener("wheel", f, !1), e.removeEventListener("touchstart", m, !1), e.removeEventListener("touchmove", h, !1));
	}, [
		h,
		m,
		f
	]);
	return p(function() {
		if (t) {
			var e = l.current;
			return g(e), function() {
				_(e);
			};
		}
	}, [
		t,
		g,
		_
	]), function(e) {
		l.current = e;
	};
}
var Rh = [
	"boxSizing",
	"height",
	"overflow",
	"paddingRight",
	"position"
], zh = {
	boxSizing: "border-box",
	overflow: "hidden",
	position: "relative",
	height: "100%"
};
function Bh(e) {
	e.cancelable && e.preventDefault();
}
function Vh(e) {
	e.stopPropagation();
}
function Hh() {
	var e = this.scrollTop, t = this.scrollHeight, n = e + this.offsetHeight;
	e === 0 ? this.scrollTop = 1 : n === t && (this.scrollTop = e - 1);
}
function Uh() {
	return "ontouchstart" in window || navigator.maxTouchPoints;
}
var Wh = !!(typeof window < "u" && window.document && window.document.createElement), Gh = 0, Kh = {
	capture: !1,
	passive: !1
};
function qh(e) {
	var t = e.isEnabled, n = e.accountForScrollbars, r = n === void 0 ? !0 : n, i = v({}), a = v(null), o = u(function(e) {
		if (Wh) {
			var t = document.body, n = t && t.style;
			if (r && Rh.forEach(function(e) {
				var t = n && n[e];
				i.current[e] = t;
			}), r && Gh < 1) {
				var a = parseInt(i.current.paddingRight, 10) || 0, o = document.body ? document.body.clientWidth : 0, s = window.innerWidth - o + a || 0;
				Object.keys(zh).forEach(function(e) {
					var t = zh[e];
					n && (n[e] = t);
				}), n && (n.paddingRight = `${s}px`);
			}
			t && Uh() && (t.addEventListener("touchmove", Bh, Kh), e && (e.addEventListener("touchstart", Hh, Kh), e.addEventListener("touchmove", Vh, Kh))), Gh += 1;
		}
	}, [r]), s = u(function(e) {
		if (Wh) {
			var t = document.body, n = t && t.style;
			Gh = Math.max(Gh - 1, 0), r && Gh < 1 && Rh.forEach(function(e) {
				var t = i.current[e];
				n && (n[e] = t);
			}), t && Uh() && (t.removeEventListener("touchmove", Bh, Kh), e && (e.removeEventListener("touchstart", Hh, Kh), e.removeEventListener("touchmove", Vh, Kh)));
		}
	}, [r]);
	return p(function() {
		if (t) {
			var e = a.current;
			return o(e), function() {
				s(e);
			};
		}
	}, [
		t,
		o,
		s
	]), function(e) {
		a.current = e;
	};
}
var Jh = function(e) {
	var t = e.target;
	return t.ownerDocument.activeElement && t.ownerDocument.activeElement.blur();
}, Yh = {
	name: "1kfdb0e",
	styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function Xh(e) {
	var t = e.children, n = e.lockEnabled, i = e.captureEnabled, a = i === void 0 ? !0 : i, o = e.onBottomArrive, s = e.onBottomLeave, c = e.onTopArrive, l = e.onTopLeave, u = Lh({
		isEnabled: a,
		onBottomArrive: o,
		onBottomLeave: s,
		onTopArrive: c,
		onTopLeave: l
	}), d = qh({ isEnabled: n });
	return nf(r, null, n && nf("div", {
		onClick: Jh,
		css: Yh
	}), t(function(e) {
		u(e), d(e);
	}));
}
var Zh = {
	name: "1a0ro4n-requiredInput",
	styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
}, Qh = function(e) {
	var t = e.name, n = e.onFocus;
	return nf("input", {
		required: !0,
		name: t,
		tabIndex: -1,
		"aria-hidden": "true",
		onFocus: n,
		css: Zh,
		value: "",
		onChange: function() {}
	});
};
function $h(e) {
	return typeof window < "u" && window.navigator != null ? e.test(window.navigator.userAgentData?.platform || window.navigator.platform) : !1;
}
function eg() {
	return $h(/^iPhone/i);
}
function tg() {
	return $h(/^Mac/i);
}
function ng() {
	return $h(/^iPad/i) || tg() && navigator.maxTouchPoints > 1;
}
function rg() {
	return eg() || ng();
}
function ig() {
	return tg() || rg();
}
var ag = function(e) {
	return e.label;
}, og = function(e) {
	return e.label;
}, sg = function(e) {
	return e.value;
}, cg = function(e) {
	return !!e.isDisabled;
}, lg = {
	clearIndicator: Mm,
	container: gm,
	control: Bm,
	dropdownIndicator: Am,
	group: Um,
	groupHeading: Gm,
	indicatorsContainer: bm,
	indicatorSeparator: Pm,
	input: Ym,
	loadingIndicator: Lm,
	loadingMessage: dm,
	menu: rm,
	menuList: sm,
	menuPortal: mm,
	multiValue: eh,
	multiValueLabel: th,
	multiValueRemove: nh,
	noOptionsMessage: um,
	option: ch,
	placeholder: uh,
	singleValue: fh,
	valueContainer: vm
}, ug = {
	primary: "#2684FF",
	primary75: "#4C9AFF",
	primary50: "#B2D4FF",
	primary25: "#DEEBFF",
	danger: "#DE350B",
	dangerLight: "#FFBDAD",
	neutral0: "hsl(0, 0%, 100%)",
	neutral5: "hsl(0, 0%, 95%)",
	neutral10: "hsl(0, 0%, 90%)",
	neutral20: "hsl(0, 0%, 80%)",
	neutral30: "hsl(0, 0%, 70%)",
	neutral40: "hsl(0, 0%, 60%)",
	neutral50: "hsl(0, 0%, 50%)",
	neutral60: "hsl(0, 0%, 40%)",
	neutral70: "hsl(0, 0%, 30%)",
	neutral80: "hsl(0, 0%, 20%)",
	neutral90: "hsl(0, 0%, 10%)"
}, dg = 4, fg = 4, pg = {
	borderRadius: dg,
	colors: ug,
	spacing: {
		baseUnit: fg,
		controlHeight: 38,
		menuGutter: fg * 2
	}
}, mg = {
	"aria-live": "polite",
	backspaceRemovesValue: !0,
	blurInputOnSelect: Bp(),
	captureMenuScroll: !Bp(),
	classNames: {},
	closeMenuOnSelect: !0,
	closeMenuOnScroll: !1,
	components: {},
	controlShouldRenderValue: !0,
	escapeClearsValue: !1,
	filterOption: Nh(),
	formatGroupLabel: ag,
	getOptionLabel: og,
	getOptionValue: sg,
	isDisabled: !1,
	isLoading: !1,
	isMulti: !1,
	isRtl: !1,
	isSearchable: !0,
	isOptionDisabled: cg,
	loadingMessage: function() {
		return "Loading...";
	},
	maxMenuHeight: 300,
	minMenuHeight: 140,
	menuIsOpen: !1,
	menuPlacement: "bottom",
	menuPosition: "absolute",
	menuShouldBlockScroll: !1,
	menuShouldScrollIntoView: !Vp(),
	noOptionsMessage: function() {
		return "No options";
	},
	openMenuOnFocus: !1,
	openMenuOnClick: !0,
	options: [],
	pageSize: 5,
	placeholder: "Select...",
	screenReaderStatus: function(e) {
		var t = e.count;
		return `${t} result${t === 1 ? "" : "s"} available`;
	},
	styles: {},
	tabIndex: 0,
	tabSelectsValue: !0,
	unstyled: !1
};
function hg(e, t, n, r) {
	return {
		type: "option",
		data: t,
		isDisabled: Eg(e, t, n),
		isSelected: Dg(e, t, n),
		label: wg(e, t),
		value: Tg(e, t),
		index: r
	};
}
function gg(e, t) {
	return e.options.map(function(n, r) {
		if ("options" in n) {
			var i = n.options.map(function(n, r) {
				return hg(e, n, t, r);
			}).filter(function(t) {
				return bg(e, t);
			});
			return i.length > 0 ? {
				type: "group",
				data: n,
				options: i,
				index: r
			} : void 0;
		}
		var a = hg(e, n, t, r);
		return bg(e, a) ? a : void 0;
	}).filter(Kp);
}
function _g(e) {
	return e.reduce(function(e, t) {
		return t.type === "group" ? e.push.apply(e, yu(t.options.map(function(e) {
			return e.data;
		}))) : e.push(t.data), e;
	}, []);
}
function vg(e, t) {
	return e.reduce(function(e, n) {
		return n.type === "group" ? e.push.apply(e, yu(n.options.map(function(e) {
			return {
				data: e.data,
				id: `${t}-${n.index}-${e.index}`
			};
		}))) : e.push({
			data: n.data,
			id: `${t}-${n.index}`
		}), e;
	}, []);
}
function yg(e, t) {
	return _g(gg(e, t));
}
function bg(e, t) {
	var n = e.inputValue, r = n === void 0 ? "" : n, i = t.data, a = t.isSelected, o = t.label, s = t.value;
	return (!kg(e) || !a) && Og(e, {
		label: o,
		value: s,
		data: i
	}, r);
}
function xg(e, t) {
	var n = e.focusedValue, r = e.selectValue.indexOf(n);
	if (r > -1) {
		if (t.indexOf(n) > -1) return n;
		if (r < t.length) return t[r];
	}
	return null;
}
function Sg(e, t) {
	var n = e.focusedOption;
	return n && t.indexOf(n) > -1 ? n : t[0];
}
var Cg = function(e, t) {
	return e.find(function(e) {
		return e.data === t;
	})?.id || null;
}, wg = function(e, t) {
	return e.getOptionLabel(t);
}, Tg = function(e, t) {
	return e.getOptionValue(t);
};
function Eg(e, t, n) {
	return typeof e.isOptionDisabled == "function" ? e.isOptionDisabled(t, n) : !1;
}
function Dg(e, t, n) {
	if (n.indexOf(t) > -1) return !0;
	if (typeof e.isOptionSelected == "function") return e.isOptionSelected(t, n);
	var r = Tg(e, t);
	return n.some(function(t) {
		return Tg(e, t) === r;
	});
}
function Og(e, t, n) {
	return e.filterOption ? e.filterOption(t, n) : !0;
}
var kg = function(e) {
	var t = e.hideSelectedOptions, n = e.isMulti;
	return t === void 0 ? n : t;
}, Ag = 1, jg = /*#__PURE__*/ function(t) {
	Eee(r, t);
	var n = kee(r);
	function r(e) {
		var t;
		if (mu(this, r), t = n.call(this, e), t.state = {
			ariaSelection: null,
			focusedOption: null,
			focusedOptionId: null,
			focusableOptionsWithIds: [],
			focusedValue: null,
			inputIsHidden: !1,
			isFocused: !1,
			selectValue: [],
			clearFocusValueOnUpdate: !1,
			prevWasFocused: !1,
			inputIsHiddenAfterUpdate: void 0,
			prevProps: void 0,
			instancePrefix: "",
			isAppleDevice: !1
		}, t.blockOptionHover = !1, t.isComposing = !1, t.commonProps = void 0, t.initialTouchX = 0, t.initialTouchY = 0, t.openAfterFocus = !1, t.scrollToFocusedOptionOnUpdate = !1, t.userIsDragging = void 0, t.controlRef = null, t.getControlRef = function(e) {
			t.controlRef = e;
		}, t.focusedOptionRef = null, t.getFocusedOptionRef = function(e) {
			t.focusedOptionRef = e;
		}, t.menuListRef = null, t.getMenuListRef = function(e) {
			t.menuListRef = e;
		}, t.inputRef = null, t.getInputRef = function(e) {
			t.inputRef = e;
		}, t.focus = t.focusInput, t.blur = t.blurInput, t.onChange = function(e, n) {
			var r = t.props, i = r.onChange;
			n.name = r.name, t.ariaOnChange(e, n), i(e, n);
		}, t.setValue = function(e, n, r) {
			var i = t.props, a = i.closeMenuOnSelect, o = i.isMulti, s = i.inputValue;
			t.onInputChange("", {
				action: "set-value",
				prevInputValue: s
			}), a && (t.setState({ inputIsHiddenAfterUpdate: !o }), t.onMenuClose()), t.setState({ clearFocusValueOnUpdate: !0 }), t.onChange(e, {
				action: n,
				option: r
			});
		}, t.selectOption = function(e) {
			var n = t.props, r = n.blurInputOnSelect, i = n.isMulti, a = n.name, o = t.state.selectValue, s = i && t.isOptionSelected(e, o), c = t.isOptionDisabled(e, o);
			if (s) {
				var l = t.getOptionValue(e);
				t.setValue(Xp(o.filter(function(e) {
					return t.getOptionValue(e) !== l;
				})), "deselect-option", e);
			} else if (!c) i ? t.setValue(Xp([].concat(yu(o), [e])), "select-option", e) : t.setValue(Yp(e), "select-option");
			else {
				t.ariaOnChange(Yp(e), {
					action: "select-option",
					option: e,
					name: a
				});
				return;
			}
			r && t.blurInput();
		}, t.removeValue = function(e) {
			var n = t.props.isMulti, r = t.state.selectValue, i = t.getOptionValue(e), a = r.filter(function(e) {
				return t.getOptionValue(e) !== i;
			}), o = Jp(n, a, a[0] || null);
			t.onChange(o, {
				action: "remove-value",
				removedValue: e
			}), t.focusInput();
		}, t.clearValue = function() {
			var e = t.state.selectValue;
			t.onChange(Jp(t.props.isMulti, [], null), {
				action: "clear",
				removedValues: e
			});
		}, t.popValue = function() {
			var e = t.props.isMulti, n = t.state.selectValue, r = n[n.length - 1], i = n.slice(0, n.length - 1), a = Jp(e, i, i[0] || null);
			r && t.onChange(a, {
				action: "pop-value",
				removedValue: r
			});
		}, t.getFocusedOptionId = function(e) {
			return Cg(t.state.focusableOptionsWithIds, e);
		}, t.getFocusableOptionsWithIds = function() {
			return vg(gg(t.props, t.state.selectValue), t.getElementId("option"));
		}, t.getValue = function() {
			return t.state.selectValue;
		}, t.cx = function() {
			var e = [...arguments];
			return bte.apply(void 0, [t.props.classNamePrefix].concat(e));
		}, t.getOptionLabel = function(e) {
			return wg(t.props, e);
		}, t.getOptionValue = function(e) {
			return Tg(t.props, e);
		}, t.getStyles = function(e, n) {
			var r = t.props.unstyled, i = lg[e](n, r);
			i.boxSizing = "border-box";
			var a = t.props.styles[e];
			return a ? a(i, n) : i;
		}, t.getClassNames = function(e, n) {
			var r;
			return (r = t.props.classNames)[e]?.call(r, n);
		}, t.getElementId = function(e) {
			return `${t.state.instancePrefix}-${e}`;
		}, t.getComponents = function() {
			return mh(t.props);
		}, t.buildCategorizedOptions = function() {
			return gg(t.props, t.state.selectValue);
		}, t.getCategorizedOptions = function() {
			return t.props.menuIsOpen ? t.buildCategorizedOptions() : [];
		}, t.buildFocusableOptions = function() {
			return _g(t.buildCategorizedOptions());
		}, t.getFocusableOptions = function() {
			return t.props.menuIsOpen ? t.buildFocusableOptions() : [];
		}, t.ariaOnChange = function(e, n) {
			t.setState({ ariaSelection: nu({ value: e }, n) });
		}, t.onMenuMouseDown = function(e) {
			e.button === 0 && (e.stopPropagation(), e.preventDefault(), t.focusInput());
		}, t.onMenuMouseMove = function(e) {
			t.blockOptionHover = !1;
		}, t.onControlMouseDown = function(e) {
			if (!e.defaultPrevented) {
				var n = t.props.openMenuOnClick;
				t.state.isFocused ? t.props.menuIsOpen ? e.target.tagName !== "INPUT" && e.target.tagName !== "TEXTAREA" && t.onMenuClose() : n && t.openMenu("first") : (n && (t.openAfterFocus = !0), t.focusInput()), e.target.tagName !== "INPUT" && e.target.tagName !== "TEXTAREA" && e.preventDefault();
			}
		}, t.onDropdownIndicatorMouseDown = function(e) {
			if (!(e && e.type === "mousedown" && e.button !== 0) && !t.props.isDisabled) {
				var n = t.props, r = n.isMulti, i = n.menuIsOpen;
				t.focusInput(), i ? (t.setState({ inputIsHiddenAfterUpdate: !r }), t.onMenuClose()) : t.openMenu("first"), e.preventDefault();
			}
		}, t.onClearIndicatorMouseDown = function(e) {
			e && e.type === "mousedown" && e.button !== 0 || (t.clearValue(), e.preventDefault(), t.openAfterFocus = !1, e.type === "touchend" ? t.focusInput() : setTimeout(function() {
				return t.focusInput();
			}));
		}, t.onScroll = function(e) {
			typeof t.props.closeMenuOnScroll == "boolean" ? e.target instanceof HTMLElement && Mp(e.target) && t.props.onMenuClose() : typeof t.props.closeMenuOnScroll == "function" && t.props.closeMenuOnScroll(e) && t.props.onMenuClose();
		}, t.onCompositionStart = function() {
			t.isComposing = !0;
		}, t.onCompositionEnd = function() {
			t.isComposing = !1;
		}, t.onTouchStart = function(e) {
			var n = e.touches, r = n && n.item(0);
			r && (t.initialTouchX = r.clientX, t.initialTouchY = r.clientY, t.userIsDragging = !1);
		}, t.onTouchMove = function(e) {
			var n = e.touches, r = n && n.item(0);
			if (r) {
				var i = Math.abs(r.clientX - t.initialTouchX), a = Math.abs(r.clientY - t.initialTouchY), o = 5;
				t.userIsDragging = i > o || a > o;
			}
		}, t.onTouchEnd = function(e) {
			t.userIsDragging || (t.controlRef && !t.controlRef.contains(e.target) && t.menuListRef && !t.menuListRef.contains(e.target) && t.blurInput(), t.initialTouchX = 0, t.initialTouchY = 0);
		}, t.onControlTouchEnd = function(e) {
			t.userIsDragging || t.onControlMouseDown(e);
		}, t.onClearIndicatorTouchEnd = function(e) {
			t.userIsDragging || t.onClearIndicatorMouseDown(e);
		}, t.onDropdownIndicatorTouchEnd = function(e) {
			t.userIsDragging || t.onDropdownIndicatorMouseDown(e);
		}, t.handleInputChange = function(e) {
			var n = t.props.inputValue, r = e.currentTarget.value;
			t.setState({ inputIsHiddenAfterUpdate: !1 }), t.onInputChange(r, {
				action: "input-change",
				prevInputValue: n
			}), t.props.menuIsOpen || t.onMenuOpen();
		}, t.onInputFocus = function(e) {
			t.props.onFocus && t.props.onFocus(e), t.setState({
				inputIsHiddenAfterUpdate: !1,
				isFocused: !0
			}), (t.openAfterFocus || t.props.openMenuOnFocus) && t.openMenu("first"), t.openAfterFocus = !1;
		}, t.onInputBlur = function(e) {
			var n = t.props.inputValue;
			if (t.menuListRef && t.menuListRef.contains(document.activeElement)) {
				t.inputRef.focus();
				return;
			}
			t.props.onBlur && t.props.onBlur(e), t.onInputChange("", {
				action: "input-blur",
				prevInputValue: n
			}), t.onMenuClose(), t.setState({
				focusedValue: null,
				isFocused: !1
			});
		}, t.onOptionHover = function(e) {
			if (!(t.blockOptionHover || t.state.focusedOption === e)) {
				var n = t.getFocusableOptions().indexOf(e);
				t.setState({
					focusedOption: e,
					focusedOptionId: n > -1 ? t.getFocusedOptionId(e) : null
				});
			}
		}, t.shouldHideSelectedOptions = function() {
			return kg(t.props);
		}, t.onValueInputFocus = function(e) {
			e.preventDefault(), e.stopPropagation(), t.focus();
		}, t.onKeyDown = function(e) {
			var n = t.props, r = n.isMulti, i = n.backspaceRemovesValue, a = n.escapeClearsValue, o = n.inputValue, s = n.isClearable, c = n.isDisabled, l = n.menuIsOpen, u = n.onKeyDown, d = n.tabSelectsValue, f = n.openMenuOnFocus, p = t.state, m = p.focusedOption, h = p.focusedValue, g = p.selectValue;
			if (!c && !(typeof u == "function" && (u(e), e.defaultPrevented))) {
				switch (t.blockOptionHover = !0, e.key) {
					case "ArrowLeft":
						if (!r || o) return;
						t.focusValue("previous");
						break;
					case "ArrowRight":
						if (!r || o) return;
						t.focusValue("next");
						break;
					case "Delete":
					case "Backspace":
						if (o) return;
						if (h) t.removeValue(h);
						else {
							if (!i) return;
							r ? t.popValue() : s && t.clearValue();
						}
						break;
					case "Tab":
						if (t.isComposing || e.shiftKey || !l || !d || !m || f && t.isOptionSelected(m, g)) return;
						t.selectOption(m);
						break;
					case "Enter":
						if (e.keyCode === 229) break;
						if (l) {
							if (!m || t.isComposing) return;
							t.selectOption(m);
							break;
						}
						return;
					case "Escape":
						l ? (t.setState({ inputIsHiddenAfterUpdate: !1 }), t.onInputChange("", {
							action: "menu-close",
							prevInputValue: o
						}), t.onMenuClose()) : s && a && t.clearValue();
						break;
					case " ":
						if (o) return;
						if (!l) {
							t.openMenu("first");
							break;
						}
						if (!m) return;
						t.selectOption(m);
						break;
					case "ArrowUp":
						l ? t.focusOption("up") : t.openMenu("last");
						break;
					case "ArrowDown":
						l ? t.focusOption("down") : t.openMenu("first");
						break;
					case "PageUp":
						if (!l) return;
						t.focusOption("pageup");
						break;
					case "PageDown":
						if (!l) return;
						t.focusOption("pagedown");
						break;
					case "Home":
						if (!l) return;
						t.focusOption("first");
						break;
					case "End":
						if (!l) return;
						t.focusOption("last");
						break;
					default: return;
				}
				e.preventDefault();
			}
		}, t.state.instancePrefix = "react-select-" + (t.props.instanceId || ++Ag), t.state.selectValue = kp(e.value), e.menuIsOpen && t.state.selectValue.length) {
			var i = t.getFocusableOptionsWithIds(), a = t.buildFocusableOptions(), o = a.indexOf(t.state.selectValue[0]);
			t.state.focusableOptionsWithIds = i, t.state.focusedOption = a[o], t.state.focusedOptionId = Cg(i, a[o]);
		}
		return t;
	}
	return Tee(r, [
		{
			key: "componentDidMount",
			value: function() {
				this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && Rp(this.menuListRef, this.focusedOptionRef), ig() && this.setState({ isAppleDevice: !0 });
			}
		},
		{
			key: "componentDidUpdate",
			value: function(e) {
				var t = this.props, n = t.isDisabled, r = t.menuIsOpen, i = this.state.isFocused;
				(i && !n && e.isDisabled || i && r && !e.menuIsOpen) && this.focusInput(), i && n && !e.isDisabled ? this.setState({ isFocused: !1 }, this.onMenuClose) : !i && !n && e.isDisabled && this.inputRef === document.activeElement && this.setState({ isFocused: !0 }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (Rp(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
			}
		},
		{
			key: "componentWillUnmount",
			value: function() {
				this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
			}
		},
		{
			key: "onMenuOpen",
			value: function() {
				this.props.onMenuOpen();
			}
		},
		{
			key: "onMenuClose",
			value: function() {
				this.onInputChange("", {
					action: "menu-close",
					prevInputValue: this.props.inputValue
				}), this.props.onMenuClose();
			}
		},
		{
			key: "onInputChange",
			value: function(e, t) {
				this.props.onInputChange(e, t);
			}
		},
		{
			key: "focusInput",
			value: function() {
				this.inputRef && this.inputRef.focus();
			}
		},
		{
			key: "blurInput",
			value: function() {
				this.inputRef && this.inputRef.blur();
			}
		},
		{
			key: "openMenu",
			value: function(e) {
				var t = this, n = this.state, r = n.selectValue, i = n.isFocused, a = this.buildFocusableOptions(), o = e === "first" ? 0 : a.length - 1;
				if (!this.props.isMulti) {
					var s = a.indexOf(r[0]);
					s > -1 && (o = s);
				}
				this.scrollToFocusedOptionOnUpdate = !(i && this.menuListRef), this.setState({
					inputIsHiddenAfterUpdate: !1,
					focusedValue: null,
					focusedOption: a[o],
					focusedOptionId: this.getFocusedOptionId(a[o])
				}, function() {
					return t.onMenuOpen();
				});
			}
		},
		{
			key: "focusValue",
			value: function(e) {
				var t = this.state, n = t.selectValue, r = t.focusedValue;
				if (this.props.isMulti) {
					this.setState({ focusedOption: null });
					var i = n.indexOf(r);
					r || (i = -1);
					var a = n.length - 1, o = -1;
					if (n.length) {
						switch (e) {
							case "previous":
								o = i === 0 ? 0 : i === -1 ? a : i - 1;
								break;
							case "next":
								i > -1 && i < a && (o = i + 1);
								break;
						}
						this.setState({
							inputIsHidden: o !== -1,
							focusedValue: n[o]
						});
					}
				}
			}
		},
		{
			key: "focusOption",
			value: function() {
				var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", t = this.props.pageSize, n = this.state.focusedOption, r = this.getFocusableOptions();
				if (r.length) {
					var i = 0, a = r.indexOf(n);
					n || (a = -1), e === "up" ? i = a > 0 ? a - 1 : r.length - 1 : e === "down" ? i = (a + 1) % r.length : e === "pageup" ? (i = a - t, i < 0 && (i = 0)) : e === "pagedown" ? (i = a + t, i > r.length - 1 && (i = r.length - 1)) : e === "last" && (i = r.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
						focusedOption: r[i],
						focusedValue: null,
						focusedOptionId: this.getFocusedOptionId(r[i])
					});
				}
			}
		},
		{
			key: "getTheme",
			value: function() {
				return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(pg) : nu(nu({}, pg), this.props.theme) : pg;
			}
		},
		{
			key: "getCommonProps",
			value: function() {
				var e = this.clearValue, t = this.cx, n = this.getStyles, r = this.getClassNames, i = this.getValue, a = this.selectOption, o = this.setValue, s = this.props, c = s.isMulti, l = s.isRtl, u = s.options;
				return {
					clearValue: e,
					cx: t,
					getStyles: n,
					getClassNames: r,
					getValue: i,
					hasValue: this.hasValue(),
					isMulti: c,
					isRtl: l,
					options: u,
					selectOption: a,
					selectProps: s,
					setValue: o,
					theme: this.getTheme()
				};
			}
		},
		{
			key: "hasValue",
			value: function() {
				return this.state.selectValue.length > 0;
			}
		},
		{
			key: "hasOptions",
			value: function() {
				return !!this.getFocusableOptions().length;
			}
		},
		{
			key: "isClearable",
			value: function() {
				var e = this.props, t = e.isClearable, n = e.isMulti;
				return t === void 0 ? n : t;
			}
		},
		{
			key: "isOptionDisabled",
			value: function(e, t) {
				return Eg(this.props, e, t);
			}
		},
		{
			key: "isOptionSelected",
			value: function(e, t) {
				return Dg(this.props, e, t);
			}
		},
		{
			key: "filterOption",
			value: function(e, t) {
				return Og(this.props, e, t);
			}
		},
		{
			key: "formatOptionLabel",
			value: function(e, t) {
				if (typeof this.props.formatOptionLabel == "function") {
					var n = this.props.inputValue, r = this.state.selectValue;
					return this.props.formatOptionLabel(e, {
						context: t,
						inputValue: n,
						selectValue: r
					});
				} else return this.getOptionLabel(e);
			}
		},
		{
			key: "formatGroupLabel",
			value: function(e) {
				return this.props.formatGroupLabel(e);
			}
		},
		{
			key: "startListeningComposition",
			value: function() {
				document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
			}
		},
		{
			key: "stopListeningComposition",
			value: function() {
				document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
			}
		},
		{
			key: "startListeningToTouch",
			value: function() {
				document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
			}
		},
		{
			key: "stopListeningToTouch",
			value: function() {
				document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
			}
		},
		{
			key: "renderInput",
			value: function() {
				var t = this.props, n = t.isDisabled, r = t.isSearchable, i = t.inputId, a = t.inputValue, o = t.tabIndex, s = t.form, c = t.menuIsOpen, l = t.required, u = this.getComponents().Input, d = this.state, f = d.inputIsHidden, p = d.ariaSelection, m = this.commonProps, h = i || this.getElementId("input"), g = nu(nu(nu({
					"aria-autocomplete": "list",
					"aria-expanded": c,
					"aria-haspopup": !0,
					"aria-errormessage": this.props["aria-errormessage"],
					"aria-invalid": this.props["aria-invalid"],
					"aria-label": this.props["aria-label"],
					"aria-labelledby": this.props["aria-labelledby"],
					"aria-required": l,
					role: "combobox",
					"aria-activedescendant": this.state.isAppleDevice ? void 0 : this.state.focusedOptionId || ""
				}, c && { "aria-controls": this.getElementId("listbox") }), !r && { "aria-readonly": !0 }), this.hasValue() ? p?.action === "initial-input-focus" && { "aria-describedby": this.getElementId("live-region") } : { "aria-describedby": this.getElementId("placeholder") });
				return r ? /*#__PURE__*/ e.createElement(u, pu({}, m, {
					autoCapitalize: "none",
					autoComplete: "off",
					autoCorrect: "off",
					id: h,
					innerRef: this.getInputRef,
					isDisabled: n,
					isHidden: f,
					onBlur: this.onInputBlur,
					onChange: this.handleInputChange,
					onFocus: this.onInputFocus,
					spellCheck: "false",
					tabIndex: o,
					form: s,
					type: "text",
					value: a
				}, g)) : /*#__PURE__*/ e.createElement(Fh, pu({
					id: h,
					innerRef: this.getInputRef,
					onBlur: this.onInputBlur,
					onChange: Op,
					onFocus: this.onInputFocus,
					disabled: n,
					tabIndex: o,
					inputMode: "none",
					form: s,
					value: ""
				}, g));
			}
		},
		{
			key: "renderPlaceholderOrValue",
			value: function() {
				var t = this, n = this.getComponents(), r = n.MultiValue, i = n.MultiValueContainer, a = n.MultiValueLabel, o = n.MultiValueRemove, s = n.SingleValue, c = n.Placeholder, l = this.commonProps, u = this.props, d = u.controlShouldRenderValue, f = u.isDisabled, p = u.isMulti, m = u.inputValue, h = u.placeholder, g = this.state, _ = g.selectValue, v = g.focusedValue, y = g.isFocused;
				if (!this.hasValue() || !d) return m ? null : /*#__PURE__*/ e.createElement(c, pu({}, l, {
					key: "placeholder",
					isDisabled: f,
					isFocused: y,
					innerProps: { id: this.getElementId("placeholder") }
				}), h);
				if (p) return _.map(function(n, s) {
					var c = n === v, u = `${t.getOptionLabel(n)}-${t.getOptionValue(n)}`;
					return /*#__PURE__*/ e.createElement(r, pu({}, l, {
						components: {
							Container: i,
							Label: a,
							Remove: o
						},
						isFocused: c,
						isDisabled: f,
						key: u,
						index: s,
						removeProps: {
							onClick: function() {
								return t.removeValue(n);
							},
							onTouchEnd: function() {
								return t.removeValue(n);
							},
							onMouseDown: function(e) {
								e.preventDefault();
							}
						},
						data: n
					}), t.formatOptionLabel(n, "value"));
				});
				if (m) return null;
				var b = _[0];
				return /*#__PURE__*/ e.createElement(s, pu({}, l, {
					data: b,
					isDisabled: f
				}), this.formatOptionLabel(b, "value"));
			}
		},
		{
			key: "renderClearIndicator",
			value: function() {
				var t = this.getComponents().ClearIndicator, n = this.commonProps, r = this.props, i = r.isDisabled, a = r.isLoading, o = this.state.isFocused;
				if (!this.isClearable() || !t || i || !this.hasValue() || a) return null;
				var s = {
					onMouseDown: this.onClearIndicatorMouseDown,
					onTouchEnd: this.onClearIndicatorTouchEnd,
					"aria-hidden": "true"
				};
				return /*#__PURE__*/ e.createElement(t, pu({}, n, {
					innerProps: s,
					isFocused: o
				}));
			}
		},
		{
			key: "renderLoadingIndicator",
			value: function() {
				var t = this.getComponents().LoadingIndicator, n = this.commonProps, r = this.props, i = r.isDisabled, a = r.isLoading, o = this.state.isFocused;
				return !t || !a ? null : /*#__PURE__*/ e.createElement(t, pu({}, n, {
					innerProps: { "aria-hidden": "true" },
					isDisabled: i,
					isFocused: o
				}));
			}
		},
		{
			key: "renderIndicatorSeparator",
			value: function() {
				var t = this.getComponents(), n = t.DropdownIndicator, r = t.IndicatorSeparator;
				if (!n || !r) return null;
				var i = this.commonProps, a = this.props.isDisabled, o = this.state.isFocused;
				return /*#__PURE__*/ e.createElement(r, pu({}, i, {
					isDisabled: a,
					isFocused: o
				}));
			}
		},
		{
			key: "renderDropdownIndicator",
			value: function() {
				var t = this.getComponents().DropdownIndicator;
				if (!t) return null;
				var n = this.commonProps, r = this.props.isDisabled, i = this.state.isFocused, a = {
					onMouseDown: this.onDropdownIndicatorMouseDown,
					onTouchEnd: this.onDropdownIndicatorTouchEnd,
					"aria-hidden": "true"
				};
				return /*#__PURE__*/ e.createElement(t, pu({}, n, {
					innerProps: a,
					isDisabled: r,
					isFocused: i
				}));
			}
		},
		{
			key: "renderMenu",
			value: function() {
				var t = this, n = this.getComponents(), r = n.Group, i = n.GroupHeading, a = n.Menu, o = n.MenuList, s = n.MenuPortal, c = n.LoadingMessage, l = n.NoOptionsMessage, u = n.Option, d = this.commonProps, f = this.state.focusedOption, p = this.props, m = p.captureMenuScroll, h = p.inputValue, g = p.isLoading, _ = p.loadingMessage, v = p.minMenuHeight, y = p.maxMenuHeight, b = p.menuIsOpen, x = p.menuPlacement, S = p.menuPosition, C = p.menuPortalTarget, w = p.menuShouldBlockScroll, T = p.menuShouldScrollIntoView, E = p.noOptionsMessage, D = p.onMenuScrollToTop, O = p.onMenuScrollToBottom;
				if (!b) return null;
				var k = function(n, r) {
					var i = n.type, a = n.data, o = n.isDisabled, s = n.isSelected, c = n.label, l = n.value, p = f === a, m = o ? void 0 : function() {
						return t.onOptionHover(a);
					}, h = o ? void 0 : function() {
						return t.selectOption(a);
					}, g = `${t.getElementId("option")}-${r}`, _ = {
						id: g,
						onClick: h,
						onMouseMove: m,
						onMouseOver: m,
						tabIndex: -1,
						role: "option",
						"aria-selected": t.state.isAppleDevice ? void 0 : s
					};
					return /*#__PURE__*/ e.createElement(u, pu({}, d, {
						innerProps: _,
						data: a,
						isDisabled: o,
						isSelected: s,
						key: g,
						label: c,
						type: i,
						value: l,
						isFocused: p,
						innerRef: p ? t.getFocusedOptionRef : void 0
					}), t.formatOptionLabel(n.data, "menu"));
				}, A;
				if (this.hasOptions()) A = this.getCategorizedOptions().map(function(n) {
					if (n.type === "group") {
						var a = n.data, o = n.options, s = n.index, c = `${t.getElementId("group")}-${s}`, l = `${c}-heading`;
						return /*#__PURE__*/ e.createElement(r, pu({}, d, {
							key: c,
							data: a,
							options: o,
							Heading: i,
							headingProps: {
								id: l,
								data: n.data
							},
							label: t.formatGroupLabel(n.data)
						}), n.options.map(function(e) {
							return k(e, `${s}-${e.index}`);
						}));
					} else if (n.type === "option") return k(n, `${n.index}`);
				});
				else if (g) {
					var j = _({ inputValue: h });
					if (j === null) return null;
					A = /*#__PURE__*/ e.createElement(c, d, j);
				} else {
					var M = E({ inputValue: h });
					if (M === null) return null;
					A = /*#__PURE__*/ e.createElement(l, d, M);
				}
				var ee = {
					minMenuHeight: v,
					maxMenuHeight: y,
					menuPlacement: x,
					menuPosition: S,
					menuShouldScrollIntoView: T
				}, te = /*#__PURE__*/ e.createElement(am, pu({}, d, ee), function(n) {
					var r = n.ref, i = n.placerProps, s = i.placement, c = i.maxHeight;
					return /*#__PURE__*/ e.createElement(a, pu({}, d, ee, {
						innerRef: r,
						innerProps: {
							onMouseDown: t.onMenuMouseDown,
							onMouseMove: t.onMenuMouseMove
						},
						isLoading: g,
						placement: s
					}), /*#__PURE__*/ e.createElement(Xh, {
						captureEnabled: m,
						onTopArrive: D,
						onBottomArrive: O,
						lockEnabled: w
					}, function(n) {
						return /*#__PURE__*/ e.createElement(o, pu({}, d, {
							innerRef: function(e) {
								t.getMenuListRef(e), n(e);
							},
							innerProps: {
								role: "listbox",
								"aria-multiselectable": d.isMulti,
								id: t.getElementId("listbox")
							},
							isLoading: g,
							maxHeight: c,
							focusedOption: f
						}), A);
					}));
				});
				return C || S === "fixed" ? /*#__PURE__*/ e.createElement(s, pu({}, d, {
					appendTo: C,
					controlElement: this.controlRef,
					menuPlacement: x,
					menuPosition: S
				}), te) : te;
			}
		},
		{
			key: "renderFormField",
			value: function() {
				var t = this, n = this.props, r = n.delimiter, i = n.isDisabled, a = n.isMulti, o = n.name, s = n.required, c = this.state.selectValue;
				if (s && !this.hasValue() && !i) return /*#__PURE__*/ e.createElement(Qh, {
					name: o,
					onFocus: this.onValueInputFocus
				});
				if (!(!o || i)) if (a) if (r) {
					var l = c.map(function(e) {
						return t.getOptionValue(e);
					}).join(r);
					return /*#__PURE__*/ e.createElement("input", {
						name: o,
						type: "hidden",
						value: l
					});
				} else {
					var u = c.length > 0 ? c.map(function(n, r) {
						return /*#__PURE__*/ e.createElement("input", {
							key: `i-${r}`,
							name: o,
							type: "hidden",
							value: t.getOptionValue(n)
						});
					}) : /*#__PURE__*/ e.createElement("input", {
						name: o,
						type: "hidden",
						value: ""
					});
					return /*#__PURE__*/ e.createElement("div", null, u);
				}
				else {
					var d = c[0] ? this.getOptionValue(c[0]) : "";
					return /*#__PURE__*/ e.createElement("input", {
						name: o,
						type: "hidden",
						value: d
					});
				}
			}
		},
		{
			key: "renderLiveRegion",
			value: function() {
				var t = this.commonProps, n = this.state, r = n.ariaSelection, i = n.focusedOption, a = n.focusedValue, o = n.isFocused, s = n.selectValue, c = this.getFocusableOptions();
				return /*#__PURE__*/ e.createElement(Sh, pu({}, t, {
					id: this.getElementId("live-region"),
					ariaSelection: r,
					focusedOption: i,
					focusedValue: a,
					isFocused: o,
					selectValue: s,
					focusableOptions: c,
					isAppleDevice: this.state.isAppleDevice
				}));
			}
		},
		{
			key: "render",
			value: function() {
				var t = this.getComponents(), n = t.Control, r = t.IndicatorsContainer, i = t.SelectContainer, a = t.ValueContainer, o = this.props, s = o.className, c = o.id, l = o.isDisabled, u = o.menuIsOpen, d = this.state.isFocused, f = this.commonProps = this.getCommonProps();
				return /*#__PURE__*/ e.createElement(i, pu({}, f, {
					className: s,
					innerProps: {
						id: c,
						onKeyDown: this.onKeyDown
					},
					isDisabled: l,
					isFocused: d
				}), this.renderLiveRegion(), /*#__PURE__*/ e.createElement(n, pu({}, f, {
					innerRef: this.getControlRef,
					innerProps: {
						onMouseDown: this.onControlMouseDown,
						onTouchEnd: this.onControlTouchEnd
					},
					isDisabled: l,
					isFocused: d,
					menuIsOpen: u
				}), /*#__PURE__*/ e.createElement(a, pu({}, f, { isDisabled: l }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ e.createElement(r, pu({}, f, { isDisabled: l }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
			}
		}
	], [{
		key: "getDerivedStateFromProps",
		value: function(e, t) {
			var n = t.prevProps, r = t.clearFocusValueOnUpdate, i = t.inputIsHiddenAfterUpdate, a = t.ariaSelection, o = t.isFocused, s = t.prevWasFocused, c = t.instancePrefix, l = e.options, u = e.value, d = e.menuIsOpen, f = e.inputValue, p = e.isMulti, m = kp(u), h = {};
			if (n && (u !== n.value || l !== n.options || d !== n.menuIsOpen || f !== n.inputValue)) {
				var g = d ? yg(e, m) : [], _ = d ? vg(gg(e, m), `${c}-option`) : [], v = r ? xg(t, m) : null, y = Sg(t, g);
				h = {
					selectValue: m,
					focusedOption: y,
					focusedOptionId: Cg(_, y),
					focusableOptionsWithIds: _,
					focusedValue: v,
					clearFocusValueOnUpdate: !1
				};
			}
			var b = i != null && e !== n ? {
				inputIsHidden: i,
				inputIsHiddenAfterUpdate: void 0
			} : {}, x = a, S = o && s;
			return o && !S && (x = {
				value: Jp(p, m, m[0] || null),
				options: m,
				action: "initial-input-focus"
			}, S = !s), a?.action === "initial-input-focus" && (x = null), nu(nu(nu({}, h), b), {}, {
				prevProps: e,
				ariaSelection: x,
				prevWasFocused: S
			});
		}
	}]), r;
}(n);
jg.defaultProps = mg;
//#endregion
//#region ../../node_modules/react-select/dist/react-select.esm.js
var Mg = /* @__PURE__ */ c(function(t, n) {
	var r = fu(t);
	return /*#__PURE__*/ e.createElement(jg, pu({ ref: n }, r));
}), Ng = "react-select", Pg = "i1aj7qrw";
//#endregion
//#region src/input-ui/select/select-option.tsx
function Fg({ children: e, className: t, ...n }) {
	return /* @__PURE__ */ I(ph.Option, {
		className: Ct(t, ae, ie, Ge, ee, re),
		...n,
		children: [e, n.isSelected && /* @__PURE__ */ F(We, {
			size: "md",
			className: "c1gmn2wl"
		})]
	});
}
//#endregion
//#region src/input-ui/select/select-config.tsx
function Ig(e) {
	return {
		control: (t, n) => ({
			...t,
			borderColor: e ? "var(--red-500, #F01830)" : n.isFocused ? "#4e56ea" : "#D8DEE4",
			backgroundColor: e ? "var(--red-100, #FCD9DD)" : n.isDisabled ? "#E5E9ED" : "#FFFFFF",
			borderWidth: "1px",
			borderStyle: "solid",
			boxShadow: "none",
			borderRadius: "2px"
		}),
		placeholder: (e) => ({
			...e,
			color: "#9FAEBC",
			fontSize: "13px",
			fontWeight: "400",
			lineHeight: "1rem"
		}),
		singleValue: (e, t) => ({
			...e,
			color: t.isDisabled ? "Select an option" : "#222B33",
			fontSize: "13px",
			fontWeight: "400",
			lineHeight: "1rem"
		}),
		clearIndicator: (t) => ({
			...t,
			color: e ? "#607890" : "#9FAEBC"
		}),
		dropdownIndicator: (t, n) => ({
			...t,
			display: n.selectProps.isClearable && n.hasValue ? "none" : "flex",
			color: e ? "#607890" : "#9FAEBC"
		}),
		container: (e) => ({
			...e,
			paddingRight: "0"
		}),
		menu: (e) => ({
			...e,
			marginTop: "2px",
			boxShadow: "0px 4px 16px 0px #222B3329"
		}),
		menuList: (e) => ({
			...e,
			borderRadius: "8px",
			padding: "8px"
		}),
		option: (e, t) => ({
			...e,
			background: t.isFocused ? "#F2F4F6" : "#FFFFFF",
			backgroundColor: t.isFocused ? "#F2F4F6" : "#FFFFFF",
			color: t.isSelected ? "#4E56EA" : "#222B33",
			fontSize: "14px",
			lineHeight: "20px",
			fontWeight: t.isSelected ? "500" : "400",
			display: "flex",
			padding: "8px 12px",
			borderRadius: "8px",
			"&:hover": {
				background: "#F2F4F6",
				backgroundColor: "#F2F4F6"
			}
		})
	};
}
function Lg() {
	return {
		IndicatorSeparator: null,
		Option: Fg
	};
}
//#endregion
//#region src/input-ui/select/select.tsx
function Rg({ disabled: e, getOptionValue: t, getOptionLabel: n, className: r, hasError: i, options: a, value: o, styles: s, components: c, label: l, errorMessage: u, placeholder: d = "Select an option", optionLabelKey: f = "label", optionValueKey: p = "value", ...m }, h) {
	let _ = g(() => {
		if (typeof o == "object") return o;
		if (typeof o == "string" && t) return a?.find((e) => t(e) === o);
	}, [a, o]), v = g(() => m.isClearable ? [{
		[f]: d,
		[p]: ""
	}, ...a] : a, [
		a,
		m.isClearable,
		d,
		f,
		p
	]);
	return /* @__PURE__ */ I(Re, { children: [
		l && /* @__PURE__ */ F(Re.Label, { children: l }),
		/* @__PURE__ */ F(Mg, {
			ref: h,
			options: v,
			getOptionValue: t,
			getOptionLabel: n,
			className: Ct(Pg, r || ""),
			classNamePrefix: Ng,
			styles: {
				...Ig(!!(i || u)),
				...s
			},
			components: {
				...Lg(),
				...c
			},
			menuPlacement: "auto",
			value: _,
			isDisabled: e,
			placeholder: d,
			...m
		}),
		u && /* @__PURE__ */ F(Re.ErrorText, {
			id: `${l}-error`,
			children: u
		})
	] });
}
var zg = t.forwardRef(Rg);
//#endregion
//#region src/input-ui/select/async-select/index.tsx
function Bg({ apiPath: e, disabled: n, placeholder: r = "Select an option", getOptionValue: i, getOptionLabel: a, className: o, onChange: s, hasError: c, value: l, optionLabelKey: u = "label", optionValueKey: d = "value", noOptionsMessage: f, onNoOptionsChange: m, ...h }, _) {
	let y = v(!1), [b, x] = t.useState(""), S = t.useRef(null), [C, w] = Ae({
		path: `/${e}${b ? `${e.includes("?") ? "&" : "?"}search=${b}` : ""}`,
		retry: !1
	}), T = Array.isArray(C) ? C : C?._embedded, E = w, D = !E && !b && T !== void 0 && T.length === 0;
	p(() => {
		m?.(D);
	}, [D]);
	let O = g(() => {
		if (typeof l == "object") return l;
		if (typeof l == "string" && i) return T?.find((e) => i(e) === l);
	}, [T, l]), k = () => !0;
	function A(e) {
		S.current && clearTimeout(S.current), S.current = setTimeout(() => {
			x(e);
		}, 350);
	}
	function j(e) {
		s?.(e);
	}
	return p(() => {
		!T || y.current || !O || (s?.(O), y.current = !0);
	}, [T]), /* @__PURE__ */ F(Mg, {
		ref: _,
		isLoading: E,
		options: g(() => {
			if (D) return [];
			if (!h.isClearable) return T ?? null;
			let e = {
				[u]: r,
				[d]: ""
			};
			return T ? [e, ...T] : [e];
		}, [
			T,
			h.isClearable,
			r,
			u,
			d,
			D
		]) ?? void 0,
		onInputChange: A,
		getOptionValue: i,
		getOptionLabel: a,
		filterOption: k,
		placeholder: r,
		noOptionsMessage: f,
		onChange: j,
		className: Ct(Pg, o || ""),
		classNamePrefix: Ng,
		styles: Ig(c),
		components: Lg(),
		menuPlacement: "auto",
		value: O,
		isDisabled: n || D,
		...h
	});
}
var Vg = t.forwardRef(Bg), Hg = /* @__PURE__ */ xt((/* @__PURE__ */ V(((e, t) => {
	(function() {
		var e = {}.hasOwnProperty;
		function n() {
			for (var e = "", t = 0; t < arguments.length; t++) {
				var n = arguments[t];
				n && (e = i(e, r(n)));
			}
			return e;
		}
		function r(t) {
			if (typeof t == "string" || typeof t == "number") return t;
			if (typeof t != "object") return "";
			if (Array.isArray(t)) return n.apply(null, t);
			if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]")) return t.toString();
			var r = "";
			for (var a in t) e.call(t, a) && t[a] && (r = i(r, a));
			return r;
		}
		function i(e, t) {
			return t ? e ? e + " " + t : e + t : e;
		}
		t !== void 0 && t.exports ? (n.default = n, t.exports = n) : typeof define == "function" && typeof define.amd == "object" && define.amd ? define("classnames", [], function() {
			return n;
		}) : window.classNames = n;
	})();
})))(), 1), Ug = "react-tooltip-core-styles", Wg = "react-tooltip-base-styles", Gg = {
	core: !1,
	base: !1
};
function Kg({ css: e, id: t = Wg, type: n = "base", ref: r }) {
	if (!e || typeof document > "u" || Gg[n] || n === "core" && typeof process < "u" && (process == null ? void 0 : process.env)?.REACT_TOOLTIP_DISABLE_CORE_STYLES || n !== "base" && typeof process < "u" && (process == null ? void 0 : process.env)?.REACT_TOOLTIP_DISABLE_BASE_STYLES) return;
	n === "core" && (t = Ug), r ||= {};
	let { insertAt: i } = r;
	if (document.getElementById(t)) return;
	let a = document.head || document.getElementsByTagName("head")[0], o = document.createElement("style");
	o.id = t, o.type = "text/css", i === "top" && a.firstChild ? a.insertBefore(o, a.firstChild) : a.appendChild(o), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(document.createTextNode(e)), Gg[n] = !0;
}
var qg = async ({ elementReference: e = null, tooltipReference: t = null, tooltipArrowReference: n = null, place: r = "top", offset: i = 10, strategy: a = "absolute", middlewares: o = [
	Cp(Number(i)),
	wp({ fallbackAxisSideDirection: "start" }),
	_te({ padding: 5 })
], border: s, arrowSize: c = 8 }) => {
	if (!e || t === null) return {
		tooltipStyles: {},
		tooltipArrowStyles: {},
		place: r
	};
	let l = o;
	return n ? (l.push(Tp({
		element: n,
		padding: 5
	})), Ep(e, t, {
		placement: r,
		strategy: a,
		middleware: l
	}).then((({ x: e, y: t, placement: n, middlewareData: r }) => {
		let i = {
			left: `${e}px`,
			top: `${t}px`,
			border: s
		}, { x: a, y: o } = r.arrow ?? {
			x: 0,
			y: 0
		}, l = {
			top: "bottom",
			right: "left",
			bottom: "top",
			left: "right"
		}[n.split("-")[0]] ?? "bottom", u = s && {
			borderBottom: s,
			borderRight: s
		}, d = 0;
		if (s) {
			let e = `${s}`.match(/(\d+)px/);
			d = e?.[1] ? Number(e[1]) : 1;
		}
		return {
			tooltipStyles: i,
			tooltipArrowStyles: {
				left: a == null ? "" : `${a}px`,
				top: o == null ? "" : `${o}px`,
				right: "",
				bottom: "",
				...u,
				[l]: `-${c / 2 + d}px`
			},
			place: n
		};
	}))) : Ep(e, t, {
		placement: "bottom",
		strategy: a,
		middleware: l
	}).then((({ x: e, y: t, placement: n }) => ({
		tooltipStyles: {
			left: `${e}px`,
			top: `${t}px`
		},
		tooltipArrowStyles: {},
		place: n
	})));
}, Jg = (e, t) => !("CSS" in window && "supports" in window.CSS) || window.CSS.supports(e, t), Yg = (e, t, n) => {
	let r = null, i = function(...i) {
		let a = () => {
			r = null, n || e.apply(this, i);
		};
		n && !r && (e.apply(this, i), r = setTimeout(a, t)), n || (r && clearTimeout(r), r = setTimeout(a, t));
	};
	return i.cancel = () => {
		r &&= (clearTimeout(r), null);
	}, i;
}, Xg = (e) => e !== null && !Array.isArray(e) && typeof e == "object", Zg = (e, t) => {
	if (e === t) return !0;
	if (Array.isArray(e) && Array.isArray(t)) return e.length === t.length && e.every(((e, n) => Zg(e, t[n])));
	if (Array.isArray(e) !== Array.isArray(t)) return !1;
	if (!Xg(e) || !Xg(t)) return e === t;
	let n = Object.keys(e), r = Object.keys(t);
	return n.length === r.length && n.every(((n) => Zg(e[n], t[n])));
}, Qg = (e) => {
	if (!(e instanceof HTMLElement || e instanceof SVGElement)) return !1;
	let t = getComputedStyle(e);
	return [
		"overflow",
		"overflow-x",
		"overflow-y"
	].some(((e) => {
		let n = t.getPropertyValue(e);
		return n === "auto" || n === "scroll";
	}));
}, $g = (e) => {
	if (!e) return null;
	let t = e.parentElement;
	for (; t;) {
		if (Qg(t)) return t;
		t = t.parentElement;
	}
	return document.scrollingElement || document.documentElement;
}, e_ = typeof window < "u" ? h : p, t_ = (e) => {
	e.current &&= (clearTimeout(e.current), null);
}, n_ = "DEFAULT_TOOLTIP_ID", r_ = {
	anchorRefs: /* @__PURE__ */ new Set(),
	activeAnchor: { current: null },
	attach: () => {},
	detach: () => {},
	setActiveAnchor: () => {}
}, i_ = a({ getTooltipData: () => r_ });
function a_(e = n_) {
	return d(i_).getTooltipData(e);
}
var o_ = {
	tooltip: "core-styles-module_tooltip__3vRRp",
	fixed: "core-styles-module_fixed__pcSol",
	arrow: "core-styles-module_arrow__cvMwQ",
	noArrow: "core-styles-module_noArrow__xock6",
	clickable: "core-styles-module_clickable__ZuTTB",
	show: "core-styles-module_show__Nt9eE",
	closing: "core-styles-module_closing__sGnxF"
}, s_ = {
	tooltip: "styles-module_tooltip__mnnfp",
	arrow: "styles-module_arrow__K0L3T",
	dark: "styles-module_dark__xNqje",
	light: "styles-module_light__Z6W-X",
	success: "styles-module_success__A2AKt",
	warning: "styles-module_warning__SCK0X",
	error: "styles-module_error__JvumD",
	info: "styles-module_info__BWdHW"
}, c_ = ({ forwardRef: e, id: n, className: r, classNameArrow: i, variant: a = "dark", anchorId: o, anchorSelect: s, place: c = "top", offset: l = 10, events: d = ["hover"], openOnClick: f = !1, positionStrategy: h = "absolute", middlewares: g, wrapper: _, delayShow: b = 0, delayHide: x = 0, float: S = !1, hidden: C = !1, noArrow: w = !1, clickable: T = !1, closeOnEsc: E = !1, closeOnScroll: D = !1, closeOnResize: O = !1, openEvents: k, closeEvents: A, globalCloseEvents: j, imperativeModeOnly: M, style: ee, position: te, afterShow: ne, afterHide: re, disableTooltip: ie, content: ae, contentWrapperRef: oe, isOpen: se, defaultIsOpen: ce = !1, setIsOpen: le, activeAnchor: N, setActiveAnchor: P, border: ue, opacity: de, arrowColor: fe, arrowSize: pe = 8, role: me = "tooltip" }) => {
	let F = v(null), I = v(null), he = v(null), L = v(null), ge = v(null), [_e, ve] = y({
		tooltipStyles: {},
		tooltipArrowStyles: {},
		place: c
	}), [ye, be] = y(!1), [R, xe] = y(!1), [z, B] = y(null), Se = v(!1), Ce = v(null), { anchorRefs: we, setActiveAnchor: Te } = a_(n), Ee = v(!1), [De, Oe] = y([]), ke = v(!1), Ae = f || d.includes("click"), je = Ae || k?.click || k?.dblclick || k?.mousedown, Me = k ? { ...k } : {
		mouseover: !0,
		focus: !0,
		mouseenter: !1,
		click: !1,
		dblclick: !1,
		mousedown: !1
	};
	!k && Ae && Object.assign(Me, {
		mouseenter: !1,
		focus: !1,
		mouseover: !1,
		click: !0
	});
	let Ne = A ? { ...A } : {
		mouseout: !0,
		blur: !0,
		mouseleave: !1,
		click: !1,
		dblclick: !1,
		mouseup: !1
	};
	!A && Ae && Object.assign(Ne, {
		mouseleave: !1,
		blur: !1,
		mouseout: !1
	});
	let Pe = j ? { ...j } : {
		escape: E || !1,
		scroll: D || !1,
		resize: O || !1,
		clickOutsideAnchor: je || !1
	};
	M && (Object.assign(Me, {
		mouseover: !1,
		focus: !1,
		mouseenter: !1,
		click: !1,
		dblclick: !1,
		mousedown: !1
	}), Object.assign(Ne, {
		mouseout: !1,
		blur: !1,
		mouseleave: !1,
		click: !1,
		dblclick: !1,
		mouseup: !1
	}), Object.assign(Pe, {
		escape: !1,
		scroll: !1,
		resize: !1,
		clickOutsideAnchor: !1
	})), e_((() => (ke.current = !0, () => {
		ke.current = !1;
	})), []);
	let Fe = (e) => {
		ke.current && (e && xe(!0), setTimeout((() => {
			ke.current && (le?.(e), se === void 0 && be(e));
		}), 10));
	};
	p((() => {
		if (se === void 0) return () => null;
		se && xe(!0);
		let e = setTimeout((() => {
			be(se);
		}), 10);
		return () => {
			clearTimeout(e);
		};
	}), [se]), p((() => {
		if (ye !== Se.current) if (t_(ge), Se.current = ye, ye) ne?.();
		else {
			let e = ((e) => {
				let t = e.match(/^([\d.]+)(ms|s)$/);
				if (!t) return 0;
				let [, n, r] = t;
				return Number(n) * (r === "ms" ? 1 : 1e3);
			})(getComputedStyle(document.body).getPropertyValue("--rt-transition-show-delay"));
			ge.current = setTimeout((() => {
				xe(!1), B(null), re?.();
			}), e + 25);
		}
	}), [ye]);
	let Ie = (e) => {
		ve(((t) => Zg(t, e) ? t : e));
	}, Le = (e = b) => {
		t_(he), R ? Fe(!0) : he.current = setTimeout((() => {
			Fe(!0);
		}), e);
	}, Re = (e = x) => {
		t_(L), L.current = setTimeout((() => {
			Ee.current || Fe(!1);
		}), e);
	}, ze = (e) => {
		if (!e) return;
		let t = e.currentTarget ?? e.target;
		if (!t?.isConnected) return P(null), void Te({ current: null });
		b ? Le() : Fe(!0), P(t), Te({ current: t }), t_(L);
	}, Be = () => {
		T ? Re(x || 100) : x ? Re() : Fe(!1), t_(he);
	}, Ve = ({ x: e, y: t }) => {
		qg({
			place: z?.place ?? c,
			offset: l,
			elementReference: { getBoundingClientRect: () => ({
				x: e,
				y: t,
				width: 0,
				height: 0,
				top: t,
				left: e,
				right: e,
				bottom: t
			}) },
			tooltipReference: F.current,
			tooltipArrowReference: I.current,
			strategy: h,
			middlewares: g,
			border: ue,
			arrowSize: pe
		}).then(((e) => {
			Ie(e);
		}));
	}, He = (e) => {
		if (!e) return;
		let t = e, n = {
			x: t.clientX,
			y: t.clientY
		};
		Ve(n), Ce.current = n;
	}, Ue = (e) => {
		if (!ye) return;
		let t = e.target;
		t.isConnected && (F.current?.contains(t) || [document.querySelector(`[id='${o}']`), ...De].some(((e) => e?.contains(t))) || (Fe(!1), t_(he)));
	}, We = Yg(ze, 50, !0), Ge = Yg(Be, 50, !0), Ke = (e) => {
		Ge.cancel(), We(e);
	}, qe = () => {
		We.cancel(), Ge();
	}, Je = u((() => {
		let e = z?.position ?? te;
		e ? Ve(e) : S ? Ce.current && Ve(Ce.current) : N != null && N.isConnected && qg({
			place: z?.place ?? c,
			offset: l,
			elementReference: N,
			tooltipReference: F.current,
			tooltipArrowReference: I.current,
			strategy: h,
			middlewares: g,
			border: ue,
			arrowSize: pe
		}).then(((e) => {
			ke.current && Ie(e);
		}));
	}), [
		ye,
		N,
		ae,
		ee,
		c,
		z?.place,
		l,
		h,
		te,
		z?.position,
		S,
		pe
	]);
	p((() => {
		var e, t;
		let n = new Set(we);
		De.forEach(((e) => {
			ie != null && ie(e) || n.add({ current: e });
		}));
		let r = document.querySelector(`[id='${o}']`);
		r && !ie?.(r) && n.add({ current: r });
		let i = () => {
			Fe(!1);
		}, a = $g(N), s = $g(F.current);
		Pe.scroll && (window.addEventListener("scroll", i), a?.addEventListener("scroll", i), s?.addEventListener("scroll", i));
		let c = null;
		Pe.resize ? window.addEventListener("resize", i) : N && F.current && (c = Sp(N, F.current, Je, {
			ancestorResize: !0,
			elementResize: !0,
			layoutShift: !0
		}));
		let l = (e) => {
			e.key === "Escape" && Fe(!1);
		};
		Pe.escape && window.addEventListener("keydown", l), Pe.clickOutsideAnchor && window.addEventListener("click", Ue);
		let u = [], d = (e) => !!(e?.target && N?.contains(e.target)), f = (e) => {
			ye && d(e) || ze(e);
		}, p = (e) => {
			ye && d(e) && Be();
		}, m = [
			"mouseover",
			"mouseout",
			"mouseenter",
			"mouseleave",
			"focus",
			"blur"
		], h = [
			"click",
			"dblclick",
			"mousedown",
			"mouseup"
		];
		Object.entries(Me).forEach((([e, t]) => {
			t && (m.includes(e) ? u.push({
				event: e,
				listener: Ke
			}) : h.includes(e) && u.push({
				event: e,
				listener: f
			}));
		})), Object.entries(Ne).forEach((([e, t]) => {
			t && (m.includes(e) ? u.push({
				event: e,
				listener: qe
			}) : h.includes(e) && u.push({
				event: e,
				listener: p
			}));
		})), S && u.push({
			event: "pointermove",
			listener: He
		});
		let g = () => {
			Ee.current = !0;
		}, _ = () => {
			Ee.current = !1, Be();
		}, v = T && (Ne.mouseout || Ne.mouseleave);
		return v && ((e = F.current) == null || e.addEventListener("mouseover", g), (t = F.current) == null || t.addEventListener("mouseout", _)), u.forEach((({ event: e, listener: t }) => {
			n.forEach(((n) => {
				var r;
				(r = n.current) == null || r.addEventListener(e, t);
			}));
		})), () => {
			var e, t;
			Pe.scroll && (window.removeEventListener("scroll", i), a?.removeEventListener("scroll", i), s?.removeEventListener("scroll", i)), Pe.resize ? window.removeEventListener("resize", i) : c?.(), Pe.clickOutsideAnchor && window.removeEventListener("click", Ue), Pe.escape && window.removeEventListener("keydown", l), v && ((e = F.current) == null || e.removeEventListener("mouseover", g), (t = F.current) == null || t.removeEventListener("mouseout", _)), u.forEach((({ event: e, listener: t }) => {
				n.forEach(((n) => {
					var r;
					(r = n.current) == null || r.removeEventListener(e, t);
				}));
			}));
		};
	}), [
		N,
		Je,
		R,
		we,
		De,
		k,
		A,
		j,
		Ae,
		b,
		x
	]), p((() => {
		let e = z?.anchorSelect ?? s ?? "";
		!e && n && (e = `[data-tooltip-id='${n.replace(/'/g, "\\'")}']`);
		let t = new MutationObserver(((t) => {
			let r = [], i = [];
			t.forEach(((t) => {
				if (t.type === "attributes" && t.attributeName === "data-tooltip-id" && (t.target.getAttribute("data-tooltip-id") === n ? r.push(t.target) : t.oldValue === n && i.push(t.target)), t.type === "childList") {
					if (N) {
						let n = [...t.removedNodes].filter(((e) => e.nodeType === 1));
						if (e) try {
							i.push(...n.filter(((t) => t.matches(e)))), i.push(...n.flatMap(((t) => [...t.querySelectorAll(e)])));
						} catch {}
						n.some(((e) => !!(e?.contains)?.call(e, N) && (xe(!1), Fe(!1), P(null), t_(he), t_(L), !0)));
					}
					if (e) try {
						let n = [...t.addedNodes].filter(((e) => e.nodeType === 1));
						r.push(...n.filter(((t) => t.matches(e)))), r.push(...n.flatMap(((t) => [...t.querySelectorAll(e)])));
					} catch {}
				}
			})), (r.length || i.length) && Oe(((e) => [...e.filter(((e) => !i.includes(e))), ...r]));
		}));
		return t.observe(document.body, {
			childList: !0,
			subtree: !0,
			attributes: !0,
			attributeFilter: ["data-tooltip-id"],
			attributeOldValue: !0
		}), () => {
			t.disconnect();
		};
	}), [
		n,
		s,
		z?.anchorSelect,
		N
	]), p((() => {
		Je();
	}), [Je]), p((() => {
		if (!oe?.current) return () => null;
		let e = new ResizeObserver((() => {
			setTimeout((() => Je()));
		}));
		return e.observe(oe.current), () => {
			e.disconnect();
		};
	}), [ae, oe?.current]), p((() => {
		let e = document.querySelector(`[id='${o}']`), t = [...De, e];
		N && t.includes(N) || P(De[0] ?? e);
	}), [
		o,
		De,
		N
	]), p((() => (ce && Fe(!0), () => {
		t_(he), t_(L);
	})), []), p((() => {
		let e = z?.anchorSelect ?? s;
		if (!e && n && (e = `[data-tooltip-id='${n.replace(/'/g, "\\'")}']`), e) try {
			Oe(Array.from(document.querySelectorAll(e)));
		} catch {
			Oe([]);
		}
	}), [
		n,
		s,
		z?.anchorSelect
	]), p((() => {
		he.current && (t_(he), Le(b));
	}), [b]);
	let Ye = z?.content ?? ae, Xe = ye && Object.keys(_e.tooltipStyles).length > 0;
	return m(e, (() => ({
		open: (e) => {
			if (e?.anchorSelect) try {
				document.querySelector(e.anchorSelect);
			} catch {
				console.warn(`[react-tooltip] "${e.anchorSelect}" is not a valid CSS selector`);
				return;
			}
			B(e ?? null), e?.delay ? Le(e.delay) : Fe(!0);
		},
		close: (e) => {
			e?.delay ? Re(e.delay) : Fe(!1);
		},
		activeAnchor: N,
		place: _e.place,
		isOpen: !!(R && !C && Ye && Xe)
	}))), R && !C && Ye ? t.createElement(_, {
		id: n,
		role: me,
		className: (0, Hg.default)("react-tooltip", o_.tooltip, s_.tooltip, s_[a], r, `react-tooltip__place-${_e.place}`, o_[Xe ? "show" : "closing"], Xe ? "react-tooltip__show" : "react-tooltip__closing", h === "fixed" && o_.fixed, T && o_.clickable),
		onTransitionEnd: (e) => {
			t_(ge), ye || e.propertyName !== "opacity" || (xe(!1), B(null), re?.());
		},
		style: {
			...ee,
			..._e.tooltipStyles,
			opacity: de !== void 0 && Xe ? de : void 0
		},
		ref: F
	}, Ye, t.createElement(_, {
		className: (0, Hg.default)("react-tooltip-arrow", o_.arrow, s_.arrow, i, w && o_.noArrow),
		style: {
			..._e.tooltipArrowStyles,
			background: fe ? `linear-gradient(to right bottom, transparent 50%, ${fe} 50%)` : void 0,
			"--rt-arrow-size": `${pe}px`
		},
		ref: I
	})) : null;
}, l_ = ({ content: e }) => t.createElement("span", { dangerouslySetInnerHTML: { __html: e } }), u_ = t.forwardRef((({ id: e, anchorId: n, anchorSelect: r, content: i, html: a, render: o, className: s, classNameArrow: c, variant: l = "dark", place: u = "top", offset: d = 10, wrapper: f = "div", children: m = null, events: h = ["hover"], openOnClick: g = !1, positionStrategy: _ = "absolute", middlewares: b, delayShow: x = 0, delayHide: S = 0, float: C = !1, hidden: w = !1, noArrow: T = !1, clickable: E = !1, closeOnEsc: D = !1, closeOnScroll: O = !1, closeOnResize: k = !1, openEvents: A, closeEvents: j, globalCloseEvents: M, imperativeModeOnly: ee = !1, style: te, position: ne, isOpen: re, defaultIsOpen: ie = !1, disableStyleInjection: ae = !1, border: oe, opacity: se, arrowColor: ce, arrowSize: le, setIsOpen: N, afterShow: P, afterHide: ue, disableTooltip: de, role: fe = "tooltip" }, pe) => {
	let [me, F] = y(i), [I, he] = y(a), [L, ge] = y(u), [_e, ve] = y(l), [ye, be] = y(d), [R, xe] = y(x), [z, B] = y(S), [Se, Ce] = y(C), [we, Te] = y(w), [Ee, De] = y(f), [Oe, ke] = y(h), [Ae, je] = y(_), [Me, Ne] = y(null), [Pe, Fe] = y(null), Ie = v(ae), { anchorRefs: Le, activeAnchor: Re } = a_(e), ze = (e) => e?.getAttributeNames().reduce(((t, n) => (n.startsWith("data-tooltip-") && (t[n.replace(/^data-tooltip-/, "")] = e?.getAttribute(n) ?? null), t)), {}), Be = (e) => {
		let t = {
			place: (e) => {
				ge(e ?? u);
			},
			content: (e) => {
				F(e ?? i);
			},
			html: (e) => {
				he(e ?? a);
			},
			variant: (e) => {
				ve(e ?? l);
			},
			offset: (e) => {
				be(e === null ? d : Number(e));
			},
			wrapper: (e) => {
				De(e ?? f);
			},
			events: (e) => {
				let t = e?.split(" ");
				ke(t ?? h);
			},
			"position-strategy": (e) => {
				je(e ?? _);
			},
			"delay-show": (e) => {
				xe(e === null ? x : Number(e));
			},
			"delay-hide": (e) => {
				B(e === null ? S : Number(e));
			},
			float: (e) => {
				Ce(e === null ? C : e === "true");
			},
			hidden: (e) => {
				Te(e === null ? w : e === "true");
			},
			"class-name": (e) => {
				Ne(e);
			}
		};
		Object.values(t).forEach(((e) => e(null))), Object.entries(e).forEach((([e, n]) => {
			var r;
			(r = t[e]) == null || r.call(t, n);
		}));
	};
	p((() => {
		F(i);
	}), [i]), p((() => {
		he(a);
	}), [a]), p((() => {
		ge(u);
	}), [u]), p((() => {
		ve(l);
	}), [l]), p((() => {
		be(d);
	}), [d]), p((() => {
		xe(x);
	}), [x]), p((() => {
		B(S);
	}), [S]), p((() => {
		Ce(C);
	}), [C]), p((() => {
		Te(w);
	}), [w]), p((() => {
		je(_);
	}), [_]), p((() => {
		Ie.current !== ae && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
	}), [ae]), p((() => {
		typeof window < "u" && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", { detail: {
			disableCore: ae === "core",
			disableBase: ae
		} }));
	}), []), p((() => {
		let t = new Set(Le), i = r;
		if (!i && e && (i = `[data-tooltip-id='${e.replace(/'/g, "\\'")}']`), i) try {
			document.querySelectorAll(i).forEach(((e) => {
				t.add({ current: e });
			}));
		} catch {
			console.warn(`[react-tooltip] "${i}" is not a valid CSS selector`);
		}
		let a = document.querySelector(`[id='${n}']`);
		if (a && t.add({ current: a }), !t.size) return () => null;
		let o = Pe ?? a ?? Re.current, s = new MutationObserver(((e) => {
			e.forEach(((e) => {
				!o || e.type !== "attributes" || !e.attributeName?.startsWith("data-tooltip-") || Be(ze(o));
			}));
		}));
		return o && (Be(ze(o)), s.observe(o, {
			attributes: !0,
			childList: !1,
			subtree: !1
		})), () => {
			s.disconnect();
		};
	}), [
		Le,
		Re,
		Pe,
		n,
		r
	]), p((() => {
		te != null && te.border && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), oe && !Jg("border", `${oe}`) && console.warn(`[react-tooltip] "${oe}" is not a valid \`border\`.`), te != null && te.opacity && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), se && !Jg("opacity", `${se}`) && console.warn(`[react-tooltip] "${se}" is not a valid \`opacity\`.`);
	}), []);
	let Ve = m, He = v(null);
	if (o) {
		let e = o({
			content: Pe?.getAttribute("data-tooltip-content") || me || null,
			activeAnchor: Pe
		});
		Ve = e ? t.createElement("div", {
			ref: He,
			className: "react-tooltip-content-wrapper"
		}, e) : null;
	} else me && (Ve = me);
	I && (Ve = t.createElement(l_, { content: I }));
	let Ue = {
		forwardRef: pe,
		id: e,
		anchorId: n,
		anchorSelect: r,
		className: (0, Hg.default)(s, Me),
		classNameArrow: c,
		content: Ve,
		contentWrapperRef: He,
		place: L,
		variant: _e,
		offset: ye,
		wrapper: Ee,
		events: Oe,
		openOnClick: g,
		positionStrategy: Ae,
		middlewares: b,
		delayShow: R,
		delayHide: z,
		float: Se,
		hidden: we,
		noArrow: T,
		clickable: E,
		closeOnEsc: D,
		closeOnScroll: O,
		closeOnResize: k,
		openEvents: A,
		closeEvents: j,
		globalCloseEvents: M,
		imperativeModeOnly: ee,
		style: te,
		position: ne,
		isOpen: re,
		defaultIsOpen: ie,
		border: oe,
		opacity: se,
		arrowColor: ce,
		arrowSize: le,
		setIsOpen: N,
		afterShow: P,
		afterHide: ue,
		disableTooltip: de,
		activeAnchor: Pe,
		setActiveAnchor: (e) => Fe(e),
		role: fe
	};
	return t.createElement(c_, { ...Ue });
}));
typeof window < "u" && window.addEventListener("react-tooltip-inject-styles", ((e) => {
	e.detail.disableCore || Kg({
		css: ":root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9;--rt-transition-show-delay:0.15s;--rt-transition-closing-delay:0.15s;--rt-arrow-size:8px}.core-styles-module_tooltip__3vRRp{position:absolute;top:0;left:0;pointer-events:none;opacity:0;will-change:opacity}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit;z-index:-1}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{opacity:var(--rt-opacity);transition:opacity var(--rt-transition-show-delay)ease-out}.core-styles-module_closing__sGnxF{opacity:0;transition:opacity var(--rt-transition-closing-delay)ease-in}",
		type: "core"
	}), e.detail.disableBase || Kg({
		css: "\n.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:var(--rt-arrow-size);height:var(--rt-arrow-size)}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}",
		type: "base"
	});
}));
//#endregion
//#region src/tooltip/index.tsx
var d_ = "t1lgsskr", f_ = t.forwardRef(({ children: e, tooltipContent: n, disableTooltip: r = !1, position: i = "top", style: a, maxWidth: o = "50%", isOpen: s }, c) => {
	let l = t.useId();
	return /* @__PURE__ */ I(me, { children: [/* @__PURE__ */ F("div", {
		id: l,
		ref: c,
		style: a,
		className: Ct(n && "e8cvq5i"),
		children: e
	}), n && /* @__PURE__ */ F(u_, {
		noArrow: !0,
		offset: 4,
		className: d_,
		anchorSelect: `#${CSS.escape(l)}`,
		content: n,
		hidden: r,
		place: i,
		style: { maxWidth: o },
		isOpen: s
	})] });
}), p_ = "fstw4j7", m_ = ({ className: e, ...t }) => /* @__PURE__ */ F(Re.Label, {
	className: Ct(p_, e),
	...t
}), h_ = t.forwardRef(({ hasError: e, ...t }, n) => {
	let r = ke(e ? "Input error" : void 0);
	return t.type === "time" ? /* @__PURE__ */ F(Ye, {
		ref: D(r, n),
		showValidity: !0,
		...t,
		type: "time"
	}) : /* @__PURE__ */ F(Je, {
		ref: D(r, n),
		showValidity: !0,
		...t
	});
}), g_ = t.forwardRef(({ className: e, label: t, labelInformationTooltip: n, hasError: r, errorMessage: i, children: a, ...o }, s) => {
	let c = !!(i || r);
	return a ? /* @__PURE__ */ F(Re, {
		className: e,
		children: a
	}) : /* @__PURE__ */ I(Re, {
		className: e,
		children: [
			t && /* @__PURE__ */ I(m_, {
				htmlFor: o.id,
				children: [t, n && /* @__PURE__ */ F(f_, {
					tooltipContent: n,
					position: "top",
					children: /* @__PURE__ */ F(qe, {
						size: "sm",
						color: "primary"
					})
				})]
			}),
			/* @__PURE__ */ F(h_, {
				ref: s,
				hasError: c,
				showValidity: !0,
				...o
			}),
			i && /* @__PURE__ */ F(Re.ErrorText, {
				id: "input-error",
				children: i
			})
		]
	});
}), __ = t.forwardRef(({ currencySymbol: e = "$", label: t, errorMessage: n, ...r }, i) => /* @__PURE__ */ I(Re, { children: [
	t && /* @__PURE__ */ F(Re.Label, { children: t }),
	/* @__PURE__ */ F(h_, {
		prefix: e,
		showValidity: !0,
		type: "text",
		ref: i,
		hasError: !!n,
		...r,
		...O(/^[0-9.]*$/)
	}),
	n && /* @__PURE__ */ F(Re.ErrorText, {
		id: "input-currency-error",
		children: n
	})
] })), v_ = "d1yqr0wu", y_ = /*#__PURE__*/ Ft("div")({
	name: "DropdownContainer",
	class: "duhgpp1",
	propsAsIs: !1
}), b_ = "d1lq6yfo", x_ = /*#__PURE__*/ Ft("div")({
	name: "DropdownTrigger",
	class: "djz3jk0",
	propsAsIs: !1
}), S_ = "dvkyuye", C_ = "d1d6rxac", w_ = "d16be35y", T_ = ({ disabled: e, className: t, children: n, ...r }) => /* @__PURE__ */ F(L, {
	className: Ct(w_, t, e && "disabled"),
	...r,
	children: n
}), E_ = ({ children: e, offset: t = "0px", fullWidth: n = !1, ...r }) => /* @__PURE__ */ F(L, {
	isFlexColumn: !0,
	className: S_,
	style: {
		top: `calc(100% + ${t})`,
		padding: "8px",
		borderRadius: "8px",
		width: n ? "100%" : "fit-content"
	},
	...r,
	children: e
});
//#endregion
//#region src/input-ui/input-search/input-search-suggestion.tsx
function D_({ suggestions: e, renderSuggestion: t, onClickSuggestion: n, isLoading: r }) {
	return /* @__PURE__ */ I(E_, {
		fullWidth: !0,
		offset: "0.5rem",
		children: [
			!r && e?.map((e, r) => /* @__PURE__ */ F(T_, {
				onClick: () => n?.(e),
				children: t?.(e)
			}, r)),
			!r && !e?.length && /* @__PURE__ */ F(he, {
				font: "text-base/regular",
				colour: "secondary",
				children: "No suggestions found"
			}),
			r && /* @__PURE__ */ F(L, {
				isFlexAlignCenter: !0,
				isFlexJustifyCenter: !0,
				children: /* @__PURE__ */ F(Le, { label: "loading" })
			})
		]
	});
}
//#endregion
//#region src/input-ui/input-search/index.tsx
var O_ = /*#__PURE__*/ Ft("div")({
	name: "InputSearchWrapper",
	class: "iq1imd",
	propsAsIs: !1
});
function k_({ onChange: e, initialSearchValue: n, placeholder: r = "Search", suggestions: i, onClickSuggestion: a, renderSuggestion: o, isLoadSuggestions: s = !1 }) {
	let [c, l] = t.useState(n || ""), [u, d] = t.useState(!1), f = t.useRef(null);
	t.useEffect(() => {
		s && d(!0);
	}, [s]), t.useEffect(() => {
		let e = (e) => {
			f.current && !f.current.contains(e.target) && d(!1);
		};
		return document.addEventListener("mousedown", e), () => document.removeEventListener("mousedown", e);
	}, []), t.useEffect(() => {
		let e = (e) => {
			e.key === "Escape" && d(!1);
		};
		return document.addEventListener("keydown", e), () => document.removeEventListener("keydown", e);
	}, []);
	let [p] = De((t) => e?.(t));
	return /* @__PURE__ */ I(O_, {
		ref: f,
		children: [/* @__PURE__ */ F(Xe, {
			type: "text",
			onChange: (e) => {
				l(e?.target.value || ""), p(e?.target.value || "");
			},
			size: "medium",
			placeholder: r,
			defaultValue: c,
			onFocus: () => d(!0)
		}), (i && u || s) && /* @__PURE__ */ F(D_, {
			suggestions: i,
			renderSuggestion: o,
			onClickSuggestion: (e) => {
				d(!1), a?.(e);
			},
			isLoading: s
		})]
	});
}
//#endregion
//#region src/input-ui/input-duration/style.tsx
var A_ = /*#__PURE__*/ Ft("div")({
	name: "InputDurationContainer",
	class: "ima3ep6",
	propsAsIs: !1
}), j_ = ({ label: e, id: t, value: n, disabled: r, errorMessage: i, onChange: a, onBlur: o, name: s }) => {
	let c = ke(i || void 0), l = t ?? s;
	return /* @__PURE__ */ I(Re, { children: [
		e && /* @__PURE__ */ F(Re.Label, {
			htmlFor: l,
			children: e
		}),
		/* @__PURE__ */ F(A_, { children: /* @__PURE__ */ F(Je, {
			ref: c,
			className: "input",
			value: n ?? "",
			onChange: (e) => {
				let t = e.target.value ? parseFloat(e.target.value) : null;
				a?.(t);
			},
			disabled: r,
			showValidity: !0,
			onBlur: o,
			name: s,
			id: l,
			suffix: "Days",
			"data-unit": "days",
			...O(/^[0-9]*$/)
		}) }),
		i && l && /* @__PURE__ */ F(Re.ErrorText, {
			id: `${l}-error`,
			children: i
		})
	] });
}, M_ = "t1khpbjn", N_ = /*#__PURE__*/ Ft("section")({
	name: "TabContent",
	class: "t1ajrsd5",
	propsAsIs: !1
}), P_ = /* @__PURE__ */ RegExp("(%[a-f0-9]{2})|([^%]+?)", "gi"), F_ = /* @__PURE__ */ RegExp("(%[a-f0-9]{2})+", "gi");
function I_(e, t) {
	try {
		return [decodeURIComponent(e.join(""))];
	} catch {}
	if (e.length === 1) return e;
	t ||= 1;
	let n = e.slice(0, t), r = e.slice(t);
	return Array.prototype.concat.call([], I_(n), I_(r));
}
function L_(e) {
	try {
		return decodeURIComponent(e);
	} catch {
		let t = e.match(P_) || [];
		for (let n = 1; n < t.length; n++) e = I_(t, n).join(""), t = e.match(P_) || [];
		return e;
	}
}
function R_(e) {
	let t = {
		"%FE%FF": "��",
		"%FF%FE": "��"
	}, n = F_.exec(e);
	for (; n;) {
		try {
			t[n[0]] = decodeURIComponent(n[0]);
		} catch {
			let e = L_(n[0]);
			e !== n[0] && (t[n[0]] = e);
		}
		n = F_.exec(e);
	}
	t["%C2"] = "�";
	let r = Object.keys(t);
	for (let n of r) e = e.replace(new RegExp(n, "g"), t[n]);
	return e;
}
function z_(e) {
	if (typeof e != "string") throw TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof e + "`");
	try {
		return decodeURIComponent(e);
	} catch {
		return R_(e);
	}
}
//#endregion
//#region ../../node_modules/split-on-first/index.js
function B_(e, t) {
	if (!(typeof e == "string" && typeof t == "string")) throw TypeError("Expected the arguments to be of type `string`");
	if (e === "" || t === "") return [];
	let n = e.indexOf(t);
	return n === -1 ? [] : [e.slice(0, n), e.slice(n + t.length)];
}
//#endregion
//#region ../../node_modules/filter-obj/index.js
function V_(e, t) {
	let n = {};
	if (Array.isArray(t)) for (let r of t) {
		let t = Object.getOwnPropertyDescriptor(e, r);
		t?.enumerable && Object.defineProperty(n, r, t);
	}
	else for (let r of Reflect.ownKeys(e)) {
		let i = Object.getOwnPropertyDescriptor(e, r);
		if (i.enumerable) {
			let a = e[r];
			t(r, a, e) && Object.defineProperty(n, r, i);
		}
	}
	return n;
}
//#endregion
//#region ../../node_modules/query-string/base.js
var H_ = /* @__PURE__ */ yt({
	exclude: () => sv,
	extract: () => tv,
	parse: () => nv,
	parseUrl: () => iv,
	pick: () => ov,
	stringify: () => rv,
	stringifyUrl: () => av
}), U_ = (e) => e == null, W_ = (e) => encodeURIComponent(e).replaceAll(/[!'()*]/g, (e) => `%${e.charCodeAt(0).toString(16).toUpperCase()}`), G_ = Symbol("encodeFragmentIdentifier");
function K_(e) {
	switch (e.arrayFormat) {
		case "index": return (t) => (n, r) => {
			let i = n.length;
			return r === void 0 || e.skipNull && r === null || e.skipEmptyString && r === "" ? n : r === null ? [...n, [
				Y_(t, e),
				"[",
				i,
				"]"
			].join("")] : [...n, [
				Y_(t, e),
				"[",
				Y_(i, e),
				"]=",
				Y_(r, e)
			].join("")];
		};
		case "bracket": return (t) => (n, r) => r === void 0 || e.skipNull && r === null || e.skipEmptyString && r === "" ? n : r === null ? [...n, [Y_(t, e), "[]"].join("")] : [...n, [
			Y_(t, e),
			"[]=",
			Y_(r, e)
		].join("")];
		case "colon-list-separator": return (t) => (n, r) => r === void 0 || e.skipNull && r === null || e.skipEmptyString && r === "" ? n : r === null ? [...n, [Y_(t, e), ":list="].join("")] : [...n, [
			Y_(t, e),
			":list=",
			Y_(r, e)
		].join("")];
		case "comma":
		case "separator":
		case "bracket-separator": {
			let t = e.arrayFormat === "bracket-separator" ? "[]=" : "=";
			return (n) => (r, i) => i === void 0 || e.skipNull && i === null || e.skipEmptyString && i === "" ? r : (i = i === null ? "" : i, r.length === 0 ? [[
				Y_(n, e),
				t,
				Y_(i, e)
			].join("")] : [[r, Y_(i, e)].join(e.arrayFormatSeparator)]);
		}
		default: return (t) => (n, r) => r === void 0 || e.skipNull && r === null || e.skipEmptyString && r === "" ? n : r === null ? [...n, Y_(t, e)] : [...n, [
			Y_(t, e),
			"=",
			Y_(r, e)
		].join("")];
	}
}
function q_(e) {
	let t;
	switch (e.arrayFormat) {
		case "index": return (e, n, r) => {
			if (t = /\[(\d*)]$/.exec(e), e = e.replace(/\[\d*]$/, ""), !t) {
				r[e] = n;
				return;
			}
			r[e] === void 0 && (r[e] = {}), r[e][t[1]] = n;
		};
		case "bracket": return (e, n, r) => {
			if (t = /(\[])$/.exec(e), e = e.replace(/\[]$/, ""), !t) {
				r[e] = n;
				return;
			}
			if (r[e] === void 0) {
				r[e] = [n];
				return;
			}
			r[e] = [...r[e], n];
		};
		case "colon-list-separator": return (e, n, r) => {
			if (t = /(:list)$/.exec(e), e = e.replace(/:list$/, ""), !t) {
				r[e] = n;
				return;
			}
			if (r[e] === void 0) {
				r[e] = [n];
				return;
			}
			r[e] = [...r[e], n];
		};
		case "comma":
		case "separator": return (t, n, r) => {
			let i = typeof n == "string" && n.includes(e.arrayFormatSeparator), a = typeof n == "string" && !i && X_(n, e).includes(e.arrayFormatSeparator);
			n = a ? X_(n, e) : n, r[t] = i || a ? n.split(e.arrayFormatSeparator).map((t) => X_(t, e)) : n === null ? n : X_(n, e);
		};
		case "bracket-separator": return (t, n, r) => {
			let i = /(\[])$/.test(t);
			if (t = t.replace(/\[]$/, ""), !i) {
				r[t] = n && X_(n, e);
				return;
			}
			let a = n === null ? [] : n.split(e.arrayFormatSeparator).map((t) => X_(t, e));
			if (r[t] === void 0) {
				r[t] = a;
				return;
			}
			r[t] = [...r[t], ...a];
		};
		default: return (e, t, n) => {
			if (n[e] === void 0) {
				n[e] = t;
				return;
			}
			n[e] = [...[n[e]].flat(), t];
		};
	}
}
function J_(e) {
	if (typeof e != "string" || e.length !== 1) throw TypeError("arrayFormatSeparator must be single character string");
}
function Y_(e, t) {
	return t.encode ? t.strict ? W_(e) : encodeURIComponent(e) : e;
}
function X_(e, t) {
	return t.decode ? z_(e) : e;
}
function Z_(e) {
	return Array.isArray(e) ? e.sort() : typeof e == "object" ? Z_(Object.keys(e)).sort((e, t) => Number(e) - Number(t)).map((t) => e[t]) : e;
}
function Q_(e) {
	let t = e.indexOf("#");
	return t !== -1 && (e = e.slice(0, t)), e;
}
function $_(e) {
	let t = "", n = e.indexOf("#");
	return n !== -1 && (t = e.slice(n)), t;
}
function ev(e, t) {
	return t.parseNumbers && !Number.isNaN(Number(e)) && typeof e == "string" && e.trim() !== "" ? e = Number(e) : t.parseBooleans && e !== null && (e.toLowerCase() === "true" || e.toLowerCase() === "false") && (e = e.toLowerCase() === "true"), e;
}
function tv(e) {
	e = Q_(e);
	let t = e.indexOf("?");
	return t === -1 ? "" : e.slice(t + 1);
}
function nv(e, t) {
	t = {
		decode: !0,
		sort: !0,
		arrayFormat: "none",
		arrayFormatSeparator: ",",
		parseNumbers: !1,
		parseBooleans: !1,
		...t
	}, J_(t.arrayFormatSeparator);
	let n = q_(t), r = Object.create(null);
	if (typeof e != "string" || (e = e.trim().replace(/^[?#&]/, ""), !e)) return r;
	for (let i of e.split("&")) {
		if (i === "") continue;
		let e = t.decode ? i.replaceAll("+", " ") : i, [a, o] = B_(e, "=");
		a === void 0 && (a = e), o = o === void 0 ? null : [
			"comma",
			"separator",
			"bracket-separator"
		].includes(t.arrayFormat) ? o : X_(o, t), n(X_(a, t), o, r);
	}
	for (let [e, n] of Object.entries(r)) if (typeof n == "object" && n) for (let [e, r] of Object.entries(n)) n[e] = ev(r, t);
	else r[e] = ev(n, t);
	return t.sort === !1 ? r : (t.sort === !0 ? Object.keys(r).sort() : Object.keys(r).sort(t.sort)).reduce((e, t) => {
		let n = r[t];
		return e[t] = n && typeof n == "object" && !Array.isArray(n) ? Z_(n) : n, e;
	}, Object.create(null));
}
function rv(e, t) {
	if (!e) return "";
	t = {
		encode: !0,
		strict: !0,
		arrayFormat: "none",
		arrayFormatSeparator: ",",
		...t
	}, J_(t.arrayFormatSeparator);
	let n = (n) => t.skipNull && U_(e[n]) || t.skipEmptyString && e[n] === "", r = K_(t), i = {};
	for (let [t, r] of Object.entries(e)) n(t) || (i[t] = r);
	let a = Object.keys(i);
	return t.sort !== !1 && a.sort(t.sort), a.map((n) => {
		let i = e[n];
		return i === void 0 ? "" : i === null ? Y_(n, t) : Array.isArray(i) ? i.length === 0 && t.arrayFormat === "bracket-separator" ? Y_(n, t) + "[]" : i.reduce(r(n), []).join("&") : Y_(n, t) + "=" + Y_(i, t);
	}).filter((e) => e.length > 0).join("&");
}
function iv(e, t) {
	t = {
		decode: !0,
		...t
	};
	let [n, r] = B_(e, "#");
	return n === void 0 && (n = e), {
		url: n?.split("?")?.[0] ?? "",
		query: nv(tv(e), t),
		...t && t.parseFragmentIdentifier && r ? { fragmentIdentifier: X_(r, t) } : {}
	};
}
function av(e, t) {
	t = {
		encode: !0,
		strict: !0,
		[G_]: !0,
		...t
	};
	let n = Q_(e.url).split("?")[0] || "", r = rv({
		...nv(tv(e.url), { sort: !1 }),
		...e.query
	}, t);
	r &&= `?${r}`;
	let i = $_(e.url);
	if (typeof e.fragmentIdentifier == "string") {
		let r = new URL(n);
		r.hash = e.fragmentIdentifier, i = t[G_] ? r.hash : `#${e.fragmentIdentifier}`;
	}
	return `${n}${r}${i}`;
}
function ov(e, t, n) {
	n = {
		parseFragmentIdentifier: !0,
		[G_]: !1,
		...n
	};
	let { url: r, query: i, fragmentIdentifier: a } = iv(e, n);
	return av({
		url: r,
		query: V_(i, t),
		fragmentIdentifier: a
	}, n);
}
function sv(e, t, n) {
	return ov(e, Array.isArray(t) ? (e) => !t.includes(e) : (e, n) => !t(e, n), n);
}
//#endregion
//#region ../../node_modules/query-string/index.js
var cv = H_, lv = ({ tabItems: e, paramKey: t = "tab", preservedParams: n = [] }) => {
	let [r] = Qe(), i = cv.parse(r.toString()), a = n.reduce((e, t) => i[t] ? {
		...e,
		[t]: i[t]
	} : e, {}), o = i[t] || e[0].name, s = e.findIndex((e) => e.name === o), c = s >= 0 ? e[s].component : null;
	return /* @__PURE__ */ I(L, {
		isFlexColumn: !0,
		className: pe,
		children: [/* @__PURE__ */ F(L, {
			tag: "div",
			isFlexRow: !0,
			isFlexWrap: !0,
			className: Ct(mo, Ke),
			children: e.map((e) => {
				let n = e.name === o, r = {
					...a,
					[t]: e.name
				};
				return /* @__PURE__ */ F(Ze, {
					to: { search: `?${cv.stringify(r, {
						skipNull: !0,
						skipEmptyString: !0
					})}` },
					className: Ct(M_, n && "tzyf6wk"),
					children: /* @__PURE__ */ F(he, {
						font: "text-base/regular",
						colour: n ? "action" : "secondary",
						children: e.title
					})
				}, e.name);
			})
		}), /* @__PURE__ */ F(b, { children: c })]
	});
}, uv = /*#__PURE__*/ Ft("div")({
	name: "TableToolbarRightContentContainer",
	class: "t13je2uj",
	propsAsIs: !1
}), dv = /*#__PURE__*/ Ft("div")({
	name: "CombinedActionContainer",
	class: "cg8mw2t",
	propsAsIs: !1
}), fv = "t172mkeb", pv = ({ className: e, ...t }) => /* @__PURE__ */ F($e.Toolbar, {
	className: Ct(fv, e),
	...t
}), mv = /*#__PURE__*/ Ft("div")({
	name: "TableMessagesContainer",
	class: "tvgfkzc",
	propsAsIs: !1
}), hv = t.memo(({ children: e, className: n, alignment: r = "right", trigger: i, disabled: a, offset: o }) => {
	let [s, c] = t.useState(!1), l = t.useRef(null);
	return p(() => {
		let e = (e) => {
			l.current?.contains(e.target) || c(!1);
		};
		return window.addEventListener("click", e), () => window.removeEventListener("click", e);
	}, []), /* @__PURE__ */ I(y_, {
		ref: l,
		className: n,
		children: [/* @__PURE__ */ F(x_, {
			className: Ct(a && "e1lijjb4"),
			onClick: () => !a && c((e) => !e),
			children: /* @__PURE__ */ I(R, {
				intent: s ? "primary" : "secondary",
				children: [i, !i && /* @__PURE__ */ F(et, { color: s ? "action" : "secondary" })]
			})
		}), s && /* @__PURE__ */ F(E_, {
			offset: o,
			onClick: (e) => {
				e.stopPropagation(), c(!1);
			},
			"data-alignment": r,
			children: e
		})]
	});
}), gv = a({
	setIsOpen: () => {},
	isOpen: !1
}), _v = () => d(gv), vv = () => {
	let [e, n] = t.useState(!1);
	return {
		isOpen: e,
		setIsOpen: n
	};
}, yv = ({ children: e, onClick: t, className: n, isOpen: r, setIsOpen: i, ...a }) => {
	let [o, s] = y(!1);
	return p(() => {
		let e = () => {
			if (i) return i(!1);
			s(!1);
		};
		return window.addEventListener("click", e), () => window.removeEventListener("click", e);
	}, []), /* @__PURE__ */ F(gv.Provider, {
		value: {
			isOpen: r ?? o,
			setIsOpen: i ?? s
		},
		children: /* @__PURE__ */ F("div", {
			onClick: (e) => {
				e.stopPropagation(), t?.(e);
			},
			className: Ct(v_, (r || o) && "is-open", n),
			...a,
			children: e
		})
	});
}, bv = ({ children: e, className: t, onClick: n, forceOpen: r, ...i }) => {
	let { isOpen: a, setIsOpen: o } = _v(), s = (e) => {
		r || o((e) => !e), n?.(e);
	};
	if (!(!a && !r)) return /* @__PURE__ */ F(L, {
		isFlexColumn: !0,
		className: Ct(S_, a && "is-open", t),
		onClick: s,
		...i,
		children: e
	});
}, xv = ({ children: e, className: t, ...n }) => {
	let { isOpen: r } = _v();
	return /* @__PURE__ */ F(z, {
		variant: "secondary",
		size: "small",
		className: Ct(C_, r && "is-open", t),
		...n,
		children: e
	});
}, Sv = ({ children: e, onClick: t, className: n, disabled: r, ...i }) => {
	let { setIsOpen: a, isOpen: o } = _v();
	return /* @__PURE__ */ F("div", {
		onClick: (e) => {
			r || (a((e) => !e), t?.(e));
		},
		className: Ct(b_, o && "is-open", n),
		...i,
		children: e
	});
}, Cv = ({ children: e, buttonTitle: n, placement: r, maxHeight: i, maxWidth: a, gap: o, ...s }) => {
	let c = t.useId(), l = t.useId();
	return /* @__PURE__ */ I(me, { children: [/* @__PURE__ */ F(z, {
		...s,
		id: c,
		"aria-controls": l,
		"aria-haspopup": "menu",
		popovertarget: l,
		popovertargetaction: "toggle",
		children: n
	}), /* @__PURE__ */ F(tt, {
		placement: r,
		maxHeight: i,
		maxWidth: a,
		gap: o,
		id: l,
		"aria-labelledby": c,
		children: e
	})] });
};
//#endregion
//#region src/table/combined-action.tsx
function wv(e, t) {
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		if (!t(r)) return !1;
	}
	return !0;
}
var Tv = t.memo(({ rowAction: e, selectedRows: t }) => e.disabledCombinedAction ? null : /* @__PURE__ */ F(z, {
	variant: "secondary",
	size: "small",
	disabled: e.visibleFor ? !wv(t, e.visibleFor) : !1,
	onClick: () => e.onClickMultiple?.(t),
	children: e.actionMultipleTitle ?? e.actionTitle
})), Ev = t.memo(function({ actions: e, selectedRows: t }) {
	if (!t || t?.length === 0 || !e?.length) return;
	let n = f(e.filter((e) => !e.disabledCombinedAction)), r = g(() => n.slice(0, 4), [n]), i = g(() => n.slice(4).map((e) => {
		let n = e.visibleFor ? !wv(t, e.visibleFor) : !1;
		return {
			...e,
			disabled: n
		};
	}), [n]), a = i.every((e) => e.disabled);
	return /* @__PURE__ */ I(dv, { children: [r.map((e, n) => /* @__PURE__ */ F(Tv, {
		rowAction: e,
		selectedRows: t
	}, n)), i.length > 0 && /* @__PURE__ */ F(Cv, {
		className: "eq6op9c",
		placement: "bottom-end",
		disabled: a,
		size: "small",
		variant: "secondary",
		iconLeft: /* @__PURE__ */ F(et, {}),
		"aria-disabled": a,
		children: i.map((e, n) => /* @__PURE__ */ F(tt.Item, {
			onClick: () => e.onClickMultiple?.(t),
			disabled: e.disabled,
			children: e.actionTitle
		}, n))
	})] });
}), Dv = t.memo(({ rowActions: e, selectedRows: t, tableAction: n, dataCount: r, dataCountDisplayMessage: i, isLoading: a }) => {
	let o = !!(t && t.length > 0), s = !!(e && e.length > 0), c = o && s, l = g(() => r ? c ? `${t?.length} of ${r} selected` : `${r} ${r > 1 ? i?.plural : i?.singular}` : "", [
		r,
		t?.length,
		c,
		i?.singular,
		i?.plural
	]);
	return /* @__PURE__ */ F(pv, {
		leftContent: /* @__PURE__ */ F(he, {
			font: "text-sm/regular",
			colour: "primary",
			children: !a && l
		}),
		rightContent: /* @__PURE__ */ I(uv, { children: [c && /* @__PURE__ */ F(Ev, {
			actions: e,
			selectedRows: t
		}), n && /* @__PURE__ */ F(z, {
			size: "medium",
			variant: "tertiary",
			hasNoPadding: !0,
			useLinkStyle: !0,
			onClick: n.onClick,
			children: n.actionTitle
		})] })
	});
}), Ov = "t15c989z", kv = ({ className: e, ...t }) => /* @__PURE__ */ F($e.SortButton, {
	className: Ct(Ov, e),
	...t
}), Av = t.memo(({ headerData: e, isSortable: t, onSortChanges: n, sortDirection: r = "asc" }) => /* @__PURE__ */ I($e.HeaderCell, {
	"aria-sort": t ? r === "asc" ? "ascending" : "descending" : void 0,
	as: "div",
	children: [!t && e.headerTitle, t && /* @__PURE__ */ F(kv, {
		name: e.key,
		value: r === "asc" ? "ascending" : "descending",
		onClick: () => n?.(String(e.sortAs ?? e.key)),
		children: e.headerTitle
	})]
})), jv = t.memo(({ headers: e, hasRowAction: n, isSelectable: r, onSortChanges: i, hasRowSelected: a, isAllRowSelected: o, onClickSelectionHeader: s, sortQueryKey: c = {
	sortKey: "sortBy",
	sortValue: "sortByDirection"
} }) => {
	let l = new URLSearchParams(window.location.href), u = t.useRef(null), d = c?.sortKey ?? "", f = c?.sortValue ?? "", [p, m] = t.useState(e.reduce((e, t) => {
		if (!t.sortable) return e;
		let n = (t.sortAs ?? t.key).toString(), r = l.get(d) === n ? l.get(f) : t.sortValue;
		return {
			...e,
			[n]: r === "Ascending" ? "asc" : "desc"
		};
	}, {}));
	function h(e) {
		let t = p[e] === "asc" ? "desc" : "asc", n = Object.keys(p).reduce((n, r) => r === e ? {
			...n,
			[r]: t
		} : {
			...n,
			[r]: "asc"
		}, {});
		m(n), i?.(e, t, n);
	}
	return t.useEffect(() => {
		u.current && (u.current.indeterminate = !!(a && !o));
	}, [a, o]), /* @__PURE__ */ I($e.HeaderRow, {
		"data-testid": "table-headers",
		as: "div",
		children: [
			r && /* @__PURE__ */ F($e.BodyCell, {
				justifySelf: "center",
				as: "div",
				"aria-label": "row selection",
				children: /* @__PURE__ */ F($e.Checkbox, {
					ref: u,
					"aria-label": "Select all rows",
					checked: o,
					onChange: (e) => s?.(e.target.checked)
				})
			}),
			e.map((e) => /* @__PURE__ */ F(Av, {
				headerData: e,
				isSortable: e.sortable,
				onSortChanges: h,
				sortDirection: p[e?.sortAs ?? e.key]
			}, e.headerTitle)),
			n && /* @__PURE__ */ F($e.HeaderCell, {
				"aria-label": "actions",
				as: "div"
			})
		]
	});
}), Mv = t.memo(({ children: e, showTooltipWhenTruncated: n, className: r, onClick: i, href: a, ...o }) => {
	let s = t.useId(), c = t.useId(), l = t.useMemo(() => a ? $e.PrimaryAction : i ? $e.PrimaryActionButton : t.Fragment, [i, a]), u = l === t.Fragment ? {} : {
		href: a,
		onClick: i
	};
	return /* @__PURE__ */ F($e.BodyCell, {
		className: r,
		...o,
		children: /* @__PURE__ */ I(l, {
			...u,
			children: [/* @__PURE__ */ F(he, {
				style: {
					textAlign: "start",
					...n ? {
						position: "relative",
						zIndex: 1
					} : {}
				},
				font: "inherit",
				id: s,
				overflow: n ? "truncate" : void 0,
				children: e
			}), n && /* @__PURE__ */ F(nt, {
				id: c,
				placement: "top",
				triggerId: s,
				truncationTargetId: s,
				children: e
			})]
		})
	});
});
//#endregion
//#region src/table/table-row/row-action-item.tsx
function Nv({ rowAction: e, rowData: t }) {
	return e.visibleFor?.(t) ?? !0 ? /* @__PURE__ */ F(tt.Item, {
		onClick: () => e.onClick?.(t),
		children: e.actionTitle
	}) : null;
}
var Pv = E(Nv);
//#endregion
//#region src/table/table-row/row-action.tsx
function Fv({ rowActions: e, className: t, rowData: n, ...r }) {
	if (!(!e || !e.length)) return /* @__PURE__ */ F($e.BodyCell, {
		...r,
		className: t,
		id: "table-row-action",
		as: "div",
		children: /* @__PURE__ */ F($e.MoreActions, {
			"aria-label": "More actions",
			children: e.map((e, t) => /* @__PURE__ */ F(Pv, {
				rowAction: e,
				rowData: n
			}, `row-action-${n.referenceID}-${t}`))
		})
	});
}
var Iv = E(Fv);
//#endregion
//#region src/table/table-row/row-selection.tsx
function Lv({ rowData: e, onRowSelectionChange: t, isSelected: n, className: r, ...i }) {
	return /* @__PURE__ */ F($e.BodyCell, {
		...i,
		id: "table-row-action",
		justifySelf: "center",
		className: r,
		as: "div",
		children: /* @__PURE__ */ F($e.Checkbox, {
			"aria-label": "Select data",
			checked: n,
			onChange: (n) => t?.(n.target.checked, e)
		})
	});
}
var Rv = E(Lv);
//#endregion
//#region src/table/table-row/index.tsx
function zv({ rowKeyIdentifier: e, rowData: t, isSelectable: n, rowActions: r, headers: i, onRowSelectionChange: a, isSelected: o, onRowClick: s, rowLink: c }) {
	if (!t) return null;
	let l = (e) => {
		e.target.closest("#table-row-action") || s?.(t);
	};
	return /* @__PURE__ */ F($e.Body, {
		as: "div",
		children: /* @__PURE__ */ I($e.BodyRow, {
			"data-testid": "table-row-item",
			as: "div",
			children: [
				n && /* @__PURE__ */ F(Rv, {
					isSelected: o,
					rowData: t,
					onRowSelectionChange: a
				}),
				i.map((n, r) => {
					let i = n.getColumnValue?.(t) ?? t[n.key] ?? "-";
					return /* @__PURE__ */ F(Mv, {
						as: "div",
						showTooltipWhenTruncated: n.showTooltipWhenTruncated,
						onClick: r === 1 ? l : void 0,
						href: r === 1 ? c?.(t) : void 0,
						children: i
					}, `${t[e]}-${n.headerTitle}-${r}`);
				}),
				/* @__PURE__ */ F(Iv, {
					rowActions: r,
					rowData: t
				})
			]
		})
	});
}
var Bv = E(zv), Ste = ({ primaryText: e, supplementaryText: n, ...r }) => {
	let i = t.useId();
	return /* @__PURE__ */ I($e.DoubleLineLayout, {
		...r,
		supplementaryData: /* @__PURE__ */ I(me, { children: [/* @__PURE__ */ F(he, {
			font: r.supplementaryFontWeight ? `text-xs/${r.supplementaryFontWeight}` : "inherit",
			id: `${i}-supplementary-text`,
			overflow: "truncate",
			children: n
		}), /* @__PURE__ */ F(nt, {
			id: `${i}-supplementary-tooltip`,
			placement: "top",
			triggerId: `${i}-supplementary-text`,
			truncationTargetId: `${i}-supplementary-text`,
			children: n
		})] }),
		children: [/* @__PURE__ */ F(he, {
			font: r.primaryFontWeight ? `text-sm/${r.primaryFontWeight}` : "inherit",
			id: `${i}-primary-text`,
			overflow: "truncate",
			children: e
		}), /* @__PURE__ */ F(nt, {
			id: `${i}-primary-tooltip`,
			placement: "top",
			triggerId: `${i}-primary-text`,
			truncationTargetId: `${i}-primary-text`,
			children: e
		})]
	});
};
//#endregion
//#region src/table/index.tsx
function Cte({ rows: e, headers: n, rowKeyIdentifier: r, onReorder: i, pagination: a, isLoading: o = !1, loadingMessage: s = "Please wait. Get the table data", isError: c = !1, errorMessage: l = "Opps. Something went wrong while getting the data!", emptyMessage: u = "The data is empty", onPageChange: d, tableRowAction: f, tableDataCountMessage: p, tableAction: m, isRowSelectable: h, onRowClick: g, sortQueryKey: _, rowLink: v }) {
	let [y, b] = t.useState(), [x, S] = t.useState(), C = t.useDeferredValue(e), w = Array.isArray(f) && f.length > 0, T = C?.length ?? 0, E = e?.length !== C?.length, D = t.useMemo(() => !(T > 0), [T]), O = D && !o && !c && !E, k = (o || E) && !c, A = c && !o && !E, j = !D && !c && !o && !E, M = !!(j && a?.dataCount), ee = !!y?.length, te = T > 0 && y?.length === T, ne = (e) => (t) => {
		t.preventDefault(), d?.(e);
	}, re = t.useCallback((e, n) => {
		t.startTransition(() => {
			if (e) {
				S((e) => ({
					...e,
					[n[r]]: n
				})), b((e) => [...e ?? [], n]);
				return;
			}
			S((e) => {
				let t = { ...e };
				return delete t[n[r]], t;
			}), b((e) => e?.filter((e) => e[r] !== n[r]));
		});
	}, []);
	return t.useEffect(() => {
		t.startTransition(() => {
			b(null), S(null);
		});
	}, [
		a?.currentPage,
		e?.length,
		j
	]), /* @__PURE__ */ I("div", { children: [
		/* @__PURE__ */ I($e, {
			as: "div",
			columns: t.useMemo(() => {
				let e = n.reduce((e, t) => t.columnWidth ? `${e} ${t.columnWidth}` : `${e} 1fr`, "");
				return h && (e = `3rem ${e}`), w && (e = `${e} 3rem`), e;
			}, []),
			children: [
				/* @__PURE__ */ F(Dv, {
					tableAction: m,
					dataCount: a?.dataCount ?? e?.length,
					dataCountDisplayMessage: p,
					rowActions: f,
					selectedRows: y,
					isLoading: k
				}),
				/* @__PURE__ */ F(jv, {
					headers: n,
					hasRowAction: w,
					isSelectable: h,
					onSortChanges: i,
					hasRowSelected: ee,
					isAllRowSelected: te,
					onClickSelectionHeader: (n) => {
						t.startTransition(() => {
							if (n && !ee) {
								S(e?.reduce((e, t) => ({
									...e,
									[t[r]]: t
								}), {})), b(e);
								return;
							}
							S(null), b(null);
						});
					},
					sortQueryKey: _
				}),
				j && C?.map((e) => /* @__PURE__ */ F(Bv, {
					headers: n,
					rowKeyIdentifier: r.toString(),
					rowData: e,
					isSelectable: h,
					onRowSelectionChange: re,
					rowActions: f,
					isSelected: !!x?.[e[r]],
					onRowClick: g,
					rowLink: v
				}, e[r]))
			]
		}),
		(O || A || k) && /* @__PURE__ */ I(mv, { children: [
			k && /* @__PURE__ */ F(Le, { label: s }),
			A && /* @__PURE__ */ F(it, {
				variant: "error",
				icon: /* @__PURE__ */ F(at, { "aria-label": "Error" }),
				children: l
			}),
			O && /* @__PURE__ */ F(he, {
				font: "text-sm/regular",
				colour: "secondary",
				children: u
			})
		] }),
		a && M && /* @__PURE__ */ F(rt, {
			pageCount: a.totalPage ?? 1,
			pageNumber: a.currentPage ?? 1,
			leftAction: /* @__PURE__ */ F(rt.Link, {
				"aria-disabled": !a.currentPage || a.currentPage === 1,
				variant: "previous-page",
				href: "",
				onClick: ne((a.currentPage ?? 1) - 1)
			}),
			rightAction: /* @__PURE__ */ F(rt.Link, {
				"aria-disabled": a.currentPage === a.totalPage,
				variant: "next-page",
				href: "",
				onClick: ne((a.currentPage ?? 1) + 1)
			})
		})
	] });
}
//#endregion
//#region src/button/button-dropdown.tsx
var wte = "tgcweh4", Tte = "bs4lx94", Ete = ({ actionDropdown: e, disabled: t }) => {
	let n = vv();
	if (!(!e || e.length < 1)) return /* @__PURE__ */ I(yv, {
		className: Ct(Tte, t && "is-disabled"),
		...n,
		children: [/* @__PURE__ */ F(Sv, {
			disabled: t,
			children: /* @__PURE__ */ F("div", {
				className: wte,
				children: n.isOpen ? /* @__PURE__ */ F(st, {}) : /* @__PURE__ */ F(ot, {})
			})
		}), /* @__PURE__ */ F(bv, { children: e.map((e, t) => /* @__PURE__ */ F(xv, {
			variant: "primary",
			size: "small",
			onClick: (t) => e.onClick?.(t),
			children: e.title
		}, t)) })]
	});
}, Dte = ({ actionDropdown: e, children: t, className: n, disabled: r, ...i }) => /* @__PURE__ */ I(L, {
	isFlexRow: !0,
	isFlexNoWrap: !0,
	className: Ct(j),
	children: [/* @__PURE__ */ F(z, {
		size: "small",
		variant: "primary",
		className: Ct("ckbtgpm", n),
		disabled: r,
		...i,
		children: /* @__PURE__ */ F(he, {
			font: "text-sm/medium",
			children: t
		})
	}), /* @__PURE__ */ F(Ete, {
		actionDropdown: e,
		disabled: r
	})]
}), Ote = ({ className: e, hideCloseButton: t, children: n, title: r, overlineTitle: i, supplementaryTitle: a, footerItems: o, ...s }) => {
	let c = !!(t || o);
	return /* @__PURE__ */ I(ct, {
		className: e,
		...s,
		children: [
			/* @__PURE__ */ F(ct.Header, {
				action: c ? null : /* @__PURE__ */ F(ct.HeaderCloseButton, {}),
				overline: i,
				supplementaryInfo: a,
				children: r
			}),
			/* @__PURE__ */ F(ct.Body, { children: n }),
			o && /* @__PURE__ */ F(ct.Footer, { children: o })
		]
	});
}, kte = /* @__PURE__ */ yt({
	Canvas: () => ry,
	Checkbox: () => Qv,
	Circle: () => iy,
	ClipPath: () => jte,
	Defs: () => ey,
	Document: () => sy,
	Ellipse: () => ay,
	FieldSet: () => Yv,
	G: () => "G",
	Image: () => ty,
	Line: () => Jv,
	LinearGradient: () => uy,
	Link: () => Uv,
	List: () => $v,
	Note: () => Gv,
	Page: () => Wv,
	Path: () => Kv,
	Polygon: () => oy,
	Polyline: () => cy,
	RadialGradient: () => dy,
	Rect: () => qv,
	Select: () => Zv,
	Stop: () => Ate,
	Svg: () => "SVG",
	Text: () => Hv,
	TextInput: () => Xv,
	TextInstance: () => ly,
	Tspan: () => ny,
	View: () => Vv
}), Vv = "VIEW", Hv = "TEXT", Uv = "LINK", Wv = "PAGE", Gv = "NOTE", Kv = "PATH", qv = "RECT", Jv = "LINE", Yv = "FIELD_SET", Xv = "TEXT_INPUT", Zv = "SELECT", Qv = "CHECKBOX", $v = "LIST", Ate = "STOP", ey = "DEFS", ty = "IMAGE", ny = "TSPAN", ry = "CANVAS", iy = "CIRCLE", ay = "ELLIPSE", oy = "POLYGON", sy = "DOCUMENT", cy = "POLYLINE", jte = "CLIP_PATH", ly = "TEXT_INSTANCE", uy = "LINEAR_GRADIENT", dy = "RADIAL_GRADIENT", Mte = /* @__PURE__ */ V(((e, t) => {
	typeof Object.create == "function" ? t.exports = function(e, t) {
		t && (e.super_ = t, e.prototype = Object.create(t.prototype, { constructor: {
			value: e,
			enumerable: !1,
			writable: !0,
			configurable: !0
		} }));
	} : t.exports = function(e, t) {
		if (t) {
			e.super_ = t;
			var n = function() {};
			n.prototype = t.prototype, e.prototype = new n(), e.prototype.constructor = e;
		}
	};
})), Nte = /* @__PURE__ */ V(((e, t) => {
	var n = typeof Reflect == "object" ? Reflect : null, r = n && typeof n.apply == "function" ? n.apply : function(e, t, n) {
		return Function.prototype.apply.call(e, t, n);
	}, i = n && typeof n.ownKeys == "function" ? n.ownKeys : Object.getOwnPropertySymbols ? function(e) {
		return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
	} : function(e) {
		return Object.getOwnPropertyNames(e);
	};
	function a(e) {
		console && console.warn && console.warn(e);
	}
	var o = Number.isNaN || function(e) {
		return e !== e;
	};
	function s() {
		s.init.call(this);
	}
	t.exports = s, t.exports.once = y, s.EventEmitter = s, s.prototype._events = void 0, s.prototype._eventsCount = 0, s.prototype._maxListeners = void 0;
	var c = 10;
	function l(e) {
		if (typeof e != "function") throw TypeError("The \"listener\" argument must be of type Function. Received type " + typeof e);
	}
	Object.defineProperty(s, "defaultMaxListeners", {
		enumerable: !0,
		get: function() {
			return c;
		},
		set: function(e) {
			if (typeof e != "number" || e < 0 || o(e)) throw RangeError("The value of \"defaultMaxListeners\" is out of range. It must be a non-negative number. Received " + e + ".");
			c = e;
		}
	}), s.init = function() {
		(this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
	}, s.prototype.setMaxListeners = function(e) {
		if (typeof e != "number" || e < 0 || o(e)) throw RangeError("The value of \"n\" is out of range. It must be a non-negative number. Received " + e + ".");
		return this._maxListeners = e, this;
	};
	function u(e) {
		return e._maxListeners === void 0 ? s.defaultMaxListeners : e._maxListeners;
	}
	s.prototype.getMaxListeners = function() {
		return u(this);
	}, s.prototype.emit = function(e) {
		for (var t = [], n = 1; n < arguments.length; n++) t.push(arguments[n]);
		var i = e === "error", a = this._events;
		if (a !== void 0) i &&= a.error === void 0;
		else if (!i) return !1;
		if (i) {
			var o;
			if (t.length > 0 && (o = t[0]), o instanceof Error) throw o;
			var s = /* @__PURE__ */ Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
			throw s.context = o, s;
		}
		var c = a[e];
		if (c === void 0) return !1;
		if (typeof c == "function") r(c, this, t);
		else for (var l = c.length, u = g(c, l), n = 0; n < l; ++n) r(u[n], this, t);
		return !0;
	};
	function d(e, t, n, r) {
		var i, o, s;
		if (l(n), o = e._events, o === void 0 ? (o = e._events = Object.create(null), e._eventsCount = 0) : (o.newListener !== void 0 && (e.emit("newListener", t, n.listener ? n.listener : n), o = e._events), s = o[t]), s === void 0) s = o[t] = n, ++e._eventsCount;
		else if (typeof s == "function" ? s = o[t] = r ? [n, s] : [s, n] : r ? s.unshift(n) : s.push(n), i = u(e), i > 0 && s.length > i && !s.warned) {
			s.warned = !0;
			var c = /* @__PURE__ */ Error("Possible EventEmitter memory leak detected. " + s.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
			c.name = "MaxListenersExceededWarning", c.emitter = e, c.type = t, c.count = s.length, a(c);
		}
		return e;
	}
	s.prototype.addListener = function(e, t) {
		return d(this, e, t, !1);
	}, s.prototype.on = s.prototype.addListener, s.prototype.prependListener = function(e, t) {
		return d(this, e, t, !0);
	};
	function f() {
		if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
	}
	function p(e, t, n) {
		var r = {
			fired: !1,
			wrapFn: void 0,
			target: e,
			type: t,
			listener: n
		}, i = f.bind(r);
		return i.listener = n, r.wrapFn = i, i;
	}
	s.prototype.once = function(e, t) {
		return l(t), this.on(e, p(this, e, t)), this;
	}, s.prototype.prependOnceListener = function(e, t) {
		return l(t), this.prependListener(e, p(this, e, t)), this;
	}, s.prototype.removeListener = function(e, t) {
		var n, r, i, a, o;
		if (l(t), r = this._events, r === void 0 || (n = r[e], n === void 0)) return this;
		if (n === t || n.listener === t) --this._eventsCount === 0 ? this._events = Object.create(null) : (delete r[e], r.removeListener && this.emit("removeListener", e, n.listener || t));
		else if (typeof n != "function") {
			for (i = -1, a = n.length - 1; a >= 0; a--) if (n[a] === t || n[a].listener === t) {
				o = n[a].listener, i = a;
				break;
			}
			if (i < 0) return this;
			i === 0 ? n.shift() : _(n, i), n.length === 1 && (r[e] = n[0]), r.removeListener !== void 0 && this.emit("removeListener", e, o || t);
		}
		return this;
	}, s.prototype.off = s.prototype.removeListener, s.prototype.removeAllListeners = function(e) {
		var t, n = this._events, r;
		if (n === void 0) return this;
		if (n.removeListener === void 0) return arguments.length === 0 ? (this._events = Object.create(null), this._eventsCount = 0) : n[e] !== void 0 && (--this._eventsCount === 0 ? this._events = Object.create(null) : delete n[e]), this;
		if (arguments.length === 0) {
			var i = Object.keys(n), a;
			for (r = 0; r < i.length; ++r) a = i[r], a !== "removeListener" && this.removeAllListeners(a);
			return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
		}
		if (t = n[e], typeof t == "function") this.removeListener(e, t);
		else if (t !== void 0) for (r = t.length - 1; r >= 0; r--) this.removeListener(e, t[r]);
		return this;
	};
	function m(e, t, n) {
		var r = e._events;
		if (r === void 0) return [];
		var i = r[t];
		return i === void 0 ? [] : typeof i == "function" ? n ? [i.listener || i] : [i] : n ? v(i) : g(i, i.length);
	}
	s.prototype.listeners = function(e) {
		return m(this, e, !0);
	}, s.prototype.rawListeners = function(e) {
		return m(this, e, !1);
	}, s.listenerCount = function(e, t) {
		return typeof e.listenerCount == "function" ? e.listenerCount(t) : h.call(e, t);
	}, s.prototype.listenerCount = h;
	function h(e) {
		var t = this._events;
		if (t !== void 0) {
			var n = t[e];
			if (typeof n == "function") return 1;
			if (n !== void 0) return n.length;
		}
		return 0;
	}
	s.prototype.eventNames = function() {
		return this._eventsCount > 0 ? i(this._events) : [];
	};
	function g(e, t) {
		for (var n = Array(t), r = 0; r < t; ++r) n[r] = e[r];
		return n;
	}
	function _(e, t) {
		for (; t + 1 < e.length; t++) e[t] = e[t + 1];
		e.pop();
	}
	function v(e) {
		for (var t = Array(e.length), n = 0; n < t.length; ++n) t[n] = e[n].listener || e[n];
		return t;
	}
	function y(e, t) {
		return new Promise(function(n, r) {
			function i(n) {
				e.removeListener(t, a), r(n);
			}
			function a() {
				typeof e.removeListener == "function" && e.removeListener("error", i), n([].slice.call(arguments));
			}
			x(e, t, a, { once: !0 }), t !== "error" && b(e, i, { once: !0 });
		});
	}
	function b(e, t, n) {
		typeof e.on == "function" && x(e, "error", t, n);
	}
	function x(e, t, n, r) {
		if (typeof e.on == "function") r.once ? e.once(t, n) : e.on(t, n);
		else if (typeof e.addEventListener == "function") e.addEventListener(t, function i(a) {
			r.once && e.removeEventListener(t, i), n(a);
		});
		else throw TypeError("The \"emitter\" argument must be of type EventEmitter. Received type " + typeof e);
	}
})), Pte = /* @__PURE__ */ V(((e, t) => {
	var n = Mte(), r = Nte().EventEmitter;
	t.exports = i, t.exports.default = i;
	function i(e) {
		if (!(this instanceof i)) return new i(e);
		r.call(this), e ||= {}, this.concurrency = e.concurrency || Infinity, this.timeout = e.timeout || 0, this.autostart = e.autostart || !1, this.results = e.results || null, this.pending = 0, this.session = 0, this.running = !1, this.jobs = [], this.timers = {};
	}
	n(i, r), [
		"pop",
		"shift",
		"indexOf",
		"lastIndexOf"
	].forEach(function(e) {
		i.prototype[e] = function() {
			return Array.prototype[e].apply(this.jobs, arguments);
		};
	}), i.prototype.slice = function(e, t) {
		return this.jobs = this.jobs.slice(e, t), this;
	}, i.prototype.reverse = function() {
		return this.jobs.reverse(), this;
	}, [
		"push",
		"unshift",
		"splice"
	].forEach(function(e) {
		i.prototype[e] = function() {
			var t = Array.prototype[e].apply(this.jobs, arguments);
			return this.autostart && this.start(), t;
		};
	}), Object.defineProperty(i.prototype, "length", { get: function() {
		return this.pending + this.jobs.length;
	} }), i.prototype.start = function(e) {
		if (e && o.call(this, e), this.running = !0, this.pending >= this.concurrency) return;
		if (this.jobs.length === 0) {
			this.pending === 0 && s.call(this);
			return;
		}
		var t = this, n = this.jobs.shift(), r = !0, i = this.session, a = null, c = !1, l = null, u = n.hasOwnProperty("timeout") ? n.timeout : this.timeout;
		function d(e, o) {
			r && t.session === i && (r = !1, t.pending--, a !== null && (delete t.timers[a], clearTimeout(a)), e ? t.emit("error", e, n) : c === !1 && (l !== null && (t.results[l] = Array.prototype.slice.call(arguments, 1)), t.emit("success", o, n)), t.session === i && (t.pending === 0 && t.jobs.length === 0 ? s.call(t) : t.running && t.start()));
		}
		u && (a = setTimeout(function() {
			c = !0, t.listeners("timeout").length > 0 ? t.emit("timeout", d, n) : d();
		}, u), this.timers[a] = a), this.results && (l = this.results.length, this.results[l] = null), this.pending++, t.emit("start", n);
		var f = n(d);
		f && f.then && typeof f.then == "function" && f.then(function(e) {
			return d(null, e);
		}).catch(function(e) {
			return d(e || !0);
		}), this.running && this.jobs.length > 0 && this.start();
	}, i.prototype.stop = function() {
		this.running = !1;
	}, i.prototype.end = function(e) {
		a.call(this), this.jobs.length = 0, this.pending = 0, s.call(this, e);
	};
	function a() {
		for (var e in this.timers) {
			var t = this.timers[e];
			delete this.timers[e], clearTimeout(t);
		}
	}
	function o(e) {
		var t = this;
		this.on("error", n), this.on("end", r);
		function n(e) {
			t.end(e);
		}
		function r(i) {
			t.removeListener("error", n), t.removeListener("end", r), e(i, this.results);
		}
	}
	function s(e) {
		this.session++, this.running = !1, this.emit("end", e);
	}
})), Fte = /* @__PURE__ */ V(((e, t) => {
	t.exports = a;
	var n = /^(?:\w+:)?\/\/(\S+)$/, r = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/, i = /^[^\s\.]+\.\S{2,}$/;
	function a(e) {
		if (typeof e != "string") return !1;
		var t = e.match(n);
		if (!t) return !1;
		var a = t[1];
		return a ? !!(r.test(a) || i.test(a)) : !1;
	}
}));
Pte(), Fte();
var Ite = {
	utf16le: "utf-16le",
	ucs2: "utf-16le",
	utf16be: "utf-16be"
}, fy = class {
	constructor(e) {
		this.buffer = e, this.view = new DataView(e.buffer, e.byteOffset, e.byteLength), this.pos = 0, this.length = this.buffer.length;
	}
	readString(e, t = "ascii") {
		t = Ite[t] || t;
		let n = this.readBuffer(e);
		try {
			return new TextDecoder(t).decode(n);
		} catch {
			return n;
		}
	}
	readBuffer(e) {
		return this.buffer.slice(this.pos, this.pos += e);
	}
	readUInt24BE() {
		return (this.readUInt16BE() << 8) + this.readUInt8();
	}
	readUInt24LE() {
		return this.readUInt16LE() + (this.readUInt8() << 16);
	}
	readInt24BE() {
		return (this.readInt16BE() << 8) + this.readUInt8();
	}
	readInt24LE() {
		return this.readUInt16LE() + (this.readInt8() << 16);
	}
};
fy.TYPES = {
	UInt8: 1,
	UInt16: 2,
	UInt24: 3,
	UInt32: 4,
	Int8: 1,
	Int16: 2,
	Int24: 3,
	Int32: 4,
	Float: 4,
	Double: 8
};
for (let e of Object.getOwnPropertyNames(DataView.prototype)) if (e.slice(0, 3) === "get") {
	let t = e.slice(3).replace("Ui", "UI");
	t === "Float32" ? t = "Float" : t === "Float64" && (t = "Double");
	let n = fy.TYPES[t];
	fy.prototype["read" + t + (n === 1 ? "" : "BE")] = function() {
		let t = this.view[e](this.pos, !1);
		return this.pos += n, t;
	}, n !== 1 && (fy.prototype["read" + t + "LE"] = function() {
		let t = this.view[e](this.pos, !0);
		return this.pos += n, t;
	});
}
//#endregion
//#region ../../node_modules/restructure/src/EncodeStream.js
var Lte = new TextEncoder(), py = new Uint8Array(new Uint16Array([4660]).buffer)[0] == 18, my = class {
	constructor(e) {
		this.buffer = e, this.view = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength), this.pos = 0;
	}
	writeBuffer(e) {
		this.buffer.set(e, this.pos), this.pos += e.length;
	}
	writeString(e, t = "ascii") {
		let n;
		switch (t) {
			case "utf16le":
			case "utf16-le":
			case "ucs2":
				n = hy(e, py);
				break;
			case "utf16be":
			case "utf16-be":
				n = hy(e, !py);
				break;
			case "utf8":
				n = Lte.encode(e);
				break;
			case "ascii":
				n = Rte(e);
				break;
			default: throw Error(`Unsupported encoding: ${t}`);
		}
		this.writeBuffer(n);
	}
	writeUInt24BE(e) {
		this.buffer[this.pos++] = e >>> 16 & 255, this.buffer[this.pos++] = e >>> 8 & 255, this.buffer[this.pos++] = e & 255;
	}
	writeUInt24LE(e) {
		this.buffer[this.pos++] = e & 255, this.buffer[this.pos++] = e >>> 8 & 255, this.buffer[this.pos++] = e >>> 16 & 255;
	}
	writeInt24BE(e) {
		e >= 0 ? this.writeUInt24BE(e) : this.writeUInt24BE(e + 16777215 + 1);
	}
	writeInt24LE(e) {
		e >= 0 ? this.writeUInt24LE(e) : this.writeUInt24LE(e + 16777215 + 1);
	}
	fill(e, t) {
		if (t < this.buffer.length) this.buffer.fill(e, this.pos, this.pos + t), this.pos += t;
		else {
			let n = new Uint8Array(t);
			n.fill(e), this.writeBuffer(n);
		}
	}
};
function hy(e, t) {
	let n = new Uint16Array(e.length);
	for (let r = 0; r < e.length; r++) {
		let i = e.charCodeAt(r);
		t && (i = i >> 8 | (i & 255) << 8), n[r] = i;
	}
	return new Uint8Array(n.buffer);
}
function Rte(e) {
	let t = new Uint8Array(e.length);
	for (let n = 0; n < e.length; n++) t[n] = e.charCodeAt(n);
	return t;
}
for (let e of Object.getOwnPropertyNames(DataView.prototype)) if (e.slice(0, 3) === "set") {
	let t = e.slice(3).replace("Ui", "UI");
	t === "Float32" ? t = "Float" : t === "Float64" && (t = "Double");
	let n = fy.TYPES[t];
	my.prototype["write" + t + (n === 1 ? "" : "BE")] = function(t) {
		this.view[e](this.pos, t, !1), this.pos += n;
	}, n !== 1 && (my.prototype["write" + t + "LE"] = function(t) {
		this.view[e](this.pos, t, !0), this.pos += n;
	});
}
//#endregion
//#region ../../node_modules/restructure/src/Base.js
var gy = class {
	fromBuffer(e) {
		let t = new fy(e);
		return this.decode(t);
	}
	toBuffer(e) {
		let t = this.size(e), n = new Uint8Array(t), r = new my(n);
		return this.encode(r, e), n;
	}
}, _y = class extends gy {
	constructor(e, t = "BE") {
		super(), this.type = e, this.endian = t, this.fn = this.type, this.type[this.type.length - 1] !== "8" && (this.fn += this.endian);
	}
	size() {
		return fy.TYPES[this.type];
	}
	decode(e) {
		return e[`read${this.fn}`]();
	}
	encode(e, t) {
		return e[`write${this.fn}`](t);
	}
}, vy = new _y("UInt8"), yy = new _y("UInt16", "BE"), H = yy, zte = new _y("UInt16", "LE"), by = new _y("UInt24", "BE");
new _y("UInt24", "LE");
var xy = new _y("UInt32", "BE"), U = xy, Bte = new _y("UInt32", "LE"), Sy = new _y("Int8"), W = new _y("Int16", "BE");
new _y("Int16", "LE"), new _y("Int24", "BE"), new _y("Int24", "LE");
var Cy = new _y("Int32", "BE");
new _y("Int32", "LE"), new _y("Float", "BE"), new _y("Float", "LE"), new _y("Double", "BE"), new _y("Double", "LE");
var wy = class extends _y {
	constructor(e, t, n = e >> 1) {
		super(`Int${e}`, t), this._point = 1 << n;
	}
	decode(e) {
		return super.decode(e) / this._point;
	}
	encode(e, t) {
		return super.encode(e, t * this._point | 0);
	}
}, Vte = new wy(16, "BE");
new wy(16, "LE");
var Ty = new wy(32, "BE");
new wy(32, "LE");
//#endregion
//#region ../../node_modules/restructure/src/utils.js
function Ey(e, t, n) {
	let r;
	if (typeof e == "number" ? r = e : typeof e == "function" ? r = e.call(n, n) : n && typeof e == "string" ? r = n[e] : t && e instanceof _y && (r = e.decode(t)), isNaN(r)) throw Error("Not a fixed size");
	return r;
}
var Dy = class {
	constructor(e = {}) {
		this.enumerable = !0, this.configurable = !0;
		for (let t in e) {
			let n = e[t];
			this[t] = n;
		}
	}
}, G = class extends gy {
	constructor(e, t, n = "count") {
		super(), this.type = e, this.length = t, this.lengthType = n;
	}
	decode(e, t) {
		let n, { pos: r } = e, i = [], a = t;
		if (this.length != null && (n = Ey(this.length, e, t)), this.length instanceof _y && (Object.defineProperties(i, {
			parent: { value: t },
			_startOffset: { value: r },
			_currentOffset: {
				value: 0,
				writable: !0
			},
			_length: { value: n }
		}), a = i), n == null || this.lengthType === "bytes") {
			let r = n == null ? t?._length ? t._startOffset + t._length : e.length : e.pos + n;
			for (; e.pos < r;) i.push(this.type.decode(e, a));
		} else for (let t = 0, r = n; t < r; t++) i.push(this.type.decode(e, a));
		return i;
	}
	size(e, t, n = !0) {
		if (!e) return this.type.size(null, t) * Ey(this.length, null, t);
		let r = 0;
		this.length instanceof _y && (r += this.length.size(), t = {
			parent: t,
			pointerSize: 0
		});
		for (let n of e) r += this.type.size(n, t);
		return t && n && this.length instanceof _y && (r += t.pointerSize), r;
	}
	encode(e, t, n) {
		let r = n;
		this.length instanceof _y && (r = {
			pointers: [],
			startOffset: e.pos,
			parent: n
		}, r.pointerOffset = e.pos + this.size(t, r, !1), this.length.encode(e, t.length));
		for (let n of t) this.type.encode(e, n, r);
		if (this.length instanceof _y) {
			let t = 0;
			for (; t < r.pointers.length;) {
				let n = r.pointers[t++];
				n.type.encode(e, n.val, n.parent);
			}
		}
	}
}, Oy = class extends G {
	decode(e, t) {
		let { pos: n } = e, r = Ey(this.length, e, t);
		this.length instanceof _y && (t = {
			parent: t,
			_startOffset: n,
			_currentOffset: 0,
			_length: r
		});
		let i = new ky(this.type, r, e, t);
		return e.pos += r * this.type.size(null, t), i;
	}
	size(e, t) {
		return e instanceof ky && (e = e.toArray()), super.size(e, t);
	}
	encode(e, t, n) {
		return t instanceof ky && (t = t.toArray()), super.encode(e, t, n);
	}
}, ky = class {
	constructor(e, t, n, r) {
		this.type = e, this.length = t, this.stream = n, this.ctx = r, this.base = this.stream.pos, this.items = [];
	}
	get(e) {
		if (!(e < 0 || e >= this.length)) {
			if (this.items[e] == null) {
				let { pos: t } = this.stream;
				this.stream.pos = this.base + this.type.size(null, this.ctx) * e, this.items[e] = this.type.decode(this.stream, this.ctx), this.stream.pos = t;
			}
			return this.items[e];
		}
	}
	toArray() {
		let e = [];
		for (let t = 0, n = this.length; t < n; t++) e.push(this.get(t));
		return e;
	}
}, Ay = class extends gy {
	constructor(e, t = []) {
		super(), this.type = e, this.flags = t;
	}
	decode(e) {
		let t = this.type.decode(e), n = {};
		for (let e = 0; e < this.flags.length; e++) {
			let r = this.flags[e];
			r != null && (n[r] = !!(t & 1 << e));
		}
		return n;
	}
	size() {
		return this.type.size();
	}
	encode(e, t) {
		let n = 0;
		for (let e = 0; e < this.flags.length; e++) {
			let r = this.flags[e];
			r != null && t[r] && (n |= 1 << e);
		}
		return this.type.encode(e, n);
	}
}, jy = class extends gy {
	constructor(e) {
		super(), this.length = e;
	}
	decode(e, t) {
		let n = Ey(this.length, e, t);
		return e.readBuffer(n);
	}
	size(e, t) {
		if (!e) return Ey(this.length, null, t);
		let n = e.length;
		return this.length instanceof _y && (n += this.length.size()), n;
	}
	encode(e, t, n) {
		return this.length instanceof _y && this.length.encode(e, t.length), e.writeBuffer(t);
	}
}, My = class extends gy {
	constructor(e, t = !0) {
		super(), this.type = e, this.condition = t;
	}
	decode(e, t) {
		let { condition: n } = this;
		if (typeof n == "function" && (n = n.call(t, t)), n) return this.type.decode(e, t);
	}
	size(e, t) {
		let { condition: n } = this;
		return typeof n == "function" && (n = n.call(t, t)), n ? this.type.size(e, t) : 0;
	}
	encode(e, t, n) {
		let { condition: r } = this;
		if (typeof r == "function" && (r = r.call(n, n)), r) return this.type.encode(e, t, n);
	}
}, Ny = class extends gy {
	constructor(e, t = 1) {
		super(), this.type = e, this.count = t;
	}
	decode(e, t) {
		e.pos += this.size(null, t);
	}
	size(e, t) {
		let n = Ey(this.count, null, t);
		return this.type.size() * n;
	}
	encode(e, t, n) {
		return e.fill(0, this.size(t, n));
	}
}, Py = class extends gy {
	constructor(e, t = "ascii") {
		super(), this.length = e, this.encoding = t;
	}
	decode(e, t) {
		let n, r, { encoding: i } = this;
		typeof i == "function" && (i = i.call(t, t) || "ascii");
		let a = Fy(i);
		if (this.length != null) n = Ey(this.length, e, t);
		else {
			let t;
			for ({buffer: t, length: n, pos: r} = e; r < n - a + 1 && (t[r] !== 0 || a === 2 && t[r + 1] !== 0);) r += a;
			n = r - e.pos;
		}
		let o = e.readString(n, i);
		return this.length == null && e.pos < e.length && (e.pos += a), o;
	}
	size(e, t) {
		if (e == null) return Ey(this.length, null, t);
		let { encoding: n } = this;
		typeof n == "function" && (n = n.call(t?.val, t?.val) || "ascii"), n === "utf16be" && (n = "utf16le");
		let r = Iy(e, n);
		return this.length instanceof _y && (r += this.length.size()), this.length ?? (r += Fy(n)), r;
	}
	encode(e, t, n) {
		let { encoding: r } = this;
		if (typeof r == "function" && (r = r.call(n?.val, n?.val) || "ascii"), this.length instanceof _y && this.length.encode(e, Iy(t, r)), e.writeString(t, r), this.length == null) return Fy(r) == 2 ? e.writeUInt16LE(0) : e.writeUInt8(0);
	}
};
function Fy(e) {
	switch (e) {
		case "ascii":
		case "utf8": return 1;
		case "utf16le":
		case "utf16-le":
		case "utf-16be":
		case "utf-16le":
		case "utf16be":
		case "utf16-be":
		case "ucs2": return 2;
		default: return 1;
	}
}
function Iy(e, t) {
	switch (t) {
		case "ascii": return e.length;
		case "utf8":
			let n = 0;
			for (let t = 0; t < e.length; t++) {
				let r = e.charCodeAt(t);
				if (r >= 55296 && r <= 56319 && t < e.length - 1) {
					let n = e.charCodeAt(++t);
					(n & 64512) == 56320 ? r = ((r & 1023) << 10) + (n & 1023) + 65536 : t--;
				}
				r & 4294967168 ? r & 4294965248 ? r & 4294901760 ? r & 4292870144 || (n += 4) : n += 3 : n += 2 : n++;
			}
			return n;
		case "utf16le":
		case "utf16-le":
		case "utf16be":
		case "utf16-be":
		case "ucs2": return e.length * 2;
		default: throw Error("Unknown encoding " + t);
	}
}
//#endregion
//#region ../../node_modules/restructure/src/Struct.js
var K = class extends gy {
	constructor(e = {}) {
		super(), this.fields = e;
	}
	decode(e, t, n = 0) {
		let r = this._setup(e, t, n);
		return this._parseFields(e, r, this.fields), this.process != null && this.process.call(r, e), r;
	}
	_setup(e, t, n) {
		let r = {};
		return Object.defineProperties(r, {
			parent: { value: t },
			_startOffset: { value: e.pos },
			_currentOffset: {
				value: 0,
				writable: !0
			},
			_length: { value: n }
		}), r;
	}
	_parseFields(e, t, n) {
		for (let i in n) {
			var r;
			let a = n[i];
			r = typeof a == "function" ? a.call(t, t) : a.decode(e, t), r !== void 0 && (r instanceof Dy ? Object.defineProperty(t, i, r) : t[i] = r), t._currentOffset = e.pos - t._startOffset;
		}
	}
	size(e, t, n = !0) {
		e ??= {};
		let r = {
			parent: t,
			val: e,
			pointerSize: 0
		};
		this.preEncode != null && this.preEncode.call(e);
		let i = 0;
		for (let t in this.fields) {
			let n = this.fields[t];
			n.size != null && (i += n.size(e[t], r));
		}
		return n && (i += r.pointerSize), i;
	}
	encode(e, t, n) {
		let r;
		this.preEncode != null && this.preEncode.call(t, e);
		let i = {
			pointers: [],
			startOffset: e.pos,
			parent: n,
			val: t,
			pointerSize: 0
		};
		i.pointerOffset = e.pos + this.size(t, i, !1);
		for (let n in this.fields) r = this.fields[n], r.encode != null && r.encode(e, t[n], i);
		let a = 0;
		for (; a < i.pointers.length;) {
			let t = i.pointers[a++];
			t.type.encode(e, t.val, t.parent);
		}
	}
}, Hte = (e, t) => t.reduce((e, t) => e && e[t], e), Ly = class e extends K {
	constructor(e, t = {}) {
		super(), this.type = e, this.versions = t, typeof e == "string" && (this.versionPath = e.split("."));
	}
	decode(t, n, r = 0) {
		let i = this._setup(t, n, r);
		typeof this.type == "string" ? i.version = Hte(n, this.versionPath) : i.version = this.type.decode(t), this.versions.header && this._parseFields(t, i, this.versions.header);
		let a = this.versions[i.version];
		if (a == null) throw Error(`Unknown version ${i.version}`);
		return a instanceof e ? a.decode(t, n) : (this._parseFields(t, i, a), this.process != null && this.process.call(i, t), i);
	}
	size(e, t, n = !0) {
		let r, i;
		if (!e) throw Error("Not a fixed size");
		this.preEncode != null && this.preEncode.call(e);
		let a = {
			parent: t,
			val: e,
			pointerSize: 0
		}, o = 0;
		if (typeof this.type != "string" && (o += this.type.size(e.version, a)), this.versions.header) for (r in this.versions.header) i = this.versions.header[r], i.size != null && (o += i.size(e[r], a));
		let s = this.versions[e.version];
		if (s == null) throw Error(`Unknown version ${e.version}`);
		for (r in s) i = s[r], i.size != null && (o += i.size(e[r], a));
		return n && (o += a.pointerSize), o;
	}
	encode(e, t, n) {
		let r, i;
		this.preEncode != null && this.preEncode.call(t, e);
		let a = {
			pointers: [],
			startOffset: e.pos,
			parent: n,
			val: t,
			pointerSize: 0
		};
		if (a.pointerOffset = e.pos + this.size(t, a, !1), typeof this.type != "string" && this.type.encode(e, t.version), this.versions.header) for (r in this.versions.header) i = this.versions.header[r], i.encode != null && i.encode(e, t[r], a);
		let o = this.versions[t.version];
		for (r in o) i = o[r], i.encode != null && i.encode(e, t[r], a);
		let s = 0;
		for (; s < a.pointers.length;) {
			let t = a.pointers[s++];
			t.type.encode(e, t.val, t.parent);
		}
	}
}, q = class extends gy {
	constructor(e, t, n = {}) {
		if (super(), this.offsetType = e, this.type = t, this.options = n, this.type === "void" && (this.type = null), this.options.type ?? (this.options.type = "local"), this.options.allowNull ?? (this.options.allowNull = !0), this.options.nullValue ?? (this.options.nullValue = 0), this.options.lazy ?? (this.options.lazy = !1), this.options.relativeTo) {
			if (typeof this.options.relativeTo != "function") throw Error("relativeTo option must be a function");
			this.relativeToGetter = n.relativeTo;
		}
	}
	decode(e, t) {
		let n = this.offsetType.decode(e, t);
		if (n === this.options.nullValue && this.options.allowNull) return null;
		let r;
		switch (this.options.type) {
			case "local":
				r = t._startOffset;
				break;
			case "immediate":
				r = e.pos - this.offsetType.size();
				break;
			case "parent":
				r = t.parent._startOffset;
				break;
			default:
				for (var i = t; i.parent;) i = i.parent;
				r = i._startOffset || 0;
		}
		this.options.relativeTo && (r += this.relativeToGetter(t));
		let a = n + r;
		if (this.type != null) {
			let n = null, r = () => {
				if (n != null) return n;
				let { pos: r } = e;
				return e.pos = a, n = this.type.decode(e, t), e.pos = r, n;
			};
			return this.options.lazy ? new Dy({ get: r }) : r();
		} else return a;
	}
	size(e, t) {
		let n = t;
		switch (this.options.type) {
			case "local":
			case "immediate": break;
			case "parent":
				t = t.parent;
				break;
			default: for (; t.parent;) t = t.parent;
		}
		let { type: r } = this;
		if (r == null) {
			if (!(e instanceof Ry)) throw Error("Must be a VoidPointer");
			({type: r} = e), e = e.value;
		}
		if (e && t) {
			let i = r.size(e, n);
			t.pointerSize += i;
		}
		return this.offsetType.size();
	}
	encode(e, t, n) {
		let r, i = n;
		if (t == null) {
			this.offsetType.encode(e, this.options.nullValue);
			return;
		}
		switch (this.options.type) {
			case "local":
				r = n.startOffset;
				break;
			case "immediate":
				r = e.pos + this.offsetType.size(t, i);
				break;
			case "parent":
				n = n.parent, r = n.startOffset;
				break;
			default: for (r = 0; n.parent;) n = n.parent;
		}
		this.options.relativeTo && (r += this.relativeToGetter(i.val)), this.offsetType.encode(e, n.pointerOffset - r);
		let { type: a } = this;
		if (a == null) {
			if (!(t instanceof Ry)) throw Error("Must be a VoidPointer");
			({type: a} = t), t = t.value;
		}
		return n.pointers.push({
			type: a,
			val: t,
			parent: i
		}), n.pointerOffset += a.size(t, i);
	}
}, Ry = class {
	constructor(e, t) {
		this.type = e, this.value = t;
	}
};
//#endregion
//#region ../../node_modules/@swc/helpers/esm/_define_property.js
function zy(e, t, n) {
	return t in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
//#endregion
//#region ../../node_modules/tslib/tslib.es6.mjs
function By(e, t, n, r) {
	var i = arguments.length, a = i < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, n) : r, o;
	if (typeof Reflect == "object" && typeof Reflect.decorate == "function") a = Reflect.decorate(e, t, n, r);
	else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
	return i > 3 && a && Object.defineProperty(t, n, a), a;
}
//#endregion
//#region ../../node_modules/fast-deep-equal/index.js
var Ute = /* @__PURE__ */ V(((e, t) => {
	t.exports = function e(t, n) {
		if (t === n) return !0;
		if (t && n && typeof t == "object" && typeof n == "object") {
			if (t.constructor !== n.constructor) return !1;
			var r, i, a;
			if (Array.isArray(t)) {
				if (r = t.length, r != n.length) return !1;
				for (i = r; i-- !== 0;) if (!e(t[i], n[i])) return !1;
				return !0;
			}
			if (t.constructor === RegExp) return t.source === n.source && t.flags === n.flags;
			if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === n.valueOf();
			if (t.toString !== Object.prototype.toString) return t.toString() === n.toString();
			if (a = Object.keys(t), r = a.length, r !== Object.keys(n).length) return !1;
			for (i = r; i-- !== 0;) if (!Object.prototype.hasOwnProperty.call(n, a[i])) return !1;
			for (i = r; i-- !== 0;) {
				var o = a[i];
				if (!e(t[o], n[o])) return !1;
			}
			return !0;
		}
		return t !== t && n !== n;
	};
})), Vy = /* @__PURE__ */ V(((e) => {
	e.byteLength = c, e.toByteArray = u, e.fromByteArray = p;
	for (var t = [], n = [], r = typeof Uint8Array < "u" ? Uint8Array : Array, i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = 0, o = i.length; a < o; ++a) t[a] = i[a], n[i.charCodeAt(a)] = a;
	n[45] = 62, n[95] = 63;
	function s(e) {
		var t = e.length;
		if (t % 4 > 0) throw Error("Invalid string. Length must be a multiple of 4");
		var n = e.indexOf("=");
		n === -1 && (n = t);
		var r = n === t ? 0 : 4 - n % 4;
		return [n, r];
	}
	function c(e) {
		var t = s(e), n = t[0], r = t[1];
		return (n + r) * 3 / 4 - r;
	}
	function l(e, t, n) {
		return (t + n) * 3 / 4 - n;
	}
	function u(e) {
		var t, i = s(e), a = i[0], o = i[1], c = new r(l(e, a, o)), u = 0, d = o > 0 ? a - 4 : a, f;
		for (f = 0; f < d; f += 4) t = n[e.charCodeAt(f)] << 18 | n[e.charCodeAt(f + 1)] << 12 | n[e.charCodeAt(f + 2)] << 6 | n[e.charCodeAt(f + 3)], c[u++] = t >> 16 & 255, c[u++] = t >> 8 & 255, c[u++] = t & 255;
		return o === 2 && (t = n[e.charCodeAt(f)] << 2 | n[e.charCodeAt(f + 1)] >> 4, c[u++] = t & 255), o === 1 && (t = n[e.charCodeAt(f)] << 10 | n[e.charCodeAt(f + 1)] << 4 | n[e.charCodeAt(f + 2)] >> 2, c[u++] = t >> 8 & 255, c[u++] = t & 255), c;
	}
	function d(e) {
		return t[e >> 18 & 63] + t[e >> 12 & 63] + t[e >> 6 & 63] + t[e & 63];
	}
	function f(e, t, n) {
		for (var r, i = [], a = t; a < n; a += 3) r = (e[a] << 16 & 16711680) + (e[a + 1] << 8 & 65280) + (e[a + 2] & 255), i.push(d(r));
		return i.join("");
	}
	function p(e) {
		for (var n, r = e.length, i = r % 3, a = [], o = 16383, s = 0, c = r - i; s < c; s += o) a.push(f(e, s, s + o > c ? c : s + o));
		return i === 1 ? (n = e[r - 1], a.push(t[n >> 2] + t[n << 4 & 63] + "==")) : i === 2 && (n = (e[r - 2] << 8) + e[r - 1], a.push(t[n >> 10] + t[n >> 4 & 63] + t[n << 2 & 63] + "=")), a.join("");
	}
})), Hy = /* @__PURE__ */ V(((e, t) => {
	var n = 0, r = -3;
	function i() {
		this.table = new Uint16Array(16), this.trans = new Uint16Array(288);
	}
	function a(e, t) {
		this.source = e, this.sourceIndex = 0, this.tag = 0, this.bitcount = 0, this.dest = t, this.destLen = 0, this.ltree = new i(), this.dtree = new i();
	}
	var o = new i(), s = new i(), c = new Uint8Array(30), l = new Uint16Array(30), u = new Uint8Array(30), d = new Uint16Array(30), f = new Uint8Array([
		16,
		17,
		18,
		0,
		8,
		7,
		9,
		6,
		10,
		5,
		11,
		4,
		12,
		3,
		13,
		2,
		14,
		1,
		15
	]), p = new i(), m = new Uint8Array(320);
	function h(e, t, n, r) {
		var i, a;
		for (i = 0; i < n; ++i) e[i] = 0;
		for (i = 0; i < 30 - n; ++i) e[i + n] = i / n | 0;
		for (a = r, i = 0; i < 30; ++i) t[i] = a, a += 1 << e[i];
	}
	function g(e, t) {
		var n;
		for (n = 0; n < 7; ++n) e.table[n] = 0;
		for (e.table[7] = 24, e.table[8] = 152, e.table[9] = 112, n = 0; n < 24; ++n) e.trans[n] = 256 + n;
		for (n = 0; n < 144; ++n) e.trans[24 + n] = n;
		for (n = 0; n < 8; ++n) e.trans[168 + n] = 280 + n;
		for (n = 0; n < 112; ++n) e.trans[176 + n] = 144 + n;
		for (n = 0; n < 5; ++n) t.table[n] = 0;
		for (t.table[5] = 32, n = 0; n < 32; ++n) t.trans[n] = n;
	}
	var _ = new Uint16Array(16);
	function v(e, t, n, r) {
		var i, a;
		for (i = 0; i < 16; ++i) e.table[i] = 0;
		for (i = 0; i < r; ++i) e.table[t[n + i]]++;
		for (e.table[0] = 0, a = 0, i = 0; i < 16; ++i) _[i] = a, a += e.table[i];
		for (i = 0; i < r; ++i) t[n + i] && (e.trans[_[t[n + i]]++] = i);
	}
	function y(e) {
		e.bitcount-- || (e.tag = e.source[e.sourceIndex++], e.bitcount = 7);
		var t = e.tag & 1;
		return e.tag >>>= 1, t;
	}
	function b(e, t, n) {
		if (!t) return n;
		for (; e.bitcount < 24;) e.tag |= e.source[e.sourceIndex++] << e.bitcount, e.bitcount += 8;
		var r = e.tag & 65535 >>> 16 - t;
		return e.tag >>>= t, e.bitcount -= t, r + n;
	}
	function x(e, t) {
		for (; e.bitcount < 24;) e.tag |= e.source[e.sourceIndex++] << e.bitcount, e.bitcount += 8;
		var n = 0, r = 0, i = 0, a = e.tag;
		do
			r = 2 * r + (a & 1), a >>>= 1, ++i, n += t.table[i], r -= t.table[i];
		while (r >= 0);
		return e.tag = a, e.bitcount -= i, t.trans[n + r];
	}
	function S(e, t, n) {
		var r = b(e, 5, 257), i = b(e, 5, 1), a = b(e, 4, 4), o, s, c;
		for (o = 0; o < 19; ++o) m[o] = 0;
		for (o = 0; o < a; ++o) {
			var l = b(e, 3, 0);
			m[f[o]] = l;
		}
		for (v(p, m, 0, 19), s = 0; s < r + i;) {
			var u = x(e, p);
			switch (u) {
				case 16:
					var d = m[s - 1];
					for (c = b(e, 2, 3); c; --c) m[s++] = d;
					break;
				case 17:
					for (c = b(e, 3, 3); c; --c) m[s++] = 0;
					break;
				case 18:
					for (c = b(e, 7, 11); c; --c) m[s++] = 0;
					break;
				default:
					m[s++] = u;
					break;
			}
		}
		v(t, m, 0, r), v(n, m, r, i);
	}
	function C(e, t, r) {
		for (;;) {
			var i = x(e, t);
			if (i === 256) return n;
			if (i < 256) e.dest[e.destLen++] = i;
			else {
				var a, o, s, f;
				for (i -= 257, a = b(e, c[i], l[i]), o = x(e, r), s = e.destLen - b(e, u[o], d[o]), f = s; f < s + a; ++f) e.dest[e.destLen++] = e.dest[f];
			}
		}
	}
	function w(e) {
		for (var t, i, a; e.bitcount > 8;) e.sourceIndex--, e.bitcount -= 8;
		if (t = e.source[e.sourceIndex + 1], t = 256 * t + e.source[e.sourceIndex], i = e.source[e.sourceIndex + 3], i = 256 * i + e.source[e.sourceIndex + 2], t !== (~i & 65535)) return r;
		for (e.sourceIndex += 4, a = t; a; --a) e.dest[e.destLen++] = e.source[e.sourceIndex++];
		return e.bitcount = 0, n;
	}
	function T(e, t) {
		var i = new a(e, t), c, l, u;
		do {
			switch (c = y(i), l = b(i, 2, 0), l) {
				case 0:
					u = w(i);
					break;
				case 1:
					u = C(i, o, s);
					break;
				case 2:
					S(i, i.ltree, i.dtree), u = C(i, i.ltree, i.dtree);
					break;
				default: u = r;
			}
			if (u !== n) throw Error("Data error");
		} while (!c);
		return i.destLen < i.dest.length ? typeof i.dest.slice == "function" ? i.dest.slice(0, i.destLen) : i.dest.subarray(0, i.destLen) : i.dest;
	}
	g(o, s), h(c, l, 4, 3), h(u, d, 2, 1), c[28] = 0, l[28] = 258, t.exports = T;
})), Wte = /* @__PURE__ */ V(((e, t) => {
	var n = new Uint8Array(new Uint32Array([305419896]).buffer)[0] === 18, r = (e, t, n) => {
		let r = e[t];
		e[t] = e[n], e[n] = r;
	}, i = (e) => {
		let t = e.length;
		for (let n = 0; n < t; n += 4) r(e, n, n + 3), r(e, n + 1, n + 2);
	};
	t.exports = { swap32LE: (e) => {
		n && i(e);
	} };
})), Gte = /* @__PURE__ */ V(((e, t) => {
	var n = Hy(), { swap32LE: r } = Wte(), i = 11, a = 5, o = i - a, s = 32, c = (1 << o) - 1, l = 2, u = (1 << a) - 1, d = 2048, f = 2112, p = 1 << l;
	t.exports = class {
		constructor(e) {
			let t = typeof e.readUInt32BE == "function" && typeof e.slice == "function";
			if (t || e instanceof Uint8Array) {
				let i;
				if (t) this.highStart = e.readUInt32LE(0), this.errorValue = e.readUInt32LE(4), i = e.readUInt32LE(8), e = e.slice(12);
				else {
					let t = new DataView(e.buffer);
					this.highStart = t.getUint32(0, !0), this.errorValue = t.getUint32(4, !0), i = t.getUint32(8, !0), e = e.subarray(12);
				}
				e = n(e, new Uint8Array(i)), e = n(e, new Uint8Array(i)), r(e), this.data = new Uint32Array(e.buffer);
			} else ({data: this.data, highStart: this.highStart, errorValue: this.errorValue} = e);
		}
		get(e) {
			let t;
			return e < 0 || e > 1114111 ? this.errorValue : e < 55296 || e > 56319 && e <= 65535 ? (t = (this.data[e >> a] << l) + (e & u), this.data[t]) : e <= 65535 ? (t = (this.data[d + (e - 55296 >> a)] << l) + (e & u), this.data[t]) : e < this.highStart ? (t = this.data[f - s + (e >> i)], t = this.data[t + (e >> a & c)], t = (t << l) + (e & u), this.data[t]) : this.data[this.data.length - p];
		}
	};
})), Uy = /* @__PURE__ */ xt(Ute(), 1), Kte = /* @__PURE__ */ xt(Vy(), 1), Wy = /* @__PURE__ */ xt(Gte(), 1);
function Gy(e) {
	return e && e.__esModule ? e.default : e;
}
var Ky = {};
Ky = JSON.parse("{\"categories\":[\"Cc\",\"Zs\",\"Po\",\"Sc\",\"Ps\",\"Pe\",\"Sm\",\"Pd\",\"Nd\",\"Lu\",\"Sk\",\"Pc\",\"Ll\",\"So\",\"Lo\",\"Pi\",\"Cf\",\"No\",\"Pf\",\"Lt\",\"Lm\",\"Mn\",\"Me\",\"Mc\",\"Nl\",\"Zl\",\"Zp\",\"Cs\",\"Co\"],\"combiningClasses\":[\"Not_Reordered\",\"Above\",\"Above_Right\",\"Below\",\"Attached_Above_Right\",\"Attached_Below\",\"Overlay\",\"Iota_Subscript\",\"Double_Below\",\"Double_Above\",\"Below_Right\",\"Above_Left\",\"CCC10\",\"CCC11\",\"CCC12\",\"CCC13\",\"CCC14\",\"CCC15\",\"CCC16\",\"CCC17\",\"CCC18\",\"CCC19\",\"CCC20\",\"CCC21\",\"CCC22\",\"CCC23\",\"CCC24\",\"CCC25\",\"CCC30\",\"CCC31\",\"CCC32\",\"CCC27\",\"CCC28\",\"CCC29\",\"CCC33\",\"CCC34\",\"CCC35\",\"CCC36\",\"Nukta\",\"Virama\",\"CCC84\",\"CCC91\",\"CCC103\",\"CCC107\",\"CCC118\",\"CCC122\",\"CCC129\",\"CCC130\",\"CCC132\",\"Attached_Above\",\"Below_Left\",\"Left\",\"Kana_Voicing\",\"CCC26\",\"Right\"],\"scripts\":[\"Common\",\"Latin\",\"Bopomofo\",\"Inherited\",\"Greek\",\"Coptic\",\"Cyrillic\",\"Armenian\",\"Hebrew\",\"Arabic\",\"Syriac\",\"Thaana\",\"Nko\",\"Samaritan\",\"Mandaic\",\"Devanagari\",\"Bengali\",\"Gurmukhi\",\"Gujarati\",\"Oriya\",\"Tamil\",\"Telugu\",\"Kannada\",\"Malayalam\",\"Sinhala\",\"Thai\",\"Lao\",\"Tibetan\",\"Myanmar\",\"Georgian\",\"Hangul\",\"Ethiopic\",\"Cherokee\",\"Canadian_Aboriginal\",\"Ogham\",\"Runic\",\"Tagalog\",\"Hanunoo\",\"Buhid\",\"Tagbanwa\",\"Khmer\",\"Mongolian\",\"Limbu\",\"Tai_Le\",\"New_Tai_Lue\",\"Buginese\",\"Tai_Tham\",\"Balinese\",\"Sundanese\",\"Batak\",\"Lepcha\",\"Ol_Chiki\",\"Braille\",\"Glagolitic\",\"Tifinagh\",\"Han\",\"Hiragana\",\"Katakana\",\"Yi\",\"Lisu\",\"Vai\",\"Bamum\",\"Syloti_Nagri\",\"Phags_Pa\",\"Saurashtra\",\"Kayah_Li\",\"Rejang\",\"Javanese\",\"Cham\",\"Tai_Viet\",\"Meetei_Mayek\",\"null\",\"Linear_B\",\"Lycian\",\"Carian\",\"Old_Italic\",\"Gothic\",\"Old_Permic\",\"Ugaritic\",\"Old_Persian\",\"Deseret\",\"Shavian\",\"Osmanya\",\"Osage\",\"Elbasan\",\"Caucasian_Albanian\",\"Linear_A\",\"Cypriot\",\"Imperial_Aramaic\",\"Palmyrene\",\"Nabataean\",\"Hatran\",\"Phoenician\",\"Lydian\",\"Meroitic_Hieroglyphs\",\"Meroitic_Cursive\",\"Kharoshthi\",\"Old_South_Arabian\",\"Old_North_Arabian\",\"Manichaean\",\"Avestan\",\"Inscriptional_Parthian\",\"Inscriptional_Pahlavi\",\"Psalter_Pahlavi\",\"Old_Turkic\",\"Old_Hungarian\",\"Hanifi_Rohingya\",\"Old_Sogdian\",\"Sogdian\",\"Elymaic\",\"Brahmi\",\"Kaithi\",\"Sora_Sompeng\",\"Chakma\",\"Mahajani\",\"Sharada\",\"Khojki\",\"Multani\",\"Khudawadi\",\"Grantha\",\"Newa\",\"Tirhuta\",\"Siddham\",\"Modi\",\"Takri\",\"Ahom\",\"Dogra\",\"Warang_Citi\",\"Nandinagari\",\"Zanabazar_Square\",\"Soyombo\",\"Pau_Cin_Hau\",\"Bhaiksuki\",\"Marchen\",\"Masaram_Gondi\",\"Gunjala_Gondi\",\"Makasar\",\"Cuneiform\",\"Egyptian_Hieroglyphs\",\"Anatolian_Hieroglyphs\",\"Mro\",\"Bassa_Vah\",\"Pahawh_Hmong\",\"Medefaidrin\",\"Miao\",\"Tangut\",\"Nushu\",\"Duployan\",\"SignWriting\",\"Nyiakeng_Puachue_Hmong\",\"Wancho\",\"Mende_Kikakui\",\"Adlam\"],\"eaw\":[\"N\",\"Na\",\"A\",\"W\",\"H\",\"F\"]}");
var qy = new Wy.default(Kte.toByteArray("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")), qte = Math.log2 || ((e) => Math.log(e) / Math.LN2), Jy = (e) => qte(e) + 1 | 0, Jte = Jy((/*@__PURE__*/ Gy(Ky)).categories.length - 1), Yy = Jy((/*@__PURE__*/ Gy(Ky)).combiningClasses.length - 1), Xy = Jy((/*@__PURE__*/ Gy(Ky)).scripts.length - 1), Zy = Jy((/*@__PURE__*/ Gy(Ky)).eaw.length - 1), Qy = 10, Yte = Yy + Xy + Zy + Qy, Xte = Xy + Zy + Qy, Zte = Zy + Qy, Qte = Qy, $te = (1 << Jte) - 1, ene = (1 << Yy) - 1, tne = (1 << Xy) - 1, nne = (1 << Zy) - 1, rne = (1 << Qy) - 1;
function $y(e) {
	let t = qy.get(e);
	return (/*@__PURE__*/ Gy(Ky)).categories[t >> Yte & $te];
}
function eb(e) {
	let t = qy.get(e);
	return (/*@__PURE__*/ Gy(Ky)).combiningClasses[t >> Xte & ene];
}
function tb(e) {
	let t = qy.get(e);
	return (/*@__PURE__*/ Gy(Ky)).scripts[t >> Zte & tne];
}
function ine(e) {
	let t = qy.get(e);
	return (/*@__PURE__*/ Gy(Ky)).eaw[t >> Qte & nne];
}
function ane(e) {
	let t = qy.get(e), n = t & rne;
	if (n === 0) return null;
	if (n <= 50) return n - 1;
	if (n < 480) return ((n >> 4) - 12) / ((n & 15) + 1);
	if (n < 768) {
		t = (n >> 5) - 14;
		let e = (n & 31) + 2;
		for (; e > 0;) t *= 10, e--;
		return t;
	} else {
		t = (n >> 2) - 191;
		let e = (n & 3) + 1;
		for (; e > 0;) t *= 60, e--;
		return t;
	}
}
function one(e) {
	let t = $y(e);
	return t === "Lu" || t === "Ll" || t === "Lt" || t === "Lm" || t === "Lo" || t === "Nl";
}
function nb(e) {
	return $y(e) === "Nd";
}
function sne(e) {
	let t = $y(e);
	return t === "Pc" || t === "Pd" || t === "Pe" || t === "Pf" || t === "Pi" || t === "Po" || t === "Ps";
}
function rb(e) {
	return $y(e) === "Ll";
}
function ib(e) {
	return $y(e) === "Lu";
}
function ab(e) {
	return $y(e) === "Lt";
}
function ob(e) {
	let t = $y(e);
	return t === "Zs" || t === "Zl" || t === "Zp";
}
function sb(e) {
	let t = $y(e);
	return t === "Nd" || t === "No" || t === "Nl" || t === "Lu" || t === "Ll" || t === "Lt" || t === "Lm" || t === "Lo" || t === "Me" || t === "Mc";
}
function cb(e) {
	let t = $y(e);
	return t === "Mn" || t === "Me" || t === "Mc";
}
var lb = {
	getCategory: $y,
	getCombiningClass: eb,
	getScript: tb,
	getEastAsianWidth: ine,
	getNumericValue: ane,
	isAlphabetic: one,
	isDigit: nb,
	isPunctuation: sne,
	isLowerCase: rb,
	isUpperCase: ib,
	isTitleCase: ab,
	isWhiteSpace: ob,
	isBaseForm: sb,
	isMark: cb
}, ub = /* @__PURE__ */ V(((e, t) => {
	var n = 1, r = 0;
	t.exports = class {
		constructor(e) {
			this.stateTable = e.stateTable, this.accepting = e.accepting, this.tags = e.tags;
		}
		match(e) {
			var t = this;
			return { *[Symbol.iterator]() {
				for (var i = n, a = null, o = null, s = null, c = 0; c < e.length; c++) {
					var l = e[c];
					s = i, i = t.stateTable[i][l], i === r && (a != null && o != null && o >= a && (yield [
						a,
						o,
						t.tags[s]
					]), i = t.stateTable[n][l], a = null), i !== r && a == null && (a = c), t.accepting[i] && (o = c), i === r && (i = n);
				}
				a != null && o != null && o >= a && (yield [
					a,
					o,
					t.tags[i]
				]);
			} };
		}
		apply(e, t) {
			for (var [n, r, i] of this.match(e)) for (var a of i) typeof t[a] == "function" && t[a](n, r, e.slice(n, r + 1));
		}
	};
})), db = /* @__PURE__ */ V(((e, t) => {
	var n = (function() {
		function e(e, t) {
			return t != null && e instanceof t;
		}
		var t;
		try {
			t = Map;
		} catch {
			t = function() {};
		}
		var n;
		try {
			n = Set;
		} catch {
			n = function() {};
		}
		var r;
		try {
			r = Promise;
		} catch {
			r = function() {};
		}
		function i(a, o, s, c, u) {
			typeof o == "object" && (s = o.depth, c = o.prototype, u = o.includeNonEnumerable, o = o.circular);
			var d = [], f = [], p = typeof Buffer < "u";
			o === void 0 && (o = !0), s === void 0 && (s = Infinity);
			function m(a, s) {
				if (a === null) return null;
				if (s === 0) return a;
				var h, g;
				if (typeof a != "object") return a;
				if (e(a, t)) h = new t();
				else if (e(a, n)) h = new n();
				else if (e(a, r)) h = new r(function(e, t) {
					a.then(function(t) {
						e(m(t, s - 1));
					}, function(e) {
						t(m(e, s - 1));
					});
				});
				else if (i.__isArray(a)) h = [];
				else if (i.__isRegExp(a)) h = new RegExp(a.source, l(a)), a.lastIndex && (h.lastIndex = a.lastIndex);
				else if (i.__isDate(a)) h = new Date(a.getTime());
				else if (p && Buffer.isBuffer(a)) return h = Buffer.allocUnsafe ? Buffer.allocUnsafe(a.length) : new Buffer(a.length), a.copy(h), h;
				else e(a, Error) ? h = Object.create(a) : c === void 0 ? (g = Object.getPrototypeOf(a), h = Object.create(g)) : (h = Object.create(c), g = c);
				if (o) {
					var _ = d.indexOf(a);
					if (_ != -1) return f[_];
					d.push(a), f.push(h);
				}
				for (var v in e(a, t) && a.forEach(function(e, t) {
					var n = m(t, s - 1), r = m(e, s - 1);
					h.set(n, r);
				}), e(a, n) && a.forEach(function(e) {
					var t = m(e, s - 1);
					h.add(t);
				}), a) {
					var y;
					g && (y = Object.getOwnPropertyDescriptor(g, v)), !(y && y.set == null) && (h[v] = m(a[v], s - 1));
				}
				if (Object.getOwnPropertySymbols) for (var b = Object.getOwnPropertySymbols(a), v = 0; v < b.length; v++) {
					var x = b[v], S = Object.getOwnPropertyDescriptor(a, x);
					S && !S.enumerable && !u || (h[x] = m(a[x], s - 1), S.enumerable || Object.defineProperty(h, x, { enumerable: !1 }));
				}
				if (u) for (var C = Object.getOwnPropertyNames(a), v = 0; v < C.length; v++) {
					var w = C[v], S = Object.getOwnPropertyDescriptor(a, w);
					S && S.enumerable || (h[w] = m(a[w], s - 1), Object.defineProperty(h, w, { enumerable: !1 }));
				}
				return h;
			}
			return m(a, s);
		}
		i.clonePrototype = function(e) {
			if (e === null) return null;
			var t = function() {};
			return t.prototype = e, new t();
		};
		function a(e) {
			return Object.prototype.toString.call(e);
		}
		i.__objToStr = a;
		function o(e) {
			return typeof e == "object" && a(e) === "[object Date]";
		}
		i.__isDate = o;
		function s(e) {
			return typeof e == "object" && a(e) === "[object Array]";
		}
		i.__isArray = s;
		function c(e) {
			return typeof e == "object" && a(e) === "[object RegExp]";
		}
		i.__isRegExp = c;
		function l(e) {
			var t = "";
			return e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), t;
		}
		return i.__getRegExpFlags = l, i;
	})();
	typeof t == "object" && t.exports && (t.exports = n);
})), fb = /* @__PURE__ */ V(((e) => {
	function t(e) {
		this.buffer = e, this.pos = 0;
	}
	t.prototype.read = function(e, t, n) {
		this.pos + n > this.buffer.length && (n = this.buffer.length - this.pos);
		for (var r = 0; r < n; r++) e[t + r] = this.buffer[this.pos + r];
		return this.pos += n, n;
	}, e.BrotliInput = t;
	function n(e) {
		this.buffer = e, this.pos = 0;
	}
	n.prototype.write = function(e, t) {
		if (this.pos + t > this.buffer.length) throw Error("Output buffer is not large enough");
		return this.buffer.set(e.subarray(0, t), this.pos), this.pos += t, t;
	}, e.BrotliOutput = n;
})), pb = /* @__PURE__ */ V(((e, t) => {
	var n = 4096, r = 2 * n + 32, i = 2 * n - 1, a = new Uint32Array([
		0,
		1,
		3,
		7,
		15,
		31,
		63,
		127,
		255,
		511,
		1023,
		2047,
		4095,
		8191,
		16383,
		32767,
		65535,
		131071,
		262143,
		524287,
		1048575,
		2097151,
		4194303,
		8388607,
		16777215
	]);
	function o(e) {
		this.buf_ = new Uint8Array(r), this.input_ = e, this.reset();
	}
	o.READ_SIZE = n, o.IBUF_MASK = i, o.prototype.reset = function() {
		this.buf_ptr_ = 0, this.val_ = 0, this.pos_ = 0, this.bit_pos_ = 0, this.bit_end_pos_ = 0, this.eos_ = 0, this.readMoreInput();
		for (var e = 0; e < 4; e++) this.val_ |= this.buf_[this.pos_] << 8 * e, ++this.pos_;
		return this.bit_end_pos_ > 0;
	}, o.prototype.readMoreInput = function() {
		if (!(this.bit_end_pos_ > 256)) if (this.eos_) {
			if (this.bit_pos_ > this.bit_end_pos_) throw Error("Unexpected end of input " + this.bit_pos_ + " " + this.bit_end_pos_);
		} else {
			var e = this.buf_ptr_, t = this.input_.read(this.buf_, e, n);
			if (t < 0) throw Error("Unexpected end of input");
			if (t < n) {
				this.eos_ = 1;
				for (var r = 0; r < 32; r++) this.buf_[e + t + r] = 0;
			}
			if (e === 0) {
				for (var r = 0; r < 32; r++) this.buf_[(n << 1) + r] = this.buf_[r];
				this.buf_ptr_ = n;
			} else this.buf_ptr_ = 0;
			this.bit_end_pos_ += t << 3;
		}
	}, o.prototype.fillBitWindow = function() {
		for (; this.bit_pos_ >= 8;) this.val_ >>>= 8, this.val_ |= this.buf_[this.pos_ & i] << 24, ++this.pos_, this.bit_pos_ = this.bit_pos_ - 8 >>> 0, this.bit_end_pos_ = this.bit_end_pos_ - 8 >>> 0;
	}, o.prototype.readBits = function(e) {
		32 - this.bit_pos_ < e && this.fillBitWindow();
		var t = this.val_ >>> this.bit_pos_ & a[e];
		return this.bit_pos_ += e, t;
	}, t.exports = o;
})), mb = /* @__PURE__ */ V(((e, t) => {
	t.exports = "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";
})), hb = /* @__PURE__ */ V(((e) => {
	var t = Vy();
	e.init = function() {
		var e = xb().BrotliDecompressBuffer;
		return e(t.toByteArray(mb()));
	};
})), gb = /* @__PURE__ */ V(((e) => {
	var t = hb();
	e.init = function() {
		e.dictionary = t.init();
	}, e.offsetsByLength = new Uint32Array([
		0,
		0,
		0,
		0,
		0,
		4096,
		9216,
		21504,
		35840,
		44032,
		53248,
		63488,
		74752,
		87040,
		93696,
		100864,
		104704,
		106752,
		108928,
		113536,
		115968,
		118528,
		119872,
		121280,
		122016
	]), e.sizeBitsByLength = new Uint8Array([
		0,
		0,
		0,
		0,
		10,
		10,
		11,
		11,
		10,
		10,
		10,
		10,
		10,
		9,
		9,
		8,
		7,
		7,
		8,
		7,
		7,
		6,
		6,
		5,
		5
	]), e.minDictionaryWordLength = 4, e.maxDictionaryWordLength = 24;
})), _b = /* @__PURE__ */ V(((e) => {
	function t(e, t) {
		this.bits = e, this.value = t;
	}
	e.HuffmanCode = t;
	var n = 15;
	function r(e, t) {
		for (var n = 1 << t - 1; e & n;) n >>= 1;
		return (e & n - 1) + n;
	}
	function i(e, n, r, i, a) {
		do
			i -= r, e[n + i] = new t(a.bits, a.value);
		while (i > 0);
	}
	function a(e, t, r) {
		for (var i = 1 << t - r; t < n && (i -= e[t], !(i <= 0));) ++t, i <<= 1;
		return t - r;
	}
	e.BrotliBuildHuffmanTable = function(e, o, s, c, l) {
		var u = o, d, f, p, m, h, g, _, v, y, b, x, S = new Int32Array(n + 1), C = new Int32Array(n + 1);
		for (x = new Int32Array(l), p = 0; p < l; p++) S[c[p]]++;
		for (C[1] = 0, f = 1; f < n; f++) C[f + 1] = C[f] + S[f];
		for (p = 0; p < l; p++) c[p] !== 0 && (x[C[c[p]]++] = p);
		if (v = s, y = 1 << v, b = y, C[n] === 1) {
			for (m = 0; m < b; ++m) e[o + m] = new t(0, x[0] & 65535);
			return b;
		}
		for (m = 0, p = 0, f = 1, h = 2; f <= s; ++f, h <<= 1) for (; S[f] > 0; --S[f]) d = new t(f & 255, x[p++] & 65535), i(e, o + m, h, y, d), m = r(m, f);
		for (_ = b - 1, g = -1, f = s + 1, h = 2; f <= n; ++f, h <<= 1) for (; S[f] > 0; --S[f]) (m & _) !== g && (o += y, v = a(S, f, s), y = 1 << v, b += y, g = m & _, e[u + g] = new t(v + s & 255, o - u - g & 65535)), d = new t(f - s & 255, x[p++] & 65535), i(e, o + (m >> s), h, y, d), m = r(m, f);
		return b;
	};
})), vb = /* @__PURE__ */ V(((e) => {
	e.lookup = new Uint8Array([
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		4,
		4,
		0,
		0,
		4,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		8,
		12,
		16,
		12,
		12,
		20,
		12,
		16,
		24,
		28,
		12,
		12,
		32,
		12,
		36,
		12,
		44,
		44,
		44,
		44,
		44,
		44,
		44,
		44,
		44,
		44,
		32,
		32,
		24,
		40,
		28,
		12,
		12,
		48,
		52,
		52,
		52,
		48,
		52,
		52,
		52,
		48,
		52,
		52,
		52,
		52,
		52,
		48,
		52,
		52,
		52,
		52,
		52,
		48,
		52,
		52,
		52,
		52,
		52,
		24,
		12,
		28,
		12,
		12,
		12,
		56,
		60,
		60,
		60,
		56,
		60,
		60,
		60,
		56,
		60,
		60,
		60,
		60,
		60,
		56,
		60,
		60,
		60,
		60,
		60,
		56,
		60,
		60,
		60,
		60,
		60,
		24,
		12,
		28,
		12,
		0,
		0,
		1,
		0,
		1,
		0,
		1,
		0,
		1,
		0,
		1,
		0,
		1,
		0,
		1,
		0,
		1,
		0,
		1,
		0,
		1,
		0,
		1,
		0,
		1,
		0,
		1,
		0,
		1,
		0,
		1,
		0,
		1,
		0,
		1,
		0,
		1,
		0,
		1,
		0,
		1,
		0,
		1,
		0,
		1,
		0,
		1,
		0,
		1,
		0,
		1,
		0,
		1,
		0,
		1,
		0,
		1,
		0,
		1,
		0,
		1,
		0,
		1,
		0,
		1,
		2,
		3,
		2,
		3,
		2,
		3,
		2,
		3,
		2,
		3,
		2,
		3,
		2,
		3,
		2,
		3,
		2,
		3,
		2,
		3,
		2,
		3,
		2,
		3,
		2,
		3,
		2,
		3,
		2,
		3,
		2,
		3,
		2,
		3,
		2,
		3,
		2,
		3,
		2,
		3,
		2,
		3,
		2,
		3,
		2,
		3,
		2,
		3,
		2,
		3,
		2,
		3,
		2,
		3,
		2,
		3,
		2,
		3,
		2,
		3,
		2,
		3,
		2,
		3,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		1,
		1,
		1,
		1,
		1,
		1,
		1,
		1,
		1,
		1,
		1,
		1,
		1,
		1,
		1,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		1,
		1,
		1,
		1,
		1,
		1,
		1,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		1,
		1,
		1,
		1,
		1,
		1,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		1,
		1,
		1,
		1,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		0,
		1,
		1,
		1,
		1,
		1,
		1,
		1,
		1,
		1,
		1,
		1,
		1,
		1,
		1,
		1,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		2,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		3,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		4,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		5,
		6,
		6,
		6,
		6,
		6,
		6,
		6,
		6,
		6,
		6,
		6,
		6,
		6,
		6,
		6,
		7,
		0,
		8,
		8,
		8,
		8,
		8,
		8,
		8,
		8,
		8,
		8,
		8,
		8,
		8,
		8,
		8,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		24,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		32,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		40,
		48,
		48,
		48,
		48,
		48,
		48,
		48,
		48,
		48,
		48,
		48,
		48,
		48,
		48,
		48,
		56,
		0,
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		8,
		9,
		10,
		11,
		12,
		13,
		14,
		15,
		16,
		17,
		18,
		19,
		20,
		21,
		22,
		23,
		24,
		25,
		26,
		27,
		28,
		29,
		30,
		31,
		32,
		33,
		34,
		35,
		36,
		37,
		38,
		39,
		40,
		41,
		42,
		43,
		44,
		45,
		46,
		47,
		48,
		49,
		50,
		51,
		52,
		53,
		54,
		55,
		56,
		57,
		58,
		59,
		60,
		61,
		62,
		63,
		0,
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		8,
		9,
		10,
		11,
		12,
		13,
		14,
		15,
		16,
		17,
		18,
		19,
		20,
		21,
		22,
		23,
		24,
		25,
		26,
		27,
		28,
		29,
		30,
		31,
		32,
		33,
		34,
		35,
		36,
		37,
		38,
		39,
		40,
		41,
		42,
		43,
		44,
		45,
		46,
		47,
		48,
		49,
		50,
		51,
		52,
		53,
		54,
		55,
		56,
		57,
		58,
		59,
		60,
		61,
		62,
		63,
		0,
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		8,
		9,
		10,
		11,
		12,
		13,
		14,
		15,
		16,
		17,
		18,
		19,
		20,
		21,
		22,
		23,
		24,
		25,
		26,
		27,
		28,
		29,
		30,
		31,
		32,
		33,
		34,
		35,
		36,
		37,
		38,
		39,
		40,
		41,
		42,
		43,
		44,
		45,
		46,
		47,
		48,
		49,
		50,
		51,
		52,
		53,
		54,
		55,
		56,
		57,
		58,
		59,
		60,
		61,
		62,
		63,
		0,
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		8,
		9,
		10,
		11,
		12,
		13,
		14,
		15,
		16,
		17,
		18,
		19,
		20,
		21,
		22,
		23,
		24,
		25,
		26,
		27,
		28,
		29,
		30,
		31,
		32,
		33,
		34,
		35,
		36,
		37,
		38,
		39,
		40,
		41,
		42,
		43,
		44,
		45,
		46,
		47,
		48,
		49,
		50,
		51,
		52,
		53,
		54,
		55,
		56,
		57,
		58,
		59,
		60,
		61,
		62,
		63,
		0,
		0,
		0,
		0,
		1,
		1,
		1,
		1,
		2,
		2,
		2,
		2,
		3,
		3,
		3,
		3,
		4,
		4,
		4,
		4,
		5,
		5,
		5,
		5,
		6,
		6,
		6,
		6,
		7,
		7,
		7,
		7,
		8,
		8,
		8,
		8,
		9,
		9,
		9,
		9,
		10,
		10,
		10,
		10,
		11,
		11,
		11,
		11,
		12,
		12,
		12,
		12,
		13,
		13,
		13,
		13,
		14,
		14,
		14,
		14,
		15,
		15,
		15,
		15,
		16,
		16,
		16,
		16,
		17,
		17,
		17,
		17,
		18,
		18,
		18,
		18,
		19,
		19,
		19,
		19,
		20,
		20,
		20,
		20,
		21,
		21,
		21,
		21,
		22,
		22,
		22,
		22,
		23,
		23,
		23,
		23,
		24,
		24,
		24,
		24,
		25,
		25,
		25,
		25,
		26,
		26,
		26,
		26,
		27,
		27,
		27,
		27,
		28,
		28,
		28,
		28,
		29,
		29,
		29,
		29,
		30,
		30,
		30,
		30,
		31,
		31,
		31,
		31,
		32,
		32,
		32,
		32,
		33,
		33,
		33,
		33,
		34,
		34,
		34,
		34,
		35,
		35,
		35,
		35,
		36,
		36,
		36,
		36,
		37,
		37,
		37,
		37,
		38,
		38,
		38,
		38,
		39,
		39,
		39,
		39,
		40,
		40,
		40,
		40,
		41,
		41,
		41,
		41,
		42,
		42,
		42,
		42,
		43,
		43,
		43,
		43,
		44,
		44,
		44,
		44,
		45,
		45,
		45,
		45,
		46,
		46,
		46,
		46,
		47,
		47,
		47,
		47,
		48,
		48,
		48,
		48,
		49,
		49,
		49,
		49,
		50,
		50,
		50,
		50,
		51,
		51,
		51,
		51,
		52,
		52,
		52,
		52,
		53,
		53,
		53,
		53,
		54,
		54,
		54,
		54,
		55,
		55,
		55,
		55,
		56,
		56,
		56,
		56,
		57,
		57,
		57,
		57,
		58,
		58,
		58,
		58,
		59,
		59,
		59,
		59,
		60,
		60,
		60,
		60,
		61,
		61,
		61,
		61,
		62,
		62,
		62,
		62,
		63,
		63,
		63,
		63,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0
	]), e.lookupOffsets = new Uint16Array([
		1024,
		1536,
		1280,
		1536,
		0,
		256,
		768,
		512
	]);
})), yb = /* @__PURE__ */ V(((e) => {
	function t(e, t) {
		this.offset = e, this.nbits = t;
	}
	e.kBlockLengthPrefixCode = [
		new t(1, 2),
		new t(5, 2),
		new t(9, 2),
		new t(13, 2),
		new t(17, 3),
		new t(25, 3),
		new t(33, 3),
		new t(41, 3),
		new t(49, 4),
		new t(65, 4),
		new t(81, 4),
		new t(97, 4),
		new t(113, 5),
		new t(145, 5),
		new t(177, 5),
		new t(209, 5),
		new t(241, 6),
		new t(305, 6),
		new t(369, 7),
		new t(497, 8),
		new t(753, 9),
		new t(1265, 10),
		new t(2289, 11),
		new t(4337, 12),
		new t(8433, 13),
		new t(16625, 24)
	], e.kInsertLengthPrefixCode = [
		new t(0, 0),
		new t(1, 0),
		new t(2, 0),
		new t(3, 0),
		new t(4, 0),
		new t(5, 0),
		new t(6, 1),
		new t(8, 1),
		new t(10, 2),
		new t(14, 2),
		new t(18, 3),
		new t(26, 3),
		new t(34, 4),
		new t(50, 4),
		new t(66, 5),
		new t(98, 5),
		new t(130, 6),
		new t(194, 7),
		new t(322, 8),
		new t(578, 9),
		new t(1090, 10),
		new t(2114, 12),
		new t(6210, 14),
		new t(22594, 24)
	], e.kCopyLengthPrefixCode = [
		new t(2, 0),
		new t(3, 0),
		new t(4, 0),
		new t(5, 0),
		new t(6, 0),
		new t(7, 0),
		new t(8, 0),
		new t(9, 0),
		new t(10, 1),
		new t(12, 1),
		new t(14, 2),
		new t(18, 2),
		new t(22, 3),
		new t(30, 3),
		new t(38, 4),
		new t(54, 4),
		new t(70, 5),
		new t(102, 5),
		new t(134, 6),
		new t(198, 7),
		new t(326, 8),
		new t(582, 9),
		new t(1094, 10),
		new t(2118, 24)
	], e.kInsertRangeLut = [
		0,
		0,
		8,
		8,
		0,
		16,
		8,
		16,
		16
	], e.kCopyRangeLut = [
		0,
		8,
		0,
		8,
		16,
		0,
		16,
		8,
		16
	];
})), bb = /* @__PURE__ */ V(((e) => {
	var t = gb(), n = 0, r = 1, i = 2, a = 3, o = 4, s = 5, c = 6, l = 7, u = 8, d = 9, f = 10, p = 11, m = 12, h = 13, g = 14, _ = 15, v = 16, y = 17, b = 18, x = 20;
	function S(e, t, n) {
		this.prefix = new Uint8Array(e.length), this.transform = t, this.suffix = new Uint8Array(n.length);
		for (var r = 0; r < e.length; r++) this.prefix[r] = e.charCodeAt(r);
		for (var r = 0; r < n.length; r++) this.suffix[r] = n.charCodeAt(r);
	}
	var C = [
		new S("", n, ""),
		new S("", n, " "),
		new S(" ", n, " "),
		new S("", m, ""),
		new S("", f, " "),
		new S("", n, " the "),
		new S(" ", n, ""),
		new S("s ", n, " "),
		new S("", n, " of "),
		new S("", f, ""),
		new S("", n, " and "),
		new S("", h, ""),
		new S("", r, ""),
		new S(", ", n, " "),
		new S("", n, ", "),
		new S(" ", f, " "),
		new S("", n, " in "),
		new S("", n, " to "),
		new S("e ", n, " "),
		new S("", n, "\""),
		new S("", n, "."),
		new S("", n, "\">"),
		new S("", n, "\n"),
		new S("", a, ""),
		new S("", n, "]"),
		new S("", n, " for "),
		new S("", g, ""),
		new S("", i, ""),
		new S("", n, " a "),
		new S("", n, " that "),
		new S(" ", f, ""),
		new S("", n, ". "),
		new S(".", n, ""),
		new S(" ", n, ", "),
		new S("", _, ""),
		new S("", n, " with "),
		new S("", n, "'"),
		new S("", n, " from "),
		new S("", n, " by "),
		new S("", v, ""),
		new S("", y, ""),
		new S(" the ", n, ""),
		new S("", o, ""),
		new S("", n, ". The "),
		new S("", p, ""),
		new S("", n, " on "),
		new S("", n, " as "),
		new S("", n, " is "),
		new S("", l, ""),
		new S("", r, "ing "),
		new S("", n, "\n	"),
		new S("", n, ":"),
		new S(" ", n, ". "),
		new S("", n, "ed "),
		new S("", x, ""),
		new S("", b, ""),
		new S("", c, ""),
		new S("", n, "("),
		new S("", f, ", "),
		new S("", u, ""),
		new S("", n, " at "),
		new S("", n, "ly "),
		new S(" the ", n, " of "),
		new S("", s, ""),
		new S("", d, ""),
		new S(" ", f, ", "),
		new S("", f, "\""),
		new S(".", n, "("),
		new S("", p, " "),
		new S("", f, "\">"),
		new S("", n, "=\""),
		new S(" ", n, "."),
		new S(".com/", n, ""),
		new S(" the ", n, " of the "),
		new S("", f, "'"),
		new S("", n, ". This "),
		new S("", n, ","),
		new S(".", n, " "),
		new S("", f, "("),
		new S("", f, "."),
		new S("", n, " not "),
		new S(" ", n, "=\""),
		new S("", n, "er "),
		new S(" ", p, " "),
		new S("", n, "al "),
		new S(" ", p, ""),
		new S("", n, "='"),
		new S("", p, "\""),
		new S("", f, ". "),
		new S(" ", n, "("),
		new S("", n, "ful "),
		new S(" ", f, ". "),
		new S("", n, "ive "),
		new S("", n, "less "),
		new S("", p, "'"),
		new S("", n, "est "),
		new S(" ", f, "."),
		new S("", p, "\">"),
		new S(" ", n, "='"),
		new S("", f, ","),
		new S("", n, "ize "),
		new S("", p, "."),
		new S("Â\xA0", n, ""),
		new S(" ", n, ","),
		new S("", f, "=\""),
		new S("", p, "=\""),
		new S("", n, "ous "),
		new S("", p, ", "),
		new S("", f, "='"),
		new S(" ", f, ","),
		new S(" ", p, "=\""),
		new S(" ", p, ", "),
		new S("", p, ","),
		new S("", p, "("),
		new S("", p, ". "),
		new S(" ", p, "."),
		new S("", p, "='"),
		new S(" ", p, ". "),
		new S(" ", f, "=\""),
		new S(" ", p, "='"),
		new S(" ", f, "='")
	];
	e.kTransforms = C, e.kNumTransforms = C.length;
	function w(e, t) {
		return e[t] < 192 ? (e[t] >= 97 && e[t] <= 122 && (e[t] ^= 32), 1) : e[t] < 224 ? (e[t + 1] ^= 32, 2) : (e[t + 2] ^= 5, 3);
	}
	e.transformDictionaryWord = function(e, n, r, i, a) {
		var o = C[a].prefix, s = C[a].suffix, c = C[a].transform, l = c < m ? 0 : c - (m - 1), u = 0, h = n, g;
		l > i && (l = i);
		for (var _ = 0; _ < o.length;) e[n++] = o[_++];
		for (r += l, i -= l, c <= d && (i -= c), u = 0; u < i; u++) e[n++] = t.dictionary[r + u];
		if (g = n - i, c === f) w(e, g);
		else if (c === p) for (; i > 0;) {
			var v = w(e, g);
			g += v, i -= v;
		}
		for (var y = 0; y < s.length;) e[n++] = s[y++];
		return n - h;
	};
})), xb = /* @__PURE__ */ V(((e) => {
	var t = fb().BrotliInput, n = fb().BrotliOutput, r = pb(), i = gb(), a = _b().HuffmanCode, o = _b().BrotliBuildHuffmanTable, s = vb(), c = yb(), l = bb(), u = 8, d = 16, f = 256, p = 704, m = 26, h = 6, g = 2, _ = 8, v = 255, y = 1080, b = 18, x = new Uint8Array([
		1,
		2,
		3,
		4,
		0,
		5,
		17,
		6,
		16,
		7,
		8,
		9,
		10,
		11,
		12,
		13,
		14,
		15
	]), S = 16, C = new Uint8Array([
		3,
		2,
		1,
		0,
		3,
		3,
		3,
		3,
		3,
		3,
		2,
		2,
		2,
		2,
		2,
		2
	]), w = new Int8Array([
		0,
		0,
		0,
		0,
		-1,
		1,
		-2,
		2,
		-3,
		3,
		-1,
		1,
		-2,
		2,
		-3,
		3
	]), T = new Uint16Array([
		256,
		402,
		436,
		468,
		500,
		534,
		566,
		598,
		630,
		662,
		694,
		726,
		758,
		790,
		822,
		854,
		886,
		920,
		952,
		984,
		1016,
		1048,
		1080
	]);
	function E(e) {
		var t;
		return e.readBits(1) === 0 ? 16 : (t = e.readBits(3), t > 0 ? 17 + t : (t = e.readBits(3), t > 0 ? 8 + t : 17));
	}
	function D(e) {
		if (e.readBits(1)) {
			var t = e.readBits(3);
			return t === 0 ? 1 : e.readBits(t) + (1 << t);
		}
		return 0;
	}
	function O() {
		this.meta_block_length = 0, this.input_end = 0, this.is_uncompressed = 0, this.is_metadata = !1;
	}
	function k(e) {
		var t = new O(), n, r, i;
		if (t.input_end = e.readBits(1), t.input_end && e.readBits(1)) return t;
		if (n = e.readBits(2) + 4, n === 7) {
			if (t.is_metadata = !0, e.readBits(1) !== 0) throw Error("Invalid reserved bit");
			if (r = e.readBits(2), r === 0) return t;
			for (i = 0; i < r; i++) {
				var a = e.readBits(8);
				if (i + 1 === r && r > 1 && a === 0) throw Error("Invalid size byte");
				t.meta_block_length |= a << i * 8;
			}
		} else for (i = 0; i < n; ++i) {
			var o = e.readBits(4);
			if (i + 1 === n && n > 4 && o === 0) throw Error("Invalid size nibble");
			t.meta_block_length |= o << i * 4;
		}
		return ++t.meta_block_length, !t.input_end && !t.is_metadata && (t.is_uncompressed = e.readBits(1)), t;
	}
	function A(e, t, n) {
		var r;
		return n.fillBitWindow(), t += n.val_ >>> n.bit_pos_ & v, r = e[t].bits - _, r > 0 && (n.bit_pos_ += _, t += e[t].value, t += n.val_ >>> n.bit_pos_ & (1 << r) - 1), n.bit_pos_ += e[t].bits, e[t].value;
	}
	function j(e, t, n, r) {
		for (var i = 0, s = u, c = 0, l = 0, f = 32768, p = [], m = 0; m < 32; m++) p.push(new a(0, 0));
		for (o(p, 0, 5, e, b); i < t && f > 0;) {
			var h = 0, g;
			if (r.readMoreInput(), r.fillBitWindow(), h += r.val_ >>> r.bit_pos_ & 31, r.bit_pos_ += p[h].bits, g = p[h].value & 255, g < d) c = 0, n[i++] = g, g !== 0 && (s = g, f -= 32768 >> g);
			else {
				var _ = g - 14, v, y, x = 0;
				if (g === d && (x = s), l !== x && (c = 0, l = x), v = c, c > 0 && (c -= 2, c <<= _), c += r.readBits(_) + 3, y = c - v, i + y > t) throw Error("[ReadHuffmanCodeLengths] symbol + repeat_delta > num_symbols");
				for (var S = 0; S < y; S++) n[i + S] = l;
				i += y, l !== 0 && (f -= y << 15 - l);
			}
		}
		if (f !== 0) throw Error("[ReadHuffmanCodeLengths] space = " + f);
		for (; i < t; i++) n[i] = 0;
	}
	function M(e, t, n, r) {
		var i = 0, s, c = new Uint8Array(e);
		if (r.readMoreInput(), s = r.readBits(2), s === 1) {
			for (var l, u = e - 1, d = 0, f = new Int32Array(4), p = r.readBits(2) + 1; u;) u >>= 1, ++d;
			for (l = 0; l < p; ++l) f[l] = r.readBits(d) % e, c[f[l]] = 2;
			switch (c[f[0]] = 1, p) {
				case 1: break;
				case 3:
					if (f[0] === f[1] || f[0] === f[2] || f[1] === f[2]) throw Error("[ReadHuffmanCode] invalid symbols");
					break;
				case 2:
					if (f[0] === f[1]) throw Error("[ReadHuffmanCode] invalid symbols");
					c[f[1]] = 1;
					break;
				case 4:
					if (f[0] === f[1] || f[0] === f[2] || f[0] === f[3] || f[1] === f[2] || f[1] === f[3] || f[2] === f[3]) throw Error("[ReadHuffmanCode] invalid symbols");
					r.readBits(1) ? (c[f[2]] = 3, c[f[3]] = 3) : c[f[0]] = 2;
					break;
			}
		} else {
			var l, m = new Uint8Array(b), h = 32, g = 0, v = [
				new a(2, 0),
				new a(2, 4),
				new a(2, 3),
				new a(3, 2),
				new a(2, 0),
				new a(2, 4),
				new a(2, 3),
				new a(4, 1),
				new a(2, 0),
				new a(2, 4),
				new a(2, 3),
				new a(3, 2),
				new a(2, 0),
				new a(2, 4),
				new a(2, 3),
				new a(4, 5)
			];
			for (l = s; l < b && h > 0; ++l) {
				var y = x[l], S = 0, C;
				r.fillBitWindow(), S += r.val_ >>> r.bit_pos_ & 15, r.bit_pos_ += v[S].bits, C = v[S].value, m[y] = C, C !== 0 && (h -= 32 >> C, ++g);
			}
			if (!(g === 1 || h === 0)) throw Error("[ReadHuffmanCode] invalid num_codes or space");
			j(m, e, c, r);
		}
		if (i = o(t, n, _, c, e), i === 0) throw Error("[ReadHuffmanCode] BuildHuffmanTable failed: ");
		return i;
	}
	function ee(e, t, n) {
		var r = A(e, t, n), i = c.kBlockLengthPrefixCode[r].nbits;
		return c.kBlockLengthPrefixCode[r].offset + n.readBits(i);
	}
	function te(e, t, n) {
		var r;
		return e < S ? (n += C[e], n &= 3, r = t[n] + w[e]) : r = e - S + 1, r;
	}
	function ne(e, t) {
		for (var n = e[t], r = t; r; --r) e[r] = e[r - 1];
		e[0] = n;
	}
	function re(e, t) {
		var n = new Uint8Array(256), r;
		for (r = 0; r < 256; ++r) n[r] = r;
		for (r = 0; r < t; ++r) {
			var i = e[r];
			e[r] = n[i], i && ne(n, i);
		}
	}
	function ie(e, t) {
		this.alphabet_size = e, this.num_htrees = t, this.codes = Array(t + t * T[e + 31 >>> 5]), this.htrees = new Uint32Array(t);
	}
	ie.prototype.decode = function(e) {
		var t, n, r = 0;
		for (t = 0; t < this.num_htrees; ++t) this.htrees[t] = r, n = M(this.alphabet_size, this.codes, r, e), r += n;
	};
	function ae(e, t) {
		var n = {
			num_htrees: null,
			context_map: null
		}, r, i = 0, o, s;
		t.readMoreInput();
		var c = n.num_htrees = D(t) + 1, l = n.context_map = new Uint8Array(e);
		if (c <= 1) return n;
		for (r = t.readBits(1), r && (i = t.readBits(4) + 1), o = [], s = 0; s < y; s++) o[s] = new a(0, 0);
		for (M(c + i, o, 0, t), s = 0; s < e;) {
			var u;
			if (t.readMoreInput(), u = A(o, 0, t), u === 0) l[s] = 0, ++s;
			else if (u <= i) for (var d = 1 + (1 << u) + t.readBits(u); --d;) {
				if (s >= e) throw Error("[DecodeContextMap] i >= context_map_size");
				l[s] = 0, ++s;
			}
			else l[s] = u - i, ++s;
		}
		return t.readBits(1) && re(l, e), n;
	}
	function oe(e, t, n, r, i, a, o) {
		var s = n * 2, c = n, l = A(t, n * y, o), u = l === 0 ? i[s + (a[c] & 1)] : l === 1 ? i[s + (a[c] - 1 & 1)] + 1 : l - 2;
		u >= e && (u -= e), r[n] = u, i[s + (a[c] & 1)] = u, ++a[c];
	}
	function se(e, t, n, i, a, o) {
		var s = a + 1, c = n & a, l = o.pos_ & r.IBUF_MASK, u;
		if (t < 8 || o.bit_pos_ + (t << 3) < o.bit_end_pos_) {
			for (; t-- > 0;) o.readMoreInput(), i[c++] = o.readBits(8), c === s && (e.write(i, s), c = 0);
			return;
		}
		if (o.bit_end_pos_ < 32) throw Error("[CopyUncompressedBlockToOutput] br.bit_end_pos_ < 32");
		for (; o.bit_pos_ < 32;) i[c] = o.val_ >>> o.bit_pos_, o.bit_pos_ += 8, ++c, --t;
		if (u = o.bit_end_pos_ - o.bit_pos_ >> 3, l + u > r.IBUF_MASK) {
			for (var d = r.IBUF_MASK + 1 - l, f = 0; f < d; f++) i[c + f] = o.buf_[l + f];
			u -= d, c += d, t -= d, l = 0;
		}
		for (var f = 0; f < u; f++) i[c + f] = o.buf_[l + f];
		if (c += u, t -= u, c >= s) {
			e.write(i, s), c -= s;
			for (var f = 0; f < c; f++) i[f] = i[s + f];
		}
		for (; c + t >= s;) {
			if (u = s - c, o.input_.read(i, c, u) < u) throw Error("[CopyUncompressedBlockToOutput] not enough bytes");
			e.write(i, s), t -= u, c = 0;
		}
		if (o.input_.read(i, c, t) < t) throw Error("[CopyUncompressedBlockToOutput] not enough bytes");
		o.reset();
	}
	function ce(e) {
		var t = e.bit_pos_ + 7 & -8;
		return e.readBits(t - e.bit_pos_) == 0;
	}
	function le(e) {
		var n = new r(new t(e));
		return E(n), k(n).meta_block_length;
	}
	e.BrotliDecompressedSize = le;
	function N(e, r) {
		var i = new t(e);
		r ??= le(e);
		var a = new n(new Uint8Array(r));
		return P(i, a), a.pos < a.buffer.length && (a.buffer = a.buffer.subarray(0, a.pos)), a.buffer;
	}
	e.BrotliDecompressBuffer = N;
	function P(e, t) {
		var n, o = 0, u = 0, d = 0, _, v = 0, b, x, C, w, T = [
			16,
			15,
			11,
			4
		], O = 0, j = 0, ne = 0, re = [
			new ie(0, 0),
			new ie(0, 0),
			new ie(0, 0)
		], le, N, P, ue = 128 + r.READ_SIZE;
		P = new r(e), d = E(P), _ = (1 << d) - 16, b = 1 << d, x = b - 1, C = new Uint8Array(b + ue + i.maxDictionaryWordLength), w = b, le = [], N = [];
		for (var de = 0; de < 3 * y; de++) le[de] = new a(0, 0), N[de] = new a(0, 0);
		for (; !u;) {
			var fe = 0, pe, me = [
				1 << 28,
				1 << 28,
				1 << 28
			], F = [0], I = [
				1,
				1,
				1
			], he = [
				0,
				1,
				0,
				1,
				0,
				1
			], L = [0], ge, _e, ve, ye, be = null, R = null, xe, z = null, B, Se = 0, Ce = null, we = 0, Te = 0, Ee = null, De = 0, Oe = 0, ke = 0, Ae, je;
			for (n = 0; n < 3; ++n) re[n].codes = null, re[n].htrees = null;
			P.readMoreInput();
			var Me = k(P);
			if (fe = Me.meta_block_length, o + fe > t.buffer.length) {
				var Ne = new Uint8Array(o + fe);
				Ne.set(t.buffer), t.buffer = Ne;
			}
			if (u = Me.input_end, pe = Me.is_uncompressed, Me.is_metadata) {
				for (ce(P); fe > 0; --fe) P.readMoreInput(), P.readBits(8);
				continue;
			}
			if (fe !== 0) {
				if (pe) {
					P.bit_pos_ = P.bit_pos_ + 7 & -8, se(t, fe, o, C, x, P), o += fe;
					continue;
				}
				for (n = 0; n < 3; ++n) I[n] = D(P) + 1, I[n] >= 2 && (M(I[n] + 2, le, n * y, P), M(m, N, n * y, P), me[n] = ee(N, n * y, P), L[n] = 1);
				for (P.readMoreInput(), ge = P.readBits(2), _e = S + (P.readBits(4) << ge), ve = (1 << ge) - 1, ye = _e + (48 << ge), R = new Uint8Array(I[0]), n = 0; n < I[0]; ++n) P.readMoreInput(), R[n] = P.readBits(2) << 1;
				var Pe = ae(I[0] << h, P);
				xe = Pe.num_htrees, be = Pe.context_map;
				var Fe = ae(I[2] << g, P);
				for (B = Fe.num_htrees, z = Fe.context_map, re[0] = new ie(f, xe), re[1] = new ie(p, I[1]), re[2] = new ie(ye, B), n = 0; n < 3; ++n) re[n].decode(P);
				for (Ce = 0, Ee = 0, Ae = R[F[0]], Oe = s.lookupOffsets[Ae], ke = s.lookupOffsets[Ae + 1], je = re[1].htrees[0]; fe > 0;) {
					var Ie, Le, Re, ze, Be, Ve, He, Ue, We, Ge, Ke;
					for (P.readMoreInput(), me[1] === 0 && (oe(I[1], le, 1, F, he, L, P), me[1] = ee(N, y, P), je = re[1].htrees[F[1]]), --me[1], Ie = A(re[1].codes, je, P), Le = Ie >> 6, Le >= 2 ? (Le -= 2, He = -1) : He = 0, Re = c.kInsertRangeLut[Le] + (Ie >> 3 & 7), ze = c.kCopyRangeLut[Le] + (Ie & 7), Be = c.kInsertLengthPrefixCode[Re].offset + P.readBits(c.kInsertLengthPrefixCode[Re].nbits), Ve = c.kCopyLengthPrefixCode[ze].offset + P.readBits(c.kCopyLengthPrefixCode[ze].nbits), j = C[o - 1 & x], ne = C[o - 2 & x], Ge = 0; Ge < Be; ++Ge) P.readMoreInput(), me[0] === 0 && (oe(I[0], le, 0, F, he, L, P), me[0] = ee(N, 0, P), Se = F[0] << h, Ce = Se, Ae = R[F[0]], Oe = s.lookupOffsets[Ae], ke = s.lookupOffsets[Ae + 1]), We = s.lookup[Oe + j] | s.lookup[ke + ne], we = be[Ce + We], --me[0], ne = j, j = A(re[0].codes, re[0].htrees[we], P), C[o & x] = j, (o & x) === x && t.write(C, b), ++o;
					if (fe -= Be, fe <= 0) break;
					if (He < 0) {
						var We;
						if (P.readMoreInput(), me[2] === 0 && (oe(I[2], le, 2, F, he, L, P), me[2] = ee(N, 2 * y, P), Te = F[2] << g, Ee = Te), --me[2], We = (Ve > 4 ? 3 : Ve - 2) & 255, De = z[Ee + We], He = A(re[2].codes, re[2].htrees[De], P), He >= _e) {
							var qe, Je, Ye;
							He -= _e, Je = He & ve, He >>= ge, qe = (He >> 1) + 1, Ye = (2 + (He & 1) << qe) - 4, He = _e + (Ye + P.readBits(qe) << ge) + Je;
						}
					}
					if (Ue = te(He, T, O), Ue < 0) throw Error("[BrotliDecompress] invalid distance");
					if (v = o < _ && v !== _ ? o : _, Ke = o & x, Ue > v) if (Ve >= i.minDictionaryWordLength && Ve <= i.maxDictionaryWordLength) {
						var Ye = i.offsetsByLength[Ve], Xe = Ue - v - 1, Ze = i.sizeBitsByLength[Ve], Qe = Xe & (1 << Ze) - 1, $e = Xe >> Ze;
						if (Ye += Qe * Ve, $e < l.kNumTransforms) {
							var et = l.transformDictionaryWord(C, Ke, Ye, Ve, $e);
							if (Ke += et, o += et, fe -= et, Ke >= w) {
								t.write(C, b);
								for (var tt = 0; tt < Ke - w; tt++) C[tt] = C[w + tt];
							}
						} else throw Error("Invalid backward reference. pos: " + o + " distance: " + Ue + " len: " + Ve + " bytes left: " + fe);
					} else throw Error("Invalid backward reference. pos: " + o + " distance: " + Ue + " len: " + Ve + " bytes left: " + fe);
					else {
						if (He > 0 && (T[O & 3] = Ue, ++O), Ve > fe) throw Error("Invalid backward reference. pos: " + o + " distance: " + Ue + " len: " + Ve + " bytes left: " + fe);
						for (Ge = 0; Ge < Ve; ++Ge) C[o & x] = C[o - Ue & x], (o & x) === x && t.write(C, b), ++o, --fe;
					}
					j = C[o - 1 & x], ne = C[o - 2 & x];
				}
				o &= 1073741823;
			}
		}
		t.write(C, o & x);
	}
	e.BrotliDecompress = P, i.init();
})), Sb = /* @__PURE__ */ V(((e, t) => {
	t.exports = xb().BrotliDecompressBuffer;
})), Cb = /* @__PURE__ */ xt(ub(), 1), wb = /* @__PURE__ */ xt(db(), 1), Tb = /* @__PURE__ */ xt(Hy(), 1), Eb = /* @__PURE__ */ xt(Sb(), 1);
function Db(e, t, n, r) {
	Object.defineProperty(e, t, {
		get: n,
		set: r,
		enumerable: !0,
		configurable: !0
	});
}
function Ob(e) {
	return e && e.__esModule ? e.default : e;
}
var kb = {};
Db(kb, "logErrors", () => !1), Db(kb, "registerFormat", () => jb), Db(kb, "create", () => Mb), Db(kb, "defaultLanguage", () => Nb), Db(kb, "setDefaultLanguage", () => Pb);
var Ab = [];
function jb(e) {
	Ab.push(e);
}
function Mb(e, t) {
	for (let n = 0; n < Ab.length; n++) {
		let r = Ab[n];
		if (r.probe(e)) {
			let n = new r(new fy(e));
			return t ? n.getFont(t) : n;
		}
	}
	throw Error("Unknown font format");
}
var Nb = "en";
function Pb(e = "en") {
	Nb = e;
}
function Fb(e, t, n) {
	if (n.get) {
		let e = n.get;
		n.get = function() {
			let n = e.call(this);
			return Object.defineProperty(this, t, { value: n }), n;
		};
	} else if (typeof n.value == "function") {
		let e = n.value;
		return { get() {
			let n = /* @__PURE__ */ new Map();
			function r(...t) {
				let r = t.length > 0 ? t[0] : "value";
				if (n.has(r)) return n.get(r);
				let i = e.apply(this, t);
				return n.set(r, i), i;
			}
			return Object.defineProperty(this, t, { value: r }), r;
		} };
	}
}
var Ib = new K({
	firstCode: H,
	entryCount: H,
	idDelta: W,
	idRangeOffset: H
}), Lb = new K({
	startCharCode: U,
	endCharCode: U,
	glyphID: U
}), Rb = new K({
	startUnicodeValue: by,
	additionalCount: vy
}), zb = new K({
	unicodeValue: by,
	glyphID: H
}), Bb = new G(Rb, U), Vb = new G(zb, U), Hb = new K({
	varSelector: by,
	defaultUVS: new q(U, Bb, { type: "parent" }),
	nonDefaultUVS: new q(U, Vb, { type: "parent" })
}), Ub = new K({
	version: H,
	numSubtables: H,
	tables: new G(new K({
		platformID: H,
		encodingID: H,
		table: new q(U, new Ly(H, {
			0: {
				length: H,
				language: H,
				codeMap: new Oy(vy, 256)
			},
			2: {
				length: H,
				language: H,
				subHeaderKeys: new G(H, 256),
				subHeaderCount: (e) => Math.max.apply(Math, e.subHeaderKeys),
				subHeaders: new Oy(Ib, "subHeaderCount"),
				glyphIndexArray: new Oy(H, "subHeaderCount")
			},
			4: {
				length: H,
				language: H,
				segCountX2: H,
				segCount: (e) => e.segCountX2 >> 1,
				searchRange: H,
				entrySelector: H,
				rangeShift: H,
				endCode: new Oy(H, "segCount"),
				reservedPad: new Ny(H),
				startCode: new Oy(H, "segCount"),
				idDelta: new Oy(W, "segCount"),
				idRangeOffset: new Oy(H, "segCount"),
				glyphIndexArray: new Oy(H, (e) => (e.length - e._currentOffset) / 2)
			},
			6: {
				length: H,
				language: H,
				firstCode: H,
				entryCount: H,
				glyphIndices: new Oy(H, "entryCount")
			},
			8: {
				reserved: new Ny(H),
				length: U,
				language: H,
				is32: new Oy(vy, 8192),
				nGroups: U,
				groups: new Oy(Lb, "nGroups")
			},
			10: {
				reserved: new Ny(H),
				length: U,
				language: U,
				firstCode: U,
				entryCount: U,
				glyphIndices: new Oy(H, "numChars")
			},
			12: {
				reserved: new Ny(H),
				length: U,
				language: U,
				nGroups: U,
				groups: new Oy(Lb, "nGroups")
			},
			13: {
				reserved: new Ny(H),
				length: U,
				language: U,
				nGroups: U,
				groups: new Oy(Lb, "nGroups")
			},
			14: {
				length: U,
				numRecords: U,
				varSelectors: new Oy(Hb, "numRecords")
			}
		}), {
			type: "parent",
			lazy: !0
		})
	}), "numSubtables")
}), Wb = new K({
	version: Cy,
	revision: Cy,
	checkSumAdjustment: U,
	magicNumber: U,
	flags: H,
	unitsPerEm: H,
	created: new G(Cy, 2),
	modified: new G(Cy, 2),
	xMin: W,
	yMin: W,
	xMax: W,
	yMax: W,
	macStyle: new Ay(H, [
		"bold",
		"italic",
		"underline",
		"outline",
		"shadow",
		"condensed",
		"extended"
	]),
	lowestRecPPEM: H,
	fontDirectionHint: W,
	indexToLocFormat: W,
	glyphDataFormat: W
}), Gb = new K({
	version: Cy,
	ascent: W,
	descent: W,
	lineGap: W,
	advanceWidthMax: H,
	minLeftSideBearing: W,
	minRightSideBearing: W,
	xMaxExtent: W,
	caretSlopeRise: W,
	caretSlopeRun: W,
	caretOffset: W,
	reserved: new Ny(W, 4),
	metricDataFormat: W,
	numberOfMetrics: H
}), Kb = new K({
	metrics: new Oy(new K({
		advance: H,
		bearing: W
	}), (e) => e.parent.hhea.numberOfMetrics),
	bearings: new Oy(W, (e) => e.parent.maxp.numGlyphs - e.parent.hhea.numberOfMetrics)
}), qb = new K({
	version: Cy,
	numGlyphs: H,
	maxPoints: H,
	maxContours: H,
	maxComponentPoints: H,
	maxComponentContours: H,
	maxZones: H,
	maxTwilightPoints: H,
	maxStorage: H,
	maxFunctionDefs: H,
	maxInstructionDefs: H,
	maxStackElements: H,
	maxSizeOfInstructions: H,
	maxComponentElements: H,
	maxComponentDepth: H
});
function Jb(e, t, n = 0) {
	return e === 1 && ex[n] ? ex[n] : $b[e][t];
}
var Yb = new Set([
	"x-mac-roman",
	"x-mac-cyrillic",
	"iso-8859-6",
	"iso-8859-8"
]), Xb = {
	"x-mac-croatian": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®Š™´¨≠ŽØ∞±≤≥∆µ∂∑∏š∫ªºΩžø¿¡¬√ƒ≈Ć«Č… ÀÃÕŒœĐ—“”‘’÷◊©⁄€‹›Æ»–·‚„‰ÂćÁčÈÍÎÏÌÓÔđÒÚÛÙıˆ˜¯πË˚¸Êæˇ",
	"x-mac-gaelic": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØḂ±≤≥ḃĊċḊḋḞḟĠġṀæøṁṖṗɼƒſṠ«»… ÀÃÕŒœ–—“”‘’ṡẛÿŸṪ€‹›Ŷŷṫ·Ỳỳ⁊ÂÊÁËÈÍÎÏÌÓÔ♣ÒÚÛÙıÝýŴŵẄẅẀẁẂẃ",
	"x-mac-greek": "Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦€ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ­",
	"x-mac-icelandic": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ",
	"x-mac-inuit": "ᐃᐄᐅᐆᐊᐋᐱᐲᐳᐴᐸᐹᑉᑎᑏᑐᑑᑕᑖᑦᑭᑮᑯᑰᑲᑳᒃᒋᒌᒍᒎᒐᒑ°ᒡᒥᒦ•¶ᒧ®©™ᒨᒪᒫᒻᓂᓃᓄᓅᓇᓈᓐᓯᓰᓱᓲᓴᓵᔅᓕᓖᓗᓘᓚᓛᓪᔨᔩᔪᔫᔭ… ᔮᔾᕕᕖᕗ–—“”‘’ᕘᕙᕚᕝᕆᕇᕈᕉᕋᕌᕐᕿᖀᖁᖂᖃᖄᖅᖏᖐᖑᖒᖓᖔᖕᙱᙲᙳᙴᙵᙶᖖᖠᖡᖢᖣᖤᖥᖦᕼŁł",
	"x-mac-ce": "ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ",
	"x-mac-romanian": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ĂȘ∞±≤≥¥µ∂∑∏π∫ªºΩăș¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄€‹›Țț‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ",
	"x-mac-turkish": "ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔÒÚÛÙˆ˜¯˘˙˚¸˝˛ˇ"
}, Zb = /* @__PURE__ */ new Map();
function Qb(e) {
	let t = Zb.get(e);
	if (t) return t;
	let n = Xb[e];
	if (n) {
		let t = /* @__PURE__ */ new Map();
		for (let e = 0; e < n.length; e++) t.set(n.charCodeAt(e), 128 + e);
		return Zb.set(e, t), t;
	}
	if (Yb.has(e)) {
		let t = new TextDecoder(e), n = new Uint8Array(128);
		for (let e = 0; e < 128; e++) n[e] = 128 + e;
		let r = /* @__PURE__ */ new Map(), i = t.decode(n);
		for (let e = 0; e < 128; e++) r.set(i.charCodeAt(e), 128 + e);
		return Zb.set(e, r), r;
	}
}
var $b = [
	[
		"utf-16be",
		"utf-16be",
		"utf-16be",
		"utf-16be",
		"utf-16be",
		"utf-16be",
		"utf-16be"
	],
	/* @__PURE__ */ "x-mac-roman.shift-jis.big5.euc-kr.iso-8859-6.iso-8859-8.x-mac-greek.x-mac-cyrillic.x-mac-symbol.x-mac-devanagari.x-mac-gurmukhi.x-mac-gujarati.Oriya.Bengali.Tamil.Telugu.Kannada.Malayalam.Sinhalese.Burmese.Khmer.iso-8859-11.Laotian.Georgian.Armenian.gbk.Tibetan.Mongolian.Geez.x-mac-ce.Vietnamese.Sindhi".split("."),
	[
		"ascii",
		null,
		"iso-8859-1"
	],
	[
		"symbol",
		"utf-16be",
		"shift-jis",
		"gb18030",
		"big5",
		"euc-kr",
		"johab",
		null,
		null,
		null,
		"utf-16be"
	]
], ex = {
	15: "x-mac-icelandic",
	17: "x-mac-turkish",
	18: "x-mac-croatian",
	24: "x-mac-ce",
	25: "x-mac-ce",
	26: "x-mac-ce",
	27: "x-mac-ce",
	28: "x-mac-ce",
	30: "x-mac-icelandic",
	37: "x-mac-romanian",
	38: "x-mac-ce",
	39: "x-mac-ce",
	40: "x-mac-ce",
	143: "x-mac-inuit",
	146: "x-mac-gaelic"
}, tx = [
	[],
	{
		0: "en",
		30: "fo",
		60: "ks",
		90: "rw",
		1: "fr",
		31: "fa",
		61: "ku",
		91: "rn",
		2: "de",
		32: "ru",
		62: "sd",
		92: "ny",
		3: "it",
		33: "zh",
		63: "bo",
		93: "mg",
		4: "nl",
		34: "nl-BE",
		64: "ne",
		94: "eo",
		5: "sv",
		35: "ga",
		65: "sa",
		128: "cy",
		6: "es",
		36: "sq",
		66: "mr",
		129: "eu",
		7: "da",
		37: "ro",
		67: "bn",
		130: "ca",
		8: "pt",
		38: "cz",
		68: "as",
		131: "la",
		9: "no",
		39: "sk",
		69: "gu",
		132: "qu",
		10: "he",
		40: "si",
		70: "pa",
		133: "gn",
		11: "ja",
		41: "yi",
		71: "or",
		134: "ay",
		12: "ar",
		42: "sr",
		72: "ml",
		135: "tt",
		13: "fi",
		43: "mk",
		73: "kn",
		136: "ug",
		14: "el",
		44: "bg",
		74: "ta",
		137: "dz",
		15: "is",
		45: "uk",
		75: "te",
		138: "jv",
		16: "mt",
		46: "be",
		76: "si",
		139: "su",
		17: "tr",
		47: "uz",
		77: "my",
		140: "gl",
		18: "hr",
		48: "kk",
		78: "km",
		141: "af",
		19: "zh-Hant",
		49: "az-Cyrl",
		79: "lo",
		142: "br",
		20: "ur",
		50: "az-Arab",
		80: "vi",
		143: "iu",
		21: "hi",
		51: "hy",
		81: "id",
		144: "gd",
		22: "th",
		52: "ka",
		82: "tl",
		145: "gv",
		23: "ko",
		53: "mo",
		83: "ms",
		146: "ga",
		24: "lt",
		54: "ky",
		84: "ms-Arab",
		147: "to",
		25: "pl",
		55: "tg",
		85: "am",
		148: "el-polyton",
		26: "hu",
		56: "tk",
		86: "ti",
		149: "kl",
		27: "es",
		57: "mn-CN",
		87: "om",
		150: "az",
		28: "lv",
		58: "mn",
		88: "so",
		151: "nn",
		29: "se",
		59: "ps",
		89: "sw"
	},
	[],
	{
		1078: "af",
		16393: "en-IN",
		1159: "rw",
		1074: "tn",
		1052: "sq",
		6153: "en-IE",
		1089: "sw",
		1115: "si",
		1156: "gsw",
		8201: "en-JM",
		1111: "kok",
		1051: "sk",
		1118: "am",
		17417: "en-MY",
		1042: "ko",
		1060: "sl",
		5121: "ar-DZ",
		5129: "en-NZ",
		1088: "ky",
		11274: "es-AR",
		15361: "ar-BH",
		13321: "en-PH",
		1108: "lo",
		16394: "es-BO",
		3073: "ar",
		18441: "en-SG",
		1062: "lv",
		13322: "es-CL",
		2049: "ar-IQ",
		7177: "en-ZA",
		1063: "lt",
		9226: "es-CO",
		11265: "ar-JO",
		11273: "en-TT",
		2094: "dsb",
		5130: "es-CR",
		13313: "ar-KW",
		2057: "en-GB",
		1134: "lb",
		7178: "es-DO",
		12289: "ar-LB",
		1033: "en",
		1071: "mk",
		12298: "es-EC",
		4097: "ar-LY",
		12297: "en-ZW",
		2110: "ms-BN",
		17418: "es-SV",
		6145: "ary",
		1061: "et",
		1086: "ms",
		4106: "es-GT",
		8193: "ar-OM",
		1080: "fo",
		1100: "ml",
		18442: "es-HN",
		16385: "ar-QA",
		1124: "fil",
		1082: "mt",
		2058: "es-MX",
		1025: "ar-SA",
		1035: "fi",
		1153: "mi",
		19466: "es-NI",
		10241: "ar-SY",
		2060: "fr-BE",
		1146: "arn",
		6154: "es-PA",
		7169: "aeb",
		3084: "fr-CA",
		1102: "mr",
		15370: "es-PY",
		14337: "ar-AE",
		1036: "fr",
		1148: "moh",
		10250: "es-PE",
		9217: "ar-YE",
		5132: "fr-LU",
		1104: "mn",
		20490: "es-PR",
		1067: "hy",
		6156: "fr-MC",
		2128: "mn-CN",
		3082: "es",
		1101: "as",
		4108: "fr-CH",
		1121: "ne",
		1034: "es",
		2092: "az-Cyrl",
		1122: "fy",
		1044: "nb",
		21514: "es-US",
		1068: "az",
		1110: "gl",
		2068: "nn",
		14346: "es-UY",
		1133: "ba",
		1079: "ka",
		1154: "oc",
		8202: "es-VE",
		1069: "eu",
		3079: "de-AT",
		1096: "or",
		2077: "sv-FI",
		1059: "be",
		1031: "de",
		1123: "ps",
		1053: "sv",
		2117: "bn",
		5127: "de-LI",
		1045: "pl",
		1114: "syr",
		1093: "bn-IN",
		4103: "de-LU",
		1046: "pt",
		1064: "tg",
		8218: "bs-Cyrl",
		2055: "de-CH",
		2070: "pt-PT",
		2143: "tzm",
		5146: "bs",
		1032: "el",
		1094: "pa",
		1097: "ta",
		1150: "br",
		1135: "kl",
		1131: "qu-BO",
		1092: "tt",
		1026: "bg",
		1095: "gu",
		2155: "qu-EC",
		1098: "te",
		1027: "ca",
		1128: "ha",
		3179: "qu",
		1054: "th",
		3076: "zh-HK",
		1037: "he",
		1048: "ro",
		1105: "bo",
		5124: "zh-MO",
		1081: "hi",
		1047: "rm",
		1055: "tr",
		2052: "zh",
		1038: "hu",
		1049: "ru",
		1090: "tk",
		4100: "zh-SG",
		1039: "is",
		9275: "smn",
		1152: "ug",
		1028: "zh-TW",
		1136: "ig",
		4155: "smj-NO",
		1058: "uk",
		1155: "co",
		1057: "id",
		5179: "smj",
		1070: "hsb",
		1050: "hr",
		1117: "iu",
		3131: "se-FI",
		1056: "ur",
		4122: "hr-BA",
		2141: "iu-Latn",
		1083: "se",
		2115: "uz-Cyrl",
		1029: "cs",
		2108: "ga",
		2107: "se-SE",
		1091: "uz",
		1030: "da",
		1076: "xh",
		8251: "sms",
		1066: "vi",
		1164: "prs",
		1077: "zu",
		6203: "sma-NO",
		1106: "cy",
		1125: "dv",
		1040: "it",
		7227: "sms",
		1160: "wo",
		2067: "nl-BE",
		2064: "it-CH",
		1103: "sa",
		1157: "sah",
		1043: "nl",
		1041: "ja",
		7194: "sr-Cyrl-BA",
		1144: "ii",
		3081: "en-AU",
		1099: "kn",
		3098: "sr",
		1130: "yo",
		10249: "en-BZ",
		1087: "kk",
		6170: "sr-Latn-BA",
		4105: "en-CA",
		1107: "km",
		2074: "sr-Latn",
		9225: "en-029",
		1158: "quc",
		1132: "nso"
	}
], nx = new K({
	platformID: H,
	encodingID: H,
	languageID: H,
	nameID: H,
	length: H,
	string: new q(H, new Py("length", (e) => Jb(e.platformID, e.encodingID, e.languageID)), {
		type: "parent",
		relativeTo: (e) => e.parent.stringOffset,
		allowNull: !1
	})
}), rx = new K({
	length: H,
	tag: new q(H, new Py("length", "utf16be"), {
		type: "parent",
		relativeTo: (e) => e.stringOffset
	})
}), ix = new Ly(H, {
	0: {
		count: H,
		stringOffset: H,
		records: new G(nx, "count")
	},
	1: {
		count: H,
		stringOffset: H,
		records: new G(nx, "count"),
		langTagCount: H,
		langTags: new G(rx, "langTagCount")
	}
}), ax = ix, ox = [
	"copyright",
	"fontFamily",
	"fontSubfamily",
	"uniqueSubfamily",
	"fullName",
	"version",
	"postscriptName",
	"trademark",
	"manufacturer",
	"designer",
	"description",
	"vendorURL",
	"designerURL",
	"license",
	"licenseURL",
	null,
	"preferredFamily",
	"preferredSubfamily",
	"compatibleFull",
	"sampleText",
	"postscriptCIDFontName",
	"wwsFamilyName",
	"wwsSubfamilyName"
];
ix.process = function(e) {
	var t = {};
	for (let e of this.records) {
		let n = tx[e.platformID][e.languageID];
		n == null && this.langTags != null && e.languageID >= 32768 && (n = this.langTags[e.languageID - 32768].tag), n ??= e.platformID + "-" + e.languageID;
		let r = e.nameID >= 256 ? "fontFeatures" : ox[e.nameID] || e.nameID;
		t[r] ?? (t[r] = {});
		let i = t[r];
		e.nameID >= 256 && (i = i[e.nameID] || (i[e.nameID] = {})), (typeof e.string == "string" || typeof i[n] != "string") && (i[n] = e.string);
	}
	this.records = t;
}, ix.preEncode = function() {
	if (Array.isArray(this.records)) return;
	this.version = 0;
	let e = [];
	for (let t in this.records) {
		let n = this.records[t];
		t !== "fontFeatures" && (e.push({
			platformID: 3,
			encodingID: 1,
			languageID: 1033,
			nameID: ox.indexOf(t),
			length: n.en.length * 2,
			string: n.en
		}), t === "postscriptName" && e.push({
			platformID: 1,
			encodingID: 0,
			languageID: 0,
			nameID: ox.indexOf(t),
			length: n.en.length,
			string: n.en
		}));
	}
	this.records = e, this.count = e.length, this.stringOffset = ix.size(this, null, !1);
};
var sx = new Ly(H, {
	header: {
		xAvgCharWidth: W,
		usWeightClass: H,
		usWidthClass: H,
		fsType: new Ay(H, [
			null,
			"noEmbedding",
			"viewOnly",
			"editable",
			null,
			null,
			null,
			null,
			"noSubsetting",
			"bitmapOnly"
		]),
		ySubscriptXSize: W,
		ySubscriptYSize: W,
		ySubscriptXOffset: W,
		ySubscriptYOffset: W,
		ySuperscriptXSize: W,
		ySuperscriptYSize: W,
		ySuperscriptXOffset: W,
		ySuperscriptYOffset: W,
		yStrikeoutSize: W,
		yStrikeoutPosition: W,
		sFamilyClass: W,
		panose: new G(vy, 10),
		ulCharRange: new G(U, 4),
		vendorID: new Py(4),
		fsSelection: new Ay(H, [
			"italic",
			"underscore",
			"negative",
			"outlined",
			"strikeout",
			"bold",
			"regular",
			"useTypoMetrics",
			"wws",
			"oblique"
		]),
		usFirstCharIndex: H,
		usLastCharIndex: H
	},
	0: {},
	1: {
		typoAscender: W,
		typoDescender: W,
		typoLineGap: W,
		winAscent: H,
		winDescent: H,
		codePageRange: new G(U, 2)
	},
	2: {
		typoAscender: W,
		typoDescender: W,
		typoLineGap: W,
		winAscent: H,
		winDescent: H,
		codePageRange: new G(U, 2),
		xHeight: W,
		capHeight: W,
		defaultChar: H,
		breakChar: H,
		maxContent: H
	},
	5: {
		typoAscender: W,
		typoDescender: W,
		typoLineGap: W,
		winAscent: H,
		winDescent: H,
		codePageRange: new G(U, 2),
		xHeight: W,
		capHeight: W,
		defaultChar: H,
		breakChar: H,
		maxContent: H,
		usLowerOpticalPointSize: H,
		usUpperOpticalPointSize: H
	}
}), cx = sx.versions;
cx[3] = cx[4] = cx[2];
var lx = sx, ux = new Ly(Ty, {
	header: {
		italicAngle: Ty,
		underlinePosition: W,
		underlineThickness: W,
		isFixedPitch: U,
		minMemType42: U,
		maxMemType42: U,
		minMemType1: U,
		maxMemType1: U
	},
	1: {},
	2: {
		numberOfGlyphs: H,
		glyphNameIndex: new G(H, "numberOfGlyphs"),
		names: new G(new Py(vy))
	},
	2.5: {
		numberOfGlyphs: H,
		offsets: new G(vy, "numberOfGlyphs")
	},
	3: {},
	4: { map: new G(U, (e) => e.parent.maxp.numGlyphs) }
}), dx = new K({ controlValues: new G(W) }), fx = new K({ instructions: new G(vy) }), px = new Ly("head.indexToLocFormat", {
	0: { offsets: new G(H) },
	1: { offsets: new G(U) }
});
px.process = function() {
	if (this.version === 0 && !this._processed) {
		for (let e = 0; e < this.offsets.length; e++) this.offsets[e] <<= 1;
		this._processed = !0;
	}
}, px.preEncode = function() {
	if (this.version === 0 && this._processed !== !1) {
		for (let e = 0; e < this.offsets.length; e++) this.offsets[e] >>>= 1;
		this._processed = !1;
	}
};
var mx = px, hx = new K({ controlValueProgram: new G(vy) }), gx = new G(new jy()), _x = class {
	getCFFVersion(e) {
		for (; e && !e.hdrSize;) e = e.parent;
		return e ? e.version : -1;
	}
	decode(e, t) {
		let n = this.getCFFVersion(t) >= 2 ? e.readUInt32BE() : e.readUInt16BE();
		if (n === 0) return [];
		let r = e.readUInt8(), i;
		if (r === 1) i = vy;
		else if (r === 2) i = H;
		else if (r === 3) i = by;
		else if (r === 4) i = U;
		else throw Error(`Bad offset size in CFFIndex: ${r} ${e.pos}`);
		let a = [], o = e.pos + (n + 1) * r - 1, s = i.decode(e);
		for (let r = 0; r < n; r++) {
			let n = i.decode(e);
			if (this.type != null) {
				let r = e.pos;
				e.pos = o + s, t.length = n - s, a.push(this.type.decode(e, t)), e.pos = r;
			} else a.push({
				offset: o + s,
				length: n - s
			});
			s = n;
		}
		return e.pos = o + s, a;
	}
	size(e, t) {
		let n = 2;
		if (e.length === 0) return n;
		let r = this.type || new jy(), i = 1;
		for (let n = 0; n < e.length; n++) {
			let a = e[n];
			i += r.size(a, t);
		}
		let a;
		if (i <= 255) a = vy;
		else if (i <= 65535) a = H;
		else if (i <= 16777215) a = by;
		else if (i <= 4294967295) a = U;
		else throw Error("Bad offset in CFFIndex");
		return n += 1 + a.size() * (e.length + 1), n += i - 1, n;
	}
	encode(e, t, n) {
		if (e.writeUInt16BE(t.length), t.length === 0) return;
		let r = this.type || new jy(), i = [], a = 1;
		for (let e of t) {
			let t = r.size(e, n);
			i.push(t), a += t;
		}
		let o;
		if (a <= 255) o = vy;
		else if (a <= 65535) o = H;
		else if (a <= 16777215) o = by;
		else if (a <= 4294967295) o = U;
		else throw Error("Bad offset in CFFIndex");
		e.writeUInt8(o.size()), a = 1, o.encode(e, a);
		for (let t of i) a += t, o.encode(e, a);
		for (let i of t) r.encode(e, i, n);
	}
	constructor(e) {
		this.type = e;
	}
}, vx = 15, yx = [
	"0",
	"1",
	"2",
	"3",
	"4",
	"5",
	"6",
	"7",
	"8",
	"9",
	".",
	"E",
	"E-",
	null,
	"-"
], bx = {
	".": 10,
	E: 11,
	"E-": 12,
	"-": 14
}, xx = class {
	static decode(e, t) {
		if (32 <= t && t <= 246) return t - 139;
		if (247 <= t && t <= 250) return (t - 247) * 256 + e.readUInt8() + 108;
		if (251 <= t && t <= 254) return -(t - 251) * 256 - e.readUInt8() - 108;
		if (t === 28) return e.readInt16BE();
		if (t === 29) return e.readInt32BE();
		if (t === 30) {
			let t = "";
			for (;;) {
				let n = e.readUInt8(), r = n >> 4;
				if (r === vx) break;
				t += yx[r];
				let i = n & 15;
				if (i === vx) break;
				t += yx[i];
			}
			return parseFloat(t);
		}
		return null;
	}
	static size(e) {
		if (e.forceLarge && (e = 32768), (e | 0) !== e) {
			let t = "" + e;
			return 1 + Math.ceil((t.length + 1) / 2);
		} else if (-107 <= e && e <= 107) return 1;
		else if (108 <= e && e <= 1131 || -1131 <= e && e <= -108) return 2;
		else if (-32768 <= e && e <= 32767) return 3;
		else return 5;
	}
	static encode(e, t) {
		let n = Number(t);
		if (t.forceLarge) return e.writeUInt8(29), e.writeInt32BE(n);
		if ((n | 0) !== n) {
			e.writeUInt8(30);
			let t = "" + n;
			for (let n = 0; n < t.length; n += 2) {
				let i = t[n], a = bx[i] || +i;
				if (n === t.length - 1) var r = vx;
				else {
					let e = t[n + 1];
					var r = bx[e] || +e;
				}
				e.writeUInt8(a << 4 | r & 15);
			}
			if (r !== vx) return e.writeUInt8(vx << 4);
		} else if (-107 <= n && n <= 107) return e.writeUInt8(n + 139);
		else if (108 <= n && n <= 1131) return n -= 108, e.writeUInt8((n >> 8) + 247), e.writeUInt8(n & 255);
		else if (-1131 <= n && n <= -108) return n = -n - 108, e.writeUInt8((n >> 8) + 251), e.writeUInt8(n & 255);
		else if (-32768 <= n && n <= 32767) return e.writeUInt8(28), e.writeInt16BE(n);
		else return e.writeUInt8(29), e.writeInt32BE(n);
	}
}, Sx = class {
	decodeOperands(e, t, n, r) {
		if (Array.isArray(e)) return r.map((r, i) => this.decodeOperands(e[i], t, n, [r]));
		if (e.decode != null) return e.decode(t, n, r);
		switch (e) {
			case "number":
			case "offset":
			case "sid": return r[0];
			case "boolean": return !!r[0];
			default: return r;
		}
	}
	encodeOperands(e, t, n, r) {
		return Array.isArray(e) ? r.map((r, i) => this.encodeOperands(e[i], t, n, r)[0]) : e.encode == null ? typeof r == "number" ? [r] : typeof r == "boolean" ? [+r] : Array.isArray(r) ? r : [r] : e.encode(t, r, n);
	}
	decode(e, t) {
		let n = e.pos + t.length, r = {}, i = [];
		Object.defineProperties(r, {
			parent: { value: t },
			_startOffset: { value: e.pos }
		});
		for (let e in this.fields) {
			let t = this.fields[e];
			r[t[1]] = t[3];
		}
		for (; e.pos < n;) {
			let t = e.readUInt8();
			if (t < 28) {
				t === 12 && (t = t << 8 | e.readUInt8());
				let n = this.fields[t];
				if (!n) throw Error(`Unknown operator ${t}`);
				let a = this.decodeOperands(n[2], e, r, i);
				a != null && (a instanceof Dy ? Object.defineProperty(r, n[1], a) : r[n[1]] = a), i = [];
			} else i.push(xx.decode(e, t));
		}
		return r;
	}
	size(e, t, n = !0) {
		let r = {
			parent: t,
			val: e,
			pointerSize: 0,
			startOffset: t.startOffset || 0
		}, i = 0;
		for (let t in this.fields) {
			let n = this.fields[t], a = e[n[1]];
			if (a == null || (0, Uy.default)(a, n[3])) continue;
			let o = this.encodeOperands(n[2], null, r, a);
			for (let e of o) i += xx.size(e);
			let s = Array.isArray(n[0]) ? n[0] : [n[0]];
			i += s.length;
		}
		return n && (i += r.pointerSize), i;
	}
	encode(e, t, n) {
		let r = {
			pointers: [],
			startOffset: e.pos,
			parent: n,
			val: t,
			pointerSize: 0
		};
		r.pointerOffset = e.pos + this.size(t, r, !1);
		for (let n of this.ops) {
			let i = t[n[1]];
			if (i == null || (0, Uy.default)(i, n[3])) continue;
			let a = this.encodeOperands(n[2], e, r, i);
			for (let t of a) xx.encode(e, t);
			let o = Array.isArray(n[0]) ? n[0] : [n[0]];
			for (let t of o) e.writeUInt8(t);
		}
		let i = 0;
		for (; i < r.pointers.length;) {
			let t = r.pointers[i++];
			t.type.encode(e, t.val, t.parent);
		}
	}
	constructor(e = []) {
		this.ops = e, this.fields = {};
		for (let t of e) {
			let e = Array.isArray(t[0]) ? t[0][0] << 8 | t[0][1] : t[0];
			this.fields[e] = t;
		}
	}
}, Cx = class extends q {
	decode(e, t, n) {
		return this.offsetType = { decode: () => n[0] }, super.decode(e, t, n);
	}
	encode(e, t, n) {
		if (!e) return this.offsetType = { size: () => 0 }, this.size(t, n), [new wx(0)];
		let r = null;
		return this.offsetType = { encode: (e, t) => r = t }, super.encode(e, t, n), [new wx(r)];
	}
	constructor(e, t = {}) {
		t.type ??= "global", super(null, e, t);
	}
}, wx = class {
	valueOf() {
		return this.val;
	}
	constructor(e) {
		this.val = e, this.forceLarge = !0;
	}
}, Tx = new Sx([
	[
		6,
		"BlueValues",
		"delta",
		null
	],
	[
		7,
		"OtherBlues",
		"delta",
		null
	],
	[
		8,
		"FamilyBlues",
		"delta",
		null
	],
	[
		9,
		"FamilyOtherBlues",
		"delta",
		null
	],
	[
		[12, 9],
		"BlueScale",
		"number",
		.039625
	],
	[
		[12, 10],
		"BlueShift",
		"number",
		7
	],
	[
		[12, 11],
		"BlueFuzz",
		"number",
		1
	],
	[
		10,
		"StdHW",
		"number",
		null
	],
	[
		11,
		"StdVW",
		"number",
		null
	],
	[
		[12, 12],
		"StemSnapH",
		"delta",
		null
	],
	[
		[12, 13],
		"StemSnapV",
		"delta",
		null
	],
	[
		[12, 14],
		"ForceBold",
		"boolean",
		!1
	],
	[
		[12, 17],
		"LanguageGroup",
		"number",
		0
	],
	[
		[12, 18],
		"ExpansionFactor",
		"number",
		.06
	],
	[
		[12, 19],
		"initialRandomSeed",
		"number",
		0
	],
	[
		20,
		"defaultWidthX",
		"number",
		0
	],
	[
		21,
		"nominalWidthX",
		"number",
		0
	],
	[
		22,
		"vsindex",
		"number",
		0
	],
	[
		23,
		"blend",
		class {
			static decode(e, t, n) {
				let r = n.pop();
				for (; n.length > r;) n.pop();
			}
		},
		null
	],
	[
		19,
		"Subrs",
		new Cx(new _x(), { type: "local" }),
		null
	]
]), Ex = /* @__PURE__ */ ".notdef,space,exclam,quotedbl,numbersign,dollar,percent,ampersand,quoteright,parenleft,parenright,asterisk,plus,comma,hyphen,period,slash,zero,one,two,three,four,five,six,seven,eight,nine,colon,semicolon,less,equal,greater,question,at,A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z,bracketleft,backslash,bracketright,asciicircum,underscore,quoteleft,a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,braceleft,bar,braceright,asciitilde,exclamdown,cent,sterling,fraction,yen,florin,section,currency,quotesingle,quotedblleft,guillemotleft,guilsinglleft,guilsinglright,fi,fl,endash,dagger,daggerdbl,periodcentered,paragraph,bullet,quotesinglbase,quotedblbase,quotedblright,guillemotright,ellipsis,perthousand,questiondown,grave,acute,circumflex,tilde,macron,breve,dotaccent,dieresis,ring,cedilla,hungarumlaut,ogonek,caron,emdash,AE,ordfeminine,Lslash,Oslash,OE,ordmasculine,ae,dotlessi,lslash,oslash,oe,germandbls,onesuperior,logicalnot,mu,trademark,Eth,onehalf,plusminus,Thorn,onequarter,divide,brokenbar,degree,thorn,threequarters,twosuperior,registered,minus,eth,multiply,threesuperior,copyright,Aacute,Acircumflex,Adieresis,Agrave,Aring,Atilde,Ccedilla,Eacute,Ecircumflex,Edieresis,Egrave,Iacute,Icircumflex,Idieresis,Igrave,Ntilde,Oacute,Ocircumflex,Odieresis,Ograve,Otilde,Scaron,Uacute,Ucircumflex,Udieresis,Ugrave,Yacute,Ydieresis,Zcaron,aacute,acircumflex,adieresis,agrave,aring,atilde,ccedilla,eacute,ecircumflex,edieresis,egrave,iacute,icircumflex,idieresis,igrave,ntilde,oacute,ocircumflex,odieresis,ograve,otilde,scaron,uacute,ucircumflex,udieresis,ugrave,yacute,ydieresis,zcaron,exclamsmall,Hungarumlautsmall,dollaroldstyle,dollarsuperior,ampersandsmall,Acutesmall,parenleftsuperior,parenrightsuperior,twodotenleader,onedotenleader,zerooldstyle,oneoldstyle,twooldstyle,threeoldstyle,fouroldstyle,fiveoldstyle,sixoldstyle,sevenoldstyle,eightoldstyle,nineoldstyle,commasuperior,threequartersemdash,periodsuperior,questionsmall,asuperior,bsuperior,centsuperior,dsuperior,esuperior,isuperior,lsuperior,msuperior,nsuperior,osuperior,rsuperior,ssuperior,tsuperior,ff,ffi,ffl,parenleftinferior,parenrightinferior,Circumflexsmall,hyphensuperior,Gravesmall,Asmall,Bsmall,Csmall,Dsmall,Esmall,Fsmall,Gsmall,Hsmall,Ismall,Jsmall,Ksmall,Lsmall,Msmall,Nsmall,Osmall,Psmall,Qsmall,Rsmall,Ssmall,Tsmall,Usmall,Vsmall,Wsmall,Xsmall,Ysmall,Zsmall,colonmonetary,onefitted,rupiah,Tildesmall,exclamdownsmall,centoldstyle,Lslashsmall,Scaronsmall,Zcaronsmall,Dieresissmall,Brevesmall,Caronsmall,Dotaccentsmall,Macronsmall,figuredash,hypheninferior,Ogoneksmall,Ringsmall,Cedillasmall,questiondownsmall,oneeighth,threeeighths,fiveeighths,seveneighths,onethird,twothirds,zerosuperior,foursuperior,fivesuperior,sixsuperior,sevensuperior,eightsuperior,ninesuperior,zeroinferior,oneinferior,twoinferior,threeinferior,fourinferior,fiveinferior,sixinferior,seveninferior,eightinferior,nineinferior,centinferior,dollarinferior,periodinferior,commainferior,Agravesmall,Aacutesmall,Acircumflexsmall,Atildesmall,Adieresissmall,Aringsmall,AEsmall,Ccedillasmall,Egravesmall,Eacutesmall,Ecircumflexsmall,Edieresissmall,Igravesmall,Iacutesmall,Icircumflexsmall,Idieresissmall,Ethsmall,Ntildesmall,Ogravesmall,Oacutesmall,Ocircumflexsmall,Otildesmall,Odieresissmall,OEsmall,Oslashsmall,Ugravesmall,Uacutesmall,Ucircumflexsmall,Udieresissmall,Yacutesmall,Thornsmall,Ydieresissmall,001.000,001.001,001.002,001.003,Black,Bold,Book,Light,Medium,Regular,Roman,Semibold".split(","), Dx = /* @__PURE__ */ "................................space.exclam.quotedbl.numbersign.dollar.percent.ampersand.quoteright.parenleft.parenright.asterisk.plus.comma.hyphen.period.slash.zero.one.two.three.four.five.six.seven.eight.nine.colon.semicolon.less.equal.greater.question.at.A.B.C.D.E.F.G.H.I.J.K.L.M.N.O.P.Q.R.S.T.U.V.W.X.Y.Z.bracketleft.backslash.bracketright.asciicircum.underscore.quoteleft.a.b.c.d.e.f.g.h.i.j.k.l.m.n.o.p.q.r.s.t.u.v.w.x.y.z.braceleft.bar.braceright.asciitilde...................................exclamdown.cent.sterling.fraction.yen.florin.section.currency.quotesingle.quotedblleft.guillemotleft.guilsinglleft.guilsinglright.fi.fl..endash.dagger.daggerdbl.periodcentered..paragraph.bullet.quotesinglbase.quotedblbase.quotedblright.guillemotright.ellipsis.perthousand..questiondown..grave.acute.circumflex.tilde.macron.breve.dotaccent.dieresis..ring.cedilla..hungarumlaut.ogonek.caron.emdash.................AE..ordfeminine.....Lslash.Oslash.OE.ordmasculine......ae....dotlessi...lslash.oslash.oe.germandbls".split("."), Ox = /* @__PURE__ */ "................................space.exclamsmall.Hungarumlautsmall..dollaroldstyle.dollarsuperior.ampersandsmall.Acutesmall.parenleftsuperior.parenrightsuperior.twodotenleader.onedotenleader.comma.hyphen.period.fraction.zerooldstyle.oneoldstyle.twooldstyle.threeoldstyle.fouroldstyle.fiveoldstyle.sixoldstyle.sevenoldstyle.eightoldstyle.nineoldstyle.colon.semicolon.commasuperior.threequartersemdash.periodsuperior.questionsmall..asuperior.bsuperior.centsuperior.dsuperior.esuperior...isuperior...lsuperior.msuperior.nsuperior.osuperior...rsuperior.ssuperior.tsuperior..ff.fi.fl.ffi.ffl.parenleftinferior..parenrightinferior.Circumflexsmall.hyphensuperior.Gravesmall.Asmall.Bsmall.Csmall.Dsmall.Esmall.Fsmall.Gsmall.Hsmall.Ismall.Jsmall.Ksmall.Lsmall.Msmall.Nsmall.Osmall.Psmall.Qsmall.Rsmall.Ssmall.Tsmall.Usmall.Vsmall.Wsmall.Xsmall.Ysmall.Zsmall.colonmonetary.onefitted.rupiah.Tildesmall...................................exclamdownsmall.centoldstyle.Lslashsmall...Scaronsmall.Zcaronsmall.Dieresissmall.Brevesmall.Caronsmall..Dotaccentsmall...Macronsmall...figuredash.hypheninferior...Ogoneksmall.Ringsmall.Cedillasmall....onequarter.onehalf.threequarters.questiondownsmall.oneeighth.threeeighths.fiveeighths.seveneighths.onethird.twothirds...zerosuperior.onesuperior.twosuperior.threesuperior.foursuperior.fivesuperior.sixsuperior.sevensuperior.eightsuperior.ninesuperior.zeroinferior.oneinferior.twoinferior.threeinferior.fourinferior.fiveinferior.sixinferior.seveninferior.eightinferior.nineinferior.centinferior.dollarinferior.periodinferior.commainferior.Agravesmall.Aacutesmall.Acircumflexsmall.Atildesmall.Adieresissmall.Aringsmall.AEsmall.Ccedillasmall.Egravesmall.Eacutesmall.Ecircumflexsmall.Edieresissmall.Igravesmall.Iacutesmall.Icircumflexsmall.Idieresissmall.Ethsmall.Ntildesmall.Ogravesmall.Oacutesmall.Ocircumflexsmall.Otildesmall.Odieresissmall.OEsmall.Oslashsmall.Ugravesmall.Uacutesmall.Ucircumflexsmall.Udieresissmall.Yacutesmall.Thornsmall.Ydieresissmall".split("."), kx = /* @__PURE__ */ ".notdef,space,exclam,quotedbl,numbersign,dollar,percent,ampersand,quoteright,parenleft,parenright,asterisk,plus,comma,hyphen,period,slash,zero,one,two,three,four,five,six,seven,eight,nine,colon,semicolon,less,equal,greater,question,at,A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z,bracketleft,backslash,bracketright,asciicircum,underscore,quoteleft,a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,braceleft,bar,braceright,asciitilde,exclamdown,cent,sterling,fraction,yen,florin,section,currency,quotesingle,quotedblleft,guillemotleft,guilsinglleft,guilsinglright,fi,fl,endash,dagger,daggerdbl,periodcentered,paragraph,bullet,quotesinglbase,quotedblbase,quotedblright,guillemotright,ellipsis,perthousand,questiondown,grave,acute,circumflex,tilde,macron,breve,dotaccent,dieresis,ring,cedilla,hungarumlaut,ogonek,caron,emdash,AE,ordfeminine,Lslash,Oslash,OE,ordmasculine,ae,dotlessi,lslash,oslash,oe,germandbls,onesuperior,logicalnot,mu,trademark,Eth,onehalf,plusminus,Thorn,onequarter,divide,brokenbar,degree,thorn,threequarters,twosuperior,registered,minus,eth,multiply,threesuperior,copyright,Aacute,Acircumflex,Adieresis,Agrave,Aring,Atilde,Ccedilla,Eacute,Ecircumflex,Edieresis,Egrave,Iacute,Icircumflex,Idieresis,Igrave,Ntilde,Oacute,Ocircumflex,Odieresis,Ograve,Otilde,Scaron,Uacute,Ucircumflex,Udieresis,Ugrave,Yacute,Ydieresis,Zcaron,aacute,acircumflex,adieresis,agrave,aring,atilde,ccedilla,eacute,ecircumflex,edieresis,egrave,iacute,icircumflex,idieresis,igrave,ntilde,oacute,ocircumflex,odieresis,ograve,otilde,scaron,uacute,ucircumflex,udieresis,ugrave,yacute,ydieresis,zcaron".split(","), Ax = /* @__PURE__ */ ".notdef,space,exclamsmall,Hungarumlautsmall,dollaroldstyle,dollarsuperior,ampersandsmall,Acutesmall,parenleftsuperior,parenrightsuperior,twodotenleader,onedotenleader,comma,hyphen,period,fraction,zerooldstyle,oneoldstyle,twooldstyle,threeoldstyle,fouroldstyle,fiveoldstyle,sixoldstyle,sevenoldstyle,eightoldstyle,nineoldstyle,colon,semicolon,commasuperior,threequartersemdash,periodsuperior,questionsmall,asuperior,bsuperior,centsuperior,dsuperior,esuperior,isuperior,lsuperior,msuperior,nsuperior,osuperior,rsuperior,ssuperior,tsuperior,ff,fi,fl,ffi,ffl,parenleftinferior,parenrightinferior,Circumflexsmall,hyphensuperior,Gravesmall,Asmall,Bsmall,Csmall,Dsmall,Esmall,Fsmall,Gsmall,Hsmall,Ismall,Jsmall,Ksmall,Lsmall,Msmall,Nsmall,Osmall,Psmall,Qsmall,Rsmall,Ssmall,Tsmall,Usmall,Vsmall,Wsmall,Xsmall,Ysmall,Zsmall,colonmonetary,onefitted,rupiah,Tildesmall,exclamdownsmall,centoldstyle,Lslashsmall,Scaronsmall,Zcaronsmall,Dieresissmall,Brevesmall,Caronsmall,Dotaccentsmall,Macronsmall,figuredash,hypheninferior,Ogoneksmall,Ringsmall,Cedillasmall,onequarter,onehalf,threequarters,questiondownsmall,oneeighth,threeeighths,fiveeighths,seveneighths,onethird,twothirds,zerosuperior,onesuperior,twosuperior,threesuperior,foursuperior,fivesuperior,sixsuperior,sevensuperior,eightsuperior,ninesuperior,zeroinferior,oneinferior,twoinferior,threeinferior,fourinferior,fiveinferior,sixinferior,seveninferior,eightinferior,nineinferior,centinferior,dollarinferior,periodinferior,commainferior,Agravesmall,Aacutesmall,Acircumflexsmall,Atildesmall,Adieresissmall,Aringsmall,AEsmall,Ccedillasmall,Egravesmall,Eacutesmall,Ecircumflexsmall,Edieresissmall,Igravesmall,Iacutesmall,Icircumflexsmall,Idieresissmall,Ethsmall,Ntildesmall,Ogravesmall,Oacutesmall,Ocircumflexsmall,Otildesmall,Odieresissmall,OEsmall,Oslashsmall,Ugravesmall,Uacutesmall,Ucircumflexsmall,Udieresissmall,Yacutesmall,Thornsmall,Ydieresissmall".split(","), jx = /* @__PURE__ */ ".notdef,space,dollaroldstyle,dollarsuperior,parenleftsuperior,parenrightsuperior,twodotenleader,onedotenleader,comma,hyphen,period,fraction,zerooldstyle,oneoldstyle,twooldstyle,threeoldstyle,fouroldstyle,fiveoldstyle,sixoldstyle,sevenoldstyle,eightoldstyle,nineoldstyle,colon,semicolon,commasuperior,threequartersemdash,periodsuperior,asuperior,bsuperior,centsuperior,dsuperior,esuperior,isuperior,lsuperior,msuperior,nsuperior,osuperior,rsuperior,ssuperior,tsuperior,ff,fi,fl,ffi,ffl,parenleftinferior,parenrightinferior,hyphensuperior,colonmonetary,onefitted,rupiah,centoldstyle,figuredash,hypheninferior,onequarter,onehalf,threequarters,oneeighth,threeeighths,fiveeighths,seveneighths,onethird,twothirds,zerosuperior,onesuperior,twosuperior,threesuperior,foursuperior,fivesuperior,sixsuperior,sevensuperior,eightsuperior,ninesuperior,zeroinferior,oneinferior,twoinferior,threeinferior,fourinferior,fiveinferior,sixinferior,seveninferior,eightinferior,nineinferior,centinferior,dollarinferior,periodinferior,commainferior".split(","), Mx = new K({
	reserved: new Ny(H),
	reqFeatureIndex: H,
	featureCount: H,
	featureIndexes: new G(H, "featureCount")
}), Nx = new K({
	tag: new Py(4),
	langSys: new q(H, Mx, { type: "parent" })
}), Px = new K({
	defaultLangSys: new q(H, Mx),
	count: H,
	langSysRecords: new G(Nx, "count")
}), Fx = new G(new K({
	tag: new Py(4),
	script: new q(H, Px, { type: "parent" })
}), H), Ix = new K({
	featureParams: new q(H, new K({
		version: H,
		nameID: H
	})),
	lookupCount: H,
	lookupListIndexes: new G(H, "lookupCount")
}), Lx = new G(new K({
	tag: new Py(4),
	feature: new q(H, Ix, { type: "parent" })
}), H), Rx = new K({
	markAttachmentType: vy,
	flags: new Ay(vy, [
		"rightToLeft",
		"ignoreBaseGlyphs",
		"ignoreLigatures",
		"ignoreMarks",
		"useMarkFilteringSet"
	])
});
function zx(e) {
	return new Oy(new q(H, new K({
		lookupType: H,
		flags: Rx,
		subTableCount: H,
		subTables: new G(new q(H, e), "subTableCount"),
		markFilteringSet: new My(H, (e) => e.flags.flags.useMarkFilteringSet)
	})), H);
}
var Bx = new K({
	start: H,
	end: H,
	startCoverageIndex: H
}), Vx = new Ly(H, {
	1: {
		glyphCount: H,
		glyphs: new G(H, "glyphCount")
	},
	2: {
		rangeCount: H,
		rangeRecords: new G(Bx, "rangeCount")
	}
}), Hx = new K({
	start: H,
	end: H,
	class: H
}), Ux = new Ly(H, {
	1: {
		startGlyph: H,
		glyphCount: H,
		classValueArray: new G(H, "glyphCount")
	},
	2: {
		classRangeCount: H,
		classRangeRecord: new G(Hx, "classRangeCount")
	}
}), Wx = new K({
	a: H,
	b: H,
	deltaFormat: H
}), Gx = new K({
	sequenceIndex: H,
	lookupListIndex: H
}), Kx = new G(new q(H, new K({
	glyphCount: H,
	lookupCount: H,
	input: new G(H, (e) => e.glyphCount - 1),
	lookupRecords: new G(Gx, "lookupCount")
})), H), qx = new G(new q(H, new K({
	glyphCount: H,
	lookupCount: H,
	classes: new G(H, (e) => e.glyphCount - 1),
	lookupRecords: new G(Gx, "lookupCount")
})), H), Jx = new Ly(H, {
	1: {
		coverage: new q(H, Vx),
		ruleSetCount: H,
		ruleSets: new G(new q(H, Kx), "ruleSetCount")
	},
	2: {
		coverage: new q(H, Vx),
		classDef: new q(H, Ux),
		classSetCnt: H,
		classSet: new G(new q(H, qx), "classSetCnt")
	},
	3: {
		glyphCount: H,
		lookupCount: H,
		coverages: new G(new q(H, Vx), "glyphCount"),
		lookupRecords: new G(Gx, "lookupCount")
	}
}), Yx = new G(new q(H, new K({
	backtrackGlyphCount: H,
	backtrack: new G(H, "backtrackGlyphCount"),
	inputGlyphCount: H,
	input: new G(H, (e) => e.inputGlyphCount - 1),
	lookaheadGlyphCount: H,
	lookahead: new G(H, "lookaheadGlyphCount"),
	lookupCount: H,
	lookupRecords: new G(Gx, "lookupCount")
})), H), Xx = new Ly(H, {
	1: {
		coverage: new q(H, Vx),
		chainCount: H,
		chainRuleSets: new G(new q(H, Yx), "chainCount")
	},
	2: {
		coverage: new q(H, Vx),
		backtrackClassDef: new q(H, Ux),
		inputClassDef: new q(H, Ux),
		lookaheadClassDef: new q(H, Ux),
		chainCount: H,
		chainClassSet: new G(new q(H, Yx), "chainCount")
	},
	3: {
		backtrackGlyphCount: H,
		backtrackCoverage: new G(new q(H, Vx), "backtrackGlyphCount"),
		inputGlyphCount: H,
		inputCoverage: new G(new q(H, Vx), "inputGlyphCount"),
		lookaheadGlyphCount: H,
		lookaheadCoverage: new G(new q(H, Vx), "lookaheadGlyphCount"),
		lookupCount: H,
		lookupRecords: new G(Gx, "lookupCount")
	}
}), Zx = new wy(16, "BE", 14), Qx = new K({
	axisCount: H,
	regionCount: H,
	variationRegions: new G(new G(new K({
		startCoord: Zx,
		peakCoord: Zx,
		endCoord: Zx
	}), "axisCount"), "regionCount")
}), $x = new K({
	shortDeltas: new G(W, (e) => e.parent.shortDeltaCount),
	regionDeltas: new G(Sy, (e) => e.parent.regionIndexCount - e.parent.shortDeltaCount),
	deltas: (e) => e.shortDeltas.concat(e.regionDeltas)
}), eS = new K({
	itemCount: H,
	shortDeltaCount: H,
	regionIndexCount: H,
	regionIndexes: new G(H, "regionIndexCount"),
	deltaSets: new G($x, "itemCount")
}), tS = new K({
	format: H,
	variationRegionList: new q(U, Qx),
	variationDataCount: H,
	itemVariationData: new G(new q(U, eS), "variationDataCount")
}), nS = new K({
	conditionCount: H,
	conditionTable: new G(new q(U, new Ly(H, { 1: {
		axisIndex: H,
		axisIndex: H,
		filterRangeMinValue: Zx,
		filterRangeMaxValue: Zx
	} })), "conditionCount")
}), rS = new K({
	version: Ty,
	substitutionCount: H,
	substitutions: new G(new K({
		featureIndex: H,
		alternateFeatureTable: new q(U, Ix, { type: "parent" })
	}), "substitutionCount")
}), iS = new K({
	majorVersion: H,
	minorVersion: H,
	featureVariationRecordCount: U,
	featureVariationRecords: new G(new K({
		conditionSet: new q(U, nS, { type: "parent" }),
		featureTableSubstitution: new q(U, rS, { type: "parent" })
	}), "featureVariationRecordCount")
}), aS = class {
	decode(e, t, n) {
		return this.predefinedOps[n[0]] ? this.predefinedOps[n[0]] : this.type.decode(e, t, n);
	}
	size(e, t) {
		return this.type.size(e, t);
	}
	encode(e, t, n) {
		let r = this.predefinedOps.indexOf(t);
		return r === -1 ? this.type.encode(e, t, n) : r;
	}
	constructor(e, t) {
		this.predefinedOps = e, this.type = t;
	}
}, oS = class extends _y {
	decode(e) {
		return vy.decode(e) & 127;
	}
	constructor() {
		super("UInt8");
	}
}, sS = new K({
	first: H,
	nLeft: vy
}), cS = new K({
	first: H,
	nLeft: H
}), lS = new Ly(new oS(), {
	0: {
		nCodes: vy,
		codes: new G(vy, "nCodes")
	},
	1: {
		nRanges: vy,
		ranges: new G(sS, "nRanges")
	}
}), uS = new aS([Dx, Ox], new Cx(lS, { lazy: !0 })), dS = class extends G {
	decode(e, t) {
		let n = Ey(this.length, e, t), r = 0, i = [];
		for (; r < n;) {
			let n = this.type.decode(e, t);
			n.offset = r, r += n.nLeft + 1, i.push(n);
		}
		return i;
	}
}, fS = new Ly(vy, {
	0: { glyphs: new G(H, (e) => e.parent.CharStrings.length - 1) },
	1: { ranges: new dS(sS, (e) => e.parent.CharStrings.length - 1) },
	2: { ranges: new dS(cS, (e) => e.parent.CharStrings.length - 1) }
}), pS = new aS([
	kx,
	Ax,
	jx
], new Cx(fS, { lazy: !0 })), mS = new K({
	first: H,
	fd: vy
}), hS = new K({
	first: U,
	fd: H
}), gS = new Ly(vy, {
	0: { fds: new G(vy, (e) => e.parent.CharStrings.length) },
	3: {
		nRanges: H,
		ranges: new G(mS, "nRanges"),
		sentinel: H
	},
	4: {
		nRanges: U,
		ranges: new G(hS, "nRanges"),
		sentinel: U
	}
}), _S = new Cx(Tx), vS = class {
	decode(e, t, n) {
		return t.length = n[0], _S.decode(e, t, [n[1]]);
	}
	size(e, t) {
		return [Tx.size(e, t, !1), _S.size(e, t)[0]];
	}
	encode(e, t, n) {
		return [Tx.size(t, n, !1), _S.encode(e, t, n)[0]];
	}
}, yS = new Sx([
	[
		18,
		"Private",
		new vS(),
		null
	],
	[
		[12, 38],
		"FontName",
		"sid",
		null
	],
	[
		[12, 7],
		"FontMatrix",
		"array",
		[
			.001,
			0,
			0,
			.001,
			0,
			0
		]
	],
	[
		[12, 5],
		"PaintType",
		"number",
		0
	]
]), bS = new Sx([
	[
		[12, 30],
		"ROS",
		[
			"sid",
			"sid",
			"number"
		],
		null
	],
	[
		0,
		"version",
		"sid",
		null
	],
	[
		1,
		"Notice",
		"sid",
		null
	],
	[
		[12, 0],
		"Copyright",
		"sid",
		null
	],
	[
		2,
		"FullName",
		"sid",
		null
	],
	[
		3,
		"FamilyName",
		"sid",
		null
	],
	[
		4,
		"Weight",
		"sid",
		null
	],
	[
		[12, 1],
		"isFixedPitch",
		"boolean",
		!1
	],
	[
		[12, 2],
		"ItalicAngle",
		"number",
		0
	],
	[
		[12, 3],
		"UnderlinePosition",
		"number",
		-100
	],
	[
		[12, 4],
		"UnderlineThickness",
		"number",
		50
	],
	[
		[12, 5],
		"PaintType",
		"number",
		0
	],
	[
		[12, 6],
		"CharstringType",
		"number",
		2
	],
	[
		[12, 7],
		"FontMatrix",
		"array",
		[
			.001,
			0,
			0,
			.001,
			0,
			0
		]
	],
	[
		13,
		"UniqueID",
		"number",
		null
	],
	[
		5,
		"FontBBox",
		"array",
		[
			0,
			0,
			0,
			0
		]
	],
	[
		[12, 8],
		"StrokeWidth",
		"number",
		0
	],
	[
		14,
		"XUID",
		"array",
		null
	],
	[
		15,
		"charset",
		pS,
		kx
	],
	[
		16,
		"Encoding",
		uS,
		Dx
	],
	[
		17,
		"CharStrings",
		new Cx(new _x()),
		null
	],
	[
		18,
		"Private",
		new vS(),
		null
	],
	[
		[12, 20],
		"SyntheticBase",
		"number",
		null
	],
	[
		[12, 21],
		"PostScript",
		"sid",
		null
	],
	[
		[12, 22],
		"BaseFontName",
		"sid",
		null
	],
	[
		[12, 23],
		"BaseFontBlend",
		"delta",
		null
	],
	[
		[12, 31],
		"CIDFontVersion",
		"number",
		0
	],
	[
		[12, 32],
		"CIDFontRevision",
		"number",
		0
	],
	[
		[12, 33],
		"CIDFontType",
		"number",
		0
	],
	[
		[12, 34],
		"CIDCount",
		"number",
		8720
	],
	[
		[12, 35],
		"UIDBase",
		"number",
		null
	],
	[
		[12, 37],
		"FDSelect",
		new Cx(gS),
		null
	],
	[
		[12, 36],
		"FDArray",
		new Cx(new _x(yS)),
		null
	],
	[
		[12, 38],
		"FontName",
		"sid",
		null
	]
]), xS = new K({
	length: H,
	itemVariationStore: tS
}), SS = new Sx([
	[
		[12, 7],
		"FontMatrix",
		"array",
		[
			.001,
			0,
			0,
			.001,
			0,
			0
		]
	],
	[
		17,
		"CharStrings",
		new Cx(new _x()),
		null
	],
	[
		[12, 37],
		"FDSelect",
		new Cx(gS),
		null
	],
	[
		[12, 36],
		"FDArray",
		new Cx(new _x(yS)),
		null
	],
	[
		24,
		"vstore",
		new Cx(xS),
		null
	],
	[
		25,
		"maxstack",
		"number",
		193
	]
]), CS = new Ly(Vte, {
	1: {
		hdrSize: vy,
		offSize: vy,
		nameIndex: new _x(new Py("length")),
		topDictIndex: new _x(bS),
		stringIndex: new _x(new Py("length")),
		globalSubrIndex: new _x()
	},
	2: {
		hdrSize: vy,
		length: H,
		topDict: SS,
		globalSubrIndex: new _x()
	}
}), wS = class e {
	static decode(t) {
		return new e(t);
	}
	decode() {
		this.stream.pos;
		let e = CS.decode(this.stream);
		for (let t in e) {
			let n = e[t];
			this[t] = n;
		}
		if (this.version < 2) {
			if (this.topDictIndex.length !== 1) throw Error("Only a single font is allowed in CFF");
			this.topDict = this.topDictIndex[0];
		}
		return this.isCIDFont = this.topDict.ROS != null, this;
	}
	string(e) {
		return this.version >= 2 ? null : e < Ex.length ? Ex[e] : this.stringIndex[e - Ex.length];
	}
	get postscriptName() {
		return this.version < 2 ? this.nameIndex[0] : null;
	}
	get fullName() {
		return this.string(this.topDict.FullName);
	}
	get familyName() {
		return this.string(this.topDict.FamilyName);
	}
	getCharString(e) {
		return this.stream.pos = this.topDict.CharStrings[e].offset, this.stream.readBuffer(this.topDict.CharStrings[e].length);
	}
	getGlyphName(e) {
		if (this.version >= 2 || this.isCIDFont) return null;
		let { charset: t } = this.topDict;
		if (Array.isArray(t)) return t[e];
		if (e === 0) return ".notdef";
		switch (--e, t.version) {
			case 0: return this.string(t.glyphs[e]);
			case 1:
			case 2:
				for (let n = 0; n < t.ranges.length; n++) {
					let r = t.ranges[n];
					if (r.offset <= e && e <= r.offset + r.nLeft) return this.string(r.first + (e - r.offset));
				}
				break;
		}
		return null;
	}
	fdForGlyph(e) {
		if (!this.topDict.FDSelect) return null;
		switch (this.topDict.FDSelect.version) {
			case 0: return this.topDict.FDSelect.fds[e];
			case 3:
			case 4:
				let { ranges: t } = this.topDict.FDSelect, n = 0, r = t.length - 1;
				for (; n <= r;) {
					let i = n + r >> 1;
					if (e < t[i].first) r = i - 1;
					else if (i < r && e >= t[i + 1].first) n = i + 1;
					else return t[i].fd;
				}
			default: throw Error(`Unknown FDSelect version: ${this.topDict.FDSelect.version}`);
		}
	}
	privateDictForGlyph(e) {
		if (this.topDict.FDSelect) {
			let t = this.fdForGlyph(e);
			return this.topDict.FDArray[t] ? this.topDict.FDArray[t].Private : null;
		}
		return this.version < 2 ? this.topDict.Private : this.topDict.FDArray[0].Private;
	}
	constructor(e) {
		this.stream = e, this.decode();
	}
}, TS = new K({
	majorVersion: H,
	minorVersion: H,
	defaultVertOriginY: W,
	numVertOriginYMetrics: H,
	metrics: new G(new K({
		glyphIndex: H,
		vertOriginY: W
	}), "numVertOriginYMetrics")
}), ES = new K({
	height: vy,
	width: vy,
	horiBearingX: Sy,
	horiBearingY: Sy,
	horiAdvance: vy,
	vertBearingX: Sy,
	vertBearingY: Sy,
	vertAdvance: vy
}), DS = new K({
	height: vy,
	width: vy,
	bearingX: Sy,
	bearingY: Sy,
	advance: vy
}), OS = new K({
	glyph: H,
	xOffset: Sy,
	yOffset: Sy
}), kS = class {}, AS = class {};
new Ly("version", {
	1: {
		metrics: DS,
		data: kS
	},
	2: {
		metrics: DS,
		data: AS
	},
	5: { data: AS },
	6: {
		metrics: ES,
		data: kS
	},
	7: {
		metrics: ES,
		data: AS
	},
	8: {
		metrics: DS,
		pad: new Ny(vy),
		numComponents: H,
		components: new G(OS, "numComponents")
	},
	9: {
		metrics: ES,
		pad: new Ny(vy),
		numComponents: H,
		components: new G(OS, "numComponents")
	},
	17: {
		metrics: DS,
		dataLen: U,
		data: new jy("dataLen")
	},
	18: {
		metrics: ES,
		dataLen: U,
		data: new jy("dataLen")
	},
	19: {
		dataLen: U,
		data: new jy("dataLen")
	}
});
var jS = new K({
	ascender: Sy,
	descender: Sy,
	widthMax: vy,
	caretSlopeNumerator: Sy,
	caretSlopeDenominator: Sy,
	caretOffset: Sy,
	minOriginSB: Sy,
	minAdvanceSB: Sy,
	maxBeforeBL: Sy,
	minAfterBL: Sy,
	pad: new Ny(Sy, 2)
}), MS = new K({
	glyphCode: H,
	offset: H
}), NS = new K({
	version: U,
	numSizes: U,
	sizes: new G(new K({
		indexSubTableArray: new q(U, new G(new K({
			firstGlyphIndex: H,
			lastGlyphIndex: H,
			subtable: new q(U, new Ly(H, {
				header: {
					imageFormat: H,
					imageDataOffset: U
				},
				1: { offsetArray: new G(U, (e) => e.parent.lastGlyphIndex - e.parent.firstGlyphIndex + 1) },
				2: {
					imageSize: U,
					bigMetrics: ES
				},
				3: { offsetArray: new G(H, (e) => e.parent.lastGlyphIndex - e.parent.firstGlyphIndex + 1) },
				4: {
					numGlyphs: U,
					glyphArray: new G(MS, (e) => e.numGlyphs + 1)
				},
				5: {
					imageSize: U,
					bigMetrics: ES,
					numGlyphs: U,
					glyphCodeArray: new G(H, "numGlyphs")
				}
			}))
		}), 1), { type: "parent" }),
		indexTablesSize: U,
		numberOfIndexSubTables: U,
		colorRef: U,
		hori: jS,
		vert: jS,
		startGlyphIndex: H,
		endGlyphIndex: H,
		ppemX: vy,
		ppemY: vy,
		bitDepth: vy,
		flags: new Ay(vy, ["horizontal", "vertical"])
	}), "numSizes")
}), PS = new K({
	ppem: H,
	resolution: H,
	imageOffsets: new G(new q(U, "void"), (e) => e.parent.parent.maxp.numGlyphs + 1)
}), FS = new K({
	version: H,
	flags: new Ay(H, ["renderOutlines"]),
	numImgTables: U,
	imageTables: new G(new q(U, PS), "numImgTables")
}), IS = new K({
	gid: H,
	paletteIndex: H
}), LS = new K({
	version: H,
	numBaseGlyphRecords: H,
	baseGlyphRecord: new q(U, new G(new K({
		gid: H,
		firstLayerIndex: H,
		numLayers: H
	}), "numBaseGlyphRecords")),
	layerRecords: new q(U, new G(IS, "numLayerRecords"), { lazy: !0 }),
	numLayerRecords: H
}), RS = new Ly(H, {
	header: {
		numPaletteEntries: H,
		numPalettes: H,
		numColorRecords: H,
		colorRecords: new q(U, new G(new K({
			blue: vy,
			green: vy,
			red: vy,
			alpha: vy
		}), "numColorRecords")),
		colorRecordIndices: new G(H, "numPalettes")
	},
	0: {},
	1: {
		offsetPaletteTypeArray: new q(U, new G(U, "numPalettes")),
		offsetPaletteLabelArray: new q(U, new G(H, "numPalettes")),
		offsetPaletteEntryLabelArray: new q(U, new G(H, "numPaletteEntries"))
	}
}), zS = new Ly(H, {
	1: { coordinate: W },
	2: {
		coordinate: W,
		referenceGlyph: H,
		baseCoordPoint: H
	},
	3: {
		coordinate: W,
		deviceTable: new q(H, Wx)
	}
}), BS = new K({
	defaultIndex: H,
	baseCoordCount: H,
	baseCoords: new G(new q(H, zS), "baseCoordCount")
}), VS = new K({
	tag: new Py(4),
	minCoord: new q(H, zS, { type: "parent" }),
	maxCoord: new q(H, zS, { type: "parent" })
}), HS = new K({
	minCoord: new q(H, zS),
	maxCoord: new q(H, zS),
	featMinMaxCount: H,
	featMinMaxRecords: new G(VS, "featMinMaxCount")
}), US = new K({
	tag: new Py(4),
	minMax: new q(H, HS, { type: "parent" })
}), WS = new K({
	baseValues: new q(H, BS),
	defaultMinMax: new q(H, HS),
	baseLangSysCount: H,
	baseLangSysRecords: new G(US, "baseLangSysCount")
}), GS = new G(new K({
	tag: new Py(4),
	script: new q(H, WS, { type: "parent" })
}), H), KS = new K({
	baseTagList: new q(H, new G(new Py(4), H)),
	baseScriptList: new q(H, GS)
}), qS = new Ly(U, {
	header: {
		horizAxis: new q(H, KS),
		vertAxis: new q(H, KS)
	},
	65536: {},
	65537: { itemVariationStore: new q(U, tS) }
}), JS = new G(H, H), YS = new K({
	coverage: new q(H, Vx),
	glyphCount: H,
	attachPoints: new G(new q(H, JS), "glyphCount")
}), XS = new G(new q(H, new Ly(H, {
	1: { coordinate: W },
	2: { caretValuePoint: H },
	3: {
		coordinate: W,
		deviceTable: new q(H, Wx)
	}
})), H), ZS = new K({
	coverage: new q(H, Vx),
	ligGlyphCount: H,
	ligGlyphs: new G(new q(H, XS), "ligGlyphCount")
}), QS = new K({
	markSetTableFormat: H,
	markSetCount: H,
	coverage: new G(new q(U, Vx), "markSetCount")
}), $S = new Ly(U, {
	header: {
		glyphClassDef: new q(H, Ux),
		attachList: new q(H, YS),
		ligCaretList: new q(H, ZS),
		markAttachClassDef: new q(H, Ux)
	},
	65536: {},
	65538: { markGlyphSetsDef: new q(H, QS) },
	65539: {
		markGlyphSetsDef: new q(H, QS),
		itemVariationStore: new q(U, tS)
	}
}), eC = new Ay(H, [
	"xPlacement",
	"yPlacement",
	"xAdvance",
	"yAdvance",
	"xPlaDevice",
	"yPlaDevice",
	"xAdvDevice",
	"yAdvDevice"
]), tC = {
	xPlacement: W,
	yPlacement: W,
	xAdvance: W,
	yAdvance: W,
	xPlaDevice: new q(H, Wx, {
		type: "global",
		relativeTo: (e) => e.rel
	}),
	yPlaDevice: new q(H, Wx, {
		type: "global",
		relativeTo: (e) => e.rel
	}),
	xAdvDevice: new q(H, Wx, {
		type: "global",
		relativeTo: (e) => e.rel
	}),
	yAdvDevice: new q(H, Wx, {
		type: "global",
		relativeTo: (e) => e.rel
	})
}, nC = class {
	buildStruct(e) {
		let t = e;
		for (; !t[this.key] && t.parent;) t = t.parent;
		if (!t[this.key]) return;
		let n = {};
		n.rel = () => t._startOffset;
		let r = t[this.key];
		for (let e in r) r[e] && (n[e] = tC[e]);
		return new K(n);
	}
	size(e, t) {
		return this.buildStruct(t).size(e, t);
	}
	decode(e, t) {
		let n = this.buildStruct(t).decode(e, t);
		return delete n.rel, n;
	}
	constructor(e = "valueFormat") {
		this.key = e;
	}
}, rC = new G(new K({
	secondGlyph: H,
	value1: new nC("valueFormat1"),
	value2: new nC("valueFormat2")
}), H), iC = new K({
	value1: new nC("valueFormat1"),
	value2: new nC("valueFormat2")
}), aC = new Ly(H, {
	1: {
		xCoordinate: W,
		yCoordinate: W
	},
	2: {
		xCoordinate: W,
		yCoordinate: W,
		anchorPoint: H
	},
	3: {
		xCoordinate: W,
		yCoordinate: W,
		xDeviceTable: new q(H, Wx),
		yDeviceTable: new q(H, Wx)
	}
}), oC = new K({
	entryAnchor: new q(H, aC, { type: "parent" }),
	exitAnchor: new q(H, aC, { type: "parent" })
}), sC = new G(new K({
	class: H,
	markAnchor: new q(H, aC, { type: "parent" })
}), H), cC = new G(new G(new q(H, aC), (e) => e.parent.classCount), H), lC = new G(new q(H, new G(new G(new q(H, aC), (e) => e.parent.parent.classCount), H)), H), uC = new Ly("lookupType", {
	1: new Ly(H, {
		1: {
			coverage: new q(H, Vx),
			valueFormat: eC,
			value: new nC()
		},
		2: {
			coverage: new q(H, Vx),
			valueFormat: eC,
			valueCount: H,
			values: new Oy(new nC(), "valueCount")
		}
	}),
	2: new Ly(H, {
		1: {
			coverage: new q(H, Vx),
			valueFormat1: eC,
			valueFormat2: eC,
			pairSetCount: H,
			pairSets: new Oy(new q(H, rC), "pairSetCount")
		},
		2: {
			coverage: new q(H, Vx),
			valueFormat1: eC,
			valueFormat2: eC,
			classDef1: new q(H, Ux),
			classDef2: new q(H, Ux),
			class1Count: H,
			class2Count: H,
			classRecords: new Oy(new Oy(iC, "class2Count"), "class1Count")
		}
	}),
	3: {
		format: H,
		coverage: new q(H, Vx),
		entryExitCount: H,
		entryExitRecords: new G(oC, "entryExitCount")
	},
	4: {
		format: H,
		markCoverage: new q(H, Vx),
		baseCoverage: new q(H, Vx),
		classCount: H,
		markArray: new q(H, sC),
		baseArray: new q(H, cC)
	},
	5: {
		format: H,
		markCoverage: new q(H, Vx),
		ligatureCoverage: new q(H, Vx),
		classCount: H,
		markArray: new q(H, sC),
		ligatureArray: new q(H, lC)
	},
	6: {
		format: H,
		mark1Coverage: new q(H, Vx),
		mark2Coverage: new q(H, Vx),
		classCount: H,
		mark1Array: new q(H, sC),
		mark2Array: new q(H, cC)
	},
	7: Jx,
	8: Xx,
	9: {
		posFormat: H,
		lookupType: H,
		extension: new q(U, null)
	}
});
uC.versions[9].extension.type = uC;
var dC = new Ly(U, {
	header: {
		scriptList: new q(H, Fx),
		featureList: new q(H, Lx),
		lookupList: new q(H, new zx(uC))
	},
	65536: {},
	65537: { featureVariations: new q(U, iS) }
}), fC = new G(H, H), pC = fC, mC = new G(new q(H, new K({
	glyph: H,
	compCount: H,
	components: new G(H, (e) => e.compCount - 1)
})), H), hC = new Ly("lookupType", {
	1: new Ly(H, {
		1: {
			coverage: new q(H, Vx),
			deltaGlyphID: W
		},
		2: {
			coverage: new q(H, Vx),
			glyphCount: H,
			substitute: new Oy(H, "glyphCount")
		}
	}),
	2: {
		substFormat: H,
		coverage: new q(H, Vx),
		count: H,
		sequences: new Oy(new q(H, fC), "count")
	},
	3: {
		substFormat: H,
		coverage: new q(H, Vx),
		count: H,
		alternateSet: new Oy(new q(H, pC), "count")
	},
	4: {
		substFormat: H,
		coverage: new q(H, Vx),
		count: H,
		ligatureSets: new Oy(new q(H, mC), "count")
	},
	5: Jx,
	6: Xx,
	7: {
		substFormat: H,
		lookupType: H,
		extension: new q(U, null)
	},
	8: {
		substFormat: H,
		coverage: new q(H, Vx),
		backtrackCoverage: new G(new q(H, Vx), "backtrackGlyphCount"),
		lookaheadGlyphCount: H,
		lookaheadCoverage: new G(new q(H, Vx), "lookaheadGlyphCount"),
		glyphCount: H,
		substitutes: new G(H, "glyphCount")
	}
});
hC.versions[7].extension.type = hC;
var gC = new Ly(U, {
	header: {
		scriptList: new q(H, Fx),
		featureList: new q(H, Lx),
		lookupList: new q(H, new zx(hC))
	},
	65536: {},
	65537: { featureVariations: new q(U, iS) }
}), _C = new G(H, H), vC = new G(new q(H, new K({
	shrinkageEnableGSUB: new q(H, _C),
	shrinkageDisableGSUB: new q(H, _C),
	shrinkageEnableGPOS: new q(H, _C),
	shrinkageDisableGPOS: new q(H, _C),
	shrinkageJstfMax: new q(H, new zx(uC)),
	extensionEnableGSUB: new q(H, _C),
	extensionDisableGSUB: new q(H, _C),
	extensionEnableGPOS: new q(H, _C),
	extensionDisableGPOS: new q(H, _C),
	extensionJstfMax: new q(H, new zx(uC))
})), H), yC = new K({
	tag: new Py(4),
	jstfLangSys: new q(H, vC)
}), bC = new K({
	extenderGlyphs: new q(H, new G(H, H)),
	defaultLangSys: new q(H, vC),
	langSysCount: H,
	langSysRecords: new G(yC, "langSysCount")
}), xC = new K({
	version: U,
	scriptCount: H,
	scriptList: new G(new K({
		tag: new Py(4),
		script: new q(H, bC, { type: "parent" })
	}), "scriptCount")
}), SC = new K({
	entryFormat: H,
	mapCount: H,
	mapData: new G(new K({
		entry: new class {
			decode(e, t) {
				switch (this.size(0, t)) {
					case 1: return e.readUInt8();
					case 2: return e.readUInt16BE();
					case 3: return e.readUInt24BE();
					case 4: return e.readUInt32BE();
				}
			}
			size(e, t) {
				return Ey(this._size, null, t);
			}
			constructor(e) {
				this._size = e;
			}
		}((e) => ((e.parent.entryFormat & 48) >> 4) + 1),
		outerIndex: (e) => e.entry >> (e.parent.entryFormat & 15) + 1,
		innerIndex: (e) => e.entry & (1 << (e.parent.entryFormat & 15) + 1) - 1
	}), "mapCount")
}), CC = new K({
	majorVersion: H,
	minorVersion: H,
	itemVariationStore: new q(U, tS),
	advanceWidthMapping: new q(U, SC),
	LSBMapping: new q(U, SC),
	RSBMapping: new q(U, SC)
}), wC = new K({
	format: U,
	length: U,
	offset: U
}), TC = new K({
	reserved: new Ny(H, 2),
	cbSignature: U,
	signature: new jy("cbSignature")
}), EC = new K({
	ulVersion: U,
	usNumSigs: H,
	usFlag: H,
	signatures: new G(wC, "usNumSigs"),
	signatureBlocks: new G(TC, "usNumSigs")
}), DC = new K({
	version: H,
	numRanges: H,
	gaspRanges: new G(new K({
		rangeMaxPPEM: H,
		rangeGaspBehavior: new Ay(H, [
			"grayscale",
			"gridfit",
			"symmetricSmoothing",
			"symmetricGridfit"
		])
	}), "numRanges")
}), OC = new K({
	version: H,
	numRecords: W,
	sizeDeviceRecord: Cy,
	records: new G(new K({
		pixelSize: vy,
		maximumWidth: vy,
		widths: new G(vy, (e) => e.parent.parent.maxp.numGlyphs)
	}), "numRecords")
}), kC = new K({
	left: H,
	right: H,
	value: W
}), AC = new K({
	firstGlyph: H,
	nGlyphs: H,
	offsets: new G(H, "nGlyphs"),
	max: (e) => e.offsets.length && Math.max.apply(Math, e.offsets)
}), jC = new K({
	off: (e) => e._startOffset - e.parent.parent._startOffset,
	len: (e) => ((e.parent.leftTable.max - e.off) / e.parent.rowWidth + 1) * (e.parent.rowWidth / 2),
	values: new Oy(W, "len")
}), MC = new Ly("format", {
	0: {
		nPairs: H,
		searchRange: H,
		entrySelector: H,
		rangeShift: H,
		pairs: new G(kC, "nPairs")
	},
	2: {
		rowWidth: H,
		leftTable: new q(H, AC, { type: "parent" }),
		rightTable: new q(H, AC, { type: "parent" }),
		array: new q(H, jC, { type: "parent" })
	},
	3: {
		glyphCount: H,
		kernValueCount: vy,
		leftClassCount: vy,
		rightClassCount: vy,
		flags: vy,
		kernValue: new G(W, "kernValueCount"),
		leftClass: new G(vy, "glyphCount"),
		rightClass: new G(vy, "glyphCount"),
		kernIndex: new G(vy, (e) => e.leftClassCount * e.rightClassCount)
	}
}), NC = new Ly("version", {
	0: {
		subVersion: H,
		length: H,
		format: vy,
		coverage: new Ay(vy, [
			"horizontal",
			"minimum",
			"crossStream",
			"override"
		]),
		subtable: MC,
		padding: new Ny(vy, (e) => e.length - e._currentOffset)
	},
	1: {
		length: U,
		coverage: new Ay(vy, [
			null,
			null,
			null,
			null,
			null,
			"variation",
			"crossStream",
			"vertical"
		]),
		format: vy,
		tupleIndex: H,
		subtable: MC,
		padding: new Ny(vy, (e) => e.length - e._currentOffset)
	}
}), PC = new Ly(H, {
	0: {
		nTables: H,
		tables: new G(NC, "nTables")
	},
	1: {
		reserved: new Ny(H),
		nTables: U,
		tables: new G(NC, "nTables")
	}
}), FC = new K({
	version: H,
	numGlyphs: H,
	yPels: new G(vy, "numGlyphs")
}), IC = new K({
	version: H,
	fontNumber: U,
	pitch: H,
	xHeight: H,
	style: H,
	typeFamily: H,
	capHeight: H,
	symbolSet: H,
	typeface: new Py(16),
	characterComplement: new Py(8),
	fileName: new Py(6),
	strokeWeight: new Py(1),
	widthType: new Py(1),
	serifStyle: vy,
	reserved: new Ny(vy)
}), LC = new K({
	bCharSet: vy,
	xRatio: vy,
	yStartRatio: vy,
	yEndRatio: vy
}), RC = new K({
	recs: H,
	startsz: vy,
	endsz: vy,
	entries: new G(new K({
		yPelHeight: H,
		yMax: W,
		yMin: W
	}), "recs")
}), zC = new K({
	version: H,
	numRecs: H,
	numRatios: H,
	ratioRanges: new G(LC, "numRatios"),
	offsets: new G(H, "numRatios"),
	groups: new G(RC, "numRecs")
}), BC = new K({
	version: H,
	ascent: W,
	descent: W,
	lineGap: W,
	advanceHeightMax: W,
	minTopSideBearing: W,
	minBottomSideBearing: W,
	yMaxExtent: W,
	caretSlopeRise: W,
	caretSlopeRun: W,
	caretOffset: W,
	reserved: new Ny(W, 4),
	metricDataFormat: W,
	numberOfMetrics: H
}), VC = new K({
	metrics: new Oy(new K({
		advance: H,
		bearing: W
	}), (e) => e.parent.vhea.numberOfMetrics),
	bearings: new Oy(W, (e) => e.parent.maxp.numGlyphs - e.parent.vhea.numberOfMetrics)
}), HC = new wy(16, "BE", 14), UC = new K({
	version: Ty,
	axisCount: U,
	segment: new G(new K({
		pairCount: H,
		correspondence: new G(new K({
			fromCoord: HC,
			toCoord: HC
		}), "pairCount")
	}), "axisCount")
}), WC = class {
	getItem(e) {
		if (this._items[e] == null) {
			let t = this.stream.pos;
			this.stream.pos = this.base + this.type.size(null, this.parent) * e, this._items[e] = this.type.decode(this.stream, this.parent), this.stream.pos = t;
		}
		return this._items[e];
	}
	inspect() {
		return `[UnboundedArray ${this.type.constructor.name}]`;
	}
	constructor(e, t, n) {
		this.type = e, this.stream = t, this.parent = n, this.base = this.stream.pos, this._items = [];
	}
}, GC = class extends G {
	decode(e, t) {
		return new WC(this.type, e, t);
	}
	constructor(e) {
		super(e, 0);
	}
}, KC = function(e = H) {
	class t {
		decode(e, t) {
			return t = t.parent.parent, this.type.decode(e, t);
		}
		size(e, t) {
			return t = t.parent.parent, this.type.size(e, t);
		}
		encode(e, t, n) {
			return n = n.parent.parent, this.type.encode(e, t, n);
		}
		constructor(e) {
			this.type = e;
		}
	}
	e = new t(e);
	let n = new K({
		unitSize: H,
		nUnits: H,
		searchRange: H,
		entrySelector: H,
		rangeShift: H
	}), r = new K({
		lastGlyph: H,
		firstGlyph: H,
		value: e
	}), i = new K({
		lastGlyph: H,
		firstGlyph: H,
		values: new q(H, new G(e, (e) => e.lastGlyph - e.firstGlyph + 1), { type: "parent" })
	}), a = new K({
		glyph: H,
		value: e
	});
	return new Ly(H, {
		0: { values: new GC(e) },
		2: {
			binarySearchHeader: n,
			segments: new G(r, (e) => e.binarySearchHeader.nUnits)
		},
		4: {
			binarySearchHeader: n,
			segments: new G(i, (e) => e.binarySearchHeader.nUnits)
		},
		6: {
			binarySearchHeader: n,
			segments: new G(a, (e) => e.binarySearchHeader.nUnits)
		},
		8: {
			firstGlyph: H,
			count: H,
			values: new G(e, "count")
		}
	});
};
function qC(e = {}, t = H) {
	let n = new K(Object.assign({
		newState: H,
		flags: H
	}, e)), r = new GC(new G(H, (e) => e.nClasses));
	return new K({
		nClasses: U,
		classTable: new q(U, new KC(t)),
		stateArray: new q(U, r),
		entryTable: new q(U, new GC(n))
	});
}
function JC(e = {}, t = H) {
	let n = new K({
		version() {
			return 8;
		},
		firstGlyph: H,
		values: new G(vy, H)
	}), r = new K(Object.assign({
		newStateOffset: H,
		newState: (e) => (e.newStateOffset - (e.parent.stateArray.base - e.parent._startOffset)) / e.parent.nClasses,
		flags: H
	}, e)), i = new GC(new G(vy, (e) => e.nClasses));
	return new K({
		nClasses: H,
		classTable: new q(H, n),
		stateArray: new q(H, i),
		entryTable: new q(H, new GC(r))
	});
}
var YC = new K({
	version: Ty,
	format: H,
	defaultBaseline: H,
	subtable: new Ly("format", {
		0: { deltas: new G(W, 32) },
		1: {
			deltas: new G(W, 32),
			mappingData: new KC(H)
		},
		2: {
			standardGlyph: H,
			controlPoints: new G(H, 32)
		},
		3: {
			standardGlyph: H,
			controlPoints: new G(H, 32),
			mappingData: new KC(H)
		}
	})
}), XC = new K({
	feature: H,
	nSettings: H,
	settingTable: new q(U, new G(new K({
		setting: H,
		nameIndex: W,
		name: (e) => e.parent.parent.parent.name.records.fontFeatures[e.nameIndex]
	}), "nSettings"), { type: "parent" }),
	featureFlags: new Ay(vy, [
		null,
		null,
		null,
		null,
		null,
		null,
		"hasDefault",
		"exclusive"
	]),
	defaultSetting: vy,
	nameIndex: W,
	name: (e) => e.parent.parent.name.records.fontFeatures[e.nameIndex]
}), ZC = new K({
	version: Ty,
	featureNameCount: H,
	reserved1: new Ny(H),
	reserved2: new Ny(U),
	featureNames: new G(XC, "featureNameCount")
}), QC = new K({
	axisTag: new Py(4),
	minValue: Ty,
	defaultValue: Ty,
	maxValue: Ty,
	flags: H,
	nameID: H,
	name: (e) => e.parent.parent.name.records.fontFeatures[e.nameID]
}), $C = new K({
	nameID: H,
	name: (e) => e.parent.parent.name.records.fontFeatures[e.nameID],
	flags: H,
	coord: new G(Ty, (e) => e.parent.axisCount),
	postscriptNameID: new My(H, (e) => e.parent.instanceSize - e._currentOffset > 0)
}), ew = new K({
	version: Ty,
	offsetToData: H,
	countSizePairs: H,
	axisCount: H,
	axisSize: H,
	instanceCount: H,
	instanceSize: H,
	axis: new G(QC, "axisCount"),
	instance: new G($C, "instanceCount")
}), tw = new wy(16, "BE", 14), nw = class {
	static decode(e, t) {
		return t.flags ? e.readUInt32BE() : e.readUInt16BE() * 2;
	}
}, rw = new K({
	version: H,
	reserved: new Ny(H),
	axisCount: H,
	globalCoordCount: H,
	globalCoords: new q(U, new G(new G(tw, "axisCount"), "globalCoordCount")),
	glyphCount: H,
	flags: H,
	offsetToData: U,
	offsets: new G(new q(nw, "void", {
		relativeTo: (e) => e.offsetToData,
		allowNull: !1
	}), (e) => e.glyphCount + 1)
}), iw = new K({
	length: H,
	coverage: H,
	subFeatureFlags: U,
	stateTable: new JC()
}), aw = new G(new K({
	justClass: U,
	beforeGrowLimit: Ty,
	beforeShrinkLimit: Ty,
	afterGrowLimit: Ty,
	afterShrinkLimit: Ty,
	growFlags: H,
	shrinkFlags: H
}), U), ow = new K({ lookupTable: new KC(new q(H, new G(new K({
	actionClass: H,
	actionType: H,
	actionLength: U,
	actionData: new Ly("actionType", {
		0: {
			lowerLimit: Ty,
			upperLimit: Ty,
			order: H,
			glyphs: new G(H, H)
		},
		1: { addGlyph: H },
		2: {
			substThreshold: Ty,
			addGlyph: H,
			substGlyph: H
		},
		3: {},
		4: {
			variationAxis: U,
			minimumLimit: Ty,
			noStretchValue: Ty,
			maximumLimit: Ty
		},
		5: {
			flags: H,
			glyph: H
		}
	}),
	padding: new Ny(vy, (e) => e.actionLength - e._currentOffset)
}), U))) }), sw = new K({
	classTable: new q(H, iw, { type: "parent" }),
	wdcOffset: H,
	postCompensationTable: new q(H, ow, { type: "parent" }),
	widthDeltaClusters: new KC(new q(H, aw, {
		type: "parent",
		relativeTo: (e) => e.wdcOffset
	}))
}), cw = new K({
	version: U,
	format: H,
	horizontal: new q(H, sw),
	vertical: new q(H, sw)
}), lw = { action: H }, uw = {
	markIndex: H,
	currentIndex: H
}, dw = {
	currentInsertIndex: H,
	markedInsertIndex: H
}, fw = new K({ items: new GC(new q(U, new KC())) }), pw = new K({
	length: U,
	coverage: by,
	type: vy,
	subFeatureFlags: U,
	table: new Ly("type", {
		0: { stateTable: new qC() },
		1: {
			stateTable: new qC(uw),
			substitutionTable: new q(U, fw)
		},
		2: {
			stateTable: new qC(lw),
			ligatureActions: new q(U, new GC(U)),
			components: new q(U, new GC(H)),
			ligatureList: new q(U, new GC(H))
		},
		4: { lookupTable: new KC() },
		5: {
			stateTable: new qC(dw),
			insertionActions: new q(U, new GC(H))
		}
	}),
	padding: new Ny(vy, (e) => e.length - e._currentOffset)
}), mw = new K({
	defaultFlags: U,
	chainLength: U,
	nFeatureEntries: U,
	nSubtables: U,
	features: new G(new K({
		featureType: H,
		featureSetting: H,
		enableFlags: U,
		disableFlags: U
	}), "nFeatureEntries"),
	subtables: new G(pw, "nSubtables")
}), hw = new K({
	version: H,
	unused: new Ny(H),
	nChains: U,
	chains: new G(mw, "nChains")
}), gw = new K({
	version: Ty,
	format: H,
	lookupTable: new KC(new K({
		left: W,
		top: W,
		right: W,
		bottom: W
	}))
}), _w = {}, vw = _w;
_w.cmap = Ub, _w.head = Wb, _w.hhea = Gb, _w.hmtx = Kb, _w.maxp = qb, _w.name = ax, _w["OS/2"] = lx, _w.post = ux, _w.fpgm = fx, _w.loca = mx, _w.prep = hx, _w["cvt "] = dx, _w.glyf = gx, _w["CFF "] = wS, _w.CFF2 = wS, _w.VORG = TS, _w.EBLC = NS, _w.CBLC = _w.EBLC, _w.sbix = FS, _w.COLR = LS, _w.CPAL = RS, _w.BASE = qS, _w.GDEF = $S, _w.GPOS = dC, _w.GSUB = gC, _w.JSTF = xC, _w.HVAR = CC, _w.DSIG = EC, _w.gasp = DC, _w.hdmx = OC, _w.kern = PC, _w.LTSH = FC, _w.PCLT = IC, _w.VDMX = zC, _w.vhea = BC, _w.vmtx = VC, _w.avar = UC, _w.bsln = YC, _w.feat = ZC, _w.fvar = ew, _w.gvar = rw, _w.just = cw, _w.morx = hw, _w.opbd = gw;
var yw = new K({
	tag: new Py(4),
	checkSum: U,
	offset: new q(U, "void", { type: "global" }),
	length: U
}), bw = new K({
	tag: new Py(4),
	numTables: H,
	searchRange: H,
	entrySelector: H,
	rangeShift: H,
	tables: new G(yw, "numTables")
});
bw.process = function() {
	let e = {};
	for (let t of this.tables) e[t.tag] = t;
	this.tables = e;
}, bw.preEncode = function() {
	if (!Array.isArray(this.tables)) {
		let e = [];
		for (let t in this.tables) {
			let n = this.tables[t];
			n && e.push({
				tag: t,
				checkSum: 0,
				offset: new Ry(vw[t], n),
				length: vw[t].size(n)
			});
		}
		this.tables = e;
	}
	this.tag = "true", this.numTables = this.tables.length;
	let e = 2 ** Math.floor(Math.log(this.numTables) / Math.LN2);
	this.searchRange = e * 16, this.entrySelector = Math.log(e) / Math.LN2, this.rangeShift = this.numTables * 16 - this.searchRange;
};
var xw = bw;
function Sw(e, t) {
	let n = 0, r = e.length - 1;
	for (; n <= r;) {
		let i = n + r >> 1, a = t(e[i]);
		if (a < 0) r = i - 1;
		else if (a > 0) n = i + 1;
		else return i;
	}
	return -1;
}
function Cw(e, t) {
	let n = [];
	for (; e < t;) n.push(e++);
	return n;
}
var ww = new TextDecoder("ascii"), Tw = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Ew = new Uint8Array(256);
for (let e = 0; e < 64; e++) Ew[Tw.charCodeAt(e)] = e;
function Dw(e) {
	let t = e.length * .75;
	e[e.length - 1] === "=" && (t--, e[e.length - 2] === "=" && t--);
	let n = new Uint8Array(t), r = 0;
	for (let t = 0, i = e.length; t < i; t += 4) {
		let i = Ew[e.charCodeAt(t)], a = Ew[e.charCodeAt(t + 1)], o = Ew[e.charCodeAt(t + 2)], s = Ew[e.charCodeAt(t + 3)];
		n[r++] = i << 2 | a >> 4, n[r++] = (a & 15) << 4 | o >> 2, n[r++] = (o & 3) << 6 | s & 63;
	}
	return n;
}
var Ow = class {
	findSubtable(e, t) {
		for (let [n, r] of t) for (let t of e.tables) if (t.platformID === n && t.encodingID === r) return t.table;
		return null;
	}
	lookup(e, t) {
		if (this.encoding) e = this.encoding.get(e) || e;
		else if (t) {
			let n = this.getVariationSelector(e, t);
			if (n) return n;
		}
		let n = this.cmap;
		switch (n.version) {
			case 0: return n.codeMap.get(e) || 0;
			case 4: {
				let t = 0, r = n.segCount - 1;
				for (; t <= r;) {
					let i = t + r >> 1;
					if (e < n.startCode.get(i)) r = i - 1;
					else if (e > n.endCode.get(i)) t = i + 1;
					else {
						let t = n.idRangeOffset.get(i), r;
						if (t === 0) r = e + n.idDelta.get(i);
						else {
							let a = t / 2 + (e - n.startCode.get(i)) - (n.segCount - i);
							r = n.glyphIndexArray.get(a) || 0, r !== 0 && (r += n.idDelta.get(i));
						}
						return r & 65535;
					}
				}
				return 0;
			}
			case 8: throw Error("TODO: cmap format 8");
			case 6:
			case 10: return n.glyphIndices.get(e - n.firstCode) || 0;
			case 12:
			case 13: {
				let t = 0, r = n.nGroups - 1;
				for (; t <= r;) {
					let i = t + r >> 1, a = n.groups.get(i);
					if (e < a.startCharCode) r = i - 1;
					else if (e > a.endCharCode) t = i + 1;
					else if (n.version === 12) return a.glyphID + (e - a.startCharCode);
					else return a.glyphID;
				}
				return 0;
			}
			case 14: throw Error("TODO: cmap format 14");
			default: throw Error(`Unknown cmap format ${n.version}`);
		}
	}
	getVariationSelector(e, t) {
		if (!this.uvs) return 0;
		let n = this.uvs.varSelectors.toArray(), r = Sw(n, (e) => t - e.varSelector), i = n[r];
		return r !== -1 && i.defaultUVS && (r = Sw(i.defaultUVS, (t) => e < t.startUnicodeValue ? -1 : +(e > t.startUnicodeValue + t.additionalCount))), r !== -1 && i.nonDefaultUVS && (r = Sw(i.nonDefaultUVS, (t) => e - t.unicodeValue), r !== -1) ? i.nonDefaultUVS[r].glyphID : 0;
	}
	getCharacterSet() {
		let e = this.cmap;
		switch (e.version) {
			case 0: return Cw(0, e.codeMap.length);
			case 4: {
				let t = [], n = e.endCode.toArray();
				for (let r = 0; r < n.length; r++) {
					let i = n[r] + 1, a = e.startCode.get(r);
					t.push(...Cw(a, i));
				}
				return t;
			}
			case 8: throw Error("TODO: cmap format 8");
			case 6:
			case 10: return Cw(e.firstCode, e.firstCode + e.glyphIndices.length);
			case 12:
			case 13: {
				let t = [];
				for (let n of e.groups.toArray()) t.push(...Cw(n.startCharCode, n.endCharCode + 1));
				return t;
			}
			case 14: throw Error("TODO: cmap format 14");
			default: throw Error(`Unknown cmap format ${e.version}`);
		}
	}
	codePointsForGlyph(e) {
		let t = this.cmap;
		switch (t.version) {
			case 0: {
				let n = [];
				for (let r = 0; r < 256; r++) t.codeMap.get(r) === e && n.push(r);
				return n;
			}
			case 4: {
				let r = [];
				for (let i = 0; i < t.segCount; i++) {
					let a = t.endCode.get(i), o = t.startCode.get(i), s = t.idRangeOffset.get(i), c = t.idDelta.get(i);
					for (var n = o; n <= a; n++) {
						let a = 0;
						if (s === 0) a = n + c;
						else {
							let e = s / 2 + (n - o) - (t.segCount - i);
							a = t.glyphIndexArray.get(e) || 0, a !== 0 && (a += c);
						}
						a === e && r.push(n);
					}
				}
				return r;
			}
			case 12: {
				let n = [];
				for (let r of t.groups.toArray()) e >= r.glyphID && e <= r.glyphID + (r.endCharCode - r.startCharCode) && n.push(r.startCharCode + (e - r.glyphID));
				return n;
			}
			case 13: {
				let n = [];
				for (let r of t.groups.toArray()) e === r.glyphID && n.push(...Cw(r.startCharCode, r.endCharCode + 1));
				return n;
			}
			default: throw Error(`Unknown cmap format ${t.version}`);
		}
	}
	constructor(e) {
		if (this.encoding = null, this.cmap = this.findSubtable(e, [
			[3, 10],
			[0, 6],
			[0, 4],
			[3, 1],
			[0, 3],
			[0, 2],
			[0, 1],
			[0, 0]
		]), !this.cmap) for (let t of e.tables) {
			let e = Qb(Jb(t.platformID, t.encodingID, t.table.language - 1));
			e && (this.cmap = t.table, this.encoding = e);
		}
		if (!this.cmap) throw Error("Could not find a supported cmap table");
		this.uvs = this.findSubtable(e, [[0, 5]]), this.uvs && this.uvs.version !== 14 && (this.uvs = null);
	}
};
By([Fb], Ow.prototype, "getCharacterSet", null), By([Fb], Ow.prototype, "codePointsForGlyph", null);
var kw = class {
	process(e, t) {
		for (let n = 0; n < e.length - 1; n++) {
			let r = e[n].id, i = e[n + 1].id;
			t[n].xAdvance += this.getKerning(r, i);
		}
	}
	getKerning(e, t) {
		let n = 0;
		for (let r of this.kern.tables) {
			if (r.coverage.crossStream) continue;
			switch (r.version) {
				case 0:
					if (!r.coverage.horizontal) continue;
					break;
				case 1:
					if (r.coverage.vertical || r.coverage.variation) continue;
					break;
				default: throw Error(`Unsupported kerning table version ${r.version}`);
			}
			let i = 0, a = r.subtable;
			switch (r.format) {
				case 0:
					let n = Sw(a.pairs, function(n) {
						return e - n.left || t - n.right;
					});
					n >= 0 && (i = a.pairs[n].value);
					break;
				case 2:
					let o = 0, s = 0;
					o = e >= a.leftTable.firstGlyph && e < a.leftTable.firstGlyph + a.leftTable.nGlyphs ? a.leftTable.offsets[e - a.leftTable.firstGlyph] : a.array.off, t >= a.rightTable.firstGlyph && t < a.rightTable.firstGlyph + a.rightTable.nGlyphs && (s = a.rightTable.offsets[t - a.rightTable.firstGlyph]);
					let c = (o + s - a.array.off) / 2;
					i = a.array.values.get(c);
					break;
				case 3:
					if (e >= a.glyphCount || t >= a.glyphCount) return 0;
					i = a.kernValue[a.kernIndex[a.leftClass[e] * a.rightClassCount + a.rightClass[t]]];
					break;
				default: throw Error(`Unsupported kerning sub-table format ${r.format}`);
			}
			r.coverage.override ? n = i : n += i;
		}
		return n;
	}
	constructor(e) {
		this.kern = e.kern;
	}
}, Aw = class {
	positionGlyphs(e, t) {
		let n = 0, r = 0;
		for (let i = 0; i < e.length; i++) e[i].isMark ? r = i : (n !== r && this.positionCluster(e, t, n, r), n = r = i);
		return n !== r && this.positionCluster(e, t, n, r), t;
	}
	positionCluster(e, t, n, r) {
		let i = e[n], a = i.cbox.copy();
		i.codePoints.length > 1 && (a.minX += (i.codePoints.length - 1) * a.width / i.codePoints.length);
		let o = -t[n].xAdvance, s = 0, c = this.font.unitsPerEm / 16;
		for (let i = n + 1; i <= r; i++) {
			let n = e[i], r = n.cbox, l = t[i], u = this.getCombiningClass(n.codePoints[0]);
			if (u !== "Not_Reordered") {
				switch (l.xOffset = l.yOffset = 0, u) {
					case "Double_Above":
					case "Double_Below":
						l.xOffset += a.minX - r.width / 2 - r.minX;
						break;
					case "Attached_Below_Left":
					case "Below_Left":
					case "Above_Left":
						l.xOffset += a.minX - r.minX;
						break;
					case "Attached_Above_Right":
					case "Below_Right":
					case "Above_Right":
						l.xOffset += a.maxX - r.width - r.minX;
						break;
					default: l.xOffset += a.minX + (a.width - r.width) / 2 - r.minX;
				}
				switch (u) {
					case "Double_Below":
					case "Below_Left":
					case "Below":
					case "Below_Right":
					case "Attached_Below_Left":
					case "Attached_Below":
						(u === "Attached_Below_Left" || u === "Attached_Below") && (a.minY += c), l.yOffset = -a.minY - r.maxY, a.minY += r.height;
						break;
					case "Double_Above":
					case "Above_Left":
					case "Above":
					case "Above_Right":
					case "Attached_Above":
					case "Attached_Above_Right":
						(u === "Attached_Above" || u === "Attached_Above_Right") && (a.maxY += c), l.yOffset = a.maxY - r.minY, a.maxY += r.height;
						break;
				}
				l.xAdvance = l.yAdvance = 0, l.xOffset += o, l.yOffset += s;
			} else o -= l.xAdvance, s -= l.yAdvance;
		}
	}
	getCombiningClass(e) {
		let t = eb(e);
		if ((e & -256) == 3584) {
			if (t === "Not_Reordered") switch (e) {
				case 3633:
				case 3636:
				case 3637:
				case 3638:
				case 3639:
				case 3655:
				case 3660:
				case 3645:
				case 3662: return "Above_Right";
				case 3761:
				case 3764:
				case 3765:
				case 3766:
				case 3767:
				case 3771:
				case 3788:
				case 3789: return "Above";
				case 3772: return "Below";
			}
			else if (e === 3642) return "Below_Right";
		}
		switch (t) {
			case "CCC10":
			case "CCC11":
			case "CCC12":
			case "CCC13":
			case "CCC14":
			case "CCC15":
			case "CCC16":
			case "CCC17":
			case "CCC18":
			case "CCC20":
			case "CCC22": return "Below";
			case "CCC23": return "Attached_Above";
			case "CCC24": return "Above_Right";
			case "CCC25":
			case "CCC19": return "Above_Left";
			case "CCC26": return "Above";
			case "CCC21": break;
			case "CCC27":
			case "CCC28":
			case "CCC30":
			case "CCC31":
			case "CCC33":
			case "CCC34":
			case "CCC35":
			case "CCC36": return "Above";
			case "CCC29":
			case "CCC32": return "Below";
			case "CCC103": return "Below_Right";
			case "CCC107": return "Above_Right";
			case "CCC118": return "Below";
			case "CCC122": return "Above";
			case "CCC129":
			case "CCC132": return "Below";
			case "CCC130": return "Above";
		}
		return t;
	}
	constructor(e) {
		this.font = e;
	}
}, jw = class e {
	get width() {
		return this.maxX - this.minX;
	}
	get height() {
		return this.maxY - this.minY;
	}
	addPoint(e, t) {
		Math.abs(e) !== Infinity && (e < this.minX && (this.minX = e), e > this.maxX && (this.maxX = e)), Math.abs(t) !== Infinity && (t < this.minY && (this.minY = t), t > this.maxY && (this.maxY = t));
	}
	copy() {
		return new e(this.minX, this.minY, this.maxX, this.maxY);
	}
	constructor(e = Infinity, t = Infinity, n = -Infinity, r = -Infinity) {
		this.minX = e, this.minY = t, this.maxX = n, this.maxY = r;
	}
}, Mw = {
	Caucasian_Albanian: "aghb",
	Arabic: "arab",
	Imperial_Aramaic: "armi",
	Armenian: "armn",
	Avestan: "avst",
	Balinese: "bali",
	Bamum: "bamu",
	Bassa_Vah: "bass",
	Batak: "batk",
	Bengali: ["bng2", "beng"],
	Bopomofo: "bopo",
	Brahmi: "brah",
	Braille: "brai",
	Buginese: "bugi",
	Buhid: "buhd",
	Chakma: "cakm",
	Canadian_Aboriginal: "cans",
	Carian: "cari",
	Cham: "cham",
	Cherokee: "cher",
	Coptic: "copt",
	Cypriot: "cprt",
	Cyrillic: "cyrl",
	Devanagari: ["dev2", "deva"],
	Deseret: "dsrt",
	Duployan: "dupl",
	Egyptian_Hieroglyphs: "egyp",
	Elbasan: "elba",
	Ethiopic: "ethi",
	Georgian: "geor",
	Glagolitic: "glag",
	Gothic: "goth",
	Grantha: "gran",
	Greek: "grek",
	Gujarati: ["gjr2", "gujr"],
	Gurmukhi: ["gur2", "guru"],
	Hangul: "hang",
	Han: "hani",
	Hanunoo: "hano",
	Hebrew: "hebr",
	Hiragana: "hira",
	Pahawh_Hmong: "hmng",
	Katakana_Or_Hiragana: "hrkt",
	Old_Italic: "ital",
	Javanese: "java",
	Kayah_Li: "kali",
	Katakana: "kana",
	Kharoshthi: "khar",
	Khmer: "khmr",
	Khojki: "khoj",
	Kannada: ["knd2", "knda"],
	Kaithi: "kthi",
	Tai_Tham: "lana",
	Lao: "lao ",
	Latin: "latn",
	Lepcha: "lepc",
	Limbu: "limb",
	Linear_A: "lina",
	Linear_B: "linb",
	Lisu: "lisu",
	Lycian: "lyci",
	Lydian: "lydi",
	Mahajani: "mahj",
	Mandaic: "mand",
	Manichaean: "mani",
	Mende_Kikakui: "mend",
	Meroitic_Cursive: "merc",
	Meroitic_Hieroglyphs: "mero",
	Malayalam: ["mlm2", "mlym"],
	Modi: "modi",
	Mongolian: "mong",
	Mro: "mroo",
	Meetei_Mayek: "mtei",
	Myanmar: ["mym2", "mymr"],
	Old_North_Arabian: "narb",
	Nabataean: "nbat",
	Nko: "nko ",
	Ogham: "ogam",
	Ol_Chiki: "olck",
	Old_Turkic: "orkh",
	Oriya: ["ory2", "orya"],
	Osmanya: "osma",
	Palmyrene: "palm",
	Pau_Cin_Hau: "pauc",
	Old_Permic: "perm",
	Phags_Pa: "phag",
	Inscriptional_Pahlavi: "phli",
	Psalter_Pahlavi: "phlp",
	Phoenician: "phnx",
	Miao: "plrd",
	Inscriptional_Parthian: "prti",
	Rejang: "rjng",
	Runic: "runr",
	Samaritan: "samr",
	Old_South_Arabian: "sarb",
	Saurashtra: "saur",
	Shavian: "shaw",
	Sharada: "shrd",
	Siddham: "sidd",
	Khudawadi: "sind",
	Sinhala: "sinh",
	Sora_Sompeng: "sora",
	Sundanese: "sund",
	Syloti_Nagri: "sylo",
	Syriac: "syrc",
	Tagbanwa: "tagb",
	Takri: "takr",
	Tai_Le: "tale",
	New_Tai_Lue: "talu",
	Tamil: ["tml2", "taml"],
	Tai_Viet: "tavt",
	Telugu: ["tel2", "telu"],
	Tifinagh: "tfng",
	Tagalog: "tglg",
	Thaana: "thaa",
	Thai: "thai",
	Tibetan: "tibt",
	Tirhuta: "tirh",
	Ugaritic: "ugar",
	Vai: "vai ",
	Warang_Citi: "wara",
	Old_Persian: "xpeo",
	Cuneiform: "xsux",
	Yi: "yi  ",
	Inherited: "zinh",
	Common: "zyyy",
	Unknown: "zzzz"
}, Nw = {};
for (let e in Mw) {
	let t = Mw[e];
	if (Array.isArray(t)) for (let n of t) Nw[n] = e;
	else Nw[t] = e;
}
function Pw(e) {
	return Nw[e];
}
function Fw(e) {
	let t = e.length, n = 0;
	for (; n < t;) {
		let r = e.charCodeAt(n++);
		if (55296 <= r && r <= 56319 && n < t) {
			let t = e.charCodeAt(n);
			56320 <= t && t <= 57343 && (n++, r = ((r & 1023) << 10) + (t & 1023) + 65536);
		}
		let i = tb(r);
		if (i !== "Common" && i !== "Inherited" && i !== "Unknown") return Mw[i];
	}
	return Mw.Unknown;
}
function Iw(e) {
	for (let t = 0; t < e.length; t++) {
		let n = e[t], r = tb(n);
		if (r !== "Common" && r !== "Inherited" && r !== "Unknown") return Mw[r];
	}
	return Mw.Unknown;
}
var Lw = {
	arab: !0,
	hebr: !0,
	syrc: !0,
	thaa: !0,
	cprt: !0,
	khar: !0,
	phnx: !0,
	"nko ": !0,
	lydi: !0,
	avst: !0,
	armi: !0,
	phli: !0,
	prti: !0,
	sarb: !0,
	orkh: !0,
	samr: !0,
	mand: !0,
	merc: !0,
	mero: !0,
	mani: !0,
	mend: !0,
	nbat: !0,
	narb: !0,
	palm: !0,
	phlp: !0
};
function Rw(e) {
	return Lw[e] ? "rtl" : "ltr";
}
var zw = class {
	get advanceWidth() {
		let e = 0;
		for (let t of this.positions) e += t.xAdvance;
		return e;
	}
	get advanceHeight() {
		let e = 0;
		for (let t of this.positions) e += t.yAdvance;
		return e;
	}
	get bbox() {
		let e = new jw(), t = 0, n = 0;
		for (let r = 0; r < this.glyphs.length; r++) {
			let i = this.glyphs[r], a = this.positions[r], o = i.bbox;
			e.addPoint(o.minX + t + a.xOffset, o.minY + n + a.yOffset), e.addPoint(o.maxX + t + a.xOffset, o.maxY + n + a.yOffset), t += a.xAdvance, n += a.yAdvance;
		}
		return e;
	}
	constructor(e, t, n, r, i) {
		if (this.glyphs = e, this.positions = null, this.script = n, this.language = r || null, this.direction = i || Rw(n), this.features = {}, Array.isArray(t)) for (let e of t) this.features[e] = !0;
		else typeof t == "object" && (this.features = t);
	}
}, Bw = class {
	constructor(e = 0, t = 0, n = 0, r = 0) {
		this.xAdvance = e, this.yAdvance = t, this.xOffset = n, this.yOffset = r;
	}
}, Vw = {
	allTypographicFeatures: {
		code: 0,
		exclusive: !1,
		allTypeFeatures: 0
	},
	ligatures: {
		code: 1,
		exclusive: !1,
		requiredLigatures: 0,
		commonLigatures: 2,
		rareLigatures: 4,
		rebusPictures: 8,
		diphthongLigatures: 10,
		squaredLigatures: 12,
		abbrevSquaredLigatures: 14,
		symbolLigatures: 16,
		contextualLigatures: 18,
		historicalLigatures: 20
	},
	cursiveConnection: {
		code: 2,
		exclusive: !0,
		unconnected: 0,
		partiallyConnected: 1,
		cursive: 2
	},
	letterCase: {
		code: 3,
		exclusive: !0
	},
	verticalSubstitution: {
		code: 4,
		exclusive: !1,
		substituteVerticalForms: 0
	},
	linguisticRearrangement: {
		code: 5,
		exclusive: !1,
		linguisticRearrangement: 0
	},
	numberSpacing: {
		code: 6,
		exclusive: !0,
		monospacedNumbers: 0,
		proportionalNumbers: 1,
		thirdWidthNumbers: 2,
		quarterWidthNumbers: 3
	},
	smartSwash: {
		code: 8,
		exclusive: !1,
		wordInitialSwashes: 0,
		wordFinalSwashes: 2,
		nonFinalSwashes: 8
	},
	diacritics: {
		code: 9,
		exclusive: !0,
		showDiacritics: 0,
		hideDiacritics: 1,
		decomposeDiacritics: 2
	},
	verticalPosition: {
		code: 10,
		exclusive: !0,
		normalPosition: 0,
		superiors: 1,
		inferiors: 2,
		ordinals: 3,
		scientificInferiors: 4
	},
	fractions: {
		code: 11,
		exclusive: !0,
		noFractions: 0,
		verticalFractions: 1,
		diagonalFractions: 2
	},
	overlappingCharacters: {
		code: 13,
		exclusive: !1,
		preventOverlap: 0
	},
	typographicExtras: {
		code: 14,
		exclusive: !1,
		slashedZero: 4
	},
	mathematicalExtras: {
		code: 15,
		exclusive: !1,
		mathematicalGreek: 10
	},
	ornamentSets: {
		code: 16,
		exclusive: !0,
		noOrnaments: 0,
		dingbats: 1,
		piCharacters: 2,
		fleurons: 3,
		decorativeBorders: 4,
		internationalSymbols: 5,
		mathSymbols: 6
	},
	characterAlternatives: {
		code: 17,
		exclusive: !0,
		noAlternates: 0
	},
	designComplexity: {
		code: 18,
		exclusive: !0,
		designLevel1: 0,
		designLevel2: 1,
		designLevel3: 2,
		designLevel4: 3,
		designLevel5: 4
	},
	styleOptions: {
		code: 19,
		exclusive: !0,
		noStyleOptions: 0,
		displayText: 1,
		engravedText: 2,
		illuminatedCaps: 3,
		titlingCaps: 4,
		tallCaps: 5
	},
	characterShape: {
		code: 20,
		exclusive: !0,
		traditionalCharacters: 0,
		simplifiedCharacters: 1,
		JIS1978Characters: 2,
		JIS1983Characters: 3,
		JIS1990Characters: 4,
		traditionalAltOne: 5,
		traditionalAltTwo: 6,
		traditionalAltThree: 7,
		traditionalAltFour: 8,
		traditionalAltFive: 9,
		expertCharacters: 10,
		JIS2004Characters: 11,
		hojoCharacters: 12,
		NLCCharacters: 13,
		traditionalNamesCharacters: 14
	},
	numberCase: {
		code: 21,
		exclusive: !0,
		lowerCaseNumbers: 0,
		upperCaseNumbers: 1
	},
	textSpacing: {
		code: 22,
		exclusive: !0,
		proportionalText: 0,
		monospacedText: 1,
		halfWidthText: 2,
		thirdWidthText: 3,
		quarterWidthText: 4,
		altProportionalText: 5,
		altHalfWidthText: 6
	},
	transliteration: {
		code: 23,
		exclusive: !0,
		noTransliteration: 0
	},
	annotation: {
		code: 24,
		exclusive: !0,
		noAnnotation: 0,
		boxAnnotation: 1,
		roundedBoxAnnotation: 2,
		circleAnnotation: 3,
		invertedCircleAnnotation: 4,
		parenthesisAnnotation: 5,
		periodAnnotation: 6,
		romanNumeralAnnotation: 7,
		diamondAnnotation: 8,
		invertedBoxAnnotation: 9,
		invertedRoundedBoxAnnotation: 10
	},
	kanaSpacing: {
		code: 25,
		exclusive: !0,
		fullWidthKana: 0,
		proportionalKana: 1
	},
	ideographicSpacing: {
		code: 26,
		exclusive: !0,
		fullWidthIdeographs: 0,
		proportionalIdeographs: 1,
		halfWidthIdeographs: 2
	},
	unicodeDecomposition: {
		code: 27,
		exclusive: !1,
		canonicalComposition: 0,
		compatibilityComposition: 2,
		transcodingComposition: 4
	},
	rubyKana: {
		code: 28,
		exclusive: !1,
		rubyKana: 2
	},
	CJKSymbolAlternatives: {
		code: 29,
		exclusive: !0,
		noCJKSymbolAlternatives: 0,
		CJKSymbolAltOne: 1,
		CJKSymbolAltTwo: 2,
		CJKSymbolAltThree: 3,
		CJKSymbolAltFour: 4,
		CJKSymbolAltFive: 5
	},
	ideographicAlternatives: {
		code: 30,
		exclusive: !0,
		noIdeographicAlternatives: 0,
		ideographicAltOne: 1,
		ideographicAltTwo: 2,
		ideographicAltThree: 3,
		ideographicAltFour: 4,
		ideographicAltFive: 5
	},
	CJKVerticalRomanPlacement: {
		code: 31,
		exclusive: !0,
		CJKVerticalRomanCentered: 0,
		CJKVerticalRomanHBaseline: 1
	},
	italicCJKRoman: {
		code: 32,
		exclusive: !1,
		CJKItalicRoman: 2
	},
	caseSensitiveLayout: {
		code: 33,
		exclusive: !1,
		caseSensitiveLayout: 0,
		caseSensitiveSpacing: 2
	},
	alternateKana: {
		code: 34,
		exclusive: !1,
		alternateHorizKana: 0,
		alternateVertKana: 2
	},
	stylisticAlternatives: {
		code: 35,
		exclusive: !1,
		noStylisticAlternates: 0,
		stylisticAltOne: 2,
		stylisticAltTwo: 4,
		stylisticAltThree: 6,
		stylisticAltFour: 8,
		stylisticAltFive: 10,
		stylisticAltSix: 12,
		stylisticAltSeven: 14,
		stylisticAltEight: 16,
		stylisticAltNine: 18,
		stylisticAltTen: 20,
		stylisticAltEleven: 22,
		stylisticAltTwelve: 24,
		stylisticAltThirteen: 26,
		stylisticAltFourteen: 28,
		stylisticAltFifteen: 30,
		stylisticAltSixteen: 32,
		stylisticAltSeventeen: 34,
		stylisticAltEighteen: 36,
		stylisticAltNineteen: 38,
		stylisticAltTwenty: 40
	},
	contextualAlternates: {
		code: 36,
		exclusive: !1,
		contextualAlternates: 0,
		swashAlternates: 2,
		contextualSwashAlternates: 4
	},
	lowerCase: {
		code: 37,
		exclusive: !0,
		defaultLowerCase: 0,
		lowerCaseSmallCaps: 1,
		lowerCasePetiteCaps: 2
	},
	upperCase: {
		code: 38,
		exclusive: !0,
		defaultUpperCase: 0,
		upperCaseSmallCaps: 1,
		upperCasePetiteCaps: 2
	},
	languageTag: {
		code: 39,
		exclusive: !0
	},
	CJKRomanSpacing: {
		code: 103,
		exclusive: !0,
		halfWidthCJKRoman: 0,
		proportionalCJKRoman: 1,
		defaultCJKRoman: 2,
		fullWidthCJKRoman: 3
	}
}, Hw = (e, t) => [Vw[e].code, Vw[e][t]], Uw = {
	rlig: Hw("ligatures", "requiredLigatures"),
	clig: Hw("ligatures", "contextualLigatures"),
	dlig: Hw("ligatures", "rareLigatures"),
	hlig: Hw("ligatures", "historicalLigatures"),
	liga: Hw("ligatures", "commonLigatures"),
	hist: Hw("ligatures", "historicalLigatures"),
	smcp: Hw("lowerCase", "lowerCaseSmallCaps"),
	pcap: Hw("lowerCase", "lowerCasePetiteCaps"),
	frac: Hw("fractions", "diagonalFractions"),
	dnom: Hw("fractions", "diagonalFractions"),
	numr: Hw("fractions", "diagonalFractions"),
	afrc: Hw("fractions", "verticalFractions"),
	case: Hw("caseSensitiveLayout", "caseSensitiveLayout"),
	ccmp: Hw("unicodeDecomposition", "canonicalComposition"),
	cpct: Hw("CJKVerticalRomanPlacement", "CJKVerticalRomanCentered"),
	valt: Hw("CJKVerticalRomanPlacement", "CJKVerticalRomanCentered"),
	swsh: Hw("contextualAlternates", "swashAlternates"),
	cswh: Hw("contextualAlternates", "contextualSwashAlternates"),
	curs: Hw("cursiveConnection", "cursive"),
	c2pc: Hw("upperCase", "upperCasePetiteCaps"),
	c2sc: Hw("upperCase", "upperCaseSmallCaps"),
	init: Hw("smartSwash", "wordInitialSwashes"),
	fin2: Hw("smartSwash", "wordFinalSwashes"),
	medi: Hw("smartSwash", "nonFinalSwashes"),
	med2: Hw("smartSwash", "nonFinalSwashes"),
	fin3: Hw("smartSwash", "wordFinalSwashes"),
	fina: Hw("smartSwash", "wordFinalSwashes"),
	pkna: Hw("kanaSpacing", "proportionalKana"),
	half: Hw("textSpacing", "halfWidthText"),
	halt: Hw("textSpacing", "altHalfWidthText"),
	hkna: Hw("alternateKana", "alternateHorizKana"),
	vkna: Hw("alternateKana", "alternateVertKana"),
	ital: Hw("italicCJKRoman", "CJKItalicRoman"),
	lnum: Hw("numberCase", "upperCaseNumbers"),
	onum: Hw("numberCase", "lowerCaseNumbers"),
	mgrk: Hw("mathematicalExtras", "mathematicalGreek"),
	calt: Hw("contextualAlternates", "contextualAlternates"),
	vrt2: Hw("verticalSubstitution", "substituteVerticalForms"),
	vert: Hw("verticalSubstitution", "substituteVerticalForms"),
	tnum: Hw("numberSpacing", "monospacedNumbers"),
	pnum: Hw("numberSpacing", "proportionalNumbers"),
	sups: Hw("verticalPosition", "superiors"),
	subs: Hw("verticalPosition", "inferiors"),
	ordn: Hw("verticalPosition", "ordinals"),
	pwid: Hw("textSpacing", "proportionalText"),
	hwid: Hw("textSpacing", "halfWidthText"),
	qwid: Hw("textSpacing", "quarterWidthText"),
	twid: Hw("textSpacing", "thirdWidthText"),
	fwid: Hw("textSpacing", "proportionalText"),
	palt: Hw("textSpacing", "altProportionalText"),
	trad: Hw("characterShape", "traditionalCharacters"),
	smpl: Hw("characterShape", "simplifiedCharacters"),
	jp78: Hw("characterShape", "JIS1978Characters"),
	jp83: Hw("characterShape", "JIS1983Characters"),
	jp90: Hw("characterShape", "JIS1990Characters"),
	jp04: Hw("characterShape", "JIS2004Characters"),
	expt: Hw("characterShape", "expertCharacters"),
	hojo: Hw("characterShape", "hojoCharacters"),
	nlck: Hw("characterShape", "NLCCharacters"),
	tnam: Hw("characterShape", "traditionalNamesCharacters"),
	ruby: Hw("rubyKana", "rubyKana"),
	titl: Hw("styleOptions", "titlingCaps"),
	zero: Hw("typographicExtras", "slashedZero"),
	ss01: Hw("stylisticAlternatives", "stylisticAltOne"),
	ss02: Hw("stylisticAlternatives", "stylisticAltTwo"),
	ss03: Hw("stylisticAlternatives", "stylisticAltThree"),
	ss04: Hw("stylisticAlternatives", "stylisticAltFour"),
	ss05: Hw("stylisticAlternatives", "stylisticAltFive"),
	ss06: Hw("stylisticAlternatives", "stylisticAltSix"),
	ss07: Hw("stylisticAlternatives", "stylisticAltSeven"),
	ss08: Hw("stylisticAlternatives", "stylisticAltEight"),
	ss09: Hw("stylisticAlternatives", "stylisticAltNine"),
	ss10: Hw("stylisticAlternatives", "stylisticAltTen"),
	ss11: Hw("stylisticAlternatives", "stylisticAltEleven"),
	ss12: Hw("stylisticAlternatives", "stylisticAltTwelve"),
	ss13: Hw("stylisticAlternatives", "stylisticAltThirteen"),
	ss14: Hw("stylisticAlternatives", "stylisticAltFourteen"),
	ss15: Hw("stylisticAlternatives", "stylisticAltFifteen"),
	ss16: Hw("stylisticAlternatives", "stylisticAltSixteen"),
	ss17: Hw("stylisticAlternatives", "stylisticAltSeventeen"),
	ss18: Hw("stylisticAlternatives", "stylisticAltEighteen"),
	ss19: Hw("stylisticAlternatives", "stylisticAltNineteen"),
	ss20: Hw("stylisticAlternatives", "stylisticAltTwenty")
};
for (let e = 1; e <= 99; e++) Uw[`cv${`00${e}`.slice(-2)}`] = [Vw.characterAlternatives.code, e];
var Ww = {};
for (let e in Uw) {
	let t = Uw[e];
	Ww[t[0]] ?? (Ww[t[0]] = {}), Ww[t[0]][t[1]] = e;
}
function Gw(e) {
	let t = {};
	for (let n in e) {
		let r;
		(r = Uw[n]) && (t[r[0]] ?? (t[r[0]] = {}), t[r[0]][r[1]] = e[n]);
	}
	return t;
}
function Kw(e) {
	let [t, n] = e;
	if (isNaN(t)) var r = Vw[t] && Vw[t].code;
	else var r = t;
	if (isNaN(n)) var i = Vw[t] && Vw[t][n];
	else var i = n;
	return [r, i];
}
function qw(e) {
	let t = {};
	if (Array.isArray(e)) for (let n = 0; n < e.length; n++) {
		let r, i = Kw(e[n]);
		(r = Ww[i[0]] && Ww[i[0]][i[1]]) && (t[r] = !0);
	}
	else if (typeof e == "object") for (let n in e) {
		let r = e[n];
		for (let e in r) {
			let i, a = Kw([n, e]);
			r[e] && (i = Ww[a[0]] && Ww[a[0]][a[1]]) && (t[i] = !0);
		}
	}
	return Object.keys(t);
}
var Jw = class {
	lookup(e) {
		switch (this.table.version) {
			case 0: return this.table.values.getItem(e);
			case 2:
			case 4: {
				let r = 0, i = this.table.binarySearchHeader.nUnits - 1;
				for (; r <= i;) {
					var t = r + i >> 1, n = this.table.segments[t];
					if (n.firstGlyph === 65535) return null;
					if (e < n.firstGlyph) i = t - 1;
					else if (e > n.lastGlyph) r = t + 1;
					else if (this.table.version === 2) return n.value;
					else return n.values[e - n.firstGlyph];
				}
				return null;
			}
			case 6: {
				let r = 0, i = this.table.binarySearchHeader.nUnits - 1;
				for (; r <= i;) {
					var t = r + i >> 1, n = this.table.segments[t];
					if (n.glyph === 65535) return null;
					if (e < n.glyph) i = t - 1;
					else if (e > n.glyph) r = t + 1;
					else return n.value;
				}
				return null;
			}
			case 8: return this.table.values[e - this.table.firstGlyph];
			default: throw Error(`Unknown lookup table format: ${this.table.version}`);
		}
	}
	glyphsForValue(e) {
		let t = [];
		switch (this.table.version) {
			case 2:
			case 4:
				for (let n of this.table.segments) if (this.table.version === 2 && n.value === e) t.push(...Cw(n.firstGlyph, n.lastGlyph + 1));
				else for (let r = 0; r < n.values.length; r++) n.values[r] === e && t.push(n.firstGlyph + r);
				break;
			case 6:
				for (let n of this.table.segments) n.value === e && t.push(n.glyph);
				break;
			case 8:
				for (let n = 0; n < this.table.values.length; n++) this.table.values[n] === e && t.push(this.table.firstGlyph + n);
				break;
			default: throw Error(`Unknown lookup table format: ${this.table.version}`);
		}
		return t;
	}
	constructor(e) {
		this.table = e;
	}
};
By([Fb], Jw.prototype, "glyphsForValue", null);
var Yw = 0, Xw = 0, Zw = 1, Qw = 2, $w = 16384, eT = class {
	process(e, t, n) {
		let r = Yw, i = t ? e.length - 1 : 0, a = t ? -1 : 1;
		for (; a === 1 && i <= e.length || a === -1 && i >= -1;) {
			let t = null, o = Zw, s = !0;
			i === e.length || i === -1 ? o = Xw : (t = e[i], t.id === 65535 ? o = Qw : (o = this.lookupTable.lookup(t.id), o ??= Zw));
			let c = this.stateTable.stateArray.getItem(r)[o], l = this.stateTable.entryTable.getItem(c);
			o !== Xw && o !== Qw && (n(t, l, i), s = !(l.flags & $w)), r = l.newState, s && (i += a);
		}
		return e;
	}
	traverse(e, t = 0, n = /* @__PURE__ */ new Set()) {
		if (n.has(t)) return;
		n.add(t);
		let { nClasses: r, stateArray: i, entryTable: a } = this.stateTable, o = i.getItem(t);
		for (let t = 4; t < r; t++) {
			let r = o[t], i = a.getItem(r);
			for (let r of this.lookupTable.glyphsForValue(t)) e.enter && e.enter(r, i), i.newState !== 0 && this.traverse(e, i.newState, n), e.exit && e.exit(r, i);
		}
	}
	constructor(e) {
		this.stateTable = e, this.lookupTable = new Jw(e.classTable);
	}
}, tT = 32768, nT = 8192, rT = 15, iT = 32768, aT = 32768, oT = 8192, sT = 2147483648, cT = 1073741824, lT = 1073741823, uT = 4194304, dT = 2048, fT = 1024, pT = 992, mT = 31, hT = class {
	process(e, t = {}) {
		for (let n of this.morx.chains) {
			let r = n.defaultFlags;
			for (let e of n.features) {
				let n;
				(n = t[e.featureType]) && (n[e.featureSetting] ? (r &= e.disableFlags, r |= e.enableFlags) : n[e.featureSetting] === !1 && (r |= ~e.disableFlags, r &= ~e.enableFlags));
			}
			for (let t of n.subtables) t.subFeatureFlags & r && this.processSubtable(t, e);
		}
		let n = e.length - 1;
		for (; n >= 0;) e[n].id === 65535 && e.splice(n, 1), n--;
		return e;
	}
	processSubtable(e, t) {
		if (this.subtable = e, this.glyphs = t, this.subtable.type === 4) {
			this.processNoncontextualSubstitutions(this.subtable, this.glyphs);
			return;
		}
		this.ligatureStack = [], this.markedGlyph = null, this.firstGlyph = null, this.lastGlyph = null, this.markedIndex = null;
		let n = this.getStateMachine(e), r = this.getProcessor(), i = !!(this.subtable.coverage & uT);
		return n.process(this.glyphs, i, r);
	}
	getStateMachine(e) {
		return new eT(e.table.stateTable);
	}
	getProcessor() {
		switch (this.subtable.type) {
			case 0: return this.processIndicRearragement;
			case 1: return this.processContextualSubstitution;
			case 2: return this.processLigature;
			case 4: return this.processNoncontextualSubstitutions;
			case 5: return this.processGlyphInsertion;
			default: throw Error(`Invalid morx subtable type: ${this.subtable.type}`);
		}
	}
	processIndicRearragement(e, t, n) {
		t.flags & tT && (this.firstGlyph = n), t.flags & nT && (this.lastGlyph = n), _T(this.glyphs, t.flags & rT, this.firstGlyph, this.lastGlyph);
	}
	processContextualSubstitution(e, t, n) {
		let r = this.subtable.table.substitutionTable.items;
		if (t.markIndex !== 65535) {
			let n = new Jw(r.getItem(t.markIndex));
			e = this.glyphs[this.markedGlyph];
			var i = n.lookup(e.id);
			i && (this.glyphs[this.markedGlyph] = this.font.getGlyph(i, e.codePoints));
		}
		if (t.currentIndex !== 65535) {
			let a = new Jw(r.getItem(t.currentIndex));
			e = this.glyphs[n];
			var i = a.lookup(e.id);
			i && (this.glyphs[n] = this.font.getGlyph(i, e.codePoints));
		}
		t.flags & iT && (this.markedGlyph = n);
	}
	processLigature(e, t, n) {
		if (t.flags & aT && this.ligatureStack.push(n), t.flags & oT) {
			let e = this.subtable.table.ligatureActions, n = this.subtable.table.components, r = this.subtable.table.ligatureList, i = t.action, a = !1, o = 0, s = [], c = [];
			for (; !a;) {
				let t = this.ligatureStack.pop();
				s.unshift(...this.glyphs[t].codePoints);
				let l = e.getItem(i++);
				a = !!(l & sT);
				let u = !!(l & cT), d = (l & lT) << 2 >> 2;
				d += this.glyphs[t].id;
				let f = n.getItem(d);
				if (o += f, a || u) {
					let e = r.getItem(o);
					this.glyphs[t] = this.font.getGlyph(e, s), c.push(t), o = 0, s = [];
				} else this.glyphs[t] = this.font.getGlyph(65535);
			}
			this.ligatureStack.push(...c);
		}
	}
	processNoncontextualSubstitutions(e, t, n) {
		let r = new Jw(e.table.lookupTable);
		for (n = 0; n < t.length; n++) {
			let e = t[n];
			if (e.id !== 65535) {
				let i = r.lookup(e.id);
				i && (t[n] = this.font.getGlyph(i, e.codePoints));
			}
		}
	}
	_insertGlyphs(e, t, n, r) {
		let i = [];
		for (; n--;) {
			let e = this.subtable.table.insertionActions.getItem(t++);
			i.push(this.font.getGlyph(e));
		}
		r || e++, this.glyphs.splice(e, 0, ...i);
	}
	processGlyphInsertion(e, t, n) {
		if (t.flags & iT && (this.markedIndex = n), t.markedInsertIndex !== 65535) {
			let e = (t.flags & mT) >>> 5, n = !!(t.flags & fT);
			this._insertGlyphs(this.markedIndex, t.markedInsertIndex, e, n);
		}
		if (t.currentInsertIndex !== 65535) {
			let e = (t.flags & pT) >>> 5, r = !!(t.flags & dT);
			this._insertGlyphs(n, t.currentInsertIndex, e, r);
		}
	}
	getSupportedFeatures() {
		let e = [];
		for (let t of this.morx.chains) for (let n of t.features) e.push([n.featureType, n.featureSetting]);
		return e;
	}
	generateInputs(e) {
		return this.inputCache || this.generateInputCache(), this.inputCache[e] || [];
	}
	generateInputCache() {
		this.inputCache = {};
		for (let e of this.morx.chains) {
			let t = e.defaultFlags;
			for (let n of e.subtables) n.subFeatureFlags & t && this.generateInputsForSubtable(n);
		}
	}
	generateInputsForSubtable(e) {
		if (e.type !== 2) return;
		if (e.coverage & uT) throw Error("Reverse subtable, not supported.");
		this.subtable = e, this.ligatureStack = [];
		let t = this.getStateMachine(e), n = this.getProcessor(), r = [], i = [];
		this.glyphs = [], t.traverse({
			enter: (e, t) => {
				let a = this.glyphs;
				i.push({
					glyphs: a.slice(),
					ligatureStack: this.ligatureStack.slice()
				});
				let o = this.font.getGlyph(e);
				r.push(o), a.push(r[r.length - 1]), n(a[a.length - 1], t, a.length - 1);
				let s = 0, c = 0;
				for (let e = 0; e < a.length && s <= 1; e++) a[e].id !== 65535 && (s++, c = a[e].id);
				if (s === 1) {
					let e = r.map((e) => e.id), t = this.inputCache[c];
					t ? t.push(e) : this.inputCache[c] = [e];
				}
			},
			exit: () => {
				({glyphs: this.glyphs, ligatureStack: this.ligatureStack} = i.pop()), r.pop();
			}
		});
	}
	constructor(e) {
		this.processIndicRearragement = this.processIndicRearragement.bind(this), this.processContextualSubstitution = this.processContextualSubstitution.bind(this), this.processLigature = this.processLigature.bind(this), this.processNoncontextualSubstitutions = this.processNoncontextualSubstitutions.bind(this), this.processGlyphInsertion = this.processGlyphInsertion.bind(this), this.font = e, this.morx = e.morx, this.inputCache = null;
	}
};
By([Fb], hT.prototype, "getStateMachine", null);
function gT(e, t, n, r = !1, i = !1) {
	let a = e.splice(n[0] - (n[1] - 1), n[1]);
	i && a.reverse();
	let o = e.splice(t[0], t[1], ...a);
	return r && o.reverse(), e.splice(n[0] - (t[1] - 1), 0, ...o), e;
}
function _T(e, t, n, r) {
	switch (r - n + 1, t) {
		case 0: return e;
		case 1: return gT(e, [n, 1], [r, 0]);
		case 2: return gT(e, [n, 0], [r, 1]);
		case 3: return gT(e, [n, 1], [r, 1]);
		case 4: return gT(e, [n, 2], [r, 0]);
		case 5: return gT(e, [n, 2], [r, 0], !0, !1);
		case 6: return gT(e, [n, 0], [r, 2]);
		case 7: return gT(e, [n, 0], [r, 2], !1, !0);
		case 8: return gT(e, [n, 1], [r, 2]);
		case 9: return gT(e, [n, 1], [r, 2], !1, !0);
		case 10: return gT(e, [n, 2], [r, 1]);
		case 11: return gT(e, [n, 2], [r, 1], !0, !1);
		case 12: return gT(e, [n, 2], [r, 2]);
		case 13: return gT(e, [n, 2], [r, 2], !0, !1);
		case 14: return gT(e, [n, 2], [r, 2], !1, !0);
		case 15: return gT(e, [n, 2], [r, 2], !0, !0);
		default: throw Error(`Unknown verb: ${t}`);
	}
}
var vT = class {
	substitute(e) {
		e.direction === "rtl" && e.glyphs.reverse(), this.morxProcessor.process(e.glyphs, Gw(e.features));
	}
	getAvailableFeatures(e, t) {
		return qw(this.morxProcessor.getSupportedFeatures());
	}
	stringsForGlyph(e) {
		let t = this.morxProcessor.generateInputs(e), n = /* @__PURE__ */ new Set();
		for (let e of t) this._addStrings(e, 0, n, "");
		return n;
	}
	_addStrings(e, t, n, r) {
		let i = this.font._cmapProcessor.codePointsForGlyph(e[t]);
		for (let a of i) {
			let i = r + String.fromCodePoint(a);
			t < e.length - 1 ? this._addStrings(e, t + 1, n, i) : n.add(i);
		}
	}
	constructor(e) {
		this.font = e, this.morxProcessor = new hT(e), this.fallbackPosition = !1;
	}
}, yT = class {
	_addFeatures(e, t) {
		let n = this.stages.length - 1, r = this.stages[n];
		for (let i of e) this.allFeatures[i] ?? (r.push(i), this.allFeatures[i] = n, t && (this.globalFeatures[i] = !0));
	}
	add(e, t = !0) {
		if (this.stages.length === 0 && this.stages.push([]), typeof e == "string" && (e = [e]), Array.isArray(e)) this._addFeatures(e, t);
		else if (typeof e == "object") this._addFeatures(e.global || [], !0), this._addFeatures(e.local || [], !1);
		else throw Error("Unsupported argument to ShapingPlan#add");
	}
	addStage(e, t) {
		typeof e == "function" ? this.stages.push(e, []) : (this.stages.push([]), this.add(e, t));
	}
	setFeatureOverrides(e) {
		if (Array.isArray(e)) this.add(e);
		else if (typeof e == "object") {
			for (let t in e) if (e[t]) this.add(t);
			else if (this.allFeatures[t] != null) {
				let e = this.stages[this.allFeatures[t]];
				e.splice(e.indexOf(t), 1), delete this.allFeatures[t], delete this.globalFeatures[t];
			}
		}
	}
	assignGlobalFeatures(e) {
		for (let t of e) for (let e in this.globalFeatures) t.features[e] = !0;
	}
	process(e, t, n) {
		for (let r of this.stages) typeof r == "function" ? n || r(this.font, t, this) : r.length > 0 && e.applyFeatures(r, t, n);
	}
	constructor(e, t, n) {
		this.font = e, this.script = t, this.direction = n, this.stages = [], this.globalFeatures = {}, this.allFeatures = {};
	}
}, bT = ["rvrn"], xT = [
	"ccmp",
	"locl",
	"rlig",
	"mark",
	"mkmk"
], ST = [
	"frac",
	"numr",
	"dnom"
], CT = [
	"calt",
	"clig",
	"liga",
	"rclt",
	"curs",
	"kern"
], wT = {
	ltr: ["ltra", "ltrm"],
	rtl: ["rtla", "rtlm"]
}, TT = class {
	static plan(e, t, n) {
		this.planPreprocessing(e), this.planFeatures(e), this.planPostprocessing(e, n), e.assignGlobalFeatures(t), this.assignFeatures(e, t);
	}
	static planPreprocessing(e) {
		e.add({
			global: [...bT, ...wT[e.direction]],
			local: ST
		});
	}
	static planFeatures(e) {}
	static planPostprocessing(e, t) {
		e.add([...xT, ...CT]), e.setFeatureOverrides(t);
	}
	static assignFeatures(e, t) {
		for (let e = 0; e < t.length; e++) {
			let n = t[e];
			if (n.codePoints[0] === 8260) {
				let r = e, i = e + 1;
				for (; r > 0 && nb(t[r - 1].codePoints[0]);) t[r - 1].features.numr = !0, t[r - 1].features.frac = !0, r--;
				for (; i < t.length && nb(t[i].codePoints[0]);) t[i].features.dnom = !0, t[i].features.frac = !0, i++;
				n.features.frac = !0, e = i - 1;
			}
		}
	}
};
zy(TT, "zeroMarkWidths", "AFTER_GPOS");
var ET = new Wy.default(Dw("APABAAAAAAAAOAAAAf0BAv7tmi1MxDAUx7vtvjhAgcDgkEgEAnmXEBIMCYaEcygEiqBQ4FAkCE4ikUgMiiBJSAgSiUQSDMn9L9eSl6bddddug9t7yS/trevre+3r27pcNxZiG+yCfdCVv/9LeQxOwRm4AJegD27ALbgD9+ABPJF+z+BN/h7yDj5k/VOWX6SdmU5+wLWknggxDxaS8u0qiiX4uiz9XamQ3wzDMAzDMAzDMAzDVI/h959V/v7BMAzDMAzDMLlyNTNiMSdewVxbiA44B4/guz1qW58VYlMI0WsJ0W+N6kXw0spvPtdwhtkwnGM6uLaV4Xyzg3v3PM9DPfQ/sOg4xPWjipy31P8LTqbU304c/cLCUmWJLNB2Uz2U1KTeRKNmKHVMfbJC+/0loTZRH/W5cvEvBJPMbREkWt3FD1NcqXZBSpuE2Ad0PBehPtNrPtIEdYP+hiRt/V1jIiE69X4NT/uVZI3PUHE9bm5M7ePGdZWy951v7Nn6j8v1WWKP3mt6ttnsigx6VN7Vc0VomSSGqW2mGNP1muZPl7LfjNUaKNFtDGVf2fvE9O7VlBS5j333c5p/eeoOqcs1R/hIqDWLJ7TTlksirVT1SI7l8k4Yp+g3jafGcrU1RM6l9th80XOpnlN97bDNY4i4s61B0Si/ipa0uHMl6zqEjlFfCZm/TM8KmzQDjmuTAQ==")), DT = [
	"isol",
	"fina",
	"fin2",
	"fin3",
	"medi",
	"med2",
	"init"
], OT = {
	Non_Joining: 0,
	Left_Joining: 1,
	Right_Joining: 2,
	Dual_Joining: 3,
	Join_Causing: 3,
	ALAPH: 4,
	"DALATH RISH": 5,
	Transparent: 6
}, kT = "isol", AT = "fina", jT = "fin2", MT = "fin3", NT = "medi", PT = "med2", FT = "init", IT = null, LT = [
	[
		[
			IT,
			IT,
			0
		],
		[
			IT,
			kT,
			2
		],
		[
			IT,
			kT,
			1
		],
		[
			IT,
			kT,
			2
		],
		[
			IT,
			kT,
			1
		],
		[
			IT,
			kT,
			6
		]
	],
	[
		[
			IT,
			IT,
			0
		],
		[
			IT,
			kT,
			2
		],
		[
			IT,
			kT,
			1
		],
		[
			IT,
			kT,
			2
		],
		[
			IT,
			jT,
			5
		],
		[
			IT,
			kT,
			6
		]
	],
	[
		[
			IT,
			IT,
			0
		],
		[
			IT,
			kT,
			2
		],
		[
			FT,
			AT,
			1
		],
		[
			FT,
			AT,
			3
		],
		[
			FT,
			AT,
			4
		],
		[
			FT,
			AT,
			6
		]
	],
	[
		[
			IT,
			IT,
			0
		],
		[
			IT,
			kT,
			2
		],
		[
			NT,
			AT,
			1
		],
		[
			NT,
			AT,
			3
		],
		[
			NT,
			AT,
			4
		],
		[
			NT,
			AT,
			6
		]
	],
	[
		[
			IT,
			IT,
			0
		],
		[
			IT,
			kT,
			2
		],
		[
			PT,
			kT,
			1
		],
		[
			PT,
			kT,
			2
		],
		[
			PT,
			jT,
			5
		],
		[
			PT,
			kT,
			6
		]
	],
	[
		[
			IT,
			IT,
			0
		],
		[
			IT,
			kT,
			2
		],
		[
			kT,
			kT,
			1
		],
		[
			kT,
			kT,
			2
		],
		[
			kT,
			jT,
			5
		],
		[
			kT,
			kT,
			6
		]
	],
	[
		[
			IT,
			IT,
			0
		],
		[
			IT,
			kT,
			2
		],
		[
			IT,
			kT,
			1
		],
		[
			IT,
			kT,
			2
		],
		[
			IT,
			MT,
			5
		],
		[
			IT,
			kT,
			6
		]
	]
], RT = class extends TT {
	static planFeatures(e) {
		e.add(["ccmp", "locl"]);
		for (let t = 0; t < DT.length; t++) {
			let n = DT[t];
			e.addStage(n, !1);
		}
		e.addStage("mset");
	}
	static assignFeatures(e, t) {
		super.assignFeatures(e, t);
		let n = -1, r = 0, i = [];
		for (let e = 0; e < t.length; e++) {
			let o, s;
			var a = t[e];
			let c = zT(a.codePoints[0]);
			if (c === OT.Transparent) {
				i[e] = IT;
				continue;
			}
			[s, o, r] = LT[r][c], s !== IT && n !== -1 && (i[n] = s), i[e] = o, n = e;
		}
		for (let e = 0; e < t.length; e++) {
			let n;
			var a = t[e];
			(n = i[e]) && (a.features[n] = !0);
		}
	}
};
function zT(e) {
	let t = ET.get(e);
	if (t) return t - 1;
	let n = $y(e);
	return n === "Mn" || n === "Me" || n === "Cf" ? OT.Transparent : OT.Non_Joining;
}
var BT = class {
	reset(e = {}, t = 0) {
		this.options = e, this.flags = e.flags || {}, this.markAttachmentType = e.markAttachmentType || 0, this.index = t;
	}
	get cur() {
		return this.glyphs[this.index] || null;
	}
	shouldIgnore(e) {
		return this.flags.ignoreMarks && e.isMark || this.flags.ignoreBaseGlyphs && e.isBase || this.flags.ignoreLigatures && e.isLigature || this.markAttachmentType && e.isMark && e.markAttachmentType !== this.markAttachmentType;
	}
	move(e) {
		for (this.index += e; 0 <= this.index && this.index < this.glyphs.length && this.shouldIgnore(this.glyphs[this.index]);) this.index += e;
		return 0 > this.index || this.index >= this.glyphs.length ? null : this.glyphs[this.index];
	}
	next() {
		return this.move(1);
	}
	prev() {
		return this.move(-1);
	}
	peek(e = 1) {
		let t = this.index, n = this.increment(e);
		return this.index = t, n;
	}
	peekIndex(e = 1) {
		let t = this.index;
		this.increment(e);
		let n = this.index;
		return this.index = t, n;
	}
	increment(e = 1) {
		let t = e < 0 ? -1 : 1;
		for (e = Math.abs(e); e--;) this.move(t);
		return this.glyphs[this.index];
	}
	constructor(e, t) {
		this.glyphs = e, this.reset(t);
	}
}, VT = [
	"DFLT",
	"dflt",
	"latn"
], HT = class {
	findScript(e) {
		if (this.table.scriptList == null) return null;
		Array.isArray(e) || (e = [e]);
		for (let t of e) for (let e of this.table.scriptList) if (e.tag === t) return e;
		return null;
	}
	selectScript(e, t, n) {
		let r = !1, i;
		if (!this.script || e !== this.scriptTag) {
			if (i = this.findScript(e), i ||= this.findScript(VT), !i) return this.scriptTag;
			this.scriptTag = i.tag, this.script = i.script, this.language = null, this.languageTag = null, r = !0;
		}
		if ((!n || n !== this.direction) && (this.direction = n || Rw(e)), t && t.length < 4 && (t += " ".repeat(4 - t.length)), !t || t !== this.languageTag) {
			this.language = null;
			for (let e of this.script.langSysRecords) if (e.tag === t) {
				this.language = e.langSys, this.languageTag = e.tag;
				break;
			}
			this.language || (this.language = this.script.defaultLangSys, this.languageTag = null), r = !0;
		}
		if (r && (this.features = {}, this.language)) for (let e of this.language.featureIndexes) {
			let t = this.table.featureList[e], n = this.substituteFeatureForVariations(e);
			this.features[t.tag] = n || t.feature;
		}
		return this.scriptTag;
	}
	lookupsForFeatures(e = [], t) {
		let n = [];
		for (let r of e) {
			let e = this.features[r];
			if (e) for (let i of e.lookupListIndexes) t && t.indexOf(i) !== -1 || n.push({
				feature: r,
				index: i,
				lookup: this.table.lookupList.get(i)
			});
		}
		return n.sort((e, t) => e.index - t.index), n;
	}
	substituteFeatureForVariations(e) {
		if (this.variationsIndex === -1) return null;
		let t = this.table.featureVariations.featureVariationRecords[this.variationsIndex].featureTableSubstitution.substitutions;
		for (let n of t) if (n.featureIndex === e) return n.alternateFeatureTable;
		return null;
	}
	findVariationsIndex(e) {
		let t = this.table.featureVariations;
		if (!t) return -1;
		let n = t.featureVariationRecords;
		for (let t = 0; t < n.length; t++) {
			let r = n[t].conditionSet.conditionTable;
			if (this.variationConditionsMatch(r, e)) return t;
		}
		return -1;
	}
	variationConditionsMatch(e, t) {
		return e.every((e) => {
			let n = e.axisIndex < t.length ? t[e.axisIndex] : 0;
			return e.filterRangeMinValue <= n && n <= e.filterRangeMaxValue;
		});
	}
	applyFeatures(e, t, n) {
		let r = this.lookupsForFeatures(e);
		this.applyLookups(r, t, n);
	}
	applyLookups(e, t, n) {
		this.glyphs = t, this.positions = n, this.glyphIterator = new BT(t);
		for (let { feature: n, lookup: r } of e) for (this.currentFeature = n, this.glyphIterator.reset(r.flags); this.glyphIterator.index < t.length;) {
			if (!(n in this.glyphIterator.cur.features)) {
				this.glyphIterator.next();
				continue;
			}
			for (let e of r.subTables) if (this.applyLookup(r.lookupType, e)) break;
			this.glyphIterator.next();
		}
	}
	applyLookup(e, t) {
		throw Error("applyLookup must be implemented by subclasses");
	}
	applyLookupList(e) {
		let t = this.glyphIterator.options, n = this.glyphIterator.index;
		for (let r of e) {
			this.glyphIterator.reset(t, n), this.glyphIterator.increment(r.sequenceIndex);
			let e = this.table.lookupList.get(r.lookupListIndex);
			this.glyphIterator.reset(e.flags, this.glyphIterator.index);
			for (let t of e.subTables) if (this.applyLookup(e.lookupType, t)) break;
		}
		return this.glyphIterator.reset(t, n), !0;
	}
	coverageIndex(e, t) {
		switch (t ??= this.glyphIterator.cur.id, e.version) {
			case 1: return e.glyphs.indexOf(t);
			case 2:
				for (let n of e.rangeRecords) if (n.start <= t && t <= n.end) return n.startCoverageIndex + t - n.start;
				break;
		}
		return -1;
	}
	match(e, t, n, r) {
		let i = this.glyphIterator.index, a = this.glyphIterator.increment(e), o = 0;
		for (; o < t.length && a && n(t[o], a);) r && r.push(this.glyphIterator.index), o++, a = this.glyphIterator.next();
		return this.glyphIterator.index = i, o < t.length ? !1 : r || !0;
	}
	sequenceMatches(e, t) {
		return this.match(e, t, (e, t) => e === t.id);
	}
	sequenceMatchIndices(e, t) {
		return this.match(e, t, (e, t) => this.currentFeature in t.features ? e === t.id : !1, []);
	}
	coverageSequenceMatches(e, t) {
		return this.match(e, t, (e, t) => this.coverageIndex(e, t.id) >= 0);
	}
	getClassID(e, t) {
		switch (t.version) {
			case 1:
				let n = e - t.startGlyph;
				if (n >= 0 && n < t.classValueArray.length) return t.classValueArray[n];
				break;
			case 2:
				for (let n of t.classRangeRecord) if (n.start <= e && e <= n.end) return n.class;
				break;
		}
		return 0;
	}
	classSequenceMatches(e, t, n) {
		return this.match(e, t, (e, t) => e === this.getClassID(t.id, n));
	}
	applyContext(e) {
		let t, n;
		switch (e.version) {
			case 1:
				if (t = this.coverageIndex(e.coverage), t === -1) return !1;
				n = e.ruleSets[t];
				for (let e of n) if (this.sequenceMatches(1, e.input)) return this.applyLookupList(e.lookupRecords);
				break;
			case 2:
				if (this.coverageIndex(e.coverage) === -1 || (t = this.getClassID(this.glyphIterator.cur.id, e.classDef), t === -1)) return !1;
				n = e.classSet[t];
				for (let t of n) if (this.classSequenceMatches(1, t.classes, e.classDef)) return this.applyLookupList(t.lookupRecords);
				break;
			case 3:
				if (this.coverageSequenceMatches(0, e.coverages)) return this.applyLookupList(e.lookupRecords);
				break;
		}
		return !1;
	}
	applyChainingContext(e) {
		let t;
		switch (e.version) {
			case 1:
				if (t = this.coverageIndex(e.coverage), t === -1) return !1;
				let n = e.chainRuleSets[t];
				for (let e of n) if (this.sequenceMatches(-e.backtrack.length, e.backtrack) && this.sequenceMatches(1, e.input) && this.sequenceMatches(1 + e.input.length, e.lookahead)) return this.applyLookupList(e.lookupRecords);
				break;
			case 2:
				if (this.coverageIndex(e.coverage) === -1) return !1;
				t = this.getClassID(this.glyphIterator.cur.id, e.inputClassDef);
				let r = e.chainClassSet[t];
				if (!r) return !1;
				for (let t of r) if (this.classSequenceMatches(-t.backtrack.length, t.backtrack, e.backtrackClassDef) && this.classSequenceMatches(1, t.input, e.inputClassDef) && this.classSequenceMatches(1 + t.input.length, t.lookahead, e.lookaheadClassDef)) return this.applyLookupList(t.lookupRecords);
				break;
			case 3:
				if (this.coverageSequenceMatches(-e.backtrackGlyphCount, e.backtrackCoverage) && this.coverageSequenceMatches(0, e.inputCoverage) && this.coverageSequenceMatches(e.inputGlyphCount, e.lookaheadCoverage)) return this.applyLookupList(e.lookupRecords);
				break;
		}
		return !1;
	}
	constructor(e, t) {
		this.font = e, this.table = t, this.script = null, this.scriptTag = null, this.language = null, this.languageTag = null, this.features = {}, this.lookups = {}, this.variationsIndex = e._variationProcessor ? this.findVariationsIndex(e._variationProcessor.normalizedCoords) : -1, this.selectScript(), this.glyphs = [], this.positions = [], this.ligatureID = 1, this.currentFeature = null;
	}
}, UT = class e {
	get id() {
		return this._id;
	}
	set id(e) {
		this._id = e, this.substituted = !0;
		let t = this._font.GDEF;
		if (t && t.glyphClassDef) {
			let n = HT.prototype.getClassID(e, t.glyphClassDef);
			this.isBase = n === 1, this.isLigature = n === 2, this.isMark = n === 3, this.markAttachmentType = t.markAttachClassDef ? HT.prototype.getClassID(e, t.markAttachClassDef) : 0;
		} else this.isMark = this.codePoints.length > 0 && this.codePoints.every(cb), this.isBase = !this.isMark, this.isLigature = this.codePoints.length > 1, this.markAttachmentType = 0;
	}
	copy() {
		return new e(this._font, this.id, this.codePoints, this.features);
	}
	constructor(e, t, n = [], r) {
		if (this._font = e, this.codePoints = n, this.id = t, this.features = {}, Array.isArray(r)) for (let e = 0; e < r.length; e++) {
			let t = r[e];
			this.features[t] = !0;
		}
		else typeof r == "object" && Object.assign(this.features, r);
		this.ligatureID = null, this.ligatureComponent = null, this.isLigated = !1, this.cursiveAttachment = null, this.markAttachment = null, this.shaperInfo = null, this.substituted = !1, this.isMultiplied = !1;
	}
}, WT = class extends TT {
	static planFeatures(e) {
		e.add([
			"ljmo",
			"vjmo",
			"tjmo"
		], !1);
	}
	static assignFeatures(e, t) {
		let n = 0, r = 0;
		for (; r < t.length;) {
			let i, a = t[r].codePoints[0], o = yE(a);
			switch ([i, n] = TE[n][o], i) {
				case xE:
					e.font.hasGlyphForCodePoint(a) || (r = DE(t, r, e.font));
					break;
				case SE:
					r = OE(t, r, e.font);
					break;
				case CE:
					AE(t, r, e.font);
					break;
				case wE:
					r = jE(t, r, e.font);
					break;
			}
			r++;
		}
	}
};
zy(WT, "zeroMarkWidths", "NONE");
var GT = 44032, KT = 55204, qT = 11173, JT = 4352, YT = 4449, XT = 4519, ZT = 21, QT = 28, $T = 4370, eE = 4469, tE = 4546, nE = 9676, rE = (e) => 4352 <= e && e <= 4447 || 43360 <= e && e <= 43388, iE = (e) => 4448 <= e && e <= 4519 || 55216 <= e && e <= 55238, aE = (e) => 4520 <= e && e <= 4607 || 55243 <= e && e <= 55291, oE = (e) => 12334 <= e && e <= 12335, sE = (e) => GT <= e && e <= KT, cE = (e) => e - GT < qT && (e - GT) % QT === 0, lE = (e) => JT <= e && e <= $T, uE = (e) => YT <= e && e <= eE, dE = (e) => 1 <= e && e <= tE, fE = 0, pE = 1, mE = 2, hE = 3, gE = 4, _E = 5, vE = 6;
function yE(e) {
	return rE(e) ? pE : iE(e) ? mE : aE(e) ? hE : cE(e) ? gE : sE(e) ? _E : oE(e) ? vE : fE;
}
var bE = 0, xE = 1, SE = 2, CE = 4, wE = 5, TE = [
	[
		[bE, 0],
		[bE, 1],
		[bE, 0],
		[bE, 0],
		[xE, 2],
		[xE, 3],
		[wE, 0]
	],
	[
		[bE, 0],
		[bE, 1],
		[SE, 2],
		[bE, 0],
		[xE, 2],
		[xE, 3],
		[wE, 0]
	],
	[
		[bE, 0],
		[bE, 1],
		[bE, 0],
		[SE, 3],
		[xE, 2],
		[xE, 3],
		[CE, 0]
	],
	[
		[bE, 0],
		[bE, 1],
		[bE, 0],
		[bE, 0],
		[xE, 2],
		[xE, 3],
		[CE, 0]
	]
];
function EE(e, t, n) {
	return new UT(e, e.glyphForCodePoint(t).id, [t], n);
}
function DE(e, t, n) {
	let r = e[t], i = r.codePoints[0] - GT, a = XT + i % QT;
	i = i / QT | 0;
	let o = JT + i / ZT | 0, s = YT + i % ZT;
	if (!n.hasGlyphForCodePoint(o) || !n.hasGlyphForCodePoint(s) || a !== XT && !n.hasGlyphForCodePoint(a)) return t;
	let c = EE(n, o, r.features);
	c.features.ljmo = !0;
	let l = EE(n, s, r.features);
	l.features.vjmo = !0;
	let u = [c, l];
	if (a > XT) {
		let e = EE(n, a, r.features);
		e.features.tjmo = !0, u.push(e);
	}
	return e.splice(t, 1, ...u), t + u.length - 1;
}
function OE(e, t, n) {
	let r = e[t], i = e[t].codePoints[0], a = yE(i), o = e[t - 1].codePoints[0], s = yE(o), c, l, u, d;
	if (s === gE && a === hE) c = o, d = r;
	else {
		a === mE ? (l = e[t - 1], u = r) : (l = e[t - 2], u = e[t - 1], d = r);
		let n = l.codePoints[0], i = u.codePoints[0];
		lE(n) && uE(i) && (c = GT + ((n - JT) * ZT + (i - YT)) * QT);
	}
	let f = d && d.codePoints[0] || XT;
	if (c != null && (f === XT || dE(f))) {
		let i = c + (f - XT);
		if (n.hasGlyphForCodePoint(i)) {
			let a = s === mE ? 3 : 2;
			return e.splice(t - a + 1, a, EE(n, i, r.features)), t - a + 1;
		}
	}
	return l && (l.features.ljmo = !0), u && (u.features.vjmo = !0), d && (d.features.tjmo = !0), s === gE ? (DE(e, t - 1, n), t + 1) : t;
}
function kE(e) {
	switch (yE(e)) {
		case gE:
		case _E: return 1;
		case mE: return 2;
		case hE: return 3;
	}
}
function AE(e, t, n) {
	let r = e[t], i = e[t].codePoints[0];
	if (n.glyphForCodePoint(i).advanceWidth === 0) return;
	let a = e[t - 1].codePoints[0], o = kE(a);
	return e.splice(t, 1), e.splice(t - o, 0, r);
}
function jE(e, t, n) {
	let r = e[t], i = e[t].codePoints[0];
	if (n.hasGlyphForCodePoint(nE)) {
		let a = EE(n, nE, r.features), o = n.glyphForCodePoint(i).advanceWidth === 0 ? t : t + 1;
		e.splice(o, 0, a), t++;
	}
	return t;
}
var ME = {};
ME = JSON.parse("{\"stateTable\":[[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,2,3,4,5,6,7,8,9,0,10,11,11,12,13,14,15,16,17],[0,0,0,18,19,20,21,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,28,29,30,31,32,33,0,34,0,0,35,36,0,0,37,0],[0,0,0,38,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,39,0,0,0,40,41,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,43,44,44,8,9,0,0,0,0,12,43,0,0,0,0],[0,0,0,0,43,44,44,8,9,0,0,0,0,0,43,0,0,0,0],[0,0,0,45,46,47,48,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,50,0,0,51,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,52,0,0,0,0,0,0,0,0],[0,0,0,53,54,55,56,57,58,0,59,0,0,60,61,0,0,62,0],[0,0,0,4,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,63,64,0,0,40,41,0,9,0,10,0,0,0,42,0,63,0,0],[0,2,3,4,5,6,7,8,9,0,10,11,11,12,13,0,2,16,0],[0,0,0,18,65,20,21,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,0,66,67,67,8,9,0,10,0,0,0,68,0,0,0,0],[0,0,0,69,0,70,70,0,71,0,72,0,0,0,0,0,0,0,0],[0,0,0,73,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,75,0,0,0,76,77,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,79,80,80,22,23,0,0,0,0,25,79,0,0,0,0],[0,0,0,18,19,20,74,22,23,0,24,0,0,25,26,0,0,27,0],[0,0,0,81,82,83,84,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,86,0,0,87,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,88,0,0,0,0,0,0,0,0],[0,0,0,18,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,89,90,0,0,76,77,0,23,0,24,0,0,0,78,0,89,0,0],[0,0,0,0,91,92,92,22,23,0,24,0,0,0,93,0,0,0,0],[0,0,0,94,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,96,0,0,0,97,98,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,35,100,0,0,0,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,0,100,0,0,0,0],[0,0,0,102,103,104,105,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,107,0,0,108,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,109,0,0,0,0,0,0,0,0],[0,0,0,28,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,110,111,0,0,97,98,0,33,0,34,0,0,0,99,0,110,0,0],[0,0,0,0,112,113,113,32,33,0,34,0,0,0,114,0,0,0,0],[0,0,0,0,5,7,7,8,9,0,10,0,0,0,13,0,0,16,0],[0,0,0,115,116,117,118,8,9,0,10,0,0,119,120,0,0,16,0],[0,0,0,0,0,121,121,0,9,0,10,0,0,0,42,0,0,0,0],[0,39,0,122,0,123,123,8,9,0,10,0,0,0,42,0,39,0,0],[0,124,64,0,0,0,0,0,0,0,0,0,0,0,0,0,124,0,0],[0,39,0,0,0,121,125,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,126,126,8,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,46,47,48,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,47,47,49,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,127,127,49,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,128,127,127,49,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,129,130,131,132,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,50,0,0,0,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,134,0,0,0,0,0,0,0,0],[0,0,0,135,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,136,0,0,0,137,138,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,140,141,141,57,58,0,0,0,0,60,140,0,0,0,0],[0,0,0,0,140,141,141,57,58,0,0,0,0,0,140,0,0,0,0],[0,0,0,142,143,144,145,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,147,0,0,148,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,149,0,0,0,0,0,0,0,0],[0,0,0,53,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,150,151,0,0,137,138,0,58,0,59,0,0,0,139,0,150,0,0],[0,0,0,0,152,153,153,57,58,0,59,0,0,0,154,0,0,0,0],[0,0,0,155,116,156,157,8,9,0,10,0,0,158,120,0,0,16,0],[0,0,0,0,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,75,3,4,5,159,160,8,161,0,162,0,11,12,163,0,75,16,0],[0,0,0,0,0,40,164,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,0,165,0,0,0,0],[0,124,64,0,0,40,164,0,9,0,10,0,0,0,42,0,124,0,0],[0,0,0,0,0,70,70,0,71,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,71,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,166,0,0,167,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,168,0,0,0,0,0,0,0,0],[0,0,0,0,19,74,74,22,23,0,24,0,0,0,26,0,0,27,0],[0,0,0,0,79,80,80,22,23,0,0,0,0,0,79,0,0,0,0],[0,0,0,169,170,171,172,22,23,0,24,0,0,173,174,0,0,27,0],[0,0,0,0,0,175,175,0,23,0,24,0,0,0,78,0,0,0,0],[0,75,0,176,0,177,177,22,23,0,24,0,0,0,78,0,75,0,0],[0,178,90,0,0,0,0,0,0,0,0,0,0,0,0,0,178,0,0],[0,75,0,0,0,175,179,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,180,180,22,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,82,83,84,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,83,83,85,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,181,181,85,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,182,181,181,85,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,183,184,185,186,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,86,0,0,0,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,188,0,0,0,0,0,0,0,0],[0,0,0,189,170,190,191,22,23,0,24,0,0,192,174,0,0,27,0],[0,0,0,0,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,76,193,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,0,194,0,0,0,0],[0,178,90,0,0,76,193,0,23,0,24,0,0,0,78,0,178,0,0],[0,0,0,0,29,95,31,32,33,0,34,0,0,0,36,0,0,37,0],[0,0,0,0,100,101,101,32,33,0,0,0,0,0,100,0,0,0,0],[0,0,0,195,196,197,198,32,33,0,34,0,0,199,200,0,0,37,0],[0,0,0,0,0,201,201,0,33,0,34,0,0,0,99,0,0,0,0],[0,96,0,202,0,203,203,32,33,0,34,0,0,0,99,0,96,0,0],[0,204,111,0,0,0,0,0,0,0,0,0,0,0,0,0,204,0,0],[0,96,0,0,0,201,205,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,206,206,32,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,103,104,105,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,104,104,106,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,207,207,106,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,208,207,207,106,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,209,210,211,212,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,107,0,0,0,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,214,0,0,0,0,0,0,0,0],[0,0,0,215,196,216,217,32,33,0,34,0,0,218,200,0,0,37,0],[0,0,0,0,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,97,219,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,0,220,0,0,0,0],[0,204,111,0,0,97,219,0,33,0,34,0,0,0,99,0,204,0,0],[0,0,0,221,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,223,0,0,0,40,224,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,119,225,0,0,0,0],[0,0,0,115,116,117,222,8,9,0,10,0,0,119,120,0,0,16,0],[0,0,0,115,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,226,64,0,0,40,224,0,9,0,10,0,0,0,42,0,226,0,0],[0,0,0,0,0,0,0,0,9,0,0,0,0,0,0,0,0,0,0],[0,39,0,0,0,121,121,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,44,44,8,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,227,0,228,229,0,9,0,10,0,0,230,0,0,0,0,0],[0,39,0,122,0,121,121,0,9,0,10,0,0,0,42,0,39,0,0],[0,0,0,0,0,0,0,8,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,231,231,49,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,232,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,130,131,132,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,131,131,133,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,233,233,133,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,234,233,233,133,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,235,236,237,238,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,54,56,56,57,58,0,59,0,0,0,61,0,0,62,0],[0,0,0,240,241,242,243,57,58,0,59,0,0,244,245,0,0,62,0],[0,0,0,0,0,246,246,0,58,0,59,0,0,0,139,0,0,0,0],[0,136,0,247,0,248,248,57,58,0,59,0,0,0,139,0,136,0,0],[0,249,151,0,0,0,0,0,0,0,0,0,0,0,0,0,249,0,0],[0,136,0,0,0,246,250,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,251,251,57,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,143,144,145,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,144,144,146,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,252,252,146,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,253,252,252,146,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,254,255,256,257,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,147,0,0,0,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,259,0,0,0,0,0,0,0,0],[0,0,0,260,241,261,262,57,58,0,59,0,0,263,245,0,0,62,0],[0,0,0,0,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,137,264,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,0,265,0,0,0,0],[0,249,151,0,0,137,264,0,58,0,59,0,0,0,139,0,249,0,0],[0,0,0,221,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,158,225,0,0,0,0],[0,0,0,155,116,156,222,8,9,0,10,0,0,158,120,0,0,16,0],[0,0,0,155,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,43,266,266,8,161,0,24,0,0,12,267,0,0,0,0],[0,75,0,176,43,268,268,269,161,0,24,0,0,0,267,0,75,0,0],[0,0,0,0,0,270,0,0,271,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,272,0,0,0,0,0,0,0,0],[0,273,274,0,0,40,41,0,9,0,10,0,0,0,42,0,273,0,0],[0,0,0,40,0,123,123,8,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,121,275,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,166,0,0,0,0,72,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,276,0,0,0,0,0,0,0,0],[0,0,0,277,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,279,0,0,0,76,280,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,173,281,0,0,0,0],[0,0,0,169,170,171,278,22,23,0,24,0,0,173,174,0,0,27,0],[0,0,0,169,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,282,90,0,0,76,280,0,23,0,24,0,0,0,78,0,282,0,0],[0,0,0,0,0,0,0,0,23,0,0,0,0,0,0,0,0,0,0],[0,75,0,0,0,175,175,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,80,80,22,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,283,0,284,285,0,23,0,24,0,0,286,0,0,0,0,0],[0,75,0,176,0,175,175,0,23,0,24,0,0,0,78,0,75,0,0],[0,0,0,0,0,0,0,22,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,287,287,85,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,288,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,184,185,186,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,185,185,187,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,289,289,187,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,290,289,289,187,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,291,292,293,294,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,277,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,192,281,0,0,0,0],[0,0,0,189,170,190,278,22,23,0,24,0,0,192,174,0,0,27,0],[0,0,0,189,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,76,0,177,177,22,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,175,296,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,297,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,299,0,0,0,97,300,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,199,301,0,0,0,0],[0,0,0,195,196,197,298,32,33,0,34,0,0,199,200,0,0,37,0],[0,0,0,195,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,302,111,0,0,97,300,0,33,0,34,0,0,0,99,0,302,0,0],[0,0,0,0,0,0,0,0,33,0,0,0,0,0,0,0,0,0,0],[0,96,0,0,0,201,201,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,101,101,32,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,303,0,304,305,0,33,0,34,0,0,306,0,0,0,0,0],[0,96,0,202,0,201,201,0,33,0,34,0,0,0,99,0,96,0,0],[0,0,0,0,0,0,0,32,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,307,307,106,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,308,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,210,211,212,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,211,211,213,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,309,309,213,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,310,309,309,213,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,311,312,313,314,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,297,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,218,301,0,0,0,0],[0,0,0,215,196,216,298,32,33,0,34,0,0,218,200,0,0,37,0],[0,0,0,215,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,97,0,203,203,32,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,201,316,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,116,222,222,8,9,0,10,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,9,0,0,0,0,0,225,0,0,0,0],[0,0,0,317,318,319,320,8,9,0,10,0,0,321,322,0,0,16,0],[0,223,0,323,0,123,123,8,9,0,10,0,0,0,42,0,223,0,0],[0,223,0,0,0,121,324,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,325,318,326,327,8,9,0,10,0,0,328,322,0,0,16,0],[0,0,0,64,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,9,0,0,0,0,230,0,0,0,0,0],[0,0,0,227,0,228,121,0,9,0,10,0,0,230,0,0,0,0,0],[0,0,0,227,0,121,121,0,9,0,10,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,49,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,46,0,0],[0,0,0,0,0,329,329,133,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,330,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,236,237,238,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,237,237,239,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,331,331,239,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,332,331,331,239,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,333,40,121,334,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,335,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,337,0,0,0,137,338,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,244,339,0,0,0,0],[0,0,0,240,241,242,336,57,58,0,59,0,0,244,245,0,0,62,0],[0,0,0,240,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,340,151,0,0,137,338,0,58,0,59,0,0,0,139,0,340,0,0],[0,0,0,0,0,0,0,0,58,0,0,0,0,0,0,0,0,0,0],[0,136,0,0,0,246,246,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,141,141,57,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,341,0,342,343,0,58,0,59,0,0,344,0,0,0,0,0],[0,136,0,247,0,246,246,0,58,0,59,0,0,0,139,0,136,0,0],[0,0,0,0,0,0,0,57,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,345,345,146,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,346,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,255,256,257,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,256,256,258,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,347,347,258,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,348,347,347,258,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,349,350,351,352,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,335,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,263,339,0,0,0,0],[0,0,0,260,241,261,336,57,58,0,59,0,0,263,245,0,0,62,0],[0,0,0,260,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,137,0,248,248,57,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,246,354,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,126,126,8,23,0,0,0,0,0,0,0,0,0,0],[0,355,90,0,0,121,125,0,9,0,10,0,0,0,42,0,355,0,0],[0,0,0,0,0,356,356,269,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,357,358,359,360,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,270,0,0,0,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,363,0,0,0,0,0,0,0,0],[0,0,0,364,116,365,366,8,161,0,162,0,0,367,120,0,0,16,0],[0,0,0,0,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,40,0,121,121,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,170,278,278,22,23,0,24,0,0,0,174,0,0,27,0],[0,0,0,0,281,80,80,22,23,0,0,0,0,0,281,0,0,0,0],[0,0,0,369,370,371,372,22,23,0,24,0,0,373,374,0,0,27,0],[0,279,0,375,0,177,177,22,23,0,24,0,0,0,78,0,279,0,0],[0,279,0,0,0,175,376,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,377,370,378,379,22,23,0,24,0,0,380,374,0,0,27,0],[0,0,0,90,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,23,0,0,0,0,286,0,0,0,0,0],[0,0,0,283,0,284,175,0,23,0,24,0,0,286,0,0,0,0,0],[0,0,0,283,0,175,175,0,23,0,24,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,85,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,82,0,0],[0,0,0,0,0,381,381,187,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,382,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,292,293,294,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,293,293,295,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,0,383,383,295,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,384,383,383,295,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,385,76,175,386,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,76,0,175,175,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,196,298,298,32,33,0,34,0,0,0,200,0,0,37,0],[0,0,0,0,301,101,101,32,33,0,0,0,0,0,301,0,0,0,0],[0,0,0,387,388,389,390,32,33,0,34,0,0,391,392,0,0,37,0],[0,299,0,393,0,203,203,32,33,0,34,0,0,0,99,0,299,0,0],[0,299,0,0,0,201,394,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,395,388,396,397,32,33,0,34,0,0,398,392,0,0,37,0],[0,0,0,111,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,33,0,0,0,0,306,0,0,0,0,0],[0,0,0,303,0,304,201,0,33,0,34,0,0,306,0,0,0,0,0],[0,0,0,303,0,201,201,0,33,0,34,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,106,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,103,0,0],[0,0,0,0,0,399,399,213,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,400,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,312,313,314,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,313,313,315,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,0,401,401,315,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,402,401,401,315,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,403,97,201,404,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,97,0,201,201,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,405,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,407,0,0,0,40,408,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,321,409,0,0,0,0],[0,0,0,317,318,319,406,8,9,0,10,0,0,321,322,0,0,16,0],[0,0,0,317,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,410,64,0,0,40,408,0,9,0,10,0,0,0,42,0,410,0,0],[0,223,0,0,0,121,121,0,9,0,10,0,0,0,42,0,223,0,0],[0,223,0,323,0,121,121,0,9,0,10,0,0,0,42,0,223,0,0],[0,0,0,405,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,328,409,0,0,0,0],[0,0,0,325,318,326,406,8,9,0,10,0,0,328,322,0,0,16,0],[0,0,0,325,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,0,0,0,133,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,130,0,0],[0,0,0,0,0,411,411,239,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,412,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,40,121,334,0,9,0,10,0,0,0,42,0,0,0,0],[0,0,0,0,413,0,0,0,9,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,241,336,336,57,58,0,59,0,0,0,245,0,0,62,0],[0,0,0,0,339,141,141,57,58,0,0,0,0,0,339,0,0,0,0],[0,0,0,414,415,416,417,57,58,0,59,0,0,418,419,0,0,62,0],[0,337,0,420,0,248,248,57,58,0,59,0,0,0,139,0,337,0,0],[0,337,0,0,0,246,421,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,422,415,423,424,57,58,0,59,0,0,425,419,0,0,62,0],[0,0,0,151,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,58,0,0,0,0,344,0,0,0,0,0],[0,0,0,341,0,342,246,0,58,0,59,0,0,344,0,0,0,0,0],[0,0,0,341,0,246,246,0,58,0,59,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,146,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,143,0,0],[0,0,0,0,0,426,426,258,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,427,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,350,351,352,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,351,351,353,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,0,428,428,353,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,429,428,428,353,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,430,137,246,431,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,137,0,246,246,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,432,116,433,434,8,161,0,162,0,0,435,120,0,0,16,0],[0,0,0,0,0,180,180,269,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,358,359,360,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,359,359,361,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,436,436,361,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,437,436,436,361,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,438,439,440,441,442,161,0,162,0,0,0,362,0,0,0,0],[0,443,274,0,0,0,0,0,0,0,0,0,0,0,0,0,443,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,444,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,367,225,0,0,0,0],[0,0,0,364,116,365,445,8,161,0,162,0,0,367,120,0,0,16,0],[0,0,0,364,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,0,0,0,0,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,446,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,448,0,0,0,76,449,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,373,450,0,0,0,0],[0,0,0,369,370,371,447,22,23,0,24,0,0,373,374,0,0,27,0],[0,0,0,369,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,451,90,0,0,76,449,0,23,0,24,0,0,0,78,0,451,0,0],[0,279,0,0,0,175,175,0,23,0,24,0,0,0,78,0,279,0,0],[0,279,0,375,0,175,175,0,23,0,24,0,0,0,78,0,279,0,0],[0,0,0,446,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,380,450,0,0,0,0],[0,0,0,377,370,378,447,22,23,0,24,0,0,380,374,0,0,27,0],[0,0,0,377,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,0,0,0,187,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,184,0,0],[0,0,0,0,0,452,452,295,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,453,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,76,175,386,0,23,0,24,0,0,0,78,0,0,0,0],[0,0,0,0,454,0,0,0,23,0,0,0,0,0,0,0,0,0,0],[0,0,0,455,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,457,0,0,0,97,458,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,391,459,0,0,0,0],[0,0,0,387,388,389,456,32,33,0,34,0,0,391,392,0,0,37,0],[0,0,0,387,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,460,111,0,0,97,458,0,33,0,34,0,0,0,99,0,460,0,0],[0,299,0,0,0,201,201,0,33,0,34,0,0,0,99,0,299,0,0],[0,299,0,393,0,201,201,0,33,0,34,0,0,0,99,0,299,0,0],[0,0,0,455,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,398,459,0,0,0,0],[0,0,0,395,388,396,456,32,33,0,34,0,0,398,392,0,0,37,0],[0,0,0,395,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,0,0,0,213,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,210,0,0],[0,0,0,0,0,461,461,315,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,462,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,97,201,404,0,33,0,34,0,0,0,99,0,0,0,0],[0,0,0,0,463,0,0,0,33,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,318,406,406,8,9,0,10,0,0,0,322,0,0,16,0],[0,0,0,0,409,44,44,8,9,0,0,0,0,0,409,0,0,0,0],[0,0,0,464,465,466,467,8,9,0,10,0,0,468,469,0,0,16,0],[0,407,0,470,0,123,123,8,9,0,10,0,0,0,42,0,407,0,0],[0,407,0,0,0,121,471,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,472,465,473,474,8,9,0,10,0,0,475,469,0,0,16,0],[0,0,0,0,0,0,0,239,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,236,0,0],[0,0,0,0,0,0,476,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,477,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,479,0,0,0,137,480,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,418,481,0,0,0,0],[0,0,0,414,415,416,478,57,58,0,59,0,0,418,419,0,0,62,0],[0,0,0,414,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,482,151,0,0,137,480,0,58,0,59,0,0,0,139,0,482,0,0],[0,337,0,0,0,246,246,0,58,0,59,0,0,0,139,0,337,0,0],[0,337,0,420,0,246,246,0,58,0,59,0,0,0,139,0,337,0,0],[0,0,0,477,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,425,481,0,0,0,0],[0,0,0,422,415,423,478,57,58,0,59,0,0,425,419,0,0,62,0],[0,0,0,422,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,0,0,0,258,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,255,0,0],[0,0,0,0,0,483,483,353,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,484,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,137,246,431,0,58,0,59,0,0,0,139,0,0,0,0],[0,0,0,0,485,0,0,0,58,0,0,0,0,0,0,0,0,0,0],[0,0,0,444,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,435,225,0,0,0,0],[0,0,0,432,116,433,445,8,161,0,162,0,0,435,120,0,0,16,0],[0,0,0,432,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,0,486,486,361,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,487,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,439,440,441,442,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,440,440,442,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,488,488,442,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,489,488,488,442,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,490,491,492,493,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,495,0,496,497,0,161,0,162,0,0,498,0,0,0,0,0],[0,0,0,0,116,445,445,8,161,0,162,0,0,0,120,0,0,16,0],[0,0,0,0,225,44,44,8,161,0,0,0,0,0,225,0,0,0,0],[0,0,0,0,370,447,447,22,23,0,24,0,0,0,374,0,0,27,0],[0,0,0,0,450,80,80,22,23,0,0,0,0,0,450,0,0,0,0],[0,0,0,499,500,501,502,22,23,0,24,0,0,503,504,0,0,27,0],[0,448,0,505,0,177,177,22,23,0,24,0,0,0,78,0,448,0,0],[0,448,0,0,0,175,506,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,507,500,508,509,22,23,0,24,0,0,510,504,0,0,27,0],[0,0,0,0,0,0,0,295,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,292,0,0],[0,0,0,0,0,0,511,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,388,456,456,32,33,0,34,0,0,0,392,0,0,37,0],[0,0,0,0,459,101,101,32,33,0,0,0,0,0,459,0,0,0,0],[0,0,0,512,513,514,515,32,33,0,34,0,0,516,517,0,0,37,0],[0,457,0,518,0,203,203,32,33,0,34,0,0,0,99,0,457,0,0],[0,457,0,0,0,201,519,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,520,513,521,522,32,33,0,34,0,0,523,517,0,0,37,0],[0,0,0,0,0,0,0,315,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,312,0,0],[0,0,0,0,0,0,524,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,525,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,527,0,0,0,40,528,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,468,529,0,0,0,0],[0,0,0,464,465,466,526,8,9,0,10,0,0,468,469,0,0,16,0],[0,0,0,464,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,530,64,0,0,40,528,0,9,0,10,0,0,0,42,0,530,0,0],[0,407,0,0,0,121,121,0,9,0,10,0,0,0,42,0,407,0,0],[0,407,0,470,0,121,121,0,9,0,10,0,0,0,42,0,407,0,0],[0,0,0,525,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,475,529,0,0,0,0],[0,0,0,472,465,473,526,8,9,0,10,0,0,475,469,0,0,16,0],[0,0,0,472,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,40,0,0],[0,0,0,0,415,478,478,57,58,0,59,0,0,0,419,0,0,62,0],[0,0,0,0,481,141,141,57,58,0,0,0,0,0,481,0,0,0,0],[0,0,0,531,532,533,534,57,58,0,59,0,0,535,536,0,0,62,0],[0,479,0,537,0,248,248,57,58,0,59,0,0,0,139,0,479,0,0],[0,479,0,0,0,246,538,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,539,532,540,541,57,58,0,59,0,0,542,536,0,0,62,0],[0,0,0,0,0,0,0,353,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,350,0,0],[0,0,0,0,0,0,543,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,361,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,358,0,0],[0,0,0,0,0,544,544,442,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,545,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,491,492,493,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,492,492,494,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,546,546,494,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,547,546,546,494,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,548,549,368,550,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,274,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,161,0,0,0,0,498,0,0,0,0,0],[0,0,0,495,0,496,368,0,161,0,162,0,0,498,0,0,0,0,0],[0,0,0,495,0,368,368,0,161,0,162,0,0,0,0,0,0,0,0],[0,0,0,551,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,553,0,0,0,76,554,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,503,555,0,0,0,0],[0,0,0,499,500,501,552,22,23,0,24,0,0,503,504,0,0,27,0],[0,0,0,499,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,556,90,0,0,76,554,0,23,0,24,0,0,0,78,0,556,0,0],[0,448,0,0,0,175,175,0,23,0,24,0,0,0,78,0,448,0,0],[0,448,0,505,0,175,175,0,23,0,24,0,0,0,78,0,448,0,0],[0,0,0,551,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,510,555,0,0,0,0],[0,0,0,507,500,508,552,22,23,0,24,0,0,510,504,0,0,27,0],[0,0,0,507,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,76,0,0],[0,0,0,557,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,559,0,0,0,97,560,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,516,561,0,0,0,0],[0,0,0,512,513,514,558,32,33,0,34,0,0,516,517,0,0,37,0],[0,0,0,512,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,562,111,0,0,97,560,0,33,0,34,0,0,0,99,0,562,0,0],[0,457,0,0,0,201,201,0,33,0,34,0,0,0,99,0,457,0,0],[0,457,0,518,0,201,201,0,33,0,34,0,0,0,99,0,457,0,0],[0,0,0,557,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,523,561,0,0,0,0],[0,0,0,520,513,521,558,32,33,0,34,0,0,523,517,0,0,37,0],[0,0,0,520,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,97,0,0],[0,0,0,0,465,526,526,8,9,0,10,0,0,0,469,0,0,16,0],[0,0,0,0,529,44,44,8,9,0,0,0,0,0,529,0,0,0,0],[0,0,0,563,66,564,565,8,9,0,10,0,0,566,68,0,0,16,0],[0,527,0,567,0,123,123,8,9,0,10,0,0,0,42,0,527,0,0],[0,527,0,0,0,121,568,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,569,66,570,571,8,9,0,10,0,0,572,68,0,0,16,0],[0,0,0,573,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,575,0,0,0,137,576,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,535,577,0,0,0,0],[0,0,0,531,532,533,574,57,58,0,59,0,0,535,536,0,0,62,0],[0,0,0,531,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,578,151,0,0,137,576,0,58,0,59,0,0,0,139,0,578,0,0],[0,479,0,0,0,246,246,0,58,0,59,0,0,0,139,0,479,0,0],[0,479,0,537,0,246,246,0,58,0,59,0,0,0,139,0,479,0,0],[0,0,0,573,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,542,577,0,0,0,0],[0,0,0,539,532,540,574,57,58,0,59,0,0,542,536,0,0,62,0],[0,0,0,539,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,137,0,0],[0,0,0,0,0,0,0,442,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,439,0,0],[0,0,0,0,0,579,579,494,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,580,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,549,368,550,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,0,368,368,0,161,0,162,0,0,0,362,0,0,0,0],[0,0,0,0,581,0,0,0,161,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,500,552,552,22,23,0,24,0,0,0,504,0,0,27,0],[0,0,0,0,555,80,80,22,23,0,0,0,0,0,555,0,0,0,0],[0,0,0,582,91,583,584,22,23,0,24,0,0,585,93,0,0,27,0],[0,553,0,586,0,177,177,22,23,0,24,0,0,0,78,0,553,0,0],[0,553,0,0,0,175,587,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,588,91,589,590,22,23,0,24,0,0,591,93,0,0,27,0],[0,0,0,0,513,558,558,32,33,0,34,0,0,0,517,0,0,37,0],[0,0,0,0,561,101,101,32,33,0,0,0,0,0,561,0,0,0,0],[0,0,0,592,112,593,594,32,33,0,34,0,0,595,114,0,0,37,0],[0,559,0,596,0,203,203,32,33,0,34,0,0,0,99,0,559,0,0],[0,559,0,0,0,201,597,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,598,112,599,600,32,33,0,34,0,0,601,114,0,0,37,0],[0,0,0,602,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,566,165,0,0,0,0],[0,0,0,563,66,564,67,8,9,0,10,0,0,566,68,0,0,16,0],[0,0,0,563,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,527,0,0,0,121,121,0,9,0,10,0,0,0,42,0,527,0,0],[0,527,0,567,0,121,121,0,9,0,10,0,0,0,42,0,527,0,0],[0,0,0,602,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,165,44,44,8,9,0,0,0,0,572,165,0,0,0,0],[0,0,0,569,66,570,67,8,9,0,10,0,0,572,68,0,0,16,0],[0,0,0,569,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,0,532,574,574,57,58,0,59,0,0,0,536,0,0,62,0],[0,0,0,0,577,141,141,57,58,0,0,0,0,0,577,0,0,0,0],[0,0,0,603,152,604,605,57,58,0,59,0,0,606,154,0,0,62,0],[0,575,0,607,0,248,248,57,58,0,59,0,0,0,139,0,575,0,0],[0,575,0,0,0,246,608,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,609,152,610,611,57,58,0,59,0,0,612,154,0,0,62,0],[0,0,0,0,0,0,0,494,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,491,0,0],[0,0,0,0,0,0,613,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,614,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,585,194,0,0,0,0],[0,0,0,582,91,583,92,22,23,0,24,0,0,585,93,0,0,27,0],[0,0,0,582,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,553,0,0,0,175,175,0,23,0,24,0,0,0,78,0,553,0,0],[0,553,0,586,0,175,175,0,23,0,24,0,0,0,78,0,553,0,0],[0,0,0,614,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,194,80,80,22,23,0,0,0,0,591,194,0,0,0,0],[0,0,0,588,91,589,92,22,23,0,24,0,0,591,93,0,0,27,0],[0,0,0,588,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,615,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,595,220,0,0,0,0],[0,0,0,592,112,593,113,32,33,0,34,0,0,595,114,0,0,37,0],[0,0,0,592,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,559,0,0,0,201,201,0,33,0,34,0,0,0,99,0,559,0,0],[0,559,0,596,0,201,201,0,33,0,34,0,0,0,99,0,559,0,0],[0,0,0,615,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,220,101,101,32,33,0,0,0,0,601,220,0,0,0,0],[0,0,0,598,112,599,113,32,33,0,34,0,0,601,114,0,0,37,0],[0,0,0,598,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,66,67,67,8,9,0,10,0,0,0,68,0,0,16,0],[0,0,0,616,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,606,265,0,0,0,0],[0,0,0,603,152,604,153,57,58,0,59,0,0,606,154,0,0,62,0],[0,0,0,603,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,575,0,0,0,246,246,0,58,0,59,0,0,0,139,0,575,0,0],[0,575,0,607,0,246,246,0,58,0,59,0,0,0,139,0,575,0,0],[0,0,0,616,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,265,141,141,57,58,0,0,0,0,612,265,0,0,0,0],[0,0,0,609,152,610,153,57,58,0,59,0,0,612,154,0,0,62,0],[0,0,0,609,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,549,0,0],[0,0,0,0,91,92,92,22,23,0,24,0,0,0,93,0,0,27,0],[0,0,0,0,112,113,113,32,33,0,34,0,0,0,114,0,0,37,0],[0,0,0,0,152,153,153,57,58,0,59,0,0,0,154,0,0,62,0]],\"accepting\":[false,true,true,true,true,true,false,false,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,false,false,true,true,true,true,true,true,true,true,true,true,false,true,true,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,false,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,true,true,true,false,true,false,true,true,false,false,true,true,true,true,true,true,true,false,true,true,false,true,true,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,true,false,true,false,true,true,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,false,true,false,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,true,true,true,false,true,true,false,false,false,false,true,true,false,false,true,true,true,false,true,true,false,false,true,false,true,true,false,true,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,true,true,false,false,false,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,true,false,true,false,true,true,false,false,true,true,false,false,true,true,true,false,true,false,true,true,true,true,false,false,false,true,false,true,true,true,true,false,false,false,true,true,false,true,true,true,true,true,true,false,true,true,false,true,false,true,true,true,true,false,false,false,false,false,false,false,true,true,false,false,true,true,false,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,true,true,false,true,true,true,true,true,true,false,true,true,false,true,false,true,true,true,true,true,true,false,true,true,true,true,true,true,false,true,true,false,false,false,false,false,true,true,false,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,true,true,true,false,true,true,true,false,true,true,true,true,false,false,false,true,false,true,true,true,true,true,false,true,true,true,false,true,true,true,true,true,false,true,true,true,true,false,true,true,true,true,true,false,true,true,false,true,true,true],\"tags\":[[],[\"broken_cluster\"],[\"consonant_syllable\"],[\"vowel_syllable\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"standalone_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"consonant_syllable\"],[\"broken_cluster\"],[\"symbol_cluster\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"symbol_cluster\"],[],[\"symbol_cluster\"],[\"symbol_cluster\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"symbol_cluster\"],[\"symbol_cluster\"],[\"symbol_cluster\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[\"broken_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"broken_cluster\"],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"broken_cluster\"],[\"symbol_cluster\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[],[],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[],[],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[],[],[\"broken_cluster\"],[],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[],[],[],[\"consonant_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[],[],[],[\"vowel_syllable\"],[],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[],[],[\"standalone_cluster\"],[],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[],[],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[],[],[],[],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[],[],[],[\"consonant_syllable\",\"broken_cluster\"],[\"consonant_syllable\",\"broken_cluster\"],[],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[],[],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"consonant_syllable\"],[],[\"consonant_syllable\"],[\"consonant_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"vowel_syllable\"],[],[\"vowel_syllable\"],[\"vowel_syllable\"],[\"broken_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"standalone_cluster\"],[\"standalone_cluster\"],[],[\"consonant_syllable\"],[\"vowel_syllable\"],[\"standalone_cluster\"]]}");
var NE = {};
NE = JSON.parse("{\"categories\":[\"O\",\"IND\",\"S\",\"GB\",\"B\",\"FM\",\"CGJ\",\"VMAbv\",\"VMPst\",\"VAbv\",\"VPst\",\"CMBlw\",\"VPre\",\"VBlw\",\"H\",\"VMBlw\",\"CMAbv\",\"MBlw\",\"CS\",\"R\",\"SUB\",\"MPst\",\"MPre\",\"FAbv\",\"FPst\",\"FBlw\",\"null\",\"SMAbv\",\"SMBlw\",\"VMPre\",\"ZWNJ\",\"ZWJ\",\"WJ\",\"M\",\"VS\",\"N\",\"HN\",\"MAbv\"],\"decompositions\":{\"2507\":[2503,2494],\"2508\":[2503,2519],\"2888\":[2887,2902],\"2891\":[2887,2878],\"2892\":[2887,2903],\"3018\":[3014,3006],\"3019\":[3015,3006],\"3020\":[3014,3031],\"3144\":[3142,3158],\"3264\":[3263,3285],\"3271\":[3270,3285],\"3272\":[3270,3286],\"3274\":[3270,3266],\"3275\":[3270,3266,3285],\"3402\":[3398,3390],\"3403\":[3399,3390],\"3404\":[3398,3415],\"3546\":[3545,3530],\"3548\":[3545,3535],\"3549\":[3545,3535,3530],\"3550\":[3545,3551],\"3635\":[3661,3634],\"3763\":[3789,3762],\"3955\":[3953,3954],\"3957\":[3953,3956],\"3958\":[4018,3968],\"3959\":[4018,3953,3968],\"3960\":[4019,3968],\"3961\":[4019,3953,3968],\"3969\":[3953,3968],\"6971\":[6970,6965],\"6973\":[6972,6965],\"6976\":[6974,6965],\"6977\":[6975,6965],\"6979\":[6978,6965],\"69934\":[69937,69927],\"69935\":[69938,69927],\"70475\":[70471,70462],\"70476\":[70471,70487],\"70843\":[70841,70842],\"70844\":[70841,70832],\"70846\":[70841,70845],\"71098\":[71096,71087],\"71099\":[71097,71087]},\"stateTable\":[[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[2,2,3,4,4,5,0,6,7,8,9,10,11,12,13,14,15,16,0,17,18,11,19,20,21,22,0,0,0,23,0,0,2,0,0,24,0,25],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,26,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,28,0,0,0,0,0,27,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,39,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,39,0,0,47],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,7,0,0,0,0,0,0,0,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,0,0,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,9,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,10,11,12,13,14,0,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,9,0,0,12,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,18,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,10,11,12,13,14,15,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,0,0,0,0,11,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,4,4,5,0,6,7,8,9,10,11,12,13,14,15,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,48,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,49,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,16,0,0,0,11,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,20,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,21,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,21,22,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,0,0,0,0,0,0,14,0,0,0,0,0,0,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,50,0,51,0],[0,0,0,0,0,5,0,6,7,8,9,0,11,12,0,14,0,16,0,0,0,11,0,20,21,22,0,0,0,23,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,27,28,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,28,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,31,0,0,0,0,0,0,0,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,0,0,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,33,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,0,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,33,0,0,36,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,41,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,34,35,36,37,38,39,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,0,0,0,0,35,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,52,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,53,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,40,0,0,0,35,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,43,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,44,0,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,44,45,0,0,0,0,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,0,0,0,0,0,0,38,0,0,0,0,0,0,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,29,0,30,31,32,33,0,35,36,0,38,0,40,0,0,0,35,0,43,44,45,0,0,0,46,0,0,0,0,0,0,0,0],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,0,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,5,0,6,7,8,9,48,11,12,13,14,48,16,0,0,18,11,19,20,21,22,0,0,0,23,0,0,0,0,0,0,0,25],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,51,0],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,54,0,0],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,0,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,29,0,30,31,32,33,52,35,36,37,38,52,40,0,0,41,35,42,43,44,45,0,0,0,46,0,0,0,0,0,0,0,47],[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,50,0,51,0]],\"accepting\":[false,true,true,true,true,true,true,true,true,true,true,true,true,false,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true,true],\"tags\":[[],[\"broken_cluster\"],[\"independent_cluster\"],[\"symbol_cluster\"],[\"standard_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"numeral_cluster\"],[\"broken_cluster\"],[\"independent_cluster\"],[\"symbol_cluster\"],[\"symbol_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"virama_terminated_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"broken_cluster\"],[\"broken_cluster\"],[\"numeral_cluster\"],[\"number_joiner_terminated_cluster\"],[\"standard_cluster\"],[\"standard_cluster\"],[\"numeral_cluster\"]]}");
var PE = {
	X: 1,
	C: 2,
	V: 4,
	N: 8,
	H: 16,
	ZWNJ: 32,
	ZWJ: 64,
	M: 128,
	SM: 256,
	VD: 512,
	A: 1024,
	Placeholder: 2048,
	Dotted_Circle: 4096,
	RS: 8192,
	Coeng: 16384,
	Repha: 32768,
	Ra: 65536,
	CM: 131072,
	Symbol: 262144
}, FE = {
	Start: 1,
	Ra_To_Become_Reph: 2,
	Pre_M: 4,
	Pre_C: 8,
	Base_C: 16,
	After_Main: 32,
	Above_C: 64,
	Before_Sub: 128,
	Below_C: 256,
	After_Sub: 512,
	Before_Post: 1024,
	Post_C: 2048,
	After_Post: 4096,
	Final_C: 8192,
	SMVD: 16384,
	End: 32768
}, IE = PE.C | PE.Ra | PE.CM | PE.V | PE.Placeholder | PE.Dotted_Circle, LE = PE.ZWJ | PE.ZWNJ, RE = PE.H | PE.Coeng, zE = {
	Default: {
		hasOldSpec: !1,
		virama: 0,
		basePos: "Last",
		rephPos: FE.Before_Post,
		rephMode: "Implicit",
		blwfMode: "Pre_And_Post"
	},
	Devanagari: {
		hasOldSpec: !0,
		virama: 2381,
		basePos: "Last",
		rephPos: FE.Before_Post,
		rephMode: "Implicit",
		blwfMode: "Pre_And_Post"
	},
	Bengali: {
		hasOldSpec: !0,
		virama: 2509,
		basePos: "Last",
		rephPos: FE.After_Sub,
		rephMode: "Implicit",
		blwfMode: "Pre_And_Post"
	},
	Gurmukhi: {
		hasOldSpec: !0,
		virama: 2637,
		basePos: "Last",
		rephPos: FE.Before_Sub,
		rephMode: "Implicit",
		blwfMode: "Pre_And_Post"
	},
	Gujarati: {
		hasOldSpec: !0,
		virama: 2765,
		basePos: "Last",
		rephPos: FE.Before_Post,
		rephMode: "Implicit",
		blwfMode: "Pre_And_Post"
	},
	Oriya: {
		hasOldSpec: !0,
		virama: 2893,
		basePos: "Last",
		rephPos: FE.After_Main,
		rephMode: "Implicit",
		blwfMode: "Pre_And_Post"
	},
	Tamil: {
		hasOldSpec: !0,
		virama: 3021,
		basePos: "Last",
		rephPos: FE.After_Post,
		rephMode: "Implicit",
		blwfMode: "Pre_And_Post"
	},
	Telugu: {
		hasOldSpec: !0,
		virama: 3149,
		basePos: "Last",
		rephPos: FE.After_Post,
		rephMode: "Explicit",
		blwfMode: "Post_Only"
	},
	Kannada: {
		hasOldSpec: !0,
		virama: 3277,
		basePos: "Last",
		rephPos: FE.After_Post,
		rephMode: "Implicit",
		blwfMode: "Post_Only"
	},
	Malayalam: {
		hasOldSpec: !0,
		virama: 3405,
		basePos: "Last",
		rephPos: FE.After_Main,
		rephMode: "Log_Repha",
		blwfMode: "Pre_And_Post"
	},
	Khmer: {
		hasOldSpec: !1,
		virama: 6098,
		basePos: "First",
		rephPos: FE.Ra_To_Become_Reph,
		rephMode: "Vis_Repha",
		blwfMode: "Pre_And_Post"
	}
}, BE = {
	6078: [6081, 6078],
	6079: [6081, 6079],
	6080: [6081, 6080],
	6084: [6081, 6084],
	6085: [6081, 6085]
}, { decompositions: VE } = /*@__PURE__*/ Ob(NE), HE = new Wy.default(Dw("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")), UE = new Cb.default(/*@__PURE__*/ Ob(ME)), WE = class extends TT {
	static planFeatures(e) {
		e.addStage(JE), e.addStage(["locl", "ccmp"]), e.addStage(eD), e.addStage("nukt"), e.addStage("akhn"), e.addStage("rphf", !1), e.addStage("rkrf"), e.addStage("pref", !1), e.addStage("blwf", !1), e.addStage("abvf", !1), e.addStage("half", !1), e.addStage("pstf", !1), e.addStage("vatu"), e.addStage("cjct"), e.addStage("cfar", !1), e.addStage(tD), e.addStage({
			local: ["init"],
			global: [
				"pres",
				"abvs",
				"blws",
				"psts",
				"haln",
				"dist",
				"abvm",
				"blwm",
				"calt",
				"clig"
			]
		}), e.unicodeScript = Pw(e.script), e.indicConfig = zE[e.unicodeScript] || zE.Default, e.isOldSpec = e.indicConfig.hasOldSpec && e.script[e.script.length - 1] !== "2";
	}
	static assignFeatures(e, t) {
		for (let n = t.length - 1; n >= 0; n--) {
			let r = t[n].codePoints[0], i = BE[r] || VE[r];
			if (i) {
				let r = i.map((r) => {
					let i = e.font.glyphForCodePoint(r);
					return new UT(e.font, i.id, [r], t[n].features);
				});
				t.splice(n, 1, ...r);
			}
		}
	}
};
zy(WE, "zeroMarkWidths", "NONE");
function GE(e) {
	return HE.get(e.codePoints[0]) >> 8;
}
function KE(e) {
	return 1 << (HE.get(e.codePoints[0]) & 255);
}
var qE = class {
	constructor(e, t, n, r) {
		this.category = e, this.position = t, this.syllableType = n, this.syllable = r;
	}
};
function JE(e, t) {
	let n = 0, r = 0;
	for (let [e, i, a] of UE.match(t.map(GE))) {
		if (e > r) {
			++n;
			for (let i = r; i < e; i++) t[i].shaperInfo = new qE(PE.X, FE.End, "non_indic_cluster", n);
		}
		++n;
		for (let r = e; r <= i; r++) t[r].shaperInfo = new qE(1 << GE(t[r]), KE(t[r]), a[0], n);
		r = i + 1;
	}
	if (r < t.length) {
		++n;
		for (let e = r; e < t.length; e++) t[e].shaperInfo = new qE(PE.X, FE.End, "non_indic_cluster", n);
	}
}
function YE(e) {
	return e.shaperInfo.category & IE;
}
function XE(e) {
	return e.shaperInfo.category & LE;
}
function ZE(e) {
	return e.shaperInfo.category & RE;
}
function QE(e, t) {
	for (let n of e) n.features = { [t]: !0 };
	return e[0]._font._layoutEngine.engine.GSUBProcessor.applyFeatures([t], e), e.length === 1;
}
function $E(e, t, n) {
	let r = [
		n,
		t,
		n
	];
	return QE(r.slice(0, 2), "blwf") || QE(r.slice(1, 3), "blwf") ? FE.Below_C : QE(r.slice(0, 2), "pstf") || QE(r.slice(1, 3), "pstf") || QE(r.slice(0, 2), "pref") || QE(r.slice(1, 3), "pref") ? FE.Post_C : FE.Base_C;
}
function eD(e, t, n) {
	let r = n.indicConfig, i = e._layoutEngine.engine.GSUBProcessor.features, a = e.glyphForCodePoint(9676).id, o = e.glyphForCodePoint(r.virama).id;
	if (o) {
		let n = new UT(e, o, [r.virama]);
		for (let r = 0; r < t.length; r++) t[r].shaperInfo.position === FE.Base_C && (t[r].shaperInfo.position = $E(e, t[r].copy(), n));
	}
	for (let o = 0, s = nD(t, 0); o < t.length; o = s, s = nD(t, o)) {
		let { category: c, syllableType: l } = t[o].shaperInfo;
		if (l === "symbol_cluster" || l === "non_indic_cluster") continue;
		if (l === "broken_cluster" && a) {
			let n = new UT(e, a, [9676]);
			n.shaperInfo = new qE(1 << GE(n), KE(n), t[o].shaperInfo.syllableType, t[o].shaperInfo.syllable);
			let r = o;
			for (; r < s && t[r].shaperInfo.category === PE.Repha;) r++;
			t.splice(r++, 0, n), s++;
		}
		let u = s, d = o, f = !1;
		if (r.rephPos !== FE.Ra_To_Become_Reph && i.rphf && o + 3 <= s && (r.rephMode === "Implicit" && !XE(t[o + 2]) || r.rephMode === "Explicit" && t[o + 2].shaperInfo.category === PE.ZWJ)) {
			let e = [
				t[o].copy(),
				t[o + 1].copy(),
				t[o + 2].copy()
			];
			if (QE(e.slice(0, 2), "rphf") || r.rephMode === "Explicit" && QE(e, "rphf")) {
				for (d += 2; d < s && XE(t[d]);) d++;
				u = o, f = !0;
			}
		} else if (r.rephMode === "Log_Repha" && t[o].shaperInfo.category === PE.Repha) {
			for (d++; d < s && XE(t[d]);) d++;
			u = o, f = !0;
		}
		switch (r.basePos) {
			case "Last": {
				let e = s, n = !1;
				do {
					let r = t[--e].shaperInfo;
					if (YE(t[e])) {
						if (r.position !== FE.Below_C && (r.position !== FE.Post_C || n)) {
							u = e;
							break;
						}
						r.position === FE.Below_C && (n = !0), u = e;
					} else if (o < e && r.category === PE.ZWJ && t[e - 1].shaperInfo.category === PE.H) break;
				} while (e > d);
				break;
			}
			case "First":
				u = o;
				for (let e = u + 1; e < s; e++) YE(t[e]) && (t[e].shaperInfo.position = FE.Below_C);
		}
		f && u === o && d - u <= 2 && (f = !1);
		for (let e = o; e < u; e++) {
			let n = t[e].shaperInfo;
			n.position = Math.min(FE.Pre_C, n.position);
		}
		u < s && (t[u].shaperInfo.position = FE.Base_C);
		for (let e = u + 1; e < s; e++) if (t[e].shaperInfo.category === PE.M) {
			for (let n = e + 1; n < s; n++) if (YE(t[n])) {
				t[n].shaperInfo.position = FE.Final_C;
				break;
			}
			break;
		}
		if (f && (t[o].shaperInfo.position = FE.Ra_To_Become_Reph), n.isOldSpec) {
			let e = n.unicodeScript !== "Malayalam";
			for (let n = u + 1; n < s; n++) if (t[n].shaperInfo.category === PE.H) {
				let r;
				for (r = s - 1; r > n && !(YE(t[r]) || e && t[r].shaperInfo.category === PE.H); r--);
				if (t[r].shaperInfo.category !== PE.H && r > n) {
					let e = t[n];
					t.splice(n, 0, ...t.splice(n + 1, r - n)), t[r] = e;
				}
				break;
			}
		}
		let p = FE.Start;
		for (let e = o; e < s; e++) {
			let n = t[e].shaperInfo;
			if (n.category & (LE | PE.N | PE.RS | PE.CM | RE & n.category)) {
				if (n.position = p, n.category === PE.H && n.position === FE.Pre_M) {
					for (let r = e; r > o; r--) if (t[r - 1].shaperInfo.position !== FE.Pre_M) {
						n.position = t[r - 1].shaperInfo.position;
						break;
					}
				}
			} else n.position !== FE.SMVD && (p = n.position);
		}
		let m = u;
		for (let e = u + 1; e < s; e++) if (YE(t[e])) {
			for (let n = m + 1; n < e; n++) t[n].shaperInfo.position < FE.SMVD && (t[n].shaperInfo.position = t[e].shaperInfo.position);
			m = e;
		} else t[e].shaperInfo.category === PE.M && (m = e);
		let h = t.slice(o, s);
		h.sort((e, t) => e.shaperInfo.position - t.shaperInfo.position), t.splice(o, h.length, ...h);
		for (let e = o; e < s; e++) if (t[e].shaperInfo.position === FE.Base_C) {
			u = e;
			break;
		}
		for (let e = o; e < s && t[e].shaperInfo.position === FE.Ra_To_Become_Reph; e++) t[e].features.rphf = !0;
		let g = !n.isOldSpec && r.blwfMode === "Pre_And_Post";
		for (let e = o; e < u; e++) t[e].features.half = !0, g && (t[e].features.blwf = !0);
		for (let e = u + 1; e < s; e++) t[e].features.abvf = !0, t[e].features.pstf = !0, t[e].features.blwf = !0;
		if (n.isOldSpec && n.unicodeScript === "Devanagari") for (let e = o; e + 1 < u; e++) t[e].shaperInfo.category === PE.Ra && t[e + 1].shaperInfo.category === PE.H && (e + 1 === u || t[e + 2].shaperInfo.category === PE.ZWJ) && (t[e].features.blwf = !0, t[e + 1].features.blwf = !0);
		if (i.pref && u + 2 < s) {
			for (let e = u + 1; e + 2 - 1 < s; e++) if (QE([t[e].copy(), t[e + 1].copy()], "pref")) {
				for (let n = 0; n < 2; n++) t[e++].features.pref = !0;
				if (i.cfar) for (; e < s; e++) t[e].features.cfar = !0;
				break;
			}
		}
		for (let e = o + 1; e < s; e++) if (XE(t[e])) {
			let n = t[e].shaperInfo.category === PE.ZWNJ, r = e;
			do
				r--, n && delete t[r].features.half;
			while (r > o && !YE(t[r]));
		}
	}
}
function tD(e, t, n) {
	let r = n.indicConfig, i = e._layoutEngine.engine.GSUBProcessor.features;
	for (let e = 0, a = nD(t, 0); e < t.length; e = a, a = nD(t, e)) {
		let o = !!i.pref, s = e;
		for (; s < a; s++) if (t[s].shaperInfo.position >= FE.Base_C) {
			if (o && s + 1 < a) {
				for (let e = s + 1; e < a; e++) if (t[e].features.pref) {
					if (!(t[e].substituted && t[e].isLigated && !t[e].isMultiplied)) {
						for (s = e; s < a && ZE(t[s]);) s++;
						t[s].shaperInfo.position = FE.BASE_C, o = !1;
					}
					break;
				}
			}
			if (n.unicodeScript === "Malayalam") for (let e = s + 1; e < a; e++) {
				for (; e < a && XE(t[e]);) e++;
				if (e === a || !ZE(t[e])) break;
				for (e++; e < a && XE(t[e]);) e++;
				e < a && YE(t[e]) && t[e].shaperInfo.position === FE.Below_C && (s = e, t[s].shaperInfo.position = FE.Base_C);
			}
			e < s && t[s].shaperInfo.position > FE.Base_C && s--;
			break;
		}
		if (s === a && e < s && t[s - 1].shaperInfo.category === PE.ZWJ && s--, s < a) for (; e < s && t[s].shaperInfo.category & (PE.N | RE);) s--;
		if (e + 1 < a && e < s) {
			let r = s === a ? s - 2 : s - 1;
			if (n.unicodeScript !== "Malayalam" && n.unicodeScript !== "Tamil") {
				for (; r > e && !(t[r].shaperInfo.category & (PE.M | RE));) r--;
				ZE(t[r]) && t[r].shaperInfo.position !== FE.Pre_M ? r + 1 < a && XE(t[r + 1]) && r++ : r = e;
			}
			if (e < r && t[r].shaperInfo.position !== FE.Pre_M) {
				for (let n = r; n > e; n--) if (t[n - 1].shaperInfo.position === FE.Pre_M) {
					let e = n - 1;
					e < s && s <= r && s--;
					let i = t[e];
					t.splice(e, 0, ...t.splice(e + 1, r - e)), t[r] = i, r--;
				}
			}
		}
		if (e + 1 < a && t[e].shaperInfo.position === FE.Ra_To_Become_Reph && t[e].shaperInfo.category === PE.Repha !== (t[e].isLigated && !t[e].isMultiplied)) {
			let n, i = r.rephPos, o = !1;
			if (i !== FE.After_Post) {
				for (n = e + 1; n < s && !ZE(t[n]);) n++;
				if (n < s && ZE(t[n]) && (n + 1 < s && XE(t[n + 1]) && n++, o = !0), !o && i === FE.After_Main) {
					for (n = s; n + 1 < a && t[n + 1].shaperInfo.position <= FE.After_Main;) n++;
					o = n < a;
				}
				if (!o && i === FE.After_Sub) {
					for (n = s; n + 1 < a && !(t[n + 1].shaperInfo.position & (FE.Post_C | FE.After_Post | FE.SMVD));) n++;
					o = n < a;
				}
			}
			if (!o) {
				for (n = e + 1; n < s && !ZE(t[n]);) n++;
				n < s && ZE(t[n]) && (n + 1 < s && XE(t[n + 1]) && n++, o = !0);
			}
			if (!o) {
				for (n = a - 1; n > e && t[n].shaperInfo.position === FE.SMVD;) n--;
				if (ZE(t[n])) for (let e = s + 1; e < n; e++) t[e].shaperInfo.category === PE.M && n--;
			}
			let c = t[e];
			t.splice(e, 0, ...t.splice(e + 1, n - e)), t[n] = c, e < s && s <= n && s--;
		}
		if (o && s + 1 < a) {
			for (let r = s + 1; r < a; r++) if (t[r].features.pref) {
				if (t[r].isLigated && !t[r].isMultiplied) {
					let i = s;
					if (n.unicodeScript !== "Malayalam" && n.unicodeScript !== "Tamil") {
						for (; i > e && !(t[i - 1].shaperInfo.category & (PE.M | RE));) i--;
						if (i > e && t[i - 1].shaperInfo.category === PE.M) {
							let e = r;
							for (let n = s + 1; n < e; n++) if (t[n].shaperInfo.category === PE.M) {
								i--;
								break;
							}
						}
					}
					i > e && ZE(t[i - 1]) && i < a && XE(t[i]) && i++;
					let o = r, c = t[o];
					t.splice(i + 1, 0, ...t.splice(i, o - i)), t[i] = c, i <= s && s < o && s++;
				}
				break;
			}
		}
		t[e].shaperInfo.position === FE.Pre_M && (!e || !/Cf|Mn/.test($y(t[e - 1].codePoints[0]))) && (t[e].features.init = !0);
	}
}
function nD(e, t) {
	if (t >= e.length) return t;
	let n = e[t].shaperInfo.syllable;
	for (; ++t < e.length && e[t].shaperInfo.syllable === n;);
	return t;
}
var { categories: rD, decompositions: iD } = /*@__PURE__*/ Ob(NE), aD = new Wy.default(Dw("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")), oD = new Cb.default(/*@__PURE__*/ Ob(NE)), sD = class extends TT {
	static planFeatures(e) {
		e.addStage(uD), e.addStage([
			"locl",
			"ccmp",
			"nukt",
			"akhn"
		]), e.addStage(dD), e.addStage(["rphf"], !1), e.addStage(fD), e.addStage(dD), e.addStage(["pref"]), e.addStage(pD), e.addStage([
			"rkrf",
			"abvf",
			"blwf",
			"half",
			"pstf",
			"vatu",
			"cjct"
		]), e.addStage(mD), e.addStage([
			"abvs",
			"blws",
			"pres",
			"psts",
			"dist",
			"abvm",
			"blwm"
		]);
	}
	static assignFeatures(e, t) {
		for (let n = t.length - 1; n >= 0; n--) {
			let r = t[n].codePoints[0];
			if (iD[r]) {
				let i = iD[r].map((r) => {
					let i = e.font.glyphForCodePoint(r);
					return new UT(e.font, i.id, [r], t[n].features);
				});
				t.splice(n, 1, ...i);
			}
		}
	}
};
zy(sD, "zeroMarkWidths", "BEFORE_GPOS");
function cD(e) {
	return aD.get(e.codePoints[0]);
}
var lD = class {
	constructor(e, t, n) {
		this.category = e, this.syllableType = t, this.syllable = n;
	}
};
function uD(e, t) {
	let n = 0;
	for (let [e, r, i] of oD.match(t.map(cD))) {
		++n;
		for (let a = e; a <= r; a++) t[a].shaperInfo = new lD(rD[cD(t[a])], i[0], n);
		let a = t[e].shaperInfo.category === "R" ? 1 : Math.min(3, r - e);
		for (let n = e; n < e + a; n++) t[n].features.rphf = !0;
	}
}
function dD(e, t) {
	for (let e of t) e.substituted = !1;
}
function fD(e, t) {
	for (let e of t) e.substituted && e.features.rphf && (e.shaperInfo.category = "R");
}
function pD(e, t) {
	for (let e of t) e.substituted && (e.shaperInfo.category = "VPre");
}
function mD(e, t) {
	let n = e.glyphForCodePoint(9676).id;
	for (let r = 0, i = hD(t, 0); r < t.length; r = i, i = hD(t, r)) {
		let a, o, s = t[r].shaperInfo, c = s.syllableType;
		if (!(c !== "virama_terminated_cluster" && c !== "standard_cluster" && c !== "broken_cluster")) {
			if (c === "broken_cluster" && n) {
				let o = new UT(e, n, [9676]);
				for (o.shaperInfo = s, a = r; a < i && t[a].shaperInfo.category === "R"; a++);
				t.splice(++a, 0, o), i++;
			}
			if (s.category === "R" && i - r > 1) {
				for (a = r + 1; a < i; a++) if (s = t[a].shaperInfo, _D(s) || gD(t[a])) {
					gD(t[a]) && a--, t.splice(r, 0, ...t.splice(r + 1, a - r), t[a]);
					break;
				}
			}
			for (a = r, o = i; a < i; a++) s = t[a].shaperInfo, _D(s) || gD(t[a]) ? o = gD(t[a]) ? a + 1 : a : (s.category === "VPre" || s.category === "VMPre") && o < a && t.splice(o, 1, t[a], ...t.splice(o, a - o));
		}
	}
}
function hD(e, t) {
	if (t >= e.length) return t;
	let n = e[t].shaperInfo.syllable;
	for (; ++t < e.length && e[t].shaperInfo.syllable === n;);
	return t;
}
function gD(e) {
	return e.shaperInfo.category === "H" && !e.isLigated;
}
function _D(e) {
	return e.category === "B" || e.category === "GB";
}
var vD = {
	arab: RT,
	mong: RT,
	syrc: RT,
	"nko ": RT,
	phag: RT,
	mand: RT,
	mani: RT,
	phlp: RT,
	hang: WT,
	bng2: WE,
	beng: WE,
	dev2: WE,
	deva: WE,
	gjr2: WE,
	gujr: WE,
	guru: WE,
	gur2: WE,
	knda: WE,
	knd2: WE,
	mlm2: WE,
	mlym: WE,
	ory2: WE,
	orya: WE,
	taml: WE,
	tml2: WE,
	telu: WE,
	tel2: WE,
	khmr: WE,
	bali: sD,
	batk: sD,
	brah: sD,
	bugi: sD,
	buhd: sD,
	cakm: sD,
	cham: sD,
	dupl: sD,
	egyp: sD,
	gran: sD,
	hano: sD,
	java: sD,
	kthi: sD,
	kali: sD,
	khar: sD,
	khoj: sD,
	sind: sD,
	lepc: sD,
	limb: sD,
	mahj: sD,
	mtei: sD,
	modi: sD,
	hmng: sD,
	rjng: sD,
	saur: sD,
	shrd: sD,
	sidd: sD,
	sinh: WE,
	sund: sD,
	sylo: sD,
	tglg: sD,
	tagb: sD,
	tale: sD,
	lana: sD,
	tavt: sD,
	takr: sD,
	tibt: sD,
	tfng: sD,
	tirh: sD,
	latn: TT,
	DFLT: TT
};
function yD(e) {
	Array.isArray(e) || (e = [e]);
	for (let t of e) {
		let e = vD[t];
		if (e) return e;
	}
	return TT;
}
var bD = class extends HT {
	applyLookup(e, t) {
		switch (e) {
			case 1: {
				let e = this.coverageIndex(t.coverage);
				if (e === -1) return !1;
				let n = this.glyphIterator.cur;
				switch (t.version) {
					case 1:
						n.id = n.id + t.deltaGlyphID & 65535;
						break;
					case 2:
						n.id = t.substitute.get(e);
						break;
				}
				return !0;
			}
			case 2: {
				let e = this.coverageIndex(t.coverage);
				if (e !== -1) {
					let n = t.sequences.get(e);
					if (n.length === 0) return this.glyphs.splice(this.glyphIterator.index, 1), !0;
					this.glyphIterator.cur.id = n[0], this.glyphIterator.cur.ligatureComponent = 0;
					let r = this.glyphIterator.cur.features, i = this.glyphIterator.cur, a = n.slice(1).map((e, t) => {
						let n = new UT(this.font, e, void 0, r);
						return n.shaperInfo = i.shaperInfo, n.isLigated = i.isLigated, n.ligatureComponent = t + 1, n.substituted = !0, n.isMultiplied = !0, n;
					});
					return this.glyphs.splice(this.glyphIterator.index + 1, 0, ...a), !0;
				}
				return !1;
			}
			case 3: {
				let e = this.coverageIndex(t.coverage);
				return e === -1 ? !1 : (this.glyphIterator.cur.id = t.alternateSet.get(e)[0], !0);
			}
			case 4: {
				let e = this.coverageIndex(t.coverage);
				if (e === -1) return !1;
				for (let r of t.ligatureSets.get(e)) {
					let e = this.sequenceMatchIndices(1, r.components);
					if (!e) continue;
					let t = this.glyphIterator.cur, i = t.codePoints.slice();
					for (let t of e) i.push(...this.glyphs[t].codePoints);
					let a = new UT(this.font, r.glyph, i, t.features);
					a.shaperInfo = t.shaperInfo, a.isLigated = !0, a.substituted = !0;
					let o = t.isMark;
					for (let t = 0; t < e.length && o; t++) o = this.glyphs[e[t]].isMark;
					a.ligatureID = o ? null : this.ligatureID++;
					let s = t.ligatureID, c = t.codePoints.length, l = c, u = this.glyphIterator.index + 1;
					for (let t of e) {
						if (o) u = t;
						else for (; u < t;) {
							var n = l - c + Math.min(this.glyphs[u].ligatureComponent || 1, c);
							this.glyphs[u].ligatureID = a.ligatureID, this.glyphs[u].ligatureComponent = n, u++;
						}
						s = this.glyphs[u].ligatureID, c = this.glyphs[u].codePoints.length, l += c, u++;
					}
					if (s && !o) for (let e = u; e < this.glyphs.length && this.glyphs[e].ligatureID === s; e++) {
						var n = l - c + Math.min(this.glyphs[e].ligatureComponent || 1, c);
						this.glyphs[e].ligatureComponent = n;
					}
					for (let t = e.length - 1; t >= 0; t--) this.glyphs.splice(e[t], 1);
					return this.glyphs[this.glyphIterator.index] = a, !0;
				}
				return !1;
			}
			case 5: return this.applyContext(t);
			case 6: return this.applyChainingContext(t);
			case 7: return this.applyLookup(t.lookupType, t.extension);
			default: throw Error(`GSUB lookupType ${e} is not supported`);
		}
	}
}, xD = class extends HT {
	applyPositionValue(e, t) {
		let n = this.positions[this.glyphIterator.peekIndex(e)];
		t.xAdvance != null && (n.xAdvance += t.xAdvance), t.yAdvance != null && (n.yAdvance += t.yAdvance), t.xPlacement != null && (n.xOffset += t.xPlacement), t.yPlacement != null && (n.yOffset += t.yPlacement);
		let r = this.font._variationProcessor, i = this.font.GDEF && this.font.GDEF.itemVariationStore;
		r && i && (t.xPlaDevice && (n.xOffset += r.getDelta(i, t.xPlaDevice.a, t.xPlaDevice.b)), t.yPlaDevice && (n.yOffset += r.getDelta(i, t.yPlaDevice.a, t.yPlaDevice.b)), t.xAdvDevice && (n.xAdvance += r.getDelta(i, t.xAdvDevice.a, t.xAdvDevice.b)), t.yAdvDevice && (n.yAdvance += r.getDelta(i, t.yAdvDevice.a, t.yAdvDevice.b)));
	}
	applyLookup(e, t) {
		switch (e) {
			case 1: {
				let e = this.coverageIndex(t.coverage);
				if (e === -1) return !1;
				switch (t.version) {
					case 1:
						this.applyPositionValue(0, t.value);
						break;
					case 2:
						this.applyPositionValue(0, t.values.get(e));
						break;
				}
				return !0;
			}
			case 2: {
				let e = this.glyphIterator.peek();
				if (!e) return !1;
				let r = this.coverageIndex(t.coverage);
				if (r === -1) return !1;
				switch (t.version) {
					case 1:
						let i = t.pairSets.get(r);
						for (let t of i) if (t.secondGlyph === e.id) return this.applyPositionValue(0, t.value1), this.applyPositionValue(1, t.value2), !0;
						return !1;
					case 2:
						let a = this.getClassID(this.glyphIterator.cur.id, t.classDef1), o = this.getClassID(e.id, t.classDef2);
						if (a === -1 || o === -1) return !1;
						var n = t.classRecords.get(a).get(o);
						return this.applyPositionValue(0, n.value1), this.applyPositionValue(1, n.value2), !0;
				}
			}
			case 3: {
				let e = this.glyphIterator.peekIndex(), n = this.glyphs[e];
				if (!n) return !1;
				let r = t.entryExitRecords[this.coverageIndex(t.coverage)];
				if (!r || !r.exitAnchor) return !1;
				let i = t.entryExitRecords[this.coverageIndex(t.coverage, n.id)];
				if (!i || !i.entryAnchor) return !1;
				let a = this.getAnchor(i.entryAnchor), o = this.getAnchor(r.exitAnchor), s = this.positions[this.glyphIterator.index], c = this.positions[e], l;
				switch (this.direction) {
					case "ltr":
						s.xAdvance = o.x + s.xOffset, l = a.x + c.xOffset, c.xAdvance -= l, c.xOffset -= l;
						break;
					case "rtl":
						l = o.x + s.xOffset, s.xAdvance -= l, s.xOffset -= l, c.xAdvance = a.x + c.xOffset;
						break;
				}
				return this.glyphIterator.flags.rightToLeft ? (this.glyphIterator.cur.cursiveAttachment = e, s.yOffset = a.y - o.y) : (n.cursiveAttachment = this.glyphIterator.index, s.yOffset = o.y - a.y), !0;
			}
			case 4: {
				let e = this.coverageIndex(t.markCoverage);
				if (e === -1) return !1;
				let n = this.glyphIterator.index;
				for (; --n >= 0 && (this.glyphs[n].isMark || this.glyphs[n].ligatureComponent > 0););
				if (n < 0) return !1;
				let r = this.coverageIndex(t.baseCoverage, this.glyphs[n].id);
				if (r === -1) return !1;
				let i = t.markArray[e], a = t.baseArray[r][i.class];
				return this.applyAnchor(i, a, n), !0;
			}
			case 5: {
				let e = this.coverageIndex(t.markCoverage);
				if (e === -1) return !1;
				let n = this.glyphIterator.index;
				for (; --n >= 0 && this.glyphs[n].isMark;);
				if (n < 0) return !1;
				let r = this.coverageIndex(t.ligatureCoverage, this.glyphs[n].id);
				if (r === -1) return !1;
				let i = t.ligatureArray[r], a = this.glyphIterator.cur, o = this.glyphs[n], s = o.ligatureID && o.ligatureID === a.ligatureID && a.ligatureComponent > 0 ? Math.min(a.ligatureComponent, o.codePoints.length) - 1 : o.codePoints.length - 1, c = t.markArray[e], l = i[s][c.class];
				return this.applyAnchor(c, l, n), !0;
			}
			case 6: {
				let e = this.coverageIndex(t.mark1Coverage);
				if (e === -1) return !1;
				let n = this.glyphIterator.peekIndex(-1), r = this.glyphs[n];
				if (!r || !r.isMark) return !1;
				let i = this.glyphIterator.cur, a = !1;
				if (i.ligatureID === r.ligatureID ? i.ligatureID ? i.ligatureComponent === r.ligatureComponent && (a = !0) : a = !0 : (i.ligatureID && !i.ligatureComponent || r.ligatureID && !r.ligatureComponent) && (a = !0), !a) return !1;
				let o = this.coverageIndex(t.mark2Coverage, r.id);
				if (o === -1) return !1;
				let s = t.mark1Array[e], c = t.mark2Array[o][s.class];
				return this.applyAnchor(s, c, n), !0;
			}
			case 7: return this.applyContext(t);
			case 8: return this.applyChainingContext(t);
			case 9: return this.applyLookup(t.lookupType, t.extension);
			default: throw Error(`Unsupported GPOS table: ${e}`);
		}
	}
	applyAnchor(e, t, n) {
		let r = this.getAnchor(t), i = this.getAnchor(e.markAnchor);
		this.positions[n];
		let a = this.positions[this.glyphIterator.index];
		a.xOffset = r.x - i.x, a.yOffset = r.y - i.y, this.glyphIterator.cur.markAttachment = n;
	}
	getAnchor(e) {
		let t = e.xCoordinate, n = e.yCoordinate, r = this.font._variationProcessor, i = this.font.GDEF && this.font.GDEF.itemVariationStore;
		return r && i && (e.xDeviceTable && (t += r.getDelta(i, e.xDeviceTable.a, e.xDeviceTable.b)), e.yDeviceTable && (n += r.getDelta(i, e.yDeviceTable.a, e.yDeviceTable.b))), {
			x: t,
			y: n
		};
	}
	applyFeatures(e, t, n) {
		super.applyFeatures(e, t, n);
		for (var r = 0; r < this.glyphs.length; r++) this.fixCursiveAttachment(r);
		this.fixMarkAttachment();
	}
	fixCursiveAttachment(e) {
		let t = this.glyphs[e];
		if (t.cursiveAttachment != null) {
			let n = t.cursiveAttachment;
			t.cursiveAttachment = null, this.fixCursiveAttachment(n), this.positions[e].yOffset += this.positions[n].yOffset;
		}
	}
	fixMarkAttachment() {
		for (let e = 0; e < this.glyphs.length; e++) {
			let t = this.glyphs[e];
			if (t.markAttachment != null) {
				let n = t.markAttachment;
				if (this.positions[e].xOffset += this.positions[n].xOffset, this.positions[e].yOffset += this.positions[n].yOffset, this.direction === "ltr") for (let t = n; t < e; t++) this.positions[e].xOffset -= this.positions[t].xAdvance, this.positions[e].yOffset -= this.positions[t].yAdvance;
				else for (let t = n + 1; t < e + 1; t++) this.positions[e].xOffset += this.positions[t].xAdvance, this.positions[e].yOffset += this.positions[t].yAdvance;
			}
		}
	}
}, SD = class {
	setup(e) {
		this.glyphInfos = e.glyphs.map((e) => new UT(this.font, e.id, [...e.codePoints]));
		let t = null;
		this.GPOSProcessor && (t = this.GPOSProcessor.selectScript(e.script, e.language, e.direction)), this.GSUBProcessor && (t = this.GSUBProcessor.selectScript(e.script, e.language, e.direction)), this.shaper = yD(t), this.plan = new yT(this.font, t, e.direction), this.shaper.plan(this.plan, this.glyphInfos, e.features);
		for (let t in this.plan.allFeatures) e.features[t] = !0;
	}
	substitute(e) {
		this.GSUBProcessor && (this.plan.process(this.GSUBProcessor, this.glyphInfos), e.glyphs = this.glyphInfos.map((e) => this.font.getGlyph(e.id, e.codePoints)));
	}
	position(e) {
		return this.shaper.zeroMarkWidths === "BEFORE_GPOS" && this.zeroMarkAdvances(e.positions), this.GPOSProcessor && this.plan.process(this.GPOSProcessor, this.glyphInfos, e.positions), this.shaper.zeroMarkWidths === "AFTER_GPOS" && this.zeroMarkAdvances(e.positions), e.direction === "rtl" && (e.glyphs.reverse(), e.positions.reverse()), this.GPOSProcessor && this.GPOSProcessor.features;
	}
	zeroMarkAdvances(e) {
		for (let t = 0; t < this.glyphInfos.length; t++) this.glyphInfos[t].isMark && (e[t].xAdvance = 0, e[t].yAdvance = 0);
	}
	cleanup() {
		this.glyphInfos = null, this.plan = null, this.shaper = null;
	}
	getAvailableFeatures(e, t) {
		let n = [];
		return this.GSUBProcessor && (this.GSUBProcessor.selectScript(e, t), n.push(...Object.keys(this.GSUBProcessor.features))), this.GPOSProcessor && (this.GPOSProcessor.selectScript(e, t), n.push(...Object.keys(this.GPOSProcessor.features))), n;
	}
	constructor(e) {
		this.font = e, this.glyphInfos = null, this.plan = null, this.GSUBProcessor = null, this.GPOSProcessor = null, this.fallbackPosition = !0, e.GSUB && (this.GSUBProcessor = new bD(e, e.GSUB)), e.GPOS && (this.GPOSProcessor = new xD(e, e.GPOS));
	}
}, CD = class {
	layout(e, t, n, r, i) {
		if (typeof t == "string" && (i = r, r = n, n = t, t = []), typeof e == "string") {
			n ??= Fw(e);
			var a = this.font.glyphsForString(e);
		} else {
			if (n == null) {
				let t = [];
				for (let n of e) t.push(...n.codePoints);
				n = Iw(t);
			}
			var a = e;
		}
		let o = new zw(a, t, n, r, i);
		return a.length === 0 ? (o.positions = [], o) : (this.engine && this.engine.setup && this.engine.setup(o), this.substitute(o), this.position(o), this.hideDefaultIgnorables(o.glyphs, o.positions), this.engine && this.engine.cleanup && this.engine.cleanup(), o);
	}
	substitute(e) {
		this.engine && this.engine.substitute && this.engine.substitute(e);
	}
	position(e) {
		e.positions = e.glyphs.map((e) => new Bw(e.advanceWidth));
		let t = null;
		this.engine && this.engine.position && (t = this.engine.position(e)), !t && (!this.engine || this.engine.fallbackPosition) && (this.unicodeLayoutEngine ||= new Aw(this.font), this.unicodeLayoutEngine.positionGlyphs(e.glyphs, e.positions)), (!t || !t.kern) && e.features.kern !== !1 && this.font.kern && (this.kernProcessor ||= new kw(this.font), this.kernProcessor.process(e.glyphs, e.positions), e.features.kern = !0);
	}
	hideDefaultIgnorables(e, t) {
		let n = this.font.glyphForCodePoint(32);
		for (let r = 0; r < e.length; r++) this.isDefaultIgnorable(e[r].codePoints[0]) && (e[r] = n, t[r].xAdvance = 0, t[r].yAdvance = 0);
	}
	isDefaultIgnorable(e) {
		let t = e >> 16;
		if (t === 0) switch (e >> 8) {
			case 0: return e === 173;
			case 3: return e === 847;
			case 6: return e === 1564;
			case 23: return 6068 <= e && e <= 6069;
			case 24: return 6155 <= e && e <= 6158;
			case 32: return 8203 <= e && e <= 8207 || 8234 <= e && e <= 8238 || 8288 <= e && e <= 8303;
			case 254: return 65024 <= e && e <= 65039 || e === 65279;
			case 255: return 65520 <= e && e <= 65528;
			default: return !1;
		}
		else switch (t) {
			case 1: return 113824 <= e && e <= 113827 || 119155 <= e && e <= 119162;
			case 14: return 917504 <= e && e <= 921599;
			default: return !1;
		}
	}
	getAvailableFeatures(e, t) {
		let n = [];
		return this.engine && n.push(...this.engine.getAvailableFeatures(e, t)), this.font.kern && n.indexOf("kern") === -1 && n.push("kern"), n;
	}
	stringsForGlyph(e) {
		let t = /* @__PURE__ */ new Set(), n = this.font._cmapProcessor.codePointsForGlyph(e);
		for (let e of n) t.add(String.fromCodePoint(e));
		if (this.engine && this.engine.stringsForGlyph) for (let n of this.engine.stringsForGlyph(e)) t.add(n);
		return Array.from(t);
	}
	constructor(e) {
		this.font = e, this.unicodeLayoutEngine = null, this.kernProcessor = null, this.font.morx ? this.engine = new vT(this.font) : (this.font.GSUB || this.font.GPOS) && (this.engine = new SD(this.font));
	}
}, wD = {
	moveTo: "M",
	lineTo: "L",
	quadraticCurveTo: "Q",
	bezierCurveTo: "C",
	closePath: "Z"
}, TD = class e {
	toFunction() {
		return (e) => {
			this.commands.forEach((t) => e[t.command].apply(e, t.args));
		};
	}
	toSVG() {
		return this.commands.map((e) => {
			let t = e.args.map((e) => Math.round(e * 100) / 100);
			return `${wD[e.command]}${t.join(" ")}`;
		}).join("");
	}
	get cbox() {
		if (!this._cbox) {
			let e = new jw();
			for (let t of this.commands) for (let n = 0; n < t.args.length; n += 2) e.addPoint(t.args[n], t.args[n + 1]);
			this._cbox = Object.freeze(e);
		}
		return this._cbox;
	}
	get bbox() {
		if (this._bbox) return this._bbox;
		let e = new jw(), t = 0, n = 0, r = (e) => (1 - e) ** 3 * f[g] + 3 * (1 - e) ** 2 * e * p[g] + 3 * (1 - e) * e ** 2 * m[g] + e ** 3 * h[g];
		for (let _ of this.commands) switch (_.command) {
			case "moveTo":
			case "lineTo":
				let [v, y] = _.args;
				e.addPoint(v, y), t = v, n = y;
				break;
			case "quadraticCurveTo":
			case "bezierCurveTo":
				if (_.command === "quadraticCurveTo") var [i, a, o, s] = _.args, c = t + 2 / 3 * (i - t), l = n + 2 / 3 * (a - n), u = o + 2 / 3 * (i - o), d = s + 2 / 3 * (a - s);
				else var [c, l, u, d, o, s] = _.args;
				e.addPoint(o, s);
				for (var f = [t, n], p = [c, l], m = [u, d], h = [o, s], g = 0; g <= 1; g++) {
					let t = 6 * f[g] - 12 * p[g] + 6 * m[g], n = -3 * f[g] + 9 * p[g] - 9 * m[g] + 3 * h[g];
					if (_ = 3 * p[g] - 3 * f[g], n === 0) {
						if (t === 0) continue;
						let n = -_ / t;
						0 < n && n < 1 && (g === 0 ? e.addPoint(r(n), e.maxY) : g === 1 && e.addPoint(e.maxX, r(n)));
						continue;
					}
					let i = t ** 2 - 4 * _ * n;
					if (i < 0) continue;
					let a = (-t + Math.sqrt(i)) / (2 * n);
					0 < a && a < 1 && (g === 0 ? e.addPoint(r(a), e.maxY) : g === 1 && e.addPoint(e.maxX, r(a)));
					let o = (-t - Math.sqrt(i)) / (2 * n);
					0 < o && o < 1 && (g === 0 ? e.addPoint(r(o), e.maxY) : g === 1 && e.addPoint(e.maxX, r(o)));
				}
				t = o, n = s;
				break;
		}
		return this._bbox = Object.freeze(e);
	}
	mapPoints(t) {
		let n = new e();
		for (let e of this.commands) {
			let r = [];
			for (let n = 0; n < e.args.length; n += 2) {
				let [i, a] = t(e.args[n], e.args[n + 1]);
				r.push(i, a);
			}
			n[e.command](...r);
		}
		return n;
	}
	transform(e, t, n, r, i, a) {
		return this.mapPoints((o, s) => [e * o + n * s + i, t * o + r * s + a]);
	}
	translate(e, t) {
		return this.transform(1, 0, 0, 1, e, t);
	}
	rotate(e) {
		let t = Math.cos(e), n = Math.sin(e);
		return this.transform(t, n, -n, t, 0, 0);
	}
	scale(e, t = e) {
		return this.transform(e, 0, 0, t, 0, 0);
	}
	constructor() {
		this.commands = [], this._bbox = null, this._cbox = null;
	}
};
for (let e of [
	"moveTo",
	"lineTo",
	"quadraticCurveTo",
	"bezierCurveTo",
	"closePath"
]) TD.prototype[e] = function(...t) {
	return this._bbox = this._cbox = null, this.commands.push({
		command: e,
		args: t
	}), this;
};
var ED = /* @__PURE__ */ ".notdef,.null,nonmarkingreturn,space,exclam,quotedbl,numbersign,dollar,percent,ampersand,quotesingle,parenleft,parenright,asterisk,plus,comma,hyphen,period,slash,zero,one,two,three,four,five,six,seven,eight,nine,colon,semicolon,less,equal,greater,question,at,A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z,bracketleft,backslash,bracketright,asciicircum,underscore,grave,a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,braceleft,bar,braceright,asciitilde,Adieresis,Aring,Ccedilla,Eacute,Ntilde,Odieresis,Udieresis,aacute,agrave,acircumflex,adieresis,atilde,aring,ccedilla,eacute,egrave,ecircumflex,edieresis,iacute,igrave,icircumflex,idieresis,ntilde,oacute,ograve,ocircumflex,odieresis,otilde,uacute,ugrave,ucircumflex,udieresis,dagger,degree,cent,sterling,section,bullet,paragraph,germandbls,registered,copyright,trademark,acute,dieresis,notequal,AE,Oslash,infinity,plusminus,lessequal,greaterequal,yen,mu,partialdiff,summation,product,pi,integral,ordfeminine,ordmasculine,Omega,ae,oslash,questiondown,exclamdown,logicalnot,radical,florin,approxequal,Delta,guillemotleft,guillemotright,ellipsis,nonbreakingspace,Agrave,Atilde,Otilde,OE,oe,endash,emdash,quotedblleft,quotedblright,quoteleft,quoteright,divide,lozenge,ydieresis,Ydieresis,fraction,currency,guilsinglleft,guilsinglright,fi,fl,daggerdbl,periodcentered,quotesinglbase,quotedblbase,perthousand,Acircumflex,Ecircumflex,Aacute,Edieresis,Egrave,Iacute,Icircumflex,Idieresis,Igrave,Oacute,Ocircumflex,apple,Ograve,Uacute,Ucircumflex,Ugrave,dotlessi,circumflex,tilde,macron,breve,dotaccent,ring,cedilla,hungarumlaut,ogonek,caron,Lslash,lslash,Scaron,scaron,Zcaron,zcaron,brokenbar,Eth,eth,Yacute,yacute,Thorn,thorn,minus,multiply,onesuperior,twosuperior,threesuperior,onehalf,onequarter,threequarters,franc,Gbreve,gbreve,Idotaccent,Scedilla,scedilla,Cacute,cacute,Ccaron,ccaron,dcroat".split(","), DD = class {
	_getPath() {
		return new TD();
	}
	_getCBox() {
		return this.path.cbox;
	}
	_getBBox() {
		return this.path.bbox;
	}
	_getTableMetrics(e) {
		if (this.id < e.metrics.length) return e.metrics.get(this.id);
		let t = e.metrics.get(e.metrics.length - 1);
		return {
			advance: t ? t.advance : 0,
			bearing: e.bearings.get(this.id - e.metrics.length) || 0
		};
	}
	_getMetrics(e) {
		if (this._metrics) return this._metrics;
		let { advance: t, bearing: n } = this._getTableMetrics(this._font.hmtx);
		if (this._font.vmtx) var { advance: r, bearing: i } = this._getTableMetrics(this._font.vmtx);
		else {
			let t;
			if (e ?? ({cbox: e} = this), (t = this._font["OS/2"]) && t.version > 0) var r = Math.abs(t.typoAscender - t.typoDescender), i = t.typoAscender - e.maxY;
			else {
				let { hhea: t } = this._font;
				var r = Math.abs(t.ascent - t.descent), i = t.ascent - e.maxY;
			}
		}
		return this._font._variationProcessor && this._font.HVAR && (t += this._font._variationProcessor.getAdvanceAdjustment(this.id, this._font.HVAR)), this._metrics = {
			advanceWidth: t,
			advanceHeight: r,
			leftBearing: n,
			topBearing: i
		};
	}
	get cbox() {
		return this._getCBox();
	}
	get bbox() {
		return this._getBBox();
	}
	get path() {
		return this._getPath();
	}
	getScaledPath(e) {
		let t = 1 / this._font.unitsPerEm * e;
		return this.path.scale(t);
	}
	get advanceWidth() {
		return this._getMetrics().advanceWidth;
	}
	get advanceHeight() {
		return this._getMetrics().advanceHeight;
	}
	get ligatureCaretPositions() {}
	_getName() {
		let { post: e } = this._font;
		if (!e) return null;
		switch (e.version) {
			case 1: return ED[this.id];
			case 2:
				let t = e.glyphNameIndex[this.id];
				return t < ED.length ? ED[t] : e.names[t - ED.length];
			case 2.5: return ED[this.id + e.offsets[this.id]];
			case 4: return String.fromCharCode(e.map[this.id]);
		}
	}
	get name() {
		return this._getName();
	}
	render(e, t) {
		e.save();
		let n = 1 / this._font.head.unitsPerEm * t;
		e.scale(n, n), this.path.toFunction()(e), e.fill(), e.restore();
	}
	constructor(e, t, n) {
		this.id = e, this.codePoints = t, this._font = n, this.isMark = this.codePoints.length > 0 && this.codePoints.every(cb), this.isLigature = this.codePoints.length > 1;
	}
};
By([Fb], DD.prototype, "cbox", null), By([Fb], DD.prototype, "bbox", null), By([Fb], DD.prototype, "path", null), By([Fb], DD.prototype, "advanceWidth", null), By([Fb], DD.prototype, "advanceHeight", null), By([Fb], DD.prototype, "name", null);
var OD = new K({
	numberOfContours: W,
	xMin: W,
	yMin: W,
	xMax: W,
	yMax: W
}), kD = 1, AD = 2, jD = 4, MD = 8, ND = 16, PD = 32, FD = 1, ID = 8, LD = 32, RD = 64, zD = 128, BD = 256, VD = class e {
	copy() {
		return new e(this.onCurve, this.endContour, this.x, this.y);
	}
	constructor(e, t, n = 0, r = 0) {
		this.onCurve = e, this.endContour = t, this.x = n, this.y = r;
	}
}, HD = class {
	constructor(e, t, n) {
		this.glyphID = e, this.dx = t, this.dy = n, this.pos = 0, this.scaleX = this.scaleY = 1, this.scale01 = this.scale10 = 0;
	}
}, UD = class extends DD {
	_getCBox(e) {
		if (this._font._variationProcessor && !e) return this.path.cbox;
		let t = this._font._getTableStream("glyf");
		t.pos += this._font.loca.offsets[this.id];
		let n = OD.decode(t), r = new jw(n.xMin, n.yMin, n.xMax, n.yMax);
		return Object.freeze(r);
	}
	_parseGlyphCoord(e, t, n, r) {
		if (n) {
			var i = e.readUInt8();
			r || (i = -i), i += t;
		} else if (r) var i = t;
		else var i = t + e.readInt16BE();
		return i;
	}
	_decode() {
		let e = this._font.loca.offsets[this.id];
		if (e === this._font.loca.offsets[this.id + 1]) return null;
		let t = this._font._getTableStream("glyf");
		t.pos += e;
		let n = t.pos, r = OD.decode(t);
		return r.numberOfContours > 0 ? this._decodeSimple(r, t) : r.numberOfContours < 0 && this._decodeComposite(r, t, n), r;
	}
	_decodeSimple(e, t) {
		e.points = [];
		let n = new G(H, e.numberOfContours).decode(t);
		e.instructions = new G(vy, H).decode(t);
		let r = [], i = n[n.length - 1] + 1;
		for (; r.length < i;) {
			var a = t.readUInt8();
			if (r.push(a), a & MD) {
				let e = t.readUInt8();
				for (let t = 0; t < e; t++) r.push(a);
			}
		}
		for (var o = 0; o < r.length; o++) {
			var a = r[o];
			let t = new VD(!!(a & kD), n.indexOf(o) >= 0, 0, 0);
			e.points.push(t);
		}
		let s = 0;
		for (var o = 0; o < r.length; o++) {
			var a = r[o];
			e.points[o].x = s = this._parseGlyphCoord(t, s, a & AD, a & ND);
		}
		let c = 0;
		for (var o = 0; o < r.length; o++) {
			var a = r[o];
			e.points[o].y = c = this._parseGlyphCoord(t, c, a & jD, a & PD);
		}
		if (this._font._variationProcessor) {
			let t = e.points.slice();
			t.push(...this._getPhantomPoints(e)), this._font._variationProcessor.transformPoints(this.id, t), e.phantomPoints = t.slice(-4);
		}
	}
	_decodeComposite(e, t, n = 0) {
		e.components = [];
		let r = !1, i = LD;
		for (; i & LD;) {
			i = t.readUInt16BE();
			let c = t.pos - n, l = t.readUInt16BE();
			if (r ||= (i & BD) !== 0, i & FD) var a = t.readInt16BE(), o = t.readInt16BE();
			else var a = t.readInt8(), o = t.readInt8();
			var s = new HD(l, a, o);
			s.pos = c, i & ID ? s.scaleX = s.scaleY = (t.readUInt8() << 24 | t.readUInt8() << 16) / 1073741824 : i & RD ? (s.scaleX = (t.readUInt8() << 24 | t.readUInt8() << 16) / 1073741824, s.scaleY = (t.readUInt8() << 24 | t.readUInt8() << 16) / 1073741824) : i & zD && (s.scaleX = (t.readUInt8() << 24 | t.readUInt8() << 16) / 1073741824, s.scale01 = (t.readUInt8() << 24 | t.readUInt8() << 16) / 1073741824, s.scale10 = (t.readUInt8() << 24 | t.readUInt8() << 16) / 1073741824, s.scaleY = (t.readUInt8() << 24 | t.readUInt8() << 16) / 1073741824), e.components.push(s);
		}
		if (this._font._variationProcessor) {
			let t = [];
			for (let n = 0; n < e.components.length; n++) {
				var s = e.components[n];
				t.push(new VD(!0, !0, s.dx, s.dy));
			}
			t.push(...this._getPhantomPoints(e)), this._font._variationProcessor.transformPoints(this.id, t), e.phantomPoints = t.splice(-4, 4);
			for (let n = 0; n < t.length; n++) {
				let r = t[n];
				e.components[n].dx = r.x, e.components[n].dy = r.y;
			}
		}
		return r;
	}
	_getPhantomPoints(e) {
		let t = this._getCBox(!0);
		this._metrics ??= DD.prototype._getMetrics.call(this, t);
		let { advanceWidth: n, advanceHeight: r, leftBearing: i, topBearing: a } = this._metrics;
		return [
			new VD(!1, !0, e.xMin - i, 0),
			new VD(!1, !0, e.xMin - i + n, 0),
			new VD(!1, !0, 0, e.yMax + a),
			new VD(!1, !0, 0, e.yMax + a + r)
		];
	}
	_getContours() {
		let e = this._decode();
		if (!e) return [];
		let t = [];
		if (e.numberOfContours < 0) for (let n of e.components) {
			let e = this._font.getGlyph(n.glyphID)._getContours();
			for (let r = 0; r < e.length; r++) {
				let i = e[r];
				for (let e = 0; e < i.length; e++) {
					let r = i[e], a = r.x * n.scaleX + r.y * n.scale01 + n.dx, o = r.y * n.scaleY + r.x * n.scale10 + n.dy;
					t.push(new VD(r.onCurve, r.endContour, a, o));
				}
			}
		}
		else t = e.points || [];
		e.phantomPoints && !this._font.directory.tables.HVAR && (this._metrics.advanceWidth = e.phantomPoints[1].x - e.phantomPoints[0].x, this._metrics.advanceHeight = e.phantomPoints[3].y - e.phantomPoints[2].y, this._metrics.leftBearing = e.xMin - e.phantomPoints[0].x, this._metrics.topBearing = e.phantomPoints[2].y - e.yMax);
		let n = [], r = [];
		for (let e = 0; e < t.length; e++) {
			var i = t[e];
			r.push(i), i.endContour && (n.push(r), r = []);
		}
		return n;
	}
	_getMetrics() {
		if (this._metrics) return this._metrics;
		let e = this._getCBox(!0);
		return super._getMetrics(e), this._font._variationProcessor && !this._font.HVAR && this.path, this._metrics;
	}
	_getPath() {
		let e = this._getContours(), t = new TD();
		for (let r = 0; r < e.length; r++) {
			let i = e[r], a = i[0], o = i[i.length - 1], s = 0;
			if (a.onCurve) {
				var n = null;
				s = 1;
			} else {
				a = o.onCurve ? o : new VD(!1, !1, (a.x + o.x) / 2, (a.y + o.y) / 2);
				var n = a;
			}
			t.moveTo(a.x, a.y);
			for (let e = s; e < i.length; e++) {
				let r = i[e], o = e === 0 ? a : i[e - 1];
				if (o.onCurve && r.onCurve) t.lineTo(r.x, r.y);
				else if (o.onCurve && !r.onCurve) var n = r;
				else if (!o.onCurve && !r.onCurve) {
					let e = (o.x + r.x) / 2, i = (o.y + r.y) / 2;
					t.quadraticCurveTo(o.x, o.y, e, i);
					var n = r;
				} else if (!o.onCurve && r.onCurve) {
					t.quadraticCurveTo(n.x, n.y, r.x, r.y);
					var n = null;
				} else throw Error("Unknown TTF path state");
			}
			n && t.quadraticCurveTo(n.x, n.y, a.x, a.y), t.closePath();
		}
		return t;
	}
	constructor(...e) {
		super(...e), zy(this, "type", "TTF");
	}
}, WD = class extends DD {
	_getName() {
		return this._font.CFF2 ? super._getName() : this._font["CFF "].getGlyphName(this.id);
	}
	bias(e) {
		return e.length < 1240 ? 107 : e.length < 33900 ? 1131 : 32768;
	}
	_getPath() {
		let e = this._font.CFF2 || this._font["CFF "], { stream: t } = e, n = e.topDict.CharStrings[this.id], r = n.offset + n.length;
		t.pos = n.offset;
		let i = new TD(), a = [], o = [], s = null, c = 0, l = 0, u = 0, d, f, p = !1;
		this._usedGsubrs = d = {}, this._usedSubrs = f = {};
		let m = e.globalSubrIndex || [], h = this.bias(m), g = e.privateDictForGlyph(this.id) || {}, _ = g.Subrs || [], v = this.bias(_), y = e.topDict.vstore && e.topDict.vstore.itemVariationStore, b = g.vsindex, x = this._font._variationProcessor;
		function S() {
			s ??= a.shift() + g.nominalWidthX;
		}
		function C() {
			return a.length % 2 != 0 && S(), c += a.length >> 1, a.length = 0;
		}
		function w(e, t) {
			p && i.closePath(), i.moveTo(e, t), p = !0;
		}
		let T = function() {
			for (; t.pos < r;) {
				let g = t.readUInt8();
				if (g < 32) {
					let s, E, D, O, k, A, j, M, ee, te, ne, re, ie, ae, oe, se;
					switch (g) {
						case 1:
						case 3:
						case 18:
						case 23:
							C();
							break;
						case 4:
							a.length > 1 && S(), u += a.shift(), w(l, u);
							break;
						case 5:
							for (; a.length >= 2;) l += a.shift(), u += a.shift(), i.lineTo(l, u);
							break;
						case 6:
						case 7:
							for (D = g === 6; a.length >= 1;) D ? l += a.shift() : u += a.shift(), i.lineTo(l, u), D = !D;
							break;
						case 8:
							for (; a.length > 0;) O = l + a.shift(), k = u + a.shift(), A = O + a.shift(), j = k + a.shift(), l = A + a.shift(), u = j + a.shift(), i.bezierCurveTo(O, k, A, j, l, u);
							break;
						case 10:
							if (s = a.pop() + v, E = _[s], E) {
								f[s] = !0;
								let e = t.pos, n = r;
								t.pos = E.offset, r = E.offset + E.length, T(), t.pos = e, r = n;
							}
							break;
						case 11:
							if (e.version >= 2) break;
							return;
						case 14:
							if (e.version >= 2) break;
							a.length > 0 && S(), p &&= (i.closePath(), !1);
							break;
						case 15:
							if (e.version < 2) throw Error("vsindex operator not supported in CFF v1");
							b = a.pop();
							break;
						case 16: {
							if (e.version < 2) throw Error("blend operator not supported in CFF v1");
							if (!x) throw Error("blend operator in non-variation font");
							let t = x.getBlendVector(y, b), n = a.pop(), r = n * t.length, i = a.length - r, o = i - n;
							for (let e = 0; e < n; e++) {
								let n = a[o + e];
								for (let e = 0; e < t.length; e++) n += t[e] * a[i++];
								a[o + e] = n;
							}
							for (; r--;) a.pop();
							break;
						}
						case 19:
						case 20:
							C(), t.pos += c + 7 >> 3;
							break;
						case 21:
							a.length > 2 && S(), l += a.shift(), u += a.shift(), w(l, u);
							break;
						case 22:
							a.length > 1 && S(), l += a.shift(), w(l, u);
							break;
						case 24:
							for (; a.length >= 8;) O = l + a.shift(), k = u + a.shift(), A = O + a.shift(), j = k + a.shift(), l = A + a.shift(), u = j + a.shift(), i.bezierCurveTo(O, k, A, j, l, u);
							l += a.shift(), u += a.shift(), i.lineTo(l, u);
							break;
						case 25:
							for (; a.length >= 8;) l += a.shift(), u += a.shift(), i.lineTo(l, u);
							O = l + a.shift(), k = u + a.shift(), A = O + a.shift(), j = k + a.shift(), l = A + a.shift(), u = j + a.shift(), i.bezierCurveTo(O, k, A, j, l, u);
							break;
						case 26:
							for (a.length % 2 && (l += a.shift()); a.length >= 4;) O = l, k = u + a.shift(), A = O + a.shift(), j = k + a.shift(), l = A, u = j + a.shift(), i.bezierCurveTo(O, k, A, j, l, u);
							break;
						case 27:
							for (a.length % 2 && (u += a.shift()); a.length >= 4;) O = l + a.shift(), k = u, A = O + a.shift(), j = k + a.shift(), l = A + a.shift(), u = j, i.bezierCurveTo(O, k, A, j, l, u);
							break;
						case 28:
							a.push(t.readInt16BE());
							break;
						case 29:
							if (s = a.pop() + h, E = m[s], E) {
								d[s] = !0;
								let e = t.pos, n = r;
								t.pos = E.offset, r = E.offset + E.length, T(), t.pos = e, r = n;
							}
							break;
						case 30:
						case 31:
							for (D = g === 31; a.length >= 4;) D ? (O = l + a.shift(), k = u, A = O + a.shift(), j = k + a.shift(), u = j + a.shift(), l = A + (a.length === 1 ? a.shift() : 0)) : (O = l, k = u + a.shift(), A = O + a.shift(), j = k + a.shift(), l = A + a.shift(), u = j + (a.length === 1 ? a.shift() : 0)), i.bezierCurveTo(O, k, A, j, l, u), D = !D;
							break;
						case 12:
							switch (g = t.readUInt8(), g) {
								case 3:
									let e = a.pop(), t = a.pop();
									a.push(e && t ? 1 : 0);
									break;
								case 4:
									e = a.pop(), t = a.pop(), a.push(e || t ? 1 : 0);
									break;
								case 5:
									e = a.pop(), a.push(+!e);
									break;
								case 9:
									e = a.pop(), a.push(Math.abs(e));
									break;
								case 10:
									e = a.pop(), t = a.pop(), a.push(e + t);
									break;
								case 11:
									e = a.pop(), t = a.pop(), a.push(e - t);
									break;
								case 12:
									e = a.pop(), t = a.pop(), a.push(e / t);
									break;
								case 14:
									e = a.pop(), a.push(-e);
									break;
								case 15:
									e = a.pop(), t = a.pop(), a.push(+(e === t));
									break;
								case 18:
									a.pop();
									break;
								case 20:
									let r = a.pop(), s = a.pop();
									o[s] = r;
									break;
								case 21:
									s = a.pop(), a.push(o[s] || 0);
									break;
								case 22:
									let c = a.pop(), d = a.pop(), f = a.pop(), p = a.pop();
									a.push(f <= p ? c : d);
									break;
								case 23:
									a.push(Math.random());
									break;
								case 24:
									e = a.pop(), t = a.pop(), a.push(e * t);
									break;
								case 26:
									e = a.pop(), a.push(Math.sqrt(e));
									break;
								case 27:
									e = a.pop(), a.push(e, e);
									break;
								case 28:
									e = a.pop(), t = a.pop(), a.push(t, e);
									break;
								case 29:
									s = a.pop(), s < 0 ? s = 0 : s > a.length - 1 && (s = a.length - 1), a.push(a[s]);
									break;
								case 30:
									let m = a.pop(), h = a.pop();
									if (h >= 0) for (; h > 0;) {
										var n = a[m - 1];
										for (let e = m - 2; e >= 0; e--) a[e + 1] = a[e];
										a[0] = n, h--;
									}
									else for (; h < 0;) {
										var n = a[0];
										for (let e = 0; e <= m; e++) a[e] = a[e + 1];
										a[m - 1] = n, h++;
									}
									break;
								case 34:
									O = l + a.shift(), k = u, A = O + a.shift(), j = k + a.shift(), M = A + a.shift(), ee = j, te = M + a.shift(), ne = ee, re = te + a.shift(), ie = ne, ae = re + a.shift(), oe = ie, l = ae, u = oe, i.bezierCurveTo(O, k, A, j, M, ee), i.bezierCurveTo(te, ne, re, ie, ae, oe);
									break;
								case 35:
									se = [];
									for (let e = 0; e <= 5; e++) l += a.shift(), u += a.shift(), se.push(l, u);
									i.bezierCurveTo(...se.slice(0, 6)), i.bezierCurveTo(...se.slice(6)), a.shift();
									break;
								case 36:
									O = l + a.shift(), k = u + a.shift(), A = O + a.shift(), j = k + a.shift(), M = A + a.shift(), ee = j, te = M + a.shift(), ne = ee, re = te + a.shift(), ie = ne + a.shift(), ae = re + a.shift(), oe = ie, l = ae, u = oe, i.bezierCurveTo(O, k, A, j, M, ee), i.bezierCurveTo(te, ne, re, ie, ae, oe);
									break;
								case 37:
									let _ = l, v = u;
									se = [];
									for (let e = 0; e <= 4; e++) l += a.shift(), u += a.shift(), se.push(l, u);
									Math.abs(l - _) > Math.abs(u - v) ? (l += a.shift(), u = v) : (l = _, u += a.shift()), se.push(l, u), i.bezierCurveTo(...se.slice(0, 6)), i.bezierCurveTo(...se.slice(6));
									break;
								default: throw Error(`Unknown op: 12 ${g}`);
							}
							break;
						default: throw Error(`Unknown op: ${g}`);
					}
				} else if (g < 247) a.push(g - 139);
				else if (g < 251) {
					var s = t.readUInt8();
					a.push((g - 247) * 256 + s + 108);
				} else if (g < 255) {
					var s = t.readUInt8();
					a.push(-(g - 251) * 256 - s - 108);
				} else a.push(t.readInt32BE() / 65536);
			}
		};
		return T(), p && i.closePath(), i;
	}
	constructor(...e) {
		super(...e), zy(this, "type", "CFF");
	}
}, GD = new K({
	originX: H,
	originY: H,
	type: new Py(4),
	data: new jy((e) => e.parent.buflen - e._currentOffset)
}), KD = class extends UD {
	getImageForSize(e) {
		for (let n = 0; n < this._font.sbix.imageTables.length; n++) {
			var t = this._font.sbix.imageTables[n];
			if (t.ppem >= e) break;
		}
		let n = t.imageOffsets, r = n[this.id], i = n[this.id + 1];
		return r === i ? null : (this._font.stream.pos = r, GD.decode(this._font.stream, { buflen: i - r }));
	}
	render(e, t) {
		let n = this.getImageForSize(t);
		if (n != null) {
			let r = t / this._font.unitsPerEm;
			e.image(n.data, {
				height: t,
				x: n.originX,
				y: (this.bbox.minY - n.originY) * r
			});
		}
		this._font.sbix.flags.renderOutlines && super.render(e, t);
	}
	constructor(...e) {
		super(...e), zy(this, "type", "SBIX");
	}
}, qD = class {
	constructor(e, t) {
		this.glyph = e, this.color = t;
	}
}, JD = class extends DD {
	_getBBox() {
		let e = new jw();
		for (let t = 0; t < this.layers.length; t++) {
			let n = this.layers[t].glyph.bbox;
			e.addPoint(n.minX, n.minY), e.addPoint(n.maxX, n.maxY);
		}
		return e;
	}
	get layers() {
		let e = this._font.CPAL, t = this._font.COLR, n = 0, r = t.baseGlyphRecord.length - 1;
		for (; n <= r;) {
			let e = n + r >> 1;
			var i = t.baseGlyphRecord[e];
			if (this.id < i.gid) r = e - 1;
			else if (this.id > i.gid) n = e + 1;
			else {
				var a = i;
				break;
			}
		}
		if (a == null) {
			var o = this._font._getBaseGlyph(this.id), s = {
				red: 0,
				green: 0,
				blue: 0,
				alpha: 255
			};
			return [new qD(o, s)];
		}
		let c = [];
		for (let n = a.firstLayerIndex; n < a.firstLayerIndex + a.numLayers; n++) {
			var i = t.layerRecords[n], s = e.colorRecords[i.paletteIndex], o = this._font._getBaseGlyph(i.gid);
			c.push(new qD(o, s));
		}
		return c;
	}
	render(e, t) {
		for (let { glyph: n, color: r } of this.layers) e.fillColor([
			r.red,
			r.green,
			r.blue
		], r.alpha / 255 * 100), n.render(e, t);
	}
	constructor(...e) {
		super(...e), zy(this, "type", "COLR");
	}
}, YD = 32768, XD = 4095, ZD = 32768, QD = 16384, $D = 8192, eO = 4095, tO = 128, nO = 127, rO = 128, iO = 64, aO = 63, oO = class {
	normalizeCoords(e) {
		let t = [];
		for (var n = 0; n < this.font.fvar.axis.length; n++) {
			let r = this.font.fvar.axis[n];
			e[n] < r.defaultValue ? t.push((e[n] - r.defaultValue + 2 ** -52) / (r.defaultValue - r.minValue + 2 ** -52)) : t.push((e[n] - r.defaultValue + 2 ** -52) / (r.maxValue - r.defaultValue + 2 ** -52));
		}
		if (this.font.avar) for (var n = 0; n < this.font.avar.segment.length; n++) {
			let e = this.font.avar.segment[n];
			for (let r = 0; r < e.correspondence.length; r++) {
				let i = e.correspondence[r];
				if (r >= 1 && t[n] < i.fromCoord) {
					let a = e.correspondence[r - 1];
					t[n] = ((t[n] - a.fromCoord) * (i.toCoord - a.toCoord) + 2 ** -52) / (i.fromCoord - a.fromCoord + 2 ** -52) + a.toCoord;
					break;
				}
			}
		}
		return t;
	}
	transformPoints(e, t) {
		if (!this.font.fvar || !this.font.gvar) return;
		let { gvar: n } = this.font;
		if (e >= n.glyphCount) return;
		let r = n.offsets[e];
		if (r === n.offsets[e + 1]) return;
		let { stream: i } = this.font;
		if (i.pos = r, i.pos >= i.length) return;
		let a = i.readUInt16BE(), o = r + i.readUInt16BE();
		if (a & YD) {
			var s = i.pos;
			i.pos = o;
			var c = this.decodePoints();
			o = i.pos, i.pos = s;
		}
		let l = t.map((e) => e.copy());
		a &= XD;
		for (let e = 0; e < a; e++) {
			let e = i.readUInt16BE(), r = i.readUInt16BE();
			if (r & ZD) {
				var u = [];
				for (let e = 0; e < n.axisCount; e++) u.push(i.readInt16BE() / 16384);
			} else {
				if ((r & eO) >= n.globalCoordCount) throw Error("Invalid gvar table");
				var u = n.globalCoords[r & eO];
			}
			if (r & QD) {
				var d = [];
				for (let e = 0; e < n.axisCount; e++) d.push(i.readInt16BE() / 16384);
				var f = [];
				for (let e = 0; e < n.axisCount; e++) f.push(i.readInt16BE() / 16384);
			}
			let a = this.tupleFactor(r, u, d, f);
			if (a === 0) {
				o += e;
				continue;
			}
			var s = i.pos;
			if (i.pos = o, r & $D) var p = this.decodePoints();
			else var p = c;
			let h = p.length === 0 ? t.length : p.length, g = this.decodeDeltas(h), _ = this.decodeDeltas(h);
			if (p.length === 0) for (let e = 0; e < t.length; e++) {
				var m = t[e];
				m.x += Math.round(g[e] * a), m.y += Math.round(_[e] * a);
			}
			else {
				let e = l.map((e) => e.copy()), n = t.map(() => !1);
				for (let r = 0; r < p.length; r++) {
					let i = p[r];
					if (i < t.length) {
						let t = e[i];
						n[i] = !0, t.x += g[r] * a, t.y += _[r] * a;
					}
				}
				this.interpolateMissingDeltas(e, l, n);
				for (let n = 0; n < t.length; n++) {
					let r = e[n].x - l[n].x, i = e[n].y - l[n].y;
					t[n].x = Math.round(t[n].x + r), t[n].y = Math.round(t[n].y + i);
				}
			}
			o += e, i.pos = s;
		}
	}
	decodePoints() {
		let e = this.font.stream, t = e.readUInt8();
		t & tO && (t = (t & nO) << 8 | e.readUInt8());
		let n = new Uint16Array(t), r = 0, i = 0;
		for (; r < t;) {
			let a = e.readUInt8(), o = (a & nO) + 1, s = a & tO ? e.readUInt16 : e.readUInt8;
			for (let a = 0; a < o && r < t; a++) i += s.call(e), n[r++] = i;
		}
		return n;
	}
	decodeDeltas(e) {
		let t = this.font.stream, n = 0, r = new Int16Array(e);
		for (; n < e;) {
			let i = t.readUInt8(), a = (i & aO) + 1;
			if (i & rO) n += a;
			else {
				let o = i & iO ? t.readInt16BE : t.readInt8;
				for (let i = 0; i < a && n < e; i++) r[n++] = o.call(t);
			}
		}
		return r;
	}
	tupleFactor(e, t, n, r) {
		let i = this.normalizedCoords, { gvar: a } = this.font, o = 1;
		for (let s = 0; s < a.axisCount; s++) if (t[s] !== 0) {
			if (i[s] === 0) return 0;
			if ((e & QD) === 0) {
				if (i[s] < Math.min(0, t[s]) || i[s] > Math.max(0, t[s])) return 0;
				o = (o * i[s] + 2 ** -52) / (t[s] + 2 ** -52);
			} else if (i[s] < n[s] || i[s] > r[s]) return 0;
			else o = i[s] < t[s] ? o * (i[s] - n[s] + 2 ** -52) / (t[s] - n[s] + 2 ** -52) : o * (r[s] - i[s] + 2 ** -52) / (r[s] - t[s] + 2 ** -52);
		}
		return o;
	}
	interpolateMissingDeltas(e, t, n) {
		if (e.length === 0) return;
		let r = 0;
		for (; r < e.length;) {
			let i = r, a = r, o = e[a];
			for (; !o.endContour;) o = e[++a];
			for (; r <= a && !n[r];) r++;
			if (r > a) continue;
			let s = r, c = r;
			for (r++; r <= a;) n[r] && (this.deltaInterpolate(c + 1, r - 1, c, r, t, e), c = r), r++;
			c === s ? this.deltaShift(i, a, c, t, e) : (this.deltaInterpolate(c + 1, a, c, s, t, e), s > 0 && this.deltaInterpolate(i, s - 1, c, s, t, e)), r = a + 1;
		}
	}
	deltaInterpolate(e, t, n, r, i, a) {
		if (e > t) return;
		let o = ["x", "y"];
		for (let c = 0; c < o.length; c++) {
			let l = o[c];
			if (i[n][l] > i[r][l]) {
				var s = n;
				n = r, r = s;
			}
			let u = i[n][l], d = i[r][l], f = a[n][l], p = a[r][l];
			if (u !== d || f === p) {
				let n = u === d ? 0 : (p - f) / (d - u);
				for (let r = e; r <= t; r++) {
					let e = i[r][l];
					e <= u ? e += f - u : e >= d ? e += p - d : e = f + (e - u) * n, a[r][l] = e;
				}
			}
		}
	}
	deltaShift(e, t, n, r, i) {
		let a = i[n].x - r[n].x, o = i[n].y - r[n].y;
		if (!(a === 0 && o === 0)) for (let r = e; r <= t; r++) r !== n && (i[r].x += a, i[r].y += o);
	}
	getAdvanceAdjustment(e, t) {
		let n, r;
		if (t.advanceWidthMapping) {
			let i = e;
			i >= t.advanceWidthMapping.mapCount && (i = t.advanceWidthMapping.mapCount - 1), t.advanceWidthMapping.entryFormat, {outerIndex: n, innerIndex: r} = t.advanceWidthMapping.mapData[i];
		} else n = 0, r = e;
		return this.getDelta(t.itemVariationStore, n, r);
	}
	getDelta(e, t, n) {
		if (t >= e.itemVariationData.length) return 0;
		let r = e.itemVariationData[t];
		if (n >= r.deltaSets.length) return 0;
		let i = r.deltaSets[n], a = this.getBlendVector(e, t), o = 0;
		for (let e = 0; e < r.regionIndexCount; e++) o += i.deltas[e] * a[e];
		return o;
	}
	getBlendVector(e, t) {
		let n = e.itemVariationData[t];
		if (this.blendVectors.has(n)) return this.blendVectors.get(n);
		let r = this.normalizedCoords, i = [];
		for (let t = 0; t < n.regionIndexCount; t++) {
			let a = 1, o = n.regionIndexes[t], s = e.variationRegionList.variationRegions[o];
			for (let e = 0; e < s.length; e++) {
				let t = s[e], n;
				n = t.startCoord > t.peakCoord || t.peakCoord > t.endCoord || t.startCoord < 0 && t.endCoord > 0 && t.peakCoord !== 0 || t.peakCoord === 0 ? 1 : r[e] < t.startCoord || r[e] > t.endCoord ? 0 : r[e] === t.peakCoord ? 1 : r[e] < t.peakCoord ? (r[e] - t.startCoord + 2 ** -52) / (t.peakCoord - t.startCoord + 2 ** -52) : (t.endCoord - r[e] + 2 ** -52) / (t.endCoord - t.peakCoord + 2 ** -52), a *= n;
			}
			i[t] = a;
		}
		return this.blendVectors.set(n, i), i;
	}
	constructor(e, t) {
		this.font = e, this.normalizedCoords = this.normalizeCoords(t), this.blendVectors = /* @__PURE__ */ new Map();
	}
};
Promise.resolve();
var sO = class {
	includeGlyph(e) {
		return typeof e == "object" && (e = e.id), this.mapping[e] ?? (this.glyphs.push(e), this.mapping[e] = this.glyphs.length - 1), this.mapping[e];
	}
	constructor(e) {
		this.font = e, this.glyphs = [], this.mapping = {}, this.includeGlyph(0);
	}
}, cO = 1, lO = 2, uO = 4, dO = 8, fO = 16, pO = 32, mO = class {
	static size(e) {
		return e >= 0 && e <= 255 ? 1 : 2;
	}
	static encode(e, t) {
		t >= 0 && t <= 255 ? e.writeUInt8(t) : e.writeInt16BE(t);
	}
}, hO = new K({
	numberOfContours: W,
	xMin: W,
	yMin: W,
	xMax: W,
	yMax: W,
	endPtsOfContours: new G(H, "numberOfContours"),
	instructions: new G(vy, H),
	flags: new G(vy, 0),
	xPoints: new G(mO, 0),
	yPoints: new G(mO, 0)
}), gO = class {
	encodeSimple(e, t = []) {
		let n = [], r = [], i = [], a = [], o = 0, s = 0, c = 0, l = 0, u = 0;
		for (let t = 0; t < e.commands.length; t++) {
			let d = e.commands[t];
			for (let n = 0; n < d.args.length; n += 2) {
				let f = d.args[n], p = d.args[n + 1], m = 0;
				if (d.command === "quadraticCurveTo" && n === 2) {
					let n = e.commands[t + 1];
					if (n && n.command === "quadraticCurveTo") {
						let e = (s + n.args[0]) / 2, t = (c + n.args[1]) / 2;
						if (f === e && p === t) continue;
					}
				}
				d.command === "quadraticCurveTo" && n === 0 || (m |= cO), m = this._encodePoint(f, s, r, m, lO, fO), m = this._encodePoint(p, c, i, m, uO, pO), m === l && o < 255 ? (a[a.length - 1] |= dO, o++) : (o > 0 && (a.push(o), o = 0), a.push(m), l = m), s = f, c = p, u++;
			}
			d.command === "closePath" && n.push(u - 1);
		}
		e.commands.length > 1 && e.commands[e.commands.length - 1].command !== "closePath" && n.push(u - 1);
		let d = e.bbox, f = {
			numberOfContours: n.length,
			xMin: d.minX,
			yMin: d.minY,
			xMax: d.maxX,
			yMax: d.maxY,
			endPtsOfContours: n,
			instructions: t,
			flags: a,
			xPoints: r,
			yPoints: i
		}, p = hO.size(f), m = 4 - p % 4, h = new my(p + m);
		return hO.encode(h, f), m !== 0 && h.fill(0, m), h.buffer;
	}
	_encodePoint(e, t, n, r, i, a) {
		let o = e - t;
		return e === t ? r |= a : (-255 <= o && o <= 255 && (r |= i, o < 0 ? o = -o : r |= a), n.push(o)), r;
	}
}, _O = class extends sO {
	_addGlyph(e) {
		let t = this.font.getGlyph(e), n = t._decode(), r = this.font.loca.offsets[e], i = this.font.loca.offsets[e + 1], a = this.font._getTableStream("glyf");
		a.pos += r;
		let o = a.readBuffer(i - r);
		if (n && n.numberOfContours < 0) {
			o = new Uint8Array(o);
			let t = new DataView(o.buffer);
			for (let r of n.components) e = this.includeGlyph(r.glyphID), t.setUint16(r.pos, e);
		} else n && this.font._variationProcessor && (o = this.glyphEncoder.encodeSimple(t.path, n.instructions));
		return this.glyf.push(o), this.loca.offsets.push(this.offset), this.hmtx.metrics.push({
			advance: t.advanceWidth,
			bearing: t._getMetrics().leftBearing
		}), this.offset += o.length, this.glyf.length - 1;
	}
	encode() {
		this.glyf = [], this.offset = 0, this.loca = {
			offsets: [],
			version: this.font.loca.version
		}, this.hmtx = {
			metrics: [],
			bearings: []
		};
		let e = 0;
		for (; e < this.glyphs.length;) this._addGlyph(this.glyphs[e++]);
		let t = (0, wb.default)(this.font.maxp);
		t.numGlyphs = this.glyf.length, this.loca.offsets.push(this.offset);
		let n = (0, wb.default)(this.font.head);
		n.indexToLocFormat = this.loca.version;
		let r = (0, wb.default)(this.font.hhea);
		return r.numberOfMetrics = this.hmtx.metrics.length, xw.toBuffer({ tables: {
			head: n,
			hhea: r,
			loca: this.loca,
			maxp: t,
			"cvt ": this.font["cvt "],
			prep: this.font.prep,
			glyf: this.glyf,
			hmtx: this.hmtx,
			fpgm: this.font.fpgm
		} });
	}
	constructor(e) {
		super(e), this.glyphEncoder = new gO();
	}
}, vO = class extends sO {
	subsetCharstrings() {
		this.charstrings = [];
		let e = {};
		for (let t of this.glyphs) {
			this.charstrings.push(this.cff.getCharString(t));
			let n = this.font.getGlyph(t);
			n.path;
			for (let t in n._usedGsubrs) e[t] = !0;
		}
		this.gsubrs = this.subsetSubrs(this.cff.globalSubrIndex, e);
	}
	subsetSubrs(e, t) {
		let n = [];
		for (let r = 0; r < e.length; r++) {
			let i = e[r];
			t[r] ? (this.cff.stream.pos = i.offset, n.push(this.cff.stream.readBuffer(i.length))) : n.push(new Uint8Array([11]));
		}
		return n;
	}
	subsetFontdict(e) {
		e.FDArray = [], e.FDSelect = {
			version: 0,
			fds: []
		};
		let t = {}, n = [], r = {};
		for (let i of this.glyphs) {
			let a = this.cff.fdForGlyph(i);
			if (a == null) continue;
			t[a] || (e.FDArray.push(Object.assign({}, this.cff.topDict.FDArray[a])), n.push({}), r[a] = e.FDArray.length - 1), t[a] = !0, e.FDSelect.fds.push(r[a]);
			let o = this.font.getGlyph(i);
			o.path;
			for (let e in o._usedSubrs) n[r[a]][e] = !0;
		}
		for (let t = 0; t < e.FDArray.length; t++) {
			let r = e.FDArray[t];
			delete r.FontName, r.Private && r.Private.Subrs && (r.Private = Object.assign({}, r.Private), r.Private.Subrs = this.subsetSubrs(r.Private.Subrs, n[t]));
		}
	}
	createCIDFontdict(e) {
		let t = {};
		for (let e of this.glyphs) {
			let n = this.font.getGlyph(e);
			n.path;
			for (let e in n._usedSubrs) t[e] = !0;
		}
		let n = Object.assign({}, this.cff.topDict.Private);
		return this.cff.topDict.Private && this.cff.topDict.Private.Subrs && (n.Subrs = this.subsetSubrs(this.cff.topDict.Private.Subrs, t)), e.FDArray = [{ Private: n }], e.FDSelect = {
			version: 3,
			nRanges: 1,
			ranges: [{
				first: 0,
				fd: 0
			}],
			sentinel: this.charstrings.length
		};
	}
	addString(e) {
		return e ? (this.strings ||= [], this.strings.push(e), Ex.length + this.strings.length - 1) : null;
	}
	encode() {
		this.subsetCharstrings();
		let e = {
			version: this.charstrings.length > 255 ? 2 : 1,
			ranges: [{
				first: 1,
				nLeft: this.charstrings.length - 2
			}]
		}, t = Object.assign({}, this.cff.topDict);
		t.Private = null, t.charset = e, t.Encoding = null, t.CharStrings = this.charstrings;
		for (let e of [
			"version",
			"Notice",
			"Copyright",
			"FullName",
			"FamilyName",
			"Weight",
			"PostScript",
			"BaseFontName",
			"FontName"
		]) t[e] = this.addString(this.cff.string(t[e]));
		t.ROS = [
			this.addString("Adobe"),
			this.addString("Identity"),
			0
		], t.CIDCount = this.charstrings.length, this.cff.isCIDFont ? this.subsetFontdict(t) : this.createCIDFontdict(t);
		let n = {
			version: 1,
			hdrSize: this.cff.hdrSize,
			offSize: 4,
			header: this.cff.header,
			nameIndex: [this.cff.postscriptName],
			topDictIndex: [t],
			stringIndex: this.strings,
			globalSubrIndex: this.gsubrs
		};
		return CS.toBuffer(n);
	}
	constructor(e) {
		if (super(e), this.cff = this.font["CFF "], !this.cff) throw Error("Not a CFF Font");
	}
}, yO = class e {
	static probe(e) {
		let t = ww.decode(e.slice(0, 4));
		return t === "true" || t === "OTTO" || t === "\0\0\0";
	}
	setDefaultLanguage(e = null) {
		this.defaultLanguage = e;
	}
	_getTable(e) {
		if (!(e.tag in this._tables)) try {
			this._tables[e.tag] = this._decodeTable(e);
		} catch {}
		return this._tables[e.tag];
	}
	_getTableStream(e) {
		let t = this.directory.tables[e];
		return t ? (this.stream.pos = t.offset, this.stream) : null;
	}
	_decodeDirectory() {
		return this.directory = xw.decode(this.stream, { _startOffset: 0 });
	}
	_decodeTable(e) {
		let t = this.stream.pos, n = this._getTableStream(e.tag), r = vw[e.tag].decode(n, this, e.length);
		return this.stream.pos = t, r;
	}
	getName(e, t = this.defaultLanguage || Nb) {
		let n = this.name && this.name.records[e];
		return n && (n[t] || n[this.defaultLanguage] || n[Nb] || n.en || n[Object.keys(n)[0]]) || null;
	}
	get postscriptName() {
		return this.getName("postscriptName");
	}
	get fullName() {
		return this.getName("fullName");
	}
	get familyName() {
		return this.getName("fontFamily");
	}
	get subfamilyName() {
		return this.getName("fontSubfamily");
	}
	get copyright() {
		return this.getName("copyright");
	}
	get version() {
		return this.getName("version");
	}
	get ascent() {
		return this.hhea.ascent;
	}
	get descent() {
		return this.hhea.descent;
	}
	get lineGap() {
		return this.hhea.lineGap;
	}
	get underlinePosition() {
		return this.post.underlinePosition;
	}
	get underlineThickness() {
		return this.post.underlineThickness;
	}
	get italicAngle() {
		return this.post.italicAngle;
	}
	get capHeight() {
		let e = this["OS/2"];
		return e ? e.capHeight : this.ascent;
	}
	get xHeight() {
		let e = this["OS/2"];
		return e ? e.xHeight : 0;
	}
	get numGlyphs() {
		return this.maxp.numGlyphs;
	}
	get unitsPerEm() {
		return this.head.unitsPerEm;
	}
	get bbox() {
		return Object.freeze(new jw(this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax));
	}
	get _cmapProcessor() {
		return new Ow(this.cmap);
	}
	get characterSet() {
		return this._cmapProcessor.getCharacterSet();
	}
	hasGlyphForCodePoint(e) {
		return !!this._cmapProcessor.lookup(e);
	}
	glyphForCodePoint(e) {
		return this.getGlyph(this._cmapProcessor.lookup(e), [e]);
	}
	glyphsForString(e) {
		let t = [], n = e.length, r = 0, i = -1, a = -1;
		for (; r <= n;) {
			let o = 0, s = 0;
			if (r < n) {
				if (o = e.charCodeAt(r++), 55296 <= o && o <= 56319 && r < n) {
					let t = e.charCodeAt(r);
					56320 <= t && t <= 57343 && (r++, o = ((o & 1023) << 10) + (t & 1023) + 65536);
				}
				s = +(65024 <= o && o <= 65039 || 917760 <= o && o <= 917999);
			} else r++;
			a === 0 && s === 1 ? t.push(this.getGlyph(this._cmapProcessor.lookup(i, o), [i, o])) : a === 0 && s === 0 && t.push(this.glyphForCodePoint(i)), i = o, a = s;
		}
		return t;
	}
	get _layoutEngine() {
		return new CD(this);
	}
	layout(e, t, n, r, i) {
		return this._layoutEngine.layout(e, t, n, r, i);
	}
	stringsForGlyph(e) {
		return this._layoutEngine.stringsForGlyph(e);
	}
	get availableFeatures() {
		return this._layoutEngine.getAvailableFeatures();
	}
	getAvailableFeatures(e, t) {
		return this._layoutEngine.getAvailableFeatures(e, t);
	}
	_getBaseGlyph(e, t = []) {
		return this._glyphs[e] || (this.directory.tables.glyf ? this._glyphs[e] = new UD(e, t, this) : (this.directory.tables["CFF "] || this.directory.tables.CFF2) && (this._glyphs[e] = new WD(e, t, this))), this._glyphs[e] || null;
	}
	getGlyph(e, t = []) {
		return this._glyphs[e] || (this.directory.tables.sbix ? this._glyphs[e] = new KD(e, t, this) : this.directory.tables.COLR && this.directory.tables.CPAL ? this._glyphs[e] = new JD(e, t, this) : this._getBaseGlyph(e, t)), this._glyphs[e] || null;
	}
	createSubset() {
		return this.directory.tables["CFF "] ? new vO(this) : new _O(this);
	}
	get variationAxes() {
		let e = {};
		if (!this.fvar) return e;
		for (let t of this.fvar.axis) e[t.axisTag.trim()] = {
			name: t.name.en,
			min: t.minValue,
			default: t.defaultValue,
			max: t.maxValue
		};
		return e;
	}
	get namedVariations() {
		let e = {};
		if (!this.fvar) return e;
		for (let t of this.fvar.instance) {
			let n = {};
			for (let e = 0; e < this.fvar.axis.length; e++) {
				let r = this.fvar.axis[e];
				n[r.axisTag.trim()] = t.coord[e];
			}
			e[t.name.en] = n;
		}
		return e;
	}
	getVariation(t) {
		if (!(this.directory.tables.fvar && (this.directory.tables.gvar && this.directory.tables.glyf || this.directory.tables.CFF2))) throw Error("Variations require a font with the fvar, gvar and glyf, or CFF2 tables.");
		if (typeof t == "string" && (t = this.namedVariations[t]), typeof t != "object") throw Error("Variation settings must be either a variation name or settings object.");
		let n = this.fvar.axis.map((e, n) => {
			let r = e.axisTag.trim();
			return r in t ? Math.max(e.minValue, Math.min(e.maxValue, t[r])) : e.defaultValue;
		}), r = new fy(this.stream.buffer);
		r.pos = this._directoryPos;
		let i = new e(r, n);
		return i._tables = this._tables, i;
	}
	get _variationProcessor() {
		if (!this.fvar) return null;
		let e = this.variationCoords;
		return !e && !this.CFF2 ? null : (e ||= this.fvar.axis.map((e) => e.defaultValue), new oO(this, e));
	}
	getFont(e) {
		return this.getVariation(e);
	}
	constructor(e, t = null) {
		zy(this, "type", "TTF"), this.defaultLanguage = null, this.stream = e, this.variationCoords = t, this._directoryPos = this.stream.pos, this._tables = {}, this._glyphs = {}, this._decodeDirectory();
		for (let e in this.directory.tables) {
			let t = this.directory.tables[e];
			vw[e] && t.length > 0 && Object.defineProperty(this, e, { get: this._getTable.bind(this, t) });
		}
	}
};
By([Fb], yO.prototype, "bbox", null), By([Fb], yO.prototype, "_cmapProcessor", null), By([Fb], yO.prototype, "characterSet", null), By([Fb], yO.prototype, "_layoutEngine", null), By([Fb], yO.prototype, "variationAxes", null), By([Fb], yO.prototype, "namedVariations", null), By([Fb], yO.prototype, "_variationProcessor", null);
var bO = new K({
	tag: new Py(4),
	offset: new q(U, "void", { type: "global" }),
	compLength: U,
	length: U,
	origChecksum: U
}), xO = new K({
	tag: new Py(4),
	flavor: U,
	length: U,
	numTables: H,
	reserved: new Ny(H),
	totalSfntSize: U,
	majorVersion: H,
	minorVersion: H,
	metaOffset: U,
	metaLength: U,
	metaOrigLength: U,
	privOffset: U,
	privLength: U,
	tables: new G(bO, "numTables")
});
xO.process = function() {
	let e = {};
	for (let t of this.tables) e[t.tag] = t;
	this.tables = e;
};
var SO = xO, CO = class extends yO {
	static probe(e) {
		return ww.decode(e.slice(0, 4)) === "wOFF";
	}
	_decodeDirectory() {
		this.directory = SO.decode(this.stream, { _startOffset: 0 });
	}
	_getTableStream(e) {
		let t = this.directory.tables[e];
		if (t) if (this.stream.pos = t.offset, t.compLength < t.length) {
			this.stream.pos += 2;
			let e = new Uint8Array(t.length);
			return new fy((0, Tb.default)(this.stream.readBuffer(t.compLength - 2), e));
		} else return this.stream;
		return null;
	}
	constructor(...e) {
		super(...e), zy(this, "type", "WOFF");
	}
}, wO = class extends UD {
	_decode() {
		return this._font._transformedGlyphs[this.id];
	}
	_getCBox() {
		return this.path.bbox;
	}
	constructor(...e) {
		super(...e), zy(this, "type", "WOFF2");
	}
}, TO = { decode(e) {
	let t = 0, n = [
		0,
		1,
		2,
		3,
		4
	];
	for (let r = 0; r < n.length; r++) {
		n[r];
		let i = e.readUInt8();
		if (t & 3758096384) throw Error("Overflow");
		if (t = t << 7 | i & 127, !(i & 128)) return t;
	}
	throw Error("Bad base 128 number");
} }, EO = /* @__PURE__ */ "cmap.head.hhea.hmtx.maxp.name.OS/2.post.cvt .fpgm.glyf.loca.prep.CFF .VORG.EBDT.EBLC.gasp.hdmx.kern.LTSH.PCLT.VDMX.vhea.vmtx.BASE.GDEF.GPOS.GSUB.EBSC.JSTF.MATH.CBDT.CBLC.COLR.CPAL.SVG .sbix.acnt.avar.bdat.bloc.bsln.cvar.fdsc.feat.fmtx.fvar.gvar.hsty.just.lcar.mort.morx.opbd.prop.trak.Zapf.Silf.Glat.Gloc.Feat.Sill".split("."), DO = new K({
	flags: vy,
	customTag: new My(new Py(4), (e) => (e.flags & 63) == 63),
	tag: (e) => e.customTag || EO[e.flags & 63],
	length: TO,
	transformVersion: (e) => e.flags >>> 6 & 3,
	transformed: (e) => e.tag === "glyf" || e.tag === "loca" ? e.transformVersion === 0 : e.transformVersion !== 0,
	transformLength: new My(TO, (e) => e.transformed)
}), OO = new K({
	tag: new Py(4),
	flavor: U,
	length: U,
	numTables: H,
	reserved: new Ny(H),
	totalSfntSize: U,
	totalCompressedSize: U,
	majorVersion: H,
	minorVersion: H,
	metaOffset: U,
	metaLength: U,
	metaOrigLength: U,
	privOffset: U,
	privLength: U,
	tables: new G(DO, "numTables")
});
OO.process = function() {
	let e = {};
	for (let t = 0; t < this.tables.length; t++) {
		let n = this.tables[t];
		e[n.tag] = n;
	}
	return this.tables = e;
};
var kO = OO, AO = class extends yO {
	static probe(e) {
		return ww.decode(e.slice(0, 4)) === "wOF2";
	}
	_decodeDirectory() {
		this.directory = kO.decode(this.stream), this._dataPos = this.stream.pos;
	}
	_decompress() {
		if (!this._decompressed) {
			this.stream.pos = this._dataPos;
			let e = this.stream.readBuffer(this.directory.totalCompressedSize), t = 0;
			for (let e in this.directory.tables) {
				let n = this.directory.tables[e];
				n.offset = t, t += n.transformLength == null ? n.length : n.transformLength;
			}
			let n = (0, Eb.default)(e, t);
			if (!n) throw Error("Error decoding compressed data in WOFF2");
			this.stream = new fy(n), this._decompressed = !0;
		}
	}
	_decodeTable(e) {
		return this._decompress(), super._decodeTable(e);
	}
	_getBaseGlyph(e, t = []) {
		if (!this._glyphs[e]) return this.directory.tables.glyf && this.directory.tables.glyf.transformed ? (this._transformedGlyphs || this._transformGlyfTable(), this._glyphs[e] = new wO(e, t, this)) : super._getBaseGlyph(e, t);
	}
	_transformGlyfTable() {
		this._decompress(), this.stream.pos = this.directory.tables.glyf.offset;
		let e = MO.decode(this.stream), t = [];
		for (let r = 0; r < e.numGlyphs; r++) {
			let r = {}, i = e.nContours.readInt16BE();
			if (r.numberOfContours = i, i > 0) {
				let t = [], n = 0;
				for (let r = 0; r < i; r++) {
					let r = LO(e.nPoints);
					n += r, t.push(n);
				}
				r.points = zO(e.flags, e.glyphs, n);
				for (let e = 0; e < i; e++) r.points[t[e] - 1].endContour = !0;
				LO(e.glyphs);
			} else if (i < 0 && UD.prototype._decodeComposite.call({ _font: this }, r, e.composites)) var n = LO(e.glyphs);
			t.push(r);
		}
		this._transformedGlyphs = t;
	}
	constructor(...e) {
		super(...e), zy(this, "type", "WOFF2");
	}
}, jO = class {
	decode(e, t) {
		return new fy(this._buf.decode(e, t));
	}
	constructor(e) {
		this.length = e, this._buf = new jy(e);
	}
}, MO = new K({
	version: U,
	numGlyphs: H,
	indexFormat: H,
	nContourStreamSize: U,
	nPointsStreamSize: U,
	flagStreamSize: U,
	glyphStreamSize: U,
	compositeStreamSize: U,
	bboxStreamSize: U,
	instructionStreamSize: U,
	nContours: new jO("nContourStreamSize"),
	nPoints: new jO("nPointsStreamSize"),
	flags: new jO("flagStreamSize"),
	glyphs: new jO("glyphStreamSize"),
	composites: new jO("compositeStreamSize"),
	bboxes: new jO("bboxStreamSize"),
	instructions: new jO("instructionStreamSize")
}), NO = 253, PO = 254, FO = 255, IO = 253;
function LO(e) {
	let t = e.readUInt8();
	return t === NO ? e.readUInt16BE() : t === FO ? e.readUInt8() + IO : t === PO ? e.readUInt8() + IO * 2 : t;
}
function RO(e, t) {
	return e & 1 ? t : -t;
}
function zO(e, t, n) {
	let r, i = r = 0, a = [];
	for (let c = 0; c < n; c++) {
		let n = 0, c = 0, l = e.readUInt8(), u = !(l >> 7);
		if (l &= 127, l < 10) n = 0, c = RO(l, ((l & 14) << 7) + t.readUInt8());
		else if (l < 20) n = RO(l, ((l - 10 & 14) << 7) + t.readUInt8()), c = 0;
		else if (l < 84) {
			var o = l - 20, s = t.readUInt8();
			n = RO(l, 1 + (o & 48) + (s >> 4)), c = RO(l >> 1, 1 + ((o & 12) << 2) + (s & 15));
		} else if (l < 120) {
			var o = l - 84;
			n = RO(l, 1 + (o / 12 << 8) + t.readUInt8()), c = RO(l >> 1, 1 + (o % 12 >> 2 << 8) + t.readUInt8());
		} else if (l < 124) {
			var s = t.readUInt8();
			let e = t.readUInt8();
			n = RO(l, (s << 4) + (e >> 4)), c = RO(l >> 1, ((e & 15) << 8) + t.readUInt8());
		} else n = RO(l, t.readUInt16BE()), c = RO(l >> 1, t.readUInt16BE());
		i += n, r += c, a.push(new VD(u, !1, i, r));
	}
	return a;
}
var BO = new Ly(U, {
	65536: {
		numFonts: U,
		offsets: new G(U, "numFonts")
	},
	131072: {
		numFonts: U,
		offsets: new G(U, "numFonts"),
		dsigTag: U,
		dsigLength: U,
		dsigOffset: U
	}
}), VO = class {
	static probe(e) {
		return ww.decode(e.slice(0, 4)) === "ttcf";
	}
	getFont(e) {
		for (let t of this.header.offsets) {
			let n = new fy(this.stream.buffer);
			n.pos = t;
			let r = new yO(n);
			if (r.postscriptName === e || r.postscriptName instanceof Uint8Array && e instanceof Uint8Array && r.postscriptName.every((t, n) => e[n] === t)) return r;
		}
		return null;
	}
	get fonts() {
		let e = [];
		for (let t of this.header.offsets) {
			let n = new fy(this.stream.buffer);
			n.pos = t, e.push(new yO(n));
		}
		return e;
	}
	constructor(e) {
		if (zy(this, "type", "TTC"), this.stream = e, e.readString(4) !== "ttcf") throw Error("Not a TrueType collection");
		this.header = BO.decode(e);
	}
}, HO = new Py(vy);
new K({
	len: U,
	buf: new jy("len")
});
var UO = new K({
	id: H,
	nameOffset: W,
	attr: vy,
	dataOffset: by,
	handle: U
}), WO = new K({
	length: H,
	types: new G(new K({
		name: new Py(4),
		maxTypeIndex: H,
		refList: new q(H, new G(UO, (e) => e.maxTypeIndex + 1), { type: "parent" })
	}), (e) => e.length + 1)
}), GO = new K({
	dataOffset: U,
	map: new q(U, new K({
		reserved: new Ny(vy, 24),
		typeList: new q(H, WO),
		nameListOffset: new q(H, "void")
	})),
	dataLength: U,
	mapLength: U
}), KO = class {
	static probe(e) {
		let t = new fy(e);
		try {
			var n = GO.decode(t);
		} catch {
			return !1;
		}
		for (let e of n.map.typeList.types) if (e.name === "sfnt") return !0;
		return !1;
	}
	getFont(e) {
		if (!this.sfnt) return null;
		for (let t of this.sfnt.refList) {
			let n = this.header.dataOffset + t.dataOffset + 4, r = new yO(new fy(this.stream.buffer.slice(n)));
			if (r.postscriptName === e || r.postscriptName instanceof Uint8Array && e instanceof Uint8Array && r.postscriptName.every((t, n) => e[n] === t)) return r;
		}
		return null;
	}
	get fonts() {
		let e = [];
		for (let t of this.sfnt.refList) {
			let n = this.header.dataOffset + t.dataOffset + 4, r = new fy(this.stream.buffer.slice(n));
			e.push(new yO(r));
		}
		return e;
	}
	constructor(e) {
		zy(this, "type", "DFont"), this.stream = e, this.header = GO.decode(this.stream);
		for (let e of this.header.map.typeList.types) {
			for (let t of e.refList) t.nameOffset >= 0 ? (this.stream.pos = t.nameOffset + this.header.map.nameListOffset, t.name = HO.decode(this.stream)) : t.name = null;
			e.name === "sfnt" && (this.sfnt = e);
		}
	}
};
jb(yO), jb(CO), jb(AO), jb(VO), jb(KO);
//#endregion
//#region ../../node_modules/pako/lib/zlib/zstream.js
var qO = /* @__PURE__ */ V(((e, t) => {
	function n() {
		this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
	}
	t.exports = n;
})), JO = /* @__PURE__ */ V(((e) => {
	var t = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
	function n(e, t) {
		return Object.prototype.hasOwnProperty.call(e, t);
	}
	e.assign = function(e) {
		for (var t = Array.prototype.slice.call(arguments, 1); t.length;) {
			var r = t.shift();
			if (r) {
				if (typeof r != "object") throw TypeError(r + "must be non-object");
				for (var i in r) n(r, i) && (e[i] = r[i]);
			}
		}
		return e;
	}, e.shrinkBuf = function(e, t) {
		return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
	};
	var r = {
		arraySet: function(e, t, n, r, i) {
			if (t.subarray && e.subarray) {
				e.set(t.subarray(n, n + r), i);
				return;
			}
			for (var a = 0; a < r; a++) e[i + a] = t[n + a];
		},
		flattenChunks: function(e) {
			var t, n, r = 0, i, a, o;
			for (t = 0, n = e.length; t < n; t++) r += e[t].length;
			for (o = new Uint8Array(r), i = 0, t = 0, n = e.length; t < n; t++) a = e[t], o.set(a, i), i += a.length;
			return o;
		}
	}, i = {
		arraySet: function(e, t, n, r, i) {
			for (var a = 0; a < r; a++) e[i + a] = t[n + a];
		},
		flattenChunks: function(e) {
			return [].concat.apply([], e);
		}
	};
	e.setTyped = function(t) {
		t ? (e.Buf8 = Uint8Array, e.Buf16 = Uint16Array, e.Buf32 = Int32Array, e.assign(e, r)) : (e.Buf8 = Array, e.Buf16 = Array, e.Buf32 = Array, e.assign(e, i));
	}, e.setTyped(t);
})), YO = /* @__PURE__ */ V(((e) => {
	var t = JO(), n = 4, r = 0, i = 1, a = 2;
	function o(e) {
		for (var t = e.length; --t >= 0;) e[t] = 0;
	}
	var s = 0, c = 1, l = 2, u = 3, d = 258, f = 29, p = 256, m = p + 1 + f, h = 30, g = 19, _ = 2 * m + 1, v = 15, y = 16, b = 7, x = 256, S = 16, C = 17, w = 18, T = [
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		1,
		1,
		1,
		1,
		2,
		2,
		2,
		2,
		3,
		3,
		3,
		3,
		4,
		4,
		4,
		4,
		5,
		5,
		5,
		5,
		0
	], E = [
		0,
		0,
		0,
		0,
		1,
		1,
		2,
		2,
		3,
		3,
		4,
		4,
		5,
		5,
		6,
		6,
		7,
		7,
		8,
		8,
		9,
		9,
		10,
		10,
		11,
		11,
		12,
		12,
		13,
		13
	], D = [
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		2,
		3,
		7
	], O = [
		16,
		17,
		18,
		0,
		8,
		7,
		9,
		6,
		10,
		5,
		11,
		4,
		12,
		3,
		13,
		2,
		14,
		1,
		15
	], k = 512, A = Array((m + 2) * 2);
	o(A);
	var j = Array(h * 2);
	o(j);
	var M = Array(k);
	o(M);
	var ee = Array(d - u + 1);
	o(ee);
	var te = Array(f);
	o(te);
	var ne = Array(h);
	o(ne);
	function re(e, t, n, r, i) {
		this.static_tree = e, this.extra_bits = t, this.extra_base = n, this.elems = r, this.max_length = i, this.has_stree = e && e.length;
	}
	var ie, ae, oe;
	function se(e, t) {
		this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
	}
	function ce(e) {
		return e < 256 ? M[e] : M[256 + (e >>> 7)];
	}
	function le(e, t) {
		e.pending_buf[e.pending++] = t & 255, e.pending_buf[e.pending++] = t >>> 8 & 255;
	}
	function N(e, t, n) {
		e.bi_valid > y - n ? (e.bi_buf |= t << e.bi_valid & 65535, le(e, e.bi_buf), e.bi_buf = t >> y - e.bi_valid, e.bi_valid += n - y) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += n);
	}
	function P(e, t, n) {
		N(e, n[t * 2], n[t * 2 + 1]);
	}
	function ue(e, t) {
		var n = 0;
		do
			n |= e & 1, e >>>= 1, n <<= 1;
		while (--t > 0);
		return n >>> 1;
	}
	function de(e) {
		e.bi_valid === 16 ? (le(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : e.bi_valid >= 8 && (e.pending_buf[e.pending++] = e.bi_buf & 255, e.bi_buf >>= 8, e.bi_valid -= 8);
	}
	function fe(e, t) {
		var n = t.dyn_tree, r = t.max_code, i = t.stat_desc.static_tree, a = t.stat_desc.has_stree, o = t.stat_desc.extra_bits, s = t.stat_desc.extra_base, c = t.stat_desc.max_length, l, u, d, f, p, m, h = 0;
		for (f = 0; f <= v; f++) e.bl_count[f] = 0;
		for (n[e.heap[e.heap_max] * 2 + 1] = 0, l = e.heap_max + 1; l < _; l++) u = e.heap[l], f = n[n[u * 2 + 1] * 2 + 1] + 1, f > c && (f = c, h++), n[u * 2 + 1] = f, !(u > r) && (e.bl_count[f]++, p = 0, u >= s && (p = o[u - s]), m = n[u * 2], e.opt_len += m * (f + p), a && (e.static_len += m * (i[u * 2 + 1] + p)));
		if (h !== 0) {
			do {
				for (f = c - 1; e.bl_count[f] === 0;) f--;
				e.bl_count[f]--, e.bl_count[f + 1] += 2, e.bl_count[c]--, h -= 2;
			} while (h > 0);
			for (f = c; f !== 0; f--) for (u = e.bl_count[f]; u !== 0;) d = e.heap[--l], !(d > r) && (n[d * 2 + 1] !== f && (e.opt_len += (f - n[d * 2 + 1]) * n[d * 2], n[d * 2 + 1] = f), u--);
		}
	}
	function pe(e, t, n) {
		var r = Array(v + 1), i = 0, a, o;
		for (a = 1; a <= v; a++) r[a] = i = i + n[a - 1] << 1;
		for (o = 0; o <= t; o++) {
			var s = e[o * 2 + 1];
			s !== 0 && (e[o * 2] = ue(r[s]++, s));
		}
	}
	function me() {
		var e, t, n, r, i, a = Array(v + 1);
		for (n = 0, r = 0; r < f - 1; r++) for (te[r] = n, e = 0; e < 1 << T[r]; e++) ee[n++] = r;
		for (ee[n - 1] = r, i = 0, r = 0; r < 16; r++) for (ne[r] = i, e = 0; e < 1 << E[r]; e++) M[i++] = r;
		for (i >>= 7; r < h; r++) for (ne[r] = i << 7, e = 0; e < 1 << E[r] - 7; e++) M[256 + i++] = r;
		for (t = 0; t <= v; t++) a[t] = 0;
		for (e = 0; e <= 143;) A[e * 2 + 1] = 8, e++, a[8]++;
		for (; e <= 255;) A[e * 2 + 1] = 9, e++, a[9]++;
		for (; e <= 279;) A[e * 2 + 1] = 7, e++, a[7]++;
		for (; e <= 287;) A[e * 2 + 1] = 8, e++, a[8]++;
		for (pe(A, m + 1, a), e = 0; e < h; e++) j[e * 2 + 1] = 5, j[e * 2] = ue(e, 5);
		ie = new re(A, T, p + 1, m, v), ae = new re(j, E, 0, h, v), oe = new re([], D, 0, g, b);
	}
	function F(e) {
		var t;
		for (t = 0; t < m; t++) e.dyn_ltree[t * 2] = 0;
		for (t = 0; t < h; t++) e.dyn_dtree[t * 2] = 0;
		for (t = 0; t < g; t++) e.bl_tree[t * 2] = 0;
		e.dyn_ltree[x * 2] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
	}
	function I(e) {
		e.bi_valid > 8 ? le(e, e.bi_buf) : e.bi_valid > 0 && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
	}
	function he(e, n, r, i) {
		I(e), i && (le(e, r), le(e, ~r)), t.arraySet(e.pending_buf, e.window, n, r, e.pending), e.pending += r;
	}
	function L(e, t, n, r) {
		var i = t * 2, a = n * 2;
		return e[i] < e[a] || e[i] === e[a] && r[t] <= r[n];
	}
	function ge(e, t, n) {
		for (var r = e.heap[n], i = n << 1; i <= e.heap_len && (i < e.heap_len && L(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !L(t, r, e.heap[i], e.depth));) e.heap[n] = e.heap[i], n = i, i <<= 1;
		e.heap[n] = r;
	}
	function _e(e, t, n) {
		var r, i, a = 0, o, s;
		if (e.last_lit !== 0) do
			r = e.pending_buf[e.d_buf + a * 2] << 8 | e.pending_buf[e.d_buf + a * 2 + 1], i = e.pending_buf[e.l_buf + a], a++, r === 0 ? P(e, i, t) : (o = ee[i], P(e, o + p + 1, t), s = T[o], s !== 0 && (i -= te[o], N(e, i, s)), r--, o = ce(r), P(e, o, n), s = E[o], s !== 0 && (r -= ne[o], N(e, r, s)));
		while (a < e.last_lit);
		P(e, x, t);
	}
	function ve(e, t) {
		var n = t.dyn_tree, r = t.stat_desc.static_tree, i = t.stat_desc.has_stree, a = t.stat_desc.elems, o, s, c = -1, l;
		for (e.heap_len = 0, e.heap_max = _, o = 0; o < a; o++) n[o * 2] === 0 ? n[o * 2 + 1] = 0 : (e.heap[++e.heap_len] = c = o, e.depth[o] = 0);
		for (; e.heap_len < 2;) l = e.heap[++e.heap_len] = c < 2 ? ++c : 0, n[l * 2] = 1, e.depth[l] = 0, e.opt_len--, i && (e.static_len -= r[l * 2 + 1]);
		for (t.max_code = c, o = e.heap_len >> 1; o >= 1; o--) ge(e, n, o);
		l = a;
		do
			o = e.heap[1], e.heap[1] = e.heap[e.heap_len--], ge(e, n, 1), s = e.heap[1], e.heap[--e.heap_max] = o, e.heap[--e.heap_max] = s, n[l * 2] = n[o * 2] + n[s * 2], e.depth[l] = (e.depth[o] >= e.depth[s] ? e.depth[o] : e.depth[s]) + 1, n[o * 2 + 1] = n[s * 2 + 1] = l, e.heap[1] = l++, ge(e, n, 1);
		while (e.heap_len >= 2);
		e.heap[--e.heap_max] = e.heap[1], fe(e, t), pe(n, c, e.bl_count);
	}
	function ye(e, t, n) {
		var r, i = -1, a, o = t[1], s = 0, c = 7, l = 4;
		for (o === 0 && (c = 138, l = 3), t[(n + 1) * 2 + 1] = 65535, r = 0; r <= n; r++) a = o, o = t[(r + 1) * 2 + 1], !(++s < c && a === o) && (s < l ? e.bl_tree[a * 2] += s : a === 0 ? s <= 10 ? e.bl_tree[C * 2]++ : e.bl_tree[w * 2]++ : (a !== i && e.bl_tree[a * 2]++, e.bl_tree[S * 2]++), s = 0, i = a, o === 0 ? (c = 138, l = 3) : a === o ? (c = 6, l = 3) : (c = 7, l = 4));
	}
	function be(e, t, n) {
		var r, i = -1, a, o = t[1], s = 0, c = 7, l = 4;
		for (o === 0 && (c = 138, l = 3), r = 0; r <= n; r++) if (a = o, o = t[(r + 1) * 2 + 1], !(++s < c && a === o)) {
			if (s < l) do
				P(e, a, e.bl_tree);
			while (--s !== 0);
			else a === 0 ? s <= 10 ? (P(e, C, e.bl_tree), N(e, s - 3, 3)) : (P(e, w, e.bl_tree), N(e, s - 11, 7)) : (a !== i && (P(e, a, e.bl_tree), s--), P(e, S, e.bl_tree), N(e, s - 3, 2));
			s = 0, i = a, o === 0 ? (c = 138, l = 3) : a === o ? (c = 6, l = 3) : (c = 7, l = 4);
		}
	}
	function R(e) {
		var t;
		for (ye(e, e.dyn_ltree, e.l_desc.max_code), ye(e, e.dyn_dtree, e.d_desc.max_code), ve(e, e.bl_desc), t = g - 1; t >= 3 && e.bl_tree[O[t] * 2 + 1] === 0; t--);
		return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
	}
	function xe(e, t, n, r) {
		var i;
		for (N(e, t - 257, 5), N(e, n - 1, 5), N(e, r - 4, 4), i = 0; i < r; i++) N(e, e.bl_tree[O[i] * 2 + 1], 3);
		be(e, e.dyn_ltree, t - 1), be(e, e.dyn_dtree, n - 1);
	}
	function z(e) {
		var t = 4093624447, n;
		for (n = 0; n <= 31; n++, t >>>= 1) if (t & 1 && e.dyn_ltree[n * 2] !== 0) return r;
		if (e.dyn_ltree[18] !== 0 || e.dyn_ltree[20] !== 0 || e.dyn_ltree[26] !== 0) return i;
		for (n = 32; n < p; n++) if (e.dyn_ltree[n * 2] !== 0) return i;
		return r;
	}
	var B = !1;
	function Se(e) {
		B ||= (me(), !0), e.l_desc = new se(e.dyn_ltree, ie), e.d_desc = new se(e.dyn_dtree, ae), e.bl_desc = new se(e.bl_tree, oe), e.bi_buf = 0, e.bi_valid = 0, F(e);
	}
	function Ce(e, t, n, r) {
		N(e, (s << 1) + +!!r, 3), he(e, t, n, !0);
	}
	function we(e) {
		N(e, c << 1, 3), P(e, x, A), de(e);
	}
	function Te(e, t, r, i) {
		var o, s, u = 0;
		e.level > 0 ? (e.strm.data_type === a && (e.strm.data_type = z(e)), ve(e, e.l_desc), ve(e, e.d_desc), u = R(e), o = e.opt_len + 3 + 7 >>> 3, s = e.static_len + 3 + 7 >>> 3, s <= o && (o = s)) : o = s = r + 5, r + 4 <= o && t !== -1 ? Ce(e, t, r, i) : e.strategy === n || s === o ? (N(e, (c << 1) + +!!i, 3), _e(e, A, j)) : (N(e, (l << 1) + +!!i, 3), xe(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, u + 1), _e(e, e.dyn_ltree, e.dyn_dtree)), F(e), i && I(e);
	}
	function Ee(e, t, n) {
		return e.pending_buf[e.d_buf + e.last_lit * 2] = t >>> 8 & 255, e.pending_buf[e.d_buf + e.last_lit * 2 + 1] = t & 255, e.pending_buf[e.l_buf + e.last_lit] = n & 255, e.last_lit++, t === 0 ? e.dyn_ltree[n * 2]++ : (e.matches++, t--, e.dyn_ltree[(ee[n] + p + 1) * 2]++, e.dyn_dtree[ce(t) * 2]++), e.last_lit === e.lit_bufsize - 1;
	}
	e._tr_init = Se, e._tr_stored_block = Ce, e._tr_flush_block = Te, e._tr_tally = Ee, e._tr_align = we;
})), XO = /* @__PURE__ */ V(((e, t) => {
	function n(e, t, n, r) {
		for (var i = e & 65535 | 0, a = e >>> 16 & 65535 | 0, o = 0; n !== 0;) {
			o = n > 2e3 ? 2e3 : n, n -= o;
			do
				i = i + t[r++] | 0, a = a + i | 0;
			while (--o);
			i %= 65521, a %= 65521;
		}
		return i | a << 16 | 0;
	}
	t.exports = n;
})), ZO = /* @__PURE__ */ V(((e, t) => {
	function n() {
		for (var e, t = [], n = 0; n < 256; n++) {
			e = n;
			for (var r = 0; r < 8; r++) e = e & 1 ? 3988292384 ^ e >>> 1 : e >>> 1;
			t[n] = e;
		}
		return t;
	}
	var r = n();
	function i(e, t, n, i) {
		var a = r, o = i + n;
		e ^= -1;
		for (var s = i; s < o; s++) e = e >>> 8 ^ a[(e ^ t[s]) & 255];
		return e ^ -1;
	}
	t.exports = i;
})), QO = /* @__PURE__ */ V(((e, t) => {
	t.exports = {
		2: "need dictionary",
		1: "stream end",
		0: "",
		"-1": "file error",
		"-2": "stream error",
		"-3": "data error",
		"-4": "insufficient memory",
		"-5": "buffer error",
		"-6": "incompatible version"
	};
})), $O = /* @__PURE__ */ V(((e) => {
	var t = JO(), n = YO(), r = XO(), i = ZO(), a = QO(), o = 0, s = 1, c = 3, l = 4, u = 5, d = 0, f = 1, p = -2, m = -3, h = -5, g = -1, _ = 1, v = 2, y = 3, b = 4, x = 0, S = 2, C = 8, w = 9, T = 15, E = 8, D = 286, O = 30, k = 19, A = 2 * D + 1, j = 15, M = 3, ee = 258, te = ee + M + 1, ne = 32, re = 42, ie = 69, ae = 73, oe = 91, se = 103, ce = 113, le = 666, N = 1, P = 2, ue = 3, de = 4, fe = 3;
	function pe(e, t) {
		return e.msg = a[t], t;
	}
	function me(e) {
		return (e << 1) - (e > 4 ? 9 : 0);
	}
	function F(e) {
		for (var t = e.length; --t >= 0;) e[t] = 0;
	}
	function I(e) {
		var n = e.state, r = n.pending;
		r > e.avail_out && (r = e.avail_out), r !== 0 && (t.arraySet(e.output, n.pending_buf, n.pending_out, r, e.next_out), e.next_out += r, n.pending_out += r, e.total_out += r, e.avail_out -= r, n.pending -= r, n.pending === 0 && (n.pending_out = 0));
	}
	function he(e, t) {
		n._tr_flush_block(e, e.block_start >= 0 ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, I(e.strm);
	}
	function L(e, t) {
		e.pending_buf[e.pending++] = t;
	}
	function ge(e, t) {
		e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = t & 255;
	}
	function _e(e, n, a, o) {
		var s = e.avail_in;
		return s > o && (s = o), s === 0 ? 0 : (e.avail_in -= s, t.arraySet(n, e.input, e.next_in, s, a), e.state.wrap === 1 ? e.adler = r(e.adler, n, s, a) : e.state.wrap === 2 && (e.adler = i(e.adler, n, s, a)), e.next_in += s, e.total_in += s, s);
	}
	function ve(e, t) {
		var n = e.max_chain_length, r = e.strstart, i, a, o = e.prev_length, s = e.nice_match, c = e.strstart > e.w_size - te ? e.strstart - (e.w_size - te) : 0, l = e.window, u = e.w_mask, d = e.prev, f = e.strstart + ee, p = l[r + o - 1], m = l[r + o];
		e.prev_length >= e.good_match && (n >>= 2), s > e.lookahead && (s = e.lookahead);
		do {
			if (i = t, l[i + o] !== m || l[i + o - 1] !== p || l[i] !== l[r] || l[++i] !== l[r + 1]) continue;
			r += 2, i++;
			do			;
while (l[++r] === l[++i] && l[++r] === l[++i] && l[++r] === l[++i] && l[++r] === l[++i] && l[++r] === l[++i] && l[++r] === l[++i] && l[++r] === l[++i] && l[++r] === l[++i] && r < f);
			if (a = ee - (f - r), r = f - ee, a > o) {
				if (e.match_start = t, o = a, a >= s) break;
				p = l[r + o - 1], m = l[r + o];
			}
		} while ((t = d[t & u]) > c && --n !== 0);
		return o <= e.lookahead ? o : e.lookahead;
	}
	function ye(e) {
		var n = e.w_size, r, i, a, o, s;
		do {
			if (o = e.window_size - e.lookahead - e.strstart, e.strstart >= n + (n - te)) {
				t.arraySet(e.window, e.window, n, n, 0), e.match_start -= n, e.strstart -= n, e.block_start -= n, i = e.hash_size, r = i;
				do
					a = e.head[--r], e.head[r] = a >= n ? a - n : 0;
				while (--i);
				i = n, r = i;
				do
					a = e.prev[--r], e.prev[r] = a >= n ? a - n : 0;
				while (--i);
				o += n;
			}
			if (e.strm.avail_in === 0) break;
			if (i = _e(e.strm, e.window, e.strstart + e.lookahead, o), e.lookahead += i, e.lookahead + e.insert >= M) for (s = e.strstart - e.insert, e.ins_h = e.window[s], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[s + M - 1]) & e.hash_mask, e.prev[s & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = s, s++, e.insert--, !(e.lookahead + e.insert < M)););
		} while (e.lookahead < te && e.strm.avail_in !== 0);
	}
	function be(e, t) {
		var n = 65535;
		for (n > e.pending_buf_size - 5 && (n = e.pending_buf_size - 5);;) {
			if (e.lookahead <= 1) {
				if (ye(e), e.lookahead === 0 && t === o) return N;
				if (e.lookahead === 0) break;
			}
			e.strstart += e.lookahead, e.lookahead = 0;
			var r = e.block_start + n;
			if ((e.strstart === 0 || e.strstart >= r) && (e.lookahead = e.strstart - r, e.strstart = r, he(e, !1), e.strm.avail_out === 0) || e.strstart - e.block_start >= e.w_size - te && (he(e, !1), e.strm.avail_out === 0)) return N;
		}
		return e.insert = 0, t === l ? (he(e, !0), e.strm.avail_out === 0 ? ue : de) : (e.strstart > e.block_start && (he(e, !1), e.strm.avail_out), N);
	}
	function R(e, t) {
		for (var r, i;;) {
			if (e.lookahead < te) {
				if (ye(e), e.lookahead < te && t === o) return N;
				if (e.lookahead === 0) break;
			}
			if (r = 0, e.lookahead >= M && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + M - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), r !== 0 && e.strstart - r <= e.w_size - te && (e.match_length = ve(e, r)), e.match_length >= M) if (i = n._tr_tally(e, e.strstart - e.match_start, e.match_length - M), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= M) {
				e.match_length--;
				do
					e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + M - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart;
				while (--e.match_length !== 0);
				e.strstart++;
			} else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
			else i = n._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
			if (i && (he(e, !1), e.strm.avail_out === 0)) return N;
		}
		return e.insert = e.strstart < M - 1 ? e.strstart : M - 1, t === l ? (he(e, !0), e.strm.avail_out === 0 ? ue : de) : e.last_lit && (he(e, !1), e.strm.avail_out === 0) ? N : P;
	}
	function xe(e, t) {
		for (var r, i, a;;) {
			if (e.lookahead < te) {
				if (ye(e), e.lookahead < te && t === o) return N;
				if (e.lookahead === 0) break;
			}
			if (r = 0, e.lookahead >= M && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + M - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = M - 1, r !== 0 && e.prev_length < e.max_lazy_match && e.strstart - r <= e.w_size - te && (e.match_length = ve(e, r), e.match_length <= 5 && (e.strategy === _ || e.match_length === M && e.strstart - e.match_start > 4096) && (e.match_length = M - 1)), e.prev_length >= M && e.match_length <= e.prev_length) {
				a = e.strstart + e.lookahead - M, i = n._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - M), e.lookahead -= e.prev_length - 1, e.prev_length -= 2;
				do
					++e.strstart <= a && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + M - 1]) & e.hash_mask, r = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart);
				while (--e.prev_length !== 0);
				if (e.match_available = 0, e.match_length = M - 1, e.strstart++, i && (he(e, !1), e.strm.avail_out === 0)) return N;
			} else if (e.match_available) {
				if (i = n._tr_tally(e, 0, e.window[e.strstart - 1]), i && he(e, !1), e.strstart++, e.lookahead--, e.strm.avail_out === 0) return N;
			} else e.match_available = 1, e.strstart++, e.lookahead--;
		}
		return e.match_available &&= (i = n._tr_tally(e, 0, e.window[e.strstart - 1]), 0), e.insert = e.strstart < M - 1 ? e.strstart : M - 1, t === l ? (he(e, !0), e.strm.avail_out === 0 ? ue : de) : e.last_lit && (he(e, !1), e.strm.avail_out === 0) ? N : P;
	}
	function z(e, t) {
		for (var r, i, a, s, c = e.window;;) {
			if (e.lookahead <= ee) {
				if (ye(e), e.lookahead <= ee && t === o) return N;
				if (e.lookahead === 0) break;
			}
			if (e.match_length = 0, e.lookahead >= M && e.strstart > 0 && (a = e.strstart - 1, i = c[a], i === c[++a] && i === c[++a] && i === c[++a])) {
				s = e.strstart + ee;
				do				;
while (i === c[++a] && i === c[++a] && i === c[++a] && i === c[++a] && i === c[++a] && i === c[++a] && i === c[++a] && i === c[++a] && a < s);
				e.match_length = ee - (s - a), e.match_length > e.lookahead && (e.match_length = e.lookahead);
			}
			if (e.match_length >= M ? (r = n._tr_tally(e, 1, e.match_length - M), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (r = n._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), r && (he(e, !1), e.strm.avail_out === 0)) return N;
		}
		return e.insert = 0, t === l ? (he(e, !0), e.strm.avail_out === 0 ? ue : de) : e.last_lit && (he(e, !1), e.strm.avail_out === 0) ? N : P;
	}
	function B(e, t) {
		for (var r;;) {
			if (e.lookahead === 0 && (ye(e), e.lookahead === 0)) {
				if (t === o) return N;
				break;
			}
			if (e.match_length = 0, r = n._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, r && (he(e, !1), e.strm.avail_out === 0)) return N;
		}
		return e.insert = 0, t === l ? (he(e, !0), e.strm.avail_out === 0 ? ue : de) : e.last_lit && (he(e, !1), e.strm.avail_out === 0) ? N : P;
	}
	function Se(e, t, n, r, i) {
		this.good_length = e, this.max_lazy = t, this.nice_length = n, this.max_chain = r, this.func = i;
	}
	var Ce = [
		new Se(0, 0, 0, 0, be),
		new Se(4, 4, 8, 4, R),
		new Se(4, 5, 16, 8, R),
		new Se(4, 6, 32, 32, R),
		new Se(4, 4, 16, 16, xe),
		new Se(8, 16, 32, 32, xe),
		new Se(8, 16, 128, 128, xe),
		new Se(8, 32, 128, 256, xe),
		new Se(32, 128, 258, 1024, xe),
		new Se(32, 258, 258, 4096, xe)
	];
	function we(e) {
		e.window_size = 2 * e.w_size, F(e.head), e.max_lazy_match = Ce[e.level].max_lazy, e.good_match = Ce[e.level].good_length, e.nice_match = Ce[e.level].nice_length, e.max_chain_length = Ce[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = M - 1, e.match_available = 0, e.ins_h = 0;
	}
	function Te() {
		this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = C, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new t.Buf16(A * 2), this.dyn_dtree = new t.Buf16((2 * O + 1) * 2), this.bl_tree = new t.Buf16((2 * k + 1) * 2), F(this.dyn_ltree), F(this.dyn_dtree), F(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new t.Buf16(j + 1), this.heap = new t.Buf16(2 * D + 1), F(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new t.Buf16(2 * D + 1), F(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
	}
	function Ee(e) {
		var t;
		return !e || !e.state ? pe(e, p) : (e.total_in = e.total_out = 0, e.data_type = S, t = e.state, t.pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? re : ce, e.adler = t.wrap === 2 ? 0 : 1, t.last_flush = o, n._tr_init(t), d);
	}
	function De(e) {
		var t = Ee(e);
		return t === d && we(e.state), t;
	}
	function Oe(e, t) {
		return !e || !e.state || e.state.wrap !== 2 ? p : (e.state.gzhead = t, d);
	}
	function ke(e, n, r, i, a, o) {
		if (!e) return p;
		var s = 1;
		if (n === g && (n = 6), i < 0 ? (s = 0, i = -i) : i > 15 && (s = 2, i -= 16), a < 1 || a > w || r !== C || i < 8 || i > 15 || n < 0 || n > 9 || o < 0 || o > b) return pe(e, p);
		i === 8 && (i = 9);
		var c = new Te();
		return e.state = c, c.strm = e, c.wrap = s, c.gzhead = null, c.w_bits = i, c.w_size = 1 << c.w_bits, c.w_mask = c.w_size - 1, c.hash_bits = a + 7, c.hash_size = 1 << c.hash_bits, c.hash_mask = c.hash_size - 1, c.hash_shift = ~~((c.hash_bits + M - 1) / M), c.window = new t.Buf8(c.w_size * 2), c.head = new t.Buf16(c.hash_size), c.prev = new t.Buf16(c.w_size), c.lit_bufsize = 1 << a + 6, c.pending_buf_size = c.lit_bufsize * 4, c.pending_buf = new t.Buf8(c.pending_buf_size), c.d_buf = 1 * c.lit_bufsize, c.l_buf = 3 * c.lit_bufsize, c.level = n, c.strategy = o, c.method = r, De(e);
	}
	function Ae(e, t) {
		return ke(e, t, C, T, E, x);
	}
	function je(e, t) {
		var r, a, m, g;
		if (!e || !e.state || t > u || t < 0) return e ? pe(e, p) : p;
		if (a = e.state, !e.output || !e.input && e.avail_in !== 0 || a.status === le && t !== l) return pe(e, e.avail_out === 0 ? h : p);
		if (a.strm = e, r = a.last_flush, a.last_flush = t, a.status === re) if (a.wrap === 2) e.adler = 0, L(a, 31), L(a, 139), L(a, 8), a.gzhead ? (L(a, +!!a.gzhead.text + (a.gzhead.hcrc ? 2 : 0) + (a.gzhead.extra ? 4 : 0) + (a.gzhead.name ? 8 : 0) + (a.gzhead.comment ? 16 : 0)), L(a, a.gzhead.time & 255), L(a, a.gzhead.time >> 8 & 255), L(a, a.gzhead.time >> 16 & 255), L(a, a.gzhead.time >> 24 & 255), L(a, a.level === 9 ? 2 : a.strategy >= v || a.level < 2 ? 4 : 0), L(a, a.gzhead.os & 255), a.gzhead.extra && a.gzhead.extra.length && (L(a, a.gzhead.extra.length & 255), L(a, a.gzhead.extra.length >> 8 & 255)), a.gzhead.hcrc && (e.adler = i(e.adler, a.pending_buf, a.pending, 0)), a.gzindex = 0, a.status = ie) : (L(a, 0), L(a, 0), L(a, 0), L(a, 0), L(a, 0), L(a, a.level === 9 ? 2 : a.strategy >= v || a.level < 2 ? 4 : 0), L(a, fe), a.status = ce);
		else {
			var _ = C + (a.w_bits - 8 << 4) << 8, b = -1;
			b = a.strategy >= v || a.level < 2 ? 0 : a.level < 6 ? 1 : a.level === 6 ? 2 : 3, _ |= b << 6, a.strstart !== 0 && (_ |= ne), _ += 31 - _ % 31, a.status = ce, ge(a, _), a.strstart !== 0 && (ge(a, e.adler >>> 16), ge(a, e.adler & 65535)), e.adler = 1;
		}
		if (a.status === ie) if (a.gzhead.extra) {
			for (m = a.pending; a.gzindex < (a.gzhead.extra.length & 65535) && !(a.pending === a.pending_buf_size && (a.gzhead.hcrc && a.pending > m && (e.adler = i(e.adler, a.pending_buf, a.pending - m, m)), I(e), m = a.pending, a.pending === a.pending_buf_size));) L(a, a.gzhead.extra[a.gzindex] & 255), a.gzindex++;
			a.gzhead.hcrc && a.pending > m && (e.adler = i(e.adler, a.pending_buf, a.pending - m, m)), a.gzindex === a.gzhead.extra.length && (a.gzindex = 0, a.status = ae);
		} else a.status = ae;
		if (a.status === ae) if (a.gzhead.name) {
			m = a.pending;
			do {
				if (a.pending === a.pending_buf_size && (a.gzhead.hcrc && a.pending > m && (e.adler = i(e.adler, a.pending_buf, a.pending - m, m)), I(e), m = a.pending, a.pending === a.pending_buf_size)) {
					g = 1;
					break;
				}
				g = a.gzindex < a.gzhead.name.length ? a.gzhead.name.charCodeAt(a.gzindex++) & 255 : 0, L(a, g);
			} while (g !== 0);
			a.gzhead.hcrc && a.pending > m && (e.adler = i(e.adler, a.pending_buf, a.pending - m, m)), g === 0 && (a.gzindex = 0, a.status = oe);
		} else a.status = oe;
		if (a.status === oe) if (a.gzhead.comment) {
			m = a.pending;
			do {
				if (a.pending === a.pending_buf_size && (a.gzhead.hcrc && a.pending > m && (e.adler = i(e.adler, a.pending_buf, a.pending - m, m)), I(e), m = a.pending, a.pending === a.pending_buf_size)) {
					g = 1;
					break;
				}
				g = a.gzindex < a.gzhead.comment.length ? a.gzhead.comment.charCodeAt(a.gzindex++) & 255 : 0, L(a, g);
			} while (g !== 0);
			a.gzhead.hcrc && a.pending > m && (e.adler = i(e.adler, a.pending_buf, a.pending - m, m)), g === 0 && (a.status = se);
		} else a.status = se;
		if (a.status === se && (a.gzhead.hcrc ? (a.pending + 2 > a.pending_buf_size && I(e), a.pending + 2 <= a.pending_buf_size && (L(a, e.adler & 255), L(a, e.adler >> 8 & 255), e.adler = 0, a.status = ce)) : a.status = ce), a.pending !== 0) {
			if (I(e), e.avail_out === 0) return a.last_flush = -1, d;
		} else if (e.avail_in === 0 && me(t) <= me(r) && t !== l) return pe(e, h);
		if (a.status === le && e.avail_in !== 0) return pe(e, h);
		if (e.avail_in !== 0 || a.lookahead !== 0 || t !== o && a.status !== le) {
			var x = a.strategy === v ? B(a, t) : a.strategy === y ? z(a, t) : Ce[a.level].func(a, t);
			if ((x === ue || x === de) && (a.status = le), x === N || x === ue) return e.avail_out === 0 && (a.last_flush = -1), d;
			if (x === P && (t === s ? n._tr_align(a) : t !== u && (n._tr_stored_block(a, 0, 0, !1), t === c && (F(a.head), a.lookahead === 0 && (a.strstart = 0, a.block_start = 0, a.insert = 0))), I(e), e.avail_out === 0)) return a.last_flush = -1, d;
		}
		return t === l ? a.wrap <= 0 ? f : (a.wrap === 2 ? (L(a, e.adler & 255), L(a, e.adler >> 8 & 255), L(a, e.adler >> 16 & 255), L(a, e.adler >> 24 & 255), L(a, e.total_in & 255), L(a, e.total_in >> 8 & 255), L(a, e.total_in >> 16 & 255), L(a, e.total_in >> 24 & 255)) : (ge(a, e.adler >>> 16), ge(a, e.adler & 65535)), I(e), a.wrap > 0 && (a.wrap = -a.wrap), a.pending === 0 ? f : d) : d;
	}
	function Me(e) {
		var t;
		return !e || !e.state ? p : (t = e.state.status, t !== re && t !== ie && t !== ae && t !== oe && t !== se && t !== ce && t !== le ? pe(e, p) : (e.state = null, t === ce ? pe(e, m) : d));
	}
	function Ne(e, n) {
		var i = n.length, a, o, s, c, l, u, f, m;
		if (!e || !e.state || (a = e.state, c = a.wrap, c === 2 || c === 1 && a.status !== re || a.lookahead)) return p;
		for (c === 1 && (e.adler = r(e.adler, n, i, 0)), a.wrap = 0, i >= a.w_size && (c === 0 && (F(a.head), a.strstart = 0, a.block_start = 0, a.insert = 0), m = new t.Buf8(a.w_size), t.arraySet(m, n, i - a.w_size, a.w_size, 0), n = m, i = a.w_size), l = e.avail_in, u = e.next_in, f = e.input, e.avail_in = i, e.next_in = 0, e.input = n, ye(a); a.lookahead >= M;) {
			o = a.strstart, s = a.lookahead - (M - 1);
			do
				a.ins_h = (a.ins_h << a.hash_shift ^ a.window[o + M - 1]) & a.hash_mask, a.prev[o & a.w_mask] = a.head[a.ins_h], a.head[a.ins_h] = o, o++;
			while (--s);
			a.strstart = o, a.lookahead = M - 1, ye(a);
		}
		return a.strstart += a.lookahead, a.block_start = a.strstart, a.insert = a.lookahead, a.lookahead = 0, a.match_length = a.prev_length = M - 1, a.match_available = 0, e.next_in = u, e.input = f, e.avail_in = l, a.wrap = c, d;
	}
	e.deflateInit = Ae, e.deflateInit2 = ke, e.deflateReset = De, e.deflateResetKeep = Ee, e.deflateSetHeader = Oe, e.deflate = je, e.deflateEnd = Me, e.deflateSetDictionary = Ne, e.deflateInfo = "pako deflate (from Nodeca project)";
})), ek = /* @__PURE__ */ V(((e, t) => {
	var n = 30, r = 12;
	t.exports = function(e, t) {
		var i = e.state, a = e.next_in, o, s, c, l, u, d, f, p, m, h, g, _, v, y, b, x, S, C, w, T, E, D = e.input, O;
		o = a + (e.avail_in - 5), s = e.next_out, O = e.output, c = s - (t - e.avail_out), l = s + (e.avail_out - 257), u = i.dmax, d = i.wsize, f = i.whave, p = i.wnext, m = i.window, h = i.hold, g = i.bits, _ = i.lencode, v = i.distcode, y = (1 << i.lenbits) - 1, b = (1 << i.distbits) - 1;
		top: do {
			g < 15 && (h += D[a++] << g, g += 8, h += D[a++] << g, g += 8), x = _[h & y];
			dolen: for (;;) {
				if (S = x >>> 24, h >>>= S, g -= S, S = x >>> 16 & 255, S === 0) O[s++] = x & 65535;
				else if (S & 16) {
					C = x & 65535, S &= 15, S && (g < S && (h += D[a++] << g, g += 8), C += h & (1 << S) - 1, h >>>= S, g -= S), g < 15 && (h += D[a++] << g, g += 8, h += D[a++] << g, g += 8), x = v[h & b];
					dodist: for (;;) {
						if (S = x >>> 24, h >>>= S, g -= S, S = x >>> 16 & 255, S & 16) {
							if (w = x & 65535, S &= 15, g < S && (h += D[a++] << g, g += 8, g < S && (h += D[a++] << g, g += 8)), w += h & (1 << S) - 1, w > u) {
								e.msg = "invalid distance too far back", i.mode = n;
								break top;
							}
							if (h >>>= S, g -= S, S = s - c, w > S) {
								if (S = w - S, S > f && i.sane) {
									e.msg = "invalid distance too far back", i.mode = n;
									break top;
								}
								if (T = 0, E = m, p === 0) {
									if (T += d - S, S < C) {
										C -= S;
										do
											O[s++] = m[T++];
										while (--S);
										T = s - w, E = O;
									}
								} else if (p < S) {
									if (T += d + p - S, S -= p, S < C) {
										C -= S;
										do
											O[s++] = m[T++];
										while (--S);
										if (T = 0, p < C) {
											S = p, C -= S;
											do
												O[s++] = m[T++];
											while (--S);
											T = s - w, E = O;
										}
									}
								} else if (T += p - S, S < C) {
									C -= S;
									do
										O[s++] = m[T++];
									while (--S);
									T = s - w, E = O;
								}
								for (; C > 2;) O[s++] = E[T++], O[s++] = E[T++], O[s++] = E[T++], C -= 3;
								C && (O[s++] = E[T++], C > 1 && (O[s++] = E[T++]));
							} else {
								T = s - w;
								do
									O[s++] = O[T++], O[s++] = O[T++], O[s++] = O[T++], C -= 3;
								while (C > 2);
								C && (O[s++] = O[T++], C > 1 && (O[s++] = O[T++]));
							}
						} else if (S & 64) {
							e.msg = "invalid distance code", i.mode = n;
							break top;
						} else {
							x = v[(x & 65535) + (h & (1 << S) - 1)];
							continue dodist;
						}
						break;
					}
				} else if (!(S & 64)) {
					x = _[(x & 65535) + (h & (1 << S) - 1)];
					continue dolen;
				} else if (S & 32) {
					i.mode = r;
					break top;
				} else {
					e.msg = "invalid literal/length code", i.mode = n;
					break top;
				}
				break;
			}
		} while (a < o && s < l);
		C = g >> 3, a -= C, g -= C << 3, h &= (1 << g) - 1, e.next_in = a, e.next_out = s, e.avail_in = a < o ? 5 + (o - a) : 5 - (a - o), e.avail_out = s < l ? 257 + (l - s) : 257 - (s - l), i.hold = h, i.bits = g;
	};
})), tk = /* @__PURE__ */ V(((e, t) => {
	var n = JO(), r = 15, i = 852, a = 592, o = 0, s = 1, c = 2, l = [
		3,
		4,
		5,
		6,
		7,
		8,
		9,
		10,
		11,
		13,
		15,
		17,
		19,
		23,
		27,
		31,
		35,
		43,
		51,
		59,
		67,
		83,
		99,
		115,
		131,
		163,
		195,
		227,
		258,
		0,
		0
	], u = [
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		16,
		17,
		17,
		17,
		17,
		18,
		18,
		18,
		18,
		19,
		19,
		19,
		19,
		20,
		20,
		20,
		20,
		21,
		21,
		21,
		21,
		16,
		72,
		78
	], d = [
		1,
		2,
		3,
		4,
		5,
		7,
		9,
		13,
		17,
		25,
		33,
		49,
		65,
		97,
		129,
		193,
		257,
		385,
		513,
		769,
		1025,
		1537,
		2049,
		3073,
		4097,
		6145,
		8193,
		12289,
		16385,
		24577,
		0,
		0
	], f = [
		16,
		16,
		16,
		16,
		17,
		17,
		18,
		18,
		19,
		19,
		20,
		20,
		21,
		21,
		22,
		22,
		23,
		23,
		24,
		24,
		25,
		25,
		26,
		26,
		27,
		27,
		28,
		28,
		29,
		29,
		64,
		64
	];
	t.exports = function(e, t, p, m, h, g, _, v) {
		var y = v.bits, b = 0, x = 0, S = 0, C = 0, w = 0, T = 0, E = 0, D = 0, O = 0, k = 0, A, j, M, ee, te, ne = null, re = 0, ie, ae = new n.Buf16(r + 1), oe = new n.Buf16(r + 1), se = null, ce = 0, le, N, P;
		for (b = 0; b <= r; b++) ae[b] = 0;
		for (x = 0; x < m; x++) ae[t[p + x]]++;
		for (w = y, C = r; C >= 1 && ae[C] === 0; C--);
		if (w > C && (w = C), C === 0) return h[g++] = 20971520, h[g++] = 20971520, v.bits = 1, 0;
		for (S = 1; S < C && ae[S] === 0; S++);
		for (w < S && (w = S), D = 1, b = 1; b <= r; b++) if (D <<= 1, D -= ae[b], D < 0) return -1;
		if (D > 0 && (e === o || C !== 1)) return -1;
		for (oe[1] = 0, b = 1; b < r; b++) oe[b + 1] = oe[b] + ae[b];
		for (x = 0; x < m; x++) t[p + x] !== 0 && (_[oe[t[p + x]]++] = x);
		if (e === o ? (ne = se = _, ie = 19) : e === s ? (ne = l, re -= 257, se = u, ce -= 257, ie = 256) : (ne = d, se = f, ie = -1), k = 0, x = 0, b = S, te = g, T = w, E = 0, M = -1, O = 1 << w, ee = O - 1, e === s && O > i || e === c && O > a) return 1;
		for (;;) {
			le = b - E, _[x] < ie ? (N = 0, P = _[x]) : _[x] > ie ? (N = se[ce + _[x]], P = ne[re + _[x]]) : (N = 96, P = 0), A = 1 << b - E, j = 1 << T, S = j;
			do
				j -= A, h[te + (k >> E) + j] = le << 24 | N << 16 | P | 0;
			while (j !== 0);
			for (A = 1 << b - 1; k & A;) A >>= 1;
			if (A === 0 ? k = 0 : (k &= A - 1, k += A), x++, --ae[b] === 0) {
				if (b === C) break;
				b = t[p + _[x]];
			}
			if (b > w && (k & ee) !== M) {
				for (E === 0 && (E = w), te += S, T = b - E, D = 1 << T; T + E < C && (D -= ae[T + E], !(D <= 0));) T++, D <<= 1;
				if (O += 1 << T, e === s && O > i || e === c && O > a) return 1;
				M = k & ee, h[M] = w << 24 | T << 16 | te - g | 0;
			}
		}
		return k !== 0 && (h[te + k] = b - E << 24 | 4194304), v.bits = w, 0;
	};
})), nk = /* @__PURE__ */ V(((e) => {
	var t = JO(), n = XO(), r = ZO(), i = ek(), a = tk(), o = 0, s = 1, c = 2, l = 4, u = 5, d = 6, f = 0, p = 1, m = 2, h = -2, g = -3, _ = -4, v = -5, y = 8, b = 1, x = 2, S = 3, C = 4, w = 5, T = 6, E = 7, D = 8, O = 9, k = 10, A = 11, j = 12, M = 13, ee = 14, te = 15, ne = 16, re = 17, ie = 18, ae = 19, oe = 20, se = 21, ce = 22, le = 23, N = 24, P = 25, ue = 26, de = 27, fe = 28, pe = 29, me = 30, F = 31, I = 32, he = 852, L = 592, ge = 15;
	function _e(e) {
		return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((e & 65280) << 8) + ((e & 255) << 24);
	}
	function ve() {
		this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new t.Buf16(320), this.work = new t.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
	}
	function ye(e) {
		var n;
		return !e || !e.state ? h : (n = e.state, e.total_in = e.total_out = n.total = 0, e.msg = "", n.wrap && (e.adler = n.wrap & 1), n.mode = b, n.last = 0, n.havedict = 0, n.dmax = 32768, n.head = null, n.hold = 0, n.bits = 0, n.lencode = n.lendyn = new t.Buf32(he), n.distcode = n.distdyn = new t.Buf32(L), n.sane = 1, n.back = -1, f);
	}
	function be(e) {
		var t;
		return !e || !e.state ? h : (t = e.state, t.wsize = 0, t.whave = 0, t.wnext = 0, ye(e));
	}
	function R(e, t) {
		var n, r;
		return !e || !e.state || (r = e.state, t < 0 ? (n = 0, t = -t) : (n = (t >> 4) + 1, t < 48 && (t &= 15)), t && (t < 8 || t > 15)) ? h : (r.window !== null && r.wbits !== t && (r.window = null), r.wrap = n, r.wbits = t, be(e));
	}
	function xe(e, t) {
		var n, r;
		return e ? (r = new ve(), e.state = r, r.window = null, n = R(e, t), n !== f && (e.state = null), n) : h;
	}
	function z(e) {
		return xe(e, ge);
	}
	var B = !0, Se, Ce;
	function we(e) {
		if (B) {
			var n;
			for (Se = new t.Buf32(512), Ce = new t.Buf32(32), n = 0; n < 144;) e.lens[n++] = 8;
			for (; n < 256;) e.lens[n++] = 9;
			for (; n < 280;) e.lens[n++] = 7;
			for (; n < 288;) e.lens[n++] = 8;
			for (a(s, e.lens, 0, 288, Se, 0, e.work, { bits: 9 }), n = 0; n < 32;) e.lens[n++] = 5;
			a(c, e.lens, 0, 32, Ce, 0, e.work, { bits: 5 }), B = !1;
		}
		e.lencode = Se, e.lenbits = 9, e.distcode = Ce, e.distbits = 5;
	}
	function Te(e, n, r, i) {
		var a, o = e.state;
		return o.window === null && (o.wsize = 1 << o.wbits, o.wnext = 0, o.whave = 0, o.window = new t.Buf8(o.wsize)), i >= o.wsize ? (t.arraySet(o.window, n, r - o.wsize, o.wsize, 0), o.wnext = 0, o.whave = o.wsize) : (a = o.wsize - o.wnext, a > i && (a = i), t.arraySet(o.window, n, r - i, a, o.wnext), i -= a, i ? (t.arraySet(o.window, n, r - i, i, 0), o.wnext = i, o.whave = o.wsize) : (o.wnext += a, o.wnext === o.wsize && (o.wnext = 0), o.whave < o.wsize && (o.whave += a))), 0;
	}
	function Ee(e, he) {
		var L, ge, ve, ye, be, R, xe, z, B, Se, Ce, Ee, De, Oe, ke = 0, Ae, je, Me, Ne, Pe, Fe, Ie, Le, Re = new t.Buf8(4), ze, Be, Ve = [
			16,
			17,
			18,
			0,
			8,
			7,
			9,
			6,
			10,
			5,
			11,
			4,
			12,
			3,
			13,
			2,
			14,
			1,
			15
		];
		if (!e || !e.state || !e.output || !e.input && e.avail_in !== 0) return h;
		L = e.state, L.mode === j && (L.mode = M), be = e.next_out, ve = e.output, xe = e.avail_out, ye = e.next_in, ge = e.input, R = e.avail_in, z = L.hold, B = L.bits, Se = R, Ce = xe, Le = f;
		inf_leave: for (;;) switch (L.mode) {
			case b:
				if (L.wrap === 0) {
					L.mode = M;
					break;
				}
				for (; B < 16;) {
					if (R === 0) break inf_leave;
					R--, z += ge[ye++] << B, B += 8;
				}
				if (L.wrap & 2 && z === 35615) {
					L.check = 0, Re[0] = z & 255, Re[1] = z >>> 8 & 255, L.check = r(L.check, Re, 2, 0), z = 0, B = 0, L.mode = x;
					break;
				}
				if (L.flags = 0, L.head && (L.head.done = !1), !(L.wrap & 1) || (((z & 255) << 8) + (z >> 8)) % 31) {
					e.msg = "incorrect header check", L.mode = me;
					break;
				}
				if ((z & 15) !== y) {
					e.msg = "unknown compression method", L.mode = me;
					break;
				}
				if (z >>>= 4, B -= 4, Ie = (z & 15) + 8, L.wbits === 0) L.wbits = Ie;
				else if (Ie > L.wbits) {
					e.msg = "invalid window size", L.mode = me;
					break;
				}
				L.dmax = 1 << Ie, e.adler = L.check = 1, L.mode = z & 512 ? k : j, z = 0, B = 0;
				break;
			case x:
				for (; B < 16;) {
					if (R === 0) break inf_leave;
					R--, z += ge[ye++] << B, B += 8;
				}
				if (L.flags = z, (L.flags & 255) !== y) {
					e.msg = "unknown compression method", L.mode = me;
					break;
				}
				if (L.flags & 57344) {
					e.msg = "unknown header flags set", L.mode = me;
					break;
				}
				L.head && (L.head.text = z >> 8 & 1), L.flags & 512 && (Re[0] = z & 255, Re[1] = z >>> 8 & 255, L.check = r(L.check, Re, 2, 0)), z = 0, B = 0, L.mode = S;
			case S:
				for (; B < 32;) {
					if (R === 0) break inf_leave;
					R--, z += ge[ye++] << B, B += 8;
				}
				L.head && (L.head.time = z), L.flags & 512 && (Re[0] = z & 255, Re[1] = z >>> 8 & 255, Re[2] = z >>> 16 & 255, Re[3] = z >>> 24 & 255, L.check = r(L.check, Re, 4, 0)), z = 0, B = 0, L.mode = C;
			case C:
				for (; B < 16;) {
					if (R === 0) break inf_leave;
					R--, z += ge[ye++] << B, B += 8;
				}
				L.head && (L.head.xflags = z & 255, L.head.os = z >> 8), L.flags & 512 && (Re[0] = z & 255, Re[1] = z >>> 8 & 255, L.check = r(L.check, Re, 2, 0)), z = 0, B = 0, L.mode = w;
			case w:
				if (L.flags & 1024) {
					for (; B < 16;) {
						if (R === 0) break inf_leave;
						R--, z += ge[ye++] << B, B += 8;
					}
					L.length = z, L.head && (L.head.extra_len = z), L.flags & 512 && (Re[0] = z & 255, Re[1] = z >>> 8 & 255, L.check = r(L.check, Re, 2, 0)), z = 0, B = 0;
				} else L.head && (L.head.extra = null);
				L.mode = T;
			case T:
				if (L.flags & 1024 && (Ee = L.length, Ee > R && (Ee = R), Ee && (L.head && (Ie = L.head.extra_len - L.length, L.head.extra || (L.head.extra = Array(L.head.extra_len)), t.arraySet(L.head.extra, ge, ye, Ee, Ie)), L.flags & 512 && (L.check = r(L.check, ge, Ee, ye)), R -= Ee, ye += Ee, L.length -= Ee), L.length)) break inf_leave;
				L.length = 0, L.mode = E;
			case E:
				if (L.flags & 2048) {
					if (R === 0) break inf_leave;
					Ee = 0;
					do
						Ie = ge[ye + Ee++], L.head && Ie && L.length < 65536 && (L.head.name += String.fromCharCode(Ie));
					while (Ie && Ee < R);
					if (L.flags & 512 && (L.check = r(L.check, ge, Ee, ye)), R -= Ee, ye += Ee, Ie) break inf_leave;
				} else L.head && (L.head.name = null);
				L.length = 0, L.mode = D;
			case D:
				if (L.flags & 4096) {
					if (R === 0) break inf_leave;
					Ee = 0;
					do
						Ie = ge[ye + Ee++], L.head && Ie && L.length < 65536 && (L.head.comment += String.fromCharCode(Ie));
					while (Ie && Ee < R);
					if (L.flags & 512 && (L.check = r(L.check, ge, Ee, ye)), R -= Ee, ye += Ee, Ie) break inf_leave;
				} else L.head && (L.head.comment = null);
				L.mode = O;
			case O:
				if (L.flags & 512) {
					for (; B < 16;) {
						if (R === 0) break inf_leave;
						R--, z += ge[ye++] << B, B += 8;
					}
					if (z !== (L.check & 65535)) {
						e.msg = "header crc mismatch", L.mode = me;
						break;
					}
					z = 0, B = 0;
				}
				L.head && (L.head.hcrc = L.flags >> 9 & 1, L.head.done = !0), e.adler = L.check = 0, L.mode = j;
				break;
			case k:
				for (; B < 32;) {
					if (R === 0) break inf_leave;
					R--, z += ge[ye++] << B, B += 8;
				}
				e.adler = L.check = _e(z), z = 0, B = 0, L.mode = A;
			case A:
				if (L.havedict === 0) return e.next_out = be, e.avail_out = xe, e.next_in = ye, e.avail_in = R, L.hold = z, L.bits = B, m;
				e.adler = L.check = 1, L.mode = j;
			case j: if (he === u || he === d) break inf_leave;
			case M:
				if (L.last) {
					z >>>= B & 7, B -= B & 7, L.mode = de;
					break;
				}
				for (; B < 3;) {
					if (R === 0) break inf_leave;
					R--, z += ge[ye++] << B, B += 8;
				}
				switch (L.last = z & 1, z >>>= 1, --B, z & 3) {
					case 0:
						L.mode = ee;
						break;
					case 1:
						if (we(L), L.mode = oe, he === d) {
							z >>>= 2, B -= 2;
							break inf_leave;
						}
						break;
					case 2:
						L.mode = re;
						break;
					case 3: e.msg = "invalid block type", L.mode = me;
				}
				z >>>= 2, B -= 2;
				break;
			case ee:
				for (z >>>= B & 7, B -= B & 7; B < 32;) {
					if (R === 0) break inf_leave;
					R--, z += ge[ye++] << B, B += 8;
				}
				if ((z & 65535) != (z >>> 16 ^ 65535)) {
					e.msg = "invalid stored block lengths", L.mode = me;
					break;
				}
				if (L.length = z & 65535, z = 0, B = 0, L.mode = te, he === d) break inf_leave;
			case te: L.mode = ne;
			case ne:
				if (Ee = L.length, Ee) {
					if (Ee > R && (Ee = R), Ee > xe && (Ee = xe), Ee === 0) break inf_leave;
					t.arraySet(ve, ge, ye, Ee, be), R -= Ee, ye += Ee, xe -= Ee, be += Ee, L.length -= Ee;
					break;
				}
				L.mode = j;
				break;
			case re:
				for (; B < 14;) {
					if (R === 0) break inf_leave;
					R--, z += ge[ye++] << B, B += 8;
				}
				if (L.nlen = (z & 31) + 257, z >>>= 5, B -= 5, L.ndist = (z & 31) + 1, z >>>= 5, B -= 5, L.ncode = (z & 15) + 4, z >>>= 4, B -= 4, L.nlen > 286 || L.ndist > 30) {
					e.msg = "too many length or distance symbols", L.mode = me;
					break;
				}
				L.have = 0, L.mode = ie;
			case ie:
				for (; L.have < L.ncode;) {
					for (; B < 3;) {
						if (R === 0) break inf_leave;
						R--, z += ge[ye++] << B, B += 8;
					}
					L.lens[Ve[L.have++]] = z & 7, z >>>= 3, B -= 3;
				}
				for (; L.have < 19;) L.lens[Ve[L.have++]] = 0;
				if (L.lencode = L.lendyn, L.lenbits = 7, ze = { bits: L.lenbits }, Le = a(o, L.lens, 0, 19, L.lencode, 0, L.work, ze), L.lenbits = ze.bits, Le) {
					e.msg = "invalid code lengths set", L.mode = me;
					break;
				}
				L.have = 0, L.mode = ae;
			case ae:
				for (; L.have < L.nlen + L.ndist;) {
					for (; ke = L.lencode[z & (1 << L.lenbits) - 1], Ae = ke >>> 24, je = ke >>> 16 & 255, Me = ke & 65535, !(Ae <= B);) {
						if (R === 0) break inf_leave;
						R--, z += ge[ye++] << B, B += 8;
					}
					if (Me < 16) z >>>= Ae, B -= Ae, L.lens[L.have++] = Me;
					else {
						if (Me === 16) {
							for (Be = Ae + 2; B < Be;) {
								if (R === 0) break inf_leave;
								R--, z += ge[ye++] << B, B += 8;
							}
							if (z >>>= Ae, B -= Ae, L.have === 0) {
								e.msg = "invalid bit length repeat", L.mode = me;
								break;
							}
							Ie = L.lens[L.have - 1], Ee = 3 + (z & 3), z >>>= 2, B -= 2;
						} else if (Me === 17) {
							for (Be = Ae + 3; B < Be;) {
								if (R === 0) break inf_leave;
								R--, z += ge[ye++] << B, B += 8;
							}
							z >>>= Ae, B -= Ae, Ie = 0, Ee = 3 + (z & 7), z >>>= 3, B -= 3;
						} else {
							for (Be = Ae + 7; B < Be;) {
								if (R === 0) break inf_leave;
								R--, z += ge[ye++] << B, B += 8;
							}
							z >>>= Ae, B -= Ae, Ie = 0, Ee = 11 + (z & 127), z >>>= 7, B -= 7;
						}
						if (L.have + Ee > L.nlen + L.ndist) {
							e.msg = "invalid bit length repeat", L.mode = me;
							break;
						}
						for (; Ee--;) L.lens[L.have++] = Ie;
					}
				}
				if (L.mode === me) break;
				if (L.lens[256] === 0) {
					e.msg = "invalid code -- missing end-of-block", L.mode = me;
					break;
				}
				if (L.lenbits = 9, ze = { bits: L.lenbits }, Le = a(s, L.lens, 0, L.nlen, L.lencode, 0, L.work, ze), L.lenbits = ze.bits, Le) {
					e.msg = "invalid literal/lengths set", L.mode = me;
					break;
				}
				if (L.distbits = 6, L.distcode = L.distdyn, ze = { bits: L.distbits }, Le = a(c, L.lens, L.nlen, L.ndist, L.distcode, 0, L.work, ze), L.distbits = ze.bits, Le) {
					e.msg = "invalid distances set", L.mode = me;
					break;
				}
				if (L.mode = oe, he === d) break inf_leave;
			case oe: L.mode = se;
			case se:
				if (R >= 6 && xe >= 258) {
					e.next_out = be, e.avail_out = xe, e.next_in = ye, e.avail_in = R, L.hold = z, L.bits = B, i(e, Ce), be = e.next_out, ve = e.output, xe = e.avail_out, ye = e.next_in, ge = e.input, R = e.avail_in, z = L.hold, B = L.bits, L.mode === j && (L.back = -1);
					break;
				}
				for (L.back = 0; ke = L.lencode[z & (1 << L.lenbits) - 1], Ae = ke >>> 24, je = ke >>> 16 & 255, Me = ke & 65535, !(Ae <= B);) {
					if (R === 0) break inf_leave;
					R--, z += ge[ye++] << B, B += 8;
				}
				if (je && !(je & 240)) {
					for (Ne = Ae, Pe = je, Fe = Me; ke = L.lencode[Fe + ((z & (1 << Ne + Pe) - 1) >> Ne)], Ae = ke >>> 24, je = ke >>> 16 & 255, Me = ke & 65535, !(Ne + Ae <= B);) {
						if (R === 0) break inf_leave;
						R--, z += ge[ye++] << B, B += 8;
					}
					z >>>= Ne, B -= Ne, L.back += Ne;
				}
				if (z >>>= Ae, B -= Ae, L.back += Ae, L.length = Me, je === 0) {
					L.mode = ue;
					break;
				}
				if (je & 32) {
					L.back = -1, L.mode = j;
					break;
				}
				if (je & 64) {
					e.msg = "invalid literal/length code", L.mode = me;
					break;
				}
				L.extra = je & 15, L.mode = ce;
			case ce:
				if (L.extra) {
					for (Be = L.extra; B < Be;) {
						if (R === 0) break inf_leave;
						R--, z += ge[ye++] << B, B += 8;
					}
					L.length += z & (1 << L.extra) - 1, z >>>= L.extra, B -= L.extra, L.back += L.extra;
				}
				L.was = L.length, L.mode = le;
			case le:
				for (; ke = L.distcode[z & (1 << L.distbits) - 1], Ae = ke >>> 24, je = ke >>> 16 & 255, Me = ke & 65535, !(Ae <= B);) {
					if (R === 0) break inf_leave;
					R--, z += ge[ye++] << B, B += 8;
				}
				if (!(je & 240)) {
					for (Ne = Ae, Pe = je, Fe = Me; ke = L.distcode[Fe + ((z & (1 << Ne + Pe) - 1) >> Ne)], Ae = ke >>> 24, je = ke >>> 16 & 255, Me = ke & 65535, !(Ne + Ae <= B);) {
						if (R === 0) break inf_leave;
						R--, z += ge[ye++] << B, B += 8;
					}
					z >>>= Ne, B -= Ne, L.back += Ne;
				}
				if (z >>>= Ae, B -= Ae, L.back += Ae, je & 64) {
					e.msg = "invalid distance code", L.mode = me;
					break;
				}
				L.offset = Me, L.extra = je & 15, L.mode = N;
			case N:
				if (L.extra) {
					for (Be = L.extra; B < Be;) {
						if (R === 0) break inf_leave;
						R--, z += ge[ye++] << B, B += 8;
					}
					L.offset += z & (1 << L.extra) - 1, z >>>= L.extra, B -= L.extra, L.back += L.extra;
				}
				if (L.offset > L.dmax) {
					e.msg = "invalid distance too far back", L.mode = me;
					break;
				}
				L.mode = P;
			case P:
				if (xe === 0) break inf_leave;
				if (Ee = Ce - xe, L.offset > Ee) {
					if (Ee = L.offset - Ee, Ee > L.whave && L.sane) {
						e.msg = "invalid distance too far back", L.mode = me;
						break;
					}
					Ee > L.wnext ? (Ee -= L.wnext, De = L.wsize - Ee) : De = L.wnext - Ee, Ee > L.length && (Ee = L.length), Oe = L.window;
				} else Oe = ve, De = be - L.offset, Ee = L.length;
				Ee > xe && (Ee = xe), xe -= Ee, L.length -= Ee;
				do
					ve[be++] = Oe[De++];
				while (--Ee);
				L.length === 0 && (L.mode = se);
				break;
			case ue:
				if (xe === 0) break inf_leave;
				ve[be++] = L.length, xe--, L.mode = se;
				break;
			case de:
				if (L.wrap) {
					for (; B < 32;) {
						if (R === 0) break inf_leave;
						R--, z |= ge[ye++] << B, B += 8;
					}
					if (Ce -= xe, e.total_out += Ce, L.total += Ce, Ce && (e.adler = L.check = L.flags ? r(L.check, ve, Ce, be - Ce) : n(L.check, ve, Ce, be - Ce)), Ce = xe, (L.flags ? z : _e(z)) !== L.check) {
						e.msg = "incorrect data check", L.mode = me;
						break;
					}
					z = 0, B = 0;
				}
				L.mode = fe;
			case fe:
				if (L.wrap && L.flags) {
					for (; B < 32;) {
						if (R === 0) break inf_leave;
						R--, z += ge[ye++] << B, B += 8;
					}
					if (z !== (L.total & 4294967295)) {
						e.msg = "incorrect length check", L.mode = me;
						break;
					}
					z = 0, B = 0;
				}
				L.mode = pe;
			case pe:
				Le = p;
				break inf_leave;
			case me:
				Le = g;
				break inf_leave;
			case F: return _;
			case I:
			default: return h;
		}
		return e.next_out = be, e.avail_out = xe, e.next_in = ye, e.avail_in = R, L.hold = z, L.bits = B, (L.wsize || Ce !== e.avail_out && L.mode < me && (L.mode < de || he !== l)) && Te(e, e.output, e.next_out, Ce - e.avail_out) ? (L.mode = F, _) : (Se -= e.avail_in, Ce -= e.avail_out, e.total_in += Se, e.total_out += Ce, L.total += Ce, L.wrap && Ce && (e.adler = L.check = L.flags ? r(L.check, ve, Ce, e.next_out - Ce) : n(L.check, ve, Ce, e.next_out - Ce)), e.data_type = L.bits + (L.last ? 64 : 0) + (L.mode === j ? 128 : 0) + (L.mode === oe || L.mode === te ? 256 : 0), (Se === 0 && Ce === 0 || he === l) && Le === f && (Le = v), Le);
	}
	function De(e) {
		if (!e || !e.state) return h;
		var t = e.state;
		return t.window &&= null, e.state = null, f;
	}
	function Oe(e, t) {
		var n;
		return !e || !e.state || (n = e.state, !(n.wrap & 2)) ? h : (n.head = t, t.done = !1, f);
	}
	function ke(e, t) {
		var r = t.length, i, a, o;
		return !e || !e.state || (i = e.state, i.wrap !== 0 && i.mode !== A) ? h : i.mode === A && (a = 1, a = n(a, t, r, 0), a !== i.check) ? g : (o = Te(e, t, r, r), o ? (i.mode = F, _) : (i.havedict = 1, f));
	}
	e.inflateReset = be, e.inflateReset2 = R, e.inflateResetKeep = ye, e.inflateInit = z, e.inflateInit2 = xe, e.inflate = Ee, e.inflateEnd = De, e.inflateGetHeader = Oe, e.inflateSetDictionary = ke, e.inflateInfo = "pako inflate (from Nodeca project)";
})), rk = /* @__PURE__ */ V(((e, t) => {
	t.exports = {
		Z_NO_FLUSH: 0,
		Z_PARTIAL_FLUSH: 1,
		Z_SYNC_FLUSH: 2,
		Z_FULL_FLUSH: 3,
		Z_FINISH: 4,
		Z_BLOCK: 5,
		Z_TREES: 6,
		Z_OK: 0,
		Z_STREAM_END: 1,
		Z_NEED_DICT: 2,
		Z_ERRNO: -1,
		Z_STREAM_ERROR: -2,
		Z_DATA_ERROR: -3,
		Z_BUF_ERROR: -5,
		Z_NO_COMPRESSION: 0,
		Z_BEST_SPEED: 1,
		Z_BEST_COMPRESSION: 9,
		Z_DEFAULT_COMPRESSION: -1,
		Z_FILTERED: 1,
		Z_HUFFMAN_ONLY: 2,
		Z_RLE: 3,
		Z_FIXED: 4,
		Z_DEFAULT_STRATEGY: 0,
		Z_BINARY: 0,
		Z_TEXT: 1,
		Z_UNKNOWN: 2,
		Z_DEFLATED: 8
	};
})), ik = /* @__PURE__ */ V(((e, t) => {
	t.exports = {};
})), ak = /* @__PURE__ */ V(((e, t) => {
	(function(n, r) {
		typeof e == "object" ? t.exports = e = r() : typeof define == "function" && define.amd ? define([], r) : n.CryptoJS = r();
	})(e, function() {
		var e = e || function(e, t) {
			var n;
			if (typeof window < "u" && window.crypto && (n = window.crypto), typeof self < "u" && self.crypto && (n = self.crypto), typeof globalThis < "u" && globalThis.crypto && (n = globalThis.crypto), !n && typeof window < "u" && window.msCrypto && (n = window.msCrypto), !n && typeof global < "u" && global.crypto && (n = global.crypto), !n && typeof St == "function") try {
				n = ik();
			} catch {}
			var r = function() {
				if (n) {
					if (typeof n.getRandomValues == "function") try {
						return n.getRandomValues(new Uint32Array(1))[0];
					} catch {}
					if (typeof n.randomBytes == "function") try {
						return n.randomBytes(4).readInt32LE();
					} catch {}
				}
				throw Error("Native crypto module could not be used to get secure random number.");
			}, i = Object.create || function() {
				function e() {}
				return function(t) {
					var n;
					return e.prototype = t, n = new e(), e.prototype = null, n;
				};
			}(), a = {}, o = a.lib = {}, s = o.Base = function() {
				return {
					extend: function(e) {
						var t = i(this);
						return e && t.mixIn(e), (!t.hasOwnProperty("init") || this.init === t.init) && (t.init = function() {
							t.$super.init.apply(this, arguments);
						}), t.init.prototype = t, t.$super = this, t;
					},
					create: function() {
						var e = this.extend();
						return e.init.apply(e, arguments), e;
					},
					init: function() {},
					mixIn: function(e) {
						for (var t in e) e.hasOwnProperty(t) && (this[t] = e[t]);
						e.hasOwnProperty("toString") && (this.toString = e.toString);
					},
					clone: function() {
						return this.init.prototype.extend(this);
					}
				};
			}(), c = o.WordArray = s.extend({
				init: function(e, n) {
					e = this.words = e || [], n == t ? this.sigBytes = e.length * 4 : this.sigBytes = n;
				},
				toString: function(e) {
					return (e || u).stringify(this);
				},
				concat: function(e) {
					var t = this.words, n = e.words, r = this.sigBytes, i = e.sigBytes;
					if (this.clamp(), r % 4) for (var a = 0; a < i; a++) {
						var o = n[a >>> 2] >>> 24 - a % 4 * 8 & 255;
						t[r + a >>> 2] |= o << 24 - (r + a) % 4 * 8;
					}
					else for (var s = 0; s < i; s += 4) t[r + s >>> 2] = n[s >>> 2];
					return this.sigBytes += i, this;
				},
				clamp: function() {
					var t = this.words, n = this.sigBytes;
					t[n >>> 2] &= 4294967295 << 32 - n % 4 * 8, t.length = e.ceil(n / 4);
				},
				clone: function() {
					var e = s.clone.call(this);
					return e.words = this.words.slice(0), e;
				},
				random: function(e) {
					for (var t = [], n = 0; n < e; n += 4) t.push(r());
					return new c.init(t, e);
				}
			}), l = a.enc = {}, u = l.Hex = {
				stringify: function(e) {
					for (var t = e.words, n = e.sigBytes, r = [], i = 0; i < n; i++) {
						var a = t[i >>> 2] >>> 24 - i % 4 * 8 & 255;
						r.push((a >>> 4).toString(16)), r.push((a & 15).toString(16));
					}
					return r.join("");
				},
				parse: function(e) {
					for (var t = e.length, n = [], r = 0; r < t; r += 2) n[r >>> 3] |= parseInt(e.substr(r, 2), 16) << 24 - r % 8 * 4;
					return new c.init(n, t / 2);
				}
			}, d = l.Latin1 = {
				stringify: function(e) {
					for (var t = e.words, n = e.sigBytes, r = [], i = 0; i < n; i++) {
						var a = t[i >>> 2] >>> 24 - i % 4 * 8 & 255;
						r.push(String.fromCharCode(a));
					}
					return r.join("");
				},
				parse: function(e) {
					for (var t = e.length, n = [], r = 0; r < t; r++) n[r >>> 2] |= (e.charCodeAt(r) & 255) << 24 - r % 4 * 8;
					return new c.init(n, t);
				}
			}, f = l.Utf8 = {
				stringify: function(e) {
					try {
						return decodeURIComponent(escape(d.stringify(e)));
					} catch {
						throw Error("Malformed UTF-8 data");
					}
				},
				parse: function(e) {
					return d.parse(unescape(encodeURIComponent(e)));
				}
			}, p = o.BufferedBlockAlgorithm = s.extend({
				reset: function() {
					this._data = new c.init(), this._nDataBytes = 0;
				},
				_append: function(e) {
					typeof e == "string" && (e = f.parse(e)), this._data.concat(e), this._nDataBytes += e.sigBytes;
				},
				_process: function(t) {
					var n, r = this._data, i = r.words, a = r.sigBytes, o = this.blockSize, s = a / (o * 4);
					s = t ? e.ceil(s) : e.max((s | 0) - this._minBufferSize, 0);
					var l = s * o, u = e.min(l * 4, a);
					if (l) {
						for (var d = 0; d < l; d += o) this._doProcessBlock(i, d);
						n = i.splice(0, l), r.sigBytes -= u;
					}
					return new c.init(n, u);
				},
				clone: function() {
					var e = s.clone.call(this);
					return e._data = this._data.clone(), e;
				},
				_minBufferSize: 0
			});
			o.Hasher = p.extend({
				cfg: s.extend(),
				init: function(e) {
					this.cfg = this.cfg.extend(e), this.reset();
				},
				reset: function() {
					p.reset.call(this), this._doReset();
				},
				update: function(e) {
					return this._append(e), this._process(), this;
				},
				finalize: function(e) {
					return e && this._append(e), this._doFinalize();
				},
				blockSize: 512 / 32,
				_createHelper: function(e) {
					return function(t, n) {
						return new e.init(n).finalize(t);
					};
				},
				_createHmacHelper: function(e) {
					return function(t, n) {
						return new m.HMAC.init(e, n).finalize(t);
					};
				}
			});
			var m = a.algo = {};
			return a;
		}(Math);
		return e;
	});
})), ok = /* @__PURE__ */ V(((e, t) => {
	(function(n, r) {
		typeof e == "object" ? t.exports = e = r(ak()) : typeof define == "function" && define.amd ? define(["./core"], r) : r(n.CryptoJS);
	})(e, function(e) {
		return (function(t) {
			var n = e, r = n.lib, i = r.WordArray, a = r.Hasher, o = n.algo, s = [];
			(function() {
				for (var e = 0; e < 64; e++) s[e] = t.abs(t.sin(e + 1)) * 4294967296 | 0;
			})();
			var c = o.MD5 = a.extend({
				_doReset: function() {
					this._hash = new i.init([
						1732584193,
						4023233417,
						2562383102,
						271733878
					]);
				},
				_doProcessBlock: function(e, t) {
					for (var n = 0; n < 16; n++) {
						var r = t + n, i = e[r];
						e[r] = (i << 8 | i >>> 24) & 16711935 | (i << 24 | i >>> 8) & 4278255360;
					}
					var a = this._hash.words, o = e[t + 0], c = e[t + 1], p = e[t + 2], m = e[t + 3], h = e[t + 4], g = e[t + 5], _ = e[t + 6], v = e[t + 7], y = e[t + 8], b = e[t + 9], x = e[t + 10], S = e[t + 11], C = e[t + 12], w = e[t + 13], T = e[t + 14], E = e[t + 15], D = a[0], O = a[1], k = a[2], A = a[3];
					D = l(D, O, k, A, o, 7, s[0]), A = l(A, D, O, k, c, 12, s[1]), k = l(k, A, D, O, p, 17, s[2]), O = l(O, k, A, D, m, 22, s[3]), D = l(D, O, k, A, h, 7, s[4]), A = l(A, D, O, k, g, 12, s[5]), k = l(k, A, D, O, _, 17, s[6]), O = l(O, k, A, D, v, 22, s[7]), D = l(D, O, k, A, y, 7, s[8]), A = l(A, D, O, k, b, 12, s[9]), k = l(k, A, D, O, x, 17, s[10]), O = l(O, k, A, D, S, 22, s[11]), D = l(D, O, k, A, C, 7, s[12]), A = l(A, D, O, k, w, 12, s[13]), k = l(k, A, D, O, T, 17, s[14]), O = l(O, k, A, D, E, 22, s[15]), D = u(D, O, k, A, c, 5, s[16]), A = u(A, D, O, k, _, 9, s[17]), k = u(k, A, D, O, S, 14, s[18]), O = u(O, k, A, D, o, 20, s[19]), D = u(D, O, k, A, g, 5, s[20]), A = u(A, D, O, k, x, 9, s[21]), k = u(k, A, D, O, E, 14, s[22]), O = u(O, k, A, D, h, 20, s[23]), D = u(D, O, k, A, b, 5, s[24]), A = u(A, D, O, k, T, 9, s[25]), k = u(k, A, D, O, m, 14, s[26]), O = u(O, k, A, D, y, 20, s[27]), D = u(D, O, k, A, w, 5, s[28]), A = u(A, D, O, k, p, 9, s[29]), k = u(k, A, D, O, v, 14, s[30]), O = u(O, k, A, D, C, 20, s[31]), D = d(D, O, k, A, g, 4, s[32]), A = d(A, D, O, k, y, 11, s[33]), k = d(k, A, D, O, S, 16, s[34]), O = d(O, k, A, D, T, 23, s[35]), D = d(D, O, k, A, c, 4, s[36]), A = d(A, D, O, k, h, 11, s[37]), k = d(k, A, D, O, v, 16, s[38]), O = d(O, k, A, D, x, 23, s[39]), D = d(D, O, k, A, w, 4, s[40]), A = d(A, D, O, k, o, 11, s[41]), k = d(k, A, D, O, m, 16, s[42]), O = d(O, k, A, D, _, 23, s[43]), D = d(D, O, k, A, b, 4, s[44]), A = d(A, D, O, k, C, 11, s[45]), k = d(k, A, D, O, E, 16, s[46]), O = d(O, k, A, D, p, 23, s[47]), D = f(D, O, k, A, o, 6, s[48]), A = f(A, D, O, k, v, 10, s[49]), k = f(k, A, D, O, T, 15, s[50]), O = f(O, k, A, D, g, 21, s[51]), D = f(D, O, k, A, C, 6, s[52]), A = f(A, D, O, k, m, 10, s[53]), k = f(k, A, D, O, x, 15, s[54]), O = f(O, k, A, D, c, 21, s[55]), D = f(D, O, k, A, y, 6, s[56]), A = f(A, D, O, k, E, 10, s[57]), k = f(k, A, D, O, _, 15, s[58]), O = f(O, k, A, D, w, 21, s[59]), D = f(D, O, k, A, h, 6, s[60]), A = f(A, D, O, k, S, 10, s[61]), k = f(k, A, D, O, p, 15, s[62]), O = f(O, k, A, D, b, 21, s[63]), a[0] = a[0] + D | 0, a[1] = a[1] + O | 0, a[2] = a[2] + k | 0, a[3] = a[3] + A | 0;
				},
				_doFinalize: function() {
					var e = this._data, n = e.words, r = this._nDataBytes * 8, i = e.sigBytes * 8;
					n[i >>> 5] |= 128 << 24 - i % 32;
					var a = t.floor(r / 4294967296), o = r;
					n[(i + 64 >>> 9 << 4) + 15] = (a << 8 | a >>> 24) & 16711935 | (a << 24 | a >>> 8) & 4278255360, n[(i + 64 >>> 9 << 4) + 14] = (o << 8 | o >>> 24) & 16711935 | (o << 24 | o >>> 8) & 4278255360, e.sigBytes = (n.length + 1) * 4, this._process();
					for (var s = this._hash, c = s.words, l = 0; l < 4; l++) {
						var u = c[l];
						c[l] = (u << 8 | u >>> 24) & 16711935 | (u << 24 | u >>> 8) & 4278255360;
					}
					return s;
				},
				clone: function() {
					var e = a.clone.call(this);
					return e._hash = this._hash.clone(), e;
				}
			});
			function l(e, t, n, r, i, a, o) {
				var s = e + (t & n | ~t & r) + i + o;
				return (s << a | s >>> 32 - a) + t;
			}
			function u(e, t, n, r, i, a, o) {
				var s = e + (t & r | n & ~r) + i + o;
				return (s << a | s >>> 32 - a) + t;
			}
			function d(e, t, n, r, i, a, o) {
				var s = e + (t ^ n ^ r) + i + o;
				return (s << a | s >>> 32 - a) + t;
			}
			function f(e, t, n, r, i, a, o) {
				var s = e + (n ^ (t | ~r)) + i + o;
				return (s << a | s >>> 32 - a) + t;
			}
			n.MD5 = a._createHelper(c), n.HmacMD5 = a._createHmacHelper(c);
		})(Math), e.MD5;
	});
})), sk = /* @__PURE__ */ V(((e) => {
	var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	(function(e) {
		var n = typeof Uint8Array < "u" ? Uint8Array : Array, r = 43, i = 47, a = 48, o = 97, s = 65, c = 45, l = 95;
		function u(e) {
			var t = e.charCodeAt(0);
			if (t === r || t === c) return 62;
			if (t === i || t === l) return 63;
			if (t < a) return -1;
			if (t < a + 10) return t - a + 26 + 26;
			if (t < s + 26) return t - s;
			if (t < o + 26) return t - o + 26;
		}
		function d(e) {
			var t, r, i, a, o, s;
			if (e.length % 4 > 0) throw Error("Invalid string. Length must be a multiple of 4");
			var c = e.length;
			o = e.charAt(c - 2) === "=" ? 2 : +(e.charAt(c - 1) === "="), s = new n(e.length * 3 / 4 - o), i = o > 0 ? e.length - 4 : e.length;
			var l = 0;
			function d(e) {
				s[l++] = e;
			}
			for (t = 0, r = 0; t < i; t += 4, r += 3) a = u(e.charAt(t)) << 18 | u(e.charAt(t + 1)) << 12 | u(e.charAt(t + 2)) << 6 | u(e.charAt(t + 3)), d((a & 16711680) >> 16), d((a & 65280) >> 8), d(a & 255);
			return o === 2 ? (a = u(e.charAt(t)) << 2 | u(e.charAt(t + 1)) >> 4, d(a & 255)) : o === 1 && (a = u(e.charAt(t)) << 10 | u(e.charAt(t + 1)) << 4 | u(e.charAt(t + 2)) >> 2, d(a >> 8 & 255), d(a & 255)), s;
		}
		function f(e) {
			var n, r = e.length % 3, i = "", a, o;
			function s(e) {
				return t.charAt(e);
			}
			function c(e) {
				return s(e >> 18 & 63) + s(e >> 12 & 63) + s(e >> 6 & 63) + s(e & 63);
			}
			for (n = 0, o = e.length - r; n < o; n += 3) a = (e[n] << 16) + (e[n + 1] << 8) + e[n + 2], i += c(a);
			switch (r) {
				case 1:
					a = e[e.length - 1], i += s(a >> 2), i += s(a << 4 & 63), i += "==";
					break;
				case 2:
					a = (e[e.length - 2] << 8) + e[e.length - 1], i += s(a >> 10), i += s(a >> 4 & 63), i += s(a << 2 & 63), i += "=";
					break;
			}
			return i;
		}
		e.toByteArray = d, e.fromByteArray = f;
	})(e === void 0 ? e.base64js = {} : e);
})), ck = /* @__PURE__ */ xt(qO(), 1), lk = /* @__PURE__ */ xt($O(), 1), uk = /* @__PURE__ */ xt(nk(), 1), dk = /* @__PURE__ */ xt(rk(), 1), fk = /* @__PURE__ */ xt(ok(), 1), pk = /* @__PURE__ */ xt(sk(), 1), mk = {}, hk = 5, gk = 12, _k = 13, vk = 16, yk = 17, bk = 22, xk = 28, Sk = 31, Ck = 33, wk = 34, Tk = 35, Ek = 36, Dk = 37, Ok = 38, kk = 39, Ak = 40, jk = 41, Mk = 42, J = 0, Y = 1, Nk = 2, Pk = 3, X = 4, Fk = [
	[
		X,
		X,
		X,
		X,
		X,
		X,
		X,
		X,
		X,
		X,
		X,
		X,
		X,
		X,
		X,
		X,
		X,
		X,
		X,
		X,
		X,
		Pk,
		X,
		X,
		X,
		X,
		X,
		X,
		X,
		X,
		X,
		X,
		X
	],
	[
		J,
		X,
		X,
		Y,
		Y,
		X,
		X,
		X,
		X,
		Y,
		Y,
		J,
		J,
		J,
		J,
		Y,
		Y,
		Y,
		J,
		J,
		X,
		Nk,
		X,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		Y,
		J
	],
	[
		J,
		X,
		X,
		Y,
		Y,
		X,
		X,
		X,
		X,
		Y,
		Y,
		Y,
		Y,
		Y,
		J,
		Y,
		Y,
		Y,
		J,
		J,
		X,
		Nk,
		X,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		Y,
		J
	],
	[
		X,
		X,
		X,
		Y,
		Y,
		Y,
		X,
		X,
		X,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		X,
		Nk,
		X,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y
	],
	[
		Y,
		X,
		X,
		Y,
		Y,
		Y,
		X,
		X,
		X,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		X,
		Nk,
		X,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y
	],
	[
		J,
		X,
		X,
		Y,
		Y,
		Y,
		X,
		X,
		X,
		J,
		J,
		J,
		J,
		J,
		J,
		Y,
		Y,
		Y,
		J,
		J,
		X,
		Nk,
		X,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		Y,
		J
	],
	[
		J,
		X,
		X,
		Y,
		Y,
		Y,
		X,
		X,
		X,
		J,
		J,
		J,
		J,
		J,
		J,
		Y,
		Y,
		Y,
		J,
		J,
		X,
		Nk,
		X,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		Y,
		J
	],
	[
		J,
		X,
		X,
		Y,
		Y,
		Y,
		X,
		X,
		X,
		J,
		J,
		Y,
		J,
		Y,
		J,
		Y,
		Y,
		Y,
		J,
		J,
		X,
		Nk,
		X,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		Y,
		J
	],
	[
		J,
		X,
		X,
		Y,
		Y,
		Y,
		X,
		X,
		X,
		J,
		J,
		Y,
		Y,
		Y,
		J,
		Y,
		Y,
		Y,
		J,
		J,
		X,
		Nk,
		X,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		Y,
		J
	],
	[
		Y,
		X,
		X,
		Y,
		Y,
		Y,
		X,
		X,
		X,
		J,
		J,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		J,
		J,
		X,
		Nk,
		X,
		Y,
		Y,
		Y,
		Y,
		Y,
		J,
		Y,
		Y,
		Y,
		J
	],
	[
		Y,
		X,
		X,
		Y,
		Y,
		Y,
		X,
		X,
		X,
		J,
		J,
		Y,
		Y,
		Y,
		J,
		Y,
		Y,
		Y,
		J,
		J,
		X,
		Nk,
		X,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		Y,
		J
	],
	[
		Y,
		X,
		X,
		Y,
		Y,
		Y,
		X,
		X,
		X,
		Y,
		Y,
		Y,
		Y,
		Y,
		J,
		Y,
		Y,
		Y,
		J,
		J,
		X,
		Nk,
		X,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		Y,
		J
	],
	[
		Y,
		X,
		X,
		Y,
		Y,
		Y,
		X,
		X,
		X,
		Y,
		Y,
		Y,
		Y,
		Y,
		J,
		Y,
		Y,
		Y,
		J,
		J,
		X,
		Nk,
		X,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		Y,
		J
	],
	[
		Y,
		X,
		X,
		Y,
		Y,
		Y,
		X,
		X,
		X,
		Y,
		Y,
		Y,
		Y,
		Y,
		J,
		Y,
		Y,
		Y,
		J,
		J,
		X,
		Nk,
		X,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		Y,
		J
	],
	[
		J,
		X,
		X,
		Y,
		Y,
		Y,
		X,
		X,
		X,
		J,
		Y,
		J,
		J,
		J,
		J,
		Y,
		Y,
		Y,
		J,
		J,
		X,
		Nk,
		X,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		Y,
		J
	],
	[
		J,
		X,
		X,
		Y,
		Y,
		Y,
		X,
		X,
		X,
		J,
		J,
		J,
		J,
		J,
		J,
		Y,
		Y,
		Y,
		J,
		J,
		X,
		Nk,
		X,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		Y,
		J
	],
	[
		J,
		X,
		X,
		Y,
		J,
		Y,
		X,
		X,
		X,
		J,
		J,
		Y,
		J,
		J,
		J,
		Y,
		Y,
		Y,
		J,
		J,
		X,
		Nk,
		X,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		Y,
		J
	],
	[
		J,
		X,
		X,
		Y,
		J,
		Y,
		X,
		X,
		X,
		J,
		J,
		J,
		J,
		J,
		J,
		Y,
		Y,
		Y,
		J,
		J,
		X,
		Nk,
		X,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		Y,
		J
	],
	[
		Y,
		X,
		X,
		Y,
		Y,
		Y,
		X,
		X,
		X,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		X,
		Nk,
		X,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		J
	],
	[
		J,
		X,
		X,
		Y,
		Y,
		Y,
		X,
		X,
		X,
		J,
		J,
		J,
		J,
		J,
		J,
		Y,
		Y,
		Y,
		J,
		X,
		X,
		Nk,
		X,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		Y,
		J
	],
	[
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		X,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J
	],
	[
		Y,
		X,
		X,
		Y,
		Y,
		Y,
		X,
		X,
		X,
		Y,
		Y,
		Y,
		Y,
		Y,
		J,
		Y,
		Y,
		Y,
		J,
		J,
		X,
		Nk,
		X,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		Y,
		J
	],
	[
		Y,
		X,
		X,
		Y,
		Y,
		Y,
		X,
		X,
		X,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		X,
		Nk,
		X,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y,
		Y
	],
	[
		J,
		X,
		X,
		Y,
		Y,
		Y,
		X,
		X,
		X,
		J,
		Y,
		J,
		J,
		J,
		J,
		Y,
		Y,
		Y,
		J,
		J,
		X,
		Nk,
		X,
		J,
		J,
		J,
		Y,
		Y,
		J,
		J,
		J,
		Y,
		J
	],
	[
		J,
		X,
		X,
		Y,
		Y,
		Y,
		X,
		X,
		X,
		J,
		Y,
		J,
		J,
		J,
		J,
		Y,
		Y,
		Y,
		J,
		J,
		X,
		Nk,
		X,
		J,
		J,
		J,
		J,
		Y,
		J,
		J,
		J,
		Y,
		J
	],
	[
		J,
		X,
		X,
		Y,
		Y,
		Y,
		X,
		X,
		X,
		J,
		Y,
		J,
		J,
		J,
		J,
		Y,
		Y,
		Y,
		J,
		J,
		X,
		Nk,
		X,
		Y,
		Y,
		Y,
		Y,
		J,
		J,
		J,
		J,
		Y,
		J
	],
	[
		J,
		X,
		X,
		Y,
		Y,
		Y,
		X,
		X,
		X,
		J,
		Y,
		J,
		J,
		J,
		J,
		Y,
		Y,
		Y,
		J,
		J,
		X,
		Nk,
		X,
		J,
		J,
		J,
		Y,
		Y,
		J,
		J,
		J,
		Y,
		J
	],
	[
		J,
		X,
		X,
		Y,
		Y,
		Y,
		X,
		X,
		X,
		J,
		Y,
		J,
		J,
		J,
		J,
		Y,
		Y,
		Y,
		J,
		J,
		X,
		Nk,
		X,
		J,
		J,
		J,
		J,
		Y,
		J,
		J,
		J,
		Y,
		J
	],
	[
		J,
		X,
		X,
		Y,
		Y,
		Y,
		X,
		X,
		X,
		J,
		J,
		J,
		J,
		J,
		J,
		Y,
		Y,
		Y,
		J,
		J,
		X,
		Nk,
		X,
		J,
		J,
		J,
		J,
		J,
		Y,
		J,
		J,
		Y,
		J
	],
	[
		J,
		X,
		X,
		Y,
		Y,
		Y,
		X,
		X,
		X,
		J,
		Y,
		J,
		J,
		J,
		J,
		Y,
		Y,
		Y,
		J,
		J,
		X,
		Nk,
		X,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		Y,
		Y,
		J
	],
	[
		J,
		X,
		X,
		Y,
		Y,
		Y,
		X,
		X,
		X,
		J,
		Y,
		J,
		J,
		J,
		J,
		Y,
		Y,
		Y,
		J,
		J,
		X,
		Nk,
		X,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		Y,
		J
	],
	[
		Y,
		X,
		X,
		Y,
		Y,
		Y,
		X,
		X,
		X,
		Y,
		Y,
		Y,
		Y,
		Y,
		J,
		Y,
		Y,
		Y,
		J,
		J,
		X,
		Nk,
		X,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		Y,
		J
	],
	[
		J,
		X,
		X,
		Y,
		Y,
		J,
		X,
		X,
		X,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		X,
		Nk,
		X,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		J,
		Y,
		J
	]
], Ik = new Wy.default(pk.default.toByteArray("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")), Lk = function(e) {
	switch (e) {
		case Ck: return gk;
		case kk:
		case Ak:
		case Mk: return gk;
		case Tk: return hk;
		default: return e;
	}
}, Rk = function(e) {
	switch (e) {
		case Dk:
		case Ok: return wk;
		case jk: return bk;
		default: return e;
	}
}, zk = class {
	constructor(e, t = !1) {
		this.position = e, this.required = t;
	}
};
mk = class {
	nextCodePoint() {
		let e = this.string.charCodeAt(this.pos++), t = this.string.charCodeAt(this.pos);
		return 55296 <= e && e <= 56319 && 56320 <= t && t <= 57343 ? (this.pos++, (e - 55296) * 1024 + (t - 56320) + 65536) : e;
	}
	nextCharClass() {
		return Lk(Ik.get(this.nextCodePoint()));
	}
	getSimpleBreak() {
		switch (this.nextClass) {
			case jk: return !1;
			case wk:
			case Dk:
			case Ok: return this.curClass = wk, !1;
			case Ek: return this.curClass = Ek, !1;
		}
		return null;
	}
	getPairTableBreak(e) {
		let t = !1;
		switch (Fk[this.curClass][this.nextClass]) {
			case J:
				t = !0;
				break;
			case Y:
				t = e === jk;
				break;
			case Nk:
				if (t = e === jk, !t) return t = !1, t;
				break;
			case Pk:
				if (e !== jk) return t;
				break;
			case X: break;
		}
		return this.LB8a && (t = !1), this.LB21a && (this.curClass === vk || this.curClass === yk) ? (t = !1, this.LB21a = !1) : this.LB21a = this.curClass === _k, this.curClass === xk ? (this.LB30a++, this.LB30a == 2 && this.nextClass === xk && (t = !0, this.LB30a = 0)) : this.LB30a = 0, this.curClass = this.nextClass, t;
	}
	nextBreak() {
		if (this.curClass == null) {
			let e = this.nextCharClass();
			this.curClass = Rk(e), this.nextClass = e, this.LB8a = e === Sk, this.LB30a = 0;
		}
		for (; this.pos < this.string.length;) {
			this.lastPos = this.pos;
			let e = this.nextClass;
			if (this.nextClass = this.nextCharClass(), this.curClass === wk || this.curClass === Ek && this.nextClass !== Dk) return this.curClass = Rk(Lk(this.nextClass)), new zk(this.lastPos, !0);
			let t = this.getSimpleBreak();
			if (t === null && (t = this.getPairTableBreak(e)), this.LB8a = this.nextClass === Sk, t) return new zk(this.lastPos);
		}
		return this.lastPos < this.string.length ? (this.lastPos = this.string.length, new zk(this.string.length)) : null;
	}
	constructor(e) {
		this.string = e, this.pos = 0, this.lastPos = 0, this.curClass = null, this.nextClass = null, this.LB8a = !1, this.LB21a = !1, this.LB30a = 0;
	}
};
var Bk = {
	name: () => "DAC",
	length: yy,
	tables: new G(new K({
		identifier: new jy(1),
		value: new jy(1)
	}), (e) => e.length / 2)
}, Vk = (e, t) => e[t], Hk = (e, t) => e[t] << 8 | e[t + 1], Uk = (e, t) => e[t] | e[t + 1] << 8, Wk = (e, t) => Xk(e, t) >>> 0, Gk = (e, t) => Zk(e, t) >>> 0, Kk = (e) => Array.from(e, (e) => e.toString(16).padStart(2, "0")).join(""), qk = new TextDecoder("utf-8"), Jk = (e) => qk.decode(e), Yk = (e) => {
	let t = e.reduce((e, t) => e + t.length, 0), n = new Uint8Array(t), r = 0;
	return e.forEach((e) => {
		n.set(e, r), r += e.length;
	}), n;
}, Xk = (e, t) => e[t] << 24 | e[t + 1] << 16 | e[t + 2] << 8 | e[t + 3], Zk = (e, t) => e[t] | e[t + 1] << 8 | e[t + 2] << 16 | e[t + 3] << 24, Qk = {
	name: () => "DHT",
	length: yy,
	tables: new class {
		decode(e, t) {
			let n = {}, r = e.buffer.slice(e.pos, e.pos + t.length - 2);
			for (; r.length > 0;) {
				let e = 1, t = [], i = Vk(r, 0), a = r.slice(e, e + 16);
				e += 16;
				for (let n of a) t.push(r.slice(e, e + n)), e += n;
				r = r.slice(e), n[i] = Yk(t);
			}
			return e.pos += t.length - 2, n;
		}
	}()
}, $k = {
	name: () => "DQT",
	length: yy,
	tables: new G(new K({
		identifier: new jy(1),
		data: new jy(64)
	}), (e) => (e.length - 2) / 65)
}, eA = {
	name: () => "DRI",
	length: yy,
	restartInterval: yy
}, tA = {
	name: () => "EOI",
	afterEOI: new Ny(vy, Infinity)
}, nA = {
	ifd: {
		"010e": "imageDescription",
		"010f": "make",
		"011a": "xResolution",
		"011b": "yResolution",
		"011c": "planarConfiguration",
		"012d": "transferFunction",
		"013b": "artist",
		"013e": "whitePoint",
		"013f": "primaryChromaticities",
		"0100": "imageWidth",
		"0101": "imageHeight",
		"0102": "bitsPerSample",
		"0103": "compression",
		"0106": "photometricInterpretation",
		"0110": "model",
		"0111": "stripOffsets",
		"0112": "orientation",
		"0115": "samplesPerPixel",
		"0116": "rowsPerStrip",
		"0117": "stripByteCounts",
		"0128": "resolutionUnit",
		"0131": "software",
		"0132": "dateTime",
		"0201": "jpegInterchangeFormat",
		"0202": "jpegInterchangeFormatLength",
		"0211": "ycbCrCoefficients",
		"0212": "ycbCrSubSampling",
		"0213": "ycbCrPositioning",
		"0214": "referenceBlackWhite",
		"829a": "exposureTime",
		"829d": "fNumber",
		"920a": "focalLength",
		"927c": "makerNote",
		8298: "copyright",
		8769: "exifIFDPointer",
		8822: "exposureProgram",
		8824: "spectralSensitivity",
		8825: "gpsInfoIFDPointer",
		8827: "photographicSensitivity",
		8828: "oecf",
		8830: "sensitivityType",
		8831: "standardOutputSensitivity",
		8832: "recommendedExposureIndex",
		8833: "isoSpeed",
		8834: "isoSpeedLatitudeyyy",
		8835: "isoSpeedLatitudezzz",
		9e3: "exifVersion",
		9003: "dateTimeOriginal",
		9004: "dateTimeDigitized",
		9101: "componentsConfiguration",
		9102: "compressedBitsPerPixel",
		9201: "shutterSpeedValue",
		9202: "apertureValue",
		9203: "brightnessValue",
		9204: "exposureBiasValue",
		9205: "maxApertureValue",
		9206: "subjectDistance",
		9207: "meteringMode",
		9208: "lightSource",
		9209: "flash",
		9214: "subjectArea",
		9286: "userComment",
		9290: "subSecTime",
		9291: "subSecTimeOriginal",
		9292: "subSecTimeDigitized",
		a000: "flashpixVersion",
		a001: "colorSpace",
		a002: "pixelXDimension",
		a003: "pixelYDimension",
		a004: "relatedSoundFile",
		a005: "interoperabilityIFDPointer",
		a20b: "flashEnergy",
		a20c: "spatialFrequencyResponse",
		a20e: "focalPlaneXResolution",
		a20f: "focalPlaneYResolution",
		a40a: "sharpness",
		a40b: "deviceSettingDescription",
		a40c: "subjectDistanceRange",
		a210: "focalPlaneResolutionUnit",
		a214: "subjectLocation",
		a215: "exposureIndex",
		a217: "sensingMethod",
		a300: "fileSource",
		a301: "sceneType",
		a302: "cfaPattern",
		a401: "customRendered",
		a402: "exposureMode",
		a403: "whiteBalance",
		a404: "digitalZoomRatio",
		a405: "focalLengthIn35mmFilm",
		a406: "sceneCaptureType",
		a407: "gainControl",
		a408: "contrast",
		a409: "saturation",
		a420: "imageUniqueID",
		a430: "cameraOwnerName",
		a431: "bodySerialNumber",
		a432: "lensSpecification",
		a433: "lensMake",
		a434: "lensModel",
		a435: "lensSerialNumber",
		a500: "gamma"
	},
	gps: {
		"0000": "gpsVersionID",
		"0001": "gpsLatitudeRef",
		"0002": "gpsLatitude",
		"0003": "gpsLongitudeRef",
		"0004": "gpsLongitude",
		"0005": "gpsAltitudeRef",
		"0006": "gpsAltitude",
		"0007": "gpsTimeStamp",
		"0008": "gpsSatellites",
		"0009": "gpsStatus",
		"000a": "gpsMeasureMode",
		"000b": "gpsDOP",
		"000c": "gpsSpeedRef",
		"000d": "gpsSpeed",
		"000e": "gpsTrackRef",
		"000f": "gpsTrack",
		"0010": "gpsImgDirectionRef",
		"0011": "gpsImgDirection",
		"0012": "gpsMapDatum",
		"0013": "gpsDestLatitudeRef",
		"0014": "gpsDestLatitude",
		"0015": "gpsDestLongitudeRef",
		"0016": "gpsDestLongitude",
		"0017": "gpsDestBearingRef",
		"0018": "gpsDestBearing",
		"0019": "gpsDestDistanceRef",
		"001a": "gpsDestDistance",
		"001b": "gpsProcessingMethod",
		"001c": "gpsAreaInformation",
		"001d": "gpsDateStamp",
		"001e": "gpsDifferential",
		"001f": "gpsHPositioningError"
	}
}, rA = class {
	constructor(e) {
		this.bigEndian = e, this.bytes = [
			0,
			1,
			1,
			2,
			4,
			8,
			1,
			1,
			2,
			4,
			8,
			4,
			8
		];
	}
	_getTagValue(e, t, n) {
		switch (t) {
			case 2: return e.toString("ascii").replace(/\0+$/, "");
			case 129: return e.toString("utf8").replace(/\0+$/, "");
			case 7: return "0x" + e.toString("hex");
			default: return this._getTagValueForNumericalData(e, t, n);
		}
	}
	_getTagValueForNumericalData(e, t, n) {
		let r = [], i = this.bytes[t];
		for (let a = 0; a < n; a += 1) r.push(this._getSingleTagValueForNumericalData(e, t, a * i));
		return r.length === 1 ? r[0] : r;
	}
	_getSingleTagValueForNumericalData(e, t, n) {
		let r = (t) => this.bigEndian ? Hk(e, t) : Uk(e, t), i = (t) => this.bigEndian ? Wk(e, t) : Gk(e, t), a = (t) => this.bigEndian ? Xk(e, t) : Zk(e, t);
		switch (t) {
			case 1: return Vk(e, n);
			case 3: return r(n);
			case 4: return i(n);
			case 5: return i(n) / i(n + 4);
			case 9: return a(n);
			case 10: return a(n) / a(n + 4);
		}
	}
	_decodeIDFEntries(e, t, n, r = !1) {
		let i = 2 + n, a = {}, o = (t) => this.bigEndian ? Hk(e, t) : Uk(e, t), s = (t) => this.bigEndian ? Wk(e, t) : Gk(e, t), c = o(n);
		for (let n = 0; n < c; n++) {
			let n = e.slice(i, i + 2), r = o(i + 2), c = s(i + 4), l = c * this.bytes[r], u = e.slice(i + 8, i + 12);
			if (l > 4) {
				let t = this.bigEndian ? Wk(u, 0) : Gk(u, 0);
				u = e.slice(t, t + l);
			}
			let d = this._getTagValue(u, r, c), f = t[this.bigEndian ? Kk(n) : Kk(n.reverse())];
			a[f] = d, i += 12;
		}
		return a;
	}
	decode(e, t) {
		let n = e.buffer.slice(e.pos - 8), r = t.offsetToFirstIFD;
		if (r > n.length) return e.pos += t.parent.length - 16, {};
		let i = this._decodeIDFEntries(n, nA.ifd, r), { exifIFDPointer: a, gpsInfoIFDPointer: o } = i;
		if (a && (i.subExif = this._decodeIDFEntries(n, nA.ifd, a)), o) {
			let e = o;
			i.gpsInfo = this._decodeIDFEntries(n, nA.gps, e, !0);
		}
		return e.pos += t.parent.length - 16, i;
	}
}, iA = (e) => new K({
	fortyTwo: e ? yy : zte,
	offsetToFirstIFD: e ? xy : Bte,
	entries: new rA(e)
}), aA = class {
	decode(e, t) {
		let n = Jk(e.buffer.slice(e.pos, e.pos + 2)) === "MM";
		return e.pos += 2, iA(n).decode(e, t).entries;
	}
}, oA = {
	name: () => "EXIF",
	length: yy,
	identifier: new Py(6),
	entries: new aA()
}, sA = {
	name: () => "JFIF",
	length: yy,
	identifier: new Py(5),
	version: yy,
	units: vy,
	xDensity: yy,
	yDensity: yy,
	thumbnailWidth: vy,
	thumbnailHeight: vy
}, cA = class {
	decode(e) {
		let t = e.buffer.slice(e.pos), n = 0, r = t.indexOf(255);
		for (; r !== -1;) {
			n = r;
			let e = t[n + 1];
			if (e !== 0 && !(e >= 208 && e <= 215)) break;
			r = t.indexOf(255, r + 1);
		}
		return e.pos += n, t.slice(0, n);
	}
}, lA = {
	name: () => "SOS",
	length: yy,
	numberOfImageComponents: vy,
	componentSpecifications: new G(new K({
		scanComponentSelector: vy,
		entropyCodingTable: new jy(1)
	}), (e) => e.numberOfImageComponents),
	startOfSpectral: vy,
	endOfSpectral: vy,
	successiveApproximationBit: new jy(1),
	data: new cA()
}, uA = {
	name: () => "SOF",
	length: yy,
	precision: vy,
	height: yy,
	width: yy,
	numberOfComponents: vy,
	components: new G(new K({
		id: vy,
		samplingFactors: vy,
		quantizationTableId: vy
	}), (e) => e.numberOfComponents)
}, dA = { name: () => "SOI" }, fA = {
	length: yy,
	buf: new jy((e) => e.length - 2)
}, pA = new G(new Ly(yy, {
	...Array(63).fill(0).reduce((e, t, n) => ({
		...e,
		[n + 65472]: fA
	}), {}),
	65472: uA,
	65473: uA,
	65474: uA,
	65475: uA,
	65476: Qk,
	65477: uA,
	65478: uA,
	65479: uA,
	65481: uA,
	65482: uA,
	65483: uA,
	65484: Bk,
	65485: uA,
	65486: uA,
	65487: uA,
	65496: dA,
	65497: tA,
	65498: lA,
	65499: $k,
	65501: eA,
	65504: sA,
	65505: oA
})), mA = { decode: (e) => pA.fromBuffer(e).map(({ version: e, ...t }) => ({
	type: e,
	...t
})) }, hA = typeof global < "u" ? global : typeof self < "u" ? self : typeof window < "u" ? window : {}, gA = [], _A = [], vA = typeof Uint8Array < "u" ? Uint8Array : Array, yA = !1;
function bA() {
	yA = !0;
	for (var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", t = 0, n = e.length; t < n; ++t) gA[t] = e[t], _A[e.charCodeAt(t)] = t;
	_A[45] = 62, _A[95] = 63;
}
function xA(e) {
	yA || bA();
	var t, n, r, i, a, o, s = e.length;
	if (s % 4 > 0) throw Error("Invalid string. Length must be a multiple of 4");
	a = e[s - 2] === "=" ? 2 : +(e[s - 1] === "="), o = new vA(s * 3 / 4 - a), r = a > 0 ? s - 4 : s;
	var c = 0;
	for (t = 0, n = 0; t < r; t += 4, n += 3) i = _A[e.charCodeAt(t)] << 18 | _A[e.charCodeAt(t + 1)] << 12 | _A[e.charCodeAt(t + 2)] << 6 | _A[e.charCodeAt(t + 3)], o[c++] = i >> 16 & 255, o[c++] = i >> 8 & 255, o[c++] = i & 255;
	return a === 2 ? (i = _A[e.charCodeAt(t)] << 2 | _A[e.charCodeAt(t + 1)] >> 4, o[c++] = i & 255) : a === 1 && (i = _A[e.charCodeAt(t)] << 10 | _A[e.charCodeAt(t + 1)] << 4 | _A[e.charCodeAt(t + 2)] >> 2, o[c++] = i >> 8 & 255, o[c++] = i & 255), o;
}
function SA(e) {
	return gA[e >> 18 & 63] + gA[e >> 12 & 63] + gA[e >> 6 & 63] + gA[e & 63];
}
function CA(e, t, n) {
	for (var r, i = [], a = t; a < n; a += 3) r = (e[a] << 16) + (e[a + 1] << 8) + e[a + 2], i.push(SA(r));
	return i.join("");
}
function wA(e) {
	yA || bA();
	for (var t, n = e.length, r = n % 3, i = "", a = [], o = 16383, s = 0, c = n - r; s < c; s += o) a.push(CA(e, s, s + o > c ? c : s + o));
	return r === 1 ? (t = e[n - 1], i += gA[t >> 2], i += gA[t << 4 & 63], i += "==") : r === 2 && (t = (e[n - 2] << 8) + e[n - 1], i += gA[t >> 10], i += gA[t >> 4 & 63], i += gA[t << 2 & 63], i += "="), a.push(i), a.join("");
}
function TA(e, t, n, r, i) {
	var a, o, s = i * 8 - r - 1, c = (1 << s) - 1, l = c >> 1, u = -7, d = n ? i - 1 : 0, f = n ? -1 : 1, p = e[t + d];
	for (d += f, a = p & (1 << -u) - 1, p >>= -u, u += s; u > 0; a = a * 256 + e[t + d], d += f, u -= 8);
	for (o = a & (1 << -u) - 1, a >>= -u, u += r; u > 0; o = o * 256 + e[t + d], d += f, u -= 8);
	if (a === 0) a = 1 - l;
	else if (a === c) return o ? NaN : (p ? -1 : 1) * Infinity;
	else o += 2 ** r, a -= l;
	return (p ? -1 : 1) * o * 2 ** (a - r);
}
function EA(e, t, n, r, i, a) {
	var o, s, c, l = a * 8 - i - 1, u = (1 << l) - 1, d = u >> 1, f = i === 23 ? 2 ** -24 - 2 ** -77 : 0, p = r ? 0 : a - 1, m = r ? 1 : -1, h = +(t < 0 || t === 0 && 1 / t < 0);
	for (t = Math.abs(t), isNaN(t) || t === Infinity ? (s = +!!isNaN(t), o = u) : (o = Math.floor(Math.log(t) / Math.LN2), t * (c = 2 ** -o) < 1 && (o--, c *= 2), o + d >= 1 ? t += f / c : t += f * 2 ** (1 - d), t * c >= 2 && (o++, c /= 2), o + d >= u ? (s = 0, o = u) : o + d >= 1 ? (s = (t * c - 1) * 2 ** i, o += d) : (s = t * 2 ** (d - 1) * 2 ** i, o = 0)); i >= 8; e[n + p] = s & 255, p += m, s /= 256, i -= 8);
	for (o = o << i | s, l += i; l > 0; e[n + p] = o & 255, p += m, o /= 256, l -= 8);
	e[n + p - m] |= h * 128;
}
var DA = {}.toString, OA = Array.isArray || function(e) {
	return DA.call(e) == "[object Array]";
}, kA = 50;
Z.TYPED_ARRAY_SUPPORT = hA.TYPED_ARRAY_SUPPORT === void 0 ? !0 : hA.TYPED_ARRAY_SUPPORT;
var AA = jA();
function jA() {
	return Z.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
}
function MA(e, t) {
	if (jA() < t) throw RangeError("Invalid typed array length");
	return Z.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(t), e.__proto__ = Z.prototype) : (e === null && (e = new Z(t)), e.length = t), e;
}
function Z(e, t, n) {
	if (!Z.TYPED_ARRAY_SUPPORT && !(this instanceof Z)) return new Z(e, t, n);
	if (typeof e == "number") {
		if (typeof t == "string") throw Error("If encoding is specified then the first argument must be a string");
		return IA(this, e);
	}
	return NA(this, e, t, n);
}
Z.poolSize = 8192, Z._augment = function(e) {
	return e.__proto__ = Z.prototype, e;
};
function NA(e, t, n, r) {
	if (typeof t == "number") throw TypeError("\"value\" argument must not be a number");
	return typeof ArrayBuffer < "u" && t instanceof ArrayBuffer ? zA(e, t, n, r) : typeof t == "string" ? LA(e, t, n) : BA(e, t);
}
Z.from = function(e, t, n) {
	return NA(null, e, t, n);
}, Z.TYPED_ARRAY_SUPPORT && (Z.prototype.__proto__ = Uint8Array.prototype, Z.__proto__ = Uint8Array, typeof Symbol < "u" && Symbol.species && Z[Symbol.species]);
function PA(e) {
	if (typeof e != "number") throw TypeError("\"size\" argument must be a number");
	if (e < 0) throw RangeError("\"size\" argument must not be negative");
}
function FA(e, t, n, r) {
	return PA(t), t <= 0 || n === void 0 ? MA(e, t) : typeof r == "string" ? MA(e, t).fill(n, r) : MA(e, t).fill(n);
}
Z.alloc = function(e, t, n) {
	return FA(null, e, t, n);
};
function IA(e, t) {
	if (PA(t), e = MA(e, t < 0 ? 0 : VA(t) | 0), !Z.TYPED_ARRAY_SUPPORT) for (var n = 0; n < t; ++n) e[n] = 0;
	return e;
}
Z.allocUnsafe = function(e) {
	return IA(null, e);
}, Z.allocUnsafeSlow = function(e) {
	return IA(null, e);
};
function LA(e, t, n) {
	if ((typeof n != "string" || n === "") && (n = "utf8"), !Z.isEncoding(n)) throw TypeError("\"encoding\" must be a valid string encoding");
	var r = WA(t, n) | 0;
	e = MA(e, r);
	var i = e.write(t, n);
	return i !== r && (e = e.slice(0, i)), e;
}
function RA(e, t) {
	var n = t.length < 0 ? 0 : VA(t.length) | 0;
	e = MA(e, n);
	for (var r = 0; r < n; r += 1) e[r] = t[r] & 255;
	return e;
}
function zA(e, t, n, r) {
	if (t.byteLength, n < 0 || t.byteLength < n) throw RangeError("'offset' is out of bounds");
	if (t.byteLength < n + (r || 0)) throw RangeError("'length' is out of bounds");
	return t = n === void 0 && r === void 0 ? new Uint8Array(t) : r === void 0 ? new Uint8Array(t, n) : new Uint8Array(t, n, r), Z.TYPED_ARRAY_SUPPORT ? (e = t, e.__proto__ = Z.prototype) : e = RA(e, t), e;
}
function BA(e, t) {
	if (UA(t)) {
		var n = VA(t.length) | 0;
		return e = MA(e, n), e.length === 0 || t.copy(e, 0, 0, n), e;
	}
	if (t) {
		if (typeof ArrayBuffer < "u" && t.buffer instanceof ArrayBuffer || "length" in t) return typeof t.length != "number" || Tj(t.length) ? MA(e, 0) : RA(e, t);
		if (t.type === "Buffer" && OA(t.data)) return RA(e, t.data);
	}
	throw TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function VA(e) {
	if (e >= jA()) throw RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + jA().toString(16) + " bytes");
	return e | 0;
}
function HA(e) {
	return +e != e && (e = 0), Z.alloc(+e);
}
Z.isBuffer = Ej;
function UA(e) {
	return !!(e != null && e._isBuffer);
}
Z.compare = function(e, t) {
	if (!UA(e) || !UA(t)) throw TypeError("Arguments must be Buffers");
	if (e === t) return 0;
	for (var n = e.length, r = t.length, i = 0, a = Math.min(n, r); i < a; ++i) if (e[i] !== t[i]) {
		n = e[i], r = t[i];
		break;
	}
	return n < r ? -1 : +(r < n);
}, Z.isEncoding = function(e) {
	switch (String(e).toLowerCase()) {
		case "hex":
		case "utf8":
		case "utf-8":
		case "ascii":
		case "latin1":
		case "binary":
		case "base64":
		case "ucs2":
		case "ucs-2":
		case "utf16le":
		case "utf-16le": return !0;
		default: return !1;
	}
}, Z.concat = function(e, t) {
	if (!OA(e)) throw TypeError("\"list\" argument must be an Array of Buffers");
	if (e.length === 0) return Z.alloc(0);
	var n;
	if (t === void 0) for (t = 0, n = 0; n < e.length; ++n) t += e[n].length;
	var r = Z.allocUnsafe(t), i = 0;
	for (n = 0; n < e.length; ++n) {
		var a = e[n];
		if (!UA(a)) throw TypeError("\"list\" argument must be an Array of Buffers");
		a.copy(r, i), i += a.length;
	}
	return r;
};
function WA(e, t) {
	if (UA(e)) return e.length;
	if (typeof ArrayBuffer < "u" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer)) return e.byteLength;
	typeof e != "string" && (e = "" + e);
	var n = e.length;
	if (n === 0) return 0;
	for (var r = !1;;) switch (t) {
		case "ascii":
		case "latin1":
		case "binary": return n;
		case "utf8":
		case "utf-8":
		case void 0: return bj(e).length;
		case "ucs2":
		case "ucs-2":
		case "utf16le":
		case "utf-16le": return n * 2;
		case "hex": return n >>> 1;
		case "base64": return Cj(e).length;
		default:
			if (r) return bj(e).length;
			t = ("" + t).toLowerCase(), r = !0;
	}
}
Z.byteLength = WA;
function GA(e, t, n) {
	var r = !1;
	if ((t === void 0 || t < 0) && (t = 0), t > this.length || ((n === void 0 || n > this.length) && (n = this.length), n <= 0) || (n >>>= 0, t >>>= 0, n <= t)) return "";
	for (e ||= "utf8";;) switch (e) {
		case "hex": return sj(this, t, n);
		case "utf8":
		case "utf-8": return nj(this, t, n);
		case "ascii": return aj(this, t, n);
		case "latin1":
		case "binary": return oj(this, t, n);
		case "base64": return tj(this, t, n);
		case "ucs2":
		case "ucs-2":
		case "utf16le":
		case "utf-16le": return cj(this, t, n);
		default:
			if (r) throw TypeError("Unknown encoding: " + e);
			e = (e + "").toLowerCase(), r = !0;
	}
}
Z.prototype._isBuffer = !0;
function KA(e, t, n) {
	var r = e[t];
	e[t] = e[n], e[n] = r;
}
Z.prototype.swap16 = function() {
	var e = this.length;
	if (e % 2 != 0) throw RangeError("Buffer size must be a multiple of 16-bits");
	for (var t = 0; t < e; t += 2) KA(this, t, t + 1);
	return this;
}, Z.prototype.swap32 = function() {
	var e = this.length;
	if (e % 4 != 0) throw RangeError("Buffer size must be a multiple of 32-bits");
	for (var t = 0; t < e; t += 4) KA(this, t, t + 3), KA(this, t + 1, t + 2);
	return this;
}, Z.prototype.swap64 = function() {
	var e = this.length;
	if (e % 8 != 0) throw RangeError("Buffer size must be a multiple of 64-bits");
	for (var t = 0; t < e; t += 8) KA(this, t, t + 7), KA(this, t + 1, t + 6), KA(this, t + 2, t + 5), KA(this, t + 3, t + 4);
	return this;
}, Z.prototype.toString = function() {
	var e = this.length | 0;
	return e === 0 ? "" : arguments.length === 0 ? nj(this, 0, e) : GA.apply(this, arguments);
}, Z.prototype.equals = function(e) {
	if (!UA(e)) throw TypeError("Argument must be a Buffer");
	return this === e ? !0 : Z.compare(this, e) === 0;
}, Z.prototype.inspect = function() {
	var e = "", t = kA;
	return this.length > 0 && (e = this.toString("hex", 0, t).match(/.{2}/g).join(" "), this.length > t && (e += " ... ")), "<Buffer " + e + ">";
}, Z.prototype.compare = function(e, t, n, r, i) {
	if (!UA(e)) throw TypeError("Argument must be a Buffer");
	if (t === void 0 && (t = 0), n === void 0 && (n = e ? e.length : 0), r === void 0 && (r = 0), i === void 0 && (i = this.length), t < 0 || n > e.length || r < 0 || i > this.length) throw RangeError("out of range index");
	if (r >= i && t >= n) return 0;
	if (r >= i) return -1;
	if (t >= n) return 1;
	if (t >>>= 0, n >>>= 0, r >>>= 0, i >>>= 0, this === e) return 0;
	for (var a = i - r, o = n - t, s = Math.min(a, o), c = this.slice(r, i), l = e.slice(t, n), u = 0; u < s; ++u) if (c[u] !== l[u]) {
		a = c[u], o = l[u];
		break;
	}
	return a < o ? -1 : +(o < a);
};
function qA(e, t, n, r, i) {
	if (e.length === 0) return -1;
	if (typeof n == "string" ? (r = n, n = 0) : n > 2147483647 ? n = 2147483647 : n < -2147483648 && (n = -2147483648), n = +n, isNaN(n) && (n = i ? 0 : e.length - 1), n < 0 && (n = e.length + n), n >= e.length) {
		if (i) return -1;
		n = e.length - 1;
	} else if (n < 0) if (i) n = 0;
	else return -1;
	if (typeof t == "string" && (t = Z.from(t, r)), UA(t)) return t.length === 0 ? -1 : JA(e, t, n, r, i);
	if (typeof t == "number") return t &= 255, Z.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? i ? Uint8Array.prototype.indexOf.call(e, t, n) : Uint8Array.prototype.lastIndexOf.call(e, t, n) : JA(e, [t], n, r, i);
	throw TypeError("val must be string, number or Buffer");
}
function JA(e, t, n, r, i) {
	var a = 1, o = e.length, s = t.length;
	if (r !== void 0 && (r = String(r).toLowerCase(), r === "ucs2" || r === "ucs-2" || r === "utf16le" || r === "utf-16le")) {
		if (e.length < 2 || t.length < 2) return -1;
		a = 2, o /= 2, s /= 2, n /= 2;
	}
	function c(e, t) {
		return a === 1 ? e[t] : e.readUInt16BE(t * a);
	}
	var l;
	if (i) {
		var u = -1;
		for (l = n; l < o; l++) if (c(e, l) === c(t, u === -1 ? 0 : l - u)) {
			if (u === -1 && (u = l), l - u + 1 === s) return u * a;
		} else u !== -1 && (l -= l - u), u = -1;
	} else for (n + s > o && (n = o - s), l = n; l >= 0; l--) {
		for (var d = !0, f = 0; f < s; f++) if (c(e, l + f) !== c(t, f)) {
			d = !1;
			break;
		}
		if (d) return l;
	}
	return -1;
}
Z.prototype.includes = function(e, t, n) {
	return this.indexOf(e, t, n) !== -1;
}, Z.prototype.indexOf = function(e, t, n) {
	return qA(this, e, t, n, !0);
}, Z.prototype.lastIndexOf = function(e, t, n) {
	return qA(this, e, t, n, !1);
};
function YA(e, t, n, r) {
	n = Number(n) || 0;
	var i = e.length - n;
	r ? (r = Number(r), r > i && (r = i)) : r = i;
	var a = t.length;
	if (a % 2 != 0) throw TypeError("Invalid hex string");
	r > a / 2 && (r = a / 2);
	for (var o = 0; o < r; ++o) {
		var s = parseInt(t.substr(o * 2, 2), 16);
		if (isNaN(s)) return o;
		e[n + o] = s;
	}
	return o;
}
function XA(e, t, n, r) {
	return wj(bj(t, e.length - n), e, n, r);
}
function ZA(e, t, n, r) {
	return wj(xj(t), e, n, r);
}
function QA(e, t, n, r) {
	return ZA(e, t, n, r);
}
function $A(e, t, n, r) {
	return wj(Cj(t), e, n, r);
}
function ej(e, t, n, r) {
	return wj(Sj(t, e.length - n), e, n, r);
}
Z.prototype.write = function(e, t, n, r) {
	if (t === void 0) r = "utf8", n = this.length, t = 0;
	else if (n === void 0 && typeof t == "string") r = t, n = this.length, t = 0;
	else if (isFinite(t)) t |= 0, isFinite(n) ? (n |= 0, r === void 0 && (r = "utf8")) : (r = n, n = void 0);
	else throw Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
	var i = this.length - t;
	if ((n === void 0 || n > i) && (n = i), e.length > 0 && (n < 0 || t < 0) || t > this.length) throw RangeError("Attempt to write outside buffer bounds");
	r ||= "utf8";
	for (var a = !1;;) switch (r) {
		case "hex": return YA(this, e, t, n);
		case "utf8":
		case "utf-8": return XA(this, e, t, n);
		case "ascii": return ZA(this, e, t, n);
		case "latin1":
		case "binary": return QA(this, e, t, n);
		case "base64": return $A(this, e, t, n);
		case "ucs2":
		case "ucs-2":
		case "utf16le":
		case "utf-16le": return ej(this, e, t, n);
		default:
			if (a) throw TypeError("Unknown encoding: " + r);
			r = ("" + r).toLowerCase(), a = !0;
	}
}, Z.prototype.toJSON = function() {
	return {
		type: "Buffer",
		data: Array.prototype.slice.call(this._arr || this, 0)
	};
};
function tj(e, t, n) {
	return t === 0 && n === e.length ? wA(e) : wA(e.slice(t, n));
}
function nj(e, t, n) {
	n = Math.min(e.length, n);
	for (var r = [], i = t; i < n;) {
		var a = e[i], o = null, s = a > 239 ? 4 : a > 223 ? 3 : a > 191 ? 2 : 1;
		if (i + s <= n) {
			var c, l, u, d;
			switch (s) {
				case 1:
					a < 128 && (o = a);
					break;
				case 2:
					c = e[i + 1], (c & 192) == 128 && (d = (a & 31) << 6 | c & 63, d > 127 && (o = d));
					break;
				case 3:
					c = e[i + 1], l = e[i + 2], (c & 192) == 128 && (l & 192) == 128 && (d = (a & 15) << 12 | (c & 63) << 6 | l & 63, d > 2047 && (d < 55296 || d > 57343) && (o = d));
					break;
				case 4: c = e[i + 1], l = e[i + 2], u = e[i + 3], (c & 192) == 128 && (l & 192) == 128 && (u & 192) == 128 && (d = (a & 15) << 18 | (c & 63) << 12 | (l & 63) << 6 | u & 63, d > 65535 && d < 1114112 && (o = d));
			}
		}
		o === null ? (o = 65533, s = 1) : o > 65535 && (o -= 65536, r.push(o >>> 10 & 1023 | 55296), o = 56320 | o & 1023), r.push(o), i += s;
	}
	return ij(r);
}
var rj = 4096;
function ij(e) {
	var t = e.length;
	if (t <= rj) return String.fromCharCode.apply(String, e);
	for (var n = "", r = 0; r < t;) n += String.fromCharCode.apply(String, e.slice(r, r += rj));
	return n;
}
function aj(e, t, n) {
	var r = "";
	n = Math.min(e.length, n);
	for (var i = t; i < n; ++i) r += String.fromCharCode(e[i] & 127);
	return r;
}
function oj(e, t, n) {
	var r = "";
	n = Math.min(e.length, n);
	for (var i = t; i < n; ++i) r += String.fromCharCode(e[i]);
	return r;
}
function sj(e, t, n) {
	var r = e.length;
	(!t || t < 0) && (t = 0), (!n || n < 0 || n > r) && (n = r);
	for (var i = "", a = t; a < n; ++a) i += yj(e[a]);
	return i;
}
function cj(e, t, n) {
	for (var r = e.slice(t, n), i = "", a = 0; a < r.length; a += 2) i += String.fromCharCode(r[a] + r[a + 1] * 256);
	return i;
}
Z.prototype.slice = function(e, t) {
	var n = this.length;
	e = ~~e, t = t === void 0 ? n : ~~t, e < 0 ? (e += n, e < 0 && (e = 0)) : e > n && (e = n), t < 0 ? (t += n, t < 0 && (t = 0)) : t > n && (t = n), t < e && (t = e);
	var r;
	if (Z.TYPED_ARRAY_SUPPORT) r = this.subarray(e, t), r.__proto__ = Z.prototype;
	else {
		var i = t - e;
		r = new Z(i, void 0);
		for (var a = 0; a < i; ++a) r[a] = this[a + e];
	}
	return r;
};
function lj(e, t, n) {
	if (e % 1 != 0 || e < 0) throw RangeError("offset is not uint");
	if (e + t > n) throw RangeError("Trying to access beyond buffer length");
}
Z.prototype.readUIntLE = function(e, t, n) {
	e |= 0, t |= 0, n || lj(e, t, this.length);
	for (var r = this[e], i = 1, a = 0; ++a < t && (i *= 256);) r += this[e + a] * i;
	return r;
}, Z.prototype.readUIntBE = function(e, t, n) {
	e |= 0, t |= 0, n || lj(e, t, this.length);
	for (var r = this[e + --t], i = 1; t > 0 && (i *= 256);) r += this[e + --t] * i;
	return r;
}, Z.prototype.readUInt8 = function(e, t) {
	return t || lj(e, 1, this.length), this[e];
}, Z.prototype.readUInt16LE = function(e, t) {
	return t || lj(e, 2, this.length), this[e] | this[e + 1] << 8;
}, Z.prototype.readUInt16BE = function(e, t) {
	return t || lj(e, 2, this.length), this[e] << 8 | this[e + 1];
}, Z.prototype.readUInt32LE = function(e, t) {
	return t || lj(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + this[e + 3] * 16777216;
}, Z.prototype.readUInt32BE = function(e, t) {
	return t || lj(e, 4, this.length), this[e] * 16777216 + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
}, Z.prototype.readIntLE = function(e, t, n) {
	e |= 0, t |= 0, n || lj(e, t, this.length);
	for (var r = this[e], i = 1, a = 0; ++a < t && (i *= 256);) r += this[e + a] * i;
	return i *= 128, r >= i && (r -= 2 ** (8 * t)), r;
}, Z.prototype.readIntBE = function(e, t, n) {
	e |= 0, t |= 0, n || lj(e, t, this.length);
	for (var r = t, i = 1, a = this[e + --r]; r > 0 && (i *= 256);) a += this[e + --r] * i;
	return i *= 128, a >= i && (a -= 2 ** (8 * t)), a;
}, Z.prototype.readInt8 = function(e, t) {
	return t || lj(e, 1, this.length), this[e] & 128 ? (255 - this[e] + 1) * -1 : this[e];
}, Z.prototype.readInt16LE = function(e, t) {
	t || lj(e, 2, this.length);
	var n = this[e] | this[e + 1] << 8;
	return n & 32768 ? n | 4294901760 : n;
}, Z.prototype.readInt16BE = function(e, t) {
	t || lj(e, 2, this.length);
	var n = this[e + 1] | this[e] << 8;
	return n & 32768 ? n | 4294901760 : n;
}, Z.prototype.readInt32LE = function(e, t) {
	return t || lj(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
}, Z.prototype.readInt32BE = function(e, t) {
	return t || lj(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
}, Z.prototype.readFloatLE = function(e, t) {
	return t || lj(e, 4, this.length), TA(this, e, !0, 23, 4);
}, Z.prototype.readFloatBE = function(e, t) {
	return t || lj(e, 4, this.length), TA(this, e, !1, 23, 4);
}, Z.prototype.readDoubleLE = function(e, t) {
	return t || lj(e, 8, this.length), TA(this, e, !0, 52, 8);
}, Z.prototype.readDoubleBE = function(e, t) {
	return t || lj(e, 8, this.length), TA(this, e, !1, 52, 8);
};
function uj(e, t, n, r, i, a) {
	if (!UA(e)) throw TypeError("\"buffer\" argument must be a Buffer instance");
	if (t > i || t < a) throw RangeError("\"value\" argument is out of bounds");
	if (n + r > e.length) throw RangeError("Index out of range");
}
Z.prototype.writeUIntLE = function(e, t, n, r) {
	if (e = +e, t |= 0, n |= 0, !r) {
		var i = 2 ** (8 * n) - 1;
		uj(this, e, t, n, i, 0);
	}
	var a = 1, o = 0;
	for (this[t] = e & 255; ++o < n && (a *= 256);) this[t + o] = e / a & 255;
	return t + n;
}, Z.prototype.writeUIntBE = function(e, t, n, r) {
	if (e = +e, t |= 0, n |= 0, !r) {
		var i = 2 ** (8 * n) - 1;
		uj(this, e, t, n, i, 0);
	}
	var a = n - 1, o = 1;
	for (this[t + a] = e & 255; --a >= 0 && (o *= 256);) this[t + a] = e / o & 255;
	return t + n;
}, Z.prototype.writeUInt8 = function(e, t, n) {
	return e = +e, t |= 0, n || uj(this, e, t, 1, 255, 0), Z.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[t] = e & 255, t + 1;
};
function dj(e, t, n, r) {
	t < 0 && (t = 65535 + t + 1);
	for (var i = 0, a = Math.min(e.length - n, 2); i < a; ++i) e[n + i] = (t & 255 << 8 * (r ? i : 1 - i)) >>> (r ? i : 1 - i) * 8;
}
Z.prototype.writeUInt16LE = function(e, t, n) {
	return e = +e, t |= 0, n || uj(this, e, t, 2, 65535, 0), Z.TYPED_ARRAY_SUPPORT ? (this[t] = e & 255, this[t + 1] = e >>> 8) : dj(this, e, t, !0), t + 2;
}, Z.prototype.writeUInt16BE = function(e, t, n) {
	return e = +e, t |= 0, n || uj(this, e, t, 2, 65535, 0), Z.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = e & 255) : dj(this, e, t, !1), t + 2;
};
function fj(e, t, n, r) {
	t < 0 && (t = 4294967295 + t + 1);
	for (var i = 0, a = Math.min(e.length - n, 4); i < a; ++i) e[n + i] = t >>> (r ? i : 3 - i) * 8 & 255;
}
Z.prototype.writeUInt32LE = function(e, t, n) {
	return e = +e, t |= 0, n || uj(this, e, t, 4, 4294967295, 0), Z.TYPED_ARRAY_SUPPORT ? (this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = e & 255) : fj(this, e, t, !0), t + 4;
}, Z.prototype.writeUInt32BE = function(e, t, n) {
	return e = +e, t |= 0, n || uj(this, e, t, 4, 4294967295, 0), Z.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = e & 255) : fj(this, e, t, !1), t + 4;
}, Z.prototype.writeIntLE = function(e, t, n, r) {
	if (e = +e, t |= 0, !r) {
		var i = 2 ** (8 * n - 1);
		uj(this, e, t, n, i - 1, -i);
	}
	var a = 0, o = 1, s = 0;
	for (this[t] = e & 255; ++a < n && (o *= 256);) e < 0 && s === 0 && this[t + a - 1] !== 0 && (s = 1), this[t + a] = (e / o >> 0) - s & 255;
	return t + n;
}, Z.prototype.writeIntBE = function(e, t, n, r) {
	if (e = +e, t |= 0, !r) {
		var i = 2 ** (8 * n - 1);
		uj(this, e, t, n, i - 1, -i);
	}
	var a = n - 1, o = 1, s = 0;
	for (this[t + a] = e & 255; --a >= 0 && (o *= 256);) e < 0 && s === 0 && this[t + a + 1] !== 0 && (s = 1), this[t + a] = (e / o >> 0) - s & 255;
	return t + n;
}, Z.prototype.writeInt8 = function(e, t, n) {
	return e = +e, t |= 0, n || uj(this, e, t, 1, 127, -128), Z.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[t] = e & 255, t + 1;
}, Z.prototype.writeInt16LE = function(e, t, n) {
	return e = +e, t |= 0, n || uj(this, e, t, 2, 32767, -32768), Z.TYPED_ARRAY_SUPPORT ? (this[t] = e & 255, this[t + 1] = e >>> 8) : dj(this, e, t, !0), t + 2;
}, Z.prototype.writeInt16BE = function(e, t, n) {
	return e = +e, t |= 0, n || uj(this, e, t, 2, 32767, -32768), Z.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = e & 255) : dj(this, e, t, !1), t + 2;
}, Z.prototype.writeInt32LE = function(e, t, n) {
	return e = +e, t |= 0, n || uj(this, e, t, 4, 2147483647, -2147483648), Z.TYPED_ARRAY_SUPPORT ? (this[t] = e & 255, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24) : fj(this, e, t, !0), t + 4;
}, Z.prototype.writeInt32BE = function(e, t, n) {
	return e = +e, t |= 0, n || uj(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), Z.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = e & 255) : fj(this, e, t, !1), t + 4;
};
function pj(e, t, n, r, i, a) {
	if (n + r > e.length || n < 0) throw RangeError("Index out of range");
}
function mj(e, t, n, r, i) {
	return i || pj(e, t, n, 4), EA(e, t, n, r, 23, 4), n + 4;
}
Z.prototype.writeFloatLE = function(e, t, n) {
	return mj(this, e, t, !0, n);
}, Z.prototype.writeFloatBE = function(e, t, n) {
	return mj(this, e, t, !1, n);
};
function hj(e, t, n, r, i) {
	return i || pj(e, t, n, 8), EA(e, t, n, r, 52, 8), n + 8;
}
Z.prototype.writeDoubleLE = function(e, t, n) {
	return hj(this, e, t, !0, n);
}, Z.prototype.writeDoubleBE = function(e, t, n) {
	return hj(this, e, t, !1, n);
}, Z.prototype.copy = function(e, t, n, r) {
	if (n ||= 0, !r && r !== 0 && (r = this.length), t >= e.length && (t = e.length), t ||= 0, r > 0 && r < n && (r = n), r === n || e.length === 0 || this.length === 0) return 0;
	if (t < 0) throw RangeError("targetStart out of bounds");
	if (n < 0 || n >= this.length) throw RangeError("sourceStart out of bounds");
	if (r < 0) throw RangeError("sourceEnd out of bounds");
	r > this.length && (r = this.length), e.length - t < r - n && (r = e.length - t + n);
	var i = r - n, a;
	if (this === e && n < t && t < r) for (a = i - 1; a >= 0; --a) e[a + t] = this[a + n];
	else if (i < 1e3 || !Z.TYPED_ARRAY_SUPPORT) for (a = 0; a < i; ++a) e[a + t] = this[a + n];
	else Uint8Array.prototype.set.call(e, this.subarray(n, n + i), t);
	return i;
}, Z.prototype.fill = function(e, t, n, r) {
	if (typeof e == "string") {
		if (typeof t == "string" ? (r = t, t = 0, n = this.length) : typeof n == "string" && (r = n, n = this.length), e.length === 1) {
			var i = e.charCodeAt(0);
			i < 256 && (e = i);
		}
		if (r !== void 0 && typeof r != "string") throw TypeError("encoding must be a string");
		if (typeof r == "string" && !Z.isEncoding(r)) throw TypeError("Unknown encoding: " + r);
	} else typeof e == "number" && (e &= 255);
	if (t < 0 || this.length < t || this.length < n) throw RangeError("Out of range index");
	if (n <= t) return this;
	t >>>= 0, n = n === void 0 ? this.length : n >>> 0, e ||= 0;
	var a;
	if (typeof e == "number") for (a = t; a < n; ++a) this[a] = e;
	else {
		var o = UA(e) ? e : bj(new Z(e, r).toString()), s = o.length;
		for (a = 0; a < n - t; ++a) this[a + t] = o[a % s];
	}
	return this;
};
var gj = /[^+\/0-9A-Za-z-_]/g;
function _j(e) {
	if (e = vj(e).replace(gj, ""), e.length < 2) return "";
	for (; e.length % 4 != 0;) e += "=";
	return e;
}
function vj(e) {
	return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
}
function yj(e) {
	return e < 16 ? "0" + e.toString(16) : e.toString(16);
}
function bj(e, t) {
	t ||= Infinity;
	for (var n, r = e.length, i = null, a = [], o = 0; o < r; ++o) {
		if (n = e.charCodeAt(o), n > 55295 && n < 57344) {
			if (!i) {
				if (n > 56319) {
					(t -= 3) > -1 && a.push(239, 191, 189);
					continue;
				} else if (o + 1 === r) {
					(t -= 3) > -1 && a.push(239, 191, 189);
					continue;
				}
				i = n;
				continue;
			}
			if (n < 56320) {
				(t -= 3) > -1 && a.push(239, 191, 189), i = n;
				continue;
			}
			n = (i - 55296 << 10 | n - 56320) + 65536;
		} else i && (t -= 3) > -1 && a.push(239, 191, 189);
		if (i = null, n < 128) {
			if (--t < 0) break;
			a.push(n);
		} else if (n < 2048) {
			if ((t -= 2) < 0) break;
			a.push(n >> 6 | 192, n & 63 | 128);
		} else if (n < 65536) {
			if ((t -= 3) < 0) break;
			a.push(n >> 12 | 224, n >> 6 & 63 | 128, n & 63 | 128);
		} else if (n < 1114112) {
			if ((t -= 4) < 0) break;
			a.push(n >> 18 | 240, n >> 12 & 63 | 128, n >> 6 & 63 | 128, n & 63 | 128);
		} else throw Error("Invalid code point");
	}
	return a;
}
function xj(e) {
	for (var t = [], n = 0; n < e.length; ++n) t.push(e.charCodeAt(n) & 255);
	return t;
}
function Sj(e, t) {
	for (var n, r, i, a = [], o = 0; o < e.length && !((t -= 2) < 0); ++o) n = e.charCodeAt(o), r = n >> 8, i = n % 256, a.push(i), a.push(r);
	return a;
}
function Cj(e) {
	return xA(_j(e));
}
function wj(e, t, n, r) {
	for (var i = 0; i < r && !(i + n >= t.length || i >= e.length); ++i) t[i + n] = e[i];
	return i;
}
function Tj(e) {
	return e !== e;
}
function Ej(e) {
	return e != null && (!!e._isBuffer || Dj(e) || Oj(e));
}
function Dj(e) {
	return !!e.constructor && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
function Oj(e) {
	return typeof e.readFloatLE == "function" && typeof e.slice == "function" && Dj(e.slice(0, 0));
}
var kj = /*#__PURE__*/ Object.freeze({
	__proto__: null,
	Buffer: Z,
	INSPECT_MAX_BYTES: kA,
	SlowBuffer: HA,
	isBuffer: Ej,
	kMaxLength: AA
});
function Aj() {
	throw Error("setTimeout has not been defined");
}
function jj() {
	throw Error("clearTimeout has not been defined");
}
var Mj = Aj, Nj = jj;
typeof hA.setTimeout == "function" && (Mj = setTimeout), typeof hA.clearTimeout == "function" && (Nj = clearTimeout);
function Pj(e) {
	if (Mj === setTimeout) return setTimeout(e, 0);
	if ((Mj === Aj || !Mj) && setTimeout) return Mj = setTimeout, setTimeout(e, 0);
	try {
		return Mj(e, 0);
	} catch {
		try {
			return Mj.call(null, e, 0);
		} catch {
			return Mj.call(this, e, 0);
		}
	}
}
function Fj(e) {
	if (Nj === clearTimeout) return clearTimeout(e);
	if ((Nj === jj || !Nj) && clearTimeout) return Nj = clearTimeout, clearTimeout(e);
	try {
		return Nj(e);
	} catch {
		try {
			return Nj.call(null, e);
		} catch {
			return Nj.call(this, e);
		}
	}
}
var Ij = [], Lj = !1, Rj, zj = -1;
function Bj() {
	!Lj || !Rj || (Lj = !1, Rj.length ? Ij = Rj.concat(Ij) : zj = -1, Ij.length && Vj());
}
function Vj() {
	if (!Lj) {
		var e = Pj(Bj);
		Lj = !0;
		for (var t = Ij.length; t;) {
			for (Rj = Ij, Ij = []; ++zj < t;) Rj && Rj[zj].run();
			zj = -1, t = Ij.length;
		}
		Rj = null, Lj = !1, Fj(e);
	}
}
function Hj(e) {
	var t = Array(arguments.length - 1);
	if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
	Ij.push(new Uj(e, t)), Ij.length === 1 && !Lj && Pj(Vj);
}
function Uj(e, t) {
	this.fun = e, this.array = t;
}
Uj.prototype.run = function() {
	this.fun.apply(null, this.array);
};
var cne = "browser", lne = "browser", une = !0, dne = {}, fne = [], pne = "", mne = {}, hne = {}, gne = {};
function Wj() {}
var _ne = Wj, vne = Wj, yne = Wj, bne = Wj, xne = Wj, Sne = Wj, Cne = Wj;
function wne(e) {
	throw Error("process.binding is not supported");
}
function Tne() {
	return "/";
}
function Ene(e) {
	throw Error("process.chdir is not supported");
}
function Dne() {
	return 0;
}
var Gj = hA.performance || {}, One = Gj.now || Gj.mozNow || Gj.msNow || Gj.oNow || Gj.webkitNow || function() {
	return (/* @__PURE__ */ new Date()).getTime();
};
function kne(e) {
	var t = One.call(Gj) * .001, n = Math.floor(t), r = Math.floor(t % 1 * 1e9);
	return e && (n -= e[0], r -= e[1], r < 0 && (n--, r += 1e9)), [n, r];
}
var Ane = /* @__PURE__ */ new Date();
function jne() {
	return (/* @__PURE__ */ new Date() - Ane) / 1e3;
}
var Kj = {
	nextTick: Hj,
	title: cne,
	browser: une,
	env: dne,
	argv: fne,
	version: pne,
	versions: mne,
	on: _ne,
	addListener: vne,
	once: yne,
	off: bne,
	removeListener: xne,
	removeAllListeners: Sne,
	emit: Cne,
	binding: wne,
	cwd: Tne,
	chdir: Ene,
	umask: Dne,
	hrtime: kne,
	platform: lne,
	release: hne,
	config: gne,
	uptime: jne
};
function Mne(e) {
	return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function qj(e) {
	if (e.__esModule) return e;
	var t = e.default;
	if (typeof t == "function") {
		var n = function e() {
			return this instanceof e ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
		};
		n.prototype = t.prototype;
	} else n = {};
	return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(t) {
		var r = Object.getOwnPropertyDescriptor(e, t);
		Object.defineProperty(n, t, r.get ? r : {
			enumerable: !0,
			get: function() {
				return e[t];
			}
		});
	}), n;
}
var Jj = {}, Yj = /*@__PURE__*/ qj(kj), Nne;
function Xj() {}
Xj.prototype = Object.create(null);
function Zj() {
	Zj.init.call(this);
}
Zj.EventEmitter = Zj, Zj.usingDomains = !1, Zj.prototype.domain = void 0, Zj.prototype._events = void 0, Zj.prototype._maxListeners = void 0, Zj.defaultMaxListeners = 10, Zj.init = function() {
	this.domain = null, Zj.usingDomains && Nne.active, (!this._events || this._events === Object.getPrototypeOf(this)._events) && (this._events = new Xj(), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
}, Zj.prototype.setMaxListeners = function(e) {
	if (typeof e != "number" || e < 0 || isNaN(e)) throw TypeError("\"n\" argument must be a positive number");
	return this._maxListeners = e, this;
};
function Qj(e) {
	return e._maxListeners === void 0 ? Zj.defaultMaxListeners : e._maxListeners;
}
Zj.prototype.getMaxListeners = function() {
	return Qj(this);
};
function Pne(e, t, n) {
	if (t) e.call(n);
	else for (var r = e.length, i = nM(e, r), a = 0; a < r; ++a) i[a].call(n);
}
function Fne(e, t, n, r) {
	if (t) e.call(n, r);
	else for (var i = e.length, a = nM(e, i), o = 0; o < i; ++o) a[o].call(n, r);
}
function Ine(e, t, n, r, i) {
	if (t) e.call(n, r, i);
	else for (var a = e.length, o = nM(e, a), s = 0; s < a; ++s) o[s].call(n, r, i);
}
function Lne(e, t, n, r, i, a) {
	if (t) e.call(n, r, i, a);
	else for (var o = e.length, s = nM(e, o), c = 0; c < o; ++c) s[c].call(n, r, i, a);
}
function Rne(e, t, n, r) {
	if (t) e.apply(n, r);
	else for (var i = e.length, a = nM(e, i), o = 0; o < i; ++o) a[o].apply(n, r);
}
Zj.prototype.emit = function(e) {
	var t, n, r, i, a, o, s, c = e === "error";
	if (o = this._events, o) c &&= o.error == null;
	else if (!c) return !1;
	if (s = this.domain, c) {
		if (t = arguments[1], s) t ||= /* @__PURE__ */ Error("Uncaught, unspecified \"error\" event"), t.domainEmitter = this, t.domain = s, t.domainThrown = !1, s.emit("error", t);
		else if (t instanceof Error) throw t;
		else {
			var l = /* @__PURE__ */ Error("Uncaught, unspecified \"error\" event. (" + t + ")");
			throw l.context = t, l;
		}
		return !1;
	}
	if (n = o[e], !n) return !1;
	var u = typeof n == "function";
	switch (r = arguments.length, r) {
		case 1:
			Pne(n, u, this);
			break;
		case 2:
			Fne(n, u, this, arguments[1]);
			break;
		case 3:
			Ine(n, u, this, arguments[1], arguments[2]);
			break;
		case 4:
			Lne(n, u, this, arguments[1], arguments[2], arguments[3]);
			break;
		default:
			for (i = Array(r - 1), a = 1; a < r; a++) i[a - 1] = arguments[a];
			Rne(n, u, this, i);
	}
	return !0;
};
function $j(e, t, n, r) {
	var i, a, o;
	if (typeof n != "function") throw TypeError("\"listener\" argument must be a function");
	if (a = e._events, a ? (a.newListener && (e.emit("newListener", t, n.listener ? n.listener : n), a = e._events), o = a[t]) : (a = e._events = new Xj(), e._eventsCount = 0), !o) o = a[t] = n, ++e._eventsCount;
	else if (typeof o == "function" ? o = a[t] = r ? [n, o] : [o, n] : r ? o.unshift(n) : o.push(n), !o.warned && (i = Qj(e), i && i > 0 && o.length > i)) {
		o.warned = !0;
		var s = /* @__PURE__ */ Error("Possible EventEmitter memory leak detected. " + o.length + " " + t + " listeners added. Use emitter.setMaxListeners() to increase limit");
		s.name = "MaxListenersExceededWarning", s.emitter = e, s.type = t, s.count = o.length, zne(s);
	}
	return e;
}
function zne(e) {
	typeof console.warn == "function" ? console.warn(e) : console.log(e);
}
Zj.prototype.addListener = function(e, t) {
	return $j(this, e, t, !1);
}, Zj.prototype.on = Zj.prototype.addListener, Zj.prototype.prependListener = function(e, t) {
	return $j(this, e, t, !0);
};
function eM(e, t, n) {
	var r = !1;
	function i() {
		e.removeListener(t, i), r || (r = !0, n.apply(e, arguments));
	}
	return i.listener = n, i;
}
Zj.prototype.once = function(e, t) {
	if (typeof t != "function") throw TypeError("\"listener\" argument must be a function");
	return this.on(e, eM(this, e, t)), this;
}, Zj.prototype.prependOnceListener = function(e, t) {
	if (typeof t != "function") throw TypeError("\"listener\" argument must be a function");
	return this.prependListener(e, eM(this, e, t)), this;
}, Zj.prototype.removeListener = function(e, t) {
	var n, r, i, a, o;
	if (typeof t != "function") throw TypeError("\"listener\" argument must be a function");
	if (r = this._events, !r || (n = r[e], !n)) return this;
	if (n === t || n.listener && n.listener === t) --this._eventsCount === 0 ? this._events = new Xj() : (delete r[e], r.removeListener && this.emit("removeListener", e, n.listener || t));
	else if (typeof n != "function") {
		for (i = -1, a = n.length; a-- > 0;) if (n[a] === t || n[a].listener && n[a].listener === t) {
			o = n[a].listener, i = a;
			break;
		}
		if (i < 0) return this;
		if (n.length === 1) {
			if (n[0] = void 0, --this._eventsCount === 0) return this._events = new Xj(), this;
			delete r[e];
		} else Bne(n, i);
		r.removeListener && this.emit("removeListener", e, o || t);
	}
	return this;
}, Zj.prototype.off = function(e, t) {
	return this.removeListener(e, t);
}, Zj.prototype.removeAllListeners = function(e) {
	var t, n = this._events;
	if (!n) return this;
	if (!n.removeListener) return arguments.length === 0 ? (this._events = new Xj(), this._eventsCount = 0) : n[e] && (--this._eventsCount === 0 ? this._events = new Xj() : delete n[e]), this;
	if (arguments.length === 0) {
		for (var r = Object.keys(n), i = 0, a; i < r.length; ++i) a = r[i], a !== "removeListener" && this.removeAllListeners(a);
		return this.removeAllListeners("removeListener"), this._events = new Xj(), this._eventsCount = 0, this;
	}
	if (t = n[e], typeof t == "function") this.removeListener(e, t);
	else if (t) do
		this.removeListener(e, t[t.length - 1]);
	while (t[0]);
	return this;
}, Zj.prototype.listeners = function(e) {
	var t, n, r = this._events;
	return r ? (t = r[e], n = t ? typeof t == "function" ? [t.listener || t] : Vne(t) : []) : n = [], n;
}, Zj.listenerCount = function(e, t) {
	return typeof e.listenerCount == "function" ? e.listenerCount(t) : tM.call(e, t);
}, Zj.prototype.listenerCount = tM;
function tM(e) {
	var t = this._events;
	if (t) {
		var n = t[e];
		if (typeof n == "function") return 1;
		if (n) return n.length;
	}
	return 0;
}
Zj.prototype.eventNames = function() {
	return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};
function Bne(e, t) {
	for (var n = t, r = n + 1, i = e.length; r < i; n += 1, r += 1) e[n] = e[r];
	e.pop();
}
function nM(e, t) {
	for (var n = Array(t); t--;) n[t] = e[t];
	return n;
}
function Vne(e) {
	for (var t = Array(e.length), n = 0; n < t.length; ++n) t[n] = e[n].listener || e[n];
	return t;
}
var rM = typeof Object.create == "function" ? function(e, t) {
	e.super_ = t, e.prototype = Object.create(t.prototype, { constructor: {
		value: e,
		enumerable: !1,
		writable: !0,
		configurable: !0
	} });
} : function(e, t) {
	e.super_ = t;
	var n = function() {};
	n.prototype = t.prototype, e.prototype = new n(), e.prototype.constructor = e;
}, iM = Object.getOwnPropertyDescriptors || function(e) {
	for (var t = Object.keys(e), n = {}, r = 0; r < t.length; r++) n[t[r]] = Object.getOwnPropertyDescriptor(e, t[r]);
	return n;
}, Hne = /%[sdj%]/g;
function aM(e) {
	if (!yM(e)) {
		for (var t = [], n = 0; n < arguments.length; n++) t.push(uM(arguments[n]));
		return t.join(" ");
	}
	for (var n = 1, r = arguments, i = r.length, a = String(e).replace(Hne, function(e) {
		if (e === "%%") return "%";
		if (n >= i) return e;
		switch (e) {
			case "%s": return String(r[n++]);
			case "%d": return Number(r[n++]);
			case "%j": try {
				return JSON.stringify(r[n++]);
			} catch {
				return "[Circular]";
			}
			default: return e;
		}
	}), o = r[n]; n < i; o = r[++n]) gM(o) || !CM(o) ? a += " " + o : a += " " + uM(o);
	return a;
}
function oM(e, t) {
	if (xM(hA.process)) return function() {
		return oM(e, t).apply(this, arguments);
	};
	if (Kj.noDeprecation === !0) return e;
	var n = !1;
	function r() {
		if (!n) {
			if (Kj.throwDeprecation) throw Error(t);
			Kj.traceDeprecation ? console.trace(t) : console.error(t), n = !0;
		}
		return e.apply(this, arguments);
	}
	return r;
}
var sM = {}, cM;
function lM(e) {
	if (xM(cM) && (cM = Kj.env.NODE_DEBUG || ""), e = e.toUpperCase(), !sM[e]) if (RegExp("\\b" + e + "\\b", "i").test(cM)) {
		var t = 0;
		sM[e] = function() {
			var n = aM.apply(null, arguments);
			console.error("%s %d: %s", e, t, n);
		};
	} else sM[e] = function() {};
	return sM[e];
}
function uM(e, t) {
	var n = {
		seen: [],
		stylize: Wne
	};
	return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), hM(t) ? n.showHidden = t : t && MM(n, t), xM(n.showHidden) && (n.showHidden = !1), xM(n.depth) && (n.depth = 2), xM(n.colors) && (n.colors = !1), xM(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = Une), dM(n, e, n.depth);
}
uM.colors = {
	bold: [1, 22],
	italic: [3, 23],
	underline: [4, 24],
	inverse: [7, 27],
	white: [37, 39],
	grey: [90, 39],
	black: [30, 39],
	blue: [34, 39],
	cyan: [36, 39],
	green: [32, 39],
	magenta: [35, 39],
	red: [31, 39],
	yellow: [33, 39]
}, uM.styles = {
	special: "cyan",
	number: "yellow",
	boolean: "yellow",
	undefined: "grey",
	null: "bold",
	string: "green",
	date: "magenta",
	regexp: "red"
};
function Une(e, t) {
	var n = uM.styles[t];
	return n ? "\x1B[" + uM.colors[n][0] + "m" + e + "\x1B[" + uM.colors[n][1] + "m" : e;
}
function Wne(e, t) {
	return e;
}
function Gne(e) {
	var t = {};
	return e.forEach(function(e, n) {
		t[e] = !0;
	}), t;
}
function dM(e, t, n) {
	if (e.customInspect && t && EM(t.inspect) && t.inspect !== uM && !(t.constructor && t.constructor.prototype === t)) {
		var r = t.inspect(n, e);
		return yM(r) || (r = dM(e, r, n)), r;
	}
	var i = Kne(e, t);
	if (i) return i;
	var a = Object.keys(t), o = Gne(a);
	if (e.showHidden && (a = Object.getOwnPropertyNames(t)), TM(t) && (a.indexOf("message") >= 0 || a.indexOf("description") >= 0)) return fM(t);
	if (a.length === 0) {
		if (EM(t)) {
			var s = t.name ? ": " + t.name : "";
			return e.stylize("[Function" + s + "]", "special");
		}
		if (SM(t)) return e.stylize(RegExp.prototype.toString.call(t), "regexp");
		if (wM(t)) return e.stylize(Date.prototype.toString.call(t), "date");
		if (TM(t)) return fM(t);
	}
	var c = "", l = !1, u = ["{", "}"];
	if (mM(t) && (l = !0, u = ["[", "]"]), EM(t) && (c = " [Function" + (t.name ? ": " + t.name : "") + "]"), SM(t) && (c = " " + RegExp.prototype.toString.call(t)), wM(t) && (c = " " + Date.prototype.toUTCString.call(t)), TM(t) && (c = " " + fM(t)), a.length === 0 && (!l || t.length == 0)) return u[0] + c + u[1];
	if (n < 0) return SM(t) ? e.stylize(RegExp.prototype.toString.call(t), "regexp") : e.stylize("[Object]", "special");
	e.seen.push(t);
	var d = l ? qne(e, t, n, o, a) : a.map(function(r) {
		return pM(e, t, n, o, r, l);
	});
	return e.seen.pop(), Jne(d, c, u);
}
function Kne(e, t) {
	if (xM(t)) return e.stylize("undefined", "undefined");
	if (yM(t)) {
		var n = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, "\"") + "'";
		return e.stylize(n, "string");
	}
	if (vM(t)) return e.stylize("" + t, "number");
	if (hM(t)) return e.stylize("" + t, "boolean");
	if (gM(t)) return e.stylize("null", "null");
}
function fM(e) {
	return "[" + Error.prototype.toString.call(e) + "]";
}
function qne(e, t, n, r, i) {
	for (var a = [], o = 0, s = t.length; o < s; ++o) NM(t, String(o)) ? a.push(pM(e, t, n, r, String(o), !0)) : a.push("");
	return i.forEach(function(i) {
		i.match(/^\d+$/) || a.push(pM(e, t, n, r, i, !0));
	}), a;
}
function pM(e, t, n, r, i, a) {
	var o, s, c = Object.getOwnPropertyDescriptor(t, i) || { value: t[i] };
	if (c.get ? s = c.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : c.set && (s = e.stylize("[Setter]", "special")), NM(r, i) || (o = "[" + i + "]"), s || (e.seen.indexOf(c.value) < 0 ? (s = gM(n) ? dM(e, c.value, null) : dM(e, c.value, n - 1), s.indexOf("\n") > -1 && (s = a ? s.split("\n").map(function(e) {
		return "  " + e;
	}).join("\n").substr(2) : "\n" + s.split("\n").map(function(e) {
		return "   " + e;
	}).join("\n"))) : s = e.stylize("[Circular]", "special")), xM(o)) {
		if (a && i.match(/^\d+$/)) return s;
		o = JSON.stringify("" + i), o.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (o = o.substr(1, o.length - 2), o = e.stylize(o, "name")) : (o = o.replace(/'/g, "\\'").replace(/\\"/g, "\"").replace(/(^"|"$)/g, "'"), o = e.stylize(o, "string"));
	}
	return o + ": " + s;
}
function Jne(e, t, n) {
	return e.reduce(function(e, t) {
		return t.indexOf("\n"), e + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
	}, 0) > 60 ? n[0] + (t === "" ? "" : t + "\n ") + " " + e.join(",\n  ") + " " + n[1] : n[0] + t + " " + e.join(", ") + " " + n[1];
}
function mM(e) {
	return Array.isArray(e);
}
function hM(e) {
	return typeof e == "boolean";
}
function gM(e) {
	return e === null;
}
function _M(e) {
	return e == null;
}
function vM(e) {
	return typeof e == "number";
}
function yM(e) {
	return typeof e == "string";
}
function bM(e) {
	return typeof e == "symbol";
}
function xM(e) {
	return e === void 0;
}
function SM(e) {
	return CM(e) && kM(e) === "[object RegExp]";
}
function CM(e) {
	return typeof e == "object" && !!e;
}
function wM(e) {
	return CM(e) && kM(e) === "[object Date]";
}
function TM(e) {
	return CM(e) && (kM(e) === "[object Error]" || e instanceof Error);
}
function EM(e) {
	return typeof e == "function";
}
function DM(e) {
	return e === null || typeof e == "boolean" || typeof e == "number" || typeof e == "string" || typeof e == "symbol" || e === void 0;
}
function OM(e) {
	return Z.isBuffer(e);
}
function kM(e) {
	return Object.prototype.toString.call(e);
}
function AM(e) {
	return e < 10 ? "0" + e.toString(10) : e.toString(10);
}
var Yne = [
	"Jan",
	"Feb",
	"Mar",
	"Apr",
	"May",
	"Jun",
	"Jul",
	"Aug",
	"Sep",
	"Oct",
	"Nov",
	"Dec"
];
function Xne() {
	var e = /* @__PURE__ */ new Date(), t = [
		AM(e.getHours()),
		AM(e.getMinutes()),
		AM(e.getSeconds())
	].join(":");
	return [
		e.getDate(),
		Yne[e.getMonth()],
		t
	].join(" ");
}
function jM() {
	console.log("%s - %s", Xne(), aM.apply(null, arguments));
}
function MM(e, t) {
	if (!t || !CM(t)) return e;
	for (var n = Object.keys(t), r = n.length; r--;) e[n[r]] = t[n[r]];
	return e;
}
function NM(e, t) {
	return Object.prototype.hasOwnProperty.call(e, t);
}
var PM = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
function FM(e) {
	if (typeof e != "function") throw TypeError("The \"original\" argument must be of type Function");
	if (PM && e[PM]) {
		var t = e[PM];
		if (typeof t != "function") throw TypeError("The \"util.promisify.custom\" argument must be of type Function");
		return Object.defineProperty(t, PM, {
			value: t,
			enumerable: !1,
			writable: !1,
			configurable: !0
		}), t;
	}
	function t() {
		for (var t, n, r = new Promise(function(e, r) {
			t = e, n = r;
		}), i = [], a = 0; a < arguments.length; a++) i.push(arguments[a]);
		i.push(function(e, r) {
			e ? n(e) : t(r);
		});
		try {
			e.apply(this, i);
		} catch (e) {
			n(e);
		}
		return r;
	}
	return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), PM && Object.defineProperty(t, PM, {
		value: t,
		enumerable: !1,
		writable: !1,
		configurable: !0
	}), Object.defineProperties(t, iM(e));
}
FM.custom = PM;
function Zne(e, t) {
	if (!e) {
		var n = /* @__PURE__ */ Error("Promise was rejected with a falsy value");
		n.reason = e, e = n;
	}
	return t(e);
}
function IM(e) {
	if (typeof e != "function") throw TypeError("The \"original\" argument must be of type Function");
	function t() {
		for (var t = [], n = 0; n < arguments.length; n++) t.push(arguments[n]);
		var r = t.pop();
		if (typeof r != "function") throw TypeError("The last argument must be of type Function");
		var i = this, a = function() {
			return r.apply(i, arguments);
		};
		e.apply(this, t).then(function(e) {
			Kj.nextTick(a.bind(null, null, e));
		}, function(e) {
			Kj.nextTick(Zne.bind(null, e, a));
		});
	}
	return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), Object.defineProperties(t, iM(e)), t;
}
var Qne = /*#__PURE__*/ Object.freeze({
	__proto__: null,
	_extend: MM,
	callbackify: IM,
	debuglog: lM,
	default: {
		inherits: rM,
		_extend: MM,
		log: jM,
		isBuffer: OM,
		isPrimitive: DM,
		isFunction: EM,
		isError: TM,
		isDate: wM,
		isObject: CM,
		isRegExp: SM,
		isUndefined: xM,
		isSymbol: bM,
		isString: yM,
		isNumber: vM,
		isNullOrUndefined: _M,
		isNull: gM,
		isBoolean: hM,
		isArray: mM,
		inspect: uM,
		deprecate: oM,
		format: aM,
		debuglog: lM,
		promisify: FM,
		callbackify: IM
	},
	deprecate: oM,
	format: aM,
	inherits: rM,
	inspect: uM,
	isArray: mM,
	isBoolean: hM,
	isBuffer: OM,
	isDate: wM,
	isError: TM,
	isFunction: EM,
	isNull: gM,
	isNullOrUndefined: _M,
	isNumber: vM,
	isObject: CM,
	isPrimitive: DM,
	isRegExp: SM,
	isString: yM,
	isSymbol: bM,
	isUndefined: xM,
	log: jM,
	promisify: FM
});
function LM() {
	this.head = null, this.tail = null, this.length = 0;
}
LM.prototype.push = function(e) {
	var t = {
		data: e,
		next: null
	};
	this.length > 0 ? this.tail.next = t : this.head = t, this.tail = t, ++this.length;
}, LM.prototype.unshift = function(e) {
	var t = {
		data: e,
		next: this.head
	};
	this.length === 0 && (this.tail = t), this.head = t, ++this.length;
}, LM.prototype.shift = function() {
	if (this.length !== 0) {
		var e = this.head.data;
		return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
	}
}, LM.prototype.clear = function() {
	this.head = this.tail = null, this.length = 0;
}, LM.prototype.join = function(e) {
	if (this.length === 0) return "";
	for (var t = this.head, n = "" + t.data; t = t.next;) n += e + t.data;
	return n;
}, LM.prototype.concat = function(e) {
	if (this.length === 0) return Z.alloc(0);
	if (this.length === 1) return this.head.data;
	for (var t = Z.allocUnsafe(e >>> 0), n = this.head, r = 0; n;) n.data.copy(t, r), r += n.data.length, n = n.next;
	return t;
};
var $ne = Z.isEncoding || function(e) {
	switch (e && e.toLowerCase()) {
		case "hex":
		case "utf8":
		case "utf-8":
		case "ascii":
		case "binary":
		case "base64":
		case "ucs2":
		case "ucs-2":
		case "utf16le":
		case "utf-16le":
		case "raw": return !0;
		default: return !1;
	}
};
function ere(e) {
	if (e && !$ne(e)) throw Error("Unknown encoding: " + e);
}
function RM(e) {
	switch (this.encoding = (e || "utf8").toLowerCase().replace(/[-_]/, ""), ere(e), this.encoding) {
		case "utf8":
			this.surrogateSize = 3;
			break;
		case "ucs2":
		case "utf16le":
			this.surrogateSize = 2, this.detectIncompleteChar = nre;
			break;
		case "base64":
			this.surrogateSize = 3, this.detectIncompleteChar = rre;
			break;
		default:
			this.write = tre;
			return;
	}
	this.charBuffer = new Z(6), this.charReceived = 0, this.charLength = 0;
}
RM.prototype.write = function(e) {
	for (var t = ""; this.charLength;) {
		var n = e.length >= this.charLength - this.charReceived ? this.charLength - this.charReceived : e.length;
		if (e.copy(this.charBuffer, this.charReceived, 0, n), this.charReceived += n, this.charReceived < this.charLength) return "";
		e = e.slice(n, e.length), t = this.charBuffer.slice(0, this.charLength).toString(this.encoding);
		var r = t.charCodeAt(t.length - 1);
		if (r >= 55296 && r <= 56319) {
			this.charLength += this.surrogateSize, t = "";
			continue;
		}
		if (this.charReceived = this.charLength = 0, e.length === 0) return t;
		break;
	}
	this.detectIncompleteChar(e);
	var i = e.length;
	this.charLength && (e.copy(this.charBuffer, 0, e.length - this.charReceived, i), i -= this.charReceived), t += e.toString(this.encoding, 0, i);
	var i = t.length - 1, r = t.charCodeAt(i);
	if (r >= 55296 && r <= 56319) {
		var a = this.surrogateSize;
		return this.charLength += a, this.charReceived += a, this.charBuffer.copy(this.charBuffer, a, 0, a), e.copy(this.charBuffer, 0, 0, a), t.substring(0, i);
	}
	return t;
}, RM.prototype.detectIncompleteChar = function(e) {
	for (var t = e.length >= 3 ? 3 : e.length; t > 0; t--) {
		var n = e[e.length - t];
		if (t == 1 && n >> 5 == 6) {
			this.charLength = 2;
			break;
		}
		if (t <= 2 && n >> 4 == 14) {
			this.charLength = 3;
			break;
		}
		if (t <= 3 && n >> 3 == 30) {
			this.charLength = 4;
			break;
		}
	}
	this.charReceived = t;
}, RM.prototype.end = function(e) {
	var t = "";
	if (e && e.length && (t = this.write(e)), this.charReceived) {
		var n = this.charReceived, r = this.charBuffer, i = this.encoding;
		t += r.slice(0, n).toString(i);
	}
	return t;
};
function tre(e) {
	return e.toString(this.encoding);
}
function nre(e) {
	this.charReceived = e.length % 2, this.charLength = this.charReceived ? 2 : 0;
}
function rre(e) {
	this.charReceived = e.length % 3, this.charLength = this.charReceived ? 3 : 0;
}
VM.ReadableState = BM;
var zM = lM("stream");
rM(VM, Zj);
function ire(e, t, n) {
	if (typeof e.prependListener == "function") return e.prependListener(t, n);
	!e._events || !e._events[t] ? e.on(t, n) : Array.isArray(e._events[t]) ? e._events[t].unshift(n) : e._events[t] = [n, e._events[t]];
}
function are(e, t) {
	return e.listeners(t).length;
}
function BM(e, t) {
	e ||= {}, this.objectMode = !!e.objectMode, t instanceof lN && (this.objectMode = this.objectMode || !!e.readableObjectMode);
	var n = e.highWaterMark, r = this.objectMode ? 16 : 16 * 1024;
	this.highWaterMark = n || n === 0 ? n : r, this.highWaterMark = ~~this.highWaterMark, this.buffer = new LM(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.defaultEncoding = e.defaultEncoding || "utf8", this.ranOut = !1, this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, e.encoding && (this.decoder = new RM(e.encoding), this.encoding = e.encoding);
}
function VM(e) {
	if (!(this instanceof VM)) return new VM(e);
	this._readableState = new BM(e, this), this.readable = !0, e && typeof e.read == "function" && (this._read = e.read), Zj.call(this);
}
VM.prototype.push = function(e, t) {
	var n = this._readableState;
	return !n.objectMode && typeof e == "string" && (t ||= n.defaultEncoding, t !== n.encoding && (e = Z.from(e, t), t = "")), HM(this, n, e, t, !1);
}, VM.prototype.unshift = function(e) {
	var t = this._readableState;
	return HM(this, t, e, "", !0);
}, VM.prototype.isPaused = function() {
	return this._readableState.flowing === !1;
};
function HM(e, t, n, r, i) {
	var a = cre(t, n);
	if (a) e.emit("error", a);
	else if (n === null) t.reading = !1, lre(e, t);
	else if (t.objectMode || n && n.length > 0) if (t.ended && !i) {
		var o = /* @__PURE__ */ Error("stream.push() after EOF");
		e.emit("error", o);
	} else if (t.endEmitted && i) {
		var s = /* @__PURE__ */ Error("stream.unshift() after end event");
		e.emit("error", s);
	} else {
		var c;
		t.decoder && !i && !r && (n = t.decoder.write(n), c = !t.objectMode && n.length === 0), i || (t.reading = !1), c || (t.flowing && t.length === 0 && !t.sync ? (e.emit("data", n), e.read(0)) : (t.length += t.objectMode ? 1 : n.length, i ? t.buffer.unshift(n) : t.buffer.push(n), t.needReadable && GM(e))), ure(e, t);
	}
	else i || (t.reading = !1);
	return ore(t);
}
function ore(e) {
	return !e.ended && (e.needReadable || e.length < e.highWaterMark || e.length === 0);
}
VM.prototype.setEncoding = function(e) {
	return this._readableState.decoder = new RM(e), this._readableState.encoding = e, this;
};
var UM = 8388608;
function sre(e) {
	return e >= UM ? e = UM : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
}
function WM(e, t) {
	return e <= 0 || t.length === 0 && t.ended ? 0 : t.objectMode ? 1 : e === e ? (e > t.highWaterMark && (t.highWaterMark = sre(e)), e <= t.length ? e : t.ended ? t.length : (t.needReadable = !0, 0)) : t.flowing && t.length ? t.buffer.head.data.length : t.length;
}
VM.prototype.read = function(e) {
	zM("read", e), e = parseInt(e, 10);
	var t = this._readableState, n = e;
	if (e !== 0 && (t.emittedReadable = !1), e === 0 && t.needReadable && (t.length >= t.highWaterMark || t.ended)) return zM("read: emitReadable", t.length, t.ended), t.length === 0 && t.ended ? YM(this) : GM(this), null;
	if (e = WM(e, t), e === 0 && t.ended) return t.length === 0 && YM(this), null;
	var r = t.needReadable;
	zM("need readable", r), (t.length === 0 || t.length - e < t.highWaterMark) && (r = !0, zM("length less than watermark", r)), t.ended || t.reading ? (r = !1, zM("reading or ended", r)) : r && (zM("do read"), t.reading = !0, t.sync = !0, t.length === 0 && (t.needReadable = !0), this._read(t.highWaterMark), t.sync = !1, t.reading || (e = WM(n, t)));
	var i = e > 0 ? JM(e, t) : null;
	return i === null ? (t.needReadable = !0, e = 0) : t.length -= e, t.length === 0 && (t.ended || (t.needReadable = !0), n !== e && t.ended && YM(this)), i !== null && this.emit("data", i), i;
};
function cre(e, t) {
	var n = null;
	return !Z.isBuffer(t) && typeof t != "string" && t != null && !e.objectMode && (n = /* @__PURE__ */ TypeError("Invalid non-string/buffer chunk")), n;
}
function lre(e, t) {
	if (!t.ended) {
		if (t.decoder) {
			var n = t.decoder.end();
			n && n.length && (t.buffer.push(n), t.length += t.objectMode ? 1 : n.length);
		}
		t.ended = !0, GM(e);
	}
}
function GM(e) {
	var t = e._readableState;
	t.needReadable = !1, t.emittedReadable || (zM("emitReadable", t.flowing), t.emittedReadable = !0, t.sync ? Hj(KM, e) : KM(e));
}
function KM(e) {
	zM("emit readable"), e.emit("readable"), qM(e);
}
function ure(e, t) {
	t.readingMore || (t.readingMore = !0, Hj(dre, e, t));
}
function dre(e, t) {
	for (var n = t.length; !t.reading && !t.flowing && !t.ended && t.length < t.highWaterMark && (zM("maybeReadMore read 0"), e.read(0), n !== t.length);) n = t.length;
	t.readingMore = !1;
}
VM.prototype._read = function(e) {
	this.emit("error", /* @__PURE__ */ Error("not implemented"));
}, VM.prototype.pipe = function(e, t) {
	var n = this, r = this._readableState;
	switch (r.pipesCount) {
		case 0:
			r.pipes = e;
			break;
		case 1:
			r.pipes = [r.pipes, e];
			break;
		default:
			r.pipes.push(e);
			break;
	}
	r.pipesCount += 1, zM("pipe count=%d opts=%j", r.pipesCount, t);
	var i = !t || t.end !== !1 ? o : l;
	r.endEmitted ? Hj(i) : n.once("end", i), e.on("unpipe", a);
	function a(e) {
		zM("onunpipe"), e === n && l();
	}
	function o() {
		zM("onend"), e.end();
	}
	var s = fre(n);
	e.on("drain", s);
	var c = !1;
	function l() {
		zM("cleanup"), e.removeListener("close", p), e.removeListener("finish", m), e.removeListener("drain", s), e.removeListener("error", f), e.removeListener("unpipe", a), n.removeListener("end", o), n.removeListener("end", l), n.removeListener("data", d), c = !0, r.awaitDrain && (!e._writableState || e._writableState.needDrain) && s();
	}
	var u = !1;
	n.on("data", d);
	function d(t) {
		zM("ondata"), u = !1, !1 === e.write(t) && !u && ((r.pipesCount === 1 && r.pipes === e || r.pipesCount > 1 && XM(r.pipes, e) !== -1) && !c && (zM("false write response, pause", n._readableState.awaitDrain), n._readableState.awaitDrain++, u = !0), n.pause());
	}
	function f(t) {
		zM("onerror", t), h(), e.removeListener("error", f), are(e, "error") === 0 && e.emit("error", t);
	}
	ire(e, "error", f);
	function p() {
		e.removeListener("finish", m), h();
	}
	e.once("close", p);
	function m() {
		zM("onfinish"), e.removeListener("close", p), h();
	}
	e.once("finish", m);
	function h() {
		zM("unpipe"), n.unpipe(e);
	}
	return e.emit("pipe", n), r.flowing || (zM("pipe resume"), n.resume()), e;
};
function fre(e) {
	return function() {
		var t = e._readableState;
		zM("pipeOnDrain", t.awaitDrain), t.awaitDrain && t.awaitDrain--, t.awaitDrain === 0 && e.listeners("data").length && (t.flowing = !0, qM(e));
	};
}
VM.prototype.unpipe = function(e) {
	var t = this._readableState;
	if (t.pipesCount === 0) return this;
	if (t.pipesCount === 1) return e && e !== t.pipes ? this : (e ||= t.pipes, t.pipes = null, t.pipesCount = 0, t.flowing = !1, e && e.emit("unpipe", this), this);
	if (!e) {
		var n = t.pipes, r = t.pipesCount;
		t.pipes = null, t.pipesCount = 0, t.flowing = !1;
		for (var i = 0; i < r; i++) n[i].emit("unpipe", this);
		return this;
	}
	var a = XM(t.pipes, e);
	return a === -1 ? this : (t.pipes.splice(a, 1), --t.pipesCount, t.pipesCount === 1 && (t.pipes = t.pipes[0]), e.emit("unpipe", this), this);
}, VM.prototype.on = function(e, t) {
	var n = Zj.prototype.on.call(this, e, t);
	if (e === "data") this._readableState.flowing !== !1 && this.resume();
	else if (e === "readable") {
		var r = this._readableState;
		!r.endEmitted && !r.readableListening && (r.readableListening = r.needReadable = !0, r.emittedReadable = !1, r.reading ? r.length && GM(this) : Hj(pre, this));
	}
	return n;
}, VM.prototype.addListener = VM.prototype.on;
function pre(e) {
	zM("readable nexttick read 0"), e.read(0);
}
VM.prototype.resume = function() {
	var e = this._readableState;
	return e.flowing || (zM("resume"), e.flowing = !0, mre(this, e)), this;
};
function mre(e, t) {
	t.resumeScheduled || (t.resumeScheduled = !0, Hj(hre, e, t));
}
function hre(e, t) {
	t.reading || (zM("resume read 0"), e.read(0)), t.resumeScheduled = !1, t.awaitDrain = 0, e.emit("resume"), qM(e), t.flowing && !t.reading && e.read(0);
}
VM.prototype.pause = function() {
	return zM("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (zM("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
};
function qM(e) {
	var t = e._readableState;
	for (zM("flow", t.flowing); t.flowing && e.read() !== null;);
}
VM.prototype.wrap = function(e) {
	var t = this._readableState, n = !1, r = this;
	for (var i in e.on("end", function() {
		if (zM("wrapped end"), t.decoder && !t.ended) {
			var e = t.decoder.end();
			e && e.length && r.push(e);
		}
		r.push(null);
	}), e.on("data", function(i) {
		zM("wrapped data"), t.decoder && (i = t.decoder.write(i)), !(t.objectMode && i == null) && (!t.objectMode && (!i || !i.length) || r.push(i) || (n = !0, e.pause()));
	}), e) this[i] === void 0 && typeof e[i] == "function" && (this[i] = function(t) {
		return function() {
			return e[t].apply(e, arguments);
		};
	}(i));
	return bre([
		"error",
		"close",
		"destroy",
		"pause",
		"resume"
	], function(t) {
		e.on(t, r.emit.bind(r, t));
	}), r._read = function(t) {
		zM("wrapped _read", t), n && (n = !1, e.resume());
	}, r;
}, VM._fromList = JM;
function JM(e, t) {
	if (t.length === 0) return null;
	var n;
	return t.objectMode ? n = t.buffer.shift() : !e || e >= t.length ? (n = t.decoder ? t.buffer.join("") : t.buffer.length === 1 ? t.buffer.head.data : t.buffer.concat(t.length), t.buffer.clear()) : n = gre(e, t.buffer, t.decoder), n;
}
function gre(e, t, n) {
	var r;
	return e < t.head.data.length ? (r = t.head.data.slice(0, e), t.head.data = t.head.data.slice(e)) : r = e === t.head.data.length ? t.shift() : n ? _re(e, t) : vre(e, t), r;
}
function _re(e, t) {
	var n = t.head, r = 1, i = n.data;
	for (e -= i.length; n = n.next;) {
		var a = n.data, o = e > a.length ? a.length : e;
		if (o === a.length ? i += a : i += a.slice(0, e), e -= o, e === 0) {
			o === a.length ? (++r, n.next ? t.head = n.next : t.head = t.tail = null) : (t.head = n, n.data = a.slice(o));
			break;
		}
		++r;
	}
	return t.length -= r, i;
}
function vre(e, t) {
	var n = Z.allocUnsafe(e), r = t.head, i = 1;
	for (r.data.copy(n), e -= r.data.length; r = r.next;) {
		var a = r.data, o = e > a.length ? a.length : e;
		if (a.copy(n, n.length - e, 0, o), e -= o, e === 0) {
			o === a.length ? (++i, r.next ? t.head = r.next : t.head = t.tail = null) : (t.head = r, r.data = a.slice(o));
			break;
		}
		++i;
	}
	return t.length -= i, n;
}
function YM(e) {
	var t = e._readableState;
	if (t.length > 0) throw Error("\"endReadable()\" called on non-empty stream");
	t.endEmitted || (t.ended = !0, Hj(yre, t, e));
}
function yre(e, t) {
	!e.endEmitted && e.length === 0 && (e.endEmitted = !0, t.readable = !1, t.emit("end"));
}
function bre(e, t) {
	for (var n = 0, r = e.length; n < r; n++) t(e[n], n);
}
function XM(e, t) {
	for (var n = 0, r = e.length; n < r; n++) if (e[n] === t) return n;
	return -1;
}
QM.WritableState = ZM, rM(QM, Zj);
function xre() {}
function Sre(e, t, n) {
	this.chunk = e, this.encoding = t, this.callback = n, this.next = null;
}
function ZM(e, t) {
	Object.defineProperty(this, "buffer", { get: oM(function() {
		return this.getBuffer();
	}, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.") }), e ||= {}, this.objectMode = !!e.objectMode, t instanceof lN && (this.objectMode = this.objectMode || !!e.writableObjectMode);
	var n = e.highWaterMark, r = this.objectMode ? 16 : 16 * 1024;
	this.highWaterMark = n || n === 0 ? n : r, this.highWaterMark = ~~this.highWaterMark, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1;
	var i = e.decodeStrings === !1;
	this.decodeStrings = !i, this.defaultEncoding = e.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(e) {
		kre(t, e);
	}, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new aN(this);
}
ZM.prototype.getBuffer = function() {
	for (var e = this.bufferedRequest, t = []; e;) t.push(e), e = e.next;
	return t;
};
function QM(e) {
	if (!(this instanceof QM) && !(this instanceof lN)) return new QM(e);
	this._writableState = new ZM(e, this), this.writable = !0, e && (typeof e.write == "function" && (this._write = e.write), typeof e.writev == "function" && (this._writev = e.writev)), Zj.call(this);
}
QM.prototype.pipe = function() {
	this.emit("error", /* @__PURE__ */ Error("Cannot pipe, not readable"));
};
function Cre(e, t) {
	var n = /* @__PURE__ */ Error("write after end");
	e.emit("error", n), Hj(t, n);
}
function wre(e, t, n, r) {
	var i = !0, a = !1;
	return n === null ? a = /* @__PURE__ */ TypeError("May not write null values to stream") : !Z.isBuffer(n) && typeof n != "string" && n !== void 0 && !t.objectMode && (a = /* @__PURE__ */ TypeError("Invalid non-string/buffer chunk")), a && (e.emit("error", a), Hj(r, a), i = !1), i;
}
QM.prototype.write = function(e, t, n) {
	var r = this._writableState, i = !1;
	return typeof t == "function" && (n = t, t = null), Z.isBuffer(e) ? t = "buffer" : t ||= r.defaultEncoding, typeof n != "function" && (n = xre), r.ended ? Cre(this, n) : wre(this, r, e, n) && (r.pendingcb++, i = Ere(this, r, e, t, n)), i;
}, QM.prototype.cork = function() {
	var e = this._writableState;
	e.corked++;
}, QM.prototype.uncork = function() {
	var e = this._writableState;
	e.corked && (e.corked--, !e.writing && !e.corked && !e.finished && !e.bufferProcessing && e.bufferedRequest && tN(this, e));
}, QM.prototype.setDefaultEncoding = function(e) {
	if (typeof e == "string" && (e = e.toLowerCase()), !([
		"hex",
		"utf8",
		"utf-8",
		"ascii",
		"binary",
		"base64",
		"ucs2",
		"ucs-2",
		"utf16le",
		"utf-16le",
		"raw"
	].indexOf((e + "").toLowerCase()) > -1)) throw TypeError("Unknown encoding: " + e);
	return this._writableState.defaultEncoding = e, this;
};
function Tre(e, t, n) {
	return !e.objectMode && e.decodeStrings !== !1 && typeof t == "string" && (t = Z.from(t, n)), t;
}
function Ere(e, t, n, r, i) {
	n = Tre(t, n, r), Z.isBuffer(n) && (r = "buffer");
	var a = t.objectMode ? 1 : n.length;
	t.length += a;
	var o = t.length < t.highWaterMark;
	if (o || (t.needDrain = !0), t.writing || t.corked) {
		var s = t.lastBufferedRequest;
		t.lastBufferedRequest = new Sre(n, r, i), s ? s.next = t.lastBufferedRequest : t.bufferedRequest = t.lastBufferedRequest, t.bufferedRequestCount += 1;
	} else $M(e, t, !1, a, n, r, i);
	return o;
}
function $M(e, t, n, r, i, a, o) {
	t.writelen = r, t.writecb = o, t.writing = !0, t.sync = !0, n ? e._writev(i, t.onwrite) : e._write(i, a, t.onwrite), t.sync = !1;
}
function Dre(e, t, n, r, i) {
	--t.pendingcb, n ? Hj(i, r) : i(r), e._writableState.errorEmitted = !0, e.emit("error", r);
}
function Ore(e) {
	e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
}
function kre(e, t) {
	var n = e._writableState, r = n.sync, i = n.writecb;
	if (Ore(n), t) Dre(e, n, r, t, i);
	else {
		var a = nN(n);
		!a && !n.corked && !n.bufferProcessing && n.bufferedRequest && tN(e, n), r ? Hj(eN, e, n, a, i) : eN(e, n, a, i);
	}
}
function eN(e, t, n, r) {
	n || Are(e, t), t.pendingcb--, r(), iN(e, t);
}
function Are(e, t) {
	t.length === 0 && t.needDrain && (t.needDrain = !1, e.emit("drain"));
}
function tN(e, t) {
	t.bufferProcessing = !0;
	var n = t.bufferedRequest;
	if (e._writev && n && n.next) {
		var r = t.bufferedRequestCount, i = Array(r), a = t.corkedRequestsFree;
		a.entry = n;
		for (var o = 0; n;) i[o] = n, n = n.next, o += 1;
		$M(e, t, !0, t.length, i, "", a.finish), t.pendingcb++, t.lastBufferedRequest = null, a.next ? (t.corkedRequestsFree = a.next, a.next = null) : t.corkedRequestsFree = new aN(t);
	} else {
		for (; n;) {
			var s = n.chunk, c = n.encoding, l = n.callback;
			if ($M(e, t, !1, t.objectMode ? 1 : s.length, s, c, l), n = n.next, t.writing) break;
		}
		n === null && (t.lastBufferedRequest = null);
	}
	t.bufferedRequestCount = 0, t.bufferedRequest = n, t.bufferProcessing = !1;
}
QM.prototype._write = function(e, t, n) {
	n(/* @__PURE__ */ Error("not implemented"));
}, QM.prototype._writev = null, QM.prototype.end = function(e, t, n) {
	var r = this._writableState;
	typeof e == "function" ? (n = e, e = null, t = null) : typeof t == "function" && (n = t, t = null), e != null && this.write(e, t), r.corked && (r.corked = 1, this.uncork()), !r.ending && !r.finished && jre(this, r, n);
};
function nN(e) {
	return e.ending && e.length === 0 && e.bufferedRequest === null && !e.finished && !e.writing;
}
function rN(e, t) {
	t.prefinished || (t.prefinished = !0, e.emit("prefinish"));
}
function iN(e, t) {
	var n = nN(t);
	return n && (t.pendingcb === 0 ? (rN(e, t), t.finished = !0, e.emit("finish")) : rN(e, t)), n;
}
function jre(e, t, n) {
	t.ending = !0, iN(e, t), n && (t.finished ? Hj(n) : e.once("finish", n)), t.ended = !0, e.writable = !1;
}
function aN(e) {
	var t = this;
	this.next = null, this.entry = null, this.finish = function(n) {
		var r = t.entry;
		for (t.entry = null; r;) {
			var i = r.callback;
			e.pendingcb--, i(n), r = r.next;
		}
		e.corkedRequestsFree ? e.corkedRequestsFree.next = t : e.corkedRequestsFree = t;
	};
}
rM(lN, VM);
for (var oN = Object.keys(QM.prototype), sN = 0; sN < oN.length; sN++) {
	var cN = oN[sN];
	lN.prototype[cN] || (lN.prototype[cN] = QM.prototype[cN]);
}
function lN(e) {
	if (!(this instanceof lN)) return new lN(e);
	VM.call(this, e), QM.call(this, e), e && e.readable === !1 && (this.readable = !1), e && e.writable === !1 && (this.writable = !1), this.allowHalfOpen = !0, e && e.allowHalfOpen === !1 && (this.allowHalfOpen = !1), this.once("end", Mre);
}
function Mre() {
	this.allowHalfOpen || this._writableState.ended || Hj(Nre, this);
}
function Nre(e) {
	e.end();
}
rM(uN, lN);
function Pre(e) {
	this.afterTransform = function(t, n) {
		return Fre(e, t, n);
	}, this.needTransform = !1, this.transforming = !1, this.writecb = null, this.writechunk = null, this.writeencoding = null;
}
function Fre(e, t, n) {
	var r = e._transformState;
	r.transforming = !1;
	var i = r.writecb;
	if (!i) return e.emit("error", /* @__PURE__ */ Error("no writecb in Transform class"));
	r.writechunk = null, r.writecb = null, n != null && e.push(n), i(t);
	var a = e._readableState;
	a.reading = !1, (a.needReadable || a.length < a.highWaterMark) && e._read(a.highWaterMark);
}
function uN(e) {
	if (!(this instanceof uN)) return new uN(e);
	lN.call(this, e), this._transformState = new Pre(this);
	var t = this;
	this._readableState.needReadable = !0, this._readableState.sync = !1, e && (typeof e.transform == "function" && (this._transform = e.transform), typeof e.flush == "function" && (this._flush = e.flush)), this.once("prefinish", function() {
		typeof this._flush == "function" ? this._flush(function(e) {
			dN(t, e);
		}) : dN(t);
	});
}
uN.prototype.push = function(e, t) {
	return this._transformState.needTransform = !1, lN.prototype.push.call(this, e, t);
}, uN.prototype._transform = function(e, t, n) {
	throw Error("Not implemented");
}, uN.prototype._write = function(e, t, n) {
	var r = this._transformState;
	if (r.writecb = n, r.writechunk = e, r.writeencoding = t, !r.transforming) {
		var i = this._readableState;
		(r.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
	}
}, uN.prototype._read = function(e) {
	var t = this._transformState;
	t.writechunk !== null && t.writecb && !t.transforming ? (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform)) : t.needTransform = !0;
};
function dN(e, t) {
	if (t) return e.emit("error", t);
	var n = e._writableState, r = e._transformState;
	if (n.length) throw Error("Calling transform done when ws.length != 0");
	if (r.transforming) throw Error("Calling transform done when still transforming");
	return e.push(null);
}
rM(fN, uN);
function fN(e) {
	if (!(this instanceof fN)) return new fN(e);
	uN.call(this, e);
}
fN.prototype._transform = function(e, t, n) {
	n(null, e);
}, rM(pN, Zj), pN.Readable = VM, pN.Writable = QM, pN.Duplex = lN, pN.Transform = uN, pN.PassThrough = fN, pN.Stream = pN;
function pN() {
	Zj.call(this);
}
pN.prototype.pipe = function(e, t) {
	var n = this;
	function r(t) {
		e.writable && !1 === e.write(t) && n.pause && n.pause();
	}
	n.on("data", r);
	function i() {
		n.readable && n.resume && n.resume();
	}
	e.on("drain", i), !e._isStdio && (!t || t.end !== !1) && (n.on("end", o), n.on("close", s));
	var a = !1;
	function o() {
		a || (a = !0, e.end());
	}
	function s() {
		a || (a = !0, typeof e.destroy == "function" && e.destroy());
	}
	function c(e) {
		if (l(), Zj.listenerCount(this, "error") === 0) throw e;
	}
	n.on("error", c), e.on("error", c);
	function l() {
		n.removeListener("data", r), e.removeListener("drain", i), n.removeListener("end", o), n.removeListener("close", s), n.removeListener("error", c), e.removeListener("error", c), n.removeListener("end", l), n.removeListener("close", l), e.removeListener("close", l);
	}
	return n.on("end", l), n.on("close", l), e.on("close", l), e.emit("pipe", n), e;
};
var Ire = /*@__PURE__*/ qj(/* @__PURE__ */ Object.freeze({
	__proto__: null,
	Duplex: lN,
	PassThrough: fN,
	Readable: VM,
	Stream: pN,
	Transform: uN,
	Writable: QM,
	default: pN
})), mN = {};
function hN(e, t) {
	if (e === t) return 0;
	for (var n = e.length, r = t.length, i = 0, a = Math.min(n, r); i < a; ++i) if (e[i] !== t[i]) {
		n = e[i], r = t[i];
		break;
	}
	return n < r ? -1 : +(r < n);
}
var Lre = Object.prototype.hasOwnProperty, gN = Object.keys || function(e) {
	var t = [];
	for (var n in e) Lre.call(e, n) && t.push(n);
	return t;
}, _N = Array.prototype.slice, vN;
function yN() {
	return vN === void 0 ? vN = function() {
		return function() {}.name === "foo";
	}() : vN;
}
function bN(e) {
	return Object.prototype.toString.call(e);
}
function xN(e) {
	return Ej(e) || typeof hA.ArrayBuffer != "function" ? !1 : typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(e) : e ? !!(e instanceof DataView || e.buffer && e.buffer instanceof ArrayBuffer) : !1;
}
function SN(e, t) {
	e || DN(e, !0, t, "==", ON);
}
var Rre = /\s*function\s+([^\(\s]*)\s*/;
function CN(e) {
	if (EM(e)) {
		if (yN()) return e.name;
		var t = e.toString().match(Rre);
		return t && t[1];
	}
}
SN.AssertionError = wN;
function wN(e) {
	this.name = "AssertionError", this.actual = e.actual, this.expected = e.expected, this.operator = e.operator, e.message ? (this.message = e.message, this.generatedMessage = !1) : (this.message = zre(this), this.generatedMessage = !0);
	var t = e.stackStartFunction || DN;
	if (Error.captureStackTrace) Error.captureStackTrace(this, t);
	else {
		var n = /* @__PURE__ */ Error();
		if (n.stack) {
			var r = n.stack, i = CN(t), a = r.indexOf("\n" + i);
			if (a >= 0) {
				var o = r.indexOf("\n", a + 1);
				r = r.substring(o + 1);
			}
			this.stack = r;
		}
	}
}
rM(wN, Error);
function TN(e, t) {
	return typeof e == "string" ? e.length < t ? e : e.slice(0, t) : e;
}
function EN(e) {
	if (yN() || !EM(e)) return uM(e);
	var t = CN(e);
	return "[Function" + (t ? ": " + t : "") + "]";
}
function zre(e) {
	return TN(EN(e.actual), 128) + " " + e.operator + " " + TN(EN(e.expected), 128);
}
function DN(e, t, n, r, i) {
	throw new wN({
		message: n,
		actual: e,
		expected: t,
		operator: r,
		stackStartFunction: i
	});
}
SN.fail = DN;
function ON(e, t) {
	e || DN(e, !0, t, "==", ON);
}
SN.ok = ON, SN.equal = kN;
function kN(e, t, n) {
	e != t && DN(e, t, n, "==", kN);
}
SN.notEqual = AN;
function AN(e, t, n) {
	e == t && DN(e, t, n, "!=", AN);
}
SN.deepEqual = jN;
function jN(e, t, n) {
	NN(e, t, !1) || DN(e, t, n, "deepEqual", jN);
}
SN.deepStrictEqual = MN;
function MN(e, t, n) {
	NN(e, t, !0) || DN(e, t, n, "deepStrictEqual", MN);
}
function NN(e, t, n, r) {
	if (e === t) return !0;
	if (Ej(e) && Ej(t)) return hN(e, t) === 0;
	if (wM(e) && wM(t)) return e.getTime() === t.getTime();
	if (SM(e) && SM(t)) return e.source === t.source && e.global === t.global && e.multiline === t.multiline && e.lastIndex === t.lastIndex && e.ignoreCase === t.ignoreCase;
	if ((typeof e != "object" || !e) && (typeof t != "object" || !t)) return n ? e === t : e == t;
	if (xN(e) && xN(t) && bN(e) === bN(t) && !(e instanceof Float32Array || e instanceof Float64Array)) return hN(new Uint8Array(e.buffer), new Uint8Array(t.buffer)) === 0;
	if (Ej(e) !== Ej(t)) return !1;
	r ||= {
		actual: [],
		expected: []
	};
	var i = r.actual.indexOf(e);
	return i !== -1 && i === r.expected.indexOf(t) ? !0 : (r.actual.push(e), r.expected.push(t), Bre(e, t, n, r));
}
function PN(e) {
	return Object.prototype.toString.call(e) == "[object Arguments]";
}
function Bre(e, t, n, r) {
	if (e == null || t == null) return !1;
	if (DM(e) || DM(t)) return e === t;
	if (n && Object.getPrototypeOf(e) !== Object.getPrototypeOf(t)) return !1;
	var i = PN(e), a = PN(t);
	if (i && !a || !i && a) return !1;
	if (i) return e = _N.call(e), t = _N.call(t), NN(e, t, n);
	var o = gN(e), s = gN(t), c, l;
	if (o.length !== s.length) return !1;
	for (o.sort(), s.sort(), l = o.length - 1; l >= 0; l--) if (o[l] !== s[l]) return !1;
	for (l = o.length - 1; l >= 0; l--) if (c = o[l], !NN(e[c], t[c], n, r)) return !1;
	return !0;
}
SN.notDeepEqual = FN;
function FN(e, t, n) {
	NN(e, t, !1) && DN(e, t, n, "notDeepEqual", FN);
}
SN.notDeepStrictEqual = IN;
function IN(e, t, n) {
	NN(e, t, !0) && DN(e, t, n, "notDeepStrictEqual", IN);
}
SN.strictEqual = LN;
function LN(e, t, n) {
	e !== t && DN(e, t, n, "===", LN);
}
SN.notStrictEqual = RN;
function RN(e, t, n) {
	e === t && DN(e, t, n, "!==", RN);
}
function zN(e, t) {
	if (!e || !t) return !1;
	if (Object.prototype.toString.call(t) == "[object RegExp]") return t.test(e);
	try {
		if (e instanceof t) return !0;
	} catch {}
	return Error.isPrototypeOf(t) ? !1 : t.call({}, e) === !0;
}
function Vre(e) {
	var t;
	try {
		e();
	} catch (e) {
		t = e;
	}
	return t;
}
function BN(e, t, n, r) {
	var i;
	if (typeof t != "function") throw TypeError("\"block\" argument must be a function");
	typeof n == "string" && (r = n, n = null), i = Vre(t), r = (n && n.name ? " (" + n.name + ")." : ".") + (r ? " " + r : "."), e && !i && DN(i, n, "Missing expected exception" + r);
	var a = typeof r == "string", o = !e && TM(i), s = !e && i && !n;
	if ((o && a && zN(i, n) || s) && DN(i, n, "Got unwanted exception" + r), e && i && n && !zN(i, n) || !e && i) throw i;
}
SN.throws = VN;
function VN(e, t, n) {
	BN(!0, e, t, n);
}
SN.doesNotThrow = HN;
function HN(e, t, n) {
	BN(!1, e, t, n);
}
SN.ifError = UN;
function UN(e) {
	if (e) throw e;
}
var WN = /*@__PURE__*/ qj(/* @__PURE__ */ Object.freeze({
	__proto__: null,
	AssertionError: wN,
	assert: ON,
	deepEqual: jN,
	deepStrictEqual: MN,
	default: SN,
	doesNotThrow: HN,
	equal: kN,
	fail: DN,
	ifError: UN,
	notDeepEqual: FN,
	notDeepStrictEqual: IN,
	notEqual: AN,
	notStrictEqual: RN,
	ok: ON,
	strictEqual: LN,
	throws: VN
}));
function Hre() {
	this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
}
var Ure = Hre, GN = {}, KN = {};
(function(e) {
	var t = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
	function n(e, t) {
		return Object.prototype.hasOwnProperty.call(e, t);
	}
	e.assign = function(e) {
		for (var t = Array.prototype.slice.call(arguments, 1); t.length;) {
			var r = t.shift();
			if (r) {
				if (typeof r != "object") throw TypeError(r + "must be non-object");
				for (var i in r) n(r, i) && (e[i] = r[i]);
			}
		}
		return e;
	}, e.shrinkBuf = function(e, t) {
		return e.length === t ? e : e.subarray ? e.subarray(0, t) : (e.length = t, e);
	};
	var r = {
		arraySet: function(e, t, n, r, i) {
			if (t.subarray && e.subarray) {
				e.set(t.subarray(n, n + r), i);
				return;
			}
			for (var a = 0; a < r; a++) e[i + a] = t[n + a];
		},
		flattenChunks: function(e) {
			var t, n, r = 0, i, a, o;
			for (t = 0, n = e.length; t < n; t++) r += e[t].length;
			for (o = new Uint8Array(r), i = 0, t = 0, n = e.length; t < n; t++) a = e[t], o.set(a, i), i += a.length;
			return o;
		}
	}, i = {
		arraySet: function(e, t, n, r, i) {
			for (var a = 0; a < r; a++) e[i + a] = t[n + a];
		},
		flattenChunks: function(e) {
			return [].concat.apply([], e);
		}
	};
	e.setTyped = function(t) {
		t ? (e.Buf8 = Uint8Array, e.Buf16 = Uint16Array, e.Buf32 = Int32Array, e.assign(e, r)) : (e.Buf8 = Array, e.Buf16 = Array, e.Buf32 = Array, e.assign(e, i));
	}, e.setTyped(t);
})(KN);
var qN = {}, Wre = KN, Gre = 4, JN = 0, YN = 1, XN = 2;
function ZN(e) {
	for (var t = e.length; --t >= 0;) e[t] = 0;
}
var QN = 0, $N = 1, eP = 2, tP = 3, nP = 258, rP = 29, iP = 256, aP = iP + 1 + rP, oP = 30, sP = 19, cP = 2 * aP + 1, lP = 15, uP = 16, dP = 7, fP = 256, pP = 16, mP = 17, hP = 18, gP = [
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	1,
	1,
	1,
	1,
	2,
	2,
	2,
	2,
	3,
	3,
	3,
	3,
	4,
	4,
	4,
	4,
	5,
	5,
	5,
	5,
	0
], _P = [
	0,
	0,
	0,
	0,
	1,
	1,
	2,
	2,
	3,
	3,
	4,
	4,
	5,
	5,
	6,
	6,
	7,
	7,
	8,
	8,
	9,
	9,
	10,
	10,
	11,
	11,
	12,
	12,
	13,
	13
], vP = [
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	0,
	2,
	3,
	7
], yP = [
	16,
	17,
	18,
	0,
	8,
	7,
	9,
	6,
	10,
	5,
	11,
	4,
	12,
	3,
	13,
	2,
	14,
	1,
	15
], bP = 512, xP = Array((aP + 2) * 2);
ZN(xP);
var SP = Array(oP * 2);
ZN(SP);
var CP = Array(bP);
ZN(CP);
var wP = Array(nP - tP + 1);
ZN(wP);
var TP = Array(rP);
ZN(TP);
var EP = Array(oP);
ZN(EP);
function DP(e, t, n, r, i) {
	this.static_tree = e, this.extra_bits = t, this.extra_base = n, this.elems = r, this.max_length = i, this.has_stree = e && e.length;
}
var OP, kP, AP;
function jP(e, t) {
	this.dyn_tree = e, this.max_code = 0, this.stat_desc = t;
}
function MP(e) {
	return e < 256 ? CP[e] : CP[256 + (e >>> 7)];
}
function NP(e, t) {
	e.pending_buf[e.pending++] = t & 255, e.pending_buf[e.pending++] = t >>> 8 & 255;
}
function PP(e, t, n) {
	e.bi_valid > uP - n ? (e.bi_buf |= t << e.bi_valid & 65535, NP(e, e.bi_buf), e.bi_buf = t >> uP - e.bi_valid, e.bi_valid += n - uP) : (e.bi_buf |= t << e.bi_valid & 65535, e.bi_valid += n);
}
function FP(e, t, n) {
	PP(e, n[t * 2], n[t * 2 + 1]);
}
function IP(e, t) {
	var n = 0;
	do
		n |= e & 1, e >>>= 1, n <<= 1;
	while (--t > 0);
	return n >>> 1;
}
function LP(e) {
	e.bi_valid === 16 ? (NP(e, e.bi_buf), e.bi_buf = 0, e.bi_valid = 0) : e.bi_valid >= 8 && (e.pending_buf[e.pending++] = e.bi_buf & 255, e.bi_buf >>= 8, e.bi_valid -= 8);
}
function RP(e, t) {
	var n = t.dyn_tree, r = t.max_code, i = t.stat_desc.static_tree, a = t.stat_desc.has_stree, o = t.stat_desc.extra_bits, s = t.stat_desc.extra_base, c = t.stat_desc.max_length, l, u, d, f, p, m, h = 0;
	for (f = 0; f <= lP; f++) e.bl_count[f] = 0;
	for (n[e.heap[e.heap_max] * 2 + 1] = 0, l = e.heap_max + 1; l < cP; l++) u = e.heap[l], f = n[n[u * 2 + 1] * 2 + 1] + 1, f > c && (f = c, h++), n[u * 2 + 1] = f, !(u > r) && (e.bl_count[f]++, p = 0, u >= s && (p = o[u - s]), m = n[u * 2], e.opt_len += m * (f + p), a && (e.static_len += m * (i[u * 2 + 1] + p)));
	if (h !== 0) {
		do {
			for (f = c - 1; e.bl_count[f] === 0;) f--;
			e.bl_count[f]--, e.bl_count[f + 1] += 2, e.bl_count[c]--, h -= 2;
		} while (h > 0);
		for (f = c; f !== 0; f--) for (u = e.bl_count[f]; u !== 0;) d = e.heap[--l], !(d > r) && (n[d * 2 + 1] !== f && (e.opt_len += (f - n[d * 2 + 1]) * n[d * 2], n[d * 2 + 1] = f), u--);
	}
}
function zP(e, t, n) {
	var r = Array(lP + 1), i = 0, a, o;
	for (a = 1; a <= lP; a++) r[a] = i = i + n[a - 1] << 1;
	for (o = 0; o <= t; o++) {
		var s = e[o * 2 + 1];
		s !== 0 && (e[o * 2] = IP(r[s]++, s));
	}
}
function BP() {
	var e, t, n, r, i, a = Array(lP + 1);
	for (n = 0, r = 0; r < rP - 1; r++) for (TP[r] = n, e = 0; e < 1 << gP[r]; e++) wP[n++] = r;
	for (wP[n - 1] = r, i = 0, r = 0; r < 16; r++) for (EP[r] = i, e = 0; e < 1 << _P[r]; e++) CP[i++] = r;
	for (i >>= 7; r < oP; r++) for (EP[r] = i << 7, e = 0; e < 1 << _P[r] - 7; e++) CP[256 + i++] = r;
	for (t = 0; t <= lP; t++) a[t] = 0;
	for (e = 0; e <= 143;) xP[e * 2 + 1] = 8, e++, a[8]++;
	for (; e <= 255;) xP[e * 2 + 1] = 9, e++, a[9]++;
	for (; e <= 279;) xP[e * 2 + 1] = 7, e++, a[7]++;
	for (; e <= 287;) xP[e * 2 + 1] = 8, e++, a[8]++;
	for (zP(xP, aP + 1, a), e = 0; e < oP; e++) SP[e * 2 + 1] = 5, SP[e * 2] = IP(e, 5);
	OP = new DP(xP, gP, iP + 1, aP, lP), kP = new DP(SP, _P, 0, oP, lP), AP = new DP([], vP, 0, sP, dP);
}
function VP(e) {
	var t;
	for (t = 0; t < aP; t++) e.dyn_ltree[t * 2] = 0;
	for (t = 0; t < oP; t++) e.dyn_dtree[t * 2] = 0;
	for (t = 0; t < sP; t++) e.bl_tree[t * 2] = 0;
	e.dyn_ltree[fP * 2] = 1, e.opt_len = e.static_len = 0, e.last_lit = e.matches = 0;
}
function HP(e) {
	e.bi_valid > 8 ? NP(e, e.bi_buf) : e.bi_valid > 0 && (e.pending_buf[e.pending++] = e.bi_buf), e.bi_buf = 0, e.bi_valid = 0;
}
function UP(e, t, n, r) {
	HP(e), r && (NP(e, n), NP(e, ~n)), Wre.arraySet(e.pending_buf, e.window, t, n, e.pending), e.pending += n;
}
function WP(e, t, n, r) {
	var i = t * 2, a = n * 2;
	return e[i] < e[a] || e[i] === e[a] && r[t] <= r[n];
}
function GP(e, t, n) {
	for (var r = e.heap[n], i = n << 1; i <= e.heap_len && (i < e.heap_len && WP(t, e.heap[i + 1], e.heap[i], e.depth) && i++, !WP(t, r, e.heap[i], e.depth));) e.heap[n] = e.heap[i], n = i, i <<= 1;
	e.heap[n] = r;
}
function KP(e, t, n) {
	var r, i, a = 0, o, s;
	if (e.last_lit !== 0) do
		r = e.pending_buf[e.d_buf + a * 2] << 8 | e.pending_buf[e.d_buf + a * 2 + 1], i = e.pending_buf[e.l_buf + a], a++, r === 0 ? FP(e, i, t) : (o = wP[i], FP(e, o + iP + 1, t), s = gP[o], s !== 0 && (i -= TP[o], PP(e, i, s)), r--, o = MP(r), FP(e, o, n), s = _P[o], s !== 0 && (r -= EP[o], PP(e, r, s)));
	while (a < e.last_lit);
	FP(e, fP, t);
}
function qP(e, t) {
	var n = t.dyn_tree, r = t.stat_desc.static_tree, i = t.stat_desc.has_stree, a = t.stat_desc.elems, o, s, c = -1, l;
	for (e.heap_len = 0, e.heap_max = cP, o = 0; o < a; o++) n[o * 2] === 0 ? n[o * 2 + 1] = 0 : (e.heap[++e.heap_len] = c = o, e.depth[o] = 0);
	for (; e.heap_len < 2;) l = e.heap[++e.heap_len] = c < 2 ? ++c : 0, n[l * 2] = 1, e.depth[l] = 0, e.opt_len--, i && (e.static_len -= r[l * 2 + 1]);
	for (t.max_code = c, o = e.heap_len >> 1; o >= 1; o--) GP(e, n, o);
	l = a;
	do
		o = e.heap[1], e.heap[1] = e.heap[e.heap_len--], GP(e, n, 1), s = e.heap[1], e.heap[--e.heap_max] = o, e.heap[--e.heap_max] = s, n[l * 2] = n[o * 2] + n[s * 2], e.depth[l] = (e.depth[o] >= e.depth[s] ? e.depth[o] : e.depth[s]) + 1, n[o * 2 + 1] = n[s * 2 + 1] = l, e.heap[1] = l++, GP(e, n, 1);
	while (e.heap_len >= 2);
	e.heap[--e.heap_max] = e.heap[1], RP(e, t), zP(n, c, e.bl_count);
}
function JP(e, t, n) {
	var r, i = -1, a, o = t[1], s = 0, c = 7, l = 4;
	for (o === 0 && (c = 138, l = 3), t[(n + 1) * 2 + 1] = 65535, r = 0; r <= n; r++) a = o, o = t[(r + 1) * 2 + 1], !(++s < c && a === o) && (s < l ? e.bl_tree[a * 2] += s : a === 0 ? s <= 10 ? e.bl_tree[mP * 2]++ : e.bl_tree[hP * 2]++ : (a !== i && e.bl_tree[a * 2]++, e.bl_tree[pP * 2]++), s = 0, i = a, o === 0 ? (c = 138, l = 3) : a === o ? (c = 6, l = 3) : (c = 7, l = 4));
}
function YP(e, t, n) {
	var r, i = -1, a, o = t[1], s = 0, c = 7, l = 4;
	for (o === 0 && (c = 138, l = 3), r = 0; r <= n; r++) if (a = o, o = t[(r + 1) * 2 + 1], !(++s < c && a === o)) {
		if (s < l) do
			FP(e, a, e.bl_tree);
		while (--s !== 0);
		else a === 0 ? s <= 10 ? (FP(e, mP, e.bl_tree), PP(e, s - 3, 3)) : (FP(e, hP, e.bl_tree), PP(e, s - 11, 7)) : (a !== i && (FP(e, a, e.bl_tree), s--), FP(e, pP, e.bl_tree), PP(e, s - 3, 2));
		s = 0, i = a, o === 0 ? (c = 138, l = 3) : a === o ? (c = 6, l = 3) : (c = 7, l = 4);
	}
}
function XP(e) {
	var t;
	for (JP(e, e.dyn_ltree, e.l_desc.max_code), JP(e, e.dyn_dtree, e.d_desc.max_code), qP(e, e.bl_desc), t = sP - 1; t >= 3 && e.bl_tree[yP[t] * 2 + 1] === 0; t--);
	return e.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
}
function ZP(e, t, n, r) {
	var i;
	for (PP(e, t - 257, 5), PP(e, n - 1, 5), PP(e, r - 4, 4), i = 0; i < r; i++) PP(e, e.bl_tree[yP[i] * 2 + 1], 3);
	YP(e, e.dyn_ltree, t - 1), YP(e, e.dyn_dtree, n - 1);
}
function QP(e) {
	var t = 4093624447, n;
	for (n = 0; n <= 31; n++, t >>>= 1) if (t & 1 && e.dyn_ltree[n * 2] !== 0) return JN;
	if (e.dyn_ltree[18] !== 0 || e.dyn_ltree[20] !== 0 || e.dyn_ltree[26] !== 0) return YN;
	for (n = 32; n < iP; n++) if (e.dyn_ltree[n * 2] !== 0) return YN;
	return JN;
}
var $P = !1;
function eF(e) {
	$P ||= (BP(), !0), e.l_desc = new jP(e.dyn_ltree, OP), e.d_desc = new jP(e.dyn_dtree, kP), e.bl_desc = new jP(e.bl_tree, AP), e.bi_buf = 0, e.bi_valid = 0, VP(e);
}
function tF(e, t, n, r) {
	PP(e, (QN << 1) + +!!r, 3), UP(e, t, n, !0);
}
function nF(e) {
	PP(e, $N << 1, 3), FP(e, fP, xP), LP(e);
}
function rF(e, t, n, r) {
	var i, a, o = 0;
	e.level > 0 ? (e.strm.data_type === XN && (e.strm.data_type = QP(e)), qP(e, e.l_desc), qP(e, e.d_desc), o = XP(e), i = e.opt_len + 3 + 7 >>> 3, a = e.static_len + 3 + 7 >>> 3, a <= i && (i = a)) : i = a = n + 5, n + 4 <= i && t !== -1 ? tF(e, t, n, r) : e.strategy === Gre || a === i ? (PP(e, ($N << 1) + +!!r, 3), KP(e, xP, SP)) : (PP(e, (eP << 1) + +!!r, 3), ZP(e, e.l_desc.max_code + 1, e.d_desc.max_code + 1, o + 1), KP(e, e.dyn_ltree, e.dyn_dtree)), VP(e), r && HP(e);
}
function iF(e, t, n) {
	return e.pending_buf[e.d_buf + e.last_lit * 2] = t >>> 8 & 255, e.pending_buf[e.d_buf + e.last_lit * 2 + 1] = t & 255, e.pending_buf[e.l_buf + e.last_lit] = n & 255, e.last_lit++, t === 0 ? e.dyn_ltree[n * 2]++ : (e.matches++, t--, e.dyn_ltree[(wP[n] + iP + 1) * 2]++, e.dyn_dtree[MP(t) * 2]++), e.last_lit === e.lit_bufsize - 1;
}
qN._tr_init = eF, qN._tr_stored_block = tF, qN._tr_flush_block = rF, qN._tr_tally = iF, qN._tr_align = nF;
function aF(e, t, n, r) {
	for (var i = e & 65535 | 0, a = e >>> 16 & 65535 | 0, o = 0; n !== 0;) {
		o = n > 2e3 ? 2e3 : n, n -= o;
		do
			i = i + t[r++] | 0, a = a + i | 0;
		while (--o);
		i %= 65521, a %= 65521;
	}
	return i | a << 16 | 0;
}
var oF = aF;
function sF() {
	for (var e, t = [], n = 0; n < 256; n++) {
		e = n;
		for (var r = 0; r < 8; r++) e = e & 1 ? 3988292384 ^ e >>> 1 : e >>> 1;
		t[n] = e;
	}
	return t;
}
var cF = sF();
function lF(e, t, n, r) {
	var i = cF, a = r + n;
	e ^= -1;
	for (var o = r; o < a; o++) e = e >>> 8 ^ i[(e ^ t[o]) & 255];
	return e ^ -1;
}
var uF = lF, dF = {
	2: "need dictionary",
	1: "stream end",
	0: "",
	"-1": "file error",
	"-2": "stream error",
	"-3": "data error",
	"-4": "insufficient memory",
	"-5": "buffer error",
	"-6": "incompatible version"
}, fF = KN, pF = qN, mF = oF, hF = uF, gF = dF, _F = 0, vF = 1, yF = 3, bF = 4, xF = 5, SF = 0, CF = 1, wF = -2, TF = -3, EF = -5, DF = -1, OF = 1, kF = 2, AF = 3, jF = 4, MF = 0, NF = 2, PF = 8, FF = 9, IF = 15, LF = 8, RF = 286, zF = 30, BF = 19, VF = 2 * RF + 1, HF = 15, UF = 3, WF = 258, GF = WF + UF + 1, KF = 32, qF = 42, JF = 69, YF = 73, XF = 91, ZF = 103, QF = 113, $F = 666, eI = 1, tI = 2, nI = 3, rI = 4, iI = 3;
function aI(e, t) {
	return e.msg = gF[t], t;
}
function oI(e) {
	return (e << 1) - (e > 4 ? 9 : 0);
}
function sI(e) {
	for (var t = e.length; --t >= 0;) e[t] = 0;
}
function cI(e) {
	var t = e.state, n = t.pending;
	n > e.avail_out && (n = e.avail_out), n !== 0 && (fF.arraySet(e.output, t.pending_buf, t.pending_out, n, e.next_out), e.next_out += n, t.pending_out += n, e.total_out += n, e.avail_out -= n, t.pending -= n, t.pending === 0 && (t.pending_out = 0));
}
function lI(e, t) {
	pF._tr_flush_block(e, e.block_start >= 0 ? e.block_start : -1, e.strstart - e.block_start, t), e.block_start = e.strstart, cI(e.strm);
}
function uI(e, t) {
	e.pending_buf[e.pending++] = t;
}
function dI(e, t) {
	e.pending_buf[e.pending++] = t >>> 8 & 255, e.pending_buf[e.pending++] = t & 255;
}
function fI(e, t, n, r) {
	var i = e.avail_in;
	return i > r && (i = r), i === 0 ? 0 : (e.avail_in -= i, fF.arraySet(t, e.input, e.next_in, i, n), e.state.wrap === 1 ? e.adler = mF(e.adler, t, i, n) : e.state.wrap === 2 && (e.adler = hF(e.adler, t, i, n)), e.next_in += i, e.total_in += i, i);
}
function pI(e, t) {
	var n = e.max_chain_length, r = e.strstart, i, a, o = e.prev_length, s = e.nice_match, c = e.strstart > e.w_size - GF ? e.strstart - (e.w_size - GF) : 0, l = e.window, u = e.w_mask, d = e.prev, f = e.strstart + WF, p = l[r + o - 1], m = l[r + o];
	e.prev_length >= e.good_match && (n >>= 2), s > e.lookahead && (s = e.lookahead);
	do {
		if (i = t, l[i + o] !== m || l[i + o - 1] !== p || l[i] !== l[r] || l[++i] !== l[r + 1]) continue;
		r += 2, i++;
		do		;
while (l[++r] === l[++i] && l[++r] === l[++i] && l[++r] === l[++i] && l[++r] === l[++i] && l[++r] === l[++i] && l[++r] === l[++i] && l[++r] === l[++i] && l[++r] === l[++i] && r < f);
		if (a = WF - (f - r), r = f - WF, a > o) {
			if (e.match_start = t, o = a, a >= s) break;
			p = l[r + o - 1], m = l[r + o];
		}
	} while ((t = d[t & u]) > c && --n !== 0);
	return o <= e.lookahead ? o : e.lookahead;
}
function mI(e) {
	var t = e.w_size, n, r, i, a, o;
	do {
		if (a = e.window_size - e.lookahead - e.strstart, e.strstart >= t + (t - GF)) {
			fF.arraySet(e.window, e.window, t, t, 0), e.match_start -= t, e.strstart -= t, e.block_start -= t, r = e.hash_size, n = r;
			do
				i = e.head[--n], e.head[n] = i >= t ? i - t : 0;
			while (--r);
			r = t, n = r;
			do
				i = e.prev[--n], e.prev[n] = i >= t ? i - t : 0;
			while (--r);
			a += t;
		}
		if (e.strm.avail_in === 0) break;
		if (r = fI(e.strm, e.window, e.strstart + e.lookahead, a), e.lookahead += r, e.lookahead + e.insert >= UF) for (o = e.strstart - e.insert, e.ins_h = e.window[o], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[o + 1]) & e.hash_mask; e.insert && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[o + UF - 1]) & e.hash_mask, e.prev[o & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = o, o++, e.insert--, !(e.lookahead + e.insert < UF)););
	} while (e.lookahead < GF && e.strm.avail_in !== 0);
}
function hI(e, t) {
	var n = 65535;
	for (n > e.pending_buf_size - 5 && (n = e.pending_buf_size - 5);;) {
		if (e.lookahead <= 1) {
			if (mI(e), e.lookahead === 0 && t === _F) return eI;
			if (e.lookahead === 0) break;
		}
		e.strstart += e.lookahead, e.lookahead = 0;
		var r = e.block_start + n;
		if ((e.strstart === 0 || e.strstart >= r) && (e.lookahead = e.strstart - r, e.strstart = r, lI(e, !1), e.strm.avail_out === 0) || e.strstart - e.block_start >= e.w_size - GF && (lI(e, !1), e.strm.avail_out === 0)) return eI;
	}
	return e.insert = 0, t === bF ? (lI(e, !0), e.strm.avail_out === 0 ? nI : rI) : (e.strstart > e.block_start && (lI(e, !1), e.strm.avail_out), eI);
}
function gI(e, t) {
	for (var n, r;;) {
		if (e.lookahead < GF) {
			if (mI(e), e.lookahead < GF && t === _F) return eI;
			if (e.lookahead === 0) break;
		}
		if (n = 0, e.lookahead >= UF && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + UF - 1]) & e.hash_mask, n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), n !== 0 && e.strstart - n <= e.w_size - GF && (e.match_length = pI(e, n)), e.match_length >= UF) if (r = pF._tr_tally(e, e.strstart - e.match_start, e.match_length - UF), e.lookahead -= e.match_length, e.match_length <= e.max_lazy_match && e.lookahead >= UF) {
			e.match_length--;
			do
				e.strstart++, e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + UF - 1]) & e.hash_mask, n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart;
			while (--e.match_length !== 0);
			e.strstart++;
		} else e.strstart += e.match_length, e.match_length = 0, e.ins_h = e.window[e.strstart], e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + 1]) & e.hash_mask;
		else r = pF._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++;
		if (r && (lI(e, !1), e.strm.avail_out === 0)) return eI;
	}
	return e.insert = e.strstart < UF - 1 ? e.strstart : UF - 1, t === bF ? (lI(e, !0), e.strm.avail_out === 0 ? nI : rI) : e.last_lit && (lI(e, !1), e.strm.avail_out === 0) ? eI : tI;
}
function _I(e, t) {
	for (var n, r, i;;) {
		if (e.lookahead < GF) {
			if (mI(e), e.lookahead < GF && t === _F) return eI;
			if (e.lookahead === 0) break;
		}
		if (n = 0, e.lookahead >= UF && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + UF - 1]) & e.hash_mask, n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart), e.prev_length = e.match_length, e.prev_match = e.match_start, e.match_length = UF - 1, n !== 0 && e.prev_length < e.max_lazy_match && e.strstart - n <= e.w_size - GF && (e.match_length = pI(e, n), e.match_length <= 5 && (e.strategy === OF || e.match_length === UF && e.strstart - e.match_start > 4096) && (e.match_length = UF - 1)), e.prev_length >= UF && e.match_length <= e.prev_length) {
			i = e.strstart + e.lookahead - UF, r = pF._tr_tally(e, e.strstart - 1 - e.prev_match, e.prev_length - UF), e.lookahead -= e.prev_length - 1, e.prev_length -= 2;
			do
				++e.strstart <= i && (e.ins_h = (e.ins_h << e.hash_shift ^ e.window[e.strstart + UF - 1]) & e.hash_mask, n = e.prev[e.strstart & e.w_mask] = e.head[e.ins_h], e.head[e.ins_h] = e.strstart);
			while (--e.prev_length !== 0);
			if (e.match_available = 0, e.match_length = UF - 1, e.strstart++, r && (lI(e, !1), e.strm.avail_out === 0)) return eI;
		} else if (e.match_available) {
			if (r = pF._tr_tally(e, 0, e.window[e.strstart - 1]), r && lI(e, !1), e.strstart++, e.lookahead--, e.strm.avail_out === 0) return eI;
		} else e.match_available = 1, e.strstart++, e.lookahead--;
	}
	return e.match_available &&= (r = pF._tr_tally(e, 0, e.window[e.strstart - 1]), 0), e.insert = e.strstart < UF - 1 ? e.strstart : UF - 1, t === bF ? (lI(e, !0), e.strm.avail_out === 0 ? nI : rI) : e.last_lit && (lI(e, !1), e.strm.avail_out === 0) ? eI : tI;
}
function vI(e, t) {
	for (var n, r, i, a, o = e.window;;) {
		if (e.lookahead <= WF) {
			if (mI(e), e.lookahead <= WF && t === _F) return eI;
			if (e.lookahead === 0) break;
		}
		if (e.match_length = 0, e.lookahead >= UF && e.strstart > 0 && (i = e.strstart - 1, r = o[i], r === o[++i] && r === o[++i] && r === o[++i])) {
			a = e.strstart + WF;
			do			;
while (r === o[++i] && r === o[++i] && r === o[++i] && r === o[++i] && r === o[++i] && r === o[++i] && r === o[++i] && r === o[++i] && i < a);
			e.match_length = WF - (a - i), e.match_length > e.lookahead && (e.match_length = e.lookahead);
		}
		if (e.match_length >= UF ? (n = pF._tr_tally(e, 1, e.match_length - UF), e.lookahead -= e.match_length, e.strstart += e.match_length, e.match_length = 0) : (n = pF._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++), n && (lI(e, !1), e.strm.avail_out === 0)) return eI;
	}
	return e.insert = 0, t === bF ? (lI(e, !0), e.strm.avail_out === 0 ? nI : rI) : e.last_lit && (lI(e, !1), e.strm.avail_out === 0) ? eI : tI;
}
function yI(e, t) {
	for (var n;;) {
		if (e.lookahead === 0 && (mI(e), e.lookahead === 0)) {
			if (t === _F) return eI;
			break;
		}
		if (e.match_length = 0, n = pF._tr_tally(e, 0, e.window[e.strstart]), e.lookahead--, e.strstart++, n && (lI(e, !1), e.strm.avail_out === 0)) return eI;
	}
	return e.insert = 0, t === bF ? (lI(e, !0), e.strm.avail_out === 0 ? nI : rI) : e.last_lit && (lI(e, !1), e.strm.avail_out === 0) ? eI : tI;
}
function bI(e, t, n, r, i) {
	this.good_length = e, this.max_lazy = t, this.nice_length = n, this.max_chain = r, this.func = i;
}
var xI = [
	new bI(0, 0, 0, 0, hI),
	new bI(4, 4, 8, 4, gI),
	new bI(4, 5, 16, 8, gI),
	new bI(4, 6, 32, 32, gI),
	new bI(4, 4, 16, 16, _I),
	new bI(8, 16, 32, 32, _I),
	new bI(8, 16, 128, 128, _I),
	new bI(8, 32, 128, 256, _I),
	new bI(32, 128, 258, 1024, _I),
	new bI(32, 258, 258, 4096, _I)
];
function SI(e) {
	e.window_size = 2 * e.w_size, sI(e.head), e.max_lazy_match = xI[e.level].max_lazy, e.good_match = xI[e.level].good_length, e.nice_match = xI[e.level].nice_length, e.max_chain_length = xI[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = UF - 1, e.match_available = 0, e.ins_h = 0;
}
function CI() {
	this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = PF, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new fF.Buf16(VF * 2), this.dyn_dtree = new fF.Buf16((2 * zF + 1) * 2), this.bl_tree = new fF.Buf16((2 * BF + 1) * 2), sI(this.dyn_ltree), sI(this.dyn_dtree), sI(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new fF.Buf16(HF + 1), this.heap = new fF.Buf16(2 * RF + 1), sI(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new fF.Buf16(2 * RF + 1), sI(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
}
function wI(e) {
	var t;
	return !e || !e.state ? aI(e, wF) : (e.total_in = e.total_out = 0, e.data_type = NF, t = e.state, t.pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? qF : QF, e.adler = t.wrap === 2 ? 0 : 1, t.last_flush = _F, pF._tr_init(t), SF);
}
function TI(e) {
	var t = wI(e);
	return t === SF && SI(e.state), t;
}
function EI(e, t) {
	return !e || !e.state || e.state.wrap !== 2 ? wF : (e.state.gzhead = t, SF);
}
function DI(e, t, n, r, i, a) {
	if (!e) return wF;
	var o = 1;
	if (t === DF && (t = 6), r < 0 ? (o = 0, r = -r) : r > 15 && (o = 2, r -= 16), i < 1 || i > FF || n !== PF || r < 8 || r > 15 || t < 0 || t > 9 || a < 0 || a > jF) return aI(e, wF);
	r === 8 && (r = 9);
	var s = new CI();
	return e.state = s, s.strm = e, s.wrap = o, s.gzhead = null, s.w_bits = r, s.w_size = 1 << s.w_bits, s.w_mask = s.w_size - 1, s.hash_bits = i + 7, s.hash_size = 1 << s.hash_bits, s.hash_mask = s.hash_size - 1, s.hash_shift = ~~((s.hash_bits + UF - 1) / UF), s.window = new fF.Buf8(s.w_size * 2), s.head = new fF.Buf16(s.hash_size), s.prev = new fF.Buf16(s.w_size), s.lit_bufsize = 1 << i + 6, s.pending_buf_size = s.lit_bufsize * 4, s.pending_buf = new fF.Buf8(s.pending_buf_size), s.d_buf = 1 * s.lit_bufsize, s.l_buf = 3 * s.lit_bufsize, s.level = t, s.strategy = a, s.method = n, TI(e);
}
function OI(e, t) {
	return DI(e, t, PF, IF, LF, MF);
}
function kI(e, t) {
	var n, r, i, a;
	if (!e || !e.state || t > xF || t < 0) return e ? aI(e, wF) : wF;
	if (r = e.state, !e.output || !e.input && e.avail_in !== 0 || r.status === $F && t !== bF) return aI(e, e.avail_out === 0 ? EF : wF);
	if (r.strm = e, n = r.last_flush, r.last_flush = t, r.status === qF) if (r.wrap === 2) e.adler = 0, uI(r, 31), uI(r, 139), uI(r, 8), r.gzhead ? (uI(r, +!!r.gzhead.text + (r.gzhead.hcrc ? 2 : 0) + (r.gzhead.extra ? 4 : 0) + (r.gzhead.name ? 8 : 0) + (r.gzhead.comment ? 16 : 0)), uI(r, r.gzhead.time & 255), uI(r, r.gzhead.time >> 8 & 255), uI(r, r.gzhead.time >> 16 & 255), uI(r, r.gzhead.time >> 24 & 255), uI(r, r.level === 9 ? 2 : r.strategy >= kF || r.level < 2 ? 4 : 0), uI(r, r.gzhead.os & 255), r.gzhead.extra && r.gzhead.extra.length && (uI(r, r.gzhead.extra.length & 255), uI(r, r.gzhead.extra.length >> 8 & 255)), r.gzhead.hcrc && (e.adler = hF(e.adler, r.pending_buf, r.pending, 0)), r.gzindex = 0, r.status = JF) : (uI(r, 0), uI(r, 0), uI(r, 0), uI(r, 0), uI(r, 0), uI(r, r.level === 9 ? 2 : r.strategy >= kF || r.level < 2 ? 4 : 0), uI(r, iI), r.status = QF);
	else {
		var o = PF + (r.w_bits - 8 << 4) << 8, s = -1;
		s = r.strategy >= kF || r.level < 2 ? 0 : r.level < 6 ? 1 : r.level === 6 ? 2 : 3, o |= s << 6, r.strstart !== 0 && (o |= KF), o += 31 - o % 31, r.status = QF, dI(r, o), r.strstart !== 0 && (dI(r, e.adler >>> 16), dI(r, e.adler & 65535)), e.adler = 1;
	}
	if (r.status === JF) if (r.gzhead.extra) {
		for (i = r.pending; r.gzindex < (r.gzhead.extra.length & 65535) && !(r.pending === r.pending_buf_size && (r.gzhead.hcrc && r.pending > i && (e.adler = hF(e.adler, r.pending_buf, r.pending - i, i)), cI(e), i = r.pending, r.pending === r.pending_buf_size));) uI(r, r.gzhead.extra[r.gzindex] & 255), r.gzindex++;
		r.gzhead.hcrc && r.pending > i && (e.adler = hF(e.adler, r.pending_buf, r.pending - i, i)), r.gzindex === r.gzhead.extra.length && (r.gzindex = 0, r.status = YF);
	} else r.status = YF;
	if (r.status === YF) if (r.gzhead.name) {
		i = r.pending;
		do {
			if (r.pending === r.pending_buf_size && (r.gzhead.hcrc && r.pending > i && (e.adler = hF(e.adler, r.pending_buf, r.pending - i, i)), cI(e), i = r.pending, r.pending === r.pending_buf_size)) {
				a = 1;
				break;
			}
			a = r.gzindex < r.gzhead.name.length ? r.gzhead.name.charCodeAt(r.gzindex++) & 255 : 0, uI(r, a);
		} while (a !== 0);
		r.gzhead.hcrc && r.pending > i && (e.adler = hF(e.adler, r.pending_buf, r.pending - i, i)), a === 0 && (r.gzindex = 0, r.status = XF);
	} else r.status = XF;
	if (r.status === XF) if (r.gzhead.comment) {
		i = r.pending;
		do {
			if (r.pending === r.pending_buf_size && (r.gzhead.hcrc && r.pending > i && (e.adler = hF(e.adler, r.pending_buf, r.pending - i, i)), cI(e), i = r.pending, r.pending === r.pending_buf_size)) {
				a = 1;
				break;
			}
			a = r.gzindex < r.gzhead.comment.length ? r.gzhead.comment.charCodeAt(r.gzindex++) & 255 : 0, uI(r, a);
		} while (a !== 0);
		r.gzhead.hcrc && r.pending > i && (e.adler = hF(e.adler, r.pending_buf, r.pending - i, i)), a === 0 && (r.status = ZF);
	} else r.status = ZF;
	if (r.status === ZF && (r.gzhead.hcrc ? (r.pending + 2 > r.pending_buf_size && cI(e), r.pending + 2 <= r.pending_buf_size && (uI(r, e.adler & 255), uI(r, e.adler >> 8 & 255), e.adler = 0, r.status = QF)) : r.status = QF), r.pending !== 0) {
		if (cI(e), e.avail_out === 0) return r.last_flush = -1, SF;
	} else if (e.avail_in === 0 && oI(t) <= oI(n) && t !== bF) return aI(e, EF);
	if (r.status === $F && e.avail_in !== 0) return aI(e, EF);
	if (e.avail_in !== 0 || r.lookahead !== 0 || t !== _F && r.status !== $F) {
		var c = r.strategy === kF ? yI(r, t) : r.strategy === AF ? vI(r, t) : xI[r.level].func(r, t);
		if ((c === nI || c === rI) && (r.status = $F), c === eI || c === nI) return e.avail_out === 0 && (r.last_flush = -1), SF;
		if (c === tI && (t === vF ? pF._tr_align(r) : t !== xF && (pF._tr_stored_block(r, 0, 0, !1), t === yF && (sI(r.head), r.lookahead === 0 && (r.strstart = 0, r.block_start = 0, r.insert = 0))), cI(e), e.avail_out === 0)) return r.last_flush = -1, SF;
	}
	return t === bF ? r.wrap <= 0 ? CF : (r.wrap === 2 ? (uI(r, e.adler & 255), uI(r, e.adler >> 8 & 255), uI(r, e.adler >> 16 & 255), uI(r, e.adler >> 24 & 255), uI(r, e.total_in & 255), uI(r, e.total_in >> 8 & 255), uI(r, e.total_in >> 16 & 255), uI(r, e.total_in >> 24 & 255)) : (dI(r, e.adler >>> 16), dI(r, e.adler & 65535)), cI(e), r.wrap > 0 && (r.wrap = -r.wrap), r.pending === 0 ? CF : SF) : SF;
}
function AI(e) {
	var t;
	return !e || !e.state ? wF : (t = e.state.status, t !== qF && t !== JF && t !== YF && t !== XF && t !== ZF && t !== QF && t !== $F ? aI(e, wF) : (e.state = null, t === QF ? aI(e, TF) : SF));
}
function jI(e, t) {
	var n = t.length, r, i, a, o, s, c, l, u;
	if (!e || !e.state || (r = e.state, o = r.wrap, o === 2 || o === 1 && r.status !== qF || r.lookahead)) return wF;
	for (o === 1 && (e.adler = mF(e.adler, t, n, 0)), r.wrap = 0, n >= r.w_size && (o === 0 && (sI(r.head), r.strstart = 0, r.block_start = 0, r.insert = 0), u = new fF.Buf8(r.w_size), fF.arraySet(u, t, n - r.w_size, r.w_size, 0), t = u, n = r.w_size), s = e.avail_in, c = e.next_in, l = e.input, e.avail_in = n, e.next_in = 0, e.input = t, mI(r); r.lookahead >= UF;) {
		i = r.strstart, a = r.lookahead - (UF - 1);
		do
			r.ins_h = (r.ins_h << r.hash_shift ^ r.window[i + UF - 1]) & r.hash_mask, r.prev[i & r.w_mask] = r.head[r.ins_h], r.head[r.ins_h] = i, i++;
		while (--a);
		r.strstart = i, r.lookahead = UF - 1, mI(r);
	}
	return r.strstart += r.lookahead, r.block_start = r.strstart, r.insert = r.lookahead, r.lookahead = 0, r.match_length = r.prev_length = UF - 1, r.match_available = 0, e.next_in = c, e.input = l, e.avail_in = s, r.wrap = o, SF;
}
GN.deflateInit = OI, GN.deflateInit2 = DI, GN.deflateReset = TI, GN.deflateResetKeep = wI, GN.deflateSetHeader = EI, GN.deflate = kI, GN.deflateEnd = AI, GN.deflateSetDictionary = jI, GN.deflateInfo = "pako deflate (from Nodeca project)";
var MI = {}, NI = 30, PI = 12, FI = function(e, t) {
	var n = e.state, r = e.next_in, i, a, o, s, c, l, u, d, f, p, m, h, g, _, v, y, b, x, S, C, w, T = e.input, E;
	i = r + (e.avail_in - 5), a = e.next_out, E = e.output, o = a - (t - e.avail_out), s = a + (e.avail_out - 257), c = n.dmax, l = n.wsize, u = n.whave, d = n.wnext, f = n.window, p = n.hold, m = n.bits, h = n.lencode, g = n.distcode, _ = (1 << n.lenbits) - 1, v = (1 << n.distbits) - 1;
	top: do {
		m < 15 && (p += T[r++] << m, m += 8, p += T[r++] << m, m += 8), y = h[p & _];
		dolen: for (;;) {
			if (b = y >>> 24, p >>>= b, m -= b, b = y >>> 16 & 255, b === 0) E[a++] = y & 65535;
			else if (b & 16) {
				x = y & 65535, b &= 15, b && (m < b && (p += T[r++] << m, m += 8), x += p & (1 << b) - 1, p >>>= b, m -= b), m < 15 && (p += T[r++] << m, m += 8, p += T[r++] << m, m += 8), y = g[p & v];
				dodist: for (;;) {
					if (b = y >>> 24, p >>>= b, m -= b, b = y >>> 16 & 255, b & 16) {
						if (S = y & 65535, b &= 15, m < b && (p += T[r++] << m, m += 8, m < b && (p += T[r++] << m, m += 8)), S += p & (1 << b) - 1, S > c) {
							e.msg = "invalid distance too far back", n.mode = NI;
							break top;
						}
						if (p >>>= b, m -= b, b = a - o, S > b) {
							if (b = S - b, b > u && n.sane) {
								e.msg = "invalid distance too far back", n.mode = NI;
								break top;
							}
							if (C = 0, w = f, d === 0) {
								if (C += l - b, b < x) {
									x -= b;
									do
										E[a++] = f[C++];
									while (--b);
									C = a - S, w = E;
								}
							} else if (d < b) {
								if (C += l + d - b, b -= d, b < x) {
									x -= b;
									do
										E[a++] = f[C++];
									while (--b);
									if (C = 0, d < x) {
										b = d, x -= b;
										do
											E[a++] = f[C++];
										while (--b);
										C = a - S, w = E;
									}
								}
							} else if (C += d - b, b < x) {
								x -= b;
								do
									E[a++] = f[C++];
								while (--b);
								C = a - S, w = E;
							}
							for (; x > 2;) E[a++] = w[C++], E[a++] = w[C++], E[a++] = w[C++], x -= 3;
							x && (E[a++] = w[C++], x > 1 && (E[a++] = w[C++]));
						} else {
							C = a - S;
							do
								E[a++] = E[C++], E[a++] = E[C++], E[a++] = E[C++], x -= 3;
							while (x > 2);
							x && (E[a++] = E[C++], x > 1 && (E[a++] = E[C++]));
						}
					} else if (b & 64) {
						e.msg = "invalid distance code", n.mode = NI;
						break top;
					} else {
						y = g[(y & 65535) + (p & (1 << b) - 1)];
						continue dodist;
					}
					break;
				}
			} else if (!(b & 64)) {
				y = h[(y & 65535) + (p & (1 << b) - 1)];
				continue dolen;
			} else if (b & 32) {
				n.mode = PI;
				break top;
			} else {
				e.msg = "invalid literal/length code", n.mode = NI;
				break top;
			}
			break;
		}
	} while (r < i && a < s);
	x = m >> 3, r -= x, m -= x << 3, p &= (1 << m) - 1, e.next_in = r, e.next_out = a, e.avail_in = r < i ? 5 + (i - r) : 5 - (r - i), e.avail_out = a < s ? 257 + (s - a) : 257 - (a - s), n.hold = p, n.bits = m;
}, II = KN, LI = 15, RI = 852, zI = 592, BI = 0, VI = 1, HI = 2, UI = [
	3,
	4,
	5,
	6,
	7,
	8,
	9,
	10,
	11,
	13,
	15,
	17,
	19,
	23,
	27,
	31,
	35,
	43,
	51,
	59,
	67,
	83,
	99,
	115,
	131,
	163,
	195,
	227,
	258,
	0,
	0
], WI = [
	16,
	16,
	16,
	16,
	16,
	16,
	16,
	16,
	17,
	17,
	17,
	17,
	18,
	18,
	18,
	18,
	19,
	19,
	19,
	19,
	20,
	20,
	20,
	20,
	21,
	21,
	21,
	21,
	16,
	72,
	78
], GI = [
	1,
	2,
	3,
	4,
	5,
	7,
	9,
	13,
	17,
	25,
	33,
	49,
	65,
	97,
	129,
	193,
	257,
	385,
	513,
	769,
	1025,
	1537,
	2049,
	3073,
	4097,
	6145,
	8193,
	12289,
	16385,
	24577,
	0,
	0
], KI = [
	16,
	16,
	16,
	16,
	17,
	17,
	18,
	18,
	19,
	19,
	20,
	20,
	21,
	21,
	22,
	22,
	23,
	23,
	24,
	24,
	25,
	25,
	26,
	26,
	27,
	27,
	28,
	28,
	29,
	29,
	64,
	64
], qI = function(e, t, n, r, i, a, o, s) {
	var c = s.bits, l = 0, u = 0, d = 0, f = 0, p = 0, m = 0, h = 0, g = 0, _ = 0, v = 0, y, b, x, S, C, w = null, T = 0, E, D = new II.Buf16(LI + 1), O = new II.Buf16(LI + 1), k = null, A = 0, j, M, ee;
	for (l = 0; l <= LI; l++) D[l] = 0;
	for (u = 0; u < r; u++) D[t[n + u]]++;
	for (p = c, f = LI; f >= 1 && D[f] === 0; f--);
	if (p > f && (p = f), f === 0) return i[a++] = 20971520, i[a++] = 20971520, s.bits = 1, 0;
	for (d = 1; d < f && D[d] === 0; d++);
	for (p < d && (p = d), g = 1, l = 1; l <= LI; l++) if (g <<= 1, g -= D[l], g < 0) return -1;
	if (g > 0 && (e === BI || f !== 1)) return -1;
	for (O[1] = 0, l = 1; l < LI; l++) O[l + 1] = O[l] + D[l];
	for (u = 0; u < r; u++) t[n + u] !== 0 && (o[O[t[n + u]]++] = u);
	if (e === BI ? (w = k = o, E = 19) : e === VI ? (w = UI, T -= 257, k = WI, A -= 257, E = 256) : (w = GI, k = KI, E = -1), v = 0, u = 0, l = d, C = a, m = p, h = 0, x = -1, _ = 1 << p, S = _ - 1, e === VI && _ > RI || e === HI && _ > zI) return 1;
	for (;;) {
		j = l - h, o[u] < E ? (M = 0, ee = o[u]) : o[u] > E ? (M = k[A + o[u]], ee = w[T + o[u]]) : (M = 96, ee = 0), y = 1 << l - h, b = 1 << m, d = b;
		do
			b -= y, i[C + (v >> h) + b] = j << 24 | M << 16 | ee | 0;
		while (b !== 0);
		for (y = 1 << l - 1; v & y;) y >>= 1;
		if (y === 0 ? v = 0 : (v &= y - 1, v += y), u++, --D[l] === 0) {
			if (l === f) break;
			l = t[n + o[u]];
		}
		if (l > p && (v & S) !== x) {
			for (h === 0 && (h = p), C += d, m = l - h, g = 1 << m; m + h < f && (g -= D[m + h], !(g <= 0));) m++, g <<= 1;
			if (_ += 1 << m, e === VI && _ > RI || e === HI && _ > zI) return 1;
			x = v & S, i[x] = p << 24 | m << 16 | C - a | 0;
		}
	}
	return v !== 0 && (i[C + v] = l - h << 24 | 4194304), s.bits = p, 0;
}, JI = KN, YI = oF, XI = uF, ZI = FI, QI = qI, $I = 0, eL = 1, tL = 2, nL = 4, rL = 5, iL = 6, aL = 0, oL = 1, sL = 2, cL = -2, lL = -3, uL = -4, dL = -5, fL = 8, pL = 1, mL = 2, hL = 3, gL = 4, _L = 5, vL = 6, yL = 7, bL = 8, xL = 9, SL = 10, CL = 11, wL = 12, TL = 13, EL = 14, DL = 15, OL = 16, kL = 17, AL = 18, jL = 19, ML = 20, NL = 21, PL = 22, FL = 23, IL = 24, LL = 25, RL = 26, zL = 27, BL = 28, VL = 29, HL = 30, UL = 31, WL = 32, GL = 852, KL = 592, qL = 15;
function JL(e) {
	return (e >>> 24 & 255) + (e >>> 8 & 65280) + ((e & 65280) << 8) + ((e & 255) << 24);
}
function YL() {
	this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new JI.Buf16(320), this.work = new JI.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}
function XL(e) {
	var t;
	return !e || !e.state ? cL : (t = e.state, e.total_in = e.total_out = t.total = 0, e.msg = "", t.wrap && (e.adler = t.wrap & 1), t.mode = pL, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = new JI.Buf32(GL), t.distcode = t.distdyn = new JI.Buf32(KL), t.sane = 1, t.back = -1, aL);
}
function ZL(e) {
	var t;
	return !e || !e.state ? cL : (t = e.state, t.wsize = 0, t.whave = 0, t.wnext = 0, XL(e));
}
function QL(e, t) {
	var n, r;
	return !e || !e.state || (r = e.state, t < 0 ? (n = 0, t = -t) : (n = (t >> 4) + 1, t < 48 && (t &= 15)), t && (t < 8 || t > 15)) ? cL : (r.window !== null && r.wbits !== t && (r.window = null), r.wrap = n, r.wbits = t, ZL(e));
}
function $L(e, t) {
	var n, r;
	return e ? (r = new YL(), e.state = r, r.window = null, n = QL(e, t), n !== aL && (e.state = null), n) : cL;
}
function eR(e) {
	return $L(e, qL);
}
var tR = !0, nR, rR;
function iR(e) {
	if (tR) {
		var t;
		for (nR = new JI.Buf32(512), rR = new JI.Buf32(32), t = 0; t < 144;) e.lens[t++] = 8;
		for (; t < 256;) e.lens[t++] = 9;
		for (; t < 280;) e.lens[t++] = 7;
		for (; t < 288;) e.lens[t++] = 8;
		for (QI(eL, e.lens, 0, 288, nR, 0, e.work, { bits: 9 }), t = 0; t < 32;) e.lens[t++] = 5;
		QI(tL, e.lens, 0, 32, rR, 0, e.work, { bits: 5 }), tR = !1;
	}
	e.lencode = nR, e.lenbits = 9, e.distcode = rR, e.distbits = 5;
}
function aR(e, t, n, r) {
	var i, a = e.state;
	return a.window === null && (a.wsize = 1 << a.wbits, a.wnext = 0, a.whave = 0, a.window = new JI.Buf8(a.wsize)), r >= a.wsize ? (JI.arraySet(a.window, t, n - a.wsize, a.wsize, 0), a.wnext = 0, a.whave = a.wsize) : (i = a.wsize - a.wnext, i > r && (i = r), JI.arraySet(a.window, t, n - r, i, a.wnext), r -= i, r ? (JI.arraySet(a.window, t, n - r, r, 0), a.wnext = r, a.whave = a.wsize) : (a.wnext += i, a.wnext === a.wsize && (a.wnext = 0), a.whave < a.wsize && (a.whave += i))), 0;
}
function oR(e, t) {
	var n, r, i, a, o, s, c, l, u, d, f, p, m, h, g = 0, _, v, y, b, x, S, C, w, T = new JI.Buf8(4), E, D, O = [
		16,
		17,
		18,
		0,
		8,
		7,
		9,
		6,
		10,
		5,
		11,
		4,
		12,
		3,
		13,
		2,
		14,
		1,
		15
	];
	if (!e || !e.state || !e.output || !e.input && e.avail_in !== 0) return cL;
	n = e.state, n.mode === wL && (n.mode = TL), o = e.next_out, i = e.output, c = e.avail_out, a = e.next_in, r = e.input, s = e.avail_in, l = n.hold, u = n.bits, d = s, f = c, w = aL;
	inf_leave: for (;;) switch (n.mode) {
		case pL:
			if (n.wrap === 0) {
				n.mode = TL;
				break;
			}
			for (; u < 16;) {
				if (s === 0) break inf_leave;
				s--, l += r[a++] << u, u += 8;
			}
			if (n.wrap & 2 && l === 35615) {
				n.check = 0, T[0] = l & 255, T[1] = l >>> 8 & 255, n.check = XI(n.check, T, 2, 0), l = 0, u = 0, n.mode = mL;
				break;
			}
			if (n.flags = 0, n.head && (n.head.done = !1), !(n.wrap & 1) || (((l & 255) << 8) + (l >> 8)) % 31) {
				e.msg = "incorrect header check", n.mode = HL;
				break;
			}
			if ((l & 15) !== fL) {
				e.msg = "unknown compression method", n.mode = HL;
				break;
			}
			if (l >>>= 4, u -= 4, C = (l & 15) + 8, n.wbits === 0) n.wbits = C;
			else if (C > n.wbits) {
				e.msg = "invalid window size", n.mode = HL;
				break;
			}
			n.dmax = 1 << C, e.adler = n.check = 1, n.mode = l & 512 ? SL : wL, l = 0, u = 0;
			break;
		case mL:
			for (; u < 16;) {
				if (s === 0) break inf_leave;
				s--, l += r[a++] << u, u += 8;
			}
			if (n.flags = l, (n.flags & 255) !== fL) {
				e.msg = "unknown compression method", n.mode = HL;
				break;
			}
			if (n.flags & 57344) {
				e.msg = "unknown header flags set", n.mode = HL;
				break;
			}
			n.head && (n.head.text = l >> 8 & 1), n.flags & 512 && (T[0] = l & 255, T[1] = l >>> 8 & 255, n.check = XI(n.check, T, 2, 0)), l = 0, u = 0, n.mode = hL;
		case hL:
			for (; u < 32;) {
				if (s === 0) break inf_leave;
				s--, l += r[a++] << u, u += 8;
			}
			n.head && (n.head.time = l), n.flags & 512 && (T[0] = l & 255, T[1] = l >>> 8 & 255, T[2] = l >>> 16 & 255, T[3] = l >>> 24 & 255, n.check = XI(n.check, T, 4, 0)), l = 0, u = 0, n.mode = gL;
		case gL:
			for (; u < 16;) {
				if (s === 0) break inf_leave;
				s--, l += r[a++] << u, u += 8;
			}
			n.head && (n.head.xflags = l & 255, n.head.os = l >> 8), n.flags & 512 && (T[0] = l & 255, T[1] = l >>> 8 & 255, n.check = XI(n.check, T, 2, 0)), l = 0, u = 0, n.mode = _L;
		case _L:
			if (n.flags & 1024) {
				for (; u < 16;) {
					if (s === 0) break inf_leave;
					s--, l += r[a++] << u, u += 8;
				}
				n.length = l, n.head && (n.head.extra_len = l), n.flags & 512 && (T[0] = l & 255, T[1] = l >>> 8 & 255, n.check = XI(n.check, T, 2, 0)), l = 0, u = 0;
			} else n.head && (n.head.extra = null);
			n.mode = vL;
		case vL:
			if (n.flags & 1024 && (p = n.length, p > s && (p = s), p && (n.head && (C = n.head.extra_len - n.length, n.head.extra || (n.head.extra = Array(n.head.extra_len)), JI.arraySet(n.head.extra, r, a, p, C)), n.flags & 512 && (n.check = XI(n.check, r, p, a)), s -= p, a += p, n.length -= p), n.length)) break inf_leave;
			n.length = 0, n.mode = yL;
		case yL:
			if (n.flags & 2048) {
				if (s === 0) break inf_leave;
				p = 0;
				do
					C = r[a + p++], n.head && C && n.length < 65536 && (n.head.name += String.fromCharCode(C));
				while (C && p < s);
				if (n.flags & 512 && (n.check = XI(n.check, r, p, a)), s -= p, a += p, C) break inf_leave;
			} else n.head && (n.head.name = null);
			n.length = 0, n.mode = bL;
		case bL:
			if (n.flags & 4096) {
				if (s === 0) break inf_leave;
				p = 0;
				do
					C = r[a + p++], n.head && C && n.length < 65536 && (n.head.comment += String.fromCharCode(C));
				while (C && p < s);
				if (n.flags & 512 && (n.check = XI(n.check, r, p, a)), s -= p, a += p, C) break inf_leave;
			} else n.head && (n.head.comment = null);
			n.mode = xL;
		case xL:
			if (n.flags & 512) {
				for (; u < 16;) {
					if (s === 0) break inf_leave;
					s--, l += r[a++] << u, u += 8;
				}
				if (l !== (n.check & 65535)) {
					e.msg = "header crc mismatch", n.mode = HL;
					break;
				}
				l = 0, u = 0;
			}
			n.head && (n.head.hcrc = n.flags >> 9 & 1, n.head.done = !0), e.adler = n.check = 0, n.mode = wL;
			break;
		case SL:
			for (; u < 32;) {
				if (s === 0) break inf_leave;
				s--, l += r[a++] << u, u += 8;
			}
			e.adler = n.check = JL(l), l = 0, u = 0, n.mode = CL;
		case CL:
			if (n.havedict === 0) return e.next_out = o, e.avail_out = c, e.next_in = a, e.avail_in = s, n.hold = l, n.bits = u, sL;
			e.adler = n.check = 1, n.mode = wL;
		case wL: if (t === rL || t === iL) break inf_leave;
		case TL:
			if (n.last) {
				l >>>= u & 7, u -= u & 7, n.mode = zL;
				break;
			}
			for (; u < 3;) {
				if (s === 0) break inf_leave;
				s--, l += r[a++] << u, u += 8;
			}
			switch (n.last = l & 1, l >>>= 1, --u, l & 3) {
				case 0:
					n.mode = EL;
					break;
				case 1:
					if (iR(n), n.mode = ML, t === iL) {
						l >>>= 2, u -= 2;
						break inf_leave;
					}
					break;
				case 2:
					n.mode = kL;
					break;
				case 3: e.msg = "invalid block type", n.mode = HL;
			}
			l >>>= 2, u -= 2;
			break;
		case EL:
			for (l >>>= u & 7, u -= u & 7; u < 32;) {
				if (s === 0) break inf_leave;
				s--, l += r[a++] << u, u += 8;
			}
			if ((l & 65535) != (l >>> 16 ^ 65535)) {
				e.msg = "invalid stored block lengths", n.mode = HL;
				break;
			}
			if (n.length = l & 65535, l = 0, u = 0, n.mode = DL, t === iL) break inf_leave;
		case DL: n.mode = OL;
		case OL:
			if (p = n.length, p) {
				if (p > s && (p = s), p > c && (p = c), p === 0) break inf_leave;
				JI.arraySet(i, r, a, p, o), s -= p, a += p, c -= p, o += p, n.length -= p;
				break;
			}
			n.mode = wL;
			break;
		case kL:
			for (; u < 14;) {
				if (s === 0) break inf_leave;
				s--, l += r[a++] << u, u += 8;
			}
			if (n.nlen = (l & 31) + 257, l >>>= 5, u -= 5, n.ndist = (l & 31) + 1, l >>>= 5, u -= 5, n.ncode = (l & 15) + 4, l >>>= 4, u -= 4, n.nlen > 286 || n.ndist > 30) {
				e.msg = "too many length or distance symbols", n.mode = HL;
				break;
			}
			n.have = 0, n.mode = AL;
		case AL:
			for (; n.have < n.ncode;) {
				for (; u < 3;) {
					if (s === 0) break inf_leave;
					s--, l += r[a++] << u, u += 8;
				}
				n.lens[O[n.have++]] = l & 7, l >>>= 3, u -= 3;
			}
			for (; n.have < 19;) n.lens[O[n.have++]] = 0;
			if (n.lencode = n.lendyn, n.lenbits = 7, E = { bits: n.lenbits }, w = QI($I, n.lens, 0, 19, n.lencode, 0, n.work, E), n.lenbits = E.bits, w) {
				e.msg = "invalid code lengths set", n.mode = HL;
				break;
			}
			n.have = 0, n.mode = jL;
		case jL:
			for (; n.have < n.nlen + n.ndist;) {
				for (; g = n.lencode[l & (1 << n.lenbits) - 1], _ = g >>> 24, v = g >>> 16 & 255, y = g & 65535, !(_ <= u);) {
					if (s === 0) break inf_leave;
					s--, l += r[a++] << u, u += 8;
				}
				if (y < 16) l >>>= _, u -= _, n.lens[n.have++] = y;
				else {
					if (y === 16) {
						for (D = _ + 2; u < D;) {
							if (s === 0) break inf_leave;
							s--, l += r[a++] << u, u += 8;
						}
						if (l >>>= _, u -= _, n.have === 0) {
							e.msg = "invalid bit length repeat", n.mode = HL;
							break;
						}
						C = n.lens[n.have - 1], p = 3 + (l & 3), l >>>= 2, u -= 2;
					} else if (y === 17) {
						for (D = _ + 3; u < D;) {
							if (s === 0) break inf_leave;
							s--, l += r[a++] << u, u += 8;
						}
						l >>>= _, u -= _, C = 0, p = 3 + (l & 7), l >>>= 3, u -= 3;
					} else {
						for (D = _ + 7; u < D;) {
							if (s === 0) break inf_leave;
							s--, l += r[a++] << u, u += 8;
						}
						l >>>= _, u -= _, C = 0, p = 11 + (l & 127), l >>>= 7, u -= 7;
					}
					if (n.have + p > n.nlen + n.ndist) {
						e.msg = "invalid bit length repeat", n.mode = HL;
						break;
					}
					for (; p--;) n.lens[n.have++] = C;
				}
			}
			if (n.mode === HL) break;
			if (n.lens[256] === 0) {
				e.msg = "invalid code -- missing end-of-block", n.mode = HL;
				break;
			}
			if (n.lenbits = 9, E = { bits: n.lenbits }, w = QI(eL, n.lens, 0, n.nlen, n.lencode, 0, n.work, E), n.lenbits = E.bits, w) {
				e.msg = "invalid literal/lengths set", n.mode = HL;
				break;
			}
			if (n.distbits = 6, n.distcode = n.distdyn, E = { bits: n.distbits }, w = QI(tL, n.lens, n.nlen, n.ndist, n.distcode, 0, n.work, E), n.distbits = E.bits, w) {
				e.msg = "invalid distances set", n.mode = HL;
				break;
			}
			if (n.mode = ML, t === iL) break inf_leave;
		case ML: n.mode = NL;
		case NL:
			if (s >= 6 && c >= 258) {
				e.next_out = o, e.avail_out = c, e.next_in = a, e.avail_in = s, n.hold = l, n.bits = u, ZI(e, f), o = e.next_out, i = e.output, c = e.avail_out, a = e.next_in, r = e.input, s = e.avail_in, l = n.hold, u = n.bits, n.mode === wL && (n.back = -1);
				break;
			}
			for (n.back = 0; g = n.lencode[l & (1 << n.lenbits) - 1], _ = g >>> 24, v = g >>> 16 & 255, y = g & 65535, !(_ <= u);) {
				if (s === 0) break inf_leave;
				s--, l += r[a++] << u, u += 8;
			}
			if (v && !(v & 240)) {
				for (b = _, x = v, S = y; g = n.lencode[S + ((l & (1 << b + x) - 1) >> b)], _ = g >>> 24, v = g >>> 16 & 255, y = g & 65535, !(b + _ <= u);) {
					if (s === 0) break inf_leave;
					s--, l += r[a++] << u, u += 8;
				}
				l >>>= b, u -= b, n.back += b;
			}
			if (l >>>= _, u -= _, n.back += _, n.length = y, v === 0) {
				n.mode = RL;
				break;
			}
			if (v & 32) {
				n.back = -1, n.mode = wL;
				break;
			}
			if (v & 64) {
				e.msg = "invalid literal/length code", n.mode = HL;
				break;
			}
			n.extra = v & 15, n.mode = PL;
		case PL:
			if (n.extra) {
				for (D = n.extra; u < D;) {
					if (s === 0) break inf_leave;
					s--, l += r[a++] << u, u += 8;
				}
				n.length += l & (1 << n.extra) - 1, l >>>= n.extra, u -= n.extra, n.back += n.extra;
			}
			n.was = n.length, n.mode = FL;
		case FL:
			for (; g = n.distcode[l & (1 << n.distbits) - 1], _ = g >>> 24, v = g >>> 16 & 255, y = g & 65535, !(_ <= u);) {
				if (s === 0) break inf_leave;
				s--, l += r[a++] << u, u += 8;
			}
			if (!(v & 240)) {
				for (b = _, x = v, S = y; g = n.distcode[S + ((l & (1 << b + x) - 1) >> b)], _ = g >>> 24, v = g >>> 16 & 255, y = g & 65535, !(b + _ <= u);) {
					if (s === 0) break inf_leave;
					s--, l += r[a++] << u, u += 8;
				}
				l >>>= b, u -= b, n.back += b;
			}
			if (l >>>= _, u -= _, n.back += _, v & 64) {
				e.msg = "invalid distance code", n.mode = HL;
				break;
			}
			n.offset = y, n.extra = v & 15, n.mode = IL;
		case IL:
			if (n.extra) {
				for (D = n.extra; u < D;) {
					if (s === 0) break inf_leave;
					s--, l += r[a++] << u, u += 8;
				}
				n.offset += l & (1 << n.extra) - 1, l >>>= n.extra, u -= n.extra, n.back += n.extra;
			}
			if (n.offset > n.dmax) {
				e.msg = "invalid distance too far back", n.mode = HL;
				break;
			}
			n.mode = LL;
		case LL:
			if (c === 0) break inf_leave;
			if (p = f - c, n.offset > p) {
				if (p = n.offset - p, p > n.whave && n.sane) {
					e.msg = "invalid distance too far back", n.mode = HL;
					break;
				}
				p > n.wnext ? (p -= n.wnext, m = n.wsize - p) : m = n.wnext - p, p > n.length && (p = n.length), h = n.window;
			} else h = i, m = o - n.offset, p = n.length;
			p > c && (p = c), c -= p, n.length -= p;
			do
				i[o++] = h[m++];
			while (--p);
			n.length === 0 && (n.mode = NL);
			break;
		case RL:
			if (c === 0) break inf_leave;
			i[o++] = n.length, c--, n.mode = NL;
			break;
		case zL:
			if (n.wrap) {
				for (; u < 32;) {
					if (s === 0) break inf_leave;
					s--, l |= r[a++] << u, u += 8;
				}
				if (f -= c, e.total_out += f, n.total += f, f && (e.adler = n.check = n.flags ? XI(n.check, i, f, o - f) : YI(n.check, i, f, o - f)), f = c, (n.flags ? l : JL(l)) !== n.check) {
					e.msg = "incorrect data check", n.mode = HL;
					break;
				}
				l = 0, u = 0;
			}
			n.mode = BL;
		case BL:
			if (n.wrap && n.flags) {
				for (; u < 32;) {
					if (s === 0) break inf_leave;
					s--, l += r[a++] << u, u += 8;
				}
				if (l !== (n.total & 4294967295)) {
					e.msg = "incorrect length check", n.mode = HL;
					break;
				}
				l = 0, u = 0;
			}
			n.mode = VL;
		case VL:
			w = oL;
			break inf_leave;
		case HL:
			w = lL;
			break inf_leave;
		case UL: return uL;
		case WL:
		default: return cL;
	}
	return e.next_out = o, e.avail_out = c, e.next_in = a, e.avail_in = s, n.hold = l, n.bits = u, (n.wsize || f !== e.avail_out && n.mode < HL && (n.mode < zL || t !== nL)) && aR(e, e.output, e.next_out, f - e.avail_out), d -= e.avail_in, f -= e.avail_out, e.total_in += d, e.total_out += f, n.total += f, n.wrap && f && (e.adler = n.check = n.flags ? XI(n.check, i, f, e.next_out - f) : YI(n.check, i, f, e.next_out - f)), e.data_type = n.bits + (n.last ? 64 : 0) + (n.mode === wL ? 128 : 0) + (n.mode === ML || n.mode === DL ? 256 : 0), (d === 0 && f === 0 || t === nL) && w === aL && (w = dL), w;
}
function sR(e) {
	if (!e || !e.state) return cL;
	var t = e.state;
	return t.window &&= null, e.state = null, aL;
}
function cR(e, t) {
	var n;
	return !e || !e.state || (n = e.state, !(n.wrap & 2)) ? cL : (n.head = t, t.done = !1, aL);
}
function lR(e, t) {
	var n = t.length, r, i, a;
	return !e || !e.state || (r = e.state, r.wrap !== 0 && r.mode !== CL) ? cL : r.mode === CL && (i = 1, i = YI(i, t, n, 0), i !== r.check) ? lL : (a = aR(e, t, n, n), a ? (r.mode = UL, uL) : (r.havedict = 1, aL));
}
MI.inflateReset = ZL, MI.inflateReset2 = QL, MI.inflateResetKeep = XL, MI.inflateInit = eR, MI.inflateInit2 = $L, MI.inflate = oR, MI.inflateEnd = sR, MI.inflateGetHeader = cR, MI.inflateSetDictionary = lR, MI.inflateInfo = "pako inflate (from Nodeca project)";
var uR = {
	Z_NO_FLUSH: 0,
	Z_PARTIAL_FLUSH: 1,
	Z_SYNC_FLUSH: 2,
	Z_FULL_FLUSH: 3,
	Z_FINISH: 4,
	Z_BLOCK: 5,
	Z_TREES: 6,
	Z_OK: 0,
	Z_STREAM_END: 1,
	Z_NEED_DICT: 2,
	Z_ERRNO: -1,
	Z_STREAM_ERROR: -2,
	Z_DATA_ERROR: -3,
	Z_BUF_ERROR: -5,
	Z_NO_COMPRESSION: 0,
	Z_BEST_SPEED: 1,
	Z_BEST_COMPRESSION: 9,
	Z_DEFAULT_COMPRESSION: -1,
	Z_FILTERED: 1,
	Z_HUFFMAN_ONLY: 2,
	Z_RLE: 3,
	Z_FIXED: 4,
	Z_DEFAULT_STRATEGY: 0,
	Z_BINARY: 0,
	Z_TEXT: 1,
	Z_UNKNOWN: 2,
	Z_DEFLATED: 8
};
(function(e) {
	var t = WN, n = Ure, r = GN, i = MI, a = uR;
	for (var o in a) e[o] = a[o];
	e.NONE = 0, e.DEFLATE = 1, e.INFLATE = 2, e.GZIP = 3, e.GUNZIP = 4, e.DEFLATERAW = 5, e.INFLATERAW = 6, e.UNZIP = 7;
	var s = 31, c = 139;
	function l(t) {
		if (typeof t != "number" || t < e.DEFLATE || t > e.UNZIP) throw TypeError("Bad argument");
		this.dictionary = null, this.err = 0, this.flush = 0, this.init_done = !1, this.level = 0, this.memLevel = 0, this.mode = t, this.strategy = 0, this.windowBits = 0, this.write_in_progress = !1, this.pending_close = !1, this.gzip_id_bytes_read = 0;
	}
	l.prototype.close = function() {
		if (this.write_in_progress) {
			this.pending_close = !0;
			return;
		}
		this.pending_close = !1, t(this.init_done, "close before init"), t(this.mode <= e.UNZIP), this.mode === e.DEFLATE || this.mode === e.GZIP || this.mode === e.DEFLATERAW ? r.deflateEnd(this.strm) : (this.mode === e.INFLATE || this.mode === e.GUNZIP || this.mode === e.INFLATERAW || this.mode === e.UNZIP) && i.inflateEnd(this.strm), this.mode = e.NONE, this.dictionary = null;
	}, l.prototype.write = function(e, t, n, r, i, a, o) {
		return this._write(!0, e, t, n, r, i, a, o);
	}, l.prototype.writeSync = function(e, t, n, r, i, a, o) {
		return this._write(!1, e, t, n, r, i, a, o);
	}, l.prototype._write = function(n, r, i, a, o, s, c, l) {
		if (t.equal(arguments.length, 8), t(this.init_done, "write before init"), t(this.mode !== e.NONE, "already finalized"), t.equal(!1, this.write_in_progress, "write already in progress"), t.equal(!1, this.pending_close, "close is pending"), this.write_in_progress = !0, t.equal(!1, r === void 0, "must provide flush value"), this.write_in_progress = !0, r !== e.Z_NO_FLUSH && r !== e.Z_PARTIAL_FLUSH && r !== e.Z_SYNC_FLUSH && r !== e.Z_FULL_FLUSH && r !== e.Z_FINISH && r !== e.Z_BLOCK) throw Error("Invalid flush value");
		if (i ?? (i = Z.alloc(0), o = 0, a = 0), this.strm.avail_in = o, this.strm.input = i, this.strm.next_in = a, this.strm.avail_out = l, this.strm.output = s, this.strm.next_out = c, this.flush = r, !n) return this._process(), this._checkError() ? this._afterSync() : void 0;
		var u = this;
		return Kj.nextTick(function() {
			u._process(), u._after();
		}), this;
	}, l.prototype._afterSync = function() {
		var e = this.strm.avail_out, t = this.strm.avail_in;
		return this.write_in_progress = !1, [t, e];
	}, l.prototype._process = function() {
		var t = null;
		switch (this.mode) {
			case e.DEFLATE:
			case e.GZIP:
			case e.DEFLATERAW:
				this.err = r.deflate(this.strm, this.flush);
				break;
			case e.UNZIP: switch (this.strm.avail_in > 0 && (t = this.strm.next_in), this.gzip_id_bytes_read) {
				case 0:
					if (t === null) break;
					if (this.strm.input[t] === s) {
						if (this.gzip_id_bytes_read = 1, t++, this.strm.avail_in === 1) break;
					} else {
						this.mode = e.INFLATE;
						break;
					}
				case 1:
					if (t === null) break;
					this.strm.input[t] === c ? (this.gzip_id_bytes_read = 2, this.mode = e.GUNZIP) : this.mode = e.INFLATE;
					break;
				default: throw Error("invalid number of gzip magic number bytes read");
			}
			case e.INFLATE:
			case e.GUNZIP:
			case e.INFLATERAW:
				for (this.err = i.inflate(this.strm, this.flush), this.err === e.Z_NEED_DICT && this.dictionary && (this.err = i.inflateSetDictionary(this.strm, this.dictionary), this.err === e.Z_OK ? this.err = i.inflate(this.strm, this.flush) : this.err === e.Z_DATA_ERROR && (this.err = e.Z_NEED_DICT)); this.strm.avail_in > 0 && this.mode === e.GUNZIP && this.err === e.Z_STREAM_END && this.strm.next_in[0] !== 0;) this.reset(), this.err = i.inflate(this.strm, this.flush);
				break;
			default: throw Error("Unknown mode " + this.mode);
		}
	}, l.prototype._checkError = function() {
		switch (this.err) {
			case e.Z_OK:
			case e.Z_BUF_ERROR:
				if (this.strm.avail_out !== 0 && this.flush === e.Z_FINISH) return this._error("unexpected end of file"), !1;
				break;
			case e.Z_STREAM_END: break;
			case e.Z_NEED_DICT: return this.dictionary == null ? this._error("Missing dictionary") : this._error("Bad dictionary"), !1;
			default: return this._error("Zlib error"), !1;
		}
		return !0;
	}, l.prototype._after = function() {
		if (this._checkError()) {
			var e = this.strm.avail_out, t = this.strm.avail_in;
			this.write_in_progress = !1, this.callback(t, e), this.pending_close && this.close();
		}
	}, l.prototype._error = function(e) {
		this.strm.msg && (e = this.strm.msg), this.onerror(e, this.err), this.write_in_progress = !1, this.pending_close && this.close();
	}, l.prototype.init = function(n, r, i, a, o) {
		t(arguments.length === 4 || arguments.length === 5, "init(windowBits, level, memLevel, strategy, [dictionary])"), t(n >= 8 && n <= 15, "invalid windowBits"), t(r >= -1 && r <= 9, "invalid compression level"), t(i >= 1 && i <= 9, "invalid memlevel"), t(a === e.Z_FILTERED || a === e.Z_HUFFMAN_ONLY || a === e.Z_RLE || a === e.Z_FIXED || a === e.Z_DEFAULT_STRATEGY, "invalid strategy"), this._init(r, n, i, a, o), this._setDictionary();
	}, l.prototype.params = function() {
		throw Error("deflateParams Not supported");
	}, l.prototype.reset = function() {
		this._reset(), this._setDictionary();
	}, l.prototype._init = function(t, a, o, s, c) {
		switch (this.level = t, this.windowBits = a, this.memLevel = o, this.strategy = s, this.flush = e.Z_NO_FLUSH, this.err = e.Z_OK, (this.mode === e.GZIP || this.mode === e.GUNZIP) && (this.windowBits += 16), this.mode === e.UNZIP && (this.windowBits += 32), (this.mode === e.DEFLATERAW || this.mode === e.INFLATERAW) && (this.windowBits = -1 * this.windowBits), this.strm = new n(), this.mode) {
			case e.DEFLATE:
			case e.GZIP:
			case e.DEFLATERAW:
				this.err = r.deflateInit2(this.strm, this.level, e.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
				break;
			case e.INFLATE:
			case e.GUNZIP:
			case e.INFLATERAW:
			case e.UNZIP:
				this.err = i.inflateInit2(this.strm, this.windowBits);
				break;
			default: throw Error("Unknown mode " + this.mode);
		}
		this.err !== e.Z_OK && this._error("Init error"), this.dictionary = c, this.write_in_progress = !1, this.init_done = !0;
	}, l.prototype._setDictionary = function() {
		if (this.dictionary != null) {
			switch (this.err = e.Z_OK, this.mode) {
				case e.DEFLATE:
				case e.DEFLATERAW:
					this.err = r.deflateSetDictionary(this.strm, this.dictionary);
					break;
			}
			this.err !== e.Z_OK && this._error("Failed to set dictionary");
		}
	}, l.prototype._reset = function() {
		switch (this.err = e.Z_OK, this.mode) {
			case e.DEFLATE:
			case e.DEFLATERAW:
			case e.GZIP:
				this.err = r.deflateReset(this.strm);
				break;
			case e.INFLATE:
			case e.INFLATERAW:
			case e.GUNZIP:
				this.err = i.inflateReset(this.strm);
				break;
		}
		this.err !== e.Z_OK && this._error("Failed to reset stream");
	}, e.Zlib = l;
})(mN);
var dR = /*@__PURE__*/ qj(Qne);
(function(e) {
	var t = Yj.Buffer, n = Ire.Transform, r = mN, i = dR, a = WN.ok, o = Yj.kMaxLength, s = "Cannot create final Buffer. It would be larger than 0x" + o.toString(16) + " bytes";
	r.Z_MIN_WINDOWBITS = 8, r.Z_MAX_WINDOWBITS = 15, r.Z_DEFAULT_WINDOWBITS = 15, r.Z_MIN_CHUNK = 64, r.Z_MAX_CHUNK = Infinity, r.Z_DEFAULT_CHUNK = 16 * 1024, r.Z_MIN_MEMLEVEL = 1, r.Z_MAX_MEMLEVEL = 9, r.Z_DEFAULT_MEMLEVEL = 8, r.Z_MIN_LEVEL = -1, r.Z_MAX_LEVEL = 9, r.Z_DEFAULT_LEVEL = r.Z_DEFAULT_COMPRESSION;
	for (var c = Object.keys(r), l = 0; l < c.length; l++) {
		var u = c[l];
		u.match(/^Z/) && Object.defineProperty(e, u, {
			enumerable: !0,
			value: r[u],
			writable: !1
		});
	}
	for (var d = {
		Z_OK: r.Z_OK,
		Z_STREAM_END: r.Z_STREAM_END,
		Z_NEED_DICT: r.Z_NEED_DICT,
		Z_ERRNO: r.Z_ERRNO,
		Z_STREAM_ERROR: r.Z_STREAM_ERROR,
		Z_DATA_ERROR: r.Z_DATA_ERROR,
		Z_MEM_ERROR: r.Z_MEM_ERROR,
		Z_BUF_ERROR: r.Z_BUF_ERROR,
		Z_VERSION_ERROR: r.Z_VERSION_ERROR
	}, f = Object.keys(d), p = 0; p < f.length; p++) {
		var m = f[p];
		d[d[m]] = m;
	}
	Object.defineProperty(e, "codes", {
		enumerable: !0,
		value: Object.freeze(d),
		writable: !1
	}), e.Deflate = _, e.Inflate = v, e.Gzip = y, e.Gunzip = b, e.DeflateRaw = x, e.InflateRaw = S, e.Unzip = C, e.createDeflate = function(e) {
		return new _(e);
	}, e.createInflate = function(e) {
		return new v(e);
	}, e.createDeflateRaw = function(e) {
		return new x(e);
	}, e.createInflateRaw = function(e) {
		return new S(e);
	}, e.createGzip = function(e) {
		return new y(e);
	}, e.createGunzip = function(e) {
		return new b(e);
	}, e.createUnzip = function(e) {
		return new C(e);
	}, e.deflate = function(e, t, n) {
		return typeof t == "function" && (n = t, t = {}), h(new _(t), e, n);
	}, e.deflateSync = function(e, t) {
		return g(new _(t), e);
	}, e.gzip = function(e, t, n) {
		return typeof t == "function" && (n = t, t = {}), h(new y(t), e, n);
	}, e.gzipSync = function(e, t) {
		return g(new y(t), e);
	}, e.deflateRaw = function(e, t, n) {
		return typeof t == "function" && (n = t, t = {}), h(new x(t), e, n);
	}, e.deflateRawSync = function(e, t) {
		return g(new x(t), e);
	}, e.unzip = function(e, t, n) {
		return typeof t == "function" && (n = t, t = {}), h(new C(t), e, n);
	}, e.unzipSync = function(e, t) {
		return g(new C(t), e);
	}, e.inflate = function(e, t, n) {
		return typeof t == "function" && (n = t, t = {}), h(new v(t), e, n);
	}, e.inflateSync = function(e, t) {
		return g(new v(t), e);
	}, e.gunzip = function(e, t, n) {
		return typeof t == "function" && (n = t, t = {}), h(new b(t), e, n);
	}, e.gunzipSync = function(e, t) {
		return g(new b(t), e);
	}, e.inflateRaw = function(e, t, n) {
		return typeof t == "function" && (n = t, t = {}), h(new S(t), e, n);
	}, e.inflateRawSync = function(e, t) {
		return g(new S(t), e);
	};
	function h(e, n, r) {
		var i = [], a = 0;
		e.on("error", l), e.on("end", u), e.end(n), c();
		function c() {
			for (var t; (t = e.read()) !== null;) i.push(t), a += t.length;
			e.once("readable", c);
		}
		function l(t) {
			e.removeListener("end", u), e.removeListener("readable", c), r(t);
		}
		function u() {
			var n, c = null;
			a >= o ? c = RangeError(s) : n = t.concat(i, a), i = [], e.close(), r(c, n);
		}
	}
	function g(e, n) {
		if (typeof n == "string" && (n = t.from(n)), !t.isBuffer(n)) throw TypeError("Not a string or buffer");
		var r = e._finishFlushFlag;
		return e._processChunk(n, r);
	}
	function _(e) {
		if (!(this instanceof _)) return new _(e);
		T.call(this, e, r.DEFLATE);
	}
	function v(e) {
		if (!(this instanceof v)) return new v(e);
		T.call(this, e, r.INFLATE);
	}
	function y(e) {
		if (!(this instanceof y)) return new y(e);
		T.call(this, e, r.GZIP);
	}
	function b(e) {
		if (!(this instanceof b)) return new b(e);
		T.call(this, e, r.GUNZIP);
	}
	function x(e) {
		if (!(this instanceof x)) return new x(e);
		T.call(this, e, r.DEFLATERAW);
	}
	function S(e) {
		if (!(this instanceof S)) return new S(e);
		T.call(this, e, r.INFLATERAW);
	}
	function C(e) {
		if (!(this instanceof C)) return new C(e);
		T.call(this, e, r.UNZIP);
	}
	function w(e) {
		return e === r.Z_NO_FLUSH || e === r.Z_PARTIAL_FLUSH || e === r.Z_SYNC_FLUSH || e === r.Z_FULL_FLUSH || e === r.Z_FINISH || e === r.Z_BLOCK;
	}
	function T(i, a) {
		var o = this;
		if (this._opts = i ||= {}, this._chunkSize = i.chunkSize || e.Z_DEFAULT_CHUNK, n.call(this, i), i.flush && !w(i.flush)) throw Error("Invalid flush flag: " + i.flush);
		if (i.finishFlush && !w(i.finishFlush)) throw Error("Invalid flush flag: " + i.finishFlush);
		if (this._flushFlag = i.flush || r.Z_NO_FLUSH, this._finishFlushFlag = i.finishFlush === void 0 ? r.Z_FINISH : i.finishFlush, i.chunkSize && (i.chunkSize < e.Z_MIN_CHUNK || i.chunkSize > e.Z_MAX_CHUNK)) throw Error("Invalid chunk size: " + i.chunkSize);
		if (i.windowBits && (i.windowBits < e.Z_MIN_WINDOWBITS || i.windowBits > e.Z_MAX_WINDOWBITS)) throw Error("Invalid windowBits: " + i.windowBits);
		if (i.level && (i.level < e.Z_MIN_LEVEL || i.level > e.Z_MAX_LEVEL)) throw Error("Invalid compression level: " + i.level);
		if (i.memLevel && (i.memLevel < e.Z_MIN_MEMLEVEL || i.memLevel > e.Z_MAX_MEMLEVEL)) throw Error("Invalid memLevel: " + i.memLevel);
		if (i.strategy && i.strategy != e.Z_FILTERED && i.strategy != e.Z_HUFFMAN_ONLY && i.strategy != e.Z_RLE && i.strategy != e.Z_FIXED && i.strategy != e.Z_DEFAULT_STRATEGY) throw Error("Invalid strategy: " + i.strategy);
		if (i.dictionary && !t.isBuffer(i.dictionary)) throw Error("Invalid dictionary: it should be a Buffer instance");
		this._handle = new r.Zlib(a);
		var s = this;
		this._hadError = !1, this._handle.onerror = function(t, n) {
			E(s), s._hadError = !0;
			var r = Error(t);
			r.errno = n, r.code = e.codes[n], s.emit("error", r);
		};
		var c = e.Z_DEFAULT_COMPRESSION;
		typeof i.level == "number" && (c = i.level);
		var l = e.Z_DEFAULT_STRATEGY;
		typeof i.strategy == "number" && (l = i.strategy), this._handle.init(i.windowBits || e.Z_DEFAULT_WINDOWBITS, c, i.memLevel || e.Z_DEFAULT_MEMLEVEL, l, i.dictionary), this._buffer = t.allocUnsafe(this._chunkSize), this._offset = 0, this._level = c, this._strategy = l, this.once("end", this.close), Object.defineProperty(this, "_closed", {
			get: function() {
				return !o._handle;
			},
			configurable: !0,
			enumerable: !0
		});
	}
	i.inherits(T, n), T.prototype.params = function(t, n, i) {
		if (t < e.Z_MIN_LEVEL || t > e.Z_MAX_LEVEL) throw RangeError("Invalid compression level: " + t);
		if (n != e.Z_FILTERED && n != e.Z_HUFFMAN_ONLY && n != e.Z_RLE && n != e.Z_FIXED && n != e.Z_DEFAULT_STRATEGY) throw TypeError("Invalid strategy: " + n);
		if (this._level !== t || this._strategy !== n) {
			var o = this;
			this.flush(r.Z_SYNC_FLUSH, function() {
				a(o._handle, "zlib binding closed"), o._handle.params(t, n), o._hadError || (o._level = t, o._strategy = n, i && i());
			});
		} else Kj.nextTick(i);
	}, T.prototype.reset = function() {
		return a(this._handle, "zlib binding closed"), this._handle.reset();
	}, T.prototype._flush = function(e) {
		this._transform(t.alloc(0), "", e);
	}, T.prototype.flush = function(e, n) {
		var i = this, a = this._writableState;
		(typeof e == "function" || e === void 0 && !n) && (n = e, e = r.Z_FULL_FLUSH), a.ended ? n && Kj.nextTick(n) : a.ending ? n && this.once("end", n) : a.needDrain ? n && this.once("drain", function() {
			return i.flush(e, n);
		}) : (this._flushFlag = e, this.write(t.alloc(0), "", n));
	}, T.prototype.close = function(e) {
		E(this, e), Kj.nextTick(D, this);
	};
	function E(e, t) {
		t && Kj.nextTick(t), e._handle &&= (e._handle.close(), null);
	}
	function D(e) {
		e.emit("close");
	}
	T.prototype._transform = function(e, n, i) {
		var a, o = this._writableState, s = (o.ending || o.ended) && (!e || o.length === e.length);
		if (e !== null && !t.isBuffer(e)) return i(/* @__PURE__ */ Error("invalid input"));
		if (!this._handle) return i(/* @__PURE__ */ Error("zlib binding closed"));
		s ? a = this._finishFlushFlag : (a = this._flushFlag, e.length >= o.length && (this._flushFlag = this._opts.flush || r.Z_NO_FLUSH)), this._processChunk(e, a, i);
	}, T.prototype._processChunk = function(e, n, r) {
		var i = e && e.length, c = this._chunkSize - this._offset, l = 0, u = this, d = typeof r == "function";
		if (!d) {
			var f = [], p = 0, m;
			this.on("error", function(e) {
				m = e;
			}), a(this._handle, "zlib binding closed");
			do
				var h = this._handle.writeSync(n, e, l, i, this._buffer, this._offset, c);
			while (!this._hadError && v(h[0], h[1]));
			if (this._hadError) throw m;
			if (p >= o) throw E(this), RangeError(s);
			var g = t.concat(f, p);
			return E(this), g;
		}
		a(this._handle, "zlib binding closed");
		var _ = this._handle.write(n, e, l, i, this._buffer, this._offset, c);
		_.buffer = e, _.callback = v;
		function v(o, s) {
			if (this && (this.buffer = null, this.callback = null), !u._hadError) {
				var m = c - s;
				if (a(m >= 0, "have should not go down"), m > 0) {
					var h = u._buffer.slice(u._offset, u._offset + m);
					u._offset += m, d ? u.push(h) : (f.push(h), p += h.length);
				}
				if ((s === 0 || u._offset >= u._chunkSize) && (c = u._chunkSize, u._offset = 0, u._buffer = t.allocUnsafe(u._chunkSize)), s === 0) {
					if (l += i - o, i = o, !d) return !0;
					var g = u._handle.write(n, e, l, i, u._buffer, u._offset, u._chunkSize);
					g.callback = v, g.buffer = e;
					return;
				}
				if (!d) return !1;
				r();
			}
		}
	}, i.inherits(_, T), i.inherits(v, T), i.inherits(y, T), i.inherits(b, T), i.inherits(x, T), i.inherits(S, T), i.inherits(C, T);
})(Jj);
var fR = /*@__PURE__*/ Mne(Jj), pR = class {
	static decode(e, t) {
		throw Error("PNG.decode not available in browser build");
	}
	static load(e) {
		throw Error("PNG.load not available in browser build");
	}
	constructor(e) {
		let t;
		for (this.data = e, this.pos = 8, this.palette = [], this.imgData = [], this.transparency = {}, this.text = {};;) {
			let e = this.readUInt32(), s = "";
			for (t = 0; t < 4; t++) s += String.fromCharCode(this.data[this.pos++]);
			switch (s) {
				case "IHDR":
					this.width = this.readUInt32(), this.height = this.readUInt32(), this.bits = this.data[this.pos++], this.colorType = this.data[this.pos++], this.compressionMethod = this.data[this.pos++], this.filterMethod = this.data[this.pos++], this.interlaceMethod = this.data[this.pos++];
					break;
				case "PLTE":
					this.palette = this.read(e);
					break;
				case "IDAT":
					for (t = 0; t < e; t++) this.imgData.push(this.data[this.pos++]);
					break;
				case "tRNS":
					switch (this.transparency = {}, this.colorType) {
						case 3:
							this.transparency.indexed = this.read(e);
							var n = 255 - this.transparency.indexed.length;
							if (n > 0) for (t = 0; t < n; t++) this.transparency.indexed.push(255);
							break;
						case 0:
							this.transparency.grayscale = this.read(e)[0];
							break;
						case 2:
							this.transparency.rgb = this.read(e);
							break;
					}
					break;
				case "tEXt":
					var r = this.read(e), i = r.indexOf(0), a = String.fromCharCode.apply(String, r.slice(0, i));
					this.text[a] = String.fromCharCode.apply(String, r.slice(i + 1));
					break;
				case "IEND":
					switch (this.colorType) {
						case 0:
						case 3:
						case 4:
							this.colors = 1;
							break;
						case 2:
						case 6:
							this.colors = 3;
							break;
					}
					this.hasAlphaChannel = [4, 6].includes(this.colorType);
					var o = this.colors + +!!this.hasAlphaChannel;
					switch (this.pixelBitlength = this.bits * o, this.colors) {
						case 1:
							this.colorSpace = "DeviceGray";
							break;
						case 3:
							this.colorSpace = "DeviceRGB";
							break;
					}
					this.imgData = Z.from(this.imgData);
					return;
				default: this.pos += e;
			}
			if (this.pos += 4, this.pos > this.data.length) throw Error("Incomplete or corrupt PNG file");
		}
	}
	read(e) {
		let t = Array(e);
		for (let n = 0; n < e; n++) t[n] = this.data[this.pos++];
		return t;
	}
	readUInt32() {
		let e = this.data[this.pos++] << 24, t = this.data[this.pos++] << 16, n = this.data[this.pos++] << 8, r = this.data[this.pos++];
		return e | t | n | r;
	}
	readUInt16() {
		return this.data[this.pos++] << 8 | this.data[this.pos++];
	}
	decodePixels(e) {
		return fR.inflate(this.imgData, (t, n) => {
			if (t) throw t;
			var r = 0;
			let { width: i, height: a } = this;
			var o = this.pixelBitlength / 8;
			let s = Z.alloc(i * a * o);
			function c(e, t, c, l, u) {
				u === void 0 && (u = !1);
				let d = Math.ceil((i - e) / c), f = Math.ceil((a - t) / l), p = o * d, m = u ? s : Z.alloc(p * f), h = 0, g = 0;
				for (; h < f && r < n.length;) {
					var _, v, y, b, x;
					switch (n[r++]) {
						case 0:
							for (y = 0; y < p; y++) m[g++] = n[r++];
							break;
						case 1:
							for (y = 0; y < p; y++) _ = n[r++], b = y < o ? 0 : m[g - o], m[g++] = (_ + b) % 256;
							break;
						case 2:
							for (y = 0; y < p; y++) _ = n[r++], v = (y - y % o) / o, x = h && m[(h - 1) * p + v * o + y % o], m[g++] = (x + _) % 256;
							break;
						case 3:
							for (y = 0; y < p; y++) _ = n[r++], v = (y - y % o) / o, b = y < o ? 0 : m[g - o], x = h && m[(h - 1) * p + v * o + y % o], m[g++] = (_ + Math.floor((b + x) / 2)) % 256;
							break;
						case 4:
							for (y = 0; y < p; y++) {
								var S, C;
								_ = n[r++], v = (y - y % o) / o, b = y < o ? 0 : m[g - o], h === 0 ? x = C = 0 : (x = m[(h - 1) * p + v * o + y % o], C = v && m[(h - 1) * p + (v - 1) * o + y % o]);
								let e = b + x - C, t = Math.abs(e - b), i = Math.abs(e - x), a = Math.abs(e - C);
								S = t <= i && t <= a ? b : i <= a ? x : C, m[g++] = (_ + S) % 256;
							}
							break;
						default: throw Error(`Invalid filter algorithm: ${n[r - 1]}`);
					}
					if (!u) {
						let n = ((t + h * l) * i + e) * o, r = h * p;
						for (y = 0; y < d; y++) {
							for (let e = 0; e < o; e++) s[n++] = m[r++];
							n += (c - 1) * o;
						}
					}
					h++;
				}
			}
			return this.interlaceMethod === 1 ? (c(0, 0, 8, 8), c(4, 0, 8, 8), c(0, 4, 4, 8), c(2, 0, 4, 4), c(0, 2, 2, 4), c(1, 0, 2, 2), c(0, 1, 1, 2)) : c(0, 0, 1, 1, !0), e(s);
		});
	}
	decodePalette() {
		let { palette: e } = this, { length: t } = e, n = this.transparency.indexed || [], r = Z.alloc(n.length + t), i = 0, a = 0;
		for (let o = 0; o < t; o += 3) r[i++] = e[o], r[i++] = e[o + 1], r[i++] = e[o + 2], r[i++] = n[a++] ?? 255;
		return r;
	}
	copyToImageData(e, t) {
		let n;
		var r;
		let { colors: i } = this, a = null, o = this.hasAlphaChannel;
		this.palette.length && (a = this._decodedPalette ||= this.decodePalette(), i = 4, o = !0);
		let s = e.data || e, { length: c } = s, l = a || t, u = n = 0;
		if (i === 1) for (; u < c;) {
			r = a ? t[u / 4] * 4 : n;
			let e = l[r++];
			s[u++] = e, s[u++] = e, s[u++] = e, s[u++] = o ? l[r++] : 255, n = r;
		}
		else for (; u < c;) r = a ? t[u / 4] * 4 : n, s[u++] = l[r++], s[u++] = l[r++], s[u++] = l[r++], s[u++] = o ? l[r++] : 255, n = r;
	}
	decode(e) {
		let t = Z.alloc(this.width * this.height * 4);
		return this.decodePixels((n) => (this.copyToImageData(t, n), e(t)));
	}
}, mR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r) {
		typeof e == "object" ? t.exports = e = r(ak()) : typeof define == "function" && define.amd ? define(["./core"], r) : r(n.CryptoJS);
	})(e, function(e) {
		return (function(t) {
			var n = e, r = n.lib, i = r.Base, a = r.WordArray, o = n.x64 = {};
			o.Word = i.extend({ init: function(e, t) {
				this.high = e, this.low = t;
			} }), o.WordArray = i.extend({
				init: function(e, n) {
					e = this.words = e || [], n == t ? this.sigBytes = e.length * 8 : this.sigBytes = n;
				},
				toX32: function() {
					for (var e = this.words, t = e.length, n = [], r = 0; r < t; r++) {
						var i = e[r];
						n.push(i.high), n.push(i.low);
					}
					return a.create(n, this.sigBytes);
				},
				clone: function() {
					for (var e = i.clone.call(this), t = e.words = this.words.slice(0), n = t.length, r = 0; r < n; r++) t[r] = t[r].clone();
					return e;
				}
			});
		})(), e;
	});
})), hR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r) {
		typeof e == "object" ? t.exports = e = r(ak()) : typeof define == "function" && define.amd ? define(["./core"], r) : r(n.CryptoJS);
	})(e, function(e) {
		return (function() {
			if (typeof ArrayBuffer == "function") {
				var t = e.lib.WordArray, n = t.init, r = t.init = function(e) {
					if (e instanceof ArrayBuffer && (e = new Uint8Array(e)), (e instanceof Int8Array || typeof Uint8ClampedArray < "u" && e instanceof Uint8ClampedArray || e instanceof Int16Array || e instanceof Uint16Array || e instanceof Int32Array || e instanceof Uint32Array || e instanceof Float32Array || e instanceof Float64Array) && (e = new Uint8Array(e.buffer, e.byteOffset, e.byteLength)), e instanceof Uint8Array) {
						for (var t = e.byteLength, r = [], i = 0; i < t; i++) r[i >>> 2] |= e[i] << 24 - i % 4 * 8;
						n.call(this, r, t);
					} else n.apply(this, arguments);
				};
				r.prototype = t;
			}
		})(), e.lib.WordArray;
	});
})), gR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r) {
		typeof e == "object" ? t.exports = e = r(ak()) : typeof define == "function" && define.amd ? define(["./core"], r) : r(n.CryptoJS);
	})(e, function(e) {
		return (function() {
			var t = e, n = t.lib.WordArray, r = t.enc;
			r.Utf16 = r.Utf16BE = {
				stringify: function(e) {
					for (var t = e.words, n = e.sigBytes, r = [], i = 0; i < n; i += 2) {
						var a = t[i >>> 2] >>> 16 - i % 4 * 8 & 65535;
						r.push(String.fromCharCode(a));
					}
					return r.join("");
				},
				parse: function(e) {
					for (var t = e.length, r = [], i = 0; i < t; i++) r[i >>> 1] |= e.charCodeAt(i) << 16 - i % 2 * 16;
					return n.create(r, t * 2);
				}
			}, r.Utf16LE = {
				stringify: function(e) {
					for (var t = e.words, n = e.sigBytes, r = [], a = 0; a < n; a += 2) {
						var o = i(t[a >>> 2] >>> 16 - a % 4 * 8 & 65535);
						r.push(String.fromCharCode(o));
					}
					return r.join("");
				},
				parse: function(e) {
					for (var t = e.length, r = [], a = 0; a < t; a++) r[a >>> 1] |= i(e.charCodeAt(a) << 16 - a % 2 * 16);
					return n.create(r, t * 2);
				}
			};
			function i(e) {
				return e << 8 & 4278255360 | e >>> 8 & 16711935;
			}
		})(), e.enc.Utf16;
	});
})), _R = /* @__PURE__ */ V(((e, t) => {
	(function(n, r) {
		typeof e == "object" ? t.exports = e = r(ak()) : typeof define == "function" && define.amd ? define(["./core"], r) : r(n.CryptoJS);
	})(e, function(e) {
		return (function() {
			var t = e, n = t.lib.WordArray, r = t.enc;
			r.Base64 = {
				stringify: function(e) {
					var t = e.words, n = e.sigBytes, r = this._map;
					e.clamp();
					for (var i = [], a = 0; a < n; a += 3) for (var o = t[a >>> 2] >>> 24 - a % 4 * 8 & 255, s = t[a + 1 >>> 2] >>> 24 - (a + 1) % 4 * 8 & 255, c = t[a + 2 >>> 2] >>> 24 - (a + 2) % 4 * 8 & 255, l = o << 16 | s << 8 | c, u = 0; u < 4 && a + u * .75 < n; u++) i.push(r.charAt(l >>> 6 * (3 - u) & 63));
					var d = r.charAt(64);
					if (d) for (; i.length % 4;) i.push(d);
					return i.join("");
				},
				parse: function(e) {
					var t = e.length, n = this._map, r = this._reverseMap;
					if (!r) {
						r = this._reverseMap = [];
						for (var a = 0; a < n.length; a++) r[n.charCodeAt(a)] = a;
					}
					var o = n.charAt(64);
					if (o) {
						var s = e.indexOf(o);
						s !== -1 && (t = s);
					}
					return i(e, t, r);
				},
				_map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
			};
			function i(e, t, r) {
				for (var i = [], a = 0, o = 0; o < t; o++) if (o % 4) {
					var s = r[e.charCodeAt(o - 1)] << o % 4 * 2 | r[e.charCodeAt(o)] >>> 6 - o % 4 * 2;
					i[a >>> 2] |= s << 24 - a % 4 * 8, a++;
				}
				return n.create(i, a);
			}
		})(), e.enc.Base64;
	});
})), vR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r) {
		typeof e == "object" ? t.exports = e = r(ak()) : typeof define == "function" && define.amd ? define(["./core"], r) : r(n.CryptoJS);
	})(e, function(e) {
		return (function() {
			var t = e, n = t.lib.WordArray, r = t.enc;
			r.Base64url = {
				stringify: function(e, t) {
					t === void 0 && (t = !0);
					var n = e.words, r = e.sigBytes, i = t ? this._safe_map : this._map;
					e.clamp();
					for (var a = [], o = 0; o < r; o += 3) for (var s = n[o >>> 2] >>> 24 - o % 4 * 8 & 255, c = n[o + 1 >>> 2] >>> 24 - (o + 1) % 4 * 8 & 255, l = n[o + 2 >>> 2] >>> 24 - (o + 2) % 4 * 8 & 255, u = s << 16 | c << 8 | l, d = 0; d < 4 && o + d * .75 < r; d++) a.push(i.charAt(u >>> 6 * (3 - d) & 63));
					var f = i.charAt(64);
					if (f) for (; a.length % 4;) a.push(f);
					return a.join("");
				},
				parse: function(e, t) {
					t === void 0 && (t = !0);
					var n = e.length, r = t ? this._safe_map : this._map, a = this._reverseMap;
					if (!a) {
						a = this._reverseMap = [];
						for (var o = 0; o < r.length; o++) a[r.charCodeAt(o)] = o;
					}
					var s = r.charAt(64);
					if (s) {
						var c = e.indexOf(s);
						c !== -1 && (n = c);
					}
					return i(e, n, a);
				},
				_map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
				_safe_map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
			};
			function i(e, t, r) {
				for (var i = [], a = 0, o = 0; o < t; o++) if (o % 4) {
					var s = r[e.charCodeAt(o - 1)] << o % 4 * 2 | r[e.charCodeAt(o)] >>> 6 - o % 4 * 2;
					i[a >>> 2] |= s << 24 - a % 4 * 8, a++;
				}
				return n.create(i, a);
			}
		})(), e.enc.Base64url;
	});
})), yR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r) {
		typeof e == "object" ? t.exports = e = r(ak()) : typeof define == "function" && define.amd ? define(["./core"], r) : r(n.CryptoJS);
	})(e, function(e) {
		return (function() {
			var t = e, n = t.lib, r = n.WordArray, i = n.Hasher, a = t.algo, o = [], s = a.SHA1 = i.extend({
				_doReset: function() {
					this._hash = new r.init([
						1732584193,
						4023233417,
						2562383102,
						271733878,
						3285377520
					]);
				},
				_doProcessBlock: function(e, t) {
					for (var n = this._hash.words, r = n[0], i = n[1], a = n[2], s = n[3], c = n[4], l = 0; l < 80; l++) {
						if (l < 16) o[l] = e[t + l] | 0;
						else {
							var u = o[l - 3] ^ o[l - 8] ^ o[l - 14] ^ o[l - 16];
							o[l] = u << 1 | u >>> 31;
						}
						var d = (r << 5 | r >>> 27) + c + o[l];
						l < 20 ? d += (i & a | ~i & s) + 1518500249 : l < 40 ? d += (i ^ a ^ s) + 1859775393 : l < 60 ? d += (i & a | i & s | a & s) - 1894007588 : d += (i ^ a ^ s) - 899497514, c = s, s = a, a = i << 30 | i >>> 2, i = r, r = d;
					}
					n[0] = n[0] + r | 0, n[1] = n[1] + i | 0, n[2] = n[2] + a | 0, n[3] = n[3] + s | 0, n[4] = n[4] + c | 0;
				},
				_doFinalize: function() {
					var e = this._data, t = e.words, n = this._nDataBytes * 8, r = e.sigBytes * 8;
					return t[r >>> 5] |= 128 << 24 - r % 32, t[(r + 64 >>> 9 << 4) + 14] = Math.floor(n / 4294967296), t[(r + 64 >>> 9 << 4) + 15] = n, e.sigBytes = t.length * 4, this._process(), this._hash;
				},
				clone: function() {
					var e = i.clone.call(this);
					return e._hash = this._hash.clone(), e;
				}
			});
			t.SHA1 = i._createHelper(s), t.HmacSHA1 = i._createHmacHelper(s);
		})(), e.SHA1;
	});
})), bR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r) {
		typeof e == "object" ? t.exports = e = r(ak()) : typeof define == "function" && define.amd ? define(["./core"], r) : r(n.CryptoJS);
	})(e, function(e) {
		return (function(t) {
			var n = e, r = n.lib, i = r.WordArray, a = r.Hasher, o = n.algo, s = [], c = [];
			(function() {
				function e(e) {
					for (var n = t.sqrt(e), r = 2; r <= n; r++) if (!(e % r)) return !1;
					return !0;
				}
				function n(e) {
					return (e - (e | 0)) * 4294967296 | 0;
				}
				for (var r = 2, i = 0; i < 64;) e(r) && (i < 8 && (s[i] = n(t.pow(r, 1 / 2))), c[i] = n(t.pow(r, 1 / 3)), i++), r++;
			})();
			var l = [], u = o.SHA256 = a.extend({
				_doReset: function() {
					this._hash = new i.init(s.slice(0));
				},
				_doProcessBlock: function(e, t) {
					for (var n = this._hash.words, r = n[0], i = n[1], a = n[2], o = n[3], s = n[4], u = n[5], d = n[6], f = n[7], p = 0; p < 64; p++) {
						if (p < 16) l[p] = e[t + p] | 0;
						else {
							var m = l[p - 15], h = (m << 25 | m >>> 7) ^ (m << 14 | m >>> 18) ^ m >>> 3, g = l[p - 2], _ = (g << 15 | g >>> 17) ^ (g << 13 | g >>> 19) ^ g >>> 10;
							l[p] = h + l[p - 7] + _ + l[p - 16];
						}
						var v = s & u ^ ~s & d, y = r & i ^ r & a ^ i & a, b = (r << 30 | r >>> 2) ^ (r << 19 | r >>> 13) ^ (r << 10 | r >>> 22), x = (s << 26 | s >>> 6) ^ (s << 21 | s >>> 11) ^ (s << 7 | s >>> 25), S = f + x + v + c[p] + l[p], C = b + y;
						f = d, d = u, u = s, s = o + S | 0, o = a, a = i, i = r, r = S + C | 0;
					}
					n[0] = n[0] + r | 0, n[1] = n[1] + i | 0, n[2] = n[2] + a | 0, n[3] = n[3] + o | 0, n[4] = n[4] + s | 0, n[5] = n[5] + u | 0, n[6] = n[6] + d | 0, n[7] = n[7] + f | 0;
				},
				_doFinalize: function() {
					var e = this._data, n = e.words, r = this._nDataBytes * 8, i = e.sigBytes * 8;
					return n[i >>> 5] |= 128 << 24 - i % 32, n[(i + 64 >>> 9 << 4) + 14] = t.floor(r / 4294967296), n[(i + 64 >>> 9 << 4) + 15] = r, e.sigBytes = n.length * 4, this._process(), this._hash;
				},
				clone: function() {
					var e = a.clone.call(this);
					return e._hash = this._hash.clone(), e;
				}
			});
			n.SHA256 = a._createHelper(u), n.HmacSHA256 = a._createHmacHelper(u);
		})(Math), e.SHA256;
	});
})), xR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r, i) {
		typeof e == "object" ? t.exports = e = r(ak(), bR()) : typeof define == "function" && define.amd ? define(["./core", "./sha256"], r) : r(n.CryptoJS);
	})(e, function(e) {
		return (function() {
			var t = e, n = t.lib.WordArray, r = t.algo, i = r.SHA256, a = r.SHA224 = i.extend({
				_doReset: function() {
					this._hash = new n.init([
						3238371032,
						914150663,
						812702999,
						4144912697,
						4290775857,
						1750603025,
						1694076839,
						3204075428
					]);
				},
				_doFinalize: function() {
					var e = i._doFinalize.call(this);
					return e.sigBytes -= 4, e;
				}
			});
			t.SHA224 = i._createHelper(a), t.HmacSHA224 = i._createHmacHelper(a);
		})(), e.SHA224;
	});
})), SR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r, i) {
		typeof e == "object" ? t.exports = e = r(ak(), mR()) : typeof define == "function" && define.amd ? define(["./core", "./x64-core"], r) : r(n.CryptoJS);
	})(e, function(e) {
		return (function() {
			var t = e, n = t.lib.Hasher, r = t.x64, i = r.Word, a = r.WordArray, o = t.algo;
			function s() {
				return i.create.apply(i, arguments);
			}
			var c = [
				s(1116352408, 3609767458),
				s(1899447441, 602891725),
				s(3049323471, 3964484399),
				s(3921009573, 2173295548),
				s(961987163, 4081628472),
				s(1508970993, 3053834265),
				s(2453635748, 2937671579),
				s(2870763221, 3664609560),
				s(3624381080, 2734883394),
				s(310598401, 1164996542),
				s(607225278, 1323610764),
				s(1426881987, 3590304994),
				s(1925078388, 4068182383),
				s(2162078206, 991336113),
				s(2614888103, 633803317),
				s(3248222580, 3479774868),
				s(3835390401, 2666613458),
				s(4022224774, 944711139),
				s(264347078, 2341262773),
				s(604807628, 2007800933),
				s(770255983, 1495990901),
				s(1249150122, 1856431235),
				s(1555081692, 3175218132),
				s(1996064986, 2198950837),
				s(2554220882, 3999719339),
				s(2821834349, 766784016),
				s(2952996808, 2566594879),
				s(3210313671, 3203337956),
				s(3336571891, 1034457026),
				s(3584528711, 2466948901),
				s(113926993, 3758326383),
				s(338241895, 168717936),
				s(666307205, 1188179964),
				s(773529912, 1546045734),
				s(1294757372, 1522805485),
				s(1396182291, 2643833823),
				s(1695183700, 2343527390),
				s(1986661051, 1014477480),
				s(2177026350, 1206759142),
				s(2456956037, 344077627),
				s(2730485921, 1290863460),
				s(2820302411, 3158454273),
				s(3259730800, 3505952657),
				s(3345764771, 106217008),
				s(3516065817, 3606008344),
				s(3600352804, 1432725776),
				s(4094571909, 1467031594),
				s(275423344, 851169720),
				s(430227734, 3100823752),
				s(506948616, 1363258195),
				s(659060556, 3750685593),
				s(883997877, 3785050280),
				s(958139571, 3318307427),
				s(1322822218, 3812723403),
				s(1537002063, 2003034995),
				s(1747873779, 3602036899),
				s(1955562222, 1575990012),
				s(2024104815, 1125592928),
				s(2227730452, 2716904306),
				s(2361852424, 442776044),
				s(2428436474, 593698344),
				s(2756734187, 3733110249),
				s(3204031479, 2999351573),
				s(3329325298, 3815920427),
				s(3391569614, 3928383900),
				s(3515267271, 566280711),
				s(3940187606, 3454069534),
				s(4118630271, 4000239992),
				s(116418474, 1914138554),
				s(174292421, 2731055270),
				s(289380356, 3203993006),
				s(460393269, 320620315),
				s(685471733, 587496836),
				s(852142971, 1086792851),
				s(1017036298, 365543100),
				s(1126000580, 2618297676),
				s(1288033470, 3409855158),
				s(1501505948, 4234509866),
				s(1607167915, 987167468),
				s(1816402316, 1246189591)
			], l = [];
			(function() {
				for (var e = 0; e < 80; e++) l[e] = s();
			})();
			var u = o.SHA512 = n.extend({
				_doReset: function() {
					this._hash = new a.init([
						new i.init(1779033703, 4089235720),
						new i.init(3144134277, 2227873595),
						new i.init(1013904242, 4271175723),
						new i.init(2773480762, 1595750129),
						new i.init(1359893119, 2917565137),
						new i.init(2600822924, 725511199),
						new i.init(528734635, 4215389547),
						new i.init(1541459225, 327033209)
					]);
				},
				_doProcessBlock: function(e, t) {
					for (var n = this._hash.words, r = n[0], i = n[1], a = n[2], o = n[3], s = n[4], u = n[5], d = n[6], f = n[7], p = r.high, m = r.low, h = i.high, g = i.low, _ = a.high, v = a.low, y = o.high, b = o.low, x = s.high, S = s.low, C = u.high, w = u.low, T = d.high, E = d.low, D = f.high, O = f.low, k = p, A = m, j = h, M = g, ee = _, te = v, ne = y, re = b, ie = x, ae = S, oe = C, se = w, ce = T, le = E, N = D, P = O, ue = 0; ue < 80; ue++) {
						var de, fe, pe = l[ue];
						if (ue < 16) fe = pe.high = e[t + ue * 2] | 0, de = pe.low = e[t + ue * 2 + 1] | 0;
						else {
							var me = l[ue - 15], F = me.high, I = me.low, he = (F >>> 1 | I << 31) ^ (F >>> 8 | I << 24) ^ F >>> 7, L = (I >>> 1 | F << 31) ^ (I >>> 8 | F << 24) ^ (I >>> 7 | F << 25), ge = l[ue - 2], _e = ge.high, ve = ge.low, ye = (_e >>> 19 | ve << 13) ^ (_e << 3 | ve >>> 29) ^ _e >>> 6, be = (ve >>> 19 | _e << 13) ^ (ve << 3 | _e >>> 29) ^ (ve >>> 6 | _e << 26), R = l[ue - 7], xe = R.high, z = R.low, B = l[ue - 16], Se = B.high, Ce = B.low;
							de = L + z, fe = he + xe + +(de >>> 0 < L >>> 0), de += be, fe = fe + ye + +(de >>> 0 < be >>> 0), de += Ce, fe = fe + Se + +(de >>> 0 < Ce >>> 0), pe.high = fe, pe.low = de;
						}
						var we = ie & oe ^ ~ie & ce, Te = ae & se ^ ~ae & le, Ee = k & j ^ k & ee ^ j & ee, De = A & M ^ A & te ^ M & te, Oe = (k >>> 28 | A << 4) ^ (k << 30 | A >>> 2) ^ (k << 25 | A >>> 7), ke = (A >>> 28 | k << 4) ^ (A << 30 | k >>> 2) ^ (A << 25 | k >>> 7), Ae = (ie >>> 14 | ae << 18) ^ (ie >>> 18 | ae << 14) ^ (ie << 23 | ae >>> 9), je = (ae >>> 14 | ie << 18) ^ (ae >>> 18 | ie << 14) ^ (ae << 23 | ie >>> 9), Me = c[ue], Ne = Me.high, Pe = Me.low, Fe = P + je, Ie = N + Ae + +(Fe >>> 0 < P >>> 0), Fe = Fe + Te, Ie = Ie + we + +(Fe >>> 0 < Te >>> 0), Fe = Fe + Pe, Ie = Ie + Ne + +(Fe >>> 0 < Pe >>> 0), Fe = Fe + de, Ie = Ie + fe + +(Fe >>> 0 < de >>> 0), Le = ke + De, Re = Oe + Ee + +(Le >>> 0 < ke >>> 0);
						N = ce, P = le, ce = oe, le = se, oe = ie, se = ae, ae = re + Fe | 0, ie = ne + Ie + +(ae >>> 0 < re >>> 0) | 0, ne = ee, re = te, ee = j, te = M, j = k, M = A, A = Fe + Le | 0, k = Ie + Re + +(A >>> 0 < Fe >>> 0) | 0;
					}
					m = r.low = m + A, r.high = p + k + +(m >>> 0 < A >>> 0), g = i.low = g + M, i.high = h + j + +(g >>> 0 < M >>> 0), v = a.low = v + te, a.high = _ + ee + +(v >>> 0 < te >>> 0), b = o.low = b + re, o.high = y + ne + +(b >>> 0 < re >>> 0), S = s.low = S + ae, s.high = x + ie + +(S >>> 0 < ae >>> 0), w = u.low = w + se, u.high = C + oe + +(w >>> 0 < se >>> 0), E = d.low = E + le, d.high = T + ce + +(E >>> 0 < le >>> 0), O = f.low = O + P, f.high = D + N + +(O >>> 0 < P >>> 0);
				},
				_doFinalize: function() {
					var e = this._data, t = e.words, n = this._nDataBytes * 8, r = e.sigBytes * 8;
					return t[r >>> 5] |= 128 << 24 - r % 32, t[(r + 128 >>> 10 << 5) + 30] = Math.floor(n / 4294967296), t[(r + 128 >>> 10 << 5) + 31] = n, e.sigBytes = t.length * 4, this._process(), this._hash.toX32();
				},
				clone: function() {
					var e = n.clone.call(this);
					return e._hash = this._hash.clone(), e;
				},
				blockSize: 1024 / 32
			});
			t.SHA512 = n._createHelper(u), t.HmacSHA512 = n._createHmacHelper(u);
		})(), e.SHA512;
	});
})), CR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r, i) {
		typeof e == "object" ? t.exports = e = r(ak(), mR(), SR()) : typeof define == "function" && define.amd ? define([
			"./core",
			"./x64-core",
			"./sha512"
		], r) : r(n.CryptoJS);
	})(e, function(e) {
		return (function() {
			var t = e, n = t.x64, r = n.Word, i = n.WordArray, a = t.algo, o = a.SHA512, s = a.SHA384 = o.extend({
				_doReset: function() {
					this._hash = new i.init([
						new r.init(3418070365, 3238371032),
						new r.init(1654270250, 914150663),
						new r.init(2438529370, 812702999),
						new r.init(355462360, 4144912697),
						new r.init(1731405415, 4290775857),
						new r.init(2394180231, 1750603025),
						new r.init(3675008525, 1694076839),
						new r.init(1203062813, 3204075428)
					]);
				},
				_doFinalize: function() {
					var e = o._doFinalize.call(this);
					return e.sigBytes -= 16, e;
				}
			});
			t.SHA384 = o._createHelper(s), t.HmacSHA384 = o._createHmacHelper(s);
		})(), e.SHA384;
	});
})), wR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r, i) {
		typeof e == "object" ? t.exports = e = r(ak(), mR()) : typeof define == "function" && define.amd ? define(["./core", "./x64-core"], r) : r(n.CryptoJS);
	})(e, function(e) {
		return (function(t) {
			var n = e, r = n.lib, i = r.WordArray, a = r.Hasher, o = n.x64.Word, s = n.algo, c = [], l = [], u = [];
			(function() {
				for (var e = 1, t = 0, n = 0; n < 24; n++) {
					c[e + 5 * t] = (n + 1) * (n + 2) / 2 % 64;
					var r = t % 5, i = (2 * e + 3 * t) % 5;
					e = r, t = i;
				}
				for (var e = 0; e < 5; e++) for (var t = 0; t < 5; t++) l[e + 5 * t] = t + (2 * e + 3 * t) % 5 * 5;
				for (var a = 1, s = 0; s < 24; s++) {
					for (var d = 0, f = 0, p = 0; p < 7; p++) {
						if (a & 1) {
							var m = (1 << p) - 1;
							m < 32 ? f ^= 1 << m : d ^= 1 << m - 32;
						}
						a & 128 ? a = a << 1 ^ 113 : a <<= 1;
					}
					u[s] = o.create(d, f);
				}
			})();
			var d = [];
			(function() {
				for (var e = 0; e < 25; e++) d[e] = o.create();
			})();
			var f = s.SHA3 = a.extend({
				cfg: a.cfg.extend({ outputLength: 512 }),
				_doReset: function() {
					for (var e = this._state = [], t = 0; t < 25; t++) e[t] = new o.init();
					this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
				},
				_doProcessBlock: function(e, t) {
					for (var n = this._state, r = this.blockSize / 2, i = 0; i < r; i++) {
						var a = e[t + 2 * i], o = e[t + 2 * i + 1];
						a = (a << 8 | a >>> 24) & 16711935 | (a << 24 | a >>> 8) & 4278255360, o = (o << 8 | o >>> 24) & 16711935 | (o << 24 | o >>> 8) & 4278255360;
						var s = n[i];
						s.high ^= o, s.low ^= a;
					}
					for (var f = 0; f < 24; f++) {
						for (var p = 0; p < 5; p++) {
							for (var m = 0, h = 0, g = 0; g < 5; g++) {
								var s = n[p + 5 * g];
								m ^= s.high, h ^= s.low;
							}
							var _ = d[p];
							_.high = m, _.low = h;
						}
						for (var p = 0; p < 5; p++) for (var v = d[(p + 4) % 5], y = d[(p + 1) % 5], b = y.high, x = y.low, m = v.high ^ (b << 1 | x >>> 31), h = v.low ^ (x << 1 | b >>> 31), g = 0; g < 5; g++) {
							var s = n[p + 5 * g];
							s.high ^= m, s.low ^= h;
						}
						for (var S = 1; S < 25; S++) {
							var m, h, s = n[S], C = s.high, w = s.low, T = c[S];
							T < 32 ? (m = C << T | w >>> 32 - T, h = w << T | C >>> 32 - T) : (m = w << T - 32 | C >>> 64 - T, h = C << T - 32 | w >>> 64 - T);
							var E = d[l[S]];
							E.high = m, E.low = h;
						}
						var D = d[0], O = n[0];
						D.high = O.high, D.low = O.low;
						for (var p = 0; p < 5; p++) for (var g = 0; g < 5; g++) {
							var S = p + 5 * g, s = n[S], k = d[S], A = d[(p + 1) % 5 + 5 * g], j = d[(p + 2) % 5 + 5 * g];
							s.high = k.high ^ ~A.high & j.high, s.low = k.low ^ ~A.low & j.low;
						}
						var s = n[0], M = u[f];
						s.high ^= M.high, s.low ^= M.low;
					}
				},
				_doFinalize: function() {
					var e = this._data, n = e.words;
					this._nDataBytes * 8;
					var r = e.sigBytes * 8, a = this.blockSize * 32;
					n[r >>> 5] |= 1 << 24 - r % 32, n[(t.ceil((r + 1) / a) * a >>> 5) - 1] |= 128, e.sigBytes = n.length * 4, this._process();
					for (var o = this._state, s = this.cfg.outputLength / 8, c = s / 8, l = [], u = 0; u < c; u++) {
						var d = o[u], f = d.high, p = d.low;
						f = (f << 8 | f >>> 24) & 16711935 | (f << 24 | f >>> 8) & 4278255360, p = (p << 8 | p >>> 24) & 16711935 | (p << 24 | p >>> 8) & 4278255360, l.push(p), l.push(f);
					}
					return new i.init(l, s);
				},
				clone: function() {
					for (var e = a.clone.call(this), t = e._state = this._state.slice(0), n = 0; n < 25; n++) t[n] = t[n].clone();
					return e;
				}
			});
			n.SHA3 = a._createHelper(f), n.HmacSHA3 = a._createHmacHelper(f);
		})(Math), e.SHA3;
	});
})), TR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r) {
		typeof e == "object" ? t.exports = e = r(ak()) : typeof define == "function" && define.amd ? define(["./core"], r) : r(n.CryptoJS);
	})(e, function(e) {
		return (function(t) {
			var n = e, r = n.lib, i = r.WordArray, a = r.Hasher, o = n.algo, s = i.create([
				0,
				1,
				2,
				3,
				4,
				5,
				6,
				7,
				8,
				9,
				10,
				11,
				12,
				13,
				14,
				15,
				7,
				4,
				13,
				1,
				10,
				6,
				15,
				3,
				12,
				0,
				9,
				5,
				2,
				14,
				11,
				8,
				3,
				10,
				14,
				4,
				9,
				15,
				8,
				1,
				2,
				7,
				0,
				6,
				13,
				11,
				5,
				12,
				1,
				9,
				11,
				10,
				0,
				8,
				12,
				4,
				13,
				3,
				7,
				15,
				14,
				5,
				6,
				2,
				4,
				0,
				5,
				9,
				7,
				12,
				2,
				10,
				14,
				1,
				3,
				8,
				11,
				6,
				15,
				13
			]), c = i.create([
				5,
				14,
				7,
				0,
				9,
				2,
				11,
				4,
				13,
				6,
				15,
				8,
				1,
				10,
				3,
				12,
				6,
				11,
				3,
				7,
				0,
				13,
				5,
				10,
				14,
				15,
				8,
				12,
				4,
				9,
				1,
				2,
				15,
				5,
				1,
				3,
				7,
				14,
				6,
				9,
				11,
				8,
				12,
				2,
				10,
				0,
				4,
				13,
				8,
				6,
				4,
				1,
				3,
				11,
				15,
				0,
				5,
				12,
				2,
				13,
				9,
				7,
				10,
				14,
				12,
				15,
				10,
				4,
				1,
				5,
				8,
				7,
				6,
				2,
				13,
				14,
				0,
				3,
				9,
				11
			]), l = i.create([
				11,
				14,
				15,
				12,
				5,
				8,
				7,
				9,
				11,
				13,
				14,
				15,
				6,
				7,
				9,
				8,
				7,
				6,
				8,
				13,
				11,
				9,
				7,
				15,
				7,
				12,
				15,
				9,
				11,
				7,
				13,
				12,
				11,
				13,
				6,
				7,
				14,
				9,
				13,
				15,
				14,
				8,
				13,
				6,
				5,
				12,
				7,
				5,
				11,
				12,
				14,
				15,
				14,
				15,
				9,
				8,
				9,
				14,
				5,
				6,
				8,
				6,
				5,
				12,
				9,
				15,
				5,
				11,
				6,
				8,
				13,
				12,
				5,
				12,
				13,
				14,
				11,
				8,
				5,
				6
			]), u = i.create([
				8,
				9,
				9,
				11,
				13,
				15,
				15,
				5,
				7,
				7,
				8,
				11,
				14,
				14,
				12,
				6,
				9,
				13,
				15,
				7,
				12,
				8,
				9,
				11,
				7,
				7,
				12,
				7,
				6,
				15,
				13,
				11,
				9,
				7,
				15,
				11,
				8,
				6,
				6,
				14,
				12,
				13,
				5,
				14,
				13,
				13,
				7,
				5,
				15,
				5,
				8,
				11,
				14,
				14,
				6,
				14,
				6,
				9,
				12,
				9,
				12,
				5,
				15,
				8,
				8,
				5,
				12,
				9,
				12,
				5,
				14,
				6,
				8,
				13,
				6,
				5,
				15,
				13,
				11,
				11
			]), d = i.create([
				0,
				1518500249,
				1859775393,
				2400959708,
				2840853838
			]), f = i.create([
				1352829926,
				1548603684,
				1836072691,
				2053994217,
				0
			]), p = o.RIPEMD160 = a.extend({
				_doReset: function() {
					this._hash = i.create([
						1732584193,
						4023233417,
						2562383102,
						271733878,
						3285377520
					]);
				},
				_doProcessBlock: function(e, t) {
					for (var n = 0; n < 16; n++) {
						var r = t + n, i = e[r];
						e[r] = (i << 8 | i >>> 24) & 16711935 | (i << 24 | i >>> 8) & 4278255360;
					}
					for (var a = this._hash.words, o = d.words, p = f.words, b = s.words, x = c.words, S = l.words, C = u.words, w, T, E, D, O, k = w = a[0], A = T = a[1], j = E = a[2], M = D = a[3], ee = O = a[4], te, n = 0; n < 80; n += 1) te = w + e[t + b[n]] | 0, n < 16 ? te += m(T, E, D) + o[0] : n < 32 ? te += h(T, E, D) + o[1] : n < 48 ? te += g(T, E, D) + o[2] : n < 64 ? te += _(T, E, D) + o[3] : te += v(T, E, D) + o[4], te |= 0, te = y(te, S[n]), te = te + O | 0, w = O, O = D, D = y(E, 10), E = T, T = te, te = k + e[t + x[n]] | 0, n < 16 ? te += v(A, j, M) + p[0] : n < 32 ? te += _(A, j, M) + p[1] : n < 48 ? te += g(A, j, M) + p[2] : n < 64 ? te += h(A, j, M) + p[3] : te += m(A, j, M) + p[4], te |= 0, te = y(te, C[n]), te = te + ee | 0, k = ee, ee = M, M = y(j, 10), j = A, A = te;
					te = a[1] + E + M | 0, a[1] = a[2] + D + ee | 0, a[2] = a[3] + O + k | 0, a[3] = a[4] + w + A | 0, a[4] = a[0] + T + j | 0, a[0] = te;
				},
				_doFinalize: function() {
					var e = this._data, t = e.words, n = this._nDataBytes * 8, r = e.sigBytes * 8;
					t[r >>> 5] |= 128 << 24 - r % 32, t[(r + 64 >>> 9 << 4) + 14] = (n << 8 | n >>> 24) & 16711935 | (n << 24 | n >>> 8) & 4278255360, e.sigBytes = (t.length + 1) * 4, this._process();
					for (var i = this._hash, a = i.words, o = 0; o < 5; o++) {
						var s = a[o];
						a[o] = (s << 8 | s >>> 24) & 16711935 | (s << 24 | s >>> 8) & 4278255360;
					}
					return i;
				},
				clone: function() {
					var e = a.clone.call(this);
					return e._hash = this._hash.clone(), e;
				}
			});
			function m(e, t, n) {
				return e ^ t ^ n;
			}
			function h(e, t, n) {
				return e & t | ~e & n;
			}
			function g(e, t, n) {
				return (e | ~t) ^ n;
			}
			function _(e, t, n) {
				return e & n | t & ~n;
			}
			function v(e, t, n) {
				return e ^ (t | ~n);
			}
			function y(e, t) {
				return e << t | e >>> 32 - t;
			}
			n.RIPEMD160 = a._createHelper(p), n.HmacRIPEMD160 = a._createHmacHelper(p);
		})(Math), e.RIPEMD160;
	});
})), ER = /* @__PURE__ */ V(((e, t) => {
	(function(n, r) {
		typeof e == "object" ? t.exports = e = r(ak()) : typeof define == "function" && define.amd ? define(["./core"], r) : r(n.CryptoJS);
	})(e, function(e) {
		(function() {
			var t = e, n = t.lib.Base, r = t.enc.Utf8, i = t.algo;
			i.HMAC = n.extend({
				init: function(e, t) {
					e = this._hasher = new e.init(), typeof t == "string" && (t = r.parse(t));
					var n = e.blockSize, i = n * 4;
					t.sigBytes > i && (t = e.finalize(t)), t.clamp();
					for (var a = this._oKey = t.clone(), o = this._iKey = t.clone(), s = a.words, c = o.words, l = 0; l < n; l++) s[l] ^= 1549556828, c[l] ^= 909522486;
					a.sigBytes = o.sigBytes = i, this.reset();
				},
				reset: function() {
					var e = this._hasher;
					e.reset(), e.update(this._iKey);
				},
				update: function(e) {
					return this._hasher.update(e), this;
				},
				finalize: function(e) {
					var t = this._hasher, n = t.finalize(e);
					return t.reset(), t.finalize(this._oKey.clone().concat(n));
				}
			});
		})();
	});
})), DR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r, i) {
		typeof e == "object" ? t.exports = e = r(ak(), bR(), ER()) : typeof define == "function" && define.amd ? define([
			"./core",
			"./sha256",
			"./hmac"
		], r) : r(n.CryptoJS);
	})(e, function(e) {
		return (function() {
			var t = e, n = t.lib, r = n.Base, i = n.WordArray, a = t.algo, o = a.SHA256, s = a.HMAC, c = a.PBKDF2 = r.extend({
				cfg: r.extend({
					keySize: 128 / 32,
					hasher: o,
					iterations: 25e4
				}),
				init: function(e) {
					this.cfg = this.cfg.extend(e);
				},
				compute: function(e, t) {
					for (var n = this.cfg, r = s.create(n.hasher, e), a = i.create(), o = i.create([1]), c = a.words, l = o.words, u = n.keySize, d = n.iterations; c.length < u;) {
						var f = r.update(t).finalize(o);
						r.reset();
						for (var p = f.words, m = p.length, h = f, g = 1; g < d; g++) {
							h = r.finalize(h), r.reset();
							for (var _ = h.words, v = 0; v < m; v++) p[v] ^= _[v];
						}
						a.concat(f), l[0]++;
					}
					return a.sigBytes = u * 4, a;
				}
			});
			t.PBKDF2 = function(e, t, n) {
				return c.create(n).compute(e, t);
			};
		})(), e.PBKDF2;
	});
})), OR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r, i) {
		typeof e == "object" ? t.exports = e = r(ak(), yR(), ER()) : typeof define == "function" && define.amd ? define([
			"./core",
			"./sha1",
			"./hmac"
		], r) : r(n.CryptoJS);
	})(e, function(e) {
		return (function() {
			var t = e, n = t.lib, r = n.Base, i = n.WordArray, a = t.algo, o = a.MD5, s = a.EvpKDF = r.extend({
				cfg: r.extend({
					keySize: 128 / 32,
					hasher: o,
					iterations: 1
				}),
				init: function(e) {
					this.cfg = this.cfg.extend(e);
				},
				compute: function(e, t) {
					for (var n, r = this.cfg, a = r.hasher.create(), o = i.create(), s = o.words, c = r.keySize, l = r.iterations; s.length < c;) {
						n && a.update(n), n = a.update(e).finalize(t), a.reset();
						for (var u = 1; u < l; u++) n = a.finalize(n), a.reset();
						o.concat(n);
					}
					return o.sigBytes = c * 4, o;
				}
			});
			t.EvpKDF = function(e, t, n) {
				return s.create(n).compute(e, t);
			};
		})(), e.EvpKDF;
	});
})), kR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r, i) {
		typeof e == "object" ? t.exports = e = r(ak(), OR()) : typeof define == "function" && define.amd ? define(["./core", "./evpkdf"], r) : r(n.CryptoJS);
	})(e, function(e) {
		e.lib.Cipher || function(t) {
			var n = e, r = n.lib, i = r.Base, a = r.WordArray, o = r.BufferedBlockAlgorithm, s = n.enc;
			s.Utf8;
			var c = s.Base64, l = n.algo.EvpKDF, u = r.Cipher = o.extend({
				cfg: i.extend(),
				createEncryptor: function(e, t) {
					return this.create(this._ENC_XFORM_MODE, e, t);
				},
				createDecryptor: function(e, t) {
					return this.create(this._DEC_XFORM_MODE, e, t);
				},
				init: function(e, t, n) {
					this.cfg = this.cfg.extend(n), this._xformMode = e, this._key = t, this.reset();
				},
				reset: function() {
					o.reset.call(this), this._doReset();
				},
				process: function(e) {
					return this._append(e), this._process();
				},
				finalize: function(e) {
					return e && this._append(e), this._doFinalize();
				},
				keySize: 128 / 32,
				ivSize: 128 / 32,
				_ENC_XFORM_MODE: 1,
				_DEC_XFORM_MODE: 2,
				_createHelper: function() {
					function e(e) {
						return typeof e == "string" ? S : y;
					}
					return function(t) {
						return {
							encrypt: function(n, r, i) {
								return e(r).encrypt(t, n, r, i);
							},
							decrypt: function(n, r, i) {
								return e(r).decrypt(t, n, r, i);
							}
						};
					};
				}()
			});
			r.StreamCipher = u.extend({
				_doFinalize: function() {
					return this._process(!0);
				},
				blockSize: 1
			});
			var d = n.mode = {}, f = r.BlockCipherMode = i.extend({
				createEncryptor: function(e, t) {
					return this.Encryptor.create(e, t);
				},
				createDecryptor: function(e, t) {
					return this.Decryptor.create(e, t);
				},
				init: function(e, t) {
					this._cipher = e, this._iv = t;
				}
			}), p = d.CBC = function() {
				var e = f.extend();
				e.Encryptor = e.extend({ processBlock: function(e, t) {
					var r = this._cipher, i = r.blockSize;
					n.call(this, e, t, i), r.encryptBlock(e, t), this._prevBlock = e.slice(t, t + i);
				} }), e.Decryptor = e.extend({ processBlock: function(e, t) {
					var r = this._cipher, i = r.blockSize, a = e.slice(t, t + i);
					r.decryptBlock(e, t), n.call(this, e, t, i), this._prevBlock = a;
				} });
				function n(e, n, r) {
					var i, a = this._iv;
					a ? (i = a, this._iv = t) : i = this._prevBlock;
					for (var o = 0; o < r; o++) e[n + o] ^= i[o];
				}
				return e;
			}(), m = n.pad = {}, h = m.Pkcs7 = {
				pad: function(e, t) {
					for (var n = t * 4, r = n - e.sigBytes % n, i = r << 24 | r << 16 | r << 8 | r, o = [], s = 0; s < r; s += 4) o.push(i);
					var c = a.create(o, r);
					e.concat(c);
				},
				unpad: function(e) {
					var t = e.words[e.sigBytes - 1 >>> 2] & 255;
					e.sigBytes -= t;
				}
			};
			r.BlockCipher = u.extend({
				cfg: u.cfg.extend({
					mode: p,
					padding: h
				}),
				reset: function() {
					var e;
					u.reset.call(this);
					var t = this.cfg, n = t.iv, r = t.mode;
					this._xformMode == this._ENC_XFORM_MODE ? e = r.createEncryptor : (e = r.createDecryptor, this._minBufferSize = 1), this._mode && this._mode.__creator == e ? this._mode.init(this, n && n.words) : (this._mode = e.call(r, this, n && n.words), this._mode.__creator = e);
				},
				_doProcessBlock: function(e, t) {
					this._mode.processBlock(e, t);
				},
				_doFinalize: function() {
					var e, t = this.cfg.padding;
					return this._xformMode == this._ENC_XFORM_MODE ? (t.pad(this._data, this.blockSize), e = this._process(!0)) : (e = this._process(!0), t.unpad(e)), e;
				},
				blockSize: 128 / 32
			});
			var g = r.CipherParams = i.extend({
				init: function(e) {
					this.mixIn(e);
				},
				toString: function(e) {
					return (e || this.formatter).stringify(this);
				}
			}), _ = n.format = {}, v = _.OpenSSL = {
				stringify: function(e) {
					var t, n = e.ciphertext, r = e.salt;
					return t = r ? a.create([1398893684, 1701076831]).concat(r).concat(n) : n, t.toString(c);
				},
				parse: function(e) {
					var t, n = c.parse(e), r = n.words;
					return r[0] == 1398893684 && r[1] == 1701076831 && (t = a.create(r.slice(2, 4)), r.splice(0, 4), n.sigBytes -= 16), g.create({
						ciphertext: n,
						salt: t
					});
				}
			}, y = r.SerializableCipher = i.extend({
				cfg: i.extend({ format: v }),
				encrypt: function(e, t, n, r) {
					r = this.cfg.extend(r);
					var i = e.createEncryptor(n, r), a = i.finalize(t), o = i.cfg;
					return g.create({
						ciphertext: a,
						key: n,
						iv: o.iv,
						algorithm: e,
						mode: o.mode,
						padding: o.padding,
						blockSize: e.blockSize,
						formatter: r.format
					});
				},
				decrypt: function(e, t, n, r) {
					return r = this.cfg.extend(r), t = this._parse(t, r.format), e.createDecryptor(n, r).finalize(t.ciphertext);
				},
				_parse: function(e, t) {
					return typeof e == "string" ? t.parse(e, this) : e;
				}
			}), b = n.kdf = {}, x = b.OpenSSL = { execute: function(e, t, n, r, i) {
				if (r ||= a.random(64 / 8), i) var o = l.create({
					keySize: t + n,
					hasher: i
				}).compute(e, r);
				else var o = l.create({ keySize: t + n }).compute(e, r);
				var s = a.create(o.words.slice(t), n * 4);
				return o.sigBytes = t * 4, g.create({
					key: o,
					iv: s,
					salt: r
				});
			} }, S = r.PasswordBasedCipher = y.extend({
				cfg: y.cfg.extend({ kdf: x }),
				encrypt: function(e, t, n, r) {
					r = this.cfg.extend(r);
					var i = r.kdf.execute(n, e.keySize, e.ivSize, r.salt, r.hasher);
					r.iv = i.iv;
					var a = y.encrypt.call(this, e, t, i.key, r);
					return a.mixIn(i), a;
				},
				decrypt: function(e, t, n, r) {
					r = this.cfg.extend(r), t = this._parse(t, r.format);
					var i = r.kdf.execute(n, e.keySize, e.ivSize, t.salt, r.hasher);
					return r.iv = i.iv, y.decrypt.call(this, e, t, i.key, r);
				}
			});
		}();
	});
})), AR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r, i) {
		typeof e == "object" ? t.exports = e = r(ak(), kR()) : typeof define == "function" && define.amd ? define(["./core", "./cipher-core"], r) : r(n.CryptoJS);
	})(e, function(e) {
		return e.mode.CFB = function() {
			var t = e.lib.BlockCipherMode.extend();
			t.Encryptor = t.extend({ processBlock: function(e, t) {
				var r = this._cipher, i = r.blockSize;
				n.call(this, e, t, i, r), this._prevBlock = e.slice(t, t + i);
			} }), t.Decryptor = t.extend({ processBlock: function(e, t) {
				var r = this._cipher, i = r.blockSize, a = e.slice(t, t + i);
				n.call(this, e, t, i, r), this._prevBlock = a;
			} });
			function n(e, t, n, r) {
				var i, a = this._iv;
				a ? (i = a.slice(0), this._iv = void 0) : i = this._prevBlock, r.encryptBlock(i, 0);
				for (var o = 0; o < n; o++) e[t + o] ^= i[o];
			}
			return t;
		}(), e.mode.CFB;
	});
})), jR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r, i) {
		typeof e == "object" ? t.exports = e = r(ak(), kR()) : typeof define == "function" && define.amd ? define(["./core", "./cipher-core"], r) : r(n.CryptoJS);
	})(e, function(e) {
		return e.mode.CTR = function() {
			var t = e.lib.BlockCipherMode.extend();
			return t.Decryptor = t.Encryptor = t.extend({ processBlock: function(e, t) {
				var n = this._cipher, r = n.blockSize, i = this._iv, a = this._counter;
				i && (a = this._counter = i.slice(0), this._iv = void 0);
				var o = a.slice(0);
				n.encryptBlock(o, 0), a[r - 1] = a[r - 1] + 1 | 0;
				for (var s = 0; s < r; s++) e[t + s] ^= o[s];
			} }), t;
		}(), e.mode.CTR;
	});
})), MR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r, i) {
		typeof e == "object" ? t.exports = e = r(ak(), kR()) : typeof define == "function" && define.amd ? define(["./core", "./cipher-core"], r) : r(n.CryptoJS);
	})(e, function(e) {
		return e.mode.CTRGladman = function() {
			var t = e.lib.BlockCipherMode.extend();
			function n(e) {
				if ((e >> 24 & 255) == 255) {
					var t = e >> 16 & 255, n = e >> 8 & 255, r = e & 255;
					t === 255 ? (t = 0, n === 255 ? (n = 0, r === 255 ? r = 0 : ++r) : ++n) : ++t, e = 0, e += t << 16, e += n << 8, e += r;
				} else e += 1 << 24;
				return e;
			}
			function r(e) {
				return (e[0] = n(e[0])) === 0 && (e[1] = n(e[1])), e;
			}
			return t.Decryptor = t.Encryptor = t.extend({ processBlock: function(e, t) {
				var n = this._cipher, i = n.blockSize, a = this._iv, o = this._counter;
				a && (o = this._counter = a.slice(0), this._iv = void 0), r(o);
				var s = o.slice(0);
				n.encryptBlock(s, 0);
				for (var c = 0; c < i; c++) e[t + c] ^= s[c];
			} }), t;
		}(), e.mode.CTRGladman;
	});
})), NR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r, i) {
		typeof e == "object" ? t.exports = e = r(ak(), kR()) : typeof define == "function" && define.amd ? define(["./core", "./cipher-core"], r) : r(n.CryptoJS);
	})(e, function(e) {
		return e.mode.OFB = function() {
			var t = e.lib.BlockCipherMode.extend();
			return t.Decryptor = t.Encryptor = t.extend({ processBlock: function(e, t) {
				var n = this._cipher, r = n.blockSize, i = this._iv, a = this._keystream;
				i && (a = this._keystream = i.slice(0), this._iv = void 0), n.encryptBlock(a, 0);
				for (var o = 0; o < r; o++) e[t + o] ^= a[o];
			} }), t;
		}(), e.mode.OFB;
	});
})), PR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r, i) {
		typeof e == "object" ? t.exports = e = r(ak(), kR()) : typeof define == "function" && define.amd ? define(["./core", "./cipher-core"], r) : r(n.CryptoJS);
	})(e, function(e) {
		return e.mode.ECB = function() {
			var t = e.lib.BlockCipherMode.extend();
			return t.Encryptor = t.extend({ processBlock: function(e, t) {
				this._cipher.encryptBlock(e, t);
			} }), t.Decryptor = t.extend({ processBlock: function(e, t) {
				this._cipher.decryptBlock(e, t);
			} }), t;
		}(), e.mode.ECB;
	});
})), FR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r, i) {
		typeof e == "object" ? t.exports = e = r(ak(), kR()) : typeof define == "function" && define.amd ? define(["./core", "./cipher-core"], r) : r(n.CryptoJS);
	})(e, function(e) {
		return e.pad.AnsiX923 = {
			pad: function(e, t) {
				var n = e.sigBytes, r = t * 4, i = r - n % r, a = n + i - 1;
				e.clamp(), e.words[a >>> 2] |= i << 24 - a % 4 * 8, e.sigBytes += i;
			},
			unpad: function(e) {
				var t = e.words[e.sigBytes - 1 >>> 2] & 255;
				e.sigBytes -= t;
			}
		}, e.pad.Ansix923;
	});
})), IR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r, i) {
		typeof e == "object" ? t.exports = e = r(ak(), kR()) : typeof define == "function" && define.amd ? define(["./core", "./cipher-core"], r) : r(n.CryptoJS);
	})(e, function(e) {
		return e.pad.Iso10126 = {
			pad: function(t, n) {
				var r = n * 4, i = r - t.sigBytes % r;
				t.concat(e.lib.WordArray.random(i - 1)).concat(e.lib.WordArray.create([i << 24], 1));
			},
			unpad: function(e) {
				var t = e.words[e.sigBytes - 1 >>> 2] & 255;
				e.sigBytes -= t;
			}
		}, e.pad.Iso10126;
	});
})), LR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r, i) {
		typeof e == "object" ? t.exports = e = r(ak(), kR()) : typeof define == "function" && define.amd ? define(["./core", "./cipher-core"], r) : r(n.CryptoJS);
	})(e, function(e) {
		return e.pad.Iso97971 = {
			pad: function(t, n) {
				t.concat(e.lib.WordArray.create([2147483648], 1)), e.pad.ZeroPadding.pad(t, n);
			},
			unpad: function(t) {
				e.pad.ZeroPadding.unpad(t), t.sigBytes--;
			}
		}, e.pad.Iso97971;
	});
})), RR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r, i) {
		typeof e == "object" ? t.exports = e = r(ak(), kR()) : typeof define == "function" && define.amd ? define(["./core", "./cipher-core"], r) : r(n.CryptoJS);
	})(e, function(e) {
		return e.pad.ZeroPadding = {
			pad: function(e, t) {
				var n = t * 4;
				e.clamp(), e.sigBytes += n - (e.sigBytes % n || n);
			},
			unpad: function(e) {
				for (var t = e.words, n = e.sigBytes - 1, n = e.sigBytes - 1; n >= 0; n--) if (t[n >>> 2] >>> 24 - n % 4 * 8 & 255) {
					e.sigBytes = n + 1;
					break;
				}
			}
		}, e.pad.ZeroPadding;
	});
})), zR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r, i) {
		typeof e == "object" ? t.exports = e = r(ak(), kR()) : typeof define == "function" && define.amd ? define(["./core", "./cipher-core"], r) : r(n.CryptoJS);
	})(e, function(e) {
		return e.pad.NoPadding = {
			pad: function() {},
			unpad: function() {}
		}, e.pad.NoPadding;
	});
})), BR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r, i) {
		typeof e == "object" ? t.exports = e = r(ak(), kR()) : typeof define == "function" && define.amd ? define(["./core", "./cipher-core"], r) : r(n.CryptoJS);
	})(e, function(e) {
		return (function(t) {
			var n = e, r = n.lib.CipherParams, i = n.enc.Hex, a = n.format;
			a.Hex = {
				stringify: function(e) {
					return e.ciphertext.toString(i);
				},
				parse: function(e) {
					var t = i.parse(e);
					return r.create({ ciphertext: t });
				}
			};
		})(), e.format.Hex;
	});
})), VR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r, i) {
		typeof e == "object" ? t.exports = e = r(ak(), _R(), ok(), OR(), kR()) : typeof define == "function" && define.amd ? define([
			"./core",
			"./enc-base64",
			"./md5",
			"./evpkdf",
			"./cipher-core"
		], r) : r(n.CryptoJS);
	})(e, function(e) {
		return (function() {
			var t = e, n = t.lib.BlockCipher, r = t.algo, i = [], a = [], o = [], s = [], c = [], l = [], u = [], d = [], f = [], p = [];
			(function() {
				for (var e = [], t = 0; t < 256; t++) t < 128 ? e[t] = t << 1 : e[t] = t << 1 ^ 283;
				for (var n = 0, r = 0, t = 0; t < 256; t++) {
					var m = r ^ r << 1 ^ r << 2 ^ r << 3 ^ r << 4;
					m = m >>> 8 ^ m & 255 ^ 99, i[n] = m, a[m] = n;
					var h = e[n], g = e[h], _ = e[g], v = e[m] * 257 ^ m * 16843008;
					o[n] = v << 24 | v >>> 8, s[n] = v << 16 | v >>> 16, c[n] = v << 8 | v >>> 24, l[n] = v;
					var v = _ * 16843009 ^ g * 65537 ^ h * 257 ^ n * 16843008;
					u[m] = v << 24 | v >>> 8, d[m] = v << 16 | v >>> 16, f[m] = v << 8 | v >>> 24, p[m] = v, n ? (n = h ^ e[e[e[_ ^ h]]], r ^= e[e[r]]) : n = r = 1;
				}
			})();
			var m = [
				0,
				1,
				2,
				4,
				8,
				16,
				32,
				64,
				128,
				27,
				54
			], h = r.AES = n.extend({
				_doReset: function() {
					var e;
					if (!(this._nRounds && this._keyPriorReset === this._key)) {
						for (var t = this._keyPriorReset = this._key, n = t.words, r = t.sigBytes / 4, a = ((this._nRounds = r + 6) + 1) * 4, o = this._keySchedule = [], s = 0; s < a; s++) s < r ? o[s] = n[s] : (e = o[s - 1], s % r ? r > 6 && s % r == 4 && (e = i[e >>> 24] << 24 | i[e >>> 16 & 255] << 16 | i[e >>> 8 & 255] << 8 | i[e & 255]) : (e = e << 8 | e >>> 24, e = i[e >>> 24] << 24 | i[e >>> 16 & 255] << 16 | i[e >>> 8 & 255] << 8 | i[e & 255], e ^= m[s / r | 0] << 24), o[s] = o[s - r] ^ e);
						for (var c = this._invKeySchedule = [], l = 0; l < a; l++) {
							var s = a - l;
							if (l % 4) var e = o[s];
							else var e = o[s - 4];
							l < 4 || s <= 4 ? c[l] = e : c[l] = u[i[e >>> 24]] ^ d[i[e >>> 16 & 255]] ^ f[i[e >>> 8 & 255]] ^ p[i[e & 255]];
						}
					}
				},
				encryptBlock: function(e, t) {
					this._doCryptBlock(e, t, this._keySchedule, o, s, c, l, i);
				},
				decryptBlock: function(e, t) {
					var n = e[t + 1];
					e[t + 1] = e[t + 3], e[t + 3] = n, this._doCryptBlock(e, t, this._invKeySchedule, u, d, f, p, a);
					var n = e[t + 1];
					e[t + 1] = e[t + 3], e[t + 3] = n;
				},
				_doCryptBlock: function(e, t, n, r, i, a, o, s) {
					for (var c = this._nRounds, l = e[t] ^ n[0], u = e[t + 1] ^ n[1], d = e[t + 2] ^ n[2], f = e[t + 3] ^ n[3], p = 4, m = 1; m < c; m++) {
						var h = r[l >>> 24] ^ i[u >>> 16 & 255] ^ a[d >>> 8 & 255] ^ o[f & 255] ^ n[p++], g = r[u >>> 24] ^ i[d >>> 16 & 255] ^ a[f >>> 8 & 255] ^ o[l & 255] ^ n[p++], _ = r[d >>> 24] ^ i[f >>> 16 & 255] ^ a[l >>> 8 & 255] ^ o[u & 255] ^ n[p++], v = r[f >>> 24] ^ i[l >>> 16 & 255] ^ a[u >>> 8 & 255] ^ o[d & 255] ^ n[p++];
						l = h, u = g, d = _, f = v;
					}
					var h = (s[l >>> 24] << 24 | s[u >>> 16 & 255] << 16 | s[d >>> 8 & 255] << 8 | s[f & 255]) ^ n[p++], g = (s[u >>> 24] << 24 | s[d >>> 16 & 255] << 16 | s[f >>> 8 & 255] << 8 | s[l & 255]) ^ n[p++], _ = (s[d >>> 24] << 24 | s[f >>> 16 & 255] << 16 | s[l >>> 8 & 255] << 8 | s[u & 255]) ^ n[p++], v = (s[f >>> 24] << 24 | s[l >>> 16 & 255] << 16 | s[u >>> 8 & 255] << 8 | s[d & 255]) ^ n[p++];
					e[t] = h, e[t + 1] = g, e[t + 2] = _, e[t + 3] = v;
				},
				keySize: 256 / 32
			});
			t.AES = n._createHelper(h);
		})(), e.AES;
	});
})), HR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r, i) {
		typeof e == "object" ? t.exports = e = r(ak(), _R(), ok(), OR(), kR()) : typeof define == "function" && define.amd ? define([
			"./core",
			"./enc-base64",
			"./md5",
			"./evpkdf",
			"./cipher-core"
		], r) : r(n.CryptoJS);
	})(e, function(e) {
		return (function() {
			var t = e, n = t.lib, r = n.WordArray, i = n.BlockCipher, a = t.algo, o = [
				57,
				49,
				41,
				33,
				25,
				17,
				9,
				1,
				58,
				50,
				42,
				34,
				26,
				18,
				10,
				2,
				59,
				51,
				43,
				35,
				27,
				19,
				11,
				3,
				60,
				52,
				44,
				36,
				63,
				55,
				47,
				39,
				31,
				23,
				15,
				7,
				62,
				54,
				46,
				38,
				30,
				22,
				14,
				6,
				61,
				53,
				45,
				37,
				29,
				21,
				13,
				5,
				28,
				20,
				12,
				4
			], s = [
				14,
				17,
				11,
				24,
				1,
				5,
				3,
				28,
				15,
				6,
				21,
				10,
				23,
				19,
				12,
				4,
				26,
				8,
				16,
				7,
				27,
				20,
				13,
				2,
				41,
				52,
				31,
				37,
				47,
				55,
				30,
				40,
				51,
				45,
				33,
				48,
				44,
				49,
				39,
				56,
				34,
				53,
				46,
				42,
				50,
				36,
				29,
				32
			], c = [
				1,
				2,
				4,
				6,
				8,
				10,
				12,
				14,
				15,
				17,
				19,
				21,
				23,
				25,
				27,
				28
			], l = [
				{
					0: 8421888,
					268435456: 32768,
					536870912: 8421378,
					805306368: 2,
					1073741824: 512,
					1342177280: 8421890,
					1610612736: 8389122,
					1879048192: 8388608,
					2147483648: 514,
					2415919104: 8389120,
					2684354560: 33280,
					2952790016: 8421376,
					3221225472: 32770,
					3489660928: 8388610,
					3758096384: 0,
					4026531840: 33282,
					134217728: 0,
					402653184: 8421890,
					671088640: 33282,
					939524096: 32768,
					1207959552: 8421888,
					1476395008: 512,
					1744830464: 8421378,
					2013265920: 2,
					2281701376: 8389120,
					2550136832: 33280,
					2818572288: 8421376,
					3087007744: 8389122,
					3355443200: 8388610,
					3623878656: 32770,
					3892314112: 514,
					4160749568: 8388608,
					1: 32768,
					268435457: 2,
					536870913: 8421888,
					805306369: 8388608,
					1073741825: 8421378,
					1342177281: 33280,
					1610612737: 512,
					1879048193: 8389122,
					2147483649: 8421890,
					2415919105: 8421376,
					2684354561: 8388610,
					2952790017: 33282,
					3221225473: 514,
					3489660929: 8389120,
					3758096385: 32770,
					4026531841: 0,
					134217729: 8421890,
					402653185: 8421376,
					671088641: 8388608,
					939524097: 512,
					1207959553: 32768,
					1476395009: 8388610,
					1744830465: 2,
					2013265921: 33282,
					2281701377: 32770,
					2550136833: 8389122,
					2818572289: 514,
					3087007745: 8421888,
					3355443201: 8389120,
					3623878657: 0,
					3892314113: 33280,
					4160749569: 8421378
				},
				{
					0: 1074282512,
					16777216: 16384,
					33554432: 524288,
					50331648: 1074266128,
					67108864: 1073741840,
					83886080: 1074282496,
					100663296: 1073758208,
					117440512: 16,
					134217728: 540672,
					150994944: 1073758224,
					167772160: 1073741824,
					184549376: 540688,
					201326592: 524304,
					218103808: 0,
					234881024: 16400,
					251658240: 1074266112,
					8388608: 1073758208,
					25165824: 540688,
					41943040: 16,
					58720256: 1073758224,
					75497472: 1074282512,
					92274688: 1073741824,
					109051904: 524288,
					125829120: 1074266128,
					142606336: 524304,
					159383552: 0,
					176160768: 16384,
					192937984: 1074266112,
					209715200: 1073741840,
					226492416: 540672,
					243269632: 1074282496,
					260046848: 16400,
					268435456: 0,
					285212672: 1074266128,
					301989888: 1073758224,
					318767104: 1074282496,
					335544320: 1074266112,
					352321536: 16,
					369098752: 540688,
					385875968: 16384,
					402653184: 16400,
					419430400: 524288,
					436207616: 524304,
					452984832: 1073741840,
					469762048: 540672,
					486539264: 1073758208,
					503316480: 1073741824,
					520093696: 1074282512,
					276824064: 540688,
					293601280: 524288,
					310378496: 1074266112,
					327155712: 16384,
					343932928: 1073758208,
					360710144: 1074282512,
					377487360: 16,
					394264576: 1073741824,
					411041792: 1074282496,
					427819008: 1073741840,
					444596224: 1073758224,
					461373440: 524304,
					478150656: 0,
					494927872: 16400,
					511705088: 1074266128,
					528482304: 540672
				},
				{
					0: 260,
					1048576: 0,
					2097152: 67109120,
					3145728: 65796,
					4194304: 65540,
					5242880: 67108868,
					6291456: 67174660,
					7340032: 67174400,
					8388608: 67108864,
					9437184: 67174656,
					10485760: 65792,
					11534336: 67174404,
					12582912: 67109124,
					13631488: 65536,
					14680064: 4,
					15728640: 256,
					524288: 67174656,
					1572864: 67174404,
					2621440: 0,
					3670016: 67109120,
					4718592: 67108868,
					5767168: 65536,
					6815744: 65540,
					7864320: 260,
					8912896: 4,
					9961472: 256,
					11010048: 67174400,
					12058624: 65796,
					13107200: 65792,
					14155776: 67109124,
					15204352: 67174660,
					16252928: 67108864,
					16777216: 67174656,
					17825792: 65540,
					18874368: 65536,
					19922944: 67109120,
					20971520: 256,
					22020096: 67174660,
					23068672: 67108868,
					24117248: 0,
					25165824: 67109124,
					26214400: 67108864,
					27262976: 4,
					28311552: 65792,
					29360128: 67174400,
					30408704: 260,
					31457280: 65796,
					32505856: 67174404,
					17301504: 67108864,
					18350080: 260,
					19398656: 67174656,
					20447232: 0,
					21495808: 65540,
					22544384: 67109120,
					23592960: 256,
					24641536: 67174404,
					25690112: 65536,
					26738688: 67174660,
					27787264: 65796,
					28835840: 67108868,
					29884416: 67109124,
					30932992: 67174400,
					31981568: 4,
					33030144: 65792
				},
				{
					0: 2151682048,
					65536: 2147487808,
					131072: 4198464,
					196608: 2151677952,
					262144: 0,
					327680: 4198400,
					393216: 2147483712,
					458752: 4194368,
					524288: 2147483648,
					589824: 4194304,
					655360: 64,
					720896: 2147487744,
					786432: 2151678016,
					851968: 4160,
					917504: 4096,
					983040: 2151682112,
					32768: 2147487808,
					98304: 64,
					163840: 2151678016,
					229376: 2147487744,
					294912: 4198400,
					360448: 2151682112,
					425984: 0,
					491520: 2151677952,
					557056: 4096,
					622592: 2151682048,
					688128: 4194304,
					753664: 4160,
					819200: 2147483648,
					884736: 4194368,
					950272: 4198464,
					1015808: 2147483712,
					1048576: 4194368,
					1114112: 4198400,
					1179648: 2147483712,
					1245184: 0,
					1310720: 4160,
					1376256: 2151678016,
					1441792: 2151682048,
					1507328: 2147487808,
					1572864: 2151682112,
					1638400: 2147483648,
					1703936: 2151677952,
					1769472: 4198464,
					1835008: 2147487744,
					1900544: 4194304,
					1966080: 64,
					2031616: 4096,
					1081344: 2151677952,
					1146880: 2151682112,
					1212416: 0,
					1277952: 4198400,
					1343488: 4194368,
					1409024: 2147483648,
					1474560: 2147487808,
					1540096: 64,
					1605632: 2147483712,
					1671168: 4096,
					1736704: 2147487744,
					1802240: 2151678016,
					1867776: 4160,
					1933312: 2151682048,
					1998848: 4194304,
					2064384: 4198464
				},
				{
					0: 128,
					4096: 17039360,
					8192: 262144,
					12288: 536870912,
					16384: 537133184,
					20480: 16777344,
					24576: 553648256,
					28672: 262272,
					32768: 16777216,
					36864: 537133056,
					40960: 536871040,
					45056: 553910400,
					49152: 553910272,
					53248: 0,
					57344: 17039488,
					61440: 553648128,
					2048: 17039488,
					6144: 553648256,
					10240: 128,
					14336: 17039360,
					18432: 262144,
					22528: 537133184,
					26624: 553910272,
					30720: 536870912,
					34816: 537133056,
					38912: 0,
					43008: 553910400,
					47104: 16777344,
					51200: 536871040,
					55296: 553648128,
					59392: 16777216,
					63488: 262272,
					65536: 262144,
					69632: 128,
					73728: 536870912,
					77824: 553648256,
					81920: 16777344,
					86016: 553910272,
					90112: 537133184,
					94208: 16777216,
					98304: 553910400,
					102400: 553648128,
					106496: 17039360,
					110592: 537133056,
					114688: 262272,
					118784: 536871040,
					122880: 0,
					126976: 17039488,
					67584: 553648256,
					71680: 16777216,
					75776: 17039360,
					79872: 537133184,
					83968: 536870912,
					88064: 17039488,
					92160: 128,
					96256: 553910272,
					100352: 262272,
					104448: 553910400,
					108544: 0,
					112640: 553648128,
					116736: 16777344,
					120832: 262144,
					124928: 537133056,
					129024: 536871040
				},
				{
					0: 268435464,
					256: 8192,
					512: 270532608,
					768: 270540808,
					1024: 268443648,
					1280: 2097152,
					1536: 2097160,
					1792: 268435456,
					2048: 0,
					2304: 268443656,
					2560: 2105344,
					2816: 8,
					3072: 270532616,
					3328: 2105352,
					3584: 8200,
					3840: 270540800,
					128: 270532608,
					384: 270540808,
					640: 8,
					896: 2097152,
					1152: 2105352,
					1408: 268435464,
					1664: 268443648,
					1920: 8200,
					2176: 2097160,
					2432: 8192,
					2688: 268443656,
					2944: 270532616,
					3200: 0,
					3456: 270540800,
					3712: 2105344,
					3968: 268435456,
					4096: 268443648,
					4352: 270532616,
					4608: 270540808,
					4864: 8200,
					5120: 2097152,
					5376: 268435456,
					5632: 268435464,
					5888: 2105344,
					6144: 2105352,
					6400: 0,
					6656: 8,
					6912: 270532608,
					7168: 8192,
					7424: 268443656,
					7680: 270540800,
					7936: 2097160,
					4224: 8,
					4480: 2105344,
					4736: 2097152,
					4992: 268435464,
					5248: 268443648,
					5504: 8200,
					5760: 270540808,
					6016: 270532608,
					6272: 270540800,
					6528: 270532616,
					6784: 8192,
					7040: 2105352,
					7296: 2097160,
					7552: 0,
					7808: 268435456,
					8064: 268443656
				},
				{
					0: 1048576,
					16: 33555457,
					32: 1024,
					48: 1049601,
					64: 34604033,
					80: 0,
					96: 1,
					112: 34603009,
					128: 33555456,
					144: 1048577,
					160: 33554433,
					176: 34604032,
					192: 34603008,
					208: 1025,
					224: 1049600,
					240: 33554432,
					8: 34603009,
					24: 0,
					40: 33555457,
					56: 34604032,
					72: 1048576,
					88: 33554433,
					104: 33554432,
					120: 1025,
					136: 1049601,
					152: 33555456,
					168: 34603008,
					184: 1048577,
					200: 1024,
					216: 34604033,
					232: 1,
					248: 1049600,
					256: 33554432,
					272: 1048576,
					288: 33555457,
					304: 34603009,
					320: 1048577,
					336: 33555456,
					352: 34604032,
					368: 1049601,
					384: 1025,
					400: 34604033,
					416: 1049600,
					432: 1,
					448: 0,
					464: 34603008,
					480: 33554433,
					496: 1024,
					264: 1049600,
					280: 33555457,
					296: 34603009,
					312: 1,
					328: 33554432,
					344: 1048576,
					360: 1025,
					376: 34604032,
					392: 33554433,
					408: 34603008,
					424: 0,
					440: 34604033,
					456: 1049601,
					472: 1024,
					488: 33555456,
					504: 1048577
				},
				{
					0: 134219808,
					1: 131072,
					2: 134217728,
					3: 32,
					4: 131104,
					5: 134350880,
					6: 134350848,
					7: 2048,
					8: 134348800,
					9: 134219776,
					10: 133120,
					11: 134348832,
					12: 2080,
					13: 0,
					14: 134217760,
					15: 133152,
					2147483648: 2048,
					2147483649: 134350880,
					2147483650: 134219808,
					2147483651: 134217728,
					2147483652: 134348800,
					2147483653: 133120,
					2147483654: 133152,
					2147483655: 32,
					2147483656: 134217760,
					2147483657: 2080,
					2147483658: 131104,
					2147483659: 134350848,
					2147483660: 0,
					2147483661: 134348832,
					2147483662: 134219776,
					2147483663: 131072,
					16: 133152,
					17: 134350848,
					18: 32,
					19: 2048,
					20: 134219776,
					21: 134217760,
					22: 134348832,
					23: 131072,
					24: 0,
					25: 131104,
					26: 134348800,
					27: 134219808,
					28: 134350880,
					29: 133120,
					30: 2080,
					31: 134217728,
					2147483664: 131072,
					2147483665: 2048,
					2147483666: 134348832,
					2147483667: 133152,
					2147483668: 32,
					2147483669: 134348800,
					2147483670: 134217728,
					2147483671: 134219808,
					2147483672: 134350880,
					2147483673: 134217760,
					2147483674: 134219776,
					2147483675: 0,
					2147483676: 133120,
					2147483677: 2080,
					2147483678: 131104,
					2147483679: 134350848
				}
			], u = [
				4160749569,
				528482304,
				33030144,
				2064384,
				129024,
				8064,
				504,
				2147483679
			], d = a.DES = i.extend({
				_doReset: function() {
					for (var e = this._key.words, t = [], n = 0; n < 56; n++) {
						var r = o[n] - 1;
						t[n] = e[r >>> 5] >>> 31 - r % 32 & 1;
					}
					for (var i = this._subKeys = [], a = 0; a < 16; a++) {
						for (var l = i[a] = [], u = c[a], n = 0; n < 24; n++) l[n / 6 | 0] |= t[(s[n] - 1 + u) % 28] << 31 - n % 6, l[4 + (n / 6 | 0)] |= t[28 + (s[n + 24] - 1 + u) % 28] << 31 - n % 6;
						l[0] = l[0] << 1 | l[0] >>> 31;
						for (var n = 1; n < 7; n++) l[n] = l[n] >>> (n - 1) * 4 + 3;
						l[7] = l[7] << 5 | l[7] >>> 27;
					}
					for (var d = this._invSubKeys = [], n = 0; n < 16; n++) d[n] = i[15 - n];
				},
				encryptBlock: function(e, t) {
					this._doCryptBlock(e, t, this._subKeys);
				},
				decryptBlock: function(e, t) {
					this._doCryptBlock(e, t, this._invSubKeys);
				},
				_doCryptBlock: function(e, t, n) {
					this._lBlock = e[t], this._rBlock = e[t + 1], f.call(this, 4, 252645135), f.call(this, 16, 65535), p.call(this, 2, 858993459), p.call(this, 8, 16711935), f.call(this, 1, 1431655765);
					for (var r = 0; r < 16; r++) {
						for (var i = n[r], a = this._lBlock, o = this._rBlock, s = 0, c = 0; c < 8; c++) s |= l[c][((o ^ i[c]) & u[c]) >>> 0];
						this._lBlock = o, this._rBlock = a ^ s;
					}
					var d = this._lBlock;
					this._lBlock = this._rBlock, this._rBlock = d, f.call(this, 1, 1431655765), p.call(this, 8, 16711935), p.call(this, 2, 858993459), f.call(this, 16, 65535), f.call(this, 4, 252645135), e[t] = this._lBlock, e[t + 1] = this._rBlock;
				},
				keySize: 64 / 32,
				ivSize: 64 / 32,
				blockSize: 64 / 32
			});
			function f(e, t) {
				var n = (this._lBlock >>> e ^ this._rBlock) & t;
				this._rBlock ^= n, this._lBlock ^= n << e;
			}
			function p(e, t) {
				var n = (this._rBlock >>> e ^ this._lBlock) & t;
				this._lBlock ^= n, this._rBlock ^= n << e;
			}
			t.DES = i._createHelper(d);
			var m = a.TripleDES = i.extend({
				_doReset: function() {
					var e = this._key.words;
					if (e.length !== 2 && e.length !== 4 && e.length < 6) throw Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");
					var t = e.slice(0, 2), n = e.length < 4 ? e.slice(0, 2) : e.slice(2, 4), i = e.length < 6 ? e.slice(0, 2) : e.slice(4, 6);
					this._des1 = d.createEncryptor(r.create(t)), this._des2 = d.createEncryptor(r.create(n)), this._des3 = d.createEncryptor(r.create(i));
				},
				encryptBlock: function(e, t) {
					this._des1.encryptBlock(e, t), this._des2.decryptBlock(e, t), this._des3.encryptBlock(e, t);
				},
				decryptBlock: function(e, t) {
					this._des3.decryptBlock(e, t), this._des2.encryptBlock(e, t), this._des1.decryptBlock(e, t);
				},
				keySize: 192 / 32,
				ivSize: 64 / 32,
				blockSize: 64 / 32
			});
			t.TripleDES = i._createHelper(m);
		})(), e.TripleDES;
	});
})), UR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r, i) {
		typeof e == "object" ? t.exports = e = r(ak(), _R(), ok(), OR(), kR()) : typeof define == "function" && define.amd ? define([
			"./core",
			"./enc-base64",
			"./md5",
			"./evpkdf",
			"./cipher-core"
		], r) : r(n.CryptoJS);
	})(e, function(e) {
		return (function() {
			var t = e, n = t.lib.StreamCipher, r = t.algo, i = r.RC4 = n.extend({
				_doReset: function() {
					for (var e = this._key, t = e.words, n = e.sigBytes, r = this._S = [], i = 0; i < 256; i++) r[i] = i;
					for (var i = 0, a = 0; i < 256; i++) {
						var o = i % n, s = t[o >>> 2] >>> 24 - o % 4 * 8 & 255;
						a = (a + r[i] + s) % 256;
						var c = r[i];
						r[i] = r[a], r[a] = c;
					}
					this._i = this._j = 0;
				},
				_doProcessBlock: function(e, t) {
					e[t] ^= a.call(this);
				},
				keySize: 256 / 32,
				ivSize: 0
			});
			function a() {
				for (var e = this._S, t = this._i, n = this._j, r = 0, i = 0; i < 4; i++) {
					t = (t + 1) % 256, n = (n + e[t]) % 256;
					var a = e[t];
					e[t] = e[n], e[n] = a, r |= e[(e[t] + e[n]) % 256] << 24 - i * 8;
				}
				return this._i = t, this._j = n, r;
			}
			t.RC4 = n._createHelper(i);
			var o = r.RC4Drop = i.extend({
				cfg: i.cfg.extend({ drop: 192 }),
				_doReset: function() {
					i._doReset.call(this);
					for (var e = this.cfg.drop; e > 0; e--) a.call(this);
				}
			});
			t.RC4Drop = n._createHelper(o);
		})(), e.RC4;
	});
})), WR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r, i) {
		typeof e == "object" ? t.exports = e = r(ak(), _R(), ok(), OR(), kR()) : typeof define == "function" && define.amd ? define([
			"./core",
			"./enc-base64",
			"./md5",
			"./evpkdf",
			"./cipher-core"
		], r) : r(n.CryptoJS);
	})(e, function(e) {
		return (function() {
			var t = e, n = t.lib.StreamCipher, r = t.algo, i = [], a = [], o = [], s = r.Rabbit = n.extend({
				_doReset: function() {
					for (var e = this._key.words, t = this.cfg.iv, n = 0; n < 4; n++) e[n] = (e[n] << 8 | e[n] >>> 24) & 16711935 | (e[n] << 24 | e[n] >>> 8) & 4278255360;
					var r = this._X = [
						e[0],
						e[3] << 16 | e[2] >>> 16,
						e[1],
						e[0] << 16 | e[3] >>> 16,
						e[2],
						e[1] << 16 | e[0] >>> 16,
						e[3],
						e[2] << 16 | e[1] >>> 16
					], i = this._C = [
						e[2] << 16 | e[2] >>> 16,
						e[0] & 4294901760 | e[1] & 65535,
						e[3] << 16 | e[3] >>> 16,
						e[1] & 4294901760 | e[2] & 65535,
						e[0] << 16 | e[0] >>> 16,
						e[2] & 4294901760 | e[3] & 65535,
						e[1] << 16 | e[1] >>> 16,
						e[3] & 4294901760 | e[0] & 65535
					];
					this._b = 0;
					for (var n = 0; n < 4; n++) c.call(this);
					for (var n = 0; n < 8; n++) i[n] ^= r[n + 4 & 7];
					if (t) {
						var a = t.words, o = a[0], s = a[1], l = (o << 8 | o >>> 24) & 16711935 | (o << 24 | o >>> 8) & 4278255360, u = (s << 8 | s >>> 24) & 16711935 | (s << 24 | s >>> 8) & 4278255360, d = l >>> 16 | u & 4294901760, f = u << 16 | l & 65535;
						i[0] ^= l, i[1] ^= d, i[2] ^= u, i[3] ^= f, i[4] ^= l, i[5] ^= d, i[6] ^= u, i[7] ^= f;
						for (var n = 0; n < 4; n++) c.call(this);
					}
				},
				_doProcessBlock: function(e, t) {
					var n = this._X;
					c.call(this), i[0] = n[0] ^ n[5] >>> 16 ^ n[3] << 16, i[1] = n[2] ^ n[7] >>> 16 ^ n[5] << 16, i[2] = n[4] ^ n[1] >>> 16 ^ n[7] << 16, i[3] = n[6] ^ n[3] >>> 16 ^ n[1] << 16;
					for (var r = 0; r < 4; r++) i[r] = (i[r] << 8 | i[r] >>> 24) & 16711935 | (i[r] << 24 | i[r] >>> 8) & 4278255360, e[t + r] ^= i[r];
				},
				blockSize: 128 / 32,
				ivSize: 64 / 32
			});
			function c() {
				for (var e = this._X, t = this._C, n = 0; n < 8; n++) a[n] = t[n];
				t[0] = t[0] + 1295307597 + this._b | 0, t[1] = t[1] + 3545052371 + +(t[0] >>> 0 < a[0] >>> 0) | 0, t[2] = t[2] + 886263092 + +(t[1] >>> 0 < a[1] >>> 0) | 0, t[3] = t[3] + 1295307597 + +(t[2] >>> 0 < a[2] >>> 0) | 0, t[4] = t[4] + 3545052371 + +(t[3] >>> 0 < a[3] >>> 0) | 0, t[5] = t[5] + 886263092 + +(t[4] >>> 0 < a[4] >>> 0) | 0, t[6] = t[6] + 1295307597 + +(t[5] >>> 0 < a[5] >>> 0) | 0, t[7] = t[7] + 3545052371 + +(t[6] >>> 0 < a[6] >>> 0) | 0, this._b = +(t[7] >>> 0 < a[7] >>> 0);
				for (var n = 0; n < 8; n++) {
					var r = e[n] + t[n], i = r & 65535, s = r >>> 16;
					o[n] = ((i * i >>> 17) + i * s >>> 15) + s * s ^ ((r & 4294901760) * r | 0) + ((r & 65535) * r | 0);
				}
				e[0] = o[0] + (o[7] << 16 | o[7] >>> 16) + (o[6] << 16 | o[6] >>> 16) | 0, e[1] = o[1] + (o[0] << 8 | o[0] >>> 24) + o[7] | 0, e[2] = o[2] + (o[1] << 16 | o[1] >>> 16) + (o[0] << 16 | o[0] >>> 16) | 0, e[3] = o[3] + (o[2] << 8 | o[2] >>> 24) + o[1] | 0, e[4] = o[4] + (o[3] << 16 | o[3] >>> 16) + (o[2] << 16 | o[2] >>> 16) | 0, e[5] = o[5] + (o[4] << 8 | o[4] >>> 24) + o[3] | 0, e[6] = o[6] + (o[5] << 16 | o[5] >>> 16) + (o[4] << 16 | o[4] >>> 16) | 0, e[7] = o[7] + (o[6] << 8 | o[6] >>> 24) + o[5] | 0;
			}
			t.Rabbit = n._createHelper(s);
		})(), e.Rabbit;
	});
})), GR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r, i) {
		typeof e == "object" ? t.exports = e = r(ak(), _R(), ok(), OR(), kR()) : typeof define == "function" && define.amd ? define([
			"./core",
			"./enc-base64",
			"./md5",
			"./evpkdf",
			"./cipher-core"
		], r) : r(n.CryptoJS);
	})(e, function(e) {
		return (function() {
			var t = e, n = t.lib.StreamCipher, r = t.algo, i = [], a = [], o = [], s = r.RabbitLegacy = n.extend({
				_doReset: function() {
					var e = this._key.words, t = this.cfg.iv, n = this._X = [
						e[0],
						e[3] << 16 | e[2] >>> 16,
						e[1],
						e[0] << 16 | e[3] >>> 16,
						e[2],
						e[1] << 16 | e[0] >>> 16,
						e[3],
						e[2] << 16 | e[1] >>> 16
					], r = this._C = [
						e[2] << 16 | e[2] >>> 16,
						e[0] & 4294901760 | e[1] & 65535,
						e[3] << 16 | e[3] >>> 16,
						e[1] & 4294901760 | e[2] & 65535,
						e[0] << 16 | e[0] >>> 16,
						e[2] & 4294901760 | e[3] & 65535,
						e[1] << 16 | e[1] >>> 16,
						e[3] & 4294901760 | e[0] & 65535
					];
					this._b = 0;
					for (var i = 0; i < 4; i++) c.call(this);
					for (var i = 0; i < 8; i++) r[i] ^= n[i + 4 & 7];
					if (t) {
						var a = t.words, o = a[0], s = a[1], l = (o << 8 | o >>> 24) & 16711935 | (o << 24 | o >>> 8) & 4278255360, u = (s << 8 | s >>> 24) & 16711935 | (s << 24 | s >>> 8) & 4278255360, d = l >>> 16 | u & 4294901760, f = u << 16 | l & 65535;
						r[0] ^= l, r[1] ^= d, r[2] ^= u, r[3] ^= f, r[4] ^= l, r[5] ^= d, r[6] ^= u, r[7] ^= f;
						for (var i = 0; i < 4; i++) c.call(this);
					}
				},
				_doProcessBlock: function(e, t) {
					var n = this._X;
					c.call(this), i[0] = n[0] ^ n[5] >>> 16 ^ n[3] << 16, i[1] = n[2] ^ n[7] >>> 16 ^ n[5] << 16, i[2] = n[4] ^ n[1] >>> 16 ^ n[7] << 16, i[3] = n[6] ^ n[3] >>> 16 ^ n[1] << 16;
					for (var r = 0; r < 4; r++) i[r] = (i[r] << 8 | i[r] >>> 24) & 16711935 | (i[r] << 24 | i[r] >>> 8) & 4278255360, e[t + r] ^= i[r];
				},
				blockSize: 128 / 32,
				ivSize: 64 / 32
			});
			function c() {
				for (var e = this._X, t = this._C, n = 0; n < 8; n++) a[n] = t[n];
				t[0] = t[0] + 1295307597 + this._b | 0, t[1] = t[1] + 3545052371 + +(t[0] >>> 0 < a[0] >>> 0) | 0, t[2] = t[2] + 886263092 + +(t[1] >>> 0 < a[1] >>> 0) | 0, t[3] = t[3] + 1295307597 + +(t[2] >>> 0 < a[2] >>> 0) | 0, t[4] = t[4] + 3545052371 + +(t[3] >>> 0 < a[3] >>> 0) | 0, t[5] = t[5] + 886263092 + +(t[4] >>> 0 < a[4] >>> 0) | 0, t[6] = t[6] + 1295307597 + +(t[5] >>> 0 < a[5] >>> 0) | 0, t[7] = t[7] + 3545052371 + +(t[6] >>> 0 < a[6] >>> 0) | 0, this._b = +(t[7] >>> 0 < a[7] >>> 0);
				for (var n = 0; n < 8; n++) {
					var r = e[n] + t[n], i = r & 65535, s = r >>> 16;
					o[n] = ((i * i >>> 17) + i * s >>> 15) + s * s ^ ((r & 4294901760) * r | 0) + ((r & 65535) * r | 0);
				}
				e[0] = o[0] + (o[7] << 16 | o[7] >>> 16) + (o[6] << 16 | o[6] >>> 16) | 0, e[1] = o[1] + (o[0] << 8 | o[0] >>> 24) + o[7] | 0, e[2] = o[2] + (o[1] << 16 | o[1] >>> 16) + (o[0] << 16 | o[0] >>> 16) | 0, e[3] = o[3] + (o[2] << 8 | o[2] >>> 24) + o[1] | 0, e[4] = o[4] + (o[3] << 16 | o[3] >>> 16) + (o[2] << 16 | o[2] >>> 16) | 0, e[5] = o[5] + (o[4] << 8 | o[4] >>> 24) + o[3] | 0, e[6] = o[6] + (o[5] << 16 | o[5] >>> 16) + (o[4] << 16 | o[4] >>> 16) | 0, e[7] = o[7] + (o[6] << 8 | o[6] >>> 24) + o[5] | 0;
			}
			t.RabbitLegacy = n._createHelper(s);
		})(), e.RabbitLegacy;
	});
})), KR = /* @__PURE__ */ V(((e, t) => {
	(function(n, r, i) {
		typeof e == "object" ? t.exports = e = r(ak(), _R(), ok(), OR(), kR()) : typeof define == "function" && define.amd ? define([
			"./core",
			"./enc-base64",
			"./md5",
			"./evpkdf",
			"./cipher-core"
		], r) : r(n.CryptoJS);
	})(e, function(e) {
		return (function() {
			var t = e, n = t.lib.BlockCipher, r = t.algo;
			let i = [
				608135816,
				2242054355,
				320440878,
				57701188,
				2752067618,
				698298832,
				137296536,
				3964562569,
				1160258022,
				953160567,
				3193202383,
				887688300,
				3232508343,
				3380367581,
				1065670069,
				3041331479,
				2450970073,
				2306472731
			], a = [
				[
					3509652390,
					2564797868,
					805139163,
					3491422135,
					3101798381,
					1780907670,
					3128725573,
					4046225305,
					614570311,
					3012652279,
					134345442,
					2240740374,
					1667834072,
					1901547113,
					2757295779,
					4103290238,
					227898511,
					1921955416,
					1904987480,
					2182433518,
					2069144605,
					3260701109,
					2620446009,
					720527379,
					3318853667,
					677414384,
					3393288472,
					3101374703,
					2390351024,
					1614419982,
					1822297739,
					2954791486,
					3608508353,
					3174124327,
					2024746970,
					1432378464,
					3864339955,
					2857741204,
					1464375394,
					1676153920,
					1439316330,
					715854006,
					3033291828,
					289532110,
					2706671279,
					2087905683,
					3018724369,
					1668267050,
					732546397,
					1947742710,
					3462151702,
					2609353502,
					2950085171,
					1814351708,
					2050118529,
					680887927,
					999245976,
					1800124847,
					3300911131,
					1713906067,
					1641548236,
					4213287313,
					1216130144,
					1575780402,
					4018429277,
					3917837745,
					3693486850,
					3949271944,
					596196993,
					3549867205,
					258830323,
					2213823033,
					772490370,
					2760122372,
					1774776394,
					2652871518,
					566650946,
					4142492826,
					1728879713,
					2882767088,
					1783734482,
					3629395816,
					2517608232,
					2874225571,
					1861159788,
					326777828,
					3124490320,
					2130389656,
					2716951837,
					967770486,
					1724537150,
					2185432712,
					2364442137,
					1164943284,
					2105845187,
					998989502,
					3765401048,
					2244026483,
					1075463327,
					1455516326,
					1322494562,
					910128902,
					469688178,
					1117454909,
					936433444,
					3490320968,
					3675253459,
					1240580251,
					122909385,
					2157517691,
					634681816,
					4142456567,
					3825094682,
					3061402683,
					2540495037,
					79693498,
					3249098678,
					1084186820,
					1583128258,
					426386531,
					1761308591,
					1047286709,
					322548459,
					995290223,
					1845252383,
					2603652396,
					3431023940,
					2942221577,
					3202600964,
					3727903485,
					1712269319,
					422464435,
					3234572375,
					1170764815,
					3523960633,
					3117677531,
					1434042557,
					442511882,
					3600875718,
					1076654713,
					1738483198,
					4213154764,
					2393238008,
					3677496056,
					1014306527,
					4251020053,
					793779912,
					2902807211,
					842905082,
					4246964064,
					1395751752,
					1040244610,
					2656851899,
					3396308128,
					445077038,
					3742853595,
					3577915638,
					679411651,
					2892444358,
					2354009459,
					1767581616,
					3150600392,
					3791627101,
					3102740896,
					284835224,
					4246832056,
					1258075500,
					768725851,
					2589189241,
					3069724005,
					3532540348,
					1274779536,
					3789419226,
					2764799539,
					1660621633,
					3471099624,
					4011903706,
					913787905,
					3497959166,
					737222580,
					2514213453,
					2928710040,
					3937242737,
					1804850592,
					3499020752,
					2949064160,
					2386320175,
					2390070455,
					2415321851,
					4061277028,
					2290661394,
					2416832540,
					1336762016,
					1754252060,
					3520065937,
					3014181293,
					791618072,
					3188594551,
					3933548030,
					2332172193,
					3852520463,
					3043980520,
					413987798,
					3465142937,
					3030929376,
					4245938359,
					2093235073,
					3534596313,
					375366246,
					2157278981,
					2479649556,
					555357303,
					3870105701,
					2008414854,
					3344188149,
					4221384143,
					3956125452,
					2067696032,
					3594591187,
					2921233993,
					2428461,
					544322398,
					577241275,
					1471733935,
					610547355,
					4027169054,
					1432588573,
					1507829418,
					2025931657,
					3646575487,
					545086370,
					48609733,
					2200306550,
					1653985193,
					298326376,
					1316178497,
					3007786442,
					2064951626,
					458293330,
					2589141269,
					3591329599,
					3164325604,
					727753846,
					2179363840,
					146436021,
					1461446943,
					4069977195,
					705550613,
					3059967265,
					3887724982,
					4281599278,
					3313849956,
					1404054877,
					2845806497,
					146425753,
					1854211946
				],
				[
					1266315497,
					3048417604,
					3681880366,
					3289982499,
					290971e4,
					1235738493,
					2632868024,
					2414719590,
					3970600049,
					1771706367,
					1449415276,
					3266420449,
					422970021,
					1963543593,
					2690192192,
					3826793022,
					1062508698,
					1531092325,
					1804592342,
					2583117782,
					2714934279,
					4024971509,
					1294809318,
					4028980673,
					1289560198,
					2221992742,
					1669523910,
					35572830,
					157838143,
					1052438473,
					1016535060,
					1802137761,
					1753167236,
					1386275462,
					3080475397,
					2857371447,
					1040679964,
					2145300060,
					2390574316,
					1461121720,
					2956646967,
					4031777805,
					4028374788,
					33600511,
					2920084762,
					1018524850,
					629373528,
					3691585981,
					3515945977,
					2091462646,
					2486323059,
					586499841,
					988145025,
					935516892,
					3367335476,
					2599673255,
					2839830854,
					265290510,
					3972581182,
					2759138881,
					3795373465,
					1005194799,
					847297441,
					406762289,
					1314163512,
					1332590856,
					1866599683,
					4127851711,
					750260880,
					613907577,
					1450815602,
					3165620655,
					3734664991,
					3650291728,
					3012275730,
					3704569646,
					1427272223,
					778793252,
					1343938022,
					2676280711,
					2052605720,
					1946737175,
					3164576444,
					3914038668,
					3967478842,
					3682934266,
					1661551462,
					3294938066,
					4011595847,
					840292616,
					3712170807,
					616741398,
					312560963,
					711312465,
					1351876610,
					322626781,
					1910503582,
					271666773,
					2175563734,
					1594956187,
					70604529,
					3617834859,
					1007753275,
					1495573769,
					4069517037,
					2549218298,
					2663038764,
					504708206,
					2263041392,
					3941167025,
					2249088522,
					1514023603,
					1998579484,
					1312622330,
					694541497,
					2582060303,
					2151582166,
					1382467621,
					776784248,
					2618340202,
					3323268794,
					2497899128,
					2784771155,
					503983604,
					4076293799,
					907881277,
					423175695,
					432175456,
					1378068232,
					4145222326,
					3954048622,
					3938656102,
					3820766613,
					2793130115,
					2977904593,
					26017576,
					3274890735,
					3194772133,
					1700274565,
					1756076034,
					4006520079,
					3677328699,
					720338349,
					1533947780,
					354530856,
					688349552,
					3973924725,
					1637815568,
					332179504,
					3949051286,
					53804574,
					2852348879,
					3044236432,
					1282449977,
					3583942155,
					3416972820,
					4006381244,
					1617046695,
					2628476075,
					3002303598,
					1686838959,
					431878346,
					2686675385,
					1700445008,
					1080580658,
					1009431731,
					832498133,
					3223435511,
					2605976345,
					2271191193,
					2516031870,
					1648197032,
					4164389018,
					2548247927,
					300782431,
					375919233,
					238389289,
					3353747414,
					2531188641,
					2019080857,
					1475708069,
					455242339,
					2609103871,
					448939670,
					3451063019,
					1395535956,
					2413381860,
					1841049896,
					1491858159,
					885456874,
					4264095073,
					4001119347,
					1565136089,
					3898914787,
					1108368660,
					540939232,
					1173283510,
					2745871338,
					3681308437,
					4207628240,
					3343053890,
					4016749493,
					1699691293,
					1103962373,
					3625875870,
					2256883143,
					3830138730,
					1031889488,
					3479347698,
					1535977030,
					4236805024,
					3251091107,
					2132092099,
					1774941330,
					1199868427,
					1452454533,
					157007616,
					2904115357,
					342012276,
					595725824,
					1480756522,
					206960106,
					497939518,
					591360097,
					863170706,
					2375253569,
					3596610801,
					1814182875,
					2094937945,
					3421402208,
					1082520231,
					3463918190,
					2785509508,
					435703966,
					3908032597,
					1641649973,
					2842273706,
					3305899714,
					1510255612,
					2148256476,
					2655287854,
					3276092548,
					4258621189,
					236887753,
					3681803219,
					274041037,
					1734335097,
					3815195456,
					3317970021,
					1899903192,
					1026095262,
					4050517792,
					356393447,
					2410691914,
					3873677099,
					3682840055
				],
				[
					3913112168,
					2491498743,
					4132185628,
					2489919796,
					1091903735,
					1979897079,
					3170134830,
					3567386728,
					3557303409,
					857797738,
					1136121015,
					1342202287,
					507115054,
					2535736646,
					337727348,
					3213592640,
					1301675037,
					2528481711,
					1895095763,
					1721773893,
					3216771564,
					62756741,
					2142006736,
					835421444,
					2531993523,
					1442658625,
					3659876326,
					2882144922,
					676362277,
					1392781812,
					170690266,
					3921047035,
					1759253602,
					3611846912,
					1745797284,
					664899054,
					1329594018,
					3901205900,
					3045908486,
					2062866102,
					2865634940,
					3543621612,
					3464012697,
					1080764994,
					553557557,
					3656615353,
					3996768171,
					991055499,
					499776247,
					1265440854,
					648242737,
					3940784050,
					980351604,
					3713745714,
					1749149687,
					3396870395,
					4211799374,
					3640570775,
					1161844396,
					3125318951,
					1431517754,
					545492359,
					4268468663,
					3499529547,
					1437099964,
					2702547544,
					3433638243,
					2581715763,
					2787789398,
					1060185593,
					1593081372,
					2418618748,
					4260947970,
					69676912,
					2159744348,
					86519011,
					2512459080,
					3838209314,
					1220612927,
					3339683548,
					133810670,
					1090789135,
					1078426020,
					1569222167,
					845107691,
					3583754449,
					4072456591,
					1091646820,
					628848692,
					1613405280,
					3757631651,
					526609435,
					236106946,
					48312990,
					2942717905,
					3402727701,
					1797494240,
					859738849,
					992217954,
					4005476642,
					2243076622,
					3870952857,
					3732016268,
					765654824,
					3490871365,
					2511836413,
					1685915746,
					3888969200,
					1414112111,
					2273134842,
					3281911079,
					4080962846,
					172450625,
					2569994100,
					980381355,
					4109958455,
					2819808352,
					2716589560,
					2568741196,
					3681446669,
					3329971472,
					1835478071,
					660984891,
					3704678404,
					4045999559,
					3422617507,
					3040415634,
					1762651403,
					1719377915,
					3470491036,
					2693910283,
					3642056355,
					3138596744,
					1364962596,
					2073328063,
					1983633131,
					926494387,
					3423689081,
					2150032023,
					4096667949,
					1749200295,
					3328846651,
					309677260,
					2016342300,
					1779581495,
					3079819751,
					111262694,
					1274766160,
					443224088,
					298511866,
					1025883608,
					3806446537,
					1145181785,
					168956806,
					3641502830,
					3584813610,
					1689216846,
					3666258015,
					3200248200,
					1692713982,
					2646376535,
					4042768518,
					1618508792,
					1610833997,
					3523052358,
					4130873264,
					2001055236,
					3610705100,
					2202168115,
					4028541809,
					2961195399,
					1006657119,
					2006996926,
					3186142756,
					1430667929,
					3210227297,
					1314452623,
					4074634658,
					4101304120,
					2273951170,
					1399257539,
					3367210612,
					3027628629,
					1190975929,
					2062231137,
					2333990788,
					2221543033,
					2438960610,
					1181637006,
					548689776,
					2362791313,
					3372408396,
					3104550113,
					3145860560,
					296247880,
					1970579870,
					3078560182,
					3769228297,
					1714227617,
					3291629107,
					3898220290,
					166772364,
					1251581989,
					493813264,
					448347421,
					195405023,
					2709975567,
					677966185,
					3703036547,
					1463355134,
					2715995803,
					1338867538,
					1343315457,
					2802222074,
					2684532164,
					233230375,
					2599980071,
					2000651841,
					3277868038,
					1638401717,
					4028070440,
					3237316320,
					6314154,
					819756386,
					300326615,
					590932579,
					1405279636,
					3267499572,
					3150704214,
					2428286686,
					3959192993,
					3461946742,
					1862657033,
					1266418056,
					963775037,
					2089974820,
					2263052895,
					1917689273,
					448879540,
					3550394620,
					3981727096,
					150775221,
					3627908307,
					1303187396,
					508620638,
					2975983352,
					2726630617,
					1817252668,
					1876281319,
					1457606340,
					908771278,
					3720792119,
					3617206836,
					2455994898,
					1729034894,
					1080033504
				],
				[
					976866871,
					3556439503,
					2881648439,
					1522871579,
					1555064734,
					1336096578,
					3548522304,
					2579274686,
					3574697629,
					3205460757,
					3593280638,
					3338716283,
					3079412587,
					564236357,
					2993598910,
					1781952180,
					1464380207,
					3163844217,
					3332601554,
					1699332808,
					1393555694,
					1183702653,
					3581086237,
					1288719814,
					691649499,
					2847557200,
					2895455976,
					3193889540,
					2717570544,
					1781354906,
					1676643554,
					2592534050,
					3230253752,
					1126444790,
					2770207658,
					2633158820,
					2210423226,
					2615765581,
					2414155088,
					3127139286,
					673620729,
					2805611233,
					1269405062,
					4015350505,
					3341807571,
					4149409754,
					1057255273,
					2012875353,
					2162469141,
					2276492801,
					2601117357,
					993977747,
					3918593370,
					2654263191,
					753973209,
					36408145,
					2530585658,
					25011837,
					3520020182,
					2088578344,
					530523599,
					2918365339,
					1524020338,
					1518925132,
					3760827505,
					3759777254,
					1202760957,
					3985898139,
					3906192525,
					674977740,
					4174734889,
					2031300136,
					2019492241,
					3983892565,
					4153806404,
					3822280332,
					352677332,
					2297720250,
					60907813,
					90501309,
					3286998549,
					1016092578,
					2535922412,
					2839152426,
					457141659,
					509813237,
					4120667899,
					652014361,
					1966332200,
					2975202805,
					55981186,
					2327461051,
					676427537,
					3255491064,
					2882294119,
					3433927263,
					1307055953,
					942726286,
					933058658,
					2468411793,
					3933900994,
					4215176142,
					1361170020,
					2001714738,
					2830558078,
					3274259782,
					1222529897,
					1679025792,
					2729314320,
					3714953764,
					1770335741,
					151462246,
					3013232138,
					1682292957,
					1483529935,
					471910574,
					1539241949,
					458788160,
					3436315007,
					1807016891,
					3718408830,
					978976581,
					1043663428,
					3165965781,
					1927990952,
					4200891579,
					2372276910,
					3208408903,
					3533431907,
					1412390302,
					2931980059,
					4132332400,
					1947078029,
					3881505623,
					4168226417,
					2941484381,
					1077988104,
					1320477388,
					886195818,
					18198404,
					3786409e3,
					2509781533,
					112762804,
					3463356488,
					1866414978,
					891333506,
					18488651,
					661792760,
					1628790961,
					3885187036,
					3141171499,
					876946877,
					2693282273,
					1372485963,
					791857591,
					2686433993,
					3759982718,
					3167212022,
					3472953795,
					2716379847,
					445679433,
					3561995674,
					3504004811,
					3574258232,
					54117162,
					3331405415,
					2381918588,
					3769707343,
					4154350007,
					1140177722,
					4074052095,
					668550556,
					3214352940,
					367459370,
					261225585,
					2610173221,
					4209349473,
					3468074219,
					3265815641,
					314222801,
					3066103646,
					3808782860,
					282218597,
					3406013506,
					3773591054,
					379116347,
					1285071038,
					846784868,
					2669647154,
					3771962079,
					3550491691,
					2305946142,
					453669953,
					1268987020,
					3317592352,
					3279303384,
					3744833421,
					2610507566,
					3859509063,
					266596637,
					3847019092,
					517658769,
					3462560207,
					3443424879,
					370717030,
					4247526661,
					2224018117,
					4143653529,
					4112773975,
					2788324899,
					2477274417,
					1456262402,
					2901442914,
					1517677493,
					1846949527,
					2295493580,
					3734397586,
					2176403920,
					1280348187,
					1908823572,
					3871786941,
					846861322,
					1172426758,
					3287448474,
					3383383037,
					1655181056,
					3139813346,
					901632758,
					1897031941,
					2986607138,
					3066810236,
					3447102507,
					1393639104,
					373351379,
					950779232,
					625454576,
					3124240540,
					4148612726,
					2007998917,
					544563296,
					2244738638,
					2330496472,
					2058025392,
					1291430526,
					424198748,
					50039436,
					29584100,
					3605783033,
					2429876329,
					2791104160,
					1057563949,
					3255363231,
					3075367218,
					3463963227,
					1469046755,
					985887462
				]
			];
			var o = {
				pbox: [],
				sbox: []
			};
			function s(e, t) {
				let n = t >> 24 & 255, r = t >> 16 & 255, i = t >> 8 & 255, a = t & 255, o = e.sbox[0][n] + e.sbox[1][r];
				return o ^= e.sbox[2][i], o += e.sbox[3][a], o;
			}
			function c(e, t, n) {
				let r = t, i = n, a;
				for (let t = 0; t < 16; ++t) r ^= e.pbox[t], i = s(e, r) ^ i, a = r, r = i, i = a;
				return a = r, r = i, i = a, i ^= e.pbox[16], r ^= e.pbox[17], {
					left: r,
					right: i
				};
			}
			function l(e, t, n) {
				let r = t, i = n, a;
				for (let t = 17; t > 1; --t) r ^= e.pbox[t], i = s(e, r) ^ i, a = r, r = i, i = a;
				return a = r, r = i, i = a, i ^= e.pbox[1], r ^= e.pbox[0], {
					left: r,
					right: i
				};
			}
			function u(e, t, n) {
				for (let t = 0; t < 4; t++) {
					e.sbox[t] = [];
					for (let n = 0; n < 256; n++) e.sbox[t][n] = a[t][n];
				}
				let r = 0;
				for (let a = 0; a < 18; a++) e.pbox[a] = i[a] ^ t[r], r++, r >= n && (r = 0);
				let o = 0, s = 0, l = 0;
				for (let t = 0; t < 18; t += 2) l = c(e, o, s), o = l.left, s = l.right, e.pbox[t] = o, e.pbox[t + 1] = s;
				for (let t = 0; t < 4; t++) for (let n = 0; n < 256; n += 2) l = c(e, o, s), o = l.left, s = l.right, e.sbox[t][n] = o, e.sbox[t][n + 1] = s;
				return !0;
			}
			var d = r.Blowfish = n.extend({
				_doReset: function() {
					if (this._keyPriorReset !== this._key) {
						var e = this._keyPriorReset = this._key, t = e.words;
						u(o, t, e.sigBytes / 4);
					}
				},
				encryptBlock: function(e, t) {
					var n = c(o, e[t], e[t + 1]);
					e[t] = n.left, e[t + 1] = n.right;
				},
				decryptBlock: function(e, t) {
					var n = l(o, e[t], e[t + 1]);
					e[t] = n.left, e[t + 1] = n.right;
				},
				blockSize: 64 / 32,
				keySize: 128 / 32,
				ivSize: 64 / 32
			});
			t.Blowfish = n._createHelper(d);
		})(), e.Blowfish;
	});
})), qR = /* @__PURE__ */ xt((/* @__PURE__ */ V(((e, t) => {
	(function(n, r, i) {
		typeof e == "object" ? t.exports = e = r(ak(), mR(), hR(), gR(), _R(), vR(), ok(), yR(), bR(), xR(), SR(), CR(), wR(), TR(), ER(), DR(), OR(), kR(), AR(), jR(), MR(), NR(), PR(), FR(), IR(), LR(), RR(), zR(), BR(), VR(), HR(), UR(), WR(), GR(), KR()) : typeof define == "function" && define.amd ? define(/* @__PURE__ */ "./core,./x64-core,./lib-typedarrays,./enc-utf16,./enc-base64,./enc-base64url,./md5,./sha1,./sha256,./sha224,./sha512,./sha384,./sha3,./ripemd160,./hmac,./pbkdf2,./evpkdf,./cipher-core,./mode-cfb,./mode-ctr,./mode-ctr-gladman,./mode-ofb,./mode-ecb,./pad-ansix923,./pad-iso10126,./pad-iso97971,./pad-zeropadding,./pad-nopadding,./format-hex,./aes,./tripledes,./rc4,./rabbit,./rabbit-legacy,./blowfish".split(","), r) : n.CryptoJS = r(n.CryptoJS);
	})(e, function(e) {
		return e;
	});
})))(), 1), JR = typeof global < "u" ? global : typeof self < "u" ? self : typeof window < "u" ? window : {}, YR = [], XR = [], ZR = typeof Uint8Array < "u" ? Uint8Array : Array, QR = !1;
function $R() {
	QR = !0;
	for (var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", t = 0, n = e.length; t < n; ++t) YR[t] = e[t], XR[e.charCodeAt(t)] = t;
	XR[45] = 62, XR[95] = 63;
}
function ez(e) {
	QR || $R();
	var t, n, r, i, a, o, s = e.length;
	if (s % 4 > 0) throw Error("Invalid string. Length must be a multiple of 4");
	a = e[s - 2] === "=" ? 2 : +(e[s - 1] === "="), o = new ZR(s * 3 / 4 - a), r = a > 0 ? s - 4 : s;
	var c = 0;
	for (t = 0, n = 0; t < r; t += 4, n += 3) i = XR[e.charCodeAt(t)] << 18 | XR[e.charCodeAt(t + 1)] << 12 | XR[e.charCodeAt(t + 2)] << 6 | XR[e.charCodeAt(t + 3)], o[c++] = i >> 16 & 255, o[c++] = i >> 8 & 255, o[c++] = i & 255;
	return a === 2 ? (i = XR[e.charCodeAt(t)] << 2 | XR[e.charCodeAt(t + 1)] >> 4, o[c++] = i & 255) : a === 1 && (i = XR[e.charCodeAt(t)] << 10 | XR[e.charCodeAt(t + 1)] << 4 | XR[e.charCodeAt(t + 2)] >> 2, o[c++] = i >> 8 & 255, o[c++] = i & 255), o;
}
function tz(e) {
	return YR[e >> 18 & 63] + YR[e >> 12 & 63] + YR[e >> 6 & 63] + YR[e & 63];
}
function nz(e, t, n) {
	for (var r, i = [], a = t; a < n; a += 3) r = (e[a] << 16) + (e[a + 1] << 8) + e[a + 2], i.push(tz(r));
	return i.join("");
}
function rz(e) {
	QR || $R();
	for (var t, n = e.length, r = n % 3, i = "", a = [], o = 16383, s = 0, c = n - r; s < c; s += o) a.push(nz(e, s, s + o > c ? c : s + o));
	return r === 1 ? (t = e[n - 1], i += YR[t >> 2], i += YR[t << 4 & 63], i += "==") : r === 2 && (t = (e[n - 2] << 8) + e[n - 1], i += YR[t >> 10], i += YR[t >> 4 & 63], i += YR[t << 2 & 63], i += "="), a.push(i), a.join("");
}
function iz(e, t, n, r, i) {
	var a, o, s = i * 8 - r - 1, c = (1 << s) - 1, l = c >> 1, u = -7, d = n ? i - 1 : 0, f = n ? -1 : 1, p = e[t + d];
	for (d += f, a = p & (1 << -u) - 1, p >>= -u, u += s; u > 0; a = a * 256 + e[t + d], d += f, u -= 8);
	for (o = a & (1 << -u) - 1, a >>= -u, u += r; u > 0; o = o * 256 + e[t + d], d += f, u -= 8);
	if (a === 0) a = 1 - l;
	else if (a === c) return o ? NaN : (p ? -1 : 1) * Infinity;
	else o += 2 ** r, a -= l;
	return (p ? -1 : 1) * o * 2 ** (a - r);
}
function az(e, t, n, r, i, a) {
	var o, s, c, l = a * 8 - i - 1, u = (1 << l) - 1, d = u >> 1, f = i === 23 ? 2 ** -24 - 2 ** -77 : 0, p = r ? 0 : a - 1, m = r ? 1 : -1, h = +(t < 0 || t === 0 && 1 / t < 0);
	for (t = Math.abs(t), isNaN(t) || t === Infinity ? (s = +!!isNaN(t), o = u) : (o = Math.floor(Math.log(t) / Math.LN2), t * (c = 2 ** -o) < 1 && (o--, c *= 2), o + d >= 1 ? t += f / c : t += f * 2 ** (1 - d), t * c >= 2 && (o++, c /= 2), o + d >= u ? (s = 0, o = u) : o + d >= 1 ? (s = (t * c - 1) * 2 ** i, o += d) : (s = t * 2 ** (d - 1) * 2 ** i, o = 0)); i >= 8; e[n + p] = s & 255, p += m, s /= 256, i -= 8);
	for (o = o << i | s, l += i; l > 0; e[n + p] = o & 255, p += m, o /= 256, l -= 8);
	e[n + p - m] |= h * 128;
}
var oz = {}.toString, sz = Array.isArray || function(e) {
	return oz.call(e) == "[object Array]";
}, cz = 50;
Q.TYPED_ARRAY_SUPPORT = JR.TYPED_ARRAY_SUPPORT === void 0 ? !0 : JR.TYPED_ARRAY_SUPPORT;
var lz = uz();
function uz() {
	return Q.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
}
function dz(e, t) {
	if (uz() < t) throw RangeError("Invalid typed array length");
	return Q.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(t), e.__proto__ = Q.prototype) : (e === null && (e = new Q(t)), e.length = t), e;
}
function Q(e, t, n) {
	if (!Q.TYPED_ARRAY_SUPPORT && !(this instanceof Q)) return new Q(e, t, n);
	if (typeof e == "number") {
		if (typeof t == "string") throw Error("If encoding is specified then the first argument must be a string");
		return hz(this, e);
	}
	return fz(this, e, t, n);
}
Q.poolSize = 8192, Q._augment = function(e) {
	return e.__proto__ = Q.prototype, e;
};
function fz(e, t, n, r) {
	if (typeof t == "number") throw TypeError("\"value\" argument must not be a number");
	return typeof ArrayBuffer < "u" && t instanceof ArrayBuffer ? vz(e, t, n, r) : typeof t == "string" ? gz(e, t, n) : yz(e, t);
}
Q.from = function(e, t, n) {
	return fz(null, e, t, n);
}, Q.TYPED_ARRAY_SUPPORT && (Q.prototype.__proto__ = Uint8Array.prototype, Q.__proto__ = Uint8Array, typeof Symbol < "u" && Symbol.species && Q[Symbol.species]);
function pz(e) {
	if (typeof e != "number") throw TypeError("\"size\" argument must be a number");
	if (e < 0) throw RangeError("\"size\" argument must not be negative");
}
function mz(e, t, n, r) {
	return pz(t), t <= 0 || n === void 0 ? dz(e, t) : typeof r == "string" ? dz(e, t).fill(n, r) : dz(e, t).fill(n);
}
Q.alloc = function(e, t, n) {
	return mz(null, e, t, n);
};
function hz(e, t) {
	if (pz(t), e = dz(e, t < 0 ? 0 : bz(t) | 0), !Q.TYPED_ARRAY_SUPPORT) for (var n = 0; n < t; ++n) e[n] = 0;
	return e;
}
Q.allocUnsafe = function(e) {
	return hz(null, e);
}, Q.allocUnsafeSlow = function(e) {
	return hz(null, e);
};
function gz(e, t, n) {
	if ((typeof n != "string" || n === "") && (n = "utf8"), !Q.isEncoding(n)) throw TypeError("\"encoding\" must be a valid string encoding");
	var r = Cz(t, n) | 0;
	e = dz(e, r);
	var i = e.write(t, n);
	return i !== r && (e = e.slice(0, i)), e;
}
function _z(e, t) {
	var n = t.length < 0 ? 0 : bz(t.length) | 0;
	e = dz(e, n);
	for (var r = 0; r < n; r += 1) e[r] = t[r] & 255;
	return e;
}
function vz(e, t, n, r) {
	if (t.byteLength, n < 0 || t.byteLength < n) throw RangeError("'offset' is out of bounds");
	if (t.byteLength < n + (r || 0)) throw RangeError("'length' is out of bounds");
	return t = n === void 0 && r === void 0 ? new Uint8Array(t) : r === void 0 ? new Uint8Array(t, n) : new Uint8Array(t, n, r), Q.TYPED_ARRAY_SUPPORT ? (e = t, e.__proto__ = Q.prototype) : e = _z(e, t), e;
}
function yz(e, t) {
	if (Sz(t)) {
		var n = bz(t.length) | 0;
		return e = dz(e, n), e.length === 0 || t.copy(e, 0, 0, n), e;
	}
	if (t) {
		if (typeof ArrayBuffer < "u" && t.buffer instanceof ArrayBuffer || "length" in t) return typeof t.length != "number" || iB(t.length) ? dz(e, 0) : _z(e, t);
		if (t.type === "Buffer" && sz(t.data)) return _z(e, t.data);
	}
	throw TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function bz(e) {
	if (e >= uz()) throw RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + uz().toString(16) + " bytes");
	return e | 0;
}
function xz(e) {
	return +e != e && (e = 0), Q.alloc(+e);
}
Q.isBuffer = aB;
function Sz(e) {
	return !!(e != null && e._isBuffer);
}
Q.compare = function(e, t) {
	if (!Sz(e) || !Sz(t)) throw TypeError("Arguments must be Buffers");
	if (e === t) return 0;
	for (var n = e.length, r = t.length, i = 0, a = Math.min(n, r); i < a; ++i) if (e[i] !== t[i]) {
		n = e[i], r = t[i];
		break;
	}
	return n < r ? -1 : +(r < n);
}, Q.isEncoding = function(e) {
	switch (String(e).toLowerCase()) {
		case "hex":
		case "utf8":
		case "utf-8":
		case "ascii":
		case "latin1":
		case "binary":
		case "base64":
		case "ucs2":
		case "ucs-2":
		case "utf16le":
		case "utf-16le": return !0;
		default: return !1;
	}
}, Q.concat = function(e, t) {
	if (!sz(e)) throw TypeError("\"list\" argument must be an Array of Buffers");
	if (e.length === 0) return Q.alloc(0);
	var n;
	if (t === void 0) for (t = 0, n = 0; n < e.length; ++n) t += e[n].length;
	var r = Q.allocUnsafe(t), i = 0;
	for (n = 0; n < e.length; ++n) {
		var a = e[n];
		if (!Sz(a)) throw TypeError("\"list\" argument must be an Array of Buffers");
		a.copy(r, i), i += a.length;
	}
	return r;
};
function Cz(e, t) {
	if (Sz(e)) return e.length;
	if (typeof ArrayBuffer < "u" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer)) return e.byteLength;
	typeof e != "string" && (e = "" + e);
	var n = e.length;
	if (n === 0) return 0;
	for (var r = !1;;) switch (t) {
		case "ascii":
		case "latin1":
		case "binary": return n;
		case "utf8":
		case "utf-8":
		case void 0: return $z(e).length;
		case "ucs2":
		case "ucs-2":
		case "utf16le":
		case "utf-16le": return n * 2;
		case "hex": return n >>> 1;
		case "base64": return nB(e).length;
		default:
			if (r) return $z(e).length;
			t = ("" + t).toLowerCase(), r = !0;
	}
}
Q.byteLength = Cz;
function wz(e, t, n) {
	var r = !1;
	if ((t === void 0 || t < 0) && (t = 0), t > this.length || ((n === void 0 || n > this.length) && (n = this.length), n <= 0) || (n >>>= 0, t >>>= 0, n <= t)) return "";
	for (e ||= "utf8";;) switch (e) {
		case "hex": return Bz(this, t, n);
		case "utf8":
		case "utf-8": return Fz(this, t, n);
		case "ascii": return Rz(this, t, n);
		case "latin1":
		case "binary": return zz(this, t, n);
		case "base64": return Pz(this, t, n);
		case "ucs2":
		case "ucs-2":
		case "utf16le":
		case "utf-16le": return Vz(this, t, n);
		default:
			if (r) throw TypeError("Unknown encoding: " + e);
			e = (e + "").toLowerCase(), r = !0;
	}
}
Q.prototype._isBuffer = !0;
function Tz(e, t, n) {
	var r = e[t];
	e[t] = e[n], e[n] = r;
}
Q.prototype.swap16 = function() {
	var e = this.length;
	if (e % 2 != 0) throw RangeError("Buffer size must be a multiple of 16-bits");
	for (var t = 0; t < e; t += 2) Tz(this, t, t + 1);
	return this;
}, Q.prototype.swap32 = function() {
	var e = this.length;
	if (e % 4 != 0) throw RangeError("Buffer size must be a multiple of 32-bits");
	for (var t = 0; t < e; t += 4) Tz(this, t, t + 3), Tz(this, t + 1, t + 2);
	return this;
}, Q.prototype.swap64 = function() {
	var e = this.length;
	if (e % 8 != 0) throw RangeError("Buffer size must be a multiple of 64-bits");
	for (var t = 0; t < e; t += 8) Tz(this, t, t + 7), Tz(this, t + 1, t + 6), Tz(this, t + 2, t + 5), Tz(this, t + 3, t + 4);
	return this;
}, Q.prototype.toString = function() {
	var e = this.length | 0;
	return e === 0 ? "" : arguments.length === 0 ? Fz(this, 0, e) : wz.apply(this, arguments);
}, Q.prototype.equals = function(e) {
	if (!Sz(e)) throw TypeError("Argument must be a Buffer");
	return this === e ? !0 : Q.compare(this, e) === 0;
}, Q.prototype.inspect = function() {
	var e = "", t = cz;
	return this.length > 0 && (e = this.toString("hex", 0, t).match(/.{2}/g).join(" "), this.length > t && (e += " ... ")), "<Buffer " + e + ">";
}, Q.prototype.compare = function(e, t, n, r, i) {
	if (!Sz(e)) throw TypeError("Argument must be a Buffer");
	if (t === void 0 && (t = 0), n === void 0 && (n = e ? e.length : 0), r === void 0 && (r = 0), i === void 0 && (i = this.length), t < 0 || n > e.length || r < 0 || i > this.length) throw RangeError("out of range index");
	if (r >= i && t >= n) return 0;
	if (r >= i) return -1;
	if (t >= n) return 1;
	if (t >>>= 0, n >>>= 0, r >>>= 0, i >>>= 0, this === e) return 0;
	for (var a = i - r, o = n - t, s = Math.min(a, o), c = this.slice(r, i), l = e.slice(t, n), u = 0; u < s; ++u) if (c[u] !== l[u]) {
		a = c[u], o = l[u];
		break;
	}
	return a < o ? -1 : +(o < a);
};
function Ez(e, t, n, r, i) {
	if (e.length === 0) return -1;
	if (typeof n == "string" ? (r = n, n = 0) : n > 2147483647 ? n = 2147483647 : n < -2147483648 && (n = -2147483648), n = +n, isNaN(n) && (n = i ? 0 : e.length - 1), n < 0 && (n = e.length + n), n >= e.length) {
		if (i) return -1;
		n = e.length - 1;
	} else if (n < 0) if (i) n = 0;
	else return -1;
	if (typeof t == "string" && (t = Q.from(t, r)), Sz(t)) return t.length === 0 ? -1 : Dz(e, t, n, r, i);
	if (typeof t == "number") return t &= 255, Q.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? i ? Uint8Array.prototype.indexOf.call(e, t, n) : Uint8Array.prototype.lastIndexOf.call(e, t, n) : Dz(e, [t], n, r, i);
	throw TypeError("val must be string, number or Buffer");
}
function Dz(e, t, n, r, i) {
	var a = 1, o = e.length, s = t.length;
	if (r !== void 0 && (r = String(r).toLowerCase(), r === "ucs2" || r === "ucs-2" || r === "utf16le" || r === "utf-16le")) {
		if (e.length < 2 || t.length < 2) return -1;
		a = 2, o /= 2, s /= 2, n /= 2;
	}
	function c(e, t) {
		return a === 1 ? e[t] : e.readUInt16BE(t * a);
	}
	var l;
	if (i) {
		var u = -1;
		for (l = n; l < o; l++) if (c(e, l) === c(t, u === -1 ? 0 : l - u)) {
			if (u === -1 && (u = l), l - u + 1 === s) return u * a;
		} else u !== -1 && (l -= l - u), u = -1;
	} else for (n + s > o && (n = o - s), l = n; l >= 0; l--) {
		for (var d = !0, f = 0; f < s; f++) if (c(e, l + f) !== c(t, f)) {
			d = !1;
			break;
		}
		if (d) return l;
	}
	return -1;
}
Q.prototype.includes = function(e, t, n) {
	return this.indexOf(e, t, n) !== -1;
}, Q.prototype.indexOf = function(e, t, n) {
	return Ez(this, e, t, n, !0);
}, Q.prototype.lastIndexOf = function(e, t, n) {
	return Ez(this, e, t, n, !1);
};
function Oz(e, t, n, r) {
	n = Number(n) || 0;
	var i = e.length - n;
	r ? (r = Number(r), r > i && (r = i)) : r = i;
	var a = t.length;
	if (a % 2 != 0) throw TypeError("Invalid hex string");
	r > a / 2 && (r = a / 2);
	for (var o = 0; o < r; ++o) {
		var s = parseInt(t.substr(o * 2, 2), 16);
		if (isNaN(s)) return o;
		e[n + o] = s;
	}
	return o;
}
function kz(e, t, n, r) {
	return rB($z(t, e.length - n), e, n, r);
}
function Az(e, t, n, r) {
	return rB(eB(t), e, n, r);
}
function jz(e, t, n, r) {
	return Az(e, t, n, r);
}
function Mz(e, t, n, r) {
	return rB(nB(t), e, n, r);
}
function Nz(e, t, n, r) {
	return rB(tB(t, e.length - n), e, n, r);
}
Q.prototype.write = function(e, t, n, r) {
	if (t === void 0) r = "utf8", n = this.length, t = 0;
	else if (n === void 0 && typeof t == "string") r = t, n = this.length, t = 0;
	else if (isFinite(t)) t |= 0, isFinite(n) ? (n |= 0, r === void 0 && (r = "utf8")) : (r = n, n = void 0);
	else throw Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
	var i = this.length - t;
	if ((n === void 0 || n > i) && (n = i), e.length > 0 && (n < 0 || t < 0) || t > this.length) throw RangeError("Attempt to write outside buffer bounds");
	r ||= "utf8";
	for (var a = !1;;) switch (r) {
		case "hex": return Oz(this, e, t, n);
		case "utf8":
		case "utf-8": return kz(this, e, t, n);
		case "ascii": return Az(this, e, t, n);
		case "latin1":
		case "binary": return jz(this, e, t, n);
		case "base64": return Mz(this, e, t, n);
		case "ucs2":
		case "ucs-2":
		case "utf16le":
		case "utf-16le": return Nz(this, e, t, n);
		default:
			if (a) throw TypeError("Unknown encoding: " + r);
			r = ("" + r).toLowerCase(), a = !0;
	}
}, Q.prototype.toJSON = function() {
	return {
		type: "Buffer",
		data: Array.prototype.slice.call(this._arr || this, 0)
	};
};
function Pz(e, t, n) {
	return t === 0 && n === e.length ? rz(e) : rz(e.slice(t, n));
}
function Fz(e, t, n) {
	n = Math.min(e.length, n);
	for (var r = [], i = t; i < n;) {
		var a = e[i], o = null, s = a > 239 ? 4 : a > 223 ? 3 : a > 191 ? 2 : 1;
		if (i + s <= n) {
			var c, l, u, d;
			switch (s) {
				case 1:
					a < 128 && (o = a);
					break;
				case 2:
					c = e[i + 1], (c & 192) == 128 && (d = (a & 31) << 6 | c & 63, d > 127 && (o = d));
					break;
				case 3:
					c = e[i + 1], l = e[i + 2], (c & 192) == 128 && (l & 192) == 128 && (d = (a & 15) << 12 | (c & 63) << 6 | l & 63, d > 2047 && (d < 55296 || d > 57343) && (o = d));
					break;
				case 4: c = e[i + 1], l = e[i + 2], u = e[i + 3], (c & 192) == 128 && (l & 192) == 128 && (u & 192) == 128 && (d = (a & 15) << 18 | (c & 63) << 12 | (l & 63) << 6 | u & 63, d > 65535 && d < 1114112 && (o = d));
			}
		}
		o === null ? (o = 65533, s = 1) : o > 65535 && (o -= 65536, r.push(o >>> 10 & 1023 | 55296), o = 56320 | o & 1023), r.push(o), i += s;
	}
	return Lz(r);
}
var Iz = 4096;
function Lz(e) {
	var t = e.length;
	if (t <= Iz) return String.fromCharCode.apply(String, e);
	for (var n = "", r = 0; r < t;) n += String.fromCharCode.apply(String, e.slice(r, r += Iz));
	return n;
}
function Rz(e, t, n) {
	var r = "";
	n = Math.min(e.length, n);
	for (var i = t; i < n; ++i) r += String.fromCharCode(e[i] & 127);
	return r;
}
function zz(e, t, n) {
	var r = "";
	n = Math.min(e.length, n);
	for (var i = t; i < n; ++i) r += String.fromCharCode(e[i]);
	return r;
}
function Bz(e, t, n) {
	var r = e.length;
	(!t || t < 0) && (t = 0), (!n || n < 0 || n > r) && (n = r);
	for (var i = "", a = t; a < n; ++a) i += Qz(e[a]);
	return i;
}
function Vz(e, t, n) {
	for (var r = e.slice(t, n), i = "", a = 0; a < r.length; a += 2) i += String.fromCharCode(r[a] + r[a + 1] * 256);
	return i;
}
Q.prototype.slice = function(e, t) {
	var n = this.length;
	e = ~~e, t = t === void 0 ? n : ~~t, e < 0 ? (e += n, e < 0 && (e = 0)) : e > n && (e = n), t < 0 ? (t += n, t < 0 && (t = 0)) : t > n && (t = n), t < e && (t = e);
	var r;
	if (Q.TYPED_ARRAY_SUPPORT) r = this.subarray(e, t), r.__proto__ = Q.prototype;
	else {
		var i = t - e;
		r = new Q(i, void 0);
		for (var a = 0; a < i; ++a) r[a] = this[a + e];
	}
	return r;
};
function Hz(e, t, n) {
	if (e % 1 != 0 || e < 0) throw RangeError("offset is not uint");
	if (e + t > n) throw RangeError("Trying to access beyond buffer length");
}
Q.prototype.readUIntLE = function(e, t, n) {
	e |= 0, t |= 0, n || Hz(e, t, this.length);
	for (var r = this[e], i = 1, a = 0; ++a < t && (i *= 256);) r += this[e + a] * i;
	return r;
}, Q.prototype.readUIntBE = function(e, t, n) {
	e |= 0, t |= 0, n || Hz(e, t, this.length);
	for (var r = this[e + --t], i = 1; t > 0 && (i *= 256);) r += this[e + --t] * i;
	return r;
}, Q.prototype.readUInt8 = function(e, t) {
	return t || Hz(e, 1, this.length), this[e];
}, Q.prototype.readUInt16LE = function(e, t) {
	return t || Hz(e, 2, this.length), this[e] | this[e + 1] << 8;
}, Q.prototype.readUInt16BE = function(e, t) {
	return t || Hz(e, 2, this.length), this[e] << 8 | this[e + 1];
}, Q.prototype.readUInt32LE = function(e, t) {
	return t || Hz(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + this[e + 3] * 16777216;
}, Q.prototype.readUInt32BE = function(e, t) {
	return t || Hz(e, 4, this.length), this[e] * 16777216 + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
}, Q.prototype.readIntLE = function(e, t, n) {
	e |= 0, t |= 0, n || Hz(e, t, this.length);
	for (var r = this[e], i = 1, a = 0; ++a < t && (i *= 256);) r += this[e + a] * i;
	return i *= 128, r >= i && (r -= 2 ** (8 * t)), r;
}, Q.prototype.readIntBE = function(e, t, n) {
	e |= 0, t |= 0, n || Hz(e, t, this.length);
	for (var r = t, i = 1, a = this[e + --r]; r > 0 && (i *= 256);) a += this[e + --r] * i;
	return i *= 128, a >= i && (a -= 2 ** (8 * t)), a;
}, Q.prototype.readInt8 = function(e, t) {
	return t || Hz(e, 1, this.length), this[e] & 128 ? (255 - this[e] + 1) * -1 : this[e];
}, Q.prototype.readInt16LE = function(e, t) {
	t || Hz(e, 2, this.length);
	var n = this[e] | this[e + 1] << 8;
	return n & 32768 ? n | 4294901760 : n;
}, Q.prototype.readInt16BE = function(e, t) {
	t || Hz(e, 2, this.length);
	var n = this[e + 1] | this[e] << 8;
	return n & 32768 ? n | 4294901760 : n;
}, Q.prototype.readInt32LE = function(e, t) {
	return t || Hz(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
}, Q.prototype.readInt32BE = function(e, t) {
	return t || Hz(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
}, Q.prototype.readFloatLE = function(e, t) {
	return t || Hz(e, 4, this.length), iz(this, e, !0, 23, 4);
}, Q.prototype.readFloatBE = function(e, t) {
	return t || Hz(e, 4, this.length), iz(this, e, !1, 23, 4);
}, Q.prototype.readDoubleLE = function(e, t) {
	return t || Hz(e, 8, this.length), iz(this, e, !0, 52, 8);
}, Q.prototype.readDoubleBE = function(e, t) {
	return t || Hz(e, 8, this.length), iz(this, e, !1, 52, 8);
};
function Uz(e, t, n, r, i, a) {
	if (!Sz(e)) throw TypeError("\"buffer\" argument must be a Buffer instance");
	if (t > i || t < a) throw RangeError("\"value\" argument is out of bounds");
	if (n + r > e.length) throw RangeError("Index out of range");
}
Q.prototype.writeUIntLE = function(e, t, n, r) {
	if (e = +e, t |= 0, n |= 0, !r) {
		var i = 2 ** (8 * n) - 1;
		Uz(this, e, t, n, i, 0);
	}
	var a = 1, o = 0;
	for (this[t] = e & 255; ++o < n && (a *= 256);) this[t + o] = e / a & 255;
	return t + n;
}, Q.prototype.writeUIntBE = function(e, t, n, r) {
	if (e = +e, t |= 0, n |= 0, !r) {
		var i = 2 ** (8 * n) - 1;
		Uz(this, e, t, n, i, 0);
	}
	var a = n - 1, o = 1;
	for (this[t + a] = e & 255; --a >= 0 && (o *= 256);) this[t + a] = e / o & 255;
	return t + n;
}, Q.prototype.writeUInt8 = function(e, t, n) {
	return e = +e, t |= 0, n || Uz(this, e, t, 1, 255, 0), Q.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[t] = e & 255, t + 1;
};
function Wz(e, t, n, r) {
	t < 0 && (t = 65535 + t + 1);
	for (var i = 0, a = Math.min(e.length - n, 2); i < a; ++i) e[n + i] = (t & 255 << 8 * (r ? i : 1 - i)) >>> (r ? i : 1 - i) * 8;
}
Q.prototype.writeUInt16LE = function(e, t, n) {
	return e = +e, t |= 0, n || Uz(this, e, t, 2, 65535, 0), Q.TYPED_ARRAY_SUPPORT ? (this[t] = e & 255, this[t + 1] = e >>> 8) : Wz(this, e, t, !0), t + 2;
}, Q.prototype.writeUInt16BE = function(e, t, n) {
	return e = +e, t |= 0, n || Uz(this, e, t, 2, 65535, 0), Q.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = e & 255) : Wz(this, e, t, !1), t + 2;
};
function Gz(e, t, n, r) {
	t < 0 && (t = 4294967295 + t + 1);
	for (var i = 0, a = Math.min(e.length - n, 4); i < a; ++i) e[n + i] = t >>> (r ? i : 3 - i) * 8 & 255;
}
Q.prototype.writeUInt32LE = function(e, t, n) {
	return e = +e, t |= 0, n || Uz(this, e, t, 4, 4294967295, 0), Q.TYPED_ARRAY_SUPPORT ? (this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = e & 255) : Gz(this, e, t, !0), t + 4;
}, Q.prototype.writeUInt32BE = function(e, t, n) {
	return e = +e, t |= 0, n || Uz(this, e, t, 4, 4294967295, 0), Q.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = e & 255) : Gz(this, e, t, !1), t + 4;
}, Q.prototype.writeIntLE = function(e, t, n, r) {
	if (e = +e, t |= 0, !r) {
		var i = 2 ** (8 * n - 1);
		Uz(this, e, t, n, i - 1, -i);
	}
	var a = 0, o = 1, s = 0;
	for (this[t] = e & 255; ++a < n && (o *= 256);) e < 0 && s === 0 && this[t + a - 1] !== 0 && (s = 1), this[t + a] = (e / o >> 0) - s & 255;
	return t + n;
}, Q.prototype.writeIntBE = function(e, t, n, r) {
	if (e = +e, t |= 0, !r) {
		var i = 2 ** (8 * n - 1);
		Uz(this, e, t, n, i - 1, -i);
	}
	var a = n - 1, o = 1, s = 0;
	for (this[t + a] = e & 255; --a >= 0 && (o *= 256);) e < 0 && s === 0 && this[t + a + 1] !== 0 && (s = 1), this[t + a] = (e / o >> 0) - s & 255;
	return t + n;
}, Q.prototype.writeInt8 = function(e, t, n) {
	return e = +e, t |= 0, n || Uz(this, e, t, 1, 127, -128), Q.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[t] = e & 255, t + 1;
}, Q.prototype.writeInt16LE = function(e, t, n) {
	return e = +e, t |= 0, n || Uz(this, e, t, 2, 32767, -32768), Q.TYPED_ARRAY_SUPPORT ? (this[t] = e & 255, this[t + 1] = e >>> 8) : Wz(this, e, t, !0), t + 2;
}, Q.prototype.writeInt16BE = function(e, t, n) {
	return e = +e, t |= 0, n || Uz(this, e, t, 2, 32767, -32768), Q.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = e & 255) : Wz(this, e, t, !1), t + 2;
}, Q.prototype.writeInt32LE = function(e, t, n) {
	return e = +e, t |= 0, n || Uz(this, e, t, 4, 2147483647, -2147483648), Q.TYPED_ARRAY_SUPPORT ? (this[t] = e & 255, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24) : Gz(this, e, t, !0), t + 4;
}, Q.prototype.writeInt32BE = function(e, t, n) {
	return e = +e, t |= 0, n || Uz(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), Q.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = e & 255) : Gz(this, e, t, !1), t + 4;
};
function Kz(e, t, n, r, i, a) {
	if (n + r > e.length || n < 0) throw RangeError("Index out of range");
}
function qz(e, t, n, r, i) {
	return i || Kz(e, t, n, 4), az(e, t, n, r, 23, 4), n + 4;
}
Q.prototype.writeFloatLE = function(e, t, n) {
	return qz(this, e, t, !0, n);
}, Q.prototype.writeFloatBE = function(e, t, n) {
	return qz(this, e, t, !1, n);
};
function Jz(e, t, n, r, i) {
	return i || Kz(e, t, n, 8), az(e, t, n, r, 52, 8), n + 8;
}
Q.prototype.writeDoubleLE = function(e, t, n) {
	return Jz(this, e, t, !0, n);
}, Q.prototype.writeDoubleBE = function(e, t, n) {
	return Jz(this, e, t, !1, n);
}, Q.prototype.copy = function(e, t, n, r) {
	if (n ||= 0, !r && r !== 0 && (r = this.length), t >= e.length && (t = e.length), t ||= 0, r > 0 && r < n && (r = n), r === n || e.length === 0 || this.length === 0) return 0;
	if (t < 0) throw RangeError("targetStart out of bounds");
	if (n < 0 || n >= this.length) throw RangeError("sourceStart out of bounds");
	if (r < 0) throw RangeError("sourceEnd out of bounds");
	r > this.length && (r = this.length), e.length - t < r - n && (r = e.length - t + n);
	var i = r - n, a;
	if (this === e && n < t && t < r) for (a = i - 1; a >= 0; --a) e[a + t] = this[a + n];
	else if (i < 1e3 || !Q.TYPED_ARRAY_SUPPORT) for (a = 0; a < i; ++a) e[a + t] = this[a + n];
	else Uint8Array.prototype.set.call(e, this.subarray(n, n + i), t);
	return i;
}, Q.prototype.fill = function(e, t, n, r) {
	if (typeof e == "string") {
		if (typeof t == "string" ? (r = t, t = 0, n = this.length) : typeof n == "string" && (r = n, n = this.length), e.length === 1) {
			var i = e.charCodeAt(0);
			i < 256 && (e = i);
		}
		if (r !== void 0 && typeof r != "string") throw TypeError("encoding must be a string");
		if (typeof r == "string" && !Q.isEncoding(r)) throw TypeError("Unknown encoding: " + r);
	} else typeof e == "number" && (e &= 255);
	if (t < 0 || this.length < t || this.length < n) throw RangeError("Out of range index");
	if (n <= t) return this;
	t >>>= 0, n = n === void 0 ? this.length : n >>> 0, e ||= 0;
	var a;
	if (typeof e == "number") for (a = t; a < n; ++a) this[a] = e;
	else {
		var o = Sz(e) ? e : $z(new Q(e, r).toString()), s = o.length;
		for (a = 0; a < n - t; ++a) this[a + t] = o[a % s];
	}
	return this;
};
var Yz = /[^+\/0-9A-Za-z-_]/g;
function Xz(e) {
	if (e = Zz(e).replace(Yz, ""), e.length < 2) return "";
	for (; e.length % 4 != 0;) e += "=";
	return e;
}
function Zz(e) {
	return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
}
function Qz(e) {
	return e < 16 ? "0" + e.toString(16) : e.toString(16);
}
function $z(e, t) {
	t ||= Infinity;
	for (var n, r = e.length, i = null, a = [], o = 0; o < r; ++o) {
		if (n = e.charCodeAt(o), n > 55295 && n < 57344) {
			if (!i) {
				if (n > 56319) {
					(t -= 3) > -1 && a.push(239, 191, 189);
					continue;
				} else if (o + 1 === r) {
					(t -= 3) > -1 && a.push(239, 191, 189);
					continue;
				}
				i = n;
				continue;
			}
			if (n < 56320) {
				(t -= 3) > -1 && a.push(239, 191, 189), i = n;
				continue;
			}
			n = (i - 55296 << 10 | n - 56320) + 65536;
		} else i && (t -= 3) > -1 && a.push(239, 191, 189);
		if (i = null, n < 128) {
			if (--t < 0) break;
			a.push(n);
		} else if (n < 2048) {
			if ((t -= 2) < 0) break;
			a.push(n >> 6 | 192, n & 63 | 128);
		} else if (n < 65536) {
			if ((t -= 3) < 0) break;
			a.push(n >> 12 | 224, n >> 6 & 63 | 128, n & 63 | 128);
		} else if (n < 1114112) {
			if ((t -= 4) < 0) break;
			a.push(n >> 18 | 240, n >> 12 & 63 | 128, n >> 6 & 63 | 128, n & 63 | 128);
		} else throw Error("Invalid code point");
	}
	return a;
}
function eB(e) {
	for (var t = [], n = 0; n < e.length; ++n) t.push(e.charCodeAt(n) & 255);
	return t;
}
function tB(e, t) {
	for (var n, r, i, a = [], o = 0; o < e.length && !((t -= 2) < 0); ++o) n = e.charCodeAt(o), r = n >> 8, i = n % 256, a.push(i), a.push(r);
	return a;
}
function nB(e) {
	return ez(Xz(e));
}
function rB(e, t, n, r) {
	for (var i = 0; i < r && !(i + n >= t.length || i >= e.length); ++i) t[i + n] = e[i];
	return i;
}
function iB(e) {
	return e !== e;
}
function aB(e) {
	return e != null && (!!e._isBuffer || oB(e) || sB(e));
}
function oB(e) {
	return !!e.constructor && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
function sB(e) {
	return typeof e.readFloatLE == "function" && typeof e.slice == "function" && oB(e.slice(0, 0));
}
var cB = /*#__PURE__*/ Object.freeze({
	__proto__: null,
	Buffer: Q,
	INSPECT_MAX_BYTES: cz,
	SlowBuffer: xz,
	isBuffer: aB,
	kMaxLength: lz
}), lB = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function uB(e) {
	return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function dB(e) {
	if (e.__esModule) return e;
	var t = e.default;
	if (typeof t == "function") {
		var n = function e() {
			return this instanceof e ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
		};
		n.prototype = t.prototype;
	} else n = {};
	return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(t) {
		var r = Object.getOwnPropertyDescriptor(e, t);
		Object.defineProperty(n, t, r.get ? r : {
			enumerable: !0,
			get: function() {
				return e[t];
			}
		});
	}), n;
}
var fB = { exports: {} }, pB = {};
function mB() {
	throw Error("setTimeout has not been defined");
}
function hB() {
	throw Error("clearTimeout has not been defined");
}
var gB = mB, _B = hB;
typeof JR.setTimeout == "function" && (gB = setTimeout), typeof JR.clearTimeout == "function" && (_B = clearTimeout);
function vB(e) {
	if (gB === setTimeout) return setTimeout(e, 0);
	if ((gB === mB || !gB) && setTimeout) return gB = setTimeout, setTimeout(e, 0);
	try {
		return gB(e, 0);
	} catch {
		try {
			return gB.call(null, e, 0);
		} catch {
			return gB.call(this, e, 0);
		}
	}
}
function yB(e) {
	if (_B === clearTimeout) return clearTimeout(e);
	if ((_B === hB || !_B) && clearTimeout) return _B = clearTimeout, clearTimeout(e);
	try {
		return _B(e);
	} catch {
		try {
			return _B.call(null, e);
		} catch {
			return _B.call(this, e);
		}
	}
}
var bB = [], xB = !1, SB, CB = -1;
function wB() {
	!xB || !SB || (xB = !1, SB.length ? bB = SB.concat(bB) : CB = -1, bB.length && TB());
}
function TB() {
	if (!xB) {
		var e = vB(wB);
		xB = !0;
		for (var t = bB.length; t;) {
			for (SB = bB, bB = []; ++CB < t;) SB && SB[CB].run();
			CB = -1, t = bB.length;
		}
		SB = null, xB = !1, yB(e);
	}
}
function EB(e) {
	var t = Array(arguments.length - 1);
	if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
	bB.push(new DB(e, t)), bB.length === 1 && !xB && vB(TB);
}
function DB(e, t) {
	this.fun = e, this.array = t;
}
DB.prototype.run = function() {
	this.fun.apply(null, this.array);
};
var OB = "browser", kB = "browser", AB = !0, jB = {}, MB = [], NB = "", PB = {}, FB = {}, IB = {};
function LB() {}
var RB = LB, zB = LB, BB = LB, VB = LB, HB = LB, UB = LB, WB = LB;
function GB(e) {
	throw Error("process.binding is not supported");
}
function KB() {
	return "/";
}
function qB(e) {
	throw Error("process.chdir is not supported");
}
function JB() {
	return 0;
}
var YB = JR.performance || {}, XB = YB.now || YB.mozNow || YB.msNow || YB.oNow || YB.webkitNow || function() {
	return (/* @__PURE__ */ new Date()).getTime();
};
function ZB(e) {
	var t = XB.call(YB) * .001, n = Math.floor(t), r = Math.floor(t % 1 * 1e9);
	return e && (n -= e[0], r -= e[1], r < 0 && (n--, r += 1e9)), [n, r];
}
var QB = /* @__PURE__ */ new Date();
function $B() {
	return (/* @__PURE__ */ new Date() - QB) / 1e3;
}
var eV = {
	nextTick: EB,
	title: OB,
	browser: AB,
	env: jB,
	argv: MB,
	version: NB,
	versions: PB,
	on: RB,
	addListener: zB,
	once: BB,
	off: VB,
	removeListener: HB,
	removeAllListeners: UB,
	emit: WB,
	binding: GB,
	cwd: KB,
	chdir: qB,
	umask: JB,
	hrtime: ZB,
	platform: kB,
	release: FB,
	config: IB,
	uptime: $B
}, tV;
function nV() {}
nV.prototype = Object.create(null);
function rV() {
	rV.init.call(this);
}
rV.EventEmitter = rV, rV.usingDomains = !1, rV.prototype.domain = void 0, rV.prototype._events = void 0, rV.prototype._maxListeners = void 0, rV.defaultMaxListeners = 10, rV.init = function() {
	this.domain = null, rV.usingDomains && tV.active && !(this instanceof tV.Domain) && (this.domain = tV.active), (!this._events || this._events === Object.getPrototypeOf(this)._events) && (this._events = new nV(), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
}, rV.prototype.setMaxListeners = function(e) {
	if (typeof e != "number" || e < 0 || isNaN(e)) throw TypeError("\"n\" argument must be a positive number");
	return this._maxListeners = e, this;
};
function iV(e) {
	return e._maxListeners === void 0 ? rV.defaultMaxListeners : e._maxListeners;
}
rV.prototype.getMaxListeners = function() {
	return iV(this);
};
function aV(e, t, n) {
	if (t) e.call(n);
	else for (var r = e.length, i = hV(e, r), a = 0; a < r; ++a) i[a].call(n);
}
function oV(e, t, n, r) {
	if (t) e.call(n, r);
	else for (var i = e.length, a = hV(e, i), o = 0; o < i; ++o) a[o].call(n, r);
}
function sV(e, t, n, r, i) {
	if (t) e.call(n, r, i);
	else for (var a = e.length, o = hV(e, a), s = 0; s < a; ++s) o[s].call(n, r, i);
}
function cV(e, t, n, r, i, a) {
	if (t) e.call(n, r, i, a);
	else for (var o = e.length, s = hV(e, o), c = 0; c < o; ++c) s[c].call(n, r, i, a);
}
function lV(e, t, n, r) {
	if (t) e.apply(n, r);
	else for (var i = e.length, a = hV(e, i), o = 0; o < i; ++o) a[o].apply(n, r);
}
rV.prototype.emit = function(e) {
	var t, n, r, i, a, o, s, c = e === "error";
	if (o = this._events, o) c &&= o.error == null;
	else if (!c) return !1;
	if (s = this.domain, c) {
		if (t = arguments[1], s) t ||= /* @__PURE__ */ Error("Uncaught, unspecified \"error\" event"), t.domainEmitter = this, t.domain = s, t.domainThrown = !1, s.emit("error", t);
		else if (t instanceof Error) throw t;
		else {
			var l = /* @__PURE__ */ Error("Uncaught, unspecified \"error\" event. (" + t + ")");
			throw l.context = t, l;
		}
		return !1;
	}
	if (n = o[e], !n) return !1;
	var u = typeof n == "function";
	switch (r = arguments.length, r) {
		case 1:
			aV(n, u, this);
			break;
		case 2:
			oV(n, u, this, arguments[1]);
			break;
		case 3:
			sV(n, u, this, arguments[1], arguments[2]);
			break;
		case 4:
			cV(n, u, this, arguments[1], arguments[2], arguments[3]);
			break;
		default:
			for (i = Array(r - 1), a = 1; a < r; a++) i[a - 1] = arguments[a];
			lV(n, u, this, i);
	}
	return !0;
};
function uV(e, t, n, r) {
	var i, a, o;
	if (typeof n != "function") throw TypeError("\"listener\" argument must be a function");
	if (a = e._events, a ? (a.newListener && (e.emit("newListener", t, n.listener ? n.listener : n), a = e._events), o = a[t]) : (a = e._events = new nV(), e._eventsCount = 0), !o) o = a[t] = n, ++e._eventsCount;
	else if (typeof o == "function" ? o = a[t] = r ? [n, o] : [o, n] : r ? o.unshift(n) : o.push(n), !o.warned && (i = iV(e), i && i > 0 && o.length > i)) {
		o.warned = !0;
		var s = /* @__PURE__ */ Error("Possible EventEmitter memory leak detected. " + o.length + " " + t + " listeners added. Use emitter.setMaxListeners() to increase limit");
		s.name = "MaxListenersExceededWarning", s.emitter = e, s.type = t, s.count = o.length, dV(s);
	}
	return e;
}
function dV(e) {
	typeof console.warn == "function" ? console.warn(e) : console.log(e);
}
rV.prototype.addListener = function(e, t) {
	return uV(this, e, t, !1);
}, rV.prototype.on = rV.prototype.addListener, rV.prototype.prependListener = function(e, t) {
	return uV(this, e, t, !0);
};
function fV(e, t, n) {
	var r = !1;
	function i() {
		e.removeListener(t, i), r || (r = !0, n.apply(e, arguments));
	}
	return i.listener = n, i;
}
rV.prototype.once = function(e, t) {
	if (typeof t != "function") throw TypeError("\"listener\" argument must be a function");
	return this.on(e, fV(this, e, t)), this;
}, rV.prototype.prependOnceListener = function(e, t) {
	if (typeof t != "function") throw TypeError("\"listener\" argument must be a function");
	return this.prependListener(e, fV(this, e, t)), this;
}, rV.prototype.removeListener = function(e, t) {
	var n, r, i, a, o;
	if (typeof t != "function") throw TypeError("\"listener\" argument must be a function");
	if (r = this._events, !r || (n = r[e], !n)) return this;
	if (n === t || n.listener && n.listener === t) --this._eventsCount === 0 ? this._events = new nV() : (delete r[e], r.removeListener && this.emit("removeListener", e, n.listener || t));
	else if (typeof n != "function") {
		for (i = -1, a = n.length; a-- > 0;) if (n[a] === t || n[a].listener && n[a].listener === t) {
			o = n[a].listener, i = a;
			break;
		}
		if (i < 0) return this;
		if (n.length === 1) {
			if (n[0] = void 0, --this._eventsCount === 0) return this._events = new nV(), this;
			delete r[e];
		} else mV(n, i);
		r.removeListener && this.emit("removeListener", e, o || t);
	}
	return this;
}, rV.prototype.off = function(e, t) {
	return this.removeListener(e, t);
}, rV.prototype.removeAllListeners = function(e) {
	var t, n = this._events;
	if (!n) return this;
	if (!n.removeListener) return arguments.length === 0 ? (this._events = new nV(), this._eventsCount = 0) : n[e] && (--this._eventsCount === 0 ? this._events = new nV() : delete n[e]), this;
	if (arguments.length === 0) {
		for (var r = Object.keys(n), i = 0, a; i < r.length; ++i) a = r[i], a !== "removeListener" && this.removeAllListeners(a);
		return this.removeAllListeners("removeListener"), this._events = new nV(), this._eventsCount = 0, this;
	}
	if (t = n[e], typeof t == "function") this.removeListener(e, t);
	else if (t) do
		this.removeListener(e, t[t.length - 1]);
	while (t[0]);
	return this;
}, rV.prototype.listeners = function(e) {
	var t, n, r = this._events;
	return r ? (t = r[e], n = t ? typeof t == "function" ? [t.listener || t] : gV(t) : []) : n = [], n;
}, rV.listenerCount = function(e, t) {
	return typeof e.listenerCount == "function" ? e.listenerCount(t) : pV.call(e, t);
}, rV.prototype.listenerCount = pV;
function pV(e) {
	var t = this._events;
	if (t) {
		var n = t[e];
		if (typeof n == "function") return 1;
		if (n) return n.length;
	}
	return 0;
}
rV.prototype.eventNames = function() {
	return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};
function mV(e, t) {
	for (var n = t, r = n + 1, i = e.length; r < i; n += 1, r += 1) e[n] = e[r];
	e.pop();
}
function hV(e, t) {
	for (var n = Array(t); t--;) n[t] = e[t];
	return n;
}
function gV(e) {
	for (var t = Array(e.length), n = 0; n < t.length; ++n) t[n] = e[n].listener || e[n];
	return t;
}
var _V = /*@__PURE__*/ dB(/* @__PURE__ */ Object.freeze({
	__proto__: null,
	EventEmitter: rV,
	default: rV
})), vV = _V.EventEmitter, yV = /*@__PURE__*/ dB(cB), bV = typeof Object.create == "function" ? function(e, t) {
	e.super_ = t, e.prototype = Object.create(t.prototype, { constructor: {
		value: e,
		enumerable: !1,
		writable: !0,
		configurable: !0
	} });
} : function(e, t) {
	e.super_ = t;
	var n = function() {};
	n.prototype = t.prototype, e.prototype = new n(), e.prototype.constructor = e;
}, xV = Object.getOwnPropertyDescriptors || function(e) {
	for (var t = Object.keys(e), n = {}, r = 0; r < t.length; r++) n[t[r]] = Object.getOwnPropertyDescriptor(e, t[r]);
	return n;
}, SV = /%[sdj%]/g;
function CV(e) {
	if (!UV(e)) {
		for (var t = [], n = 0; n < arguments.length; n++) t.push(OV(arguments[n]));
		return t.join(" ");
	}
	for (var n = 1, r = arguments, i = r.length, a = String(e).replace(SV, function(e) {
		if (e === "%%") return "%";
		if (n >= i) return e;
		switch (e) {
			case "%s": return String(r[n++]);
			case "%d": return Number(r[n++]);
			case "%j": try {
				return JSON.stringify(r[n++]);
			} catch {
				return "[Circular]";
			}
			default: return e;
		}
	}), o = r[n]; n < i; o = r[++n]) BV(o) || !qV(o) ? a += " " + o : a += " " + OV(o);
	return a;
}
function wV(e, t) {
	if (GV(JR.process)) return function() {
		return wV(e, t).apply(this, arguments);
	};
	if (eV.noDeprecation === !0) return e;
	var n = !1;
	function r() {
		if (!n) {
			if (eV.throwDeprecation) throw Error(t);
			eV.traceDeprecation ? console.trace(t) : console.error(t), n = !0;
		}
		return e.apply(this, arguments);
	}
	return r;
}
var TV = {}, EV;
function DV(e) {
	if (GV(EV) && (EV = eV.env.NODE_DEBUG || ""), e = e.toUpperCase(), !TV[e]) if (RegExp("\\b" + e + "\\b", "i").test(EV)) {
		var t = 0;
		TV[e] = function() {
			var n = CV.apply(null, arguments);
			console.error("%s %d: %s", e, t, n);
		};
	} else TV[e] = function() {};
	return TV[e];
}
function OV(e, t) {
	var n = {
		seen: [],
		stylize: AV
	};
	return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), zV(t) ? n.showHidden = t : t && iH(n, t), GV(n.showHidden) && (n.showHidden = !1), GV(n.depth) && (n.depth = 2), GV(n.colors) && (n.colors = !1), GV(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = kV), MV(n, e, n.depth);
}
OV.colors = {
	bold: [1, 22],
	italic: [3, 23],
	underline: [4, 24],
	inverse: [7, 27],
	white: [37, 39],
	grey: [90, 39],
	black: [30, 39],
	blue: [34, 39],
	cyan: [36, 39],
	green: [32, 39],
	magenta: [35, 39],
	red: [31, 39],
	yellow: [33, 39]
}, OV.styles = {
	special: "cyan",
	number: "yellow",
	boolean: "yellow",
	undefined: "grey",
	null: "bold",
	string: "green",
	date: "magenta",
	regexp: "red"
};
function kV(e, t) {
	var n = OV.styles[t];
	return n ? "\x1B[" + OV.colors[n][0] + "m" + e + "\x1B[" + OV.colors[n][1] + "m" : e;
}
function AV(e, t) {
	return e;
}
function jV(e) {
	var t = {};
	return e.forEach(function(e, n) {
		t[e] = !0;
	}), t;
}
function MV(e, t, n) {
	if (e.customInspect && t && XV(t.inspect) && t.inspect !== OV && !(t.constructor && t.constructor.prototype === t)) {
		var r = t.inspect(n, e);
		return UV(r) || (r = MV(e, r, n)), r;
	}
	var i = NV(e, t);
	if (i) return i;
	var a = Object.keys(t), o = jV(a);
	if (e.showHidden && (a = Object.getOwnPropertyNames(t)), YV(t) && (a.indexOf("message") >= 0 || a.indexOf("description") >= 0)) return PV(t);
	if (a.length === 0) {
		if (XV(t)) {
			var s = t.name ? ": " + t.name : "";
			return e.stylize("[Function" + s + "]", "special");
		}
		if (KV(t)) return e.stylize(RegExp.prototype.toString.call(t), "regexp");
		if (JV(t)) return e.stylize(Date.prototype.toString.call(t), "date");
		if (YV(t)) return PV(t);
	}
	var c = "", l = !1, u = ["{", "}"];
	if (RV(t) && (l = !0, u = ["[", "]"]), XV(t) && (c = " [Function" + (t.name ? ": " + t.name : "") + "]"), KV(t) && (c = " " + RegExp.prototype.toString.call(t)), JV(t) && (c = " " + Date.prototype.toUTCString.call(t)), YV(t) && (c = " " + PV(t)), a.length === 0 && (!l || t.length == 0)) return u[0] + c + u[1];
	if (n < 0) return KV(t) ? e.stylize(RegExp.prototype.toString.call(t), "regexp") : e.stylize("[Object]", "special");
	e.seen.push(t);
	var d = l ? FV(e, t, n, o, a) : a.map(function(r) {
		return IV(e, t, n, o, r, l);
	});
	return e.seen.pop(), LV(d, c, u);
}
function NV(e, t) {
	if (GV(t)) return e.stylize("undefined", "undefined");
	if (UV(t)) {
		var n = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, "\"") + "'";
		return e.stylize(n, "string");
	}
	if (HV(t)) return e.stylize("" + t, "number");
	if (zV(t)) return e.stylize("" + t, "boolean");
	if (BV(t)) return e.stylize("null", "null");
}
function PV(e) {
	return "[" + Error.prototype.toString.call(e) + "]";
}
function FV(e, t, n, r, i) {
	for (var a = [], o = 0, s = t.length; o < s; ++o) aH(t, String(o)) ? a.push(IV(e, t, n, r, String(o), !0)) : a.push("");
	return i.forEach(function(i) {
		i.match(/^\d+$/) || a.push(IV(e, t, n, r, i, !0));
	}), a;
}
function IV(e, t, n, r, i, a) {
	var o, s, c = Object.getOwnPropertyDescriptor(t, i) || { value: t[i] };
	if (c.get ? s = c.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : c.set && (s = e.stylize("[Setter]", "special")), aH(r, i) || (o = "[" + i + "]"), s || (e.seen.indexOf(c.value) < 0 ? (s = BV(n) ? MV(e, c.value, null) : MV(e, c.value, n - 1), s.indexOf("\n") > -1 && (s = a ? s.split("\n").map(function(e) {
		return "  " + e;
	}).join("\n").substr(2) : "\n" + s.split("\n").map(function(e) {
		return "   " + e;
	}).join("\n"))) : s = e.stylize("[Circular]", "special")), GV(o)) {
		if (a && i.match(/^\d+$/)) return s;
		o = JSON.stringify("" + i), o.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (o = o.substr(1, o.length - 2), o = e.stylize(o, "name")) : (o = o.replace(/'/g, "\\'").replace(/\\"/g, "\"").replace(/(^"|"$)/g, "'"), o = e.stylize(o, "string"));
	}
	return o + ": " + s;
}
function LV(e, t, n) {
	return e.reduce(function(e, t) {
		return t.indexOf("\n"), e + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
	}, 0) > 60 ? n[0] + (t === "" ? "" : t + "\n ") + " " + e.join(",\n  ") + " " + n[1] : n[0] + t + " " + e.join(", ") + " " + n[1];
}
function RV(e) {
	return Array.isArray(e);
}
function zV(e) {
	return typeof e == "boolean";
}
function BV(e) {
	return e === null;
}
function VV(e) {
	return e == null;
}
function HV(e) {
	return typeof e == "number";
}
function UV(e) {
	return typeof e == "string";
}
function WV(e) {
	return typeof e == "symbol";
}
function GV(e) {
	return e === void 0;
}
function KV(e) {
	return qV(e) && $V(e) === "[object RegExp]";
}
function qV(e) {
	return typeof e == "object" && !!e;
}
function JV(e) {
	return qV(e) && $V(e) === "[object Date]";
}
function YV(e) {
	return qV(e) && ($V(e) === "[object Error]" || e instanceof Error);
}
function XV(e) {
	return typeof e == "function";
}
function ZV(e) {
	return e === null || typeof e == "boolean" || typeof e == "number" || typeof e == "string" || typeof e == "symbol" || e === void 0;
}
function QV(e) {
	return Q.isBuffer(e);
}
function $V(e) {
	return Object.prototype.toString.call(e);
}
function eH(e) {
	return e < 10 ? "0" + e.toString(10) : e.toString(10);
}
var tH = [
	"Jan",
	"Feb",
	"Mar",
	"Apr",
	"May",
	"Jun",
	"Jul",
	"Aug",
	"Sep",
	"Oct",
	"Nov",
	"Dec"
];
function nH() {
	var e = /* @__PURE__ */ new Date(), t = [
		eH(e.getHours()),
		eH(e.getMinutes()),
		eH(e.getSeconds())
	].join(":");
	return [
		e.getDate(),
		tH[e.getMonth()],
		t
	].join(" ");
}
function rH() {
	console.log("%s - %s", nH(), CV.apply(null, arguments));
}
function iH(e, t) {
	if (!t || !qV(t)) return e;
	for (var n = Object.keys(t), r = n.length; r--;) e[n[r]] = t[n[r]];
	return e;
}
function aH(e, t) {
	return Object.prototype.hasOwnProperty.call(e, t);
}
var oH = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
function sH(e) {
	if (typeof e != "function") throw TypeError("The \"original\" argument must be of type Function");
	if (oH && e[oH]) {
		var t = e[oH];
		if (typeof t != "function") throw TypeError("The \"util.promisify.custom\" argument must be of type Function");
		return Object.defineProperty(t, oH, {
			value: t,
			enumerable: !1,
			writable: !1,
			configurable: !0
		}), t;
	}
	function t() {
		for (var t, n, r = new Promise(function(e, r) {
			t = e, n = r;
		}), i = [], a = 0; a < arguments.length; a++) i.push(arguments[a]);
		i.push(function(e, r) {
			e ? n(e) : t(r);
		});
		try {
			e.apply(this, i);
		} catch (e) {
			n(e);
		}
		return r;
	}
	return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), oH && Object.defineProperty(t, oH, {
		value: t,
		enumerable: !1,
		writable: !1,
		configurable: !0
	}), Object.defineProperties(t, xV(e));
}
sH.custom = oH;
function cH(e, t) {
	if (!e) {
		var n = /* @__PURE__ */ Error("Promise was rejected with a falsy value");
		n.reason = e, e = n;
	}
	return t(e);
}
function lH(e) {
	if (typeof e != "function") throw TypeError("The \"original\" argument must be of type Function");
	function t() {
		for (var t = [], n = 0; n < arguments.length; n++) t.push(arguments[n]);
		var r = t.pop();
		if (typeof r != "function") throw TypeError("The last argument must be of type Function");
		var i = this, a = function() {
			return r.apply(i, arguments);
		};
		e.apply(this, t).then(function(e) {
			eV.nextTick(a.bind(null, null, e));
		}, function(e) {
			eV.nextTick(cH.bind(null, e, a));
		});
	}
	return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), Object.defineProperties(t, xV(e)), t;
}
var uH = /*@__PURE__*/ dB(/* @__PURE__ */ Object.freeze({
	__proto__: null,
	_extend: iH,
	callbackify: lH,
	debuglog: DV,
	default: {
		inherits: bV,
		_extend: iH,
		log: rH,
		isBuffer: QV,
		isPrimitive: ZV,
		isFunction: XV,
		isError: YV,
		isDate: JV,
		isObject: qV,
		isRegExp: KV,
		isUndefined: GV,
		isSymbol: WV,
		isString: UV,
		isNumber: HV,
		isNullOrUndefined: VV,
		isNull: BV,
		isBoolean: zV,
		isArray: RV,
		inspect: OV,
		deprecate: wV,
		format: CV,
		debuglog: DV,
		promisify: sH,
		callbackify: lH
	},
	deprecate: wV,
	format: CV,
	inherits: bV,
	inspect: OV,
	isArray: RV,
	isBoolean: zV,
	isBuffer: QV,
	isDate: JV,
	isError: YV,
	isFunction: XV,
	isNull: BV,
	isNullOrUndefined: VV,
	isNumber: HV,
	isObject: qV,
	isPrimitive: ZV,
	isRegExp: KV,
	isString: UV,
	isSymbol: WV,
	isUndefined: GV,
	log: rH,
	promisify: sH
})), dH, fH;
function pH() {
	if (fH) return dH;
	fH = 1;
	function e(e, t) {
		var n = Object.keys(e);
		if (Object.getOwnPropertySymbols) {
			var r = Object.getOwnPropertySymbols(e);
			t && (r = r.filter(function(t) {
				return Object.getOwnPropertyDescriptor(e, t).enumerable;
			})), n.push.apply(n, r);
		}
		return n;
	}
	function t(t) {
		for (var r = 1; r < arguments.length; r++) {
			var i = arguments[r] == null ? {} : arguments[r];
			r % 2 ? e(Object(i), !0).forEach(function(e) {
				n(t, e, i[e]);
			}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i)) : e(Object(i)).forEach(function(e) {
				Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(i, e));
			});
		}
		return t;
	}
	function n(e, t, n) {
		return t in e ? Object.defineProperty(e, t, {
			value: n,
			enumerable: !0,
			configurable: !0,
			writable: !0
		}) : e[t] = n, e;
	}
	function r(e, t) {
		if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
	}
	function i(e, t) {
		for (var n = 0; n < t.length; n++) {
			var r = t[n];
			r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
		}
	}
	function a(e, t, n) {
		return t && i(e.prototype, t), e;
	}
	var o = yV.Buffer, s = uH.inspect, c = s && s.custom || "inspect";
	function l(e, t, n) {
		o.prototype.copy.call(e, t, n);
	}
	return dH = /*#__PURE__*/ function() {
		function e() {
			r(this, e), this.head = null, this.tail = null, this.length = 0;
		}
		return a(e, [
			{
				key: "push",
				value: function(e) {
					var t = {
						data: e,
						next: null
					};
					this.length > 0 ? this.tail.next = t : this.head = t, this.tail = t, ++this.length;
				}
			},
			{
				key: "unshift",
				value: function(e) {
					var t = {
						data: e,
						next: this.head
					};
					this.length === 0 && (this.tail = t), this.head = t, ++this.length;
				}
			},
			{
				key: "shift",
				value: function() {
					if (this.length !== 0) {
						var e = this.head.data;
						return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
					}
				}
			},
			{
				key: "clear",
				value: function() {
					this.head = this.tail = null, this.length = 0;
				}
			},
			{
				key: "join",
				value: function(e) {
					if (this.length === 0) return "";
					for (var t = this.head, n = "" + t.data; t = t.next;) n += e + t.data;
					return n;
				}
			},
			{
				key: "concat",
				value: function(e) {
					if (this.length === 0) return o.alloc(0);
					for (var t = o.allocUnsafe(e >>> 0), n = this.head, r = 0; n;) l(n.data, t, r), r += n.data.length, n = n.next;
					return t;
				}
			},
			{
				key: "consume",
				value: function(e, t) {
					var n;
					return e < this.head.data.length ? (n = this.head.data.slice(0, e), this.head.data = this.head.data.slice(e)) : n = e === this.head.data.length ? this.shift() : t ? this._getString(e) : this._getBuffer(e), n;
				}
			},
			{
				key: "first",
				value: function() {
					return this.head.data;
				}
			},
			{
				key: "_getString",
				value: function(e) {
					var t = this.head, n = 1, r = t.data;
					for (e -= r.length; t = t.next;) {
						var i = t.data, a = e > i.length ? i.length : e;
						if (a === i.length ? r += i : r += i.slice(0, e), e -= a, e === 0) {
							a === i.length ? (++n, t.next ? this.head = t.next : this.head = this.tail = null) : (this.head = t, t.data = i.slice(a));
							break;
						}
						++n;
					}
					return this.length -= n, r;
				}
			},
			{
				key: "_getBuffer",
				value: function(e) {
					var t = o.allocUnsafe(e), n = this.head, r = 1;
					for (n.data.copy(t), e -= n.data.length; n = n.next;) {
						var i = n.data, a = e > i.length ? i.length : e;
						if (i.copy(t, t.length - e, 0, a), e -= a, e === 0) {
							a === i.length ? (++r, n.next ? this.head = n.next : this.head = this.tail = null) : (this.head = n, n.data = i.slice(a));
							break;
						}
						++r;
					}
					return this.length -= r, t;
				}
			},
			{
				key: c,
				value: function(e, n) {
					return s(this, t({}, n, {
						depth: 0,
						customInspect: !1
					}));
				}
			}
		]), e;
	}(), dH;
}
function mH(e, t) {
	var n = this, r = this._readableState && this._readableState.destroyed, i = this._writableState && this._writableState.destroyed;
	return r || i ? (t ? t(e) : e && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, eV.nextTick(vH, this, e)) : eV.nextTick(vH, this, e)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(e || null, function(e) {
		!t && e ? n._writableState ? n._writableState.errorEmitted ? eV.nextTick(gH, n) : (n._writableState.errorEmitted = !0, eV.nextTick(hH, n, e)) : eV.nextTick(hH, n, e) : t ? (eV.nextTick(gH, n), t(e)) : eV.nextTick(gH, n);
	}), this);
}
function hH(e, t) {
	vH(e, t), gH(e);
}
function gH(e) {
	e._writableState && !e._writableState.emitClose || e._readableState && !e._readableState.emitClose || e.emit("close");
}
function _H() {
	this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
}
function vH(e, t) {
	e.emit("error", t);
}
function yH(e, t) {
	var n = e._readableState, r = e._writableState;
	n && n.autoDestroy || r && r.autoDestroy ? e.destroy(t) : e.emit("error", t);
}
var bH = {
	destroy: mH,
	undestroy: _H,
	errorOrDestroy: yH
}, xH = {};
function SH(e, t) {
	e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
var CH = {};
function wH(e, t, n) {
	n ||= Error;
	function r(e, n, r) {
		return typeof t == "string" ? t : t(e, n, r);
	}
	var i = /*#__PURE__*/ function(e) {
		SH(t, e);
		function t(t, n, i) {
			return e.call(this, r(t, n, i)) || this;
		}
		return t;
	}(n);
	i.prototype.name = n.name, i.prototype.code = e, CH[e] = i;
}
function TH(e, t) {
	if (Array.isArray(e)) {
		var n = e.length;
		return e = e.map(function(e) {
			return String(e);
		}), n > 2 ? `one of ${t} ${e.slice(0, n - 1).join(", ")}, or ` + e[n - 1] : n === 2 ? `one of ${t} ${e[0]} or ${e[1]}` : `of ${t} ${e[0]}`;
	} else return `of ${t} ${String(e)}`;
}
function EH(e, t, n) {
	return e.substr(0, t.length) === t;
}
function DH(e, t, n) {
	return (n === void 0 || n > e.length) && (n = e.length), e.substring(n - t.length, n) === t;
}
function OH(e, t, n) {
	return typeof n != "number" && (n = 0), n + t.length > e.length ? !1 : e.indexOf(t, n) !== -1;
}
wH("ERR_INVALID_OPT_VALUE", function(e, t) {
	return "The value \"" + t + "\" is invalid for option \"" + e + "\"";
}, TypeError), wH("ERR_INVALID_ARG_TYPE", function(e, t, n) {
	var r;
	typeof t == "string" && EH(t, "not ") ? (r = "must not be", t = t.replace(/^not /, "")) : r = "must be";
	var i = DH(e, " argument") ? `The ${e} ${r} ${TH(t, "type")}` : `The "${e}" ${OH(e, ".") ? "property" : "argument"} ${r} ${TH(t, "type")}`;
	return i += `. Received type ${typeof n}`, i;
}, TypeError), wH("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), wH("ERR_METHOD_NOT_IMPLEMENTED", function(e) {
	return "The " + e + " method is not implemented";
}), wH("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), wH("ERR_STREAM_DESTROYED", function(e) {
	return "Cannot call " + e + " after a stream was destroyed";
}), wH("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), wH("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), wH("ERR_STREAM_WRITE_AFTER_END", "write after end"), wH("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), wH("ERR_UNKNOWN_ENCODING", function(e) {
	return "Unknown encoding: " + e;
}, TypeError), wH("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), xH.codes = CH;
var kH = xH.codes.ERR_INVALID_OPT_VALUE;
function AH(e, t, n) {
	return e.highWaterMark == null ? t ? e[n] : null : e.highWaterMark;
}
function jH(e, t, n, r) {
	var i = AH(t, r, n);
	if (i != null) {
		if (!(isFinite(i) && Math.floor(i) === i) || i < 0) throw new kH(r ? n : "highWaterMark", i);
		return Math.floor(i);
	}
	return e.objectMode ? 16 : 16 * 1024;
}
var MH = { getHighWaterMark: jH }, NH = /*@__PURE__*/ dB(/* @__PURE__ */ Object.freeze({
	__proto__: null,
	default: typeof Object.create == "function" ? function(e, t) {
		e.super_ = t, e.prototype = Object.create(t.prototype, { constructor: {
			value: e,
			enumerable: !1,
			writable: !0,
			configurable: !0
		} });
	} : function(e, t) {
		e.super_ = t;
		var n = function() {};
		n.prototype = t.prototype, e.prototype = new n(), e.prototype.constructor = e;
	}
})), PH = Q.isEncoding || function(e) {
	switch (e && e.toLowerCase()) {
		case "hex":
		case "utf8":
		case "utf-8":
		case "ascii":
		case "binary":
		case "base64":
		case "ucs2":
		case "ucs-2":
		case "utf16le":
		case "utf-16le":
		case "raw": return !0;
		default: return !1;
	}
};
function FH(e) {
	if (e && !PH(e)) throw Error("Unknown encoding: " + e);
}
function IH(e) {
	switch (this.encoding = (e || "utf8").toLowerCase().replace(/[-_]/, ""), FH(e), this.encoding) {
		case "utf8":
			this.surrogateSize = 3;
			break;
		case "ucs2":
		case "utf16le":
			this.surrogateSize = 2, this.detectIncompleteChar = RH;
			break;
		case "base64":
			this.surrogateSize = 3, this.detectIncompleteChar = zH;
			break;
		default:
			this.write = LH;
			return;
	}
	this.charBuffer = new Q(6), this.charReceived = 0, this.charLength = 0;
}
IH.prototype.write = function(e) {
	for (var t = ""; this.charLength;) {
		var n = e.length >= this.charLength - this.charReceived ? this.charLength - this.charReceived : e.length;
		if (e.copy(this.charBuffer, this.charReceived, 0, n), this.charReceived += n, this.charReceived < this.charLength) return "";
		e = e.slice(n, e.length), t = this.charBuffer.slice(0, this.charLength).toString(this.encoding);
		var r = t.charCodeAt(t.length - 1);
		if (r >= 55296 && r <= 56319) {
			this.charLength += this.surrogateSize, t = "";
			continue;
		}
		if (this.charReceived = this.charLength = 0, e.length === 0) return t;
		break;
	}
	this.detectIncompleteChar(e);
	var i = e.length;
	this.charLength && (e.copy(this.charBuffer, 0, e.length - this.charReceived, i), i -= this.charReceived), t += e.toString(this.encoding, 0, i);
	var i = t.length - 1, r = t.charCodeAt(i);
	if (r >= 55296 && r <= 56319) {
		var a = this.surrogateSize;
		return this.charLength += a, this.charReceived += a, this.charBuffer.copy(this.charBuffer, a, 0, a), e.copy(this.charBuffer, 0, 0, a), t.substring(0, i);
	}
	return t;
}, IH.prototype.detectIncompleteChar = function(e) {
	for (var t = e.length >= 3 ? 3 : e.length; t > 0; t--) {
		var n = e[e.length - t];
		if (t == 1 && n >> 5 == 6) {
			this.charLength = 2;
			break;
		}
		if (t <= 2 && n >> 4 == 14) {
			this.charLength = 3;
			break;
		}
		if (t <= 3 && n >> 3 == 30) {
			this.charLength = 4;
			break;
		}
	}
	this.charReceived = t;
}, IH.prototype.end = function(e) {
	var t = "";
	if (e && e.length && (t = this.write(e)), this.charReceived) {
		var n = this.charReceived, r = this.charBuffer, i = this.encoding;
		t += r.slice(0, n).toString(i);
	}
	return t;
};
function LH(e) {
	return e.toString(this.encoding);
}
function RH(e) {
	this.charReceived = e.length % 2, this.charLength = this.charReceived ? 2 : 0;
}
function zH(e) {
	this.charReceived = e.length % 3, this.charLength = this.charReceived ? 3 : 0;
}
var BH = /*@__PURE__*/ dB(/* @__PURE__ */ Object.freeze({
	__proto__: null,
	StringDecoder: IH
})), VH = xH.codes.ERR_STREAM_PREMATURE_CLOSE;
function HH(e) {
	var t = !1;
	return function() {
		if (!t) {
			t = !0;
			var n = [...arguments];
			e.apply(this, n);
		}
	};
}
function UH() {}
function WH(e) {
	return e.setHeader && typeof e.abort == "function";
}
function GH(e, t, n) {
	if (typeof t == "function") return GH(e, null, t);
	t ||= {}, n = HH(n || UH);
	var r = t.readable || t.readable !== !1 && e.readable, i = t.writable || t.writable !== !1 && e.writable, a = function() {
		e.writable || s();
	}, o = e._writableState && e._writableState.finished, s = function() {
		i = !1, o = !0, r || n.call(e);
	}, c = e._readableState && e._readableState.endEmitted, l = function() {
		r = !1, c = !0, i || n.call(e);
	}, u = function(t) {
		n.call(e, t);
	}, d = function() {
		var t;
		if (r && !c) return (!e._readableState || !e._readableState.ended) && (t = new VH()), n.call(e, t);
		if (i && !o) return (!e._writableState || !e._writableState.ended) && (t = new VH()), n.call(e, t);
	}, f = function() {
		e.req.on("finish", s);
	};
	return WH(e) ? (e.on("complete", s), e.on("abort", d), e.req ? f() : e.on("request", f)) : i && !e._writableState && (e.on("end", a), e.on("close", a)), e.on("end", l), e.on("finish", s), t.error !== !1 && e.on("error", u), e.on("close", d), function() {
		e.removeListener("complete", s), e.removeListener("abort", d), e.removeListener("request", f), e.req && e.req.removeListener("finish", s), e.removeListener("end", a), e.removeListener("close", a), e.removeListener("finish", s), e.removeListener("end", l), e.removeListener("error", u), e.removeListener("close", d);
	};
}
var KH = GH, qH, JH;
function YH() {
	if (JH) return qH;
	JH = 1;
	var e;
	function t(e, t, n) {
		return t in e ? Object.defineProperty(e, t, {
			value: n,
			enumerable: !0,
			configurable: !0,
			writable: !0
		}) : e[t] = n, e;
	}
	var n = KH, r = Symbol("lastResolve"), i = Symbol("lastReject"), a = Symbol("error"), o = Symbol("ended"), s = Symbol("lastPromise"), c = Symbol("handlePromise"), l = Symbol("stream");
	function u(e, t) {
		return {
			value: e,
			done: t
		};
	}
	function d(e) {
		var t = e[r];
		if (t !== null) {
			var n = e[l].read();
			n !== null && (e[s] = null, e[r] = null, e[i] = null, t(u(n, !1)));
		}
	}
	function f(e) {
		eV.nextTick(d, e);
	}
	function p(e, t) {
		return function(n, r) {
			e.then(function() {
				if (t[o]) {
					n(u(void 0, !0));
					return;
				}
				t[c](n, r);
			}, r);
		};
	}
	var m = Object.getPrototypeOf(function() {}), h = Object.setPrototypeOf((e = {
		get stream() {
			return this[l];
		},
		next: function() {
			var e = this, t = this[a];
			if (t !== null) return Promise.reject(t);
			if (this[o]) return Promise.resolve(u(void 0, !0));
			if (this[l].destroyed) return new Promise(function(t, n) {
				eV.nextTick(function() {
					e[a] ? n(e[a]) : t(u(void 0, !0));
				});
			});
			var n = this[s], r;
			if (n) r = new Promise(p(n, this));
			else {
				var i = this[l].read();
				if (i !== null) return Promise.resolve(u(i, !1));
				r = new Promise(this[c]);
			}
			return this[s] = r, r;
		}
	}, t(e, Symbol.asyncIterator, function() {
		return this;
	}), t(e, "return", function() {
		var e = this;
		return new Promise(function(t, n) {
			e[l].destroy(null, function(e) {
				if (e) {
					n(e);
					return;
				}
				t(u(void 0, !0));
			});
		});
	}), e), m);
	return qH = function(e) {
		var d, p = Object.create(h, (d = {}, t(d, l, {
			value: e,
			writable: !0
		}), t(d, r, {
			value: null,
			writable: !0
		}), t(d, i, {
			value: null,
			writable: !0
		}), t(d, a, {
			value: null,
			writable: !0
		}), t(d, o, {
			value: e._readableState.endEmitted,
			writable: !0
		}), t(d, c, {
			value: function(e, t) {
				var n = p[l].read();
				n ? (p[s] = null, p[r] = null, p[i] = null, e(u(n, !1))) : (p[r] = e, p[i] = t);
			},
			writable: !0
		}), d));
		return p[s] = null, n(e, function(e) {
			if (e && e.code !== "ERR_STREAM_PREMATURE_CLOSE") {
				var t = p[i];
				t !== null && (p[s] = null, p[r] = null, p[i] = null, t(e)), p[a] = e;
				return;
			}
			var n = p[r];
			n !== null && (p[s] = null, p[r] = null, p[i] = null, n(u(void 0, !0))), p[o] = !0;
		}), e.on("readable", f.bind(null, p)), p;
	}, qH;
}
var XH, ZH;
function QH() {
	return ZH ? XH : (ZH = 1, XH = function() {
		throw Error("Readable.from is not available in the browser");
	}, XH);
}
var $H = pB;
$H.Readable = CU, CU.ReadableState = SU, _V.EventEmitter;
var eU = function(e, t) {
	return e.listeners(t).length;
}, tU = vV, nU = yV.Buffer, rU = lB.Uint8Array || function() {};
function iU(e) {
	return nU.from(e);
}
function aU(e) {
	return nU.isBuffer(e) || e instanceof rU;
}
var oU = uH, sU = oU && oU.debuglog ? oU.debuglog("stream") : function() {}, cU = pH(), lU = bH, uU = MH.getHighWaterMark, dU = xH.codes, fU = dU.ERR_INVALID_ARG_TYPE, pU = dU.ERR_STREAM_PUSH_AFTER_EOF, mU = dU.ERR_METHOD_NOT_IMPLEMENTED, hU = dU.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, gU, _U, vU;
NH(CU, tU);
var yU = lU.errorOrDestroy, bU = [
	"error",
	"close",
	"destroy",
	"pause",
	"resume"
];
function xU(e, t, n) {
	if (typeof e.prependListener == "function") return e.prependListener(t, n);
	!e._events || !e._events[t] ? e.on(t, n) : Array.isArray(e._events[t]) ? e._events[t].unshift(n) : e._events[t] = [n, e._events[t]];
}
function SU(e, t, n) {
	e ||= {}, typeof n != "boolean" && (n = t instanceof $H.Duplex), this.objectMode = !!e.objectMode, n && (this.objectMode = this.objectMode || !!e.readableObjectMode), this.highWaterMark = uU(this, e, "readableHighWaterMark", n), this.buffer = new cU(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = e.emitClose !== !1, this.autoDestroy = !!e.autoDestroy, this.destroyed = !1, this.defaultEncoding = e.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, e.encoding && (gU ||= BH.StringDecoder, this.decoder = new gU(e.encoding), this.encoding = e.encoding);
}
function CU(e) {
	if (!(this instanceof CU)) return new CU(e);
	var t = this instanceof $H.Duplex;
	this._readableState = new SU(e, this, t), this.readable = !0, e && (typeof e.read == "function" && (this._read = e.read), typeof e.destroy == "function" && (this._destroy = e.destroy)), tU.call(this);
}
Object.defineProperty(CU.prototype, "destroyed", {
	enumerable: !1,
	get: function() {
		return this._readableState === void 0 ? !1 : this._readableState.destroyed;
	},
	set: function(e) {
		this._readableState && (this._readableState.destroyed = e);
	}
}), CU.prototype.destroy = lU.destroy, CU.prototype._undestroy = lU.undestroy, CU.prototype._destroy = function(e, t) {
	t(e);
}, CU.prototype.push = function(e, t) {
	var n = this._readableState, r;
	return n.objectMode ? r = !0 : typeof e == "string" && (t ||= n.defaultEncoding, t !== n.encoding && (e = nU.from(e, t), t = ""), r = !0), wU(this, e, t, !1, r);
}, CU.prototype.unshift = function(e) {
	return wU(this, e, null, !0, !1);
};
function wU(e, t, n, r, i) {
	sU("readableAddChunk", t);
	var a = e._readableState;
	if (t === null) a.reading = !1, AU(e, a);
	else {
		var o;
		if (i || (o = EU(a, t)), o) yU(e, o);
		else if (a.objectMode || t && t.length > 0) if (typeof t != "string" && !a.objectMode && Object.getPrototypeOf(t) !== nU.prototype && (t = iU(t)), r) a.endEmitted ? yU(e, new hU()) : TU(e, a, t, !0);
		else if (a.ended) yU(e, new pU());
		else if (a.destroyed) return !1;
		else a.reading = !1, a.decoder && !n ? (t = a.decoder.write(t), a.objectMode || t.length !== 0 ? TU(e, a, t, !1) : NU(e, a)) : TU(e, a, t, !1);
		else r || (a.reading = !1, NU(e, a));
	}
	return !a.ended && (a.length < a.highWaterMark || a.length === 0);
}
function TU(e, t, n, r) {
	t.flowing && t.length === 0 && !t.sync ? (t.awaitDrain = 0, e.emit("data", n)) : (t.length += t.objectMode ? 1 : n.length, r ? t.buffer.unshift(n) : t.buffer.push(n), t.needReadable && jU(e)), NU(e, t);
}
function EU(e, t) {
	var n;
	return !aU(t) && typeof t != "string" && t !== void 0 && !e.objectMode && (n = new fU("chunk", [
		"string",
		"Buffer",
		"Uint8Array"
	], t)), n;
}
CU.prototype.isPaused = function() {
	return this._readableState.flowing === !1;
}, CU.prototype.setEncoding = function(e) {
	gU ||= BH.StringDecoder;
	var t = new gU(e);
	this._readableState.decoder = t, this._readableState.encoding = this._readableState.decoder.encoding;
	for (var n = this._readableState.buffer.head, r = ""; n !== null;) r += t.write(n.data), n = n.next;
	return this._readableState.buffer.clear(), r !== "" && this._readableState.buffer.push(r), this._readableState.length = r.length, this;
};
var DU = 1073741824;
function OU(e) {
	return e >= DU ? e = DU : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
}
function kU(e, t) {
	return e <= 0 || t.length === 0 && t.ended ? 0 : t.objectMode ? 1 : e === e ? (e > t.highWaterMark && (t.highWaterMark = OU(e)), e <= t.length ? e : t.ended ? t.length : (t.needReadable = !0, 0)) : t.flowing && t.length ? t.buffer.head.data.length : t.length;
}
CU.prototype.read = function(e) {
	sU("read", e), e = parseInt(e, 10);
	var t = this._readableState, n = e;
	if (e !== 0 && (t.emittedReadable = !1), e === 0 && t.needReadable && ((t.highWaterMark === 0 ? t.length > 0 : t.length >= t.highWaterMark) || t.ended)) return sU("read: emitReadable", t.length, t.ended), t.length === 0 && t.ended ? HU(this) : jU(this), null;
	if (e = kU(e, t), e === 0 && t.ended) return t.length === 0 && HU(this), null;
	var r = t.needReadable;
	sU("need readable", r), (t.length === 0 || t.length - e < t.highWaterMark) && (r = !0, sU("length less than watermark", r)), t.ended || t.reading ? (r = !1, sU("reading or ended", r)) : r && (sU("do read"), t.reading = !0, t.sync = !0, t.length === 0 && (t.needReadable = !0), this._read(t.highWaterMark), t.sync = !1, t.reading || (e = kU(n, t)));
	var i = e > 0 ? VU(e, t) : null;
	return i === null ? (t.needReadable = t.length <= t.highWaterMark, e = 0) : (t.length -= e, t.awaitDrain = 0), t.length === 0 && (t.ended || (t.needReadable = !0), n !== e && t.ended && HU(this)), i !== null && this.emit("data", i), i;
};
function AU(e, t) {
	if (sU("onEofChunk"), !t.ended) {
		if (t.decoder) {
			var n = t.decoder.end();
			n && n.length && (t.buffer.push(n), t.length += t.objectMode ? 1 : n.length);
		}
		t.ended = !0, t.sync ? jU(e) : (t.needReadable = !1, t.emittedReadable || (t.emittedReadable = !0, MU(e)));
	}
}
function jU(e) {
	var t = e._readableState;
	sU("emitReadable", t.needReadable, t.emittedReadable), t.needReadable = !1, t.emittedReadable || (sU("emitReadable", t.flowing), t.emittedReadable = !0, eV.nextTick(MU, e));
}
function MU(e) {
	var t = e._readableState;
	sU("emitReadable_", t.destroyed, t.length, t.ended), !t.destroyed && (t.length || t.ended) && (e.emit("readable"), t.emittedReadable = !1), t.needReadable = !t.flowing && !t.ended && t.length <= t.highWaterMark, BU(e);
}
function NU(e, t) {
	t.readingMore || (t.readingMore = !0, eV.nextTick(PU, e, t));
}
function PU(e, t) {
	for (; !t.reading && !t.ended && (t.length < t.highWaterMark || t.flowing && t.length === 0);) {
		var n = t.length;
		if (sU("maybeReadMore read 0"), e.read(0), n === t.length) break;
	}
	t.readingMore = !1;
}
CU.prototype._read = function(e) {
	yU(this, new mU("_read()"));
}, CU.prototype.pipe = function(e, t) {
	var n = this, r = this._readableState;
	switch (r.pipesCount) {
		case 0:
			r.pipes = e;
			break;
		case 1:
			r.pipes = [r.pipes, e];
			break;
		default:
			r.pipes.push(e);
			break;
	}
	r.pipesCount += 1, sU("pipe count=%d opts=%j", r.pipesCount, t);
	var i = (!t || t.end !== !1) && e !== eV.stdout && e !== eV.stderr ? o : m;
	r.endEmitted ? eV.nextTick(i) : n.once("end", i), e.on("unpipe", a);
	function a(e, t) {
		sU("onunpipe"), e === n && t && t.hasUnpiped === !1 && (t.hasUnpiped = !0, l());
	}
	function o() {
		sU("onend"), e.end();
	}
	var s = FU(n);
	e.on("drain", s);
	var c = !1;
	function l() {
		sU("cleanup"), e.removeListener("close", f), e.removeListener("finish", p), e.removeListener("drain", s), e.removeListener("error", d), e.removeListener("unpipe", a), n.removeListener("end", o), n.removeListener("end", m), n.removeListener("data", u), c = !0, r.awaitDrain && (!e._writableState || e._writableState.needDrain) && s();
	}
	n.on("data", u);
	function u(t) {
		sU("ondata");
		var i = e.write(t);
		sU("dest.write", i), i === !1 && ((r.pipesCount === 1 && r.pipes === e || r.pipesCount > 1 && WU(r.pipes, e) !== -1) && !c && (sU("false write response, pause", r.awaitDrain), r.awaitDrain++), n.pause());
	}
	function d(t) {
		sU("onerror", t), m(), e.removeListener("error", d), eU(e, "error") === 0 && yU(e, t);
	}
	xU(e, "error", d);
	function f() {
		e.removeListener("finish", p), m();
	}
	e.once("close", f);
	function p() {
		sU("onfinish"), e.removeListener("close", f), m();
	}
	e.once("finish", p);
	function m() {
		sU("unpipe"), n.unpipe(e);
	}
	return e.emit("pipe", n), r.flowing || (sU("pipe resume"), n.resume()), e;
};
function FU(e) {
	return function() {
		var t = e._readableState;
		sU("pipeOnDrain", t.awaitDrain), t.awaitDrain && t.awaitDrain--, t.awaitDrain === 0 && eU(e, "data") && (t.flowing = !0, BU(e));
	};
}
CU.prototype.unpipe = function(e) {
	var t = this._readableState, n = { hasUnpiped: !1 };
	if (t.pipesCount === 0) return this;
	if (t.pipesCount === 1) return e && e !== t.pipes ? this : (e ||= t.pipes, t.pipes = null, t.pipesCount = 0, t.flowing = !1, e && e.emit("unpipe", this, n), this);
	if (!e) {
		var r = t.pipes, i = t.pipesCount;
		t.pipes = null, t.pipesCount = 0, t.flowing = !1;
		for (var a = 0; a < i; a++) r[a].emit("unpipe", this, { hasUnpiped: !1 });
		return this;
	}
	var o = WU(t.pipes, e);
	return o === -1 ? this : (t.pipes.splice(o, 1), --t.pipesCount, t.pipesCount === 1 && (t.pipes = t.pipes[0]), e.emit("unpipe", this, n), this);
}, CU.prototype.on = function(e, t) {
	var n = tU.prototype.on.call(this, e, t), r = this._readableState;
	return e === "data" ? (r.readableListening = this.listenerCount("readable") > 0, r.flowing !== !1 && this.resume()) : e === "readable" && !r.endEmitted && !r.readableListening && (r.readableListening = r.needReadable = !0, r.flowing = !1, r.emittedReadable = !1, sU("on readable", r.length, r.reading), r.length ? jU(this) : r.reading || eV.nextTick(LU, this)), n;
}, CU.prototype.addListener = CU.prototype.on, CU.prototype.removeListener = function(e, t) {
	var n = tU.prototype.removeListener.call(this, e, t);
	return e === "readable" && eV.nextTick(IU, this), n;
}, CU.prototype.removeAllListeners = function(e) {
	var t = tU.prototype.removeAllListeners.apply(this, arguments);
	return (e === "readable" || e === void 0) && eV.nextTick(IU, this), t;
};
function IU(e) {
	var t = e._readableState;
	t.readableListening = e.listenerCount("readable") > 0, t.resumeScheduled && !t.paused ? t.flowing = !0 : e.listenerCount("data") > 0 && e.resume();
}
function LU(e) {
	sU("readable nexttick read 0"), e.read(0);
}
CU.prototype.resume = function() {
	var e = this._readableState;
	return e.flowing || (sU("resume"), e.flowing = !e.readableListening, RU(this, e)), e.paused = !1, this;
};
function RU(e, t) {
	t.resumeScheduled || (t.resumeScheduled = !0, eV.nextTick(zU, e, t));
}
function zU(e, t) {
	sU("resume", t.reading), t.reading || e.read(0), t.resumeScheduled = !1, e.emit("resume"), BU(e), t.flowing && !t.reading && e.read(0);
}
CU.prototype.pause = function() {
	return sU("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (sU("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
};
function BU(e) {
	var t = e._readableState;
	for (sU("flow", t.flowing); t.flowing && e.read() !== null;);
}
CU.prototype.wrap = function(e) {
	var t = this, n = this._readableState, r = !1;
	for (var i in e.on("end", function() {
		if (sU("wrapped end"), n.decoder && !n.ended) {
			var e = n.decoder.end();
			e && e.length && t.push(e);
		}
		t.push(null);
	}), e.on("data", function(i) {
		sU("wrapped data"), n.decoder && (i = n.decoder.write(i)), !(n.objectMode && i == null) && (!n.objectMode && (!i || !i.length) || t.push(i) || (r = !0, e.pause()));
	}), e) this[i] === void 0 && typeof e[i] == "function" && (this[i] = function(t) {
		return function() {
			return e[t].apply(e, arguments);
		};
	}(i));
	for (var a = 0; a < bU.length; a++) e.on(bU[a], this.emit.bind(this, bU[a]));
	return this._read = function(t) {
		sU("wrapped _read", t), r && (r = !1, e.resume());
	}, this;
}, typeof Symbol == "function" && (CU.prototype[Symbol.asyncIterator] = function() {
	return _U === void 0 && (_U = YH()), _U(this);
}), Object.defineProperty(CU.prototype, "readableHighWaterMark", {
	enumerable: !1,
	get: function() {
		return this._readableState.highWaterMark;
	}
}), Object.defineProperty(CU.prototype, "readableBuffer", {
	enumerable: !1,
	get: function() {
		return this._readableState && this._readableState.buffer;
	}
}), Object.defineProperty(CU.prototype, "readableFlowing", {
	enumerable: !1,
	get: function() {
		return this._readableState.flowing;
	},
	set: function(e) {
		this._readableState && (this._readableState.flowing = e);
	}
}), CU._fromList = VU, Object.defineProperty(CU.prototype, "readableLength", {
	enumerable: !1,
	get: function() {
		return this._readableState.length;
	}
});
function VU(e, t) {
	if (t.length === 0) return null;
	var n;
	return t.objectMode ? n = t.buffer.shift() : !e || e >= t.length ? (n = t.decoder ? t.buffer.join("") : t.buffer.length === 1 ? t.buffer.first() : t.buffer.concat(t.length), t.buffer.clear()) : n = t.buffer.consume(e, t.decoder), n;
}
function HU(e) {
	var t = e._readableState;
	sU("endReadable", t.endEmitted), t.endEmitted || (t.ended = !0, eV.nextTick(UU, t, e));
}
function UU(e, t) {
	if (sU("endReadableNT", e.endEmitted, e.length), !e.endEmitted && e.length === 0 && (e.endEmitted = !0, t.readable = !1, t.emit("end"), e.autoDestroy)) {
		var n = t._writableState;
		(!n || n.autoDestroy && n.finished) && t.destroy();
	}
}
typeof Symbol == "function" && (CU.from = function(e, t) {
	return vU === void 0 && (vU = QH()), vU(CU, e, t);
});
function WU(e, t) {
	for (var n = 0, r = e.length; n < r; n++) if (e[n] === t) return n;
	return -1;
}
var GU = KU;
function KU(e, t) {
	if (qU("noDeprecation")) return e;
	var n = !1;
	function r() {
		if (!n) {
			if (qU("throwDeprecation")) throw Error(t);
			qU("traceDeprecation") ? console.trace(t) : console.warn(t), n = !0;
		}
		return e.apply(this, arguments);
	}
	return r;
}
function qU(e) {
	try {
		if (!lB.localStorage) return !1;
	} catch {
		return !1;
	}
	var t = lB.localStorage[e];
	return t == null ? !1 : String(t).toLowerCase() === "true";
}
var JU = pB;
JU.Writable = _W;
function YU(e) {
	var t = this;
	this.next = null, this.entry = null, this.finish = function() {
		PW(t, e);
	};
}
_W.WritableState = hW;
var XU = { deprecate: GU }, ZU = vV, QU = yV.Buffer, $U = lB.Uint8Array || function() {};
function eW(e) {
	return QU.from(e);
}
function tW(e) {
	return QU.isBuffer(e) || e instanceof $U;
}
var nW = bH, rW = MH.getHighWaterMark, iW = xH.codes, aW = iW.ERR_INVALID_ARG_TYPE, oW = iW.ERR_METHOD_NOT_IMPLEMENTED, sW = iW.ERR_MULTIPLE_CALLBACK, cW = iW.ERR_STREAM_CANNOT_PIPE, lW = iW.ERR_STREAM_DESTROYED, uW = iW.ERR_STREAM_NULL_VALUES, dW = iW.ERR_STREAM_WRITE_AFTER_END, fW = iW.ERR_UNKNOWN_ENCODING, pW = nW.errorOrDestroy;
NH(_W, ZU);
function mW() {}
function hW(e, t, n) {
	e ||= {}, typeof n != "boolean" && (n = t instanceof JU.Duplex), this.objectMode = !!e.objectMode, n && (this.objectMode = this.objectMode || !!e.writableObjectMode), this.highWaterMark = rW(this, e, "writableHighWaterMark", n), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
	var r = e.decodeStrings === !1;
	this.decodeStrings = !r, this.defaultEncoding = e.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(e) {
		TW(t, e);
	}, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = e.emitClose !== !1, this.autoDestroy = !!e.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new YU(this);
}
hW.prototype.getBuffer = function() {
	for (var e = this.bufferedRequest, t = []; e;) t.push(e), e = e.next;
	return t;
}, (function() {
	try {
		Object.defineProperty(hW.prototype, "buffer", { get: XU.deprecate(function() {
			return this.getBuffer();
		}, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003") });
	} catch {}
})();
var gW;
typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (gW = Function.prototype[Symbol.hasInstance], Object.defineProperty(_W, Symbol.hasInstance, { value: function(e) {
	return gW.call(this, e) ? !0 : this === _W ? e && e._writableState instanceof hW : !1;
} })) : gW = function(e) {
	return e instanceof this;
};
function _W(e) {
	var t = this instanceof JU.Duplex;
	if (!t && !gW.call(_W, this)) return new _W(e);
	this._writableState = new hW(e, this, t), this.writable = !0, e && (typeof e.write == "function" && (this._write = e.write), typeof e.writev == "function" && (this._writev = e.writev), typeof e.destroy == "function" && (this._destroy = e.destroy), typeof e.final == "function" && (this._final = e.final)), ZU.call(this);
}
_W.prototype.pipe = function() {
	pW(this, new cW());
};
function vW(e, t) {
	var n = new dW();
	pW(e, n), eV.nextTick(t, n);
}
function yW(e, t, n, r) {
	var i;
	return n === null ? i = new uW() : typeof n != "string" && !t.objectMode && (i = new aW("chunk", ["string", "Buffer"], n)), i ? (pW(e, i), eV.nextTick(r, i), !1) : !0;
}
_W.prototype.write = function(e, t, n) {
	var r = this._writableState, i = !1, a = !r.objectMode && tW(e);
	return a && !QU.isBuffer(e) && (e = eW(e)), typeof t == "function" && (n = t, t = null), a ? t = "buffer" : t ||= r.defaultEncoding, typeof n != "function" && (n = mW), r.ending ? vW(this, n) : (a || yW(this, r, e, n)) && (r.pendingcb++, i = xW(this, r, a, e, t, n)), i;
}, _W.prototype.cork = function() {
	this._writableState.corked++;
}, _W.prototype.uncork = function() {
	var e = this._writableState;
	e.corked && (e.corked--, !e.writing && !e.corked && !e.bufferProcessing && e.bufferedRequest && OW(this, e));
}, _W.prototype.setDefaultEncoding = function(e) {
	if (typeof e == "string" && (e = e.toLowerCase()), !([
		"hex",
		"utf8",
		"utf-8",
		"ascii",
		"binary",
		"base64",
		"ucs2",
		"ucs-2",
		"utf16le",
		"utf-16le",
		"raw"
	].indexOf((e + "").toLowerCase()) > -1)) throw new fW(e);
	return this._writableState.defaultEncoding = e, this;
}, Object.defineProperty(_W.prototype, "writableBuffer", {
	enumerable: !1,
	get: function() {
		return this._writableState && this._writableState.getBuffer();
	}
});
function bW(e, t, n) {
	return !e.objectMode && e.decodeStrings !== !1 && typeof t == "string" && (t = QU.from(t, n)), t;
}
Object.defineProperty(_W.prototype, "writableHighWaterMark", {
	enumerable: !1,
	get: function() {
		return this._writableState.highWaterMark;
	}
});
function xW(e, t, n, r, i, a) {
	if (!n) {
		var o = bW(t, r, i);
		r !== o && (n = !0, i = "buffer", r = o);
	}
	var s = t.objectMode ? 1 : r.length;
	t.length += s;
	var c = t.length < t.highWaterMark;
	if (c || (t.needDrain = !0), t.writing || t.corked) {
		var l = t.lastBufferedRequest;
		t.lastBufferedRequest = {
			chunk: r,
			encoding: i,
			isBuf: n,
			callback: a,
			next: null
		}, l ? l.next = t.lastBufferedRequest : t.bufferedRequest = t.lastBufferedRequest, t.bufferedRequestCount += 1;
	} else SW(e, t, !1, s, r, i, a);
	return c;
}
function SW(e, t, n, r, i, a, o) {
	t.writelen = r, t.writecb = o, t.writing = !0, t.sync = !0, t.destroyed ? t.onwrite(new lW("write")) : n ? e._writev(i, t.onwrite) : e._write(i, a, t.onwrite), t.sync = !1;
}
function CW(e, t, n, r, i) {
	--t.pendingcb, n ? (eV.nextTick(i, r), eV.nextTick(MW, e, t), e._writableState.errorEmitted = !0, pW(e, r)) : (i(r), e._writableState.errorEmitted = !0, pW(e, r), MW(e, t));
}
function wW(e) {
	e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
}
function TW(e, t) {
	var n = e._writableState, r = n.sync, i = n.writecb;
	if (typeof i != "function") throw new sW();
	if (wW(n), t) CW(e, n, r, t, i);
	else {
		var a = kW(n) || e.destroyed;
		!a && !n.corked && !n.bufferProcessing && n.bufferedRequest && OW(e, n), r ? eV.nextTick(EW, e, n, a, i) : EW(e, n, a, i);
	}
}
function EW(e, t, n, r) {
	n || DW(e, t), t.pendingcb--, r(), MW(e, t);
}
function DW(e, t) {
	t.length === 0 && t.needDrain && (t.needDrain = !1, e.emit("drain"));
}
function OW(e, t) {
	t.bufferProcessing = !0;
	var n = t.bufferedRequest;
	if (e._writev && n && n.next) {
		var r = t.bufferedRequestCount, i = Array(r), a = t.corkedRequestsFree;
		a.entry = n;
		for (var o = 0, s = !0; n;) i[o] = n, n.isBuf || (s = !1), n = n.next, o += 1;
		i.allBuffers = s, SW(e, t, !0, t.length, i, "", a.finish), t.pendingcb++, t.lastBufferedRequest = null, a.next ? (t.corkedRequestsFree = a.next, a.next = null) : t.corkedRequestsFree = new YU(t), t.bufferedRequestCount = 0;
	} else {
		for (; n;) {
			var c = n.chunk, l = n.encoding, u = n.callback;
			if (SW(e, t, !1, t.objectMode ? 1 : c.length, c, l, u), n = n.next, t.bufferedRequestCount--, t.writing) break;
		}
		n === null && (t.lastBufferedRequest = null);
	}
	t.bufferedRequest = n, t.bufferProcessing = !1;
}
_W.prototype._write = function(e, t, n) {
	n(new oW("_write()"));
}, _W.prototype._writev = null, _W.prototype.end = function(e, t, n) {
	var r = this._writableState;
	return typeof e == "function" ? (n = e, e = null, t = null) : typeof t == "function" && (n = t, t = null), e != null && this.write(e, t), r.corked && (r.corked = 1, this.uncork()), r.ending || NW(this, r, n), this;
}, Object.defineProperty(_W.prototype, "writableLength", {
	enumerable: !1,
	get: function() {
		return this._writableState.length;
	}
});
function kW(e) {
	return e.ending && e.length === 0 && e.bufferedRequest === null && !e.finished && !e.writing;
}
function AW(e, t) {
	e._final(function(n) {
		t.pendingcb--, n && pW(e, n), t.prefinished = !0, e.emit("prefinish"), MW(e, t);
	});
}
function jW(e, t) {
	!t.prefinished && !t.finalCalled && (typeof e._final == "function" && !t.destroyed ? (t.pendingcb++, t.finalCalled = !0, eV.nextTick(AW, e, t)) : (t.prefinished = !0, e.emit("prefinish")));
}
function MW(e, t) {
	var n = kW(t);
	if (n && (jW(e, t), t.pendingcb === 0 && (t.finished = !0, e.emit("finish"), t.autoDestroy))) {
		var r = e._readableState;
		(!r || r.autoDestroy && r.endEmitted) && e.destroy();
	}
	return n;
}
function NW(e, t, n) {
	t.ending = !0, MW(e, t), n && (t.finished ? eV.nextTick(n) : e.once("finish", n)), t.ended = !0, e.writable = !1;
}
function PW(e, t, n) {
	var r = e.entry;
	for (e.entry = null; r;) {
		var i = r.callback;
		t.pendingcb--, i(n), r = r.next;
	}
	t.corkedRequestsFree.next = e;
}
Object.defineProperty(_W.prototype, "destroyed", {
	enumerable: !1,
	get: function() {
		return this._writableState === void 0 ? !1 : this._writableState.destroyed;
	},
	set: function(e) {
		this._writableState && (this._writableState.destroyed = e);
	}
}), _W.prototype.destroy = nW.destroy, _W.prototype._undestroy = nW.undestroy, _W.prototype._destroy = function(e, t) {
	t(e);
};
var FW = Object.keys || function(e) {
	var t = [];
	for (var n in e) t.push(n);
	return t;
}, IW = pB;
IW.Duplex = BW, NH(BW, IW.Readable);
for (var LW = FW(IW.Writable.prototype), RW = 0; RW < LW.length; RW++) {
	var zW = LW[RW];
	BW.prototype[zW] || (BW.prototype[zW] = IW.Writable.prototype[zW]);
}
function BW(e) {
	if (!(this instanceof BW)) return new BW(e);
	IW.Readable.call(this, e), IW.Writable.call(this, e), this.allowHalfOpen = !0, e && (e.readable === !1 && (this.readable = !1), e.writable === !1 && (this.writable = !1), e.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", VW)));
}
Object.defineProperty(BW.prototype, "writableHighWaterMark", {
	enumerable: !1,
	get: function() {
		return this._writableState.highWaterMark;
	}
}), Object.defineProperty(BW.prototype, "writableBuffer", {
	enumerable: !1,
	get: function() {
		return this._writableState && this._writableState.getBuffer();
	}
}), Object.defineProperty(BW.prototype, "writableLength", {
	enumerable: !1,
	get: function() {
		return this._writableState.length;
	}
});
function VW() {
	this._writableState.ended || eV.nextTick(HW, this);
}
function HW(e) {
	e.end();
}
Object.defineProperty(BW.prototype, "destroyed", {
	enumerable: !1,
	get: function() {
		return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
	},
	set: function(e) {
		this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = e, this._writableState.destroyed = e);
	}
});
var UW = pB;
UW.Transform = XW;
var WW = xH.codes, GW = WW.ERR_METHOD_NOT_IMPLEMENTED, KW = WW.ERR_MULTIPLE_CALLBACK, qW = WW.ERR_TRANSFORM_ALREADY_TRANSFORMING, JW = WW.ERR_TRANSFORM_WITH_LENGTH_0;
NH(XW, UW.Duplex);
function YW(e, t) {
	var n = this._transformState;
	n.transforming = !1;
	var r = n.writecb;
	if (r === null) return this.emit("error", new KW());
	n.writechunk = null, n.writecb = null, t != null && this.push(t), r(e);
	var i = this._readableState;
	i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
}
function XW(e) {
	if (!(this instanceof XW)) return new XW(e);
	UW.Duplex.call(this, e), this._transformState = {
		afterTransform: YW.bind(this),
		needTransform: !1,
		transforming: !1,
		writecb: null,
		writechunk: null,
		writeencoding: null
	}, this._readableState.needReadable = !0, this._readableState.sync = !1, e && (typeof e.transform == "function" && (this._transform = e.transform), typeof e.flush == "function" && (this._flush = e.flush)), this.on("prefinish", ZW);
}
function ZW() {
	var e = this;
	typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(t, n) {
		QW(e, t, n);
	}) : QW(this, null, null);
}
XW.prototype.push = function(e, t) {
	return this._transformState.needTransform = !1, UW.Duplex.prototype.push.call(this, e, t);
}, XW.prototype._transform = function(e, t, n) {
	n(new GW("_transform()"));
}, XW.prototype._write = function(e, t, n) {
	var r = this._transformState;
	if (r.writecb = n, r.writechunk = e, r.writeencoding = t, !r.transforming) {
		var i = this._readableState;
		(r.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
	}
}, XW.prototype._read = function(e) {
	var t = this._transformState;
	t.writechunk !== null && !t.transforming ? (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform)) : t.needTransform = !0;
}, XW.prototype._destroy = function(e, t) {
	UW.Duplex.prototype._destroy.call(this, e, function(e) {
		t(e);
	});
};
function QW(e, t, n) {
	if (t) return e.emit("error", t);
	if (n != null && e.push(n), e._writableState.length) throw new JW();
	if (e._transformState.transforming) throw new qW();
	return e.push(null);
}
var $W = pB;
$W.PassThrough = eG, NH(eG, $W.Transform);
function eG(e) {
	if (!(this instanceof eG)) return new eG(e);
	Transform.call(this, e);
}
eG.prototype._transform = function(e, t, n) {
	n(null, e);
};
var tG;
function nG(e) {
	var t = !1;
	return function() {
		t || (t = !0, e.apply(void 0, arguments));
	};
}
var rG = xH.codes, iG = rG.ERR_MISSING_ARGS, aG = rG.ERR_STREAM_DESTROYED;
function oG(e) {
	if (e) throw e;
}
function sG(e) {
	return e.setHeader && typeof e.abort == "function";
}
function cG(e, t, n, r) {
	r = nG(r);
	var i = !1;
	e.on("close", function() {
		i = !0;
	}), tG === void 0 && (tG = KH), tG(e, {
		readable: t,
		writable: n
	}, function(e) {
		if (e) return r(e);
		i = !0, r();
	});
	var a = !1;
	return function(t) {
		if (!i && !a) {
			if (a = !0, sG(e)) return e.abort();
			if (typeof e.destroy == "function") return e.destroy();
			r(t || new aG("pipe"));
		}
	};
}
function lG(e) {
	e();
}
function uG(e, t) {
	return e.pipe(t);
}
function dG(e) {
	return !e.length || typeof e[e.length - 1] != "function" ? oG : e.pop();
}
function fG() {
	var e = [...arguments], t = dG(e);
	if (Array.isArray(e[0]) && (e = e[0]), e.length < 2) throw new iG("streams");
	var n, r = e.map(function(i, a) {
		var o = a < e.length - 1;
		return cG(i, o, a > 0, function(e) {
			n ||= e, e && r.forEach(lG), !o && (r.forEach(lG), t(n));
		});
	});
	return e.reduce(uG);
}
var pG = fG;
(function(e, t) {
	let n = pB;
	t = e.exports = n.Readable, t.Stream = n.Readable, t.Readable = n.Readable, t.Writable = n.Writable, t.Duplex = n.Duplex, t.Transform = n.Transform, t.PassThrough = n.PassThrough, t.finished = KH, t.pipeline = pG;
})(fB, fB.exports);
var mG = fB.exports, hG = /*@__PURE__*/ uB(mG), gG = {}, _G = {};
function vG(e, t) {
	if (e === t) return 0;
	for (var n = e.length, r = t.length, i = 0, a = Math.min(n, r); i < a; ++i) if (e[i] !== t[i]) {
		n = e[i], r = t[i];
		break;
	}
	return n < r ? -1 : +(r < n);
}
var yG = Object.prototype.hasOwnProperty, bG = Object.keys || function(e) {
	var t = [];
	for (var n in e) yG.call(e, n) && t.push(n);
	return t;
}, xG = Array.prototype.slice, SG;
function CG() {
	return SG === void 0 ? SG = function() {
		return function() {}.name === "foo";
	}() : SG;
}
function wG(e) {
	return Object.prototype.toString.call(e);
}
function TG(e) {
	return aB(e) || typeof JR.ArrayBuffer != "function" ? !1 : typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(e) : e ? !!(e instanceof DataView || e.buffer && e.buffer instanceof ArrayBuffer) : !1;
}
function EG(e, t) {
	e || NG(e, !0, t, "==", PG);
}
var DG = /\s*function\s+([^\(\s]*)\s*/;
function OG(e) {
	if (XV(e)) {
		if (CG()) return e.name;
		var t = e.toString().match(DG);
		return t && t[1];
	}
}
EG.AssertionError = kG;
function kG(e) {
	this.name = "AssertionError", this.actual = e.actual, this.expected = e.expected, this.operator = e.operator, e.message ? (this.message = e.message, this.generatedMessage = !1) : (this.message = MG(this), this.generatedMessage = !0);
	var t = e.stackStartFunction || NG;
	if (Error.captureStackTrace) Error.captureStackTrace(this, t);
	else {
		var n = /* @__PURE__ */ Error();
		if (n.stack) {
			var r = n.stack, i = OG(t), a = r.indexOf("\n" + i);
			if (a >= 0) {
				var o = r.indexOf("\n", a + 1);
				r = r.substring(o + 1);
			}
			this.stack = r;
		}
	}
}
bV(kG, Error);
function AG(e, t) {
	return typeof e == "string" ? e.length < t ? e : e.slice(0, t) : e;
}
function jG(e) {
	if (CG() || !XV(e)) return OV(e);
	var t = OG(e);
	return "[Function" + (t ? ": " + t : "") + "]";
}
function MG(e) {
	return AG(jG(e.actual), 128) + " " + e.operator + " " + AG(jG(e.expected), 128);
}
function NG(e, t, n, r, i) {
	throw new kG({
		message: n,
		actual: e,
		expected: t,
		operator: r,
		stackStartFunction: i
	});
}
EG.fail = NG;
function PG(e, t) {
	e || NG(e, !0, t, "==", PG);
}
EG.ok = PG, EG.equal = FG;
function FG(e, t, n) {
	e != t && NG(e, t, n, "==", FG);
}
EG.notEqual = IG;
function IG(e, t, n) {
	e == t && NG(e, t, n, "!=", IG);
}
EG.deepEqual = LG;
function LG(e, t, n) {
	zG(e, t, !1) || NG(e, t, n, "deepEqual", LG);
}
EG.deepStrictEqual = RG;
function RG(e, t, n) {
	zG(e, t, !0) || NG(e, t, n, "deepStrictEqual", RG);
}
function zG(e, t, n, r) {
	if (e === t) return !0;
	if (aB(e) && aB(t)) return vG(e, t) === 0;
	if (JV(e) && JV(t)) return e.getTime() === t.getTime();
	if (KV(e) && KV(t)) return e.source === t.source && e.global === t.global && e.multiline === t.multiline && e.lastIndex === t.lastIndex && e.ignoreCase === t.ignoreCase;
	if ((typeof e != "object" || !e) && (typeof t != "object" || !t)) return n ? e === t : e == t;
	if (TG(e) && TG(t) && wG(e) === wG(t) && !(e instanceof Float32Array || e instanceof Float64Array)) return vG(new Uint8Array(e.buffer), new Uint8Array(t.buffer)) === 0;
	if (aB(e) !== aB(t)) return !1;
	r ||= {
		actual: [],
		expected: []
	};
	var i = r.actual.indexOf(e);
	return i !== -1 && i === r.expected.indexOf(t) ? !0 : (r.actual.push(e), r.expected.push(t), VG(e, t, n, r));
}
function BG(e) {
	return Object.prototype.toString.call(e) == "[object Arguments]";
}
function VG(e, t, n, r) {
	if (e == null || t == null) return !1;
	if (ZV(e) || ZV(t)) return e === t;
	if (n && Object.getPrototypeOf(e) !== Object.getPrototypeOf(t)) return !1;
	var i = BG(e), a = BG(t);
	if (i && !a || !i && a) return !1;
	if (i) return e = xG.call(e), t = xG.call(t), zG(e, t, n);
	var o = bG(e), s = bG(t), c, l;
	if (o.length !== s.length) return !1;
	for (o.sort(), s.sort(), l = o.length - 1; l >= 0; l--) if (o[l] !== s[l]) return !1;
	for (l = o.length - 1; l >= 0; l--) if (c = o[l], !zG(e[c], t[c], n, r)) return !1;
	return !0;
}
EG.notDeepEqual = HG;
function HG(e, t, n) {
	zG(e, t, !1) && NG(e, t, n, "notDeepEqual", HG);
}
EG.notDeepStrictEqual = UG;
function UG(e, t, n) {
	zG(e, t, !0) && NG(e, t, n, "notDeepStrictEqual", UG);
}
EG.strictEqual = WG;
function WG(e, t, n) {
	e !== t && NG(e, t, n, "===", WG);
}
EG.notStrictEqual = GG;
function GG(e, t, n) {
	e === t && NG(e, t, n, "!==", GG);
}
function KG(e, t) {
	if (!e || !t) return !1;
	if (Object.prototype.toString.call(t) == "[object RegExp]") return t.test(e);
	try {
		if (e instanceof t) return !0;
	} catch {}
	return Error.isPrototypeOf(t) ? !1 : t.call({}, e) === !0;
}
function qG(e) {
	var t;
	try {
		e();
	} catch (e) {
		t = e;
	}
	return t;
}
function JG(e, t, n, r) {
	var i;
	if (typeof t != "function") throw TypeError("\"block\" argument must be a function");
	typeof n == "string" && (r = n, n = null), i = qG(t), r = (n && n.name ? " (" + n.name + ")." : ".") + (r ? " " + r : "."), e && !i && NG(i, n, "Missing expected exception" + r);
	var a = typeof r == "string", o = !e && YV(i), s = !e && i && !n;
	if ((o && a && KG(i, n) || s) && NG(i, n, "Got unwanted exception" + r), e && i && n && !KG(i, n) || !e && i) throw i;
}
EG.throws = YG;
function YG(e, t, n) {
	JG(!0, e, t, n);
}
EG.doesNotThrow = XG;
function XG(e, t, n) {
	JG(!1, e, t, n);
}
EG.ifError = ZG;
function ZG(e) {
	if (e) throw e;
}
var QG = /*@__PURE__*/ dB(/* @__PURE__ */ Object.freeze({
	__proto__: null,
	AssertionError: kG,
	assert: PG,
	deepEqual: LG,
	deepStrictEqual: RG,
	default: EG,
	doesNotThrow: XG,
	equal: FG,
	fail: NG,
	ifError: ZG,
	notDeepEqual: HG,
	notDeepStrictEqual: UG,
	notEqual: IG,
	notStrictEqual: GG,
	ok: PG,
	strictEqual: WG,
	throws: YG
}));
(function(e) {
	var t = QG, n = ck.default, r = lk.default, i = uk.default, a = dk.default;
	for (var o in a) e[o] = a[o];
	e.NONE = 0, e.DEFLATE = 1, e.INFLATE = 2, e.GZIP = 3, e.GUNZIP = 4, e.DEFLATERAW = 5, e.INFLATERAW = 6, e.UNZIP = 7;
	var s = 31, c = 139;
	function l(t) {
		if (typeof t != "number" || t < e.DEFLATE || t > e.UNZIP) throw TypeError("Bad argument");
		this.dictionary = null, this.err = 0, this.flush = 0, this.init_done = !1, this.level = 0, this.memLevel = 0, this.mode = t, this.strategy = 0, this.windowBits = 0, this.write_in_progress = !1, this.pending_close = !1, this.gzip_id_bytes_read = 0;
	}
	l.prototype.close = function() {
		if (this.write_in_progress) {
			this.pending_close = !0;
			return;
		}
		this.pending_close = !1, t(this.init_done, "close before init"), t(this.mode <= e.UNZIP), this.mode === e.DEFLATE || this.mode === e.GZIP || this.mode === e.DEFLATERAW ? r.deflateEnd(this.strm) : (this.mode === e.INFLATE || this.mode === e.GUNZIP || this.mode === e.INFLATERAW || this.mode === e.UNZIP) && i.inflateEnd(this.strm), this.mode = e.NONE, this.dictionary = null;
	}, l.prototype.write = function(e, t, n, r, i, a, o) {
		return this._write(!0, e, t, n, r, i, a, o);
	}, l.prototype.writeSync = function(e, t, n, r, i, a, o) {
		return this._write(!1, e, t, n, r, i, a, o);
	}, l.prototype._write = function(n, r, i, a, o, s, c, l) {
		if (t.equal(arguments.length, 8), t(this.init_done, "write before init"), t(this.mode !== e.NONE, "already finalized"), t.equal(!1, this.write_in_progress, "write already in progress"), t.equal(!1, this.pending_close, "close is pending"), this.write_in_progress = !0, t.equal(!1, r === void 0, "must provide flush value"), this.write_in_progress = !0, r !== e.Z_NO_FLUSH && r !== e.Z_PARTIAL_FLUSH && r !== e.Z_SYNC_FLUSH && r !== e.Z_FULL_FLUSH && r !== e.Z_FINISH && r !== e.Z_BLOCK) throw Error("Invalid flush value");
		if (i ?? (i = Q.alloc(0), o = 0, a = 0), this.strm.avail_in = o, this.strm.input = i, this.strm.next_in = a, this.strm.avail_out = l, this.strm.output = s, this.strm.next_out = c, this.flush = r, !n) return this._process(), this._checkError() ? this._afterSync() : void 0;
		var u = this;
		return eV.nextTick(function() {
			u._process(), u._after();
		}), this;
	}, l.prototype._afterSync = function() {
		var e = this.strm.avail_out, t = this.strm.avail_in;
		return this.write_in_progress = !1, [t, e];
	}, l.prototype._process = function() {
		var t = null;
		switch (this.mode) {
			case e.DEFLATE:
			case e.GZIP:
			case e.DEFLATERAW:
				this.err = r.deflate(this.strm, this.flush);
				break;
			case e.UNZIP: switch (this.strm.avail_in > 0 && (t = this.strm.next_in), this.gzip_id_bytes_read) {
				case 0:
					if (t === null) break;
					if (this.strm.input[t] === s) {
						if (this.gzip_id_bytes_read = 1, t++, this.strm.avail_in === 1) break;
					} else {
						this.mode = e.INFLATE;
						break;
					}
				case 1:
					if (t === null) break;
					this.strm.input[t] === c ? (this.gzip_id_bytes_read = 2, this.mode = e.GUNZIP) : this.mode = e.INFLATE;
					break;
				default: throw Error("invalid number of gzip magic number bytes read");
			}
			case e.INFLATE:
			case e.GUNZIP:
			case e.INFLATERAW:
				for (this.err = i.inflate(this.strm, this.flush), this.err === e.Z_NEED_DICT && this.dictionary && (this.err = i.inflateSetDictionary(this.strm, this.dictionary), this.err === e.Z_OK ? this.err = i.inflate(this.strm, this.flush) : this.err === e.Z_DATA_ERROR && (this.err = e.Z_NEED_DICT)); this.strm.avail_in > 0 && this.mode === e.GUNZIP && this.err === e.Z_STREAM_END && this.strm.next_in[0] !== 0;) this.reset(), this.err = i.inflate(this.strm, this.flush);
				break;
			default: throw Error("Unknown mode " + this.mode);
		}
	}, l.prototype._checkError = function() {
		switch (this.err) {
			case e.Z_OK:
			case e.Z_BUF_ERROR:
				if (this.strm.avail_out !== 0 && this.flush === e.Z_FINISH) return this._error("unexpected end of file"), !1;
				break;
			case e.Z_STREAM_END: break;
			case e.Z_NEED_DICT: return this.dictionary == null ? this._error("Missing dictionary") : this._error("Bad dictionary"), !1;
			default: return this._error("Zlib error"), !1;
		}
		return !0;
	}, l.prototype._after = function() {
		if (this._checkError()) {
			var e = this.strm.avail_out, t = this.strm.avail_in;
			this.write_in_progress = !1, this.callback(t, e), this.pending_close && this.close();
		}
	}, l.prototype._error = function(e) {
		this.strm.msg && (e = this.strm.msg), this.onerror(e, this.err), this.write_in_progress = !1, this.pending_close && this.close();
	}, l.prototype.init = function(n, r, i, a, o) {
		t(arguments.length === 4 || arguments.length === 5, "init(windowBits, level, memLevel, strategy, [dictionary])"), t(n >= 8 && n <= 15, "invalid windowBits"), t(r >= -1 && r <= 9, "invalid compression level"), t(i >= 1 && i <= 9, "invalid memlevel"), t(a === e.Z_FILTERED || a === e.Z_HUFFMAN_ONLY || a === e.Z_RLE || a === e.Z_FIXED || a === e.Z_DEFAULT_STRATEGY, "invalid strategy"), this._init(r, n, i, a, o), this._setDictionary();
	}, l.prototype.params = function() {
		throw Error("deflateParams Not supported");
	}, l.prototype.reset = function() {
		this._reset(), this._setDictionary();
	}, l.prototype._init = function(t, a, o, s, c) {
		switch (this.level = t, this.windowBits = a, this.memLevel = o, this.strategy = s, this.flush = e.Z_NO_FLUSH, this.err = e.Z_OK, (this.mode === e.GZIP || this.mode === e.GUNZIP) && (this.windowBits += 16), this.mode === e.UNZIP && (this.windowBits += 32), (this.mode === e.DEFLATERAW || this.mode === e.INFLATERAW) && (this.windowBits = -1 * this.windowBits), this.strm = new n(), this.mode) {
			case e.DEFLATE:
			case e.GZIP:
			case e.DEFLATERAW:
				this.err = r.deflateInit2(this.strm, this.level, e.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
				break;
			case e.INFLATE:
			case e.GUNZIP:
			case e.INFLATERAW:
			case e.UNZIP:
				this.err = i.inflateInit2(this.strm, this.windowBits);
				break;
			default: throw Error("Unknown mode " + this.mode);
		}
		this.err !== e.Z_OK && this._error("Init error"), this.dictionary = c, this.write_in_progress = !1, this.init_done = !0;
	}, l.prototype._setDictionary = function() {
		if (this.dictionary != null) {
			switch (this.err = e.Z_OK, this.mode) {
				case e.DEFLATE:
				case e.DEFLATERAW:
					this.err = r.deflateSetDictionary(this.strm, this.dictionary);
					break;
			}
			this.err !== e.Z_OK && this._error("Failed to set dictionary");
		}
	}, l.prototype._reset = function() {
		switch (this.err = e.Z_OK, this.mode) {
			case e.DEFLATE:
			case e.DEFLATERAW:
			case e.GZIP:
				this.err = r.deflateReset(this.strm);
				break;
			case e.INFLATE:
			case e.INFLATERAW:
			case e.GUNZIP:
				this.err = i.inflateReset(this.strm);
				break;
		}
		this.err !== e.Z_OK && this._error("Failed to reset stream");
	}, e.Zlib = l;
})(_G), (function(e) {
	var t = yV.Buffer, n = mG.Transform, r = _G, i = uH, a = QG.ok, o = yV.kMaxLength, s = "Cannot create final Buffer. It would be larger than 0x" + o.toString(16) + " bytes";
	r.Z_MIN_WINDOWBITS = 8, r.Z_MAX_WINDOWBITS = 15, r.Z_DEFAULT_WINDOWBITS = 15, r.Z_MIN_CHUNK = 64, r.Z_MAX_CHUNK = Infinity, r.Z_DEFAULT_CHUNK = 16 * 1024, r.Z_MIN_MEMLEVEL = 1, r.Z_MAX_MEMLEVEL = 9, r.Z_DEFAULT_MEMLEVEL = 8, r.Z_MIN_LEVEL = -1, r.Z_MAX_LEVEL = 9, r.Z_DEFAULT_LEVEL = r.Z_DEFAULT_COMPRESSION;
	for (var c = Object.keys(r), l = 0; l < c.length; l++) {
		var u = c[l];
		u.match(/^Z/) && Object.defineProperty(e, u, {
			enumerable: !0,
			value: r[u],
			writable: !1
		});
	}
	for (var d = {
		Z_OK: r.Z_OK,
		Z_STREAM_END: r.Z_STREAM_END,
		Z_NEED_DICT: r.Z_NEED_DICT,
		Z_ERRNO: r.Z_ERRNO,
		Z_STREAM_ERROR: r.Z_STREAM_ERROR,
		Z_DATA_ERROR: r.Z_DATA_ERROR,
		Z_MEM_ERROR: r.Z_MEM_ERROR,
		Z_BUF_ERROR: r.Z_BUF_ERROR,
		Z_VERSION_ERROR: r.Z_VERSION_ERROR
	}, f = Object.keys(d), p = 0; p < f.length; p++) {
		var m = f[p];
		d[d[m]] = m;
	}
	Object.defineProperty(e, "codes", {
		enumerable: !0,
		value: Object.freeze(d),
		writable: !1
	}), e.Deflate = _, e.Inflate = v, e.Gzip = y, e.Gunzip = b, e.DeflateRaw = x, e.InflateRaw = S, e.Unzip = C, e.createDeflate = function(e) {
		return new _(e);
	}, e.createInflate = function(e) {
		return new v(e);
	}, e.createDeflateRaw = function(e) {
		return new x(e);
	}, e.createInflateRaw = function(e) {
		return new S(e);
	}, e.createGzip = function(e) {
		return new y(e);
	}, e.createGunzip = function(e) {
		return new b(e);
	}, e.createUnzip = function(e) {
		return new C(e);
	}, e.deflate = function(e, t, n) {
		return typeof t == "function" && (n = t, t = {}), h(new _(t), e, n);
	}, e.deflateSync = function(e, t) {
		return g(new _(t), e);
	}, e.gzip = function(e, t, n) {
		return typeof t == "function" && (n = t, t = {}), h(new y(t), e, n);
	}, e.gzipSync = function(e, t) {
		return g(new y(t), e);
	}, e.deflateRaw = function(e, t, n) {
		return typeof t == "function" && (n = t, t = {}), h(new x(t), e, n);
	}, e.deflateRawSync = function(e, t) {
		return g(new x(t), e);
	}, e.unzip = function(e, t, n) {
		return typeof t == "function" && (n = t, t = {}), h(new C(t), e, n);
	}, e.unzipSync = function(e, t) {
		return g(new C(t), e);
	}, e.inflate = function(e, t, n) {
		return typeof t == "function" && (n = t, t = {}), h(new v(t), e, n);
	}, e.inflateSync = function(e, t) {
		return g(new v(t), e);
	}, e.gunzip = function(e, t, n) {
		return typeof t == "function" && (n = t, t = {}), h(new b(t), e, n);
	}, e.gunzipSync = function(e, t) {
		return g(new b(t), e);
	}, e.inflateRaw = function(e, t, n) {
		return typeof t == "function" && (n = t, t = {}), h(new S(t), e, n);
	}, e.inflateRawSync = function(e, t) {
		return g(new S(t), e);
	};
	function h(e, n, r) {
		var i = [], a = 0;
		e.on("error", l), e.on("end", u), e.end(n), c();
		function c() {
			for (var t; (t = e.read()) !== null;) i.push(t), a += t.length;
			e.once("readable", c);
		}
		function l(t) {
			e.removeListener("end", u), e.removeListener("readable", c), r(t);
		}
		function u() {
			var n, c = null;
			a >= o ? c = RangeError(s) : n = t.concat(i, a), i = [], e.close(), r(c, n);
		}
	}
	function g(e, n) {
		if (typeof n == "string" && (n = t.from(n)), !t.isBuffer(n)) throw TypeError("Not a string or buffer");
		var r = e._finishFlushFlag;
		return e._processChunk(n, r);
	}
	function _(e) {
		if (!(this instanceof _)) return new _(e);
		T.call(this, e, r.DEFLATE);
	}
	function v(e) {
		if (!(this instanceof v)) return new v(e);
		T.call(this, e, r.INFLATE);
	}
	function y(e) {
		if (!(this instanceof y)) return new y(e);
		T.call(this, e, r.GZIP);
	}
	function b(e) {
		if (!(this instanceof b)) return new b(e);
		T.call(this, e, r.GUNZIP);
	}
	function x(e) {
		if (!(this instanceof x)) return new x(e);
		T.call(this, e, r.DEFLATERAW);
	}
	function S(e) {
		if (!(this instanceof S)) return new S(e);
		T.call(this, e, r.INFLATERAW);
	}
	function C(e) {
		if (!(this instanceof C)) return new C(e);
		T.call(this, e, r.UNZIP);
	}
	function w(e) {
		return e === r.Z_NO_FLUSH || e === r.Z_PARTIAL_FLUSH || e === r.Z_SYNC_FLUSH || e === r.Z_FULL_FLUSH || e === r.Z_FINISH || e === r.Z_BLOCK;
	}
	function T(i, a) {
		var o = this;
		if (this._opts = i ||= {}, this._chunkSize = i.chunkSize || e.Z_DEFAULT_CHUNK, n.call(this, i), i.flush && !w(i.flush)) throw Error("Invalid flush flag: " + i.flush);
		if (i.finishFlush && !w(i.finishFlush)) throw Error("Invalid flush flag: " + i.finishFlush);
		if (this._flushFlag = i.flush || r.Z_NO_FLUSH, this._finishFlushFlag = i.finishFlush === void 0 ? r.Z_FINISH : i.finishFlush, i.chunkSize && (i.chunkSize < e.Z_MIN_CHUNK || i.chunkSize > e.Z_MAX_CHUNK)) throw Error("Invalid chunk size: " + i.chunkSize);
		if (i.windowBits && (i.windowBits < e.Z_MIN_WINDOWBITS || i.windowBits > e.Z_MAX_WINDOWBITS)) throw Error("Invalid windowBits: " + i.windowBits);
		if (i.level && (i.level < e.Z_MIN_LEVEL || i.level > e.Z_MAX_LEVEL)) throw Error("Invalid compression level: " + i.level);
		if (i.memLevel && (i.memLevel < e.Z_MIN_MEMLEVEL || i.memLevel > e.Z_MAX_MEMLEVEL)) throw Error("Invalid memLevel: " + i.memLevel);
		if (i.strategy && i.strategy != e.Z_FILTERED && i.strategy != e.Z_HUFFMAN_ONLY && i.strategy != e.Z_RLE && i.strategy != e.Z_FIXED && i.strategy != e.Z_DEFAULT_STRATEGY) throw Error("Invalid strategy: " + i.strategy);
		if (i.dictionary && !t.isBuffer(i.dictionary)) throw Error("Invalid dictionary: it should be a Buffer instance");
		this._handle = new r.Zlib(a);
		var s = this;
		this._hadError = !1, this._handle.onerror = function(t, n) {
			E(s), s._hadError = !0;
			var r = Error(t);
			r.errno = n, r.code = e.codes[n], s.emit("error", r);
		};
		var c = e.Z_DEFAULT_COMPRESSION;
		typeof i.level == "number" && (c = i.level);
		var l = e.Z_DEFAULT_STRATEGY;
		typeof i.strategy == "number" && (l = i.strategy), this._handle.init(i.windowBits || e.Z_DEFAULT_WINDOWBITS, c, i.memLevel || e.Z_DEFAULT_MEMLEVEL, l, i.dictionary), this._buffer = t.allocUnsafe(this._chunkSize), this._offset = 0, this._level = c, this._strategy = l, this.once("end", this.close), Object.defineProperty(this, "_closed", {
			get: function() {
				return !o._handle;
			},
			configurable: !0,
			enumerable: !0
		});
	}
	i.inherits(T, n), T.prototype.params = function(t, n, i) {
		if (t < e.Z_MIN_LEVEL || t > e.Z_MAX_LEVEL) throw RangeError("Invalid compression level: " + t);
		if (n != e.Z_FILTERED && n != e.Z_HUFFMAN_ONLY && n != e.Z_RLE && n != e.Z_FIXED && n != e.Z_DEFAULT_STRATEGY) throw TypeError("Invalid strategy: " + n);
		if (this._level !== t || this._strategy !== n) {
			var o = this;
			this.flush(r.Z_SYNC_FLUSH, function() {
				a(o._handle, "zlib binding closed"), o._handle.params(t, n), o._hadError || (o._level = t, o._strategy = n, i && i());
			});
		} else eV.nextTick(i);
	}, T.prototype.reset = function() {
		return a(this._handle, "zlib binding closed"), this._handle.reset();
	}, T.prototype._flush = function(e) {
		this._transform(t.alloc(0), "", e);
	}, T.prototype.flush = function(e, n) {
		var i = this, a = this._writableState;
		(typeof e == "function" || e === void 0 && !n) && (n = e, e = r.Z_FULL_FLUSH), a.ended ? n && eV.nextTick(n) : a.ending ? n && this.once("end", n) : a.needDrain ? n && this.once("drain", function() {
			return i.flush(e, n);
		}) : (this._flushFlag = e, this.write(t.alloc(0), "", n));
	}, T.prototype.close = function(e) {
		E(this, e), eV.nextTick(D, this);
	};
	function E(e, t) {
		t && eV.nextTick(t), e._handle &&= (e._handle.close(), null);
	}
	function D(e) {
		e.emit("close");
	}
	T.prototype._transform = function(e, n, i) {
		var a, o = this._writableState, s = (o.ending || o.ended) && (!e || o.length === e.length);
		if (e !== null && !t.isBuffer(e)) return i(/* @__PURE__ */ Error("invalid input"));
		if (!this._handle) return i(/* @__PURE__ */ Error("zlib binding closed"));
		s ? a = this._finishFlushFlag : (a = this._flushFlag, e.length >= o.length && (this._flushFlag = this._opts.flush || r.Z_NO_FLUSH)), this._processChunk(e, a, i);
	}, T.prototype._processChunk = function(e, n, r) {
		var i = e && e.length, c = this._chunkSize - this._offset, l = 0, u = this, d = typeof r == "function";
		if (!d) {
			var f = [], p = 0, m;
			this.on("error", function(e) {
				m = e;
			}), a(this._handle, "zlib binding closed");
			do
				var h = this._handle.writeSync(n, e, l, i, this._buffer, this._offset, c);
			while (!this._hadError && v(h[0], h[1]));
			if (this._hadError) throw m;
			if (p >= o) throw E(this), RangeError(s);
			var g = t.concat(f, p);
			return E(this), g;
		}
		a(this._handle, "zlib binding closed");
		var _ = this._handle.write(n, e, l, i, this._buffer, this._offset, c);
		_.buffer = e, _.callback = v;
		function v(o, s) {
			if (this && (this.buffer = null, this.callback = null), !u._hadError) {
				var m = c - s;
				if (a(m >= 0, "have should not go down"), m > 0) {
					var h = u._buffer.slice(u._offset, u._offset + m);
					u._offset += m, d ? u.push(h) : (f.push(h), p += h.length);
				}
				if ((s === 0 || u._offset >= u._chunkSize) && (c = u._chunkSize, u._offset = 0, u._buffer = t.allocUnsafe(u._chunkSize)), s === 0) {
					if (l += i - o, i = o, !d) return !0;
					var g = u._handle.write(n, e, l, i, u._buffer, u._offset, u._chunkSize);
					g.callback = v, g.buffer = e;
					return;
				}
				if (!d) return !1;
				r();
			}
		}
	}, i.inherits(_, T), i.inherits(v, T), i.inherits(y, T), i.inherits(b, T), i.inherits(x, T), i.inherits(S, T), i.inherits(C, T);
})(gG);
var $G = /*@__PURE__*/ uB(gG), eK = class extends hG.Writable {
	constructor(e, t, n) {
		super({ decodeStrings: !1 }), this.finalize = this.finalize.bind(this), this.document = e, this.id = t, n ??= {}, this.data = n, this.gen = 0, this.deflate = null, this.compress = this.document.compress && !this.data.Filter, this.uncompressedLength = 0, this.chunks = [];
	}
	initDeflate() {
		return this.data.Filter = "FlateDecode", this.deflate = $G.createDeflate(), this.deflate.on("data", (e) => (this.chunks.push(e), this.data.Length += e.length)), this.deflate.on("end", this.finalize);
	}
	_write(e, t, n) {
		return e instanceof Uint8Array || (e = Q.from(e + "\n", "binary")), this.uncompressedLength += e.length, this.data.Length ?? (this.data.Length = 0), this.compress ? (this.deflate || this.initDeflate(), this.deflate.write(e)) : (this.chunks.push(e), this.data.Length += e.length), n();
	}
	end() {
		return super.end(...arguments), this.deflate ? this.deflate.end() : this.finalize();
	}
	finalize() {
		if (this.offset = this.document._offset, this.document._write(`${this.id} ${this.gen} obj`), this.document._write(sK.convert(this.data)), this.chunks.length) {
			this.document._write("stream");
			for (let e of Array.from(this.chunks)) this.document._write(e);
			this.chunks.length = 0, this.document._write("\nendstream");
		}
		return this.document._write("endobj"), this.document._refEnd(this);
	}
	toString() {
		return `${this.id} ${this.gen} R`;
	}
}, tK = class {
	constructor(e) {
		e === void 0 && (e = {}), this._items = {}, this.limits = typeof e.limits == "boolean" ? e.limits : !0;
	}
	add(e, t) {
		return this._items[e] = t;
	}
	get(e) {
		return this._items[e];
	}
	toString() {
		let e = Object.keys(this._items).sort((e, t) => this._compareKeys(e, t)), t = ["<<"];
		if (this.limits && e.length > 1) {
			let n = e[0], r = e[e.length - 1];
			t.push(`  /Limits ${sK.convert([this._dataForKey(n), this._dataForKey(r)])}`);
		}
		t.push(`  /${this._keysName()} [`);
		for (let n of e) t.push(`    ${sK.convert(this._dataForKey(n))} ${sK.convert(this._items[n])}`);
		return t.push("]"), t.push(">>"), t.join("\n");
	}
	_compareKeys() {
		throw Error("Must be implemented by subclasses");
	}
	_keysName() {
		throw Error("Must be implemented by subclasses");
	}
	_dataForKey() {
		throw Error("Must be implemented by subclasses");
	}
}, nK = class extends tK {
	_compareKeys(e, t) {
		return e.localeCompare(t);
	}
	_keysName() {
		return "Names";
	}
	_dataForKey(e) {
		return new String(e);
	}
}, rK = (e, t) => (Array(t + 1).join("0") + e).slice(-t), iK = /[\n\r\t\b\f()\\]/g, aK = {
	"\n": "\\n",
	"\r": "\\r",
	"	": "\\t",
	"\b": "\\b",
	"\f": "\\f",
	"\\": "\\\\",
	"(": "\\(",
	")": "\\)"
}, oK = function(e) {
	let t = e.length;
	if (t & 1) throw Error("Buffer length must be even");
	for (let n = 0, r = t - 1; n < r; n += 2) {
		let t = e[n];
		e[n] = e[n + 1], e[n + 1] = t;
	}
	return e;
}, sK = class e {
	static convert(t) {
		if (typeof t == "string") return `/${t}`;
		if (t instanceof String) {
			let e = t, n = !1;
			for (let t = 0, r = e.length; t < r; t++) if (e.charCodeAt(t) > 127) {
				n = !0;
				break;
			}
			return n && (e = oK(Q.from(`\ufeff${e}`, "utf16le")).toString("binary")), e = e.replace(iK, (e) => aK[e]), `(${e})`;
		}
		if (Q.isBuffer(t)) return `<${t.toString("hex")}>`;
		if (t instanceof eK || t instanceof nK) return t.toString();
		if (t instanceof Date) return `(D:${rK(t.getUTCFullYear(), 4)}` + rK(t.getUTCMonth() + 1, 2) + rK(t.getUTCDate(), 2) + rK(t.getUTCHours(), 2) + rK(t.getUTCMinutes(), 2) + rK(t.getUTCSeconds(), 2) + "Z)";
		if (Array.isArray(t)) return `[${Array.from(t).map((t) => e.convert(t)).join(" ")}]`;
		if ({}.toString.call(t) === "[object Object]") {
			let n = ["<<"];
			for (let r in t) {
				let i = t[r];
				n.push(`/${r} ${e.convert(i)}`);
			}
			return n.push(">>"), n.join("\n");
		}
		return typeof t == "number" ? e.number(t) : `${t}`;
	}
	static number(e) {
		if (e > -1e21 && e < 1e21) return Math.round(e * 1e6) / 1e6;
		throw Error(`unsupported number: ${e}`);
	}
}, cK = {
	top: 72,
	left: 72,
	bottom: 72,
	right: 72
}, lK = {
	"4A0": [4767.87, 6740.79],
	"2A0": [3370.39, 4767.87],
	A0: [2383.94, 3370.39],
	A1: [1683.78, 2383.94],
	A2: [1190.55, 1683.78],
	A3: [841.89, 1190.55],
	A4: [595.28, 841.89],
	A5: [419.53, 595.28],
	A6: [297.64, 419.53],
	A7: [209.76, 297.64],
	A8: [147.4, 209.76],
	A9: [104.88, 147.4],
	A10: [73.7, 104.88],
	B0: [2834.65, 4008.19],
	B1: [2004.09, 2834.65],
	B2: [1417.32, 2004.09],
	B3: [1000.63, 1417.32],
	B4: [708.66, 1000.63],
	B5: [498.9, 708.66],
	B6: [354.33, 498.9],
	B7: [249.45, 354.33],
	B8: [175.75, 249.45],
	B9: [124.72, 175.75],
	B10: [87.87, 124.72],
	C0: [2599.37, 3676.54],
	C1: [1836.85, 2599.37],
	C2: [1298.27, 1836.85],
	C3: [918.43, 1298.27],
	C4: [649.13, 918.43],
	C5: [459.21, 649.13],
	C6: [323.15, 459.21],
	C7: [229.61, 323.15],
	C8: [161.57, 229.61],
	C9: [113.39, 161.57],
	C10: [79.37, 113.39],
	RA0: [2437.8, 3458.27],
	RA1: [1729.13, 2437.8],
	RA2: [1218.9, 1729.13],
	RA3: [864.57, 1218.9],
	RA4: [609.45, 864.57],
	SRA0: [2551.18, 3628.35],
	SRA1: [1814.17, 2551.18],
	SRA2: [1275.59, 1814.17],
	SRA3: [907.09, 1275.59],
	SRA4: [637.8, 907.09],
	EXECUTIVE: [521.86, 756],
	FOLIO: [612, 936],
	LEGAL: [612, 1008],
	LETTER: [612, 792],
	TABLOID: [792, 1224]
}, uK = class {
	constructor(e, t) {
		t === void 0 && (t = {}), this.document = e, this._options = t, this.size = t.size || "letter", this.layout = t.layout || "portrait", this.userUnit = t.userUnit || 1, typeof t.margin == "number" ? this.margins = {
			top: t.margin,
			left: t.margin,
			bottom: t.margin,
			right: t.margin
		} : this.margins = t.margins || cK;
		let n = Array.isArray(this.size) ? this.size : lK[this.size.toUpperCase()];
		this.width = n[this.layout === "portrait" ? 0 : 1], this.height = n[+(this.layout === "portrait")], this.content = this.document.ref(), t.font && e.font(t.font, t.fontFamily), t.fontSize && e.fontSize(t.fontSize), this.resources = this.document.ref({ ProcSet: [
			"PDF",
			"Text",
			"ImageB",
			"ImageC",
			"ImageI"
		] }), this.dictionary = this.document.ref({
			Type: "Page",
			Parent: this.document._root.data.Pages,
			MediaBox: [
				0,
				0,
				this.width,
				this.height
			],
			Contents: this.content,
			Resources: this.resources,
			UserUnit: this.userUnit
		}), this.markings = [];
	}
	get fonts() {
		let e = this.resources.data;
		return e.Font == null ? e.Font = {} : e.Font;
	}
	get xobjects() {
		let e = this.resources.data;
		return e.XObject == null ? e.XObject = {} : e.XObject;
	}
	get ext_gstates() {
		let e = this.resources.data;
		return e.ExtGState == null ? e.ExtGState = {} : e.ExtGState;
	}
	get patterns() {
		let e = this.resources.data;
		return e.Pattern == null ? e.Pattern = {} : e.Pattern;
	}
	get colorSpaces() {
		let e = this.resources.data;
		return e.ColorSpace ||= {};
	}
	get annotations() {
		let e = this.dictionary.data;
		return e.Annots == null ? e.Annots = [] : e.Annots;
	}
	get structParentTreeKey() {
		let e = this.dictionary.data;
		return e.StructParents == null ? e.StructParents = this.document.createStructParentTreeNextKey() : e.StructParents;
	}
	maxY() {
		return this.height - this.margins.bottom;
	}
	write(e) {
		return this.content.write(e);
	}
	_setTabOrder() {
		!this.dictionary.Tabs && this.document.hasMarkInfoDictionary() && (this.dictionary.data.Tabs = "S");
	}
	end() {
		this._setTabOrder(), this.dictionary.end(), this.resources.data.ColorSpace = this.resources.data.ColorSpace || {};
		for (let e of Object.values(this.document.spotColors)) this.resources.data.ColorSpace[e.id] = e;
		return this.resources.end(), this.content.end();
	}
}, dK = (e) => {
	let t = [];
	for (let n = 0; n < e.sigBytes; n++) t.push(e.words[Math.floor(n / 4)] >> 8 * (3 - n % 4) & 255);
	return Q.from(t);
}, fK = class {
	static generateFileID(e) {
		e === void 0 && (e = {});
		let t = `${e.CreationDate.getTime()}\n`;
		for (let n in e) e.hasOwnProperty(n) && (t += `${n}: ${e[n].valueOf()}\n`);
		return dK((0, fk.default)(t));
	}
}, { number: pK } = sK, mK = class {
	constructor(e) {
		this.doc = e, this.stops = [], this.embedded = !1, this.transform = [
			1,
			0,
			0,
			1,
			0,
			0
		];
	}
	stop(e, t, n) {
		if (n ??= 1, t = this.doc._normalizeColor(t), this.stops.length === 0) if (t.length === 3) this._colorSpace = "DeviceRGB";
		else if (t.length === 4) this._colorSpace = "DeviceCMYK";
		else if (t.length === 1) this._colorSpace = "DeviceGray";
		else throw Error("Unknown color space");
		else if (this._colorSpace === "DeviceRGB" && t.length !== 3 || this._colorSpace === "DeviceCMYK" && t.length !== 4 || this._colorSpace === "DeviceGray" && t.length !== 1) throw Error("All gradient stops must use the same color space");
		return n = Math.max(0, Math.min(1, n)), this.stops.push([
			e,
			t,
			n
		]), this;
	}
	setTransform(e, t, n, r, i, a) {
		return this.transform = [
			e,
			t,
			n,
			r,
			i,
			a
		], this;
	}
	embed(e) {
		let t, n = this.stops.length;
		if (n === 0) return;
		this.embedded = !0, this.matrix = e;
		let r = this.stops[n - 1];
		r[0] < 1 && this.stops.push([
			1,
			r[1],
			r[2]
		]);
		let i = [], a = [], o = [];
		for (let e = 0; e < n - 1; e++) a.push(0, 1), e + 2 !== n && i.push(this.stops[e + 1][0]), t = this.doc.ref({
			FunctionType: 2,
			Domain: [0, 1],
			C0: this.stops[e + 0][1],
			C1: this.stops[e + 1][1],
			N: 1
		}), o.push(t), t.end();
		n === 1 ? t = o[0] : (t = this.doc.ref({
			FunctionType: 3,
			Domain: [0, 1],
			Functions: o,
			Bounds: i,
			Encode: a
		}), t.end()), this.id = `Sh${++this.doc._gradCount}`;
		let s = this.shader(t);
		s.end();
		let c = this.doc.ref({
			Type: "Pattern",
			PatternType: 2,
			Shading: s,
			Matrix: this.matrix.map(pK)
		});
		if (c.end(), this.stops.some((e) => e[2] < 1)) {
			let e = this.opacityGradient();
			e._colorSpace = "DeviceGray";
			for (let t of this.stops) e.stop(t[0], [t[2]]);
			e = e.embed(this.matrix);
			let t = [
				0,
				0,
				this.doc.page.width,
				this.doc.page.height
			], n = this.doc.ref({
				Type: "XObject",
				Subtype: "Form",
				FormType: 1,
				BBox: t,
				Group: {
					Type: "Group",
					S: "Transparency",
					CS: "DeviceGray"
				},
				Resources: {
					ProcSet: [
						"PDF",
						"Text",
						"ImageB",
						"ImageC",
						"ImageI"
					],
					Pattern: { Sh1: e }
				}
			});
			n.write("/Pattern cs /Sh1 scn"), n.end(`${t.join(" ")} re f`);
			let r = this.doc.ref({
				Type: "ExtGState",
				SMask: {
					Type: "Mask",
					S: "Luminosity",
					G: n
				}
			});
			r.end();
			let i = this.doc.ref({
				Type: "Pattern",
				PatternType: 1,
				PaintType: 1,
				TilingType: 2,
				BBox: t,
				XStep: t[2],
				YStep: t[3],
				Resources: {
					ProcSet: [
						"PDF",
						"Text",
						"ImageB",
						"ImageC",
						"ImageI"
					],
					Pattern: { Sh1: c },
					ExtGState: { Gs1: r }
				}
			});
			i.write("/Gs1 gs /Pattern cs /Sh1 scn"), i.end(`${t.join(" ")} re f`), this.doc.page.patterns[this.id] = i;
		} else this.doc.page.patterns[this.id] = c;
		return c;
	}
	apply(e) {
		let [t, n, r, i, a, o] = this.doc._ctm, [s, c, l, u, d, f] = this.transform, p = [
			t * s + r * c,
			n * s + i * c,
			t * l + r * u,
			n * l + i * u,
			t * d + r * f + a,
			n * d + i * f + o
		];
		(!this.embedded || p.join(" ") !== this.matrix.join(" ")) && this.embed(p), this.doc._setColorSpace("Pattern", e);
		let m = e ? "SCN" : "scn";
		return this.doc.addContent(`/${this.id} ${m}`);
	}
}, hK = {
	PDFGradient: mK,
	PDFLinearGradient: class e extends mK {
		constructor(e, t, n, r, i) {
			super(e), this.x1 = t, this.y1 = n, this.x2 = r, this.y2 = i;
		}
		shader(e) {
			return this.doc.ref({
				ShadingType: 2,
				ColorSpace: this._colorSpace,
				Coords: [
					this.x1,
					this.y1,
					this.x2,
					this.y2
				],
				Function: e,
				Extend: [!0, !0]
			});
		}
		opacityGradient() {
			return new e(this.doc, this.x1, this.y1, this.x2, this.y2);
		}
	},
	PDFRadialGradient: class e extends mK {
		constructor(e, t, n, r, i, a, o) {
			super(e), this.doc = e, this.x1 = t, this.y1 = n, this.r1 = r, this.x2 = i, this.y2 = a, this.r2 = o;
		}
		shader(e) {
			return this.doc.ref({
				ShadingType: 3,
				ColorSpace: this._colorSpace,
				Coords: [
					this.x1,
					this.y1,
					this.r1,
					this.x2,
					this.y2,
					this.r2
				],
				Function: e,
				Extend: [!0, !0]
			});
		}
		opacityGradient() {
			return new e(this.doc, this.x1, this.y1, this.r1, this.x2, this.y2, this.r2);
		}
	}
}, gK = ["DeviceCMYK", "DeviceRGB"], _K = { PDFTilingPattern: class {
	constructor(e, t, n, r, i) {
		this.doc = e, this.bBox = t, this.xStep = n, this.yStep = r, this.stream = i;
	}
	createPattern() {
		let e = this.doc.ref();
		e.end();
		let [t, n, r, i, a, o] = this.doc._ctm, [s, c, l, u, d, f] = [
			1,
			0,
			0,
			1,
			0,
			0
		], p = [
			t * s + r * c,
			n * s + i * c,
			t * l + r * u,
			n * l + i * u,
			t * d + r * f + a,
			n * d + i * f + o
		], m = this.doc.ref({
			Type: "Pattern",
			PatternType: 1,
			PaintType: 2,
			TilingType: 2,
			BBox: this.bBox,
			XStep: this.xStep,
			YStep: this.yStep,
			Matrix: p.map((e) => +e.toFixed(5)),
			Resources: e
		});
		return m.end(this.stream), m;
	}
	embedPatternColorSpaces() {
		gK.forEach((e) => {
			let t = this.getPatternColorSpaceId(e);
			if (this.doc.page.colorSpaces[t]) return;
			let n = this.doc.ref(["Pattern", e]);
			n.end(), this.doc.page.colorSpaces[t] = n;
		});
	}
	getPatternColorSpaceId(e) {
		return `CsP${e}`;
	}
	embed() {
		this.id || (this.doc._patternCount = this.doc._patternCount + 1, this.id = "P" + this.doc._patternCount, this.pattern = this.createPattern()), this.doc.page.patterns[this.id] || (this.doc.page.patterns[this.id] = this.pattern);
	}
	apply(e, t) {
		this.embedPatternColorSpaces(), this.embed();
		let n = this.doc._normalizeColor(t);
		if (!n) throw Error(`invalid pattern color. (value: ${t})`);
		let r = this.getPatternColorSpaceId(this.doc._getColorSpace(n));
		this.doc._setColorSpace(r, e);
		let i = e ? "SCN" : "scn";
		return this.doc.addContent(`${n.join(" ")} /${this.id} ${i}`);
	}
} }, vK = class {
	constructor(e, t, n, r, i, a) {
		this.id = "CS" + Object.keys(e.spotColors).length, this.name = t, this.values = [
			n,
			r,
			i,
			a
		], this.ref = e.ref([
			"Separation",
			this.name,
			"DeviceCMYK",
			{
				Range: [
					0,
					1,
					0,
					1,
					0,
					1,
					0,
					1
				],
				C0: [
					0,
					0,
					0,
					0
				],
				C1: this.values.map((e) => e / 100),
				FunctionType: 2,
				Domain: [0, 1],
				N: 1
			}
		]), this.ref.end();
	}
	toString() {
		return `${this.ref.id} 0 R`;
	}
}, { PDFGradient: yK, PDFLinearGradient: bK, PDFRadialGradient: xK } = hK, { PDFTilingPattern: SK } = _K, CK = {
	initColor() {
		return this.spotColors = {}, this._opacityRegistry = {}, this._opacityCount = 0, this._patternCount = 0, this._gradCount = 0;
	},
	_normalizeColor(e) {
		if (typeof e == "string") {
			if (e.charAt(0) === "#") {
				e.length === 4 && (e = e.replace(/#([0-9A-F])([0-9A-F])([0-9A-F])/i, "#$1$1$2$2$3$3"));
				let t = parseInt(e.slice(1), 16);
				e = [
					t >> 16,
					t >> 8 & 255,
					t & 255
				];
			} else if (wK[e]) e = wK[e];
			else if (this.spotColors[e]) return this.spotColors[e];
		}
		return Array.isArray(e) ? (e.length === 3 ? e = e.map((e) => e / 255) : e.length === 4 && (e = e.map((e) => e / 100)), e) : null;
	},
	_setColor(e, t) {
		return e instanceof yK ? (e.apply(t), !0) : Array.isArray(e) && e[0] instanceof SK ? (e[0].apply(t, e[1]), !0) : this._setColorCore(e, t);
	},
	_setColorCore(e, t) {
		if (e = this._normalizeColor(e), !e) return !1;
		let n = t ? "SCN" : "scn", r = this._getColorSpace(e);
		return this._setColorSpace(r, t), e instanceof vK ? (this.page.colorSpaces[e.id] = e.ref, this.addContent(`1 ${n}`)) : this.addContent(`${e.join(" ")} ${n}`), !0;
	},
	_setColorSpace(e, t) {
		let n = t ? "CS" : "cs";
		return this.addContent(`/${e} ${n}`);
	},
	_getColorSpace(e) {
		return e instanceof vK ? e.id : e.length === 4 ? "DeviceCMYK" : "DeviceRGB";
	},
	fillColor(e, t) {
		return this._setColor(e, !1) && this.fillOpacity(t), this._fillColor = [e, t], this;
	},
	strokeColor(e, t) {
		return this._setColor(e, !0) && this.strokeOpacity(t), this;
	},
	opacity(e) {
		return this._doOpacity(e, e), this;
	},
	fillOpacity(e) {
		return this._doOpacity(e, null), this;
	},
	strokeOpacity(e) {
		return this._doOpacity(null, e), this;
	},
	_doOpacity(e, t) {
		let n, r;
		if (e == null && t == null) return;
		e != null && (e = Math.max(0, Math.min(1, e))), t != null && (t = Math.max(0, Math.min(1, t)));
		let i = `${e}_${t}`;
		return this._opacityRegistry[i] ? [n, r] = this._opacityRegistry[i] : (n = { Type: "ExtGState" }, e != null && (n.ca = e), t != null && (n.CA = t), n = this.ref(n), n.end(), r = `Gs${++this._opacityCount}`, this._opacityRegistry[i] = [n, r]), this.page.ext_gstates[r] = n, this.addContent(`/${r} gs`);
	},
	linearGradient(e, t, n, r) {
		return new bK(this, e, t, n, r);
	},
	radialGradient(e, t, n, r, i, a) {
		return new xK(this, e, t, n, r, i, a);
	},
	pattern(e, t, n, r) {
		return new SK(this, e, t, n, r);
	},
	addSpotColor(e, t, n, r, i) {
		let a = new vK(this, e, t, n, r, i);
		return this.spotColors[e] = a, this;
	}
}, wK = {
	aliceblue: [
		240,
		248,
		255
	],
	antiquewhite: [
		250,
		235,
		215
	],
	aqua: [
		0,
		255,
		255
	],
	aquamarine: [
		127,
		255,
		212
	],
	azure: [
		240,
		255,
		255
	],
	beige: [
		245,
		245,
		220
	],
	bisque: [
		255,
		228,
		196
	],
	black: [
		0,
		0,
		0
	],
	blanchedalmond: [
		255,
		235,
		205
	],
	blue: [
		0,
		0,
		255
	],
	blueviolet: [
		138,
		43,
		226
	],
	brown: [
		165,
		42,
		42
	],
	burlywood: [
		222,
		184,
		135
	],
	cadetblue: [
		95,
		158,
		160
	],
	chartreuse: [
		127,
		255,
		0
	],
	chocolate: [
		210,
		105,
		30
	],
	coral: [
		255,
		127,
		80
	],
	cornflowerblue: [
		100,
		149,
		237
	],
	cornsilk: [
		255,
		248,
		220
	],
	crimson: [
		220,
		20,
		60
	],
	cyan: [
		0,
		255,
		255
	],
	darkblue: [
		0,
		0,
		139
	],
	darkcyan: [
		0,
		139,
		139
	],
	darkgoldenrod: [
		184,
		134,
		11
	],
	darkgray: [
		169,
		169,
		169
	],
	darkgreen: [
		0,
		100,
		0
	],
	darkgrey: [
		169,
		169,
		169
	],
	darkkhaki: [
		189,
		183,
		107
	],
	darkmagenta: [
		139,
		0,
		139
	],
	darkolivegreen: [
		85,
		107,
		47
	],
	darkorange: [
		255,
		140,
		0
	],
	darkorchid: [
		153,
		50,
		204
	],
	darkred: [
		139,
		0,
		0
	],
	darksalmon: [
		233,
		150,
		122
	],
	darkseagreen: [
		143,
		188,
		143
	],
	darkslateblue: [
		72,
		61,
		139
	],
	darkslategray: [
		47,
		79,
		79
	],
	darkslategrey: [
		47,
		79,
		79
	],
	darkturquoise: [
		0,
		206,
		209
	],
	darkviolet: [
		148,
		0,
		211
	],
	deeppink: [
		255,
		20,
		147
	],
	deepskyblue: [
		0,
		191,
		255
	],
	dimgray: [
		105,
		105,
		105
	],
	dimgrey: [
		105,
		105,
		105
	],
	dodgerblue: [
		30,
		144,
		255
	],
	firebrick: [
		178,
		34,
		34
	],
	floralwhite: [
		255,
		250,
		240
	],
	forestgreen: [
		34,
		139,
		34
	],
	fuchsia: [
		255,
		0,
		255
	],
	gainsboro: [
		220,
		220,
		220
	],
	ghostwhite: [
		248,
		248,
		255
	],
	gold: [
		255,
		215,
		0
	],
	goldenrod: [
		218,
		165,
		32
	],
	gray: [
		128,
		128,
		128
	],
	grey: [
		128,
		128,
		128
	],
	green: [
		0,
		128,
		0
	],
	greenyellow: [
		173,
		255,
		47
	],
	honeydew: [
		240,
		255,
		240
	],
	hotpink: [
		255,
		105,
		180
	],
	indianred: [
		205,
		92,
		92
	],
	indigo: [
		75,
		0,
		130
	],
	ivory: [
		255,
		255,
		240
	],
	khaki: [
		240,
		230,
		140
	],
	lavender: [
		230,
		230,
		250
	],
	lavenderblush: [
		255,
		240,
		245
	],
	lawngreen: [
		124,
		252,
		0
	],
	lemonchiffon: [
		255,
		250,
		205
	],
	lightblue: [
		173,
		216,
		230
	],
	lightcoral: [
		240,
		128,
		128
	],
	lightcyan: [
		224,
		255,
		255
	],
	lightgoldenrodyellow: [
		250,
		250,
		210
	],
	lightgray: [
		211,
		211,
		211
	],
	lightgreen: [
		144,
		238,
		144
	],
	lightgrey: [
		211,
		211,
		211
	],
	lightpink: [
		255,
		182,
		193
	],
	lightsalmon: [
		255,
		160,
		122
	],
	lightseagreen: [
		32,
		178,
		170
	],
	lightskyblue: [
		135,
		206,
		250
	],
	lightslategray: [
		119,
		136,
		153
	],
	lightslategrey: [
		119,
		136,
		153
	],
	lightsteelblue: [
		176,
		196,
		222
	],
	lightyellow: [
		255,
		255,
		224
	],
	lime: [
		0,
		255,
		0
	],
	limegreen: [
		50,
		205,
		50
	],
	linen: [
		250,
		240,
		230
	],
	magenta: [
		255,
		0,
		255
	],
	maroon: [
		128,
		0,
		0
	],
	mediumaquamarine: [
		102,
		205,
		170
	],
	mediumblue: [
		0,
		0,
		205
	],
	mediumorchid: [
		186,
		85,
		211
	],
	mediumpurple: [
		147,
		112,
		219
	],
	mediumseagreen: [
		60,
		179,
		113
	],
	mediumslateblue: [
		123,
		104,
		238
	],
	mediumspringgreen: [
		0,
		250,
		154
	],
	mediumturquoise: [
		72,
		209,
		204
	],
	mediumvioletred: [
		199,
		21,
		133
	],
	midnightblue: [
		25,
		25,
		112
	],
	mintcream: [
		245,
		255,
		250
	],
	mistyrose: [
		255,
		228,
		225
	],
	moccasin: [
		255,
		228,
		181
	],
	navajowhite: [
		255,
		222,
		173
	],
	navy: [
		0,
		0,
		128
	],
	oldlace: [
		253,
		245,
		230
	],
	olive: [
		128,
		128,
		0
	],
	olivedrab: [
		107,
		142,
		35
	],
	orange: [
		255,
		165,
		0
	],
	orangered: [
		255,
		69,
		0
	],
	orchid: [
		218,
		112,
		214
	],
	palegoldenrod: [
		238,
		232,
		170
	],
	palegreen: [
		152,
		251,
		152
	],
	paleturquoise: [
		175,
		238,
		238
	],
	palevioletred: [
		219,
		112,
		147
	],
	papayawhip: [
		255,
		239,
		213
	],
	peachpuff: [
		255,
		218,
		185
	],
	peru: [
		205,
		133,
		63
	],
	pink: [
		255,
		192,
		203
	],
	plum: [
		221,
		160,
		221
	],
	powderblue: [
		176,
		224,
		230
	],
	purple: [
		128,
		0,
		128
	],
	red: [
		255,
		0,
		0
	],
	rosybrown: [
		188,
		143,
		143
	],
	royalblue: [
		65,
		105,
		225
	],
	saddlebrown: [
		139,
		69,
		19
	],
	salmon: [
		250,
		128,
		114
	],
	sandybrown: [
		244,
		164,
		96
	],
	seagreen: [
		46,
		139,
		87
	],
	seashell: [
		255,
		245,
		238
	],
	sienna: [
		160,
		82,
		45
	],
	silver: [
		192,
		192,
		192
	],
	skyblue: [
		135,
		206,
		235
	],
	slateblue: [
		106,
		90,
		205
	],
	slategray: [
		112,
		128,
		144
	],
	slategrey: [
		112,
		128,
		144
	],
	snow: [
		255,
		250,
		250
	],
	springgreen: [
		0,
		255,
		127
	],
	steelblue: [
		70,
		130,
		180
	],
	tan: [
		210,
		180,
		140
	],
	teal: [
		0,
		128,
		128
	],
	thistle: [
		216,
		191,
		216
	],
	tomato: [
		255,
		99,
		71
	],
	turquoise: [
		64,
		224,
		208
	],
	violet: [
		238,
		130,
		238
	],
	wheat: [
		245,
		222,
		179
	],
	white: [
		255,
		255,
		255
	],
	whitesmoke: [
		245,
		245,
		245
	],
	yellow: [
		255,
		255,
		0
	],
	yellowgreen: [
		154,
		205,
		50
	]
}, TK = EK = DK = OK = kK = AK = 0, EK, DK, OK, kK, AK, jK = {
	M: 2,
	m: 2,
	Z: 0,
	z: 0,
	L: 2,
	l: 2,
	H: 1,
	h: 1,
	V: 1,
	v: 1,
	C: 6,
	c: 6,
	S: 4,
	s: 4,
	Q: 4,
	q: 4,
	T: 2,
	t: 2,
	A: 7,
	a: 7
}, MK = (e) => e in jK, NK = (e) => {
	let t = e.codePointAt(0);
	return t === 32 || t === 9 || t === 13 || t === 10;
}, PK = (e) => {
	let t = e.codePointAt(0);
	return t == null ? !1 : 48 <= t && t <= 57;
}, FK = (e, t) => {
	let n = t, r = "", i = "none";
	for (; n < e.length; n += 1) {
		let t = e[n];
		if (t === "+" || t === "-") {
			if (i === "none") {
				i = "sign", r += t;
				continue;
			}
			if (i === "e") {
				i = "exponent_sign", r += t;
				continue;
			}
		}
		if (PK(t)) {
			if (i === "none" || i === "sign" || i === "whole") {
				i = "whole", r += t;
				continue;
			}
			if (i === "decimal_point" || i === "decimal") {
				i = "decimal", r += t;
				continue;
			}
			if (i === "e" || i === "exponent_sign" || i === "exponent") {
				i = "exponent", r += t;
				continue;
			}
		}
		if (t === "." && (i === "none" || i === "sign" || i === "whole")) {
			i = "decimal_point", r += t;
			continue;
		}
		if ((t === "E" || t === "e") && (i === "whole" || i === "decimal_point" || i === "decimal")) {
			i = "e", r += t;
			continue;
		}
		break;
	}
	let a = Number.parseFloat(r);
	return Number.isNaN(a) ? [t, null] : [n - 1, a];
}, IK = (e) => {
	let t = [], n = null, r = [], i = 0, a = !1, o = !1;
	for (let s = 0; s < e.length; s += 1) {
		let c = e.charAt(s);
		if (NK(c)) continue;
		if (a && c === ",") {
			if (o) break;
			o = !0;
			continue;
		}
		if (MK(c)) {
			if (o) return t;
			if (n == null) {
				if (c !== "M" && c !== "m") return t;
			} else if (r.length !== 0) return t;
			n = c, r = [], i = jK[n], a = !1, i === 0 && t.push({
				command: n,
				args: r
			});
			continue;
		}
		if (n == null) return t;
		let l = s, u = null;
		if (n === "A" || n === "a") {
			let t = r.length;
			(t === 0 || t === 1) && c !== "+" && c !== "-" && ([l, u] = FK(e, s)), (t === 2 || t === 5 || t === 6) && ([l, u] = FK(e, s)), (t === 3 || t === 4) && (c === "0" && (u = 0), c === "1" && (u = 1));
		} else [l, u] = FK(e, s);
		if (u == null) return t;
		r.push(u), a = !0, o = !1, s = l, r.length === i && (t.push({
			command: n,
			args: r
		}), n === "M" && (n = "L"), n === "m" && (n = "l"), r = []);
	}
	return t;
}, LK = function(e, t) {
	TK = EK = DK = OK = kK = AK = 0;
	for (let n = 0; n < e.length; n++) {
		let { command: r, args: i } = e[n];
		typeof RK[r] == "function" && RK[r](t, i);
	}
}, RK = {
	M(e, t) {
		return TK = t[0], EK = t[1], DK = OK = null, kK = TK, AK = EK, e.moveTo(TK, EK);
	},
	m(e, t) {
		return TK += t[0], EK += t[1], DK = OK = null, kK = TK, AK = EK, e.moveTo(TK, EK);
	},
	C(e, t) {
		return TK = t[4], EK = t[5], DK = t[2], OK = t[3], e.bezierCurveTo(...t);
	},
	c(e, t) {
		return e.bezierCurveTo(t[0] + TK, t[1] + EK, t[2] + TK, t[3] + EK, t[4] + TK, t[5] + EK), DK = TK + t[2], OK = EK + t[3], TK += t[4], EK += t[5];
	},
	S(e, t) {
		return DK === null && (DK = TK, OK = EK), e.bezierCurveTo(TK - (DK - TK), EK - (OK - EK), t[0], t[1], t[2], t[3]), DK = t[0], OK = t[1], TK = t[2], EK = t[3];
	},
	s(e, t) {
		return DK === null && (DK = TK, OK = EK), e.bezierCurveTo(TK - (DK - TK), EK - (OK - EK), TK + t[0], EK + t[1], TK + t[2], EK + t[3]), DK = TK + t[0], OK = EK + t[1], TK += t[2], EK += t[3];
	},
	Q(e, t) {
		return DK = t[0], OK = t[1], TK = t[2], EK = t[3], e.quadraticCurveTo(t[0], t[1], TK, EK);
	},
	q(e, t) {
		return e.quadraticCurveTo(t[0] + TK, t[1] + EK, t[2] + TK, t[3] + EK), DK = TK + t[0], OK = EK + t[1], TK += t[2], EK += t[3];
	},
	T(e, t) {
		return DK === null ? (DK = TK, OK = EK) : (DK = TK - (DK - TK), OK = EK - (OK - EK)), e.quadraticCurveTo(DK, OK, t[0], t[1]), DK = TK - (DK - TK), OK = EK - (OK - EK), TK = t[0], EK = t[1];
	},
	t(e, t) {
		return DK === null ? (DK = TK, OK = EK) : (DK = TK - (DK - TK), OK = EK - (OK - EK)), e.quadraticCurveTo(DK, OK, TK + t[0], EK + t[1]), TK += t[0], EK += t[1];
	},
	A(e, t) {
		return zK(e, TK, EK, t), TK = t[5], EK = t[6];
	},
	a(e, t) {
		return t[5] += TK, t[6] += EK, zK(e, TK, EK, t), TK = t[5], EK = t[6];
	},
	L(e, t) {
		return TK = t[0], EK = t[1], DK = OK = null, e.lineTo(TK, EK);
	},
	l(e, t) {
		return TK += t[0], EK += t[1], DK = OK = null, e.lineTo(TK, EK);
	},
	H(e, t) {
		return TK = t[0], DK = OK = null, e.lineTo(TK, EK);
	},
	h(e, t) {
		return TK += t[0], DK = OK = null, e.lineTo(TK, EK);
	},
	V(e, t) {
		return EK = t[0], DK = OK = null, e.lineTo(TK, EK);
	},
	v(e, t) {
		return EK += t[0], DK = OK = null, e.lineTo(TK, EK);
	},
	Z(e) {
		return e.closePath(), TK = kK, EK = AK;
	},
	z(e) {
		return e.closePath(), TK = kK, EK = AK;
	}
}, zK = function(e, t, n, r) {
	let [i, a, o, s, c, l, u] = r, d = BK(l, u, i, a, s, c, o, t, n);
	for (let t of d) {
		let n = VK(...t);
		e.bezierCurveTo(...n);
	}
}, BK = function(e, t, n, r, i, a, o, s, c) {
	let l = Math.PI / 180 * o, u = Math.sin(l), d = Math.cos(l);
	n = Math.abs(n), r = Math.abs(r), DK = d * (s - e) * .5 + u * (c - t) * .5, OK = d * (c - t) * .5 - u * (s - e) * .5;
	let f = DK * DK / (n * n) + OK * OK / (r * r);
	f > 1 && (f = Math.sqrt(f), n *= f, r *= f);
	let p = d / n, m = u / n, h = -u / r, g = d / r, _ = p * s + m * c, v = h * s + g * c, y = p * e + m * t, b = h * e + g * t, x = 1 / ((y - _) * (y - _) + (b - v) * (b - v)) - .25;
	x < 0 && (x = 0);
	let S = Math.sqrt(x);
	a === i && (S = -S);
	let C = .5 * (_ + y) - S * (b - v), w = .5 * (v + b) + S * (y - _), T = Math.atan2(v - w, _ - C), E = Math.atan2(b - w, y - C) - T;
	E < 0 && a === 1 ? E += 2 * Math.PI : E > 0 && a === 0 && (E -= 2 * Math.PI);
	let D = Math.ceil(Math.abs(E / (Math.PI * .5 + .001))), O = [];
	for (let e = 0; e < D; e++) O[e] = [
		C,
		w,
		T + e * E / D,
		T + (e + 1) * E / D,
		n,
		r,
		u,
		d
	];
	return O;
}, VK = function(e, t, n, r, i, a, o, s) {
	let c = s * i, l = -o * a, u = o * i, d = s * a, f = .5 * (r - n), p = 8 / 3 * Math.sin(f * .5) * Math.sin(f * .5) / Math.sin(f), m = e + Math.cos(n) - p * Math.sin(n), h = t + Math.sin(n) + p * Math.cos(n), g = e + Math.cos(r), _ = t + Math.sin(r), v = g + p * Math.sin(r), y = _ - p * Math.cos(r);
	return [
		c * m + l * h,
		u * m + d * h,
		c * v + l * y,
		u * v + d * y,
		c * g + l * _,
		u * g + d * _
	];
}, HK = class {
	static apply(e, t) {
		LK(IK(t), e);
	}
}, { number: UK } = sK, WK = 4 * ((Math.sqrt(2) - 1) / 3), GK = {
	initVector() {
		return this._ctm = [
			1,
			0,
			0,
			1,
			0,
			0
		], this._ctmStack = [];
	},
	save() {
		return this._ctmStack.push(this._ctm.slice()), this.addContent("q");
	},
	restore() {
		return this._ctm = this._ctmStack.pop() || [
			1,
			0,
			0,
			1,
			0,
			0
		], this.addContent("Q");
	},
	closePath() {
		return this.addContent("h");
	},
	lineWidth(e) {
		return this.addContent(`${UK(e)} w`);
	},
	_CAP_STYLES: {
		BUTT: 0,
		ROUND: 1,
		SQUARE: 2
	},
	lineCap(e) {
		return typeof e == "string" && (e = this._CAP_STYLES[e.toUpperCase()]), this.addContent(`${e} J`);
	},
	_JOIN_STYLES: {
		MITER: 0,
		ROUND: 1,
		BEVEL: 2
	},
	lineJoin(e) {
		return typeof e == "string" && (e = this._JOIN_STYLES[e.toUpperCase()]), this.addContent(`${e} j`);
	},
	miterLimit(e) {
		return this.addContent(`${UK(e)} M`);
	},
	dash(e, t) {
		t === void 0 && (t = {});
		let n = e;
		if (Array.isArray(e) || (e = [e, t.space || e]), !e.every((e) => Number.isFinite(e) && e > 0)) throw Error(`dash(${JSON.stringify(n)}, ${JSON.stringify(t)}) invalid, lengths must be numeric and greater than zero`);
		return e = e.map(UK).join(" "), this.addContent(`[${e}] ${UK(t.phase || 0)} d`);
	},
	undash() {
		return this.addContent("[] 0 d");
	},
	moveTo(e, t) {
		return this.addContent(`${UK(e)} ${UK(t)} m`);
	},
	lineTo(e, t) {
		return this.addContent(`${UK(e)} ${UK(t)} l`);
	},
	bezierCurveTo(e, t, n, r, i, a) {
		return this.addContent(`${UK(e)} ${UK(t)} ${UK(n)} ${UK(r)} ${UK(i)} ${UK(a)} c`);
	},
	quadraticCurveTo(e, t, n, r) {
		return this.addContent(`${UK(e)} ${UK(t)} ${UK(n)} ${UK(r)} v`);
	},
	rect(e, t, n, r) {
		return this.addContent(`${UK(e)} ${UK(t)} ${UK(n)} ${UK(r)} re`);
	},
	roundedRect(e, t, n, r, i) {
		i ??= 0, i = Math.min(i, .5 * n, .5 * r);
		let a = i * (1 - WK);
		return this.moveTo(e + i, t), this.lineTo(e + n - i, t), this.bezierCurveTo(e + n - a, t, e + n, t + a, e + n, t + i), this.lineTo(e + n, t + r - i), this.bezierCurveTo(e + n, t + r - a, e + n - a, t + r, e + n - i, t + r), this.lineTo(e + i, t + r), this.bezierCurveTo(e + a, t + r, e, t + r - a, e, t + r - i), this.lineTo(e, t + i), this.bezierCurveTo(e, t + a, e + a, t, e + i, t), this.closePath();
	},
	ellipse(e, t, n, r) {
		r ??= n, e -= n, t -= r;
		let i = n * WK, a = r * WK, o = e + n * 2, s = t + r * 2, c = e + n, l = t + r;
		return this.moveTo(e, l), this.bezierCurveTo(e, l - a, c - i, t, c, t), this.bezierCurveTo(c + i, t, o, l - a, o, l), this.bezierCurveTo(o, l + a, c + i, s, c, s), this.bezierCurveTo(c - i, s, e, l + a, e, l), this.closePath();
	},
	circle(e, t, n) {
		return this.ellipse(e, t, n);
	},
	arc(e, t, n, r, i, a) {
		a ??= !1;
		let o = 2 * Math.PI, s = .5 * Math.PI, c = i - r;
		Math.abs(c) > o ? c = o : c !== 0 && a !== c < 0 && (c = (a ? -1 : 1) * o + c);
		let l = Math.ceil(Math.abs(c) / s), u = c / l, d = u / s * WK * n, f = r, p = -Math.sin(f) * d, m = Math.cos(f) * d, h = e + Math.cos(f) * n, g = t + Math.sin(f) * n;
		this.moveTo(h, g);
		for (let r = 0; r < l; r++) {
			let r = h + p, i = g + m;
			f += u, h = e + Math.cos(f) * n, g = t + Math.sin(f) * n, p = -Math.sin(f) * d, m = Math.cos(f) * d;
			let a = h - p, o = g - m;
			this.bezierCurveTo(r, i, a, o, h, g);
		}
		return this;
	},
	polygon() {
		var e = [...arguments];
		this.moveTo(...e.shift() || []);
		for (let t of e) this.lineTo(...t || []);
		return this.closePath();
	},
	path(e) {
		return HK.apply(this, e), this;
	},
	_windingRule(e) {
		return /even-?odd/.test(e) ? "*" : "";
	},
	fill(e, t) {
		return /(even-?odd)|(non-?zero)/.test(e) && (t = e, e = null), e && this.fillColor(e), this.addContent(`f${this._windingRule(t)}`);
	},
	stroke(e) {
		return e && this.strokeColor(e), this.addContent("S");
	},
	fillAndStroke(e, t, n) {
		t ??= e;
		let r = /(even-?odd)|(non-?zero)/;
		return r.test(e) && (n = e, e = null), r.test(t) && (n = t, t = e), e && (this.fillColor(e), this.strokeColor(t)), this.addContent(`B${this._windingRule(n)}`);
	},
	clip(e) {
		return this.addContent(`W${this._windingRule(e)} n`);
	},
	transform(e, t, n, r, i, a) {
		if (e === 1 && t === 0 && n === 0 && r === 1 && i === 0 && a === 0) return this;
		let o = this._ctm, [s, c, l, u, d, f] = o;
		o[0] = s * e + l * t, o[1] = c * e + u * t, o[2] = s * n + l * r, o[3] = c * n + u * r, o[4] = s * i + l * a + d, o[5] = c * i + u * a + f;
		let p = [
			e,
			t,
			n,
			r,
			i,
			a
		].map((e) => UK(e)).join(" ");
		return this.addContent(`${p} cm`);
	},
	translate(e, t) {
		return this.transform(1, 0, 0, 1, e, t);
	},
	rotate(e, t) {
		t === void 0 && (t = {});
		let n, r = e * Math.PI / 180, i = Math.cos(r), a = Math.sin(r), o = n = 0;
		if (t.origin != null) {
			[o, n] = t.origin;
			let e = o * i - n * a, r = o * a + n * i;
			o -= e, n -= r;
		}
		return this.transform(i, a, -a, i, o, n);
	},
	scale(e, t, n) {
		n === void 0 && (n = {});
		let r;
		t ??= e, typeof t == "object" && (n = t, t = e);
		let i = r = 0;
		return n.origin != null && ([i, r] = n.origin, i -= e * i, r -= t * r), this.transform(e, 0, 0, t, i, r);
	}
}, KK = {}, qK = (e, t, n) => {
	let r = [], i = t + 1;
	for (let t = e; t < i; t++) r.push(t);
	return r;
}, JK = {
	402: 131,
	8211: 150,
	8212: 151,
	8216: 145,
	8217: 146,
	8218: 130,
	8220: 147,
	8221: 148,
	8222: 132,
	8224: 134,
	8225: 135,
	8226: 149,
	8230: 133,
	8364: 128,
	8240: 137,
	8249: 139,
	8250: 155,
	710: 136,
	8482: 153,
	338: 140,
	339: 156,
	732: 152,
	352: 138,
	353: 154,
	376: 159,
	381: 142,
	382: 158
}, YK = ".notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n.notdef       .notdef        .notdef        .notdef\n\nspace         exclam         quotedbl       numbersign\ndollar        percent        ampersand      quotesingle\nparenleft     parenright     asterisk       plus\ncomma         hyphen         period         slash\nzero          one            two            three\nfour          five           six            seven\neight         nine           colon          semicolon\nless          equal          greater        question\n\nat            A              B              C\nD             E              F              G\nH             I              J              K\nL             M              N              O\nP             Q              R              S\nT             U              V              W\nX             Y              Z              bracketleft\nbackslash     bracketright   asciicircum    underscore\n\ngrave         a              b              c\nd             e              f              g\nh             i              j              k\nl             m              n              o\np             q              r              s\nt             u              v              w\nx             y              z              braceleft\nbar           braceright     asciitilde     .notdef\n\nEuro          .notdef        quotesinglbase florin\nquotedblbase  ellipsis       dagger         daggerdbl\ncircumflex    perthousand    Scaron         guilsinglleft\nOE            .notdef        Zcaron         .notdef\n.notdef       quoteleft      quoteright     quotedblleft\nquotedblright bullet         endash         emdash\ntilde         trademark      scaron         guilsinglright\noe            .notdef        zcaron         ydieresis\n\nspace         exclamdown     cent           sterling\ncurrency      yen            brokenbar      section\ndieresis      copyright      ordfeminine    guillemotleft\nlogicalnot    hyphen         registered     macron\ndegree        plusminus      twosuperior    threesuperior\nacute         mu             paragraph      periodcentered\ncedilla       onesuperior    ordmasculine   guillemotright\nonequarter    onehalf        threequarters  questiondown\n\nAgrave        Aacute         Acircumflex    Atilde\nAdieresis     Aring          AE             Ccedilla\nEgrave        Eacute         Ecircumflex    Edieresis\nIgrave        Iacute         Icircumflex    Idieresis\nEth           Ntilde         Ograve         Oacute\nOcircumflex   Otilde         Odieresis      multiply\nOslash        Ugrave         Uacute         Ucircumflex\nUdieresis     Yacute         Thorn          germandbls\n\nagrave        aacute         acircumflex    atilde\nadieresis     aring          ae             ccedilla\negrave        eacute         ecircumflex    edieresis\nigrave        iacute         icircumflex    idieresis\neth           ntilde         ograve         oacute\nocircumflex   otilde         odieresis      divide\noslash        ugrave         uacute         ucircumflex\nudieresis     yacute         thorn          ydieresis".split(/\s+/);
function XK(e) {
	let t = {
		attributes: {},
		glyphWidths: {},
		kernPairs: {}
	}, n = "";
	for (let c of e.split("\n")) {
		var r, i;
		if (r = c.match(/^Start(\w+)/)) {
			n = r[1];
			continue;
		} else if (r = c.match(/^End(\w+)/)) {
			n = "";
			continue;
		}
		switch (n) {
			case "FontMetrics":
				r = c.match(/(^\w+)\s+(.*)/);
				var a = r[1], o = r[2];
				(i = t.attributes[a]) ? (Array.isArray(i) || (i = t.attributes[a] = [i]), i.push(o)) : t.attributes[a] = o;
				break;
			case "CharMetrics":
				if (!/^CH?\s/.test(c)) continue;
				var s = c.match(/\bN\s+(\.?\w+)\s*;/)[1];
				t.glyphWidths[s] = +c.match(/\bWX\s+(\d+)\s*;/)[1];
				break;
			case "KernPairs":
				r = c.match(/^KPX\s+(\.?\w+)\s+(\.?\w+)\s+(-?\d+)/), r && (t.kernPairs[r[1] + r[2]] = parseInt(r[3]));
				break;
		}
	}
	return t;
}
var ZK = class e {
	static open(e) {
		throw Error("AFMFont.open not available on browser build");
	}
	static fromJson(t) {
		return new e(t);
	}
	constructor(e) {
		typeof e == "string" ? (this.contents = e, this.parse()) : (this.attributes = e.attributes, this.glyphWidths = e.glyphWidths, this.kernPairs = e.kernPairs), this.charWidths = qK(0, 255).map((e) => this.glyphWidths[YK[e]]), this.bbox = Array.from(this.attributes.FontBBox.split(/\s+/)).map((e) => +e), this.ascender = +(this.attributes.Ascender || 0), this.descender = +(this.attributes.Descender || 0), this.xHeight = +(this.attributes.XHeight || 0), this.capHeight = +(this.attributes.CapHeight || 0), this.lineGap = this.bbox[3] - this.bbox[1] - (this.ascender - this.descender);
	}
	parse() {
		let e = XK(this.contents);
		this.attributes = e.attributes, this.glyphWidths = e.glyphWidths, this.kernPairs = e.kernPairs;
	}
	encodeText(e) {
		let t = [];
		for (let n = 0, r = e.length, i = 0 <= r; i ? n < r : n > r; i ? n++ : n--) {
			let r = e.charCodeAt(n);
			r = JK[r] || r, t.push(r.toString(16));
		}
		return t;
	}
	glyphsForString(e) {
		let t = [];
		for (let n = 0, r = e.length, i = 0 <= r; i ? n < r : n > r; i ? n++ : n--) {
			let r = e.charCodeAt(n);
			t.push(this.characterToGlyph(r));
		}
		return t;
	}
	characterToGlyph(e) {
		return YK[JK[e] || e] || ".notdef";
	}
	widthOfGlyph(e) {
		return this.glyphWidths[e] || 0;
	}
	getKernPair(e, t) {
		return this.kernPairs[e + t] || 0;
	}
	advancesForGlyphs(e) {
		let t = [];
		for (let n = 0; n < e.length; n++) {
			let r = e[n], i = e[n + 1];
			t.push(this.widthOfGlyph(r) + this.getKernPair(r, i));
		}
		return t;
	}
}, QK = {
	attributes: [
		{
			Comment: [
				"Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
				"Creation Date: Thu May  1 12:43:52 1997",
				"UniqueID 43052",
				"VMusage 37169 48194"
			],
			FontName: "Helvetica-Bold",
			FullName: "Helvetica Bold",
			FamilyName: "Helvetica",
			Weight: "Bold",
			ItalicAngle: "0",
			IsFixedPitch: "false",
			CharacterSet: "ExtendedRoman",
			FontBBox: "-170 -228 1003 962 ",
			UnderlinePosition: "-100",
			UnderlineThickness: "50",
			Version: "002.000",
			Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.",
			EncodingScheme: "AdobeStandardEncoding",
			CapHeight: "718",
			XHeight: "532",
			Ascender: "718",
			Descender: "-207",
			StdHW: "118",
			StdVW: "140"
		},
		{
			Comment: [
				"Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
				"Creation Date: Thu May  1 12:45:12 1997",
				"UniqueID 43053",
				"VMusage 14482 68586"
			],
			FontName: "Helvetica-BoldOblique",
			FullName: "Helvetica Bold Oblique",
			FamilyName: "Helvetica",
			Weight: "Bold",
			ItalicAngle: "-12",
			IsFixedPitch: "false",
			CharacterSet: "ExtendedRoman",
			FontBBox: "-174 -228 1114 962",
			UnderlinePosition: "-100",
			UnderlineThickness: "50",
			Version: "002.000",
			Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.",
			EncodingScheme: "AdobeStandardEncoding",
			CapHeight: "718",
			XHeight: "532",
			Ascender: "718",
			Descender: "-207",
			StdHW: "118",
			StdVW: "140"
		},
		{
			Comment: [
				"Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
				"Creation Date: Thu May  1 12:44:31 1997",
				"UniqueID 43055",
				"VMusage 14960 69346"
			],
			FontName: "Helvetica-Oblique",
			FullName: "Helvetica Oblique",
			FamilyName: "Helvetica",
			Weight: "Medium",
			ItalicAngle: "-12",
			IsFixedPitch: "false",
			CharacterSet: "ExtendedRoman",
			FontBBox: "-170 -225 1116 931 ",
			UnderlinePosition: "-100",
			UnderlineThickness: "50",
			Version: "002.000",
			Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.",
			EncodingScheme: "AdobeStandardEncoding",
			CapHeight: "718",
			XHeight: "523",
			Ascender: "718",
			Descender: "-207",
			StdHW: "76",
			StdVW: "88"
		},
		{
			Comment: [
				"Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
				"Creation Date: Thu May  1 12:38:23 1997",
				"UniqueID 43054",
				"VMusage 37069 48094"
			],
			FontName: "Helvetica",
			FullName: "Helvetica",
			FamilyName: "Helvetica",
			Weight: "Medium",
			ItalicAngle: "0",
			IsFixedPitch: "false",
			CharacterSet: "ExtendedRoman",
			FontBBox: "-166 -225 1000 931 ",
			UnderlinePosition: "-100",
			UnderlineThickness: "50",
			Version: "002.000",
			Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1997 Adobe Systems Incorporated.  All Rights Reserved.Helvetica is a trademark of Linotype-Hell AG and/or its subsidiaries.",
			EncodingScheme: "AdobeStandardEncoding",
			CapHeight: "718",
			XHeight: "523",
			Ascender: "718",
			Descender: "-207",
			StdHW: "76",
			StdVW: "88"
		},
		{
			Comment: [
				"Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
				"Creation Date: Thu May  1 12:52:56 1997",
				"UniqueID 43065",
				"VMusage 41636 52661"
			],
			FontName: "Times-Bold",
			FullName: "Times Bold",
			FamilyName: "Times",
			Weight: "Bold",
			ItalicAngle: "0",
			IsFixedPitch: "false",
			CharacterSet: "ExtendedRoman",
			FontBBox: "-168 -218 1000 935 ",
			UnderlinePosition: "-100",
			UnderlineThickness: "50",
			Version: "002.000",
			Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.",
			EncodingScheme: "AdobeStandardEncoding",
			CapHeight: "676",
			XHeight: "461",
			Ascender: "683",
			Descender: "-217",
			StdHW: "44",
			StdVW: "139"
		},
		{
			Comment: [
				"Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
				"Creation Date: Thu May  1 13:04:06 1997",
				"UniqueID 43066",
				"VMusage 45874 56899"
			],
			FontName: "Times-BoldItalic",
			FullName: "Times Bold Italic",
			FamilyName: "Times",
			Weight: "Bold",
			ItalicAngle: "-15",
			IsFixedPitch: "false",
			CharacterSet: "ExtendedRoman",
			FontBBox: "-200 -218 996 921",
			UnderlinePosition: "-100",
			UnderlineThickness: "50",
			Version: "002.000",
			Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.",
			EncodingScheme: "AdobeStandardEncoding",
			CapHeight: "669",
			XHeight: "462",
			Ascender: "683",
			Descender: "-217",
			StdHW: "42",
			StdVW: "121"
		},
		{
			Comment: [
				"Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
				"Creation Date: Thu May  1 12:56:55 1997",
				"UniqueID 43067",
				"VMusage 47727 58752"
			],
			FontName: "Times-Italic",
			FullName: "Times Italic",
			FamilyName: "Times",
			Weight: "Medium",
			ItalicAngle: "-15.5",
			IsFixedPitch: "false",
			CharacterSet: "ExtendedRoman",
			FontBBox: "-169 -217 1010 883 ",
			UnderlinePosition: "-100",
			UnderlineThickness: "50",
			Version: "002.000",
			Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.",
			EncodingScheme: "AdobeStandardEncoding",
			CapHeight: "653",
			XHeight: "441",
			Ascender: "683",
			Descender: "-217",
			StdHW: "32",
			StdVW: "76"
		},
		{
			Comment: [
				"Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
				"Creation Date: Thu May  1 12:49:17 1997",
				"UniqueID 43068",
				"VMusage 43909 54934"
			],
			FontName: "Times-Roman",
			FullName: "Times Roman",
			FamilyName: "Times",
			Weight: "Roman",
			ItalicAngle: "0",
			IsFixedPitch: "false",
			CharacterSet: "ExtendedRoman",
			FontBBox: "-168 -218 1000 898 ",
			UnderlinePosition: "-100",
			UnderlineThickness: "50",
			Version: "002.000",
			Notice: "Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.",
			EncodingScheme: "AdobeStandardEncoding",
			CapHeight: "662",
			XHeight: "450",
			Ascender: "683",
			Descender: "-217",
			StdHW: "28",
			StdVW: "84"
		},
		{
			Comment: [
				"Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
				"Creation Date: Mon Jun 23 16:28:00 1997",
				"UniqueID 43048",
				"VMusage 41139 52164"
			],
			FontName: "Courier-Bold",
			FullName: "Courier Bold",
			FamilyName: "Courier",
			Weight: "Bold",
			ItalicAngle: "0",
			IsFixedPitch: "true",
			CharacterSet: "ExtendedRoman",
			FontBBox: "-113 -250 749 801 ",
			UnderlinePosition: "-100",
			UnderlineThickness: "50",
			Version: "003.000",
			Notice: "Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
			EncodingScheme: "AdobeStandardEncoding",
			CapHeight: "562",
			XHeight: "439",
			Ascender: "629",
			Descender: "-157",
			StdHW: "84",
			StdVW: "106"
		},
		{
			Comment: [
				"Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
				"Creation Date: Mon Jun 23 16:28:46 1997",
				"UniqueID 43049",
				"VMusage 17529 79244"
			],
			FontName: "Courier-BoldOblique",
			FullName: "Courier Bold Oblique",
			FamilyName: "Courier",
			Weight: "Bold",
			ItalicAngle: "-12",
			IsFixedPitch: "true",
			CharacterSet: "ExtendedRoman",
			FontBBox: "-57 -250 869 801",
			UnderlinePosition: "-100",
			UnderlineThickness: "50",
			Version: "003.000",
			Notice: "Copyright (c) 1989, 1990, 1991, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
			EncodingScheme: "AdobeStandardEncoding",
			CapHeight: "562",
			XHeight: "439",
			Ascender: "629",
			Descender: "-157",
			StdHW: "84",
			StdVW: "106"
		},
		{
			Comment: [
				"Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
				"Creation Date: Thu May  1 17:37:52 1997",
				"UniqueID 43051",
				"VMusage 16248 75829"
			],
			FontName: "Courier-Oblique",
			FullName: "Courier Oblique",
			FamilyName: "Courier",
			Weight: "Medium",
			ItalicAngle: "-12",
			IsFixedPitch: "true",
			CharacterSet: "ExtendedRoman",
			FontBBox: "-27 -250 849 805 ",
			UnderlinePosition: "-100",
			UnderlineThickness: "50",
			Version: "003.000",
			Notice: "Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
			EncodingScheme: "AdobeStandardEncoding",
			CapHeight: "562",
			XHeight: "426",
			Ascender: "629",
			Descender: "-157",
			StdHW: "51",
			StdVW: "51"
		},
		{
			Comment: [
				"Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
				"Creation Date: Thu May  1 17:27:09 1997",
				"UniqueID 43050",
				"VMusage 39754 50779"
			],
			FontName: "Courier",
			FullName: "Courier",
			FamilyName: "Courier",
			Weight: "Medium",
			ItalicAngle: "0",
			IsFixedPitch: "true",
			CharacterSet: "ExtendedRoman",
			FontBBox: "-23 -250 715 805 ",
			UnderlinePosition: "-100",
			UnderlineThickness: "50",
			Version: "003.000",
			Notice: "Copyright (c) 1989, 1990, 1991, 1992, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.",
			EncodingScheme: "AdobeStandardEncoding",
			CapHeight: "562",
			XHeight: "426",
			Ascender: "629",
			Descender: "-157",
			StdHW: "51",
			StdVW: "51"
		}
	],
	glyphWidths: {
		space: [
			278,
			278,
			278,
			278,
			250,
			250,
			250,
			250,
			600,
			600,
			600,
			600
		],
		exclam: [
			333,
			333,
			278,
			278,
			333,
			389,
			333,
			333,
			600,
			600,
			600,
			600
		],
		quotedbl: [
			474,
			474,
			355,
			355,
			555,
			555,
			420,
			408,
			600,
			600,
			600,
			600
		],
		numbersign: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		dollar: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		percent: [
			889,
			889,
			889,
			889,
			1e3,
			833,
			833,
			833,
			600,
			600,
			600,
			600
		],
		ampersand: [
			722,
			722,
			667,
			667,
			833,
			778,
			778,
			778,
			600,
			600,
			600,
			600
		],
		quoteright: [
			278,
			278,
			222,
			222,
			333,
			333,
			333,
			333,
			600,
			600,
			600,
			600
		],
		parenleft: [
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			600,
			600,
			600,
			600
		],
		parenright: [
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			600,
			600,
			600,
			600
		],
		asterisk: [
			389,
			389,
			389,
			389,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		plus: [
			584,
			584,
			584,
			584,
			570,
			570,
			675,
			564,
			600,
			600,
			600,
			600
		],
		comma: [
			278,
			278,
			278,
			278,
			250,
			250,
			250,
			250,
			600,
			600,
			600,
			600
		],
		hyphen: [
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			600,
			600,
			600,
			600
		],
		period: [
			278,
			278,
			278,
			278,
			250,
			250,
			250,
			250,
			600,
			600,
			600,
			600
		],
		slash: [
			278,
			278,
			278,
			278,
			278,
			278,
			278,
			278,
			600,
			600,
			600,
			600
		],
		zero: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		one: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		two: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		three: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		four: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		five: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		six: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		seven: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		eight: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		nine: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		colon: [
			333,
			333,
			278,
			278,
			333,
			333,
			333,
			278,
			600,
			600,
			600,
			600
		],
		semicolon: [
			333,
			333,
			278,
			278,
			333,
			333,
			333,
			278,
			600,
			600,
			600,
			600
		],
		less: [
			584,
			584,
			584,
			584,
			570,
			570,
			675,
			564,
			600,
			600,
			600,
			600
		],
		equal: [
			584,
			584,
			584,
			584,
			570,
			570,
			675,
			564,
			600,
			600,
			600,
			600
		],
		greater: [
			584,
			584,
			584,
			584,
			570,
			570,
			675,
			564,
			600,
			600,
			600,
			600
		],
		question: [
			611,
			611,
			556,
			556,
			500,
			500,
			500,
			444,
			600,
			600,
			600,
			600
		],
		at: [
			975,
			975,
			1015,
			1015,
			930,
			832,
			920,
			921,
			600,
			600,
			600,
			600
		],
		A: [
			722,
			722,
			667,
			667,
			722,
			667,
			611,
			722,
			600,
			600,
			600,
			600
		],
		B: [
			722,
			722,
			667,
			667,
			667,
			667,
			611,
			667,
			600,
			600,
			600,
			600
		],
		C: [
			722,
			722,
			722,
			722,
			722,
			667,
			667,
			667,
			600,
			600,
			600,
			600
		],
		D: [
			722,
			722,
			722,
			722,
			722,
			722,
			722,
			722,
			600,
			600,
			600,
			600
		],
		E: [
			667,
			667,
			667,
			667,
			667,
			667,
			611,
			611,
			600,
			600,
			600,
			600
		],
		F: [
			611,
			611,
			611,
			611,
			611,
			667,
			611,
			556,
			600,
			600,
			600,
			600
		],
		G: [
			778,
			778,
			778,
			778,
			778,
			722,
			722,
			722,
			600,
			600,
			600,
			600
		],
		H: [
			722,
			722,
			722,
			722,
			778,
			778,
			722,
			722,
			600,
			600,
			600,
			600
		],
		I: [
			278,
			278,
			278,
			278,
			389,
			389,
			333,
			333,
			600,
			600,
			600,
			600
		],
		J: [
			556,
			556,
			500,
			500,
			500,
			500,
			444,
			389,
			600,
			600,
			600,
			600
		],
		K: [
			722,
			722,
			667,
			667,
			778,
			667,
			667,
			722,
			600,
			600,
			600,
			600
		],
		L: [
			611,
			611,
			556,
			556,
			667,
			611,
			556,
			611,
			600,
			600,
			600,
			600
		],
		M: [
			833,
			833,
			833,
			833,
			944,
			889,
			833,
			889,
			600,
			600,
			600,
			600
		],
		N: [
			722,
			722,
			722,
			722,
			722,
			722,
			667,
			722,
			600,
			600,
			600,
			600
		],
		O: [
			778,
			778,
			778,
			778,
			778,
			722,
			722,
			722,
			600,
			600,
			600,
			600
		],
		P: [
			667,
			667,
			667,
			667,
			611,
			611,
			611,
			556,
			600,
			600,
			600,
			600
		],
		Q: [
			778,
			778,
			778,
			778,
			778,
			722,
			722,
			722,
			600,
			600,
			600,
			600
		],
		R: [
			722,
			722,
			722,
			722,
			722,
			667,
			611,
			667,
			600,
			600,
			600,
			600
		],
		S: [
			667,
			667,
			667,
			667,
			556,
			556,
			500,
			556,
			600,
			600,
			600,
			600
		],
		T: [
			611,
			611,
			611,
			611,
			667,
			611,
			556,
			611,
			600,
			600,
			600,
			600
		],
		U: [
			722,
			722,
			722,
			722,
			722,
			722,
			722,
			722,
			600,
			600,
			600,
			600
		],
		V: [
			667,
			667,
			667,
			667,
			722,
			667,
			611,
			722,
			600,
			600,
			600,
			600
		],
		W: [
			944,
			944,
			944,
			944,
			1e3,
			889,
			833,
			944,
			600,
			600,
			600,
			600
		],
		X: [
			667,
			667,
			667,
			667,
			722,
			667,
			611,
			722,
			600,
			600,
			600,
			600
		],
		Y: [
			667,
			667,
			667,
			667,
			722,
			611,
			556,
			722,
			600,
			600,
			600,
			600
		],
		Z: [
			611,
			611,
			611,
			611,
			667,
			611,
			556,
			611,
			600,
			600,
			600,
			600
		],
		bracketleft: [
			333,
			333,
			278,
			278,
			333,
			333,
			389,
			333,
			600,
			600,
			600,
			600
		],
		backslash: [
			278,
			278,
			278,
			278,
			278,
			278,
			278,
			278,
			600,
			600,
			600,
			600
		],
		bracketright: [
			333,
			333,
			278,
			278,
			333,
			333,
			389,
			333,
			600,
			600,
			600,
			600
		],
		asciicircum: [
			584,
			584,
			469,
			469,
			581,
			570,
			422,
			469,
			600,
			600,
			600,
			600
		],
		underscore: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		quoteleft: [
			278,
			278,
			222,
			222,
			333,
			333,
			333,
			333,
			600,
			600,
			600,
			600
		],
		a: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			444,
			600,
			600,
			600,
			600
		],
		b: [
			611,
			611,
			556,
			556,
			556,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		c: [
			556,
			556,
			500,
			500,
			444,
			444,
			444,
			444,
			600,
			600,
			600,
			600
		],
		d: [
			611,
			611,
			556,
			556,
			556,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		e: [
			556,
			556,
			556,
			556,
			444,
			444,
			444,
			444,
			600,
			600,
			600,
			600
		],
		f: [
			333,
			333,
			278,
			278,
			333,
			333,
			278,
			333,
			600,
			600,
			600,
			600
		],
		g: [
			611,
			611,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		h: [
			611,
			611,
			556,
			556,
			556,
			556,
			500,
			500,
			600,
			600,
			600,
			600
		],
		i: [
			278,
			278,
			222,
			222,
			278,
			278,
			278,
			278,
			600,
			600,
			600,
			600
		],
		j: [
			278,
			278,
			222,
			222,
			333,
			278,
			278,
			278,
			600,
			600,
			600,
			600
		],
		k: [
			556,
			556,
			500,
			500,
			556,
			500,
			444,
			500,
			600,
			600,
			600,
			600
		],
		l: [
			278,
			278,
			222,
			222,
			278,
			278,
			278,
			278,
			600,
			600,
			600,
			600
		],
		m: [
			889,
			889,
			833,
			833,
			833,
			778,
			722,
			778,
			600,
			600,
			600,
			600
		],
		n: [
			611,
			611,
			556,
			556,
			556,
			556,
			500,
			500,
			600,
			600,
			600,
			600
		],
		o: [
			611,
			611,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		p: [
			611,
			611,
			556,
			556,
			556,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		q: [
			611,
			611,
			556,
			556,
			556,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		r: [
			389,
			389,
			333,
			333,
			444,
			389,
			389,
			333,
			600,
			600,
			600,
			600
		],
		s: [
			556,
			556,
			500,
			500,
			389,
			389,
			389,
			389,
			600,
			600,
			600,
			600
		],
		t: [
			333,
			333,
			278,
			278,
			333,
			278,
			278,
			278,
			600,
			600,
			600,
			600
		],
		u: [
			611,
			611,
			556,
			556,
			556,
			556,
			500,
			500,
			600,
			600,
			600,
			600
		],
		v: [
			556,
			556,
			500,
			500,
			500,
			444,
			444,
			500,
			600,
			600,
			600,
			600
		],
		w: [
			778,
			778,
			722,
			722,
			722,
			667,
			667,
			722,
			600,
			600,
			600,
			600
		],
		x: [
			556,
			556,
			500,
			500,
			500,
			500,
			444,
			500,
			600,
			600,
			600,
			600
		],
		y: [
			556,
			556,
			500,
			500,
			500,
			444,
			444,
			500,
			600,
			600,
			600,
			600
		],
		z: [
			500,
			500,
			500,
			500,
			444,
			389,
			389,
			444,
			600,
			600,
			600,
			600
		],
		braceleft: [
			389,
			389,
			334,
			334,
			394,
			348,
			400,
			480,
			600,
			600,
			600,
			600
		],
		bar: [
			280,
			280,
			260,
			260,
			220,
			220,
			275,
			200,
			600,
			600,
			600,
			600
		],
		braceright: [
			389,
			389,
			334,
			334,
			394,
			348,
			400,
			480,
			600,
			600,
			600,
			600
		],
		asciitilde: [
			584,
			584,
			584,
			584,
			520,
			570,
			541,
			541,
			600,
			600,
			600,
			600
		],
		exclamdown: [
			333,
			333,
			333,
			333,
			333,
			389,
			389,
			333,
			600,
			600,
			600,
			600
		],
		cent: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		sterling: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		fraction: [
			167,
			167,
			167,
			167,
			167,
			167,
			167,
			167,
			600,
			600,
			600,
			600
		],
		yen: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		florin: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		section: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		currency: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		quotesingle: [
			238,
			238,
			191,
			191,
			278,
			278,
			214,
			180,
			600,
			600,
			600,
			600
		],
		quotedblleft: [
			500,
			500,
			333,
			333,
			500,
			500,
			556,
			444,
			600,
			600,
			600,
			600
		],
		guillemotleft: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		guilsinglleft: [
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			600,
			600,
			600,
			600
		],
		guilsinglright: [
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			600,
			600,
			600,
			600
		],
		fi: [
			611,
			611,
			500,
			500,
			556,
			556,
			500,
			556,
			600,
			600,
			600,
			600
		],
		fl: [
			611,
			611,
			500,
			500,
			556,
			556,
			500,
			556,
			600,
			600,
			600,
			600
		],
		endash: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		dagger: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		daggerdbl: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		periodcentered: [
			278,
			278,
			278,
			278,
			250,
			250,
			250,
			250,
			600,
			600,
			600,
			600
		],
		paragraph: [
			556,
			556,
			537,
			537,
			540,
			500,
			523,
			453,
			600,
			600,
			600,
			600
		],
		bullet: [
			350,
			350,
			350,
			350,
			350,
			350,
			350,
			350,
			600,
			600,
			600,
			600
		],
		quotesinglbase: [
			278,
			278,
			222,
			222,
			333,
			333,
			333,
			333,
			600,
			600,
			600,
			600
		],
		quotedblbase: [
			500,
			500,
			333,
			333,
			500,
			500,
			556,
			444,
			600,
			600,
			600,
			600
		],
		quotedblright: [
			500,
			500,
			333,
			333,
			500,
			500,
			556,
			444,
			600,
			600,
			600,
			600
		],
		guillemotright: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		ellipsis: [
			1e3,
			1e3,
			1e3,
			1e3,
			1e3,
			1e3,
			889,
			1e3,
			600,
			600,
			600,
			600
		],
		perthousand: [
			1e3,
			1e3,
			1e3,
			1e3,
			1e3,
			1e3,
			1e3,
			1e3,
			600,
			600,
			600,
			600
		],
		questiondown: [
			611,
			611,
			611,
			611,
			500,
			500,
			500,
			444,
			600,
			600,
			600,
			600
		],
		grave: [
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			600,
			600,
			600,
			600
		],
		acute: [
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			600,
			600,
			600,
			600
		],
		circumflex: [
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			600,
			600,
			600,
			600
		],
		tilde: [
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			600,
			600,
			600,
			600
		],
		macron: [
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			600,
			600,
			600,
			600
		],
		breve: [
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			600,
			600,
			600,
			600
		],
		dotaccent: [
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			600,
			600,
			600,
			600
		],
		dieresis: [
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			600,
			600,
			600,
			600
		],
		ring: [
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			600,
			600,
			600,
			600
		],
		cedilla: [
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			600,
			600,
			600,
			600
		],
		hungarumlaut: [
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			600,
			600,
			600,
			600
		],
		ogonek: [
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			600,
			600,
			600,
			600
		],
		caron: [
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			333,
			600,
			600,
			600,
			600
		],
		emdash: [
			1e3,
			1e3,
			1e3,
			1e3,
			1e3,
			1e3,
			889,
			1e3,
			600,
			600,
			600,
			600
		],
		AE: [
			1e3,
			1e3,
			1e3,
			1e3,
			1e3,
			944,
			889,
			889,
			600,
			600,
			600,
			600
		],
		ordfeminine: [
			370,
			370,
			370,
			370,
			300,
			266,
			276,
			276,
			600,
			600,
			600,
			600
		],
		Lslash: [
			611,
			611,
			556,
			556,
			667,
			611,
			556,
			611,
			600,
			600,
			600,
			600
		],
		Oslash: [
			778,
			778,
			778,
			778,
			778,
			722,
			722,
			722,
			600,
			600,
			600,
			600
		],
		OE: [
			1e3,
			1e3,
			1e3,
			1e3,
			1e3,
			944,
			944,
			889,
			600,
			600,
			600,
			600
		],
		ordmasculine: [
			365,
			365,
			365,
			365,
			330,
			300,
			310,
			310,
			600,
			600,
			600,
			600
		],
		ae: [
			889,
			889,
			889,
			889,
			722,
			722,
			667,
			667,
			600,
			600,
			600,
			600
		],
		dotlessi: [
			278,
			278,
			278,
			278,
			278,
			278,
			278,
			278,
			600,
			600,
			600,
			600
		],
		lslash: [
			278,
			278,
			222,
			222,
			278,
			278,
			278,
			278,
			600,
			600,
			600,
			600
		],
		oslash: [
			611,
			611,
			611,
			611,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		oe: [
			944,
			944,
			944,
			944,
			722,
			722,
			667,
			722,
			600,
			600,
			600,
			600
		],
		germandbls: [
			611,
			611,
			611,
			611,
			556,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		Idieresis: [
			278,
			278,
			278,
			278,
			389,
			389,
			333,
			333,
			600,
			600,
			600,
			600
		],
		eacute: [
			556,
			556,
			556,
			556,
			444,
			444,
			444,
			444,
			600,
			600,
			600,
			600
		],
		abreve: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			444,
			600,
			600,
			600,
			600
		],
		uhungarumlaut: [
			611,
			611,
			556,
			556,
			556,
			556,
			500,
			500,
			600,
			600,
			600,
			600
		],
		ecaron: [
			556,
			556,
			556,
			556,
			444,
			444,
			444,
			444,
			600,
			600,
			600,
			600
		],
		Ydieresis: [
			667,
			667,
			667,
			667,
			722,
			611,
			556,
			722,
			600,
			600,
			600,
			600
		],
		divide: [
			584,
			584,
			584,
			584,
			570,
			570,
			675,
			564,
			600,
			600,
			600,
			600
		],
		Yacute: [
			667,
			667,
			667,
			667,
			722,
			611,
			556,
			722,
			600,
			600,
			600,
			600
		],
		Acircumflex: [
			722,
			722,
			667,
			667,
			722,
			667,
			611,
			722,
			600,
			600,
			600,
			600
		],
		aacute: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			444,
			600,
			600,
			600,
			600
		],
		Ucircumflex: [
			722,
			722,
			722,
			722,
			722,
			722,
			722,
			722,
			600,
			600,
			600,
			600
		],
		yacute: [
			556,
			556,
			500,
			500,
			500,
			444,
			444,
			500,
			600,
			600,
			600,
			600
		],
		scommaaccent: [
			556,
			556,
			500,
			500,
			389,
			389,
			389,
			389,
			600,
			600,
			600,
			600
		],
		ecircumflex: [
			556,
			556,
			556,
			556,
			444,
			444,
			444,
			444,
			600,
			600,
			600,
			600
		],
		Uring: [
			722,
			722,
			722,
			722,
			722,
			722,
			722,
			722,
			600,
			600,
			600,
			600
		],
		Udieresis: [
			722,
			722,
			722,
			722,
			722,
			722,
			722,
			722,
			600,
			600,
			600,
			600
		],
		aogonek: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			444,
			600,
			600,
			600,
			600
		],
		Uacute: [
			722,
			722,
			722,
			722,
			722,
			722,
			722,
			722,
			600,
			600,
			600,
			600
		],
		uogonek: [
			611,
			611,
			556,
			556,
			556,
			556,
			500,
			500,
			600,
			600,
			600,
			600
		],
		Edieresis: [
			667,
			667,
			667,
			667,
			667,
			667,
			611,
			611,
			600,
			600,
			600,
			600
		],
		Dcroat: [
			722,
			722,
			722,
			722,
			722,
			722,
			722,
			722,
			600,
			600,
			600,
			600
		],
		commaaccent: [
			250,
			250,
			250,
			250,
			250,
			250,
			250,
			250,
			600,
			600,
			600,
			600
		],
		copyright: [
			737,
			737,
			737,
			737,
			747,
			747,
			760,
			760,
			600,
			600,
			600,
			600
		],
		Emacron: [
			667,
			667,
			667,
			667,
			667,
			667,
			611,
			611,
			600,
			600,
			600,
			600
		],
		ccaron: [
			556,
			556,
			500,
			500,
			444,
			444,
			444,
			444,
			600,
			600,
			600,
			600
		],
		aring: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			444,
			600,
			600,
			600,
			600
		],
		Ncommaaccent: [
			722,
			722,
			722,
			722,
			722,
			722,
			667,
			722,
			600,
			600,
			600,
			600
		],
		lacute: [
			278,
			278,
			222,
			222,
			278,
			278,
			278,
			278,
			600,
			600,
			600,
			600
		],
		agrave: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			444,
			600,
			600,
			600,
			600
		],
		Tcommaaccent: [
			611,
			611,
			611,
			611,
			667,
			611,
			556,
			611,
			600,
			600,
			600,
			600
		],
		Cacute: [
			722,
			722,
			722,
			722,
			722,
			667,
			667,
			667,
			600,
			600,
			600,
			600
		],
		atilde: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			444,
			600,
			600,
			600,
			600
		],
		Edotaccent: [
			667,
			667,
			667,
			667,
			667,
			667,
			611,
			611,
			600,
			600,
			600,
			600
		],
		scaron: [
			556,
			556,
			500,
			500,
			389,
			389,
			389,
			389,
			600,
			600,
			600,
			600
		],
		scedilla: [
			556,
			556,
			500,
			500,
			389,
			389,
			389,
			389,
			600,
			600,
			600,
			600
		],
		iacute: [
			278,
			278,
			278,
			278,
			278,
			278,
			278,
			278,
			600,
			600,
			600,
			600
		],
		lozenge: [
			494,
			494,
			471,
			471,
			494,
			494,
			471,
			471,
			600,
			600,
			600,
			600
		],
		Rcaron: [
			722,
			722,
			722,
			722,
			722,
			667,
			611,
			667,
			600,
			600,
			600,
			600
		],
		Gcommaaccent: [
			778,
			778,
			778,
			778,
			778,
			722,
			722,
			722,
			600,
			600,
			600,
			600
		],
		ucircumflex: [
			611,
			611,
			556,
			556,
			556,
			556,
			500,
			500,
			600,
			600,
			600,
			600
		],
		acircumflex: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			444,
			600,
			600,
			600,
			600
		],
		Amacron: [
			722,
			722,
			667,
			667,
			722,
			667,
			611,
			722,
			600,
			600,
			600,
			600
		],
		rcaron: [
			389,
			389,
			333,
			333,
			444,
			389,
			389,
			333,
			600,
			600,
			600,
			600
		],
		ccedilla: [
			556,
			556,
			500,
			500,
			444,
			444,
			444,
			444,
			600,
			600,
			600,
			600
		],
		Zdotaccent: [
			611,
			611,
			611,
			611,
			667,
			611,
			556,
			611,
			600,
			600,
			600,
			600
		],
		Thorn: [
			667,
			667,
			667,
			667,
			611,
			611,
			611,
			556,
			600,
			600,
			600,
			600
		],
		Omacron: [
			778,
			778,
			778,
			778,
			778,
			722,
			722,
			722,
			600,
			600,
			600,
			600
		],
		Racute: [
			722,
			722,
			722,
			722,
			722,
			667,
			611,
			667,
			600,
			600,
			600,
			600
		],
		Sacute: [
			667,
			667,
			667,
			667,
			556,
			556,
			500,
			556,
			600,
			600,
			600,
			600
		],
		dcaron: [
			743,
			743,
			643,
			643,
			672,
			608,
			544,
			588,
			600,
			600,
			600,
			600
		],
		Umacron: [
			722,
			722,
			722,
			722,
			722,
			722,
			722,
			722,
			600,
			600,
			600,
			600
		],
		uring: [
			611,
			611,
			556,
			556,
			556,
			556,
			500,
			500,
			600,
			600,
			600,
			600
		],
		threesuperior: [
			333,
			333,
			333,
			333,
			300,
			300,
			300,
			300,
			600,
			600,
			600,
			600
		],
		Ograve: [
			778,
			778,
			778,
			778,
			778,
			722,
			722,
			722,
			600,
			600,
			600,
			600
		],
		Agrave: [
			722,
			722,
			667,
			667,
			722,
			667,
			611,
			722,
			600,
			600,
			600,
			600
		],
		Abreve: [
			722,
			722,
			667,
			667,
			722,
			667,
			611,
			722,
			600,
			600,
			600,
			600
		],
		multiply: [
			584,
			584,
			584,
			584,
			570,
			570,
			675,
			564,
			600,
			600,
			600,
			600
		],
		uacute: [
			611,
			611,
			556,
			556,
			556,
			556,
			500,
			500,
			600,
			600,
			600,
			600
		],
		Tcaron: [
			611,
			611,
			611,
			611,
			667,
			611,
			556,
			611,
			600,
			600,
			600,
			600
		],
		partialdiff: [
			494,
			494,
			476,
			476,
			494,
			494,
			476,
			476,
			600,
			600,
			600,
			600
		],
		ydieresis: [
			556,
			556,
			500,
			500,
			500,
			444,
			444,
			500,
			600,
			600,
			600,
			600
		],
		Nacute: [
			722,
			722,
			722,
			722,
			722,
			722,
			667,
			722,
			600,
			600,
			600,
			600
		],
		icircumflex: [
			278,
			278,
			278,
			278,
			278,
			278,
			278,
			278,
			600,
			600,
			600,
			600
		],
		Ecircumflex: [
			667,
			667,
			667,
			667,
			667,
			667,
			611,
			611,
			600,
			600,
			600,
			600
		],
		adieresis: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			444,
			600,
			600,
			600,
			600
		],
		edieresis: [
			556,
			556,
			556,
			556,
			444,
			444,
			444,
			444,
			600,
			600,
			600,
			600
		],
		cacute: [
			556,
			556,
			500,
			500,
			444,
			444,
			444,
			444,
			600,
			600,
			600,
			600
		],
		nacute: [
			611,
			611,
			556,
			556,
			556,
			556,
			500,
			500,
			600,
			600,
			600,
			600
		],
		umacron: [
			611,
			611,
			556,
			556,
			556,
			556,
			500,
			500,
			600,
			600,
			600,
			600
		],
		Ncaron: [
			722,
			722,
			722,
			722,
			722,
			722,
			667,
			722,
			600,
			600,
			600,
			600
		],
		Iacute: [
			278,
			278,
			278,
			278,
			389,
			389,
			333,
			333,
			600,
			600,
			600,
			600
		],
		plusminus: [
			584,
			584,
			584,
			584,
			570,
			570,
			675,
			564,
			600,
			600,
			600,
			600
		],
		brokenbar: [
			280,
			280,
			260,
			260,
			220,
			220,
			275,
			200,
			600,
			600,
			600,
			600
		],
		registered: [
			737,
			737,
			737,
			737,
			747,
			747,
			760,
			760,
			600,
			600,
			600,
			600
		],
		Gbreve: [
			778,
			778,
			778,
			778,
			778,
			722,
			722,
			722,
			600,
			600,
			600,
			600
		],
		Idotaccent: [
			278,
			278,
			278,
			278,
			389,
			389,
			333,
			333,
			600,
			600,
			600,
			600
		],
		summation: [
			600,
			600,
			600,
			600,
			600,
			600,
			600,
			600,
			600,
			600,
			600,
			600
		],
		Egrave: [
			667,
			667,
			667,
			667,
			667,
			667,
			611,
			611,
			600,
			600,
			600,
			600
		],
		racute: [
			389,
			389,
			333,
			333,
			444,
			389,
			389,
			333,
			600,
			600,
			600,
			600
		],
		omacron: [
			611,
			611,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		Zacute: [
			611,
			611,
			611,
			611,
			667,
			611,
			556,
			611,
			600,
			600,
			600,
			600
		],
		Zcaron: [
			611,
			611,
			611,
			611,
			667,
			611,
			556,
			611,
			600,
			600,
			600,
			600
		],
		greaterequal: [
			549,
			549,
			549,
			549,
			549,
			549,
			549,
			549,
			600,
			600,
			600,
			600
		],
		Eth: [
			722,
			722,
			722,
			722,
			722,
			722,
			722,
			722,
			600,
			600,
			600,
			600
		],
		Ccedilla: [
			722,
			722,
			722,
			722,
			722,
			667,
			667,
			667,
			600,
			600,
			600,
			600
		],
		lcommaaccent: [
			278,
			278,
			222,
			222,
			278,
			278,
			278,
			278,
			600,
			600,
			600,
			600
		],
		tcaron: [
			389,
			389,
			317,
			317,
			416,
			366,
			300,
			326,
			600,
			600,
			600,
			600
		],
		eogonek: [
			556,
			556,
			556,
			556,
			444,
			444,
			444,
			444,
			600,
			600,
			600,
			600
		],
		Uogonek: [
			722,
			722,
			722,
			722,
			722,
			722,
			722,
			722,
			600,
			600,
			600,
			600
		],
		Aacute: [
			722,
			722,
			667,
			667,
			722,
			667,
			611,
			722,
			600,
			600,
			600,
			600
		],
		Adieresis: [
			722,
			722,
			667,
			667,
			722,
			667,
			611,
			722,
			600,
			600,
			600,
			600
		],
		egrave: [
			556,
			556,
			556,
			556,
			444,
			444,
			444,
			444,
			600,
			600,
			600,
			600
		],
		zacute: [
			500,
			500,
			500,
			500,
			444,
			389,
			389,
			444,
			600,
			600,
			600,
			600
		],
		iogonek: [
			278,
			278,
			222,
			222,
			278,
			278,
			278,
			278,
			600,
			600,
			600,
			600
		],
		Oacute: [
			778,
			778,
			778,
			778,
			778,
			722,
			722,
			722,
			600,
			600,
			600,
			600
		],
		oacute: [
			611,
			611,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		amacron: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			444,
			600,
			600,
			600,
			600
		],
		sacute: [
			556,
			556,
			500,
			500,
			389,
			389,
			389,
			389,
			600,
			600,
			600,
			600
		],
		idieresis: [
			278,
			278,
			278,
			278,
			278,
			278,
			278,
			278,
			600,
			600,
			600,
			600
		],
		Ocircumflex: [
			778,
			778,
			778,
			778,
			778,
			722,
			722,
			722,
			600,
			600,
			600,
			600
		],
		Ugrave: [
			722,
			722,
			722,
			722,
			722,
			722,
			722,
			722,
			600,
			600,
			600,
			600
		],
		Delta: [
			612,
			612,
			612,
			612,
			612,
			612,
			612,
			612,
			600,
			600,
			600,
			600
		],
		thorn: [
			611,
			611,
			556,
			556,
			556,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		twosuperior: [
			333,
			333,
			333,
			333,
			300,
			300,
			300,
			300,
			600,
			600,
			600,
			600
		],
		Odieresis: [
			778,
			778,
			778,
			778,
			778,
			722,
			722,
			722,
			600,
			600,
			600,
			600
		],
		mu: [
			611,
			611,
			556,
			556,
			556,
			576,
			500,
			500,
			600,
			600,
			600,
			600
		],
		igrave: [
			278,
			278,
			278,
			278,
			278,
			278,
			278,
			278,
			600,
			600,
			600,
			600
		],
		ohungarumlaut: [
			611,
			611,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		Eogonek: [
			667,
			667,
			667,
			667,
			667,
			667,
			611,
			611,
			600,
			600,
			600,
			600
		],
		dcroat: [
			611,
			611,
			556,
			556,
			556,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		threequarters: [
			834,
			834,
			834,
			834,
			750,
			750,
			750,
			750,
			600,
			600,
			600,
			600
		],
		Scedilla: [
			667,
			667,
			667,
			667,
			556,
			556,
			500,
			556,
			600,
			600,
			600,
			600
		],
		lcaron: [
			400,
			400,
			299,
			299,
			394,
			382,
			300,
			344,
			600,
			600,
			600,
			600
		],
		Kcommaaccent: [
			722,
			722,
			667,
			667,
			778,
			667,
			667,
			722,
			600,
			600,
			600,
			600
		],
		Lacute: [
			611,
			611,
			556,
			556,
			667,
			611,
			556,
			611,
			600,
			600,
			600,
			600
		],
		trademark: [
			1e3,
			1e3,
			1e3,
			1e3,
			1e3,
			1e3,
			980,
			980,
			600,
			600,
			600,
			600
		],
		edotaccent: [
			556,
			556,
			556,
			556,
			444,
			444,
			444,
			444,
			600,
			600,
			600,
			600
		],
		Igrave: [
			278,
			278,
			278,
			278,
			389,
			389,
			333,
			333,
			600,
			600,
			600,
			600
		],
		Imacron: [
			278,
			278,
			278,
			278,
			389,
			389,
			333,
			333,
			600,
			600,
			600,
			600
		],
		Lcaron: [
			611,
			611,
			556,
			556,
			667,
			611,
			611,
			611,
			600,
			600,
			600,
			600
		],
		onehalf: [
			834,
			834,
			834,
			834,
			750,
			750,
			750,
			750,
			600,
			600,
			600,
			600
		],
		lessequal: [
			549,
			549,
			549,
			549,
			549,
			549,
			549,
			549,
			600,
			600,
			600,
			600
		],
		ocircumflex: [
			611,
			611,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		ntilde: [
			611,
			611,
			556,
			556,
			556,
			556,
			500,
			500,
			600,
			600,
			600,
			600
		],
		Uhungarumlaut: [
			722,
			722,
			722,
			722,
			722,
			722,
			722,
			722,
			600,
			600,
			600,
			600
		],
		Eacute: [
			667,
			667,
			667,
			667,
			667,
			667,
			611,
			611,
			600,
			600,
			600,
			600
		],
		emacron: [
			556,
			556,
			556,
			556,
			444,
			444,
			444,
			444,
			600,
			600,
			600,
			600
		],
		gbreve: [
			611,
			611,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		onequarter: [
			834,
			834,
			834,
			834,
			750,
			750,
			750,
			750,
			600,
			600,
			600,
			600
		],
		Scaron: [
			667,
			667,
			667,
			667,
			556,
			556,
			500,
			556,
			600,
			600,
			600,
			600
		],
		Scommaaccent: [
			667,
			667,
			667,
			667,
			556,
			556,
			500,
			556,
			600,
			600,
			600,
			600
		],
		Ohungarumlaut: [
			778,
			778,
			778,
			778,
			778,
			722,
			722,
			722,
			600,
			600,
			600,
			600
		],
		degree: [
			400,
			400,
			400,
			400,
			400,
			400,
			400,
			400,
			600,
			600,
			600,
			600
		],
		ograve: [
			611,
			611,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		Ccaron: [
			722,
			722,
			722,
			722,
			722,
			667,
			667,
			667,
			600,
			600,
			600,
			600
		],
		ugrave: [
			611,
			611,
			556,
			556,
			556,
			556,
			500,
			500,
			600,
			600,
			600,
			600
		],
		radical: [
			549,
			549,
			453,
			453,
			549,
			549,
			453,
			453,
			600,
			600,
			600,
			600
		],
		Dcaron: [
			722,
			722,
			722,
			722,
			722,
			722,
			722,
			722,
			600,
			600,
			600,
			600
		],
		rcommaaccent: [
			389,
			389,
			333,
			333,
			444,
			389,
			389,
			333,
			600,
			600,
			600,
			600
		],
		Ntilde: [
			722,
			722,
			722,
			722,
			722,
			722,
			667,
			722,
			600,
			600,
			600,
			600
		],
		otilde: [
			611,
			611,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		Rcommaaccent: [
			722,
			722,
			722,
			722,
			722,
			667,
			611,
			667,
			600,
			600,
			600,
			600
		],
		Lcommaaccent: [
			611,
			611,
			556,
			556,
			667,
			611,
			556,
			611,
			600,
			600,
			600,
			600
		],
		Atilde: [
			722,
			722,
			667,
			667,
			722,
			667,
			611,
			722,
			600,
			600,
			600,
			600
		],
		Aogonek: [
			722,
			722,
			667,
			667,
			722,
			667,
			611,
			722,
			600,
			600,
			600,
			600
		],
		Aring: [
			722,
			722,
			667,
			667,
			722,
			667,
			611,
			722,
			600,
			600,
			600,
			600
		],
		Otilde: [
			778,
			778,
			778,
			778,
			778,
			722,
			722,
			722,
			600,
			600,
			600,
			600
		],
		zdotaccent: [
			500,
			500,
			500,
			500,
			444,
			389,
			389,
			444,
			600,
			600,
			600,
			600
		],
		Ecaron: [
			667,
			667,
			667,
			667,
			667,
			667,
			611,
			611,
			600,
			600,
			600,
			600
		],
		Iogonek: [
			278,
			278,
			278,
			278,
			389,
			389,
			333,
			333,
			600,
			600,
			600,
			600
		],
		kcommaaccent: [
			556,
			556,
			500,
			500,
			556,
			500,
			444,
			500,
			600,
			600,
			600,
			600
		],
		minus: [
			584,
			584,
			584,
			584,
			570,
			606,
			675,
			564,
			600,
			600,
			600,
			600
		],
		Icircumflex: [
			278,
			278,
			278,
			278,
			389,
			389,
			333,
			333,
			600,
			600,
			600,
			600
		],
		ncaron: [
			611,
			611,
			556,
			556,
			556,
			556,
			500,
			500,
			600,
			600,
			600,
			600
		],
		tcommaaccent: [
			333,
			333,
			278,
			278,
			333,
			278,
			278,
			278,
			600,
			600,
			600,
			600
		],
		logicalnot: [
			584,
			584,
			584,
			584,
			570,
			606,
			675,
			564,
			600,
			600,
			600,
			600
		],
		odieresis: [
			611,
			611,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		udieresis: [
			611,
			611,
			556,
			556,
			556,
			556,
			500,
			500,
			600,
			600,
			600,
			600
		],
		notequal: [
			549,
			549,
			549,
			549,
			549,
			549,
			549,
			549,
			600,
			600,
			600,
			600
		],
		gcommaaccent: [
			611,
			611,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		eth: [
			611,
			611,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		],
		zcaron: [
			500,
			500,
			500,
			500,
			444,
			389,
			389,
			444,
			600,
			600,
			600,
			600
		],
		ncommaaccent: [
			611,
			611,
			556,
			556,
			556,
			556,
			500,
			500,
			600,
			600,
			600,
			600
		],
		onesuperior: [
			333,
			333,
			333,
			333,
			300,
			300,
			300,
			300,
			600,
			600,
			600,
			600
		],
		imacron: [
			278,
			278,
			278,
			278,
			278,
			278,
			278,
			278,
			600,
			600,
			600,
			600
		],
		Euro: [
			556,
			556,
			556,
			556,
			500,
			500,
			500,
			500,
			600,
			600,
			600,
			600
		]
	},
	kernPairs: {
		AC: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		ACacute: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		ACcaron: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		ACcedilla: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AG: [
			-50,
			-50,
			-30,
			-30,
			-55,
			-60,
			-35,
			-40
		],
		AGbreve: [
			-50,
			-50,
			-30,
			-30,
			-55,
			-60,
			-35,
			-40
		],
		AGcommaaccent: [
			-50,
			-50,
			-30,
			-30,
			-55,
			-60,
			-35,
			-40
		],
		AO: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AOacute: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AOcircumflex: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AOdieresis: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AOgrave: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AOhungarumlaut: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AOmacron: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AOslash: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AOtilde: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AQ: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-55,
			-40,
			-55
		],
		AT: [
			-90,
			-90,
			-120,
			-120,
			-95,
			-55,
			-37,
			-111
		],
		ATcaron: [
			-90,
			-90,
			-120,
			-120,
			-95,
			-55,
			-37,
			-111
		],
		ATcommaaccent: [
			-90,
			-90,
			-120,
			-120,
			-95,
			-55,
			-37,
			-111
		],
		AU: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AUacute: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AUcircumflex: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AUdieresis: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AUgrave: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AUhungarumlaut: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AUmacron: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AUogonek: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AUring: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AV: [
			-80,
			-80,
			-70,
			-70,
			-145,
			-95,
			-105,
			-135
		],
		AW: [
			-60,
			-60,
			-50,
			-50,
			-130,
			-100,
			-95,
			-90
		],
		AY: [
			-110,
			-110,
			-100,
			-100,
			-100,
			-70,
			-55,
			-105
		],
		AYacute: [
			-110,
			-110,
			-100,
			-100,
			-100,
			-70,
			-55,
			-105
		],
		AYdieresis: [
			-110,
			-110,
			-100,
			-100,
			-100,
			-70,
			-55,
			-105
		],
		Au: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Auacute: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Aucircumflex: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Audieresis: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Augrave: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Auhungarumlaut: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Aumacron: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Auogonek: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Auring: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Av: [
			-40,
			-40,
			-40,
			-40,
			-100,
			-74,
			-55,
			-74
		],
		Aw: [
			-30,
			-30,
			-40,
			-40,
			-90,
			-74,
			-55,
			-92
		],
		Ay: [
			-30,
			-30,
			-40,
			-40,
			-74,
			-74,
			-55,
			-92
		],
		Ayacute: [
			-30,
			-30,
			-40,
			-40,
			-74,
			-74,
			-55,
			-92
		],
		Aydieresis: [
			-30,
			-30,
			-40,
			-40,
			-74,
			-74,
			-55,
			-92
		],
		AacuteC: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AacuteCacute: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AacuteCcaron: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AacuteCcedilla: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AacuteG: [
			-50,
			-50,
			-30,
			-30,
			-55,
			-60,
			-35,
			-40
		],
		AacuteGbreve: [
			-50,
			-50,
			-30,
			-30,
			-55,
			-60,
			-35,
			-40
		],
		AacuteGcommaaccent: [
			-50,
			-50,
			-30,
			-30,
			-55,
			-60,
			-35,
			-40
		],
		AacuteO: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AacuteOacute: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AacuteOcircumflex: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AacuteOdieresis: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AacuteOgrave: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AacuteOhungarumlaut: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AacuteOmacron: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AacuteOslash: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AacuteOtilde: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AacuteQ: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-55,
			-40,
			-55
		],
		AacuteT: [
			-90,
			-90,
			-120,
			-120,
			-95,
			-55,
			-37,
			-111
		],
		AacuteTcaron: [
			-90,
			-90,
			-120,
			-120,
			-95,
			-55,
			-37,
			-111
		],
		AacuteTcommaaccent: [
			-90,
			-90,
			-120,
			-120,
			-95,
			-55,
			-37,
			-111
		],
		AacuteU: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AacuteUacute: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AacuteUcircumflex: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AacuteUdieresis: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AacuteUgrave: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AacuteUhungarumlaut: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AacuteUmacron: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AacuteUogonek: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AacuteUring: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AacuteV: [
			-80,
			-80,
			-70,
			-70,
			-145,
			-95,
			-105,
			-135
		],
		AacuteW: [
			-60,
			-60,
			-50,
			-50,
			-130,
			-100,
			-95,
			-90
		],
		AacuteY: [
			-110,
			-110,
			-100,
			-100,
			-100,
			-70,
			-55,
			-105
		],
		AacuteYacute: [
			-110,
			-110,
			-100,
			-100,
			-100,
			-70,
			-55,
			-105
		],
		AacuteYdieresis: [
			-110,
			-110,
			-100,
			-100,
			-100,
			-70,
			-55,
			-105
		],
		Aacuteu: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Aacuteuacute: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Aacuteucircumflex: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Aacuteudieresis: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Aacuteugrave: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Aacuteuhungarumlaut: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Aacuteumacron: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Aacuteuogonek: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Aacuteuring: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Aacutev: [
			-40,
			-40,
			-40,
			-40,
			-100,
			-74,
			-55,
			-74
		],
		Aacutew: [
			-30,
			-30,
			-40,
			-40,
			-90,
			-74,
			-55,
			-92
		],
		Aacutey: [
			-30,
			-30,
			-40,
			-40,
			-74,
			-74,
			-55,
			-92
		],
		Aacuteyacute: [
			-30,
			-30,
			-40,
			-40,
			-74,
			-74,
			-55,
			-92
		],
		Aacuteydieresis: [
			-30,
			-30,
			-40,
			-40,
			-74,
			-74,
			-55,
			-92
		],
		AbreveC: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AbreveCacute: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AbreveCcaron: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AbreveCcedilla: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AbreveG: [
			-50,
			-50,
			-30,
			-30,
			-55,
			-60,
			-35,
			-40
		],
		AbreveGbreve: [
			-50,
			-50,
			-30,
			-30,
			-55,
			-60,
			-35,
			-40
		],
		AbreveGcommaaccent: [
			-50,
			-50,
			-30,
			-30,
			-55,
			-60,
			-35,
			-40
		],
		AbreveO: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AbreveOacute: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AbreveOcircumflex: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AbreveOdieresis: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AbreveOgrave: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AbreveOhungarumlaut: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AbreveOmacron: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AbreveOslash: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AbreveOtilde: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AbreveQ: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-55,
			-40,
			-55
		],
		AbreveT: [
			-90,
			-90,
			-120,
			-120,
			-95,
			-55,
			-37,
			-111
		],
		AbreveTcaron: [
			-90,
			-90,
			-120,
			-120,
			-95,
			-55,
			-37,
			-111
		],
		AbreveTcommaaccent: [
			-90,
			-90,
			-120,
			-120,
			-95,
			-55,
			-37,
			-111
		],
		AbreveU: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AbreveUacute: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AbreveUcircumflex: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AbreveUdieresis: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AbreveUgrave: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AbreveUhungarumlaut: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AbreveUmacron: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AbreveUogonek: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AbreveUring: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AbreveV: [
			-80,
			-80,
			-70,
			-70,
			-145,
			-95,
			-105,
			-135
		],
		AbreveW: [
			-60,
			-60,
			-50,
			-50,
			-130,
			-100,
			-95,
			-90
		],
		AbreveY: [
			-110,
			-110,
			-100,
			-100,
			-100,
			-70,
			-55,
			-105
		],
		AbreveYacute: [
			-110,
			-110,
			-100,
			-100,
			-100,
			-70,
			-55,
			-105
		],
		AbreveYdieresis: [
			-110,
			-110,
			-100,
			-100,
			-100,
			-70,
			-55,
			-105
		],
		Abreveu: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Abreveuacute: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Abreveucircumflex: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Abreveudieresis: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Abreveugrave: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Abreveuhungarumlaut: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Abreveumacron: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Abreveuogonek: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Abreveuring: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Abrevev: [
			-40,
			-40,
			-40,
			-40,
			-100,
			-74,
			-55,
			-74
		],
		Abrevew: [
			-30,
			-30,
			-40,
			-40,
			-90,
			-74,
			-55,
			-92
		],
		Abrevey: [
			-30,
			-30,
			-40,
			-40,
			-74,
			-74,
			-55,
			-92
		],
		Abreveyacute: [
			-30,
			-30,
			-40,
			-40,
			-74,
			-74,
			-55,
			-92
		],
		Abreveydieresis: [
			-30,
			-30,
			-40,
			-40,
			-74,
			-74,
			-55,
			-92
		],
		AcircumflexC: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AcircumflexCacute: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AcircumflexCcaron: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AcircumflexCcedilla: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AcircumflexG: [
			-50,
			-50,
			-30,
			-30,
			-55,
			-60,
			-35,
			-40
		],
		AcircumflexGbreve: [
			-50,
			-50,
			-30,
			-30,
			-55,
			-60,
			-35,
			-40
		],
		AcircumflexGcommaaccent: [
			-50,
			-50,
			-30,
			-30,
			-55,
			-60,
			-35,
			-40
		],
		AcircumflexO: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AcircumflexOacute: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AcircumflexOcircumflex: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AcircumflexOdieresis: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AcircumflexOgrave: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AcircumflexOhungarumlaut: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AcircumflexOmacron: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AcircumflexOslash: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AcircumflexOtilde: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AcircumflexQ: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-55,
			-40,
			-55
		],
		AcircumflexT: [
			-90,
			-90,
			-120,
			-120,
			-95,
			-55,
			-37,
			-111
		],
		AcircumflexTcaron: [
			-90,
			-90,
			-120,
			-120,
			-95,
			-55,
			-37,
			-111
		],
		AcircumflexTcommaaccent: [
			-90,
			-90,
			-120,
			-120,
			-95,
			-55,
			-37,
			-111
		],
		AcircumflexU: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AcircumflexUacute: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AcircumflexUcircumflex: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AcircumflexUdieresis: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AcircumflexUgrave: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AcircumflexUhungarumlaut: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AcircumflexUmacron: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AcircumflexUogonek: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AcircumflexUring: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AcircumflexV: [
			-80,
			-80,
			-70,
			-70,
			-145,
			-95,
			-105,
			-135
		],
		AcircumflexW: [
			-60,
			-60,
			-50,
			-50,
			-130,
			-100,
			-95,
			-90
		],
		AcircumflexY: [
			-110,
			-110,
			-100,
			-100,
			-100,
			-70,
			-55,
			-105
		],
		AcircumflexYacute: [
			-110,
			-110,
			-100,
			-100,
			-100,
			-70,
			-55,
			-105
		],
		AcircumflexYdieresis: [
			-110,
			-110,
			-100,
			-100,
			-100,
			-70,
			-55,
			-105
		],
		Acircumflexu: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Acircumflexuacute: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Acircumflexucircumflex: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Acircumflexudieresis: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Acircumflexugrave: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Acircumflexuhungarumlaut: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Acircumflexumacron: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Acircumflexuogonek: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Acircumflexuring: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Acircumflexv: [
			-40,
			-40,
			-40,
			-40,
			-100,
			-74,
			-55,
			-74
		],
		Acircumflexw: [
			-30,
			-30,
			-40,
			-40,
			-90,
			-74,
			-55,
			-92
		],
		Acircumflexy: [
			-30,
			-30,
			-40,
			-40,
			-74,
			-74,
			-55,
			-92
		],
		Acircumflexyacute: [
			-30,
			-30,
			-40,
			-40,
			-74,
			-74,
			-55,
			-92
		],
		Acircumflexydieresis: [
			-30,
			-30,
			-40,
			-40,
			-74,
			-74,
			-55,
			-92
		],
		AdieresisC: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AdieresisCacute: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AdieresisCcaron: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AdieresisCcedilla: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AdieresisG: [
			-50,
			-50,
			-30,
			-30,
			-55,
			-60,
			-35,
			-40
		],
		AdieresisGbreve: [
			-50,
			-50,
			-30,
			-30,
			-55,
			-60,
			-35,
			-40
		],
		AdieresisGcommaaccent: [
			-50,
			-50,
			-30,
			-30,
			-55,
			-60,
			-35,
			-40
		],
		AdieresisO: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AdieresisOacute: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AdieresisOcircumflex: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AdieresisOdieresis: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AdieresisOgrave: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AdieresisOhungarumlaut: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AdieresisOmacron: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AdieresisOslash: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AdieresisOtilde: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AdieresisQ: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-55,
			-40,
			-55
		],
		AdieresisT: [
			-90,
			-90,
			-120,
			-120,
			-95,
			-55,
			-37,
			-111
		],
		AdieresisTcaron: [
			-90,
			-90,
			-120,
			-120,
			-95,
			-55,
			-37,
			-111
		],
		AdieresisTcommaaccent: [
			-90,
			-90,
			-120,
			-120,
			-95,
			-55,
			-37,
			-111
		],
		AdieresisU: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AdieresisUacute: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AdieresisUcircumflex: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AdieresisUdieresis: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AdieresisUgrave: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AdieresisUhungarumlaut: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AdieresisUmacron: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AdieresisUogonek: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AdieresisUring: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AdieresisV: [
			-80,
			-80,
			-70,
			-70,
			-145,
			-95,
			-105,
			-135
		],
		AdieresisW: [
			-60,
			-60,
			-50,
			-50,
			-130,
			-100,
			-95,
			-90
		],
		AdieresisY: [
			-110,
			-110,
			-100,
			-100,
			-100,
			-70,
			-55,
			-105
		],
		AdieresisYacute: [
			-110,
			-110,
			-100,
			-100,
			-100,
			-70,
			-55,
			-105
		],
		AdieresisYdieresis: [
			-110,
			-110,
			-100,
			-100,
			-100,
			-70,
			-55,
			-105
		],
		Adieresisu: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Adieresisuacute: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Adieresisucircumflex: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Adieresisudieresis: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Adieresisugrave: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Adieresisuhungarumlaut: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Adieresisumacron: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Adieresisuogonek: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Adieresisuring: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Adieresisv: [
			-40,
			-40,
			-40,
			-40,
			-100,
			-74,
			-55,
			-74
		],
		Adieresisw: [
			-30,
			-30,
			-40,
			-40,
			-90,
			-74,
			-55,
			-92
		],
		Adieresisy: [
			-30,
			-30,
			-40,
			-40,
			-74,
			-74,
			-55,
			-92
		],
		Adieresisyacute: [
			-30,
			-30,
			-40,
			-40,
			-74,
			-74,
			-55,
			-92
		],
		Adieresisydieresis: [
			-30,
			-30,
			-40,
			-40,
			-74,
			-74,
			-55,
			-92
		],
		AgraveC: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AgraveCacute: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AgraveCcaron: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AgraveCcedilla: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AgraveG: [
			-50,
			-50,
			-30,
			-30,
			-55,
			-60,
			-35,
			-40
		],
		AgraveGbreve: [
			-50,
			-50,
			-30,
			-30,
			-55,
			-60,
			-35,
			-40
		],
		AgraveGcommaaccent: [
			-50,
			-50,
			-30,
			-30,
			-55,
			-60,
			-35,
			-40
		],
		AgraveO: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AgraveOacute: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AgraveOcircumflex: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AgraveOdieresis: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AgraveOgrave: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AgraveOhungarumlaut: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AgraveOmacron: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AgraveOslash: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AgraveOtilde: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AgraveQ: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-55,
			-40,
			-55
		],
		AgraveT: [
			-90,
			-90,
			-120,
			-120,
			-95,
			-55,
			-37,
			-111
		],
		AgraveTcaron: [
			-90,
			-90,
			-120,
			-120,
			-95,
			-55,
			-37,
			-111
		],
		AgraveTcommaaccent: [
			-90,
			-90,
			-120,
			-120,
			-95,
			-55,
			-37,
			-111
		],
		AgraveU: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AgraveUacute: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AgraveUcircumflex: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AgraveUdieresis: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AgraveUgrave: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AgraveUhungarumlaut: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AgraveUmacron: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AgraveUogonek: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AgraveUring: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AgraveV: [
			-80,
			-80,
			-70,
			-70,
			-145,
			-95,
			-105,
			-135
		],
		AgraveW: [
			-60,
			-60,
			-50,
			-50,
			-130,
			-100,
			-95,
			-90
		],
		AgraveY: [
			-110,
			-110,
			-100,
			-100,
			-100,
			-70,
			-55,
			-105
		],
		AgraveYacute: [
			-110,
			-110,
			-100,
			-100,
			-100,
			-70,
			-55,
			-105
		],
		AgraveYdieresis: [
			-110,
			-110,
			-100,
			-100,
			-100,
			-70,
			-55,
			-105
		],
		Agraveu: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Agraveuacute: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Agraveucircumflex: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Agraveudieresis: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Agraveugrave: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Agraveuhungarumlaut: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Agraveumacron: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Agraveuogonek: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Agraveuring: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Agravev: [
			-40,
			-40,
			-40,
			-40,
			-100,
			-74,
			-55,
			-74
		],
		Agravew: [
			-30,
			-30,
			-40,
			-40,
			-90,
			-74,
			-55,
			-92
		],
		Agravey: [
			-30,
			-30,
			-40,
			-40,
			-74,
			-74,
			-55,
			-92
		],
		Agraveyacute: [
			-30,
			-30,
			-40,
			-40,
			-74,
			-74,
			-55,
			-92
		],
		Agraveydieresis: [
			-30,
			-30,
			-40,
			-40,
			-74,
			-74,
			-55,
			-92
		],
		AmacronC: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AmacronCacute: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AmacronCcaron: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AmacronCcedilla: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AmacronG: [
			-50,
			-50,
			-30,
			-30,
			-55,
			-60,
			-35,
			-40
		],
		AmacronGbreve: [
			-50,
			-50,
			-30,
			-30,
			-55,
			-60,
			-35,
			-40
		],
		AmacronGcommaaccent: [
			-50,
			-50,
			-30,
			-30,
			-55,
			-60,
			-35,
			-40
		],
		AmacronO: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AmacronOacute: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AmacronOcircumflex: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AmacronOdieresis: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AmacronOgrave: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AmacronOhungarumlaut: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AmacronOmacron: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AmacronOslash: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AmacronOtilde: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AmacronQ: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-55,
			-40,
			-55
		],
		AmacronT: [
			-90,
			-90,
			-120,
			-120,
			-95,
			-55,
			-37,
			-111
		],
		AmacronTcaron: [
			-90,
			-90,
			-120,
			-120,
			-95,
			-55,
			-37,
			-111
		],
		AmacronTcommaaccent: [
			-90,
			-90,
			-120,
			-120,
			-95,
			-55,
			-37,
			-111
		],
		AmacronU: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AmacronUacute: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AmacronUcircumflex: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AmacronUdieresis: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AmacronUgrave: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AmacronUhungarumlaut: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AmacronUmacron: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AmacronUogonek: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AmacronUring: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AmacronV: [
			-80,
			-80,
			-70,
			-70,
			-145,
			-95,
			-105,
			-135
		],
		AmacronW: [
			-60,
			-60,
			-50,
			-50,
			-130,
			-100,
			-95,
			-90
		],
		AmacronY: [
			-110,
			-110,
			-100,
			-100,
			-100,
			-70,
			-55,
			-105
		],
		AmacronYacute: [
			-110,
			-110,
			-100,
			-100,
			-100,
			-70,
			-55,
			-105
		],
		AmacronYdieresis: [
			-110,
			-110,
			-100,
			-100,
			-100,
			-70,
			-55,
			-105
		],
		Amacronu: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Amacronuacute: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Amacronucircumflex: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Amacronudieresis: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Amacronugrave: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Amacronuhungarumlaut: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Amacronumacron: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Amacronuogonek: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Amacronuring: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Amacronv: [
			-40,
			-40,
			-40,
			-40,
			-100,
			-74,
			-55,
			-74
		],
		Amacronw: [
			-30,
			-30,
			-40,
			-40,
			-90,
			-74,
			-55,
			-92
		],
		Amacrony: [
			-30,
			-30,
			-40,
			-40,
			-74,
			-74,
			-55,
			-92
		],
		Amacronyacute: [
			-30,
			-30,
			-40,
			-40,
			-74,
			-74,
			-55,
			-92
		],
		Amacronydieresis: [
			-30,
			-30,
			-40,
			-40,
			-74,
			-74,
			-55,
			-92
		],
		AogonekC: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AogonekCacute: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AogonekCcaron: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AogonekCcedilla: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AogonekG: [
			-50,
			-50,
			-30,
			-30,
			-55,
			-60,
			-35,
			-40
		],
		AogonekGbreve: [
			-50,
			-50,
			-30,
			-30,
			-55,
			-60,
			-35,
			-40
		],
		AogonekGcommaaccent: [
			-50,
			-50,
			-30,
			-30,
			-55,
			-60,
			-35,
			-40
		],
		AogonekO: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AogonekOacute: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AogonekOcircumflex: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AogonekOdieresis: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AogonekOgrave: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AogonekOhungarumlaut: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AogonekOmacron: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AogonekOslash: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AogonekOtilde: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AogonekQ: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-55,
			-40,
			-55
		],
		AogonekT: [
			-90,
			-90,
			-120,
			-120,
			-95,
			-55,
			-37,
			-111
		],
		AogonekTcaron: [
			-90,
			-90,
			-120,
			-120,
			-95,
			-55,
			-37,
			-111
		],
		AogonekTcommaaccent: [
			-90,
			-90,
			-120,
			-120,
			-95,
			-55,
			-37,
			-111
		],
		AogonekU: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AogonekUacute: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AogonekUcircumflex: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AogonekUdieresis: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AogonekUgrave: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AogonekUhungarumlaut: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AogonekUmacron: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AogonekUogonek: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AogonekUring: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AogonekV: [
			-80,
			-80,
			-70,
			-70,
			-145,
			-95,
			-105,
			-135
		],
		AogonekW: [
			-60,
			-60,
			-50,
			-50,
			-130,
			-100,
			-95,
			-90
		],
		AogonekY: [
			-110,
			-110,
			-100,
			-100,
			-100,
			-70,
			-55,
			-105
		],
		AogonekYacute: [
			-110,
			-110,
			-100,
			-100,
			-100,
			-70,
			-55,
			-105
		],
		AogonekYdieresis: [
			-110,
			-110,
			-100,
			-100,
			-100,
			-70,
			-55,
			-105
		],
		Aogoneku: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Aogonekuacute: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Aogonekucircumflex: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Aogonekudieresis: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Aogonekugrave: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Aogonekuhungarumlaut: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Aogonekumacron: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Aogonekuogonek: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Aogonekuring: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Aogonekv: [
			-40,
			-40,
			-40,
			-40,
			-100,
			-74,
			-55,
			-74
		],
		Aogonekw: [
			-30,
			-30,
			-40,
			-40,
			-90,
			-74,
			-55,
			-52
		],
		Aogoneky: [
			-30,
			-30,
			-40,
			-40,
			-34,
			-34,
			-55,
			-52
		],
		Aogonekyacute: [
			-30,
			-30,
			-40,
			-40,
			-34,
			-34,
			-55,
			-52
		],
		Aogonekydieresis: [
			-30,
			-30,
			-40,
			-40,
			-34,
			-34,
			-55,
			-52
		],
		AringC: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AringCacute: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AringCcaron: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AringCcedilla: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AringG: [
			-50,
			-50,
			-30,
			-30,
			-55,
			-60,
			-35,
			-40
		],
		AringGbreve: [
			-50,
			-50,
			-30,
			-30,
			-55,
			-60,
			-35,
			-40
		],
		AringGcommaaccent: [
			-50,
			-50,
			-30,
			-30,
			-55,
			-60,
			-35,
			-40
		],
		AringO: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AringOacute: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AringOcircumflex: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AringOdieresis: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AringOgrave: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AringOhungarumlaut: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AringOmacron: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AringOslash: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AringOtilde: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AringQ: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-55,
			-40,
			-55
		],
		AringT: [
			-90,
			-90,
			-120,
			-120,
			-95,
			-55,
			-37,
			-111
		],
		AringTcaron: [
			-90,
			-90,
			-120,
			-120,
			-95,
			-55,
			-37,
			-111
		],
		AringTcommaaccent: [
			-90,
			-90,
			-120,
			-120,
			-95,
			-55,
			-37,
			-111
		],
		AringU: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AringUacute: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AringUcircumflex: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AringUdieresis: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AringUgrave: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AringUhungarumlaut: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AringUmacron: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AringUogonek: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AringUring: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AringV: [
			-80,
			-80,
			-70,
			-70,
			-145,
			-95,
			-105,
			-135
		],
		AringW: [
			-60,
			-60,
			-50,
			-50,
			-130,
			-100,
			-95,
			-90
		],
		AringY: [
			-110,
			-110,
			-100,
			-100,
			-100,
			-70,
			-55,
			-105
		],
		AringYacute: [
			-110,
			-110,
			-100,
			-100,
			-100,
			-70,
			-55,
			-105
		],
		AringYdieresis: [
			-110,
			-110,
			-100,
			-100,
			-100,
			-70,
			-55,
			-105
		],
		Aringu: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Aringuacute: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Aringucircumflex: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Aringudieresis: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Aringugrave: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Aringuhungarumlaut: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Aringumacron: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Aringuogonek: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Aringuring: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Aringv: [
			-40,
			-40,
			-40,
			-40,
			-100,
			-74,
			-55,
			-74
		],
		Aringw: [
			-30,
			-30,
			-40,
			-40,
			-90,
			-74,
			-55,
			-92
		],
		Aringy: [
			-30,
			-30,
			-40,
			-40,
			-74,
			-74,
			-55,
			-92
		],
		Aringyacute: [
			-30,
			-30,
			-40,
			-40,
			-74,
			-74,
			-55,
			-92
		],
		Aringydieresis: [
			-30,
			-30,
			-40,
			-40,
			-74,
			-74,
			-55,
			-92
		],
		AtildeC: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AtildeCacute: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AtildeCcaron: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AtildeCcedilla: [
			-40,
			-40,
			-30,
			-30,
			-55,
			-65,
			-30,
			-40
		],
		AtildeG: [
			-50,
			-50,
			-30,
			-30,
			-55,
			-60,
			-35,
			-40
		],
		AtildeGbreve: [
			-50,
			-50,
			-30,
			-30,
			-55,
			-60,
			-35,
			-40
		],
		AtildeGcommaaccent: [
			-50,
			-50,
			-30,
			-30,
			-55,
			-60,
			-35,
			-40
		],
		AtildeO: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AtildeOacute: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AtildeOcircumflex: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AtildeOdieresis: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AtildeOgrave: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AtildeOhungarumlaut: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AtildeOmacron: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AtildeOslash: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AtildeOtilde: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-50,
			-40,
			-55
		],
		AtildeQ: [
			-40,
			-40,
			-30,
			-30,
			-45,
			-55,
			-40,
			-55
		],
		AtildeT: [
			-90,
			-90,
			-120,
			-120,
			-95,
			-55,
			-37,
			-111
		],
		AtildeTcaron: [
			-90,
			-90,
			-120,
			-120,
			-95,
			-55,
			-37,
			-111
		],
		AtildeTcommaaccent: [
			-90,
			-90,
			-120,
			-120,
			-95,
			-55,
			-37,
			-111
		],
		AtildeU: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AtildeUacute: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AtildeUcircumflex: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AtildeUdieresis: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AtildeUgrave: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AtildeUhungarumlaut: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AtildeUmacron: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AtildeUogonek: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AtildeUring: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-55
		],
		AtildeV: [
			-80,
			-80,
			-70,
			-70,
			-145,
			-95,
			-105,
			-135
		],
		AtildeW: [
			-60,
			-60,
			-50,
			-50,
			-130,
			-100,
			-95,
			-90
		],
		AtildeY: [
			-110,
			-110,
			-100,
			-100,
			-100,
			-70,
			-55,
			-105
		],
		AtildeYacute: [
			-110,
			-110,
			-100,
			-100,
			-100,
			-70,
			-55,
			-105
		],
		AtildeYdieresis: [
			-110,
			-110,
			-100,
			-100,
			-100,
			-70,
			-55,
			-105
		],
		Atildeu: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Atildeuacute: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Atildeucircumflex: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Atildeudieresis: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Atildeugrave: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Atildeuhungarumlaut: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Atildeumacron: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Atildeuogonek: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Atildeuring: [
			-30,
			-30,
			-30,
			-30,
			-50,
			-30,
			-20
		],
		Atildev: [
			-40,
			-40,
			-40,
			-40,
			-100,
			-74,
			-55,
			-74
		],
		Atildew: [
			-30,
			-30,
			-40,
			-40,
			-90,
			-74,
			-55,
			-92
		],
		Atildey: [
			-30,
			-30,
			-40,
			-40,
			-74,
			-74,
			-55,
			-92
		],
		Atildeyacute: [
			-30,
			-30,
			-40,
			-40,
			-74,
			-74,
			-55,
			-92
		],
		Atildeydieresis: [
			-30,
			-30,
			-40,
			-40,
			-74,
			-74,
			-55,
			-92
		],
		BA: [
			-30,
			-30,
			0,
			0,
			-30,
			-25,
			-25,
			-35
		],
		BAacute: [
			-30,
			-30,
			0,
			0,
			-30,
			-25,
			-25,
			-35
		],
		BAbreve: [
			-30,
			-30,
			0,
			0,
			-30,
			-25,
			-25,
			-35
		],
		BAcircumflex: [
			-30,
			-30,
			0,
			0,
			-30,
			-25,
			-25,
			-35
		],
		BAdieresis: [
			-30,
			-30,
			0,
			0,
			-30,
			-25,
			-25,
			-35
		],
		BAgrave: [
			-30,
			-30,
			0,
			0,
			-30,
			-25,
			-25,
			-35
		],
		BAmacron: [
			-30,
			-30,
			0,
			0,
			-30,
			-25,
			-25,
			-35
		],
		BAogonek: [
			-30,
			-30,
			0,
			0,
			-30,
			-25,
			-25,
			-35
		],
		BAring: [
			-30,
			-30,
			0,
			0,
			-30,
			-25,
			-25,
			-35
		],
		BAtilde: [
			-30,
			-30,
			0,
			0,
			-30,
			-25,
			-25,
			-35
		],
		BU: [
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10
		],
		BUacute: [
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10
		],
		BUcircumflex: [
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10
		],
		BUdieresis: [
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10
		],
		BUgrave: [
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10
		],
		BUhungarumlaut: [
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10
		],
		BUmacron: [
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10
		],
		BUogonek: [
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10
		],
		BUring: [
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10
		],
		DA: [
			-40,
			-40,
			-40,
			-40,
			-35,
			-25,
			-35,
			-40
		],
		DAacute: [
			-40,
			-40,
			-40,
			-40,
			-35,
			-25,
			-35,
			-40
		],
		DAbreve: [
			-40,
			-40,
			-40,
			-40,
			-35,
			-25,
			-35,
			-40
		],
		DAcircumflex: [
			-40,
			-40,
			-40,
			-40,
			-35,
			-25,
			-35,
			-40
		],
		DAdieresis: [
			-40,
			-40,
			-40,
			-40,
			-35,
			-25,
			-35,
			-40
		],
		DAgrave: [
			-40,
			-40,
			-40,
			-40,
			-35,
			-25,
			-35,
			-40
		],
		DAmacron: [
			-40,
			-40,
			-40,
			-40,
			-35,
			-25,
			-35,
			-40
		],
		DAogonek: [
			-40,
			-40,
			-40,
			-40,
			-35,
			-25,
			-35,
			-40
		],
		DAring: [
			-40,
			-40,
			-40,
			-40,
			-35,
			-25,
			-35,
			-40
		],
		DAtilde: [
			-40,
			-40,
			-40,
			-40,
			-35,
			-25,
			-35,
			-40
		],
		DV: [
			-40,
			-40,
			-70,
			-70,
			-40,
			-50,
			-40,
			-40
		],
		DW: [
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-30
		],
		DY: [
			-70,
			-70,
			-90,
			-90,
			-40,
			-50,
			-40,
			-55
		],
		DYacute: [
			-70,
			-70,
			-90,
			-90,
			-40,
			-50,
			-40,
			-55
		],
		DYdieresis: [
			-70,
			-70,
			-90,
			-90,
			-40,
			-50,
			-40,
			-55
		],
		Dcomma: [
			-30,
			-30,
			-70,
			-70
		],
		Dperiod: [
			-30,
			-30,
			-70,
			-70,
			-20
		],
		DcaronA: [
			-40,
			-40,
			-40,
			-40,
			-35,
			-25,
			-35,
			-40
		],
		DcaronAacute: [
			-40,
			-40,
			-40,
			-40,
			-35,
			-25,
			-35,
			-40
		],
		DcaronAbreve: [
			-40,
			-40,
			-40,
			-40,
			-35,
			-25,
			-35,
			-40
		],
		DcaronAcircumflex: [
			-40,
			-40,
			-40,
			-40,
			-35,
			-25,
			-35,
			-40
		],
		DcaronAdieresis: [
			-40,
			-40,
			-40,
			-40,
			-35,
			-25,
			-35,
			-40
		],
		DcaronAgrave: [
			-40,
			-40,
			-40,
			-40,
			-35,
			-25,
			-35,
			-40
		],
		DcaronAmacron: [
			-40,
			-40,
			-40,
			-40,
			-35,
			-25,
			-35,
			-40
		],
		DcaronAogonek: [
			-40,
			-40,
			-40,
			-40,
			-35,
			-25,
			-35,
			-40
		],
		DcaronAring: [
			-40,
			-40,
			-40,
			-40,
			-35,
			-25,
			-35,
			-40
		],
		DcaronAtilde: [
			-40,
			-40,
			-40,
			-40,
			-35,
			-25,
			-35,
			-40
		],
		DcaronV: [
			-40,
			-40,
			-70,
			-70,
			-40,
			-50,
			-40,
			-40
		],
		DcaronW: [
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-30
		],
		DcaronY: [
			-70,
			-70,
			-90,
			-90,
			-40,
			-50,
			-40,
			-55
		],
		DcaronYacute: [
			-70,
			-70,
			-90,
			-90,
			-40,
			-50,
			-40,
			-55
		],
		DcaronYdieresis: [
			-70,
			-70,
			-90,
			-90,
			-40,
			-50,
			-40,
			-55
		],
		Dcaroncomma: [
			-30,
			-30,
			-70,
			-70
		],
		Dcaronperiod: [
			-30,
			-30,
			-70,
			-70,
			-20
		],
		DcroatA: [
			-40,
			-40,
			-40,
			-40,
			-35,
			-25,
			-35,
			-40
		],
		DcroatAacute: [
			-40,
			-40,
			-40,
			-40,
			-35,
			-25,
			-35,
			-40
		],
		DcroatAbreve: [
			-40,
			-40,
			-40,
			-40,
			-35,
			-25,
			-35,
			-40
		],
		DcroatAcircumflex: [
			-40,
			-40,
			-40,
			-40,
			-35,
			-25,
			-35,
			-40
		],
		DcroatAdieresis: [
			-40,
			-40,
			-40,
			-40,
			-35,
			-25,
			-35,
			-40
		],
		DcroatAgrave: [
			-40,
			-40,
			-40,
			-40,
			-35,
			-25,
			-35,
			-40
		],
		DcroatAmacron: [
			-40,
			-40,
			-40,
			-40,
			-35,
			-25,
			-35,
			-40
		],
		DcroatAogonek: [
			-40,
			-40,
			-40,
			-40,
			-35,
			-25,
			-35,
			-40
		],
		DcroatAring: [
			-40,
			-40,
			-40,
			-40,
			-35,
			-25,
			-35,
			-40
		],
		DcroatAtilde: [
			-40,
			-40,
			-40,
			-40,
			-35,
			-25,
			-35,
			-40
		],
		DcroatV: [
			-40,
			-40,
			-70,
			-70,
			-40,
			-50,
			-40,
			-40
		],
		DcroatW: [
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-30
		],
		DcroatY: [
			-70,
			-70,
			-90,
			-90,
			-40,
			-50,
			-40,
			-55
		],
		DcroatYacute: [
			-70,
			-70,
			-90,
			-90,
			-40,
			-50,
			-40,
			-55
		],
		DcroatYdieresis: [
			-70,
			-70,
			-90,
			-90,
			-40,
			-50,
			-40,
			-55
		],
		Dcroatcomma: [
			-30,
			-30,
			-70,
			-70
		],
		Dcroatperiod: [
			-30,
			-30,
			-70,
			-70,
			-20
		],
		FA: [
			-80,
			-80,
			-80,
			-80,
			-90,
			-100,
			-115,
			-74
		],
		FAacute: [
			-80,
			-80,
			-80,
			-80,
			-90,
			-100,
			-115,
			-74
		],
		FAbreve: [
			-80,
			-80,
			-80,
			-80,
			-90,
			-100,
			-115,
			-74
		],
		FAcircumflex: [
			-80,
			-80,
			-80,
			-80,
			-90,
			-100,
			-115,
			-74
		],
		FAdieresis: [
			-80,
			-80,
			-80,
			-80,
			-90,
			-100,
			-115,
			-74
		],
		FAgrave: [
			-80,
			-80,
			-80,
			-80,
			-90,
			-100,
			-115,
			-74
		],
		FAmacron: [
			-80,
			-80,
			-80,
			-80,
			-90,
			-100,
			-115,
			-74
		],
		FAogonek: [
			-80,
			-80,
			-80,
			-80,
			-90,
			-100,
			-115,
			-74
		],
		FAring: [
			-80,
			-80,
			-80,
			-80,
			-90,
			-100,
			-115,
			-74
		],
		FAtilde: [
			-80,
			-80,
			-80,
			-80,
			-90,
			-100,
			-115,
			-74
		],
		Fa: [
			-20,
			-20,
			-50,
			-50,
			-25,
			-95,
			-75,
			-15
		],
		Faacute: [
			-20,
			-20,
			-50,
			-50,
			-25,
			-95,
			-75,
			-15
		],
		Fabreve: [
			-20,
			-20,
			-50,
			-50,
			-25,
			-95,
			-75,
			-15
		],
		Facircumflex: [
			-20,
			-20,
			-50,
			-50,
			-25,
			-95,
			-75,
			-15
		],
		Fadieresis: [
			-20,
			-20,
			-50,
			-50,
			-25,
			-95,
			-75,
			-15
		],
		Fagrave: [
			-20,
			-20,
			-50,
			-50,
			-25,
			-95,
			-75,
			-15
		],
		Famacron: [
			-20,
			-20,
			-50,
			-50,
			-25,
			-95,
			-75,
			-15
		],
		Faogonek: [
			-20,
			-20,
			-50,
			-50,
			-25,
			-95,
			-75,
			-15
		],
		Faring: [
			-20,
			-20,
			-50,
			-50,
			-25,
			-95,
			-75,
			-15
		],
		Fatilde: [
			-20,
			-20,
			-50,
			-50,
			-25,
			-95,
			-75,
			-15
		],
		Fcomma: [
			-100,
			-100,
			-150,
			-150,
			-92,
			-129,
			-135,
			-80
		],
		Fperiod: [
			-100,
			-100,
			-150,
			-150,
			-110,
			-129,
			-135,
			-80
		],
		JA: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-25,
			-40,
			-60
		],
		JAacute: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-25,
			-40,
			-60
		],
		JAbreve: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-25,
			-40,
			-60
		],
		JAcircumflex: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-25,
			-40,
			-60
		],
		JAdieresis: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-25,
			-40,
			-60
		],
		JAgrave: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-25,
			-40,
			-60
		],
		JAmacron: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-25,
			-40,
			-60
		],
		JAogonek: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-25,
			-40,
			-60
		],
		JAring: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-25,
			-40,
			-60
		],
		JAtilde: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-25,
			-40,
			-60
		],
		Jcomma: [
			-20,
			-20,
			-30,
			-30,
			0,
			-10,
			-25
		],
		Jperiod: [
			-20,
			-20,
			-30,
			-30,
			-20,
			-10,
			-25
		],
		Ju: [
			-20,
			-20,
			-20,
			-20,
			-15,
			-40,
			-35
		],
		Juacute: [
			-20,
			-20,
			-20,
			-20,
			-15,
			-40,
			-35
		],
		Jucircumflex: [
			-20,
			-20,
			-20,
			-20,
			-15,
			-40,
			-35
		],
		Judieresis: [
			-20,
			-20,
			-20,
			-20,
			-15,
			-40,
			-35
		],
		Jugrave: [
			-20,
			-20,
			-20,
			-20,
			-15,
			-40,
			-35
		],
		Juhungarumlaut: [
			-20,
			-20,
			-20,
			-20,
			-15,
			-40,
			-35
		],
		Jumacron: [
			-20,
			-20,
			-20,
			-20,
			-15,
			-40,
			-35
		],
		Juogonek: [
			-20,
			-20,
			-20,
			-20,
			-15,
			-40,
			-35
		],
		Juring: [
			-20,
			-20,
			-20,
			-20,
			-15,
			-40,
			-35
		],
		KO: [
			-30,
			-30,
			-50,
			-50,
			-30,
			-30,
			-50,
			-30
		],
		KOacute: [
			-30,
			-30,
			-50,
			-50,
			-30,
			-30,
			-50,
			-30
		],
		KOcircumflex: [
			-30,
			-30,
			-50,
			-50,
			-30,
			-30,
			-50,
			-30
		],
		KOdieresis: [
			-30,
			-30,
			-50,
			-50,
			-30,
			-30,
			-50,
			-30
		],
		KOgrave: [
			-30,
			-30,
			-50,
			-50,
			-30,
			-30,
			-50,
			-30
		],
		KOhungarumlaut: [
			-30,
			-30,
			-50,
			-50,
			-30,
			-30,
			-50,
			-30
		],
		KOmacron: [
			-30,
			-30,
			-50,
			-50,
			-30,
			-30,
			-50,
			-30
		],
		KOslash: [
			-30,
			-30,
			-50,
			-50,
			-30,
			-30,
			-50,
			-30
		],
		KOtilde: [
			-30,
			-30,
			-50,
			-50,
			-30,
			-30,
			-50,
			-30
		],
		Ke: [
			-15,
			-15,
			-40,
			-40,
			-25,
			-25,
			-35,
			-25
		],
		Keacute: [
			-15,
			-15,
			-40,
			-40,
			-25,
			-25,
			-35,
			-25
		],
		Kecaron: [
			-15,
			-15,
			-40,
			-40,
			-25,
			-25,
			-35,
			-25
		],
		Kecircumflex: [
			-15,
			-15,
			-40,
			-40,
			-25,
			-25,
			-35,
			-25
		],
		Kedieresis: [
			-15,
			-15,
			-40,
			-40,
			-25,
			-25,
			-35,
			-25
		],
		Kedotaccent: [
			-15,
			-15,
			-40,
			-40,
			-25,
			-25,
			-35,
			-25
		],
		Kegrave: [
			-15,
			-15,
			-40,
			-40,
			-25,
			-25,
			-35,
			-25
		],
		Kemacron: [
			-15,
			-15,
			-40,
			-40,
			-25,
			-25,
			-35,
			-25
		],
		Keogonek: [
			-15,
			-15,
			-40,
			-40,
			-25,
			-25,
			-35,
			-25
		],
		Ko: [
			-35,
			-35,
			-40,
			-40,
			-25,
			-25,
			-40,
			-35
		],
		Koacute: [
			-35,
			-35,
			-40,
			-40,
			-25,
			-25,
			-40,
			-35
		],
		Kocircumflex: [
			-35,
			-35,
			-40,
			-40,
			-25,
			-25,
			-40,
			-35
		],
		Kodieresis: [
			-35,
			-35,
			-40,
			-40,
			-25,
			-25,
			-40,
			-35
		],
		Kograve: [
			-35,
			-35,
			-40,
			-40,
			-25,
			-25,
			-40,
			-35
		],
		Kohungarumlaut: [
			-35,
			-35,
			-40,
			-40,
			-25,
			-25,
			-40,
			-35
		],
		Komacron: [
			-35,
			-35,
			-40,
			-40,
			-25,
			-25,
			-40,
			-35
		],
		Koslash: [
			-35,
			-35,
			-40,
			-40,
			-25,
			-25,
			-40,
			-35
		],
		Kotilde: [
			-35,
			-35,
			-40,
			-40,
			-25,
			-25,
			-40,
			-35
		],
		Ku: [
			-30,
			-30,
			-30,
			-30,
			-15,
			-20,
			-40,
			-15
		],
		Kuacute: [
			-30,
			-30,
			-30,
			-30,
			-15,
			-20,
			-40,
			-15
		],
		Kucircumflex: [
			-30,
			-30,
			-30,
			-30,
			-15,
			-20,
			-40,
			-15
		],
		Kudieresis: [
			-30,
			-30,
			-30,
			-30,
			-15,
			-20,
			-40,
			-15
		],
		Kugrave: [
			-30,
			-30,
			-30,
			-30,
			-15,
			-20,
			-40,
			-15
		],
		Kuhungarumlaut: [
			-30,
			-30,
			-30,
			-30,
			-15,
			-20,
			-40,
			-15
		],
		Kumacron: [
			-30,
			-30,
			-30,
			-30,
			-15,
			-20,
			-40,
			-15
		],
		Kuogonek: [
			-30,
			-30,
			-30,
			-30,
			-15,
			-20,
			-40,
			-15
		],
		Kuring: [
			-30,
			-30,
			-30,
			-30,
			-15,
			-20,
			-40,
			-15
		],
		Ky: [
			-40,
			-40,
			-50,
			-50,
			-45,
			-20,
			-40,
			-25
		],
		Kyacute: [
			-40,
			-40,
			-50,
			-50,
			-45,
			-20,
			-40,
			-25
		],
		Kydieresis: [
			-40,
			-40,
			-50,
			-50,
			-45,
			-20,
			-40,
			-25
		],
		KcommaaccentO: [
			-30,
			-30,
			-50,
			-50,
			-30,
			-30,
			-50,
			-30
		],
		KcommaaccentOacute: [
			-30,
			-30,
			-50,
			-50,
			-30,
			-30,
			-50,
			-30
		],
		KcommaaccentOcircumflex: [
			-30,
			-30,
			-50,
			-50,
			-30,
			-30,
			-50,
			-30
		],
		KcommaaccentOdieresis: [
			-30,
			-30,
			-50,
			-50,
			-30,
			-30,
			-50,
			-30
		],
		KcommaaccentOgrave: [
			-30,
			-30,
			-50,
			-50,
			-30,
			-30,
			-50,
			-30
		],
		KcommaaccentOhungarumlaut: [
			-30,
			-30,
			-50,
			-50,
			-30,
			-30,
			-50,
			-30
		],
		KcommaaccentOmacron: [
			-30,
			-30,
			-50,
			-50,
			-30,
			-30,
			-50,
			-30
		],
		KcommaaccentOslash: [
			-30,
			-30,
			-50,
			-50,
			-30,
			-30,
			-50,
			-30
		],
		KcommaaccentOtilde: [
			-30,
			-30,
			-50,
			-50,
			-30,
			-30,
			-50,
			-30
		],
		Kcommaaccente: [
			-15,
			-15,
			-40,
			-40,
			-25,
			-25,
			-35,
			-25
		],
		Kcommaaccenteacute: [
			-15,
			-15,
			-40,
			-40,
			-25,
			-25,
			-35,
			-25
		],
		Kcommaaccentecaron: [
			-15,
			-15,
			-40,
			-40,
			-25,
			-25,
			-35,
			-25
		],
		Kcommaaccentecircumflex: [
			-15,
			-15,
			-40,
			-40,
			-25,
			-25,
			-35,
			-25
		],
		Kcommaaccentedieresis: [
			-15,
			-15,
			-40,
			-40,
			-25,
			-25,
			-35,
			-25
		],
		Kcommaaccentedotaccent: [
			-15,
			-15,
			-40,
			-40,
			-25,
			-25,
			-35,
			-25
		],
		Kcommaaccentegrave: [
			-15,
			-15,
			-40,
			-40,
			-25,
			-25,
			-35,
			-25
		],
		Kcommaaccentemacron: [
			-15,
			-15,
			-40,
			-40,
			-25,
			-25,
			-35,
			-25
		],
		Kcommaaccenteogonek: [
			-15,
			-15,
			-40,
			-40,
			-25,
			-25,
			-35,
			-25
		],
		Kcommaaccento: [
			-35,
			-35,
			-40,
			-40,
			-25,
			-25,
			-40,
			-35
		],
		Kcommaaccentoacute: [
			-35,
			-35,
			-40,
			-40,
			-25,
			-25,
			-40,
			-35
		],
		Kcommaaccentocircumflex: [
			-35,
			-35,
			-40,
			-40,
			-25,
			-25,
			-40,
			-35
		],
		Kcommaaccentodieresis: [
			-35,
			-35,
			-40,
			-40,
			-25,
			-25,
			-40,
			-35
		],
		Kcommaaccentograve: [
			-35,
			-35,
			-40,
			-40,
			-25,
			-25,
			-40,
			-35
		],
		Kcommaaccentohungarumlaut: [
			-35,
			-35,
			-40,
			-40,
			-25,
			-25,
			-40,
			-35
		],
		Kcommaaccentomacron: [
			-35,
			-35,
			-40,
			-40,
			-25,
			-25,
			-40,
			-35
		],
		Kcommaaccentoslash: [
			-35,
			-35,
			-40,
			-40,
			-25,
			-25,
			-40,
			-35
		],
		Kcommaaccentotilde: [
			-35,
			-35,
			-40,
			-40,
			-25,
			-25,
			-40,
			-35
		],
		Kcommaaccentu: [
			-30,
			-30,
			-30,
			-30,
			-15,
			-20,
			-40,
			-15
		],
		Kcommaaccentuacute: [
			-30,
			-30,
			-30,
			-30,
			-15,
			-20,
			-40,
			-15
		],
		Kcommaaccentucircumflex: [
			-30,
			-30,
			-30,
			-30,
			-15,
			-20,
			-40,
			-15
		],
		Kcommaaccentudieresis: [
			-30,
			-30,
			-30,
			-30,
			-15,
			-20,
			-40,
			-15
		],
		Kcommaaccentugrave: [
			-30,
			-30,
			-30,
			-30,
			-15,
			-20,
			-40,
			-15
		],
		Kcommaaccentuhungarumlaut: [
			-30,
			-30,
			-30,
			-30,
			-15,
			-20,
			-40,
			-15
		],
		Kcommaaccentumacron: [
			-30,
			-30,
			-30,
			-30,
			-15,
			-20,
			-40,
			-15
		],
		Kcommaaccentuogonek: [
			-30,
			-30,
			-30,
			-30,
			-15,
			-20,
			-40,
			-15
		],
		Kcommaaccenturing: [
			-30,
			-30,
			-30,
			-30,
			-15,
			-20,
			-40,
			-15
		],
		Kcommaaccenty: [
			-40,
			-40,
			-50,
			-50,
			-45,
			-20,
			-40,
			-25
		],
		Kcommaaccentyacute: [
			-40,
			-40,
			-50,
			-50,
			-45,
			-20,
			-40,
			-25
		],
		Kcommaaccentydieresis: [
			-40,
			-40,
			-50,
			-50,
			-45,
			-20,
			-40,
			-25
		],
		LT: [
			-90,
			-90,
			-110,
			-110,
			-92,
			-18,
			-20,
			-92
		],
		LTcaron: [
			-90,
			-90,
			-110,
			-110,
			-92,
			-18,
			-20,
			-92
		],
		LTcommaaccent: [
			-90,
			-90,
			-110,
			-110,
			-92,
			-18,
			-20,
			-92
		],
		LV: [
			-110,
			-110,
			-110,
			-110,
			-92,
			-37,
			-55,
			-100
		],
		LW: [
			-80,
			-80,
			-70,
			-70,
			-92,
			-37,
			-55,
			-74
		],
		LY: [
			-120,
			-120,
			-140,
			-140,
			-92,
			-37,
			-20,
			-100
		],
		LYacute: [
			-120,
			-120,
			-140,
			-140,
			-92,
			-37,
			-20,
			-100
		],
		LYdieresis: [
			-120,
			-120,
			-140,
			-140,
			-92,
			-37,
			-20,
			-100
		],
		Lquotedblright: [
			-140,
			-140,
			-140,
			-140,
			-20
		],
		Lquoteright: [
			-140,
			-140,
			-160,
			-160,
			-110,
			-55,
			-37,
			-92
		],
		Ly: [
			-30,
			-30,
			-30,
			-30,
			-55,
			-37,
			-30,
			-55
		],
		Lyacute: [
			-30,
			-30,
			-30,
			-30,
			-55,
			-37,
			-30,
			-55
		],
		Lydieresis: [
			-30,
			-30,
			-30,
			-30,
			-55,
			-37,
			-30,
			-55
		],
		LacuteT: [
			-90,
			-90,
			-110,
			-110,
			-92,
			-18,
			-20,
			-92
		],
		LacuteTcaron: [
			-90,
			-90,
			-110,
			-110,
			-92,
			-18,
			-20,
			-92
		],
		LacuteTcommaaccent: [
			-90,
			-90,
			-110,
			-110,
			-92,
			-18,
			-20,
			-92
		],
		LacuteV: [
			-110,
			-110,
			-110,
			-110,
			-92,
			-37,
			-55,
			-100
		],
		LacuteW: [
			-80,
			-80,
			-70,
			-70,
			-92,
			-37,
			-55,
			-74
		],
		LacuteY: [
			-120,
			-120,
			-140,
			-140,
			-92,
			-37,
			-20,
			-100
		],
		LacuteYacute: [
			-120,
			-120,
			-140,
			-140,
			-92,
			-37,
			-20,
			-100
		],
		LacuteYdieresis: [
			-120,
			-120,
			-140,
			-140,
			-92,
			-37,
			-20,
			-100
		],
		Lacutequotedblright: [
			-140,
			-140,
			-140,
			-140,
			-20
		],
		Lacutequoteright: [
			-140,
			-140,
			-160,
			-160,
			-110,
			-55,
			-37,
			-92
		],
		Lacutey: [
			-30,
			-30,
			-30,
			-30,
			-55,
			-37,
			-30,
			-55
		],
		Lacuteyacute: [
			-30,
			-30,
			-30,
			-30,
			-55,
			-37,
			-30,
			-55
		],
		Lacuteydieresis: [
			-30,
			-30,
			-30,
			-30,
			-55,
			-37,
			-30,
			-55
		],
		LcommaaccentT: [
			-90,
			-90,
			-110,
			-110,
			-92,
			-18,
			-20,
			-92
		],
		LcommaaccentTcaron: [
			-90,
			-90,
			-110,
			-110,
			-92,
			-18,
			-20,
			-92
		],
		LcommaaccentTcommaaccent: [
			-90,
			-90,
			-110,
			-110,
			-92,
			-18,
			-20,
			-92
		],
		LcommaaccentV: [
			-110,
			-110,
			-110,
			-110,
			-92,
			-37,
			-55,
			-100
		],
		LcommaaccentW: [
			-80,
			-80,
			-70,
			-70,
			-92,
			-37,
			-55,
			-74
		],
		LcommaaccentY: [
			-120,
			-120,
			-140,
			-140,
			-92,
			-37,
			-20,
			-100
		],
		LcommaaccentYacute: [
			-120,
			-120,
			-140,
			-140,
			-92,
			-37,
			-20,
			-100
		],
		LcommaaccentYdieresis: [
			-120,
			-120,
			-140,
			-140,
			-92,
			-37,
			-20,
			-100
		],
		Lcommaaccentquotedblright: [
			-140,
			-140,
			-140,
			-140,
			-20
		],
		Lcommaaccentquoteright: [
			-140,
			-140,
			-160,
			-160,
			-110,
			-55,
			-37,
			-92
		],
		Lcommaaccenty: [
			-30,
			-30,
			-30,
			-30,
			-55,
			-37,
			-30,
			-55
		],
		Lcommaaccentyacute: [
			-30,
			-30,
			-30,
			-30,
			-55,
			-37,
			-30,
			-55
		],
		Lcommaaccentydieresis: [
			-30,
			-30,
			-30,
			-30,
			-55,
			-37,
			-30,
			-55
		],
		LslashT: [
			-90,
			-90,
			-110,
			-110,
			-92,
			-18,
			-20,
			-92
		],
		LslashTcaron: [
			-90,
			-90,
			-110,
			-110,
			-92,
			-18,
			-20,
			-92
		],
		LslashTcommaaccent: [
			-90,
			-90,
			-110,
			-110,
			-92,
			-18,
			-20,
			-92
		],
		LslashV: [
			-110,
			-110,
			-110,
			-110,
			-92,
			-37,
			-55,
			-100
		],
		LslashW: [
			-80,
			-80,
			-70,
			-70,
			-92,
			-37,
			-55,
			-74
		],
		LslashY: [
			-120,
			-120,
			-140,
			-140,
			-92,
			-37,
			-20,
			-100
		],
		LslashYacute: [
			-120,
			-120,
			-140,
			-140,
			-92,
			-37,
			-20,
			-100
		],
		LslashYdieresis: [
			-120,
			-120,
			-140,
			-140,
			-92,
			-37,
			-20,
			-100
		],
		Lslashquotedblright: [
			-140,
			-140,
			-140,
			-140,
			-20
		],
		Lslashquoteright: [
			-140,
			-140,
			-160,
			-160,
			-110,
			-55,
			-37,
			-92
		],
		Lslashy: [
			-30,
			-30,
			-30,
			-30,
			-55,
			-37,
			-30,
			-55
		],
		Lslashyacute: [
			-30,
			-30,
			-30,
			-30,
			-55,
			-37,
			-30,
			-55
		],
		Lslashydieresis: [
			-30,
			-30,
			-30,
			-30,
			-55,
			-37,
			-30,
			-55
		],
		OA: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OAacute: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OAbreve: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OAcircumflex: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OAdieresis: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OAgrave: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OAmacron: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OAogonek: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OAring: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OAtilde: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OT: [
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40
		],
		OTcaron: [
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40
		],
		OTcommaaccent: [
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40
		],
		OV: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50
		],
		OW: [
			-50,
			-50,
			-30,
			-30,
			-50,
			-50,
			-50,
			-35
		],
		OX: [
			-50,
			-50,
			-60,
			-60,
			-40,
			-40,
			-40,
			-40
		],
		OY: [
			-70,
			-70,
			-70,
			-70,
			-50,
			-50,
			-50,
			-50
		],
		OYacute: [
			-70,
			-70,
			-70,
			-70,
			-50,
			-50,
			-50,
			-50
		],
		OYdieresis: [
			-70,
			-70,
			-70,
			-70,
			-50,
			-50,
			-50,
			-50
		],
		Ocomma: [
			-40,
			-40,
			-40,
			-40
		],
		Operiod: [
			-40,
			-40,
			-40,
			-40
		],
		OacuteA: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OacuteAacute: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OacuteAbreve: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OacuteAcircumflex: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OacuteAdieresis: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OacuteAgrave: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OacuteAmacron: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OacuteAogonek: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OacuteAring: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OacuteAtilde: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OacuteT: [
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40
		],
		OacuteTcaron: [
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40
		],
		OacuteTcommaaccent: [
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40
		],
		OacuteV: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50
		],
		OacuteW: [
			-50,
			-50,
			-30,
			-30,
			-50,
			-50,
			-50,
			-35
		],
		OacuteX: [
			-50,
			-50,
			-60,
			-60,
			-40,
			-40,
			-40,
			-40
		],
		OacuteY: [
			-70,
			-70,
			-70,
			-70,
			-50,
			-50,
			-50,
			-50
		],
		OacuteYacute: [
			-70,
			-70,
			-70,
			-70,
			-50,
			-50,
			-50,
			-50
		],
		OacuteYdieresis: [
			-70,
			-70,
			-70,
			-70,
			-50,
			-50,
			-50,
			-50
		],
		Oacutecomma: [
			-40,
			-40,
			-40,
			-40
		],
		Oacuteperiod: [
			-40,
			-40,
			-40,
			-40
		],
		OcircumflexA: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OcircumflexAacute: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OcircumflexAbreve: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OcircumflexAcircumflex: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OcircumflexAdieresis: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OcircumflexAgrave: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OcircumflexAmacron: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OcircumflexAogonek: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OcircumflexAring: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OcircumflexAtilde: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OcircumflexT: [
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40
		],
		OcircumflexTcaron: [
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40
		],
		OcircumflexTcommaaccent: [
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40
		],
		OcircumflexV: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50
		],
		OcircumflexW: [
			-50,
			-50,
			-30,
			-30,
			-50,
			-50,
			-50,
			-35
		],
		OcircumflexX: [
			-50,
			-50,
			-60,
			-60,
			-40,
			-40,
			-40,
			-40
		],
		OcircumflexY: [
			-70,
			-70,
			-70,
			-70,
			-50,
			-50,
			-50,
			-50
		],
		OcircumflexYacute: [
			-70,
			-70,
			-70,
			-70,
			-50,
			-50,
			-50,
			-50
		],
		OcircumflexYdieresis: [
			-70,
			-70,
			-70,
			-70,
			-50,
			-50,
			-50,
			-50
		],
		Ocircumflexcomma: [
			-40,
			-40,
			-40,
			-40
		],
		Ocircumflexperiod: [
			-40,
			-40,
			-40,
			-40
		],
		OdieresisA: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OdieresisAacute: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OdieresisAbreve: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OdieresisAcircumflex: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OdieresisAdieresis: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OdieresisAgrave: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OdieresisAmacron: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OdieresisAogonek: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OdieresisAring: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OdieresisAtilde: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OdieresisT: [
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40
		],
		OdieresisTcaron: [
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40
		],
		OdieresisTcommaaccent: [
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40
		],
		OdieresisV: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50
		],
		OdieresisW: [
			-50,
			-50,
			-30,
			-30,
			-50,
			-50,
			-50,
			-35
		],
		OdieresisX: [
			-50,
			-50,
			-60,
			-60,
			-40,
			-40,
			-40,
			-40
		],
		OdieresisY: [
			-70,
			-70,
			-70,
			-70,
			-50,
			-50,
			-50,
			-50
		],
		OdieresisYacute: [
			-70,
			-70,
			-70,
			-70,
			-50,
			-50,
			-50,
			-50
		],
		OdieresisYdieresis: [
			-70,
			-70,
			-70,
			-70,
			-50,
			-50,
			-50,
			-50
		],
		Odieresiscomma: [
			-40,
			-40,
			-40,
			-40
		],
		Odieresisperiod: [
			-40,
			-40,
			-40,
			-40
		],
		OgraveA: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OgraveAacute: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OgraveAbreve: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OgraveAcircumflex: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OgraveAdieresis: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OgraveAgrave: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OgraveAmacron: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OgraveAogonek: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OgraveAring: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OgraveAtilde: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OgraveT: [
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40
		],
		OgraveTcaron: [
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40
		],
		OgraveTcommaaccent: [
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40
		],
		OgraveV: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50
		],
		OgraveW: [
			-50,
			-50,
			-30,
			-30,
			-50,
			-50,
			-50,
			-35
		],
		OgraveX: [
			-50,
			-50,
			-60,
			-60,
			-40,
			-40,
			-40,
			-40
		],
		OgraveY: [
			-70,
			-70,
			-70,
			-70,
			-50,
			-50,
			-50,
			-50
		],
		OgraveYacute: [
			-70,
			-70,
			-70,
			-70,
			-50,
			-50,
			-50,
			-50
		],
		OgraveYdieresis: [
			-70,
			-70,
			-70,
			-70,
			-50,
			-50,
			-50,
			-50
		],
		Ogravecomma: [
			-40,
			-40,
			-40,
			-40
		],
		Ograveperiod: [
			-40,
			-40,
			-40,
			-40
		],
		OhungarumlautA: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OhungarumlautAacute: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OhungarumlautAbreve: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OhungarumlautAcircumflex: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OhungarumlautAdieresis: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OhungarumlautAgrave: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OhungarumlautAmacron: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OhungarumlautAogonek: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OhungarumlautAring: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OhungarumlautAtilde: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OhungarumlautT: [
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40
		],
		OhungarumlautTcaron: [
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40
		],
		OhungarumlautTcommaaccent: [
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40
		],
		OhungarumlautV: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50
		],
		OhungarumlautW: [
			-50,
			-50,
			-30,
			-30,
			-50,
			-50,
			-50,
			-35
		],
		OhungarumlautX: [
			-50,
			-50,
			-60,
			-60,
			-40,
			-40,
			-40,
			-40
		],
		OhungarumlautY: [
			-70,
			-70,
			-70,
			-70,
			-50,
			-50,
			-50,
			-50
		],
		OhungarumlautYacute: [
			-70,
			-70,
			-70,
			-70,
			-50,
			-50,
			-50,
			-50
		],
		OhungarumlautYdieresis: [
			-70,
			-70,
			-70,
			-70,
			-50,
			-50,
			-50,
			-50
		],
		Ohungarumlautcomma: [
			-40,
			-40,
			-40,
			-40
		],
		Ohungarumlautperiod: [
			-40,
			-40,
			-40,
			-40
		],
		OmacronA: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OmacronAacute: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OmacronAbreve: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OmacronAcircumflex: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OmacronAdieresis: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OmacronAgrave: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OmacronAmacron: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OmacronAogonek: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OmacronAring: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OmacronAtilde: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OmacronT: [
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40
		],
		OmacronTcaron: [
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40
		],
		OmacronTcommaaccent: [
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40
		],
		OmacronV: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50
		],
		OmacronW: [
			-50,
			-50,
			-30,
			-30,
			-50,
			-50,
			-50,
			-35
		],
		OmacronX: [
			-50,
			-50,
			-60,
			-60,
			-40,
			-40,
			-40,
			-40
		],
		OmacronY: [
			-70,
			-70,
			-70,
			-70,
			-50,
			-50,
			-50,
			-50
		],
		OmacronYacute: [
			-70,
			-70,
			-70,
			-70,
			-50,
			-50,
			-50,
			-50
		],
		OmacronYdieresis: [
			-70,
			-70,
			-70,
			-70,
			-50,
			-50,
			-50,
			-50
		],
		Omacroncomma: [
			-40,
			-40,
			-40,
			-40
		],
		Omacronperiod: [
			-40,
			-40,
			-40,
			-40
		],
		OslashA: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OslashAacute: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OslashAbreve: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OslashAcircumflex: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OslashAdieresis: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OslashAgrave: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OslashAmacron: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OslashAogonek: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OslashAring: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OslashAtilde: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OslashT: [
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40
		],
		OslashTcaron: [
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40
		],
		OslashTcommaaccent: [
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40
		],
		OslashV: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50
		],
		OslashW: [
			-50,
			-50,
			-30,
			-30,
			-50,
			-50,
			-50,
			-35
		],
		OslashX: [
			-50,
			-50,
			-60,
			-60,
			-40,
			-40,
			-40,
			-40
		],
		OslashY: [
			-70,
			-70,
			-70,
			-70,
			-50,
			-50,
			-50,
			-50
		],
		OslashYacute: [
			-70,
			-70,
			-70,
			-70,
			-50,
			-50,
			-50,
			-50
		],
		OslashYdieresis: [
			-70,
			-70,
			-70,
			-70,
			-50,
			-50,
			-50,
			-50
		],
		Oslashcomma: [
			-40,
			-40,
			-40,
			-40
		],
		Oslashperiod: [
			-40,
			-40,
			-40,
			-40
		],
		OtildeA: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OtildeAacute: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OtildeAbreve: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OtildeAcircumflex: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OtildeAdieresis: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OtildeAgrave: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OtildeAmacron: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OtildeAogonek: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OtildeAring: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OtildeAtilde: [
			-50,
			-50,
			-20,
			-20,
			-40,
			-40,
			-55,
			-35
		],
		OtildeT: [
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40
		],
		OtildeTcaron: [
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40
		],
		OtildeTcommaaccent: [
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40
		],
		OtildeV: [
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50,
			-50
		],
		OtildeW: [
			-50,
			-50,
			-30,
			-30,
			-50,
			-50,
			-50,
			-35
		],
		OtildeX: [
			-50,
			-50,
			-60,
			-60,
			-40,
			-40,
			-40,
			-40
		],
		OtildeY: [
			-70,
			-70,
			-70,
			-70,
			-50,
			-50,
			-50,
			-50
		],
		OtildeYacute: [
			-70,
			-70,
			-70,
			-70,
			-50,
			-50,
			-50,
			-50
		],
		OtildeYdieresis: [
			-70,
			-70,
			-70,
			-70,
			-50,
			-50,
			-50,
			-50
		],
		Otildecomma: [
			-40,
			-40,
			-40,
			-40
		],
		Otildeperiod: [
			-40,
			-40,
			-40,
			-40
		],
		PA: [
			-100,
			-100,
			-120,
			-120,
			-74,
			-85,
			-90,
			-92
		],
		PAacute: [
			-100,
			-100,
			-120,
			-120,
			-74,
			-85,
			-90,
			-92
		],
		PAbreve: [
			-100,
			-100,
			-120,
			-120,
			-74,
			-85,
			-90,
			-92
		],
		PAcircumflex: [
			-100,
			-100,
			-120,
			-120,
			-74,
			-85,
			-90,
			-92
		],
		PAdieresis: [
			-100,
			-100,
			-120,
			-120,
			-74,
			-85,
			-90,
			-92
		],
		PAgrave: [
			-100,
			-100,
			-120,
			-120,
			-74,
			-85,
			-90,
			-92
		],
		PAmacron: [
			-100,
			-100,
			-120,
			-120,
			-74,
			-85,
			-90,
			-92
		],
		PAogonek: [
			-100,
			-100,
			-120,
			-120,
			-74,
			-85,
			-90,
			-92
		],
		PAring: [
			-100,
			-100,
			-120,
			-120,
			-74,
			-85,
			-90,
			-92
		],
		PAtilde: [
			-100,
			-100,
			-120,
			-120,
			-74,
			-85,
			-90,
			-92
		],
		Pa: [
			-30,
			-30,
			-40,
			-40,
			-10,
			-40,
			-80,
			-15
		],
		Paacute: [
			-30,
			-30,
			-40,
			-40,
			-10,
			-40,
			-80,
			-15
		],
		Pabreve: [
			-30,
			-30,
			-40,
			-40,
			-10,
			-40,
			-80,
			-15
		],
		Pacircumflex: [
			-30,
			-30,
			-40,
			-40,
			-10,
			-40,
			-80,
			-15
		],
		Padieresis: [
			-30,
			-30,
			-40,
			-40,
			-10,
			-40,
			-80,
			-15
		],
		Pagrave: [
			-30,
			-30,
			-40,
			-40,
			-10,
			-40,
			-80,
			-15
		],
		Pamacron: [
			-30,
			-30,
			-40,
			-40,
			-10,
			-40,
			-80,
			-15
		],
		Paogonek: [
			-30,
			-30,
			-40,
			-40,
			-10,
			-40,
			-80,
			-15
		],
		Paring: [
			-30,
			-30,
			-40,
			-40,
			-10,
			-40,
			-80,
			-15
		],
		Patilde: [
			-30,
			-30,
			-40,
			-40,
			-10,
			-40,
			-80,
			-15
		],
		Pcomma: [
			-120,
			-120,
			-180,
			-180,
			-92,
			-129,
			-135,
			-111
		],
		Pe: [
			-30,
			-30,
			-50,
			-50,
			-20,
			-50,
			-80
		],
		Peacute: [
			-30,
			-30,
			-50,
			-50,
			-20,
			-50,
			-80
		],
		Pecaron: [
			-30,
			-30,
			-50,
			-50,
			-20,
			-50,
			-80
		],
		Pecircumflex: [
			-30,
			-30,
			-50,
			-50,
			-20,
			-50,
			-80
		],
		Pedieresis: [
			-30,
			-30,
			-50,
			-50,
			-20,
			-50,
			-80
		],
		Pedotaccent: [
			-30,
			-30,
			-50,
			-50,
			-20,
			-50,
			-80
		],
		Pegrave: [
			-30,
			-30,
			-50,
			-50,
			-20,
			-50,
			-80
		],
		Pemacron: [
			-30,
			-30,
			-50,
			-50,
			-20,
			-50,
			-80
		],
		Peogonek: [
			-30,
			-30,
			-50,
			-50,
			-20,
			-50,
			-80
		],
		Po: [
			-40,
			-40,
			-50,
			-50,
			-20,
			-55,
			-80
		],
		Poacute: [
			-40,
			-40,
			-50,
			-50,
			-20,
			-55,
			-80
		],
		Pocircumflex: [
			-40,
			-40,
			-50,
			-50,
			-20,
			-55,
			-80
		],
		Podieresis: [
			-40,
			-40,
			-50,
			-50,
			-20,
			-55,
			-80
		],
		Pograve: [
			-40,
			-40,
			-50,
			-50,
			-20,
			-55,
			-80
		],
		Pohungarumlaut: [
			-40,
			-40,
			-50,
			-50,
			-20,
			-55,
			-80
		],
		Pomacron: [
			-40,
			-40,
			-50,
			-50,
			-20,
			-55,
			-80
		],
		Poslash: [
			-40,
			-40,
			-50,
			-50,
			-20,
			-55,
			-80
		],
		Potilde: [
			-40,
			-40,
			-50,
			-50,
			-20,
			-55,
			-80
		],
		Pperiod: [
			-120,
			-120,
			-180,
			-180,
			-110,
			-129,
			-135,
			-111
		],
		QU: [
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10
		],
		QUacute: [
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10
		],
		QUcircumflex: [
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10
		],
		QUdieresis: [
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10
		],
		QUgrave: [
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10
		],
		QUhungarumlaut: [
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10
		],
		QUmacron: [
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10
		],
		QUogonek: [
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10
		],
		QUring: [
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10,
			-10
		],
		Qcomma: [20, 20],
		Qperiod: [
			20,
			20,
			0,
			0,
			-20
		],
		RO: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		ROacute: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		ROcircumflex: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		ROdieresis: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		ROgrave: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		ROhungarumlaut: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		ROmacron: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		ROslash: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		ROtilde: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		RT: [
			-20,
			-20,
			-30,
			-30,
			-40,
			-30,
			0,
			-60
		],
		RTcaron: [
			-20,
			-20,
			-30,
			-30,
			-40,
			-30,
			0,
			-60
		],
		RTcommaaccent: [
			-20,
			-20,
			-30,
			-30,
			-40,
			-30,
			0,
			-60
		],
		RU: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RUacute: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RUcircumflex: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RUdieresis: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RUgrave: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RUhungarumlaut: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RUmacron: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RUogonek: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RUring: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RV: [
			-50,
			-50,
			-50,
			-50,
			-55,
			-18,
			-18,
			-80
		],
		RW: [
			-40,
			-40,
			-30,
			-30,
			-35,
			-18,
			-18,
			-55
		],
		RY: [
			-50,
			-50,
			-50,
			-50,
			-35,
			-18,
			-18,
			-65
		],
		RYacute: [
			-50,
			-50,
			-50,
			-50,
			-35,
			-18,
			-18,
			-65
		],
		RYdieresis: [
			-50,
			-50,
			-50,
			-50,
			-35,
			-18,
			-18,
			-65
		],
		RacuteO: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		RacuteOacute: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		RacuteOcircumflex: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		RacuteOdieresis: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		RacuteOgrave: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		RacuteOhungarumlaut: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		RacuteOmacron: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		RacuteOslash: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		RacuteOtilde: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		RacuteT: [
			-20,
			-20,
			-30,
			-30,
			-40,
			-30,
			0,
			-60
		],
		RacuteTcaron: [
			-20,
			-20,
			-30,
			-30,
			-40,
			-30,
			0,
			-60
		],
		RacuteTcommaaccent: [
			-20,
			-20,
			-30,
			-30,
			-40,
			-30,
			0,
			-60
		],
		RacuteU: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RacuteUacute: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RacuteUcircumflex: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RacuteUdieresis: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RacuteUgrave: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RacuteUhungarumlaut: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RacuteUmacron: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RacuteUogonek: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RacuteUring: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RacuteV: [
			-50,
			-50,
			-50,
			-50,
			-55,
			-18,
			-18,
			-80
		],
		RacuteW: [
			-40,
			-40,
			-30,
			-30,
			-35,
			-18,
			-18,
			-55
		],
		RacuteY: [
			-50,
			-50,
			-50,
			-50,
			-35,
			-18,
			-18,
			-65
		],
		RacuteYacute: [
			-50,
			-50,
			-50,
			-50,
			-35,
			-18,
			-18,
			-65
		],
		RacuteYdieresis: [
			-50,
			-50,
			-50,
			-50,
			-35,
			-18,
			-18,
			-65
		],
		RcaronO: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		RcaronOacute: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		RcaronOcircumflex: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		RcaronOdieresis: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		RcaronOgrave: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		RcaronOhungarumlaut: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		RcaronOmacron: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		RcaronOslash: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		RcaronOtilde: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		RcaronT: [
			-20,
			-20,
			-30,
			-30,
			-40,
			-30,
			0,
			-60
		],
		RcaronTcaron: [
			-20,
			-20,
			-30,
			-30,
			-40,
			-30,
			0,
			-60
		],
		RcaronTcommaaccent: [
			-20,
			-20,
			-30,
			-30,
			-40,
			-30,
			0,
			-60
		],
		RcaronU: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RcaronUacute: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RcaronUcircumflex: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RcaronUdieresis: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RcaronUgrave: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RcaronUhungarumlaut: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RcaronUmacron: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RcaronUogonek: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RcaronUring: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RcaronV: [
			-50,
			-50,
			-50,
			-50,
			-55,
			-18,
			-18,
			-80
		],
		RcaronW: [
			-40,
			-40,
			-30,
			-30,
			-35,
			-18,
			-18,
			-55
		],
		RcaronY: [
			-50,
			-50,
			-50,
			-50,
			-35,
			-18,
			-18,
			-65
		],
		RcaronYacute: [
			-50,
			-50,
			-50,
			-50,
			-35,
			-18,
			-18,
			-65
		],
		RcaronYdieresis: [
			-50,
			-50,
			-50,
			-50,
			-35,
			-18,
			-18,
			-65
		],
		RcommaaccentO: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		RcommaaccentOacute: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		RcommaaccentOcircumflex: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		RcommaaccentOdieresis: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		RcommaaccentOgrave: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		RcommaaccentOhungarumlaut: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		RcommaaccentOmacron: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		RcommaaccentOslash: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		RcommaaccentOtilde: [
			-20,
			-20,
			-20,
			-20,
			-30,
			-40,
			-40,
			-40
		],
		RcommaaccentT: [
			-20,
			-20,
			-30,
			-30,
			-40,
			-30,
			0,
			-60
		],
		RcommaaccentTcaron: [
			-20,
			-20,
			-30,
			-30,
			-40,
			-30,
			0,
			-60
		],
		RcommaaccentTcommaaccent: [
			-20,
			-20,
			-30,
			-30,
			-40,
			-30,
			0,
			-60
		],
		RcommaaccentU: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RcommaaccentUacute: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RcommaaccentUcircumflex: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RcommaaccentUdieresis: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RcommaaccentUgrave: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RcommaaccentUhungarumlaut: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RcommaaccentUmacron: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RcommaaccentUogonek: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RcommaaccentUring: [
			-20,
			-20,
			-40,
			-40,
			-30,
			-40,
			-40,
			-40
		],
		RcommaaccentV: [
			-50,
			-50,
			-50,
			-50,
			-55,
			-18,
			-18,
			-80
		],
		RcommaaccentW: [
			-40,
			-40,
			-30,
			-30,
			-35,
			-18,
			-18,
			-55
		],
		RcommaaccentY: [
			-50,
			-50,
			-50,
			-50,
			-35,
			-18,
			-18,
			-65
		],
		RcommaaccentYacute: [
			-50,
			-50,
			-50,
			-50,
			-35,
			-18,
			-18,
			-65
		],
		RcommaaccentYdieresis: [
			-50,
			-50,
			-50,
			-50,
			-35,
			-18,
			-18,
			-65
		],
		TA: [
			-90,
			-90,
			-120,
			-120,
			-90,
			-55,
			-50,
			-93
		],
		TAacute: [
			-90,
			-90,
			-120,
			-120,
			-90,
			-55,
			-50,
			-93
		],
		TAbreve: [
			-90,
			-90,
			-120,
			-120,
			-90,
			-55,
			-50,
			-93
		],
		TAcircumflex: [
			-90,
			-90,
			-120,
			-120,
			-90,
			-55,
			-50,
			-93
		],
		TAdieresis: [
			-90,
			-90,
			-120,
			-120,
			-90,
			-55,
			-50,
			-93
		],
		TAgrave: [
			-90,
			-90,
			-120,
			-120,
			-90,
			-55,
			-50,
			-93
		],
		TAmacron: [
			-90,
			-90,
			-120,
			-120,
			-90,
			-55,
			-50,
			-93
		],
		TAogonek: [
			-90,
			-90,
			-120,
			-120,
			-90,
			-55,
			-50,
			-93
		],
		TAring: [
			-90,
			-90,
			-120,
			-120,
			-90,
			-55,
			-50,
			-93
		],
		TAtilde: [
			-90,
			-90,
			-120,
			-120,
			-90,
			-55,
			-50,
			-93
		],
		TO: [
			-40,
			-40,
			-40,
			-40,
			-18,
			-18,
			-18,
			-18
		],
		TOacute: [
			-40,
			-40,
			-40,
			-40,
			-18,
			-18,
			-18,
			-18
		],
		TOcircumflex: [
			-40,
			-40,
			-40,
			-40,
			-18,
			-18,
			-18,
			-18
		],
		TOdieresis: [
			-40,
			-40,
			-40,
			-40,
			-18,
			-18,
			-18,
			-18
		],
		TOgrave: [
			-40,
			-40,
			-40,
			-40,
			-18,
			-18,
			-18,
			-18
		],
		TOhungarumlaut: [
			-40,
			-40,
			-40,
			-40,
			-18,
			-18,
			-18,
			-18
		],
		TOmacron: [
			-40,
			-40,
			-40,
			-40,
			-18,
			-18,
			-18,
			-18
		],
		TOslash: [
			-40,
			-40,
			-40,
			-40,
			-18,
			-18,
			-18,
			-18
		],
		TOtilde: [
			-40,
			-40,
			-40,
			-40,
			-18,
			-18,
			-18,
			-18
		],
		Ta: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-92,
			-92,
			-80
		],
		Taacute: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-92,
			-92,
			-80
		],
		Tabreve: [
			-80,
			-80,
			-60,
			-60,
			-52,
			-92,
			-92,
			-80
		],
		Tacircumflex: [
			-80,
			-80,
			-120,
			-120,
			-52,
			-92,
			-92,
			-80
		],
		Tadieresis: [
			-80,
			-80,
			-120,
			-120,
			-52,
			-92,
			-92,
			-40
		],
		Tagrave: [
			-80,
			-80,
			-120,
			-120,
			-52,
			-92,
			-92,
			-40
		],
		Tamacron: [
			-80,
			-80,
			-60,
			-60,
			-52,
			-92,
			-92,
			-40
		],
		Taogonek: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-92,
			-92,
			-80
		],
		Taring: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-92,
			-92,
			-80
		],
		Tatilde: [
			-80,
			-80,
			-60,
			-60,
			-52,
			-92,
			-92,
			-40
		],
		Tcolon: [
			-40,
			-40,
			-20,
			-20,
			-74,
			-74,
			-55,
			-50
		],
		Tcomma: [
			-80,
			-80,
			-120,
			-120,
			-74,
			-92,
			-74,
			-74
		],
		Te: [
			-60,
			-60,
			-120,
			-120,
			-92,
			-92,
			-92,
			-70
		],
		Teacute: [
			-60,
			-60,
			-120,
			-120,
			-92,
			-92,
			-92,
			-70
		],
		Tecaron: [
			-60,
			-60,
			-120,
			-120,
			-92,
			-92,
			-92,
			-70
		],
		Tecircumflex: [
			-60,
			-60,
			-120,
			-120,
			-92,
			-92,
			-52,
			-70
		],
		Tedieresis: [
			-60,
			-60,
			-120,
			-120,
			-52,
			-52,
			-52,
			-30
		],
		Tedotaccent: [
			-60,
			-60,
			-120,
			-120,
			-92,
			-92,
			-92,
			-70
		],
		Tegrave: [
			-60,
			-60,
			-60,
			-60,
			-52,
			-52,
			-52,
			-70
		],
		Temacron: [
			-60,
			-60,
			-60,
			-60,
			-52,
			-52,
			-52,
			-30
		],
		Teogonek: [
			-60,
			-60,
			-120,
			-120,
			-92,
			-92,
			-92,
			-70
		],
		Thyphen: [
			-120,
			-120,
			-140,
			-140,
			-92,
			-92,
			-74,
			-92
		],
		To: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-95,
			-92,
			-80
		],
		Toacute: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-95,
			-92,
			-80
		],
		Tocircumflex: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-95,
			-92,
			-80
		],
		Todieresis: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-95,
			-92,
			-80
		],
		Tograve: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-95,
			-92,
			-80
		],
		Tohungarumlaut: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-95,
			-92,
			-80
		],
		Tomacron: [
			-80,
			-80,
			-60,
			-60,
			-92,
			-95,
			-92,
			-80
		],
		Toslash: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-95,
			-92,
			-80
		],
		Totilde: [
			-80,
			-80,
			-60,
			-60,
			-92,
			-95,
			-92,
			-80
		],
		Tperiod: [
			-80,
			-80,
			-120,
			-120,
			-90,
			-92,
			-74,
			-74
		],
		Tr: [
			-80,
			-80,
			-120,
			-120,
			-74,
			-37,
			-55,
			-35
		],
		Tracute: [
			-80,
			-80,
			-120,
			-120,
			-74,
			-37,
			-55,
			-35
		],
		Trcommaaccent: [
			-80,
			-80,
			-120,
			-120,
			-74,
			-37,
			-55,
			-35
		],
		Tsemicolon: [
			-40,
			-40,
			-20,
			-20,
			-74,
			-74,
			-65,
			-55
		],
		Tu: [
			-90,
			-90,
			-120,
			-120,
			-92,
			-37,
			-55,
			-45
		],
		Tuacute: [
			-90,
			-90,
			-120,
			-120,
			-92,
			-37,
			-55,
			-45
		],
		Tucircumflex: [
			-90,
			-90,
			-120,
			-120,
			-92,
			-37,
			-55,
			-45
		],
		Tudieresis: [
			-90,
			-90,
			-120,
			-120,
			-92,
			-37,
			-55,
			-45
		],
		Tugrave: [
			-90,
			-90,
			-120,
			-120,
			-92,
			-37,
			-55,
			-45
		],
		Tuhungarumlaut: [
			-90,
			-90,
			-120,
			-120,
			-92,
			-37,
			-55,
			-45
		],
		Tumacron: [
			-90,
			-90,
			-60,
			-60,
			-92,
			-37,
			-55,
			-45
		],
		Tuogonek: [
			-90,
			-90,
			-120,
			-120,
			-92,
			-37,
			-55,
			-45
		],
		Turing: [
			-90,
			-90,
			-120,
			-120,
			-92,
			-37,
			-55,
			-45
		],
		Tw: [
			-60,
			-60,
			-120,
			-120,
			-74,
			-37,
			-74,
			-80
		],
		Ty: [
			-60,
			-60,
			-120,
			-120,
			-34,
			-37,
			-74,
			-80
		],
		Tyacute: [
			-60,
			-60,
			-120,
			-120,
			-34,
			-37,
			-74,
			-80
		],
		Tydieresis: [
			-60,
			-60,
			-60,
			-60,
			-34,
			-37,
			-34,
			-80
		],
		TcaronA: [
			-90,
			-90,
			-120,
			-120,
			-90,
			-55,
			-50,
			-93
		],
		TcaronAacute: [
			-90,
			-90,
			-120,
			-120,
			-90,
			-55,
			-50,
			-93
		],
		TcaronAbreve: [
			-90,
			-90,
			-120,
			-120,
			-90,
			-55,
			-50,
			-93
		],
		TcaronAcircumflex: [
			-90,
			-90,
			-120,
			-120,
			-90,
			-55,
			-50,
			-93
		],
		TcaronAdieresis: [
			-90,
			-90,
			-120,
			-120,
			-90,
			-55,
			-50,
			-93
		],
		TcaronAgrave: [
			-90,
			-90,
			-120,
			-120,
			-90,
			-55,
			-50,
			-93
		],
		TcaronAmacron: [
			-90,
			-90,
			-120,
			-120,
			-90,
			-55,
			-50,
			-93
		],
		TcaronAogonek: [
			-90,
			-90,
			-120,
			-120,
			-90,
			-55,
			-50,
			-93
		],
		TcaronAring: [
			-90,
			-90,
			-120,
			-120,
			-90,
			-55,
			-50,
			-93
		],
		TcaronAtilde: [
			-90,
			-90,
			-120,
			-120,
			-90,
			-55,
			-50,
			-93
		],
		TcaronO: [
			-40,
			-40,
			-40,
			-40,
			-18,
			-18,
			-18,
			-18
		],
		TcaronOacute: [
			-40,
			-40,
			-40,
			-40,
			-18,
			-18,
			-18,
			-18
		],
		TcaronOcircumflex: [
			-40,
			-40,
			-40,
			-40,
			-18,
			-18,
			-18,
			-18
		],
		TcaronOdieresis: [
			-40,
			-40,
			-40,
			-40,
			-18,
			-18,
			-18,
			-18
		],
		TcaronOgrave: [
			-40,
			-40,
			-40,
			-40,
			-18,
			-18,
			-18,
			-18
		],
		TcaronOhungarumlaut: [
			-40,
			-40,
			-40,
			-40,
			-18,
			-18,
			-18,
			-18
		],
		TcaronOmacron: [
			-40,
			-40,
			-40,
			-40,
			-18,
			-18,
			-18,
			-18
		],
		TcaronOslash: [
			-40,
			-40,
			-40,
			-40,
			-18,
			-18,
			-18,
			-18
		],
		TcaronOtilde: [
			-40,
			-40,
			-40,
			-40,
			-18,
			-18,
			-18,
			-18
		],
		Tcarona: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-92,
			-92,
			-80
		],
		Tcaronaacute: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-92,
			-92,
			-80
		],
		Tcaronabreve: [
			-80,
			-80,
			-60,
			-60,
			-52,
			-92,
			-92,
			-80
		],
		Tcaronacircumflex: [
			-80,
			-80,
			-120,
			-120,
			-52,
			-92,
			-92,
			-80
		],
		Tcaronadieresis: [
			-80,
			-80,
			-120,
			-120,
			-52,
			-92,
			-92,
			-40
		],
		Tcaronagrave: [
			-80,
			-80,
			-120,
			-120,
			-52,
			-92,
			-92,
			-40
		],
		Tcaronamacron: [
			-80,
			-80,
			-60,
			-60,
			-52,
			-92,
			-92,
			-40
		],
		Tcaronaogonek: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-92,
			-92,
			-80
		],
		Tcaronaring: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-92,
			-92,
			-80
		],
		Tcaronatilde: [
			-80,
			-80,
			-60,
			-60,
			-52,
			-92,
			-92,
			-40
		],
		Tcaroncolon: [
			-40,
			-40,
			-20,
			-20,
			-74,
			-74,
			-55,
			-50
		],
		Tcaroncomma: [
			-80,
			-80,
			-120,
			-120,
			-74,
			-92,
			-74,
			-74
		],
		Tcarone: [
			-60,
			-60,
			-120,
			-120,
			-92,
			-92,
			-92,
			-70
		],
		Tcaroneacute: [
			-60,
			-60,
			-120,
			-120,
			-92,
			-92,
			-92,
			-70
		],
		Tcaronecaron: [
			-60,
			-60,
			-120,
			-120,
			-92,
			-92,
			-92,
			-70
		],
		Tcaronecircumflex: [
			-60,
			-60,
			-120,
			-120,
			-92,
			-92,
			-52,
			-30
		],
		Tcaronedieresis: [
			-60,
			-60,
			-120,
			-120,
			-52,
			-52,
			-52,
			-30
		],
		Tcaronedotaccent: [
			-60,
			-60,
			-120,
			-120,
			-92,
			-92,
			-92,
			-70
		],
		Tcaronegrave: [
			-60,
			-60,
			-60,
			-60,
			-52,
			-52,
			-52,
			-70
		],
		Tcaronemacron: [
			-60,
			-60,
			-60,
			-60,
			-52,
			-52,
			-52,
			-30
		],
		Tcaroneogonek: [
			-60,
			-60,
			-120,
			-120,
			-92,
			-92,
			-92,
			-70
		],
		Tcaronhyphen: [
			-120,
			-120,
			-140,
			-140,
			-92,
			-92,
			-74,
			-92
		],
		Tcarono: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-95,
			-92,
			-80
		],
		Tcaronoacute: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-95,
			-92,
			-80
		],
		Tcaronocircumflex: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-95,
			-92,
			-80
		],
		Tcaronodieresis: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-95,
			-92,
			-80
		],
		Tcaronograve: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-95,
			-92,
			-80
		],
		Tcaronohungarumlaut: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-95,
			-92,
			-80
		],
		Tcaronomacron: [
			-80,
			-80,
			-60,
			-60,
			-92,
			-95,
			-92,
			-80
		],
		Tcaronoslash: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-95,
			-92,
			-80
		],
		Tcaronotilde: [
			-80,
			-80,
			-60,
			-60,
			-92,
			-95,
			-92,
			-80
		],
		Tcaronperiod: [
			-80,
			-80,
			-120,
			-120,
			-90,
			-92,
			-74,
			-74
		],
		Tcaronr: [
			-80,
			-80,
			-120,
			-120,
			-74,
			-37,
			-55,
			-35
		],
		Tcaronracute: [
			-80,
			-80,
			-120,
			-120,
			-74,
			-37,
			-55,
			-35
		],
		Tcaronrcommaaccent: [
			-80,
			-80,
			-120,
			-120,
			-74,
			-37,
			-55,
			-35
		],
		Tcaronsemicolon: [
			-40,
			-40,
			-20,
			-20,
			-74,
			-74,
			-65,
			-55
		],
		Tcaronu: [
			-90,
			-90,
			-120,
			-120,
			-92,
			-37,
			-55,
			-45
		],
		Tcaronuacute: [
			-90,
			-90,
			-120,
			-120,
			-92,
			-37,
			-55,
			-45
		],
		Tcaronucircumflex: [
			-90,
			-90,
			-120,
			-120,
			-92,
			-37,
			-55,
			-45
		],
		Tcaronudieresis: [
			-90,
			-90,
			-120,
			-120,
			-92,
			-37,
			-55,
			-45
		],
		Tcaronugrave: [
			-90,
			-90,
			-120,
			-120,
			-92,
			-37,
			-55,
			-45
		],
		Tcaronuhungarumlaut: [
			-90,
			-90,
			-120,
			-120,
			-92,
			-37,
			-55,
			-45
		],
		Tcaronumacron: [
			-90,
			-90,
			-60,
			-60,
			-92,
			-37,
			-55,
			-45
		],
		Tcaronuogonek: [
			-90,
			-90,
			-120,
			-120,
			-92,
			-37,
			-55,
			-45
		],
		Tcaronuring: [
			-90,
			-90,
			-120,
			-120,
			-92,
			-37,
			-55,
			-45
		],
		Tcaronw: [
			-60,
			-60,
			-120,
			-120,
			-74,
			-37,
			-74,
			-80
		],
		Tcarony: [
			-60,
			-60,
			-120,
			-120,
			-34,
			-37,
			-74,
			-80
		],
		Tcaronyacute: [
			-60,
			-60,
			-120,
			-120,
			-34,
			-37,
			-74,
			-80
		],
		Tcaronydieresis: [
			-60,
			-60,
			-60,
			-60,
			-34,
			-37,
			-34,
			-80
		],
		TcommaaccentA: [
			-90,
			-90,
			-120,
			-120,
			-90,
			-55,
			-50,
			-93
		],
		TcommaaccentAacute: [
			-90,
			-90,
			-120,
			-120,
			-90,
			-55,
			-50,
			-93
		],
		TcommaaccentAbreve: [
			-90,
			-90,
			-120,
			-120,
			-90,
			-55,
			-50,
			-93
		],
		TcommaaccentAcircumflex: [
			-90,
			-90,
			-120,
			-120,
			-90,
			-55,
			-50,
			-93
		],
		TcommaaccentAdieresis: [
			-90,
			-90,
			-120,
			-120,
			-90,
			-55,
			-50,
			-93
		],
		TcommaaccentAgrave: [
			-90,
			-90,
			-120,
			-120,
			-90,
			-55,
			-50,
			-93
		],
		TcommaaccentAmacron: [
			-90,
			-90,
			-120,
			-120,
			-90,
			-55,
			-50,
			-93
		],
		TcommaaccentAogonek: [
			-90,
			-90,
			-120,
			-120,
			-90,
			-55,
			-50,
			-93
		],
		TcommaaccentAring: [
			-90,
			-90,
			-120,
			-120,
			-90,
			-55,
			-50,
			-93
		],
		TcommaaccentAtilde: [
			-90,
			-90,
			-120,
			-120,
			-90,
			-55,
			-50,
			-93
		],
		TcommaaccentO: [
			-40,
			-40,
			-40,
			-40,
			-18,
			-18,
			-18,
			-18
		],
		TcommaaccentOacute: [
			-40,
			-40,
			-40,
			-40,
			-18,
			-18,
			-18,
			-18
		],
		TcommaaccentOcircumflex: [
			-40,
			-40,
			-40,
			-40,
			-18,
			-18,
			-18,
			-18
		],
		TcommaaccentOdieresis: [
			-40,
			-40,
			-40,
			-40,
			-18,
			-18,
			-18,
			-18
		],
		TcommaaccentOgrave: [
			-40,
			-40,
			-40,
			-40,
			-18,
			-18,
			-18,
			-18
		],
		TcommaaccentOhungarumlaut: [
			-40,
			-40,
			-40,
			-40,
			-18,
			-18,
			-18,
			-18
		],
		TcommaaccentOmacron: [
			-40,
			-40,
			-40,
			-40,
			-18,
			-18,
			-18,
			-18
		],
		TcommaaccentOslash: [
			-40,
			-40,
			-40,
			-40,
			-18,
			-18,
			-18,
			-18
		],
		TcommaaccentOtilde: [
			-40,
			-40,
			-40,
			-40,
			-18,
			-18,
			-18,
			-18
		],
		Tcommaaccenta: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-92,
			-92,
			-80
		],
		Tcommaaccentaacute: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-92,
			-92,
			-80
		],
		Tcommaaccentabreve: [
			-80,
			-80,
			-60,
			-60,
			-52,
			-92,
			-92,
			-80
		],
		Tcommaaccentacircumflex: [
			-80,
			-80,
			-120,
			-120,
			-52,
			-92,
			-92,
			-80
		],
		Tcommaaccentadieresis: [
			-80,
			-80,
			-120,
			-120,
			-52,
			-92,
			-92,
			-40
		],
		Tcommaaccentagrave: [
			-80,
			-80,
			-120,
			-120,
			-52,
			-92,
			-92,
			-40
		],
		Tcommaaccentamacron: [
			-80,
			-80,
			-60,
			-60,
			-52,
			-92,
			-92,
			-40
		],
		Tcommaaccentaogonek: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-92,
			-92,
			-80
		],
		Tcommaaccentaring: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-92,
			-92,
			-80
		],
		Tcommaaccentatilde: [
			-80,
			-80,
			-60,
			-60,
			-52,
			-92,
			-92,
			-40
		],
		Tcommaaccentcolon: [
			-40,
			-40,
			-20,
			-20,
			-74,
			-74,
			-55,
			-50
		],
		Tcommaaccentcomma: [
			-80,
			-80,
			-120,
			-120,
			-74,
			-92,
			-74,
			-74
		],
		Tcommaaccente: [
			-60,
			-60,
			-120,
			-120,
			-92,
			-92,
			-92,
			-70
		],
		Tcommaaccenteacute: [
			-60,
			-60,
			-120,
			-120,
			-92,
			-92,
			-92,
			-70
		],
		Tcommaaccentecaron: [
			-60,
			-60,
			-120,
			-120,
			-92,
			-92,
			-92,
			-70
		],
		Tcommaaccentecircumflex: [
			-60,
			-60,
			-120,
			-120,
			-92,
			-92,
			-52,
			-30
		],
		Tcommaaccentedieresis: [
			-60,
			-60,
			-120,
			-120,
			-52,
			-52,
			-52,
			-30
		],
		Tcommaaccentedotaccent: [
			-60,
			-60,
			-120,
			-120,
			-92,
			-92,
			-92,
			-70
		],
		Tcommaaccentegrave: [
			-60,
			-60,
			-60,
			-60,
			-52,
			-52,
			-52,
			-30
		],
		Tcommaaccentemacron: [
			-60,
			-60,
			-60,
			-60,
			-52,
			-52,
			-52,
			-70
		],
		Tcommaaccenteogonek: [
			-60,
			-60,
			-120,
			-120,
			-92,
			-92,
			-92,
			-70
		],
		Tcommaaccenthyphen: [
			-120,
			-120,
			-140,
			-140,
			-92,
			-92,
			-74,
			-92
		],
		Tcommaaccento: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-95,
			-92,
			-80
		],
		Tcommaaccentoacute: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-95,
			-92,
			-80
		],
		Tcommaaccentocircumflex: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-95,
			-92,
			-80
		],
		Tcommaaccentodieresis: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-95,
			-92,
			-80
		],
		Tcommaaccentograve: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-95,
			-92,
			-80
		],
		Tcommaaccentohungarumlaut: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-95,
			-92,
			-80
		],
		Tcommaaccentomacron: [
			-80,
			-80,
			-60,
			-60,
			-92,
			-95,
			-92,
			-80
		],
		Tcommaaccentoslash: [
			-80,
			-80,
			-120,
			-120,
			-92,
			-95,
			-92,
			-80
		],
		Tcommaaccentotilde: [
			-80,
			-80,
			-60,
			-60,
			-92,
			-95,
			-92,
			-80
		],
		Tcommaaccentperiod: [
			-80,
			-80,
			-120,
			-120,
			-90,
			-92,
			-74,
			-74
		],
		Tcommaaccentr: [
			-80,
			-80,
			-120,
			-120,
			-74,
			-37,
			-55,
			-35
		],
		Tcommaaccentracute: [
			-80,
			-80,
			-120,
			-120,
			-74,
			-37,
			-55,
			-35
		],
		Tcommaaccentrcommaaccent: [
			-80,
			-80,
			-120,
			-120,
			-74,
			-37,
			-55,
			-35
		],
		Tcommaaccentsemicolon: [
			-40,
			-40,
			-20,
			-20,
			-74,
			-74,
			-65,
			-55
		],
		Tcommaaccentu: [
			-90,
			-90,
			-120,
			-120,
			-92,
			-37,
			-55,
			-45
		],
		Tcommaaccentuacute: [
			-90,
			-90,
			-120,
			-120,
			-92,
			-37,
			-55,
			-45
		],
		Tcommaaccentucircumflex: [
			-90,
			-90,
			-120,
			-120,
			-92,
			-37,
			-55,
			-45
		],
		Tcommaaccentudieresis: [
			-90,
			-90,
			-120,
			-120,
			-92,
			-37,
			-55,
			-45
		],
		Tcommaaccentugrave: [
			-90,
			-90,
			-120,
			-120,
			-92,
			-37,
			-55,
			-45
		],
		Tcommaaccentuhungarumlaut: [
			-90,
			-90,
			-120,
			-120,
			-92,
			-37,
			-55,
			-45
		],
		Tcommaaccentumacron: [
			-90,
			-90,
			-60,
			-60,
			-92,
			-37,
			-55,
			-45
		],
		Tcommaaccentuogonek: [
			-90,
			-90,
			-120,
			-120,
			-92,
			-37,
			-55,
			-45
		],
		Tcommaaccenturing: [
			-90,
			-90,
			-120,
			-120,
			-92,
			-37,
			-55,
			-45
		],
		Tcommaaccentw: [
			-60,
			-60,
			-120,
			-120,
			-74,
			-37,
			-74,
			-80
		],
		Tcommaaccenty: [
			-60,
			-60,
			-120,
			-120,
			-34,
			-37,
			-74,
			-80
		],
		Tcommaaccentyacute: [
			-60,
			-60,
			-120,
			-120,
			-34,
			-37,
			-74,
			-80
		],
		Tcommaaccentydieresis: [
			-60,
			-60,
			-60,
			-60,
			-34,
			-37,
			-34,
			-80
		],
		UA: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UAacute: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UAbreve: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UAcircumflex: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UAdieresis: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UAgrave: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UAmacron: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UAogonek: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UAring: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UAtilde: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		Ucomma: [
			-30,
			-30,
			-40,
			-40,
			-50,
			0,
			-25
		],
		Uperiod: [
			-30,
			-30,
			-40,
			-40,
			-50,
			0,
			-25
		],
		UacuteA: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UacuteAacute: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UacuteAbreve: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UacuteAcircumflex: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UacuteAdieresis: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UacuteAgrave: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UacuteAmacron: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UacuteAogonek: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UacuteAring: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UacuteAtilde: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		Uacutecomma: [
			-30,
			-30,
			-40,
			-40,
			-50,
			0,
			-25
		],
		Uacuteperiod: [
			-30,
			-30,
			-40,
			-40,
			-50,
			0,
			-25
		],
		UcircumflexA: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UcircumflexAacute: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UcircumflexAbreve: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UcircumflexAcircumflex: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UcircumflexAdieresis: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UcircumflexAgrave: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UcircumflexAmacron: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UcircumflexAogonek: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UcircumflexAring: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UcircumflexAtilde: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		Ucircumflexcomma: [
			-30,
			-30,
			-40,
			-40,
			-50,
			0,
			-25
		],
		Ucircumflexperiod: [
			-30,
			-30,
			-40,
			-40,
			-50,
			0,
			-25
		],
		UdieresisA: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UdieresisAacute: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UdieresisAbreve: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UdieresisAcircumflex: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UdieresisAdieresis: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UdieresisAgrave: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UdieresisAmacron: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UdieresisAogonek: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UdieresisAring: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UdieresisAtilde: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		Udieresiscomma: [
			-30,
			-30,
			-40,
			-40,
			-50,
			0,
			-25
		],
		Udieresisperiod: [
			-30,
			-30,
			-40,
			-40,
			-50,
			0,
			-25
		],
		UgraveA: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UgraveAacute: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UgraveAbreve: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UgraveAcircumflex: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UgraveAdieresis: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UgraveAgrave: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UgraveAmacron: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UgraveAogonek: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UgraveAring: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UgraveAtilde: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		Ugravecomma: [
			-30,
			-30,
			-40,
			-40,
			-50,
			0,
			-25
		],
		Ugraveperiod: [
			-30,
			-30,
			-40,
			-40,
			-50,
			0,
			-25
		],
		UhungarumlautA: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UhungarumlautAacute: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UhungarumlautAbreve: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UhungarumlautAcircumflex: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UhungarumlautAdieresis: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UhungarumlautAgrave: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UhungarumlautAmacron: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UhungarumlautAogonek: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UhungarumlautAring: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UhungarumlautAtilde: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		Uhungarumlautcomma: [
			-30,
			-30,
			-40,
			-40,
			-50,
			0,
			-25
		],
		Uhungarumlautperiod: [
			-30,
			-30,
			-40,
			-40,
			-50,
			0,
			-25
		],
		UmacronA: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UmacronAacute: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UmacronAbreve: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UmacronAcircumflex: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UmacronAdieresis: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UmacronAgrave: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UmacronAmacron: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UmacronAogonek: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UmacronAring: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UmacronAtilde: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		Umacroncomma: [
			-30,
			-30,
			-40,
			-40,
			-50,
			0,
			-25
		],
		Umacronperiod: [
			-30,
			-30,
			-40,
			-40,
			-50,
			0,
			-25
		],
		UogonekA: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UogonekAacute: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UogonekAbreve: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UogonekAcircumflex: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UogonekAdieresis: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UogonekAgrave: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UogonekAmacron: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UogonekAogonek: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UogonekAring: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UogonekAtilde: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		Uogonekcomma: [
			-30,
			-30,
			-40,
			-40,
			-50,
			0,
			-25
		],
		Uogonekperiod: [
			-30,
			-30,
			-40,
			-40,
			-50,
			0,
			-25
		],
		UringA: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UringAacute: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UringAbreve: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UringAcircumflex: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UringAdieresis: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UringAgrave: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UringAmacron: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UringAogonek: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UringAring: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		UringAtilde: [
			-50,
			-50,
			-40,
			-40,
			-60,
			-45,
			-40,
			-40
		],
		Uringcomma: [
			-30,
			-30,
			-40,
			-40,
			-50,
			0,
			-25
		],
		Uringperiod: [
			-30,
			-30,
			-40,
			-40,
			-50,
			0,
			-25
		],
		VA: [
			-80,
			-80,
			-80,
			-80,
			-135,
			-85,
			-60,
			-135
		],
		VAacute: [
			-80,
			-80,
			-80,
			-80,
			-135,
			-85,
			-60,
			-135
		],
		VAbreve: [
			-80,
			-80,
			-80,
			-80,
			-135,
			-85,
			-60,
			-135
		],
		VAcircumflex: [
			-80,
			-80,
			-80,
			-80,
			-135,
			-85,
			-60,
			-135
		],
		VAdieresis: [
			-80,
			-80,
			-80,
			-80,
			-135,
			-85,
			-60,
			-135
		],
		VAgrave: [
			-80,
			-80,
			-80,
			-80,
			-135,
			-85,
			-60,
			-135
		],
		VAmacron: [
			-80,
			-80,
			-80,
			-80,
			-135,
			-85,
			-60,
			-135
		],
		VAogonek: [
			-80,
			-80,
			-80,
			-80,
			-135,
			-85,
			-60,
			-135
		],
		VAring: [
			-80,
			-80,
			-80,
			-80,
			-135,
			-85,
			-60,
			-135
		],
		VAtilde: [
			-80,
			-80,
			-80,
			-80,
			-135,
			-85,
			-60,
			-135
		],
		VG: [
			-50,
			-50,
			-40,
			-40,
			-30,
			-10,
			0,
			-15
		],
		VGbreve: [
			-50,
			-50,
			-40,
			-40,
			-30,
			-10,
			0,
			-15
		],
		VGcommaaccent: [
			-50,
			-50,
			-40,
			-40,
			-30,
			-10,
			0,
			-15
		],
		VO: [
			-50,
			-50,
			-40,
			-40,
			-45,
			-30,
			-30,
			-40
		],
		VOacute: [
			-50,
			-50,
			-40,
			-40,
			-45,
			-30,
			-30,
			-40
		],
		VOcircumflex: [
			-50,
			-50,
			-40,
			-40,
			-45,
			-30,
			-30,
			-40
		],
		VOdieresis: [
			-50,
			-50,
			-40,
			-40,
			-45,
			-30,
			-30,
			-40
		],
		VOgrave: [
			-50,
			-50,
			-40,
			-40,
			-45,
			-30,
			-30,
			-40
		],
		VOhungarumlaut: [
			-50,
			-50,
			-40,
			-40,
			-45,
			-30,
			-30,
			-40
		],
		VOmacron: [
			-50,
			-50,
			-40,
			-40,
			-45,
			-30,
			-30,
			-40
		],
		VOslash: [
			-50,
			-50,
			-40,
			-40,
			-45,
			-30,
			-30,
			-40
		],
		VOtilde: [
			-50,
			-50,
			-40,
			-40,
			-45,
			-30,
			-30,
			-40
		],
		Va: [
			-60,
			-60,
			-70,
			-70,
			-92,
			-111,
			-111,
			-111
		],
		Vaacute: [
			-60,
			-60,
			-70,
			-70,
			-92,
			-111,
			-111,
			-111
		],
		Vabreve: [
			-60,
			-60,
			-70,
			-70,
			-92,
			-111,
			-111,
			-111
		],
		Vacircumflex: [
			-60,
			-60,
			-70,
			-70,
			-92,
			-111,
			-111,
			-71
		],
		Vadieresis: [
			-60,
			-60,
			-70,
			-70,
			-92,
			-111,
			-111,
			-71
		],
		Vagrave: [
			-60,
			-60,
			-70,
			-70,
			-92,
			-111,
			-111,
			-71
		],
		Vamacron: [
			-60,
			-60,
			-70,
			-70,
			-92,
			-111,
			-111,
			-71
		],
		Vaogonek: [
			-60,
			-60,
			-70,
			-70,
			-92,
			-111,
			-111,
			-111
		],
		Varing: [
			-60,
			-60,
			-70,
			-70,
			-92,
			-111,
			-111,
			-111
		],
		Vatilde: [
			-60,
			-60,
			-70,
			-70,
			-92,
			-111,
			-111,
			-71
		],
		Vcolon: [
			-40,
			-40,
			-40,
			-40,
			-92,
			-74,
			-65,
			-74
		],
		Vcomma: [
			-120,
			-120,
			-125,
			-125,
			-129,
			-129,
			-129,
			-129
		],
		Ve: [
			-50,
			-50,
			-80,
			-80,
			-100,
			-111,
			-111,
			-111
		],
		Veacute: [
			-50,
			-50,
			-80,
			-80,
			-100,
			-111,
			-111,
			-111
		],
		Vecaron: [
			-50,
			-50,
			-80,
			-80,
			-100,
			-111,
			-111,
			-71
		],
		Vecircumflex: [
			-50,
			-50,
			-80,
			-80,
			-100,
			-111,
			-111,
			-71
		],
		Vedieresis: [
			-50,
			-50,
			-80,
			-80,
			-100,
			-71,
			-71,
			-71
		],
		Vedotaccent: [
			-50,
			-50,
			-80,
			-80,
			-100,
			-111,
			-111,
			-111
		],
		Vegrave: [
			-50,
			-50,
			-80,
			-80,
			-100,
			-71,
			-71,
			-71
		],
		Vemacron: [
			-50,
			-50,
			-80,
			-80,
			-100,
			-71,
			-71,
			-71
		],
		Veogonek: [
			-50,
			-50,
			-80,
			-80,
			-100,
			-111,
			-111,
			-111
		],
		Vhyphen: [
			-80,
			-80,
			-80,
			-80,
			-74,
			-70,
			-55,
			-100
		],
		Vo: [
			-90,
			-90,
			-80,
			-80,
			-100,
			-111,
			-111,
			-129
		],
		Voacute: [
			-90,
			-90,
			-80,
			-80,
			-100,
			-111,
			-111,
			-129
		],
		Vocircumflex: [
			-90,
			-90,
			-80,
			-80,
			-100,
			-111,
			-111,
			-129
		],
		Vodieresis: [
			-90,
			-90,
			-80,
			-80,
			-100,
			-111,
			-111,
			-89
		],
		Vograve: [
			-90,
			-90,
			-80,
			-80,
			-100,
			-111,
			-111,
			-89
		],
		Vohungarumlaut: [
			-90,
			-90,
			-80,
			-80,
			-100,
			-111,
			-111,
			-129
		],
		Vomacron: [
			-90,
			-90,
			-80,
			-80,
			-100,
			-111,
			-111,
			-89
		],
		Voslash: [
			-90,
			-90,
			-80,
			-80,
			-100,
			-111,
			-111,
			-129
		],
		Votilde: [
			-90,
			-90,
			-80,
			-80,
			-100,
			-111,
			-111,
			-89
		],
		Vperiod: [
			-120,
			-120,
			-125,
			-125,
			-145,
			-129,
			-129,
			-129
		],
		Vsemicolon: [
			-40,
			-40,
			-40,
			-40,
			-92,
			-74,
			-74,
			-74
		],
		Vu: [
			-60,
			-60,
			-70,
			-70,
			-92,
			-55,
			-74,
			-75
		],
		Vuacute: [
			-60,
			-60,
			-70,
			-70,
			-92,
			-55,
			-74,
			-75
		],
		Vucircumflex: [
			-60,
			-60,
			-70,
			-70,
			-92,
			-55,
			-74,
			-75
		],
		Vudieresis: [
			-60,
			-60,
			-70,
			-70,
			-92,
			-55,
			-74,
			-75
		],
		Vugrave: [
			-60,
			-60,
			-70,
			-70,
			-92,
			-55,
			-74,
			-75
		],
		Vuhungarumlaut: [
			-60,
			-60,
			-70,
			-70,
			-92,
			-55,
			-74,
			-75
		],
		Vumacron: [
			-60,
			-60,
			-70,
			-70,
			-92,
			-55,
			-74,
			-75
		],
		Vuogonek: [
			-60,
			-60,
			-70,
			-70,
			-92,
			-55,
			-74,
			-75
		],
		Vuring: [
			-60,
			-60,
			-70,
			-70,
			-92,
			-55,
			-74,
			-75
		],
		WA: [
			-60,
			-60,
			-50,
			-50,
			-120,
			-74,
			-60,
			-120
		],
		WAacute: [
			-60,
			-60,
			-50,
			-50,
			-120,
			-74,
			-60,
			-120
		],
		WAbreve: [
			-60,
			-60,
			-50,
			-50,
			-120,
			-74,
			-60,
			-120
		],
		WAcircumflex: [
			-60,
			-60,
			-50,
			-50,
			-120,
			-74,
			-60,
			-120
		],
		WAdieresis: [
			-60,
			-60,
			-50,
			-50,
			-120,
			-74,
			-60,
			-120
		],
		WAgrave: [
			-60,
			-60,
			-50,
			-50,
			-120,
			-74,
			-60,
			-120
		],
		WAmacron: [
			-60,
			-60,
			-50,
			-50,
			-120,
			-74,
			-60,
			-120
		],
		WAogonek: [
			-60,
			-60,
			-50,
			-50,
			-120,
			-74,
			-60,
			-120
		],
		WAring: [
			-60,
			-60,
			-50,
			-50,
			-120,
			-74,
			-60,
			-120
		],
		WAtilde: [
			-60,
			-60,
			-50,
			-50,
			-120,
			-74,
			-60,
			-120
		],
		WO: [
			-20,
			-20,
			-20,
			-20,
			-10,
			-15,
			-25,
			-10
		],
		WOacute: [
			-20,
			-20,
			-20,
			-20,
			-10,
			-15,
			-25,
			-10
		],
		WOcircumflex: [
			-20,
			-20,
			-20,
			-20,
			-10,
			-15,
			-25,
			-10
		],
		WOdieresis: [
			-20,
			-20,
			-20,
			-20,
			-10,
			-15,
			-25,
			-10
		],
		WOgrave: [
			-20,
			-20,
			-20,
			-20,
			-10,
			-15,
			-25,
			-10
		],
		WOhungarumlaut: [
			-20,
			-20,
			-20,
			-20,
			-10,
			-15,
			-25,
			-10
		],
		WOmacron: [
			-20,
			-20,
			-20,
			-20,
			-10,
			-15,
			-25,
			-10
		],
		WOslash: [
			-20,
			-20,
			-20,
			-20,
			-10,
			-15,
			-25,
			-10
		],
		WOtilde: [
			-20,
			-20,
			-20,
			-20,
			-10,
			-15,
			-25,
			-10
		],
		Wa: [
			-40,
			-40,
			-40,
			-40,
			-65,
			-85,
			-92,
			-80
		],
		Waacute: [
			-40,
			-40,
			-40,
			-40,
			-65,
			-85,
			-92,
			-80
		],
		Wabreve: [
			-40,
			-40,
			-40,
			-40,
			-65,
			-85,
			-92,
			-80
		],
		Wacircumflex: [
			-40,
			-40,
			-40,
			-40,
			-65,
			-85,
			-92,
			-80
		],
		Wadieresis: [
			-40,
			-40,
			-40,
			-40,
			-65,
			-85,
			-92,
			-80
		],
		Wagrave: [
			-40,
			-40,
			-40,
			-40,
			-65,
			-85,
			-92,
			-80
		],
		Wamacron: [
			-40,
			-40,
			-40,
			-40,
			-65,
			-85,
			-92,
			-80
		],
		Waogonek: [
			-40,
			-40,
			-40,
			-40,
			-65,
			-85,
			-92,
			-80
		],
		Waring: [
			-40,
			-40,
			-40,
			-40,
			-65,
			-85,
			-92,
			-80
		],
		Watilde: [
			-40,
			-40,
			-40,
			-40,
			-65,
			-85,
			-92,
			-80
		],
		Wcolon: [
			-10,
			-10,
			0,
			0,
			-55,
			-55,
			-65,
			-37
		],
		Wcomma: [
			-80,
			-80,
			-80,
			-80,
			-92,
			-74,
			-92,
			-92
		],
		We: [
			-35,
			-35,
			-30,
			-30,
			-65,
			-90,
			-92,
			-80
		],
		Weacute: [
			-35,
			-35,
			-30,
			-30,
			-65,
			-90,
			-92,
			-80
		],
		Wecaron: [
			-35,
			-35,
			-30,
			-30,
			-65,
			-90,
			-92,
			-80
		],
		Wecircumflex: [
			-35,
			-35,
			-30,
			-30,
			-65,
			-90,
			-92,
			-80
		],
		Wedieresis: [
			-35,
			-35,
			-30,
			-30,
			-65,
			-50,
			-52,
			-40
		],
		Wedotaccent: [
			-35,
			-35,
			-30,
			-30,
			-65,
			-90,
			-92,
			-80
		],
		Wegrave: [
			-35,
			-35,
			-30,
			-30,
			-65,
			-50,
			-52,
			-40
		],
		Wemacron: [
			-35,
			-35,
			-30,
			-30,
			-65,
			-50,
			-52,
			-40
		],
		Weogonek: [
			-35,
			-35,
			-30,
			-30,
			-65,
			-90,
			-92,
			-80
		],
		Whyphen: [
			-40,
			-40,
			-40,
			-40,
			-37,
			-50,
			-37,
			-65
		],
		Wo: [
			-60,
			-60,
			-30,
			-30,
			-75,
			-80,
			-92,
			-80
		],
		Woacute: [
			-60,
			-60,
			-30,
			-30,
			-75,
			-80,
			-92,
			-80
		],
		Wocircumflex: [
			-60,
			-60,
			-30,
			-30,
			-75,
			-80,
			-92,
			-80
		],
		Wodieresis: [
			-60,
			-60,
			-30,
			-30,
			-75,
			-80,
			-92,
			-80
		],
		Wograve: [
			-60,
			-60,
			-30,
			-30,
			-75,
			-80,
			-92,
			-80
		],
		Wohungarumlaut: [
			-60,
			-60,
			-30,
			-30,
			-75,
			-80,
			-92,
			-80
		],
		Womacron: [
			-60,
			-60,
			-30,
			-30,
			-75,
			-80,
			-92,
			-80
		],
		Woslash: [
			-60,
			-60,
			-30,
			-30,
			-75,
			-80,
			-92,
			-80
		],
		Wotilde: [
			-60,
			-60,
			-30,
			-30,
			-75,
			-80,
			-92,
			-80
		],
		Wperiod: [
			-80,
			-80,
			-80,
			-80,
			-92,
			-74,
			-92,
			-92
		],
		Wsemicolon: [
			-10,
			-10,
			0,
			0,
			-55,
			-55,
			-65,
			-37
		],
		Wu: [
			-45,
			-45,
			-30,
			-30,
			-50,
			-55,
			-55,
			-50
		],
		Wuacute: [
			-45,
			-45,
			-30,
			-30,
			-50,
			-55,
			-55,
			-50
		],
		Wucircumflex: [
			-45,
			-45,
			-30,
			-30,
			-50,
			-55,
			-55,
			-50
		],
		Wudieresis: [
			-45,
			-45,
			-30,
			-30,
			-50,
			-55,
			-55,
			-50
		],
		Wugrave: [
			-45,
			-45,
			-30,
			-30,
			-50,
			-55,
			-55,
			-50
		],
		Wuhungarumlaut: [
			-45,
			-45,
			-30,
			-30,
			-50,
			-55,
			-55,
			-50
		],
		Wumacron: [
			-45,
			-45,
			-30,
			-30,
			-50,
			-55,
			-55,
			-50
		],
		Wuogonek: [
			-45,
			-45,
			-30,
			-30,
			-50,
			-55,
			-55,
			-50
		],
		Wuring: [
			-45,
			-45,
			-30,
			-30,
			-50,
			-55,
			-55,
			-50
		],
		Wy: [
			-20,
			-20,
			-20,
			-20,
			-60,
			-55,
			-70,
			-73
		],
		Wyacute: [
			-20,
			-20,
			-20,
			-20,
			-60,
			-55,
			-70,
			-73
		],
		Wydieresis: [
			-20,
			-20,
			-20,
			-20,
			-60,
			-55,
			-70,
			-73
		],
		YA: [
			-110,
			-110,
			-110,
			-110,
			-110,
			-74,
			-50,
			-120
		],
		YAacute: [
			-110,
			-110,
			-110,
			-110,
			-110,
			-74,
			-50,
			-120
		],
		YAbreve: [
			-110,
			-110,
			-110,
			-110,
			-110,
			-74,
			-50,
			-120
		],
		YAcircumflex: [
			-110,
			-110,
			-110,
			-110,
			-110,
			-74,
			-50,
			-120
		],
		YAdieresis: [
			-110,
			-110,
			-110,
			-110,
			-110,
			-74,
			-50,
			-120
		],
		YAgrave: [
			-110,
			-110,
			-110,
			-110,
			-110,
			-74,
			-50,
			-120
		],
		YAmacron: [
			-110,
			-110,
			-110,
			-110,
			-110,
			-74,
			-50,
			-120
		],
		YAogonek: [
			-110,
			-110,
			-110,
			-110,
			-110,
			-74,
			-50,
			-120
		],
		YAring: [
			-110,
			-110,
			-110,
			-110,
			-110,
			-74,
			-50,
			-120
		],
		YAtilde: [
			-110,
			-110,
			-110,
			-110,
			-110,
			-74,
			-50,
			-120
		],
		YO: [
			-70,
			-70,
			-85,
			-85,
			-35,
			-25,
			-15,
			-30
		],
		YOacute: [
			-70,
			-70,
			-85,
			-85,
			-35,
			-25,
			-15,
			-30
		],
		YOcircumflex: [
			-70,
			-70,
			-85,
			-85,
			-35,
			-25,
			-15,
			-30
		],
		YOdieresis: [
			-70,
			-70,
			-85,
			-85,
			-35,
			-25,
			-15,
			-30
		],
		YOgrave: [
			-70,
			-70,
			-85,
			-85,
			-35,
			-25,
			-15,
			-30
		],
		YOhungarumlaut: [
			-70,
			-70,
			-85,
			-85,
			-35,
			-25,
			-15,
			-30
		],
		YOmacron: [
			-70,
			-70,
			-85,
			-85,
			-35,
			-25,
			-15,
			-30
		],
		YOslash: [
			-70,
			-70,
			-85,
			-85,
			-35,
			-25,
			-15,
			-30
		],
		YOtilde: [
			-70,
			-70,
			-85,
			-85,
			-35,
			-25,
			-15,
			-30
		],
		Ya: [
			-90,
			-90,
			-140,
			-140,
			-85,
			-92,
			-92,
			-100
		],
		Yaacute: [
			-90,
			-90,
			-140,
			-140,
			-85,
			-92,
			-92,
			-100
		],
		Yabreve: [
			-90,
			-90,
			-70,
			-70,
			-85,
			-92,
			-92,
			-100
		],
		Yacircumflex: [
			-90,
			-90,
			-140,
			-140,
			-85,
			-92,
			-92,
			-100
		],
		Yadieresis: [
			-90,
			-90,
			-140,
			-140,
			-85,
			-92,
			-92,
			-60
		],
		Yagrave: [
			-90,
			-90,
			-140,
			-140,
			-85,
			-92,
			-92,
			-60
		],
		Yamacron: [
			-90,
			-90,
			-70,
			-70,
			-85,
			-92,
			-92,
			-60
		],
		Yaogonek: [
			-90,
			-90,
			-140,
			-140,
			-85,
			-92,
			-92,
			-100
		],
		Yaring: [
			-90,
			-90,
			-140,
			-140,
			-85,
			-92,
			-92,
			-100
		],
		Yatilde: [
			-90,
			-90,
			-140,
			-140,
			-85,
			-92,
			-92,
			-60
		],
		Ycolon: [
			-50,
			-50,
			-60,
			-60,
			-92,
			-92,
			-65,
			-92
		],
		Ycomma: [
			-100,
			-100,
			-140,
			-140,
			-92,
			-92,
			-92,
			-129
		],
		Ye: [
			-80,
			-80,
			-140,
			-140,
			-111,
			-111,
			-92,
			-100
		],
		Yeacute: [
			-80,
			-80,
			-140,
			-140,
			-111,
			-111,
			-92,
			-100
		],
		Yecaron: [
			-80,
			-80,
			-140,
			-140,
			-111,
			-111,
			-92,
			-100
		],
		Yecircumflex: [
			-80,
			-80,
			-140,
			-140,
			-111,
			-71,
			-92,
			-100
		],
		Yedieresis: [
			-80,
			-80,
			-140,
			-140,
			-71,
			-71,
			-52,
			-60
		],
		Yedotaccent: [
			-80,
			-80,
			-140,
			-140,
			-111,
			-111,
			-92,
			-100
		],
		Yegrave: [
			-80,
			-80,
			-140,
			-140,
			-71,
			-71,
			-52,
			-60
		],
		Yemacron: [
			-80,
			-80,
			-70,
			-70,
			-71,
			-71,
			-52,
			-60
		],
		Yeogonek: [
			-80,
			-80,
			-140,
			-140,
			-111,
			-111,
			-92,
			-100
		],
		Yo: [
			-100,
			-100,
			-140,
			-140,
			-111,
			-111,
			-92,
			-110
		],
		Yoacute: [
			-100,
			-100,
			-140,
			-140,
			-111,
			-111,
			-92,
			-110
		],
		Yocircumflex: [
			-100,
			-100,
			-140,
			-140,
			-111,
			-111,
			-92,
			-110
		],
		Yodieresis: [
			-100,
			-100,
			-140,
			-140,
			-111,
			-111,
			-92,
			-70
		],
		Yograve: [
			-100,
			-100,
			-140,
			-140,
			-111,
			-111,
			-92,
			-70
		],
		Yohungarumlaut: [
			-100,
			-100,
			-140,
			-140,
			-111,
			-111,
			-92,
			-110
		],
		Yomacron: [
			-100,
			-100,
			-140,
			-140,
			-111,
			-111,
			-92,
			-70
		],
		Yoslash: [
			-100,
			-100,
			-140,
			-140,
			-111,
			-111,
			-92,
			-110
		],
		Yotilde: [
			-100,
			-100,
			-140,
			-140,
			-111,
			-111,
			-92,
			-70
		],
		Yperiod: [
			-100,
			-100,
			-140,
			-140,
			-92,
			-74,
			-92,
			-129
		],
		Ysemicolon: [
			-50,
			-50,
			-60,
			-60,
			-92,
			-92,
			-65,
			-92
		],
		Yu: [
			-100,
			-100,
			-110,
			-110,
			-92,
			-92,
			-92,
			-111
		],
		Yuacute: [
			-100,
			-100,
			-110,
			-110,
			-92,
			-92,
			-92,
			-111
		],
		Yucircumflex: [
			-100,
			-100,
			-110,
			-110,
			-92,
			-92,
			-92,
			-111
		],
		Yudieresis: [
			-100,
			-100,
			-110,
			-110,
			-92,
			-92,
			-92,
			-71
		],
		Yugrave: [
			-100,
			-100,
			-110,
			-110,
			-92,
			-92,
			-92,
			-71
		],
		Yuhungarumlaut: [
			-100,
			-100,
			-110,
			-110,
			-92,
			-92,
			-92,
			-111
		],
		Yumacron: [
			-100,
			-100,
			-110,
			-110,
			-92,
			-92,
			-92,
			-71
		],
		Yuogonek: [
			-100,
			-100,
			-110,
			-110,
			-92,
			-92,
			-92,
			-111
		],
		Yuring: [
			-100,
			-100,
			-110,
			-110,
			-92,
			-92,
			-92,
			-111
		],
		YacuteA: [
			-110,
			-110,
			-110,
			-110,
			-110,
			-74,
			-50,
			-120
		],
		YacuteAacute: [
			-110,
			-110,
			-110,
			-110,
			-110,
			-74,
			-50,
			-120
		],
		YacuteAbreve: [
			-110,
			-110,
			-110,
			-110,
			-110,
			-74,
			-50,
			-120
		],
		YacuteAcircumflex: [
			-110,
			-110,
			-110,
			-110,
			-110,
			-74,
			-50,
			-120
		],
		YacuteAdieresis: [
			-110,
			-110,
			-110,
			-110,
			-110,
			-74,
			-50,
			-120
		],
		YacuteAgrave: [
			-110,
			-110,
			-110,
			-110,
			-110,
			-74,
			-50,
			-120
		],
		YacuteAmacron: [
			-110,
			-110,
			-110,
			-110,
			-110,
			-74,
			-50,
			-120
		],
		YacuteAogonek: [
			-110,
			-110,
			-110,
			-110,
			-110,
			-74,
			-50,
			-120
		],
		YacuteAring: [
			-110,
			-110,
			-110,
			-110,
			-110,
			-74,
			-50,
			-120
		],
		YacuteAtilde: [
			-110,
			-110,
			-110,
			-110,
			-110,
			-74,
			-50,
			-120
		],
		YacuteO: [
			-70,
			-70,
			-85,
			-85,
			-35,
			-25,
			-15,
			-30
		],
		YacuteOacute: [
			-70,
			-70,
			-85,
			-85,
			-35,
			-25,
			-15,
			-30
		],
		YacuteOcircumflex: [
			-70,
			-70,
			-85,
			-85,
			-35,
			-25,
			-15,
			-30
		],
		YacuteOdieresis: [
			-70,
			-70,
			-85,
			-85,
			-35,
			-25,
			-15,
			-30
		],
		YacuteOgrave: [
			-70,
			-70,
			-85,
			-85,
			-35,
			-25,
			-15,
			-30
		],
		YacuteOhungarumlaut: [
			-70,
			-70,
			-85,
			-85,
			-35,
			-25,
			-15,
			-30
		],
		YacuteOmacron: [
			-70,
			-70,
			-85,
			-85,
			-35,
			-25,
			-15,
			-30
		],
		YacuteOslash: [
			-70,
			-70,
			-85,
			-85,
			-35,
			-25,
			-15,
			-30
		],
		YacuteOtilde: [
			-70,
			-70,
			-85,
			-85,
			-35,
			-25,
			-15,
			-30
		],
		Yacutea: [
			-90,
			-90,
			-140,
			-140,
			-85,
			-92,
			-92,
			-100
		],
		Yacuteaacute: [
			-90,
			-90,
			-140,
			-140,
			-85,
			-92,
			-92,
			-100
		],
		Yacuteabreve: [
			-90,
			-90,
			-70,
			-70,
			-85,
			-92,
			-92,
			-100
		],
		Yacuteacircumflex: [
			-90,
			-90,
			-140,
			-140,
			-85,
			-92,
			-92,
			-100
		],
		Yacuteadieresis: [
			-90,
			-90,
			-140,
			-140,
			-85,
			-92,
			-92,
			-60
		],
		Yacuteagrave: [
			-90,
			-90,
			-140,
			-140,
			-85,
			-92,
			-92,
			-60
		],
		Yacuteamacron: [
			-90,
			-90,
			-70,
			-70,
			-85,
			-92,
			-92,
			-60
		],
		Yacuteaogonek: [
			-90,
			-90,
			-140,
			-140,
			-85,
			-92,
			-92,
			-100
		],
		Yacutearing: [
			-90,
			-90,
			-140,
			-140,
			-85,
			-92,
			-92,
			-100
		],
		Yacuteatilde: [
			-90,
			-90,
			-70,
			-70,
			-85,
			-92,
			-92,
			-60
		],
		Yacutecolon: [
			-50,
			-50,
			-60,
			-60,
			-92,
			-92,
			-65,
			-92
		],
		Yacutecomma: [
			-100,
			-100,
			-140,
			-140,
			-92,
			-92,
			-92,
			-129
		],
		Yacutee: [
			-80,
			-80,
			-140,
			-140,
			-111,
			-111,
			-92,
			-100
		],
		Yacuteeacute: [
			-80,
			-80,
			-140,
			-140,
			-111,
			-111,
			-92,
			-100
		],
		Yacuteecaron: [
			-80,
			-80,
			-140,
			-140,
			-111,
			-111,
			-92,
			-100
		],
		Yacuteecircumflex: [
			-80,
			-80,
			-140,
			-140,
			-111,
			-71,
			-92,
			-100
		],
		Yacuteedieresis: [
			-80,
			-80,
			-140,
			-140,
			-71,
			-71,
			-52,
			-60
		],
		Yacuteedotaccent: [
			-80,
			-80,
			-140,
			-140,
			-111,
			-111,
			-92,
			-100
		],
		Yacuteegrave: [
			-80,
			-80,
			-140,
			-140,
			-71,
			-71,
			-52,
			-60
		],
		Yacuteemacron: [
			-80,
			-80,
			-70,
			-70,
			-71,
			-71,
			-52,
			-60
		],
		Yacuteeogonek: [
			-80,
			-80,
			-140,
			-140,
			-111,
			-111,
			-92,
			-100
		],
		Yacuteo: [
			-100,
			-100,
			-140,
			-140,
			-111,
			-111,
			-92,
			-110
		],
		Yacuteoacute: [
			-100,
			-100,
			-140,
			-140,
			-111,
			-111,
			-92,
			-110
		],
		Yacuteocircumflex: [
			-100,
			-100,
			-140,
			-140,
			-111,
			-111,
			-92,
			-110
		],
		Yacuteodieresis: [
			-100,
			-100,
			-140,
			-140,
			-111,
			-111,
			-92,
			-70
		],
		Yacuteograve: [
			-100,
			-100,
			-140,
			-140,
			-111,
			-111,
			-92,
			-70
		],
		Yacuteohungarumlaut: [
			-100,
			-100,
			-140,
			-140,
			-111,
			-111,
			-92,
			-110
		],
		Yacuteomacron: [
			-100,
			-100,
			-70,
			-70,
			-111,
			-111,
			-92,
			-70
		],
		Yacuteoslash: [
			-100,
			-100,
			-140,
			-140,
			-111,
			-111,
			-92,
			-110
		],
		Yacuteotilde: [
			-100,
			-100,
			-140,
			-140,
			-111,
			-111,
			-92,
			-70
		],
		Yacuteperiod: [
			-100,
			-100,
			-140,
			-140,
			-92,
			-74,
			-92,
			-129
		],
		Yacutesemicolon: [
			-50,
			-50,
			-60,
			-60,
			-92,
			-92,
			-65,
			-92
		],
		Yacuteu: [
			-100,
			-100,
			-110,
			-110,
			-92,
			-92,
			-92,
			-111
		],
		Yacuteuacute: [
			-100,
			-100,
			-110,
			-110,
			-92,
			-92,
			-92,
			-111
		],
		Yacuteucircumflex: [
			-100,
			-100,
			-110,
			-110,
			-92,
			-92,
			-92,
			-111
		],
		Yacuteudieresis: [
			-100,
			-100,
			-110,
			-110,
			-92,
			-92,
			-92,
			-71
		],
		Yacuteugrave: [
			-100,
			-100,
			-110,
			-110,
			-92,
			-92,
			-92,
			-71
		],
		Yacuteuhungarumlaut: [
			-100,
			-100,
			-110,
			-110,
			-92,
			-92,
			-92,
			-111
		],
		Yacuteumacron: [
			-100,
			-100,
			-110,
			-110,
			-92,
			-92,
			-92,
			-71
		],
		Yacuteuogonek: [
			-100,
			-100,
			-110,
			-110,
			-92,
			-92,
			-92,
			-111
		],
		Yacuteuring: [
			-100,
			-100,
			-110,
			-110,
			-92,
			-92,
			-92,
			-111
		],
		YdieresisA: [
			-110,
			-110,
			-110,
			-110,
			-110,
			-74,
			-50,
			-120
		],
		YdieresisAacute: [
			-110,
			-110,
			-110,
			-110,
			-110,
			-74,
			-50,
			-120
		],
		YdieresisAbreve: [
			-110,
			-110,
			-110,
			-110,
			-110,
			-74,
			-50,
			-120
		],
		YdieresisAcircumflex: [
			-110,
			-110,
			-110,
			-110,
			-110,
			-74,
			-50,
			-120
		],
		YdieresisAdieresis: [
			-110,
			-110,
			-110,
			-110,
			-110,
			-74,
			-50,
			-120
		],
		YdieresisAgrave: [
			-110,
			-110,
			-110,
			-110,
			-110,
			-74,
			-50,
			-120
		],
		YdieresisAmacron: [
			-110,
			-110,
			-110,
			-110,
			-110,
			-74,
			-50,
			-120
		],
		YdieresisAogonek: [
			-110,
			-110,
			-110,
			-110,
			-110,
			-74,
			-50,
			-120
		],
		YdieresisAring: [
			-110,
			-110,
			-110,
			-110,
			-110,
			-74,
			-50,
			-120
		],
		YdieresisAtilde: [
			-110,
			-110,
			-110,
			-110,
			-110,
			-74,
			-50,
			-120
		],
		YdieresisO: [
			-70,
			-70,
			-85,
			-85,
			-35,
			-25,
			-15,
			-30
		],
		YdieresisOacute: [
			-70,
			-70,
			-85,
			-85,
			-35,
			-25,
			-15,
			-30
		],
		YdieresisOcircumflex: [
			-70,
			-70,
			-85,
			-85,
			-35,
			-25,
			-15,
			-30
		],
		YdieresisOdieresis: [
			-70,
			-70,
			-85,
			-85,
			-35,
			-25,
			-15,
			-30
		],
		YdieresisOgrave: [
			-70,
			-70,
			-85,
			-85,
			-35,
			-25,
			-15,
			-30
		],
		YdieresisOhungarumlaut: [
			-70,
			-70,
			-85,
			-85,
			-35,
			-25,
			-15,
			-30
		],
		YdieresisOmacron: [
			-70,
			-70,
			-85,
			-85,
			-35,
			-25,
			-15,
			-30
		],
		YdieresisOslash: [
			-70,
			-70,
			-85,
			-85,
			-35,
			-25,
			-15,
			-30
		],
		YdieresisOtilde: [
			-70,
			-70,
			-85,
			-85,
			-35,
			-25,
			-15,
			-30
		],
		Ydieresisa: [
			-90,
			-90,
			-140,
			-140,
			-85,
			-92,
			-92,
			-100
		],
		Ydieresisaacute: [
			-90,
			-90,
			-140,
			-140,
			-85,
			-92,
			-92,
			-100
		],
		Ydieresisabreve: [
			-90,
			-90,
			-70,
			-70,
			-85,
			-92,
			-92,
			-100
		],
		Ydieresisacircumflex: [
			-90,
			-90,
			-140,
			-140,
			-85,
			-92,
			-92,
			-100
		],
		Ydieresisadieresis: [
			-90,
			-90,
			-140,
			-140,
			-85,
			-92,
			-92,
			-60
		],
		Ydieresisagrave: [
			-90,
			-90,
			-140,
			-140,
			-85,
			-92,
			-92,
			-60
		],
		Ydieresisamacron: [
			-90,
			-90,
			-70,
			-70,
			-85,
			-92,
			-92,
			-60
		],
		Ydieresisaogonek: [
			-90,
			-90,
			-140,
			-140,
			-85,
			-92,
			-92,
			-100
		],
		Ydieresisaring: [
			-90,
			-90,
			-140,
			-140,
			-85,
			-92,
			-92,
			-100
		],
		Ydieresisatilde: [
			-90,
			-90,
			-70,
			-70,
			-85,
			-92,
			-92,
			-100
		],
		Ydieresiscolon: [
			-50,
			-50,
			-60,
			-60,
			-92,
			-92,
			-65,
			-92
		],
		Ydieresiscomma: [
			-100,
			-100,
			-140,
			-140,
			-92,
			-92,
			-92,
			-129
		],
		Ydieresise: [
			-80,
			-80,
			-140,
			-140,
			-111,
			-111,
			-92,
			-100
		],
		Ydieresiseacute: [
			-80,
			-80,
			-140,
			-140,
			-111,
			-111,
			-92,
			-100
		],
		Ydieresisecaron: [
			-80,
			-80,
			-140,
			-140,
			-111,
			-111,
			-92,
			-100
		],
		Ydieresisecircumflex: [
			-80,
			-80,
			-140,
			-140,
			-111,
			-71,
			-92,
			-100
		],
		Ydieresisedieresis: [
			-80,
			-80,
			-140,
			-140,
			-71,
			-71,
			-52,
			-60
		],
		Ydieresisedotaccent: [
			-80,
			-80,
			-140,
			-140,
			-111,
			-111,
			-92,
			-100
		],
		Ydieresisegrave: [
			-80,
			-80,
			-140,
			-140,
			-71,
			-71,
			-52,
			-60
		],
		Ydieresisemacron: [
			-80,
			-80,
			-70,
			-70,
			-71,
			-71,
			-52,
			-60
		],
		Ydieresiseogonek: [
			-80,
			-80,
			-140,
			-140,
			-111,
			-111,
			-92,
			-100
		],
		Ydieresiso: [
			-100,
			-100,
			-140,
			-140,
			-111,
			-111,
			-92,
			-110
		],
		Ydieresisoacute: [
			-100,
			-100,
			-140,
			-140,
			-111,
			-111,
			-92,
			-110
		],
		Ydieresisocircumflex: [
			-100,
			-100,
			-140,
			-140,
			-111,
			-111,
			-92,
			-110
		],
		Ydieresisodieresis: [
			-100,
			-100,
			-140,
			-140,
			-111,
			-111,
			-92,
			-70
		],
		Ydieresisograve: [
			-100,
			-100,
			-140,
			-140,
			-111,
			-111,
			-92,
			-70
		],
		Ydieresisohungarumlaut: [
			-100,
			-100,
			-140,
			-140,
			-111,
			-111,
			-92,
			-110
		],
		Ydieresisomacron: [
			-100,
			-100,
			-140,
			-140,
			-111,
			-111,
			-92,
			-70
		],
		Ydieresisoslash: [
			-100,
			-100,
			-140,
			-140,
			-111,
			-111,
			-92,
			-110
		],
		Ydieresisotilde: [
			-100,
			-100,
			-140,
			-140,
			-111,
			-111,
			-92,
			-70
		],
		Ydieresisperiod: [
			-100,
			-100,
			-140,
			-140,
			-92,
			-74,
			-92,
			-129
		],
		Ydieresissemicolon: [
			-50,
			-50,
			-60,
			-60,
			-92,
			-92,
			-65,
			-92
		],
		Ydieresisu: [
			-100,
			-100,
			-110,
			-110,
			-92,
			-92,
			-92,
			-111
		],
		Ydieresisuacute: [
			-100,
			-100,
			-110,
			-110,
			-92,
			-92,
			-92,
			-111
		],
		Ydieresisucircumflex: [
			-100,
			-100,
			-110,
			-110,
			-92,
			-92,
			-92,
			-111
		],
		Ydieresisudieresis: [
			-100,
			-100,
			-110,
			-110,
			-92,
			-92,
			-92,
			-71
		],
		Ydieresisugrave: [
			-100,
			-100,
			-110,
			-110,
			-92,
			-92,
			-92,
			-71
		],
		Ydieresisuhungarumlaut: [
			-100,
			-100,
			-110,
			-110,
			-92,
			-92,
			-92,
			-111
		],
		Ydieresisumacron: [
			-100,
			-100,
			-110,
			-110,
			-92,
			-92,
			-92,
			-71
		],
		Ydieresisuogonek: [
			-100,
			-100,
			-110,
			-110,
			-92,
			-92,
			-92,
			-111
		],
		Ydieresisuring: [
			-100,
			-100,
			-110,
			-110,
			-92,
			-92,
			-92,
			-111
		],
		ag: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		agbreve: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		agcommaaccent: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		av: [
			-15,
			-15,
			-20,
			-20,
			-25,
			0,
			0,
			-20
		],
		aw: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			0,
			-15
		],
		ay: [
			-20,
			-20,
			-30,
			-30
		],
		ayacute: [
			-20,
			-20,
			-30,
			-30
		],
		aydieresis: [
			-20,
			-20,
			-30,
			-30
		],
		aacuteg: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		aacutegbreve: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		aacutegcommaaccent: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		aacutev: [
			-15,
			-15,
			-20,
			-20,
			-25,
			0,
			0,
			-20
		],
		aacutew: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			0,
			-15
		],
		aacutey: [
			-20,
			-20,
			-30,
			-30
		],
		aacuteyacute: [
			-20,
			-20,
			-30,
			-30
		],
		aacuteydieresis: [
			-20,
			-20,
			-30,
			-30
		],
		abreveg: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		abrevegbreve: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		abrevegcommaaccent: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		abrevev: [
			-15,
			-15,
			-20,
			-20,
			-25,
			0,
			0,
			-20
		],
		abrevew: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			0,
			-15
		],
		abrevey: [
			-20,
			-20,
			-30,
			-30
		],
		abreveyacute: [
			-20,
			-20,
			-30,
			-30
		],
		abreveydieresis: [
			-20,
			-20,
			-30,
			-30
		],
		acircumflexg: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		acircumflexgbreve: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		acircumflexgcommaaccent: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		acircumflexv: [
			-15,
			-15,
			-20,
			-20,
			-25,
			0,
			0,
			-20
		],
		acircumflexw: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			0,
			-15
		],
		acircumflexy: [
			-20,
			-20,
			-30,
			-30
		],
		acircumflexyacute: [
			-20,
			-20,
			-30,
			-30
		],
		acircumflexydieresis: [
			-20,
			-20,
			-30,
			-30
		],
		adieresisg: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		adieresisgbreve: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		adieresisgcommaaccent: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		adieresisv: [
			-15,
			-15,
			-20,
			-20,
			-25,
			0,
			0,
			-20
		],
		adieresisw: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			0,
			-15
		],
		adieresisy: [
			-20,
			-20,
			-30,
			-30
		],
		adieresisyacute: [
			-20,
			-20,
			-30,
			-30
		],
		adieresisydieresis: [
			-20,
			-20,
			-30,
			-30
		],
		agraveg: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		agravegbreve: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		agravegcommaaccent: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		agravev: [
			-15,
			-15,
			-20,
			-20,
			-25,
			0,
			0,
			-20
		],
		agravew: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			0,
			-15
		],
		agravey: [
			-20,
			-20,
			-30,
			-30
		],
		agraveyacute: [
			-20,
			-20,
			-30,
			-30
		],
		agraveydieresis: [
			-20,
			-20,
			-30,
			-30
		],
		amacrong: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		amacrongbreve: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		amacrongcommaaccent: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		amacronv: [
			-15,
			-15,
			-20,
			-20,
			-25,
			0,
			0,
			-20
		],
		amacronw: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			0,
			-15
		],
		amacrony: [
			-20,
			-20,
			-30,
			-30
		],
		amacronyacute: [
			-20,
			-20,
			-30,
			-30
		],
		amacronydieresis: [
			-20,
			-20,
			-30,
			-30
		],
		aogonekg: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		aogonekgbreve: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		aogonekgcommaaccent: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		aogonekv: [
			-15,
			-15,
			-20,
			-20,
			-25,
			0,
			0,
			-20
		],
		aogonekw: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			0,
			-15
		],
		aogoneky: [
			-20,
			-20,
			-30,
			-30
		],
		aogonekyacute: [
			-20,
			-20,
			-30,
			-30
		],
		aogonekydieresis: [
			-20,
			-20,
			-30,
			-30
		],
		aringg: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		aringgbreve: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		aringgcommaaccent: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		aringv: [
			-15,
			-15,
			-20,
			-20,
			-25,
			0,
			0,
			-20
		],
		aringw: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			0,
			-15
		],
		aringy: [
			-20,
			-20,
			-30,
			-30
		],
		aringyacute: [
			-20,
			-20,
			-30,
			-30
		],
		aringydieresis: [
			-20,
			-20,
			-30,
			-30
		],
		atildeg: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		atildegbreve: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		atildegcommaaccent: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		atildev: [
			-15,
			-15,
			-20,
			-20,
			-25,
			0,
			0,
			-20
		],
		atildew: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			0,
			-15
		],
		atildey: [
			-20,
			-20,
			-30,
			-30
		],
		atildeyacute: [
			-20,
			-20,
			-30,
			-30
		],
		atildeydieresis: [
			-20,
			-20,
			-30,
			-30
		],
		bl: [
			-10,
			-10,
			-20,
			-20
		],
		blacute: [
			-10,
			-10,
			-20,
			-20
		],
		blcommaaccent: [
			-10,
			-10,
			-20,
			-20
		],
		blslash: [
			-10,
			-10,
			-20,
			-20
		],
		bu: [
			-20,
			-20,
			-20,
			-20,
			-20,
			-20,
			-20,
			-20
		],
		buacute: [
			-20,
			-20,
			-20,
			-20,
			-20,
			-20,
			-20,
			-20
		],
		bucircumflex: [
			-20,
			-20,
			-20,
			-20,
			-20,
			-20,
			-20,
			-20
		],
		budieresis: [
			-20,
			-20,
			-20,
			-20,
			-20,
			-20,
			-20,
			-20
		],
		bugrave: [
			-20,
			-20,
			-20,
			-20,
			-20,
			-20,
			-20,
			-20
		],
		buhungarumlaut: [
			-20,
			-20,
			-20,
			-20,
			-20,
			-20,
			-20,
			-20
		],
		bumacron: [
			-20,
			-20,
			-20,
			-20,
			-20,
			-20,
			-20,
			-20
		],
		buogonek: [
			-20,
			-20,
			-20,
			-20,
			-20,
			-20,
			-20,
			-20
		],
		buring: [
			-20,
			-20,
			-20,
			-20,
			-20,
			-20,
			-20,
			-20
		],
		bv: [
			-20,
			-20,
			-20,
			-20,
			-15,
			0,
			0,
			-15
		],
		by: [
			-20,
			-20,
			-20,
			-20
		],
		byacute: [
			-20,
			-20,
			-20,
			-20
		],
		bydieresis: [
			-20,
			-20,
			-20,
			-20
		],
		ch: [
			-10,
			-10,
			0,
			0,
			0,
			-10,
			-15
		],
		ck: [
			-20,
			-20,
			-20,
			-20,
			0,
			-10,
			-20
		],
		ckcommaaccent: [
			-20,
			-20,
			-20,
			-20,
			0,
			-10,
			-20
		],
		cl: [-20, -20],
		clacute: [-20, -20],
		clcommaaccent: [-20, -20],
		clslash: [-20, -20],
		cy: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			0,
			-15
		],
		cyacute: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			0,
			-15
		],
		cydieresis: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			0,
			-15
		],
		cacuteh: [
			-10,
			-10,
			0,
			0,
			0,
			-10,
			-15
		],
		cacutek: [
			-20,
			-20,
			-20,
			-20,
			0,
			-10,
			-20
		],
		cacutekcommaaccent: [
			-20,
			-20,
			-20,
			-20,
			0,
			-10,
			-20
		],
		cacutel: [-20, -20],
		cacutelacute: [-20, -20],
		cacutelcommaaccent: [-20, -20],
		cacutelslash: [-20, -20],
		cacutey: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			0,
			-15
		],
		cacuteyacute: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			0,
			-15
		],
		cacuteydieresis: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			0,
			-15
		],
		ccaronh: [
			-10,
			-10,
			0,
			0,
			0,
			-10,
			-15
		],
		ccaronk: [
			-20,
			-20,
			-20,
			-20,
			0,
			-10,
			-20
		],
		ccaronkcommaaccent: [
			-20,
			-20,
			-20,
			-20,
			0,
			-10,
			-20
		],
		ccaronl: [-20, -20],
		ccaronlacute: [-20, -20],
		ccaronlcommaaccent: [-20, -20],
		ccaronlslash: [-20, -20],
		ccarony: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			0,
			-15
		],
		ccaronyacute: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			0,
			-15
		],
		ccaronydieresis: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			0,
			-15
		],
		ccedillah: [
			-10,
			-10,
			0,
			0,
			0,
			-10,
			-15
		],
		ccedillak: [
			-20,
			-20,
			-20,
			-20,
			0,
			-10,
			-20
		],
		ccedillakcommaaccent: [
			-20,
			-20,
			-20,
			-20,
			0,
			-10,
			-20
		],
		ccedillal: [-20, -20],
		ccedillalacute: [-20, -20],
		ccedillalcommaaccent: [-20, -20],
		ccedillalslash: [-20, -20],
		ccedillay: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			0,
			-15
		],
		ccedillayacute: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			0,
			-15
		],
		ccedillaydieresis: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			0,
			-15
		],
		colonspace: [
			-40,
			-40,
			-50,
			-50
		],
		commaquotedblright: [
			-120,
			-120,
			-100,
			-100,
			-45,
			-95,
			-140,
			-70
		],
		commaquoteright: [
			-120,
			-120,
			-100,
			-100,
			-55,
			-95,
			-140,
			-70
		],
		commaspace: [-40, -40],
		dd: [-10, -10],
		ddcroat: [-10, -10],
		dv: [-15, -15],
		dw: [
			-15,
			-15,
			0,
			0,
			-15
		],
		dy: [-15, -15],
		dyacute: [-15, -15],
		dydieresis: [-15, -15],
		dcroatd: [-10, -10],
		dcroatdcroat: [-10, -10],
		dcroatv: [-15, -15],
		dcroatw: [
			-15,
			-15,
			0,
			0,
			-15
		],
		dcroaty: [-15, -15],
		dcroatyacute: [-15, -15],
		dcroatydieresis: [-15, -15],
		ecomma: [
			10,
			10,
			-15,
			-15,
			0,
			0,
			-10
		],
		eperiod: [
			20,
			20,
			-15,
			-15,
			0,
			0,
			-15
		],
		ev: [
			-15,
			-15,
			-30,
			-30,
			-15,
			0,
			-15,
			-25
		],
		ew: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-15,
			-25
		],
		ex: [
			-15,
			-15,
			-30,
			-30,
			0,
			0,
			-20,
			-15
		],
		ey: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-30,
			-15
		],
		eyacute: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-30,
			-15
		],
		eydieresis: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-30,
			-15
		],
		eacutecomma: [
			10,
			10,
			-15,
			-15,
			0,
			0,
			-10
		],
		eacuteperiod: [
			20,
			20,
			-15,
			-15,
			0,
			0,
			-15
		],
		eacutev: [
			-15,
			-15,
			-30,
			-30,
			-15,
			0,
			-15,
			-25
		],
		eacutew: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-15,
			-25
		],
		eacutex: [
			-15,
			-15,
			-30,
			-30,
			0,
			0,
			-20,
			-15
		],
		eacutey: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-30,
			-15
		],
		eacuteyacute: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-30,
			-15
		],
		eacuteydieresis: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-30,
			-15
		],
		ecaroncomma: [
			10,
			10,
			-15,
			-15,
			0,
			0,
			-10
		],
		ecaronperiod: [
			20,
			20,
			-15,
			-15,
			0,
			0,
			-15
		],
		ecaronv: [
			-15,
			-15,
			-30,
			-30,
			-15,
			0,
			-15,
			-25
		],
		ecaronw: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-15,
			-25
		],
		ecaronx: [
			-15,
			-15,
			-30,
			-30,
			0,
			0,
			-20,
			-15
		],
		ecarony: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-30,
			-15
		],
		ecaronyacute: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-30,
			-15
		],
		ecaronydieresis: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-30,
			-15
		],
		ecircumflexcomma: [
			10,
			10,
			-15,
			-15,
			0,
			0,
			-10
		],
		ecircumflexperiod: [
			20,
			20,
			-15,
			-15,
			0,
			0,
			-15
		],
		ecircumflexv: [
			-15,
			-15,
			-30,
			-30,
			-15,
			0,
			-15,
			-25
		],
		ecircumflexw: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-15,
			-25
		],
		ecircumflexx: [
			-15,
			-15,
			-30,
			-30,
			0,
			0,
			-20,
			-15
		],
		ecircumflexy: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-30,
			-15
		],
		ecircumflexyacute: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-30,
			-15
		],
		ecircumflexydieresis: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-30,
			-15
		],
		edieresiscomma: [
			10,
			10,
			-15,
			-15,
			0,
			0,
			-10
		],
		edieresisperiod: [
			20,
			20,
			-15,
			-15,
			0,
			0,
			-15
		],
		edieresisv: [
			-15,
			-15,
			-30,
			-30,
			-15,
			0,
			-15,
			-25
		],
		edieresisw: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-15,
			-25
		],
		edieresisx: [
			-15,
			-15,
			-30,
			-30,
			0,
			0,
			-20,
			-15
		],
		edieresisy: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-30,
			-15
		],
		edieresisyacute: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-30,
			-15
		],
		edieresisydieresis: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-30,
			-15
		],
		edotaccentcomma: [
			10,
			10,
			-15,
			-15,
			0,
			0,
			-10
		],
		edotaccentperiod: [
			20,
			20,
			-15,
			-15,
			0,
			0,
			-15
		],
		edotaccentv: [
			-15,
			-15,
			-30,
			-30,
			-15,
			0,
			-15,
			-25
		],
		edotaccentw: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-15,
			-25
		],
		edotaccentx: [
			-15,
			-15,
			-30,
			-30,
			0,
			0,
			-20,
			-15
		],
		edotaccenty: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-30,
			-15
		],
		edotaccentyacute: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-30,
			-15
		],
		edotaccentydieresis: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-30,
			-15
		],
		egravecomma: [
			10,
			10,
			-15,
			-15,
			0,
			0,
			-10
		],
		egraveperiod: [
			20,
			20,
			-15,
			-15,
			0,
			0,
			-15
		],
		egravev: [
			-15,
			-15,
			-30,
			-30,
			-15,
			0,
			-15,
			-25
		],
		egravew: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-15,
			-25
		],
		egravex: [
			-15,
			-15,
			-30,
			-30,
			0,
			0,
			-20,
			-15
		],
		egravey: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-30,
			-15
		],
		egraveyacute: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-30,
			-15
		],
		egraveydieresis: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-30,
			-15
		],
		emacroncomma: [
			10,
			10,
			-15,
			-15,
			0,
			0,
			-10
		],
		emacronperiod: [
			20,
			20,
			-15,
			-15,
			0,
			0,
			-15
		],
		emacronv: [
			-15,
			-15,
			-30,
			-30,
			-15,
			0,
			-15,
			-25
		],
		emacronw: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-15,
			-25
		],
		emacronx: [
			-15,
			-15,
			-30,
			-30,
			0,
			0,
			-20,
			-15
		],
		emacrony: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-30,
			-15
		],
		emacronyacute: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-30,
			-15
		],
		emacronydieresis: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-30,
			-15
		],
		eogonekcomma: [
			10,
			10,
			-15,
			-15,
			0,
			0,
			-10
		],
		eogonekperiod: [
			20,
			20,
			-15,
			-15,
			0,
			0,
			-15
		],
		eogonekv: [
			-15,
			-15,
			-30,
			-30,
			-15,
			0,
			-15,
			-25
		],
		eogonekw: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-15,
			-25
		],
		eogonekx: [
			-15,
			-15,
			-30,
			-30,
			0,
			0,
			-20,
			-15
		],
		eogoneky: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-30,
			-15
		],
		eogonekyacute: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-30,
			-15
		],
		eogonekydieresis: [
			-15,
			-15,
			-20,
			-20,
			0,
			0,
			-30,
			-15
		],
		fcomma: [
			-10,
			-10,
			-30,
			-30,
			-15,
			-10,
			-10
		],
		fe: [
			-10,
			-10,
			-30,
			-30,
			0,
			-10
		],
		feacute: [
			-10,
			-10,
			-30,
			-30,
			0,
			-10
		],
		fecaron: [
			-10,
			-10,
			-30,
			-30
		],
		fecircumflex: [
			-10,
			-10,
			-30,
			-30
		],
		fedieresis: [
			-10,
			-10,
			-30,
			-30
		],
		fedotaccent: [
			-10,
			-10,
			-30,
			-30,
			0,
			-10
		],
		fegrave: [
			-10,
			-10,
			-30,
			-30
		],
		femacron: [
			-10,
			-10,
			-30,
			-30
		],
		feogonek: [
			-10,
			-10,
			-30,
			-30,
			0,
			-10
		],
		fo: [
			-20,
			-20,
			-30,
			-30,
			-25,
			-10
		],
		foacute: [
			-20,
			-20,
			-30,
			-30,
			-25,
			-10
		],
		focircumflex: [
			-20,
			-20,
			-30,
			-30,
			-25,
			-10
		],
		fodieresis: [
			-20,
			-20,
			-30,
			-30,
			-25
		],
		fograve: [
			-20,
			-20,
			-30,
			-30,
			-25,
			-10
		],
		fohungarumlaut: [
			-20,
			-20,
			-30,
			-30,
			-25,
			-10
		],
		fomacron: [
			-20,
			-20,
			-30,
			-30,
			-25
		],
		foslash: [
			-20,
			-20,
			-30,
			-30,
			-25,
			-10
		],
		fotilde: [
			-20,
			-20,
			-30,
			-30,
			-25,
			-10
		],
		fperiod: [
			-10,
			-10,
			-30,
			-30,
			-15,
			-10,
			-15
		],
		fquotedblright: [
			30,
			30,
			60,
			60,
			50
		],
		fquoteright: [
			30,
			30,
			50,
			50,
			55,
			55,
			92,
			55
		],
		ge: [
			10,
			10,
			0,
			0,
			0,
			0,
			-10
		],
		geacute: [
			10,
			10,
			0,
			0,
			0,
			0,
			-10
		],
		gecaron: [
			10,
			10,
			0,
			0,
			0,
			0,
			-10
		],
		gecircumflex: [
			10,
			10,
			0,
			0,
			0,
			0,
			-10
		],
		gedieresis: [
			10,
			10,
			0,
			0,
			0,
			0,
			-10
		],
		gedotaccent: [
			10,
			10,
			0,
			0,
			0,
			0,
			-10
		],
		gegrave: [
			10,
			10,
			0,
			0,
			0,
			0,
			-10
		],
		gemacron: [
			10,
			10,
			0,
			0,
			0,
			0,
			-10
		],
		geogonek: [
			10,
			10,
			0,
			0,
			0,
			0,
			-10
		],
		gg: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		ggbreve: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		ggcommaaccent: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		gbrevee: [
			10,
			10,
			0,
			0,
			0,
			0,
			-10
		],
		gbreveeacute: [
			10,
			10,
			0,
			0,
			0,
			0,
			-10
		],
		gbreveecaron: [
			10,
			10,
			0,
			0,
			0,
			0,
			-10
		],
		gbreveecircumflex: [
			10,
			10,
			0,
			0,
			0,
			0,
			-10
		],
		gbreveedieresis: [
			10,
			10,
			0,
			0,
			0,
			0,
			-10
		],
		gbreveedotaccent: [
			10,
			10,
			0,
			0,
			0,
			0,
			-10
		],
		gbreveegrave: [
			10,
			10,
			0,
			0,
			0,
			0,
			-10
		],
		gbreveemacron: [
			10,
			10,
			0,
			0,
			0,
			0,
			-10
		],
		gbreveeogonek: [
			10,
			10,
			0,
			0,
			0,
			0,
			-10
		],
		gbreveg: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		gbrevegbreve: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		gbrevegcommaaccent: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		gcommaaccente: [
			10,
			10,
			0,
			0,
			0,
			0,
			-10
		],
		gcommaaccenteacute: [
			10,
			10,
			0,
			0,
			0,
			0,
			-10
		],
		gcommaaccentecaron: [
			10,
			10,
			0,
			0,
			0,
			0,
			-10
		],
		gcommaaccentecircumflex: [
			10,
			10,
			0,
			0,
			0,
			0,
			-10
		],
		gcommaaccentedieresis: [
			10,
			10,
			0,
			0,
			0,
			0,
			-10
		],
		gcommaaccentedotaccent: [
			10,
			10,
			0,
			0,
			0,
			0,
			-10
		],
		gcommaaccentegrave: [
			10,
			10,
			0,
			0,
			0,
			0,
			-10
		],
		gcommaaccentemacron: [
			10,
			10,
			0,
			0,
			0,
			0,
			-10
		],
		gcommaaccenteogonek: [
			10,
			10,
			0,
			0,
			0,
			0,
			-10
		],
		gcommaaccentg: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		gcommaaccentgbreve: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		gcommaaccentgcommaaccent: [
			-10,
			-10,
			0,
			0,
			0,
			0,
			-10
		],
		hy: [
			-20,
			-20,
			-30,
			-30,
			-15,
			0,
			0,
			-5
		],
		hyacute: [
			-20,
			-20,
			-30,
			-30,
			-15,
			0,
			0,
			-5
		],
		hydieresis: [
			-20,
			-20,
			-30,
			-30,
			-15,
			0,
			0,
			-5
		],
		ko: [
			-15,
			-15,
			-20,
			-20,
			-15,
			-10,
			-10,
			-10
		],
		koacute: [
			-15,
			-15,
			-20,
			-20,
			-15,
			-10,
			-10,
			-10
		],
		kocircumflex: [
			-15,
			-15,
			-20,
			-20,
			-15,
			-10,
			-10,
			-10
		],
		kodieresis: [
			-15,
			-15,
			-20,
			-20,
			-15,
			-10,
			-10,
			-10
		],
		kograve: [
			-15,
			-15,
			-20,
			-20,
			-15,
			-10,
			-10,
			-10
		],
		kohungarumlaut: [
			-15,
			-15,
			-20,
			-20,
			-15,
			-10,
			-10,
			-10
		],
		komacron: [
			-15,
			-15,
			-20,
			-20,
			-15,
			-10,
			-10,
			-10
		],
		koslash: [
			-15,
			-15,
			-20,
			-20,
			-15,
			-10,
			-10,
			-10
		],
		kotilde: [
			-15,
			-15,
			-20,
			-20,
			-15,
			-10,
			-10,
			-10
		],
		kcommaaccento: [
			-15,
			-15,
			-20,
			-20,
			-15,
			-10,
			-10,
			-10
		],
		kcommaaccentoacute: [
			-15,
			-15,
			-20,
			-20,
			-15,
			-10,
			-10,
			-10
		],
		kcommaaccentocircumflex: [
			-15,
			-15,
			-20,
			-20,
			-15,
			-10,
			-10,
			-10
		],
		kcommaaccentodieresis: [
			-15,
			-15,
			-20,
			-20,
			-15,
			-10,
			-10,
			-10
		],
		kcommaaccentograve: [
			-15,
			-15,
			-20,
			-20,
			-15,
			-10,
			-10,
			-10
		],
		kcommaaccentohungarumlaut: [
			-15,
			-15,
			-20,
			-20,
			-15,
			-10,
			-10,
			-10
		],
		kcommaaccentomacron: [
			-15,
			-15,
			-20,
			-20,
			-15,
			-10,
			-10,
			-10
		],
		kcommaaccentoslash: [
			-15,
			-15,
			-20,
			-20,
			-15,
			-10,
			-10,
			-10
		],
		kcommaaccentotilde: [
			-15,
			-15,
			-20,
			-20,
			-15,
			-10,
			-10,
			-10
		],
		lw: [
			-15,
			-15,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		ly: [-15, -15],
		lyacute: [-15, -15],
		lydieresis: [-15, -15],
		lacutew: [
			-15,
			-15,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		lacutey: [-15, -15],
		lacuteyacute: [-15, -15],
		lacuteydieresis: [-15, -15],
		lcommaaccentw: [
			-15,
			-15,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		lcommaaccenty: [-15, -15],
		lcommaaccentyacute: [-15, -15],
		lcommaaccentydieresis: [-15, -15],
		lslashw: [
			-15,
			-15,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		lslashy: [-15, -15],
		lslashyacute: [-15, -15],
		lslashydieresis: [-15, -15],
		mu: [
			-20,
			-20,
			-10,
			-10
		],
		muacute: [
			-20,
			-20,
			-10,
			-10
		],
		mucircumflex: [
			-20,
			-20,
			-10,
			-10
		],
		mudieresis: [
			-20,
			-20,
			-10,
			-10
		],
		mugrave: [
			-20,
			-20,
			-10,
			-10
		],
		muhungarumlaut: [
			-20,
			-20,
			-10,
			-10
		],
		mumacron: [
			-20,
			-20,
			-10,
			-10
		],
		muogonek: [
			-20,
			-20,
			-10,
			-10
		],
		muring: [
			-20,
			-20,
			-10,
			-10
		],
		my: [
			-30,
			-30,
			-15,
			-15
		],
		myacute: [
			-30,
			-30,
			-15,
			-15
		],
		mydieresis: [
			-30,
			-30,
			-15,
			-15
		],
		nu: [
			-10,
			-10,
			-10,
			-10
		],
		nuacute: [
			-10,
			-10,
			-10,
			-10
		],
		nucircumflex: [
			-10,
			-10,
			-10,
			-10
		],
		nudieresis: [
			-10,
			-10,
			-10,
			-10
		],
		nugrave: [
			-10,
			-10,
			-10,
			-10
		],
		nuhungarumlaut: [
			-10,
			-10,
			-10,
			-10
		],
		numacron: [
			-10,
			-10,
			-10,
			-10
		],
		nuogonek: [
			-10,
			-10,
			-10,
			-10
		],
		nuring: [
			-10,
			-10,
			-10,
			-10
		],
		nv: [
			-40,
			-40,
			-20,
			-20,
			-40,
			-40,
			-40,
			-40
		],
		ny: [
			-20,
			-20,
			-15,
			-15,
			0,
			0,
			0,
			-15
		],
		nyacute: [
			-20,
			-20,
			-15,
			-15,
			0,
			0,
			0,
			-15
		],
		nydieresis: [
			-20,
			-20,
			-15,
			-15,
			0,
			0,
			0,
			-15
		],
		nacuteu: [
			-10,
			-10,
			-10,
			-10
		],
		nacuteuacute: [
			-10,
			-10,
			-10,
			-10
		],
		nacuteucircumflex: [
			-10,
			-10,
			-10,
			-10
		],
		nacuteudieresis: [
			-10,
			-10,
			-10,
			-10
		],
		nacuteugrave: [
			-10,
			-10,
			-10,
			-10
		],
		nacuteuhungarumlaut: [
			-10,
			-10,
			-10,
			-10
		],
		nacuteumacron: [
			-10,
			-10,
			-10,
			-10
		],
		nacuteuogonek: [
			-10,
			-10,
			-10,
			-10
		],
		nacuteuring: [
			-10,
			-10,
			-10,
			-10
		],
		nacutev: [
			-40,
			-40,
			-20,
			-20,
			-40,
			-40,
			-40,
			-40
		],
		nacutey: [
			-20,
			-20,
			-15,
			-15,
			0,
			0,
			0,
			-15
		],
		nacuteyacute: [
			-20,
			-20,
			-15,
			-15,
			0,
			0,
			0,
			-15
		],
		nacuteydieresis: [
			-20,
			-20,
			-15,
			-15,
			0,
			0,
			0,
			-15
		],
		ncaronu: [
			-10,
			-10,
			-10,
			-10
		],
		ncaronuacute: [
			-10,
			-10,
			-10,
			-10
		],
		ncaronucircumflex: [
			-10,
			-10,
			-10,
			-10
		],
		ncaronudieresis: [
			-10,
			-10,
			-10,
			-10
		],
		ncaronugrave: [
			-10,
			-10,
			-10,
			-10
		],
		ncaronuhungarumlaut: [
			-10,
			-10,
			-10,
			-10
		],
		ncaronumacron: [
			-10,
			-10,
			-10,
			-10
		],
		ncaronuogonek: [
			-10,
			-10,
			-10,
			-10
		],
		ncaronuring: [
			-10,
			-10,
			-10,
			-10
		],
		ncaronv: [
			-40,
			-40,
			-20,
			-20,
			-40,
			-40,
			-40,
			-40
		],
		ncarony: [
			-20,
			-20,
			-15,
			-15,
			0,
			0,
			0,
			-15
		],
		ncaronyacute: [
			-20,
			-20,
			-15,
			-15,
			0,
			0,
			0,
			-15
		],
		ncaronydieresis: [
			-20,
			-20,
			-15,
			-15,
			0,
			0,
			0,
			-15
		],
		ncommaaccentu: [
			-10,
			-10,
			-10,
			-10
		],
		ncommaaccentuacute: [
			-10,
			-10,
			-10,
			-10
		],
		ncommaaccentucircumflex: [
			-10,
			-10,
			-10,
			-10
		],
		ncommaaccentudieresis: [
			-10,
			-10,
			-10,
			-10
		],
		ncommaaccentugrave: [
			-10,
			-10,
			-10,
			-10
		],
		ncommaaccentuhungarumlaut: [
			-10,
			-10,
			-10,
			-10
		],
		ncommaaccentumacron: [
			-10,
			-10,
			-10,
			-10
		],
		ncommaaccentuogonek: [
			-10,
			-10,
			-10,
			-10
		],
		ncommaaccenturing: [
			-10,
			-10,
			-10,
			-10
		],
		ncommaaccentv: [
			-40,
			-40,
			-20,
			-20,
			-40,
			-40,
			-40,
			-40
		],
		ncommaaccenty: [
			-20,
			-20,
			-15,
			-15,
			0,
			0,
			0,
			-15
		],
		ncommaaccentyacute: [
			-20,
			-20,
			-15,
			-15,
			0,
			0,
			0,
			-15
		],
		ncommaaccentydieresis: [
			-20,
			-20,
			-15,
			-15,
			0,
			0,
			0,
			-15
		],
		ntildeu: [
			-10,
			-10,
			-10,
			-10
		],
		ntildeuacute: [
			-10,
			-10,
			-10,
			-10
		],
		ntildeucircumflex: [
			-10,
			-10,
			-10,
			-10
		],
		ntildeudieresis: [
			-10,
			-10,
			-10,
			-10
		],
		ntildeugrave: [
			-10,
			-10,
			-10,
			-10
		],
		ntildeuhungarumlaut: [
			-10,
			-10,
			-10,
			-10
		],
		ntildeumacron: [
			-10,
			-10,
			-10,
			-10
		],
		ntildeuogonek: [
			-10,
			-10,
			-10,
			-10
		],
		ntildeuring: [
			-10,
			-10,
			-10,
			-10
		],
		ntildev: [
			-40,
			-40,
			-20,
			-20,
			-40,
			-40,
			-40,
			-40
		],
		ntildey: [
			-20,
			-20,
			-15,
			-15,
			0,
			0,
			0,
			-15
		],
		ntildeyacute: [
			-20,
			-20,
			-15,
			-15,
			0,
			0,
			0,
			-15
		],
		ntildeydieresis: [
			-20,
			-20,
			-15,
			-15,
			0,
			0,
			0,
			-15
		],
		ov: [
			-20,
			-20,
			-15,
			-15,
			-10,
			-15,
			-10,
			-15
		],
		ow: [
			-15,
			-15,
			-15,
			-15,
			-10,
			-25,
			0,
			-25
		],
		ox: [
			-30,
			-30,
			-30,
			-30,
			0,
			-10
		],
		oy: [
			-20,
			-20,
			-30,
			-30,
			0,
			-10,
			0,
			-10
		],
		oyacute: [
			-20,
			-20,
			-30,
			-30,
			0,
			-10,
			0,
			-10
		],
		oydieresis: [
			-20,
			-20,
			-30,
			-30,
			0,
			-10,
			0,
			-10
		],
		oacutev: [
			-20,
			-20,
			-15,
			-15,
			-10,
			-15,
			-10,
			-15
		],
		oacutew: [
			-15,
			-15,
			-15,
			-15,
			-10,
			-25,
			0,
			-25
		],
		oacutex: [
			-30,
			-30,
			-30,
			-30,
			0,
			-10
		],
		oacutey: [
			-20,
			-20,
			-30,
			-30,
			0,
			-10,
			0,
			-10
		],
		oacuteyacute: [
			-20,
			-20,
			-30,
			-30,
			0,
			-10,
			0,
			-10
		],
		oacuteydieresis: [
			-20,
			-20,
			-30,
			-30,
			0,
			-10,
			0,
			-10
		],
		ocircumflexv: [
			-20,
			-20,
			-15,
			-15,
			-10,
			-15,
			-10,
			-15
		],
		ocircumflexw: [
			-15,
			-15,
			-15,
			-15,
			-10,
			-25,
			0,
			-25
		],
		ocircumflexx: [
			-30,
			-30,
			-30,
			-30,
			0,
			-10
		],
		ocircumflexy: [
			-20,
			-20,
			-30,
			-30,
			0,
			-10,
			0,
			-10
		],
		ocircumflexyacute: [
			-20,
			-20,
			-30,
			-30,
			0,
			-10,
			0,
			-10
		],
		ocircumflexydieresis: [
			-20,
			-20,
			-30,
			-30,
			0,
			-10,
			0,
			-10
		],
		odieresisv: [
			-20,
			-20,
			-15,
			-15,
			-10,
			-15,
			-10,
			-15
		],
		odieresisw: [
			-15,
			-15,
			-15,
			-15,
			-10,
			-25,
			0,
			-25
		],
		odieresisx: [
			-30,
			-30,
			-30,
			-30,
			0,
			-10
		],
		odieresisy: [
			-20,
			-20,
			-30,
			-30,
			0,
			-10,
			0,
			-10
		],
		odieresisyacute: [
			-20,
			-20,
			-30,
			-30,
			0,
			-10,
			0,
			-10
		],
		odieresisydieresis: [
			-20,
			-20,
			-30,
			-30,
			0,
			-10,
			0,
			-10
		],
		ogravev: [
			-20,
			-20,
			-15,
			-15,
			-10,
			-15,
			-10,
			-15
		],
		ogravew: [
			-15,
			-15,
			-15,
			-15,
			-10,
			-25,
			0,
			-25
		],
		ogravex: [
			-30,
			-30,
			-30,
			-30,
			0,
			-10
		],
		ogravey: [
			-20,
			-20,
			-30,
			-30,
			0,
			-10,
			0,
			-10
		],
		ograveyacute: [
			-20,
			-20,
			-30,
			-30,
			0,
			-10,
			0,
			-10
		],
		ograveydieresis: [
			-20,
			-20,
			-30,
			-30,
			0,
			-10,
			0,
			-10
		],
		ohungarumlautv: [
			-20,
			-20,
			-15,
			-15,
			-10,
			-15,
			-10,
			-15
		],
		ohungarumlautw: [
			-15,
			-15,
			-15,
			-15,
			-10,
			-25,
			0,
			-25
		],
		ohungarumlautx: [
			-30,
			-30,
			-30,
			-30,
			0,
			-10
		],
		ohungarumlauty: [
			-20,
			-20,
			-30,
			-30,
			0,
			-10,
			0,
			-10
		],
		ohungarumlautyacute: [
			-20,
			-20,
			-30,
			-30,
			0,
			-10,
			0,
			-10
		],
		ohungarumlautydieresis: [
			-20,
			-20,
			-30,
			-30,
			0,
			-10,
			0,
			-10
		],
		omacronv: [
			-20,
			-20,
			-15,
			-15,
			-10,
			-15,
			-10,
			-15
		],
		omacronw: [
			-15,
			-15,
			-15,
			-15,
			-10,
			-25,
			0,
			-25
		],
		omacronx: [
			-30,
			-30,
			-30,
			-30,
			0,
			-10
		],
		omacrony: [
			-20,
			-20,
			-30,
			-30,
			0,
			-10,
			0,
			-10
		],
		omacronyacute: [
			-20,
			-20,
			-30,
			-30,
			0,
			-10,
			0,
			-10
		],
		omacronydieresis: [
			-20,
			-20,
			-30,
			-30,
			0,
			-10,
			0,
			-10
		],
		oslashv: [
			-20,
			-20,
			-70,
			-70,
			-10,
			-15,
			-10,
			-15
		],
		oslashw: [
			-15,
			-15,
			-70,
			-70,
			-10,
			-25,
			0,
			-25
		],
		oslashx: [
			-30,
			-30,
			-85,
			-85,
			0,
			-10
		],
		oslashy: [
			-20,
			-20,
			-70,
			-70,
			0,
			-10,
			0,
			-10
		],
		oslashyacute: [
			-20,
			-20,
			-70,
			-70,
			0,
			-10,
			0,
			-10
		],
		oslashydieresis: [
			-20,
			-20,
			-70,
			-70,
			0,
			-10,
			0,
			-10
		],
		otildev: [
			-20,
			-20,
			-15,
			-15,
			-10,
			-15,
			-10,
			-15
		],
		otildew: [
			-15,
			-15,
			-15,
			-15,
			-10,
			-25,
			0,
			-25
		],
		otildex: [
			-30,
			-30,
			-30,
			-30,
			0,
			-10
		],
		otildey: [
			-20,
			-20,
			-30,
			-30,
			0,
			-10,
			0,
			-10
		],
		otildeyacute: [
			-20,
			-20,
			-30,
			-30,
			0,
			-10,
			0,
			-10
		],
		otildeydieresis: [
			-20,
			-20,
			-30,
			-30,
			0,
			-10,
			0,
			-10
		],
		py: [
			-15,
			-15,
			-30,
			-30,
			0,
			0,
			0,
			-10
		],
		pyacute: [
			-15,
			-15,
			-30,
			-30,
			0,
			0,
			0,
			-10
		],
		pydieresis: [
			-15,
			-15,
			-30,
			-30,
			0,
			0,
			0,
			-10
		],
		periodquotedblright: [
			-120,
			-120,
			-100,
			-100,
			-55,
			-95,
			-140,
			-70
		],
		periodquoteright: [
			-120,
			-120,
			-100,
			-100,
			-55,
			-95,
			-140,
			-70
		],
		periodspace: [
			-40,
			-40,
			-60,
			-60
		],
		quotedblrightspace: [
			-80,
			-80,
			-40,
			-40
		],
		quoteleftquoteleft: [
			-46,
			-46,
			-57,
			-57,
			-63,
			-74,
			-111,
			-74
		],
		quoterightd: [
			-80,
			-80,
			-50,
			-50,
			-20,
			-15,
			-25,
			-50
		],
		quoterightdcroat: [
			-80,
			-80,
			-50,
			-50,
			-20,
			-15,
			-25,
			-50
		],
		quoterightl: [
			-20,
			-20,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		quoterightlacute: [
			-20,
			-20,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		quoterightlcommaaccent: [
			-20,
			-20,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		quoterightlslash: [
			-20,
			-20,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		quoterightquoteright: [
			-46,
			-46,
			-57,
			-57,
			-63,
			-74,
			-111,
			-74
		],
		quoterightr: [
			-40,
			-40,
			-50,
			-50,
			-20,
			-15,
			-25,
			-50
		],
		quoterightracute: [
			-40,
			-40,
			-50,
			-50,
			-20,
			-15,
			-25,
			-50
		],
		quoterightrcaron: [
			-40,
			-40,
			-50,
			-50,
			-20,
			-15,
			-25,
			-50
		],
		quoterightrcommaaccent: [
			-40,
			-40,
			-50,
			-50,
			-20,
			-15,
			-25,
			-50
		],
		quoterights: [
			-60,
			-60,
			-50,
			-50,
			-37,
			-74,
			-40,
			-55
		],
		quoterightsacute: [
			-60,
			-60,
			-50,
			-50,
			-37,
			-74,
			-40,
			-55
		],
		quoterightscaron: [
			-60,
			-60,
			-50,
			-50,
			-37,
			-74,
			-40,
			-55
		],
		quoterightscedilla: [
			-60,
			-60,
			-50,
			-50,
			-37,
			-74,
			-40,
			-55
		],
		quoterightscommaaccent: [
			-60,
			-60,
			-50,
			-50,
			-37,
			-74,
			-40,
			-55
		],
		quoterightspace: [
			-80,
			-80,
			-70,
			-70,
			-74,
			-74,
			-111,
			-74
		],
		quoterightv: [
			-20,
			-20,
			0,
			0,
			-20,
			-15,
			-10,
			-50
		],
		rc: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-37
		],
		rcacute: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-37
		],
		rccaron: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-37
		],
		rccedilla: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-37
		],
		rcomma: [
			-60,
			-60,
			-50,
			-50,
			-92,
			-65,
			-111,
			-40
		],
		rd: [
			-20,
			-20,
			0,
			0,
			0,
			0,
			-37
		],
		rdcroat: [
			-20,
			-20,
			0,
			0,
			0,
			0,
			-37
		],
		rg: [
			-15,
			-15,
			0,
			0,
			-10,
			0,
			-37,
			-18
		],
		rgbreve: [
			-15,
			-15,
			0,
			0,
			-10,
			0,
			-37,
			-18
		],
		rgcommaaccent: [
			-15,
			-15,
			0,
			0,
			-10,
			0,
			-37,
			-18
		],
		rhyphen: [
			-20,
			-20,
			0,
			0,
			-37,
			0,
			-20,
			-20
		],
		ro: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		roacute: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		rocircumflex: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		rodieresis: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		rograve: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		rohungarumlaut: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		romacron: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		roslash: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		rotilde: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		rperiod: [
			-60,
			-60,
			-50,
			-50,
			-100,
			-65,
			-111,
			-55
		],
		rq: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-37
		],
		rs: [
			-15,
			-15,
			0,
			0,
			0,
			0,
			-10
		],
		rsacute: [
			-15,
			-15,
			0,
			0,
			0,
			0,
			-10
		],
		rscaron: [
			-15,
			-15,
			0,
			0,
			0,
			0,
			-10
		],
		rscedilla: [
			-15,
			-15,
			0,
			0,
			0,
			0,
			-10
		],
		rscommaaccent: [
			-15,
			-15,
			0,
			0,
			0,
			0,
			-10
		],
		rt: [
			20,
			20,
			40,
			40
		],
		rtcommaaccent: [
			20,
			20,
			40,
			40
		],
		rv: [
			10,
			10,
			30,
			30,
			-10
		],
		ry: [
			10,
			10,
			30,
			30
		],
		ryacute: [
			10,
			10,
			30,
			30
		],
		rydieresis: [
			10,
			10,
			30,
			30
		],
		racutec: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-37
		],
		racutecacute: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-37
		],
		racuteccaron: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-37
		],
		racuteccedilla: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-37
		],
		racutecomma: [
			-60,
			-60,
			-50,
			-50,
			-92,
			-65,
			-111,
			-40
		],
		racuted: [
			-20,
			-20,
			0,
			0,
			0,
			0,
			-37
		],
		racutedcroat: [
			-20,
			-20,
			0,
			0,
			0,
			0,
			-37
		],
		racuteg: [
			-15,
			-15,
			0,
			0,
			-10,
			0,
			-37,
			-18
		],
		racutegbreve: [
			-15,
			-15,
			0,
			0,
			-10,
			0,
			-37,
			-18
		],
		racutegcommaaccent: [
			-15,
			-15,
			0,
			0,
			-10,
			0,
			-37,
			-18
		],
		racutehyphen: [
			-20,
			-20,
			0,
			0,
			-37,
			0,
			-20,
			-20
		],
		racuteo: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		racuteoacute: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		racuteocircumflex: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		racuteodieresis: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		racuteograve: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		racuteohungarumlaut: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		racuteomacron: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		racuteoslash: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		racuteotilde: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		racuteperiod: [
			-60,
			-60,
			-50,
			-50,
			-100,
			-65,
			-111,
			-55
		],
		racuteq: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-37
		],
		racutes: [
			-15,
			-15,
			0,
			0,
			0,
			0,
			-10
		],
		racutesacute: [
			-15,
			-15,
			0,
			0,
			0,
			0,
			-10
		],
		racutescaron: [
			-15,
			-15,
			0,
			0,
			0,
			0,
			-10
		],
		racutescedilla: [
			-15,
			-15,
			0,
			0,
			0,
			0,
			-10
		],
		racutescommaaccent: [
			-15,
			-15,
			0,
			0,
			0,
			0,
			-10
		],
		racutet: [
			20,
			20,
			40,
			40
		],
		racutetcommaaccent: [
			20,
			20,
			40,
			40
		],
		racutev: [
			10,
			10,
			30,
			30,
			-10
		],
		racutey: [
			10,
			10,
			30,
			30
		],
		racuteyacute: [
			10,
			10,
			30,
			30
		],
		racuteydieresis: [
			10,
			10,
			30,
			30
		],
		rcaronc: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-37
		],
		rcaroncacute: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-37
		],
		rcaronccaron: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-37
		],
		rcaronccedilla: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-37
		],
		rcaroncomma: [
			-60,
			-60,
			-50,
			-50,
			-92,
			-65,
			-111,
			-40
		],
		rcarond: [
			-20,
			-20,
			0,
			0,
			0,
			0,
			-37
		],
		rcarondcroat: [
			-20,
			-20,
			0,
			0,
			0,
			0,
			-37
		],
		rcarong: [
			-15,
			-15,
			0,
			0,
			-10,
			0,
			-37,
			-18
		],
		rcarongbreve: [
			-15,
			-15,
			0,
			0,
			-10,
			0,
			-37,
			-18
		],
		rcarongcommaaccent: [
			-15,
			-15,
			0,
			0,
			-10,
			0,
			-37,
			-18
		],
		rcaronhyphen: [
			-20,
			-20,
			0,
			0,
			-37,
			0,
			-20,
			-20
		],
		rcarono: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		rcaronoacute: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		rcaronocircumflex: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		rcaronodieresis: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		rcaronograve: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		rcaronohungarumlaut: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		rcaronomacron: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		rcaronoslash: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		rcaronotilde: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		rcaronperiod: [
			-60,
			-60,
			-50,
			-50,
			-100,
			-65,
			-111,
			-55
		],
		rcaronq: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-37
		],
		rcarons: [
			-15,
			-15,
			0,
			0,
			0,
			0,
			-10
		],
		rcaronsacute: [
			-15,
			-15,
			0,
			0,
			0,
			0,
			-10
		],
		rcaronscaron: [
			-15,
			-15,
			0,
			0,
			0,
			0,
			-10
		],
		rcaronscedilla: [
			-15,
			-15,
			0,
			0,
			0,
			0,
			-10
		],
		rcaronscommaaccent: [
			-15,
			-15,
			0,
			0,
			0,
			0,
			-10
		],
		rcaront: [
			20,
			20,
			40,
			40
		],
		rcarontcommaaccent: [
			20,
			20,
			40,
			40
		],
		rcaronv: [
			10,
			10,
			30,
			30,
			-10
		],
		rcarony: [
			10,
			10,
			30,
			30
		],
		rcaronyacute: [
			10,
			10,
			30,
			30
		],
		rcaronydieresis: [
			10,
			10,
			30,
			30
		],
		rcommaaccentc: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-37
		],
		rcommaaccentcacute: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-37
		],
		rcommaaccentccaron: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-37
		],
		rcommaaccentccedilla: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-37
		],
		rcommaaccentcomma: [
			-60,
			-60,
			-50,
			-50,
			-92,
			-65,
			-111,
			-40
		],
		rcommaaccentd: [
			-20,
			-20,
			0,
			0,
			0,
			0,
			-37
		],
		rcommaaccentdcroat: [
			-20,
			-20,
			0,
			0,
			0,
			0,
			-37
		],
		rcommaaccentg: [
			-15,
			-15,
			0,
			0,
			-10,
			0,
			-37,
			-18
		],
		rcommaaccentgbreve: [
			-15,
			-15,
			0,
			0,
			-10,
			0,
			-37,
			-18
		],
		rcommaaccentgcommaaccent: [
			-15,
			-15,
			0,
			0,
			-10,
			0,
			-37,
			-18
		],
		rcommaaccenthyphen: [
			-20,
			-20,
			0,
			0,
			-37,
			0,
			-20,
			-20
		],
		rcommaaccento: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		rcommaaccentoacute: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		rcommaaccentocircumflex: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		rcommaaccentodieresis: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		rcommaaccentograve: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		rcommaaccentohungarumlaut: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		rcommaaccentomacron: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		rcommaaccentoslash: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		rcommaaccentotilde: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-45
		],
		rcommaaccentperiod: [
			-60,
			-60,
			-50,
			-50,
			-100,
			-65,
			-111,
			-55
		],
		rcommaaccentq: [
			-20,
			-20,
			0,
			0,
			-18,
			0,
			-37
		],
		rcommaaccents: [
			-15,
			-15,
			0,
			0,
			0,
			0,
			-10
		],
		rcommaaccentsacute: [
			-15,
			-15,
			0,
			0,
			0,
			0,
			-10
		],
		rcommaaccentscaron: [
			-15,
			-15,
			0,
			0,
			0,
			0,
			-10
		],
		rcommaaccentscedilla: [
			-15,
			-15,
			0,
			0,
			0,
			0,
			-10
		],
		rcommaaccentscommaaccent: [
			-15,
			-15,
			0,
			0,
			0,
			0,
			-10
		],
		rcommaaccentt: [
			20,
			20,
			40,
			40
		],
		rcommaaccenttcommaaccent: [
			20,
			20,
			40,
			40
		],
		rcommaaccentv: [
			10,
			10,
			30,
			30,
			-10
		],
		rcommaaccenty: [
			10,
			10,
			30,
			30
		],
		rcommaaccentyacute: [
			10,
			10,
			30,
			30
		],
		rcommaaccentydieresis: [
			10,
			10,
			30,
			30
		],
		sw: [
			-15,
			-15,
			-30,
			-30
		],
		sacutew: [
			-15,
			-15,
			-30,
			-30
		],
		scaronw: [
			-15,
			-15,
			-30,
			-30
		],
		scedillaw: [
			-15,
			-15,
			-30,
			-30
		],
		scommaaccentw: [
			-15,
			-15,
			-30,
			-30
		],
		semicolonspace: [
			-40,
			-40,
			-50,
			-50
		],
		spaceT: [
			-100,
			-100,
			-50,
			-50,
			-30,
			0,
			-18,
			-18
		],
		spaceTcaron: [
			-100,
			-100,
			-50,
			-50,
			-30,
			0,
			-18,
			-18
		],
		spaceTcommaaccent: [
			-100,
			-100,
			-50,
			-50,
			-30,
			0,
			-18,
			-18
		],
		spaceV: [
			-80,
			-80,
			-50,
			-50,
			-45,
			-70,
			-35,
			-50
		],
		spaceW: [
			-80,
			-80,
			-40,
			-40,
			-30,
			-70,
			-40,
			-30
		],
		spaceY: [
			-120,
			-120,
			-90,
			-90,
			-55,
			-70,
			-75,
			-90
		],
		spaceYacute: [
			-120,
			-120,
			-90,
			-90,
			-55,
			-70,
			-75,
			-90
		],
		spaceYdieresis: [
			-120,
			-120,
			-90,
			-90,
			-55,
			-70,
			-75,
			-90
		],
		spacequotedblleft: [
			-80,
			-80,
			-30,
			-30
		],
		spacequoteleft: [
			-60,
			-60,
			-60,
			-60
		],
		va: [
			-20,
			-20,
			-25,
			-25,
			-10,
			0,
			0,
			-25
		],
		vaacute: [
			-20,
			-20,
			-25,
			-25,
			-10,
			0,
			0,
			-25
		],
		vabreve: [
			-20,
			-20,
			-25,
			-25,
			-10,
			0,
			0,
			-25
		],
		vacircumflex: [
			-20,
			-20,
			-25,
			-25,
			-10,
			0,
			0,
			-25
		],
		vadieresis: [
			-20,
			-20,
			-25,
			-25,
			-10,
			0,
			0,
			-25
		],
		vagrave: [
			-20,
			-20,
			-25,
			-25,
			-10,
			0,
			0,
			-25
		],
		vamacron: [
			-20,
			-20,
			-25,
			-25,
			-10,
			0,
			0,
			-25
		],
		vaogonek: [
			-20,
			-20,
			-25,
			-25,
			-10,
			0,
			0,
			-25
		],
		varing: [
			-20,
			-20,
			-25,
			-25,
			-10,
			0,
			0,
			-25
		],
		vatilde: [
			-20,
			-20,
			-25,
			-25,
			-10,
			0,
			0,
			-25
		],
		vcomma: [
			-80,
			-80,
			-80,
			-80,
			-55,
			-37,
			-74,
			-65
		],
		vo: [
			-30,
			-30,
			-25,
			-25,
			-10,
			-15,
			0,
			-20
		],
		voacute: [
			-30,
			-30,
			-25,
			-25,
			-10,
			-15,
			0,
			-20
		],
		vocircumflex: [
			-30,
			-30,
			-25,
			-25,
			-10,
			-15,
			0,
			-20
		],
		vodieresis: [
			-30,
			-30,
			-25,
			-25,
			-10,
			-15,
			0,
			-20
		],
		vograve: [
			-30,
			-30,
			-25,
			-25,
			-10,
			-15,
			0,
			-20
		],
		vohungarumlaut: [
			-30,
			-30,
			-25,
			-25,
			-10,
			-15,
			0,
			-20
		],
		vomacron: [
			-30,
			-30,
			-25,
			-25,
			-10,
			-15,
			0,
			-20
		],
		voslash: [
			-30,
			-30,
			-25,
			-25,
			-10,
			-15,
			0,
			-20
		],
		votilde: [
			-30,
			-30,
			-25,
			-25,
			-10,
			-15,
			0,
			-20
		],
		vperiod: [
			-80,
			-80,
			-80,
			-80,
			-70,
			-37,
			-74,
			-65
		],
		wcomma: [
			-40,
			-40,
			-60,
			-60,
			-55,
			-37,
			-74,
			-65
		],
		wo: [
			-20,
			-20,
			-10,
			-10,
			-10,
			-15,
			0,
			-10
		],
		woacute: [
			-20,
			-20,
			-10,
			-10,
			-10,
			-15,
			0,
			-10
		],
		wocircumflex: [
			-20,
			-20,
			-10,
			-10,
			-10,
			-15,
			0,
			-10
		],
		wodieresis: [
			-20,
			-20,
			-10,
			-10,
			-10,
			-15,
			0,
			-10
		],
		wograve: [
			-20,
			-20,
			-10,
			-10,
			-10,
			-15,
			0,
			-10
		],
		wohungarumlaut: [
			-20,
			-20,
			-10,
			-10,
			-10,
			-15,
			0,
			-10
		],
		womacron: [
			-20,
			-20,
			-10,
			-10,
			-10,
			-15,
			0,
			-10
		],
		woslash: [
			-20,
			-20,
			-10,
			-10,
			-10,
			-15,
			0,
			-10
		],
		wotilde: [
			-20,
			-20,
			-10,
			-10,
			-10,
			-15,
			0,
			-10
		],
		wperiod: [
			-40,
			-40,
			-60,
			-60,
			-70,
			-37,
			-74,
			-65
		],
		xe: [
			-10,
			-10,
			-30,
			-30,
			0,
			-10,
			0,
			-15
		],
		xeacute: [
			-10,
			-10,
			-30,
			-30,
			0,
			-10,
			0,
			-15
		],
		xecaron: [
			-10,
			-10,
			-30,
			-30,
			0,
			-10,
			0,
			-15
		],
		xecircumflex: [
			-10,
			-10,
			-30,
			-30,
			0,
			-10,
			0,
			-15
		],
		xedieresis: [
			-10,
			-10,
			-30,
			-30,
			0,
			-10,
			0,
			-15
		],
		xedotaccent: [
			-10,
			-10,
			-30,
			-30,
			0,
			-10,
			0,
			-15
		],
		xegrave: [
			-10,
			-10,
			-30,
			-30,
			0,
			-10,
			0,
			-15
		],
		xemacron: [
			-10,
			-10,
			-30,
			-30,
			0,
			-10,
			0,
			-15
		],
		xeogonek: [
			-10,
			-10,
			-30,
			-30,
			0,
			-10,
			0,
			-15
		],
		ya: [
			-30,
			-30,
			-20,
			-20
		],
		yaacute: [
			-30,
			-30,
			-20,
			-20
		],
		yabreve: [
			-30,
			-30,
			-20,
			-20
		],
		yacircumflex: [
			-30,
			-30,
			-20,
			-20
		],
		yadieresis: [
			-30,
			-30,
			-20,
			-20
		],
		yagrave: [
			-30,
			-30,
			-20,
			-20
		],
		yamacron: [
			-30,
			-30,
			-20,
			-20
		],
		yaogonek: [
			-30,
			-30,
			-20,
			-20
		],
		yaring: [
			-30,
			-30,
			-20,
			-20
		],
		yatilde: [
			-30,
			-30,
			-20,
			-20
		],
		ycomma: [
			-80,
			-80,
			-100,
			-100,
			-55,
			-37,
			-55,
			-65
		],
		ye: [
			-10,
			-10,
			-20,
			-20,
			-10
		],
		yeacute: [
			-10,
			-10,
			-20,
			-20,
			-10
		],
		yecaron: [
			-10,
			-10,
			-20,
			-20,
			-10
		],
		yecircumflex: [
			-10,
			-10,
			-20,
			-20,
			-10
		],
		yedieresis: [
			-10,
			-10,
			-20,
			-20,
			-10
		],
		yedotaccent: [
			-10,
			-10,
			-20,
			-20,
			-10
		],
		yegrave: [
			-10,
			-10,
			-20,
			-20,
			-10
		],
		yemacron: [
			-10,
			-10,
			-20,
			-20,
			-10
		],
		yeogonek: [
			-10,
			-10,
			-20,
			-20,
			-10
		],
		yo: [
			-25,
			-25,
			-20,
			-20,
			-25
		],
		yoacute: [
			-25,
			-25,
			-20,
			-20,
			-25
		],
		yocircumflex: [
			-25,
			-25,
			-20,
			-20,
			-25
		],
		yodieresis: [
			-25,
			-25,
			-20,
			-20,
			-25
		],
		yograve: [
			-25,
			-25,
			-20,
			-20,
			-25
		],
		yohungarumlaut: [
			-25,
			-25,
			-20,
			-20,
			-25
		],
		yomacron: [
			-25,
			-25,
			-20,
			-20,
			-25
		],
		yoslash: [
			-25,
			-25,
			-20,
			-20,
			-25
		],
		yotilde: [
			-25,
			-25,
			-20,
			-20,
			-25
		],
		yperiod: [
			-80,
			-80,
			-100,
			-100,
			-70,
			-37,
			-55,
			-65
		],
		yacutea: [
			-30,
			-30,
			-20,
			-20
		],
		yacuteaacute: [
			-30,
			-30,
			-20,
			-20
		],
		yacuteabreve: [
			-30,
			-30,
			-20,
			-20
		],
		yacuteacircumflex: [
			-30,
			-30,
			-20,
			-20
		],
		yacuteadieresis: [
			-30,
			-30,
			-20,
			-20
		],
		yacuteagrave: [
			-30,
			-30,
			-20,
			-20
		],
		yacuteamacron: [
			-30,
			-30,
			-20,
			-20
		],
		yacuteaogonek: [
			-30,
			-30,
			-20,
			-20
		],
		yacutearing: [
			-30,
			-30,
			-20,
			-20
		],
		yacuteatilde: [
			-30,
			-30,
			-20,
			-20
		],
		yacutecomma: [
			-80,
			-80,
			-100,
			-100,
			-55,
			-37,
			-55,
			-65
		],
		yacutee: [
			-10,
			-10,
			-20,
			-20,
			-10
		],
		yacuteeacute: [
			-10,
			-10,
			-20,
			-20,
			-10
		],
		yacuteecaron: [
			-10,
			-10,
			-20,
			-20,
			-10
		],
		yacuteecircumflex: [
			-10,
			-10,
			-20,
			-20,
			-10
		],
		yacuteedieresis: [
			-10,
			-10,
			-20,
			-20,
			-10
		],
		yacuteedotaccent: [
			-10,
			-10,
			-20,
			-20,
			-10
		],
		yacuteegrave: [
			-10,
			-10,
			-20,
			-20,
			-10
		],
		yacuteemacron: [
			-10,
			-10,
			-20,
			-20,
			-10
		],
		yacuteeogonek: [
			-10,
			-10,
			-20,
			-20,
			-10
		],
		yacuteo: [
			-25,
			-25,
			-20,
			-20,
			-25
		],
		yacuteoacute: [
			-25,
			-25,
			-20,
			-20,
			-25
		],
		yacuteocircumflex: [
			-25,
			-25,
			-20,
			-20,
			-25
		],
		yacuteodieresis: [
			-25,
			-25,
			-20,
			-20,
			-25
		],
		yacuteograve: [
			-25,
			-25,
			-20,
			-20,
			-25
		],
		yacuteohungarumlaut: [
			-25,
			-25,
			-20,
			-20,
			-25
		],
		yacuteomacron: [
			-25,
			-25,
			-20,
			-20,
			-25
		],
		yacuteoslash: [
			-25,
			-25,
			-20,
			-20,
			-25
		],
		yacuteotilde: [
			-25,
			-25,
			-20,
			-20,
			-25
		],
		yacuteperiod: [
			-80,
			-80,
			-100,
			-100,
			-70,
			-37,
			-55,
			-65
		],
		ydieresisa: [
			-30,
			-30,
			-20,
			-20
		],
		ydieresisaacute: [
			-30,
			-30,
			-20,
			-20
		],
		ydieresisabreve: [
			-30,
			-30,
			-20,
			-20
		],
		ydieresisacircumflex: [
			-30,
			-30,
			-20,
			-20
		],
		ydieresisadieresis: [
			-30,
			-30,
			-20,
			-20
		],
		ydieresisagrave: [
			-30,
			-30,
			-20,
			-20
		],
		ydieresisamacron: [
			-30,
			-30,
			-20,
			-20
		],
		ydieresisaogonek: [
			-30,
			-30,
			-20,
			-20
		],
		ydieresisaring: [
			-30,
			-30,
			-20,
			-20
		],
		ydieresisatilde: [
			-30,
			-30,
			-20,
			-20
		],
		ydieresiscomma: [
			-80,
			-80,
			-100,
			-100,
			-55,
			-37,
			-55,
			-65
		],
		ydieresise: [
			-10,
			-10,
			-20,
			-20,
			-10
		],
		ydieresiseacute: [
			-10,
			-10,
			-20,
			-20,
			-10
		],
		ydieresisecaron: [
			-10,
			-10,
			-20,
			-20,
			-10
		],
		ydieresisecircumflex: [
			-10,
			-10,
			-20,
			-20,
			-10
		],
		ydieresisedieresis: [
			-10,
			-10,
			-20,
			-20,
			-10
		],
		ydieresisedotaccent: [
			-10,
			-10,
			-20,
			-20,
			-10
		],
		ydieresisegrave: [
			-10,
			-10,
			-20,
			-20,
			-10
		],
		ydieresisemacron: [
			-10,
			-10,
			-20,
			-20,
			-10
		],
		ydieresiseogonek: [
			-10,
			-10,
			-20,
			-20,
			-10
		],
		ydieresiso: [
			-25,
			-25,
			-20,
			-20,
			-25
		],
		ydieresisoacute: [
			-25,
			-25,
			-20,
			-20,
			-25
		],
		ydieresisocircumflex: [
			-25,
			-25,
			-20,
			-20,
			-25
		],
		ydieresisodieresis: [
			-25,
			-25,
			-20,
			-20,
			-25
		],
		ydieresisograve: [
			-25,
			-25,
			-20,
			-20,
			-25
		],
		ydieresisohungarumlaut: [
			-25,
			-25,
			-20,
			-20,
			-25
		],
		ydieresisomacron: [
			-25,
			-25,
			-20,
			-20,
			-25
		],
		ydieresisoslash: [
			-25,
			-25,
			-20,
			-20,
			-25
		],
		ydieresisotilde: [
			-25,
			-25,
			-20,
			-20,
			-25
		],
		ydieresisperiod: [
			-80,
			-80,
			-100,
			-100,
			-70,
			-37,
			-55,
			-65
		],
		ze: [
			10,
			10,
			-15,
			-15
		],
		zeacute: [
			10,
			10,
			-15,
			-15
		],
		zecaron: [
			10,
			10,
			-15,
			-15
		],
		zecircumflex: [
			10,
			10,
			-15,
			-15
		],
		zedieresis: [
			10,
			10,
			-15,
			-15
		],
		zedotaccent: [
			10,
			10,
			-15,
			-15
		],
		zegrave: [
			10,
			10,
			-15,
			-15
		],
		zemacron: [
			10,
			10,
			-15,
			-15
		],
		zeogonek: [
			10,
			10,
			-15,
			-15
		],
		zacutee: [
			10,
			10,
			-15,
			-15
		],
		zacuteeacute: [
			10,
			10,
			-15,
			-15
		],
		zacuteecaron: [
			10,
			10,
			-15,
			-15
		],
		zacuteecircumflex: [
			10,
			10,
			-15,
			-15
		],
		zacuteedieresis: [
			10,
			10,
			-15,
			-15
		],
		zacuteedotaccent: [
			10,
			10,
			-15,
			-15
		],
		zacuteegrave: [
			10,
			10,
			-15,
			-15
		],
		zacuteemacron: [
			10,
			10,
			-15,
			-15
		],
		zacuteeogonek: [
			10,
			10,
			-15,
			-15
		],
		zcarone: [
			10,
			10,
			-15,
			-15
		],
		zcaroneacute: [
			10,
			10,
			-15,
			-15
		],
		zcaronecaron: [
			10,
			10,
			-15,
			-15
		],
		zcaronecircumflex: [
			10,
			10,
			-15,
			-15
		],
		zcaronedieresis: [
			10,
			10,
			-15,
			-15
		],
		zcaronedotaccent: [
			10,
			10,
			-15,
			-15
		],
		zcaronegrave: [
			10,
			10,
			-15,
			-15
		],
		zcaronemacron: [
			10,
			10,
			-15,
			-15
		],
		zcaroneogonek: [
			10,
			10,
			-15,
			-15
		],
		zdotaccente: [
			10,
			10,
			-15,
			-15
		],
		zdotaccenteacute: [
			10,
			10,
			-15,
			-15
		],
		zdotaccentecaron: [
			10,
			10,
			-15,
			-15
		],
		zdotaccentecircumflex: [
			10,
			10,
			-15,
			-15
		],
		zdotaccentedieresis: [
			10,
			10,
			-15,
			-15
		],
		zdotaccentedotaccent: [
			10,
			10,
			-15,
			-15
		],
		zdotaccentegrave: [
			10,
			10,
			-15,
			-15
		],
		zdotaccentemacron: [
			10,
			10,
			-15,
			-15
		],
		zdotaccenteogonek: [
			10,
			10,
			-15,
			-15
		],
		Bcomma: [
			0,
			0,
			-20,
			-20
		],
		Bperiod: [
			0,
			0,
			-20,
			-20
		],
		Ccomma: [
			0,
			0,
			-30,
			-30
		],
		Cperiod: [
			0,
			0,
			-30,
			-30
		],
		Cacutecomma: [
			0,
			0,
			-30,
			-30
		],
		Cacuteperiod: [
			0,
			0,
			-30,
			-30
		],
		Ccaroncomma: [
			0,
			0,
			-30,
			-30
		],
		Ccaronperiod: [
			0,
			0,
			-30,
			-30
		],
		Ccedillacomma: [
			0,
			0,
			-30,
			-30
		],
		Ccedillaperiod: [
			0,
			0,
			-30,
			-30
		],
		Fe: [
			0,
			0,
			-30,
			-30,
			-25,
			-100,
			-75
		],
		Feacute: [
			0,
			0,
			-30,
			-30,
			-25,
			-100,
			-75
		],
		Fecaron: [
			0,
			0,
			-30,
			-30,
			-25,
			-100,
			-75
		],
		Fecircumflex: [
			0,
			0,
			-30,
			-30,
			-25,
			-100,
			-75
		],
		Fedieresis: [
			0,
			0,
			-30,
			-30,
			-25,
			-100,
			-75
		],
		Fedotaccent: [
			0,
			0,
			-30,
			-30,
			-25,
			-100,
			-75
		],
		Fegrave: [
			0,
			0,
			-30,
			-30,
			-25,
			-100,
			-75
		],
		Femacron: [
			0,
			0,
			-30,
			-30,
			-25,
			-100,
			-75
		],
		Feogonek: [
			0,
			0,
			-30,
			-30,
			-25,
			-100,
			-75
		],
		Fo: [
			0,
			0,
			-30,
			-30,
			-25,
			-70,
			-105,
			-15
		],
		Foacute: [
			0,
			0,
			-30,
			-30,
			-25,
			-70,
			-105,
			-15
		],
		Focircumflex: [
			0,
			0,
			-30,
			-30,
			-25,
			-70,
			-105,
			-15
		],
		Fodieresis: [
			0,
			0,
			-30,
			-30,
			-25,
			-70,
			-105,
			-15
		],
		Fograve: [
			0,
			0,
			-30,
			-30,
			-25,
			-70,
			-105,
			-15
		],
		Fohungarumlaut: [
			0,
			0,
			-30,
			-30,
			-25,
			-70,
			-105,
			-15
		],
		Fomacron: [
			0,
			0,
			-30,
			-30,
			-25,
			-70,
			-105,
			-15
		],
		Foslash: [
			0,
			0,
			-30,
			-30,
			-25,
			-70,
			-105,
			-15
		],
		Fotilde: [
			0,
			0,
			-30,
			-30,
			-25,
			-70,
			-105,
			-15
		],
		Fr: [
			0,
			0,
			-45,
			-45,
			0,
			-50,
			-55
		],
		Fracute: [
			0,
			0,
			-45,
			-45,
			0,
			-50,
			-55
		],
		Frcaron: [
			0,
			0,
			-45,
			-45,
			0,
			-50,
			-55
		],
		Frcommaaccent: [
			0,
			0,
			-45,
			-45,
			0,
			-50,
			-55
		],
		Ja: [
			0,
			0,
			-20,
			-20,
			-15,
			-40,
			-35
		],
		Jaacute: [
			0,
			0,
			-20,
			-20,
			-15,
			-40,
			-35
		],
		Jabreve: [
			0,
			0,
			-20,
			-20,
			-15,
			-40,
			-35
		],
		Jacircumflex: [
			0,
			0,
			-20,
			-20,
			-15,
			-40,
			-35
		],
		Jadieresis: [
			0,
			0,
			-20,
			-20,
			-15,
			-40,
			-35
		],
		Jagrave: [
			0,
			0,
			-20,
			-20,
			-15,
			-40,
			-35
		],
		Jamacron: [
			0,
			0,
			-20,
			-20,
			-15,
			-40,
			-35
		],
		Jaogonek: [
			0,
			0,
			-20,
			-20,
			-15,
			-40,
			-35
		],
		Jaring: [
			0,
			0,
			-20,
			-20,
			-15,
			-40,
			-35
		],
		Jatilde: [
			0,
			0,
			-20,
			-20,
			-15,
			-40,
			-35
		],
		LcaronT: [
			0,
			0,
			-110,
			-110
		],
		LcaronTcaron: [
			0,
			0,
			-110,
			-110
		],
		LcaronTcommaaccent: [
			0,
			0,
			-110,
			-110
		],
		LcaronV: [
			0,
			0,
			-110,
			-110
		],
		LcaronW: [
			0,
			0,
			-70,
			-70
		],
		LcaronY: [
			0,
			0,
			-140,
			-140
		],
		LcaronYacute: [
			0,
			0,
			-140,
			-140
		],
		LcaronYdieresis: [
			0,
			0,
			-140,
			-140
		],
		Lcaronquotedblright: [
			0,
			0,
			-140,
			-140
		],
		Lcaronquoteright: [
			0,
			0,
			-160,
			-160,
			0,
			0,
			0,
			-92
		],
		Lcarony: [
			0,
			0,
			-30,
			-30,
			0,
			0,
			0,
			-55
		],
		Lcaronyacute: [
			0,
			0,
			-30,
			-30,
			0,
			0,
			0,
			-55
		],
		Lcaronydieresis: [
			0,
			0,
			-30,
			-30,
			0,
			0,
			0,
			-55
		],
		Scomma: [
			0,
			0,
			-20,
			-20
		],
		Speriod: [
			0,
			0,
			-20,
			-20
		],
		Sacutecomma: [
			0,
			0,
			-20,
			-20
		],
		Sacuteperiod: [
			0,
			0,
			-20,
			-20
		],
		Scaroncomma: [
			0,
			0,
			-20,
			-20
		],
		Scaronperiod: [
			0,
			0,
			-20,
			-20
		],
		Scedillacomma: [
			0,
			0,
			-20,
			-20
		],
		Scedillaperiod: [
			0,
			0,
			-20,
			-20
		],
		Scommaaccentcomma: [
			0,
			0,
			-20,
			-20
		],
		Scommaaccentperiod: [
			0,
			0,
			-20,
			-20
		],
		Trcaron: [
			0,
			0,
			-120,
			-120,
			-74,
			-37,
			-55,
			-35
		],
		Tcaronrcaron: [
			0,
			0,
			-120,
			-120,
			-74,
			-37,
			-55,
			-35
		],
		Tcommaaccentrcaron: [
			0,
			0,
			-120,
			-120,
			-74,
			-37,
			-55,
			-35
		],
		Yhyphen: [
			0,
			0,
			-140,
			-140,
			-92,
			-92,
			-74,
			-111
		],
		Yi: [
			0,
			0,
			-20,
			-20,
			-37,
			-55,
			-74,
			-55
		],
		Yiacute: [
			0,
			0,
			-20,
			-20,
			-37,
			-55,
			-74,
			-55
		],
		Yiogonek: [
			0,
			0,
			-20,
			-20,
			-37,
			-55,
			-74,
			-55
		],
		Yacutehyphen: [
			0,
			0,
			-140,
			-140,
			-92,
			-92,
			-74,
			-111
		],
		Yacutei: [
			0,
			0,
			-20,
			-20,
			-37,
			-55,
			-74,
			-55
		],
		Yacuteiacute: [
			0,
			0,
			-20,
			-20,
			-37,
			-55,
			-74,
			-55
		],
		Yacuteiogonek: [
			0,
			0,
			-20,
			-20,
			-37,
			-55,
			-74,
			-55
		],
		Ydieresishyphen: [
			0,
			0,
			-140,
			-140,
			-92,
			-92,
			-74,
			-111
		],
		Ydieresisi: [
			0,
			0,
			-20,
			-20,
			-37,
			-55,
			-74,
			-55
		],
		Ydieresisiacute: [
			0,
			0,
			-20,
			-20,
			-37,
			-55,
			-74,
			-55
		],
		Ydieresisiogonek: [
			0,
			0,
			-20,
			-20,
			-37,
			-55,
			-74,
			-55
		],
		bb: [
			0,
			0,
			-10,
			-10,
			-10,
			-10
		],
		bcomma: [
			0,
			0,
			-40,
			-40
		],
		bperiod: [
			0,
			0,
			-40,
			-40,
			-40,
			-40,
			-40,
			-40
		],
		ccomma: [
			0,
			0,
			-15,
			-15
		],
		cacutecomma: [
			0,
			0,
			-15,
			-15
		],
		ccaroncomma: [
			0,
			0,
			-15,
			-15
		],
		ccedillacomma: [
			0,
			0,
			-15,
			-15
		],
		fa: [
			0,
			0,
			-30,
			-30,
			0,
			0,
			0,
			-10
		],
		faacute: [
			0,
			0,
			-30,
			-30,
			0,
			0,
			0,
			-10
		],
		fabreve: [
			0,
			0,
			-30,
			-30,
			0,
			0,
			0,
			-10
		],
		facircumflex: [
			0,
			0,
			-30,
			-30,
			0,
			0,
			0,
			-10
		],
		fadieresis: [
			0,
			0,
			-30,
			-30,
			0,
			0,
			0,
			-10
		],
		fagrave: [
			0,
			0,
			-30,
			-30,
			0,
			0,
			0,
			-10
		],
		famacron: [
			0,
			0,
			-30,
			-30,
			0,
			0,
			0,
			-10
		],
		faogonek: [
			0,
			0,
			-30,
			-30,
			0,
			0,
			0,
			-10
		],
		faring: [
			0,
			0,
			-30,
			-30,
			0,
			0,
			0,
			-10
		],
		fatilde: [
			0,
			0,
			-30,
			-30,
			0,
			0,
			0,
			-10
		],
		fdotlessi: [
			0,
			0,
			-28,
			-28,
			-35,
			-30,
			-60,
			-50
		],
		gr: [
			0,
			0,
			-10,
			-10
		],
		gracute: [
			0,
			0,
			-10,
			-10
		],
		grcaron: [
			0,
			0,
			-10,
			-10
		],
		grcommaaccent: [
			0,
			0,
			-10,
			-10
		],
		gbrever: [
			0,
			0,
			-10,
			-10
		],
		gbreveracute: [
			0,
			0,
			-10,
			-10
		],
		gbrevercaron: [
			0,
			0,
			-10,
			-10
		],
		gbrevercommaaccent: [
			0,
			0,
			-10,
			-10
		],
		gcommaaccentr: [
			0,
			0,
			-10,
			-10
		],
		gcommaaccentracute: [
			0,
			0,
			-10,
			-10
		],
		gcommaaccentrcaron: [
			0,
			0,
			-10,
			-10
		],
		gcommaaccentrcommaaccent: [
			0,
			0,
			-10,
			-10
		],
		ke: [
			0,
			0,
			-20,
			-20,
			-10,
			-30,
			-10,
			-10
		],
		keacute: [
			0,
			0,
			-20,
			-20,
			-10,
			-30,
			-10,
			-10
		],
		kecaron: [
			0,
			0,
			-20,
			-20,
			-10,
			-30,
			-10,
			-10
		],
		kecircumflex: [
			0,
			0,
			-20,
			-20,
			-10,
			-30,
			-10,
			-10
		],
		kedieresis: [
			0,
			0,
			-20,
			-20,
			-10,
			-30,
			-10,
			-10
		],
		kedotaccent: [
			0,
			0,
			-20,
			-20,
			-10,
			-30,
			-10,
			-10
		],
		kegrave: [
			0,
			0,
			-20,
			-20,
			-10,
			-30,
			-10,
			-10
		],
		kemacron: [
			0,
			0,
			-20,
			-20,
			-10,
			-30,
			-10,
			-10
		],
		keogonek: [
			0,
			0,
			-20,
			-20,
			-10,
			-30,
			-10,
			-10
		],
		kcommaaccente: [
			0,
			0,
			-20,
			-20,
			-10,
			-30,
			-10,
			-10
		],
		kcommaaccenteacute: [
			0,
			0,
			-20,
			-20,
			-10,
			-30,
			-10,
			-10
		],
		kcommaaccentecaron: [
			0,
			0,
			-20,
			-20,
			-10,
			-30,
			-10,
			-10
		],
		kcommaaccentecircumflex: [
			0,
			0,
			-20,
			-20,
			-10,
			-30,
			-10,
			-10
		],
		kcommaaccentedieresis: [
			0,
			0,
			-20,
			-20,
			-10,
			-30,
			-10,
			-10
		],
		kcommaaccentedotaccent: [
			0,
			0,
			-20,
			-20,
			-10,
			-30,
			-10,
			-10
		],
		kcommaaccentegrave: [
			0,
			0,
			-20,
			-20,
			-10,
			-30,
			-10,
			-10
		],
		kcommaaccentemacron: [
			0,
			0,
			-20,
			-20,
			-10,
			-30,
			-10,
			-10
		],
		kcommaaccenteogonek: [
			0,
			0,
			-20,
			-20,
			-10,
			-30,
			-10,
			-10
		],
		ocomma: [
			0,
			0,
			-40,
			-40
		],
		operiod: [
			0,
			0,
			-40,
			-40
		],
		oacutecomma: [
			0,
			0,
			-40,
			-40
		],
		oacuteperiod: [
			0,
			0,
			-40,
			-40
		],
		ocircumflexcomma: [
			0,
			0,
			-40,
			-40
		],
		ocircumflexperiod: [
			0,
			0,
			-40,
			-40
		],
		odieresiscomma: [
			0,
			0,
			-40,
			-40
		],
		odieresisperiod: [
			0,
			0,
			-40,
			-40
		],
		ogravecomma: [
			0,
			0,
			-40,
			-40
		],
		ograveperiod: [
			0,
			0,
			-40,
			-40
		],
		ohungarumlautcomma: [
			0,
			0,
			-40,
			-40
		],
		ohungarumlautperiod: [
			0,
			0,
			-40,
			-40
		],
		omacroncomma: [
			0,
			0,
			-40,
			-40
		],
		omacronperiod: [
			0,
			0,
			-40,
			-40
		],
		oslasha: [
			0,
			0,
			-55,
			-55
		],
		oslashaacute: [
			0,
			0,
			-55,
			-55
		],
		oslashabreve: [
			0,
			0,
			-55,
			-55
		],
		oslashacircumflex: [
			0,
			0,
			-55,
			-55
		],
		oslashadieresis: [
			0,
			0,
			-55,
			-55
		],
		oslashagrave: [
			0,
			0,
			-55,
			-55
		],
		oslashamacron: [
			0,
			0,
			-55,
			-55
		],
		oslashaogonek: [
			0,
			0,
			-55,
			-55
		],
		oslasharing: [
			0,
			0,
			-55,
			-55
		],
		oslashatilde: [
			0,
			0,
			-55,
			-55
		],
		oslashb: [
			0,
			0,
			-55,
			-55
		],
		oslashc: [
			0,
			0,
			-55,
			-55
		],
		oslashcacute: [
			0,
			0,
			-55,
			-55
		],
		oslashccaron: [
			0,
			0,
			-55,
			-55
		],
		oslashccedilla: [
			0,
			0,
			-55,
			-55
		],
		oslashcomma: [
			0,
			0,
			-95,
			-95
		],
		oslashd: [
			0,
			0,
			-55,
			-55
		],
		oslashdcroat: [
			0,
			0,
			-55,
			-55
		],
		oslashe: [
			0,
			0,
			-55,
			-55
		],
		oslasheacute: [
			0,
			0,
			-55,
			-55
		],
		oslashecaron: [
			0,
			0,
			-55,
			-55
		],
		oslashecircumflex: [
			0,
			0,
			-55,
			-55
		],
		oslashedieresis: [
			0,
			0,
			-55,
			-55
		],
		oslashedotaccent: [
			0,
			0,
			-55,
			-55
		],
		oslashegrave: [
			0,
			0,
			-55,
			-55
		],
		oslashemacron: [
			0,
			0,
			-55,
			-55
		],
		oslasheogonek: [
			0,
			0,
			-55,
			-55
		],
		oslashf: [
			0,
			0,
			-55,
			-55
		],
		oslashg: [
			0,
			0,
			-55,
			-55,
			0,
			0,
			-10
		],
		oslashgbreve: [
			0,
			0,
			-55,
			-55,
			0,
			0,
			-10
		],
		oslashgcommaaccent: [
			0,
			0,
			-55,
			-55,
			0,
			0,
			-10
		],
		oslashh: [
			0,
			0,
			-55,
			-55
		],
		oslashi: [
			0,
			0,
			-55,
			-55
		],
		oslashiacute: [
			0,
			0,
			-55,
			-55
		],
		oslashicircumflex: [
			0,
			0,
			-55,
			-55
		],
		oslashidieresis: [
			0,
			0,
			-55,
			-55
		],
		oslashigrave: [
			0,
			0,
			-55,
			-55
		],
		oslashimacron: [
			0,
			0,
			-55,
			-55
		],
		oslashiogonek: [
			0,
			0,
			-55,
			-55
		],
		oslashj: [
			0,
			0,
			-55,
			-55
		],
		oslashk: [
			0,
			0,
			-55,
			-55
		],
		oslashkcommaaccent: [
			0,
			0,
			-55,
			-55
		],
		oslashl: [
			0,
			0,
			-55,
			-55
		],
		oslashlacute: [
			0,
			0,
			-55,
			-55
		],
		oslashlcommaaccent: [
			0,
			0,
			-55,
			-55
		],
		oslashlslash: [
			0,
			0,
			-55,
			-55
		],
		oslashm: [
			0,
			0,
			-55,
			-55
		],
		oslashn: [
			0,
			0,
			-55,
			-55
		],
		oslashnacute: [
			0,
			0,
			-55,
			-55
		],
		oslashncaron: [
			0,
			0,
			-55,
			-55
		],
		oslashncommaaccent: [
			0,
			0,
			-55,
			-55
		],
		oslashntilde: [
			0,
			0,
			-55,
			-55
		],
		oslasho: [
			0,
			0,
			-55,
			-55
		],
		oslashoacute: [
			0,
			0,
			-55,
			-55
		],
		oslashocircumflex: [
			0,
			0,
			-55,
			-55
		],
		oslashodieresis: [
			0,
			0,
			-55,
			-55
		],
		oslashograve: [
			0,
			0,
			-55,
			-55
		],
		oslashohungarumlaut: [
			0,
			0,
			-55,
			-55
		],
		oslashomacron: [
			0,
			0,
			-55,
			-55
		],
		oslashoslash: [
			0,
			0,
			-55,
			-55
		],
		oslashotilde: [
			0,
			0,
			-55,
			-55
		],
		oslashp: [
			0,
			0,
			-55,
			-55
		],
		oslashperiod: [
			0,
			0,
			-95,
			-95
		],
		oslashq: [
			0,
			0,
			-55,
			-55
		],
		oslashr: [
			0,
			0,
			-55,
			-55
		],
		oslashracute: [
			0,
			0,
			-55,
			-55
		],
		oslashrcaron: [
			0,
			0,
			-55,
			-55
		],
		oslashrcommaaccent: [
			0,
			0,
			-55,
			-55
		],
		oslashs: [
			0,
			0,
			-55,
			-55
		],
		oslashsacute: [
			0,
			0,
			-55,
			-55
		],
		oslashscaron: [
			0,
			0,
			-55,
			-55
		],
		oslashscedilla: [
			0,
			0,
			-55,
			-55
		],
		oslashscommaaccent: [
			0,
			0,
			-55,
			-55
		],
		oslasht: [
			0,
			0,
			-55,
			-55
		],
		oslashtcommaaccent: [
			0,
			0,
			-55,
			-55
		],
		oslashu: [
			0,
			0,
			-55,
			-55
		],
		oslashuacute: [
			0,
			0,
			-55,
			-55
		],
		oslashucircumflex: [
			0,
			0,
			-55,
			-55
		],
		oslashudieresis: [
			0,
			0,
			-55,
			-55
		],
		oslashugrave: [
			0,
			0,
			-55,
			-55
		],
		oslashuhungarumlaut: [
			0,
			0,
			-55,
			-55
		],
		oslashumacron: [
			0,
			0,
			-55,
			-55
		],
		oslashuogonek: [
			0,
			0,
			-55,
			-55
		],
		oslashuring: [
			0,
			0,
			-55,
			-55
		],
		oslashz: [
			0,
			0,
			-55,
			-55
		],
		oslashzacute: [
			0,
			0,
			-55,
			-55
		],
		oslashzcaron: [
			0,
			0,
			-55,
			-55
		],
		oslashzdotaccent: [
			0,
			0,
			-55,
			-55
		],
		otildecomma: [
			0,
			0,
			-40,
			-40
		],
		otildeperiod: [
			0,
			0,
			-40,
			-40
		],
		pcomma: [
			0,
			0,
			-35,
			-35
		],
		pperiod: [
			0,
			0,
			-35,
			-35
		],
		ra: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		raacute: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		rabreve: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		racircumflex: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		radieresis: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		ragrave: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		ramacron: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		raogonek: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		raring: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		ratilde: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		rcolon: [
			0,
			0,
			30,
			30
		],
		ri: [
			0,
			0,
			15,
			15
		],
		riacute: [
			0,
			0,
			15,
			15
		],
		ricircumflex: [
			0,
			0,
			15,
			15
		],
		ridieresis: [
			0,
			0,
			15,
			15
		],
		rigrave: [
			0,
			0,
			15,
			15
		],
		rimacron: [
			0,
			0,
			15,
			15
		],
		riogonek: [
			0,
			0,
			15,
			15
		],
		rk: [
			0,
			0,
			15,
			15
		],
		rkcommaaccent: [
			0,
			0,
			15,
			15
		],
		rl: [
			0,
			0,
			15,
			15
		],
		rlacute: [
			0,
			0,
			15,
			15
		],
		rlcommaaccent: [
			0,
			0,
			15,
			15
		],
		rlslash: [
			0,
			0,
			15,
			15
		],
		rm: [
			0,
			0,
			25,
			25
		],
		rn: [
			0,
			0,
			25,
			25,
			-15
		],
		rnacute: [
			0,
			0,
			25,
			25,
			-15
		],
		rncaron: [
			0,
			0,
			25,
			25,
			-15
		],
		rncommaaccent: [
			0,
			0,
			25,
			25,
			-15
		],
		rntilde: [
			0,
			0,
			25,
			25,
			-15
		],
		rp: [
			0,
			0,
			30,
			30,
			-10
		],
		rsemicolon: [
			0,
			0,
			30,
			30
		],
		ru: [
			0,
			0,
			15,
			15
		],
		ruacute: [
			0,
			0,
			15,
			15
		],
		rucircumflex: [
			0,
			0,
			15,
			15
		],
		rudieresis: [
			0,
			0,
			15,
			15
		],
		rugrave: [
			0,
			0,
			15,
			15
		],
		ruhungarumlaut: [
			0,
			0,
			15,
			15
		],
		rumacron: [
			0,
			0,
			15,
			15
		],
		ruogonek: [
			0,
			0,
			15,
			15
		],
		ruring: [
			0,
			0,
			15,
			15
		],
		racutea: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		racuteaacute: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		racuteabreve: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		racuteacircumflex: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		racuteadieresis: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		racuteagrave: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		racuteamacron: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		racuteaogonek: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		racutearing: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		racuteatilde: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		racutecolon: [
			0,
			0,
			30,
			30
		],
		racutei: [
			0,
			0,
			15,
			15
		],
		racuteiacute: [
			0,
			0,
			15,
			15
		],
		racuteicircumflex: [
			0,
			0,
			15,
			15
		],
		racuteidieresis: [
			0,
			0,
			15,
			15
		],
		racuteigrave: [
			0,
			0,
			15,
			15
		],
		racuteimacron: [
			0,
			0,
			15,
			15
		],
		racuteiogonek: [
			0,
			0,
			15,
			15
		],
		racutek: [
			0,
			0,
			15,
			15
		],
		racutekcommaaccent: [
			0,
			0,
			15,
			15
		],
		racutel: [
			0,
			0,
			15,
			15
		],
		racutelacute: [
			0,
			0,
			15,
			15
		],
		racutelcommaaccent: [
			0,
			0,
			15,
			15
		],
		racutelslash: [
			0,
			0,
			15,
			15
		],
		racutem: [
			0,
			0,
			25,
			25
		],
		racuten: [
			0,
			0,
			25,
			25,
			-15
		],
		racutenacute: [
			0,
			0,
			25,
			25,
			-15
		],
		racutencaron: [
			0,
			0,
			25,
			25,
			-15
		],
		racutencommaaccent: [
			0,
			0,
			25,
			25,
			-15
		],
		racutentilde: [
			0,
			0,
			25,
			25,
			-15
		],
		racutep: [
			0,
			0,
			30,
			30,
			-10
		],
		racutesemicolon: [
			0,
			0,
			30,
			30
		],
		racuteu: [
			0,
			0,
			15,
			15
		],
		racuteuacute: [
			0,
			0,
			15,
			15
		],
		racuteucircumflex: [
			0,
			0,
			15,
			15
		],
		racuteudieresis: [
			0,
			0,
			15,
			15
		],
		racuteugrave: [
			0,
			0,
			15,
			15
		],
		racuteuhungarumlaut: [
			0,
			0,
			15,
			15
		],
		racuteumacron: [
			0,
			0,
			15,
			15
		],
		racuteuogonek: [
			0,
			0,
			15,
			15
		],
		racuteuring: [
			0,
			0,
			15,
			15
		],
		rcarona: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		rcaronaacute: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		rcaronabreve: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		rcaronacircumflex: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		rcaronadieresis: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		rcaronagrave: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		rcaronamacron: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		rcaronaogonek: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		rcaronaring: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		rcaronatilde: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		rcaroncolon: [
			0,
			0,
			30,
			30
		],
		rcaroni: [
			0,
			0,
			15,
			15
		],
		rcaroniacute: [
			0,
			0,
			15,
			15
		],
		rcaronicircumflex: [
			0,
			0,
			15,
			15
		],
		rcaronidieresis: [
			0,
			0,
			15,
			15
		],
		rcaronigrave: [
			0,
			0,
			15,
			15
		],
		rcaronimacron: [
			0,
			0,
			15,
			15
		],
		rcaroniogonek: [
			0,
			0,
			15,
			15
		],
		rcaronk: [
			0,
			0,
			15,
			15
		],
		rcaronkcommaaccent: [
			0,
			0,
			15,
			15
		],
		rcaronl: [
			0,
			0,
			15,
			15
		],
		rcaronlacute: [
			0,
			0,
			15,
			15
		],
		rcaronlcommaaccent: [
			0,
			0,
			15,
			15
		],
		rcaronlslash: [
			0,
			0,
			15,
			15
		],
		rcaronm: [
			0,
			0,
			25,
			25
		],
		rcaronn: [
			0,
			0,
			25,
			25,
			-15
		],
		rcaronnacute: [
			0,
			0,
			25,
			25,
			-15
		],
		rcaronncaron: [
			0,
			0,
			25,
			25,
			-15
		],
		rcaronncommaaccent: [
			0,
			0,
			25,
			25,
			-15
		],
		rcaronntilde: [
			0,
			0,
			25,
			25,
			-15
		],
		rcaronp: [
			0,
			0,
			30,
			30,
			-10
		],
		rcaronsemicolon: [
			0,
			0,
			30,
			30
		],
		rcaronu: [
			0,
			0,
			15,
			15
		],
		rcaronuacute: [
			0,
			0,
			15,
			15
		],
		rcaronucircumflex: [
			0,
			0,
			15,
			15
		],
		rcaronudieresis: [
			0,
			0,
			15,
			15
		],
		rcaronugrave: [
			0,
			0,
			15,
			15
		],
		rcaronuhungarumlaut: [
			0,
			0,
			15,
			15
		],
		rcaronumacron: [
			0,
			0,
			15,
			15
		],
		rcaronuogonek: [
			0,
			0,
			15,
			15
		],
		rcaronuring: [
			0,
			0,
			15,
			15
		],
		rcommaaccenta: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		rcommaaccentaacute: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		rcommaaccentabreve: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		rcommaaccentacircumflex: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		rcommaaccentadieresis: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		rcommaaccentagrave: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		rcommaaccentamacron: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		rcommaaccentaogonek: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		rcommaaccentaring: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		rcommaaccentatilde: [
			0,
			0,
			-10,
			-10,
			0,
			0,
			-15
		],
		rcommaaccentcolon: [
			0,
			0,
			30,
			30
		],
		rcommaaccenti: [
			0,
			0,
			15,
			15
		],
		rcommaaccentiacute: [
			0,
			0,
			15,
			15
		],
		rcommaaccenticircumflex: [
			0,
			0,
			15,
			15
		],
		rcommaaccentidieresis: [
			0,
			0,
			15,
			15
		],
		rcommaaccentigrave: [
			0,
			0,
			15,
			15
		],
		rcommaaccentimacron: [
			0,
			0,
			15,
			15
		],
		rcommaaccentiogonek: [
			0,
			0,
			15,
			15
		],
		rcommaaccentk: [
			0,
			0,
			15,
			15
		],
		rcommaaccentkcommaaccent: [
			0,
			0,
			15,
			15
		],
		rcommaaccentl: [
			0,
			0,
			15,
			15
		],
		rcommaaccentlacute: [
			0,
			0,
			15,
			15
		],
		rcommaaccentlcommaaccent: [
			0,
			0,
			15,
			15
		],
		rcommaaccentlslash: [
			0,
			0,
			15,
			15
		],
		rcommaaccentm: [
			0,
			0,
			25,
			25
		],
		rcommaaccentn: [
			0,
			0,
			25,
			25,
			-15
		],
		rcommaaccentnacute: [
			0,
			0,
			25,
			25,
			-15
		],
		rcommaaccentncaron: [
			0,
			0,
			25,
			25,
			-15
		],
		rcommaaccentncommaaccent: [
			0,
			0,
			25,
			25,
			-15
		],
		rcommaaccentntilde: [
			0,
			0,
			25,
			25,
			-15
		],
		rcommaaccentp: [
			0,
			0,
			30,
			30,
			-10
		],
		rcommaaccentsemicolon: [
			0,
			0,
			30,
			30
		],
		rcommaaccentu: [
			0,
			0,
			15,
			15
		],
		rcommaaccentuacute: [
			0,
			0,
			15,
			15
		],
		rcommaaccentucircumflex: [
			0,
			0,
			15,
			15
		],
		rcommaaccentudieresis: [
			0,
			0,
			15,
			15
		],
		rcommaaccentugrave: [
			0,
			0,
			15,
			15
		],
		rcommaaccentuhungarumlaut: [
			0,
			0,
			15,
			15
		],
		rcommaaccentumacron: [
			0,
			0,
			15,
			15
		],
		rcommaaccentuogonek: [
			0,
			0,
			15,
			15
		],
		rcommaaccenturing: [
			0,
			0,
			15,
			15
		],
		scomma: [
			0,
			0,
			-15,
			-15
		],
		speriod: [
			0,
			0,
			-15,
			-15
		],
		sacutecomma: [
			0,
			0,
			-15,
			-15
		],
		sacuteperiod: [
			0,
			0,
			-15,
			-15
		],
		scaroncomma: [
			0,
			0,
			-15,
			-15
		],
		scaronperiod: [
			0,
			0,
			-15,
			-15
		],
		scedillacomma: [
			0,
			0,
			-15,
			-15
		],
		scedillaperiod: [
			0,
			0,
			-15,
			-15
		],
		scommaaccentcomma: [
			0,
			0,
			-15,
			-15
		],
		scommaaccentperiod: [
			0,
			0,
			-15,
			-15
		],
		ve: [
			0,
			0,
			-25,
			-25,
			-10,
			-15,
			0,
			-15
		],
		veacute: [
			0,
			0,
			-25,
			-25,
			-10,
			-15,
			0,
			-15
		],
		vecaron: [
			0,
			0,
			-25,
			-25,
			-10,
			-15,
			0,
			-15
		],
		vecircumflex: [
			0,
			0,
			-25,
			-25,
			-10,
			-15,
			0,
			-15
		],
		vedieresis: [
			0,
			0,
			-25,
			-25,
			-10,
			-15,
			0,
			-15
		],
		vedotaccent: [
			0,
			0,
			-25,
			-25,
			-10,
			-15,
			0,
			-15
		],
		vegrave: [
			0,
			0,
			-25,
			-25,
			-10,
			-15,
			0,
			-15
		],
		vemacron: [
			0,
			0,
			-25,
			-25,
			-10,
			-15,
			0,
			-15
		],
		veogonek: [
			0,
			0,
			-25,
			-25,
			-10,
			-15,
			0,
			-15
		],
		wa: [
			0,
			0,
			-15,
			-15,
			0,
			-10,
			0,
			-10
		],
		waacute: [
			0,
			0,
			-15,
			-15,
			0,
			-10,
			0,
			-10
		],
		wabreve: [
			0,
			0,
			-15,
			-15,
			0,
			-10,
			0,
			-10
		],
		wacircumflex: [
			0,
			0,
			-15,
			-15,
			0,
			-10,
			0,
			-10
		],
		wadieresis: [
			0,
			0,
			-15,
			-15,
			0,
			-10,
			0,
			-10
		],
		wagrave: [
			0,
			0,
			-15,
			-15,
			0,
			-10,
			0,
			-10
		],
		wamacron: [
			0,
			0,
			-15,
			-15,
			0,
			-10,
			0,
			-10
		],
		waogonek: [
			0,
			0,
			-15,
			-15,
			0,
			-10,
			0,
			-10
		],
		waring: [
			0,
			0,
			-15,
			-15,
			0,
			-10,
			0,
			-10
		],
		watilde: [
			0,
			0,
			-15,
			-15,
			0,
			-10,
			0,
			-10
		],
		we: [
			0,
			0,
			-10,
			-10,
			0,
			-10
		],
		weacute: [
			0,
			0,
			-10,
			-10,
			0,
			-10
		],
		wecaron: [
			0,
			0,
			-10,
			-10,
			0,
			-10
		],
		wecircumflex: [
			0,
			0,
			-10,
			-10,
			0,
			-10
		],
		wedieresis: [
			0,
			0,
			-10,
			-10,
			0,
			-10
		],
		wedotaccent: [
			0,
			0,
			-10,
			-10,
			0,
			-10
		],
		wegrave: [
			0,
			0,
			-10,
			-10,
			0,
			-10
		],
		wemacron: [
			0,
			0,
			-10,
			-10,
			0,
			-10
		],
		weogonek: [
			0,
			0,
			-10,
			-10,
			0,
			-10
		],
		zo: [
			0,
			0,
			-15,
			-15
		],
		zoacute: [
			0,
			0,
			-15,
			-15
		],
		zocircumflex: [
			0,
			0,
			-15,
			-15
		],
		zodieresis: [
			0,
			0,
			-15,
			-15
		],
		zograve: [
			0,
			0,
			-15,
			-15
		],
		zohungarumlaut: [
			0,
			0,
			-15,
			-15
		],
		zomacron: [
			0,
			0,
			-15,
			-15
		],
		zoslash: [
			0,
			0,
			-15,
			-15
		],
		zotilde: [
			0,
			0,
			-15,
			-15
		],
		zacuteo: [
			0,
			0,
			-15,
			-15
		],
		zacuteoacute: [
			0,
			0,
			-15,
			-15
		],
		zacuteocircumflex: [
			0,
			0,
			-15,
			-15
		],
		zacuteodieresis: [
			0,
			0,
			-15,
			-15
		],
		zacuteograve: [
			0,
			0,
			-15,
			-15
		],
		zacuteohungarumlaut: [
			0,
			0,
			-15,
			-15
		],
		zacuteomacron: [
			0,
			0,
			-15,
			-15
		],
		zacuteoslash: [
			0,
			0,
			-15,
			-15
		],
		zacuteotilde: [
			0,
			0,
			-15,
			-15
		],
		zcarono: [
			0,
			0,
			-15,
			-15
		],
		zcaronoacute: [
			0,
			0,
			-15,
			-15
		],
		zcaronocircumflex: [
			0,
			0,
			-15,
			-15
		],
		zcaronodieresis: [
			0,
			0,
			-15,
			-15
		],
		zcaronograve: [
			0,
			0,
			-15,
			-15
		],
		zcaronohungarumlaut: [
			0,
			0,
			-15,
			-15
		],
		zcaronomacron: [
			0,
			0,
			-15,
			-15
		],
		zcaronoslash: [
			0,
			0,
			-15,
			-15
		],
		zcaronotilde: [
			0,
			0,
			-15,
			-15
		],
		zdotaccento: [
			0,
			0,
			-15,
			-15
		],
		zdotaccentoacute: [
			0,
			0,
			-15,
			-15
		],
		zdotaccentocircumflex: [
			0,
			0,
			-15,
			-15
		],
		zdotaccentodieresis: [
			0,
			0,
			-15,
			-15
		],
		zdotaccentograve: [
			0,
			0,
			-15,
			-15
		],
		zdotaccentohungarumlaut: [
			0,
			0,
			-15,
			-15
		],
		zdotaccentomacron: [
			0,
			0,
			-15,
			-15
		],
		zdotaccentoslash: [
			0,
			0,
			-15,
			-15
		],
		zdotaccentotilde: [
			0,
			0,
			-15,
			-15
		],
		Ap: [
			0,
			0,
			0,
			0,
			-25
		],
		Aquoteright: [
			0,
			0,
			0,
			0,
			-74,
			-74,
			-37,
			-111
		],
		Aacutep: [
			0,
			0,
			0,
			0,
			-25
		],
		Aacutequoteright: [
			0,
			0,
			0,
			0,
			-74,
			-74,
			-37,
			-111
		],
		Abrevep: [
			0,
			0,
			0,
			0,
			-25
		],
		Abrevequoteright: [
			0,
			0,
			0,
			0,
			-74,
			-74,
			-37,
			-111
		],
		Acircumflexp: [
			0,
			0,
			0,
			0,
			-25
		],
		Acircumflexquoteright: [
			0,
			0,
			0,
			0,
			-74,
			-74,
			-37,
			-111
		],
		Adieresisp: [
			0,
			0,
			0,
			0,
			-25
		],
		Adieresisquoteright: [
			0,
			0,
			0,
			0,
			-74,
			-74,
			-37,
			-111
		],
		Agravep: [
			0,
			0,
			0,
			0,
			-25
		],
		Agravequoteright: [
			0,
			0,
			0,
			0,
			-74,
			-74,
			-37,
			-111
		],
		Amacronp: [
			0,
			0,
			0,
			0,
			-25
		],
		Amacronquoteright: [
			0,
			0,
			0,
			0,
			-74,
			-74,
			-37,
			-111
		],
		Aogonekp: [
			0,
			0,
			0,
			0,
			-25
		],
		Aogonekquoteright: [
			0,
			0,
			0,
			0,
			-74,
			-74,
			-37,
			-111
		],
		Aringp: [
			0,
			0,
			0,
			0,
			-25
		],
		Aringquoteright: [
			0,
			0,
			0,
			0,
			-74,
			-74,
			-37,
			-111
		],
		Atildep: [
			0,
			0,
			0,
			0,
			-25
		],
		Atildequoteright: [
			0,
			0,
			0,
			0,
			-74,
			-74,
			-37,
			-111
		],
		Je: [
			0,
			0,
			0,
			0,
			-15,
			-40,
			-25
		],
		Jeacute: [
			0,
			0,
			0,
			0,
			-15,
			-40,
			-25
		],
		Jecaron: [
			0,
			0,
			0,
			0,
			-15,
			-40,
			-25
		],
		Jecircumflex: [
			0,
			0,
			0,
			0,
			-15,
			-40,
			-25
		],
		Jedieresis: [
			0,
			0,
			0,
			0,
			-15,
			-40,
			-25
		],
		Jedotaccent: [
			0,
			0,
			0,
			0,
			-15,
			-40,
			-25
		],
		Jegrave: [
			0,
			0,
			0,
			0,
			-15,
			-40,
			-25
		],
		Jemacron: [
			0,
			0,
			0,
			0,
			-15,
			-40,
			-25
		],
		Jeogonek: [
			0,
			0,
			0,
			0,
			-15,
			-40,
			-25
		],
		Jo: [
			0,
			0,
			0,
			0,
			-15,
			-40,
			-25
		],
		Joacute: [
			0,
			0,
			0,
			0,
			-15,
			-40,
			-25
		],
		Jocircumflex: [
			0,
			0,
			0,
			0,
			-15,
			-40,
			-25
		],
		Jodieresis: [
			0,
			0,
			0,
			0,
			-15,
			-40,
			-25
		],
		Jograve: [
			0,
			0,
			0,
			0,
			-15,
			-40,
			-25
		],
		Johungarumlaut: [
			0,
			0,
			0,
			0,
			-15,
			-40,
			-25
		],
		Jomacron: [
			0,
			0,
			0,
			0,
			-15,
			-40,
			-25
		],
		Joslash: [
			0,
			0,
			0,
			0,
			-15,
			-40,
			-25
		],
		Jotilde: [
			0,
			0,
			0,
			0,
			-15,
			-40,
			-25
		],
		NA: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NAacute: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NAbreve: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NAcircumflex: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NAdieresis: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NAgrave: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NAmacron: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NAogonek: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NAring: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NAtilde: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NacuteA: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NacuteAacute: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NacuteAbreve: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NacuteAcircumflex: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NacuteAdieresis: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NacuteAgrave: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NacuteAmacron: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NacuteAogonek: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NacuteAring: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NacuteAtilde: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NcaronA: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NcaronAacute: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NcaronAbreve: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NcaronAcircumflex: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NcaronAdieresis: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NcaronAgrave: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NcaronAmacron: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NcaronAogonek: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NcaronAring: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NcaronAtilde: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NcommaaccentA: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NcommaaccentAacute: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NcommaaccentAbreve: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NcommaaccentAcircumflex: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NcommaaccentAdieresis: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NcommaaccentAgrave: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NcommaaccentAmacron: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NcommaaccentAogonek: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NcommaaccentAring: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NcommaaccentAtilde: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NtildeA: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NtildeAacute: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NtildeAbreve: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NtildeAcircumflex: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NtildeAdieresis: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NtildeAgrave: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NtildeAmacron: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NtildeAogonek: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NtildeAring: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		NtildeAtilde: [
			0,
			0,
			0,
			0,
			-20,
			-30,
			-27,
			-35
		],
		Ti: [
			0,
			0,
			0,
			0,
			-18,
			-37,
			-55,
			-35
		],
		Tiacute: [
			0,
			0,
			0,
			0,
			-18,
			-37,
			-55,
			-35
		],
		Tiogonek: [
			0,
			0,
			0,
			0,
			-18,
			-37,
			-55,
			-35
		],
		Tcaroni: [
			0,
			0,
			0,
			0,
			-18,
			-37,
			-55,
			-35
		],
		Tcaroniacute: [
			0,
			0,
			0,
			0,
			-18,
			-37,
			-55,
			-35
		],
		Tcaroniogonek: [
			0,
			0,
			0,
			0,
			-18,
			-37,
			-55,
			-35
		],
		Tcommaaccenti: [
			0,
			0,
			0,
			0,
			-18,
			-37,
			-55,
			-35
		],
		Tcommaaccentiacute: [
			0,
			0,
			0,
			0,
			-18,
			-37,
			-55,
			-35
		],
		Tcommaaccentiogonek: [
			0,
			0,
			0,
			0,
			-18,
			-37,
			-55,
			-35
		],
		Vi: [
			0,
			0,
			0,
			0,
			-37,
			-55,
			-74,
			-60
		],
		Viacute: [
			0,
			0,
			0,
			0,
			-37,
			-55,
			-74,
			-60
		],
		Vicircumflex: [
			0,
			0,
			0,
			0,
			-37,
			0,
			-34,
			-20
		],
		Vidieresis: [
			0,
			0,
			0,
			0,
			-37,
			0,
			-34,
			-20
		],
		Vigrave: [
			0,
			0,
			0,
			0,
			-37,
			0,
			-34,
			-20
		],
		Vimacron: [
			0,
			0,
			0,
			0,
			-37,
			0,
			-34,
			-20
		],
		Viogonek: [
			0,
			0,
			0,
			0,
			-37,
			-55,
			-74,
			-60
		],
		Wi: [
			0,
			0,
			0,
			0,
			-18,
			-37,
			-55,
			-40
		],
		Wiacute: [
			0,
			0,
			0,
			0,
			-18,
			-37,
			-55,
			-40
		],
		Wiogonek: [
			0,
			0,
			0,
			0,
			-18,
			-37,
			-55,
			-40
		],
		fi: [
			0,
			0,
			0,
			0,
			-25,
			0,
			-20,
			-20
		],
		gperiod: [
			0,
			0,
			0,
			0,
			-15,
			0,
			-15
		],
		gbreveperiod: [
			0,
			0,
			0,
			0,
			-15,
			0,
			-15
		],
		gcommaaccentperiod: [
			0,
			0,
			0,
			0,
			-15,
			0,
			-15
		],
		iv: [
			0,
			0,
			0,
			0,
			-10,
			0,
			0,
			-25
		],
		iacutev: [
			0,
			0,
			0,
			0,
			-10,
			0,
			0,
			-25
		],
		icircumflexv: [
			0,
			0,
			0,
			0,
			-10,
			0,
			0,
			-25
		],
		idieresisv: [
			0,
			0,
			0,
			0,
			-10,
			0,
			0,
			-25
		],
		igravev: [
			0,
			0,
			0,
			0,
			-10,
			0,
			0,
			-25
		],
		imacronv: [
			0,
			0,
			0,
			0,
			-10,
			0,
			0,
			-25
		],
		iogonekv: [
			0,
			0,
			0,
			0,
			-10,
			0,
			0,
			-25
		],
		ky: [
			0,
			0,
			0,
			0,
			-15,
			0,
			-10,
			-15
		],
		kyacute: [
			0,
			0,
			0,
			0,
			-15,
			0,
			-10,
			-15
		],
		kydieresis: [
			0,
			0,
			0,
			0,
			-15,
			0,
			-10,
			-15
		],
		kcommaaccenty: [
			0,
			0,
			0,
			0,
			-15,
			0,
			-10,
			-15
		],
		kcommaaccentyacute: [
			0,
			0,
			0,
			0,
			-15,
			0,
			-10,
			-15
		],
		kcommaaccentydieresis: [
			0,
			0,
			0,
			0,
			-15,
			0,
			-10,
			-15
		],
		quotedblleftA: [
			0,
			0,
			0,
			0,
			-10,
			0,
			0,
			-80
		],
		quotedblleftAacute: [
			0,
			0,
			0,
			0,
			-10,
			0,
			0,
			-80
		],
		quotedblleftAbreve: [
			0,
			0,
			0,
			0,
			-10,
			0,
			0,
			-80
		],
		quotedblleftAcircumflex: [
			0,
			0,
			0,
			0,
			-10,
			0,
			0,
			-80
		],
		quotedblleftAdieresis: [
			0,
			0,
			0,
			0,
			-10,
			0,
			0,
			-80
		],
		quotedblleftAgrave: [
			0,
			0,
			0,
			0,
			-10,
			0,
			0,
			-80
		],
		quotedblleftAmacron: [
			0,
			0,
			0,
			0,
			-10,
			0,
			0,
			-80
		],
		quotedblleftAogonek: [
			0,
			0,
			0,
			0,
			-10,
			0,
			0,
			-80
		],
		quotedblleftAring: [
			0,
			0,
			0,
			0,
			-10,
			0,
			0,
			-80
		],
		quotedblleftAtilde: [
			0,
			0,
			0,
			0,
			-10,
			0,
			0,
			-80
		],
		quoteleftA: [
			0,
			0,
			0,
			0,
			-10,
			0,
			0,
			-80
		],
		quoteleftAacute: [
			0,
			0,
			0,
			0,
			-10,
			0,
			0,
			-80
		],
		quoteleftAbreve: [
			0,
			0,
			0,
			0,
			-10,
			0,
			0,
			-80
		],
		quoteleftAcircumflex: [
			0,
			0,
			0,
			0,
			-10,
			0,
			0,
			-80
		],
		quoteleftAdieresis: [
			0,
			0,
			0,
			0,
			-10,
			0,
			0,
			-80
		],
		quoteleftAgrave: [
			0,
			0,
			0,
			0,
			-10,
			0,
			0,
			-80
		],
		quoteleftAmacron: [
			0,
			0,
			0,
			0,
			-10,
			0,
			0,
			-80
		],
		quoteleftAogonek: [
			0,
			0,
			0,
			0,
			-10,
			0,
			0,
			-80
		],
		quoteleftAring: [
			0,
			0,
			0,
			0,
			-10,
			0,
			0,
			-80
		],
		quoteleftAtilde: [
			0,
			0,
			0,
			0,
			-10,
			0,
			0,
			-80
		],
		re: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		reacute: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		recaron: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		recircumflex: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		redieresis: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		redotaccent: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		regrave: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		remacron: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		reogonek: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		racutee: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		racuteeacute: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		racuteecaron: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		racuteecircumflex: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		racuteedieresis: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		racuteedotaccent: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		racuteegrave: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		racuteemacron: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		racuteeogonek: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		rcarone: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		rcaroneacute: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		rcaronecaron: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		rcaronecircumflex: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		rcaronedieresis: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		rcaronedotaccent: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		rcaronegrave: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		rcaronemacron: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		rcaroneogonek: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		rcommaaccente: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		rcommaaccenteacute: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		rcommaaccentecaron: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		rcommaaccentecircumflex: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		rcommaaccentedieresis: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		rcommaaccentedotaccent: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		rcommaaccentegrave: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		rcommaaccentemacron: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		rcommaaccenteogonek: [
			0,
			0,
			0,
			0,
			-18,
			0,
			-37
		],
		spaceA: [
			0,
			0,
			0,
			0,
			-55,
			-37,
			-18,
			-55
		],
		spaceAacute: [
			0,
			0,
			0,
			0,
			-55,
			-37,
			-18,
			-55
		],
		spaceAbreve: [
			0,
			0,
			0,
			0,
			-55,
			-37,
			-18,
			-55
		],
		spaceAcircumflex: [
			0,
			0,
			0,
			0,
			-55,
			-37,
			-18,
			-55
		],
		spaceAdieresis: [
			0,
			0,
			0,
			0,
			-55,
			-37,
			-18,
			-55
		],
		spaceAgrave: [
			0,
			0,
			0,
			0,
			-55,
			-37,
			-18,
			-55
		],
		spaceAmacron: [
			0,
			0,
			0,
			0,
			-55,
			-37,
			-18,
			-55
		],
		spaceAogonek: [
			0,
			0,
			0,
			0,
			-55,
			-37,
			-18,
			-55
		],
		spaceAring: [
			0,
			0,
			0,
			0,
			-55,
			-37,
			-18,
			-55
		],
		spaceAtilde: [
			0,
			0,
			0,
			0,
			-55,
			-37,
			-18,
			-55
		],
		Fi: [
			0,
			0,
			0,
			0,
			0,
			-40,
			-45
		],
		Fiacute: [
			0,
			0,
			0,
			0,
			0,
			-40,
			-45
		],
		Ficircumflex: [
			0,
			0,
			0,
			0,
			0,
			-40,
			-45
		],
		Fidieresis: [
			0,
			0,
			0,
			0,
			0,
			-40,
			-45
		],
		Figrave: [
			0,
			0,
			0,
			0,
			0,
			-40,
			-45
		],
		Fimacron: [
			0,
			0,
			0,
			0,
			0,
			-40,
			-45
		],
		Fiogonek: [
			0,
			0,
			0,
			0,
			0,
			-40,
			-45
		],
		eb: [
			0,
			0,
			0,
			0,
			0,
			-10
		],
		eacuteb: [
			0,
			0,
			0,
			0,
			0,
			-10
		],
		ecaronb: [
			0,
			0,
			0,
			0,
			0,
			-10
		],
		ecircumflexb: [
			0,
			0,
			0,
			0,
			0,
			-10
		],
		edieresisb: [
			0,
			0,
			0,
			0,
			0,
			-10
		],
		edotaccentb: [
			0,
			0,
			0,
			0,
			0,
			-10
		],
		egraveb: [
			0,
			0,
			0,
			0,
			0,
			-10
		],
		emacronb: [
			0,
			0,
			0,
			0,
			0,
			-10
		],
		eogonekb: [
			0,
			0,
			0,
			0,
			0,
			-10
		],
		ff: [
			0,
			0,
			0,
			0,
			0,
			-18,
			-18,
			-25
		],
		quoterightt: [
			0,
			0,
			0,
			0,
			0,
			-37,
			-30,
			-18
		],
		quoterighttcommaaccent: [
			0,
			0,
			0,
			0,
			0,
			-37,
			-30,
			-18
		],
		Yicircumflex: [
			0,
			0,
			0,
			0,
			0,
			0,
			-34
		],
		Yidieresis: [
			0,
			0,
			0,
			0,
			0,
			0,
			-34
		],
		Yigrave: [
			0,
			0,
			0,
			0,
			0,
			0,
			-34
		],
		Yimacron: [
			0,
			0,
			0,
			0,
			0,
			0,
			-34
		],
		Yacuteicircumflex: [
			0,
			0,
			0,
			0,
			0,
			0,
			-34
		],
		Yacuteidieresis: [
			0,
			0,
			0,
			0,
			0,
			0,
			-34
		],
		Yacuteigrave: [
			0,
			0,
			0,
			0,
			0,
			0,
			-34
		],
		Yacuteimacron: [
			0,
			0,
			0,
			0,
			0,
			0,
			-34
		],
		Ydieresisicircumflex: [
			0,
			0,
			0,
			0,
			0,
			0,
			-34
		],
		Ydieresisidieresis: [
			0,
			0,
			0,
			0,
			0,
			0,
			-34
		],
		Ydieresisigrave: [
			0,
			0,
			0,
			0,
			0,
			0,
			-34
		],
		Ydieresisimacron: [
			0,
			0,
			0,
			0,
			0,
			0,
			-34
		],
		eg: [
			0,
			0,
			0,
			0,
			0,
			0,
			-40,
			-15
		],
		egbreve: [
			0,
			0,
			0,
			0,
			0,
			0,
			-40,
			-15
		],
		egcommaaccent: [
			0,
			0,
			0,
			0,
			0,
			0,
			-40,
			-15
		],
		eacuteg: [
			0,
			0,
			0,
			0,
			0,
			0,
			-40,
			-15
		],
		eacutegbreve: [
			0,
			0,
			0,
			0,
			0,
			0,
			-40,
			-15
		],
		eacutegcommaaccent: [
			0,
			0,
			0,
			0,
			0,
			0,
			-40,
			-15
		],
		ecarong: [
			0,
			0,
			0,
			0,
			0,
			0,
			-40,
			-15
		],
		ecarongbreve: [
			0,
			0,
			0,
			0,
			0,
			0,
			-40,
			-15
		],
		ecarongcommaaccent: [
			0,
			0,
			0,
			0,
			0,
			0,
			-40,
			-15
		],
		ecircumflexg: [
			0,
			0,
			0,
			0,
			0,
			0,
			-40,
			-15
		],
		ecircumflexgbreve: [
			0,
			0,
			0,
			0,
			0,
			0,
			-40,
			-15
		],
		ecircumflexgcommaaccent: [
			0,
			0,
			0,
			0,
			0,
			0,
			-40,
			-15
		],
		edieresisg: [
			0,
			0,
			0,
			0,
			0,
			0,
			-40,
			-15
		],
		edieresisgbreve: [
			0,
			0,
			0,
			0,
			0,
			0,
			-40,
			-15
		],
		edieresisgcommaaccent: [
			0,
			0,
			0,
			0,
			0,
			0,
			-40,
			-15
		],
		edotaccentg: [
			0,
			0,
			0,
			0,
			0,
			0,
			-40,
			-15
		],
		edotaccentgbreve: [
			0,
			0,
			0,
			0,
			0,
			0,
			-40,
			-15
		],
		edotaccentgcommaaccent: [
			0,
			0,
			0,
			0,
			0,
			0,
			-40,
			-15
		],
		egraveg: [
			0,
			0,
			0,
			0,
			0,
			0,
			-40,
			-15
		],
		egravegbreve: [
			0,
			0,
			0,
			0,
			0,
			0,
			-40,
			-15
		],
		egravegcommaaccent: [
			0,
			0,
			0,
			0,
			0,
			0,
			-40,
			-15
		],
		emacrong: [
			0,
			0,
			0,
			0,
			0,
			0,
			-40,
			-15
		],
		emacrongbreve: [
			0,
			0,
			0,
			0,
			0,
			0,
			-40,
			-15
		],
		emacrongcommaaccent: [
			0,
			0,
			0,
			0,
			0,
			0,
			-40,
			-15
		],
		eogonekg: [
			0,
			0,
			0,
			0,
			0,
			0,
			-40,
			-15
		],
		eogonekgbreve: [
			0,
			0,
			0,
			0,
			0,
			0,
			-40,
			-15
		],
		eogonekgcommaaccent: [
			0,
			0,
			0,
			0,
			0,
			0,
			-40,
			-15
		],
		fiogonek: [
			0,
			0,
			0,
			0,
			0,
			0,
			-20
		],
		gcomma: [
			0,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		gbrevecomma: [
			0,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		gcommaaccentcomma: [
			0,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		og: [
			0,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		ogbreve: [
			0,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		ogcommaaccent: [
			0,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		oacuteg: [
			0,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		oacutegbreve: [
			0,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		oacutegcommaaccent: [
			0,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		ocircumflexg: [
			0,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		ocircumflexgbreve: [
			0,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		ocircumflexgcommaaccent: [
			0,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		odieresisg: [
			0,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		odieresisgbreve: [
			0,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		odieresisgcommaaccent: [
			0,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		ograveg: [
			0,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		ogravegbreve: [
			0,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		ogravegcommaaccent: [
			0,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		ohungarumlautg: [
			0,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		ohungarumlautgbreve: [
			0,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		ohungarumlautgcommaaccent: [
			0,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		omacrong: [
			0,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		omacrongbreve: [
			0,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		omacrongcommaaccent: [
			0,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		otildeg: [
			0,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		otildegbreve: [
			0,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		otildegcommaaccent: [
			0,
			0,
			0,
			0,
			0,
			0,
			-10
		],
		fiacute: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-20
		],
		ga: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-5
		],
		gaacute: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-5
		],
		gabreve: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-5
		],
		gacircumflex: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-5
		],
		gadieresis: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-5
		],
		gagrave: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-5
		],
		gamacron: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-5
		],
		gaogonek: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-5
		],
		garing: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-5
		],
		gatilde: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-5
		],
		gbrevea: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-5
		],
		gbreveaacute: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-5
		],
		gbreveabreve: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-5
		],
		gbreveacircumflex: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-5
		],
		gbreveadieresis: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-5
		],
		gbreveagrave: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-5
		],
		gbreveamacron: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-5
		],
		gbreveaogonek: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-5
		],
		gbrevearing: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-5
		],
		gbreveatilde: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-5
		],
		gcommaaccenta: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-5
		],
		gcommaaccentaacute: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-5
		],
		gcommaaccentabreve: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-5
		],
		gcommaaccentacircumflex: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-5
		],
		gcommaaccentadieresis: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-5
		],
		gcommaaccentagrave: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-5
		],
		gcommaaccentamacron: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-5
		],
		gcommaaccentaogonek: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-5
		],
		gcommaaccentaring: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-5
		],
		gcommaaccentatilde: [
			0,
			0,
			0,
			0,
			0,
			0,
			0,
			-5
		]
	}
}, $K = (e) => [e.FontName, {
	attributes: e,
	glyphWidths: {},
	kernPairs: {}
}], eq = ((e) => {
	let { attributes: t, glyphWidths: n, kernPairs: r } = e, i = t.map($K);
	return Object.keys(n).forEach((e) => {
		n[e].forEach((t, n) => {
			t && (i[n][1].glyphWidths[e] = t);
		});
	}), Object.keys(r).forEach((e) => {
		r[e].forEach((t, n) => {
			t && (i[n][1].kernPairs[e] = t);
		});
	}), Object.fromEntries(i);
})(QK), tq = (e) => class extends e {
	constructor(e, t, n) {
		super(), this.document = e, this.name = t, this.id = n, this.font = ZK.fromJson(eq[this.name]), this.ascender = this.font.ascender, this.descender = this.font.descender, this.bbox = this.font.bbox, this.lineGap = this.font.lineGap;
	}
	embed() {
		return this.dictionary.data = {
			Type: "Font",
			BaseFont: this.name,
			Subtype: "Type1",
			Encoding: "WinAnsiEncoding"
		}, this.dictionary.end();
	}
	encode(e) {
		let t = this.font.encodeText(e), n = this.font.glyphsForString(`${e}`), r = this.font.advancesForGlyphs(n), i = [];
		for (let e = 0; e < n.length; e++) {
			let t = n[e];
			i.push({
				xAdvance: r[e],
				yAdvance: 0,
				xOffset: 0,
				yOffset: 0,
				advanceWidth: this.font.widthOfGlyph(t)
			});
		}
		return [t, i];
	}
	encodeGlyphs(e) {
		let t = [];
		for (let n of Array.from(e)) t.push(`00${n.id.toString(16)}`.slice(-2));
		return t;
	}
	widthOfString(e, t) {
		let n = this.font.glyphsForString(`${e}`), r = this.font.advancesForGlyphs(n), i = 0;
		for (let e of Array.from(r)) i += e;
		let a = t / 1e3;
		return i * a;
	}
	static isStandardFont(e) {
		return e in eq;
	}
}, nq = function() {
	var e = [...arguments];
	return Array.from(e).map((e) => `0000${e.toString(16)}`.slice(-4)).join("");
}, rq = (e) => class extends e {
	constructor(e, t, n) {
		super(), this.document = e, this.font = t, this.id = n, this.subset = this.font.createSubset(), this.unicode = [[0]], this.widths = [this.font.getGlyph(0).advanceWidth], this.name = this.font.postscriptName, this.scale = 1e3 / this.font.unitsPerEm, this.ascender = this.font.ascent * this.scale, this.descender = this.font.descent * this.scale, this.xHeight = this.font.xHeight * this.scale, this.capHeight = this.font.capHeight * this.scale, this.lineGap = this.font.lineGap * this.scale, this.bbox = this.font.bbox, this.layoutCache = Object.create(null);
	}
	layoutRun(e, t) {
		let n = this.font.layout(e, t, void 0, void 0, "ltr");
		for (let e = 0; e < n.positions.length; e++) {
			let t = n.positions[e];
			for (let e in t) t[e] *= this.scale;
			t.advanceWidth = n.glyphs[e].advanceWidth * this.scale;
		}
		return n;
	}
	layoutCached(e) {
		let t;
		if (t = this.layoutCache[e]) return t;
		let n = this.layoutRun(e);
		return this.layoutCache[e] = n, n;
	}
	layout(e, t, n) {
		if (n ??= !1, t) return this.layoutRun(e, t);
		let r = n ? null : [], i = n ? null : [], a = 0, o = 0, s = 0;
		for (; s <= e.length;) {
			let t;
			if (s === e.length && o < s || (t = e.charAt(s), [" ", "	"].includes(t))) {
				let t = this.layoutCached(e.slice(o, ++s));
				n || (r.push(...Array.from(t.glyphs || [])), i.push(...Array.from(t.positions || []))), a += t.advanceWidth, o = s;
			} else s++;
		}
		return {
			glyphs: r,
			positions: i,
			advanceWidth: a
		};
	}
	encode(e, t) {
		let { glyphs: n, positions: r } = this.layout(e, t), i = [];
		for (let e = 0; e < n.length; e++) {
			let t = n[e], r = this.subset.includeGlyph(t.id);
			i.push(`0000${r.toString(16)}`.slice(-4)), this.widths[r] ?? (this.widths[r] = t.advanceWidth * this.scale), this.unicode[r] ?? (this.unicode[r] = t.codePoints);
		}
		return [i, r];
	}
	encodeGlyphs(e) {
		let t = [];
		for (let n = 0; n < e.length; n++) {
			let r = e[n], i = this.subset.includeGlyph(r.id);
			t.push(`0000${i.toString(16)}`.slice(-4)), this.widths[i] ?? (this.widths[i] = r.advanceWidth * this.scale), this.unicode[i] ?? (this.unicode[i] = r.codePoints);
		}
		return t;
	}
	widthOfString(e, t, n) {
		return this.layout(e, n, !0).advanceWidth * (t / 1e3);
	}
	embed() {
		let e = this.subset.cff != null, t = this.document.ref();
		e && (t.data.Subtype = "CIDFontType0C"), t.end(this.subset.encode());
		let n = ((this.font["OS/2"] == null ? void 0 : this.font["OS/2"].sFamilyClass) || 0) >> 8, r = 0;
		this.font.post.isFixedPitch && (r |= 1), 1 <= n && n <= 7 && (r |= 2), r |= 4, n === 10 && (r |= 8), this.font.head.macStyle.italic && (r |= 64);
		let i = [
			0,
			1,
			2,
			3,
			4,
			5
		].map(() => String.fromCharCode(Math.random() * 26 + 65)).join("") + "+" + this.font.postscriptName, { bbox: a } = this.font, o = this.document.ref({
			Type: "FontDescriptor",
			FontName: i,
			Flags: r,
			FontBBox: [
				a.minX * this.scale,
				a.minY * this.scale,
				a.maxX * this.scale,
				a.maxY * this.scale
			],
			ItalicAngle: this.font.italicAngle,
			Ascent: this.ascender,
			Descent: this.descender,
			CapHeight: (this.font.capHeight || this.font.ascent) * this.scale,
			XHeight: (this.font.xHeight || 0) * this.scale,
			StemV: 0
		});
		e ? o.data.FontFile3 = t : o.data.FontFile2 = t, o.end();
		let s = {
			Type: "Font",
			Subtype: "CIDFontType0",
			BaseFont: i,
			CIDSystemInfo: {
				Registry: /* @__PURE__ */ new String("Adobe"),
				Ordering: /* @__PURE__ */ new String("Identity"),
				Supplement: 0
			},
			FontDescriptor: o,
			W: [0, this.widths]
		};
		e || (s.Subtype = "CIDFontType2", s.CIDToGIDMap = "Identity");
		let c = this.document.ref(s);
		return c.end(), this.dictionary.data = {
			Type: "Font",
			Subtype: "Type0",
			BaseFont: i,
			Encoding: "Identity-H",
			DescendantFonts: [c],
			ToUnicode: this.toUnicodeCmap()
		}, this.dictionary.end();
	}
	toUnicodeCmap() {
		let e = this.document.ref(), t = [], n = "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange";
		for (let [e, r] of this.unicode.entries()) {
			let i = [];
			t.length >= 100 && (n += "\n" + t.length + " beginbfchar\n" + t.join("\n") + "\nendbfchar", t = []);
			for (let e of r) e > 65535 && (e -= 65536, i.push(nq(e >>> 10 & 1023 | 55296)), e = 56320 | e & 1023), i.push(nq(e));
			t.push("<" + nq(e) + "><" + i.join(" ") + ">");
		}
		return t.length && (n += "\n" + t.length + " beginbfchar\n" + t.join("\n") + "\nendbfchar\n"), n += "endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend", e.end(n), e;
	}
}, iq = class {
	static open(e, t, n, r) {
		let i;
		if (typeof t == "string") {
			if (aq.isStandardFont(t)) return new aq(e, t, r);
			throw Error(`Can't open ${t} in browser build`);
		} else t instanceof Uint8Array ? i = Mb(t, n) : t instanceof ArrayBuffer ? i = Mb(new Uint8Array(t), n) : typeof t == "object" && (i = t);
		if (i == null) throw Error("Not a supported font format or standard PDF font.");
		return new oq(e, i, r);
	}
	encode() {
		throw Error("Must be implemented by subclasses");
	}
	widthOfString() {
		throw Error("Must be implemented by subclasses");
	}
	ref() {
		return this.dictionary == null ? this.dictionary = this.document.ref() : this.dictionary;
	}
	finalize() {
		if (!(this.embedded || this.dictionary == null)) return this.embed(), this.embedded = !0;
	}
	embed() {
		throw Error("Must be implemented by subclasses");
	}
	lineHeight(e, t) {
		t ??= !1;
		let n = t ? this.lineGap : 0;
		return (this.ascender + n - this.descender) / 1e3 * e;
	}
}, aq = tq(iq), oq = rq(iq), sq = {
	initFonts() {
		return this._fontFamilies = {}, this._fontCount = 0, this._fontSize = 12, this._font = null, this._registeredFonts = {}, this.font("Helvetica");
	},
	font(e, t, n) {
		let r, i;
		if (typeof t == "number" && (n = t, t = null), typeof e == "string" && this._registeredFonts[e] ? (r = e, {src: e, family: t} = this._registeredFonts[e]) : (r = t || e, typeof r != "string" && (r = null)), n != null && this.fontSize(n), i = this._fontFamilies[r]) return this._font = i, this;
		let a = `F${++this._fontCount}`;
		return this._font = iq.open(this, e, t, a), (i = this._fontFamilies[this._font.name]) ? (this._font = i, this) : (r && (this._fontFamilies[r] = this._font), this._font.name && (this._fontFamilies[this._font.name] = this._font), this);
	},
	fontSize(e) {
		return this._fontSize = e, this;
	},
	currentLineHeight(e) {
		return e ??= !1, this._font.lineHeight(this._fontSize, e);
	},
	registerFont(e, t, n) {
		return this._registeredFonts[e] = {
			src: t,
			family: n
		}, this;
	}
};
function cq(e) {
	return Math.fround(e);
}
var lq = "­", uq = "-", dq = class extends rV {
	constructor(e, t) {
		super(), this.document = e, this.horizontalScaling = t.horizontalScaling || 100, this.indent = (t.indent || 0) * this.horizontalScaling / 100, this.characterSpacing = (t.characterSpacing || 0) * this.horizontalScaling / 100, this.wordSpacing = (t.wordSpacing === 0) * this.horizontalScaling / 100, this.columns = t.columns || 1, this.columnGap = (t.columnGap == null ? 18 : t.columnGap) * this.horizontalScaling / 100, this.lineWidth = (t.width * this.horizontalScaling / 100 - this.columnGap * (this.columns - 1)) / this.columns, this.spaceLeft = this.lineWidth, this.startX = this.document.x, this.startY = this.document.y, this.column = 1, this.ellipsis = t.ellipsis, this.continuedX = 0, this.features = t.features, t.height == null ? this.maxY = cq(this.document.page.maxY()) : (this.height = t.height, this.maxY = cq(this.startY + t.height)), this.on("firstLine", (e) => {
			let t = this.continuedX || this.indent;
			if (this.document.x += t, this.lineWidth -= t, !e.indentAllLines) return this.once("line", () => {
				if (this.document.x -= t, this.lineWidth += t, e.continued && !this.continuedX && (this.continuedX = this.indent), !e.continued) return this.continuedX = 0;
			});
		}), this.on("lastLine", (e) => {
			let { align: t } = e;
			return t === "justify" && (e.align = "left"), this.lastLine = !0, this.once("line", () => (this.document.y += e.paragraphGap || 0, e.align = t, this.lastLine = !1));
		});
	}
	wordWidth(e) {
		return this.document.widthOfString(e, this) + this.characterSpacing + this.wordSpacing;
	}
	canFit(e, t) {
		return e[e.length - 1] == lq ? t + this.wordWidth(uq) <= this.spaceLeft : t <= this.spaceLeft;
	}
	eachWord(e, t) {
		let n, r = new mk(e), i = null, a = Object.create(null);
		for (; n = r.nextBreak();) {
			var o;
			let r = e.slice(i?.position || 0, n.position), l = a[r] == null ? a[r] = this.wordWidth(r) : a[r];
			if (l > this.lineWidth + this.continuedX) {
				let e = i, a = {};
				for (; r.length;) {
					var s, c;
					l > this.spaceLeft ? (s = Math.ceil(this.spaceLeft / (l / r.length)), l = this.wordWidth(r.slice(0, s)), c = l <= this.spaceLeft && s < r.length) : s = r.length;
					let i = l > this.spaceLeft && s > 0;
					for (; i || c;) i ? (l = this.wordWidth(r.slice(0, --s)), i = l > this.spaceLeft && s > 0) : (l = this.wordWidth(r.slice(0, ++s)), i = l > this.spaceLeft && s > 0, c = l <= this.spaceLeft && s < r.length);
					if (s === 0 && this.spaceLeft === this.lineWidth && (s = 1), a.required = n.required || s < r.length, o = t(r.slice(0, s), l, a, e), e = { required: !1 }, r = r.slice(s), l = this.wordWidth(r), o === !1) break;
				}
			} else o = t(r, l, n, i);
			if (o === !1) break;
			i = n;
		}
	}
	wrap(e, t) {
		this.horizontalScaling = t.horizontalScaling || 100, t.indent != null && (this.indent = t.indent * this.horizontalScaling / 100), t.characterSpacing != null && (this.characterSpacing = t.characterSpacing * this.horizontalScaling / 100), t.wordSpacing != null && (this.wordSpacing = t.wordSpacing * this.horizontalScaling / 100), t.ellipsis != null && (this.ellipsis = t.ellipsis);
		let n = this.document.y + this.document.currentLineHeight(!0);
		(this.document.y > this.maxY || n > this.maxY) && this.nextSection();
		let r = "", i = 0, a = 0, o = 0, { y: s } = this.document, c = () => (t.textWidth = i + this.wordSpacing * (a - 1), t.wordCount = a, t.lineWidth = this.lineWidth, {y: s} = this.document, this.emit("line", r, t, this), o++);
		return this.emit("sectionStart", t, this), this.eachWord(e, (e, n, o, s) => {
			if ((s == null || s.required) && (this.emit("firstLine", t, this), this.spaceLeft = this.lineWidth), this.canFit(e, n) && (r += e, i += n, a++), o.required || !this.canFit(e, n)) {
				let s = this.document.currentLineHeight(!0);
				if (this.height != null && this.ellipsis && cq(this.document.y + s * 2) > this.maxY && this.column >= this.columns) {
					for (this.ellipsis === !0 && (this.ellipsis = "…"), r = r.replace(/\s+$/, ""), i = this.wordWidth(r + this.ellipsis); r && i > this.lineWidth;) r = r.slice(0, -1).replace(/\s+$/, ""), i = this.wordWidth(r + this.ellipsis);
					i <= this.lineWidth && (r += this.ellipsis), i = this.wordWidth(r);
				}
				return o.required && (n > this.spaceLeft && (c(), r = e, i = n, a = 1), this.emit("lastLine", t, this)), r[r.length - 1] == lq && (r = r.slice(0, -1) + uq, this.spaceLeft -= this.wordWidth(uq)), c(), cq(this.document.y + s) > this.maxY && !this.nextSection() ? (a = 0, r = "", !1) : o.required ? (this.spaceLeft = this.lineWidth, r = "", i = 0, a = 0) : (this.spaceLeft = this.lineWidth - n, r = e, i = n, a = 1);
			} else return this.spaceLeft -= n;
		}), a > 0 && (this.emit("lastLine", t, this), c()), this.emit("sectionEnd", t, this), t.continued === !0 ? (o > 1 && (this.continuedX = 0), this.continuedX += t.textWidth || 0, this.document.y = s) : this.document.x = this.startX;
	}
	nextSection(e) {
		if (this.emit("sectionEnd", e, this), ++this.column > this.columns) {
			if (this.height != null) return !1;
			this.document.continueOnNewPage(), this.column = 1, this.startY = this.document.page.margins.top, this.maxY = this.document.page.maxY(), this.document.x = this.startX, this.document._fillColor && this.document.fillColor(...this.document._fillColor), this.emit("pageBreak", e, this);
		} else this.document.x += this.lineWidth + this.columnGap, this.document.y = this.startY, this.emit("columnBreak", e, this);
		return this.emit("sectionStart", e, this), !0;
	}
}, { number: fq } = sK, pq = {
	initText() {
		return this._line = this._line.bind(this), this.x = 0, this.y = 0, this._lineGap = 0;
	},
	lineGap(e) {
		return this._lineGap = e, this;
	},
	moveDown(e) {
		return e ??= 1, this.y += this.currentLineHeight(!0) * e + this._lineGap, this;
	},
	moveUp(e) {
		return e ??= 1, this.y -= this.currentLineHeight(!0) * e + this._lineGap, this;
	},
	_text(e, t, n, r, i) {
		r = this._initOptions(t, n, r), e = e == null ? "" : `${e}`, r.wordSpacing && (e = e.replace(/\s{2,}/g, " "));
		let a = () => {
			r.structParent && r.structParent.add(this.struct(r.structType || "P", [this.markStructureContent(r.structType || "P")]));
		};
		if (r.rotation !== 0 && (this.save(), this.rotate(-r.rotation, { origin: [this.x, this.y] })), r.width) {
			let t = this._wrapper;
			t || (t = new dq(this, r), t.on("line", i), t.on("firstLine", a)), this._wrapper = r.continued ? t : null, this._textOptions = r.continued ? r : null, t.wrap(e, r);
		} else for (let t of e.split("\n")) a(), i(t, r);
		return r.rotation !== 0 && this.restore(), this;
	},
	text(e, t, n, r) {
		return this._text(e, t, n, r, this._line);
	},
	widthOfString(e, t) {
		t === void 0 && (t = {});
		let n = t.horizontalScaling || 100;
		return (this._font.widthOfString(e, this._fontSize, t.features) + (t.characterSpacing || 0) * (e.length - 1)) * n / 100;
	},
	boundsOfString(e, t, n, r) {},
	heightOfString(e, t) {
		let { x: n, y: r } = this;
		t = this._initOptions(t), t.height = Infinity;
		let i = t.lineGap || this._lineGap || 0;
		this._text(e, this.x, this.y, t, () => this.y += this.currentLineHeight(!0) + i);
		let a = this.y - r;
		return this.x = n, this.y = r, a;
	},
	list(e, t, n, r, i) {
		r = this._initOptions(t, n, r);
		let a = r.listType || "bullet", o = Math.round(this._font.ascender / 1e3 * this._fontSize), s = o / 2, c = r.bulletRadius || o / 3, l = r.textIndent || (a === "bullet" ? c * 5 : o * 2), u = r.bulletIndent || (a === "bullet" ? c * 8 : o * 2), d = 1, f = [], p = [], m = [];
		var h = function(e) {
			let t = 1;
			for (let n = 0; n < e.length; n++) {
				let r = e[n];
				Array.isArray(r) ? (d++, h(r), d--) : (f.push(r), p.push(d), a !== "bullet" && m.push(t++));
			}
		};
		h(e);
		let g = function(e) {
			switch (a) {
				case "numbered": return `${e}.`;
				case "lettered":
					var t = String.fromCharCode((e - 1) % 26 + 65), n = Math.floor((e - 1) / 26 + 1);
					return `${Array(n + 1).join(t)}.`;
			}
		}, _ = function(e, t) {
			i = new dq(this, r), i.on("line", this._line), d = 1, i.once("firstLine", () => {
				let e, n, o, f;
				r.structParent && (r.structTypes ? [n, o, f] = r.structTypes : [n, o, f] = [
					"LI",
					"Lbl",
					"LBody"
				]), n ? (e = this.struct(n), r.structParent.add(e)) : r.structParent && (e = r.structParent);
				let h;
				if ((h = p[t++]) !== d) {
					let e = u * (h - d);
					this.x += e, i.lineWidth -= e, d = h;
				}
				switch (e && (o || f) && e.add(this.struct(o || f, [this.markStructureContent(o || f)])), a) {
					case "bullet":
						this.circle(this.x - l + c, this.y + s, c), this.fill();
						break;
					case "numbered":
					case "lettered":
						var _ = g(m[t - 1]);
						this._fragment(_, this.x - l, this.y, r);
						break;
				}
				e && o && f && e.add(this.struct(f, [this.markStructureContent(f)])), e && e !== r.structParent && e.end();
			}), i.on("sectionStart", () => {
				let e = l + u * (d - 1);
				return this.x += e, i.lineWidth -= e;
			}), i.on("sectionEnd", () => {
				let e = l + u * (d - 1);
				return this.x -= e, i.lineWidth += e;
			}), i.wrap(e, r);
		};
		for (let e = 0; e < f.length; e++) _.call(this, f[e], e);
		return this;
	},
	_initOptions(e, t, n) {
		e === void 0 && (e = {}), n === void 0 && (n = {}), typeof e == "object" && (n = e, e = null);
		let r = Object.assign({}, n);
		if (this._textOptions) for (let e in this._textOptions) {
			let t = this._textOptions[e];
			e !== "continued" && r[e] === void 0 && (r[e] = t);
		}
		return e != null && (this.x = e), t != null && (this.y = t), r.lineBreak !== !1 && (r.width ??= this.page.width - this.x - this.page.margins.right, r.width = Math.max(r.width, 0)), r.columns ||= 0, r.columnGap ??= 18, r.rotation = Number(n.rotation ?? 0) % 360, r.rotation < 0 && (r.rotation += 360), r;
	},
	_line(e, t, n) {
		t === void 0 && (t = {}), this._fragment(e, this.x, this.y, t);
		let r = t.lineGap || this._lineGap || 0;
		return n ? this.y += this.currentLineHeight(!0) + r : this.x += this.widthOfString(e, t);
	},
	_fragment(e, t, n, r) {
		let i, a, o, s, c, l;
		if (e = `${e}`.replace(/\n/g, ""), e.length === 0) return;
		let u = r.align || "left", d = r.wordSpacing || 0, f = r.characterSpacing || 0, p = r.horizontalScaling || 100;
		if (r.width) switch (u) {
			case "right":
				c = this.widthOfString(e.replace(/\s+$/, ""), r), t += r.lineWidth - c;
				break;
			case "center":
				t += r.lineWidth / 2 - r.textWidth / 2;
				break;
			case "justify":
				l = e.trim().split(/\s+/), c = this.widthOfString(e.replace(/\s+/g, ""), r);
				var m = this.widthOfString(" ") + f;
				d = Math.max(0, (r.lineWidth - c) / Math.max(1, l.length - 1) - m);
				break;
		}
		if (typeof r.baseline == "number") i = -r.baseline;
		else {
			switch (r.baseline) {
				case "svg-middle":
					i = .5 * this._font.xHeight;
					break;
				case "middle":
				case "svg-central":
					i = .5 * (this._font.descender + this._font.ascender);
					break;
				case "bottom":
				case "ideographic":
					i = this._font.descender;
					break;
				case "alphabetic":
					i = 0;
					break;
				case "mathematical":
					i = .5 * this._font.ascender;
					break;
				case "hanging":
					i = .8 * this._font.ascender;
					break;
				case "top":
					i = this._font.ascender;
					break;
				default: i = this._font.ascender;
			}
			i = i / 1e3 * this._fontSize;
		}
		let h = r.textWidth + d * (r.wordCount - 1) + f * (e.length - 1);
		if (r.link != null && this.link(t, n, h, this.currentLineHeight(), r.link), r.goTo != null && this.goTo(t, n, h, this.currentLineHeight(), r.goTo), r.destination != null && this.addNamedDestination(r.destination, "XYZ", t, n, null), r.underline) {
			this.save(), r.stroke || this.strokeColor(...this._fillColor || []);
			let e = this._fontSize < 10 ? .5 : Math.floor(this._fontSize / 10);
			this.lineWidth(e);
			let i = n + this.currentLineHeight() - e;
			this.moveTo(t, i), this.lineTo(t + h, i), this.stroke(), this.restore();
		}
		if (r.strike) {
			this.save(), r.stroke || this.strokeColor(...this._fillColor || []);
			let e = this._fontSize < 10 ? .5 : Math.floor(this._fontSize / 10);
			this.lineWidth(e);
			let i = n + this.currentLineHeight() / 2;
			this.moveTo(t, i), this.lineTo(t + h, i), this.stroke(), this.restore();
		}
		if (this.save(), r.oblique) {
			let e;
			e = typeof r.oblique == "number" ? -Math.tan(r.oblique * Math.PI / 180) : -.25, this.transform(1, 0, 0, 1, t, n), this.transform(1, 0, e, 1, -e * i, 0), this.transform(1, 0, 0, 1, -t, -n);
		}
		this.transform(1, 0, 0, -1, 0, this.page.height), n = this.page.height - n - i, this.page.fonts[this._font.id] ?? (this.page.fonts[this._font.id] = this._font.ref()), this.addContent("BT"), this.addContent(`1 0 0 1 ${fq(t)} ${fq(n)} Tm`), this.addContent(`/${this._font.id} ${fq(this._fontSize)} Tf`);
		let g = r.fill && r.stroke ? 2 : +!!r.stroke;
		if (g && this.addContent(`${g} Tr`), f && this.addContent(`${fq(f)} Tc`), p !== 100 && this.addContent(`${p} Tz`), d) {
			l = e.trim().split(/\s+/), d += this.widthOfString(" ") + f, d *= 1e3 / this._fontSize, a = [], s = [];
			for (let e of l) {
				let [t, n] = this._font.encode(e, r.features);
				a = a.concat(t), s = s.concat(n);
				let i = {}, o = s[s.length - 1];
				for (let e in o) i[e] = o[e];
				i.xAdvance += d, s[s.length - 1] = i;
			}
		} else [a, s] = this._font.encode(e, r.features);
		let _ = this._fontSize / 1e3, v = [], y = 0, b = !1, x = (e) => {
			if (y < e) {
				let t = a.slice(y, e).join(""), n = s[e - 1].xAdvance - s[e - 1].advanceWidth;
				v.push(`<${t}> ${fq(-n)}`);
			}
			return y = e;
		}, S = (e) => {
			if (x(e), v.length > 0) return this.addContent(`[${v.join(" ")}] TJ`), v.length = 0;
		};
		for (o = 0; o < s.length; o++) {
			let e = s[o];
			e.xOffset || e.yOffset ? (S(o), this.addContent(`1 0 0 1 ${fq(t + e.xOffset * _)} ${fq(n + e.yOffset * _)} Tm`), S(o + 1), b = !0) : (b &&= (this.addContent(`1 0 0 1 ${fq(t)} ${fq(n)} Tm`), !1), e.xAdvance - e.advanceWidth !== 0 && x(o + 1)), t += e.xAdvance * _;
		}
		return S(o), this.addContent("ET"), this.restore();
	}
}, mq = {
	1: "DeviceGray",
	3: "DeviceRGB",
	4: "DeviceCMYK"
}, hq = class {
	constructor(e, t) {
		if (this.data = e, this.label = t, this.orientation = 1, this.data.readUInt16BE(0) !== 65496) throw "SOI not found in JPEG";
		let n = mA.decode(this.data);
		for (let e = 0; e < n.length; e += 1) {
			let t = n[e];
			t.name === "EXIF" && t.entries.orientation && (this.orientation = t.entries.orientation), t.name === "SOF" && (this.bits ||= t.precision, this.width ||= t.width, this.height ||= t.height, this.colorSpace ||= mq[t.numberOfComponents]);
		}
		this.obj = null;
	}
	embed(e) {
		if (!this.obj) return this.obj = e.ref({
			Type: "XObject",
			Subtype: "Image",
			BitsPerComponent: this.bits,
			Width: this.width,
			Height: this.height,
			ColorSpace: this.colorSpace,
			Filter: "DCTDecode"
		}), this.colorSpace === "DeviceCMYK" && (this.obj.data.Decode = [
			1,
			0,
			1,
			0,
			1,
			0,
			1,
			0
		]), this.obj.end(this.data), this.data = null;
	}
}, gq = class {
	constructor(e, t) {
		this.label = t, this.image = new pR(e), this.width = this.image.width, this.height = this.image.height, this.imgData = this.image.imgData, this.obj = null;
	}
	embed(e) {
		let t = !1;
		if (this.document = e, this.obj) return;
		let n = this.image.hasAlphaChannel, r = this.image.interlaceMethod === 1;
		if (this.obj = this.document.ref({
			Type: "XObject",
			Subtype: "Image",
			BitsPerComponent: n ? 8 : this.image.bits,
			Width: this.width,
			Height: this.height,
			Filter: "FlateDecode"
		}), !n) {
			let e = this.document.ref({
				Predictor: r ? 1 : 15,
				Colors: this.image.colors,
				BitsPerComponent: this.image.bits,
				Columns: this.width
			});
			this.obj.data.DecodeParms = e, e.end();
		}
		if (this.image.palette.length === 0) this.obj.data.ColorSpace = this.image.colorSpace;
		else {
			let e = this.document.ref();
			e.end(Q.from(this.image.palette)), this.obj.data.ColorSpace = [
				"Indexed",
				"DeviceRGB",
				this.image.palette.length / 3 - 1,
				e
			];
		}
		if (this.image.transparency.grayscale != null) {
			let e = this.image.transparency.grayscale;
			this.obj.data.Mask = [e, e];
		} else if (this.image.transparency.rgb) {
			let { rgb: e } = this.image.transparency, t = [];
			for (let n of e) t.push(n, n);
			this.obj.data.Mask = t;
		} else if (this.image.transparency.indexed) return t = !0, this.loadIndexedAlphaChannel();
		else if (n) return t = !0, this.splitAlphaChannel();
		if (r && !t) return this.decodeData();
		this.finalize();
	}
	finalize() {
		if (this.alphaChannel) {
			let e = this.document.ref({
				Type: "XObject",
				Subtype: "Image",
				Height: this.height,
				Width: this.width,
				BitsPerComponent: 8,
				Filter: "FlateDecode",
				ColorSpace: "DeviceGray",
				Decode: [0, 1]
			});
			e.end(this.alphaChannel), this.obj.data.SMask = e;
		}
		return this.obj.end(this.imgData), this.image = null, this.imgData = null;
	}
	splitAlphaChannel() {
		return this.image.decodePixels((e) => {
			let t, n, r = this.image.colors, i = this.width * this.height, a = Q.alloc(i * r), o = Q.alloc(i), s = n = t = 0, c = e.length, l = +(this.image.bits === 16);
			for (; s < c;) {
				for (let t = 0; t < r; t++) a[n++] = e[s++], s += l;
				o[t++] = e[s++], s += l;
			}
			return this.imgData = $G.deflateSync(a), this.alphaChannel = $G.deflateSync(o), this.finalize();
		});
	}
	loadIndexedAlphaChannel() {
		let e = this.image.transparency.indexed;
		return this.image.decodePixels((t) => {
			let n = Q.alloc(this.width * this.height), r = 0;
			for (let i = 0, a = t.length; i < a; i++) n[r++] = e[t[i]];
			return this.alphaChannel = $G.deflateSync(n), this.finalize();
		});
	}
	decodeData() {
		this.image.decodePixels((e) => {
			this.imgData = $G.deflateSync(e), this.finalize();
		});
	}
}, _q = class {
	static open(e, t) {
		let n;
		if (Q.isBuffer(e)) n = e;
		else if (e instanceof ArrayBuffer) n = Q.from(new Uint8Array(e));
		else {
			let t;
			if (t = /^data:.+?;base64,(.*)$/.exec(e)) n = Q.from(t[1], "base64");
			else if (n = KK.readFileSync(e), !n) return;
		}
		if (n[0] === 255 && n[1] === 216) return new hq(n, t);
		if (n[0] === 137 && n.toString("ascii", 1, 4) === "PNG") return new gq(n, t);
		throw Error("Unknown image format.");
	}
}, vq = {
	initImages() {
		return this._imageRegistry = {}, this._imageCount = 0;
	},
	image(e, t, n, r) {
		r === void 0 && (r = {});
		let i, a, o, s, c, l, u, d;
		typeof t == "object" && (r = t, t = null);
		let f = r.ignoreOrientation || r.ignoreOrientation !== !1 && this.options.ignoreOrientation;
		t = t ?? r.x ?? this.x, n = n ?? r.y ?? this.y, typeof e == "string" && (s = this._imageRegistry[e]), s ||= e.width && e.height ? e : this.openImage(e), s.obj || s.embed(this), this.page.xobjects[s.label] ?? (this.page.xobjects[s.label] = s.obj);
		let { width: p, height: m } = s;
		!f && s.orientation > 4 && ([p, m] = [m, p]);
		let h = r.width || p, g = r.height || m;
		if (r.width && !r.height) {
			let e = h / p;
			h = p * e, g = m * e;
		} else if (r.height && !r.width) {
			let e = g / m;
			h = p * e, g = m * e;
		} else r.scale ? (h = p * r.scale, g = m * r.scale) : r.fit ? ([o, i] = r.fit, a = o / i, c = p / m, c > a ? (h = o, g = o / c) : (g = i, h = i * c)) : r.cover && ([o, i] = r.cover, a = o / i, c = p / m, c > a ? (g = i, h = i * c) : (h = o, g = o / c));
		if ((r.fit || r.cover) && (r.align === "center" ? t = t + o / 2 - h / 2 : r.align === "right" && (t = t + o - h), r.valign === "center" ? n = n + i / 2 - g / 2 : r.valign === "bottom" && (n = n + i - g)), f) g = -g, n -= g, l = 0;
		else switch (s.orientation) {
			default:
			case 1:
				g = -g, n -= g, l = 0;
				break;
			case 2:
				h = -h, g = -g, t -= h, n -= g, l = 0;
				break;
			case 3:
				u = t, d = n, g = -g, t -= h, l = 180;
				break;
			case 4: break;
			case 5:
				u = t, d = n, [h, g] = [g, h], n -= g, l = 90;
				break;
			case 6:
				u = t, d = n, [h, g] = [g, h], g = -g, l = 90;
				break;
			case 7:
				u = t, d = n, [h, g] = [g, h], g = -g, h = -h, t -= h, l = 90;
				break;
			case 8:
				u = t, d = n, [h, g] = [g, h], g = -g, t -= h, n -= g, l = -90;
				break;
		}
		return r.link != null && this.link(t, n, h, g, r.link), r.goTo != null && this.goTo(t, n, h, g, r.goTo), r.destination != null && this.addNamedDestination(r.destination, "XYZ", t, n, null), this.y === n && (this.y += g), this.save(), l && this.rotate(l, { origin: [u, d] }), this.transform(h, 0, 0, g, t, n), this.addContent(`/${s.label} Do`), this.restore(), this;
	},
	openImage(e) {
		let t;
		return typeof e == "string" && (t = this._imageRegistry[e]), t || (t = _q.open(e, `I${++this._imageCount}`), typeof e == "string" && (this._imageRegistry[e] = t)), t;
	}
}, yq = {
	annotate(e, t, n, r, i) {
		i.Type = "Annot", i.Rect = this._convertRect(e, t, n, r), i.Border = [
			0,
			0,
			0
		], i.Subtype === "Link" && i.F === void 0 && (i.F = 4), i.Subtype !== "Link" && (i.C ??= this._normalizeColor(i.color || [
			0,
			0,
			0
		])), delete i.color, typeof i.Dest == "string" && (i.Dest = new String(i.Dest));
		for (let e in i) {
			let t = i[e];
			i[e[0].toUpperCase() + e.slice(1)] = t;
		}
		let a = this.ref(i);
		return this.page.annotations.push(a), a.end(), this;
	},
	note(e, t, n, r, i, a) {
		return a === void 0 && (a = {}), a.Subtype = "Text", a.Contents = new String(i), a.Name ??= "Comment", a.color ??= [
			243,
			223,
			92
		], this.annotate(e, t, n, r, a);
	},
	goTo(e, t, n, r, i, a) {
		return a === void 0 && (a = {}), a.Subtype = "Link", a.A = this.ref({
			S: "GoTo",
			D: new String(i)
		}), a.A.end(), this.annotate(e, t, n, r, a);
	},
	link(e, t, n, r, i, a) {
		if (a === void 0 && (a = {}), a.Subtype = "Link", typeof i == "number") {
			let e = this._root.data.Pages.data;
			if (i >= 0 && i < e.Kids.length) a.A = this.ref({
				S: "GoTo",
				D: [
					e.Kids[i],
					"XYZ",
					null,
					null,
					null
				]
			}), a.A.end();
			else throw Error(`The document has no page ${i}`);
		} else a.A = this.ref({
			S: "URI",
			URI: new String(i)
		}), a.A.end();
		return this.annotate(e, t, n, r, a);
	},
	_markup(e, t, n, r, i) {
		i === void 0 && (i = {});
		let [a, o, s, c] = this._convertRect(e, t, n, r);
		return i.QuadPoints = [
			a,
			c,
			s,
			c,
			a,
			o,
			s,
			o
		], i.Contents = /* @__PURE__ */ new String(), this.annotate(e, t, n, r, i);
	},
	highlight(e, t, n, r, i) {
		return i === void 0 && (i = {}), i.Subtype = "Highlight", i.color ??= [
			241,
			238,
			148
		], this._markup(e, t, n, r, i);
	},
	underline(e, t, n, r, i) {
		return i === void 0 && (i = {}), i.Subtype = "Underline", this._markup(e, t, n, r, i);
	},
	strike(e, t, n, r, i) {
		return i === void 0 && (i = {}), i.Subtype = "StrikeOut", this._markup(e, t, n, r, i);
	},
	lineAnnotation(e, t, n, r, i) {
		return i === void 0 && (i = {}), i.Subtype = "Line", i.Contents = /* @__PURE__ */ new String(), i.L = [
			e,
			this.page.height - t,
			n,
			this.page.height - r
		], this.annotate(e, t, n, r, i);
	},
	rectAnnotation(e, t, n, r, i) {
		return i === void 0 && (i = {}), i.Subtype = "Square", i.Contents = /* @__PURE__ */ new String(), this.annotate(e, t, n, r, i);
	},
	ellipseAnnotation(e, t, n, r, i) {
		return i === void 0 && (i = {}), i.Subtype = "Circle", i.Contents = /* @__PURE__ */ new String(), this.annotate(e, t, n, r, i);
	},
	textAnnotation(e, t, n, r, i, a) {
		return a === void 0 && (a = {}), a.Subtype = "FreeText", a.Contents = new String(i), a.DA = /* @__PURE__ */ new String(), this.annotate(e, t, n, r, a);
	},
	fileAnnotation(e, t, n, r, i, a) {
		i === void 0 && (i = {}), a === void 0 && (a = {});
		let o = this.file(i.src, Object.assign({ hidden: !0 }, i));
		return a.Subtype = "FileAttachment", a.FS = o, a.Contents ? a.Contents = new String(a.Contents) : o.data.Desc && (a.Contents = o.data.Desc), this.annotate(e, t, n, r, a);
	},
	_convertRect(e, t, n, r) {
		let i = t;
		t += r;
		let a = e + n, [o, s, c, l, u, d] = this._ctm;
		return e = o * e + c * t + u, t = s * e + l * t + d, a = o * a + c * i + u, i = s * a + l * i + d, [
			e,
			t,
			a,
			i
		];
	}
}, bq = class e {
	constructor(e, t, n, r, i) {
		i === void 0 && (i = { expanded: !1 }), this.document = e, this.options = i, this.outlineData = {}, r !== null && (this.outlineData.Dest = [r.dictionary, "Fit"]), t !== null && (this.outlineData.Parent = t), n !== null && (this.outlineData.Title = new String(n)), this.dictionary = this.document.ref(this.outlineData), this.children = [];
	}
	addItem(t, n) {
		n === void 0 && (n = { expanded: !1 });
		let r = new e(this.document, this.dictionary, t, this.document.page, n);
		return this.children.push(r), r;
	}
	endOutline() {
		if (this.children.length > 0) {
			this.options.expanded && (this.outlineData.Count = this.children.length);
			let e = this.children[0], t = this.children[this.children.length - 1];
			this.outlineData.First = e.dictionary, this.outlineData.Last = t.dictionary;
			for (let e = 0, t = this.children.length; e < t; e++) {
				let t = this.children[e];
				e > 0 && (t.outlineData.Prev = this.children[e - 1].dictionary), e < this.children.length - 1 && (t.outlineData.Next = this.children[e + 1].dictionary), t.endOutline();
			}
		}
		return this.dictionary.end();
	}
}, xq = {
	initOutline() {
		return this.outline = new bq(this, null, null, null);
	},
	endOutline() {
		if (this.outline.endOutline(), this.outline.children.length > 0) return this._root.data.Outlines = this.outline.dictionary, this._root.data.PageMode = "UseOutlines";
	}
}, Sq = class {
	constructor(e, t) {
		this.refs = [{
			pageRef: e,
			mcid: t
		}];
	}
	push(e) {
		e.refs.forEach((e) => this.refs.push(e));
	}
}, Cq = class e {
	constructor(e, t, n, r) {
		n === void 0 && (n = {}), r === void 0 && (r = null), this.document = e, this._attached = !1, this._ended = !1, this._flushed = !1, this.dictionary = e.ref({ S: t });
		let i = this.dictionary.data;
		(Array.isArray(n) || this._isValidChild(n)) && (r = n, n = {}), n.title !== void 0 && (i.T = new String(n.title)), n.lang !== void 0 && (i.Lang = new String(n.lang)), n.alt !== void 0 && (i.Alt = new String(n.alt)), n.expanded !== void 0 && (i.E = new String(n.expanded)), n.actual !== void 0 && (i.ActualText = new String(n.actual)), this._children = [], r && (Array.isArray(r) || (r = [r]), r.forEach((e) => this.add(e)), this.end());
	}
	add(t) {
		if (this._ended) throw Error("Cannot add child to already-ended structure element");
		if (!this._isValidChild(t)) throw Error("Invalid structure element child");
		return t instanceof e && (t.setParent(this.dictionary), this._attached && t.setAttached()), t instanceof Sq && this._addContentToParentTree(t), typeof t == "function" && this._attached && (t = this._contentForClosure(t)), this._children.push(t), this;
	}
	_addContentToParentTree(e) {
		e.refs.forEach((e) => {
			let { pageRef: t, mcid: n } = e, r = this.document.getStructParentTree().get(t.data.StructParents);
			r[n] = this.dictionary;
		});
	}
	setParent(e) {
		if (this.dictionary.data.P) throw Error("Structure element added to more than one parent");
		this.dictionary.data.P = e, this._flush();
	}
	setAttached() {
		this._attached || (this._children.forEach((t, n) => {
			t instanceof e && t.setAttached(), typeof t == "function" && (this._children[n] = this._contentForClosure(t));
		}), this._attached = !0, this._flush());
	}
	end() {
		this._ended || (this._children.filter((t) => t instanceof e).forEach((e) => e.end()), this._ended = !0, this._flush());
	}
	_isValidChild(t) {
		return t instanceof e || t instanceof Sq || typeof t == "function";
	}
	_contentForClosure(e) {
		let t = this.document.markStructureContent(this.dictionary.data.S);
		return e(), this.document.endMarkedContent(), this._addContentToParentTree(t), t;
	}
	_isFlushable() {
		return !this.dictionary.data.P || !this._ended ? !1 : this._children.every((t) => typeof t == "function" ? !1 : t instanceof e ? t._isFlushable() : !0);
	}
	_flush() {
		this._flushed || !this._isFlushable() || (this.dictionary.data.K = [], this._children.forEach((e) => this._flushChild(e)), this.dictionary.end(), this._children = [], this.dictionary.data.K = null, this._flushed = !0);
	}
	_flushChild(t) {
		t instanceof e && this.dictionary.data.K.push(t.dictionary), t instanceof Sq && t.refs.forEach((e) => {
			let { pageRef: t, mcid: n } = e;
			this.dictionary.data.Pg || (this.dictionary.data.Pg = t), this.dictionary.data.Pg === t ? this.dictionary.data.K.push(n) : this.dictionary.data.K.push({
				Type: "MCR",
				Pg: t,
				MCID: n
			});
		});
	}
}, wq = class extends tK {
	_compareKeys(e, t) {
		return parseInt(e) - parseInt(t);
	}
	_keysName() {
		return "Nums";
	}
	_dataForKey(e) {
		return parseInt(e);
	}
}, Tq = {
	initMarkings(e) {
		this.structChildren = [], e.tagged && (this.getMarkInfoDictionary().data.Marked = !0, this.getStructTreeRoot());
	},
	markContent(e, t) {
		if (t === void 0 && (t = null), e === "Artifact" || t && t.mcid) {
			let e = 0;
			for (this.page.markings.forEach((t) => {
				(e || t.structContent || t.tag === "Artifact") && e++;
			}); e--;) this.endMarkedContent();
		}
		if (!t) return this.page.markings.push({ tag: e }), this.addContent(`/${e} BMC`), this;
		this.page.markings.push({
			tag: e,
			options: t
		});
		let n = {};
		return t.mcid !== void 0 && (n.MCID = t.mcid), e === "Artifact" && (typeof t.type == "string" && (n.Type = t.type), Array.isArray(t.bbox) && (n.BBox = [
			t.bbox[0],
			this.page.height - t.bbox[3],
			t.bbox[2],
			this.page.height - t.bbox[1]
		]), Array.isArray(t.attached) && t.attached.every((e) => typeof e == "string") && (n.Attached = t.attached)), e === "Span" && (t.lang && (n.Lang = new String(t.lang)), t.alt && (n.Alt = new String(t.alt)), t.expanded && (n.E = new String(t.expanded)), t.actual && (n.ActualText = new String(t.actual))), this.addContent(`/${e} ${sK.convert(n)} BDC`), this;
	},
	markStructureContent(e, t) {
		t === void 0 && (t = {});
		let n = this.getStructParentTree().get(this.page.structParentTreeKey), r = n.length;
		n.push(null), this.markContent(e, {
			...t,
			mcid: r
		});
		let i = new Sq(this.page.dictionary, r);
		return this.page.markings.slice(-1)[0].structContent = i, i;
	},
	endMarkedContent() {
		return this.page.markings.pop(), this.addContent("EMC"), this;
	},
	struct(e, t, n) {
		return t === void 0 && (t = {}), n === void 0 && (n = null), new Cq(this, e, t, n);
	},
	addStructure(e) {
		let t = this.getStructTreeRoot();
		return e.setParent(t), e.setAttached(), this.structChildren.push(e), t.data.K || (t.data.K = []), t.data.K.push(e.dictionary), this;
	},
	initPageMarkings(e) {
		e.forEach((e) => {
			if (e.structContent) {
				let t = e.structContent, n = this.markStructureContent(e.tag, e.options);
				t.push(n), this.page.markings.slice(-1)[0].structContent = t;
			} else this.markContent(e.tag, e.options);
		});
	},
	endPageMarkings(e) {
		let t = e.markings;
		return t.forEach(() => e.write("EMC")), e.markings = [], t;
	},
	getMarkInfoDictionary() {
		return this._root.data.MarkInfo || (this._root.data.MarkInfo = this.ref({})), this._root.data.MarkInfo;
	},
	hasMarkInfoDictionary() {
		return !!this._root.data.MarkInfo;
	},
	getStructTreeRoot() {
		return this._root.data.StructTreeRoot || (this._root.data.StructTreeRoot = this.ref({
			Type: "StructTreeRoot",
			ParentTree: new wq(),
			ParentTreeNextKey: 0
		})), this._root.data.StructTreeRoot;
	},
	getStructParentTree() {
		return this.getStructTreeRoot().data.ParentTree;
	},
	createStructParentTreeNextKey() {
		this.getMarkInfoDictionary();
		let e = this.getStructTreeRoot(), t = e.data.ParentTreeNextKey++;
		return e.data.ParentTree.add(t, []), t;
	},
	endMarkings() {
		let e = this._root.data.StructTreeRoot;
		e && (e.end(), this.structChildren.forEach((e) => e.end())), this._root.data.MarkInfo && this._root.data.MarkInfo.end();
	}
}, Eq = {
	readOnly: 1,
	required: 2,
	noExport: 4,
	multiline: 4096,
	password: 8192,
	toggleToOffButton: 16384,
	radioButton: 32768,
	pushButton: 65536,
	combo: 131072,
	edit: 262144,
	sort: 524288,
	multiSelect: 2097152,
	noSpell: 4194304
}, Dq = {
	left: 0,
	center: 1,
	right: 2
}, Oq = {
	value: "V",
	defaultValue: "DV"
}, kq = {
	zip: "0",
	zipPlus4: "1",
	zip4: "1",
	phone: "2",
	ssn: "3"
}, Aq = {
	number: {
		nDec: 0,
		sepComma: !1,
		negStyle: "MinusBlack",
		currency: "",
		currencyPrepend: !0
	},
	percent: {
		nDec: 0,
		sepComma: !1
	}
}, jq = {
	initForm() {
		if (!this._font) throw Error("Must set a font before calling initForm method");
		this._acroform = {
			fonts: {},
			defaultFont: this._font.name
		}, this._acroform.fonts[this._font.id] = this._font.ref();
		let e = {
			Fields: [],
			NeedAppearances: !0,
			DA: /* @__PURE__ */ new String(`/${this._font.id} 0 Tf 0 g`),
			DR: { Font: {} }
		};
		e.DR.Font[this._font.id] = this._font.ref();
		let t = this.ref(e);
		return this._root.data.AcroForm = t, this;
	},
	endAcroForm() {
		if (this._root.data.AcroForm) {
			if (!Object.keys(this._acroform.fonts).length && !this._acroform.defaultFont) throw Error("No fonts specified for PDF form");
			let e = this._root.data.AcroForm.data.DR.Font;
			Object.keys(this._acroform.fonts).forEach((t) => {
				e[t] = this._acroform.fonts[t];
			}), this._root.data.AcroForm.data.Fields.forEach((e) => {
				this._endChild(e);
			}), this._root.data.AcroForm.end();
		}
		return this;
	},
	_endChild(e) {
		return Array.isArray(e.data.Kids) && (e.data.Kids.forEach((e) => {
			this._endChild(e);
		}), e.end()), this;
	},
	formField(e, t) {
		t === void 0 && (t = {});
		let n = this._fieldDict(e, null, t), r = this.ref(n);
		return this._addToParent(r), r;
	},
	formAnnotation(e, t, n, r, i, a, o) {
		o === void 0 && (o = {});
		let s = this._fieldDict(e, t, o);
		s.Subtype = "Widget", s.F === void 0 && (s.F = 4), this.annotate(n, r, i, a, s);
		let c = this.page.annotations[this.page.annotations.length - 1];
		return this._addToParent(c);
	},
	formText(e, t, n, r, i, a) {
		return a === void 0 && (a = {}), this.formAnnotation(e, "text", t, n, r, i, a);
	},
	formPushButton(e, t, n, r, i, a) {
		return a === void 0 && (a = {}), this.formAnnotation(e, "pushButton", t, n, r, i, a);
	},
	formCombo(e, t, n, r, i, a) {
		return a === void 0 && (a = {}), this.formAnnotation(e, "combo", t, n, r, i, a);
	},
	formList(e, t, n, r, i, a) {
		return a === void 0 && (a = {}), this.formAnnotation(e, "list", t, n, r, i, a);
	},
	formRadioButton(e, t, n, r, i, a) {
		return a === void 0 && (a = {}), this.formAnnotation(e, "radioButton", t, n, r, i, a);
	},
	formCheckbox(e, t, n, r, i, a) {
		return a === void 0 && (a = {}), this.formAnnotation(e, "checkbox", t, n, r, i, a);
	},
	_addToParent(e) {
		let t = e.data.Parent;
		return t ? (t.data.Kids || (t.data.Kids = []), t.data.Kids.push(e)) : this._root.data.AcroForm.data.Fields.push(e), this;
	},
	_fieldDict(e, t, n) {
		if (n === void 0 && (n = {}), !this._acroform) throw Error("Call document.initForm() method before adding form elements to document");
		let r = Object.assign({}, n);
		return t !== null && (r = this._resolveType(t, n)), r = this._resolveFlags(r), r = this._resolveJustify(r), r = this._resolveFont(r), r = this._resolveStrings(r), r = this._resolveColors(r), r = this._resolveFormat(r), r.T = new String(e), r.parent && (r.Parent = r.parent, delete r.parent), r;
	},
	_resolveType(e, t) {
		if (e === "text") t.FT = "Tx";
		else if (e === "pushButton") t.FT = "Btn", t.pushButton = !0;
		else if (e === "radioButton") t.FT = "Btn", t.radioButton = !0;
		else if (e === "checkbox") t.FT = "Btn";
		else if (e === "combo") t.FT = "Ch", t.combo = !0;
		else if (e === "list") t.FT = "Ch";
		else throw Error(`Invalid form annotation type '${e}'`);
		return t;
	},
	_resolveFormat(e) {
		let t = e.format;
		if (t && t.type) {
			let n, r, i = "";
			if (kq[t.type] !== void 0) n = "AFSpecial_Keystroke", r = "AFSpecial_Format", i = kq[t.type];
			else {
				let e = t.type.charAt(0).toUpperCase() + t.type.slice(1);
				if (n = `AF${e}_Keystroke`, r = `AF${e}_Format`, t.type === "date") n += "Ex", i = String(t.param);
				else if (t.type === "time") i = String(t.param);
				else if (t.type === "number") {
					let e = Object.assign({}, Aq.number, t);
					i = String([
						String(e.nDec),
						e.sepComma ? "0" : "1",
						"\"" + e.negStyle + "\"",
						"null",
						"\"" + e.currency + "\"",
						String(e.currencyPrepend)
					].join(","));
				} else if (t.type === "percent") {
					let e = Object.assign({}, Aq.percent, t);
					i = String([String(e.nDec), e.sepComma ? "0" : "1"].join(","));
				}
			}
			e.AA = e.AA ? e.AA : {}, e.AA.K = {
				S: "JavaScript",
				JS: /* @__PURE__ */ new String(`${n}(${i});`)
			}, e.AA.F = {
				S: "JavaScript",
				JS: /* @__PURE__ */ new String(`${r}(${i});`)
			};
		}
		return delete e.format, e;
	},
	_resolveColors(e) {
		let t = this._normalizeColor(e.backgroundColor);
		return t && (e.MK ||= {}, e.MK.BG = t), t = this._normalizeColor(e.borderColor), t && (e.MK ||= {}, e.MK.BC = t), delete e.backgroundColor, delete e.borderColor, e;
	},
	_resolveFlags(e) {
		let t = 0;
		return Object.keys(e).forEach((n) => {
			Eq[n] && (e[n] && (t |= Eq[n]), delete e[n]);
		}), t !== 0 && (e.Ff = e.Ff ? e.Ff : 0, e.Ff |= t), e;
	},
	_resolveJustify(e) {
		let t = 0;
		return e.align !== void 0 && (typeof Dq[e.align] == "number" && (t = Dq[e.align]), delete e.align), t !== 0 && (e.Q = t), e;
	},
	_resolveFont(e) {
		if (this._acroform.fonts[this._font.id] ?? (this._acroform.fonts[this._font.id] = this._font.ref()), this._acroform.defaultFont !== this._font.name) {
			e.DR = { Font: {} };
			let t = e.fontSize || 0;
			e.DR.Font[this._font.id] = this._font.ref(), e.DA = /* @__PURE__ */ new String(`/${this._font.id} ${t} Tf 0 g`);
		}
		return e;
	},
	_resolveStrings(e) {
		let t = [];
		function n(e) {
			if (Array.isArray(e)) for (let n = 0; n < e.length; n++) typeof e[n] == "string" ? t.push(new String(e[n])) : t.push(e[n]);
		}
		return n(e.Opt), e.select && (n(e.select), delete e.select), t.length && (e.Opt = t), Object.keys(Oq).forEach((t) => {
			e[t] !== void 0 && (e[Oq[t]] = e[t], delete e[t]);
		}), ["V", "DV"].forEach((t) => {
			typeof e[t] == "string" && (e[t] = new String(e[t]));
		}), e.MK && e.MK.CA && (e.MK.CA = new String(e.MK.CA)), e.label && (e.MK = e.MK ? e.MK : {}, e.MK.CA = new String(e.label), delete e.label), e;
	}
}, Mq = { file(e, t) {
	t === void 0 && (t = {}), t.name = t.name || e, t.relationship = t.relationship || "Unspecified";
	let n = {
		Type: "EmbeddedFile",
		Params: {}
	}, r;
	if (!e) throw Error("No src specified");
	if (Q.isBuffer(e)) r = e;
	else if (e instanceof ArrayBuffer) r = Q.from(new Uint8Array(e));
	else {
		let t;
		if (t = /^data:(.*?);base64,(.*)$/.exec(e)) t[1] && (n.Subtype = t[1].replace("/", "#2F")), r = Q.from(t[2], "base64");
		else {
			if (r = KK.readFileSync(e), !r) throw Error(`Could not read contents of file at filepath ${e}`);
			let { birthtime: t, ctime: i } = KK.statSync(e);
			n.Params.CreationDate = t, n.Params.ModDate = i;
		}
	}
	t.creationDate instanceof Date && (n.Params.CreationDate = t.creationDate), t.modifiedDate instanceof Date && (n.Params.ModDate = t.modifiedDate), t.type && (n.Subtype = t.type.replace("/", "#2F"));
	let i = qR.default.MD5(qR.default.lib.WordArray.create(new Uint8Array(r)));
	n.Params.CheckSum = new String(i), n.Params.Size = r.byteLength;
	let a;
	this._fileRegistry ||= {};
	let o = this._fileRegistry[t.name];
	o && Nq(n, o) ? a = o.ref : (a = this.ref(n), a.end(r), this._fileRegistry[t.name] = {
		...n,
		ref: a
	});
	let s = {
		Type: "Filespec",
		AFRelationship: t.relationship,
		F: new String(t.name),
		EF: { F: a },
		UF: new String(t.name)
	};
	t.description && (s.Desc = new String(t.description));
	let c = this.ref(s);
	return c.end(), t.hidden || this.addNamedEmbeddedFile(t.name, c), this._root.data.AF ? this._root.data.AF.push(c) : this._root.data.AF = [c], c;
} };
function Nq(e, t) {
	return e.Subtype === t.Subtype && e.Params.CheckSum.toString() === t.Params.CheckSum.toString() && e.Params.Size === t.Params.Size && e.Params.CreationDate.getTime() === t.Params.CreationDate.getTime() && (e.Params.ModDate === void 0 && t.Params.ModDate === void 0 || e.Params.ModDate.getTime() === t.Params.ModDate.getTime());
}
var Pq = "/home/runner/work/react-pdf/react-pdf/packages/pdfkit/src/mixins", Fq = {
	initPDFA(e) {
		e.charAt(e.length - 3) === "-" ? (this.subset_conformance = e.charAt(e.length - 1).toUpperCase(), this.subset = parseInt(e.charAt(e.length - 2))) : (this.subset_conformance = "B", this.subset = parseInt(e.charAt(e.length - 1)));
	},
	endSubset() {
		this._addPdfaMetadata(), this._addColorOutputIntent();
	},
	_addColorOutputIntent() {
		let e = KK.readFileSync(`${Pq}/data/sRGB_IEC61966_2_1.icc`), t = this.ref({
			Length: e.length,
			N: 3
		});
		t.write(e), t.end();
		let n = this.ref({
			Type: "OutputIntent",
			S: "GTS_PDFA1",
			Info: /* @__PURE__ */ new String("sRGB IEC61966-2.1"),
			OutputConditionIdentifier: /* @__PURE__ */ new String("sRGB IEC61966-2.1"),
			DestOutputProfile: t
		});
		n.end(), this._root.data.OutputIntents = [n];
	},
	_getPdfaid() {
		return `
        <rdf:Description xmlns:pdfaid="http://www.aiim.org/pdfa/ns/id/" rdf:about="">
            <pdfaid:part>${this.subset}</pdfaid:part>
            <pdfaid:conformance>${this.subset_conformance}</pdfaid:conformance>
        </rdf:Description>
        `;
	},
	_addPdfaMetadata() {
		this.appendXML(this._getPdfaid());
	}
}, Iq = {
	initPDFUA() {
		this.subset = 1;
	},
	endSubset() {
		this._addPdfuaMetadata();
	},
	_addPdfuaMetadata() {
		this.appendXML(this._getPdfuaid());
	},
	_getPdfuaid() {
		return `
        <rdf:Description xmlns:pdfuaid="http://www.aiim.org/pdfua/ns/id/" rdf:about="">
            <pdfuaid:part>${this.subset}</pdfuaid:part>
        </rdf:Description>
        `;
	}
}, Lq = {
	_importSubset(e) {
		Object.assign(this, e);
	},
	initSubset(e) {
		switch (e.subset) {
			case "PDF/A-1":
			case "PDF/A-1a":
			case "PDF/A-1b":
			case "PDF/A-2":
			case "PDF/A-2a":
			case "PDF/A-2b":
			case "PDF/A-3":
			case "PDF/A-3a":
			case "PDF/A-3b":
				this._importSubset(Fq), this.initPDFA(e.subset);
				break;
			case "PDF/UA":
				this._importSubset(Iq), this.initPDFUA();
				break;
		}
	}
}, Rq = class {
	constructor() {
		this._metadata = "\n        <?xpacket begin=\"﻿\" id=\"W5M0MpCehiHzreSzNTczkc9d\"?>\n            <x:xmpmeta xmlns:x=\"adobe:ns:meta/\">\n                <rdf:RDF xmlns:rdf=\"http://www.w3.org/1999/02/22-rdf-syntax-ns#\">\n        ";
	}
	_closeTags() {
		this._metadata = this._metadata.concat("\n                </rdf:RDF>\n            </x:xmpmeta>\n        <?xpacket end=\"w\"?>\n        ");
	}
	append(e, t) {
		t === void 0 && (t = !0), this._metadata = this._metadata.concat(e), t && (this._metadata = this._metadata.concat("\n"));
	}
	getXML() {
		return this._metadata;
	}
	getLength() {
		return this._metadata.length;
	}
	end() {
		this._closeTags(), this._metadata = this._metadata.trim();
	}
}, zq = {
	initMetadata() {
		this.metadata = new Rq();
	},
	appendXML(e, t) {
		t === void 0 && (t = !0), this.metadata.append(e, t);
	},
	_addInfo() {
		this.appendXML(`
        <rdf:Description rdf:about="" xmlns:xmp="http://ns.adobe.com/xap/1.0/">
            <xmp:CreateDate>${this.info.CreationDate.toISOString().split(".")[0] + "Z"}</xmp:CreateDate>
            <xmp:CreatorTool>${this.info.Creator}</xmp:CreatorTool>
        </rdf:Description>
        `), (this.info.Title || this.info.Author || this.info.Subject) && (this.appendXML("\n            <rdf:Description rdf:about=\"\" xmlns:dc=\"http://purl.org/dc/elements/1.1/\">\n            "), this.info.Title && this.appendXML(`
                <dc:title>
                    <rdf:Alt>
                        <rdf:li xml:lang="x-default">${this.info.Title}</rdf:li>
                    </rdf:Alt>
                </dc:title>
                `), this.info.Author && this.appendXML(`
                <dc:creator>
                    <rdf:Seq>
                        <rdf:li>${this.info.Author}</rdf:li>
                    </rdf:Seq>
                </dc:creator>
                `), this.info.Subject && this.appendXML(`
                <dc:description>
                    <rdf:Alt>
                        <rdf:li xml:lang="x-default">${this.info.Subject}</rdf:li>
                    </rdf:Alt>
                </dc:description>
                `), this.appendXML("\n            </rdf:Description>\n            ")), this.appendXML(`
        <rdf:Description rdf:about="" xmlns:pdf="http://ns.adobe.com/pdf/1.3/">
            <pdf:Producer>${this.info.Creator}</pdf:Producer>`, !1), this.info.Keywords && this.appendXML(`
            <pdf:Keywords>${this.info.Keywords}</pdf:Keywords>`, !1), this.appendXML("\n        </rdf:Description>\n        ");
	},
	endMetadata() {
		this._addInfo(), this.metadata.end(), this.version != 1.3 && (this.metadataRef = this.ref({
			length: this.metadata.getLength(),
			Type: "Metadata",
			Subtype: "XML"
		}), this.metadataRef.compress = !1, this.metadataRef.write(Q.from(this.metadata.getXML(), "utf-8")), this.metadataRef.end(), this._root.data.Metadata = this.metadataRef);
	}
}, Bq = class extends hG.Readable {
	constructor(e) {
		switch (e === void 0 && (e = {}), super(e), this.options = e, e.pdfVersion) {
			case "1.4":
				this.version = 1.4;
				break;
			case "1.5":
				this.version = 1.5;
				break;
			case "1.6":
				this.version = 1.6;
				break;
			case "1.7":
			case "1.7ext3":
				this.version = 1.7;
				break;
			default:
				this.version = 1.3;
				break;
		}
		this.compress = this.options.compress == null ? !0 : this.options.compress, this._pageBuffer = [], this._pageBufferStart = 0, this._offsets = [], this._waiting = 0, this._ended = !1, this._offset = 0;
		let t = this.ref({
			Type: "Pages",
			Count: 0,
			Kids: []
		}), n = this.ref({ Dests: new nK() });
		if (this._root = this.ref({
			Type: "Catalog",
			Pages: t,
			Names: n
		}), this.options.lang && (this._root.data.Lang = new String(this.options.lang)), this.page = null, this.initMetadata(), this.initColor(), this.initVector(), this.initFonts(e.font), this.initText(), this.initImages(), this.initOutline(), this.initMarkings(e), this.initSubset(e), this.info = {
			Producer: "PDFKit",
			Creator: "PDFKit",
			CreationDate: /* @__PURE__ */ new Date()
		}, this.options.info) for (let e in this.options.info) {
			let t = this.options.info[e];
			this.info[e] = t;
		}
		this.options.displayTitle && (this._root.data.ViewerPreferences = this.ref({ DisplayDocTitle: !0 })), this._id = fK.generateFileID(this.info), this._write(`%PDF-${this.version}`), this._write("%ÿÿÿÿ"), this.options.autoFirstPage !== !1 && this.addPage();
	}
	addPage(e) {
		e ?? ({options: e} = this), this.options.bufferPages || this.flushPages(), this.page = new uK(this, e), this._pageBuffer.push(this.page);
		let t = this._root.data.Pages.data;
		return t.Kids.push(this.page.dictionary), t.Count++, this.x = this.page.margins.left, this.y = this.page.margins.top, this._ctm = [
			1,
			0,
			0,
			1,
			0,
			0
		], this.transform(1, 0, 0, -1, 0, this.page.height), this.emit("pageAdded"), this;
	}
	continueOnNewPage(e) {
		let t = this.endPageMarkings(this.page);
		return this.addPage(e ?? this.page._options), this.initPageMarkings(t), this;
	}
	bufferedPageRange() {
		return {
			start: this._pageBufferStart,
			count: this._pageBuffer.length
		};
	}
	switchToPage(e) {
		let t;
		if (!(t = this._pageBuffer[e - this._pageBufferStart])) throw Error(`switchToPage(${e}) out of bounds, current buffer covers pages ${this._pageBufferStart} to ${this._pageBufferStart + this._pageBuffer.length - 1}`);
		return this.page = t;
	}
	flushPages() {
		let e = this._pageBuffer;
		this._pageBuffer = [], this._pageBufferStart += e.length;
		for (let t of e) this.endPageMarkings(t), t.end();
	}
	addNamedDestination(e) {
		var t = [...arguments].slice(1);
		t.length === 0 && (t = [
			"XYZ",
			null,
			null,
			null
		]), t[0] === "XYZ" && t[2] !== null && (t[2] = this.page.height - t[2]), t.unshift(this.page.dictionary), this._root.data.Names.data.Dests.add(e, t);
	}
	addNamedEmbeddedFile(e, t) {
		this._root.data.Names.data.EmbeddedFiles || (this._root.data.Names.data.EmbeddedFiles = new nK({ limits: !1 })), this._root.data.Names.data.EmbeddedFiles.add(e, t);
	}
	addNamedJavaScript(e, t) {
		this._root.data.Names.data.JavaScript || (this._root.data.Names.data.JavaScript = new nK());
		let n = {
			JS: new String(t),
			S: "JavaScript"
		};
		this._root.data.Names.data.JavaScript.add(e, n);
	}
	ref(e) {
		let t = new eK(this, this._offsets.length + 1, e);
		return this._offsets.push(null), this._waiting++, t;
	}
	_read() {}
	_write(e) {
		return Q.isBuffer(e) || (e = Q.from(e + "\n", "binary")), this.push(e), this._offset += e.length;
	}
	addContent(e) {
		return this.page.write(e), this;
	}
	_refEnd(e) {
		if (this._offsets[e.id - 1] = e.offset, --this._waiting === 0 && this._ended) return this._finalize(), this._ended = !1;
	}
	end() {
		this.flushPages(), this._info = this.ref();
		for (let e in this.info) {
			let t = this.info[e];
			typeof t == "string" && (t = new String(t));
			let n = this.ref(t);
			n.end(), this._info.data[e] = n;
		}
		this._info.end();
		for (let e in this._fontFamilies) this._fontFamilies[e].finalize();
		return this.endOutline(), this.endMarkings(), this.subset && this.endSubset(), this.endMetadata(), this._root.end(), this._root.data.Pages.end(), this._root.data.Names.end(), this.endAcroForm(), this._root.data.ViewerPreferences && this._root.data.ViewerPreferences.end(), this._security && this._security.end(), this._waiting === 0 ? this._finalize() : this._ended = !0;
	}
	_finalize() {
		let e = this._offset;
		this._write("xref"), this._write(`0 ${this._offsets.length + 1}`), this._write("0000000000 65535 f ");
		for (let e of this._offsets) e = `0000000000${e}`.slice(-10), this._write(e + " 00000 n ");
		let t = {
			Size: this._offsets.length + 1,
			Root: this._root,
			Info: this._info,
			ID: [this._id, this._id]
		};
		return this._security && (t.Encrypt = this._security.dictionary), this._write("trailer"), this._write(sK.convert(t)), this._write("startxref"), this._write(`${e}`), this._write("%%EOF"), this.push(null);
	}
	toString() {
		return "[object PDFDocument]";
	}
}, Vq = (e) => {
	Object.assign(Bq.prototype, e);
};
Vq(zq), Vq(CK), Vq(GK), Vq(sq), Vq(pq), Vq(vq), Vq(yq), Vq(xq), Vq(Tq), Vq(jq), Vq(Mq), Vq(Lq), Bq.LineWrapper = dq;
//#endregion
//#region ../../node_modules/@react-pdf/font/lib/index.browser.js
var Hq = [
	"Courier",
	"Courier-Bold",
	"Courier-Oblique",
	"Courier-BoldOblique",
	"Helvetica",
	"Helvetica-Bold",
	"Helvetica-Oblique",
	"Helvetica-BoldOblique",
	"Times-Roman",
	"Times-Bold",
	"Times-Italic",
	"Times-BoldItalic"
], Uq = class {
	name;
	src;
	fullName;
	familyName;
	subfamilyName;
	postscriptName;
	copyright;
	version;
	underlinePosition;
	underlineThickness;
	italicAngle;
	bbox;
	"OS/2";
	hhea;
	numGlyphs;
	characterSet;
	availableFeatures;
	type;
	constructor(e) {
		this.name = e, this.fullName = e, this.familyName = e, this.subfamilyName = e, this.type = "STANDARD", this.postscriptName = e, this.availableFeatures = [], this.copyright = "", this.version = 1, this.underlinePosition = -100, this.underlineThickness = 50, this.italicAngle = 0, this.bbox = {}, this["OS/2"] = {}, this.hhea = {}, this.numGlyphs = 0, this.characterSet = [], this.src = iq.open(null, e);
	}
	encode(e) {
		return this.src.encode(e);
	}
	layout(e) {
		let [t, n] = this.encode(e), r = t.map((e, t) => {
			let r = this.getGlyph(parseInt(e, 16));
			return r.advanceWidth = n[t].advanceWidth, r;
		}), i = n.reduce((e, t) => e + t.advanceWidth, 0);
		return {
			positions: n,
			stringIndices: n.map((e, t) => t),
			glyphs: r,
			script: "latin",
			language: "dflt",
			direction: "ltr",
			features: {},
			advanceWidth: i,
			advanceHeight: 0,
			bbox: void 0
		};
	}
	glyphForCodePoint(e) {
		let t = this.getGlyph(e);
		return t.advanceWidth = 400, t;
	}
	getGlyph(e) {
		return {
			id: e,
			codePoints: [e],
			isLigature: !1,
			name: this.src.font.characterToGlyph(e),
			_font: this.src,
			advanceWidth: void 0
		};
	}
	hasGlyphForCodePoint(e) {
		return this.src.font.characterToGlyph(e) !== ".notdef";
	}
	get ascent() {
		return 900;
	}
	get capHeight() {
		switch (this.name) {
			case "Times-Roman":
			case "Times-Bold":
			case "Times-Italic":
			case "Times-BoldItalic": return 650;
			case "Courier":
			case "Courier-Bold":
			case "Courier-Oblique":
			case "Courier-BoldOblique": return 550;
			default: return 690;
		}
	}
	get xHeight() {
		switch (this.name) {
			case "Times-Roman":
			case "Times-Bold":
			case "Times-Italic":
			case "Times-BoldItalic": return 440;
			case "Courier":
			case "Courier-Bold":
			case "Courier-Oblique":
			case "Courier-BoldOblique": return 390;
			default: return 490;
		}
	}
	get descent() {
		switch (this.name) {
			case "Times-Roman":
			case "Times-Bold":
			case "Times-Italic":
			case "Times-BoldItalic": return -220;
			case "Courier":
			case "Courier-Bold":
			case "Courier-Oblique":
			case "Courier-BoldOblique": return -230;
			default: return -200;
		}
	}
	get lineGap() {
		return 0;
	}
	get unitsPerEm() {
		return 1e3;
	}
	stringsForGlyph() {
		throw Error("Method not implemented.");
	}
	glyphsForString() {
		throw Error("Method not implemented.");
	}
	widthOfGlyph() {
		throw Error("Method not implemented.");
	}
	getAvailableFeatures() {
		throw Error("Method not implemented.");
	}
	createSubset() {
		throw Error("Method not implemented.");
	}
	getVariation() {
		throw Error("Method not implemented.");
	}
	getFont() {
		throw Error("Method not implemented.");
	}
	getName() {
		throw Error("Method not implemented.");
	}
	setDefaultLanguage() {
		throw Error("Method not implemented.");
	}
}, Wq = async (e, t) => {
	let n = await (await fetch(e, t)).arrayBuffer();
	return new Uint8Array(n);
}, Gq = (e) => {
	let t = e.split(",")[0], n = t.substring(0, 5) === "data:", r = t.split(";")[1] === "base64";
	return n && r;
}, Kq = class {
	src;
	fontFamily;
	fontStyle;
	fontWeight;
	data;
	options;
	loadResultPromise;
	constructor(e, t, n, r, i) {
		this.src = e, this.fontFamily = t, this.fontStyle = n || "normal", this.fontWeight = r || 400, this.data = null, this.options = i || {}, this.loadResultPromise = null;
	}
	async _load() {
		let { postscriptName: e } = this.options, t = null;
		if (Hq.includes(this.src)) t = new Uq(this.src);
		else if (Gq(this.src)) {
			let n = this.src.split(",")[1];
			t = Mb(new Uint8Array(atob(n).split("").map((e) => e.charCodeAt(0))), e);
		} else {
			let { headers: n, body: r, method: i = "GET" } = this.options;
			t = Mb(await Wq(this.src, {
				method: i,
				body: r,
				headers: n
			}), e);
		}
		if (t && "fonts" in t) throw Error("Font collection is not supported");
		this.data = t;
	}
	async load() {
		return this.loadResultPromise === null && (this.loadResultPromise = this._load()), this.loadResultPromise;
	}
}, qq = {
	thin: 100,
	hairline: 100,
	ultralight: 200,
	extralight: 200,
	light: 300,
	normal: 400,
	medium: 500,
	semibold: 600,
	demibold: 600,
	bold: 700,
	ultrabold: 800,
	extrabold: 800,
	heavy: 900,
	black: 900
}, Jq = (e) => typeof e == "string" ? qq[e] : e, Yq = (e, t) => e.fontWeight - t.fontWeight, Xq = class e {
	family;
	sources;
	static create(t) {
		return new e(t);
	}
	constructor(e) {
		this.family = e, this.sources = [];
	}
	register({ src: e, fontWeight: t, fontStyle: n, ...r }) {
		let i = t ? Jq(t) : void 0;
		this.sources.push(new Kq(e, this.family, n, i, r));
	}
	resolve(e) {
		let { fontWeight: t = 400, fontStyle: n = "normal" } = e, r = this.sources.filter((e) => e.fontStyle === n), i = r.find((e) => e.fontWeight === t);
		if (i) return i;
		let a = null, o = Jq(t);
		if (o >= 400 && o <= 500) {
			let e = r.filter((e) => e.fontWeight <= o), t = r.filter((e) => e.fontWeight > 500);
			a = r.filter((e) => e.fontWeight >= o && e.fontWeight < 500)[0] || e[e.length - 1] || t[0];
		}
		let s = r.filter((e) => e.fontWeight < o).sort(Yq), c = r.filter((e) => e.fontWeight > o).sort(Yq);
		if (o < 400 && (a = s[s.length - 1] || c[0]), o > 500 && (a = c[0] || s[s.length - 1]), !a) throw Error(`Could not resolve font for ${this.family}, fontWeight ${t}, fontStyle ${n}`);
		return a;
	}
}, Zq = class {
	fontFamilies = {};
	emojiSource = null;
	constructor() {
		this.register({
			family: "Helvetica",
			fonts: [
				{
					src: "Helvetica",
					fontStyle: "normal",
					fontWeight: 400
				},
				{
					src: "Helvetica-Bold",
					fontStyle: "normal",
					fontWeight: 700
				},
				{
					src: "Helvetica-Oblique",
					fontStyle: "italic",
					fontWeight: 400
				},
				{
					src: "Helvetica-BoldOblique",
					fontStyle: "italic",
					fontWeight: 700
				}
			]
		}), this.register({
			family: "Courier",
			fonts: [
				{
					src: "Courier",
					fontStyle: "normal",
					fontWeight: 400
				},
				{
					src: "Courier-Bold",
					fontStyle: "normal",
					fontWeight: 700
				},
				{
					src: "Courier-Oblique",
					fontStyle: "italic",
					fontWeight: 400
				},
				{
					src: "Courier-BoldOblique",
					fontStyle: "italic",
					fontWeight: 700
				}
			]
		}), this.register({
			family: "Times-Roman",
			fonts: [
				{
					src: "Times-Roman",
					fontStyle: "normal",
					fontWeight: 400
				},
				{
					src: "Times-Bold",
					fontStyle: "normal",
					fontWeight: 700
				},
				{
					src: "Times-Italic",
					fontStyle: "italic",
					fontWeight: 400
				},
				{
					src: "Times-BoldItalic",
					fontStyle: "italic",
					fontWeight: 700
				}
			]
		}), this.register({
			family: "Helvetica-Bold",
			src: "Helvetica-Bold"
		}), this.register({
			family: "Helvetica-Oblique",
			src: "Helvetica-Oblique"
		}), this.register({
			family: "Helvetica-BoldOblique",
			src: "Helvetica-BoldOblique"
		}), this.register({
			family: "Courier-Bold",
			src: "Courier-Bold"
		}), this.register({
			family: "Courier-Oblique",
			src: "Courier-Oblique"
		}), this.register({
			family: "Courier-BoldOblique",
			src: "Courier-BoldOblique"
		}), this.register({
			family: "Times-Bold",
			src: "Times-Bold"
		}), this.register({
			family: "Times-Italic",
			src: "Times-Italic"
		}), this.register({
			family: "Times-BoldItalic",
			src: "Times-BoldItalic"
		}), this.load({
			fontFamily: "Helvetica",
			fontStyle: "normal",
			fontWeight: 400
		}), this.load({
			fontFamily: "Helvetica",
			fontStyle: "normal",
			fontWeight: 700
		}), this.load({
			fontFamily: "Helvetica",
			fontStyle: "italic",
			fontWeight: 400
		}), this.load({
			fontFamily: "Helvetica",
			fontStyle: "italic",
			fontWeight: 700
		});
	}
	hyphenationCallback = null;
	register = (e) => {
		let { family: t } = e;
		if (this.fontFamilies[t] || (this.fontFamilies[t] = Xq.create(t)), "fonts" in e) for (let n = 0; n < e.fonts.length; n += 1) {
			let { src: r, fontStyle: i, fontWeight: a, ...o } = e.fonts[n];
			this.fontFamilies[t].register({
				src: r,
				fontStyle: i,
				fontWeight: a,
				...o
			});
		}
		else {
			let { src: n, fontStyle: r, fontWeight: i, ...a } = e;
			this.fontFamilies[t].register({
				src: n,
				fontStyle: r,
				fontWeight: i,
				...a
			});
		}
	};
	registerEmojiSource = (e) => {
		this.emojiSource = e;
	};
	registerHyphenationCallback = (e) => {
		this.hyphenationCallback = e;
	};
	getFont = (e) => {
		let { fontFamily: t } = e;
		if (!this.fontFamilies[t]) throw Error(`Font family not registered: ${t}. Please register it calling Font.register() method.`);
		return this.fontFamilies[t].resolve(e);
	};
	load = async (e) => {
		let t = this.getFont(e);
		t && await t.load();
	};
	reset = () => {
		let e = Object.keys(this.fontFamilies);
		for (let t = 0; t < e.length; t += 1) {
			let n = e[t];
			for (let e = 0; e < this.fontFamilies[n].sources.length; e++) {
				let t = this.fontFamilies[n].sources[e];
				t.data = null;
			}
		}
	};
	clear = () => {
		this.fontFamilies = {};
	};
	getRegisteredFonts = () => this.fontFamilies;
	getEmojiSource = () => this.emojiSource;
	getHyphenationCallback = () => this.hyphenationCallback;
	getRegisteredFontFamilies = () => Object.keys(this.fontFamilies);
}, Qq = (e, t, n) => {
	if (e >= 0 && e >= n.length || e < 0 && Math.abs(e) > n.length) return n;
	let r = e < 0 ? n.length + e : e;
	return Object.assign([], n, { [r]: t(n[r]) });
}, $q = (e) => e && e.replace(/(^|\s)\S/g, (e) => e.toUpperCase()), eJ = (e) => Array.isArray(e) ? e : [e], tJ = (...e) => (t, ...n) => {
	let r = t, i = e.slice().reverse();
	for (let e = 0; e < i.length; e += 1) {
		let t = i[e];
		r = t(r, ...n);
	}
	return r;
}, nJ = (e) => e.slice(0, e.length - 1);
function rJ(e, t) {
	let n = {}, r = Object.keys(t);
	for (let i = 0; i < r.length; i += 1) {
		let a = r[i], o = e[a];
		typeof o == "function" ? n[a] = o(t[a]) : n[a] = t[a];
	}
	return n;
}
var iJ = (e) => e == null;
function aJ(e) {
	return e === "" ? "" : e[e.length - 1];
}
var oJ = (e, t) => Object.entries(e).reduce((e, [n, r], i) => (e[n] = t(r, n, i), e), {}), sJ = (e) => /((-)?\d+\.?\d*)%/g.exec(`${e}`), cJ = (e) => {
	let t = sJ(e);
	if (t) {
		let e = parseFloat(t[1]);
		return {
			percent: e / 100,
			value: e
		};
	}
	return null;
}, lJ = (e, t) => {
	let n = {};
	for (let r = 0; r < e.length; r += 1) {
		let i = e[r];
		i in t && (n[i] = t[i]);
	}
	return n;
}, uJ = (e, t = 0) => {
	let n = Array(t);
	for (let r = 0; r < t; r += 1) n[r] = e;
	return n;
}, dJ = (e) => Array.prototype.slice.call(e, 0).reverse(), fJ = (e) => e && e.charAt(0).toUpperCase() + e.slice(1), pJ = (e, t) => {
	let n = [];
	for (let r = 0; r < t.length; r += 1) {
		let i = t[r];
		e.includes(i) || n.push(i);
	}
	return n;
}, mJ = (e) => typeof e == "string" ? Number.parseFloat(e) : e, hJ = /* @__PURE__ */ V(((e, t) => {
	t.exports = n;
	function n(e) {
		var t = 0, n = 0, r = 0, i = 0;
		return e.map(function(e) {
			e = e.slice();
			var a = e[0], o = a.toUpperCase();
			if (a != o) switch (e[0] = o, a) {
				case "a":
					e[6] += r, e[7] += i;
					break;
				case "v":
					e[1] += i;
					break;
				case "h":
					e[1] += r;
					break;
				default: for (var s = 1; s < e.length;) e[s++] += r, e[s++] += i;
			}
			switch (o) {
				case "Z":
					r = t, i = n;
					break;
				case "H":
					r = e[1];
					break;
				case "V":
					i = e[1];
					break;
				case "M":
					r = t = e[1], i = n = e[2];
					break;
				default: r = e[e.length - 2], i = e[e.length - 1];
			}
			return e;
		});
	}
})), gJ = /* @__PURE__ */ V(((e, t) => {
	t.exports = i;
	var n = {
		a: 7,
		c: 6,
		h: 1,
		l: 2,
		m: 2,
		q: 4,
		s: 4,
		t: 2,
		v: 1,
		z: 0
	}, r = /([astvzqmhlc])([^astvzqmhlc]*)/gi;
	function i(e) {
		var t = [];
		return e.replace(r, function(e, r, i) {
			var a = r.toLowerCase();
			for (i = o(i), a == "m" && i.length > 2 && (t.push([r].concat(i.splice(0, 2))), a = "l", r = r == "m" ? "l" : "L");;) {
				if (i.length == n[a]) return i.unshift(r), t.push(i);
				if (i.length < n[a]) throw Error("malformed path data");
				t.push([r].concat(i.splice(0, n[a])));
			}
		}), t;
	}
	var a = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/gi;
	function o(e) {
		var t = e.match(a);
		return t ? t.map(Number) : [];
	}
})), _J = /* @__PURE__ */ xt(hJ(), 1), vJ = /* @__PURE__ */ xt(gJ(), 1), yJ = function() {
	function e(e, t) {
		var n = [], r = !0, i = !1, a = void 0;
		try {
			for (var o = e[Symbol.iterator](), s; !(r = (s = o.next()).done) && (n.push(s.value), !(t && n.length === t)); r = !0);
		} catch (e) {
			i = !0, a = e;
		} finally {
			try {
				!r && o.return && o.return();
			} finally {
				if (i) throw a;
			}
		}
		return n;
	}
	return function(t, n) {
		if (Array.isArray(t)) return t;
		if (Symbol.iterator in Object(t)) return e(t, n);
		throw TypeError("Invalid attempt to destructure non-iterable instance");
	};
}(), bJ = Math.PI * 2, xJ = function(e, t, n, r, i, a, o) {
	var s = e.x, c = e.y;
	s *= t, c *= n;
	var l = r * s - i * c, u = i * s + r * c;
	return {
		x: l + a,
		y: u + o
	};
}, SJ = function(e, t) {
	var n = t === 1.5707963267948966 ? .551915024494 : t === -1.5707963267948966 ? -.551915024494 : 4 / 3 * Math.tan(t / 4), r = Math.cos(e), i = Math.sin(e), a = Math.cos(e + t), o = Math.sin(e + t);
	return [
		{
			x: r - i * n,
			y: i + r * n
		},
		{
			x: a + o * n,
			y: o - a * n
		},
		{
			x: a,
			y: o
		}
	];
}, CJ = function(e, t, n, r) {
	var i = e * r - t * n < 0 ? -1 : 1, a = e * n + t * r;
	return a > 1 && (a = 1), a < -1 && (a = -1), i * Math.acos(a);
}, wJ = function(e, t, n, r, i, a, o, s, c, l, u, d) {
	var f = i ** 2, p = a ** 2, m = u ** 2, h = d ** 2, g = f * p - f * h - p * m;
	g < 0 && (g = 0), g /= f * h + p * m, g = Math.sqrt(g) * (o === s ? -1 : 1);
	var _ = g * i / a * d, v = g * -a / i * u, y = l * _ - c * v + (e + n) / 2, b = c * _ + l * v + (t + r) / 2, x = (u - _) / i, S = (d - v) / a, C = (-u - _) / i, w = (-d - v) / a, T = CJ(1, 0, x, S), E = CJ(x, S, C, w);
	return s === 0 && E > 0 && (E -= bJ), s === 1 && E < 0 && (E += bJ), [
		y,
		b,
		T,
		E
	];
}, TJ = function(e) {
	var t = e.px, n = e.py, r = e.cx, i = e.cy, a = e.rx, o = e.ry, s = e.xAxisRotation, c = s === void 0 ? 0 : s, l = e.largeArcFlag, u = l === void 0 ? 0 : l, d = e.sweepFlag, f = d === void 0 ? 0 : d, p = [];
	if (a === 0 || o === 0) return [];
	var m = Math.sin(c * bJ / 360), h = Math.cos(c * bJ / 360), g = h * (t - r) / 2 + m * (n - i) / 2, _ = -m * (t - r) / 2 + h * (n - i) / 2;
	if (g === 0 && _ === 0) return [];
	a = Math.abs(a), o = Math.abs(o);
	var v = g ** 2 / a ** 2 + _ ** 2 / o ** 2;
	v > 1 && (a *= Math.sqrt(v), o *= Math.sqrt(v));
	var y = yJ(wJ(t, n, r, i, a, o, u, f, m, h, g, _), 4), b = y[0], x = y[1], S = y[2], C = y[3], w = Math.abs(C) / (bJ / 4);
	Math.abs(1 - w) < 1e-7 && (w = 1);
	var T = Math.max(Math.ceil(w), 1);
	C /= T;
	for (var E = 0; E < T; E++) p.push(SJ(S, C)), S += C;
	return p.map(function(e) {
		var t = xJ(e[0], a, o, h, m, b, x), n = t.x, r = t.y, i = xJ(e[1], a, o, h, m, b, x), s = i.x, c = i.y, l = xJ(e[2], a, o, h, m, b, x);
		return {
			x1: n,
			y1: r,
			x2: s,
			y2: c,
			x: l.x,
			y: l.y
		};
	});
};
//#endregion
//#region ../../node_modules/normalize-svg-path/index.mjs
function EJ(e) {
	for (var t, n = [], r = 0, i = 0, a = 0, o = 0, s = null, c = null, l = 0, u = 0, d = 0, f = e.length; d < f; d++) {
		var p = e[d], m = p[0];
		switch (m) {
			case "M":
				a = p[1], o = p[2];
				break;
			case "A":
				var h = TJ({
					px: l,
					py: u,
					cx: p[6],
					cy: p[7],
					rx: p[1],
					ry: p[2],
					xAxisRotation: p[3],
					largeArcFlag: p[4],
					sweepFlag: p[5]
				});
				if (!h.length) continue;
				for (var g = 0, _; g < h.length; g++) _ = h[g], p = [
					"C",
					_.x1,
					_.y1,
					_.x2,
					_.y2,
					_.x,
					_.y
				], g < h.length - 1 && n.push(p);
				break;
			case "S":
				var v = l, y = u;
				(t == "C" || t == "S") && (v += v - r, y += y - i), p = [
					"C",
					v,
					y,
					p[1],
					p[2],
					p[3],
					p[4]
				];
				break;
			case "T":
				t == "Q" || t == "T" ? (s = l * 2 - s, c = u * 2 - c) : (s = l, c = u), p = OJ(l, u, s, c, p[1], p[2]);
				break;
			case "Q":
				s = p[1], c = p[2], p = OJ(l, u, p[1], p[2], p[3], p[4]);
				break;
			case "L":
				p = DJ(l, u, p[1], p[2]);
				break;
			case "H":
				p = DJ(l, u, p[1], u);
				break;
			case "V":
				p = DJ(l, u, l, p[1]);
				break;
			case "Z":
				p = DJ(l, u, a, o);
				break;
		}
		t = m, l = p[p.length - 2], u = p[p.length - 1], p.length > 4 ? (r = p[p.length - 4], i = p[p.length - 3]) : (r = l, i = u), n.push(p);
	}
	return n;
}
function DJ(e, t, n, r) {
	return [
		"C",
		e,
		t,
		n,
		r,
		n,
		r
	];
}
function OJ(e, t, n, r, i, a) {
	return [
		"C",
		e / 3 + 2 / 3 * n,
		t / 3 + 2 / 3 * r,
		i / 3 + 2 / 3 * n,
		a / 3 + 2 / 3 * r,
		i,
		a
	];
}
//#endregion
//#region ../../node_modules/color-name/index.js
var kJ = /* @__PURE__ */ V(((e, t) => {
	t.exports = {
		aliceblue: [
			240,
			248,
			255
		],
		antiquewhite: [
			250,
			235,
			215
		],
		aqua: [
			0,
			255,
			255
		],
		aquamarine: [
			127,
			255,
			212
		],
		azure: [
			240,
			255,
			255
		],
		beige: [
			245,
			245,
			220
		],
		bisque: [
			255,
			228,
			196
		],
		black: [
			0,
			0,
			0
		],
		blanchedalmond: [
			255,
			235,
			205
		],
		blue: [
			0,
			0,
			255
		],
		blueviolet: [
			138,
			43,
			226
		],
		brown: [
			165,
			42,
			42
		],
		burlywood: [
			222,
			184,
			135
		],
		cadetblue: [
			95,
			158,
			160
		],
		chartreuse: [
			127,
			255,
			0
		],
		chocolate: [
			210,
			105,
			30
		],
		coral: [
			255,
			127,
			80
		],
		cornflowerblue: [
			100,
			149,
			237
		],
		cornsilk: [
			255,
			248,
			220
		],
		crimson: [
			220,
			20,
			60
		],
		cyan: [
			0,
			255,
			255
		],
		darkblue: [
			0,
			0,
			139
		],
		darkcyan: [
			0,
			139,
			139
		],
		darkgoldenrod: [
			184,
			134,
			11
		],
		darkgray: [
			169,
			169,
			169
		],
		darkgreen: [
			0,
			100,
			0
		],
		darkgrey: [
			169,
			169,
			169
		],
		darkkhaki: [
			189,
			183,
			107
		],
		darkmagenta: [
			139,
			0,
			139
		],
		darkolivegreen: [
			85,
			107,
			47
		],
		darkorange: [
			255,
			140,
			0
		],
		darkorchid: [
			153,
			50,
			204
		],
		darkred: [
			139,
			0,
			0
		],
		darksalmon: [
			233,
			150,
			122
		],
		darkseagreen: [
			143,
			188,
			143
		],
		darkslateblue: [
			72,
			61,
			139
		],
		darkslategray: [
			47,
			79,
			79
		],
		darkslategrey: [
			47,
			79,
			79
		],
		darkturquoise: [
			0,
			206,
			209
		],
		darkviolet: [
			148,
			0,
			211
		],
		deeppink: [
			255,
			20,
			147
		],
		deepskyblue: [
			0,
			191,
			255
		],
		dimgray: [
			105,
			105,
			105
		],
		dimgrey: [
			105,
			105,
			105
		],
		dodgerblue: [
			30,
			144,
			255
		],
		firebrick: [
			178,
			34,
			34
		],
		floralwhite: [
			255,
			250,
			240
		],
		forestgreen: [
			34,
			139,
			34
		],
		fuchsia: [
			255,
			0,
			255
		],
		gainsboro: [
			220,
			220,
			220
		],
		ghostwhite: [
			248,
			248,
			255
		],
		gold: [
			255,
			215,
			0
		],
		goldenrod: [
			218,
			165,
			32
		],
		gray: [
			128,
			128,
			128
		],
		green: [
			0,
			128,
			0
		],
		greenyellow: [
			173,
			255,
			47
		],
		grey: [
			128,
			128,
			128
		],
		honeydew: [
			240,
			255,
			240
		],
		hotpink: [
			255,
			105,
			180
		],
		indianred: [
			205,
			92,
			92
		],
		indigo: [
			75,
			0,
			130
		],
		ivory: [
			255,
			255,
			240
		],
		khaki: [
			240,
			230,
			140
		],
		lavender: [
			230,
			230,
			250
		],
		lavenderblush: [
			255,
			240,
			245
		],
		lawngreen: [
			124,
			252,
			0
		],
		lemonchiffon: [
			255,
			250,
			205
		],
		lightblue: [
			173,
			216,
			230
		],
		lightcoral: [
			240,
			128,
			128
		],
		lightcyan: [
			224,
			255,
			255
		],
		lightgoldenrodyellow: [
			250,
			250,
			210
		],
		lightgray: [
			211,
			211,
			211
		],
		lightgreen: [
			144,
			238,
			144
		],
		lightgrey: [
			211,
			211,
			211
		],
		lightpink: [
			255,
			182,
			193
		],
		lightsalmon: [
			255,
			160,
			122
		],
		lightseagreen: [
			32,
			178,
			170
		],
		lightskyblue: [
			135,
			206,
			250
		],
		lightslategray: [
			119,
			136,
			153
		],
		lightslategrey: [
			119,
			136,
			153
		],
		lightsteelblue: [
			176,
			196,
			222
		],
		lightyellow: [
			255,
			255,
			224
		],
		lime: [
			0,
			255,
			0
		],
		limegreen: [
			50,
			205,
			50
		],
		linen: [
			250,
			240,
			230
		],
		magenta: [
			255,
			0,
			255
		],
		maroon: [
			128,
			0,
			0
		],
		mediumaquamarine: [
			102,
			205,
			170
		],
		mediumblue: [
			0,
			0,
			205
		],
		mediumorchid: [
			186,
			85,
			211
		],
		mediumpurple: [
			147,
			112,
			219
		],
		mediumseagreen: [
			60,
			179,
			113
		],
		mediumslateblue: [
			123,
			104,
			238
		],
		mediumspringgreen: [
			0,
			250,
			154
		],
		mediumturquoise: [
			72,
			209,
			204
		],
		mediumvioletred: [
			199,
			21,
			133
		],
		midnightblue: [
			25,
			25,
			112
		],
		mintcream: [
			245,
			255,
			250
		],
		mistyrose: [
			255,
			228,
			225
		],
		moccasin: [
			255,
			228,
			181
		],
		navajowhite: [
			255,
			222,
			173
		],
		navy: [
			0,
			0,
			128
		],
		oldlace: [
			253,
			245,
			230
		],
		olive: [
			128,
			128,
			0
		],
		olivedrab: [
			107,
			142,
			35
		],
		orange: [
			255,
			165,
			0
		],
		orangered: [
			255,
			69,
			0
		],
		orchid: [
			218,
			112,
			214
		],
		palegoldenrod: [
			238,
			232,
			170
		],
		palegreen: [
			152,
			251,
			152
		],
		paleturquoise: [
			175,
			238,
			238
		],
		palevioletred: [
			219,
			112,
			147
		],
		papayawhip: [
			255,
			239,
			213
		],
		peachpuff: [
			255,
			218,
			185
		],
		peru: [
			205,
			133,
			63
		],
		pink: [
			255,
			192,
			203
		],
		plum: [
			221,
			160,
			221
		],
		powderblue: [
			176,
			224,
			230
		],
		purple: [
			128,
			0,
			128
		],
		rebeccapurple: [
			102,
			51,
			153
		],
		red: [
			255,
			0,
			0
		],
		rosybrown: [
			188,
			143,
			143
		],
		royalblue: [
			65,
			105,
			225
		],
		saddlebrown: [
			139,
			69,
			19
		],
		salmon: [
			250,
			128,
			114
		],
		sandybrown: [
			244,
			164,
			96
		],
		seagreen: [
			46,
			139,
			87
		],
		seashell: [
			255,
			245,
			238
		],
		sienna: [
			160,
			82,
			45
		],
		silver: [
			192,
			192,
			192
		],
		skyblue: [
			135,
			206,
			235
		],
		slateblue: [
			106,
			90,
			205
		],
		slategray: [
			112,
			128,
			144
		],
		slategrey: [
			112,
			128,
			144
		],
		snow: [
			255,
			250,
			250
		],
		springgreen: [
			0,
			255,
			127
		],
		steelblue: [
			70,
			130,
			180
		],
		tan: [
			210,
			180,
			140
		],
		teal: [
			0,
			128,
			128
		],
		thistle: [
			216,
			191,
			216
		],
		tomato: [
			255,
			99,
			71
		],
		turquoise: [
			64,
			224,
			208
		],
		violet: [
			238,
			130,
			238
		],
		wheat: [
			245,
			222,
			179
		],
		white: [
			255,
			255,
			255
		],
		whitesmoke: [
			245,
			245,
			245
		],
		yellow: [
			255,
			255,
			0
		],
		yellowgreen: [
			154,
			205,
			50
		]
	};
})), AJ = /* @__PURE__ */ V(((e, t) => {
	t.exports = function(e) {
		return !e || typeof e == "string" ? !1 : e instanceof Array || Array.isArray(e) || e.length >= 0 && (e.splice instanceof Function || Object.getOwnPropertyDescriptor(e, e.length - 1) && e.constructor.name !== "String");
	};
})), jJ = /* @__PURE__ */ V(((e, t) => {
	var n = AJ(), r = Array.prototype.concat, i = Array.prototype.slice, a = t.exports = function(e) {
		for (var t = [], a = 0, o = e.length; a < o; a++) {
			var s = e[a];
			n(s) ? t = r.call(t, i.call(s)) : t.push(s);
		}
		return t;
	};
	a.wrap = function(e) {
		return function() {
			return e(a(arguments));
		};
	};
})), MJ = /* @__PURE__ */ xt((/* @__PURE__ */ V(((e, t) => {
	var n = kJ(), r = jJ(), i = Object.hasOwnProperty, a = Object.create(null);
	for (var o in n) i.call(n, o) && (a[n[o]] = o);
	var s = t.exports = {
		to: {},
		get: {}
	};
	s.get = function(e) {
		var t = e.substring(0, 3).toLowerCase(), n, r;
		switch (t) {
			case "hsl":
				n = s.get.hsl(e), r = "hsl";
				break;
			case "hwb":
				n = s.get.hwb(e), r = "hwb";
				break;
			default:
				n = s.get.rgb(e), r = "rgb";
				break;
		}
		return n ? {
			model: r,
			value: n
		} : null;
	}, s.get.rgb = function(e) {
		if (!e) return null;
		var t = /^#([a-f0-9]{3,4})$/i, r = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i, a = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/, o = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/, s = /^(\w+)$/, l = [
			0,
			0,
			0,
			1
		], u, d, f;
		if (u = e.match(r)) {
			for (f = u[2], u = u[1], d = 0; d < 3; d++) {
				var p = d * 2;
				l[d] = parseInt(u.slice(p, p + 2), 16);
			}
			f && (l[3] = parseInt(f, 16) / 255);
		} else if (u = e.match(t)) {
			for (u = u[1], f = u[3], d = 0; d < 3; d++) l[d] = parseInt(u[d] + u[d], 16);
			f && (l[3] = parseInt(f + f, 16) / 255);
		} else if (u = e.match(a)) {
			for (d = 0; d < 3; d++) l[d] = parseInt(u[d + 1], 0);
			u[4] && (u[5] ? l[3] = parseFloat(u[4]) * .01 : l[3] = parseFloat(u[4]));
		} else if (u = e.match(o)) {
			for (d = 0; d < 3; d++) l[d] = Math.round(parseFloat(u[d + 1]) * 2.55);
			u[4] && (u[5] ? l[3] = parseFloat(u[4]) * .01 : l[3] = parseFloat(u[4]));
		} else if (u = e.match(s)) return u[1] === "transparent" ? [
			0,
			0,
			0,
			0
		] : i.call(n, u[1]) ? (l = n[u[1]], l[3] = 1, l) : null;
		else return null;
		for (d = 0; d < 3; d++) l[d] = c(l[d], 0, 255);
		return l[3] = c(l[3], 0, 1), l;
	}, s.get.hsl = function(e) {
		if (!e) return null;
		var t = e.match(/^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/);
		if (t) {
			var n = parseFloat(t[4]);
			return [
				(parseFloat(t[1]) % 360 + 360) % 360,
				c(parseFloat(t[2]), 0, 100),
				c(parseFloat(t[3]), 0, 100),
				c(isNaN(n) ? 1 : n, 0, 1)
			];
		}
		return null;
	}, s.get.hwb = function(e) {
		if (!e) return null;
		var t = e.match(/^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/);
		if (t) {
			var n = parseFloat(t[4]);
			return [
				(parseFloat(t[1]) % 360 + 360) % 360,
				c(parseFloat(t[2]), 0, 100),
				c(parseFloat(t[3]), 0, 100),
				c(isNaN(n) ? 1 : n, 0, 1)
			];
		}
		return null;
	}, s.to.hex = function() {
		var e = r(arguments);
		return "#" + l(e[0]) + l(e[1]) + l(e[2]) + (e[3] < 1 ? l(Math.round(e[3] * 255)) : "");
	}, s.to.rgb = function() {
		var e = r(arguments);
		return e.length < 4 || e[3] === 1 ? "rgb(" + Math.round(e[0]) + ", " + Math.round(e[1]) + ", " + Math.round(e[2]) + ")" : "rgba(" + Math.round(e[0]) + ", " + Math.round(e[1]) + ", " + Math.round(e[2]) + ", " + e[3] + ")";
	}, s.to.rgb.percent = function() {
		var e = r(arguments), t = Math.round(e[0] / 255 * 100), n = Math.round(e[1] / 255 * 100), i = Math.round(e[2] / 255 * 100);
		return e.length < 4 || e[3] === 1 ? "rgb(" + t + "%, " + n + "%, " + i + "%)" : "rgba(" + t + "%, " + n + "%, " + i + "%, " + e[3] + ")";
	}, s.to.hsl = function() {
		var e = r(arguments);
		return e.length < 4 || e[3] === 1 ? "hsl(" + e[0] + ", " + e[1] + "%, " + e[2] + "%)" : "hsla(" + e[0] + ", " + e[1] + "%, " + e[2] + "%, " + e[3] + ")";
	}, s.to.hwb = function() {
		var e = r(arguments), t = "";
		return e.length >= 4 && e[3] !== 1 && (t = ", " + e[3]), "hwb(" + e[0] + ", " + e[1] + "%, " + e[2] + "%" + t + ")";
	}, s.to.keyword = function(e) {
		return a[e.slice(0, 3)];
	};
	function c(e, t, n) {
		return Math.min(Math.max(t, e), n);
	}
	function l(e) {
		var t = Math.round(e).toString(16).toUpperCase();
		return t.length < 2 ? "0" + t : t;
	}
})))(), 1), NJ = (e, t) => {
	t.props?.d && e.path(t.props.d);
}, PJ = 4 * ((Math.sqrt(2) - 1) / 3), FJ = (e, t) => {
	let n = t.props?.x || 0, r = t.props?.y || 0, i = t.props?.rx || 0, a = t.props?.ry || 0, o = t.props?.width || 0, s = t.props?.height || 0;
	if (!(!o || !s)) {
		if (i && a) {
			let t = i * PJ, c = a * PJ;
			e.moveTo(n + i, r), e.lineTo(n - i + o, r), e.bezierCurveTo(n - i + o + t, r, n + o, r + a - c, n + o, r + a), e.lineTo(n + o, r + s - a), e.bezierCurveTo(n + o, r + s - a + c, n - i + o + t, r + s, n - i + o, r + s), e.lineTo(n + i, r + s), e.bezierCurveTo(n + i - t, r + s, n, r + s - a + c, n, r + s - a), e.lineTo(n, r + a), e.bezierCurveTo(n, r + a - c, n + i - t, r, n + i, r);
		} else e.moveTo(n, r), e.lineTo(n + o, r), e.lineTo(n + o, r + s), e.lineTo(n, r + s);
		e.closePath();
	}
}, IJ = (e, t) => {
	let { x1: n, x2: r, y1: i, y2: a } = t.props || {};
	e.moveTo(n, i), e.lineTo(r, a);
}, LJ = () => {}, RJ = 4 * ((Math.sqrt(2) - 1) / 3), zJ = (e, t, n, r = 0, i = 0) => {
	let a = r - t, o = i - n, s = t * RJ, c = n * RJ, l = a + t * 2, u = o + n * 2, d = a + t, f = o + n;
	e.moveTo(a, f), e.bezierCurveTo(a, f - c, d - s, o, d, o), e.bezierCurveTo(d + s, o, l, f - c, l, f), e.bezierCurveTo(l, f + c, d + s, u, d, u), e.bezierCurveTo(d - s, u, a, f + c, a, f), e.closePath();
}, BJ = (e, t) => {
	let { cx: n, cy: r, rx: i, ry: a } = t.props || {};
	zJ(e, i, a, n, r);
}, VJ = (e, t) => {
	let n = t.props?.cx, r = t.props?.cy, i = t.props?.r;
	zJ(e, i, i, n, r);
}, HJ = (e) => {
	if (e > -1e21 && e < 1e21) return Math.round(e * 1e6) / 1e6;
	throw Error(`unsupported number: ${e}`);
}, UJ = (e, t, n, r, i) => {
	let a = [], o = e._fontSize / 1e3, s, c = 0, l = !1;
	e.save(), e.transform(1, 0, 0, -1, 0, e.page.height), i = e.page.height - i, e.page.fonts[e._font.id] ?? (e.page.fonts[e._font.id] = e._font.ref()), e.addContent("BT"), e.addContent(`1 0 0 1 ${HJ(r)} ${HJ(i)} Tm`), e.addContent(`/${e._font.id} ${HJ(e._fontSize)} Tf`);
	let u = (e) => {
		if (c < e) {
			let r = t.slice(c, e).join(""), i = n[e - 1].xAdvance - n[e - 1].advanceWidth;
			a.push(`<${r}> ${HJ(-i)}`);
		}
		return c = e;
	}, d = (t) => {
		if (u(t), a.length > 0) return e.addContent(`[${a.join(" ")}] TJ`), a.length = 0;
	};
	for (s = 0; s < n.length; s += 1) {
		let t = n[s];
		t.xOffset || t.yOffset ? (d(s), e.addContent(`1 0 0 1 ${HJ(r + t.xOffset * o)} ${HJ(i + t.yOffset * o)} Tm`), d(s + 1), l = !0) : (l &&= (e.addContent(`1 0 0 1 ${HJ(r)} ${HJ(i)} Tm`), !1), t.xAdvance - t.advanceWidth !== 0 && u(s + 1)), r += t.xAdvance * o;
	}
	return d(s), e.addContent("ET"), e.restore();
}, WJ = (e, t, n, r, i) => {
	let a = 1e3 / e._fontSize, o = 1e3 / (e._font.font.unitsPerEm || 1e3);
	return UJ(e, e._font.encodeGlyphs(t), n.map((e, n) => ({
		xAdvance: e.xAdvance * a,
		yAdvance: e.yAdvance * a,
		xOffset: e.xOffset,
		yOffset: e.yOffset,
		advanceWidth: t[n].advanceWidth * o
	})), r, i);
}, GJ = (e, t) => {
	if (!t.glyphs || !t.positions) return;
	let n = t.xAdvance, r = t.attributes.font?.[0], { fontSize: i, color: a, opacity: o } = t.attributes;
	a && e.fillColor(a), e.fillOpacity(o), r && e.font(r.type === "STANDARD" ? r.fullName : r, i);
	try {
		WJ(e, t.glyphs, t.positions, 0, 0);
	} catch (e) {
		console.log(e);
	}
	e.translate(n, 0);
}, KJ = (e, t, n, r) => {
	e.save();
	let i = t.box?.x || 0, a = t.box?.y || 0, o = t.runs[0]?.attributes.font?.[0], s = t.runs[0]?.attributes?.scale || 1, c = t.xAdvance;
	if (!o) return;
	let l = o.ascent * s, u = o.xHeight * s, d = o.descent * s, f = o.capHeight * s, p = i, m = a;
	switch (n) {
		case "middle":
			p = i - c / 2;
			break;
		case "end":
			p = i - c;
			break;
		default:
			p = i;
			break;
	}
	switch (r) {
		case "middle":
		case "central":
			m = a + f / 2;
			break;
		case "hanging":
			m = a + f;
			break;
		case "mathematical":
			m = a + u;
			break;
		case "text-after-edge":
			m = a + d;
			break;
		case "text-before-edge":
			m = a + l;
			break;
		default:
			m = a;
			break;
	}
	e.translate(p, m), t.runs.forEach((t) => GJ(e, t)), e.restore();
}, qJ = (e, t) => {
	t.children.forEach((t) => KJ(e, t.lines[0], t.props.textAnchor, t.props.dominantBaseline));
}, JJ = (e) => {
	let t = [];
	for (let n = 0; n < e.length; n += 2) t.push([e[n], e[n + 1]]);
	return t;
}, YJ = (e) => {
	let t = (e || "").trim().replace(/,/g, " ").replace(/(\d)-(\d)/g, "$1 -$2").split(/\s+/);
	return t.length % 2 != 0 && (t = t.slice(0, -1)), JJ(t.map(parseFloat));
}, XJ = (e, t) => {
	t.length > 0 && (e.moveTo(t[0][0], t[0][1]), t.slice(1).forEach((t) => e.lineTo(t[0], t[1])));
}, ZJ = (e, t) => {
	XJ(e, YJ(t.props.points || ""));
}, QJ = (e, t) => {
	XJ(e, YJ(t.props.points || "")), e.closePath();
}, $J = (e, t) => {
	if (!t.box || !t.image?.data) return;
	let { x: n = 0, y: r = 0 } = t.props, { width: i, height: a, opacity: o } = t.style, s = t.box.paddingLeft || 0, c = t.box.paddingLeft || 0;
	if (i === 0 || a === 0) {
		console.warn(`Image with src '${t.props.href}' skipped due to invalid dimensions`);
		return;
	}
	if (typeof i == "string" || typeof a == "string") {
		console.warn(`Image with src '${t.props.href}' skipped due to percentage width or height`);
		return;
	}
	e.save(), e.fillOpacity(o || 1).image(t.image.data, n + c, r + s, {
		width: i,
		height: a
	}), e.restore();
}, eY = 4 * ((Math.sqrt(2) - 1) / 3), tY = (e, t) => {
	if (!t.box || !t.style) return;
	let { top: n, left: r, width: i, height: a } = t.box, { borderTopLeftRadius: o = 0, borderTopRightRadius: s = 0, borderBottomRightRadius: c = 0, borderBottomLeftRadius: l = 0 } = t.style, u = Math.min(s, .5 * i, .5 * a), d = u * (1 - eY);
	e.moveTo(r + u, n), e.lineTo(r + i - u, n), e.bezierCurveTo(r + i - d, n, r + i, n + d, r + i, n + u);
	let f = Math.min(c, .5 * i, .5 * a), p = f * (1 - eY);
	e.lineTo(r + i, n + a - f), e.bezierCurveTo(r + i, n + a - p, r + i - p, n + a, r + i - f, n + a);
	let m = Math.min(l, .5 * i, .5 * a), h = m * (1 - eY);
	e.lineTo(r + m, n + a), e.bezierCurveTo(r + h, n + a, r, n + a - h, r, n + a - m);
	let g = Math.min(o, .5 * i, .5 * a), _ = g * (1 - eY);
	e.lineTo(r, n + g), e.bezierCurveTo(r, n + _, r + _, n, r + g, n), e.closePath(), e.clip();
}, nY = (e, t, n) => {
	let { operation: r, value: i } = t;
	switch (r) {
		case "scale": {
			let [t, r] = i;
			e.scale(t, r, { origin: n });
			break;
		}
		case "rotate": {
			let [t] = i;
			e.rotate(t, { origin: n });
			break;
		}
		case "translate": {
			let [t, r = 0] = i;
			e.translate(t, r, { origin: n });
			break;
		}
		case "skew": {
			let [t = 0, r = 0] = i, a = t * Math.PI / 180, o = r * Math.PI / 180, s = Math.tan(a), c = Math.tan(o), l = 0, u = 0;
			if (n != null) {
				[l, u] = Array.from(n);
				let e = l + s * u, t = u + c * l;
				l -= e, u -= t;
			}
			e.transform(1, c, s, 1, l, u);
			break;
		}
		case "matrix":
			e.transform(...i);
			break;
		default: console.error(`Transform operation: '${r}' doesn't supported`);
	}
}, rY = (e, t) => {
	if (!t.origin) return;
	let { props: n, style: r } = t, i = [t.origin.left, t.origin.top], a = "transform" in n ? n.transform : void 0;
	(r?.transform || a || []).forEach((t) => {
		nY(e, t, i);
	});
}, iY = (e) => {
	let t = EJ((0, _J.default)((0, vJ.default)(e.props?.d || "")));
	if (!t.length) return [
		0,
		0,
		0,
		0
	];
	let n = [
		Infinity,
		Infinity,
		-Infinity,
		-Infinity
	];
	for (let e = 0, r = t.length; e < r; e += 1) {
		let r = t[e].slice(1);
		for (let e = 0; e < r.length; e += 2) r[e + 0] < n[0] && (n[0] = r[e + 0]), r[e + 1] < n[1] && (n[1] = r[e + 1]), r[e + 0] > n[2] && (n[2] = r[e + 0]), r[e + 1] > n[3] && (n[3] = r[e + 1]);
	}
	return n;
}, aY = (e) => {
	let t = e.props?.r || 0, n = e.props?.cx || 0, r = e.props?.cy || 0;
	return [
		n - t,
		r - t,
		n + t,
		r + t
	];
}, oY = (e) => {
	let t = e.props?.cx || 0, n = e.props?.cy || 0, r = e.props?.rx || 0, i = e.props?.ry || 0;
	return [
		t - r,
		n - i,
		t + r,
		n + i
	];
}, sY = (e) => {
	let t = e.props?.x1 || 0, n = e.props?.y1 || 0, r = e.props?.x2 || 0, i = e.props?.y2 || 0;
	return [
		Math.min(t, r),
		Math.min(n, i),
		Math.max(t, r),
		Math.max(n, i)
	];
}, cY = (e) => {
	let t = e.props?.x || 0, n = e.props?.y || 0, r = e.props?.width || 0, i = e.props?.height || 0;
	return [
		t,
		n,
		t + r,
		n + i
	];
}, lY = (e) => Math.max(-Infinity, ...e), uY = (e) => Math.min(Infinity, ...e), dY = (e) => {
	let t = YJ(e.props?.points), n = t.map((e) => e[0]), r = t.map((e) => e[1]);
	return [
		uY(n),
		uY(r),
		lY(n),
		lY(r)
	];
}, fY = {
	[qv]: cY,
	[Jv]: sY,
	[Kv]: iY,
	[iy]: aY,
	[ay]: oY,
	[oy]: dY,
	[cy]: dY
}, pY = (e) => {
	let t = fY[e.type];
	return t ? t(e) : [
		0,
		0,
		0,
		0
	];
}, mY = (e, t) => {
	if (!t.props || !("strokeWidth" in t.props)) return;
	let n = t.props.strokeWidth;
	n && e.lineWidth(n);
}, hY = (e, t) => {
	if (!t.props || !("stroke" in t.props)) return;
	let n = t.props.stroke;
	n && e.strokeColor(n);
}, gY = (e, t) => {
	if (!t.props || !("opacity" in t.props)) return;
	let n = t.props.opacity;
	iJ(n) || e.opacity(n);
}, _Y = (e, t) => {
	if (!t.props || !("fillOpacity" in t.props)) return;
	let n = t.props.fillOpacity || null;
	iJ(n) || e.fillOpacity(n);
}, vY = (e, t) => {
	if (!t.props || !("strokeOpacity" in t.props)) return;
	let n = t.props?.strokeOpacity;
	iJ(n) || e.strokeOpacity(n);
}, yY = (e, t) => {
	if (!t.props || !("strokeLinejoin" in t.props)) return;
	let n = t.props.strokeLinejoin;
	n && e.lineJoin(n);
}, bY = (e, t) => {
	if (!t.props || !("strokeLinecap" in t.props)) return;
	let n = t.props?.strokeLinecap;
	n && e.lineCap(n);
}, xY = (e, t) => {
	if (!t.props || !("strokeDasharray" in t.props)) return;
	let n = t.props?.strokeDasharray || null;
	n && e.dash(n.split(/[\s,]+/).map(Number));
}, SY = (e) => !e.props || !("fill" in e.props) || typeof e.props.fill == "string" ? !1 : e.props.fill?.type === uy, CY = (e) => !e.props || !("fill" in e.props) || typeof e.props.fill == "string" ? !1 : e.props.fill?.type === dy;
function wY(e, t) {
	return [
		e[0] * t[0] + e[2] * t[1],
		e[1] * t[0] + e[3] * t[1],
		e[0] * t[2] + e[2] * t[3],
		e[1] * t[2] + e[3] * t[3],
		e[0] * t[4] + e[2] * t[5] + e[4],
		e[1] * t[4] + e[3] * t[5] + e[5]
	];
}
var TY = (e, t, n, r) => {
	let i = t.map((e) => {
		switch (e.operation) {
			case "scale": {
				let t = e.value;
				return [
					t[0],
					0,
					0,
					t[1],
					0,
					0
				];
			}
			case "translate": {
				let t = e.value, i = t[0] || 0, a = t[1] || 0;
				return r === "objectBoundingBox" && (i = (n[2] - n[0]) * i, a = (n[3] - n[1]) * a), [
					1,
					0,
					0,
					1,
					i,
					a
				];
			}
			case "rotate": {
				let t = e.value, n = Math.cos(t[0]), r = Math.sin(t[0]);
				return [
					n,
					r,
					-r,
					n,
					0,
					0
				];
			}
			case "skew": {
				let t = e.value;
				return [
					1,
					Math.tan(t[0]),
					Math.tan(t[1]),
					1,
					0,
					0
				];
			}
			case "matrix": {
				let t = e.value, i = t[4] || 0, a = t[5] || 0;
				return r === "objectBoundingBox" && (i = (n[2] - n[0]) * i, a = (n[3] - n[1]) * a), [
					t[0],
					t[1],
					t[2],
					t[3],
					i,
					a
				];
			}
			default: return [
				1,
				0,
				0,
				1,
				0,
				0
			];
		}
	}).reduce(wY, [
		1,
		0,
		0,
		1,
		0,
		0
	]);
	e.setTransform(...i);
}, EY = (e, t) => {
	if (!t.props || !("fill" in t.props)) return;
	let n = pY(t), r = t.props?.fill;
	if (!r) return;
	let i = r.props.gradientUnits || "objectBoundingBox", a = r.props.gradientTransform || [], o = r.props.x1 || 0, s = r.props.y1 || 0, c = r.props.x2 || 1, l = r.props.y2 || 0;
	if (i === "objectBoundingBox") {
		let e = n[2] - n[0], t = n[3] - n[1], r = n[0], i = n[1];
		o = e * o + r, s = t * s + i, c = e * c + r, l = t * l + i;
	}
	let u = e.linearGradient(o, s, c, l);
	TY(u, a, n, i), r.children?.forEach((e) => {
		u.stop(e.props.offset, e.props.stopColor, e.props.stopOpacity);
	}), e.fill(u);
}, DY = (e, t) => {
	if (!t.props || !("fill" in t.props)) return;
	let n = pY(t), r = t.props?.fill;
	if (!r) return;
	let i = r.props.gradientUnits || "objectBoundingBox", a = r.props.gradientTransform || [], o = r.props.r || .5, s = r.props.cx || .5, c = r.props.cy || .5, l = r.props.fx || s, u = r.props.fy || c;
	if (i === "objectBoundingBox") {
		let e = n[2] - n[0], t = n[3] - n[1], r = n[0], i = n[1];
		o *= e, s = e * s + r, c = t * c + i, l = e * l + r, u = t * u + i;
	}
	let d = e.radialGradient(s, c, 0, l, u, o);
	TY(d, a, n, i), r.children?.forEach((e) => {
		d.stop(e.props.offset, e.props.stopColor, e.props.stopOpacity);
	}), e.fill(d);
}, OY = (e, t) => {
	if (!t.props || !("fill" in t.props)) return;
	let n = t.props?.fill;
	n && e.fillColor(n);
}, kY = (e, t) => SY(t) ? EY(e, t) : CY(t) ? DY(e, t) : OY(e, t), AY = (e, t) => {
	let n = t.props || {};
	"fill" in n && "stroke" in n && n.fill && n.stroke ? e.fillAndStroke(n.fillRule) : "fill" in n && n.fill ? e.fill(n.fillRule) : "stroke" in n && n.stroke ? e.stroke() : (e.save(), e.opacity(0), e.fill(null), e.restore());
}, jY = () => {}, MY = {
	[ny]: jY,
	[ly]: jY,
	[Kv]: NJ,
	[qv]: FJ,
	[Jv]: IJ,
	G: LJ,
	[Hv]: qJ,
	[iy]: VJ,
	[ty]: $J,
	[ay]: BJ,
	[oy]: QJ,
	[cy]: ZJ
}, NY = (e, t) => {
	let n = MY[t.type];
	n ? n(e, t) : console.warn(`SVG node of type ${t.type} is not currently supported`);
}, PY = (e, t) => {
	bY(e, t), xY(e, t), yY(e, t), mY(e, t), hY(e, t), kY(e, t), vY(e, t), _Y(e, t), gY(e, t), rY(e, t), NY(e, t), AY(e, t);
}, FY = (e, t) => {
	if (!t.props || !("clipPath" in t.props)) return;
	let n = t.props.clipPath;
	n && ((n.children || []).forEach((t) => NY(e, t)), e.clip());
}, IY = (e, t) => {
	(t.children || []).forEach((t) => {
		e.save(), FY(e, t), PY(e, t), IY(e, t), e.restore();
	});
}, LY = (e, t) => {
	if (!t.box) return;
	let { width: n, height: r } = t.box, { viewBox: i, preserveAspectRatio: a } = t.props, { meetOrSlice: o = "meet", align: s = "xMidYMid" } = a || {};
	if (i == null || n == null || r == null) return;
	let c = i?.minX || 0, l = i?.minY || 0, u = i?.maxX || n, d = i?.maxY || r, f = u / d, p = n / r, m = n / u, h = r / d;
	if (s === "none") {
		e.scale(m, h), e.translate(-c, -l);
		return;
	}
	if (f < p && o === "meet" || f >= p && o === "slice") switch (e.scale(h, h), s) {
		case "xMinYMin":
		case "xMinYMid":
		case "xMinYMax":
			e.translate(-c, -l);
			break;
		case "xMidYMin":
		case "xMidYMid":
		case "xMidYMax":
			e.translate(-c - (u - n * d / r) / 2, -l);
			break;
		default: e.translate(-c - (u - n * d / r), -l);
	}
	else switch (e.scale(m, m), s) {
		case "xMinYMin":
		case "xMidYMin":
		case "xMaxYMin":
			e.translate(-c, -l);
			break;
		case "xMinYMid":
		case "xMidYMid":
		case "xMaxYMid":
			e.translate(-c, -l - (d - r * u / n) / 2);
			break;
		default: e.translate(-c, -l - (d - r * u / n));
	}
}, RY = (e, t) => {
	if (!t.box) return;
	let { top: n, left: r } = t.box, i = t.box.paddingLeft || 0, a = t.box.paddingTop || 0;
	e.translate(r + i, n + a);
}, zY = (e, t) => {
	e.save(), tY(e, t), RY(e, t), LY(e, t), IY(e, t), e.restore();
}, BY = {
	value: "#000",
	opacity: 1
}, VY = (e) => {
	if (!e) return BY;
	let t = MJ.default.get(e);
	return t ? {
		value: MJ.default.to.hex(t.value.slice(0, 3)),
		opacity: t.value[3]
	} : BY;
}, HY = /^#.+/, UY = (e) => e.match(HY), WY = (e, t) => {
	let { xOffset: n = 0, yOffset: r = 0, width: i, height: a, image: o } = t;
	e.translate(-i + n, -a + r), e.image(o, 0, 0, {
		fit: [i, a],
		align: "center",
		valign: "bottom"
	});
}, GY = (e, t) => {
	if (!t.glyphs || !t.positions) return;
	let n = t.attributes.font?.[0];
	if (!n) return;
	e.save();
	let r = n.glyphForCodePoint(32), i = n.glyphForCodePoint(65532), a = 0;
	for (let n = 0; n < t.glyphs.length; n += 1) {
		let o = t.positions[n], s = t.glyphs[n];
		a += o.xAdvance || 0, s.id === i.id && t.attributes.attachment && (e.translate(a, o.yOffset || 0), WY(e, t.attributes.attachment), t.glyphs[n] = r, a = 0);
	}
	e.restore();
}, KY = (e, t) => {
	if (!t.glyphs || !t.positions) return;
	let n = t.attributes.font?.[0];
	if (!n) return;
	let { fontSize: r, link: i } = t.attributes, a = VY(t.attributes.color), o = iJ(t.attributes.opacity) ? a.opacity : t.attributes.opacity, { height: s = 0, descent: c = 0, xAdvance: l = 0 } = t;
	e.fillColor(a.value), e.fillOpacity(o), i && (UY(i) ? e.goTo(0, -s - c, l, s, i.slice(1)) : e.link(0, -s - c, l, s, i)), GY(e, t), e.font(n.type === "STANDARD" ? n.fullName : n, r);
	try {
		WJ(e, t.glyphs, t.positions, 0, 0);
	} catch (e) {
		console.log(e);
	}
	e.translate(l, 0);
}, qY = (e, t, n) => {
	let r = VY(n);
	e.save(), e.fillOpacity(r.opacity), e.rect(t.x, t.y, t.width, t.height), e.fill(r.value), e.restore();
}, JY = (e, t) => {
	if (e.save(), e.lineWidth(t.rect.height), e.strokeOpacity(t.opacity), /dashed/.test(t.style) ? e.dash(3 * t.rect.height, {}) : /dotted/.test(t.style) && e.dash(t.rect.height, {}), /wavy/.test(t.style)) {
		let n = Math.max(2, t.rect.height), r = 1.1 * n, i = Math.floor(t.rect.width / (2 * r)), a = (t.rect.width - i * 2 * r) / i / 2;
		r += a;
		let o = t.rect.y + n, s = t.rect.y - n, { x: c } = t.rect;
		e.moveTo(t.rect.x, t.rect.y);
		for (let n = 0; n < i; n += 1) e.bezierCurveTo(c + r, o, c + r, s, c + 2 * r, t.rect.y), c += 2 * r;
	} else e.moveTo(t.rect.x, t.rect.y), e.lineTo(t.rect.x + t.rect.width, t.rect.y), /double/.test(t.style) && (e.moveTo(t.rect.x, t.rect.y + t.rect.height * 2), e.lineTo(t.rect.x + t.rect.width, t.rect.y + t.rect.height * 2));
	e.stroke(t.color), e.restore();
}, YY = (e, t) => {
	if (!t.box) return;
	let n = t.ascent || 0;
	e.save(), e.translate(t.box.x, t.box.y + n);
	for (let r = 0; r < t.runs.length; r += 1) {
		let i = t.runs[r], a = r === t.runs.length - 1;
		if (i.attributes.backgroundColor) {
			let r = i.xAdvance ?? 0, o = a ? t.overflowRight ?? 0 : 0;
			qY(e, {
				x: 0,
				y: -n,
				height: t.box.height,
				width: r - o
			}, i.attributes.backgroundColor);
		}
		KY(e, i);
	}
	if (e.restore(), e.save(), e.translate(t.box.x, t.box.y), t.decorationLines) for (let n = 0; n < t.decorationLines.length; n += 1) {
		let r = t.decorationLines[n];
		JY(e, r);
	}
	e.restore();
}, XY = (e, t) => {
	t.forEach((t) => {
		YY(e, t);
	});
}, ZY = (e, t) => {
	if (!t.box || !t.lines) return;
	let { top: n, left: r } = t.box, i = [t.lines], a = t.box?.paddingTop || 0, o = t.box?.paddingLeft || 0, s = t.lines[0] ? t.lines[0].box.y : 0, c = t.alignOffset || 0;
	e.save(), e.translate(r + o - c, n + a - s), i.forEach((t) => {
		XY(e, t);
	}), e.restore();
}, QY = (e, t) => {
	if (!t.box) return;
	let { width: n, height: r } = t.box, i = (t.props?.dpi || 72) / 72;
	e.addPage({
		size: [n, r],
		margin: 0,
		userUnit: i
	});
}, $Y = (e, t) => {
	if (!t.box) return;
	let { top: n, left: r } = t.box, i = t?.children?.[0].value || "", a = t.style?.backgroundColor;
	e.note(r, n, 0, 0, i, { color: a });
}, eX = (e, t) => {
	let n = t.image.data, r;
	return typeof n == "string" && (r = e._imageRegistry[n]), r ||= e.openImage(n), r.obj || r.embed(e), r;
}, tX = (e) => !Number.isNaN(parseFloat(e)) && Number.isFinite(e), nX = (e, t, n, r, i, a) => {
	let o = e / t, s = n / r, c = cJ(i ?? null), l = cJ(a ?? null), u = c ? c.percent : .5, d = l ? l.percent : .5;
	if (o > s) {
		let n = t, r = n * s, o = tX(a) ? a : 0;
		return {
			width: r,
			height: n,
			xOffset: tX(i) ? i : (e - r) * u,
			yOffset: o
		};
	}
	let f = e, p = f / s, m = tX(i) ? i : 0;
	return {
		width: f,
		height: p,
		yOffset: tX(a) ? a : (t - p) * d,
		xOffset: m
	};
}, rX = (e, t, n, r, i, a) => {
	let o = n, s = r, c = cJ(i ?? null), l = cJ(a ?? null), u = c ? c.percent : .5, d = l ? l.percent : .5;
	return {
		width: o,
		height: s,
		xOffset: tX(i) ? i : (e - o) * u,
		yOffset: tX(a) ? a : (t - s) * d
	};
}, iX = (e, t, n, r, i, a) => {
	let o = n / r, s = e / t, c = cJ(i ?? null), l = cJ(a ?? null), u = c ? c.percent : .5, d = l ? l.percent : .5;
	if (s > o) {
		let n = e, r = n / o, s = tX(i) ? i : 0;
		return {
			width: n,
			height: r,
			yOffset: tX(a) ? a : (t - r) * d,
			xOffset: s
		};
	}
	let f = t, p = f * o;
	return {
		width: p,
		height: f,
		xOffset: tX(i) ? i : (e - p) * u,
		yOffset: tX(a) ? a : 0
	};
}, aX = (e, t, n, r, i, a) => {
	let o = nX(e, t, n, r, i, a), s = rX(e, t, n, r, i, a);
	return o.width < s.width ? o : s;
}, oX = (e, t, n, r) => ({
	width: e,
	height: t,
	xOffset: cJ(n ?? null) ? 0 : n || 0,
	yOffset: cJ(r ?? null) ? 0 : r || 0
}), sX = (e = "fill", t, n, r, i, a, o) => {
	switch (e) {
		case "contain": return nX(t, n, r, i, a, o);
		case "cover": return iX(t, n, r, i, a, o);
		case "none": return rX(t, n, r, i, a, o);
		case "scale-down": return aX(t, n, r, i, a, o);
		default: return oX(t, n, a, o);
	}
}, cX = (e, t, n) => {
	if (!t.box || !t.image) return;
	let { left: r, top: i } = t.box, a = t.style?.opacity, o = t.style?.objectFit, s = t.style?.objectPositionX, c = t.style?.objectPositionY, l = t.box.paddingTop || 0, u = t.box.paddingRight || 0, d = t.box.paddingBottom || 0, f = t.box.paddingLeft || 0, p = n.imageCache || /* @__PURE__ */ new Map(), { width: m, height: h, xOffset: g, yOffset: _ } = sX(o, t.box.width - f - u, t.box.height - l - d, t.image.width, t.image.height, s, c);
	if (t.image.data) if (m !== 0 && h !== 0) {
		let n = t.image.key, o = p.get(n) || eX(e, t);
		n && p.set(n, o);
		let s = iJ(a) ? 1 : a;
		e.fillOpacity(s).image(o, r + f + g, i + l + _, {
			width: m,
			height: h
		});
	} else console.warn(`Image with src '${JSON.stringify(t.props.src || t.props.source)}' skipped due to invalid dimensions`);
}, lX = (e, t, n) => {
	e.save(), tY(e, t), cX(e, t, n), e.restore();
}, uX = "#a1c6e7", dX = "#c4deb9", fX = "#f8cca1", pX = (e, t) => {
	if (!t.box) return;
	let { left: n, top: r, width: i, height: a, paddingLeft: o = 0, paddingTop: s = 0, paddingRight: c = 0, paddingBottom: l = 0, borderLeftWidth: u = 0, borderTopWidth: d = 0, borderRightWidth: f = 0, borderBottomWidth: p = 0 } = t.box;
	e.fillColor(uX).opacity(.5).rect(n + o + u, r + s + d, i - o - c - f - u, a - s - l - d - p).fill();
}, mX = (e, t) => {
	if (!t.box) return;
	let { left: n, top: r, width: i, height: a, paddingLeft: o = 0, paddingTop: s = 0, paddingRight: c = 0, paddingBottom: l = 0, borderLeftWidth: u = 0, borderTopWidth: d = 0, borderRightWidth: f = 0, borderBottomWidth: p = 0 } = t.box;
	e.fillColor(dX).opacity(.5), e.rect(n + o + u, r + d, i - c - o - u - f, s).fill(), e.rect(n + u, r + d, o, a - d - p).fill(), e.rect(n + i - c - f, r + d, c, a - d - p).fill(), e.rect(n + o + u, r + a - l - p, i - c - o - u - f, l).fill();
}, hX = (e, t) => {
	if (!t.box) return;
	let { left: n, top: r, width: i, height: a } = t.box, { marginLeft: o = 0, marginTop: s = 0, marginRight: c = 0, marginBottom: l = 0 } = t.box;
	e.fillColor(fX).opacity(.5), e.rect(n, r - s, i, s).fill(), e.rect(n - o, r - s, o, a + s + l).fill(), e.rect(n + i, r - s, c, a + s + l).fill(), e.rect(n, r + a, i, l).fill();
}, gX = (e, t) => {
	if (!t.box) return;
	let { left: n, top: r, width: i, height: a } = t.box, { marginLeft: o = 0, marginTop: s = 0, marginRight: c = 0, marginBottom: l = 0 } = t.box, u = Math.round(i + o + c), d = Math.round(a + s + l);
	e.fontSize(6).opacity(1).fillColor("black").text(`${u} x ${d}`, n - o, Math.max(r - s - 4, 1), { width: Infinity });
}, _X = (e, t) => {
	t.origin && e.circle(t.origin.left, t.origin.top, 3).fill("red").circle(t.origin.left, t.origin.top, 5).stroke("red");
}, vX = (e, t) => {
	t.props && (!("debug" in t.props) || !t.props.debug || (e.save(), pX(e, t), mX(e, t), hX(e, t), gX(e, t), _X(e, t), e.restore()));
}, yX = /* @__PURE__ */ "dash.clip.save.path.fill.font.text.rect.scale.moveTo.lineTo.stroke.rotate.circle.lineCap.opacity.ellipse.polygon.restore.lineJoin.fontSize.fillColor.lineWidth.translate.miterLimit.strokeColor.fillOpacity.roundedRect.fillAndStroke.strokeOpacity.bezierCurveTo.quadraticCurveTo.linearGradient.radialGradient".split("."), bX = (e) => {
	let t = yX.reduce((n, r) => ({
		...n,
		[r]: (...n) => (e[r](...n), t)
	}), {});
	return t;
}, xX = (e, t) => {
	if (!t.box) return;
	let { top: n, left: r, width: i, height: a } = t.box, o = t.box.paddingTop || 0, s = t.box.paddingLeft || 0, c = t.box.paddingRight || 0, l = t.box.paddingBottom || 0, u = i - s - c, d = a - o - l;
	(!u || !d) && console.warn("Canvas element has null width or height. Please provide valid values via the `style` prop in order to correctly render it."), e.save().translate(r + s, n + o), t.props.paint && t.props.paint(bX(e), u, d), e.restore();
}, SX = 4 * ((Math.sqrt(2) - 1) / 3), CX = (e, t, n, r, i) => {
	let { top: a, left: o, width: s, height: c } = t, { borderTopWidth: l, borderRightWidth: u, borderLeftWidth: d } = n;
	e.moveTo(o + i, a), e.lineTo(o + s - r, a);
	let f = r * (1 - SX);
	e.bezierCurveTo(o + s - f, a, o + s, a + f, o + s, a + r);
	let p = a + Math.max(l, r);
	e.lineTo(o + s, p), e.lineTo(o + s - u, p);
	let m = Math.max(r - u, 0), h = Math.max(r - l, 0), g = m * (1 - SX), _ = h * (1 - SX);
	e.bezierCurveTo(o + s - u, a + l + _, o + s - u - g, a + l, o + s - u - m, a + l), e.lineTo(o + Math.max(i, d), a + l);
	let v = Math.max(i - d, 0), y = Math.max(i - l, 0), b = v * (1 - SX), x = y * (1 - SX), S = a + Math.max(l, i);
	e.bezierCurveTo(o + d + b, a + l, o + d, a + l + x, o + d, S), e.lineTo(o, S), e.lineTo(o, a + i);
	let C = i * (1 - SX);
	if (e.bezierCurveTo(o, a + C, o + C, a, o + i, a), e.closePath(), e.clip(), u) {
		let t = -l / u;
		e.moveTo(o + s / 2, t * (-s / 2) + a), e.lineTo(o + s, a), e.lineTo(o, a), e.lineTo(o, a + c), e.closePath(), e.clip();
	}
	if (d) {
		let t = -l / d;
		e.moveTo(o + s / 2, t * (-s / 2) + a), e.lineTo(o, a), e.lineTo(o + s, a), e.lineTo(o + s, a + c), e.closePath(), e.clip();
	}
}, wX = (e, t, n, r, i) => {
	let { top: a, left: o, width: s } = t, { borderTopColor: c, borderTopWidth: l, borderTopStyle: u, borderRightWidth: d, borderLeftWidth: f } = n, p = i * (1 - SX), m = r * (1 - SX);
	e.moveTo(o, a + Math.max(i, l)), e.bezierCurveTo(o, a + p, o + p, a, o + i, a), e.lineTo(o + s - r, a), e.bezierCurveTo(o + s - m, a, o + s, a + m, o + s, a + r), e.strokeColor(c), e.lineWidth(Math.max(d, l, f) * 2), u === "dashed" ? e.dash(l * 2, { space: l * 1.2 }) : u === "dotted" && e.dash(l, { space: l * 1.2 }), e.stroke(), e.undash();
}, TX = (e, t, n, r, i) => {
	let { top: a, left: o, width: s, height: c } = t, { borderTopWidth: l, borderRightWidth: u, borderBottomWidth: d } = n;
	e.moveTo(o + s, a + r), e.lineTo(o + s, a + c - i);
	let f = i * (1 - SX);
	e.bezierCurveTo(o + s, a + c - f, o + s - f, a + c, o + s - i, a + c);
	let p = o + s - Math.max(u, i);
	e.lineTo(p, a + c), e.lineTo(p, a + c - d);
	let m = Math.max(i - u, 0), h = Math.max(i - d, 0), g = m * (1 - SX), _ = h * (1 - SX);
	e.bezierCurveTo(o + s - u - g, a + c - d, o + s - u, a + c - d - _, o + s - u, a + c - Math.max(i, d)), e.lineTo(o + s - u, a + Math.max(r, l));
	let v = Math.max(r - u, 0), y = Math.max(r - l, 0), b = v * (1 - SX), x = y * (1 - SX), S = o + s - Math.max(r, u);
	e.bezierCurveTo(o + s - u, a + l + x, o + s - u - b, a + l, S, a + l), e.lineTo(S, a), e.lineTo(o + s - r, a);
	let C = r * (1 - SX);
	if (e.bezierCurveTo(o + s - C, a, o + s, a + C, o + s, a + r), e.closePath(), e.clip(), l) {
		let t = -l / u;
		e.moveTo(o + s / 2, t * (-s / 2) + a), e.lineTo(o + s, a), e.lineTo(o + s, a + c), e.lineTo(o, a + c), e.closePath(), e.clip();
	}
	if (d) {
		let t = d / u;
		e.moveTo(o + s / 2, t * (-s / 2) + a + c), e.lineTo(o + s, a + c), e.lineTo(o + s, a), e.lineTo(o, a), e.closePath(), e.clip();
	}
}, EX = (e, t, n, r, i) => {
	let { top: a, left: o, width: s, height: c } = t, { borderRightColor: l, borderRightStyle: u, borderRightWidth: d, borderTopWidth: f, borderBottomWidth: p } = n, m = i * (1 - SX), h = r * (1 - SX);
	e.moveTo(o + s - r, a), e.bezierCurveTo(o + s - h, a, o + s, a + h, o + s, a + r), e.lineTo(o + s, a + c - i), e.bezierCurveTo(o + s, a + c - m, o + s - m, a + c, o + s - i, a + c), e.strokeColor(l), e.lineWidth(Math.max(d, f, p) * 2), u === "dashed" ? e.dash(d * 2, { space: d * 1.2 }) : u === "dotted" && e.dash(d, { space: d * 1.2 }), e.stroke(), e.undash();
}, DX = (e, t, n, r, i) => {
	let { top: a, left: o, width: s, height: c } = t, { borderBottomWidth: l, borderRightWidth: u, borderLeftWidth: d } = n;
	e.moveTo(o + s - i, a + c), e.lineTo(o + r, a + c);
	let f = r * (1 - SX);
	e.bezierCurveTo(o + f, a + c, o, a + c - f, o, a + c - r);
	let p = a + c - Math.max(l, r);
	e.lineTo(o, p), e.lineTo(o + d, p);
	let m = Math.max(r - d, 0), h = Math.max(r - l, 0), g = m * (1 - SX), _ = h * (1 - SX);
	e.bezierCurveTo(o + d, a + c - l - _, o + d + g, a + c - l, o + d + m, a + c - l), e.lineTo(o + s - Math.max(i, u), a + c - l);
	let v = Math.max(i - u, 0), y = Math.max(i - l, 0), b = v * (1 - SX), x = y * (1 - SX), S = a + c - Math.max(l, i);
	e.bezierCurveTo(o + s - u - b, a + c - l, o + s - u, a + c - l - x, o + s - u, S), e.lineTo(o + s, S), e.lineTo(o + s, a + c - i);
	let C = i * (1 - SX);
	if (e.bezierCurveTo(o + s, a + c - C, o + s - C, a + c, o + s - i, a + c), e.closePath(), e.clip(), u) {
		let t = l / u;
		e.moveTo(o + s / 2, t * (-s / 2) + a + c), e.lineTo(o + s, a + c), e.lineTo(o, a + c), e.lineTo(o, a), e.closePath(), e.clip();
	}
	if (d) {
		let t = -l / d;
		e.moveTo(o + s / 2, s / 2 * t + a + c), e.lineTo(o, a + c), e.lineTo(o + s, a + c), e.lineTo(o + s, a), e.closePath(), e.clip();
	}
}, OX = (e, t, n, r, i) => {
	let { top: a, left: o, width: s, height: c } = t, { borderBottomColor: l, borderBottomStyle: u, borderBottomWidth: d, borderRightWidth: f, borderLeftWidth: p } = n, m = r * (1 - SX), h = i * (1 - SX);
	e.moveTo(o + s, a + c - i), e.bezierCurveTo(o + s, a + c - h, o + s - h, a + c, o + s - i, a + c), e.lineTo(o + r, a + c), e.bezierCurveTo(o + m, a + c, o, a + c - m, o, a + c - r), e.strokeColor(l), e.lineWidth(Math.max(d, f, p) * 2), u === "dashed" ? e.dash(d * 2, { space: d * 1.2 }) : u === "dotted" && e.dash(d, { space: d * 1.2 }), e.stroke(), e.undash();
}, kX = (e, t, n, r, i) => {
	let { top: a, left: o, width: s, height: c } = t, { borderTopWidth: l, borderLeftWidth: u, borderBottomWidth: d } = n;
	e.moveTo(o, a + c - r), e.lineTo(o, a + i);
	let f = i * (1 - SX);
	e.bezierCurveTo(o, a + f, o + f, a, o + i, a);
	let p = o + Math.max(u, i);
	e.lineTo(p, a), e.lineTo(p, a + l);
	let m = Math.max(i - u, 0), h = Math.max(i - l, 0), g = m * (1 - SX), _ = h * (1 - SX);
	e.bezierCurveTo(o + u + g, a + l, o + u, a + l + _, o + u, a + Math.max(i, l)), e.lineTo(o + u, a + c - Math.max(r, d));
	let v = Math.max(r - u, 0), y = Math.max(r - d, 0), b = v * (1 - SX), x = y * (1 - SX), S = o + Math.max(r, u);
	e.bezierCurveTo(o + u, a + c - d - x, o + u + b, a + c - d, S, a + c - d), e.lineTo(S, a + c), e.lineTo(o + r, a + c);
	let C = r * (1 - SX);
	if (e.bezierCurveTo(o + C, a + c, o, a + c - C, o, a + c - r), e.closePath(), e.clip(), d) {
		let t = -d / u;
		e.moveTo(o + s / 2, s / 2 * t + a + c), e.lineTo(o, a + c), e.lineTo(o, a), e.lineTo(o + s, a), e.closePath(), e.clip();
	}
	if (d) {
		let t = -l / u;
		e.moveTo(o + s / 2, t * (-s / 2) + a), e.lineTo(o, a), e.lineTo(o, a + c), e.lineTo(o + s, a + c), e.closePath(), e.clip();
	}
}, AX = (e, t, n, r, i) => {
	let { top: a, left: o, height: s } = t, { borderLeftColor: c, borderLeftStyle: l, borderLeftWidth: u, borderTopWidth: d, borderBottomWidth: f } = n, p = r * (1 - SX), m = i * (1 - SX);
	e.moveTo(o + r, a + s), e.bezierCurveTo(o + p, a + s, o, a + s - p, o, a + s - r), e.lineTo(o, a + i), e.bezierCurveTo(o, a + m, o + m, a, o + i, a), e.strokeColor(c), e.lineWidth(Math.max(u, d, f) * 2), l === "dashed" ? e.dash(u * 2, { space: u * 1.2 }) : l === "dotted" && e.dash(u, { space: u * 1.2 }), e.stroke(), e.undash();
}, jX = (e) => e.box && (e.box.borderTopWidth || e.box.borderRightWidth || e.box.borderBottomWidth || e.box.borderLeftWidth), MX = (e, t) => {
	if (!t.box || !jX(t)) return;
	let { width: n, height: r, borderTopWidth: i = 0, borderLeftWidth: a = 0, borderRightWidth: o = 0, borderBottomWidth: s = 0 } = t.box, { opacity: c = 1, borderTopColor: l = "black", borderTopStyle: u = "solid", borderLeftColor: d = "black", borderLeftStyle: f = "solid", borderRightColor: p = "black", borderRightStyle: m = "solid", borderBottomColor: h = "black", borderBottomStyle: g = "solid" } = t.style, _ = t.style.borderTopLeftRadius || 0, v = t.style.borderTopRightRadius || 0, y = t.style.borderBottomLeftRadius || 0, b = t.style.borderBottomRightRadius || 0, x = {
		borderTopColor: l,
		borderTopWidth: i,
		borderTopStyle: u,
		borderLeftColor: d,
		borderLeftWidth: a,
		borderLeftStyle: f,
		borderRightColor: p,
		borderRightWidth: o,
		borderRightStyle: m,
		borderBottomColor: h,
		borderBottomWidth: s,
		borderBottomStyle: g
	}, S = Math.min(v, .5 * n, .5 * r), C = Math.min(_, .5 * n, .5 * r), w = Math.min(b, .5 * n, .5 * r), T = Math.min(y, .5 * n, .5 * r);
	e.save(), e.strokeOpacity(c), i && (e.save(), CX(e, t.box, x, S, C), wX(e, t.box, x, S, C), e.restore()), o && (e.save(), TX(e, t.box, x, S, w), EX(e, t.box, x, S, w), e.restore()), s && (e.save(), DX(e, t.box, x, T, w), OX(e, t.box, x, T, w), e.restore()), a && (e.save(), kX(e, t.box, x, T, C), AX(e, t.box, x, T, C), e.restore()), e.restore();
}, NX = (e, t) => {
	if (!t.box) return;
	let { top: n, left: r, width: i, height: a } = t.box, o = VY(t.style.backgroundColor), s = iJ(t.style?.opacity) ? 1 : t.style.opacity, c = Math.min(o.opacity, s);
	e.fillOpacity(c).fillColor(o.value).rect(r, n, i, a).fill();
}, PX = (e, t) => {
	t.box && t.style?.backgroundColor && (e.save(), tY(e, t), NX(e, t), e.restore());
}, FX = (e) => typeof e == "string", IX = (e) => /^#.+/.test(e), LX = (e, t, n) => {
	if (!n || !t.box) return;
	let r = IX(n), i = r ? "goTo" : "link", a = r ? n.slice(1) : n, { top: o, left: s, width: c, height: l } = t.box;
	e[i](s, o, c, l, a);
}, RX = (e, t) => {
	let n = t.props || {};
	if ("src" in n && FX(n.src)) return LX(e, t, n.src);
	if ("href" in n && FX(n.href)) return LX(e, t, n.href);
}, zX = (e, t) => {
	t.box && t.props && "id" in t.props && e.addNamedDestination(t.props.id, "XYZ", null, t.box.top, null);
}, BX = (e) => {
	let t = { ...e };
	return Object.entries(t).forEach((e) => {
		e[1] || delete t[e[0]];
	}), t;
}, VX = (e) => ({
	required: e.props?.required || !1,
	noExport: e.props?.noExport || !1,
	readOnly: e.props?.readOnly || !1,
	value: e.props?.value || void 0,
	defaultValue: e.props?.defaultValue || void 0
}), HX = (e, t) => BX({
	...VX(e),
	parent: t || void 0,
	align: e.props?.align || "left",
	multiline: e.props?.multiline || void 0,
	password: e.props?.password || !1,
	noSpell: e.props?.noSpell || !1,
	format: e.props?.format || void 0,
	fontSize: e.props?.fontSize || void 0,
	MaxLen: e.props?.maxLength || void 0
}), UX = (e) => BX({
	...VX(e),
	sort: e.props?.sort || !1,
	edit: e.props?.edit || !1,
	multiSelect: e.props?.multiSelect || !1,
	noSpell: e.props?.noSpell || !1,
	select: e.props?.select || [""]
}), WX = (e, t, n, r) => {
	let i = e.ref({
		Type: "XObject",
		Subtype: "Form",
		BBox: [
			0,
			0,
			n,
			r
		],
		Resources: {
			ProcSet: [
				"PDF",
				"Text",
				"ImageB",
				"ImageC",
				"ImageI"
			],
			Font: { ZaDi: e._acroform.fonts.ZaDi }
		}
	});
	return i.initDeflate(), i.write(`/Tx BMC\nq\n/ZaDi ${r * .8} Tf\nBT\n${n * .45} ${r / 4} Td (${t}) Tj\nET\nQ\nEMC`), i.end(null), i;
}, GX = (e, t, n) => {
	let { width: r, height: i } = t.box || {}, a = t.props?.onState || "Yes", o = t.props?.offState || "Off", s = t.props?.xMark || !1;
	if (!Object.prototype.hasOwnProperty.call(e._acroform.fonts, "ZaDi")) {
		let t = e.ref({
			Type: "Font",
			Subtype: "Type1",
			BaseFont: "ZapfDingbats"
		});
		e._acroform.fonts.ZaDi = t, t.end(null);
	}
	let c = {
		[a]: WX(e, s ? "8" : "4", r, i),
		[o]: WX(e, s ? " " : "8", r, i)
	};
	return BX({
		...VX(t),
		backgroundColor: t.props?.backgroundColor || void 0,
		borderColor: t.props?.borderColor || void 0,
		parent: n || void 0,
		value: `/${t.props?.checked === !0 ? a : o}`,
		defaultValue: `/${t.props?.checked === !0 ? a : o}`,
		AS: t.props?.checked === !0 ? a : o,
		AP: {
			N: c,
			D: c
		}
	});
}, KX = (e, t, n) => {
	if (!t.box) return;
	let { top: r, left: i, width: a, height: o } = t.box, s = t.props?.name || "", c = n.fieldSets?.at(0);
	e._root.data.AcroForm || e.initForm(), e.formText(s, i, r, a, o, HX(t, c));
}, qX = (e, t) => {
	if (!t.box) return;
	let { top: n, left: r, width: i, height: a } = t.box, o = t.props?.name || "";
	e._root.data.AcroForm || e.initForm(), e.formCombo(o, r, n, i, a, UX(t));
}, JX = (e, t, n) => {
	let r = t.props?.name || "";
	e._root.data.AcroForm || e.initForm();
	let i = e.formField(r), a = n;
	a.fieldSets ? a.fieldSets.push(i) : a.fieldSets = [i];
}, YX = (e, t, n) => {
	n.fieldSets.pop();
}, XX = (e, t) => {
	if (!t.box) return;
	let { top: n, left: r, width: i, height: a } = t.box || {}, o = "name" in t.props && t.props.name || "";
	e._root.data.AcroForm || e.initForm(), e.formList(o, r, n, i, a, UX(t));
}, ZX = (e, t, n) => {
	if (!t.box) return;
	let { top: r, left: i, width: a, height: o } = t.box, s = t.props?.name || "", c = n.fieldSets?.at(0);
	e._root.data.AcroForm || e.initForm(), e.formCheckbox(s, i, r, a, o, GX(e, t, c));
}, QX = (e) => e.type !== "TEXT" && e.type !== "SVG", $X = (e, t, n) => {
	e.save(), t.box && e.translate(t.box.left, t.box.top), (t.children || []).forEach((t) => nZ(e, t, n)), e.restore();
}, eZ = {
	[Hv]: ZY,
	[Gv]: $Y,
	[ty]: lX,
	[Yv]: JX,
	[Xv]: KX,
	[Zv]: qX,
	[Qv]: ZX,
	[$v]: XX,
	[ry]: xX,
	SVG: zY,
	[Uv]: RX
}, tZ = { [Yv]: YX }, nZ = (e, t, n) => {
	let r = t.style?.overflow === "hidden", i = QX(t);
	t.type === "PAGE" && QY(e, t), e.save(), r && tY(e, t), rY(e, t), PX(e, t), MX(e, t);
	let a = eZ[t.type];
	a && a(e, t, n), i && $X(e, t, n);
	let o = tZ[t.type];
	o && o(e, t, n), zX(e, t), vX(e, t), e.restore();
}, rZ = (e, t, n, r) => {
	if (t.box && t.props) {
		if ("bookmark" in t.props && t.props.bookmark) {
			let i = t.props.bookmark, { title: a, parent: o, expanded: s, zoom: c, fit: l } = i, u = r[o] || e.outline, d = i.top || t.box.top, f = i.left || t.box.left, p = u.addItem(a, {
				pageNumber: n,
				expanded: s,
				top: d,
				left: f,
				zoom: c,
				fit: l
			});
			r[i.ref] = p;
		}
		t.children && t.children.forEach((t) => rZ(e, t, n, r));
	}
}, iZ = /* @__PURE__ */ V(((e, t) => {
	function n(e) {
		this.value = e, this.match = function(e) {
			return this.value >= e.height;
		};
	}
	function r(e) {
		this.value = e, this.match = function(e) {
			return this.value < e.height;
		};
	}
	function i(e) {
		this.value = e, this.match = function(e) {
			return this.value >= e.width;
		};
	}
	function a(e) {
		this.value = e, this.match = function(e) {
			return this.value < e.width;
		};
	}
	function o(e) {
		this.value = e, this.match = function(e) {
			return this.value === e.orientation;
		};
	}
	t.exports = function(e, t) {
		switch (e) {
			case "max-height": return new n(t);
			case "min-height": return new r(t);
			case "max-width": return new i(t);
			case "min-width": return new a(t);
			case "orientation": return new o(t);
			default: throw Error(t);
		}
	};
})), aZ = /* @__PURE__ */ V(((e, t) => {
	function n(e, t) {
		this.left = e, this.right = t, this.match = function(n) {
			return e.match(n) && t.match(n);
		};
	}
	function r(e, t) {
		this.left = e, this.right = t, this.match = function(n) {
			return e.match(n) || t.match(n);
		};
	}
	t.exports = function(e, t, i) {
		switch (e) {
			case "and": return new n(t, i);
			case ",": return new r(t, i);
			default: throw Error(value);
		}
	};
})), oZ = /* @__PURE__ */ V(((e, t) => {
	var n = iZ(), r = aZ(), i = /[0-9]/, a = /[a-z|\-]/i, o = /\s/, s = /:/, c = /,/, l = /and$/, u = /@/;
	function d(e) {
		for (var t = 0, n = []; t < e.length;) {
			var r = e[t];
			if (u.test(r)) for (r = e[++t]; a.test(r) && r !== void 0;) r = e[++t];
			if (o.test(r) || r === ")" || r === "(") {
				t++;
				continue;
			}
			if (s.test(r) || c.test(r)) {
				t++, n.push({
					type: "operator",
					value: r
				});
				continue;
			}
			if (i.test(r)) {
				for (var d = ""; i.test(r);) d += r, r = e[++t];
				n.push({
					type: "number",
					value: d
				});
				continue;
			}
			if (a.test(r)) {
				for (var d = ""; a.test(r) && r !== void 0;) d += r, r = e[++t];
				l.test(d) ? n.push({
					type: "operator",
					value: d
				}) : n.push({
					type: "literal",
					value: d
				});
				continue;
			}
			throw TypeError("Tokenizer: I dont know what this character is: " + r);
		}
		return n;
	}
	function f(e) {
		for (var t = [], i = []; e.length > 0;) {
			var a = e.shift();
			if (a.type === "number" || a.type === "literal") {
				t.push(a);
				continue;
			}
			if (a.type === "operator") {
				if (s.test(a.value)) {
					a = {
						type: "query",
						key: t.pop(),
						value: e.shift()
					}, t.push(a);
					continue;
				}
				for (; i.length > 0;) t.unshift(i.pop());
				i.push(a);
			}
		}
		for (; i.length > 0;) t.unshift(i.pop());
		function o() {
			var e = t.shift();
			if (e.type === "number") return parseInt(e.value);
			if (e.type === "literal") return e.value;
			if (e.type === "operator") {
				var i = o(), a = o();
				return r(e.value, i, a);
			}
			if (e.type === "query") {
				var i = e.key.value, a = e.value.value;
				return n(i, a);
			}
		}
		return o();
	}
	t.exports = { parse: function(e) {
		return f(d(e));
	} };
})), sZ = /* @__PURE__ */ V(((e, t) => {
	var n = oZ();
	t.exports = function(e, t) {
		var r = {};
		return Object.keys(e).forEach(function(i) {
			n.parse(i).match(t) && Object.assign(r, e[i]);
		}), r;
	};
})), cZ = /* @__PURE__ */ V(((e, t) => {
	t.exports = function(e, t, n) {
		if (e == null) return [
			0,
			0,
			0
		];
		var r = (1 - Math.abs(2 * n - 1)) * t, i = e / 60, a = r * (1 - Math.abs(i % 2 - 1));
		i = Math.floor(i);
		var o, s, c;
		i === 0 ? (o = r, s = a, c = 0) : i === 1 ? (o = a, s = r, c = 0) : i === 2 ? (o = 0, s = r, c = a) : i === 3 ? (o = 0, s = a, c = r) : i === 4 ? (o = a, s = 0, c = r) : i === 5 && (o = r, s = 0, c = a);
		var l = n - r / 2;
		return o += l, s += l, c += l, [
			Math.abs(Math.round(o * 255)),
			Math.abs(Math.round(s * 255)),
			Math.abs(Math.round(c * 255))
		];
	};
})), lZ = /* @__PURE__ */ V(((e, t) => {
	var n = cZ();
	function r(e, t) {
		return e > t ? t : e;
	}
	function i(e, t) {
		return e < t ? t : e;
	}
	function a(e) {
		for (e = r(e, 1e7), e = i(e, -1e7); e < 0;) e += 360;
		for (; e > 359;) e -= 360;
		return e;
	}
	function o(e, t, o) {
		return e = a(e), t = i(r(t, 100), 0), o = i(r(o, 100), 0), t /= 100, o /= 100, "#" + n(e, t, o).map(function(e) {
			return (256 + e).toString(16).substr(-2);
		}).join("");
	}
	t.exports = o;
})), uZ = /* @__PURE__ */ V(((e, t) => {
	var n = 40, r = 41, i = 39, a = 34, o = 92, s = 47, c = 44, l = 58, u = 42, d = 117, f = 85, p = 43, m = /^[a-f0-9?-]+$/i;
	t.exports = function(e) {
		for (var t = [], h = e, g, _, v, y, b, x, S, C, w = 0, T = h.charCodeAt(w), E = h.length, D = [{ nodes: t }], O = 0, k, A = "", j = "", M = ""; w < E;) if (T <= 32) {
			g = w;
			do
				g += 1, T = h.charCodeAt(g);
			while (T <= 32);
			y = h.slice(w, g), v = t[t.length - 1], T === r && O ? M = y : v && v.type === "div" ? (v.after = y, v.sourceEndIndex += y.length) : T === c || T === l || T === s && h.charCodeAt(g + 1) !== u && (!k || k && k.type === "function" && k.value !== "calc") ? j = y : t.push({
				type: "space",
				sourceIndex: w,
				sourceEndIndex: g,
				value: y
			}), w = g;
		} else if (T === i || T === a) {
			g = w, _ = T === i ? "'" : "\"", y = {
				type: "string",
				sourceIndex: w,
				quote: _
			};
			do
				if (b = !1, g = h.indexOf(_, g + 1), ~g) for (x = g; h.charCodeAt(x - 1) === o;) --x, b = !b;
				else h += _, g = h.length - 1, y.unclosed = !0;
			while (b);
			y.value = h.slice(w + 1, g), y.sourceEndIndex = y.unclosed ? g : g + 1, t.push(y), w = g + 1, T = h.charCodeAt(w);
		} else if (T === s && h.charCodeAt(w + 1) === u) g = h.indexOf("*/", w), y = {
			type: "comment",
			sourceIndex: w,
			sourceEndIndex: g + 2
		}, g === -1 && (y.unclosed = !0, g = h.length, y.sourceEndIndex = g), y.value = h.slice(w + 2, g), t.push(y), w = g + 2, T = h.charCodeAt(w);
		else if ((T === s || T === u) && k && k.type === "function" && k.value === "calc") y = h[w], t.push({
			type: "word",
			sourceIndex: w - j.length,
			sourceEndIndex: w + y.length,
			value: y
		}), w += 1, T = h.charCodeAt(w);
		else if (T === s || T === c || T === l) y = h[w], t.push({
			type: "div",
			sourceIndex: w - j.length,
			sourceEndIndex: w + y.length,
			value: y,
			before: j,
			after: ""
		}), j = "", w += 1, T = h.charCodeAt(w);
		else if (n === T) {
			g = w;
			do
				g += 1, T = h.charCodeAt(g);
			while (T <= 32);
			if (C = w, y = {
				type: "function",
				sourceIndex: w - A.length,
				value: A,
				before: h.slice(C + 1, g)
			}, w = g, A === "url" && T !== i && T !== a) {
				--g;
				do
					if (b = !1, g = h.indexOf(")", g + 1), ~g) for (x = g; h.charCodeAt(x - 1) === o;) --x, b = !b;
					else h += ")", g = h.length - 1, y.unclosed = !0;
				while (b);
				S = g;
				do
					--S, T = h.charCodeAt(S);
				while (T <= 32);
				C < S ? (w === S + 1 ? y.nodes = [] : y.nodes = [{
					type: "word",
					sourceIndex: w,
					sourceEndIndex: S + 1,
					value: h.slice(w, S + 1)
				}], y.unclosed && S + 1 !== g ? (y.after = "", y.nodes.push({
					type: "space",
					sourceIndex: S + 1,
					sourceEndIndex: g,
					value: h.slice(S + 1, g)
				})) : (y.after = h.slice(S + 1, g), y.sourceEndIndex = g)) : (y.after = "", y.nodes = []), w = g + 1, y.sourceEndIndex = y.unclosed ? g : w, T = h.charCodeAt(w), t.push(y);
			} else O += 1, y.after = "", y.sourceEndIndex = w + 1, t.push(y), D.push(y), t = y.nodes = [], k = y;
			A = "";
		} else if (r === T && O) w += 1, T = h.charCodeAt(w), k.after = M, k.sourceEndIndex += M.length, M = "", --O, D[D.length - 1].sourceEndIndex = w, D.pop(), k = D[O], t = k.nodes;
		else {
			g = w;
			do
				T === o && (g += 1), g += 1, T = h.charCodeAt(g);
			while (g < E && !(T <= 32 || T === i || T === a || T === c || T === l || T === s || T === n || T === u && k && k.type === "function" && k.value === "calc" || T === s && k.type === "function" && k.value === "calc" || T === r && O));
			y = h.slice(w, g), n === T ? A = y : (d === y.charCodeAt(0) || f === y.charCodeAt(0)) && p === y.charCodeAt(1) && m.test(y.slice(2)) ? t.push({
				type: "unicode-range",
				sourceIndex: w,
				sourceEndIndex: g,
				value: y
			}) : t.push({
				type: "word",
				sourceIndex: w,
				sourceEndIndex: g,
				value: y
			}), w = g;
		}
		for (w = D.length - 1; w; --w) D[w].unclosed = !0, D[w].sourceEndIndex = h.length;
		return D[0].nodes;
	};
})), dZ = /* @__PURE__ */ V(((e, t) => {
	var n = 45, r = 43, i = 46, a = 101, o = 69;
	function s(e) {
		var t = e.charCodeAt(0), a;
		if (t === r || t === n) {
			if (a = e.charCodeAt(1), a >= 48 && a <= 57) return !0;
			var o = e.charCodeAt(2);
			return a === i && o >= 48 && o <= 57;
		}
		return t === i ? (a = e.charCodeAt(1), a >= 48 && a <= 57) : t >= 48 && t <= 57;
	}
	t.exports = function(e) {
		var t = 0, c = e.length, l, u, d;
		if (c === 0 || !s(e)) return !1;
		for (l = e.charCodeAt(t), (l === r || l === n) && t++; t < c && (l = e.charCodeAt(t), !(l < 48 || l > 57));) t += 1;
		if (l = e.charCodeAt(t), u = e.charCodeAt(t + 1), l === i && u >= 48 && u <= 57) for (t += 2; t < c && (l = e.charCodeAt(t), !(l < 48 || l > 57));) t += 1;
		if (l = e.charCodeAt(t), u = e.charCodeAt(t + 1), d = e.charCodeAt(t + 2), (l === a || l === o) && (u >= 48 && u <= 57 || (u === r || u === n) && d >= 48 && d <= 57)) for (t += u === r || u === n ? 3 : 2; t < c && (l = e.charCodeAt(t), !(l < 48 || l > 57));) t += 1;
		return {
			number: e.slice(0, t),
			unit: e.slice(t)
		};
	};
})), fZ = /* @__PURE__ */ xt(sZ(), 1), pZ = /* @__PURE__ */ xt(lZ(), 1), mZ = /* @__PURE__ */ xt(uZ(), 1), hZ = /* @__PURE__ */ xt(dZ(), 1), gZ = tJ((e) => e.reduce((e, t) => {
	let n = Array.isArray(t) ? gZ(t) : t;
	return Object.keys(n).forEach((t) => {
		n[t] !== null && n[t] !== void 0 && (e[t] = n[t]);
	}), e;
}, {}), (e) => e.filter(Boolean), eJ), _Z = (e, t) => Object.keys(t).reduce((n, r) => /@media/.test(r) ? {
	...n,
	...(0, fZ.default)({ [r]: t[r] }, e)
} : {
	...n,
	[r]: t[r]
}, {}), vZ = (e) => /rgba?/g.test(e), yZ = (e) => /hsla?/g.test(e), bZ = (e) => {
	let t = MJ.default.get.rgb(e);
	return MJ.default.to.hex(t);
}, xZ = (e) => (0, pZ.default)(...MJ.default.get.hsl(e).map(Math.round)).toUpperCase(), SZ = (e) => vZ(e) ? bZ(e) : yZ(e) ? xZ(e) : e, CZ = (e) => {
	if (typeof e == "number") return {
		value: e,
		unit: void 0
	};
	let t = /^(-?\d*\.?\d+)(in|mm|cm|pt|vh|vw|px|rem)?$/g.exec(e);
	return t ? {
		value: parseFloat(t[1]),
		unit: t[2] || "pt"
	} : {
		value: e,
		unit: void 0
	};
}, wZ = (e, t) => {
	let n = CZ(t), r = e.dpi || 72;
	if (typeof n.value != "number") return n.value;
	switch (n.unit) {
		case "rem": return n.value * (e.remBase || 18);
		case "in": return n.value * 72;
		case "mm": return n.value * 2.8346456692913384;
		case "cm": return n.value * 28.346456692913385;
		case "vh": return n.value * (e.height / 100);
		case "vw": return n.value * (e.width / 100);
		case "px": return Math.round(n.value * (72 / r));
		default: return n.value;
	}
}, TZ = (e, t) => ({ [e]: mJ(t) }), EZ = (e, t, n) => ({ [e]: wZ(n, t) }), DZ = (e, t) => ({ [e]: SZ(t) }), OZ = (e, t) => ({ [e]: t }), kZ = /(-?\d+(\.\d+)?(in|mm|cm|pt|vw|vh|px|rem)?)\s(\S+)\s(.+)/, AZ = (e) => e.match(kZ) || [], jZ = (e, t, n) => {
	let r = AZ(`${t}`);
	if (r) {
		let i = r[1] || t, a = r[4] || t, o = r[5] || t, s = a, c = o ? SZ(o) : void 0, l = i ? wZ(n, i) : void 0;
		if (e.match(/(Top|Right|Bottom|Left)$/)) return {
			[`${e}Color`]: c,
			[`${e}Style`]: s,
			[`${e}Width`]: l
		};
		if (e.match(/Color$/)) return {
			borderTopColor: c,
			borderRightColor: c,
			borderBottomColor: c,
			borderLeftColor: c
		};
		if (e.match(/Style$/)) {
			if (typeof s == "number") throw Error(`Invalid border style: ${s}`);
			return {
				borderTopStyle: s,
				borderRightStyle: s,
				borderBottomStyle: s,
				borderLeftStyle: s
			};
		}
		if (e.match(/Width$/)) {
			if (typeof l != "number") throw Error(`Invalid border width: ${l}`);
			return {
				borderTopWidth: l,
				borderRightWidth: l,
				borderBottomWidth: l,
				borderLeftWidth: l
			};
		}
		if (e.match(/Radius$/)) {
			let e = t ? wZ(n, t) : void 0;
			if (typeof e != "number") throw Error(`Invalid border radius: ${e}`);
			return {
				borderTopLeftRadius: e,
				borderTopRightRadius: e,
				borderBottomRightRadius: e,
				borderBottomLeftRadius: e
			};
		}
		if (typeof l != "number") throw Error(`Invalid border width: ${l}`);
		if (typeof s == "number") throw Error(`Invalid border style: ${s}`);
		return {
			borderTopColor: c,
			borderTopStyle: s,
			borderTopWidth: l,
			borderRightColor: c,
			borderRightStyle: s,
			borderRightWidth: l,
			borderBottomColor: c,
			borderBottomStyle: s,
			borderBottomWidth: l,
			borderLeftColor: c,
			borderLeftStyle: s,
			borderLeftWidth: l
		};
	}
	return { [e]: t };
}, MZ = {
	border: jZ,
	borderBottom: jZ,
	borderBottomColor: DZ,
	borderBottomLeftRadius: EZ,
	borderBottomRightRadius: EZ,
	borderBottomStyle: OZ,
	borderBottomWidth: EZ,
	borderColor: jZ,
	borderLeft: jZ,
	borderLeftColor: DZ,
	borderLeftStyle: OZ,
	borderLeftWidth: EZ,
	borderRadius: jZ,
	borderRight: jZ,
	borderRightColor: DZ,
	borderRightStyle: OZ,
	borderRightWidth: EZ,
	borderStyle: jZ,
	borderTop: jZ,
	borderTopColor: DZ,
	borderTopLeftRadius: EZ,
	borderTopRightRadius: EZ,
	borderTopStyle: OZ,
	borderTopWidth: EZ,
	borderWidth: jZ
}, NZ = {
	backgroundColor: DZ,
	color: DZ,
	opacity: TZ
}, PZ = {
	height: EZ,
	maxHeight: EZ,
	maxWidth: EZ,
	minHeight: EZ,
	minWidth: EZ,
	width: EZ
}, FZ = [
	1,
	1,
	0
], IZ = [
	1,
	1,
	"auto"
], LZ = {
	alignContent: OZ,
	alignItems: OZ,
	alignSelf: OZ,
	flex: (e, t, n) => {
		let r = FZ, i = [];
		return t === "auto" ? r = IZ : i = `${t}`.split(" "), {
			flexGrow: mJ(i[0] || r[0]),
			flexShrink: mJ(i[1] || r[1]),
			flexBasis: wZ(n, i[2] || r[2])
		};
	},
	flexBasis: EZ,
	flexDirection: OZ,
	flexFlow: OZ,
	flexGrow: TZ,
	flexShrink: TZ,
	flexWrap: OZ,
	justifyContent: OZ,
	justifySelf: OZ
}, RZ = {
	gap: (e, t, n) => {
		let r = `${t}`.split(" ");
		return {
			rowGap: wZ(n, r?.[0] || t),
			columnGap: wZ(n, r?.[1] || t)
		};
	},
	columnGap: EZ,
	rowGap: EZ
}, zZ = {
	aspectRatio: TZ,
	bottom: EZ,
	display: OZ,
	left: EZ,
	position: OZ,
	right: EZ,
	top: EZ,
	overflow: OZ,
	zIndex: TZ
}, BZ = "px,in,mm,cm,pt,%,vw,vh", VZ = (e, t) => {
	let n = e.toString();
	console.error(`
    @react-pdf/stylesheet parsing error:
    ${n}: ${t},
    ${" ".repeat(n.length + 2)}^
    Unsupported ${n} value format
  `);
}, HZ = ({ expandsTo: e, maxValues: t = 1, autoSupported: n = !1 } = {}) => (r, i, a) => {
	let o = (0, mZ.default)(`${i}`), s = [];
	for (let e = 0; e < o.length; e++) {
		let t = o[e];
		if (t.type === "function" || t.type === "string" || t.type === "div") return VZ(r, i), {};
		if (t.type === "word") if (t.value === "auto" && n) s.push(t.value);
		else {
			let e = (0, hZ.default)(t.value);
			if (e && BZ.includes(e.unit)) s.push(t.value);
			else return VZ(r, i), {};
		}
	}
	if (s.length > t) return VZ(r, i), {};
	let c = wZ(a, s[0]);
	return e ? e({
		first: c,
		second: wZ(a, s[1] || s[0]),
		third: wZ(a, s[2] || s[0]),
		fourth: wZ(a, s[3] || s[1] || s[0])
	}) : { [r]: c };
}, UZ = HZ({
	expandsTo: ({ first: e, second: t, third: n, fourth: r }) => ({
		marginTop: e,
		marginRight: t,
		marginBottom: n,
		marginLeft: r
	}),
	maxValues: 4,
	autoSupported: !0
}), WZ = HZ({
	expandsTo: ({ first: e, second: t }) => ({
		marginTop: e,
		marginBottom: t
	}),
	maxValues: 2,
	autoSupported: !0
}), GZ = HZ({
	expandsTo: ({ first: e, second: t }) => ({
		marginRight: e,
		marginLeft: t
	}),
	maxValues: 2,
	autoSupported: !0
}), KZ = HZ({ autoSupported: !0 }), qZ = {
	margin: UZ,
	marginBottom: KZ,
	marginHorizontal: GZ,
	marginLeft: KZ,
	marginRight: KZ,
	marginTop: KZ,
	marginVertical: WZ
}, JZ = HZ({
	expandsTo: ({ first: e, second: t, third: n, fourth: r }) => ({
		paddingTop: e,
		paddingRight: t,
		paddingBottom: n,
		paddingLeft: r
	}),
	maxValues: 4
}), YZ = HZ({
	expandsTo: ({ first: e, second: t }) => ({
		paddingTop: e,
		paddingBottom: t
	}),
	maxValues: 2
}), XZ = HZ({
	expandsTo: ({ first: e, second: t }) => ({
		paddingRight: e,
		paddingLeft: t
	}),
	maxValues: 2
}), ZZ = HZ(), QZ = {
	padding: JZ,
	paddingBottom: ZZ,
	paddingHorizontal: XZ,
	paddingLeft: ZZ,
	paddingRight: ZZ,
	paddingTop: ZZ,
	paddingVertical: YZ
}, $Z = (e) => {
	switch (e) {
		case "top":
		case "left": return "0%";
		case "right":
		case "bottom": return "100%";
		case "center": return "50%";
		default: return e;
	}
}, eQ = (e, t, n) => {
	let r = `${t}`.split(" ");
	return {
		objectPositionX: $Z(wZ(n, r?.[0] || t)),
		objectPositionY: $Z(wZ(n, r?.[1] || t))
	};
}, tQ = (e, t, n) => ({ [e]: $Z(wZ(n, t)) }), nQ = {
	objectPosition: eQ,
	objectPositionX: tQ,
	objectPositionY: tQ,
	objectFit: OZ
}, rQ = (e) => typeof e == "number" ? e : parseInt(e, 10), iQ = {
	thin: 100,
	hairline: 100,
	ultralight: 200,
	extralight: 200,
	light: 300,
	normal: 400,
	medium: 500,
	semibold: 600,
	demibold: 600,
	bold: 700,
	ultrabold: 800,
	extrabold: 800,
	heavy: 900,
	black: 900
}, aQ = (e) => {
	if (!e) return iQ.normal;
	if (typeof e == "number") return e;
	let t = e.toLowerCase();
	return iQ[t] ? iQ[t] : rQ(e);
}, oQ = (e, t) => ({ [e]: aQ(t) }), sQ = (e, t, n) => {
	if (e === "") return e;
	let r = wZ(n, t.fontSize || 18), i = wZ(n, e), { percent: a } = cJ(i) || {};
	return a ? a * r : isNaN(e) ? i : i * r;
}, cQ = {
	direction: OZ,
	fontFamily: OZ,
	fontSize: EZ,
	fontStyle: OZ,
	fontWeight: oQ,
	letterSpacing: EZ,
	lineHeight: (e, t, n, r) => ({ [e]: sQ(t, r, n) }),
	maxLines: TZ,
	textAlign: OZ,
	textDecoration: OZ,
	textDecorationColor: DZ,
	textDecorationStyle: OZ,
	textIndent: OZ,
	textOverflow: OZ,
	textTransform: OZ,
	verticalAlign: OZ
}, lQ = (e) => typeof e == "string" && /^-?\d*\.?\d*$/.test(e), uQ = (e) => typeof e == "string" && lQ(e) ? parseFloat(e) : e, dQ = (e) => {
	let t = e.trim().split(/\)[ ,]|\)/);
	if (t.length === 1) return [[t[0], !0]];
	let n = [];
	for (let e = 0; e < t.length; e += 1) {
		let r = t[e];
		if (r) {
			let [e, t] = r.split("("), i = t.indexOf(",") >= 0 ? "," : " ", a = t.split(i).map((e) => e.trim());
			n.push({
				operation: e.trim(),
				value: a
			});
		}
	}
	return n;
}, fQ = (e) => {
	let [, t, n] = /(-?\d*\.?\d*)(\w*)?/i.exec(e), r = Number.parseFloat(t);
	return n === "rad" ? r * 180 / Math.PI : r;
}, pQ = ({ operation: e, value: t }) => {
	switch (e) {
		case "scale": {
			let [e, n = e] = t.map((e) => Number.parseFloat(e));
			return {
				operation: "scale",
				value: [e, n]
			};
		}
		case "scaleX": return {
			operation: "scale",
			value: [Number.parseFloat(t), 1]
		};
		case "scaleY": return {
			operation: "scale",
			value: [1, Number.parseFloat(t)]
		};
		case "rotate": return {
			operation: "rotate",
			value: [fQ(t)]
		};
		case "translate": return {
			operation: "translate",
			value: t.map((e) => Number.parseFloat(e))
		};
		case "translateX": return {
			operation: "translate",
			value: [Number.parseFloat(t), 0]
		};
		case "translateY": return {
			operation: "translate",
			value: [0, Number.parseFloat(t)]
		};
		case "skew": return {
			operation: "skew",
			value: t.map(fQ)
		};
		case "skewX": return {
			operation: "skew",
			value: [fQ(t), 0]
		};
		case "skewY": return {
			operation: "skew",
			value: [0, fQ(t)]
		};
		default: return {
			operation: e,
			value: t.map((e) => Number.parseFloat(e))
		};
	}
}, mQ = (e) => e.map((e) => pQ(e)), hQ = (e, t) => typeof t == "string" ? { [e]: mQ(dQ(t)) } : { [e]: t }, gQ = {
	top: !0,
	bottom: !0
}, _Q = (e, t) => gQ[e] ? 1 : gQ[t] ? -1 : 0, vQ = (e) => !e || e.length === 0 ? ["center", "center"] : (e.length === 1 ? [e[0], "center"] : e).sort(_Q), yQ = (e, t, n) => {
	let r = vQ(`${t}`.split(" ")), i = wZ(n, r[0]), a = wZ(n, r[1]);
	return {
		transformOriginX: $Z(i) || uQ(i),
		transformOriginY: $Z(a) || uQ(a)
	};
}, bQ = (e, t, n) => {
	let r = wZ(n, t);
	return { [e]: $Z(r) || uQ(r) };
}, xQ = {
	transform: hQ,
	gradientTransform: hQ,
	transformOrigin: yQ,
	transformOriginX: bQ,
	transformOriginY: bQ
}, SQ = {
	fill: DZ,
	stroke: DZ,
	strokeDasharray: OZ,
	strokeWidth: EZ,
	fillOpacity: TZ,
	strokeOpacity: TZ,
	fillRule: OZ,
	textAnchor: OZ,
	strokeLinecap: OZ,
	strokeLinejoin: OZ,
	visibility: OZ,
	clipPath: OZ,
	dominantBaseline: OZ
}, CQ = {
	...MZ,
	...NZ,
	...PZ,
	...LZ,
	...RZ,
	...zZ,
	...qZ,
	...QZ,
	...nQ,
	...cQ,
	...xQ,
	...SQ
}, wQ = (e) => (t) => {
	let n = Object.keys(t), r = {};
	for (let i = 0; i < n.length; i += 1) {
		let a = n[i], o = t[a];
		if (!CQ[a]) {
			r[a] = o;
			continue;
		}
		let s = CQ[a](a, o, e, t), c = Object.keys(s);
		for (let e = 0; e < c.length; e += 1) {
			let t = c[e];
			r[t] = s[t];
		}
	}
	return r;
}, TQ = (e, t) => tJ(wQ(e), (t) => _Z(e, t), gZ)(t);
//#endregion
//#region ../../node_modules/bidi-js/dist/bidi.mjs
function EQ() {
	return function(e) {
		var t = {
			R: "13k,1a,2,3,3,2+1j,ch+16,a+1,5+2,2+n,5,a,4,6+16,4+3,h+1b,4mo,179q,2+9,2+11,2i9+7y,2+68,4,3+4,5+13,4+3,2+4k,3+29,8+cf,1t+7z,w+17,3+3m,1t+3z,16o1+5r,8+30,8+mc,29+1r,29+4v,75+73",
			EN: "1c+9,3d+1,6,187+9,513,4+5,7+9,sf+j,175h+9,qw+q,161f+1d,4xt+a,25i+9",
			ES: "17,2,6dp+1,f+1,av,16vr,mx+1,4o,2",
			ET: "z+2,3h+3,b+1,ym,3e+1,2o,p4+1,8,6u,7c,g6,1wc,1n9+4,30+1b,2n,6d,qhx+1,h0m,a+1,49+2,63+1,4+1,6bb+3,12jj",
			AN: "16o+5,2j+9,2+1,35,ed,1ff2+9,87+u",
			CS: "18,2+1,b,2u,12k,55v,l,17v0,2,3,53,2+1,b",
			B: "a,3,f+2,2v,690",
			S: "9,2,k",
			WS: "c,k,4f4,1vk+a,u,1j,335",
			ON: "x+1,4+4,h+5,r+5,r+3,z,5+3,2+1,2+1,5,2+2,3+4,o,w,ci+1,8+d,3+d,6+8,2+g,39+1,9,6+1,2,33,b8,3+1,3c+1,7+1,5r,b,7h+3,sa+5,2,3i+6,jg+3,ur+9,2v,ij+1,9g+9,7+a,8m,4+1,49+x,14u,2+2,c+2,e+2,e+2,e+1,i+n,e+e,2+p,u+2,e+2,36+1,2+3,2+1,b,2+2,6+5,2,2,2,h+1,5+4,6+3,3+f,16+2,5+3l,3+81,1y+p,2+40,q+a,m+13,2r+ch,2+9e,75+hf,3+v,2+2w,6e+5,f+6,75+2a,1a+p,2+2g,d+5x,r+b,6+3,4+o,g,6+1,6+2,2k+1,4,2j,5h+z,1m+1,1e+f,t+2,1f+e,d+3,4o+3,2s+1,w,535+1r,h3l+1i,93+2,2s,b+1,3l+x,2v,4g+3,21+3,kz+1,g5v+1,5a,j+9,n+v,2,3,2+8,2+1,3+2,2,3,46+1,4+4,h+5,r+5,r+a,3h+2,4+6,b+4,78,1r+24,4+c,4,1hb,ey+6,103+j,16j+c,1ux+7,5+g,fsh,jdq+1t,4,57+2e,p1,1m,1m,1m,1m,4kt+1,7j+17,5+2r,d+e,3+e,2+e,2+10,m+4,w,1n+5,1q,4z+5,4b+rb,9+c,4+c,4+37,d+2g,8+b,l+b,5+1j,9+9,7+13,9+t,3+1,27+3c,2+29,2+3q,d+d,3+4,4+2,6+6,a+o,8+6,a+2,e+6,16+42,2+1i",
			BN: "0+8,6+d,2s+5,2+p,e,4m9,1kt+2,2b+5,5+5,17q9+v,7k,6p+8,6+1,119d+3,440+7,96s+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+1,1ekf+75,6p+2rz,1ben+1,1ekf+1,1ekf+1",
			NSM: "lc+33,7o+6,7c+18,2,2+1,2+1,2,21+a,1d+k,h,2u+6,3+5,3+1,2+3,10,v+q,2k+a,1n+8,a,p+3,2+8,2+2,2+4,18+2,3c+e,2+v,1k,2,5+7,5,4+6,b+1,u,1n,5+3,9,l+1,r,3+1,1m,5+1,5+1,3+2,4,v+1,4,c+1,1m,5+4,2+1,5,l+1,n+5,2,1n,3,2+3,9,8+1,c+1,v,1q,d,1f,4,1m+2,6+2,2+3,8+1,c+1,u,1n,g+1,l+1,t+1,1m+1,5+3,9,l+1,u,21,8+2,2,2j,3+6,d+7,2r,3+8,c+5,23+1,s,2,2,1k+d,2+4,2+1,6+a,2+z,a,2v+3,2+5,2+1,3+1,q+1,5+2,h+3,e,3+1,7,g,jk+2,qb+2,u+2,u+1,v+1,1t+1,2+6,9,3+a,a,1a+2,3c+1,z,3b+2,5+1,a,7+2,64+1,3,1n,2+6,2,2,3+7,7+9,3,1d+g,1s+3,1d,2+4,2,6,15+8,d+1,x+3,3+1,2+2,1l,2+1,4,2+2,1n+7,3+1,49+2,2+c,2+6,5,7,4+1,5j+1l,2+4,k1+w,2db+2,3y,2p+v,ff+3,30+1,n9x+3,2+9,x+1,29+1,7l,4,5,q+1,6,48+1,r+h,e,13+7,q+a,1b+2,1d,3+3,3+1,14,1w+5,3+1,3+1,d,9,1c,1g,2+2,3+1,6+1,2,17+1,9,6n,3,5,fn5,ki+f,h+f,r2,6b,46+4,1af+2,2+1,6+3,15+2,5,4m+1,fy+3,as+1,4a+a,4x,1j+e,1l+2,1e+3,3+1,1y+2,11+4,2+7,1r,d+1,1h+8,b+3,3,2o+2,3,2+1,7,4h,4+7,m+1,1m+1,4,12+6,4+4,5g+7,3+2,2,o,2d+5,2,5+1,2+1,6n+3,7+1,2+1,s+1,2e+7,3,2+1,2z,2,3+5,2,2u+2,3+3,2+4,78+8,2+1,75+1,2,5,41+3,3+1,5,x+5,3+1,15+5,3+3,9,a+5,3+2,1b+c,2+1,bb+6,2+5,2d+l,3+6,2+1,2+1,3f+5,4,2+1,2+6,2,21+1,4,2,9o+1,f0c+4,1o+6,t5,1s+3,2a,f5l+1,43t+2,i+7,3+6,v+3,45+2,1j0+1i,5+1d,9,f,n+4,2+e,11t+6,2+g,3+6,2+1,2+4,7a+6,c6+3,15t+6,32+6,gzhy+6n",
			AL: "16w,3,2,e+1b,z+2,2+2s,g+1,8+1,b+m,2+t,s+2i,c+e,4h+f,1d+1e,1bwe+dp,3+3z,x+c,2+1,35+3y,2rm+z,5+7,b+5,dt+l,c+u,17nl+27,1t+27,4x+6n,3+d",
			LRO: "6ct",
			RLO: "6cu",
			LRE: "6cq",
			RLE: "6cr",
			PDF: "6cs",
			LRI: "6ee",
			RLI: "6ef",
			FSI: "6eg",
			PDI: "6eh"
		}, n = {}, r = {};
		n.L = 1, r[1] = "L", Object.keys(t).forEach(function(e, t) {
			n[e] = 1 << t + 1, r[n[e]] = e;
		}), Object.freeze(n);
		var i = n.LRI | n.RLI | n.FSI, a = n.L | n.R | n.AL, o = n.B | n.S | n.WS | n.ON | n.FSI | n.LRI | n.RLI | n.PDI, s = n.BN | n.RLE | n.LRE | n.RLO | n.LRO | n.PDF, c = n.S | n.WS | n.B | i | n.PDI | s, l = null;
		function u() {
			if (!l) {
				l = /* @__PURE__ */ new Map();
				var e = function(e) {
					if (t.hasOwnProperty(e)) {
						var r = 0;
						t[e].split(",").forEach(function(t) {
							var i = t.split("+"), a = i[0], o = i[1];
							a = parseInt(a, 36), o = o ? parseInt(o, 36) : 0, l.set(r += a, n[e]);
							for (var s = 0; s < o; s++) l.set(++r, n[e]);
						});
					}
				};
				for (var r in t) e(r);
			}
		}
		function d(e) {
			return u(), l.get(e.codePointAt(0)) || n.L;
		}
		function f(e) {
			return r[d(e)];
		}
		var p = {
			pairs: "14>1,1e>2,u>2,2wt>1,1>1,1ge>1,1wp>1,1j>1,f>1,hm>1,1>1,u>1,u6>1,1>1,+5,28>1,w>1,1>1,+3,b8>1,1>1,+3,1>3,-1>-1,3>1,1>1,+2,1s>1,1>1,x>1,th>1,1>1,+2,db>1,1>1,+3,3>1,1>1,+2,14qm>1,1>1,+1,4q>1,1e>2,u>2,2>1,+1",
			canonical: "6f1>-6dx,6dy>-6dx,6ec>-6ed,6ee>-6ed,6ww>2jj,-2ji>2jj,14r4>-1e7l,1e7m>-1e7l,1e7m>-1e5c,1e5d>-1e5b,1e5c>-14qx,14qy>-14qx,14vn>-1ecg,1ech>-1ecg,1edu>-1ecg,1eci>-1ecg,1eda>-1ecg,1eci>-1ecg,1eci>-168q,168r>-168q,168s>-14ye,14yf>-14ye"
		};
		function m(e, t) {
			var n = 36, r = 0, i = /* @__PURE__ */ new Map(), a = t && /* @__PURE__ */ new Map(), o;
			return e.split(",").forEach(function e(s) {
				if (s.indexOf("+") !== -1) for (var c = +s; c--;) e(o);
				else {
					o = s;
					var l = s.split(">"), u = l[0], d = l[1];
					u = String.fromCodePoint(r += parseInt(u, n)), d = String.fromCodePoint(r += parseInt(d, n)), i.set(u, d), t && a.set(d, u);
				}
			}), {
				map: i,
				reverseMap: a
			};
		}
		var h, g, _;
		function v() {
			if (!h) {
				var e = m(p.pairs, !0), t = e.map, n = e.reverseMap;
				h = t, g = n, _ = m(p.canonical, !1).map;
			}
		}
		function y(e) {
			return v(), h.get(e) || null;
		}
		function b(e) {
			return v(), g.get(e) || null;
		}
		function x(e) {
			return v(), _.get(e) || null;
		}
		var S = n.L, C = n.R, w = n.EN, T = n.ES, E = n.ET, D = n.AN, O = n.CS, k = n.B, A = n.S, j = n.ON, M = n.BN, ee = n.NSM, te = n.AL, ne = n.LRO, re = n.RLO, ie = n.LRE, ae = n.RLE, oe = n.PDF, se = n.LRI, ce = n.RLI, le = n.FSI, N = n.PDI;
		function P(e, t) {
			for (var n = 125, r = new Uint32Array(e.length), l = 0; l < e.length; l++) r[l] = d(e[l]);
			var u = /* @__PURE__ */ new Map();
			function f(e, t) {
				var n = r[e];
				r[e] = t, u.set(n, u.get(n) - 1), n & o && u.set(o, u.get(o) - 1), u.set(t, (u.get(t) || 0) + 1), t & o && u.set(o, (u.get(o) || 0) + 1);
			}
			for (var p = new Uint8Array(e.length), m = /* @__PURE__ */ new Map(), h = [], g = null, _ = 0; _ < e.length; _++) g || h.push(g = {
				start: _,
				end: e.length - 1,
				level: t === "rtl" ? 1 : t === "ltr" ? 0 : $t(_, !1)
			}), r[_] & k && (g.end = _, g = null);
			for (var v = ae | ie | re | ne | i | N | oe | k, P = function(e) {
				return e + (e & 1 ? 1 : 2);
			}, ue = function(e) {
				return e + (e & 1 ? 2 : 1);
			}, de = 0; de < h.length; de++) {
				g = h[de];
				var fe = [{
					_level: g.level,
					_override: 0,
					_isolate: 0
				}], pe = void 0, me = 0, F = 0, I = 0;
				u.clear();
				for (var he = g.start; he <= g.end; he++) {
					var L = r[he];
					if (pe = fe[fe.length - 1], u.set(L, (u.get(L) || 0) + 1), L & o && u.set(o, (u.get(o) || 0) + 1), L & v) if (L & (ae | ie)) {
						p[he] = pe._level;
						var ge = (L === ae ? ue : P)(pe._level);
						ge <= n && !me && !F ? fe.push({
							_level: ge,
							_override: 0,
							_isolate: 0
						}) : me || F++;
					} else if (L & (re | ne)) {
						p[he] = pe._level;
						var _e = (L === re ? ue : P)(pe._level);
						_e <= n && !me && !F ? fe.push({
							_level: _e,
							_override: L & re ? C : S,
							_isolate: 0
						}) : me || F++;
					} else if (L & i) {
						L & le && (L = $t(he + 1, !0) === 1 ? ce : se), p[he] = pe._level, pe._override && f(he, pe._override);
						var ve = (L === ce ? ue : P)(pe._level);
						ve <= n && me === 0 && F === 0 ? (I++, fe.push({
							_level: ve,
							_override: 0,
							_isolate: 1,
							_isolInitIndex: he
						})) : me++;
					} else if (L & N) {
						if (me > 0) me--;
						else if (I > 0) {
							for (F = 0; !fe[fe.length - 1]._isolate;) fe.pop();
							var ye = fe[fe.length - 1]._isolInitIndex;
							ye != null && (m.set(ye, he), m.set(he, ye)), fe.pop(), I--;
						}
						pe = fe[fe.length - 1], p[he] = pe._level, pe._override && f(he, pe._override);
					} else L & oe ? (me === 0 && (F > 0 ? F-- : !pe._isolate && fe.length > 1 && (fe.pop(), pe = fe[fe.length - 1])), p[he] = pe._level) : L & k && (p[he] = g.level);
					else p[he] = pe._level, pe._override && L !== M && f(he, pe._override);
				}
				for (var be = [], R = null, xe = g.start; xe <= g.end; xe++) {
					var z = r[xe];
					if (!(z & s)) {
						var B = p[xe], Se = z & i, Ce = z === N;
						R && B === R._level ? (R._end = xe, R._endsWithIsolInit = Se) : be.push(R = {
							_start: xe,
							_end: xe,
							_level: B,
							_startsWithPDI: Ce,
							_endsWithIsolInit: Se
						});
					}
				}
				for (var we = [], Te = 0; Te < be.length; Te++) {
					var Ee = be[Te];
					if (!Ee._startsWithPDI || Ee._startsWithPDI && !m.has(Ee._start)) {
						for (var De = [R = Ee], Oe = void 0; R && R._endsWithIsolInit && (Oe = m.get(R._end)) != null;) for (var ke = Te + 1; ke < be.length; ke++) if (be[ke]._start === Oe) {
							De.push(R = be[ke]);
							break;
						}
						for (var Ae = [], je = 0; je < De.length; je++) for (var Me = De[je], Ne = Me._start; Ne <= Me._end; Ne++) Ae.push(Ne);
						for (var Pe = p[Ae[0]], Fe = g.level, Ie = Ae[0] - 1; Ie >= 0; Ie--) if (!(r[Ie] & s)) {
							Fe = p[Ie];
							break;
						}
						var Le = Ae[Ae.length - 1], Re = p[Le], ze = g.level;
						if (!(r[Le] & i)) {
							for (var Be = Le + 1; Be <= g.end; Be++) if (!(r[Be] & s)) {
								ze = p[Be];
								break;
							}
						}
						we.push({
							_seqIndices: Ae,
							_sosType: Math.max(Fe, Pe) % 2 ? C : S,
							_eosType: Math.max(ze, Re) % 2 ? C : S
						});
					}
				}
				for (var Ve = 0; Ve < we.length; Ve++) {
					var He = we[Ve], Ue = He._seqIndices, We = He._sosType, Ge = He._eosType, Ke = p[Ue[0]] & 1 ? C : S;
					if (u.get(ee)) for (var qe = 0; qe < Ue.length; qe++) {
						var Je = Ue[qe];
						if (r[Je] & ee) {
							for (var Ye = We, Xe = qe - 1; Xe >= 0; Xe--) if (!(r[Ue[Xe]] & s)) {
								Ye = r[Ue[Xe]];
								break;
							}
							f(Je, Ye & (i | N) ? j : Ye);
						}
					}
					if (u.get(w)) for (var Ze = 0; Ze < Ue.length; Ze++) {
						var Qe = Ue[Ze];
						if (r[Qe] & w) for (var $e = Ze - 1; $e >= -1; $e--) {
							var et = $e === -1 ? We : r[Ue[$e]];
							if (et & a) {
								et === te && f(Qe, D);
								break;
							}
						}
					}
					if (u.get(te)) for (var tt = 0; tt < Ue.length; tt++) {
						var nt = Ue[tt];
						r[nt] & te && f(nt, C);
					}
					if (u.get(T) || u.get(O)) for (var rt = 1; rt < Ue.length - 1; rt++) {
						var it = Ue[rt];
						if (r[it] & (T | O)) {
							for (var at = 0, ot = 0, st = rt - 1; st >= 0 && (at = r[Ue[st]], at & s); st--);
							for (var ct = rt + 1; ct < Ue.length && (ot = r[Ue[ct]], ot & s); ct++);
							at === ot && (r[it] === T ? at === w : at & (w | D)) && f(it, at);
						}
					}
					if (u.get(w)) {
						for (var lt = 0; lt < Ue.length; lt++) if (r[Ue[lt]] & w) {
							for (var ut = lt - 1; ut >= 0 && r[Ue[ut]] & (E | s); ut--) f(Ue[ut], w);
							for (lt++; lt < Ue.length && r[Ue[lt]] & (E | s | w); lt++) r[Ue[lt]] !== w && f(Ue[lt], w);
						}
					}
					if (u.get(E) || u.get(T) || u.get(O)) for (var dt = 0; dt < Ue.length; dt++) {
						var ft = Ue[dt];
						if (r[ft] & (E | T | O)) {
							f(ft, j);
							for (var pt = dt - 1; pt >= 0 && r[Ue[pt]] & s; pt--) f(Ue[pt], j);
							for (var mt = dt + 1; mt < Ue.length && r[Ue[mt]] & s; mt++) f(Ue[mt], j);
						}
					}
					if (u.get(w)) for (var ht = 0, gt = We; ht < Ue.length; ht++) {
						var _t = Ue[ht], vt = r[_t];
						vt & w ? gt === S && f(_t, S) : vt & a && (gt = vt);
					}
					if (u.get(o)) {
						for (var V = C | w | D, yt = V | S, bt = [], xt = [], St = 0; St < Ue.length; St++) if (r[Ue[St]] & o) {
							var Ct = e[Ue[St]], wt = void 0;
							if (y(Ct) !== null) if (xt.length < 63) xt.push({
								char: Ct,
								seqIndex: St
							});
							else break;
							else if ((wt = b(Ct)) !== null) for (var Tt = xt.length - 1; Tt >= 0; Tt--) {
								var Et = xt[Tt].char;
								if (Et === wt || Et === b(x(Ct)) || y(x(Et)) === Ct) {
									bt.push([xt[Tt].seqIndex, St]), xt.length = Tt;
									break;
								}
							}
						}
						bt.sort(function(e, t) {
							return e[0] - t[0];
						});
						for (var Dt = 0; Dt < bt.length; Dt++) {
							for (var Ot = bt[Dt], kt = Ot[0], At = Ot[1], jt = !1, Mt = 0, Nt = kt + 1; Nt < At; Nt++) {
								var Pt = Ue[Nt];
								if (r[Pt] & yt) {
									jt = !0;
									var Ft = r[Pt] & V ? C : S;
									if (Ft === Ke) {
										Mt = Ft;
										break;
									}
								}
							}
							if (jt && !Mt) {
								Mt = We;
								for (var It = kt - 1; It >= 0; It--) {
									var Lt = Ue[It];
									if (r[Lt] & yt) {
										var Rt = r[Lt] & V ? C : S;
										Mt = Rt === Ke ? Ke : Rt;
										break;
									}
								}
							}
							if (Mt) {
								if (r[Ue[kt]] = r[Ue[At]] = Mt, Mt !== Ke) {
									for (var zt = kt + 1; zt < Ue.length; zt++) if (!(r[Ue[zt]] & s)) {
										d(e[Ue[zt]]) & ee && (r[Ue[zt]] = Mt);
										break;
									}
								}
								if (Mt !== Ke) {
									for (var Bt = At + 1; Bt < Ue.length; Bt++) if (!(r[Ue[Bt]] & s)) {
										d(e[Ue[Bt]]) & ee && (r[Ue[Bt]] = Mt);
										break;
									}
								}
							}
						}
						for (var Vt = 0; Vt < Ue.length; Vt++) if (r[Ue[Vt]] & o) {
							for (var Ht = Vt, Ut = Vt, Wt = We, Gt = Vt - 1; Gt >= 0; Gt--) if (r[Ue[Gt]] & s) Ht = Gt;
							else {
								Wt = r[Ue[Gt]] & V ? C : S;
								break;
							}
							for (var Kt = Ge, qt = Vt + 1; qt < Ue.length; qt++) if (r[Ue[qt]] & (o | s)) Ut = qt;
							else {
								Kt = r[Ue[qt]] & V ? C : S;
								break;
							}
							for (var Jt = Ht; Jt <= Ut; Jt++) r[Ue[Jt]] = Wt === Kt ? Wt : Ke;
							Vt = Ut;
						}
					}
				}
				for (var Yt = g.start; Yt <= g.end; Yt++) {
					var Xt = p[Yt], Zt = r[Yt];
					if (Xt & 1 ? Zt & (S | w | D) && p[Yt]++ : Zt & C ? p[Yt]++ : Zt & (D | w) && (p[Yt] += 2), Zt & s && (p[Yt] = Yt === 0 ? g.level : p[Yt - 1]), Yt === g.end || d(e[Yt]) & (A | k)) for (var Qt = Yt; Qt >= 0 && d(e[Qt]) & c; Qt--) p[Qt] = g.level;
				}
			}
			return {
				levels: p,
				paragraphs: h
			};
			function $t(t, n) {
				for (var a = t; a < e.length; a++) {
					var o = r[a];
					if (o & (C | te)) return 1;
					if (o & (k | S) || n && o === N) return 0;
					if (o & i) {
						var s = en(a);
						a = s === -1 ? e.length : s;
					}
				}
				return 0;
			}
			function en(t) {
				for (var n = 1, a = t + 1; a < e.length; a++) {
					var o = r[a];
					if (o & k) break;
					if (o & N) {
						if (--n === 0) return a;
					} else o & i && n++;
				}
				return -1;
			}
		}
		var ue = "14>1,j>2,t>2,u>2,1a>g,2v3>1,1>1,1ge>1,1wd>1,b>1,1j>1,f>1,ai>3,-2>3,+1,8>1k0,-1jq>1y7,-1y6>1hf,-1he>1h6,-1h5>1ha,-1h8>1qi,-1pu>1,6>3u,-3s>7,6>1,1>1,f>1,1>1,+2,3>1,1>1,+13,4>1,1>1,6>1eo,-1ee>1,3>1mg,-1me>1mk,-1mj>1mi,-1mg>1mi,-1md>1,1>1,+2,1>10k,-103>1,1>1,4>1,5>1,1>1,+10,3>1,1>8,-7>8,+1,-6>7,+1,a>1,1>1,u>1,u6>1,1>1,+5,26>1,1>1,2>1,2>2,8>1,7>1,4>1,1>1,+5,b8>1,1>1,+3,1>3,-2>1,2>1,1>1,+2,c>1,3>1,1>1,+2,h>1,3>1,a>1,1>1,2>1,3>1,1>1,d>1,f>1,3>1,1a>1,1>1,6>1,7>1,13>1,k>1,1>1,+19,4>1,1>1,+2,2>1,1>1,+18,m>1,a>1,1>1,lk>1,1>1,4>1,2>1,f>1,3>1,1>1,+3,db>1,1>1,+3,3>1,1>1,+2,14qm>1,1>1,+1,6>1,4j>1,j>2,t>2,u>2,2>1,+1", de;
		function fe() {
			if (!de) {
				var e = m(ue, !0), t = e.map;
				e.reverseMap.forEach(function(e, n) {
					t.set(n, e);
				}), de = t;
			}
		}
		function pe(e) {
			return fe(), de.get(e) || null;
		}
		function me(e, t, n, r) {
			var i = e.length;
			n = Math.max(0, n == null ? 0 : +n), r = Math.min(i - 1, r == null ? i - 1 : +r);
			for (var a = /* @__PURE__ */ new Map(), o = n; o <= r; o++) if (t[o] & 1) {
				var s = pe(e[o]);
				s !== null && a.set(o, s);
			}
			return a;
		}
		function F(e, t, n, r) {
			var i = e.length;
			n = Math.max(0, n == null ? 0 : +n), r = Math.min(i - 1, r == null ? i - 1 : +r);
			var a = [];
			return t.paragraphs.forEach(function(i) {
				var o = Math.max(n, i.start), s = Math.min(r, i.end);
				if (o < s) {
					for (var l = t.levels.slice(o, s + 1), u = s; u >= o && d(e[u]) & c; u--) l[u] = i.level;
					for (var f = i.level, p = Infinity, m = 0; m < l.length; m++) {
						var h = l[m];
						h > f && (f = h), h < p && (p = h | 1);
					}
					for (var g = f; g >= p; g--) for (var _ = 0; _ < l.length; _++) if (l[_] >= g) {
						for (var v = _; _ + 1 < l.length && l[_ + 1] >= g;) _++;
						_ > v && a.push([v + o, _ + o]);
					}
				}
			}), a;
		}
		function I(e, t, n, r) {
			var i = he(e, t, n, r), a = [].concat(e);
			return i.forEach(function(n, r) {
				a[r] = (t.levels[n] & 1 ? pe(e[n]) : null) || e[n];
			}), a.join("");
		}
		function he(e, t, n, r) {
			for (var i = F(e, t, n, r), a = [], o = 0; o < e.length; o++) a[o] = o;
			return i.forEach(function(e) {
				for (var t = e[0], n = e[1], r = a.slice(t, n + 1), i = r.length; i--;) a[n - i] = r[i];
			}), a;
		}
		return e.closingToOpeningBracket = b, e.getBidiCharType = d, e.getBidiCharTypeName = f, e.getCanonicalBracket = x, e.getEmbeddingLevels = P, e.getMirroredCharacter = pe, e.getMirroredCharactersMap = me, e.getReorderSegments = F, e.getReorderedIndices = he, e.getReorderedString = I, e.openingToClosingBracket = y, Object.defineProperty(e, "__esModule", { value: !0 }), e;
	}({});
}
//#endregion
//#region ../../node_modules/hyphen/hyphen.js
var DQ = /* @__PURE__ */ V(((e, t) => {
	(function(e, n) {
		typeof define == "function" && define.amd ? define([], n) : typeof t == "object" && t.exports ? t.exports = n() : e.createHyphenator = n();
	})(e, function() {
		function e(e) {
			var t = "", n = "", r = 0, i = e();
			return function(e) {
				for (; r < e.length;) {
					t = e.charAt(r++), n = e.charAt(r);
					var a = i(t, n);
					if (a !== void 0) return a;
				}
			};
		}
		var t = RegExp.prototype.test.bind(/\s|(?![\'])[\!-\@\[-\`\{-\~\u2013-\u203C]/);
		function n() {
			var e = !1;
			return function(n, r) {
				return e ? r[0] === ">" && (n(), e = !1) : r[0] === "<" && (!t(r[1]) || r[1] === "/") && (e = !0), e;
			};
		}
		function r(e) {
			var n = !1;
			return function(r, i) {
				return n ? !t(i[0]) && t(i[1]) && (r(), n = !1) : !t(i[0]) && i[1] === e && (n = !0), n;
			};
		}
		function i(e, n) {
			return function() {
				var r = "", i = "";
				function a() {
					r += i, i = "";
				}
				function o(e) {
					return r = "", i = "", e;
				}
				return function(s, c) {
					i += s;
					var l = e.reduce(function(e, t) {
						return e || t(a, [s, c]);
					}, !1);
					if (!l && (t(s) && !t(c) && a(), !t(s) && t(c))) {
						if (i.length >= n) return o([r, i]);
						a();
					}
					if (c === "") return (i.length < n || l) && a(), o([r, i]);
				};
			};
		}
		function a(e) {
			var t = 0;
			function n() {
				return e[t++];
			}
			return n;
		}
		function o(e) {
			var t = 0, n = e;
			function r() {
				if (n = e.slice(t++), !(n.length < 3)) return n;
			}
			function i() {
				return t === 2;
			}
			return [r, i];
		}
		function s(e, t, n, r, i) {
			for (var s = Array(e.length + 1), c = ("." + e.toLocaleLowerCase() + ".").split(""), l, u, d, f, p, m, h = -1, g, _, v, y, b = s.length; b--;) s[b] = 0;
			for (g = o(c), _ = g[0], v = g[1]; l = _();) for (h++, v() && h--, d = n, y = a(l); (u = y()) && (f = d[u]) !== void 0;) {
				switch (d = {}, p = -1, Object.prototype.toString.call(f)) {
					case "[object Array]":
						d = f[0], p = f[1];
						break;
					case "[object Object]":
						d = f;
						break;
					case "[object Number]":
						p = f;
						break;
				}
				if (!(p < 0)) {
					t[p].splice || (t[p] = t[p].slice("")), m = t[p];
					for (var x = 0; x < m.length; x++) s[h + x] = Math.max(m[x], s[h + x]);
				}
			}
			s[0] = s[1] = s[s.length - 1] = s[s.length - 2] = 0;
			for (var S = "", b = 0; b < s.length; b++) S += (s[b] % 2 == 1 ? i : "") + e.charAt(b);
			return S;
		}
		function c(t, a, o, c, l, u, d, f, p) {
			function m() {
				v(h);
			}
			var h = "", g, _ = e(i((d ? [n()] : []).concat(r(u)), f)), v = function() {};
			function y() {
				for (var e = /* @__PURE__ */ new Date(); (!p || /* @__PURE__ */ new Date() - e < 10) && (g = _(t));) {
					if (g[1]) {
						var n = g[1].length ? "~" + g[1] : "";
						c[n] === void 0 && (c[n] = s(g[1], a, o, l, u)), g[1] = c[n];
					}
					h += g[0] + g[1];
				}
				g ? setTimeout(y) : m();
			}
			return p ? (setTimeout(y), new Promise(function(e) {
				v = e;
			})) : (y(), h);
		}
		var l = !1, u = !1, d = [], f = !0, p = "­", m = 5, h = "async", g = "debug", _ = "exceptions", v = "html", y = "hyphenChar", b = "minWordLength", x = typeof global == "object" ? global : typeof window == "object" ? window : typeof self == "object" ? self : {};
		function S(e, t) {
			for (var n in e ||= {}, t) e[n] = t[n];
			return e;
		}
		function C(e) {
			return e instanceof Array;
		}
		function w(e, t, n, r) {
			return t in e && (!r || r(e[t])) ? e[t] : n;
		}
		function T(e, t) {
			return e.reduce(function(e, n) {
				return e["~" + n.replace(/\-/g, "")] = n.replace(/\-/g, t), e;
			}, {});
		}
		function E(e, t) {
			t ||= {};
			var n = w(t, h, l), r = {}, i = w(t, g, u), a = {}, o = w(t, y, p), s = e[0].split(","), E = JSON.parse(e[1]), D = w(t, b, m) >> 0, O = w(t, v, f), k = w(t, _, d, C), A = o + D;
			if (a[A] = {}, e[2] && (a[A] = T(e[2], o)), k && k.length && (a[A] = S(a[A], T(k, o))), r[A] = S({}, a[A]), n && !("Promise" in x)) throw Error("Failed to create hyphenator: Could not find global Promise object, needed for hyphenator to work in async mode");
			return function(t, l) {
				l ||= {};
				var u = w(l, g, i), f = w(l, y, o), p = w(l, b, D) >> 0, m = w(l, _, d, C), h = f + p;
				return !a[h] && e[2] && (a[h] = T(e[2], f), r[h] = S(r[h], a[h])), m && m.length && (a[h] = S(a[h], T(m, f)), r[h] = S(r[h], a[h])), c(t, s, E, r[h], u, f, O, p, n);
			};
		}
		return E;
	});
})), OQ = /* @__PURE__ */ V(((e, t) => {
	(function(e, n) {
		typeof define == "function" && define.amd ? define([], n) : typeof t == "object" && t.exports ? t.exports = n() : e.hyphenationPatternsEnUs = n();
	})(e, function() {
		return [
			"0004,004,001,003,005,0005,00005,000005,0002,002,0000005,0003,00003,00505,00034,0001,00055,00004,4,05,0055,04,42,03,02,2,404,3,044,01,0505,55,5,045,041,0033,000004,22,00504,5504,0042,1,21,41,402,405,4004,43,23,000054,303,3005,022,5004,000003,252,45,25,2004,000505,054,403,401,3002,0025,144,432,00054,34,12,234,0022,014,0304,012,143,503,0403,101,052,414,212,011,043,00002,0041,0024,05005,03003,00102,0404,04303,01004,0034,025,0044,00404,00025,0103,042,0205,412,104,54,344,433,5005,253,055,0402,3004,0043,204,505,454,0000004,00303,04004,552,201,4005,0255,52,444,14,44,02004,033,05004,00045,00013,0021,0405,00044,0054,50055,000303,00001,304,0204,11,301,232,122,00305,504,000043,0104,00052,000045,50004,0023,00033,00032,00202,5003,202,0401,0000505,214,102,032,000161,004101,00501,00301,0036,0052,00023,006101,006,00401,000521,0014,0063,00012,000501,000006,000604,000601,005001,005005,0010305,00006,003012,003005,0003011,0061,013,000021,000022,000105,00211,00062,00051,000112,006013,000011,0200306,1021,0050001,003003,2102,305,000015,01030005,000035,001011,00021,16330001,0234,030006,5020001,000001,00016,0031,021,21431,002305,0350014,0000012,000063,00101,106,105,00435,00063,0300061,00041,100306,003602,023,0503,0010011,10003,1005,30011,00031,0001001,0000061,0030003,30305,001201,0301,5000101,500101,00015,000401,000065,000016,0000402,0500002,000205,030201,500301,00014,5001,000002,00030011,01034,0300006,030213,00400304,050001,05003,000311,0634,00061,0006,00000604,00050013,00213,0030001,100003,000033,30002,00003632,0003004,050003,0000021,006303,0000006,00005005,30451,03001,00231,00056,00011,6,001001,00500001,03005,503005,0000010001,1002,003001,001065,300001,32011,32,0000003,0213001,0500053,021005,10001,0000011,0001041,0020016,100032,50011,0606,5002,3001,03002,0015001,0102,00003001,000000033,0000001,300101,300015,0101003,00000101,0100501,0101,0010033,00000362,000014,0005001,031",
			"{\".\":{\"a\":{\"c\":{\"h\":0},\"d\":{\"d\":{\"e\":{\"r\":1}}},\"f\":{\"t\":2},\"l\":{\"t\":3},\"m\":{\"a\":{\"t\":4}},\"n\":{\"c\":4,\"g\":0,\"i\":{\"m\":5},\"t\":[{\"e\":3,\"i\":{\"s\":6}},0]},\"r\":{\"s\":4,\"t\":{\"i\":{\"e\":1},\"y\":1}},\"s\":{\"c\":3,\"p\":2,\"s\":2,\"t\":{\"e\":{\"r\":7}}},\"t\":{\"o\":{\"m\":6}},\"u\":{\"d\":2},\"v\":{\"i\":1},\"w\":{\"n\":0}},\"b\":{\"a\":{\"g\":1,\"n\":{\"a\":4},\"s\":{\"e\":0}},\"e\":{\"r\":[{\"a\":4},0],\"s\":{\"m\":3,\"t\":{\"o\":4}}},\"r\":{\"i\":8},\"u\":{\"t\":{\"t\":{\"i\":0}}}},\"c\":{\"a\":{\"m\":{\"p\":{\"e\":0}},\"n\":{\"c\":5},\"p\":{\"a\":{\"b\":6}},\"r\":{\"o\":{\"l\":5}},\"t\":1},\"e\":{\"l\":{\"a\":1}},\"h\":[{\"i\":{\"l\":{\"l\":{\"i\":7}}}},1],\"i\":[{\"t\":{\"r\":5}},9],\"o\":{\"e\":3,\"r\":[{\"n\":{\"e\":{\"r\":5}}},1],\"n\":{\"g\":{\"r\":5}}}},\"d\":{\"e\":{\"m\":{\"o\":{\"i\":1}},\"o\":3,\"r\":{\"a\":3,\"i\":[{\"v\":{\"a\":4}},3]},\"s\":{\"c\":0}},\"i\":{\"c\":{\"t\":{\"i\":{\"o\":10}}}},\"o\":{\"t\":1},\"u\":{\"c\":1,\"m\":{\"b\":6}},\"r\":{\"i\":{\"v\":67}}},\"e\":{\"a\":{\"r\":{\"t\":{\"h\":7}},\"s\":{\"i\":11}},\"b\":1,\"e\":{\"r\":0},\"g\":9,\"l\":{\"d\":4,\"e\":{\"m\":3}},\"n\":{\"a\":{\"m\":12},\"g\":3,\"s\":3},\"q\":{\"u\":{\"i\":{\"t\":13}}},\"r\":{\"r\":{\"i\":1}},\"s\":3,\"u\":[{\"l\":{\"e\":{\"r\":1}}},3],\"y\":{\"e\":5},\"t\":{\"h\":{\"y\":{\"l\":162}}},\"v\":[{\"e\":{\"r\":{\"s\":{\"i\":{\"b\":158}}}}},9]},\"f\":{\"e\":{\"s\":11},\"o\":{\"r\":{\"m\":{\"e\":{\"r\":5}}}}},\"g\":{\"a\":[{\"s\":{\"o\":{\"m\":163}}},9],\"e\":[{\"n\":{\"t\":14},\"o\":{\"g\":4,\"m\":{\"e\":1},\"t\":164}},9],\"i\":{\"a\":4,\"b\":1},\"o\":{\"r\":1}},\"h\":{\"a\":{\"n\":{\"d\":{\"i\":6},\"k\":5}},\"e\":[{\"r\":{\"o\":{\"i\":6,\"e\":3}},\"s\":11,\"t\":11,\"m\":{\"o\":165},\"p\":{\"a\":166}},9],\"i\":{\"b\":3,\"e\":{\"r\":3}},\"o\":{\"n\":{\"e\":{\"y\":5},\"o\":11},\"v\":5}},\"i\":{\"d\":{\"l\":1,\"o\":{\"l\":12}},\"m\":{\"m\":3,\"p\":{\"i\":{\"n\":4}}},\"n\":[{\"c\":{\"i\":3},\"e\":8,\"k\":9,\"s\":3,\"u\":{\"t\":167}},2],\"r\":{\"r\":4},\"s\":{\"i\":1}},\"j\":{\"u\":{\"r\":3}},\"l\":{\"a\":{\"c\":{\"y\":1},\"m\":1,\"t\":{\"e\":{\"r\":5},\"h\":6}},\"e\":[{\"g\":{\"e\":5},\"n\":0,\"p\":5,\"v\":15,\"i\":{\"c\":{\"e\":{\"s\":170}}}},9],\"i\":{\"g\":[{\"a\":5},1],\"n\":9,\"o\":3,\"t\":1}},\"m\":{\"a\":{\"g\":{\"a\":16},\"l\":{\"o\":5},\"n\":{\"a\":5},\"r\":{\"t\":{\"i\":5}}},\"e\":[{\"r\":{\"c\":11},\"t\":{\"e\":{\"r\":4},\"a\":{\"l\":{\"a\":0}}},\"g\":{\"a\":{\"l\":171}}},9],\"i\":{\"s\":[{\"t\":{\"i\":6},\"e\":{\"r\":{\"s\":173}}},15],\"m\":{\"i\":{\"c\":172}}},\"o\":{\"n\":{\"e\":11},\"r\":{\"o\":3}},\"u\":{\"t\":{\"a\":[{\"b\":6},4]}}},\"n\":{\"i\":{\"c\":1},\"e\":{\"o\":{\"f\":174}},\"o\":{\"e\":{\"t\":{\"h\":15}},\"n\":{\"e\":{\"m\":175}}}},\"o\":{\"d\":[{\"d\":5},9],\"f\":{\"t\":{\"e\":4}},\"r\":{\"a\":{\"t\":{\"o\":4}},\"c\":3,\"d\":2,\"t\":3},\"s\":[{\"t\":{\"l\":1}},3],\"t\":{\"h\":11},\"u\":{\"t\":11}},\"p\":{\"e\":{\"d\":{\"a\":{\"l\":5}},\"t\":{\"e\":4,\"i\":{\"t\":4}}},\"i\":{\"e\":1,\"o\":{\"n\":5},\"t\":9},\"r\":{\"e\":{\"m\":11,\"a\":{\"m\":15}}},\"o\":{\"l\":{\"y\":{\"s\":137}},\"s\":{\"t\":{\"a\":{\"m\":137}}}}},\"r\":{\"a\":{\"c\":1,\"n\":{\"t\":0},\"t\":{\"i\":{\"o\":{\"n\":{\"a\":7}}}},\"v\":{\"e\":{\"n\":{\"o\":176}}}},\"e\":{\"e\":[{\"c\":173},8],\"m\":{\"i\":{\"t\":4}},\"s\":[{\"t\":{\"a\":{\"t\":4}}},8]},\"i\":{\"g\":1,\"t\":{\"u\":5}},\"o\":{\"q\":1,\"s\":{\"t\":5},\"w\":{\"d\":5}},\"u\":{\"d\":1}},\"s\":{\"c\":{\"i\":{\"e\":11}},\"e\":{\"l\":{\"f\":6,\"l\":6},\"n\":9,\"r\":{\"i\":{\"e\":4}},\"m\":{\"i\":[{\"c\":0,\"d\":177,\"p\":36,\"r\":36,\"s\":178,\"v\":36},6]}},\"h\":9,\"i\":[{\"n\":{\"g\":17}},9],\"t\":[{\"a\":{\"b\":{\"l\":5}}},1],\"y\":9,\"p\":{\"h\":{\"i\":{\"n\":179}},\"i\":{\"n\":{\"o\":137}}}},\"t\":{\"a\":[{\"p\":{\"e\":{\"s\":{\"t\":{\"r\":180}}}}},1],\"e\":[{\"n\":{\"a\":{\"n\":5}},\"l\":{\"e\":{\"g\":{\"r\":3}}}},1],\"h\":9,\"i\":[{\"l\":0,\"m\":{\"o\":16},\"n\":{\"g\":17,\"k\":5}},9],\"o\":{\"n\":{\"a\":0},\"p\":[{\"i\":5,\"o\":{\"g\":170}},1],\"u\":{\"s\":5},\"q\":9},\"r\":{\"i\":{\"b\":{\"u\":{\"t\":6}}}}},\"u\":{\"n\":{\"a\":[{\"t\":{\"t\":144}},2],\"c\":{\"e\":3},\"d\":{\"e\":{\"r\":7}},\"e\":[{\"r\":{\"r\":181}},2],\"k\":4,\"o\":4,\"u\":3},\"p\":3,\"r\":{\"e\":11},\"s\":{\"a\":4}},\"v\":{\"e\":{\"n\":{\"d\":{\"e\":0}},\"r\":{\"a\":4}},\"i\":{\"c\":{\"a\":{\"r\":151}}}},\"w\":{\"i\":{\"l\":{\"i\":5}},\"e\":{\"b\":{\"l\":131}}},\"y\":{\"e\":1},\"k\":{\"i\":{\"l\":{\"n\":{\"i\":168}}},\"o\":{\"r\":{\"t\":{\"e\":169}}}}},\"a\":{\"b\":{\".\":18,\"a\":{\"l\":19,\"n\":19},\"e\":[{\"r\":{\"d\":4}},8],\"i\":{\"a\":5,\"t\":{\"a\":{\"b\":13}}},\"l\":{\"a\":{\"t\":4}},\"o\":{\"l\":{\"i\":{\"z\":20,\"c\":19}}},\"r\":[{\"o\":{\"g\":4}},18],\"u\":{\"l\":3}},\"c\":{\"a\":{\"r\":[{\"d\":4,\"o\":4},21],\"b\":{\"l\":24}},\"e\":{\"o\":{\"u\":19},\"r\":2},\"h\":{\"e\":{\"t\":19}},\"i\":[{\"e\":23,\"n\":2,\"o\":23},22],\"r\":{\"o\":{\"b\":4}},\"t\":{\"i\":{\"f\":5}},\"u\":{\"l\":3,\"m\":1}},\"d\":[{\"d\":{\"i\":{\"n\":1}},\"e\":{\"r\":{\".\":4}},\"i\":[{\"a\":23,\"c\":{\"a\":3},\"e\":{\"r\":0},\"o\":23,\"t\":23,\"u\":19},25],\"l\":{\"e\":1},\"o\":{\"w\":3},\"r\":{\"a\":{\"n\":4}},\"s\":{\"u\":1},\"u\":[{\"c\":23,\"m\":4},18]},24],\"e\":{\"r\":[{\"i\":{\"e\":17}},1]},\"f\":[{\"f\":[{\"i\":{\"s\":{\"h\":170}}},0]},24],\"g\":{\"a\":{\"b\":21,\"n\":0},\"e\":{\"l\":{\"l\":4},\"o\":0,\"u\":18},\"i\":2,\"l\":26,\"n\":2,\"o\":[{\"g\":27,\"n\":{\"i\":3}},24],\"u\":{\"e\":{\"r\":19},\"l\":4},\"y\":21},\"h\":{\"a\":23,\"e\":23,\"l\":1,\"o\":23},\"i\":[{\"a\":19,\"c\":{\".\":23},\"l\":{\"y\":4},\"n\":[{\"i\":{\"n\":5},\"o\":5},28],\"t\":{\"e\":{\"n\":5}}},9],\"j\":29,\"k\":{\"e\":{\"n\":2}},\"l\":{\"a\":{\"b\":4,\"d\":3,\"r\":21},\"d\":{\"i\":18},\"e\":[{\"n\":{\"d\":3,\"t\":{\"i\":21}},\"o\":30},25],\"i\":[{\"a\":{\".\":1},\"e\":0},2],\"l\":{\"e\":{\"v\":4},\"i\":{\"c\":18}},\"m\":18,\"o\":{\"g\":{\".\":19}},\"y\":{\".\":21,\"s\":[{\"t\":31},18],\"t\":32,\"z\":27}},\"m\":{\"a\":[{\"b\":4,\"g\":3,\"r\":{\"a\":5},\"s\":{\"c\":4},\"t\":{\"i\":{\"s\":21},\"o\":33}},18],\"e\":{\"r\":{\"a\":4},\"n\":{\"t\":{\"a\":{\"b\":182}}}},\"i\":{\"c\":3,\"f\":4,\"l\":{\"y\":4},\"n\":[{\"o\":0},2]},\"o\":[{\"n\":19,\"r\":{\"i\":6}},24],\"p\":{\"e\":{\"n\":5}}},\"n\":[{\"a\":{\"g\":{\"e\":3},\"l\":{\"y\":[{\"s\":183},27]},\"r\":[{\"c\":3,\"i\":17},23],\"t\":{\"i\":23}},\"d\":[{\"e\":{\"s\":17},\"i\":{\"s\":3},\"l\":2,\"o\":{\"w\":1}},18],\"e\":{\"e\":19,\"n\":23,\"s\":{\"t\":{\".\":4}},\"u\":23},\"g\":[{\"i\":{\"e\":5},\"l\":2},25],\"i\":{\"c\":34,\"e\":{\"s\":23},\"f\":35,\"m\":{\"e\":1,\"i\":19},\"n\":{\"e\":19},\"o\":3,\"p\":23,\"s\":{\"h\":3},\"t\":3,\"u\":23},\"k\":{\"l\":{\"i\":1}},\"n\":{\"i\":{\"z\":32}},\"o\":[{\"t\":[{\"h\":7},4],\"a\":{\"c\":148}},0],\"s\":{\"a\":9,\"c\":{\"o\":1},\"n\":1,\"p\":[{\"o\":11},9],\"t\":1,\"u\":{\"r\":1},\"g\":{\"r\":5},\"v\":11},\"t\":{\"a\":{\"l\":36},\"i\":{\"e\":1,\"d\":137,\"n\":184,\"r\":{\"e\":137}},\"o\":18,\"r\":9,\"w\":1},\"u\":{\"a\":3,\"l\":3,\"r\":19}},24],\"o\":18,\"p\":{\"a\":{\"r\":17,\"t\":4},\"e\":{\"r\":{\"o\":4},\"a\":{\"b\":{\"l\":{\"e\":132}}}},\"h\":{\"e\":{\"r\":23},\"i\":18},\"i\":{\"l\":{\"l\":{\"a\":[{\"r\":4},21]}},\"n\":3,\"t\":{\"a\":3,\"u\":23}},\"l\":24,\"o\":{\"c\":6,\"l\":{\"a\":4},\"r\":{\"i\":6},\"s\":{\"t\":12}},\"s\":{\"e\":{\"s\":5}},\"u\":23},\"q\":{\"u\":{\"e\":6}},\"r\":[{\"a\":{\"c\":{\"t\":3},\"d\":{\"e\":19,\"i\":{\"s\":4}},\"l\":3,\"m\":{\"e\":{\"t\":{\"e\":19}}},\"n\":{\"g\":17},\"p\":11,\"t\":[{\"i\":{\"o\":19,\"v\":4}},1],\"u\":19,\"v\":38,\"w\":17},\"b\":{\"a\":{\"l\":36}},\"c\":{\"h\":{\"a\":{\"n\":1},\"e\":{\"t\":185}}},\"d\":{\"i\":{\"n\":{\"e\":4}},\"r\":1},\"e\":{\"a\":{\"s\":4},\"e\":23,\"n\":{\"t\":3},\"s\":{\"s\":19}},\"f\":{\"i\":1,\"l\":1},\"i\":[{\"a\":{\"l\":4,\"n\":3},\"e\":{\"t\":23},\"m\":1,\"n\":{\"a\":{\"t\":4}},\"o\":3,\"z\":9},2],\"m\":{\"i\":9},\"o\":{\"d\":20,\"n\":{\"i\":19},\"o\":23},\"p\":9,\"q\":3,\"r\":{\"e\":17,\"a\":{\"n\":{\"g\":{\"e\":9}}}},\"s\":{\"a\":1,\"h\":9}},37],\"s\":{\".\":18,\"a\":{\"b\":1,\"n\":{\"t\":3}},\"h\":{\"i\":17},\"i\":{\"a\":{\".\":19},\"b\":23,\"c\":23,\"t\":39},\"k\":{\"i\":11},\"l\":1,\"o\":{\"c\":21},\"p\":{\"h\":4},\"s\":{\"h\":1},\"t\":{\"e\":{\"n\":3},\"r\":2},\"u\":{\"r\":{\"a\":6}},\"y\":{\"m\":{\"p\":{\"t\":{\"o\":{\"t\":4}}}}}},\"t\":{\"a\":[{\"b\":{\"l\":3},\"c\":4,\"l\":{\"o\":3},\"p\":4},24],\"e\":{\"c\":[{\"h\":4},5],\"g\":{\"o\":3},\"n\":{\".\":3},\"r\":{\"a\":3,\"n\":[{\"a\":19},6]},\"s\":{\"t\":3},\"v\":4},\"h\":[{\"e\":{\"m\":5,\"n\":19,\"r\":{\"o\":{\"s\":186}}},\"o\":[{\"m\":5},1]},18],\"i\":{\".\":18,\"a\":19,\"b\":20,\"c\":2,\"f\":3,\"o\":{\"n\":{\"a\":{\"r\":7}}},\"t\":{\"u\":3}},\"o\":{\"g\":21,\"m\":[{\"i\":{\"z\":4}},24],\"p\":21,\"s\":21},\"r\":[{\"o\":{\"p\":4}},29],\"s\":{\"k\":1},\"t\":{\"a\":{\"g\":1},\"e\":[{\"s\":{\".\":170}},4],\"h\":1},\"u\":[{\"a\":4,\"e\":4,\"l\":3,\"r\":{\"a\":3}},24],\"y\":24},\"u\":{\"b\":1,\"g\":{\"h\":[{\"t\":{\"l\":17}},12],\"u\":3},\"l\":[{\"i\":{\"f\":13}},40],\"n\":{\"d\":5},\"r\":3,\"s\":{\"i\":{\"b\":4}},\"t\":{\"e\":{\"n\":5},\"h\":2}},\"v\":{\"a\":[{\"g\":3,\"n\":19},24],\"e\":{\"n\":{\"o\":0},\"r\":{\"a\":3,\"n\":4,\"y\":4}},\"i\":[{\"e\":{\"r\":0},\"g\":3,\"o\":{\"u\":3}},2],\"o\":{\"c\":4,\"r\":29}},\"w\":{\"a\":{\"y\":27},\"i\":3,\"l\":{\"y\":1},\"s\":0},\"x\":{\"i\":{\"c\":1,\"d\":1}},\"y\":{\"a\":{\"l\":4},\"e\":0,\"s\":0},\"z\":{\"i\":{\"e\":{\"r\":0}},\"z\":{\"i\":5}}},\"b\":{\"a\":{\".\":32,\"d\":{\"g\":{\"e\":{\"r\":5}}},\"g\":{\"e\":1},\"l\":{\"a\":15},\"n\":{\"d\":{\"a\":{\"g\":5}},\"e\":0,\"i\":11},\"r\":{\"b\":{\"i\":7},\"i\":{\"a\":17},\"o\":{\"n\":{\"i\":{\"e\":187}}}},\"s\":{\"s\":{\"i\":0}},\"t\":[{\"h\":{\"y\":2}},41],\"z\":1,\"c\":{\"k\":{\"e\":{\"r\":{\".\":84}}}}},\"b\":[{\"e\":[{\"r\":23},24],\"i\":{\"n\":{\"a\":0},\"t\":0}},42],\"d\":43,\"e\":{\".\":18,\"a\":{\"k\":17,\"t\":12},\"d\":[{\"a\":3,\"e\":3,\"i\":3},44],\"g\":{\"i\":3,\"u\":4},\"l\":[{\"i\":2,\"o\":3},41],\"m\":45,\"n\":{\"i\":{\"g\":4},\"u\":4},\"s\":[{\"p\":3,\"t\":{\"r\":4}},46],\"t\":[{\"i\":{\"z\":5},\"r\":4,\"w\":3},27],\"w\":3,\"y\":{\"o\":4},\"v\":{\"i\":{\"e\":9}}},\"f\":25,\"h\":47,\"i\":{\"b\":9,\"d\":[{\"i\":{\"f\":167}},1],\"e\":[{\"n\":4,\"r\":1},27],\"f\":48,\"l\":[{\"i\":{\"z\":3},\"l\":{\"a\":{\"b\":8}}},41],\"n\":{\"a\":{\"r\":49},\"d\":0,\"e\":{\"t\":4}},\"o\":{\"g\":{\"r\":3},\"u\":4,\"m\":5,\"r\":{\"b\":2,\"h\":15}},\"t\":[{\"i\":{\"o\":50,\"v\":{\"e\":188}},\"r\":3,\"u\":{\"a\":51},\"z\":19},9]},\"j\":29,\"k\":1,\"l\":[{\"a\":{\"t\":{\"h\":7},\"n\":{\"d\":189}},\"e\":{\".\":21,\"n\":17,\"s\":{\"p\":32}},\"i\":{\"s\":23,\"n\":{\"d\":189}},\"o\":[{\"n\":{\"d\":190}},21],\"u\":{\"n\":{\"t\":17}}},52],\"m\":43,\"n\":[{\"e\":{\"g\":5}},47],\"o\":{\"d\":[{\"i\":11},27],\"e\":1,\"l\":{\"i\":{\"c\":11}},\"m\":{\"b\":{\"i\":0}},\"n\":{\"a\":[{\"t\":5},0]},\"o\":27,\"r\":{\".\":32,\"a\":43,\"d\":5,\"e\":32,\"i\":32,\"n\":{\"o\":191}},\"s\":53,\"t\":{\"a\":19,\"h\":6,\"o\":1,\"u\":{\"l\":192}},\"u\":{\"n\":{\"d\":54}}},\"p\":18,\"r\":{\"i\":{\"t\":18},\"o\":{\"t\":{\"h\":54}},\"u\":{\"s\":{\"q\":17}}},\"s\":[{\"o\":{\"r\":17}},55],\"t\":[{\"l\":1,\"o\":21,\"r\":23},25],\"u\":{\"f\":{\"f\":{\"e\":{\"r\":0}}},\"g\":{\"a\":1},\"l\":{\"i\":3},\"m\":{\"i\":17},\"n\":[{\"t\":{\"i\":17}},1],\"r\":{\"e\":3},\"s\":{\"i\":{\"e\":[{\"r\":193,\"s\":193},5]},\"s\":{\"e\":17,\"i\":{\"n\":{\"g\":17}}},\"t\":32},\"t\":{\"a\":18,\"i\":{\"o\":27},\"o\":19,\"e\":{\"d\":{\".\":8}},\"t\":{\"e\":{\"d\":0}}}},\"v\":29,\"w\":56,\"y\":{\".\":32,\"s\":0}},\"c\":{\"a\":[{\"b\":{\"i\":{\"n\":11},\"l\":2},\"c\":{\"h\":17},\"d\":{\"e\":{\"n\":4,\"m\":194}},\"g\":46,\"h\":57,\"l\":{\"a\":{\"t\":3},\"l\":{\"a\":0,\"i\":{\"n\":6}},\"o\":18},\"n\":{\"d\":5,\"e\":0,\"i\":{\"c\":0,\"s\":5,\"z\":11},\"t\":{\"y\":0},\"y\":17},\"p\":{\"e\":{\"r\":4}},\"r\":{\"o\":{\"m\":5}},\"s\":{\"t\":{\"e\":{\"r\":6},\"i\":{\"g\":5}},\"y\":18},\"t\":{\"h\":1,\"i\":{\"v\":18},\"a\":{\"s\":195}},\"v\":{\"a\":{\"l\":5}}},41],\"c\":[{\"h\":{\"a\":6},\"i\":{\"a\":0},\"o\":{\"m\":{\"p\":{\"a\":10}},\"n\":17,\"u\":{\"t\":12}}},23],\"e\":{\".\":25,\"d\":{\".\":18,\"e\":{\"n\":18}},\"i\":27,\"l\":{\".\":32,\"l\":27},\"n\":[{\"c\":27,\"e\":58,\"i\":18,\"t\":27},41],\"p\":27,\"r\":{\"a\":{\"m\":4}},\"s\":{\"a\":18,\"s\":{\"i\":[{\"b\":59},27]},\"t\":5},\"t\":[{\"a\":60},0],\"w\":0},\"h\":[{\".\":18,\"a\":{\"b\":61,\"n\":{\"i\":{\"c\":32,\"s\":20}}},\"e\":[{\"a\":{\"p\":54},\"d\":18,\"l\":{\"o\":5},\"m\":{\"i\":27},\"n\":{\"e\":4},\"r\":{\".\":3,\"s\":3}},8],\"i\":{\"n\":[{\"e\":{\".\":32,\"s\":{\"s\":4}},\"i\":32},62],\"o\":32,\"t\":27,\"z\":8,\"e\":{\"v\":{\"o\":6}}},\"o\":63,\"t\":{\"i\":1},\"s\":{\".\":18,\"h\":{\"u\":11}}},25],\"i\":[{\"a\":[{\"b\":64,\"r\":5},27],\"c\":4,\"e\":{\"r\":18},\"f\":{\"i\":{\"c\":{\".\":32}}},\"i\":18,\"l\":{\"a\":1,\"i\":27},\"m\":25,\"n\":[{\"a\":[{\"t\":27},21],\"e\":{\"m\":11},\"g\":[{\".\":19},29],\"o\":32,\"q\":8},25],\"o\":{\"n\":17},\"p\":{\"e\":18,\"h\":3,\"i\":{\"c\":18}},\"s\":{\"t\":{\"a\":18,\"i\":18}},\"t\":[{\"i\":{\"z\":11}},42],\"z\":32,\"g\":{\"a\":{\"r\":152}}},41],\"k\":[{\"i\":3},2],\"l\":[{\"a\":{\"r\":[{\"a\":{\"t\":{\"i\":{\"o\":19}}},\"e\":32},18]},\"e\":{\"m\":0,\"a\":{\"r\":0}},\"i\":{\"c\":18,\"m\":17},\"y\":0},65],\"n\":19,\"o\":[{\"a\":{\"g\":4},\"e\":8,\"g\":[{\"r\":1},25],\"i\":[{\"n\":{\"c\":3}},0],\"l\":{\"i\":5,\"o\":[{\"r\":11},32]},\"m\":{\"e\":{\"r\":5}},\"n\":{\"a\":0,\"e\":21,\"g\":11,\"t\":5},\"p\":{\"a\":3,\"i\":{\"c\":11},\"l\":1,\"h\":{\"o\":{\"n\":196}}},\"r\":{\"b\":18,\"o\":{\"n\":12}},\"s\":{\"e\":0},\"v\":[{\"e\":17},15],\"w\":{\"a\":5},\"z\":{\"e\":5,\"i\":4},\"u\":{\"s\":{\"t\":{\"i\":84}}}},41],\"q\":29,\"r\":{\"a\":{\"s\":{\"t\":6},\"t\":{\".\":32,\"i\":{\"c\":32}}},\"e\":{\"a\":{\"t\":11},\"d\":32,\"t\":{\"a\":47},\"v\":0},\"i\":[{\"f\":5,\"n\":21,\"s\":17,\"t\":{\"i\":[{\"e\":11},32]}},8],\"o\":{\"p\":{\"l\":0,\"o\":6},\"s\":{\"e\":17},\"c\":{\"o\":{\"d\":197}},\"e\":{\"c\":{\"o\":148}}},\"u\":{\"d\":0}},\"s\":66,\"t\":[{\"a\":{\"b\":0,\"n\":{\"g\":4,\"t\":19}},\"e\":[{\"r\":23},24],\"i\":{\"c\":{\"u\":21},\"m\":{\"i\":12}},\"u\":{\"r\":0},\"w\":21,\"r\":{\"o\":{\"m\":{\"e\":{\"c\":198}}}}},42],\"u\":{\"d\":5,\"f\":21,\"i\":[{\"t\":{\"y\":4}},21],\"l\":{\"i\":32,\"t\":{\"i\":{\"s\":0},\"u\":27}},\"m\":{\"a\":9,\"e\":23,\"i\":1},\"n\":27,\"p\":{\"i\":3,\"y\":4},\"r\":{\"a\":{\"b\":67,\"n\":{\"c\":{\"e\":199}}},\"i\":{\"a\":4}},\"s\":[{\"s\":{\"i\":17}},41],\"t\":[{\"i\":{\"e\":1,\"v\":56},\"r\":18},68]},\"y\":41,\"z\":{\"e\":0}},\"d\":{\"a\":[{\".\":32,\"b\":70,\"c\":{\"h\":17},\"f\":18,\"g\":25,\"m\":71,\"n\":{\"g\":11},\"r\":{\"d\":6,\"k\":6,\"y\":18},\"t\":[{\"i\":{\"v\":18},\"o\":18,\"a\":{\"b\":137}},27],\"v\":[{\"e\":5},53],\"y\":32,\"l\":{\"o\":{\"n\":{\"e\":48}}}},69],\"b\":29,\"c\":19,\"d\":[{\"a\":{\"b\":20},\"i\":{\"b\":94}},72],\"e\":{\".\":25,\"a\":{\"f\":6,\"l\":{\"s\":{\".\":1}}},\"b\":{\"i\":{\"t\":5},\"o\":{\"n\":1}},\"c\":{\"a\":{\"n\":36},\"i\":{\"l\":1},\"o\":{\"m\":4},\"l\":{\"a\":{\"r\":200},\"i\":{\"n\":{\"a\":64}}}},\"d\":42,\"e\":{\".\":18},\"i\":{\"f\":4},\"l\":{\"i\":{\"e\":17,\"q\":16},\"o\":4},\"m\":[{\".\":32,\"i\":{\"c\":[{\".\":5},27],\"l\":4},\"o\":{\"n\":{\"s\":1},\"r\":7,\"s\":9}},21],\"n\":[{\"a\":{\"r\":1},\"o\":3,\"t\":{\"i\":{\"f\":7}},\"u\":3},41],\"p\":[{\"a\":3,\"i\":17,\"u\":9},2],\"q\":23,\"r\":{\"h\":21,\"m\":32,\"n\":{\"i\":{\"z\":6}},\"s\":5},\"s\":[{\".\":24,\"c\":2,\"o\":64,\"t\":{\"i\":11,\"r\":3},\"u\":1,\"i\":{\"c\":11}},8],\"t\":[{\"o\":9,\"i\":{\"c\":9}},2],\"v\":[{\"i\":{\"l\":11}},2],\"y\":18,\"f\":{\"i\":{\"n\":{\"i\":{\"t\":{\"i\":201}}}}}},\"f\":43,\"g\":{\"a\":21,\"e\":{\"t\":73},\"i\":2,\"y\":24},\"h\":74,\"i\":{\".\":32,\"a\":[{\"b\":5},75],\"c\":{\"a\":{\"m\":1,\"i\":{\"d\":15}},\"e\":21,\"t\":27},\"d\":27,\"e\":{\"n\":76},\"f\":[{\"f\":{\"r\":{\"a\":5}}},29],\"g\":{\"e\":3},\"l\":{\"a\":{\"t\":{\"o\":1}}},\"n\":[{\"a\":41,\"e\":{\".\":27},\"i\":[{\"z\":4},32]},29],\"o\":[{\"g\":5},41],\"p\":{\"l\":1},\"r\":[{\"e\":[{\"n\":9,\"r\":9},2],\"t\":{\"i\":6}},8],\"s\":[{\"i\":32,\"t\":77},15],\"t\":{\"i\":24},\"v\":78,\"m\":{\"e\":{\"t\":{\"h\":{\"y\":141}}}}},\"j\":29,\"k\":79,\"l\":{\"a\":56,\"e\":{\".\":27,\"d\":27,\"s\":{\".\":27,\"s\":18},\"a\":{\"d\":42}},\"o\":48,\"u\":56,\"y\":25,\"i\":{\"e\":202}},\"m\":29,\"n\":80,\"o\":[{\".\":27,\"d\":{\"e\":4},\"e\":32,\"f\":57,\"g\":21,\"l\":{\"a\":1,\"i\":17,\"o\":{\"r\":4}},\"m\":{\"i\":{\"z\":5}},\"n\":{\"a\":{\"t\":3},\"i\":17},\"o\":{\"d\":11},\"p\":{\"p\":0},\"r\":21,\"s\":27,\"u\":{\"t\":56},\"v\":1,\"x\":27,\"w\":{\"o\":{\"r\":{\"d\":203}}}},41],\"p\":29,\"r\":[{\"a\":{\"g\":{\"o\":{\"n\":6}},\"i\":18},\"e\":[{\"a\":{\"r\":6},\"n\":[{\"a\":{\"l\":204}},32]},0],\"i\":{\"b\":0,\"l\":17,\"f\":{\"t\":{\"a\":189}},\"p\":{\"l\":{\"e\":{\"g\":205}}}},\"o\":{\"p\":0,\"w\":18,\"m\":{\"e\":{\"d\":206}}},\"u\":{\"p\":{\"l\":{\"i\":32}}},\"y\":18},41],\"s\":[{\"p\":1,\"w\":21,\"y\":21},81],\"t\":{\"h\":24,\"a\":{\"b\":23}},\"u\":[{\"a\":[{\"l\":{\".\":9}},82],\"c\":[{\"a\":29,\"e\":{\"r\":5},\"t\":{\".\":18,\"s\":18}},9],\"e\":{\"l\":4},\"g\":1,\"l\":{\"e\":23},\"m\":{\"b\":{\"e\":0}},\"n\":1,\"p\":[{\"e\":1},18],\"o\":{\"p\":{\"o\":{\"l\":207}}}},41],\"v\":29,\"w\":29,\"y\":[{\"n\":32,\"s\":{\"e\":1,\"p\":5}},24]},\"e\":{\"a\":{\"b\":72,\"c\":{\"t\":23},\"d\":[{\"i\":{\"e\":5}},15],\"g\":{\"e\":[{\"r\":4},1]},\"l\":[{\"e\":{\"r\":5},\"o\":{\"u\":11}},1],\"m\":{\"e\":{\"r\":11}},\"n\":{\"d\":19,\"i\":{\"e\":{\"s\":111}}},\"r\":{\"a\":11,\"c\":0,\"e\":{\"s\":5},\"i\":{\"c\":0,\"l\":0},\"k\":5,\"t\":[{\"e\":12},8]},\"s\":{\"p\":4,\"s\":23,\"t\":12},\"t\":[{\"e\":{\"n\":5},\"h\":{\"i\":12},\"i\":{\"f\":19},\"u\":83},9],\"v\":[{\"e\":{\"n\":11},\"i\":5,\"o\":5},9]},\"b\":[{\"e\":{\"l\":{\".\":21,\"s\":21},\"n\":21},\"i\":{\"t\":21},\"r\":23},42],\"c\":{\"a\":{\"d\":21,\"n\":{\"c\":6}},\"c\":{\"a\":6},\"e\":[{\"s\":{\"s\":{\"a\":4}}},29],\"i\":[{\"b\":21,\"f\":{\"i\":{\"c\":{\"a\":{\"t\":4}},\"e\":4},\"y\":4},\"m\":3,\"t\":[{\"e\":19},0]},9],\"l\":{\"a\":{\"m\":21},\"u\":{\"s\":21}},\"o\":{\"l\":24,\"m\":{\"m\":21,\"p\":{\"e\":21}},\"n\":{\"c\":21},\"r\":[{\"a\":3,\"o\":5},24]},\"r\":[{\"e\":{\"m\":21}},29],\"t\":{\"a\":{\"n\":1},\"e\":1},\"u\":[{\"l\":[{\"a\":3},21]},29],\"h\":{\"a\":{\"s\":23}}},\"d\":{\"a\":37,\"d\":61,\"e\":{\"r\":34,\"s\":0},\"i\":[{\"a\":23,\"b\":3,\"c\":{\"a\":3},\"m\":3,\"t\":2,\"z\":5},18],\"o\":[{\"l\":21,\"n\":84},18],\"r\":{\"i\":21},\"u\":{\"l\":[{\"o\":4,\"i\":{\"n\":{\"g\":2}}},21]},\"g\":{\"l\":15}},\"e\":{\"c\":9,\"d\":{\"i\":11},\"f\":9,\"l\":{\"i\":11,\"y\":1},\"m\":9,\"n\":{\"a\":1},\"p\":85,\"s\":[{\"t\":17},86],\"t\":{\"y\":1},\"x\":19},\"f\":[{\"e\":{\"r\":{\"e\":83}},\"f\":41,\"i\":{\"c\":[{\"i\":32},21],\"l\":17,\"n\":{\"e\":23,\"i\":{\"t\":{\"e\":20}}},\"t\":27},\"o\":{\"r\":{\"e\":{\"s\":6}}},\"u\":{\"s\":{\"e\":{\".\":21}}}},29],\"g\":{\"a\":{\"l\":18},\"e\":{\"r\":17},\"i\":{\"b\":4,\"c\":1,\"n\":{\"g\":4},\"t\":87},\"n\":4,\"o\":{\".\":21,\"s\":21},\"u\":{\"l\":2,\"r\":19},\"y\":32},\"h\":[{\"e\":{\"r\":17}},72],\"i\":[{\"c\":19,\"d\":4,\"g\":[{\"l\":4},8],\"m\":{\"b\":23},\"n\":{\"f\":23,\"g\":29,\"s\":{\"t\":19}},\"r\":{\"d\":0},\"t\":{\"e\":11,\"h\":3,\"y\":19}},9],\"j\":[{\"u\":{\"d\":[{\"i\":4},21]}},29],\"k\":{\"i\":{\"n\":0},\"l\":{\"a\":1}},\"l\":{\"a\":[{\".\":21,\"c\":21,\"n\":{\"d\":17},\"t\":{\"i\":{\"v\":4}},\"w\":21,\"x\":{\"a\":36}},29],\"e\":{\"a\":23,\"b\":{\"r\":{\"a\":4}},\"c\":32,\"d\":21,\"g\":{\"a\":3},\"n\":19,\"r\":34,\"s\":29},\"f\":9,\"i\":[{\"b\":{\"e\":23},\"c\":{\".\":33,\"a\":3},\"e\":{\"r\":23},\"g\":{\"i\":{\"b\":4}},\"m\":19,\"n\":{\"g\":83},\"o\":23,\"s\":[{\"h\":4},24],\"v\":88,\"t\":{\"i\":{\"s\":208}}},9],\"l\":{\"a\":[{\"b\":1},18],\"o\":17},\"o\":{\"c\":19,\"g\":4,\"p\":{\".\":3},\"a\":29},\"s\":{\"h\":9},\"t\":{\"a\":1},\"u\":{\"d\":19,\"g\":4}},\"m\":{\"a\":{\"c\":21,\"g\":21,\"n\":[{\"a\":4},19]},\"b\":4,\"e\":[{\"l\":24,\"t\":21},29],\"i\":{\"c\":{\"a\":3},\"e\":0,\"g\":{\"r\":{\"a\":4}},\"n\":[{\"e\":4,\"i\":35},89],\"s\":[{\"h\":4,\"s\":19},21],\"z\":3},\"n\":{\"i\":{\"z\":32}},\"o\":{\"g\":0,\"n\":{\"i\":{\"o\":7}}},\"p\":{\"i\":3},\"u\":{\"l\":[{\"a\":4},21],\"n\":11},\"y\":23},\"n\":{\"a\":{\"m\":{\"o\":4},\"n\":{\"t\":21}},\"c\":{\"h\":{\"e\":{\"r\":17}}},\"d\":{\"i\":{\"c\":3,\"x\":2}},\"e\":{\"a\":19,\"e\":19,\"m\":3,\"r\":{\"o\":4},\"s\":{\"i\":4,\"t\":4},\"t\":{\"r\":3},\"w\":23},\"i\":{\"c\":{\"s\":4},\"e\":19,\"l\":19,\"o\":23,\"s\":{\"h\":3},\"t\":3,\"u\":19,\"z\":32},\"n\":18,\"o\":[{\"g\":0,\"s\":21,\"v\":3},18],\"s\":{\"w\":1},\"t\":{\"a\":{\"g\":{\"e\":5}},\"h\":{\"e\":{\"s\":18}}},\"u\":{\"a\":3,\"f\":4},\"y\":{\".\":23},\"z\":61},\"o\":{\"f\":19,\"g\":[{\"r\":{\"a\":{\"p\":3}}},9],\"i\":90,\"l\":23,\"p\":{\"a\":{\"r\":11}},\"r\":[{\"e\":3,\"o\":{\"l\":4}},29],\"s\":0,\"t\":[{\"o\":1},21],\"u\":{\"t\":19},\"w\":19},\"p\":{\"a\":[{\"i\":23,\"n\":{\"c\":4}},24],\"e\":{\"l\":19,\"n\":{\"t\":23},\"t\":{\"i\":{\"t\":{\"i\":{\"o\":4}}}}},\"h\":{\"e\":17},\"l\":{\"i\":21},\"o\":29,\"r\":{\"e\":{\"c\":[{\"a\":4},21],\"d\":21,\"h\":3},\"o\":[{\"b\":21},23]},\"s\":{\"h\":1},\"t\":{\"i\":{\"b\":13}},\"u\":{\"t\":[{\"a\":4},21]},\"i\":{\"n\":{\"e\":{\"p\":{\"h\":209}}}}},\"q\":[{\"u\":{\"i\":{\"l\":12,\"s\":91}}},29],\"r\":{\"a\":[{\"b\":0,\"n\":{\"d\":18},\"r\":3,\"t\":{\"i\":{\".\":18}}},2],\"b\":[{\"l\":1},25],\"c\":{\"h\":[{\"e\":1},3]},\"e\":{\".\":25,\"a\":{\"l\":23},\"c\":{\"o\":5},\"i\":{\"n\":11},\"l\":{\".\":4},\"m\":{\"o\":3},\"n\":{\"a\":4,\"c\":{\"e\":4},\"e\":18,\"t\":3},\"q\":0,\"s\":{\"s\":4,\"t\":3},\"t\":17},\"h\":2,\"i\":[{\"a\":[{\"n\":{\".\":210}},92],\"c\":{\"k\":32},\"e\":{\"n\":23,\"r\":0},\"n\":{\"e\":3},\"o\":29,\"t\":18,\"u\":1,\"v\":[{\"a\":21},0]},2],\"m\":93,\"n\":{\"i\":{\"s\":1,\"t\":18,\"z\":32},\"o\":3},\"o\":[{\"b\":4,\"c\":19,\"r\":0,\"u\":2},25],\"s\":[{\"e\":{\"t\":3}},2],\"t\":{\"e\":{\"r\":11},\"l\":18,\"w\":3},\"u\":[{\"t\":0},18],\"w\":{\"a\":{\"u\":32}}},\"s\":{\"a\":[{\"g\":{\"e\":{\".\":21,\"s\":21}}},72],\"c\":[{\"a\":[{\"n\":4},24],\"r\":23,\"u\":4},9],\"e\":[{\"c\":[{\"r\":4},24],\"n\":{\"c\":4},\"r\":{\"t\":{\".\":21,\"s\":21},\"v\":{\"a\":21}}},74],\"h\":[{\"a\":23,\"e\":{\"n\":5}},18],\"i\":[{\"c\":24,\"d\":[{\"e\":{\"n\":4}},24],\"g\":{\"n\":{\"a\":4}},\"m\":94,\"n\":95,\"s\":{\"t\":{\"e\":17}},\"u\":0},29],\"k\":{\"i\":{\"n\":19}},\"m\":{\"i\":1},\"o\":{\"l\":[{\"u\":3},24],\"n\":[{\"a\":4},24]},\"p\":[{\"e\":{\"r\":3},\"i\":{\"r\":{\"a\":4}},\"r\":{\"e\":1},\"a\":{\"c\":{\"i\":211}}},29],\"s\":[{\"i\":{\"b\":96}},25],\"t\":{\"a\":{\"n\":36},\"i\":{\"g\":3,\"m\":4},\"o\":[{\"n\":23},44],\"r\":[{\"o\":19,\"u\":{\"c\":10}},25]},\"u\":{\"r\":[{\"r\":4},24]},\"w\":1},\"t\":{\"a\":{\"b\":0},\"e\":{\"n\":{\"d\":17},\"o\":23},\"h\":{\"o\":{\"d\":54},\"y\":{\"l\":{\"e\":{\"n\":{\"e\":162}}}}},\"i\":{\"c\":2,\"d\":{\"e\":19},\"n\":[{\"o\":0},17],\"r\":19,\"t\":{\"i\":{\"o\":19,\"v\":4}}},\"n\":18,\"o\":{\"n\":{\"a\":4}},\"r\":{\"a\":23,\"e\":23,\"i\":{\"c\":3,\"f\":4},\"o\":{\"g\":3,\"s\":4}},\"u\":{\"a\":3},\"y\":{\"m\":4},\"z\":4},\"u\":[{\"n\":19,\"p\":23,\"r\":{\"o\":3},\"s\":0,\"t\":{\"e\":17,\"i\":{\"l\":6},\"r\":4},\"c\":{\"l\":{\"i\":{\"d\":212}}}},18],\"v\":{\"a\":{\"p\":97,\"s\":[{\"t\":4},24]},\"e\":{\"a\":19,\"l\":{\"l\":3,\"o\":12},\"n\":{\"g\":19,\"i\":17},\"r\":[{\"b\":19},2]},\"i\":[{\"d\":3,\"l\":0,\"n\":21,\"v\":0},29],\"o\":{\"c\":19},\"u\":19},\"w\":{\"a\":[{\"g\":21},29],\"e\":{\"e\":19},\"h\":23,\"i\":{\"l\":6,\"n\":{\"g\":3},\"t\":23}},\"x\":{\"p\":41},\"y\":{\"c\":32,\"e\":{\".\":32},\"s\":0}},\"f\":{\"a\":[{\"b\":{\"l\":3,\"r\":11},\"c\":{\"e\":1},\"g\":18,\"i\":{\"n\":17},\"l\":{\"l\":{\"e\":6}},\"m\":{\"a\":26,\"i\":{\"s\":5}},\"r\":[{\"t\":{\"h\":5}},32],\"t\":{\"a\":3,\"h\":{\"e\":3},\"o\":18},\"u\":{\"l\":{\"t\":7}}},41],\"b\":56,\"d\":18,\"e\":{\".\":18,\"a\":{\"s\":17,\"t\":{\"h\":54}},\"b\":[{\"r\":{\"u\":{\"a\":15}}},1],\"c\":{\"a\":18,\"t\":32},\"d\":25,\"l\":{\"i\":3},\"m\":{\"o\":1},\"n\":{\"d\":[{\"e\":6},8]},\"r\":[{\"r\":32,\"m\":{\"i\":{\"o\":213}}},15],\"v\":0},\"f\":[{\"e\":{\"s\":21},\"i\":{\"e\":21,\"n\":{\".\":19},\"s\":94},\"l\":{\"y\":21},\"y\":24},43],\"h\":18,\"i\":[{\"a\":3,\"c\":{\".\":48,\"a\":{\"l\":47,\"n\":23,\"t\":{\"e\":18}},\"e\":{\"n\":23,\"r\":3},\"i\":[{\"a\":32,\"e\":32},0],\"s\":18,\"u\":3,\"h\":27},\"d\":{\"e\":{\"l\":4}},\"g\":{\"h\":{\"t\":7}},\"l\":{\"i\":5,\"l\":{\"i\":{\"n\":6}},\"y\":18},\"n\":[{\"a\":32,\"d\":97,\"e\":9,\"g\":98,\"n\":0},25],\"s\":{\"t\":{\"i\":0}},\"t\":{\"t\":{\"e\":{\"d\":{\".\":5}}}}},41],\"l\":[{\"e\":{\"s\":{\"s\":19}},\"i\":{\"n\":17},\"o\":{\"r\":{\"e\":11},\"w\":{\"e\":{\"r\":{\".\":84}}}},\"y\":100,\"a\":{\"g\":{\"e\":{\"l\":214}}},\"u\":{\"o\":{\"r\":27}}},99],\"m\":18,\"n\":18,\"o\":[{\"n\":[{\"d\":{\"e\":0},\"t\":0},32],\"r\":[{\"a\":{\"t\":4,\"y\":5},\"e\":{\"t\":6},\"i\":0,\"t\":{\"a\":6}},9],\"s\":5},41],\"p\":56,\"r\":{\"a\":{\"t\":0},\"e\":{\"a\":19,\"s\":{\"c\":6}},\"i\":[{\"l\":17},8],\"o\":{\"l\":6}},\"s\":48,\"t\":[{\"o\":21,\"y\":24},25],\"u\":[{\"e\":{\"l\":4},\"g\":18,\"m\":{\"i\":{\"n\":1}},\"n\":{\"e\":4},\"r\":{\"i\":3},\"s\":{\"i\":17,\"s\":0},\"t\":{\"a\":18}},27],\"y\":41},\"g\":{\"a\":[{\"f\":0,\"l\":{\".\":32,\"i\":27,\"o\":3},\"m\":[{\"e\":{\"t\":4},\"o\":19},25],\"n\":{\"i\":{\"s\":5,\"z\":[{\"a\":6},3]},\"o\":18},\"r\":{\"n\":67},\"s\":{\"s\":17},\"t\":{\"h\":12,\"i\":{\"v\":18}},\"z\":18},41],\"b\":23,\"d\":1,\"e\":{\".\":25,\"d\":25,\"e\":{\"z\":17},\"l\":{\"i\":{\"n\":0,\"s\":4,\"z\":4},\"y\":18},\"n\":[{\"a\":{\"t\":1},\"i\":{\"z\":4},\"o\":18,\"y\":18,\"c\":{\"y\":{\".\":8}}},41],\"o\":[{\"m\":3,\"d\":215},41],\"r\":{\"y\":21},\"s\":{\"i\":32},\"t\":{\"h\":6,\"o\":18,\"y\":1,\"i\":{\"c\":{\".\":8}}},\"v\":1},\"g\":[{\"e\":[{\"r\":23},24],\"l\":{\"u\":6},\"o\":0},101],\"h\":{\"i\":{\"n\":3},\"o\":{\"u\":{\"t\":4}},\"t\":{\"o\":1,\"w\":{\"e\":15}}},\"i\":{\".\":32,\"a\":[{\"r\":5},102],\"c\":[{\"i\":{\"a\":32},\"o\":21},29],\"e\":{\"n\":6,\"s\":{\".\":32}},\"l\":0,\"m\":{\"e\":{\"n\":23}},\"n\":{\".\":68,\"g\":{\"e\":5},\"s\":103},\"o\":32,\"r\":[{\"l\":0},27],\"s\":{\"l\":23},\"u\":1,\"v\":32,\"z\":27},\"l\":[{\"a\":[{\"d\":{\"i\":6},\"s\":32},0],\"e\":[{\"a\":{\"d\":29}},41],\"i\":{\"b\":0,\"g\":23,\"s\":{\"h\":43}},\"o\":[{\"r\":11,\"b\":{\"i\":{\"n\":106}}},27]},9],\"m\":[{\"y\":21},29],\"n\":{\"a\":[{\".\":21,\"c\":69},1],\"e\":{\"t\":{\"t\":17,\"i\":{\"s\":{\"m\":137}}}},\"i\":[{\"n\":24,\"o\":21},29],\"o\":[{\"n\":21,\"m\":{\"o\":5},\"r\":{\".\":216,\"e\":{\"s\":{\"p\":24}}}},29]},\"o\":[{\".\":27,\"b\":5,\"e\":32,\"g\":104,\"i\":{\"s\":3},\"n\":[{\"a\":105,\"d\":{\"o\":7},\"i\":[{\"z\":{\"a\":217}},3]},8],\"o\":32,\"r\":{\"i\":{\"z\":4},\"o\":{\"u\":5}},\"s\":{\".\":32},\"v\":15},41],\"p\":23,\"r\":[{\"a\":{\"d\":{\"a\":18},\"i\":21,\"n\":84,\"p\":{\"h\":{\".\":32,\"e\":{\"r\":[{\".\":7},19]},\"i\":{\"c\":32},\"y\":18}},\"y\":18},\"e\":{\"n\":0,\"s\":{\"s\":{\".\":18}}},\"i\":{\"t\":18,\"e\":{\"v\":213}},\"o\":21,\"u\":{\"f\":17}},41],\"s\":[{\"t\":{\"e\":19}},9],\"t\":{\"h\":11},\"u\":{\"a\":[{\"r\":{\"d\":27}},1],\"e\":25,\"i\":{\"t\":106},\"n\":27,\"s\":27,\"t\":[{\"a\":{\"n\":29}},26]},\"w\":23,\"y\":[{\"n\":107,\"r\":{\"a\":4}},41]},\"h\":{\"a\":{\"b\":{\"l\":73},\"c\":{\"h\":17},\"e\":{\"m\":0,\"t\":0},\"g\":{\"u\":19},\"l\":{\"a\":[{\"m\":12},3]},\"m\":1,\"n\":{\"c\":{\"i\":0,\"y\":0},\"d\":{\".\":32},\"g\":[{\"e\":{\"r\":6},\"o\":6},0],\"i\":{\"z\":108},\"k\":0,\"t\":{\"e\":0}},\"p\":{\"l\":11,\"t\":5,\"a\":{\"r\":{\"r\":218}}},\"r\":{\"a\":{\"n\":3,\"s\":4},\"d\":[{\"e\":12},8],\"l\":{\"e\":0},\"p\":{\"e\":{\"n\":6}},\"t\":{\"e\":{\"r\":5}}},\"s\":{\"s\":5},\"u\":{\"n\":17},\"z\":[{\"a\":11},32],\"i\":{\"r\":{\"s\":137}},\"t\":{\"c\":{\"h\":213}}},\"b\":29,\"e\":{\"a\":{\"d\":41,\"r\":27},\"c\":{\"a\":{\"n\":1,\"t\":19}},\"d\":[{\"o\":13},21],\"l\":{\"i\":93,\"l\":{\"i\":{\"s\":0},\"y\":0},\"o\":19},\"m\":{\"p\":0},\"n\":[{\"a\":[{\"t\":5},17]},9],\"o\":{\"r\":5},\"p\":5,\"r\":{\"a\":[{\"p\":12},21],\"b\":{\"a\":0},\"e\":{\"a\":6},\"n\":23,\"o\":{\"u\":19},\"y\":23},\"s\":[{\"p\":64},29],\"t\":[{\"e\":{\"d\":0}},1],\"u\":0,\"x\":{\"a\":168}},\"f\":29,\"h\":29,\"i\":{\"a\":{\"n\":4},\"c\":{\"o\":1},\"g\":{\"h\":6},\"l\":109,\"m\":{\"e\":{\"r\":36}},\"n\":{\"a\":21},\"o\":{\"n\":{\"e\":17}},\"p\":[{\"e\":{\"l\":{\"a\":219}}},1],\"r\":{\"l\":0,\"o\":3,\"p\":0,\"r\":0},\"s\":{\"e\":{\"l\":11},\"s\":0},\"t\":{\"h\":{\"e\":{\"r\":6}},\"e\":{\"s\":{\"i\":{\"d\":12}}}},\"v\":9},\"k\":18,\"l\":[{\"a\":{\"n\":17},\"o\":[{\"r\":{\"i\":11}},24]},80],\"m\":[{\"e\":{\"t\":17}},43],\"n\":[{\"a\":{\"u\":{\"z\":12}}},42],\"o\":{\"d\":{\"i\":{\"z\":19},\"s\":19},\"g\":[{\"e\":17},1],\"l\":{\"a\":{\"r\":5},\"e\":110},\"m\":{\"a\":1,\"e\":12},\"n\":{\"a\":0,\"y\":4},\"o\":{\"d\":27,\"n\":17},\"r\":{\"a\":{\"t\":5},\"i\":{\"s\":4,\"c\":{\".\":187}},\"t\":{\"e\":12},\"u\":4},\"s\":{\"e\":[{\"n\":4},0],\"p\":15},\"u\":{\"s\":[{\"e\":54},41]},\"v\":{\"e\":{\"l\":5}}},\"p\":56,\"r\":[{\"e\":{\"e\":6},\"o\":{\"n\":{\"i\":{\"z\":5}},\"p\":{\"o\":11}}},26],\"s\":[{\"h\":21},101],\"t\":{\"a\":{\"r\":21},\"e\":{\"n\":2,\"s\":4,\"o\":{\"u\":216}},\"y\":21},\"u\":{\"g\":1,\"m\":{\"i\":{\"n\":1}},\"n\":{\"k\":{\"e\":5},\"t\":0},\"s\":{\"t\":14},\"t\":1},\"w\":[{\"a\":{\"r\":{\"t\":21}}},29],\"y\":{\"p\":{\"e\":3,\"h\":3,\"o\":{\"t\":{\"h\":{\"a\":137}}}},\"s\":9}},\"i\":{\"a\":[{\"l\":24,\"m\":[{\"e\":{\"t\":{\"e\":5}}},0],\"n\":[{\"c\":18,\"i\":11,\"t\":46},24],\"p\":{\"e\":4},\"s\":{\"s\":17},\"t\":{\"i\":{\"v\":21},\"r\":{\"i\":{\"c\":1}},\"u\":21}},42],\"b\":{\"e\":[{\"r\":{\"a\":3,\"t\":4}},0],\"i\":{\"a\":4,\"n\":3,\"t\":{\".\":4,\"e\":4}},\"l\":[{\"i\":3},29],\"o\":19,\"r\":[{\"i\":94},29],\"u\":{\"n\":19}},\"c\":{\"a\":{\"m\":18,\"p\":32,\"r\":[{\".\":21,\"a\":21},18],\"s\":6,\"y\":21},\"c\":{\"u\":17},\"e\":{\"o\":18},\"h\":18,\"i\":[{\"d\":19,\"n\":{\"a\":4},\"p\":[{\"a\":3},24]},25],\"l\":{\"y\":21},\"o\":{\"c\":94},\"r\":[{\"a\":32,\"y\":21},43],\"t\":{\"e\":1,\"u\":[{\"a\":111},84]},\"u\":{\"l\":{\"a\":3},\"m\":1,\"o\":4,\"r\":23}},\"d\":[{\"a\":{\"i\":21,\"n\":{\"c\":4}},\"d\":4,\"e\":{\"a\":{\"l\":11},\"s\":0},\"i\":[{\"a\":{\"n\":4,\"r\":0},\"e\":19,\"o\":[{\"u\":5,\"s\":1},3],\"t\":2,\"u\":4},24],\"l\":{\"e\":23},\"o\":{\"m\":21,\"w\":3},\"r\":21,\"u\":[{\"o\":4},24]},25],\"e\":[{\"d\":{\"e\":0},\"g\":{\"a\":113},\"l\":{\"d\":12},\"n\":{\"a\":67,\"e\":0,\"n\":19,\"t\":{\"i\":23}},\"r\":{\".\":29},\"s\":{\"c\":23,\"t\":29},\"t\":23},112],\"f\":{\".\":18,\"e\":{\"r\":{\"o\":4}},\"f\":{\"e\":{\"n\":5},\"r\":1},\"i\":{\"c\":{\".\":18},\"e\":23},\"l\":23,\"t\":18,\"a\":{\"c\":{\"e\":{\"t\":137}}}},\"g\":[{\"a\":{\"b\":5},\"e\":{\"r\":{\"a\":3}},\"h\":{\"t\":{\"i\":12}},\"i\":[{\"b\":23,\"l\":3,\"n\":3,\"t\":3},18],\"l\":28,\"o\":[{\"r\":3,\"t\":4},24],\"r\":{\"e\":19},\"u\":{\"i\":5,\"r\":2},\"n\":{\"i\":{\"t\":[{\"e\":{\"r\":213}},0]}}},25],\"h\":23,\"i\":114,\"j\":[{\"k\":21},23],\"k\":18,\"l\":{\"a\":[{\"b\":93,\"d\":{\"e\":21},\"m\":94,\"r\":{\"a\":5}},29],\"e\":{\"g\":23,\"r\":2,\"v\":17},\"f\":4,\"i\":[{\"a\":3,\"b\":9,\"o\":3,\"s\":{\"t\":1},\"t\":25,\"z\":9},2],\"l\":{\"a\":{\"b\":5}},\"n\":18,\"o\":{\"q\":3},\"t\":{\"y\":1},\"u\":{\"r\":4},\"v\":3},\"m\":{\"a\":{\"g\":[{\"e\":3},21],\"r\":{\"y\":5}},\"e\":{\"n\":{\"t\":{\"a\":{\"r\":10}}},\"t\":18},\"i\":[{\"d\":{\"a\":4},\"l\":{\"e\":5},\"n\":{\"i\":19},\"t\":18},2],\"n\":{\"i\":1},\"o\":{\"n\":23},\"u\":[{\"l\":{\"a\":3}},24],\"p\":{\"e\":{\"d\":{\"a\":201}}}},\"n\":{\".\":25,\"a\":{\"u\":83,\"v\":18},\"c\":{\"e\":{\"l\":36,\"r\":3}},\"d\":[{\"l\":{\"i\":{\"n\":{\"g\":4}}}},18],\"e\":[{\"e\":23,\"r\":{\"a\":{\"r\":17}},\"s\":{\"s\":19}},25],\"g\":{\"a\":18,\"e\":[{\"n\":4},18],\"i\":18,\"l\":{\"i\":{\"n\":{\"g\":4}}},\"o\":18,\"u\":18},\"i\":[{\".\":19,\"a\":21,\"o\":3,\"s\":2,\"t\":{\"e\":{\".\":19,\"l\":{\"y\":{\".\":19}}},\"i\":{\"o\":32},\"y\":3}},25],\"k\":18,\"l\":18,\"n\":25,\"o\":[{\"c\":90,\"s\":0,\"t\":21},42],\"s\":[{\"e\":3,\"u\":{\"r\":{\"a\":7}}},25],\"t\":{\".\":25,\"h\":112},\"u\":[{\"s\":19},2],\"y\":18,\"f\":{\"r\":{\"a\":{\"s\":220}}}},\"o\":[{\".\":18,\"g\":{\"e\":17,\"r\":9},\"l\":29,\"m\":1,\"n\":{\"a\":{\"t\":11},\"e\":{\"r\":{\"y\":0}},\"i\":11},\"p\":{\"h\":4},\"r\":{\"i\":11},\"s\":21,\"t\":{\"h\":4,\"i\":19,\"o\":1},\"u\":{\"r\":21}},25],\"p\":[{\"e\":0,\"h\":{\"r\":{\"a\":{\"s\":115}}},\"i\":[{\"c\":1},3],\"r\":{\"e\":96},\"u\":{\"l\":3}},25],\"q\":{\"u\":{\"a\":23,\"e\":{\"f\":4},\"i\":{\"d\":3,\"t\":116}}},\"r\":[{\"a\":[{\"b\":0,\"c\":21},29],\"d\":{\"e\":5},\"e\":{\"d\":{\"e\":0},\"f\":21,\"l\":117,\"s\":21},\"g\":{\"i\":4},\"i\":[{\"d\":{\"e\":5},\"s\":1,\"t\":{\"u\":11},\"z\":118},2],\"m\":{\"i\":{\"n\":1}},\"o\":{\"g\":0,\"n\":{\".\":32}},\"u\":{\"l\":4},\"r\":{\"e\":{\"v\":{\"o\":{\"c\":221}}}}},18],\"s\":{\".\":25,\"a\":{\"g\":4,\"r\":3,\"s\":6},\"c\":[{\"h\":3},119],\"e\":[{\"r\":3},18],\"f\":27,\"h\":{\"a\":{\"n\":4},\"o\":{\"n\":3,\"p\":5}},\"i\":{\"b\":3,\"d\":0,\"s\":19,\"t\":{\"i\":{\"v\":4}}},\"k\":26,\"l\":{\"a\":{\"n\":36}},\"m\":{\"s\":18},\"o\":[{\"m\":{\"e\":{\"r\":5}}},24],\"p\":[{\"i\":9,\"y\":1},2],\"s\":[{\"a\":{\"l\":1},\"e\":{\"n\":36,\"s\":1}},62],\"t\":{\"a\":{\".\":1},\"e\":2,\"i\":2,\"l\":{\"y\":0},\"r\":{\"a\":{\"l\":18}}},\"u\":[{\"s\":4},24]},\"t\":{\"a\":{\".\":18,\"b\":{\"i\":0},\"g\":21,\"m\":120,\"n\":23,\"t\":23},\"e\":[{\"r\":{\"a\":3,\"i\":19},\"s\":[{\"i\":{\"m\":{\"a\":29}}},1]},25],\"h\":[{\"i\":{\"l\":148}},25],\"i\":[{\"a\":18,\"c\":[{\"a\":3,\"k\":31},22],\"g\":3,\"l\":{\"l\":4},\"m\":24,\"o\":25,\"s\":[{\"m\":21},18],\"n\":{\"e\":{\"r\":{\"a\":{\"r\":158}}}}},29],\"o\":{\"m\":121,\"n\":18},\"r\":{\"a\":{\"m\":21},\"y\":4},\"t\":18,\"u\":{\"a\":{\"t\":3},\"d\":19,\"l\":3},\"z\":{\".\":18}},\"u\":29,\"v\":[{\"e\":{\"l\":{\"l\":3},\"n\":{\".\":3},\"r\":{\".\":83,\"s\":{\".\":21}}},\"i\":{\"l\":{\".\":4},\"o\":4,\"t\":2},\"o\":{\"r\":{\"e\":19,\"o\":35},\"t\":83}},25],\"w\":56,\"x\":{\"o\":1},\"y\":18,\"z\":{\"a\":{\"r\":18},\"i\":0,\"o\":{\"n\":{\"t\":32}}}},\"j\":{\"a\":[{\"c\":{\"q\":0},\"p\":[{\"a\":{\"n\":{\"e\":{\"s\":220}}}},1],\"n\":{\"u\":{\"a\":12}}},32],\"e\":[{\"r\":{\"s\":5,\"e\":{\"m\":222}},\"s\":{\"t\":{\"i\":{\"e\":18},\"y\":18}},\"w\":11},41],\"o\":{\"p\":1},\"u\":{\"d\":{\"g\":32}}},\"k\":{\"a\":{\".\":27,\"b\":23,\"g\":19,\"i\":{\"s\":17},\"l\":0},\"b\":29,\"e\":{\"d\":24,\"e\":41,\"g\":1,\"l\":{\"i\":[{\"n\":{\"g\":223}},4]},\"n\":{\"d\":73},\"r\":29,\"s\":[{\"t\":{\".\":23}},0],\"t\":{\"y\":1}},\"f\":23,\"h\":1,\"i\":[{\".\":32,\"c\":122,\"l\":{\"l\":21,\"o\":6},\"m\":21,\"n\":{\".\":21,\"d\":{\"e\":0},\"e\":{\"s\":{\"s\":19},\"t\":{\"i\":{\"c\":224}}},\"g\":0},\"p\":1,\"s\":[{\"h\":19},0]},29],\"k\":1,\"l\":[{\"e\":{\"y\":18},\"y\":18},29],\"m\":29,\"n\":{\"e\":{\"s\":19},\"o\":69},\"o\":{\"r\":4,\"s\":{\"h\":17},\"u\":23,\"v\":{\"i\":{\"a\":{\"n\":41}}}},\"r\":{\"o\":{\"n\":5}},\"s\":[{\"c\":21,\"l\":1,\"y\":21,\"h\":{\"a\":23}},101],\"t\":19,\"w\":29},\"l\":{\"a\":{\"b\":{\"i\":{\"c\":11},\"o\":21},\"c\":{\"i\":[{\"e\":225},17]},\"d\":{\"e\":21,\"y\":3},\"g\":{\"n\":0},\"m\":{\"o\":11},\"n\":{\"d\":[{\"l\":0},27],\"e\":{\"t\":5},\"t\":{\"e\":0}},\"r\":{\"g\":0,\"i\":11,\"c\":{\"e\":{\"n\":176}}},\"s\":{\"e\":0},\"t\":{\"a\":{\"n\":4},\"e\":{\"l\":{\"i\":18}},\"i\":{\"v\":18}},\"v\":[{\"a\":95},18],\"i\":{\"n\":{\"e\":{\"s\":{\"s\":226}}}}},\"b\":[{\"i\":{\"n\":17}},42],\"c\":[{\"e\":0,\"i\":23,\"h\":{\"a\":{\"i\":23},\"i\":{\"l\":{\"d\":227}}}},101],\"d\":[{\"e\":[{\"r\":{\"e\":1,\"i\":1}},24],\"i\":[{\"s\":4},0],\"r\":[{\"i\":21},23]},25],\"e\":{\"a\":[{\"d\":{\"e\":{\"r\":{\".\":183}}},\"s\":{\"a\":228}},9],\"b\":{\"i\":1},\"f\":{\"t\":6},\"g\":{\".\":32,\"g\":32,\"e\":{\"n\":{\"d\":{\"r\":{\"e\":230}}}}},\"m\":{\"a\":{\"t\":[{\"i\":{\"c\":5}},1]}},\"n\":{\".\":18,\"c\":27,\"e\":{\".\":32},\"t\":41,\"o\":{\"i\":{\"d\":78}}},\"p\":{\"h\":3,\"r\":1},\"r\":{\"a\":{\"b\":6},\"e\":0,\"g\":27,\"i\":68,\"o\":21},\"s\":[{\"c\":{\"o\":4},\"q\":32,\"s\":[{\".\":32},27]},8],\"v\":{\"a\":23,\"e\":{\"r\":{\".\":0,\"a\":0,\"s\":0}}},\"y\":[{\"e\":18},27],\"c\":{\"t\":{\"a\":{\"b\":229}}}},\"f\":[{\"r\":19},25],\"g\":[{\"a\":[{\"r\":12},19],\"e\":{\"s\":21},\"o\":11},80],\"h\":48,\"i\":{\"a\":{\"g\":1,\"m\":9,\"r\":{\"i\":{\"z\":6}},\"s\":1,\"t\":{\"o\":1}},\"b\":{\"i\":4},\"c\":{\"i\":{\"o\":32},\"o\":{\"r\":1},\"s\":18,\"t\":{\".\":18},\"u\":21,\"y\":23},\"d\":{\"a\":23,\"e\":{\"r\":5},\"i\":27},\"f\":{\"e\":{\"r\":11},\"f\":21,\"l\":1},\"g\":{\"a\":{\"t\":{\"e\":32}},\"h\":27,\"r\":{\"a\":1}},\"k\":27,\"l\":123,\"m\":{\"b\":{\"l\":0},\"i\":11,\"o\":1,\"p\":90},\"n\":{\"a\":21,\"e\":[{\"a\":11},124],\"i\":11,\"k\":{\"e\":{\"r\":6}}},\"o\":{\"g\":4},\"q\":125,\"s\":{\"p\":0},\"t\":[{\".\":24,\"i\":{\"c\":{\"a\":32,\"s\":108}},\"h\":{\"o\":{\"g\":204}}},29],\"v\":{\"e\":{\"r\":11}},\"z\":29},\"j\":18,\"k\":{\"a\":[{\"l\":23,\"t\":0},11]},\"l\":[{\"a\":{\"w\":21},\"e\":[{\"a\":19,\"c\":23,\"g\":23,\"l\":23,\"n\":73,\"t\":73},24],\"i\":[{\"n\":[{\"a\":19},126],\"s\":{\"h\":231}},9],\"o\":[{\"q\":{\"u\":{\"i\":10}},\"u\":{\"t\":4},\"w\":19},1],\"f\":{\"l\":2}},29],\"m\":[{\"e\":{\"t\":19},\"i\":{\"n\":{\"g\":3}},\"o\":{\"d\":21,\"n\":[{\"e\":{\"l\":{\"l\":232}}},17]}},25],\"n\":81,\"o\":{\".\":27,\"b\":{\"a\":{\"l\":5},\"o\":{\"t\":{\"o\":233}}},\"c\":{\"i\":1},\"f\":18,\"g\":{\"i\":{\"c\":27},\"o\":19,\"u\":27,\"e\":{\"s\":{\".\":9}}},\"m\":{\"e\":{\"r\":11}},\"n\":{\"g\":32,\"i\":[{\"z\":127},0]},\"o\":{\"d\":6},\"p\":{\"e\":{\".\":32},\"i\":11,\"m\":23},\"r\":{\"a\":[{\"t\":{\"o\":1}},17],\"i\":{\"e\":4},\"o\":{\"u\":5}},\"s\":{\".\":32,\"e\":{\"t\":5},\"o\":{\"p\":{\"h\":{\"i\":{\"z\":32},\"y\":32}}},\"t\":0},\"t\":{\"a\":1},\"u\":{\"n\":{\"d\":6},\"t\":25},\"v\":18,\"a\":{\"d\":{\"e\":{\"d\":{\".\":17},\"r\":{\".\":183}}}}},\"p\":[{\"a\":{\"b\":5},\"h\":{\"a\":23,\"i\":19},\"i\":{\"n\":{\"g\":4},\"t\":23},\"l\":21,\"r\":19},25],\"r\":43,\"s\":[{\"c\":21,\"e\":24,\"i\":{\"e\":21}},81],\"t\":[{\"a\":{\"g\":4,\"n\":{\"e\":7}},\"e\":[{\"n\":17,\"r\":{\"a\":36},\"a\":23},29],\"h\":{\"i\":[{\"l\":{\"y\":148}},11]},\"i\":{\"e\":{\"s\":{\".\":19}},\"s\":17},\"r\":29,\"u\":[{\"r\":{\"a\":12}},8]},18],\"u\":{\"a\":4,\"b\":{\"r\":3},\"c\":{\"h\":17,\"i\":3},\"e\":{\"n\":3,\"p\":15},\"f\":0,\"i\":{\"d\":4},\"m\":{\"a\":1,\"i\":32,\"n\":{\".\":19,\"i\":{\"a\":32}},\"b\":{\"i\":{\"a\":{\".\":235}}}},\"o\":[{\"r\":11},3],\"p\":18,\"s\":{\"s\":17,\"t\":{\"e\":11}},\"t\":41,\"n\":{\"k\":{\"e\":{\"r\":234}}}},\"v\":{\"e\":{\"n\":19,\"t\":128}},\"w\":42,\"y\":[{\"a\":18,\"b\":18,\"m\":{\"e\":4},\"n\":{\"o\":3},\"s\":[{\"e\":19,\"t\":{\"y\":{\"r\":4}}},58],\"g\":{\"a\":{\"m\":{\"i\":236}}}},41]},\"m\":{\"a\":[{\"b\":25,\"c\":{\"a\":9,\"h\":{\"i\":{\"n\":{\"e\":4}}},\"l\":1},\"g\":{\"i\":{\"n\":5},\"n\":32},\"h\":25,\"i\":{\"d\":6},\"l\":{\"d\":18,\"i\":{\"g\":3,\"n\":4},\"l\":{\"i\":0},\"t\":{\"y\":0},\"a\":{\"p\":222}},\"n\":{\"i\":{\"a\":32,\"s\":5,\"z\":11},\".\":24,\"u\":{\"s\":{\"c\":237}}},\"p\":[{\"h\":{\"r\":{\"o\":244}}},18],\"r\":{\"i\":{\"n\":{\"e\":{\".\":4}},\"z\":4},\"l\":{\"y\":0},\"v\":11,\"g\":{\"i\":{\"n\":238}}},\"s\":{\"c\":{\"e\":4},\"e\":0,\"t\":15},\"t\":{\"e\":32,\"h\":12,\"i\":{\"s\":3,\"z\":{\"a\":18}}}},41],\"b\":[{\"a\":{\"t\":129},\"i\":{\"l\":19,\"n\":{\"g\":83},\"v\":0}},43],\"c\":56,\"e\":{\".\":18,\"d\":[{\".\":18,\"i\":{\"a\":32,\"e\":3,\"c\":[{\"i\":{\"n\":152}},84],\"o\":{\"c\":239}},\"y\":108},25],\"g\":[{\"r\":{\"a\":{\"n\":240}}},9],\"l\":{\"o\":{\"n\":5},\"t\":0},\"m\":[{\"o\":130},9],\"n\":[{\"a\":[{\"c\":5},0],\"d\":{\"e\":0},\"e\":18,\"i\":0,\"s\":[{\"u\":7},17],\"t\":[{\"e\":0},27],\".\":24},41],\"o\":{\"n\":4},\"r\":{\"s\":{\"a\":19}},\"s\":[{\"t\":{\"i\":27}},25],\"t\":{\"a\":[{\"l\":11},1],\"e\":2,\"h\":{\"i\":4},\"r\":[{\"i\":{\"c\":32,\"e\":4},\"y\":3},21]},\"v\":1},\"f\":43,\"h\":25,\"i\":{\".\":32,\"a\":3,\"d\":{\"a\":[{\"b\":241},0],\"g\":0},\"g\":0,\"l\":{\"i\":{\"a\":27,\"e\":108,\"t\":{\"a\":27}},\"l\":[{\"a\":{\"g\":208},\"i\":{\"l\":{\"i\":59}}},21]},\"n\":{\"a\":0,\"d\":27,\"e\":{\"e\":19},\"g\":{\"l\":[{\"i\":5,\"y\":19},21]},\"t\":0,\"u\":[{\"t\":{\"e\":{\"r\":242,\"s\":{\"t\":242}}}},21],\"i\":{\"s\":{\".\":174}}},\"o\":{\"t\":17},\"s\":[{\"e\":{\"r\":{\".\":0}},\"l\":5,\"t\":{\"i\":0,\"r\":{\"y\":19}}},24],\"t\":{\"h\":18},\"z\":24},\"k\":18,\"l\":43,\"m\":[{\"a\":{\"r\":{\"y\":5},\"b\":243}},29],\"n\":[{\"a\":1,\"i\":{\"n\":21},\"o\":1},43],\"o\":[{\"c\":{\"r\":[{\"a\":{\"t\":[{\"i\":{\"z\":32}},245]}},18]},\"d\":131,\"g\":{\"o\":1},\"i\":{\"s\":[{\"e\":5},84]},\"k\":18,\"l\":{\"e\":{\"s\":{\"t\":4},\"c\":246}},\"m\":{\"e\":3},\"n\":{\"e\":{\"t\":5,\"y\":{\"l\":247}},\"g\":{\"e\":5},\"i\":{\"a\":12,\"s\":{\"m\":0,\"t\":0},\"z\":3},\"o\":{\"l\":36,\"c\":{\"h\":12},\"e\":{\"n\":171},\"s\":249},\"y\":{\".\":3}},\"r\":[{\"a\":{\".\":18},\"o\":{\"n\":{\"i\":{\"s\":248}}}},9],\"s\":[{\"e\":{\"y\":4},\"p\":3},8],\"t\":{\"h\":[{\"e\":{\"t\":250}},12]},\"u\":{\"f\":19,\"s\":[{\"i\":{\"n\":98}},27]},\"v\":9,\"e\":{\"l\":{\"a\":{\"s\":167}}}},41],\"p\":[{\"a\":{\"r\":{\"a\":[{\"b\":5},7],\"i\":6}},\"e\":{\"t\":23},\"h\":{\"a\":{\"s\":36}},\"i\":[{\"a\":0,\"e\":{\"s\":4},\"n\":34,\"r\":19,\"s\":4},24],\"o\":{\"r\":{\"i\":11},\"s\":{\"i\":{\"t\":{\"e\":6}}},\"u\":{\"s\":21},\"v\":6},\"t\":{\"r\":1},\"y\":24},43],\"r\":47,\"s\":[{\"h\":[{\"a\":{\"c\":{\"k\":251}}},21],\"i\":19},101],\"t\":18,\"u\":[{\"l\":{\"a\":{\"r\":49},\"t\":[{\"i\":[{\"u\":252},54]},32]},\"m\":27,\"n\":8,\"p\":18,\"u\":1,\"d\":{\"r\":{\"o\":9}}},41],\"w\":18},\"n\":{\"a\":[{\"b\":[{\"u\":21},81],\"c\":{\".\":18,\"a\":1,\"t\":19},\"g\":{\"e\":{\"r\":{\".\":5}}},\"k\":0,\"l\":{\"i\":[{\"a\":4},1],\"t\":18},\"m\":{\"i\":{\"t\":4}},\"n\":[{\"c\":{\"i\":36},\"i\":{\"t\":0},\"k\":17},24],\"r\":{\"c\":[{\"h\":{\"s\":{\".\":73}}},11],\"e\":18,\"i\":11,\"l\":0,\"m\":19},\"s\":[{\"c\":0,\"t\":{\"i\":5}},21],\"t\":[{\"a\":{\"l\":3},\"o\":{\"m\":{\"i\":{\"z\":6}}}},24],\"u\":[{\"s\":{\"e\":11},\"t\":27},24],\"v\":{\"e\":0}},41],\"b\":80,\"c\":{\"a\":{\"r\":6},\"e\":{\"s\":{\".\":21}},\"h\":{\"a\":23,\"e\":{\"o\":19,\"s\":{\"t\":253}},\"i\":{\"l\":19,\"s\":23}},\"i\":{\"n\":2,\"t\":1},\"o\":{\"u\":{\"r\":{\"a\":7}}},\"r\":29,\"u\":29},\"d\":{\"a\":{\"i\":21,\"n\":19},\"e\":[{\"s\":{\"t\":{\".\":4}}},29],\"i\":{\"b\":0,\"f\":79,\"t\":29,\"z\":23,\"e\":{\"c\":{\"k\":29}}},\"u\":{\"c\":19,\"r\":0},\"w\":{\"e\":9},\"t\":{\"h\":{\"r\":3}}},\"e\":{\".\":25,\"a\":{\"r\":23},\"b\":[{\"u\":11,\"a\":{\"c\":{\"k\":3}}},9],\"c\":[{\"k\":32},9],\"d\":25,\"g\":{\"a\":{\"t\":[{\"i\":{\"v\":5}},1]},\"e\":32},\"l\":{\"a\":1,\"i\":{\"z\":5}},\"m\":{\"i\":4,\"o\":1},\"n\":[{\"e\":18},41],\"o\":27,\"p\":{\"o\":1},\"q\":9,\"r\":[{\"a\":{\"b\":6,\"r\":21},\"e\":24,\"i\":132,\"r\":0},29],\"s\":[{\".\":25,\"p\":18,\"t\":25,\"w\":18,\"k\":{\"i\":119}},41],\"t\":{\"i\":{\"c\":27}},\"v\":[{\"e\":19},1],\"w\":1},\"f\":[{\"i\":{\"n\":{\"i\":{\"t\":{\"e\":{\"s\":226}}}}}},23],\"g\":{\"a\":{\"b\":21},\"e\":{\"l\":23,\"n\":{\"e\":[{\"s\":5},133]},\"r\":{\"e\":19,\"i\":23}},\"h\":{\"a\":4,\"o\":2},\"i\":{\"b\":23,\"n\":2,\"t\":19},\"l\":{\"a\":21},\"o\":{\"v\":17},\"s\":{\"h\":4,\"p\":{\"r\":2}},\"u\":[{\"m\":21},29],\"y\":24},\"h\":[{\"a\":[{\"b\":12},0],\"e\":0},80],\"i\":{\"a\":[{\"n\":[{\".\":114},3],\"p\":1},68],\"b\":{\"a\":3,\"l\":1},\"d\":[{\"i\":4},1],\"e\":{\"r\":1},\"f\":{\"i\":[{\"c\":{\"a\":{\"t\":4}}},9]},\"g\":{\"r\":19},\"k\":0,\"m\":[{\"i\":{\"z\":3}},29],\"n\":[{\"e\":{\".\":32},\"g\":0},29],\"o\":1,\"s\":{\".\":32,\"t\":{\"a\":0}},\"t\":[{\"h\":21,\"i\":{\"o\":27},\"o\":{\"r\":23},\"r\":3},24]},\"j\":29,\"k\":[{\"e\":{\"r\":{\"o\":19},\"t\":23},\"i\":{\"n\":3},\"l\":29,\"r\":{\"u\":{\"p\":3}}},44],\"l\":[{\"e\":{\"s\":{\"s\":19}}},43],\"m\":[{\"e\":[{\"t\":17},0]},19],\"n\":[{\"e\":0,\"i\":{\"a\":{\"l\":11},\"v\":0}},101],\"o\":{\"b\":{\"l\":[{\"e\":3},0]},\"c\":{\"l\":19,\"e\":{\"r\":{\"o\":{\"s\":254}}}},\"d\":66,\"e\":27,\"g\":[{\"e\":17},18],\"i\":{\"s\":{\"i\":6}},\"l\":{\"i\":134,\"o\":{\"g\":{\"i\":{\"s\":32}}}},\"m\":{\"i\":{\"c\":27,\"z\":108,\"s\":{\"t\":82}},\"o\":1,\"y\":3,\"a\":{\"l\":214},\"e\":{\"n\":{\"o\":194}}},\"n\":[{\"a\":{\"g\":0},\"i\":[{\"z\":19,\"s\":{\"o\":255}},5],\"e\":{\"q\":15}},1],\"p\":[{\"o\":{\"l\":{\"i\":135,\"y\":{\".\":256}}}},18],\"r\":{\"a\":{\"b\":5,\"r\":{\"y\":1}}},\"s\":{\"c\":18,\"e\":0,\"t\":5},\"t\":{\"a\":4},\"u\":[{\"n\":27},41],\"v\":{\"e\":{\"l\":136,\"m\":{\"b\":2}}},\"w\":{\"l\":12}},\"p\":[{\"i\":0,\"r\":{\"e\":{\"c\":17}}},72],\"q\":29,\"r\":[{\"u\":0},29],\"s\":[{\"a\":{\"b\":4,\"t\":{\"i\":36}},\"c\":[{\"e\":{\"i\":{\"v\":4}}},1],\"e\":[{\"s\":83},24],\"i\":{\"d\":137,\"g\":17},\"l\":24,\"m\":[{\"o\":{\"o\":1}},3],\"o\":{\"c\":21},\"p\":{\"e\":1,\"i\":19},\"t\":{\"a\":{\"b\":{\"l\":6}}}},81],\"t\":[{\"a\":{\"b\":0},\"e\":{\"r\":{\"s\":12}},\"i\":[{\"b\":19,\"e\":{\"r\":0},\"f\":8,\"n\":{\"e\":23,\"g\":83},\"p\":0},9],\"r\":{\"o\":{\"l\":{\"l\":{\"i\":7}}},\"e\":{\"p\":137}},\"s\":1,\"u\":{\"m\":{\"e\":11}}},29],\"u\":{\"a\":2,\"d\":1,\"e\":{\"n\":4},\"f\":{\"f\":{\"e\":0}},\"i\":{\"n\":23,\"t\":50},\"m\":[{\"e\":2,\"i\":19},21],\"n\":138,\"o\":23,\"t\":{\"r\":3}},\"v\":74,\"w\":72,\"y\":{\"m\":0,\"p\":0},\"z\":[{\"a\":23},18]},\"o\":{\"a\":[{\"d\":11,\"l\":{\"e\":{\"s\":108}},\"r\":{\"d\":12},\"s\":{\"e\":0,\"t\":{\"e\":6}},\"t\":{\"i\":5}},18],\"b\":{\"a\":{\"b\":35,\"r\":19},\"e\":{\"l\":0},\"i\":[{\"n\":[{\"g\":4},24]},29],\"r\":23,\"u\":{\"l\":3},\"l\":{\"i\":{\"g\":189}}},\"c\":{\"e\":29,\"h\":[{\"e\":{\"t\":23},\"a\":{\"s\":23}},0],\"i\":{\"f\":12,\"l\":21},\"l\":{\"a\":{\"m\":21}},\"o\":{\"d\":21},\"r\":{\"a\":{\"c\":3,\"t\":{\"i\":{\"z\":4}}},\"e\":12,\"i\":{\"t\":32}},\"t\":{\"o\":{\"r\":{\"a\":7}}},\"u\":{\"l\":{\"a\":3},\"r\":{\"e\":19}}},\"d\":{\"d\":{\"e\":{\"d\":4}},\"i\":{\"c\":3,\"o\":11,\"t\":{\"i\":{\"c\":137}}},\"o\":[{\"r\":12},139],\"u\":{\"c\":{\"t\":{\".\":4,\"s\":4}}},\"e\":{\"l\":{\"l\":{\"i\":12}}}},\"e\":{\"l\":21,\"n\":{\"g\":19},\"r\":[{\"s\":{\"t\":257}},23],\"t\":{\"a\":1},\"v\":23},\"f\":{\"i\":[{\"t\":{\"e\":4,\"t\":17}},24]},\"g\":{\"a\":{\"r\":121,\"t\":{\"i\":{\"v\":4},\"o\":21}},\"e\":[{\"n\":{\"e\":19},\"o\":19,\"r\":21},29],\"i\":{\"e\":23,\"s\":140,\"t\":3},\"l\":[{\"y\":79},21],\"n\":{\"i\":{\"z\":27}},\"r\":{\"o\":21},\"u\":{\"i\":5},\"y\":[{\"n\":25},41]},\"h\":[{\"a\":{\"b\":6}},74],\"i\":[{\"c\":{\"e\":{\"s\":11}},\"d\":{\"e\":{\"r\":3}},\"f\":{\"f\":17},\"g\":0,\"l\":{\"e\":{\"t\":4}},\"n\":{\"g\":23,\"t\":{\"e\":{\"r\":6}}},\"s\":{\"m\":19,\"o\":{\"n\":4},\"t\":{\"e\":{\"n\":6}}},\"t\":{\"e\":{\"r\":3}}},9],\"j\":19,\"k\":[{\"e\":{\"n\":23,\"s\":{\"t\":15}},\"i\":{\"e\":4}},25],\"l\":{\"a\":[{\"n\":21,\"s\":{\"s\":36}},29],\"d\":[{\"e\":15},9],\"e\":{\"r\":3,\"s\":{\"c\":23,\"t\":{\"e\":{\"r\":88}}},\"t\":23},\"f\":{\"i\":1},\"i\":[{\"a\":23,\"c\":{\"e\":23},\"d\":{\".\":4},\"f\":73,\"l\":19,\"n\":{\"g\":3},\"o\":19,\"s\":{\".\":19,\"h\":3},\"t\":{\"e\":19,\"i\":{\"o\":19}},\"v\":19,\"g\":{\"o\":{\"p\":{\"o\":258}}}},9],\"l\":{\"i\":{\"e\":17}},\"o\":{\"g\":{\"i\":{\"z\":4}},\"r\":0,\"n\":{\"o\":{\"m\":259}}},\"p\":{\"l\":4},\"t\":9,\"u\":{\"b\":3,\"m\":{\"e\":3},\"n\":3,\"s\":19},\"v\":9,\"y\":24},\"m\":{\"a\":{\"h\":4,\"l\":5,\"t\":{\"i\":{\"z\":4}}},\"b\":{\"e\":9,\"l\":1},\"e\":[{\"n\":{\"a\":3},\"r\":{\"s\":{\"e\":4}},\"t\":[{\"r\":{\"y\":4}},21],\"c\":{\"h\":{\"a\":260}}},24],\"i\":{\"a\":23,\"c\":{\".\":3,\"a\":3},\"d\":19,\"n\":[{\"i\":19},2]},\"m\":{\"e\":{\"n\":{\"d\":32}}},\"o\":{\"g\":{\"e\":0},\"n\":21},\"p\":{\"i\":3,\"r\":{\"o\":7}}},\"n\":[{\"a\":[{\"c\":1,\"n\":23},2],\"c\":[{\"i\":{\"l\":27}},2],\"d\":[{\"o\":4},25],\"e\":{\"n\":23,\"s\":{\"t\":4}},\"g\":{\"u\":1},\"i\":{\"c\":2,\"o\":23,\"s\":2,\"u\":19},\"k\":{\"e\":{\"y\":3}},\"o\":{\"d\":{\"i\":1},\"m\":{\"y\":3,\"i\":{\"c\":137}},\"r\":{\"m\":{\"a\":23}},\"t\":{\"o\":{\"n\":261}},\"u\":23},\"s\":[{\"p\":{\"i\":[{\"r\":{\"a\":10}},36]},\"u\":17},3],\"t\":{\"e\":{\"n\":36},\"i\":[{\"f\":7},93]},\"u\":{\"m\":4},\"v\":{\"a\":6}},24],\"o\":[{\"d\":{\"e\":5,\"i\":5},\"k\":1,\"p\":{\"i\":11},\"r\":{\"d\":23},\"s\":{\"t\":6}},9],\"p\":{\"a\":24,\"e\":{\"d\":5,\"r\":[{\"a\":[{\"g\":18},27]},2]},\"h\":[{\"a\":{\"n\":19},\"e\":{\"r\":19}},25],\"i\":{\"n\":{\"g\":3},\"t\":23,\"s\":{\"m\":{\".\":2}}},\"o\":{\"n\":19,\"s\":{\"i\":21}},\"r\":29,\"u\":2,\"y\":5},\"q\":29,\"r\":{\"a\":[{\".\":19,\"g\":83,\"l\":{\"i\":{\"z\":4}},\"n\":{\"g\":{\"e\":4}}},29],\"e\":{\"a\":[{\"l\":19},5],\"i\":3,\"s\":{\"h\":5,\"t\":{\".\":4}},\"w\":17},\"g\":{\"u\":1},\"i\":{\"a\":56,\"c\":{\"a\":3},\"l\":19,\"n\":2,\"o\":29,\"t\":{\"y\":3},\"u\":23},\"m\":{\"i\":9},\"n\":{\"e\":8},\"o\":{\"f\":19,\"u\":{\"g\":3}},\"p\":{\"e\":4},\"r\":{\"h\":27},\"s\":{\"e\":[{\"n\":5},1],\"t\":17},\"t\":{\"h\":{\"i\":3,\"y\":3,\"o\":{\"n\":{\"i\":{\"t\":262}}},\"r\":{\"i\":137}},\"y\":1,\"i\":{\"v\":{\"e\":{\"l\":{\"y\":4}}}}},\"u\":{\"m\":19},\"y\":29},\"s\":{\"a\":{\"l\":3},\"c\":[{\"e\":1,\"o\":{\"p\":[{\"i\":18},23]},\"r\":19},9],\"i\":{\"e\":95,\"t\":{\"i\":{\"v\":4},\"o\":3,\"y\":3},\"u\":0},\"l\":1,\"o\":24,\"p\":{\"a\":1,\"o\":1,\"h\":{\"e\":{\"r\":83}}},\"t\":{\"a\":[{\"t\":{\"i\":19}},9],\"i\":{\"l\":4,\"t\":4}}},\"t\":{\"a\":{\"n\":21},\"e\":{\"l\":{\"e\":{\"g\":36}},\"r\":{\".\":3,\"s\":4},\"s\":[{\"t\":{\"e\":{\"r\":263},\"o\":{\"r\":264}}},21]},\"h\":[{\"e\":{\"s\":{\"i\":5},\"o\":{\"s\":265}},\"i\":14},18],\"i\":{\"c\":{\".\":3,\"a\":4,\"e\":23},\"f\":23,\"s\":23},\"o\":{\"s\":5}},\"u\":[{\"b\":{\"l\":3,\"a\":{\"d\":{\"o\":116}}},\"c\":{\"h\":{\"i\":6}},\"e\":{\"t\":4},\"l\":1,\"n\":{\"c\":{\"e\":{\"r\":6}},\"d\":8},\"v\":4},9],\"v\":{\"e\":{\"n\":1,\"r\":{\"n\":{\"e\":17},\"s\":12,\"t\":1}},\"i\":{\"s\":23,\"t\":{\"i\":36},\"a\":{\"n\":{\".\":266}}},\"o\":{\"l\":60}},\"w\":{\"d\":{\"e\":{\"r\":3}},\"e\":{\"l\":3,\"s\":{\"t\":4}},\"i\":2,\"n\":{\"i\":5},\"o\":21},\"y\":{\"a\":2},\"x\":{\"i\":{\"d\":{\"i\":{\"c\":267}}}}},\"p\":{\"a\":[{\"c\":{\"a\":1,\"e\":1,\"t\":0},\"d\":21,\"g\":{\"a\":{\"n\":32,\"t\":23}},\"i\":[{\"n\":17},21],\"l\":[{\"m\":{\"a\":{\"t\":268}}},21],\"n\":{\"a\":0,\"e\":{\"l\":11},\"t\":{\"y\":0},\"y\":3},\"p\":[{\"u\":1},2],\"r\":{\"a\":{\"b\":{\"l\":6},\"g\":{\"e\":5,\"r\":{\"a\":269}},\"l\":{\"e\":228},\"m\":[{\"e\":12},36]},\"d\":{\"i\":5},\"e\":[{\"l\":5},27],\"i\":[{\"s\":0},28]},\"t\":{\"e\":[{\"r\":4},9],\"h\":{\"i\":{\"c\":32},\"y\":4},\"r\":{\"i\":{\"c\":1}}},\"v\":0,\"y\":27},41],\"b\":43,\"d\":1,\"e\":{\".\":18,\"a\":[{\"r\":{\"l\":17}},138],\"c\":9,\"d\":[{\"e\":27,\"i\":[{\"a\":36,\"c\":0},27]},37],\"e\":[{\"d\":0,\"v\":208},21],\"k\":0,\"l\":{\"a\":1,\"i\":{\"e\":17}},\"n\":{\"a\":{\"n\":1},\"c\":21,\"t\":{\"h\":0}},\"o\":{\"n\":4},\"r\":{\"a\":{\".\":21,\"b\":{\"l\":6},\"g\":21},\"i\":[{\"s\":{\"t\":6}},21],\"m\":{\"a\":{\"l\":0},\"e\":7},\"n\":21,\"o\":11,\"t\":{\"i\":11},\"u\":4,\"v\":15},\"t\":[{\"e\":{\"n\":4},\"i\":{\"z\":4}},9]},\"f\":18,\"g\":18,\"h\":{\".\":18,\"a\":{\"r\":{\"i\":6}},\"e\":{\"n\":{\"o\":11},\"r\":1,\"s\":{\".\":1}},\"i\":{\"c\":2,\"e\":32,\"n\":{\"g\":4},\"s\":{\"t\":{\"i\":32}},\"z\":27,\"l\":{\"a\":{\"n\":{\"t\":168},\"t\":{\"e\":{\"l\":270}}}}},\"l\":9,\"o\":{\"b\":27,\"n\":{\"e\":27,\"i\":32},\"r\":0},\"s\":18,\"t\":3,\"u\":32,\"y\":41},\"i\":{\"a\":[{\"n\":17},3],\"c\":{\"i\":{\"e\":1},\"y\":1,\"a\":{\"d\":271}},\"d\":[{\"a\":19,\"e\":3,\"i\":32},21],\"e\":{\"c\":27,\"n\":3},\"g\":{\"r\":{\"a\":{\"p\":1}}},\"l\":{\"o\":3},\"n\":[{\".\":21,\"d\":17,\"o\":21},9],\"o\":[{\"n\":17},141],\"t\":{\"h\":[{\"a\":4},23],\"u\":9}},\"k\":142,\"l\":[{\"a\":{\"n\":27,\"s\":{\"t\":6}},\"i\":{\"a\":11,\"e\":{\"r\":5},\"g\":18,\"n\":[{\"a\":{\"r\":5}},0],\"c\":{\"a\":{\"b\":208}}},\"o\":{\"i\":17},\"u\":{\"m\":[{\"b\":17},0]}},143],\"m\":43,\"n\":48,\"o\":{\"c\":1,\"d\":{\".\":32},\"e\":{\"m\":4,\"t\":144},\"g\":145,\"i\":{\"n\":[{\"t\":32,\"c\":{\"a\":12}},84]},\"l\":{\"y\":{\"t\":6,\"e\":137,\"p\":{\"h\":{\"o\":{\"n\":{\"o\":272}}}}},\"e\":{\".\":41}},\"n\":{\"i\":1},\"p\":1,\"r\":[{\"y\":1},124],\"s\":[{\"s\":15},41],\"t\":[{\"a\":1},21],\"u\":{\"n\":32}},\"p\":[{\"a\":{\"r\":{\"a\":5}},\"e\":[{\"d\":21,\"l\":19,\"n\":23,\"r\":23,\"t\":23},24],\"o\":{\"s\":{\"i\":{\"t\":{\"e\":5}}}}},43],\"r\":[{\"a\":{\"y\":{\"e\":17}},\"e\":{\"c\":{\"i\":32,\"o\":5},\"e\":{\"m\":11},\"f\":{\"a\":{\"c\":6}},\"l\":{\"a\":0},\"r\":11,\"s\":{\"e\":23,\"s\":27,\"p\":{\"l\":{\"i\":84}}},\"t\":{\"e\":{\"n\":5}},\"v\":11,\"m\":{\"a\":{\"c\":273}},\"n\":{\"e\":{\"u\":15}}},\"i\":{\"e\":53,\"n\":{\"t\":146},\"s\":[{\"o\":12},0]},\"o\":{\"c\":{\"a\":23,\"e\":{\"s\":{\"s\":8}},\"i\":{\"t\":{\"y\":{\".\":274}}}},\"f\":{\"i\":{\"t\":6}},\"l\":11,\"s\":{\"e\":12},\"t\":15,\"g\":{\"e\":208}}},9],\"s\":[{\"e\":[{\"u\":{\"d\":[{\"o\":{\"d\":276,\"f\":276}},275]}},24],\"h\":1,\"i\":{\"b\":21}},81],\"t\":[{\"a\":{\"b\":134},\"e\":24,\"h\":24,\"i\":{\"m\":11},\"u\":{\"r\":0},\"w\":21,\"o\":{\"m\":{\"a\":{\"t\":277}}},\"r\":{\"o\":{\"l\":278}}},42],\"u\":{\"b\":[{\"e\":{\"s\":{\"c\":181}}},11],\"e\":0,\"f\":0,\"l\":{\"c\":11},\"m\":1,\"n\":9,\"r\":{\"r\":0},\"s\":32,\"t\":[{\"e\":[{\"r\":11},32],\"r\":3,\"t\":{\"e\":{\"d\":0},\"i\":{\"n\":0}}},9]},\"w\":23},\"q\":{\"u\":[{\"a\":{\"v\":5,\"i\":{\"n\":{\"t\":{\"e\":279}}},\"s\":{\"i\":[{\"r\":281,\"s\":281},280]}},\"e\":{\".\":25,\"r\":27,\"t\":27},\"i\":{\"n\":{\"t\":{\"e\":{\"s\":{\"s\":282}}}},\"v\":{\"a\":{\"r\":14}}}},9]},\"r\":{\"a\":{\"b\":[{\"i\":3,\"o\":{\"l\":{\"i\":{\"c\":29},\"o\":{\"i\":236}}}},25],\"c\":{\"h\":{\"e\":17,\"u\":3},\"l\":19},\"f\":{\"f\":{\"i\":5},\"t\":0},\"i\":24,\"l\":{\"o\":1},\"m\":{\"e\":{\"t\":[{\"r\":{\"i\":{\"z\":283}}},11],\"n\":24},\"i\":24,\"o\":{\"u\":3}},\"n\":{\"e\":{\"o\":6},\"g\":{\"e\":0},\"i\":21,\"o\":4,\"h\":{\"a\":{\"s\":167}}},\"p\":{\"e\":{\"r\":11},\"h\":{\"y\":27}},\"r\":{\"c\":5,\"e\":[{\"f\":5},17],\"i\":{\"l\":18}},\"s\":24,\"t\":{\"i\":{\"o\":{\"n\":115}}},\"u\":{\"t\":0},\"v\":{\"a\":{\"i\":4},\"e\":{\"l\":11}},\"z\":{\"i\":{\"e\":4}},\"d\":{\"i\":{\"g\":127,\"o\":{\"g\":249}}},\"o\":{\"r\":2}},\"b\":[{\"a\":{\"b\":21,\"g\":21},\"i\":[{\"f\":0,\"n\":[{\"e\":19,\"g\":{\".\":4,\"e\":284}},24]},8],\"o\":1},29],\"c\":[{\"e\":[{\"n\":17},24],\"h\":{\"a\":23,\"e\":{\"r\":0}},\"i\":{\"b\":90,\"t\":1},\"u\":{\"m\":12}},29],\"d\":{\"a\":{\"l\":21},\"i\":[{\"a\":0,\"e\":{\"r\":0},\"n\":[{\"g\":3},17]},9]},\"e\":{\".\":25,\"a\":{\"l\":2,\"n\":3,\"r\":{\"r\":4},\"v\":32,\"w\":1},\"b\":{\"r\":{\"a\":{\"t\":19}}},\"c\":{\"o\":{\"l\":{\"l\":5},\"m\":{\"p\":{\"e\":5}}},\"r\":{\"e\":1},\"i\":{\"p\":{\"r\":285}},\"t\":{\"a\":{\"n\":{\"g\":286}}}},\"d\":[{\"e\":2,\"i\":{\"s\":3,\"t\":5}},37],\"f\":{\"a\":{\"c\":1},\"e\":[{\"r\":{\".\":4}},9],\"i\":3,\"y\":1},\"g\":{\"i\":{\"s\":11}},\"i\":{\"t\":4},\"l\":{\"i\":2,\"u\":4},\"n\":{\"t\":{\"a\":90,\"e\":0}},\"o\":2,\"p\":{\"i\":{\"n\":4},\"o\":{\"s\":{\"i\":1}},\"u\":2},\"r\":[{\"i\":21,\"o\":17,\"u\":4},147],\"s\":{\".\":21,\"p\":{\"i\":1},\"s\":{\"i\":{\"b\":6}},\"t\":[{\"a\":{\"l\":4},\"r\":3},8]},\"t\":{\"e\":{\"r\":1},\"i\":{\"z\":96},\"r\":{\"i\":[{\"b\":{\"u\":85}},3]}},\"u\":[{\"t\":{\"i\":4}},8],\"v\":[{\"a\":{\"l\":1},\"e\":{\"l\":11,\"r\":{\".\":30,\"s\":4,\"t\":4}},\"i\":{\"l\":4},\"o\":{\"l\":{\"u\":5}}},8],\"w\":{\"h\":1}},\"f\":[{\"u\":0,\"y\":21},29],\"g\":[{\"e\":{\"r\":3,\"t\":23},\"i\":{\"c\":23,\"n\":[{\"g\":3},0],\"s\":19,\"t\":19},\"l\":29,\"o\":{\"n\":0},\"u\":23},9],\"h\":[{\".\":18,\"a\":{\"l\":18}},1],\"i\":{\"a\":[{\"b\":0,\"g\":1,\"l\":{\".\":23}},3],\"b\":[{\"a\":11},21],\"c\":{\"a\":{\"s\":5},\"e\":21,\"i\":[{\"d\":32,\"e\":1},18],\"o\":21},\"d\":{\"e\":{\"r\":5}},\"e\":{\"n\":{\"c\":3,\"t\":3},\"r\":2,\"t\":4},\"g\":{\"a\":{\"n\":5},\"i\":32},\"l\":{\"i\":{\"z\":11}},\"m\":{\"a\":{\"n\":32},\"i\":5,\"o\":27,\"p\":{\"e\":0}},\"n\":{\"a\":[{\".\":32},24],\"d\":0,\"e\":0,\"g\":0},\"o\":2,\"p\":{\"h\":[{\"e\":6},32],\"l\":[{\"i\":{\"c\":5}},9]},\"q\":21,\"s\":[{\".\":21,\"c\":0,\"h\":23,\"p\":0},24],\"t\":{\"a\":{\"b\":116},\"e\":{\"d\":{\".\":19},\"r\":{\".\":5,\"s\":5}},\"i\":{\"c\":11},\"u\":[{\"r\":5},9]},\"v\":{\"e\":{\"l\":5,\"t\":11},\"i\":11,\"o\":{\"l\":287}}},\"j\":23,\"k\":{\"e\":{\"t\":23},\"l\":{\"e\":1,\"i\":{\"n\":1}},\".\":288,\"h\":{\"o\":2},\"r\":{\"a\":{\"u\":29}},\"s\":{\".\":288}},\"l\":[{\"e\":[{\"d\":24,\"q\":{\"u\":30}},0],\"i\":{\"g\":21,\"s\":[{\"h\":4},21]},\"o\":73},29],\"m\":[{\"a\":{\"c\":5},\"e\":[{\"n\":23,\"r\":{\"s\":4}},24],\"i\":{\"n\":{\"g\":[{\".\":21},3]},\"o\":21,\"t\":23},\"y\":21},29],\"n\":{\"a\":{\"r\":21},\"e\":{\"l\":23,\"r\":21,\"t\":19,\"y\":23},\"i\":{\"c\":19,\"s\":92,\"t\":23,\"v\":23},\"o\":[{\"u\":21},0],\"u\":23},\"o\":{\"b\":{\"l\":11,\"o\":{\"t\":289}},\"c\":[{\"r\":3},24],\"e\":[{\"l\":{\"a\":{\"s\":167}},\"p\":{\"i\":{\"d\":{\"e\":290}}}},1],\"f\":{\"e\":2,\"i\":{\"l\":4}},\"k\":[{\"e\":{\"r\":4}},8],\"l\":{\"e\":{\".\":32}},\"m\":{\"e\":{\"t\":{\"e\":5},\"s\":{\"h\":3}},\"i\":0,\"p\":0},\"n\":{\"a\":{\"l\":0},\"e\":0,\"i\":{\"s\":134},\"t\":{\"a\":0}},\"o\":{\"m\":41,\"t\":32},\"p\":{\"e\":{\"l\":3},\"i\":{\"c\":11}},\"r\":{\"i\":11,\"o\":4},\"s\":{\"p\":{\"e\":{\"r\":5}},\"s\":0},\"t\":{\"h\":{\"e\":1},\"y\":1,\"r\":{\"o\":{\"n\":2}}},\"v\":{\"a\":1,\"e\":{\"l\":5}},\"x\":5},\"p\":[{\"e\":{\"a\":21,\"n\":{\"t\":19},\"r\":{\".\":4},\"t\":23},\"h\":95,\"i\":{\"n\":{\"g\":3}},\"o\":23,\"a\":{\"u\":{\"l\":{\"i\":291}}}},29],\"r\":[{\"e\":{\"c\":0,\"f\":0,\"o\":21,\"s\":{\"t\":0}},\"i\":{\"o\":0,\"v\":0},\"o\":{\"n\":17,\"s\":17},\"y\":{\"s\":17}},72],\"s\":[{\"a\":[{\"t\":{\"i\":5}},29],\"c\":1,\"e\":[{\"c\":[{\"r\":0},23],\"r\":{\".\":4,\"a\":{\"d\":{\"i\":238}}},\"s\":3,\"v\":148},24],\"h\":[{\"a\":19},29],\"i\":[{\"b\":90},29],\"o\":{\"n\":12},\"p\":29,\"w\":19},44],\"t\":{\"a\":{\"c\":{\"h\":36},\"g\":21},\"e\":{\"b\":23,\"n\":{\"d\":17},\"o\":5},\"i\":[{\"b\":4,\"d\":0,\"e\":{\"r\":21},\"g\":23,\"l\":{\"i\":12,\"l\":17,\"y\":21},\"s\":{\"t\":21},\"v\":21},29],\"r\":{\"i\":23,\"o\":{\"p\":{\"h\":115}},\"e\":{\"u\":29}},\"s\":{\"h\":1},\"h\":{\"o\":{\"u\":29}}},\"u\":{\"a\":3,\"e\":{\"l\":93,\"n\":3},\"g\":{\"l\":1},\"i\":{\"n\":3},\"m\":{\"p\":{\"l\":11}},\"n\":[{\"k\":6,\"t\":{\"y\":0}},9],\"s\":{\"c\":19},\"t\":{\"i\":{\"n\":6}}},\"v\":{\"e\":[{\"l\":{\"i\":17},\"n\":23,\"r\":{\".\":4},\"s\":{\"t\":19},\"y\":23,\"i\":{\"l\":29}},1],\"i\":{\"c\":23,\"v\":0},\"o\":23},\"w\":29,\"y\":{\"c\":1,\"n\":{\"g\":{\"e\":32}},\"t\":3},\"z\":{\"s\":{\"c\":2}}},\"s\":{\"a\":[{\"b\":42,\"c\":{\"k\":32,\"r\":{\"i\":11},\"t\":23},\"i\":32,\"l\":{\"a\":{\"r\":36},\"m\":0,\"o\":4,\"t\":0,\"e\":{\"s\":{\"c\":54,\"w\":7}}},\"n\":{\"c\":27,\"d\":{\"e\":0}},\"p\":[{\"a\":{\"r\":{\"i\":{\"l\":292}}}},29],\"t\":{\"a\":4,\"i\":{\"o\":76},\"u\":11},\"u\":0,\"v\":{\"o\":{\"r\":4}},\"w\":32},9],\"b\":56,\"c\":{\"a\":{\"n\":{\"t\":149},\"p\":[{\"e\":{\"r\":267}},0],\"v\":6,\"t\":{\"o\":{\"l\":208}}},\"e\":{\"d\":21,\"i\":18,\"s\":21},\"h\":[{\"o\":21,\"i\":{\"t\":{\"z\":21}},\"r\":{\"o\":{\"d\":{\"i\":{\"n\":{\"g\":293}}}}}},8],\"i\":{\"e\":68,\"n\":{\"d\":150},\"u\":{\"t\":{\"t\":294}}},\"l\":{\"e\":6,\"i\":21},\"o\":{\"f\":17,\"p\":{\"y\":18},\"u\":{\"r\":{\"a\":7}}},\"u\":29,\"r\":{\"a\":{\"p\":{\"e\":{\"r\":{\".\":36}}}}},\"y\":{\"t\":{\"h\":247}}},\"d\":56,\"e\":{\".\":18,\"a\":[{\"s\":17,\"w\":5},1],\"c\":{\"o\":151,\"t\":27},\"d\":[{\"e\":95,\"l\":19},125],\"g\":[{\"r\":11},9],\"i\":32,\"l\":{\"e\":2,\"f\":32,\"v\":32},\"m\":{\"e\":[{\"s\":{\"t\":295}},18],\"o\":{\"l\":1},\"a\":{\"p\":{\"h\":287}},\"i\":{\"t\":{\"i\":{\"c\":296}}}},\"n\":{\"a\":{\"t\":5},\"c\":18,\"d\":0,\"e\":{\"d\":19},\"g\":5,\"i\":{\"n\":19},\"t\":{\"d\":18,\"l\":18}},\"p\":{\"a\":152,\"t\":{\"e\":{\"m\":{\"b\":11}}}},\"r\":{\".\":43,\"l\":21,\"o\":0,\"v\":{\"o\":18}},\"s\":[{\"h\":4,\"t\":5},72],\"u\":{\"m\":113},\"v\":[{\"e\":{\"n\":11}},32],\"w\":{\"i\":0},\"x\":32},\"f\":47,\"g\":48,\"h\":[{\".\":25,\"e\":{\"r\":2,\"v\":32},\"i\":{\"n\":2,\"o\":3,\"p\":27,\"v\":6},\"o\":[{\"l\":{\"d\":4},\"n\":12,\"r\":[{\"t\":7},17],\"e\":{\"s\":{\"t\":137}}},0],\"w\":18},24],\"i\":{\"b\":2,\"c\":{\"c\":19},\"d\":{\"e\":{\".\":27,\"s\":[{\"t\":6,\"w\":6},32],\"d\":{\".\":8}},\"i\":[{\"z\":4},32]},\"g\":{\"n\":{\"a\":18}},\"l\":{\"e\":0,\"y\":18},\"n\":[{\"a\":24,\"e\":{\".\":32},\"g\":23},42],\"o\":[{\"n\":[{\"a\":6},32]},41],\"r\":[{\"a\":5,\"e\":{\"s\":{\"i\":{\"d\":4}}}},9],\"s\":41,\"t\":{\"i\":{\"o\":27}},\"u\":32,\"v\":41,\"z\":32},\"k\":[{\"e\":[{\"t\":23},18],\"i\":{\"n\":{\"e\":4,\"g\":4}},\"y\":{\"s\":{\"c\":15}}},9],\"l\":[{\"a\":{\"t\":23},\"e\":24,\"i\":{\"t\":{\"h\":7}},\"o\":{\"v\":{\"a\":{\"k\":{\"i\":{\"a\":297}}}}}},74],\"m\":[{\"a\":[{\"l\":{\"l\":54},\"n\":12},23],\"e\":{\"l\":17,\"n\":19},\"i\":{\"t\":{\"h\":32}},\"o\":{\"l\":{\"d\":49}}},42],\"n\":72,\"o\":[{\"c\":{\"e\":1},\"f\":{\"t\":12},\"l\":{\"a\":{\"b\":1},\"d\":153,\"i\":{\"c\":3},\"v\":32,\"u\":{\"t\":{\"e\":9}}},\"m\":27,\"n\":{\".\":68,\"a\":17,\"g\":0},\"p\":[{\"h\":{\"i\":{\"c\":32,\"z\":19},\"y\":19}},21],\"r\":{\"c\":5,\"d\":5},\"v\":[{\"i\":4},18],\"g\":{\"a\":{\"m\":{\"y\":298}}}},41],\"p\":{\"a\":[{\"i\":32,\"n\":0,\"c\":{\"e\":299,\"i\":{\"n\":69}}},25],\"e\":{\"n\":{\"d\":17},\"o\":57,\"r\":25,\"c\":{\"i\":{\"o\":11}}},\"h\":{\"e\":[{\"r\":[{\"o\":213},27]},24],\"o\":6},\"i\":{\"l\":17,\"n\":{\"g\":4},\"o\":18,\"c\":{\"i\":{\"l\":208}}},\"l\":{\"y\":21},\"o\":{\"n\":21,\"r\":[{\"t\":{\"s\":{\"c\":300,\"w\":300}}},17],\"t\":18,\"k\":{\"e\":{\"s\":{\"w\":10}}}}},\"q\":{\"u\":{\"a\":{\"l\":{\"l\":36}},\"i\":{\"t\":{\"o\":88}}}},\"r\":29,\"s\":[{\"a\":[{\"s\":12,\"c\":{\"h\":{\"u\":301}}},29],\"c\":94,\"e\":{\"l\":23,\"n\":{\"g\":19},\"s\":{\".\":21},\"t\":19},\"i\":[{\"e\":[{\"r\":0},21],\"l\":{\"y\":4},\"a\":{\"n\":{\".\":210}},\"g\":{\"n\":{\"a\":{\"b\":302}}}},29],\"l\":[{\"i\":1},21],\"n\":21,\"p\":{\"e\":{\"n\":{\"d\":115}}},\"t\":9,\"u\":{\"r\":{\"a\":6}},\"w\":4,\"h\":{\"a\":{\"t\":3}}},25],\"t\":{\".\":25,\"a\":{\"g\":24,\"l\":24,\"m\":{\"i\":17,\"p\":69},\"n\":{\"d\":32,\"t\":{\"s\":{\"h\":{\"i\":303}}}},\"p\":90,\"t\":{\".\":32,\"i\":15},\"r\":{\"t\":{\"l\":{\"i\":12}}}},\"e\":{\"d\":21,\"r\":{\"n\":{\"i\":7},\"o\":19},\"w\":[{\"a\":6},8]},\"h\":{\"e\":23},\"i\":[{\".\":21,\"a\":19,\"c\":[{\"k\":32},29],\"e\":21,\"f\":23,\"n\":{\"g\":3},\"r\":32},9],\"l\":{\"e\":29},\"o\":{\"c\":{\"k\":32},\"m\":{\"a\":12},\"n\":{\"e\":32},\"p\":21,\"r\":{\"e\":27,\"a\":{\"b\":304}}},\"r\":[{\"a\":{\"d\":21,\"t\":{\"u\":32,\"a\":{\"g\":305}},\"y\":21},\"i\":{\"d\":21,\"b\":{\"u\":{\"t\":7}}},\"y\":18},1],\"w\":61,\"y\":[{\"l\":{\"i\":{\"s\":137}}},24],\"b\":4,\"s\":{\"c\":{\"r\":4}},\"u\":{\"p\":{\"i\":{\"d\":306}}}},\"u\":[{\"a\":{\"l\":2},\"b\":111,\"g\":151,\"i\":{\"s\":4,\"t\":12},\"l\":21,\"m\":[{\"i\":11},9],\"n\":9,\"r\":9,\"p\":{\"e\":{\"r\":{\"e\":307}}}},41],\"v\":18,\"w\":[{\"o\":18,\"i\":{\"m\":{\"m\":177}}},9],\"y\":[{\"c\":18,\"l\":27,\"n\":{\"o\":5,\"c\":41},\"r\":{\"i\":{\"n\":4}},\"t\":{\"h\":{\"i\":308}}},21]},\"t\":{\"a\":[{\".\":27,\"b\":[{\"l\":{\"e\":{\"s\":4}},\"o\":{\"l\":{\"i\":{\"z\":32,\"s\":{\"m\":309}}}}},25],\"c\":{\"i\":18},\"d\":{\"o\":4},\"f\":46,\"i\":{\"l\":{\"o\":5}},\"l\":[{\"a\":4,\"e\":{\"n\":5},\"i\":11,\"k\":[{\"a\":204},18],\"l\":{\"i\":{\"s\":0}},\"o\":{\"g\":4}},9],\"m\":{\"o\":4,\"i\":{\"n\":82}},\"n\":{\"d\":{\"e\":0},\"t\":{\"a\":54}},\"p\":{\"e\":{\"r\":4},\"l\":4,\"a\":{\"t\":{\"h\":310}}},\"r\":{\"a\":0,\"c\":18,\"e\":18,\"i\":{\"z\":3},\"r\":{\"h\":311}},\"s\":{\"e\":0,\"y\":4},\"t\":{\"i\":{\"c\":18},\"u\":{\"r\":1}},\"u\":{\"n\":17},\"v\":0,\"w\":25,\"x\":{\"i\":{\"s\":0}},\"g\":{\"o\":{\"n\":{\".\":3}}}},41],\"b\":42,\"c\":[{\"h\":[{\"e\":{\"t\":5},\"c\":15,\"i\":{\"e\":{\"r\":237}}},21],\"r\":29},18],\"d\":43,\"e\":{\".\":18,\"a\":{\"d\":{\"i\":17},\"t\":18,\"c\":{\"h\":{\"e\":{\"r\":{\".\":36}}}}},\"c\":{\"e\":17,\"t\":32},\"d\":[{\"i\":4},42],\"e\":41,\"g\":[{\"e\":{\"r\":4},\"i\":4},0],\"l\":{\".\":27,\"i\":17,\"s\":32,\"e\":{\"g\":84,\"r\":{\"o\":249}}},\"m\":{\"a\":[{\"t\":11},154]},\"n\":{\"a\":{\"n\":27},\"c\":27,\"d\":27,\"e\":{\"s\":18},\"t\":[{\"a\":{\"g\":0}},41]},\"o\":41,\"p\":[{\"e\":4},1],\"r\":{\"c\":11,\"d\":155,\"i\":[{\"e\":{\"s\":5},\"s\":11,\"z\":{\"a\":6},\"c\":{\".\":8}},41],\"n\":{\"i\":{\"t\":32}},\"v\":5,\"g\":{\"e\":{\"i\":312}}},\"s\":{\".\":18,\"s\":[{\".\":23,\"e\":{\"s\":313}},18]},\"t\":{\"h\":{\"e\":6}},\"u\":27,\"x\":27,\"y\":18},\"f\":42,\"g\":43,\"h\":{\".\":25,\"a\":{\"n\":17,\"l\":{\"a\":{\"m\":228}}},\"e\":[{\"a\":[{\"s\":3,\"t\":5},18],\"i\":{\"s\":11},\"t\":27},9],\"i\":{\"c\":{\".\":4,\"a\":4},\"l\":18,\"n\":{\"k\":32}},\"l\":18,\"o\":{\"d\":{\"e\":4,\"i\":{\"c\":32},\"o\":{\"n\":11}},\"o\":18,\"r\":{\"i\":{\"t\":6,\"z\":5}},\"g\":{\"e\":{\"n\":{\"i\":314}}},\"k\":{\"e\":{\"r\":175}}},\"s\":25,\"y\":{\"l\":{\"a\":{\"n\":228}},\"s\":{\"c\":11}}},\"i\":{\"a\":[{\"b\":1,\"t\":{\"o\":1},\"n\":{\".\":70}},41],\"b\":156,\"c\":{\"k\":18,\"o\":21,\"u\":157},\"d\":{\"i\":32},\"e\":{\"n\":27},\"f\":[{\"y\":4},8],\"g\":[{\"u\":32},25],\"l\":{\"l\":{\"i\":{\"n\":6}}},\"m\":[{\"p\":18,\"u\":{\"l\":5}},41],\"n\":[{\"a\":24,\"e\":{\".\":27},\"i\":27,\"o\":{\"m\":285}},42],\"o\":[{\"c\":4,\"n\":{\"e\":{\"e\":6}}},41],\"q\":32,\"s\":{\"a\":3,\"e\":27,\"m\":0,\"o\":4,\"p\":0,\"t\":{\"i\":{\"c\":{\"a\":32}}}},\"t\":{\"l\":3},\"u\":1,\"v\":[{\"a\":0},41],\"z\":[{\"a\":3,\"e\":{\"n\":3}},41]},\"l\":[{\"a\":[{\"n\":17},19],\"e\":{\".\":27,\"d\":27,\"s\":{\".\":27},\"t\":{\".\":19}},\"o\":19,\"i\":{\"e\":{\"r\":315}}},25],\"m\":[{\"e\":0},43],\"n\":81,\"o\":[{\"b\":3,\"c\":{\"r\":{\"a\":{\"t\":4}}},\"d\":{\"o\":18},\"f\":25,\"g\":{\"r\":9},\"i\":{\"c\":4},\"m\":{\"a\":9,\"b\":0,\"y\":3},\"n\":{\"a\":{\"l\":{\"i\":0},\"t\":3},\"o\":18,\"y\":18},\"r\":{\"a\":9,\"i\":{\"e\":3,\"z\":5}},\"s\":8,\"u\":{\"r\":32,\"t\":18},\"w\":{\"a\":{\"r\":3}},\"l\":{\"o\":{\"g\":{\"y\":84}}},\"t\":{\"i\":{\"c\":11}}},41],\"p\":43,\"r\":{\"a\":[{\"b\":11,\"c\":{\"h\":5,\"i\":[{\"t\":17},36],\"t\":{\"e\":17}},\"s\":17,\"v\":{\"e\":{\"n\":5,\"s\":158,\"r\":{\"s\":[{\"a\":{\"b\":317}},15]}}},\"i\":{\"t\":{\"o\":{\"r\":316}}}},41],\"e\":{\"f\":5,\"m\":[{\"i\":6},0],\"a\":{\"c\":{\"h\":{\"e\":318}}}},\"i\":{\"a\":[{\"l\":{\".\":1}},32],\"c\":{\"e\":{\"s\":5},\"i\":{\"a\":32},\"s\":18},\"m\":25,\"v\":0},\"o\":{\"m\":{\"i\":5},\"n\":{\"i\":6,\"y\":18},\"p\":{\"h\":{\"e\":5},\"i\":{\"s\":175},\"o\":{\"l\":{\"e\":{\"s\":320},\"i\":{\"s\":320,\"t\":321}}}},\"s\":{\"p\":11},\"v\":11,\"l\":{\"e\":{\"u\":{\"m\":319}}},\"f\":{\"i\":{\"c\":{\".\":17},\"t\":11}}},\"u\":{\"i\":5,\"s\":17}},\"s\":[{\"c\":[{\"h\":{\"i\":{\"e\":12}}},21],\"h\":0,\"w\":21},101],\"t\":[{\"e\":{\"s\":21},\"o\":19,\"u\":0,\"r\":{\"i\":{\"b\":{\"u\":{\"t\":322}}}}},66],\"u\":[{\"a\":[{\"r\":3},2],\"b\":{\"i\":1},\"d\":8,\"e\":18,\"f\":46,\"i\":76,\"m\":27,\"n\":{\"i\":{\"s\":1}},\"p\":{\".\":48},\"r\":{\"e\":27,\"i\":[{\"s\":11},32],\"o\":5,\"y\":4,\"n\":{\"a\":{\"r\":12}}},\"s\":27},41],\"v\":18,\"w\":[{\"a\":43,\"i\":{\"s\":17},\"o\":18,\"h\":29},1],\"y\":[{\"a\":18,\"l\":25,\"p\":{\"e\":12,\"h\":4,\"a\":{\"l\":64}}},41],\"z\":[{\"e\":1},18]},\"u\":{\"a\":{\"b\":18,\"c\":0,\"n\":{\"a\":4,\"i\":0},\"r\":{\"a\":{\"n\":{\"t\":5}},\"d\":8,\"i\":11,\"t\":11},\"t\":29,\"v\":0,\"d\":{\"r\":{\"a\":{\"t\":{\"i\":3,\"u\":15}}}}},\"b\":{\"e\":[{\"l\":21,\"r\":[{\"o\":21},23]},1],\"i\":[{\"n\":{\"g\":33}},72],\"l\":{\"e\":{\".\":23}}},\"c\":{\"a\":23,\"i\":{\"b\":0,\"t\":1},\"l\":{\"e\":12},\"r\":23,\"u\":23,\"y\":21},\"d\":{\"d\":4,\"e\":{\"r\":3,\"s\":{\"t\":4},\"v\":17},\"i\":{\"c\":29,\"e\":{\"d\":3,\"s\":3},\"s\":4,\"t\":19},\"o\":{\"n\":[{\"y\":232},21]},\"s\":{\"i\":1},\"u\":21},\"e\":{\"n\":{\"e\":21,\"s\":17,\"t\":{\"e\":0}},\"r\":{\"i\":{\"l\":0}},\"a\":{\"m\":15}},\"f\":{\"a\":27,\"l\":23},\"g\":{\"h\":{\"e\":{\"n\":11}},\"i\":{\"n\":4}},\"i\":[{\"l\":{\"i\":{\"z\":5}},\"n\":[{\"g\":29},1],\"r\":{\"m\":0},\"t\":{\"a\":17},\"v\":[{\"e\":{\"r\":{\".\":0}}},11]},156],\"j\":19,\"k\":18,\"l\":{\"a\":[{\"b\":5,\"t\":{\"i\":19}},29],\"c\":{\"h\":[{\"e\":32},17]},\"d\":{\"e\":{\"r\":3}},\"e\":[{\"n\":29},1],\"g\":{\"i\":1},\"i\":[{\"a\":19,\"n\":{\"g\":3},\"s\":{\"h\":4}},9],\"l\":{\"a\":{\"r\":1},\"i\":{\"b\":96,\"s\":1}},\"m\":61,\"o\":72,\"s\":[{\"e\":{\"s\":5}},18],\"t\":{\"i\":2,\"r\":{\"a\":54},\"u\":18},\"u\":[{\"l\":4},23],\"v\":4},\"m\":{\"a\":{\"b\":4},\"b\":{\"i\":1,\"l\":{\"y\":1}},\"i\":[{\"n\":{\"g\":83}},29],\"o\":{\"r\":{\"o\":6}},\"p\":9},\"n\":{\"a\":{\"t\":17},\"e\":[{\"r\":1},24],\"i\":[{\"m\":1,\"n\":24,\"s\":{\"h\":4},\"v\":11},29],\"s\":[{\"w\":1},93],\"t\":{\"a\":{\"b\":11},\"e\":{\"r\":{\".\":1},\"s\":1}},\"u\":0,\"y\":4,\"z\":4},\"o\":{\"r\":{\"s\":21},\"s\":19,\"u\":29},\"p\":{\"e\":[{\"r\":{\"s\":6}},29],\"i\":{\"a\":19,\"n\":{\"g\":3}},\"l\":23,\"p\":[{\"o\":{\"r\":{\"t\":10}}},3],\"t\":{\"i\":{\"b\":5},\"u\":17}},\"r\":{\"a\":[{\".\":18,\"g\":21,\"s\":21,\"l\":{\".\":216}},29],\"b\":{\"e\":1},\"c\":0,\"d\":2,\"e\":{\"a\":{\"t\":5}},\"f\":{\"e\":{\"r\":1},\"r\":1},\"i\":{\"f\":[{\"i\":{\"c\":0}},23],\"n\":2,\"o\":23,\"t\":29,\"z\":3,\"a\":{\"l\":{\".\":0}}},\"l\":[{\"i\":{\"n\":{\"g\":{\".\":5}}}},9],\"n\":{\"o\":1},\"o\":{\"s\":17},\"p\":{\"e\":1,\"i\":1},\"s\":{\"e\":{\"r\":5}},\"t\":{\"e\":{\"s\":4},\"h\":{\"e\":3},\"i\":[{\"e\":1},17]},\"u\":23},\"s\":[{\"a\":{\"d\":19,\"n\":19,\"p\":1},\"c\":[{\"i\":3},8],\"e\":{\"a\":5,\"r\":{\".\":9}},\"i\":{\"a\":19,\"c\":23},\"l\":{\"i\":{\"n\":1}},\"p\":2,\"s\":{\"l\":4},\"t\":{\"e\":{\"r\":{\"e\":4}},\"r\":2},\"u\":[{\"r\":17},24]},25],\"t\":{\"a\":{\"b\":0,\"t\":23},\"e\":{\".\":18,\"l\":18,\"n\":[{\"i\":17},18]},\"i\":[{\"l\":{\"i\":{\"z\":5}},\"n\":{\"e\":23,\"g\":3},\"o\":{\"n\":{\"a\":7}},\"s\":21,\"z\":31},101],\"l\":34,\"o\":{\"f\":4,\"g\":5,\"m\":{\"a\":{\"t\":{\"i\":{\"c\":5}}}},\"n\":19,\"u\":21},\"s\":0},\"u\":[{\"m\":1},23],\"v\":74,\"x\":{\"u\":11},\"z\":{\"e\":1}},\"v\":{\"a\":[{\".\":32,\"b\":159,\"c\":{\"i\":{\"l\":5},\"u\":11},\"g\":[{\"e\":1,\"u\":{\"e\":{\"r\":170}}},0],\"l\":{\"i\":{\"e\":4},\"o\":5,\"u\":15},\"m\":{\"o\":4},\"n\":{\"i\":{\"z\":4}},\"p\":{\"i\":4},\"r\":{\"i\":{\"e\":{\"d\":5}}},\"t\":[{\"i\":{\"v\":29}},27],\"u\":{\"d\":{\"e\":{\"v\":54}}}},41],\"e\":{\".\":18,\"d\":18,\"g\":11,\"l\":{\".\":23,\"l\":{\"i\":11},\"o\":1,\"y\":21},\"n\":{\"o\":{\"m\":11},\"u\":{\"e\":19}},\"r\":{\"d\":21,\"e\":{\".\":32,\"l\":[{\"y\":{\".\":41}},21],\"n\":[{\"c\":5},23],\"s\":21,\"i\":{\"g\":324}},\"i\":{\"e\":11},\"m\":{\"i\":{\"n\":36}},\"s\":{\"e\":27},\"t\":{\"h\":11}},\"s\":[{\".\":18,\"t\":{\"e\":0,\"i\":{\"t\":{\"e\":15}}}},99],\"t\":{\"e\":[{\"r\":11},1],\"y\":1}},\"i\":{\"a\":{\"l\":{\"i\":4},\"n\":32},\"d\":{\"e\":{\".\":32,\"d\":32,\"n\":47,\"s\":32},\"i\":32},\"f\":23,\"g\":{\"n\":4},\"k\":0,\"l\":[{\"i\":{\"t\":32,\"z\":127}},25],\"n\":[{\"a\":26,\"c\":24,\"d\":5,\"g\":18},29],\"o\":{\"l\":11,\"r\":73,\"u\":2},\"p\":1,\"r\":{\"o\":4},\"s\":{\"i\":{\"t\":11},\"o\":3,\"u\":3},\"t\":{\"i\":18,\"r\":11,\"y\":18},\"v\":[{\"i\":{\"p\":{\"a\":{\"r\":325}}}},27]},\"o\":{\".\":32,\"i\":[{\"r\":{\"d\":{\"u\":323}},\"c\":{\"e\":{\"p\":213}}},0],\"k\":27,\"l\":{\"a\":1,\"e\":19,\"t\":32,\"v\":27},\"m\":{\"i\":5},\"r\":{\"a\":{\"b\":5},\"i\":17,\"y\":1},\"t\":{\"a\":1,\"e\":{\"e\":18}}},\"v\":26,\"y\":21},\"w\":{\"a\":{\"b\":{\"l\":19},\"c\":25,\"g\":{\"e\":{\"r\":4},\"o\":5},\"i\":{\"t\":6},\"l\":{\".\":19},\"m\":0,\"r\":{\"t\":0},\"s\":{\"t\":[{\"e\":{\"w\":{\"a\":326}}},0]},\"t\":{\"e\":2},\"v\":{\"e\":{\"r\":4,\"g\":327}}},\"b\":29,\"e\":{\"a\":{\"r\":{\"i\":{\"e\":5}},\"t\":{\"h\":54}},\"d\":{\"n\":0},\"e\":{\"t\":12,\"v\":5,\"k\":{\"n\":137}},\"l\":{\"l\":0},\"r\":29,\"s\":{\"t\":12},\"v\":23},\"h\":{\"i\":0},\"i\":[{\"l\":[{\"l\":{\"i\":{\"n\":6}}},8],\"n\":{\"d\":{\"e\":0},\"g\":0},\"r\":0,\"s\":{\"e\":27},\"t\":{\"h\":12},\"z\":5,\"d\":{\"e\":{\"s\":{\"p\":6}}}},9],\"k\":21,\"l\":{\"e\":{\"s\":1},\"i\":{\"n\":3}},\"n\":{\"o\":21},\"o\":[{\"m\":15,\"v\":{\"e\":{\"n\":4}},\"k\":{\"e\":{\"n\":85}}},160],\"p\":19,\"r\":{\"a\":[{\"p\":{\"a\":{\"r\":{\"o\":12}}}},0],\"i\":[{\"t\":{\"a\":36,\"e\":{\"r\":{\".\":183}}}},0]},\"s\":{\"h\":23,\"l\":1,\"p\":{\"e\":1},\"t\":60},\"t\":18,\"y\":1,\"c\":23},\"x\":{\"a\":[{\"c\":{\"e\":5},\"g\":{\"o\":21},\"m\":11,\"p\":21,\"s\":5},29],\"c\":161,\"e\":[{\"c\":{\"u\":{\"t\":{\"o\":1}}},\"d\":24,\"r\":{\"i\":0,\"o\":4}},29],\"h\":[{\"i\":[{\"l\":6},8],\"u\":0},29],\"i\":[{\"a\":4,\"c\":4,\"d\":{\"i\":4},\"m\":{\"e\":21,\"i\":{\"z\":4}}},23],\"o\":[{\"b\":21},23],\"p\":[{\"a\":{\"n\":{\"d\":17}},\"e\":{\"c\":{\"t\":{\"o\":10}},\"d\":11}},23],\"t\":[{\"i\":23},74],\"u\":[{\"a\":3},29],\"x\":1,\"q\":[{\"u\":{\"i\":{\"s\":54}}},29]},\"y\":{\"a\":{\"c\":19,\"r\":110,\"t\":19},\"b\":29,\"c\":[{\"e\":[{\"r\":4},24],\"h\":[{\"e\":[{\"d\":264},0]},23],\"o\":{\"m\":17,\"t\":17}},29],\"d\":29,\"e\":{\"e\":19,\"r\":[{\"f\":21},29],\"s\":[{\"t\":{\"e\":{\"r\":{\"y\":328}}}},0],\"t\":1},\"g\":{\"i\":19},\"h\":47,\"i\":29,\"l\":{\"a\":23,\"l\":{\"a\":{\"b\":{\"l\":6}}},\"o\":23,\"u\":19},\"m\":{\"b\":{\"o\":{\"l\":7}},\"e\":[{\"t\":{\"r\":{\"y\":20}}},0],\"p\":{\"a\":12}},\"n\":{\"c\":{\"h\":{\"r\":3}},\"d\":4,\"g\":4,\"i\":{\"c\":4},\"x\":32},\"o\":[{\"d\":4,\"g\":33,\"m\":0,\"n\":{\"e\":{\"t\":4},\"s\":21},\"s\":21},72],\"p\":{\"e\":{\"d\":21,\"r\":6},\"i\":3,\"o\":[{\"c\":21},23],\"t\":{\"a\":9},\"u\":19},\"r\":{\"a\":{\"m\":5},\"i\":{\"a\":4},\"o\":23,\"r\":1},\"s\":{\"c\":1,\"e\":161,\"i\":{\"c\":{\"a\":3},\"o\":3,\"s\":27},\"o\":21,\"s\":0,\"t\":[{\"a\":3,\"r\":{\"o\":29}},2],\"u\":{\"r\":17}},\"t\":{\"h\":{\"i\":{\"n\":23}},\"i\":{\"c\":3}},\"w\":29},\"z\":{\"a\":[{\"b\":79,\"r\":8},2],\"b\":18,\"e\":[{\"n\":1,\"p\":1,\"r\":[{\"o\":3},29],\"t\":0},25],\"i\":[{\"l\":21,\"s\":21,\"a\":{\"n\":{\".\":23}}},42],\"l\":32,\"m\":18,\"o\":[{\"m\":1,\"o\":{\"l\":4},\"p\":{\"h\":{\"r\":329}}},41],\"t\":{\"e\":0},\"z\":[{\"y\":21,\"w\":231},101]}}",
			[
				"as-so-ciate",
				"as-so-ciates",
				"dec-li-na-tion",
				"oblig-a-tory",
				"phil-an-thropic",
				"present",
				"presents",
				"project",
				"projects",
				"reci-procity",
				"re-cog-ni-zance",
				"ref-or-ma-tion",
				"ret-ri-bu-tion",
				"ta-ble"
			]
		];
	});
})), kQ = /* @__PURE__ */ xt(DQ(), 1), AQ = /* @__PURE__ */ xt(OQ(), 1), jQ = (e) => {
	let t = 0, n = "", r = [];
	return e.forEach((e) => {
		n += e.string, r.push({
			...e,
			start: t,
			end: t + e.string.length,
			attributes: e.attributes || {}
		}), t += e.string.length;
	}), {
		string: n,
		runs: r
	};
}, MQ = (e) => [e], NQ = (e = {}, t = {}) => (n) => {
	let r = [], i = [], a = t.hyphenationCallback || e.wordHyphenation?.() || MQ;
	for (let e = 0; e < n.runs.length; e += 1) {
		let t = "", o = n.runs[e], s = n.string.slice(o.start, o.end).split(/([ ]+)/g).filter(Boolean);
		for (let e = 0; e < s.length; e += 1) {
			let n = s[e], i = a(n);
			r.push(...i), t += i.join("");
		}
		i.push({
			...o,
			string: t
		});
	}
	return {
		...jQ(i),
		syllables: r
	};
}, PQ = (e) => Object.assign({}, e), FQ = (e, t) => [Object.assign({}, e, { height: t }), Object.assign({}, e, {
	y: e.y + t,
	height: e.height - t
})], IQ = (e, t) => {
	let [, n] = FQ(t, e);
	return n;
}, LQ = (e) => e.reduce((e, t) => e + t.box.height, 0), RQ = (e) => {
	let t = e.attributes || {}, n = t.fontSize || 12, r = t.font, i = typeof r == "string" ? null : r?.[0]?.unitsPerEm;
	return i ? n / i : 0;
}, zQ = (e) => e.attributes?.scale || RQ(e), BQ = (e, t) => {
	if (!t) return 0;
	let n = t.glyphIndices || [], r = n[e];
	return n.slice(0, e).filter((e) => e === r).length;
}, VQ = (e) => e.attributes?.font?.[0] || null, HQ = (e, t, n, r) => {
	if (!r || e === t) return [];
	if (e === 0 && t === r.codePoints.length) return [r];
	let i = r.codePoints.slice(e, t), a = String.fromCodePoint(...i);
	return n ? n.layout(a, void 0, void 0, void 0, "ltr").glyphs : [r];
}, UQ = (e, t) => {
	let n = t?.glyphIndices?.[e];
	return iJ(n) ? e : n;
}, WQ = (e) => {
	let t = e[0];
	return e.map((e) => e - t);
}, GQ = (e, t, n) => {
	let r = zQ(n), i = VQ(n), a = UQ(e, n), o = UQ(t, n), s = n.glyphs?.[a], c = n.glyphs?.[o], l = BQ(e, n), u = l > 0 ? HQ(l, Infinity, i, s) : [], d = HQ(0, BQ(t, n), i, c), f = a + Math.min(1, l), p = (n.glyphs || []).slice(f, o), m = (e) => ({
		xAdvance: e.advanceWidth * r,
		yAdvance: 0,
		xOffset: 0,
		yOffset: 0
	}), h = u.map(m), g = (n.positions || []).slice(f, o), _ = d.map(m);
	return Object.assign({}, n, {
		start: n.start + e,
		end: Math.min(n.end, n.start + t),
		glyphIndices: WQ((n.glyphIndices || []).slice(e, t)),
		glyphs: [
			u,
			p,
			d
		].flat(),
		positions: [
			h,
			g,
			_
		].flat()
	});
}, KQ = (e, t) => t ? t.findIndex((t) => t.start <= e && e < t.end) : -1, qQ = (e, t, n) => {
	let r = KQ(e, n), i = Math.max(KQ(t - 1, n), r);
	return n.slice(r, i + 1);
}, JQ = (e, t) => {
	let n = t.start - e, r = t.end - e;
	return Object.assign({}, t, {
		start: n,
		end: r
	});
}, YQ = (e, t, n) => {
	let r = (n) => GQ(e - n.start, t - n.start, n), i = (e) => GQ(0, t - e.start, e);
	return n.map((t, a) => {
		let o = t, s = a === 0, c = !s && a === n.length - 1;
		return s && (o = r(t)), c && (o = i(t)), JQ(e, o);
	});
}, XQ = (e, t, n) => {
	if (n.string.length === 0) return n;
	let r = n.string.slice(e, t), i = YQ(e, t, qQ(e, t, n.runs));
	return Object.assign({}, n, {
		string: r,
		runs: i
	});
}, ZQ = (e) => e.search(/\S/g), QQ = (e) => {
	let t = e.match(/\S/g);
	return t ? e.lastIndexOf(t[t.length - 1]) : -1;
}, $Q = (e) => XQ(ZQ(e.string), QQ(e.string) + 1, e), e$ = () => ({
	start: 0,
	end: 0,
	glyphIndices: [],
	glyphs: [],
	positions: [],
	attributes: {}
}), t$ = (e) => typeof e == "number", n$ = (e, t) => {
	let n = aJ(t), r = iJ(n) ? 0 : n + 1, i = Array(e).fill(r);
	return t.concat(i);
}, r$ = (e, t) => typeof t == "string" ? null : t && e ? t.glyphForCodePoint(e) : null, i$ = (e, t) => {
	let n = e.codePoints?.length || 0, r = t.end + n, i = t.glyphs.concat(e), a = n$(n, t.glyphIndices);
	if (!t.positions) return Object.assign({}, t, {
		end: r,
		glyphs: i,
		glyphIndices: a
	});
	let o = t.positions.concat({
		xAdvance: e.advanceWidth * zQ(t),
		yAdvance: 0,
		xOffset: 0,
		yOffset: 0
	});
	return Object.assign({}, t, {
		end: r,
		glyphs: i,
		glyphIndices: a,
		positions: o
	});
}, a$ = (e, t) => {
	if (!e) return t;
	let n = VQ(t);
	return i$(t$(e) ? r$(e, n) : e, t);
}, o$ = (e) => String.fromCodePoint(...e || []), s$ = (e, t) => {
	let n = o$((typeof e == "number" ? [e] : e?.codePoints) || []), r = t.string + n, i = t.runs.slice(0, -1), a = aJ(t.runs) || e$(), o = i.concat(a$(e, a));
	return Object.assign({}, t, {
		string: r,
		runs: o
	});
}, c$ = 8230, l$ = String.fromCharCode(c$), u$ = (e) => {
	if (!e.encode) return c$;
	let [t] = e.encode(l$);
	return parseInt(t[0], 16);
}, d$ = (e) => {
	let t = aJ(aJ(e)?.runs || [])?.attributes?.font[0];
	if (t) {
		let n = e.length - 1, r = u$(t), i = s$(t.glyphForCodePoint(r), $Q(e[n]));
		return Object.assign([], e, { [n]: i });
	}
	return e;
}, f$ = (e, t) => {
	let n = Object.assign({}, t.attributes);
	return delete n[e], Object.assign({}, t, { attributes: n });
}, p$ = (e) => {
	let { font: t, attachment: n } = e.attributes, r = n?.height || 0, i = typeof t == "string" ? 0 : t?.[0]?.ascent || 0;
	return Math.max(r, i * zQ(e));
}, m$ = (e) => {
	let t = e.attributes?.font, n = typeof t == "string" ? 0 : t?.[0]?.descent || 0;
	return zQ(e) * n;
}, h$ = (e) => {
	let t = e.attributes?.font;
	return (typeof t == "string" ? 0 : t?.[0]?.lineGap || 0) * zQ(e);
}, g$ = (e) => e.attributes?.lineHeight || h$(e) + p$(e) - m$(e), _$ = (e) => e.runs.reduce((e, t) => Math.max(e, g$(t)), 0), v$ = (e, t) => {
	let n = Math.max(e.x, t.x), r = Math.min(e.x + e.width, t.x + t.width), i = Math.max(e.y, t.y), a = Math.min(e.y + e.height, t.y + t.height);
	return r >= n && a >= i;
}, y$ = (e, t) => {
	if (!v$(t, e)) return [e];
	let n = t.x, r = t.x + t.width, i = e.x, a = e.x + e.width;
	return [Object.assign({}, e, { width: n - i }), Object.assign({}, e, {
		x: r,
		width: a - r
	})].filter((e) => e.width > 0);
}, b$ = (e, t) => {
	let n = [e];
	for (let e = 0; e < t.length; e += 1) {
		let r = t[e];
		n = n.reduce((e, t) => {
			let n = y$(t, r);
			return e.concat(n);
		}, []);
	}
	return n;
}, x$ = (e, t) => {
	let { excludeRects: n, ...r } = e;
	if (!n) return [r];
	let i = [], a = Math.max(...n.map((e) => e.y + e.height)), o = r;
	for (; o.y < a;) {
		let [e, r] = FQ(o, t), a = b$(e, n);
		o = r, i.push(...a);
	}
	return [...i, o];
}, S$ = "￼", C$ = (e) => {
	if (e.string.includes(S$)) return e;
	let t = e.runs.map((e) => f$("attachment", e));
	return Object.assign({}, e, { runs: t });
}, w$ = (e, t, n) => {
	let r = e.shift(), i = r.y;
	return t.map((t, a) => {
		let o = a === 0 ? n : 0, s = t.runs?.[0]?.attributes || {}, c = Math.max(_$(t), s.lineHeight);
		i + c > r.y + r.height && e.length > 0 && (r = e.shift(), i = r.y);
		let l = {
			string: t.string,
			runs: t.runs,
			box: {
				x: r.x + o,
				y: i,
				width: r.width - o,
				height: c
			}
		};
		return i += c, C$(l);
	});
}, T$ = (e, t = {}) => (n, r) => {
	let i = _$(r), a = r.runs?.[0]?.attributes?.indent || 0, o = x$(n, i), s = o.map((e) => e.width);
	return s.unshift(s[0] - a), w$(o, e.linebreaker(t)(r, s), a);
}, E$ = (e, t) => {
	let n = [], r = 0;
	for (let i = 0; i < t.length; i += 1) {
		let a = t[i];
		if (r += a.box.height, r < e) n.push(a);
		else break;
	}
	return n;
}, D$ = (e, t, n) => (r) => {
	let i = [], a = [...r], o = T$(e, t), s = iJ(n.maxLines) ? Infinity : n.maxLines, c = n.truncateMode === "ellipsis", l = s, u = PQ(n), d = a.shift();
	for (; l > 0 && d;) {
		let e = o(u, d), t = e.slice(0, l), n = LQ(t), r = c && e.length !== t.length;
		if (l -= t.length, u.height >= n) i.push(r ? d$(t) : t), u = IQ(n, u), d = a.shift();
		else {
			i.push(d$(E$(u.height, t)));
			break;
		}
	}
	return i;
}, O$ = (e) => {
	let { runs: t } = e;
	return t.length === 0 ? 0 : t[0].start;
}, k$ = (e) => {
	let { runs: t } = e;
	return t.length === 0 ? 0 : aJ(t).end;
}, A$ = (e) => k$(e) - O$(e), j$ = EQ(), M$ = (e) => e.reduce((e, t) => {
	let n = t.end - t.start, r = uJ(t.attributes.bidiLevel, n);
	return e.concat(r);
}, []), N$ = (e, t) => {
	let n = [];
	for (let t = 0; t < e.length; t += 1) n[t] = t;
	return t.forEach(([e, t]) => {
		let r = n.slice(e, t + 1);
		for (let e = r.length - 1; e >= 0; --e) n[t - e] = r[e];
	}), n;
}, P$ = (e, t, n) => {
	for (let r = 0; r < e.length; r += 1) {
		let i = e[r], a = i.glyphIndices[n - i.start];
		if (n >= i.start && n < i.end) return i[t][a];
	}
	throw Error(`index ${n} out of range`);
}, F$ = (e) => {
	let t = M$(e.runs), n = +(e.runs[0]?.attributes.direction === "rtl"), r = {
		paragraphs: [{
			start: 0,
			end: A$(e) - 1,
			level: n
		}],
		levels: t
	}, i = j$.getReorderSegments(e.string, r);
	if (i.length === 0) return e;
	let a = N$(e.string, i), o = j$.getReorderedString(e.string, r), s = e.runs.map((t) => {
		let n = a.slice(t.start, t.end), r = [], i = [], o = /* @__PURE__ */ new Set();
		for (let t = 0; t < n.length; t += 1) {
			let a = n[t], s = P$(e.runs, "glyphs", a);
			o.has(s.id) || (r.push(s), i.push(P$(e.runs, "positions", a)), s.isLigature && o.add(s.id));
		}
		return {
			...t,
			glyphs: r,
			positions: i
		};
	});
	return {
		box: e.box,
		runs: s,
		string: o
	};
}, I$ = (e) => e.map(F$), L$ = () => (e) => e.map(I$), R$ = 123, z$ = (e = []) => e.reduce((e, t) => {
	let n = t?.codePoints || [R$];
	if (e.length === 0) return n.map(() => 0);
	let r = e[e.length - 1], i = n.map(() => r + 1);
	return [...e, ...i];
}, []), B$ = (e) => e.attributes?.characterSpacing || 0, V$ = (e, t) => {
	let n = zQ(e), r = B$(e);
	return t.map((e, i) => {
		let a = i === t.length ? 0 : r;
		return Object.assign({}, e, {
			xAdvance: e.xAdvance * n + a,
			yAdvance: e.yAdvance * n,
			xOffset: e.xOffset * n,
			yOffset: e.yOffset * n
		});
	});
}, H$ = (e) => (t) => {
	let { start: n, end: r, attributes: i = {} } = t, { font: a } = i;
	if (!a) return {
		...t,
		glyphs: [],
		glyphIndices: [],
		positions: []
	};
	let o = e.slice(n, r);
	if (typeof a == "string") throw Error("Invalid font");
	let s = a[0].layout(o, void 0, void 0, void 0, "ltr"), c = V$(t, s.positions), l = z$(s.glyphs);
	return {
		...t,
		positions: c,
		glyphIndices: l,
		glyphs: s.glyphs
	};
}, U$ = () => (e) => {
	let t = e.runs.map(H$(e.string));
	return Object.assign({}, e, { runs: t });
}, W$ = (e) => {
	if (!e.positions) return e;
	let t = e.attributes?.font?.[0]?.unitsPerEm || 0, n = (e.attributes?.yOffset || 0) * t, r = e.positions.map((e) => Object.assign({}, e, { yOffset: n }));
	return Object.assign({}, e, { positions: r });
}, G$ = () => (e) => {
	let t = e.runs.map(W$);
	return Object.assign({}, e, { runs: t });
}, K$ = (e) => e.sort((e, t) => e.start - t.start || e.end - t.end), q$ = (e) => e.start === e.end, Kre = (e, t) => e[1] - t[1] || e[3] - t[3], J$ = (e) => e.reduce((e, t, n) => e.concat([[
	"start",
	t.start,
	t.attributes,
	n
], [
	"end",
	t.end,
	t.attributes,
	n
]]), []).sort(Kre), Y$ = (e) => e.reduce((e, t) => {
	let n = Object.assign({}, e.attributes, t.attributes);
	return Object.assign({}, t, { attributes: n });
}, {}), X$ = (e) => {
	let t = e.reduce((e, t) => (e[t.start] || (e[t.start] = []), e[t.start].push(t), e), []);
	return Object.values(t);
}, Z$ = (e) => X$(e).map(Y$), Q$ = (e) => {
	let t = [], n = J$(e), r = -1, i = {}, a = [];
	for (let e = 0; e < n.length; e += 1) {
		let [o, s, c] = n[e];
		if (r !== -1 && r < s && t.push({
			start: r,
			end: s,
			attributes: i,
			glyphIndices: [],
			glyphs: [],
			positions: []
		}), o === "start") a.push(c), i = Object.assign({}, i, c);
		else {
			i = {};
			for (let e = 0; e < a.length; e += 1) a[e] === c ? a.splice(e--, 1) : i = Object.assign({}, i, a[e]);
		}
		r = s;
	}
	return t;
}, $$ = (e = []) => {
	let t = Z$(e.filter((e) => q$(e))), n = Q$(e.filter((e) => !q$(e)));
	return K$(t.concat(n));
}, e1 = () => ({
	string: "",
	runs: []
}), t1 = (e) => {
	let t = e.runs.map((e) => f$("font", e));
	return Object.assign({}, e, { runs: t });
}, n1 = (e) => (t) => {
	if (iJ(t)) return e1();
	let { string: n } = t, { fontSubstitution: r, scriptItemizer: i, bidi: a } = e, { runs: o } = t1(t), { runs: s } = i()(t), { runs: c } = r()(t), { runs: l } = a()(t);
	return {
		string: n,
		runs: $$(l.concat(c).concat(s).concat(o))
	};
}, r1 = () => (e) => {
	let t = [], n = 0, r = e.string.indexOf("\n") + 1;
	for (; r > 0;) t.push(XQ(n, r, e)), n = r, r = e.string.indexOf("\n", r) + 1;
	return n === 0 ? t.push(e) : n < e.string.length && t.push(XQ(n, A$(e), e)), t;
}, i1 = (e) => e.reduce((e, t) => e + (t.xAdvance || 0), 0), a1 = (e) => i1(e.positions || []), o1 = (e) => e.runs.reduce((e, t) => e + a1(t), 0), s1 = 32, c1 = (e) => (e?.codePoints || []).includes(s1), l1 = (e) => {
	let t = e.glyphs || [], n = e.positions || [], r = t.findIndex((e) => !c1(e));
	return n.slice(0, r);
}, u1 = (e) => l1(e).reduce((e, t) => e + (t.xAdvance || 0), 0), d1 = (e) => u1((e.runs || [])[0]), f1 = (e) => {
	let t = dJ(e.glyphs || []), n = dJ(e.positions || []), r = t.findIndex((e) => !c1(e));
	return n.slice(0, r);
}, p1 = (e) => f1(e).reduce((e, t) => e + (t.xAdvance || 0), 0), m1 = (e) => p1(aJ(e.runs || [])), h1 = (e) => GQ(0, e.end - e.start - 1, e), g1 = (e) => {
	let t = nJ(e.string), n = Qq(-1, h1, e.runs);
	return Object.assign({}, e, {
		string: t,
		runs: n
	});
}, _1 = {
	center: .5,
	right: 1
}, v1 = (e) => aJ(e.string) === "\n" ? g1(e) : e, y1 = (e) => d1(e) + (e.overflowLeft || 0), b1 = (e) => m1(e) + (e.overflowRight || 0), x1 = (e) => {
	let t = y1(e), n = b1(e), r = e.box.x - t, i = e.box.width + t + n, a = Object.assign({}, e.box, {
		x: r,
		width: i
	});
	return Object.assign({}, e, {
		box: a,
		overflowLeft: t,
		overflowRight: n
	});
}, S1 = (e, t, n) => (r) => {
	let i = o1(r), a = _1[n] || 0, o = Math.max(0, r.box.width - i), s = n === "justify" || i > r.box.width, c = r.box.x + o * a, l = Object.assign({}, r.box, { x: c }), u = Object.assign({}, r, { box: l });
	return s ? e.justification(t)(u) : u;
}, C1 = (e) => {
	let t = 0, n = 0, r = 0, i = 0, a = e.runs.map((e) => {
		let a = g$(e), o = p$(e), s = m$(e), c = a1(e);
		return r = Math.max(r, a), t = Math.max(t, o), n = Math.max(n, s), i += c, Object.assign({}, e, {
			height: a,
			ascent: o,
			descent: s,
			xAdvance: c
		});
	});
	return Object.assign({}, e, {
		runs: a,
		height: r,
		ascent: t,
		descent: n,
		xAdvance: i
	});
}, w1 = (e, t) => (n, r, i) => {
	let a = r === i.length - 1, o = n.runs?.[0]?.attributes || {}, s = a ? o.alignLastLine : o.align;
	return tJ(C1, e.textDecoration(), S1(e, t, s), x1, v1)(n);
}, T1 = (e, t) => (n) => {
	let r = w1(e, t);
	return n.map((e) => e.map(r));
}, E1 = 65532, D1 = (e) => e.codePoints.includes(E1), O1 = (e) => {
	if (!e.positions) return e;
	let t = e.glyphs || [], n = e.attributes?.attachment;
	if (!n) return e;
	let r = e.positions.map((e, r) => {
		let i = t[r];
		return n.width && D1(i) ? Object.assign({}, e, { xAdvance: n.width }) : Object.assign({}, e);
	});
	return Object.assign({}, e, { positions: r });
}, k1 = () => (e) => {
	let t = e.runs.map(O1);
	return Object.assign({}, e, { runs: t });
}, A1 = (e) => ({
	align: e.align || (e.direction === "rtl" ? "right" : "left"),
	alignLastLine: e.alignLastLine || (e.align === "justify" ? "left" : e.align || "left"),
	attachment: e.attachment || null,
	backgroundColor: e.backgroundColor || null,
	bullet: e.bullet || null,
	characterSpacing: e.characterSpacing || 0,
	color: e.color || "black",
	direction: e.direction || "ltr",
	features: e.features || [],
	fill: e.fill !== !1,
	font: e.font || [],
	fontSize: e.fontSize || 12,
	hangingPunctuation: e.hangingPunctuation || !1,
	hyphenationFactor: e.hyphenationFactor || 0,
	indent: e.indent || 0,
	justificationFactor: e.justificationFactor || 1,
	lineHeight: e.lineHeight || null,
	lineSpacing: e.lineSpacing || 0,
	link: e.link || null,
	marginLeft: e.marginLeft || e.margin || 0,
	marginRight: e.marginRight || e.margin || 0,
	opacity: e.opacity,
	paddingTop: e.paddingTop || e.padding || 0,
	paragraphSpacing: e.paragraphSpacing || 0,
	script: e.script || null,
	shrinkFactor: e.shrinkFactor || 0,
	strike: e.strike || !1,
	strikeColor: e.strikeColor || e.color || "black",
	strikeStyle: e.strikeStyle || "solid",
	stroke: e.stroke || !1,
	underline: e.underline || !1,
	underlineColor: e.underlineColor || e.color || "black",
	underlineStyle: e.underlineStyle || "solid",
	verticalAlign: e.verticalAlign || null,
	wordSpacing: e.wordSpacing || 0,
	yOffset: e.yOffset || 0
}), j1 = (e) => {
	let t = A1(e.attributes);
	return Object.assign({}, e, { attributes: t });
}, M1 = () => (e) => ({
	string: e.string || "",
	runs: (e.runs || []).map(j1)
}), N1 = () => (e) => (e.runs.forEach((e) => {
	let { attributes: t } = e, { verticalAlign: n } = t;
	n === "sub" ? t.yOffset = -.2 : n === "super" && (t.yOffset = .4);
}), e), P1 = EQ(), F1 = (e) => e.reduce((e, t) => {
	let n = t.end - t.start, r = uJ(t.attributes.bidiLevel, n);
	return e.concat(r);
}, []), I1 = () => (e) => {
	let t = F1(e.runs), n = "";
	return e.string.split("").forEach((r, i) => {
		let a = t[i] % 2 == 1 ? P1.getMirroredCharacter(e.string.charAt(i)) : null;
		n += a || r;
	}), {
		...e,
		string: n
	};
}, L1 = (e) => (t, n, r = {}) => {
	let i = tJ(G$(), k1(), N1(), NQ(e, r), U$(), I1(), n1(e));
	return tJ(T1(e, r), L$(), D$(e, r, n), (e) => e.map(i), r1(), M1())(t);
}, R1 = EQ(), z1 = () => (e) => {
	let { string: t } = e, n = e.runs[0]?.attributes.direction, { levels: r } = R1.getEmbeddingLevels(t, n), i = null, a = 0, o = 0, s = [];
	for (let e = 0; e < r.length; e += 1) {
		let t = r[e];
		t !== i && (i !== null && s.push({
			start: a,
			end: o,
			attributes: { bidiLevel: i }
		}), a = o, i = t), o += 1;
	}
	return a < t.length && s.push({
		start: a,
		end: t.length,
		attributes: { bidiLevel: i }
	}), {
		string: t,
		runs: s
	};
}, B1 = 1e4, V1 = (e, t, n) => {
	let r = null, i = Infinity, a = {
		width: 0,
		stretch: 0,
		shrink: 0
	}, o = t[Math.min(n, t.length - 1)], s = (e) => {
		let t = "stretch" in e ? e.stretch : null;
		if (a.width < o) return t && a.stretch - t > 0 ? (o - a.width) / a.stretch : B1;
		let n = "shrink" in e ? e.shrink : null;
		return a.width > o ? n && a.shrink - n > 0 ? (o - a.width) / a.shrink : B1 : 0;
	};
	for (let t = 0; t < e.length; t += 1) {
		let n = e[t];
		if (n.type === "box" && (a.width += n.width), n.type === "glue" && (a.width += n.width, a.stretch += n.stretch, a.shrink += n.shrink), a.width - a.shrink > o) {
			if (r === null) {
				let n = t === 0 ? t + 1 : t;
				for (; n < e.length && (e[n].type === "glue" || e[n].type === "penalty");) n++;
				r = n - 1;
			}
			break;
		}
		if (n.type === "penalty" || n.type === "glue") {
			let e = s(n), a = n.type === "penalty" ? n.penalty : 0, o = 100 * Math.abs(e) ** 3 + a;
			i >= o && (r = t, i = o);
		}
	}
	return a.width - a.shrink > o ? r : null;
}, H1 = (e, t) => {
	let n = 0, r = 0, i = e, a = [0];
	for (; i.length > 0;) {
		let e = V1(i, t, r);
		e === null ? i = [] : (n += e, a.push(n), i = i.slice(e + 1, i.length), n++, r++);
	}
	return a;
}, U1 = class {
	data;
	prev;
	next;
	constructor(e) {
		this.data = e, this.prev = null, this.next = null;
	}
}, W1 = class {
	static Node = U1;
	head;
	tail;
	listSize;
	listLength;
	constructor() {
		this.head = null, this.tail = null, this.listSize = 0, this.listLength = 0;
	}
	isLinked(e) {
		return !(e && e.prev === null && e.next === null && this.tail !== e && this.head !== e || this.isEmpty());
	}
	size() {
		return this.listSize;
	}
	isEmpty() {
		return this.listSize === 0;
	}
	first() {
		return this.head;
	}
	last() {
		return this.last;
	}
	forEach(e) {
		let t = this.head;
		for (; t !== null;) e(t), t = t.next;
	}
	at(e) {
		let t = this.head, n = 0;
		if (e >= this.listLength || e < 0) return null;
		for (; t !== null;) {
			if (e === n) return t;
			t = t.next, n += 1;
		}
		return null;
	}
	insertAfter(e, t) {
		return this.isLinked(e) ? (t.prev = e, t.next = e.next, e.next === null ? this.tail = t : e.next.prev = t, e.next = t, this.listSize += 1, this) : this;
	}
	insertBefore(e, t) {
		return this.isLinked(e) ? (t.prev = e.prev, t.next = e, e.prev === null ? this.head = t : e.prev.next = t, e.prev = t, this.listSize += 1, this) : this;
	}
	push(e) {
		return this.head === null ? this.unshift(e) : this.insertAfter(this.tail, e), this;
	}
	unshift(e) {
		return this.head === null ? (this.head = e, this.tail = e, e.prev = null, e.next = null, this.listSize += 1) : this.insertBefore(this.head, e), this;
	}
	remove(e) {
		return this.isLinked(e) ? (e.prev === null ? this.head = e.next : e.prev.next = e.next, e.next === null ? this.tail = e.prev : e.next.prev = e.prev, --this.listSize, this) : this;
	}
};
function G1(e, t, n, r, i, a) {
	return {
		position: e,
		demerits: t,
		line: n,
		fitnessClass: r,
		totals: i || {
			width: 0,
			stretch: 0,
			shrink: 0
		},
		previous: a
	};
}
function K1(e, t, n, r, i, a) {
	let o = n.width - i.totals.width, s = 0, c = 0, l = a < t.length ? t[a - 1] : t[t.length - 1];
	return e[r].type === "penalty" && (o += e[r].width), o < l ? (s = n.stretch - i.totals.stretch, s > 0 ? (l - o) / s : Y1.infinity) : o > l ? (c = n.shrink - i.totals.shrink, c > 0 ? (l - o) / c : Y1.infinity) : 0;
}
function q1(e, t, n) {
	let r = {
		width: t.width,
		stretch: t.stretch,
		shrink: t.shrink
	};
	for (let t = n; t < e.length; t += 1) {
		let i = e[t];
		if (i.type === "glue") r.width += i.width, r.stretch += i.stretch, r.shrink += i.shrink;
		else if (i.type === "box" || i.type === "penalty" && i.penalty === -Y1.infinity && t > n) break;
	}
	return r;
}
function J1(e) {
	let t = [];
	if (e.size() === 0) return [];
	let n = { data: { demerits: Infinity } };
	for (e.forEach((e) => {
		e.data.demerits < n.data.demerits && (n = e);
	}); n !== null;) t.push(n.data.position), n = n.data.previous;
	return t.reverse();
}
var Y1 = (e, t, n) => {
	let r = {
		demerits: {
			line: 10,
			flagged: 100,
			fitness: 3e3
		},
		tolerance: n || 3
	}, i = new W1(), a = {
		width: 0,
		stretch: 0,
		shrink: 0
	}, o = t;
	i.push(new W1.Node(G1(0, 0, 0, 0, void 0, null)));
	function s(e, t, n) {
		let s = i.first();
		for (; s !== null;) {
			let c = 0, l = [
				{
					active: void 0,
					demerits: Infinity
				},
				{
					active: void 0,
					demerits: Infinity
				},
				{
					active: void 0,
					demerits: Infinity
				},
				{
					active: void 0,
					demerits: Infinity
				}
			];
			for (; s !== null;) {
				c = s.data.line + 1;
				let u = K1(n, o, a, t, s.data, c);
				if ((u < -1 || e.type === "penalty" && e.penalty === -Y1.infinity) && i.remove(s), u >= -1 && u <= r.tolerance) {
					let t = 100 * Math.abs(u) ** 3, i = 0;
					i = e.type === "penalty" && e.penalty >= 0 ? (r.demerits.line + t) ** 2 + e.penalty ** 2 : e.type === "penalty" && e.penalty !== -Y1.infinity ? (r.demerits.line + t) ** 2 - e.penalty ** 2 : (r.demerits.line + t) ** 2, e.type === "penalty" && n[s.data.position].type === "penalty" && (i += r.demerits.flagged * e.flagged * n[s.data.position].flagged);
					let a;
					a = u < -.5 ? 0 : u <= .5 ? 1 : u <= 1 ? 2 : 3, Math.abs(a - s.data.fitnessClass) > 1 && (i += r.demerits.fitness), i += s.data.demerits, i < l[a].demerits && (l[a] = {
						active: s,
						demerits: i
					});
				}
				if (s = s.next, s !== null && s.data.line >= c) break;
			}
			let u = q1(n, a, t);
			for (let e = 0; e < l.length; e += 1) {
				let n = l[e];
				if (n.demerits === Infinity) continue;
				let r = new W1.Node(G1(t, n.demerits, n.active.data.line + 1, e, u, n.active));
				s === null ? i.push(r) : i.insertBefore(s, r);
			}
		}
	}
	return e.forEach((e, t, n) => {
		if (e.type === "box") {
			a.width += e.width;
			return;
		}
		if (e.type === "glue") {
			t > 0 && n[t - 1].type === "box" && s(e, t, n), a.width += e.width, a.stretch += e.stretch, a.shrink += e.shrink;
			return;
		}
		e.type === "penalty" && e.penalty !== Y1.infinity && s(e, t, n);
	}), J1(i);
};
Y1.infinity = 1e4, Y1.glue = (e, t, n, r, i) => ({
	type: "glue",
	start: t,
	end: n,
	width: e,
	stretch: r,
	shrink: i
}), Y1.box = (e, t, n, r = !1) => ({
	type: "box",
	width: e,
	start: t,
	end: n,
	hyphenated: r
}), Y1.penalty = (e, t, n) => ({
	type: "penalty",
	width: e,
	penalty: t,
	flagged: n
});
var X1 = (e, t) => {
	let n = t.start + e, r = t.end + e;
	return Object.assign({}, t, {
		start: n,
		end: r
	});
}, Z1 = (e) => e.end - e.start, Q1 = (e, t) => {
	let n = e.end + Z1(t), r = (e.glyphs || []).concat(t.glyphs || []), i = (e.positions || []).concat(t.positions || []), a = Object.assign({}, e.attributes, t.attributes), o = e.glyphIndices || [], s = aJ(o) || 0, c = (t.glyphIndices || []).map((e) => e + s + 1), l = WQ(o.concat(c));
	return Object.assign({}, e, {
		end: n,
		glyphs: r,
		positions: i,
		attributes: a,
		glyphIndices: l
	});
}, $1 = (e, t, n) => {
	if (!t) return n;
	let r = GQ(0, e, n), i = GQ(e, Infinity, n);
	return Q1(a$(t, r), i);
}, e0 = (e, t, n) => {
	let r = VQ(n);
	return $1(e, t$(t) ? r$(t, r) : t, n);
}, t0 = (e, t) => KQ(e, t.runs), n0 = (e, t, n) => {
	let r = t0(e, n);
	if (r === -1) return s$(t, n);
	let i = [t], a = n.string.slice(0, e) + o$(i) + n.string.slice(e), o = n.runs.map((n, a) => a === r ? e0(e - n.start, t, n) : a > r ? X1(i.length, n) : n);
	return Object.assign({}, n, {
		string: a,
		runs: o
	});
}, r0 = (e, t, n) => {
	let r = n.start || 0, i = Math.max(0, UQ(e - r, n)), a = Math.max(0, UQ(t - r, n));
	return i1((n.positions || []).slice(i, a));
}, i0 = (e, t, n) => qQ(e, t, n.runs).reduce((n, r) => n + r0(e, t, r), 0), a0 = 45, o0 = 5, s0 = 50, c0 = {
	width: 3,
	stretch: 6,
	shrink: 9
}, l0 = (e, t, n) => {
	let r = 0, i = null, a = n.reduce((n, a) => {
		let o = t[a], s = t[a - 1];
		if (a === t.length - 1) return n;
		let c;
		return o.type === "penalty" ? (i = s.end, c = XQ(r, i, e), c = n0(c.string.length, a0, c)) : (i = o.end, c = XQ(r, i, e)), r = i, [...n, c];
	}, []);
	return a.push(XQ(r, e.string.length, e)), a;
}, u0 = (e, { align: t }, n) => {
	let r = 0, { syllables: i } = e, a = n.hyphenationPenalty || (t === "justify" ? 100 : 600), o = i.reduce((t, n, o) => {
		let s = i0(r, r + n.length, e);
		if (n.trim() === "") {
			let e = s * c0.width / c0.stretch, i = s * c0.width / c0.shrink, a = r + n.length;
			t.push(Y1.glue(s, r, a, e, i));
		} else {
			let e = i[o + 1] !== " ", c = r + n.length;
			t.push(Y1.box(s, r, c, e)), i[o + 1] && e && t.push(Y1.penalty(5, a, 1));
		}
		return r += n.length, t;
	}, []);
	return o.push(Y1.glue(0, r, r, Y1.infinity, 0)), o.push(Y1.penalty(0, -Y1.infinity, 1)), o;
}, d0 = (e) => e.runs?.[0]?.attributes || {}, f0 = (e) => (t, n) => {
	let r = e.tolerance || 4, i = u0(t, d0(t), e), a = Y1(i, n, r);
	for (; a.length === 0 && r < s0;) r += o0, a = Y1(i, n, r);
	return (a.length === 0 || a.length === 1 && a[0] === 0) && (a = H1(i, n)), l0(t, i, a.slice(1));
}, p0;
(function(e) {
	e[e.GROW = 0] = "GROW", e[e.SHRINK = 1] = "SHRINK";
})(p0 ||= {});
var m0 = 1, h0 = 2, g0 = {
	before: .5,
	after: .5,
	priority: m0,
	unconstrained: !1
}, _0 = {
	before: .14453125,
	after: .14453125,
	priority: h0,
	unconstrained: !1
}, v0 = {
	before: -.04296875,
	after: -.04296875,
	priority: m0,
	unconstrained: !1
}, y0 = {
	before: -.04296875,
	after: -.04296875,
	priority: h0,
	unconstrained: !1
}, b0 = (e, t) => {
	let n = t.expandCharFactor || {}, r = t.shrinkCharFactor || {};
	return e === p0.GROW ? Object.assign({}, _0, n) : Object.assign({}, y0, r);
}, x0 = (e, t) => {
	let n = t.expandWhitespaceFactor || {}, r = t.shrinkWhitespaceFactor || {};
	return e === p0.GROW ? Object.assign({}, g0, n) : Object.assign({}, v0, r);
}, S0 = (e, t) => (n) => {
	let r = b0(e, t), i = x0(e, t), a = [];
	for (let e = 0; e < n.length; e += 1) {
		let t, o = n[e];
		c1(o) ? (t = Object.assign({}, i), e === n.length - 1 && (t.before = 0, e > 0 && (a[e - 1].after = 0))) : o.isMark && e > 0 ? (t = Object.assign({}, a[e - 1]), t.before = 0, a[e - 1].after = 0) : t = Object.assign({}, r), a.push(t);
	}
	return a;
}, C0 = (e, t, n) => {
	let r = S0(e > 0 ? p0.GROW : p0.SHRINK, n), i = t.runs.reduce((e, t) => e.concat(r(t.glyphs)), []);
	return i[0].before = 0, i[i.length - 1].after = 0, i;
}, w0 = 0, T0 = 3, E0 = (e, t) => {
	let n = 0, r = [], i = [];
	for (let e = w0; e <= T0; e += 1) r[e] = i[e] = 0;
	for (let e = 0; e < t.length; e += 1) {
		let a = t[e], o = a.before + a.after;
		n += o, r[a.priority] += o, a.unconstrained && (i[a.priority] += o);
	}
	let a = -1, o = 0, s = e, c;
	for (c = w0; c <= T0; c += 1) {
		let e = r[c];
		if (e !== 0) {
			if (a === -1 && (a = c, o = e), Math.abs(s) <= Math.abs(e)) {
				r[c] = s / e, i[c] = 0, s = 0;
				break;
			}
			if (r[c] = 1, s -= e, i[c] !== 0) {
				i[c] = s / i[c], s = 0;
				break;
			}
		}
	}
	for (let e = c + 1; e <= T0; e += 1) r[e] = 0, i[e] = 0;
	s > 0 && a > -1 && (r[a] = (o + (e - n)) / o);
	let l = [];
	for (let e = 0; e < t.length; e += 1) {
		let n = t[e], a = t[e + 1], o = n.after * r[n.priority];
		a && (o += a.before * r[a.priority]), n.unconstrained && (o += n.after * i[n.priority], a && (o += a.before * i[a.priority])), l.push(o);
	}
	return l;
}, D0 = (e, t) => {
	let n = 0;
	for (let r of t.runs) for (let t of r.positions) t.xAdvance += e[n++];
	return t;
}, O0 = (e) => (t) => {
	let n = t.box.width - o1(t);
	return n === 0 ? t : D0(E0(n, C0(n, t, e)), t);
}, k0 = (e) => e.runs.reduce((e, t) => Math.max(e, p$(t)), 0), A0 = 12, j0 = () => (e) => {
	let t = e.overflowLeft || 0, n = e.overflowRight || 0, r = o1(e) - n;
	e.decorationLines = [];
	for (let n = 0; n < e.runs.length; n += 1) {
		let i = e.runs[n], a = Math.min(r - t, a1(i)), o = Math.max(.5, Math.floor(i.attributes.fontSize / A0));
		if (i.attributes.underline) {
			let n = {
				rect: {
					x: t,
					y: k0(e) + o * 2,
					width: a,
					height: o
				},
				opacity: i.attributes.opacity,
				color: i.attributes.underlineColor || "black",
				style: i.attributes.underlineStyle || "solid"
			};
			e.decorationLines.push(n);
		}
		if (i.attributes.strike) {
			let n = k0(e) - p$(i) / 3, r = {
				rect: {
					x: t,
					y: n,
					width: a,
					height: o
				},
				opacity: i.attributes.opacity,
				color: i.attributes.strikeColor || "black",
				style: i.attributes.strikeStyle || "solid"
			};
			e.decorationLines.push(r);
		}
		t += a;
	}
	return e;
}, M0 = [
	"Common",
	"Inherited",
	"Unknown"
], N0 = () => (e) => {
	let { string: t } = e, n = "Unknown", r = 0, i = 0, a = [];
	if (!t) return e1();
	for (let e = 0; e < t.length; e += 1) {
		let o = t[e], s = o.codePointAt(0), c = lb.getScript(s);
		c !== n && !M0.includes(c) && (n !== "Unknown" && a.push({
			start: r,
			end: i,
			attributes: { script: n }
		}), r = i, n = c), i += o.length;
	}
	return r < t.length && a.push({
		start: r,
		end: t.length,
		attributes: { script: n }
	}), {
		string: t,
		runs: a
	};
}, P0 = "­", F0 = (0, kQ.default)(AQ.default), I0 = (e) => e.split(P0), L0 = {}, R0 = (e) => I0(e.includes(P0) ? e : F0(e)), z0 = () => (e) => {
	let t = `_${e}`;
	return iJ(e) ? [] : (L0[t] || (L0[t] = R0(e)), L0[t]);
}, B0 = [173], V0 = (e) => e.attributes.fontSize || 12, H0 = (e, t, n) => {
	let r = [...t, n];
	for (let t = 0; t < r.length; t += 1) {
		let n = r[t];
		if (!B0.includes(e) && n && n.hasGlyphForCodePoint && n.hasGlyphForCodePoint(e)) return n;
	}
	return t.at(-1);
}, U0 = () => ({ string: e, runs: t }) => {
	let n = null, r = null, i = 0, a = 0, o = [];
	for (let s = 0; s < t.length; s += 1) {
		let c = t[s];
		if (e.length === 0) {
			o.push({
				start: 0,
				end: 0,
				attributes: { font: c.attributes.font }
			});
			break;
		}
		let l = e.slice(c.start, c.end);
		for (let e = 0; e < l.length; e += 1) {
			let t = l[e], s = H0(t.codePointAt(0), c.attributes.font, n), u = V0(c);
			(s !== n || u !== r || s.unitsPerEm !== n.unitsPerEm) && (n && o.push({
				start: i,
				end: a,
				attributes: {
					font: [n],
					scale: r / n.unitsPerEm
				}
			}), n = s, r = u, i = a), a += t.length;
		}
	}
	if (i < e.length) {
		let r = V0(aJ(t));
		o.push({
			start: i,
			end: e.length,
			attributes: {
				font: [n],
				scale: r / n.unitsPerEm
			}
		});
	}
	return {
		string: e,
		runs: o
	};
};
(() => {
	var e = import.meta.url;
	return (function(t) {
		t ||= {};
		var n;
		n ||= t === void 0 ? {} : t;
		var r, i;
		n.ready = new Promise(function(e, t) {
			r = e, i = t;
		});
		var a = Object.assign({}, n), o = "";
		typeof document < "u" && document.currentScript && (o = document.currentScript.src), e && (o = e), o = o.indexOf("blob:") === 0 ? "" : o.substr(0, o.replace(/[?#].*/, "").lastIndexOf("/") + 1);
		var s = n.print || console.log.bind(console), c = n.printErr || console.warn.bind(console);
		Object.assign(n, a), a = null;
		var l;
		n.wasmBinary && (l = n.wasmBinary), n.noExitRuntime, typeof WebAssembly != "object" && j("no native wasm support detected");
		var u, d = !1;
		function f(e, t, n) {
			n = t + n;
			for (var r = ""; !(t >= n);) {
				var i = e[t++];
				if (!i) break;
				if (i & 128) {
					var a = e[t++] & 63;
					if ((i & 224) == 192) r += String.fromCharCode((i & 31) << 6 | a);
					else {
						var o = e[t++] & 63;
						i = (i & 240) == 224 ? (i & 15) << 12 | a << 6 | o : (i & 7) << 18 | a << 12 | o << 6 | e[t++] & 63, 65536 > i ? r += String.fromCharCode(i) : (i -= 65536, r += String.fromCharCode(55296 | i >> 10, 56320 | i & 1023));
					}
				} else r += String.fromCharCode(i);
			}
			return r;
		}
		var p, m, h, g, _, v, y, b, x;
		function S() {
			var e = u.buffer;
			p = e, n.HEAP8 = m = new Int8Array(e), n.HEAP16 = g = new Int16Array(e), n.HEAP32 = v = new Int32Array(e), n.HEAPU8 = h = new Uint8Array(e), n.HEAPU16 = _ = new Uint16Array(e), n.HEAPU32 = y = new Uint32Array(e), n.HEAPF32 = b = new Float32Array(e), n.HEAPF64 = x = new Float64Array(e);
		}
		var C, w = [], T = [], E = [];
		function D() {
			var e = n.preRun.shift();
			w.unshift(e);
		}
		var O = 0, k = null, A = null;
		function j(e) {
			throw n.onAbort && n.onAbort(e), e = "Aborted(" + e + ")", c(e), d = !0, e = new WebAssembly.RuntimeError(e + ". Build with -sASSERTIONS for more info."), i(e), e;
		}
		function M(e) {
			return e.startsWith("data:application/octet-stream;base64,");
		}
		var ee = "data:application/octet-stream;base64,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";
		if (!M(ee)) {
			var te = ee;
			ee = n.locateFile ? n.locateFile(te, o) : o + te;
		}
		function ne() {
			var e = ee;
			try {
				if (e == ee && l) return new Uint8Array(l);
				if (M(e)) try {
					var t = _t(e.slice(37)), n = new Uint8Array(t.length);
					for (e = 0; e < t.length; ++e) n[e] = t.charCodeAt(e);
					var r = n;
				} catch {
					throw Error("Converting base64 string to bytes failed.");
				}
				else r = void 0;
				var i = r;
				if (i) return i;
				throw "both async and sync fetching of the wasm failed";
			} catch (e) {
				j(e);
			}
		}
		function re() {
			return l || typeof fetch != "function" ? Promise.resolve().then(function() {
				return ne();
			}) : fetch(ee, { credentials: "same-origin" }).then(function(e) {
				if (!e.ok) throw "failed to load wasm binary file at '" + ee + "'";
				return e.arrayBuffer();
			}).catch(function() {
				return ne();
			});
		}
		function ie(e) {
			for (; 0 < e.length;) e.shift()(n);
		}
		function ae(e) {
			if (e === void 0) return "_unknown";
			e = e.replace(/[^a-zA-Z0-9_]/g, "$");
			var t = e.charCodeAt(0);
			return 48 <= t && 57 >= t ? "_" + e : e;
		}
		function oe(e, t) {
			return e = ae(e), function() {
				return t.apply(this, arguments);
			};
		}
		var se = [
			{},
			{ value: void 0 },
			{ value: null },
			{ value: !0 },
			{ value: !1 }
		], ce = [];
		function le(e) {
			var t = Error, n = oe(e, function(t) {
				this.name = e, this.message = t, t = Error(t).stack, t !== void 0 && (this.stack = this.toString() + "\n" + t.replace(/^Error(:[^\n]*)?\n/, ""));
			});
			return n.prototype = Object.create(t.prototype), n.prototype.constructor = n, n.prototype.toString = function() {
				return this.message === void 0 ? this.name : this.name + ": " + this.message;
			}, n;
		}
		var N = void 0;
		function P(e) {
			throw new N(e);
		}
		var ue = (e) => (e || P("Cannot use deleted val. handle = " + e), se[e].value), de = (e) => {
			switch (e) {
				case void 0: return 1;
				case null: return 2;
				case !0: return 3;
				case !1: return 4;
				default:
					var t = ce.length ? ce.pop() : se.length;
					return se[t] = {
						ga: 1,
						value: e
					}, t;
			}
		}, fe = void 0, pe = void 0;
		function me(e) {
			for (var t = ""; h[e];) t += pe[h[e++]];
			return t;
		}
		var F = [];
		function I() {
			for (; F.length;) {
				var e = F.pop();
				e.M.$ = !1, e.delete();
			}
		}
		var he = void 0, L = {};
		function ge(e, t) {
			for (t === void 0 && P("ptr should not be undefined"); e.R;) t = e.ba(t), e = e.R;
			return t;
		}
		var _e = {};
		function ve(e) {
			e = V(e);
			var t = me(e);
			return bt(e), t;
		}
		function ye(e, t) {
			var n = _e[e];
			return n === void 0 && P(t + " has unknown type " + ve(e)), n;
		}
		function be() {}
		var R = !1;
		function xe(e) {
			--e.count.value, e.count.value === 0 && (e.T ? e.U.W(e.T) : e.P.N.W(e.O));
		}
		function z(e, t, n) {
			return t === n ? e : n.R === void 0 ? null : (e = z(e, t, n.R), e === null ? null : n.na(e));
		}
		var B = {};
		function Se(e, t) {
			return t = ge(e, t), L[t];
		}
		var Ce = void 0;
		function we(e) {
			throw new Ce(e);
		}
		function Te(e, t) {
			return t.P && t.O || we("makeClassHandle requires ptr and ptrType"), !!t.U != !!t.T && we("Both smartPtrType and smartPtr must be specified"), t.count = { value: 1 }, Ee(Object.create(e, { M: { value: t } }));
		}
		function Ee(e) {
			return typeof FinalizationRegistry > "u" ? (Ee = (e) => e, e) : (R = new FinalizationRegistry((e) => {
				xe(e.M);
			}), Ee = (e) => {
				var t = e.M;
				return t.T && R.register(e, { M: t }, e), e;
			}, be = (e) => {
				R.unregister(e);
			}, Ee(e));
		}
		var De = {};
		function Oe(e) {
			for (; e.length;) {
				var t = e.pop();
				e.pop()(t);
			}
		}
		function ke(e) {
			return this.fromWireType(v[e >> 2]);
		}
		var Ae = {}, je = {};
		function Me(e, t, n) {
			function r(t) {
				t = n(t), t.length !== e.length && we("Mismatched type converter count");
				for (var r = 0; r < e.length; ++r) Pe(e[r], t[r]);
			}
			e.forEach(function(e) {
				je[e] = t;
			});
			var i = Array(t.length), a = [], o = 0;
			t.forEach((e, t) => {
				_e.hasOwnProperty(e) ? i[t] = _e[e] : (a.push(e), Ae.hasOwnProperty(e) || (Ae[e] = []), Ae[e].push(() => {
					i[t] = _e[e], ++o, o === a.length && r(i);
				}));
			}), a.length === 0 && r(i);
		}
		function Ne(e) {
			switch (e) {
				case 1: return 0;
				case 2: return 1;
				case 4: return 2;
				case 8: return 3;
				default: throw TypeError("Unknown type size: " + e);
			}
		}
		function Pe(e, t, n = {}) {
			if (!("argPackAdvance" in t)) throw TypeError("registerType registeredInstance requires argPackAdvance");
			var r = t.name;
			if (e || P("type \"" + r + "\" must have a positive integer typeid pointer"), _e.hasOwnProperty(e)) {
				if (n.ua) return;
				P("Cannot register type '" + r + "' twice");
			}
			_e[e] = t, delete je[e], Ae.hasOwnProperty(e) && (t = Ae[e], delete Ae[e], t.forEach((e) => e()));
		}
		function Fe(e) {
			P(e.M.P.N.name + " instance already deleted");
		}
		function Ie() {}
		function Le(e, t, n) {
			if (e[t].S === void 0) {
				var r = e[t];
				e[t] = function() {
					return e[t].S.hasOwnProperty(arguments.length) || P("Function '" + n + "' called with an invalid number of arguments (" + arguments.length + ") - expects one of (" + e[t].S + ")!"), e[t].S[arguments.length].apply(this, arguments);
				}, e[t].S = [], e[t].S[r.Z] = r;
			}
		}
		function Re(e, t) {
			n.hasOwnProperty(e) ? (P("Cannot register public name '" + e + "' twice"), Le(n, e, e), n.hasOwnProperty(void 0) && P("Cannot register multiple overloads of a function with the same number of arguments (undefined)!"), n[e].S[void 0] = t) : n[e] = t;
		}
		function ze(e, t, n, r, i, a, o, s) {
			this.name = e, this.constructor = t, this.X = n, this.W = r, this.R = i, this.pa = a, this.ba = o, this.na = s, this.ja = [];
		}
		function Be(e, t, n) {
			for (; t !== n;) t.ba || P("Expected null or instance of " + n.name + ", got an instance of " + t.name), e = t.ba(e), t = t.R;
			return e;
		}
		function Ve(e, t) {
			return t === null ? (this.ea && P("null is not a valid " + this.name), 0) : (t.M || P("Cannot pass \"" + $e(t) + "\" as a " + this.name), t.M.O || P("Cannot pass deleted object as a pointer of type " + this.name), Be(t.M.O, t.M.P.N, this.N));
		}
		function He(e, t) {
			if (t === null) {
				if (this.ea && P("null is not a valid " + this.name), this.da) {
					var n = this.fa();
					return e !== null && e.push(this.W, n), n;
				}
				return 0;
			}
			if (t.M || P("Cannot pass \"" + $e(t) + "\" as a " + this.name), t.M.O || P("Cannot pass deleted object as a pointer of type " + this.name), !this.ca && t.M.P.ca && P("Cannot convert argument of type " + (t.M.U ? t.M.U.name : t.M.P.name) + " to parameter type " + this.name), n = Be(t.M.O, t.M.P.N, this.N), this.da) switch (t.M.T === void 0 && P("Passing raw pointer to smart pointer is illegal"), this.Ba) {
				case 0:
					t.M.U === this ? n = t.M.T : P("Cannot convert argument of type " + (t.M.U ? t.M.U.name : t.M.P.name) + " to parameter type " + this.name);
					break;
				case 1:
					n = t.M.T;
					break;
				case 2:
					if (t.M.U === this) n = t.M.T;
					else {
						var r = t.clone();
						n = this.xa(n, de(function() {
							r.delete();
						})), e !== null && e.push(this.W, n);
					}
					break;
				default: P("Unsupporting sharing policy");
			}
			return n;
		}
		function Ue(e, t) {
			return t === null ? (this.ea && P("null is not a valid " + this.name), 0) : (t.M || P("Cannot pass \"" + $e(t) + "\" as a " + this.name), t.M.O || P("Cannot pass deleted object as a pointer of type " + this.name), t.M.P.ca && P("Cannot convert argument of type " + t.M.P.name + " to parameter type " + this.name), Be(t.M.O, t.M.P.N, this.N));
		}
		function We(e, t, n, r) {
			this.name = e, this.N = t, this.ea = n, this.ca = r, this.da = !1, this.W = this.xa = this.fa = this.ka = this.Ba = this.wa = void 0, t.R === void 0 ? (this.toWireType = r ? Ve : Ue, this.V = null) : this.toWireType = He;
		}
		function Ge(e, t) {
			n.hasOwnProperty(e) || we("Replacing nonexistant public symbol"), n[e] = t, n[e].Z = void 0;
		}
		function Ke(e, t) {
			var r = [];
			return function() {
				if (r.length = 0, Object.assign(r, arguments), e.includes("j")) {
					var i = n["dynCall_" + e];
					i = r && r.length ? i.apply(null, [t].concat(r)) : i.call(null, t);
				} else i = C.get(t).apply(null, r);
				return i;
			};
		}
		function qe(e, t) {
			e = me(e);
			var n = e.includes("j") ? Ke(e, t) : C.get(t);
			return typeof n != "function" && P("unknown function pointer with signature " + e + ": " + t), n;
		}
		var Je = void 0;
		function Ye(e, t) {
			function n(e) {
				i[e] || _e[e] || (je[e] ? je[e].forEach(n) : (r.push(e), i[e] = !0));
			}
			var r = [], i = {};
			throw t.forEach(n), new Je(e + ": " + r.map(ve).join([", "]));
		}
		function Xe(e, t, n, r, i) {
			var a = t.length;
			2 > a && P("argTypes array size mismatch! Must at least get return value and 'this' types!");
			var o = t[1] !== null && n !== null, s = !1;
			for (n = 1; n < t.length; ++n) if (t[n] !== null && t[n].V === void 0) {
				s = !0;
				break;
			}
			var c = t[0].name !== "void", l = a - 2, u = Array(l), d = [], f = [];
			return function() {
				if (arguments.length !== l && P("function " + e + " called with " + arguments.length + " arguments, expected " + l + " args!"), f.length = 0, d.length = o ? 2 : 1, d[0] = i, o) {
					var n = t[1].toWireType(f, this);
					d[1] = n;
				}
				for (var a = 0; a < l; ++a) u[a] = t[a + 2].toWireType(f, arguments[a]), d.push(u[a]);
				if (a = r.apply(null, d), s) Oe(f);
				else for (var p = o ? 1 : 2; p < t.length; p++) {
					var m = p === 1 ? n : u[p - 2];
					t[p].V !== null && t[p].V(m);
				}
				return n = c ? t[0].fromWireType(a) : void 0, n;
			};
		}
		function Ze(e, t) {
			for (var n = [], r = 0; r < e; r++) n.push(y[t + 4 * r >> 2]);
			return n;
		}
		function Qe(e) {
			4 < e && --se[e].ga === 0 && (se[e] = void 0, ce.push(e));
		}
		function $e(e) {
			if (e === null) return "null";
			var t = typeof e;
			return t === "object" || t === "array" || t === "function" ? e.toString() : "" + e;
		}
		function et(e, t) {
			switch (t) {
				case 2: return function(e) {
					return this.fromWireType(b[e >> 2]);
				};
				case 3: return function(e) {
					return this.fromWireType(x[e >> 3]);
				};
				default: throw TypeError("Unknown float type: " + e);
			}
		}
		function tt(e, t, n) {
			switch (t) {
				case 0: return n ? function(e) {
					return m[e];
				} : function(e) {
					return h[e];
				};
				case 1: return n ? function(e) {
					return g[e >> 1];
				} : function(e) {
					return _[e >> 1];
				};
				case 2: return n ? function(e) {
					return v[e >> 2];
				} : function(e) {
					return y[e >> 2];
				};
				default: throw TypeError("Unknown integer type: " + e);
			}
		}
		function nt(e, t) {
			for (var n = "", r = 0; !(r >= t / 2); ++r) {
				var i = g[e + 2 * r >> 1];
				if (i == 0) break;
				n += String.fromCharCode(i);
			}
			return n;
		}
		function rt(e, t, n) {
			if (n === void 0 && (n = 2147483647), 2 > n) return 0;
			n -= 2;
			var r = t;
			n = n < 2 * e.length ? n / 2 : e.length;
			for (var i = 0; i < n; ++i) g[t >> 1] = e.charCodeAt(i), t += 2;
			return g[t >> 1] = 0, t - r;
		}
		function it(e) {
			return 2 * e.length;
		}
		function at(e, t) {
			for (var n = 0, r = ""; !(n >= t / 4);) {
				var i = v[e + 4 * n >> 2];
				if (i == 0) break;
				++n, 65536 <= i ? (i -= 65536, r += String.fromCharCode(55296 | i >> 10, 56320 | i & 1023)) : r += String.fromCharCode(i);
			}
			return r;
		}
		function ot(e, t, n) {
			if (n === void 0 && (n = 2147483647), 4 > n) return 0;
			var r = t;
			n = r + n - 4;
			for (var i = 0; i < e.length; ++i) {
				var a = e.charCodeAt(i);
				if (55296 <= a && 57343 >= a) {
					var o = e.charCodeAt(++i);
					a = 65536 + ((a & 1023) << 10) | o & 1023;
				}
				if (v[t >> 2] = a, t += 4, t + 4 > n) break;
			}
			return v[t >> 2] = 0, t - r;
		}
		function st(e) {
			for (var t = 0, n = 0; n < e.length; ++n) {
				var r = e.charCodeAt(n);
				55296 <= r && 57343 >= r && ++n, t += 4;
			}
			return t;
		}
		var ct = {};
		function lt(e) {
			var t = ct[e];
			return t === void 0 ? me(e) : t;
		}
		var ut = [];
		function dt(e) {
			var t = ut.length;
			return ut.push(e), t;
		}
		function ft(e, t) {
			for (var n = Array(e), r = 0; r < e; ++r) n[r] = ye(y[t + 4 * r >> 2], "parameter " + r);
			return n;
		}
		var pt = [], mt = [
			null,
			[],
			[]
		];
		N = n.BindingError = le("BindingError"), n.count_emval_handles = function() {
			for (var e = 0, t = 5; t < se.length; ++t) se[t] !== void 0 && ++e;
			return e;
		}, n.get_first_emval = function() {
			for (var e = 5; e < se.length; ++e) if (se[e] !== void 0) return se[e];
			return null;
		}, fe = n.PureVirtualError = le("PureVirtualError");
		for (var ht = Array(256), gt = 0; 256 > gt; ++gt) ht[gt] = String.fromCharCode(gt);
		pe = ht, n.getInheritedInstanceCount = function() {
			return Object.keys(L).length;
		}, n.getLiveInheritedInstances = function() {
			var e = [], t;
			for (t in L) L.hasOwnProperty(t) && e.push(L[t]);
			return e;
		}, n.flushPendingDeletes = I, n.setDelayFunction = function(e) {
			he = e, F.length && he && he(I);
		}, Ce = n.InternalError = le("InternalError"), Ie.prototype.isAliasOf = function(e) {
			if (!(this instanceof Ie && e instanceof Ie)) return !1;
			var t = this.M.P.N, n = this.M.O, r = e.M.P.N;
			for (e = e.M.O; t.R;) n = t.ba(n), t = t.R;
			for (; r.R;) e = r.ba(e), r = r.R;
			return t === r && n === e;
		}, Ie.prototype.clone = function() {
			if (this.M.O || Fe(this), this.M.aa) return this.M.count.value += 1, this;
			var e = Ee, t = Object, n = t.create, r = Object.getPrototypeOf(this), i = this.M;
			return e = e(n.call(t, r, { M: { value: {
				count: i.count,
				$: i.$,
				aa: i.aa,
				O: i.O,
				P: i.P,
				T: i.T,
				U: i.U
			} } })), e.M.count.value += 1, e.M.$ = !1, e;
		}, Ie.prototype.delete = function() {
			this.M.O || Fe(this), this.M.$ && !this.M.aa && P("Object already scheduled for deletion"), be(this), xe(this.M), this.M.aa || (this.M.T = void 0, this.M.O = void 0);
		}, Ie.prototype.isDeleted = function() {
			return !this.M.O;
		}, Ie.prototype.deleteLater = function() {
			return this.M.O || Fe(this), this.M.$ && !this.M.aa && P("Object already scheduled for deletion"), F.push(this), F.length === 1 && he && he(I), this.M.$ = !0, this;
		}, We.prototype.qa = function(e) {
			return this.ka && (e = this.ka(e)), e;
		}, We.prototype.ha = function(e) {
			this.W && this.W(e);
		}, We.prototype.argPackAdvance = 8, We.prototype.readValueFromPointer = ke, We.prototype.deleteObject = function(e) {
			e !== null && e.delete();
		}, We.prototype.fromWireType = function(e) {
			function t() {
				return this.da ? Te(this.N.X, {
					P: this.wa,
					O: n,
					U: this,
					T: e
				}) : Te(this.N.X, {
					P: this,
					O: e
				});
			}
			var n = this.qa(e);
			if (!n) return this.ha(e), null;
			var r = Se(this.N, n);
			if (r !== void 0) return r.M.count.value === 0 ? (r.M.O = n, r.M.T = e, r.clone()) : (r = r.clone(), this.ha(e), r);
			if (r = this.N.pa(n), r = B[r], !r) return t.call(this);
			r = this.ca ? r.la : r.pointerType;
			var i = z(n, this.N, r.N);
			return i === null ? t.call(this) : this.da ? Te(r.N.X, {
				P: r,
				O: i,
				U: this,
				T: e
			}) : Te(r.N.X, {
				P: r,
				O: i
			});
		}, Je = n.UnboundTypeError = le("UnboundTypeError");
		var _t = typeof atob == "function" ? atob : function(e) {
			var t = "", n = 0;
			e = e.replace(/[^A-Za-z0-9\+\/=]/g, "");
			do {
				var r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(e.charAt(n++)), i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(e.charAt(n++)), a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(e.charAt(n++)), o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(e.charAt(n++));
				r = r << 2 | i >> 4, i = (i & 15) << 4 | a >> 2;
				var s = (a & 3) << 6 | o;
				t += String.fromCharCode(r), a !== 64 && (t += String.fromCharCode(i)), o !== 64 && (t += String.fromCharCode(s));
			} while (n < e.length);
			return t;
		}, vt = {
			l: function(e, t, n, r) {
				j("Assertion failed: " + (e ? f(h, e) : "") + ", at: " + [
					t ? t ? f(h, t) : "" : "unknown filename",
					n,
					r ? r ? f(h, r) : "" : "unknown function"
				]);
			},
			q: function(e, t, n) {
				e = me(e), t = ye(t, "wrapper"), n = ue(n);
				var r = [].slice, i = t.N, a = i.X, o = i.R.X, s = i.R.constructor;
				for (var c in e = oe(e, function() {
					i.R.ja.forEach(function(e) {
						if (this[e] === o[e]) throw new fe("Pure virtual function " + e + " must be implemented in JavaScript");
					}.bind(this)), Object.defineProperty(this, "__parent", { value: a }), this.__construct.apply(this, r.call(arguments));
				}), a.__construct = function() {
					this === a && P("Pass correct 'this' to __construct");
					var e = s.implement.apply(void 0, [this].concat(r.call(arguments)));
					be(e);
					var t = e.M;
					e.notifyOnDestruction(), t.aa = !0, Object.defineProperties(this, { M: { value: t } }), Ee(this), e = t.O, e = ge(i, e), L.hasOwnProperty(e) ? P("Tried to register registered instance: " + e) : L[e] = this;
				}, a.__destruct = function() {
					this === a && P("Pass correct 'this' to __destruct"), be(this);
					var e = this.M.O;
					e = ge(i, e), L.hasOwnProperty(e) ? delete L[e] : P("Tried to unregister unregistered instance: " + e);
				}, e.prototype = Object.create(a), n) e.prototype[c] = n[c];
				return de(e);
			},
			j: function(e) {
				var t = De[e];
				delete De[e];
				var n = t.fa, r = t.W, i = t.ia, a = i.map((e) => e.ta).concat(i.map((e) => e.za));
				Me([e], a, (e) => {
					var a = {};
					return i.forEach((t, n) => {
						var r = e[n], o = t.ra, s = t.sa, c = e[n + i.length], l = t.ya, u = t.Aa;
						a[t.oa] = {
							read: (e) => r.fromWireType(o(s, e)),
							write: (e, t) => {
								var n = [];
								l(u, e, c.toWireType(n, t)), Oe(n);
							}
						};
					}), [{
						name: t.name,
						fromWireType: function(e) {
							var t = {}, n;
							for (n in a) t[n] = a[n].read(e);
							return r(e), t;
						},
						toWireType: function(e, t) {
							for (var i in a) if (!(i in t)) throw TypeError("Missing field:  \"" + i + "\"");
							var o = n();
							for (i in a) a[i].write(o, t[i]);
							return e !== null && e.push(r, o), o;
						},
						argPackAdvance: 8,
						readValueFromPointer: ke,
						V: r
					}];
				});
			},
			v: function() {},
			B: function(e, t, n, r, i) {
				var a = Ne(n);
				t = me(t), Pe(e, {
					name: t,
					fromWireType: function(e) {
						return !!e;
					},
					toWireType: function(e, t) {
						return t ? r : i;
					},
					argPackAdvance: 8,
					readValueFromPointer: function(e) {
						if (n === 1) var r = m;
						else if (n === 2) r = g;
						else if (n === 4) r = v;
						else throw TypeError("Unknown boolean type size: " + t);
						return this.fromWireType(r[e >> a]);
					},
					V: null
				});
			},
			f: function(e, t, n, r, i, a, o, s, c, l, u, d, f) {
				u = me(u), a = qe(i, a), s &&= qe(o, s), l &&= qe(c, l), f = qe(d, f);
				var p = ae(u);
				Re(p, function() {
					Ye("Cannot construct " + u + " due to unbound types", [r]);
				}), Me([
					e,
					t,
					n
				], r ? [r] : [], function(t) {
					if (t = t[0], r) var n = t.N, i = n.X;
					else i = Ie.prototype;
					t = oe(p, function() {
						if (Object.getPrototypeOf(this) !== o) throw new N("Use 'new' to construct " + u);
						if (c.Y === void 0) throw new N(u + " has no accessible constructor");
						var e = c.Y[arguments.length];
						if (e === void 0) throw new N("Tried to invoke ctor of " + u + " with invalid number of parameters (" + arguments.length + ") - expected (" + Object.keys(c.Y).toString() + ") parameters instead!");
						return e.apply(this, arguments);
					});
					var o = Object.create(i, { constructor: { value: t } });
					t.prototype = o;
					var c = new ze(u, t, o, f, n, a, s, l);
					n = new We(u, c, !0, !1), i = new We(u + "*", c, !1, !1);
					var d = new We(u + " const*", c, !1, !0);
					return B[e] = {
						pointerType: i,
						la: d
					}, Ge(p, t), [
						n,
						i,
						d
					];
				});
			},
			d: function(e, t, n, r, i, a, o) {
				var s = Ze(n, r);
				t = me(t), a = qe(i, a), Me([], [e], function(e) {
					function r() {
						Ye("Cannot call " + i + " due to unbound types", s);
					}
					e = e[0];
					var i = e.name + "." + t;
					t.startsWith("@@") && (t = Symbol[t.substring(2)]);
					var c = e.N.constructor;
					return c[t] === void 0 ? (r.Z = n - 1, c[t] = r) : (Le(c, t, i), c[t].S[n - 1] = r), Me([], s, function(e) {
						return e = Xe(i, [e[0], null].concat(e.slice(1)), null, a, o), c[t].S === void 0 ? (e.Z = n - 1, c[t] = e) : c[t].S[n - 1] = e, [];
					}), [];
				});
			},
			p: function(e, t, n, r, i, a) {
				0 < t || j();
				var o = Ze(t, n);
				i = qe(r, i), Me([], [e], function(e) {
					e = e[0];
					var n = "constructor " + e.name;
					if (e.N.Y === void 0 && (e.N.Y = []), e.N.Y[t - 1] !== void 0) throw new N("Cannot register multiple constructors with identical number of parameters (" + (t - 1) + ") for class '" + e.name + "'! Overload resolution is currently only performed using the parameter count, not actual type info!");
					return e.N.Y[t - 1] = () => {
						Ye("Cannot construct " + e.name + " due to unbound types", o);
					}, Me([], o, function(r) {
						return r.splice(1, 0, null), e.N.Y[t - 1] = Xe(n, r, null, i, a), [];
					}), [];
				});
			},
			a: function(e, t, n, r, i, a, o, s) {
				var c = Ze(n, r);
				t = me(t), a = qe(i, a), Me([], [e], function(e) {
					function r() {
						Ye("Cannot call " + i + " due to unbound types", c);
					}
					e = e[0];
					var i = e.name + "." + t;
					t.startsWith("@@") && (t = Symbol[t.substring(2)]), s && e.N.ja.push(t);
					var l = e.N.X, u = l[t];
					return u === void 0 || u.S === void 0 && u.className !== e.name && u.Z === n - 2 ? (r.Z = n - 2, r.className = e.name, l[t] = r) : (Le(l, t, i), l[t].S[n - 2] = r), Me([], c, function(r) {
						return r = Xe(i, r, e, a, o), l[t].S === void 0 ? (r.Z = n - 2, l[t] = r) : l[t].S[n - 2] = r, [];
					}), [];
				});
			},
			A: function(e, t) {
				t = me(t), Pe(e, {
					name: t,
					fromWireType: function(e) {
						var t = ue(e);
						return Qe(e), t;
					},
					toWireType: function(e, t) {
						return de(t);
					},
					argPackAdvance: 8,
					readValueFromPointer: ke,
					V: null
				});
			},
			n: function(e, t, n) {
				n = Ne(n), t = me(t), Pe(e, {
					name: t,
					fromWireType: function(e) {
						return e;
					},
					toWireType: function(e, t) {
						return t;
					},
					argPackAdvance: 8,
					readValueFromPointer: et(t, n),
					V: null
				});
			},
			e: function(e, t, n, r, i) {
				t = me(t), i === -1 && (i = 4294967295), i = Ne(n);
				var a = (e) => e;
				if (r === 0) {
					var o = 32 - 8 * n;
					a = (e) => e << o >>> o;
				}
				n = t.includes("unsigned") ? function(e, t) {
					return t >>> 0;
				} : function(e, t) {
					return t;
				}, Pe(e, {
					name: t,
					fromWireType: a,
					toWireType: n,
					argPackAdvance: 8,
					readValueFromPointer: tt(t, i, r !== 0),
					V: null
				});
			},
			b: function(e, t, n) {
				function r(e) {
					e >>= 2;
					var t = y;
					return new i(p, t[e + 1], t[e]);
				}
				var i = [
					Int8Array,
					Uint8Array,
					Int16Array,
					Uint16Array,
					Int32Array,
					Uint32Array,
					Float32Array,
					Float64Array
				][t];
				n = me(n), Pe(e, {
					name: n,
					fromWireType: r,
					argPackAdvance: 8,
					readValueFromPointer: r
				}, { ua: !0 });
			},
			o: function(e, t) {
				t = me(t);
				var n = t === "std::string";
				Pe(e, {
					name: t,
					fromWireType: function(e) {
						var t = y[e >> 2], r = e + 4;
						if (n) for (var i = r, a = 0; a <= t; ++a) {
							var o = r + a;
							if (a == t || h[o] == 0) {
								if (i = i ? f(h, i, o - i) : "", s === void 0) var s = i;
								else s += "\0", s += i;
								i = o + 1;
							}
						}
						else {
							for (s = Array(t), a = 0; a < t; ++a) s[a] = String.fromCharCode(h[r + a]);
							s = s.join("");
						}
						return bt(e), s;
					},
					toWireType: function(e, t) {
						t instanceof ArrayBuffer && (t = new Uint8Array(t));
						var r, i = typeof t == "string";
						if (i || t instanceof Uint8Array || t instanceof Uint8ClampedArray || t instanceof Int8Array || P("Cannot pass non-string to std::string"), n && i) {
							var a = 0;
							for (r = 0; r < t.length; ++r) {
								var o = t.charCodeAt(r);
								127 >= o ? a++ : 2047 >= o ? a += 2 : 55296 <= o && 57343 >= o ? (a += 4, ++r) : a += 3;
							}
							r = a;
						} else r = t.length;
						if (a = yt(4 + r + 1), o = a + 4, y[a >> 2] = r, n && i) {
							if (i = o, o = r + 1, r = h, 0 < o) {
								o = i + o - 1;
								for (var s = 0; s < t.length; ++s) {
									var c = t.charCodeAt(s);
									if (55296 <= c && 57343 >= c) {
										var l = t.charCodeAt(++s);
										c = 65536 + ((c & 1023) << 10) | l & 1023;
									}
									if (127 >= c) {
										if (i >= o) break;
										r[i++] = c;
									} else {
										if (2047 >= c) {
											if (i + 1 >= o) break;
											r[i++] = 192 | c >> 6;
										} else {
											if (65535 >= c) {
												if (i + 2 >= o) break;
												r[i++] = 224 | c >> 12;
											} else {
												if (i + 3 >= o) break;
												r[i++] = 240 | c >> 18, r[i++] = 128 | c >> 12 & 63;
											}
											r[i++] = 128 | c >> 6 & 63;
										}
										r[i++] = 128 | c & 63;
									}
								}
								r[i] = 0;
							}
						} else if (i) for (i = 0; i < r; ++i) s = t.charCodeAt(i), 255 < s && (bt(o), P("String has UTF-16 code units that do not fit in 8 bits")), h[o + i] = s;
						else for (i = 0; i < r; ++i) h[o + i] = t[i];
						return e !== null && e.push(bt, a), a;
					},
					argPackAdvance: 8,
					readValueFromPointer: ke,
					V: function(e) {
						bt(e);
					}
				});
			},
			i: function(e, t, n) {
				if (n = me(n), t === 2) var r = nt, i = rt, a = it, o = () => _, s = 1;
				else t === 4 && (r = at, i = ot, a = st, o = () => y, s = 2);
				Pe(e, {
					name: n,
					fromWireType: function(e) {
						for (var n = y[e >> 2], i = o(), a, c = e + 4, l = 0; l <= n; ++l) {
							var u = e + 4 + l * t;
							(l == n || i[u >> s] == 0) && (c = r(c, u - c), a === void 0 ? a = c : (a += "\0", a += c), c = u + t);
						}
						return bt(e), a;
					},
					toWireType: function(e, r) {
						typeof r != "string" && P("Cannot pass non-string to C++ string type " + n);
						var o = a(r), c = yt(4 + o + t);
						return y[c >> 2] = o >> s, i(r, c + 4, o + t), e !== null && e.push(bt, c), c;
					},
					argPackAdvance: 8,
					readValueFromPointer: ke,
					V: function(e) {
						bt(e);
					}
				});
			},
			k: function(e, t, n, r, i, a) {
				De[e] = {
					name: me(t),
					fa: qe(n, r),
					W: qe(i, a),
					ia: []
				};
			},
			h: function(e, t, n, r, i, a, o, s, c, l) {
				De[e].ia.push({
					oa: me(t),
					ta: n,
					ra: qe(r, i),
					sa: a,
					za: o,
					ya: qe(s, c),
					Aa: l
				});
			},
			C: function(e, t) {
				t = me(t), Pe(e, {
					va: !0,
					name: t,
					argPackAdvance: 0,
					fromWireType: function() {},
					toWireType: function() {}
				});
			},
			s: function(e, t, n, r, i) {
				e = ut[e], t = ue(t), n = lt(n);
				var a = [];
				return y[r >> 2] = de(a), e(t, n, a, i);
			},
			t: function(e, t, n, r) {
				e = ut[e], t = ue(t), n = lt(n), e(t, n, null, r);
			},
			g: Qe,
			m: function(e, t) {
				var n = ft(e, t), r = n[0];
				t = r.name + "_$" + n.slice(1).map(function(e) {
					return e.name;
				}).join("_") + "$";
				var i = pt[t];
				if (i !== void 0) return i;
				var a = Array(e - 1);
				return i = dt((t, i, o, s) => {
					for (var c = 0, l = 0; l < e - 1; ++l) a[l] = n[l + 1].readValueFromPointer(s + c), c += n[l + 1].argPackAdvance;
					for (t = t[i].apply(t, a), l = 0; l < e - 1; ++l) n[l + 1].ma && n[l + 1].ma(a[l]);
					if (!r.va) return r.toWireType(o, t);
				}), pt[t] = i;
			},
			D: function(e) {
				4 < e && (se[e].ga += 1);
			},
			r: function(e) {
				Oe(ue(e)), Qe(e);
			},
			c: function() {
				j("");
			},
			x: function(e, t, n) {
				h.copyWithin(e, t, t + n);
			},
			w: function(e) {
				var t = h.length;
				if (e >>>= 0, 2147483648 < e) return !1;
				for (var n = 1; 4 >= n; n *= 2) {
					var r = t * (1 + .2 / n);
					r = Math.min(r, e + 100663296);
					var i = Math;
					r = Math.max(e, r), i = i.min.call(i, 2147483648, r + (65536 - r % 65536) % 65536);
					a: {
						try {
							u.grow(i - p.byteLength + 65535 >>> 16), S();
							var a = 1;
							break a;
						} catch {}
						a = void 0;
					}
					if (a) return !0;
				}
				return !1;
			},
			z: function() {
				return 52;
			},
			u: function() {
				return 70;
			},
			y: function(e, t, n, r) {
				for (var i = 0, a = 0; a < n; a++) {
					var o = y[t >> 2], l = y[t + 4 >> 2];
					t += 8;
					for (var u = 0; u < l; u++) {
						var d = h[o + u], p = mt[e];
						d === 0 || d === 10 ? ((e === 1 ? s : c)(f(p, 0)), p.length = 0) : p.push(d);
					}
					i += l;
				}
				return y[r >> 2] = i, 0;
			}
		};
		(function() {
			function e(e) {
				n.asm = e.exports, u = n.asm.E, S(), C = n.asm.J, T.unshift(n.asm.F), O--, n.monitorRunDependencies && n.monitorRunDependencies(O), O == 0 && (k !== null && (clearInterval(k), k = null), A && (e = A, A = null, e()));
			}
			function t(t) {
				e(t.instance);
			}
			function r(e) {
				return re().then(function(e) {
					return WebAssembly.instantiate(e, a);
				}).then(function(e) {
					return e;
				}).then(e, function(e) {
					c("failed to asynchronously prepare wasm: " + e), j(e);
				});
			}
			var a = { a: vt };
			if (O++, n.monitorRunDependencies && n.monitorRunDependencies(O), n.instantiateWasm) try {
				return n.instantiateWasm(a, e);
			} catch (e) {
				c("Module.instantiateWasm callback failed with error: " + e), i(e);
			}
			return (function() {
				return l || typeof WebAssembly.instantiateStreaming != "function" || M(ee) || typeof fetch != "function" ? r(t) : fetch(ee, { credentials: "same-origin" }).then(function(e) {
					return WebAssembly.instantiateStreaming(e, a).then(t, function(e) {
						return c("wasm streaming compile failed: " + e), c("falling back to ArrayBuffer instantiation"), r(t);
					});
				});
			})().catch(i), {};
		})(), n.___wasm_call_ctors = function() {
			return (n.___wasm_call_ctors = n.asm.F).apply(null, arguments);
		};
		var V = n.___getTypeName = function() {
			return (V = n.___getTypeName = n.asm.G).apply(null, arguments);
		};
		n.__embind_initialize_bindings = function() {
			return (n.__embind_initialize_bindings = n.asm.H).apply(null, arguments);
		};
		var yt = n._malloc = function() {
			return (yt = n._malloc = n.asm.I).apply(null, arguments);
		}, bt = n._free = function() {
			return (bt = n._free = n.asm.K).apply(null, arguments);
		};
		n.dynCall_jiji = function() {
			return (n.dynCall_jiji = n.asm.L).apply(null, arguments);
		};
		var xt;
		A = function e() {
			xt || St(), xt || (A = e);
		};
		function St() {
			function e() {
				if (!xt && (xt = !0, n.calledRun = !0, !d)) {
					if (ie(T), r(n), n.onRuntimeInitialized && n.onRuntimeInitialized(), n.postRun) for (typeof n.postRun == "function" && (n.postRun = [n.postRun]); n.postRun.length;) {
						var e = n.postRun.shift();
						E.unshift(e);
					}
					ie(E);
				}
			}
			if (!(0 < O)) {
				if (n.preRun) for (typeof n.preRun == "function" && (n.preRun = [n.preRun]); n.preRun.length;) D();
				ie(w), 0 < O || (n.setStatus ? (n.setStatus("Running..."), setTimeout(function() {
					setTimeout(function() {
						n.setStatus("");
					}, 1), e();
				}, 1)) : e());
			}
		}
		if (n.preInit) for (typeof n.preInit == "function" && (n.preInit = [n.preInit]); 0 < n.preInit.length;) n.preInit.pop()();
		return St(), t.ready;
	});
})();
var W0 = /*#__PURE__*/ function(e) {
	return e[e.Auto = 0] = "Auto", e[e.FlexStart = 1] = "FlexStart", e[e.Center = 2] = "Center", e[e.FlexEnd = 3] = "FlexEnd", e[e.Stretch = 4] = "Stretch", e[e.Baseline = 5] = "Baseline", e[e.SpaceBetween = 6] = "SpaceBetween", e[e.SpaceAround = 7] = "SpaceAround", e[e.SpaceEvenly = 8] = "SpaceEvenly", e;
}({}), G0 = /*#__PURE__*/ function(e) {
	return e[e.BorderBox = 0] = "BorderBox", e[e.ContentBox = 1] = "ContentBox", e;
}({}), K0 = /*#__PURE__*/ function(e) {
	return e[e.Width = 0] = "Width", e[e.Height = 1] = "Height", e;
}({}), q0 = /*#__PURE__*/ function(e) {
	return e[e.Inherit = 0] = "Inherit", e[e.LTR = 1] = "LTR", e[e.RTL = 2] = "RTL", e;
}({}), J0 = /*#__PURE__*/ function(e) {
	return e[e.Flex = 0] = "Flex", e[e.None = 1] = "None", e[e.Contents = 2] = "Contents", e;
}({}), Y0 = /*#__PURE__*/ function(e) {
	return e[e.Left = 0] = "Left", e[e.Top = 1] = "Top", e[e.Right = 2] = "Right", e[e.Bottom = 3] = "Bottom", e[e.Start = 4] = "Start", e[e.End = 5] = "End", e[e.Horizontal = 6] = "Horizontal", e[e.Vertical = 7] = "Vertical", e[e.All = 8] = "All", e;
}({}), X0 = /*#__PURE__*/ function(e) {
	return e[e.None = 0] = "None", e[e.StretchFlexBasis = 1] = "StretchFlexBasis", e[e.AbsolutePositionWithoutInsetsExcludesPadding = 2] = "AbsolutePositionWithoutInsetsExcludesPadding", e[e.AbsolutePercentAgainstInnerSize = 4] = "AbsolutePercentAgainstInnerSize", e[e.All = 2147483647] = "All", e[e.Classic = 2147483646] = "Classic", e;
}({}), Z0 = /*#__PURE__*/ function(e) {
	return e[e.WebFlexBasis = 0] = "WebFlexBasis", e;
}({}), Q0 = /*#__PURE__*/ function(e) {
	return e[e.Column = 0] = "Column", e[e.ColumnReverse = 1] = "ColumnReverse", e[e.Row = 2] = "Row", e[e.RowReverse = 3] = "RowReverse", e;
}({}), $0 = /*#__PURE__*/ function(e) {
	return e[e.Column = 0] = "Column", e[e.Row = 1] = "Row", e[e.All = 2] = "All", e;
}({}), e2 = /*#__PURE__*/ function(e) {
	return e[e.FlexStart = 0] = "FlexStart", e[e.Center = 1] = "Center", e[e.FlexEnd = 2] = "FlexEnd", e[e.SpaceBetween = 3] = "SpaceBetween", e[e.SpaceAround = 4] = "SpaceAround", e[e.SpaceEvenly = 5] = "SpaceEvenly", e;
}({}), t2 = /*#__PURE__*/ function(e) {
	return e[e.Error = 0] = "Error", e[e.Warn = 1] = "Warn", e[e.Info = 2] = "Info", e[e.Debug = 3] = "Debug", e[e.Verbose = 4] = "Verbose", e[e.Fatal = 5] = "Fatal", e;
}({}), n2 = /*#__PURE__*/ function(e) {
	return e[e.Undefined = 0] = "Undefined", e[e.Exactly = 1] = "Exactly", e[e.AtMost = 2] = "AtMost", e;
}({}), r2 = /*#__PURE__*/ function(e) {
	return e[e.Default = 0] = "Default", e[e.Text = 1] = "Text", e;
}({}), i2 = /*#__PURE__*/ function(e) {
	return e[e.Visible = 0] = "Visible", e[e.Hidden = 1] = "Hidden", e[e.Scroll = 2] = "Scroll", e;
}({}), a2 = /*#__PURE__*/ function(e) {
	return e[e.Static = 0] = "Static", e[e.Relative = 1] = "Relative", e[e.Absolute = 2] = "Absolute", e;
}({}), o2 = /*#__PURE__*/ function(e) {
	return e[e.Undefined = 0] = "Undefined", e[e.Point = 1] = "Point", e[e.Percent = 2] = "Percent", e[e.Auto = 3] = "Auto", e;
}({}), s2 = /*#__PURE__*/ function(e) {
	return e[e.NoWrap = 0] = "NoWrap", e[e.Wrap = 1] = "Wrap", e[e.WrapReverse = 2] = "WrapReverse", e;
}({});
W0.Auto, W0.FlexStart, W0.Center, W0.FlexEnd, W0.Stretch, W0.Baseline, W0.SpaceBetween, W0.SpaceAround, W0.SpaceEvenly, G0.BorderBox, G0.ContentBox, K0.Width, K0.Height, q0.Inherit, q0.LTR, q0.RTL, J0.Flex, J0.None, J0.Contents, Y0.Left, Y0.Top, Y0.Right, Y0.Bottom, Y0.Start, Y0.End, Y0.Horizontal, Y0.Vertical, Y0.All, X0.None, X0.StretchFlexBasis, X0.AbsolutePositionWithoutInsetsExcludesPadding, X0.AbsolutePercentAgainstInnerSize, X0.All, X0.Classic, Z0.WebFlexBasis, Q0.Column, Q0.ColumnReverse, Q0.Row, Q0.RowReverse, $0.Column, $0.Row, $0.All, e2.FlexStart, e2.Center, e2.FlexEnd, e2.SpaceBetween, e2.SpaceAround, e2.SpaceEvenly, t2.Error, t2.Warn, t2.Info, t2.Debug, t2.Verbose, t2.Fatal, n2.Undefined, n2.Exactly, n2.AtMost, r2.Default, r2.Text, i2.Visible, i2.Hidden, i2.Scroll, a2.Static, a2.Relative, a2.Absolute, o2.Undefined, o2.Point, o2.Percent, o2.Auto, s2.NoWrap, s2.Wrap, s2.WrapReverse;
var c2 = () => /[#*0-9]\uFE0F?\u20E3|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26AA\u26B0\u26B1\u26BD\u26BE\u26C4\u26C8\u26CF\u26D1\u26E9\u26F0-\u26F5\u26F7\u26F8\u26FA\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B55\u3030\u303D\u3297\u3299]\uFE0F?|[\u261D\u270C\u270D](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?|[\u270A\u270B](?:\uD83C[\uDFFB-\uDFFF])?|[\u23E9-\u23EC\u23F0\u23F3\u25FD\u2693\u26A1\u26AB\u26C5\u26CE\u26D4\u26EA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2795-\u2797\u27B0\u27BF\u2B50]|\u26D3\uFE0F?(?:\u200D\uD83D\uDCA5)?|\u26F9(?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|\u2764\uFE0F?(?:\u200D(?:\uD83D\uDD25|\uD83E\uDE79))?|\uD83C(?:[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]\uFE0F?|[\uDF85\uDFC2\uDFC7](?:\uD83C[\uDFFB-\uDFFF])?|[\uDFC4\uDFCA](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDFCB\uDFCC](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF43\uDF45-\uDF4A\uDF4C-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF7\uDDFA-\uDDFF]|\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF]|\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uDDFC\uD83C[\uDDEB\uDDF8]|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C[\uDDEA\uDDF9]|\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uDF44(?:\u200D\uD83D\uDFEB)?|\uDF4B(?:\u200D\uD83D\uDFE9)?|\uDFC3(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDFF3\uFE0F?(?:\u200D(?:\u26A7\uFE0F?|\uD83C\uDF08))?|\uDFF4(?:\u200D\u2620\uFE0F?|\uDB40\uDC67\uDB40\uDC62\uDB40(?:\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDC73\uDB40\uDC63\uDB40\uDC74|\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F)?)|\uD83D(?:[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3]\uFE0F?|[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC6E-\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4\uDEB5](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD74\uDD90](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?|[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC25\uDC27-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE41\uDE43\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED8\uDEDC-\uDEDF\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uDC08(?:\u200D\u2B1B)?|\uDC15(?:\u200D\uD83E\uDDBA)?|\uDC26(?:\u200D(?:\u2B1B|\uD83D\uDD25))?|\uDC3B(?:\u200D\u2744\uFE0F?)?|\uDC41\uFE0F?(?:\u200D\uD83D\uDDE8\uFE0F?)?|\uDC68(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDC68\uDC69]\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?))?|\uDC69(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?[\uDC68\uDC69]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|\uDC69\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?))|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFC-\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFC-\uDFFF]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFD-\uDFFF]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFD\uDFFF]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFB-\uDFFE])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFE]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFB-\uDFFE])))?))?|\uDD75(?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDE2E(?:\u200D\uD83D\uDCA8)?|\uDE35(?:\u200D\uD83D\uDCAB)?|\uDE36(?:\u200D\uD83C\uDF2B\uFE0F?)?|\uDE42(?:\u200D[\u2194\u2195]\uFE0F?)?|\uDEB6(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?)|\uD83E(?:[\uDD0C\uDD0F\uDD18-\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5\uDEC3-\uDEC5\uDEF0\uDEF2-\uDEF8](?:\uD83C[\uDFFB-\uDFFF])?|[\uDD26\uDD35\uDD37-\uDD39\uDD3C-\uDD3E\uDDB8\uDDB9\uDDCD\uDDCF\uDDD4\uDDD6-\uDDDD](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDDDE\uDDDF](?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD0D\uDD0E\uDD10-\uDD17\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCC\uDDD0\uDDE0-\uDDFF\uDE70-\uDE7C\uDE80-\uDE8A\uDE8E-\uDEC2\uDEC6\uDEC8\uDECD-\uDEDC\uDEDF-\uDEEA\uDEEF]|\uDDCE(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDDD1(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1|\uDDD1\u200D\uD83E\uDDD2(?:\u200D\uD83E\uDDD2)?|\uDDD2(?:\u200D\uD83E\uDDD2)?))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE])))?))?|\uDEF1(?:\uD83C(?:\uDFFB(?:\u200D\uD83E\uDEF2\uD83C[\uDFFC-\uDFFF])?|\uDFFC(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFD-\uDFFF])?|\uDFFD(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])?|\uDFFE(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFD\uDFFF])?|\uDFFF(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFE])?))?)/g, l2 = typeof global < "u" ? global : typeof self < "u" ? self : typeof window < "u" ? window : {}, u2 = [], d2 = [], f2 = typeof Uint8Array < "u" ? Uint8Array : Array, p2 = !1;
function m2() {
	p2 = !0;
	for (var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", t = 0, n = e.length; t < n; ++t) u2[t] = e[t], d2[e.charCodeAt(t)] = t;
	d2[45] = 62, d2[95] = 63;
}
function h2(e) {
	p2 || m2();
	var t, n, r, i, a, o, s = e.length;
	if (s % 4 > 0) throw Error("Invalid string. Length must be a multiple of 4");
	a = e[s - 2] === "=" ? 2 : +(e[s - 1] === "="), o = new f2(s * 3 / 4 - a), r = a > 0 ? s - 4 : s;
	var c = 0;
	for (t = 0, n = 0; t < r; t += 4, n += 3) i = d2[e.charCodeAt(t)] << 18 | d2[e.charCodeAt(t + 1)] << 12 | d2[e.charCodeAt(t + 2)] << 6 | d2[e.charCodeAt(t + 3)], o[c++] = i >> 16 & 255, o[c++] = i >> 8 & 255, o[c++] = i & 255;
	return a === 2 ? (i = d2[e.charCodeAt(t)] << 2 | d2[e.charCodeAt(t + 1)] >> 4, o[c++] = i & 255) : a === 1 && (i = d2[e.charCodeAt(t)] << 10 | d2[e.charCodeAt(t + 1)] << 4 | d2[e.charCodeAt(t + 2)] >> 2, o[c++] = i >> 8 & 255, o[c++] = i & 255), o;
}
function g2(e) {
	return u2[e >> 18 & 63] + u2[e >> 12 & 63] + u2[e >> 6 & 63] + u2[e & 63];
}
function _2(e, t, n) {
	for (var r, i = [], a = t; a < n; a += 3) r = (e[a] << 16) + (e[a + 1] << 8) + e[a + 2], i.push(g2(r));
	return i.join("");
}
function v2(e) {
	p2 || m2();
	for (var t, n = e.length, r = n % 3, i = "", a = [], o = 16383, s = 0, c = n - r; s < c; s += o) a.push(_2(e, s, s + o > c ? c : s + o));
	return r === 1 ? (t = e[n - 1], i += u2[t >> 2], i += u2[t << 4 & 63], i += "==") : r === 2 && (t = (e[n - 2] << 8) + e[n - 1], i += u2[t >> 10], i += u2[t >> 4 & 63], i += u2[t << 2 & 63], i += "="), a.push(i), a.join("");
}
function y2(e, t, n, r, i) {
	var a, o, s = i * 8 - r - 1, c = (1 << s) - 1, l = c >> 1, u = -7, d = n ? i - 1 : 0, f = n ? -1 : 1, p = e[t + d];
	for (d += f, a = p & (1 << -u) - 1, p >>= -u, u += s; u > 0; a = a * 256 + e[t + d], d += f, u -= 8);
	for (o = a & (1 << -u) - 1, a >>= -u, u += r; u > 0; o = o * 256 + e[t + d], d += f, u -= 8);
	if (a === 0) a = 1 - l;
	else if (a === c) return o ? NaN : (p ? -1 : 1) * Infinity;
	else o += 2 ** r, a -= l;
	return (p ? -1 : 1) * o * 2 ** (a - r);
}
function b2(e, t, n, r, i, a) {
	var o, s, c, l = a * 8 - i - 1, u = (1 << l) - 1, d = u >> 1, f = i === 23 ? 2 ** -24 - 2 ** -77 : 0, p = r ? 0 : a - 1, m = r ? 1 : -1, h = +(t < 0 || t === 0 && 1 / t < 0);
	for (t = Math.abs(t), isNaN(t) || t === Infinity ? (s = +!!isNaN(t), o = u) : (o = Math.floor(Math.log(t) / Math.LN2), t * (c = 2 ** -o) < 1 && (o--, c *= 2), o + d >= 1 ? t += f / c : t += f * 2 ** (1 - d), t * c >= 2 && (o++, c /= 2), o + d >= u ? (s = 0, o = u) : o + d >= 1 ? (s = (t * c - 1) * 2 ** i, o += d) : (s = t * 2 ** (d - 1) * 2 ** i, o = 0)); i >= 8; e[n + p] = s & 255, p += m, s /= 256, i -= 8);
	for (o = o << i | s, l += i; l > 0; e[n + p] = o & 255, p += m, o /= 256, l -= 8);
	e[n + p - m] |= h * 128;
}
var x2 = {}.toString, S2 = Array.isArray || function(e) {
	return x2.call(e) == "[object Array]";
}, C2 = 50;
$.TYPED_ARRAY_SUPPORT = l2.TYPED_ARRAY_SUPPORT === void 0 ? !0 : l2.TYPED_ARRAY_SUPPORT, w2();
function w2() {
	return $.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
}
function T2(e, t) {
	if (w2() < t) throw RangeError("Invalid typed array length");
	return $.TYPED_ARRAY_SUPPORT ? (e = new Uint8Array(t), e.__proto__ = $.prototype) : (e === null && (e = new $(t)), e.length = t), e;
}
function $(e, t, n) {
	if (!$.TYPED_ARRAY_SUPPORT && !(this instanceof $)) return new $(e, t, n);
	if (typeof e == "number") {
		if (typeof t == "string") throw Error("If encoding is specified then the first argument must be a string");
		return k2(this, e);
	}
	return E2(this, e, t, n);
}
$.poolSize = 8192, $._augment = function(e) {
	return e.__proto__ = $.prototype, e;
};
function E2(e, t, n, r) {
	if (typeof t == "number") throw TypeError("\"value\" argument must not be a number");
	return typeof ArrayBuffer < "u" && t instanceof ArrayBuffer ? M2(e, t, n, r) : typeof t == "string" ? A2(e, t, n) : N2(e, t);
}
$.from = function(e, t, n) {
	return E2(null, e, t, n);
}, $.TYPED_ARRAY_SUPPORT && ($.prototype.__proto__ = Uint8Array.prototype, $.__proto__ = Uint8Array, typeof Symbol < "u" && Symbol.species && $[Symbol.species]);
function D2(e) {
	if (typeof e != "number") throw TypeError("\"size\" argument must be a number");
	if (e < 0) throw RangeError("\"size\" argument must not be negative");
}
function O2(e, t, n, r) {
	return D2(t), t <= 0 || n === void 0 ? T2(e, t) : typeof r == "string" ? T2(e, t).fill(n, r) : T2(e, t).fill(n);
}
$.alloc = function(e, t, n) {
	return O2(null, e, t, n);
};
function k2(e, t) {
	if (D2(t), e = T2(e, t < 0 ? 0 : P2(t) | 0), !$.TYPED_ARRAY_SUPPORT) for (var n = 0; n < t; ++n) e[n] = 0;
	return e;
}
$.allocUnsafe = function(e) {
	return k2(null, e);
}, $.allocUnsafeSlow = function(e) {
	return k2(null, e);
};
function A2(e, t, n) {
	if ((typeof n != "string" || n === "") && (n = "utf8"), !$.isEncoding(n)) throw TypeError("\"encoding\" must be a valid string encoding");
	var r = I2(t, n) | 0;
	e = T2(e, r);
	var i = e.write(t, n);
	return i !== r && (e = e.slice(0, i)), e;
}
function j2(e, t) {
	var n = t.length < 0 ? 0 : P2(t.length) | 0;
	e = T2(e, n);
	for (var r = 0; r < n; r += 1) e[r] = t[r] & 255;
	return e;
}
function M2(e, t, n, r) {
	if (t.byteLength, n < 0 || t.byteLength < n) throw RangeError("'offset' is out of bounds");
	if (t.byteLength < n + (r || 0)) throw RangeError("'length' is out of bounds");
	return t = n === void 0 && r === void 0 ? new Uint8Array(t) : r === void 0 ? new Uint8Array(t, n) : new Uint8Array(t, n, r), $.TYPED_ARRAY_SUPPORT ? (e = t, e.__proto__ = $.prototype) : e = j2(e, t), e;
}
function N2(e, t) {
	if (F2(t)) {
		var n = P2(t.length) | 0;
		return e = T2(e, n), e.length === 0 || t.copy(e, 0, 0, n), e;
	}
	if (t) {
		if (typeof ArrayBuffer < "u" && t.buffer instanceof ArrayBuffer || "length" in t) return typeof t.length != "number" || _4(t.length) ? T2(e, 0) : j2(e, t);
		if (t.type === "Buffer" && S2(t.data)) return j2(e, t.data);
	}
	throw TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function P2(e) {
	if (e >= w2()) throw RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + w2().toString(16) + " bytes");
	return e | 0;
}
$.isBuffer = v4;
function F2(e) {
	return !!(e != null && e._isBuffer);
}
$.compare = function(e, t) {
	if (!F2(e) || !F2(t)) throw TypeError("Arguments must be Buffers");
	if (e === t) return 0;
	for (var n = e.length, r = t.length, i = 0, a = Math.min(n, r); i < a; ++i) if (e[i] !== t[i]) {
		n = e[i], r = t[i];
		break;
	}
	return n < r ? -1 : +(r < n);
}, $.isEncoding = function(e) {
	switch (String(e).toLowerCase()) {
		case "hex":
		case "utf8":
		case "utf-8":
		case "ascii":
		case "latin1":
		case "binary":
		case "base64":
		case "ucs2":
		case "ucs-2":
		case "utf16le":
		case "utf-16le": return !0;
		default: return !1;
	}
}, $.concat = function(e, t) {
	if (!S2(e)) throw TypeError("\"list\" argument must be an Array of Buffers");
	if (e.length === 0) return $.alloc(0);
	var n;
	if (t === void 0) for (t = 0, n = 0; n < e.length; ++n) t += e[n].length;
	var r = $.allocUnsafe(t), i = 0;
	for (n = 0; n < e.length; ++n) {
		var a = e[n];
		if (!F2(a)) throw TypeError("\"list\" argument must be an Array of Buffers");
		a.copy(r, i), i += a.length;
	}
	return r;
};
function I2(e, t) {
	if (F2(e)) return e.length;
	if (typeof ArrayBuffer < "u" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(e) || e instanceof ArrayBuffer)) return e.byteLength;
	typeof e != "string" && (e = "" + e);
	var n = e.length;
	if (n === 0) return 0;
	for (var r = !1;;) switch (t) {
		case "ascii":
		case "latin1":
		case "binary": return n;
		case "utf8":
		case "utf-8":
		case void 0: return f4(e).length;
		case "ucs2":
		case "ucs-2":
		case "utf16le":
		case "utf-16le": return n * 2;
		case "hex": return n >>> 1;
		case "base64": return h4(e).length;
		default:
			if (r) return f4(e).length;
			t = ("" + t).toLowerCase(), r = !0;
	}
}
$.byteLength = I2;
function L2(e, t, n) {
	var r = !1;
	if ((t === void 0 || t < 0) && (t = 0), t > this.length || ((n === void 0 || n > this.length) && (n = this.length), n <= 0) || (n >>>= 0, t >>>= 0, n <= t)) return "";
	for (e ||= "utf8";;) switch (e) {
		case "hex": return $2(this, t, n);
		case "utf8":
		case "utf-8": return J2(this, t, n);
		case "ascii": return Z2(this, t, n);
		case "latin1":
		case "binary": return Q2(this, t, n);
		case "base64": return q2(this, t, n);
		case "ucs2":
		case "ucs-2":
		case "utf16le":
		case "utf-16le": return e4(this, t, n);
		default:
			if (r) throw TypeError("Unknown encoding: " + e);
			e = (e + "").toLowerCase(), r = !0;
	}
}
$.prototype._isBuffer = !0;
function R2(e, t, n) {
	var r = e[t];
	e[t] = e[n], e[n] = r;
}
$.prototype.swap16 = function() {
	var e = this.length;
	if (e % 2 != 0) throw RangeError("Buffer size must be a multiple of 16-bits");
	for (var t = 0; t < e; t += 2) R2(this, t, t + 1);
	return this;
}, $.prototype.swap32 = function() {
	var e = this.length;
	if (e % 4 != 0) throw RangeError("Buffer size must be a multiple of 32-bits");
	for (var t = 0; t < e; t += 4) R2(this, t, t + 3), R2(this, t + 1, t + 2);
	return this;
}, $.prototype.swap64 = function() {
	var e = this.length;
	if (e % 8 != 0) throw RangeError("Buffer size must be a multiple of 64-bits");
	for (var t = 0; t < e; t += 8) R2(this, t, t + 7), R2(this, t + 1, t + 6), R2(this, t + 2, t + 5), R2(this, t + 3, t + 4);
	return this;
}, $.prototype.toString = function() {
	var e = this.length | 0;
	return e === 0 ? "" : arguments.length === 0 ? J2(this, 0, e) : L2.apply(this, arguments);
}, $.prototype.equals = function(e) {
	if (!F2(e)) throw TypeError("Argument must be a Buffer");
	return this === e ? !0 : $.compare(this, e) === 0;
}, $.prototype.inspect = function() {
	var e = "", t = C2;
	return this.length > 0 && (e = this.toString("hex", 0, t).match(/.{2}/g).join(" "), this.length > t && (e += " ... ")), "<Buffer " + e + ">";
}, $.prototype.compare = function(e, t, n, r, i) {
	if (!F2(e)) throw TypeError("Argument must be a Buffer");
	if (t === void 0 && (t = 0), n === void 0 && (n = e ? e.length : 0), r === void 0 && (r = 0), i === void 0 && (i = this.length), t < 0 || n > e.length || r < 0 || i > this.length) throw RangeError("out of range index");
	if (r >= i && t >= n) return 0;
	if (r >= i) return -1;
	if (t >= n) return 1;
	if (t >>>= 0, n >>>= 0, r >>>= 0, i >>>= 0, this === e) return 0;
	for (var a = i - r, o = n - t, s = Math.min(a, o), c = this.slice(r, i), l = e.slice(t, n), u = 0; u < s; ++u) if (c[u] !== l[u]) {
		a = c[u], o = l[u];
		break;
	}
	return a < o ? -1 : +(o < a);
};
function z2(e, t, n, r, i) {
	if (e.length === 0) return -1;
	if (typeof n == "string" ? (r = n, n = 0) : n > 2147483647 ? n = 2147483647 : n < -2147483648 && (n = -2147483648), n = +n, isNaN(n) && (n = i ? 0 : e.length - 1), n < 0 && (n = e.length + n), n >= e.length) {
		if (i) return -1;
		n = e.length - 1;
	} else if (n < 0) if (i) n = 0;
	else return -1;
	if (typeof t == "string" && (t = $.from(t, r)), F2(t)) return t.length === 0 ? -1 : B2(e, t, n, r, i);
	if (typeof t == "number") return t &= 255, $.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? i ? Uint8Array.prototype.indexOf.call(e, t, n) : Uint8Array.prototype.lastIndexOf.call(e, t, n) : B2(e, [t], n, r, i);
	throw TypeError("val must be string, number or Buffer");
}
function B2(e, t, n, r, i) {
	var a = 1, o = e.length, s = t.length;
	if (r !== void 0 && (r = String(r).toLowerCase(), r === "ucs2" || r === "ucs-2" || r === "utf16le" || r === "utf-16le")) {
		if (e.length < 2 || t.length < 2) return -1;
		a = 2, o /= 2, s /= 2, n /= 2;
	}
	function c(e, t) {
		return a === 1 ? e[t] : e.readUInt16BE(t * a);
	}
	var l;
	if (i) {
		var u = -1;
		for (l = n; l < o; l++) if (c(e, l) === c(t, u === -1 ? 0 : l - u)) {
			if (u === -1 && (u = l), l - u + 1 === s) return u * a;
		} else u !== -1 && (l -= l - u), u = -1;
	} else for (n + s > o && (n = o - s), l = n; l >= 0; l--) {
		for (var d = !0, f = 0; f < s; f++) if (c(e, l + f) !== c(t, f)) {
			d = !1;
			break;
		}
		if (d) return l;
	}
	return -1;
}
$.prototype.includes = function(e, t, n) {
	return this.indexOf(e, t, n) !== -1;
}, $.prototype.indexOf = function(e, t, n) {
	return z2(this, e, t, n, !0);
}, $.prototype.lastIndexOf = function(e, t, n) {
	return z2(this, e, t, n, !1);
};
function V2(e, t, n, r) {
	n = Number(n) || 0;
	var i = e.length - n;
	r ? (r = Number(r), r > i && (r = i)) : r = i;
	var a = t.length;
	if (a % 2 != 0) throw TypeError("Invalid hex string");
	r > a / 2 && (r = a / 2);
	for (var o = 0; o < r; ++o) {
		var s = parseInt(t.substr(o * 2, 2), 16);
		if (isNaN(s)) return o;
		e[n + o] = s;
	}
	return o;
}
function H2(e, t, n, r) {
	return g4(f4(t, e.length - n), e, n, r);
}
function U2(e, t, n, r) {
	return g4(p4(t), e, n, r);
}
function W2(e, t, n, r) {
	return U2(e, t, n, r);
}
function G2(e, t, n, r) {
	return g4(h4(t), e, n, r);
}
function K2(e, t, n, r) {
	return g4(m4(t, e.length - n), e, n, r);
}
$.prototype.write = function(e, t, n, r) {
	if (t === void 0) r = "utf8", n = this.length, t = 0;
	else if (n === void 0 && typeof t == "string") r = t, n = this.length, t = 0;
	else if (isFinite(t)) t |= 0, isFinite(n) ? (n |= 0, r === void 0 && (r = "utf8")) : (r = n, n = void 0);
	else throw Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
	var i = this.length - t;
	if ((n === void 0 || n > i) && (n = i), e.length > 0 && (n < 0 || t < 0) || t > this.length) throw RangeError("Attempt to write outside buffer bounds");
	r ||= "utf8";
	for (var a = !1;;) switch (r) {
		case "hex": return V2(this, e, t, n);
		case "utf8":
		case "utf-8": return H2(this, e, t, n);
		case "ascii": return U2(this, e, t, n);
		case "latin1":
		case "binary": return W2(this, e, t, n);
		case "base64": return G2(this, e, t, n);
		case "ucs2":
		case "ucs-2":
		case "utf16le":
		case "utf-16le": return K2(this, e, t, n);
		default:
			if (a) throw TypeError("Unknown encoding: " + r);
			r = ("" + r).toLowerCase(), a = !0;
	}
}, $.prototype.toJSON = function() {
	return {
		type: "Buffer",
		data: Array.prototype.slice.call(this._arr || this, 0)
	};
};
function q2(e, t, n) {
	return t === 0 && n === e.length ? v2(e) : v2(e.slice(t, n));
}
function J2(e, t, n) {
	n = Math.min(e.length, n);
	for (var r = [], i = t; i < n;) {
		var a = e[i], o = null, s = a > 239 ? 4 : a > 223 ? 3 : a > 191 ? 2 : 1;
		if (i + s <= n) {
			var c, l, u, d;
			switch (s) {
				case 1:
					a < 128 && (o = a);
					break;
				case 2:
					c = e[i + 1], (c & 192) == 128 && (d = (a & 31) << 6 | c & 63, d > 127 && (o = d));
					break;
				case 3:
					c = e[i + 1], l = e[i + 2], (c & 192) == 128 && (l & 192) == 128 && (d = (a & 15) << 12 | (c & 63) << 6 | l & 63, d > 2047 && (d < 55296 || d > 57343) && (o = d));
					break;
				case 4: c = e[i + 1], l = e[i + 2], u = e[i + 3], (c & 192) == 128 && (l & 192) == 128 && (u & 192) == 128 && (d = (a & 15) << 18 | (c & 63) << 12 | (l & 63) << 6 | u & 63, d > 65535 && d < 1114112 && (o = d));
			}
		}
		o === null ? (o = 65533, s = 1) : o > 65535 && (o -= 65536, r.push(o >>> 10 & 1023 | 55296), o = 56320 | o & 1023), r.push(o), i += s;
	}
	return X2(r);
}
var Y2 = 4096;
function X2(e) {
	var t = e.length;
	if (t <= Y2) return String.fromCharCode.apply(String, e);
	for (var n = "", r = 0; r < t;) n += String.fromCharCode.apply(String, e.slice(r, r += Y2));
	return n;
}
function Z2(e, t, n) {
	var r = "";
	n = Math.min(e.length, n);
	for (var i = t; i < n; ++i) r += String.fromCharCode(e[i] & 127);
	return r;
}
function Q2(e, t, n) {
	var r = "";
	n = Math.min(e.length, n);
	for (var i = t; i < n; ++i) r += String.fromCharCode(e[i]);
	return r;
}
function $2(e, t, n) {
	var r = e.length;
	(!t || t < 0) && (t = 0), (!n || n < 0 || n > r) && (n = r);
	for (var i = "", a = t; a < n; ++a) i += d4(e[a]);
	return i;
}
function e4(e, t, n) {
	for (var r = e.slice(t, n), i = "", a = 0; a < r.length; a += 2) i += String.fromCharCode(r[a] + r[a + 1] * 256);
	return i;
}
$.prototype.slice = function(e, t) {
	var n = this.length;
	e = ~~e, t = t === void 0 ? n : ~~t, e < 0 ? (e += n, e < 0 && (e = 0)) : e > n && (e = n), t < 0 ? (t += n, t < 0 && (t = 0)) : t > n && (t = n), t < e && (t = e);
	var r;
	if ($.TYPED_ARRAY_SUPPORT) r = this.subarray(e, t), r.__proto__ = $.prototype;
	else {
		var i = t - e;
		r = new $(i, void 0);
		for (var a = 0; a < i; ++a) r[a] = this[a + e];
	}
	return r;
};
function t4(e, t, n) {
	if (e % 1 != 0 || e < 0) throw RangeError("offset is not uint");
	if (e + t > n) throw RangeError("Trying to access beyond buffer length");
}
$.prototype.readUIntLE = function(e, t, n) {
	e |= 0, t |= 0, n || t4(e, t, this.length);
	for (var r = this[e], i = 1, a = 0; ++a < t && (i *= 256);) r += this[e + a] * i;
	return r;
}, $.prototype.readUIntBE = function(e, t, n) {
	e |= 0, t |= 0, n || t4(e, t, this.length);
	for (var r = this[e + --t], i = 1; t > 0 && (i *= 256);) r += this[e + --t] * i;
	return r;
}, $.prototype.readUInt8 = function(e, t) {
	return t || t4(e, 1, this.length), this[e];
}, $.prototype.readUInt16LE = function(e, t) {
	return t || t4(e, 2, this.length), this[e] | this[e + 1] << 8;
}, $.prototype.readUInt16BE = function(e, t) {
	return t || t4(e, 2, this.length), this[e] << 8 | this[e + 1];
}, $.prototype.readUInt32LE = function(e, t) {
	return t || t4(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + this[e + 3] * 16777216;
}, $.prototype.readUInt32BE = function(e, t) {
	return t || t4(e, 4, this.length), this[e] * 16777216 + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
}, $.prototype.readIntLE = function(e, t, n) {
	e |= 0, t |= 0, n || t4(e, t, this.length);
	for (var r = this[e], i = 1, a = 0; ++a < t && (i *= 256);) r += this[e + a] * i;
	return i *= 128, r >= i && (r -= 2 ** (8 * t)), r;
}, $.prototype.readIntBE = function(e, t, n) {
	e |= 0, t |= 0, n || t4(e, t, this.length);
	for (var r = t, i = 1, a = this[e + --r]; r > 0 && (i *= 256);) a += this[e + --r] * i;
	return i *= 128, a >= i && (a -= 2 ** (8 * t)), a;
}, $.prototype.readInt8 = function(e, t) {
	return t || t4(e, 1, this.length), this[e] & 128 ? (255 - this[e] + 1) * -1 : this[e];
}, $.prototype.readInt16LE = function(e, t) {
	t || t4(e, 2, this.length);
	var n = this[e] | this[e + 1] << 8;
	return n & 32768 ? n | 4294901760 : n;
}, $.prototype.readInt16BE = function(e, t) {
	t || t4(e, 2, this.length);
	var n = this[e + 1] | this[e] << 8;
	return n & 32768 ? n | 4294901760 : n;
}, $.prototype.readInt32LE = function(e, t) {
	return t || t4(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
}, $.prototype.readInt32BE = function(e, t) {
	return t || t4(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
}, $.prototype.readFloatLE = function(e, t) {
	return t || t4(e, 4, this.length), y2(this, e, !0, 23, 4);
}, $.prototype.readFloatBE = function(e, t) {
	return t || t4(e, 4, this.length), y2(this, e, !1, 23, 4);
}, $.prototype.readDoubleLE = function(e, t) {
	return t || t4(e, 8, this.length), y2(this, e, !0, 52, 8);
}, $.prototype.readDoubleBE = function(e, t) {
	return t || t4(e, 8, this.length), y2(this, e, !1, 52, 8);
};
function n4(e, t, n, r, i, a) {
	if (!F2(e)) throw TypeError("\"buffer\" argument must be a Buffer instance");
	if (t > i || t < a) throw RangeError("\"value\" argument is out of bounds");
	if (n + r > e.length) throw RangeError("Index out of range");
}
$.prototype.writeUIntLE = function(e, t, n, r) {
	if (e = +e, t |= 0, n |= 0, !r) {
		var i = 2 ** (8 * n) - 1;
		n4(this, e, t, n, i, 0);
	}
	var a = 1, o = 0;
	for (this[t] = e & 255; ++o < n && (a *= 256);) this[t + o] = e / a & 255;
	return t + n;
}, $.prototype.writeUIntBE = function(e, t, n, r) {
	if (e = +e, t |= 0, n |= 0, !r) {
		var i = 2 ** (8 * n) - 1;
		n4(this, e, t, n, i, 0);
	}
	var a = n - 1, o = 1;
	for (this[t + a] = e & 255; --a >= 0 && (o *= 256);) this[t + a] = e / o & 255;
	return t + n;
}, $.prototype.writeUInt8 = function(e, t, n) {
	return e = +e, t |= 0, n || n4(this, e, t, 1, 255, 0), $.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), this[t] = e & 255, t + 1;
};
function r4(e, t, n, r) {
	t < 0 && (t = 65535 + t + 1);
	for (var i = 0, a = Math.min(e.length - n, 2); i < a; ++i) e[n + i] = (t & 255 << 8 * (r ? i : 1 - i)) >>> (r ? i : 1 - i) * 8;
}
$.prototype.writeUInt16LE = function(e, t, n) {
	return e = +e, t |= 0, n || n4(this, e, t, 2, 65535, 0), $.TYPED_ARRAY_SUPPORT ? (this[t] = e & 255, this[t + 1] = e >>> 8) : r4(this, e, t, !0), t + 2;
}, $.prototype.writeUInt16BE = function(e, t, n) {
	return e = +e, t |= 0, n || n4(this, e, t, 2, 65535, 0), $.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = e & 255) : r4(this, e, t, !1), t + 2;
};
function i4(e, t, n, r) {
	t < 0 && (t = 4294967295 + t + 1);
	for (var i = 0, a = Math.min(e.length - n, 4); i < a; ++i) e[n + i] = t >>> (r ? i : 3 - i) * 8 & 255;
}
$.prototype.writeUInt32LE = function(e, t, n) {
	return e = +e, t |= 0, n || n4(this, e, t, 4, 4294967295, 0), $.TYPED_ARRAY_SUPPORT ? (this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = e & 255) : i4(this, e, t, !0), t + 4;
}, $.prototype.writeUInt32BE = function(e, t, n) {
	return e = +e, t |= 0, n || n4(this, e, t, 4, 4294967295, 0), $.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = e & 255) : i4(this, e, t, !1), t + 4;
}, $.prototype.writeIntLE = function(e, t, n, r) {
	if (e = +e, t |= 0, !r) {
		var i = 2 ** (8 * n - 1);
		n4(this, e, t, n, i - 1, -i);
	}
	var a = 0, o = 1, s = 0;
	for (this[t] = e & 255; ++a < n && (o *= 256);) e < 0 && s === 0 && this[t + a - 1] !== 0 && (s = 1), this[t + a] = (e / o >> 0) - s & 255;
	return t + n;
}, $.prototype.writeIntBE = function(e, t, n, r) {
	if (e = +e, t |= 0, !r) {
		var i = 2 ** (8 * n - 1);
		n4(this, e, t, n, i - 1, -i);
	}
	var a = n - 1, o = 1, s = 0;
	for (this[t + a] = e & 255; --a >= 0 && (o *= 256);) e < 0 && s === 0 && this[t + a + 1] !== 0 && (s = 1), this[t + a] = (e / o >> 0) - s & 255;
	return t + n;
}, $.prototype.writeInt8 = function(e, t, n) {
	return e = +e, t |= 0, n || n4(this, e, t, 1, 127, -128), $.TYPED_ARRAY_SUPPORT || (e = Math.floor(e)), e < 0 && (e = 255 + e + 1), this[t] = e & 255, t + 1;
}, $.prototype.writeInt16LE = function(e, t, n) {
	return e = +e, t |= 0, n || n4(this, e, t, 2, 32767, -32768), $.TYPED_ARRAY_SUPPORT ? (this[t] = e & 255, this[t + 1] = e >>> 8) : r4(this, e, t, !0), t + 2;
}, $.prototype.writeInt16BE = function(e, t, n) {
	return e = +e, t |= 0, n || n4(this, e, t, 2, 32767, -32768), $.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 8, this[t + 1] = e & 255) : r4(this, e, t, !1), t + 2;
}, $.prototype.writeInt32LE = function(e, t, n) {
	return e = +e, t |= 0, n || n4(this, e, t, 4, 2147483647, -2147483648), $.TYPED_ARRAY_SUPPORT ? (this[t] = e & 255, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24) : i4(this, e, t, !0), t + 4;
}, $.prototype.writeInt32BE = function(e, t, n) {
	return e = +e, t |= 0, n || n4(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), $.TYPED_ARRAY_SUPPORT ? (this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = e & 255) : i4(this, e, t, !1), t + 4;
};
function a4(e, t, n, r, i, a) {
	if (n + r > e.length || n < 0) throw RangeError("Index out of range");
}
function o4(e, t, n, r, i) {
	return i || a4(e, t, n, 4), b2(e, t, n, r, 23, 4), n + 4;
}
$.prototype.writeFloatLE = function(e, t, n) {
	return o4(this, e, t, !0, n);
}, $.prototype.writeFloatBE = function(e, t, n) {
	return o4(this, e, t, !1, n);
};
function s4(e, t, n, r, i) {
	return i || a4(e, t, n, 8), b2(e, t, n, r, 52, 8), n + 8;
}
$.prototype.writeDoubleLE = function(e, t, n) {
	return s4(this, e, t, !0, n);
}, $.prototype.writeDoubleBE = function(e, t, n) {
	return s4(this, e, t, !1, n);
}, $.prototype.copy = function(e, t, n, r) {
	if (n ||= 0, !r && r !== 0 && (r = this.length), t >= e.length && (t = e.length), t ||= 0, r > 0 && r < n && (r = n), r === n || e.length === 0 || this.length === 0) return 0;
	if (t < 0) throw RangeError("targetStart out of bounds");
	if (n < 0 || n >= this.length) throw RangeError("sourceStart out of bounds");
	if (r < 0) throw RangeError("sourceEnd out of bounds");
	r > this.length && (r = this.length), e.length - t < r - n && (r = e.length - t + n);
	var i = r - n, a;
	if (this === e && n < t && t < r) for (a = i - 1; a >= 0; --a) e[a + t] = this[a + n];
	else if (i < 1e3 || !$.TYPED_ARRAY_SUPPORT) for (a = 0; a < i; ++a) e[a + t] = this[a + n];
	else Uint8Array.prototype.set.call(e, this.subarray(n, n + i), t);
	return i;
}, $.prototype.fill = function(e, t, n, r) {
	if (typeof e == "string") {
		if (typeof t == "string" ? (r = t, t = 0, n = this.length) : typeof n == "string" && (r = n, n = this.length), e.length === 1) {
			var i = e.charCodeAt(0);
			i < 256 && (e = i);
		}
		if (r !== void 0 && typeof r != "string") throw TypeError("encoding must be a string");
		if (typeof r == "string" && !$.isEncoding(r)) throw TypeError("Unknown encoding: " + r);
	} else typeof e == "number" && (e &= 255);
	if (t < 0 || this.length < t || this.length < n) throw RangeError("Out of range index");
	if (n <= t) return this;
	t >>>= 0, n = n === void 0 ? this.length : n >>> 0, e ||= 0;
	var a;
	if (typeof e == "number") for (a = t; a < n; ++a) this[a] = e;
	else {
		var o = F2(e) ? e : f4(new $(e, r).toString()), s = o.length;
		for (a = 0; a < n - t; ++a) this[a + t] = o[a % s];
	}
	return this;
};
var c4 = /[^+\/0-9A-Za-z-_]/g;
function l4(e) {
	if (e = u4(e).replace(c4, ""), e.length < 2) return "";
	for (; e.length % 4 != 0;) e += "=";
	return e;
}
function u4(e) {
	return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
}
function d4(e) {
	return e < 16 ? "0" + e.toString(16) : e.toString(16);
}
function f4(e, t) {
	t ||= Infinity;
	for (var n, r = e.length, i = null, a = [], o = 0; o < r; ++o) {
		if (n = e.charCodeAt(o), n > 55295 && n < 57344) {
			if (!i) {
				if (n > 56319) {
					(t -= 3) > -1 && a.push(239, 191, 189);
					continue;
				} else if (o + 1 === r) {
					(t -= 3) > -1 && a.push(239, 191, 189);
					continue;
				}
				i = n;
				continue;
			}
			if (n < 56320) {
				(t -= 3) > -1 && a.push(239, 191, 189), i = n;
				continue;
			}
			n = (i - 55296 << 10 | n - 56320) + 65536;
		} else i && (t -= 3) > -1 && a.push(239, 191, 189);
		if (i = null, n < 128) {
			if (--t < 0) break;
			a.push(n);
		} else if (n < 2048) {
			if ((t -= 2) < 0) break;
			a.push(n >> 6 | 192, n & 63 | 128);
		} else if (n < 65536) {
			if ((t -= 3) < 0) break;
			a.push(n >> 12 | 224, n >> 6 & 63 | 128, n & 63 | 128);
		} else if (n < 1114112) {
			if ((t -= 4) < 0) break;
			a.push(n >> 18 | 240, n >> 12 & 63 | 128, n >> 6 & 63 | 128, n & 63 | 128);
		} else throw Error("Invalid code point");
	}
	return a;
}
function p4(e) {
	for (var t = [], n = 0; n < e.length; ++n) t.push(e.charCodeAt(n) & 255);
	return t;
}
function m4(e, t) {
	for (var n, r, i, a = [], o = 0; o < e.length && !((t -= 2) < 0); ++o) n = e.charCodeAt(o), r = n >> 8, i = n % 256, a.push(i), a.push(r);
	return a;
}
function h4(e) {
	return h2(l4(e));
}
function g4(e, t, n, r) {
	for (var i = 0; i < r && !(i + n >= t.length || i >= e.length); ++i) t[i + n] = e[i];
	return i;
}
function _4(e) {
	return e !== e;
}
function v4(e) {
	return e != null && (!!e._isBuffer || y4(e) || b4(e));
}
function y4(e) {
	return !!e.constructor && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
}
function b4(e) {
	return typeof e.readFloatLE == "function" && typeof e.slice == "function" && y4(e.slice(0, 0));
}
var qre = class e {
	data;
	width;
	height;
	format;
	constructor(e) {
		let t = new pR(e);
		this.data = e, this.width = t.width, this.height = t.height, this.format = "png";
	}
	static isValid(t) {
		try {
			return !!new e(t);
		} catch {
			return !1;
		}
	}
}, Jre = class {
	data;
	width;
	height;
	format;
	constructor(e) {
		if (this.data = e, this.format = "jpeg", this.width = 0, this.height = 0, e.readUInt16BE(0) !== 65496) throw Error("SOI not found in JPEG");
		let t = mA.decode(this.data), n;
		for (let e = 0; e < t.length; e += 1) {
			let r = t[e];
			r.name === "EXIF" && r.entries.orientation && (n = r.entries.orientation), r.name === "SOF" && (this.width ||= r.width, this.height ||= r.height);
		}
		n > 4 && ([this.width, this.height] = [this.height, this.width]);
	}
	static isValid(e) {
		return e && $.isBuffer(e) && e.readUInt16BE(0) === 65496;
	}
};
(({ limit: e = 100 } = {}) => {
	let t = {}, n = [];
	return {
		get: (e) => e ? t[e] : null,
		set: (r, i) => {
			n.push(r), n.length > e && delete t[n.shift()], t[r] = i;
		},
		reset: () => {
			t = {}, n = [];
		},
		length: () => n.length
	};
})({ limit: 30 }), $.isBuffer;
var x4 = (e, t) => {
	switch (t) {
		case "uppercase": return e.toUpperCase();
		case "lowercase": return e.toLowerCase();
		case "capitalize": return $q(e);
		case "upperfirst": return fJ(e);
		default: return e;
	}
}, S4 = (e) => e.type === ny, C4 = (e) => e.type === ly, w4 = L1({
	bidi: z1,
	linebreaker: f0,
	justification: O0,
	textDecoration: j0,
	scriptItemizer: N0,
	wordHyphenation: z0,
	fontSubstitution: U0
}), T4 = (e, t) => {
	if (!t) return [{ string: "" }];
	let n = [], { fill: r = "black", fontFamily: i = "Helvetica", fontWeight: a, fontStyle: o, fontSize: s = 18, textDecorationColor: c, textDecorationStyle: l, textTransform: u, opacity: d } = t.props, f = t.props.textDecoration, p = typeof i == "string" ? [i] : [...i || []];
	p.push("Helvetica");
	let m = {
		font: p.map((t) => {
			let n = {
				fontFamily: t,
				fontWeight: a,
				fontStyle: o
			};
			return e.getFont(n)?.data;
		}),
		opacity: d,
		fontSize: s,
		color: r,
		underlineStyle: l,
		underline: f === "underline" || f === "underline line-through" || f === "line-through underline",
		underlineColor: c || r,
		strike: f === "line-through" || f === "underline line-through" || f === "line-through underline",
		strikeStyle: l,
		strikeColor: c || r
	};
	for (let r = 0; r < t.children.length; r += 1) {
		let i = t.children[r];
		C4(i) ? n.push({
			string: x4(i.value, u),
			attributes: m
		}) : i && n.push(...T4(e, i));
	}
	return n;
}, E4 = (e, t) => jQ(T4(e, t)), D4 = 999999999999, O4 = {
	before: -.5,
	after: -.5
}, k4 = (e) => (t, n) => {
	let r = w4(E4(e, t), {
		x: t.props.x === void 0 ? n : t.props.x,
		y: t.props?.y || 0,
		width: D4,
		height: D4
	}, {
		hyphenationCallback: t.props.hyphenationCallback || e?.getHyphenationCallback() || null,
		shrinkWhitespaceFactor: O4
	}).flat();
	return Object.assign({}, t, { lines: r });
}, A4 = (e) => {
	let t = e.children.map((t, n) => {
		if (!S4(t)) return t;
		let r = t.children[0];
		return t.props.x === void 0 && n < e.children.length - 1 && r?.value ? Object.assign({}, t, { children: [{
			...r,
			value: `${r.value} `
		}] }) : t;
	}, []);
	return Object.assign({}, e, { children: t });
}, j4 = (e, t) => {
	if (!t.children) return t;
	let n = t.props?.x || 0, r = k4(e), i = A4(t).children.map((e) => {
		let t = r(e, n);
		return n += t.lines[0].xAdvance, t;
	});
	return Object.assign({}, t, { children: i });
}, M4 = (e) => e.type === ey, N4 = (e) => ((e.children || []).find(M4)?.children || []).reduce((e, t) => {
	let n = t.props?.id;
	return n && (e[n] = t), e;
}, {}), P4 = (e) => e.type !== ey, F4 = (e) => {
	if (!e.children) return e;
	let t = e.children.filter(P4);
	return Object.assign({}, e, { children: t });
}, I4 = /url\(['"]?#([^'"]+)['"]?\)/, L4 = (e, t) => {
	if (t) return I4.test(t) ? e[t.match(I4)[1]] : t;
}, R4 = (e) => (t) => {
	let n = t.props, r = "fill" in n ? L4(e, n?.fill) : void 0, i = "clipPath" in n ? L4(e, n?.clipPath) : void 0, a = Object.assign({}, t.props, {
		fill: r,
		clipPath: i
	}), o = t.children ? t.children.map(R4(e)) : void 0;
	return Object.assign({}, t, {
		props: a,
		children: o
	});
}, z4 = (e) => {
	if (!e.children) return e;
	let t = N4(e), n = e.children.map(R4(t));
	return Object.assign({}, e, { children: n });
}, B4 = (e) => F4(z4(e)), V4 = (e) => {
	if (!e) return null;
	if (typeof e != "string") return e;
	let t = e.split(/[,\s]+/).map(mJ);
	return t.length === 4 ? {
		minX: t[0],
		minY: t[1],
		maxX: t[2],
		maxY: t[3]
	} : null;
}, H4 = (e) => {
	let t = V4(e.props.viewBox);
	return t ? {
		width: t.maxX,
		height: t.maxY
	} : e.props.width && e.props.height ? {
		width: mJ(e.props.width),
		height: mJ(e.props.height)
	} : {
		width: 0,
		height: 0
	};
}, U4 = /* @__PURE__ */ "x.y.clipPath.clipRule.opacity.fill.fillOpacity.fillRule.stroke.strokeLinecap.strokeLinejoin.strokeOpacity.strokeWidth.textAnchor.dominantBaseline.color.fontFamily.fontSize.fontStyle.fontWeight.letterSpacing.opacity.textDecoration.lineHeight.textAlign.visibility.wordSpacing".split("."), W4 = pJ(["x"], U4), G4 = { [Hv]: W4 }, K4 = (e) => {
	let t = e.props || {};
	return lJ(G4[e.type] ?? U4, t);
}, q4 = (e) => {
	if (!e.children) return e;
	let t = K4(e), n = e.children.map((e) => {
		let n = Object.assign({}, t, e.props || {});
		return q4(Object.assign({}, e, { props: n }));
	});
	return Object.assign({}, e, { children: n });
}, J4 = (e) => {
	if (typeof e != "string") return e;
	let t = e.replace(/[\s\r\t\n]+/gm, " ").replace(/^defer\s/, "").split(" ");
	return {
		align: t[0] || "xMidYMid",
		meetOrSlice: t[1] || "meet"
	};
}, Y4 = [
	"width",
	"height",
	"color",
	"stroke",
	"strokeWidth",
	"opacity",
	"fillOpacity",
	"strokeOpacity",
	"fill",
	"fillRule",
	"clipPath",
	"offset",
	"transform",
	"strokeLinejoin",
	"strokeLinecap",
	"strokeDasharray",
	"gradientUnits",
	"gradientTransform"
], X4 = [
	"y",
	"y1",
	"y2",
	"height",
	"cy",
	"ry"
], Z4 = [
	"x",
	"x1",
	"x2",
	"width",
	"cx",
	"rx"
], Q4 = (e) => e.type === "SVG", $4 = (e) => e.type === Hv, e3 = (e) => e.type === ly, t3 = (e) => (t) => oJ(t, (t, n) => {
	let r = cJ(t);
	return r && X4.includes(n) ? r.percent * e.height : r && Z4.includes(n) ? r.percent * e.width : t;
}), n3 = (e) => {
	let t = cJ(e);
	return t ? t.percent : mJ(e);
}, r3 = (e) => (t) => TQ(e, { transform: t }).transform, i3 = (e) => (t) => {
	let n = t3(e)(t.props);
	return n = rJ({
		x: mJ,
		x1: mJ,
		x2: mJ,
		y: mJ,
		y1: mJ,
		y2: mJ,
		r: mJ,
		rx: mJ,
		ry: mJ,
		cx: mJ,
		cy: mJ,
		width: mJ,
		height: mJ,
		offset: n3,
		fill: SZ,
		opacity: n3,
		stroke: SZ,
		stopOpacity: n3,
		stopColor: SZ,
		transform: r3(e),
		gradientTransform: r3(e)
	}, n), Object.assign({}, t, { props: n });
}, a3 = (e) => {
	let t = e.style || {}, n = Object.assign({}, t, e.props);
	return Object.assign({}, e, { props: n });
}, o3 = (e) => {
	let t = oJ(e.props, (e) => e === "none" ? null : e);
	return Object.assign({}, e, { props: t });
}, s3 = (e) => {
	let t = lJ(Y4, e.props || {}), n = Object.assign({}, t, e.style || {});
	return Object.assign({}, e, { style: n });
}, c3 = (e) => {
	let t = rJ({
		width: mJ,
		height: mJ,
		viewBox: V4,
		preserveAspectRatio: J4
	}, e.props);
	return Object.assign({}, e, { props: t });
}, l3 = (e) => ({
	type: ny,
	props: {},
	style: {},
	children: [e]
}), u3 = (e) => {
	if (!$4(e) || !e.children) return e;
	let t = e.children.map((e) => e3(e) ? l3(e) : e);
	return Object.assign({}, e, { children: t });
}, d3 = (e) => (t) => {
	if ($4(t)) return j4(e, t);
	if (!t.children) return t;
	let n = t.children.map(d3(e));
	return Object.assign({}, t, { children: n });
}, f3 = (e) => tJ(i3(e), u3, o3, a3), p3 = (e) => (t) => {
	if (!t.children) return t;
	let n = tJ(p3(e), f3(e)), r = t.children.map(n);
	return Object.assign({}, t, { children: r });
}, m3 = (e) => {
	let t = {}, n = e.children?.slice(0) || [];
	for (; n.length > 0;) {
		let e = n.shift();
		e.props && "id" in e.props && (t[e.props.id] = e), e.children && n.push(...e.children);
	}
	return t;
}, h3 = (e, t) => {
	if (e.props && "xlinkHref" in e.props) {
		let n = t[e.props.xlinkHref.replace(/^#/, "")];
		if (!n) return e;
		let r = Object.assign({}, n.props, e.props);
		return delete r.xlinkHref, Object.assign({}, n, { props: r });
	}
	let n = e.children?.map((e) => h3(e, t));
	return Object.assign({}, e, { children: n });
}, g3 = (e) => h3(e, m3(e)), _3 = (e, t) => {
	let n = H4(e);
	return tJ(B4, d3(t), c3, s3, q4, p3(n), g3)(e);
}, v3 = (e, t) => {
	if (!("children" in e)) return e;
	let n = (e) => v3(e, t), r = Q4(e) ? _3(e, t) : e, i = r.children?.map(n);
	return Object.assign({}, r, { children: i });
}, y3 = (e) => e.style.zIndex, b3 = (e) => e.type !== "DOCUMENT" && e.type !== "SVG", x3 = (e, t) => {
	let n = y3(e), r = y3(t);
	return !n && !r ? 0 : n ? r ? r - n : -1 : 1;
}, S3 = (e) => {
	if (!e.children) return e;
	let t = (b3(e) ? e.children.sort(x3) : e.children).map(S3);
	return Object.assign({}, e, { children: t });
}, C3 = {}, w3 = c2(), T3 = (e) => {
	let t = [];
	for (let n = 0; n < e.length; n += 1) {
		let r = e[n], i = 0;
		Array.from(r.string.matchAll(w3)).forEach((e) => {
			let { index: n } = e, a = e[0], o = r.attributes.fontSize, s = r.string.slice(i, n + e[0].length);
			C3[a] && C3[a].data ? t.push({
				string: s.replace(e[0], "￼"),
				attributes: {
					...r.attributes,
					attachment: {
						width: o,
						height: o,
						yOffset: Math.floor(o * .1),
						image: C3[a].data
					}
				}
			}) : t.push({
				string: s,
				attributes: r.attributes
			}), i = n + a.length;
		}), i < r.string.length && t.push({
			string: r.string.slice(i),
			attributes: r.attributes
		});
	}
	return t;
}, E3 = (e) => e.type === Uv, D3 = {
	color: "blue",
	textDecoration: "underline"
}, O3 = (e, t) => {
	let n = [t.style];
	return E3(t) && (n = Array.isArray(t.style) ? [D3, ...t.style] : [D3, t.style]), TQ(e, n);
}, k3 = (e) => (t) => {
	let n = O3(e, t);
	if (!t.children) return Object.assign({}, t, { style: n });
	let r = t.children.map(k3(e));
	return Object.assign({}, t, {
		style: n,
		children: r
	});
}, A3 = (e) => (t) => iJ(t.style?.[e]) ? "50%" : t.style?.[e] ?? null, j3 = (e) => {
	if (!e.box) return null;
	let { left: t, top: n, width: r, height: i } = e.box, a = A3("transformOriginX")(e), o = A3("transformOriginY")(e), s = cJ(a), c = cJ(o), l = s ? r * s.percent : a, u = c ? i * c.percent : o;
	if (iJ(l) || typeof l == "string") throw Error(`Invalid origin offsetX: ${l}`);
	if (iJ(u) || typeof u == "string") throw Error(`Invalid origin offsetY: ${u}`);
	return {
		left: t + l,
		top: n + u
	};
}, M3 = (e) => {
	let t = j3(e), n = Object.assign({}, e, { origin: t });
	if (!e.children) return n;
	let r = e.children.map(M3);
	return Object.assign({}, n, { children: r });
}, N3 = (e) => e.props && "fixed" in e.props ? e.props.fixed === !0 : !1, P3 = (e, t) => {
	let n = 0;
	if (!e.lines) return 0;
	for (let r = 0; r < e.lines.length; r += 1) {
		let i = e.lines[r];
		if (n + i.box.height > t) return r;
		n += i.box.height;
	}
	return e.lines.length;
}, F3 = (e, t) => {
	let n = 0;
	if (!e.lines) return n;
	for (let r = 0; r < t; r += 1) {
		let t = e.lines[r];
		if (!t) break;
		n += t.box.height;
	}
	return n;
}, I3 = (e, t) => {
	let n = e.box?.top || 0, r = e.props.widows || 2, i = e.props.orphans || 2, a = e.lines.length, o = P3(e, t - n);
	return o === 0 ? 0 : a < i ? a : o < i || a < i + r ? 0 : a === i + r ? i : a - o < r ? a - r : o;
}, L3 = (e, t) => {
	let n = I3(e, t), r = F3(e, n), i = e.box.height - r;
	return [Object.assign({}, e, {
		box: {
			...e.box,
			height: r,
			borderBottomWidth: 0
		},
		style: {
			...e.style,
			marginBottom: 0,
			paddingBottom: 0,
			borderBottomWidth: 0,
			borderBottomLeftRadius: 0,
			borderBottomRightRadius: 0
		},
		lines: e.lines.slice(0, n)
	}), Object.assign({}, e, {
		box: {
			...e.box,
			top: 0,
			height: i,
			borderTopWidth: 0
		},
		style: {
			...e.style,
			marginTop: 0,
			paddingTop: 0,
			borderTopWidth: 0,
			borderTopLeftRadius: 0,
			borderTopRightRadius: 0
		},
		lines: e.lines.slice(n)
	})];
}, R3 = (e) => e.box?.top || 0, z3 = (e) => !iJ(e.style?.height), B3 = (e, t) => {
	if (!e) return [null, null];
	let n = R3(e), r = Object.assign({}, e, {
		box: {
			...e.box,
			borderBottomWidth: 0
		},
		style: {
			...e.style,
			marginBottom: 0,
			paddingBottom: 0,
			borderBottomWidth: 0,
			borderBottomLeftRadius: 0,
			borderBottomRightRadius: 0
		}
	});
	r.style.height = t - n;
	let i = z3(e) ? e.box.height - (t - n) : null, a = Object.assign({}, e, {
		box: {
			...e.box,
			top: 0,
			borderTopWidth: 0
		},
		style: {
			...e.style,
			marginTop: 0,
			paddingTop: 0,
			borderTopWidth: 0,
			borderTopLeftRadius: 0,
			borderTopRightRadius: 0
		}
	});
	return i && (a.style.height = i), [r, a];
}, V3 = [
	"SVG",
	Gv,
	ty,
	ry
], H3 = (e) => V3.includes(e.type) ? !1 : e.props && "wrap" in e.props ? e.props.wrap : !0, U3 = (e, t) => {
	let { yogaNode: n } = e;
	return n ? n.getComputedPadding(t) : null;
}, W3 = (e) => {
	let { style: t, box: n } = e;
	return {
		paddingTop: U3(e, Y0.Top) || n?.paddingTop || t?.paddingTop || 0,
		paddingRight: U3(e, Y0.Right) || n?.paddingRight || t?.paddingRight || 0,
		paddingBottom: U3(e, Y0.Bottom) || n?.paddingBottom || t?.paddingBottom || 0,
		paddingLeft: U3(e, Y0.Left) || n?.paddingLeft || t?.paddingLeft || 0
	};
}, G3 = (e) => typeof e == "string", K3 = (e) => typeof e == "number", q3 = (e) => typeof e == "boolean", J3 = (e) => e && e.type === Symbol.for("react.fragment"), Y3 = (e) => {
	if (!e) return [];
	if (Array.isArray(e)) return e.reduce((e, t) => e.concat(Y3(t)), []);
	if (q3(e)) return [];
	if (G3(e) || K3(e)) return [{
		type: ly,
		value: `${e}`
	}];
	if (J3(e)) return Y3(e.props.children);
	if (!G3(e.type)) return Y3(e.type(e.props));
	let { type: t, props: { style: n = {}, children: r, ...i } } = e;
	return [{
		type: t,
		style: n,
		props: i,
		children: eJ(r).reduce((e, t) => e.concat(Y3(t)), [])
	}];
}, X3 = (e) => "break" in e.props ? e.props.break : !1, Z3 = (e) => "minPresenceAhead" in e.props ? e.props.minPresenceAhead : 0, Q3 = (e) => Math.max(...e.map((e) => e.box.top + e.box.height)), $3 = (e) => e.box.top + e.box.height + e.box.marginBottom + Z3(e), e6 = (e, t) => {
	let n = $3(e), r = Q3(t.filter((e) => !("fixed" in e.props)));
	return Math.min(n, r);
}, t6 = (e, t, n) => {
	if ("fixed" in e.props) return !1;
	let r = n < e.box.top + e.box.height, i = H3(e), a = e6(e, t), o = e.box.top > e.box.marginTop;
	return X3(e) || r && !i || !r && a > n && o;
}, n6 = [8232, 8233], r6 = (e) => n6.reduce((t, n) => e && e.hasGlyphForCodePoint && e.hasGlyphForCodePoint(n) ? t : [...t, String.fromCharCode(n)], []), i6 = [(e) => e.map((e) => {
	let t = r6(e.attributes.font[0]), n = new RegExp(t.join("|"));
	return {
		string: e.string.replace(n, ""),
		attributes: e.attributes
	};
}), T3], a6 = (e) => e.type === ty, o6 = (e) => e.type === ly, s6 = (e, t, n = null, r = 0) => {
	if (!t) return [{ string: "" }];
	let i = [], { color: a = "black", direction: o = "ltr", fontFamily: s = "Helvetica", fontWeight: c, fontStyle: l, fontSize: u = 18, textAlign: d, lineHeight: f, textDecoration: p, textDecorationColor: m, textDecorationStyle: h, textTransform: g, letterSpacing: _, textIndent: v, opacity: y, verticalAlign: b } = t.style, x = typeof s == "string" ? [s] : [...s || []];
	x.push("Helvetica");
	let S = {
		font: x.map((t) => {
			let n = {
				fontFamily: t,
				fontWeight: c,
				fontStyle: l
			};
			return e.getFont(n)?.data;
		}),
		color: a,
		opacity: y,
		fontSize: u,
		lineHeight: f,
		direction: o,
		verticalAlign: b,
		backgroundColor: r === 0 ? null : t.style.backgroundColor,
		indent: v,
		characterSpacing: _,
		strikeStyle: h,
		underlineStyle: h,
		underline: p === "underline" || p === "underline line-through" || p === "line-through underline",
		strike: p === "line-through" || p === "underline line-through" || p === "line-through underline",
		strikeColor: m || a,
		underlineColor: m || a,
		link: n || t.props?.src || t.props?.href,
		align: d || (o === "rtl" ? "right" : "left")
	};
	for (let n = 0; n < t.children.length; n += 1) {
		let a = t.children[n];
		a6(a) ? i.push({
			string: "￼",
			attributes: {
				...S,
				attachment: {
					width: a.style.width || u,
					height: a.style.height || u,
					image: a.image.data
				}
			}
		}) : o6(a) ? i.push({
			string: x4(a.value, g),
			attributes: S
		}) : a && i.push(...s6(e, a, S.link, r + 1));
	}
	for (let e = 0; e < i6.length; e += 1) {
		let t = i6[e];
		i = t(i);
	}
	return i;
}, c6 = (e, t) => jQ(s6(e, t)), l6 = L1({
	bidi: z1,
	linebreaker: f0,
	justification: O0,
	textDecoration: j0,
	scriptItemizer: N0,
	wordHyphenation: z0,
	fontSubstitution: U0
}), u6 = (e) => e.style?.maxLines, d6 = (e) => e.style?.textOverflow, f6 = (e, t, n) => {
	let r = u6(n), i = d6(n);
	return {
		x: 0,
		y: 0,
		width: e,
		maxLines: r,
		height: t || Infinity,
		truncateMode: i
	};
}, p6 = (e, t) => ({
	hyphenationPenalty: t.props.hyphenationPenalty,
	shrinkWhitespaceFactor: {
		before: -.5,
		after: -.5
	},
	hyphenationCallback: t.props.hyphenationCallback || e?.getHyphenationCallback() || null
}), m6 = (e, t, n, r) => l6(c6(r, e), f6(t, n, e), p6(r, e)).reduce((e, t) => [...e, ...t], []), h6 = (e) => e.type === "SVG", g6 = (e) => e.type === Hv, _6 = (e) => !h6(e) && !g6(e), v6 = (e) => g6(e) && !e.lines, y6 = (e, t) => {
	if (v6(e) && (e.lines = m6(e, e.box.width - (e.box.paddingRight + e.box.paddingLeft), e.box.height - (e.box.paddingTop + e.box.paddingBottom), t)), _6(e)) {
		if (!e.children) return e;
		let n = e.children.map((e) => y6(e, t));
		return Object.assign({}, e, { children: n });
	}
	return e;
}, b6 = [
	"color",
	"fontFamily",
	"fontSize",
	"fontStyle",
	"fontWeight",
	"letterSpacing",
	"opacity",
	"textDecoration",
	"textTransform",
	"lineHeight",
	"textAlign",
	"visibility",
	"wordSpacing"
], x6 = [...b6, "backgroundColor"], S6 = (e) => (t) => t.type === e, C6 = S6("SVG"), w6 = S6(Hv), T6 = (e, t, n) => {
	switch (e) {
		case "textDecoration": return [n, t].filter((e) => e && e !== "none").join(" ");
		default: return t;
	}
}, E6 = (e, t) => {
	let n = { ...e };
	return Object.entries(t).forEach(([t, r]) => {
		n[t] = T6(t, r, e[t]);
	}), n;
}, D6 = (e) => (t) => {
	let n = E6(e, t.style || {});
	return Object.assign({}, t, { style: n });
}, O6 = (e) => {
	if (C6(e) || !("children" in e)) return e;
	let t = tJ(O6, D6(lJ(w6(e) ? x6 : b6, e.style || {}))), n = e.children.map(t);
	return Object.assign({}, e, { children: n });
}, k6 = (e, t) => {
	let { yogaNode: n } = e;
	return n ? n.getComputedMargin(t) : null;
}, A6 = (e) => {
	let { style: t, box: n } = e;
	return {
		marginTop: k6(e, Y0.Top) || n?.marginTop || t?.marginTop || 0,
		marginRight: k6(e, Y0.Right) || n?.marginRight || t?.marginRight || 0,
		marginBottom: k6(e, Y0.Bottom) || n?.marginBottom || t?.marginBottom || 0,
		marginLeft: k6(e, Y0.Left) || n?.marginLeft || t?.marginLeft || 0
	};
}, j6 = (e) => {
	let { yogaNode: t } = e;
	return {
		top: t?.getComputedTop() || 0,
		right: t?.getComputedRight() || 0,
		bottom: t?.getComputedBottom() || 0,
		left: t?.getComputedLeft() || 0
	};
}, M6 = {
	width: 0,
	height: 0
}, N6 = (e) => {
	let { yogaNode: t } = e;
	return t ? {
		width: t.getComputedWidth(),
		height: t.getComputedHeight()
	} : M6;
}, P6 = (e, t) => e ? e.getComputedBorder(t) : 0, F6 = (e) => {
	let { yogaNode: t } = e;
	return {
		borderTopWidth: P6(t, Y0.Top),
		borderRightWidth: P6(t, Y0.Right),
		borderBottomWidth: P6(t, Y0.Bottom),
		borderLeftWidth: P6(t, Y0.Left)
	};
}, I6 = (e) => (t) => {
	let { yogaNode: n } = t;
	return n && n.setDisplay(e === "none" ? J0.None : J0.Flex), t;
}, L6 = {
	hidden: i2.Hidden,
	scroll: i2.Scroll
}, R6 = (e) => (t) => {
	let { yogaNode: n } = t;
	if (!iJ(e) && n) {
		let t = L6[e] || i2.Visible;
		n.setOverflow(t);
	}
	return t;
}, z6 = {
	wrap: s2.Wrap,
	"wrap-reverse": s2.WrapReverse
}, B6 = (e) => (t) => {
	let { yogaNode: n } = t;
	if (n) {
		let t = z6[e] || s2.NoWrap;
		n.setFlexWrap(t);
	}
	return t;
}, V6 = (e, t) => (n) => (r) => {
	let { yogaNode: i } = r;
	if (!iJ(n) && i) {
		let r = !iJ(t), a = `set${fJ(e)}`, o = `${a}Auto`, s = `${a}Percent`, c = cJ(n);
		if (c && !i[s]) throw Error(`You can't pass percentage values to ${e} property`);
		c ? r ? i[s]?.(t, c.value) : i[s]?.(c.value) : n === "auto" ? r ? i[o]?.(t) : i[o]?.() : r ? i[a]?.(t, n) : i[a]?.(n);
	}
	return r;
}, H6 = (e) => (t) => V6("flexGrow")(e || 0)(t), U6 = V6("flexBasis"), W6 = {
	"flex-start": W0.FlexStart,
	center: W0.Center,
	"flex-end": W0.FlexEnd,
	stretch: W0.Stretch,
	baseline: W0.Baseline,
	"space-between": W0.SpaceBetween,
	"space-around": W0.SpaceAround,
	"space-evenly": W0.SpaceEvenly
}, G6 = (e) => (t) => (n) => {
	let { yogaNode: r } = n, i = e === "items" ? W0.Stretch : W0.Auto;
	if (r) {
		let n = W6[t] || i;
		r[`setAlign${fJ(e)}`](n);
	}
	return n;
}, K6 = G6("self"), q6 = G6("items"), J6 = (e) => (t) => V6("flexShrink")(e || 1)(t), Y6 = (e) => (t) => {
	let { yogaNode: n } = t;
	return !iJ(e) && n && n.setAspectRatio(e), t;
}, X6 = G6("content"), Z6 = {
	absolute: a2.Absolute,
	relative: a2.Relative,
	static: a2.Static
}, Q6 = (e) => (t) => {
	let { yogaNode: n } = t;
	return !iJ(e) && n && n.setPositionType(Z6[e]), t;
}, $6 = {
	row: Q0.Row,
	"row-reverse": Q0.RowReverse,
	"column-reverse": Q0.ColumnReverse
}, e8 = (e) => (t) => {
	let { yogaNode: n } = t;
	if (n) {
		let t = $6[e] || Q0.Column;
		n.setFlexDirection(t);
	}
	return t;
}, t8 = {
	center: e2.Center,
	"flex-end": e2.FlexEnd,
	"space-between": e2.SpaceBetween,
	"space-around": e2.SpaceAround,
	"space-evenly": e2.SpaceEvenly
}, n8 = (e) => (t) => {
	let { yogaNode: n } = t;
	if (!iJ(e) && n) {
		let t = t8[e] || e2.FlexStart;
		n.setJustifyContent(t);
	}
	return t;
}, r8 = V6("margin", Y0.Top), i8 = V6("margin", Y0.Right), a8 = V6("margin", Y0.Bottom), o8 = V6("margin", Y0.Left), s8 = V6("padding", Y0.Top), Yre = V6("padding", Y0.Right), Xre = V6("padding", Y0.Bottom), Zre = V6("padding", Y0.Left), Qre = V6("border", Y0.Top), $re = V6("border", Y0.Right), eie = V6("border", Y0.Bottom), tie = V6("border", Y0.Left), nie = V6("position", Y0.Top), rie = V6("position", Y0.Right), iie = V6("position", Y0.Bottom), aie = V6("position", Y0.Left), oie = V6("width"), sie = V6("minWidth"), cie = V6("maxWidth"), lie = V6("height"), uie = V6("minHeight"), die = V6("maxHeight"), fie = V6("gap", $0.Row), pie = V6("gap", $0.Column), mie = (e) => !e || typeof e == "string" ? null : (e.maxX - e.minX) / (e.maxY - e.minY), hie = (e, t) => (e, n, r, i) => {
	let a = mie(t.props.viewBox) || 1;
	return n === n2.Exactly || n === n2.AtMost ? {
		width: e,
		height: e / a
	} : i === n2.Exactly ? { width: r * a } : {};
}, c8 = (e) => e.lines ? Math.max(0, ...e.lines.map((e) => e.xAdvance)) : 0, l8 = (e) => e.lines ? e.lines.reduce((e, t) => e + t.box.height, 0) : -1, gie = {
	center: .5,
	right: 1
}, _ie = (e, t, n) => (e, r, i) => {
	if (r === n2.Exactly) return t.lines ||= m6(t, e, i, n), { height: l8(t) };
	if (r === n2.AtMost) {
		let r = gie[t.style?.textAlign] || 0;
		return t.lines || (t.lines = m6(t, e, i, n), t.alignOffset = (e - c8(t)) * r), {
			height: l8(t),
			width: Math.min(e, c8(t))
		};
	}
	return {};
}, vie = (e) => e.image?.data ? e.image.width / e.image.height : 1, u8 = (e) => iJ(e.box?.height), yie = 10, bie = (e, t) => (n, r, i, a) => {
	let o = vie(t), s = A6(t), c = W3(e), l = u8(e) ? Infinity : (e.box?.height || 0) - c.paddingTop - c.paddingBottom - s.marginTop - s.marginBottom - yie;
	if (!t.image) return {
		width: 0,
		height: 0
	};
	if (r === n2.Exactly && a === n2.Undefined) {
		let e = n / o;
		return { height: Math.min(l, e) };
	}
	if (a === n2.Exactly && (r === n2.AtMost || r === n2.Undefined)) return { width: Math.min(i * o, n) };
	if (r === n2.Exactly && a === n2.AtMost) {
		let e = n / o;
		return { height: Math.min(i, l, e) };
	}
	return r === n2.AtMost && a === n2.AtMost ? o > 1 ? {
		width: n,
		height: Math.min(n / o, i)
	} : {
		height: i,
		width: Math.min(i * o, n)
	} : {
		height: i,
		width: n
	};
}, xie = 10, d8 = (e) => Math.max(-Infinity, ...e), Sie = () => {
	let e = {}, t = [], n = () => e, r = (e, n) => t.push([e, n]), i = (t, n) => (r(t, n), e), a = (t, n, i, a) => (r(t, n), r(t + i, n), r(t, n + a), r(t + i, n + a), e), o = (t, n, i, a) => (a ||= i, r(t - i, n - a), r(t + i, n - a), r(t + i, n + a), r(t - i, n + a), e);
	return e.rect = a, e.moveTo = i, e.lineTo = i, e.circle = o, e.polygon = (...n) => (t.push(...n), e), e.ellipse = o, e.roundedRect = a, e.text = n, e.path = n, e.lineWidth = n, e.bezierCurveTo = n, e.quadraticCurveTo = n, e.scale = n, e.rotate = n, e.translate = n, e.dash = n, e.clip = n, e.save = n, e.fill = n, e.font = n, e.stroke = n, e.lineCap = n, e.opacity = n, e.restore = n, e.lineJoin = n, e.fontSize = n, e.fillColor = n, e.miterLimit = n, e.strokeColor = n, e.fillOpacity = n, e.strokeOpacity = n, e.linearGradient = n, e.radialGradient = n, e.getWidth = () => d8(t.map((e) => e[0])), e.getHeight = () => d8(t.map((e) => e[1])), e;
}, Cie = (e, t) => () => {
	let n = A6(t), r = W3(e), i = u8(e) ? Infinity : (e.box?.height || 0) - r.paddingTop - r.paddingBottom - n.marginTop - n.marginBottom - xie, a = Sie();
	return t.props.paint(a), {
		width: a.getWidth(),
		height: Math.min(i, a.getHeight())
	};
}, f8 = (e) => (t) => t.type === e, p8 = f8("SVG"), m8 = f8(Hv), wie = f8(Gv), Tie = f8(Wv), Eie = f8(ty), Die = f8(ry), Oie = f8(ly), kie = (e) => lie(Tie(e) ? e.box?.height : e.style?.height), Aie = (e) => {
	tJ(kie(e), oie(e.style.width), sie(e.style.minWidth), cie(e.style.maxWidth), uie(e.style.minHeight), die(e.style.maxHeight), r8(e.style.marginTop), i8(e.style.marginRight), a8(e.style.marginBottom), o8(e.style.marginLeft), s8(e.style.paddingTop), Yre(e.style.paddingRight), Xre(e.style.paddingBottom), Zre(e.style.paddingLeft), Q6(e.style.position), nie(e.style.top), rie(e.style.right), iie(e.style.bottom), aie(e.style.left), Qre(e.style.borderTopWidth), $re(e.style.borderRightWidth), eie(e.style.borderBottomWidth), tie(e.style.borderLeftWidth), I6(e.style.display), e8(e.style.flexDirection), K6(e.style.alignSelf), X6(e.style.alignContent), q6(e.style.alignItems), n8(e.style.justifyContent), B6(e.style.flexWrap), R6(e.style.overflow), Y6(e.style.aspectRatio), U6(e.style.flexBasis), H6(e.style.flexGrow), J6(e.style.flexShrink), fie(e.style.rowGap), pie(e.style.columnGap))(e);
}, jie = (e) => (t) => (e.insertChild(t.yogaNode, e.getChildCount()), t), Mie = (e, t, n) => {
	let { yogaNode: r } = e;
	return m8(e) && r.setMeasureFunc(_ie(t, e, n)), Eie(e) && r.setMeasureFunc(bie(t, e)), Die(e) && r.setMeasureFunc(Cie(t, e)), p8(e) && r.setMeasureFunc(hie(t, e)), e;
}, Nie = (e) => !m8(e) && !wie(e) && !p8(e), Pie = (e, t, n) => (r) => {
	let i = n.node.create(), a = Object.assign({}, r, { yogaNode: i });
	if (Aie(a), Nie(r) && r.children) {
		let o = tJ(jie(i), Pie(e, t, n));
		a.children = r.children.map(o);
	}
	return Mie(a, e, t), a;
}, Fie = (e) => {
	if (Oie(e)) return e;
	let t = Object.assign(W3(e), A6(e), F6(e), j6(e), N6(e)), n = Object.assign({}, e, { box: t });
	if (!e.children) return n;
	let r = e.children.map(Fie);
	return Object.assign({}, n, { children: r });
}, Iie = (e) => {
	let t = Object.assign({}, e);
	if (delete t.yogaNode, !e.children) return t;
	let n = e.children.map(Iie);
	return Object.assign({}, t, { children: n });
}, h8 = (e) => e.type === Hv, Lie = .001, g8 = (e, t) => Object.assign({}, t, { children: e }), _8 = (e) => e.box?.top || 0, v8 = (e) => e.props && "render" in e.props, Rie = (e) => {
	console.warn(`Node of type ${e.type} can't wrap between pages and it's bigger than available page height`);
}, zie = (e, t, n) => {
	let r = [], i = [];
	for (let a = 0; a < n.length; a += 1) {
		let o = n[a], s = n.slice(a + 1), c = s.filter(N3), l = _8(o), u = o.box.height, d = e <= l, f = t6(o, s, e), p = e + Lie < l + u, m = H3(o), h = u <= t;
		if (N3(o)) {
			i.push(o), r.push(o);
			continue;
		}
		if (d) {
			let t = Object.assign({}, o.box, { top: o.box.top - e }), n = Object.assign({}, o, { box: t });
			i.push(n);
			continue;
		}
		if (!h && !m) {
			r.push(o), i.push(...s), Rie(o);
			break;
		}
		if (f) {
			let t = Object.assign({}, o.box, { top: o.box.top - e }), n = Object.assign({}, o.props, {
				wrap: !0,
				break: !1
			}), a = Object.assign({}, o, {
				box: t,
				props: n
			});
			r.push(...c), i.push(a, ...s);
			break;
		}
		if (p) {
			let [n, a] = Hie(o, e, t);
			if (o.children.length > 0 && n.children.length === 0) {
				if (r.length === 0) r.push(o, ...c), i.push(...s);
				else {
					let t = Object.assign({}, o.box, { top: o.box.top - e }), n = Object.assign({}, o, { box: t });
					r.push(...c), i.push(n, ...s);
				}
				break;
			}
			n && r.push(n), a && i.push(a);
			continue;
		}
		r.push(o);
	}
	return [r, i];
}, Bie = (e, t, n) => {
	let r = n.children || [];
	return zie(e - _8(n), t, r);
}, Vie = (e, t, n) => {
	let [r, i] = B3(e, t), [a, o] = Bie(t, n, e);
	return [g8(a, r), g8(o, i)];
}, Hie = (e, t, n) => h8(e) ? L3(e, t) : Vie(e, t, n), Uie = (e) => {
	let t = e.children || [];
	return v8(e) || t.some(Uie);
}, y8 = (e, t) => {
	let n = v8(t), r = (r = []) => n ? Y3(t.props.render(e)).filter(Boolean).map((t) => y8(e, t)) : r.map((t) => y8(e, t)), i = n && h8(t) ? {
		...t.box,
		height: 0
	} : t.box, a = r(t.children), o = n ? null : t.lines;
	return Object.assign({}, t, {
		box: i,
		lines: o,
		children: a
	});
}, b8 = (e) => (t) => {
	if (!t) return;
	let n = cJ(t);
	return n ? n.percent * Math.min(e.width, e.height) : t;
}, Wie = (e) => {
	let t = rJ({
		borderTopLeftRadius: b8(e.box),
		borderTopRightRadius: b8(e.box),
		borderBottomRightRadius: b8(e.box),
		borderBottomLeftRadius: b8(e.box)
	}, e.style || {}), n = Object.assign({}, e, { style: t });
	if (!e.children) return n;
	let r = e.children.map(Wie);
	return Object.assign({}, n, { children: r });
}, x8 = (e) => (t) => t.type === e, Gie = x8(Uv), S8 = x8(Hv), C8 = x8(ly), Kie = (e) => "render" in e.props, qie = (e) => S8(e) || C8(e), Jie = (e) => {
	let t = e.children || [];
	return t.every(C8) ? !0 : t.every(S8) ? !1 : t.every(qie);
}, Yie = (e) => {
	let t = {
		type: Hv,
		props: {},
		style: {},
		box: {},
		children: e.children
	};
	return Object.assign({}, e, { children: [t] });
}, Xie = (e) => Gie(e) ? Kie(e) ? Object.assign({}, e, { type: Hv }) : Jie(e) ? Yie(e) : e : e, Zie = (e) => {
	if (!e.children) return e;
	let t = tJ(Xie, Zie), n = e.children.map(t);
	return Object.assign({}, e, { children: n });
}, Qie = /* @__PURE__ */ V(((e) => {
	function t(e, t) {
		var n = e.length;
		e.push(t);
		a: for (; 0 < n;) {
			var r = n - 1 >>> 1, a = e[r];
			if (0 < i(a, t)) e[r] = t, e[n] = a, n = r;
			else break a;
		}
	}
	function n(e) {
		return e.length === 0 ? null : e[0];
	}
	function r(e) {
		if (e.length === 0) return null;
		var t = e[0], n = e.pop();
		if (n !== t) {
			e[0] = n;
			a: for (var r = 0, a = e.length, o = a >>> 1; r < o;) {
				var s = 2 * (r + 1) - 1, c = e[s], l = s + 1, u = e[l];
				if (0 > i(c, n)) l < a && 0 > i(u, c) ? (e[r] = u, e[l] = n, r = l) : (e[r] = c, e[s] = n, r = s);
				else if (l < a && 0 > i(u, n)) e[r] = u, e[l] = n, r = l;
				else break a;
			}
		}
		return t;
	}
	function i(e, t) {
		var n = e.sortIndex - t.sortIndex;
		return n === 0 ? e.id - t.id : n;
	}
	if (e.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
		var a = performance;
		e.unstable_now = function() {
			return a.now();
		};
	} else {
		var o = Date, s = o.now();
		e.unstable_now = function() {
			return o.now() - s;
		};
	}
	var c = [], l = [], u = 1, d = null, f = 3, p = !1, m = !1, h = !1, g = typeof setTimeout == "function" ? setTimeout : null, _ = typeof clearTimeout == "function" ? clearTimeout : null, v = typeof setImmediate < "u" ? setImmediate : null;
	function y(e) {
		for (var i = n(l); i !== null;) {
			if (i.callback === null) r(l);
			else if (i.startTime <= e) r(l), i.sortIndex = i.expirationTime, t(c, i);
			else break;
			i = n(l);
		}
	}
	function b(e) {
		if (h = !1, y(e), !m) if (n(c) !== null) m = !0, A();
		else {
			var t = n(l);
			t !== null && j(b, t.startTime - e);
		}
	}
	var x = !1, S = -1, C = 5, w = -1;
	function T() {
		return !(e.unstable_now() - w < C);
	}
	function E() {
		if (x) {
			var t = e.unstable_now();
			w = t;
			var i = !0;
			try {
				a: {
					m = !1, h && (h = !1, _(S), S = -1), p = !0;
					var a = f;
					try {
						b: {
							for (y(t), d = n(c); d !== null && !(d.expirationTime > t && T());) {
								var o = d.callback;
								if (typeof o == "function") {
									d.callback = null, f = d.priorityLevel;
									var s = o(d.expirationTime <= t);
									if (t = e.unstable_now(), typeof s == "function") {
										d.callback = s, y(t), i = !0;
										break b;
									}
									d === n(c) && r(c), y(t);
								} else r(c);
								d = n(c);
							}
							if (d !== null) i = !0;
							else {
								var u = n(l);
								u !== null && j(b, u.startTime - t), i = !1;
							}
						}
						break a;
					} finally {
						d = null, f = a, p = !1;
					}
					i = void 0;
				}
			} finally {
				i ? D() : x = !1;
			}
		}
	}
	var D;
	if (typeof v == "function") D = function() {
		v(E);
	};
	else if (typeof MessageChannel < "u") {
		var O = new MessageChannel(), k = O.port2;
		O.port1.onmessage = E, D = function() {
			k.postMessage(null);
		};
	} else D = function() {
		g(E, 0);
	};
	function A() {
		x || (x = !0, D());
	}
	function j(t, n) {
		S = g(function() {
			t(e.unstable_now());
		}, n);
	}
	e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(e) {
		e.callback = null;
	}, e.unstable_continueExecution = function() {
		m || p || (m = !0, A());
	}, e.unstable_forceFrameRate = function(e) {
		0 > e || 125 < e ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : C = 0 < e ? Math.floor(1e3 / e) : 5;
	}, e.unstable_getCurrentPriorityLevel = function() {
		return f;
	}, e.unstable_getFirstCallbackNode = function() {
		return n(c);
	}, e.unstable_next = function(e) {
		switch (f) {
			case 1:
			case 2:
			case 3:
				var t = 3;
				break;
			default: t = f;
		}
		var n = f;
		f = t;
		try {
			return e();
		} finally {
			f = n;
		}
	}, e.unstable_pauseExecution = function() {}, e.unstable_requestPaint = function() {}, e.unstable_runWithPriority = function(e, t) {
		switch (e) {
			case 1:
			case 2:
			case 3:
			case 4:
			case 5: break;
			default: e = 3;
		}
		var n = f;
		f = e;
		try {
			return t();
		} finally {
			f = n;
		}
	}, e.unstable_scheduleCallback = function(r, i, a) {
		var o = e.unstable_now();
		switch (typeof a == "object" && a ? (a = a.delay, a = typeof a == "number" && 0 < a ? o + a : o) : a = o, r) {
			case 1:
				var s = -1;
				break;
			case 2:
				s = 250;
				break;
			case 5:
				s = 1073741823;
				break;
			case 4:
				s = 1e4;
				break;
			default: s = 5e3;
		}
		return s = a + s, r = {
			id: u++,
			callback: i,
			priorityLevel: r,
			startTime: a,
			expirationTime: s,
			sortIndex: -1
		}, a > o ? (r.sortIndex = a, t(l, r), n(c) === null && r === n(l) && (h ? (_(S), S = -1) : h = !0, j(b, a - o))) : (r.sortIndex = s, t(c, r), m || p || (m = !0, A())), r;
	}, e.unstable_shouldYield = T, e.unstable_wrapCallback = function(e) {
		var t = f;
		return function() {
			var n = f;
			f = t;
			try {
				return e.apply(this, arguments);
			} finally {
				f = n;
			}
		};
	};
})), w8 = /* @__PURE__ */ xt((/* @__PURE__ */ V(((e, t) => {
	t.exports = Qie();
})))(), 1);
function $ie(e) {
	return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function eae(e) {
	if (e.__esModule) return e;
	var t = e.default;
	if (typeof t == "function") {
		var n = function e() {
			return this instanceof e ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
		};
		n.prototype = t.prototype;
	} else n = {};
	return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach((function(t) {
		var r = Object.getOwnPropertyDescriptor(e, t);
		Object.defineProperty(n, t, r.get ? r : {
			enumerable: !0,
			get: function() {
				return e[t];
			}
		});
	})), n;
}
var T8, E8 = { exports: {} }, D8 = { exports: {} }, tae = eae(w8), O8;
E8.exports = (T8 || (T8 = 1, (O8 = D8).exports = function(e) {
	function n(e, t, n, r) {
		return new ri(e, t, n, r);
	}
	function r(e) {
		var t = "https://react.dev/errors/" + e;
		if (1 < arguments.length) {
			t += "?args[]=" + encodeURIComponent(arguments[1]);
			for (var n = 2; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
		}
		return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
	}
	function i(e) {
		return typeof e != "object" || !e ? null : typeof (e = Ii && e[Ii] || e["@@iterator"]) == "function" ? e : null;
	}
	function a(e) {
		if (e == null) return null;
		if (typeof e == "function") return e.$$typeof === Li ? null : e.displayName || e.name || null;
		if (typeof e == "string") return e;
		switch (e) {
			case Ci: return "Fragment";
			case Si: return "Portal";
			case Ti: return "Profiler";
			case wi: return "StrictMode";
			case Ai: return "Suspense";
			case ji: return "SuspenseList";
		}
		if (typeof e == "object") switch (e.$$typeof) {
			case Oi: return (e.displayName || "Context") + ".Provider";
			case Di: return (e._context.displayName || "Context") + ".Consumer";
			case ki:
				var t = e.render;
				return (e = e.displayName) || (e = (e = t.displayName || t.name || "") === "" ? "ForwardRef" : "ForwardRef(" + e + ")"), e;
			case Mi: return (t = e.displayName || null) === null ? a(e.type) || "Memo" : t;
			case Ni:
				t = e._payload, e = e._init;
				try {
					return a(e(t));
				} catch {}
		}
		return null;
	}
	function o(e) {
		if (mi === void 0) try {
			throw Error();
		} catch (e) {
			var t = e.stack.trim().match(/\n( *(at )?)/);
			mi = t && t[1] || "", hi = -1 < e.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < e.stack.indexOf("@") ? "@unknown:0:0" : "";
		}
		return "\n" + mi + e + hi;
	}
	function s(e, t) {
		if (!e || zi) return "";
		zi = !0;
		var n = Error.prepareStackTrace;
		Error.prepareStackTrace = void 0;
		try {
			var r = { DetermineComponentFrameRoot: function() {
				try {
					if (t) {
						var n = function() {
							throw Error();
						};
						if (Object.defineProperty(n.prototype, "props", { set: function() {
							throw Error();
						} }), typeof Reflect == "object" && Reflect.construct) {
							try {
								Reflect.construct(n, []);
							} catch (e) {
								var r = e;
							}
							Reflect.construct(e, [], n);
						} else {
							try {
								n.call();
							} catch (e) {
								r = e;
							}
							e.call(n.prototype);
						}
					} else {
						try {
							throw Error();
						} catch (e) {
							r = e;
						}
						(n = e()) && typeof n.catch == "function" && n.catch((function() {}));
					}
				} catch (e) {
					if (e && r && typeof e.stack == "string") return [e.stack, r.stack];
				}
				return [null, null];
			} };
			r.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
			var i = Object.getOwnPropertyDescriptor(r.DetermineComponentFrameRoot, "name");
			i && i.configurable && Object.defineProperty(r.DetermineComponentFrameRoot, "name", { value: "DetermineComponentFrameRoot" });
			var a = r.DetermineComponentFrameRoot(), s = a[0], c = a[1];
			if (s && c) {
				var l = s.split("\n"), u = c.split("\n");
				for (i = r = 0; r < l.length && !l[r].includes("DetermineComponentFrameRoot");) r++;
				for (; i < u.length && !u[i].includes("DetermineComponentFrameRoot");) i++;
				if (r === l.length || i === u.length) for (r = l.length - 1, i = u.length - 1; 1 <= r && 0 <= i && l[r] !== u[i];) i--;
				for (; 1 <= r && 0 <= i; r--, i--) if (l[r] !== u[i]) {
					if (r !== 1 || i !== 1) do
						if (r--, 0 > --i || l[r] !== u[i]) {
							var d = "\n" + l[r].replace(" at new ", " at ");
							return e.displayName && d.includes("<anonymous>") && (d = d.replace("<anonymous>", e.displayName)), d;
						}
					while (1 <= r && 0 <= i);
					break;
				}
			}
		} finally {
			zi = !1, Error.prepareStackTrace = n;
		}
		return (n = e ? e.displayName || e.name : "") ? o(n) : "";
	}
	function c(e) {
		switch (e.tag) {
			case 26:
			case 27:
			case 5: return o(e.type);
			case 16: return o("Lazy");
			case 13: return o("Suspense");
			case 19: return o("SuspenseList");
			case 0:
			case 15: return s(e.type, !1);
			case 11: return s(e.type.render, !1);
			case 1: return s(e.type, !0);
			default: return "";
		}
	}
	function l(e) {
		try {
			var t = "";
			do
				t += c(e), e = e.return;
			while (e);
			return t;
		} catch (e) {
			return "\nError generating stack: " + e.message + "\n" + e.stack;
		}
	}
	function u(e) {
		return { current: e };
	}
	function d(e) {
		0 > Ha || (e.current = Va[Ha], Va[Ha] = null, Ha--);
	}
	function f(e, t) {
		Ha++, Va[Ha] = e.current, e.current = t;
	}
	function p(e) {
		var t = 42 & e;
		if (t !== 0) return t;
		switch (e & -e) {
			case 1: return 1;
			case 2: return 2;
			case 4: return 4;
			case 8: return 8;
			case 16: return 16;
			case 32: return 32;
			case 64: return 64;
			case 128:
			case 256:
			case 512:
			case 1024:
			case 2048:
			case 4096:
			case 8192:
			case 16384:
			case 32768:
			case 65536:
			case 131072:
			case 262144:
			case 524288:
			case 1048576:
			case 2097152: return 4194176 & e;
			case 4194304:
			case 8388608:
			case 16777216:
			case 33554432: return 62914560 & e;
			case 67108864: return 67108864;
			case 134217728: return 134217728;
			case 268435456: return 268435456;
			case 536870912: return 536870912;
			case 1073741824: return 0;
			default: return e;
		}
	}
	function m(e, t) {
		var n = e.pendingLanes;
		if (n === 0) return 0;
		var r = 0, i = e.suspendedLanes;
		e = e.pingedLanes;
		var a = 134217727 & n;
		return a === 0 ? (n &= ~i) == 0 ? e !== 0 && (r = p(e)) : r = p(n) : (n = a & ~i) == 0 ? (e &= a) != 0 && (r = p(e)) : r = p(n), r === 0 ? 0 : t !== 0 && t !== r && (t & i) == 0 && ((i = r & -r) >= (e = t & -t) || i === 32 && 4194176 & e) ? t : r;
	}
	function h(e, t) {
		switch (e) {
			case 1:
			case 2:
			case 4:
			case 8: return t + 250;
			case 16:
			case 32:
			case 64:
			case 128:
			case 256:
			case 512:
			case 1024:
			case 2048:
			case 4096:
			case 8192:
			case 16384:
			case 32768:
			case 65536:
			case 131072:
			case 262144:
			case 524288:
			case 1048576:
			case 2097152: return t + 5e3;
			default: return -1;
		}
	}
	function g() {
		var e = qa;
		return !(4194176 & (qa <<= 1)) && (qa = 128), e;
	}
	function _() {
		var e = Ja;
		return !(62914560 & (Ja <<= 1)) && (Ja = 4194304), e;
	}
	function v(e) {
		for (var t = [], n = 0; 31 > n; n++) t.push(e);
		return t;
	}
	function y(e, t) {
		e.pendingLanes |= t, t !== 268435456 && (e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0);
	}
	function b(e, t, n) {
		e.pendingLanes |= t, e.suspendedLanes &= ~t;
		var r = 31 - Wa(t);
		e.entangledLanes |= t, e.entanglements[r] = 1073741824 | e.entanglements[r] | 4194218 & n;
	}
	function x(e, t) {
		var n = e.entangledLanes |= t;
		for (e = e.entanglements; n;) {
			var r = 31 - Wa(n), i = 1 << r;
			i & t | e[r] & t && (e[r] |= t), n &= ~i;
		}
	}
	function S(e) {
		return 2 < (e &= -e) ? 8 < e ? 134217727 & e ? 32 : 268435456 : 8 : 2;
	}
	function C(e) {
		typeof io == "function" && ao(e);
	}
	function w(e, t) {
		if (typeof e == "object" && e) {
			var n = co.get(e);
			return n === void 0 ? (t = {
				value: e,
				source: t,
				stack: l(t)
			}, co.set(e, t), t) : n;
		}
		return {
			value: e,
			source: t,
			stack: l(t)
		};
	}
	function T(e) {
		for (; e === fo;) fo = lo[--uo], lo[uo] = null, lo[--uo], lo[uo] = null;
		for (; e === ho;) ho = po[--mo], po[mo] = null, po[--mo], po[mo] = null, po[--mo], po[mo] = null;
	}
	function E(e, t) {
		f(vo, t), f(_o, e), f(go, null), e = Hi(t), d(go), f(go, e);
	}
	function D() {
		d(go), d(_o), d(vo);
	}
	function O(e) {
		e.memoizedState !== null && f(yo, e);
		var t = go.current, n = Ui(t, e.type);
		t !== n && (f(_o, e), f(go, n));
	}
	function k(e) {
		_o.current === e && (d(go), d(_o)), yo.current === e && (d(yo), ma._currentValue2 = pa);
	}
	function A() {
		for (var e = Co, t = wo = Co = 0; t < e;) {
			var n = So[t];
			So[t++] = null;
			var r = So[t];
			So[t++] = null;
			var i = So[t];
			So[t++] = null;
			var a = So[t];
			if (So[t++] = null, r !== null && i !== null) {
				var o = r.pending;
				o === null ? i.next = i : (i.next = o.next, o.next = i), r.pending = i;
			}
			a !== 0 && te(n, i, a);
		}
	}
	function j(e, t, n, r) {
		So[Co++] = e, So[Co++] = t, So[Co++] = n, So[Co++] = r, wo |= r, e.lanes |= r, (e = e.alternate) !== null && (e.lanes |= r);
	}
	function M(e, t, n, r) {
		return j(e, t, n, r), ne(e);
	}
	function ee(e, t) {
		return j(e, null, null, t), ne(e);
	}
	function te(e, t, n) {
		e.lanes |= n;
		var r = e.alternate;
		r !== null && (r.lanes |= n);
		for (var i = !1, a = e.return; a !== null;) a.childLanes |= n, (r = a.alternate) !== null && (r.childLanes |= n), a.tag === 22 && ((e = a.stateNode) === null || 1 & e._visibility || (i = !0)), e = a, a = a.return;
		i && t !== null && e.tag === 3 && (a = e.stateNode, i = 31 - Wa(n), (e = (a = a.hiddenUpdates)[i]) === null ? a[i] = [t] : e.push(t), t.lane = 536870912 | n);
	}
	function ne(e) {
		if (50 < pc) throw pc = 0, mc = null, Error(r(185));
		for (var t = e.return; t !== null;) t = (e = t).return;
		return e.tag === 3 ? e.stateNode : null;
	}
	function re(e) {
		e !== Eo && e.next === null && (Eo === null ? To = Eo = e : Eo = Eo.next = e), Oo = !0, Do || (Do = !0, Ya(eo, ae));
	}
	function ie(e, t) {
		if (!ko && Oo) {
			ko = !0;
			do
				for (var n = !1, r = To; r !== null;) {
					if (e !== 0) {
						var i = r.pendingLanes;
						if (i === 0) var a = 0;
						else {
							var o = r.suspendedLanes, s = r.pingedLanes;
							a = (1 << 31 - Wa(42 | e) + 1) - 1, a = 201326677 & (a &= i & ~(o & ~s)) ? 201326677 & a | 1 : a ? 2 | a : 0;
						}
						a !== 0 && (n = !0, ce(r, a));
					} else a = Us, 3 & (a = m(r, r === Vs ? a : 0)) && (n = !0, ce(r, a));
					r = r.next;
				}
			while (n);
			ko = !1;
		}
	}
	function ae() {
		Oo = Do = !1;
		var e = 0;
		Ao !== 0 && (oa() && (e = Ao), Ao = 0);
		for (var t = $a(), n = null, r = To; r !== null;) {
			var i = r.next, a = oe(r, t);
			a === 0 ? (r.next = null, n === null ? To = i : n.next = i, i === null && (Eo = n)) : (n = r, (e !== 0 || 3 & a) && (Oo = !0)), r = i;
		}
		ie(e);
	}
	function oe(e, t) {
		for (var n = e.suspendedLanes, r = e.pingedLanes, i = e.expirationTimes, a = -62914561 & e.pendingLanes; 0 < a;) {
			var o = 31 - Wa(a), s = 1 << o, c = i[o];
			c === -1 ? (s & n) != 0 && (s & r) == 0 || (i[o] = h(s, t)) : c <= t && (e.expiredLanes |= s), a &= ~s;
		}
		if (n = Us, n = m(e, e === (t = Vs) ? n : 0), r = e.callbackNode, n === 0 || e === t && Ws === 2 || e.cancelPendingCommit !== null) return r !== null && r !== null && Xa(r), e.callbackNode = null, e.callbackPriority = 0;
		if (3 & n) return r !== null && r !== null && Xa(r), e.callbackPriority = 2, e.callbackNode = null, 2;
		if ((t = n & -n) === e.callbackPriority) return t;
		switch (r !== null && Xa(r), S(n)) {
			case 2:
				n = eo;
				break;
			case 8:
				n = to;
				break;
			case 32:
			default:
				n = no;
				break;
			case 268435456: n = ro;
		}
		return r = se.bind(null, e), n = Ya(n, r), e.callbackPriority = t, e.callbackNode = n, t;
	}
	function se(e, t) {
		var n = e.callbackNode;
		if (Yr() && e.callbackNode !== n) return null;
		var r = Us;
		return (r = m(e, e === Vs ? r : 0)) === 0 ? null : (Dr(e, r, t), oe(e, $a()), e.callbackNode === n ? se.bind(null, e) : null);
	}
	function ce(e, t) {
		if (Yr()) return null;
		Dr(e, t, !0);
	}
	function le() {
		return Ao === 0 && (Ao = g()), Ao;
	}
	function N() {
		if (--Mo == 0 && jo !== null) {
			Po !== null && (Po.status = "fulfilled");
			var e = jo;
			jo = null, No = 0, Po = null;
			for (var t = 0; t < e.length; t++) (0, e[t])();
		}
	}
	function P(e) {
		e.updateQueue = {
			baseState: e.memoizedState,
			firstBaseUpdate: null,
			lastBaseUpdate: null,
			shared: {
				pending: null,
				lanes: 0,
				hiddenCallbacks: null
			},
			callbacks: null
		};
	}
	function ue(e, t) {
		e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
			baseState: e.baseState,
			firstBaseUpdate: e.firstBaseUpdate,
			lastBaseUpdate: e.lastBaseUpdate,
			shared: e.shared,
			callbacks: null
		});
	}
	function de(e) {
		return {
			lane: e,
			tag: 0,
			payload: null,
			callback: null,
			next: null
		};
	}
	function fe(e, t, n) {
		var r = e.updateQueue;
		if (r === null) return null;
		if (r = r.shared, 2 & Bs) {
			var i = r.pending;
			return i === null ? t.next = t : (t.next = i.next, i.next = t), r.pending = t, t = ne(e), te(e, null, n), t;
		}
		return j(e, r, t, n), ne(e);
	}
	function pe(e, t, n) {
		if ((t = t.updateQueue) !== null && (t = t.shared, 4194176 & n)) {
			var r = t.lanes;
			n |= r &= e.pendingLanes, t.lanes = n, x(e, n);
		}
	}
	function me(e, t) {
		var n = e.updateQueue, r = e.alternate;
		if (r !== null && n === (r = r.updateQueue)) {
			var i = null, a = null;
			if ((n = n.firstBaseUpdate) !== null) {
				do {
					var o = {
						lane: n.lane,
						tag: n.tag,
						payload: n.payload,
						callback: null,
						next: null
					};
					a === null ? i = a = o : a = a.next = o, n = n.next;
				} while (n !== null);
				a === null ? i = a = t : a = a.next = t;
			} else i = a = t;
			n = {
				baseState: r.baseState,
				firstBaseUpdate: i,
				lastBaseUpdate: a,
				shared: r.shared,
				callbacks: r.callbacks
			}, e.updateQueue = n;
			return;
		}
		(e = n.lastBaseUpdate) === null ? n.firstBaseUpdate = t : e.next = t, n.lastBaseUpdate = t;
	}
	function F() {
		if (Io && Po !== null) throw Po;
	}
	function I(e, t, n, r) {
		Io = !1;
		var i = e.updateQueue;
		Fo = !1;
		var a = i.firstBaseUpdate, o = i.lastBaseUpdate, s = i.shared.pending;
		if (s !== null) {
			i.shared.pending = null;
			var c = s, l = c.next;
			c.next = null, o === null ? a = l : o.next = l, o = c;
			var u = e.alternate;
			u !== null && (s = (u = u.updateQueue).lastBaseUpdate) !== o && (s === null ? u.firstBaseUpdate = l : s.next = l, u.lastBaseUpdate = c);
		}
		if (a !== null) {
			var d = i.baseState;
			for (o = 0, u = l = c = null, s = a;;) {
				var f = -536870913 & s.lane, p = f !== s.lane;
				if (p ? (Us & f) === f : (r & f) === f) {
					f !== 0 && f === No && (Io = !0), u !== null && (u = u.next = {
						lane: 0,
						tag: s.tag,
						payload: s.payload,
						callback: null,
						next: null
					});
					e: {
						var m = e, h = s;
						f = t;
						var g = n;
						switch (h.tag) {
							case 1:
								if (typeof (m = h.payload) == "function") {
									d = m.call(g, d, f);
									break e;
								}
								d = m;
								break e;
							case 3: m.flags = -65537 & m.flags | 128;
							case 0:
								if ((f = typeof (m = h.payload) == "function" ? m.call(g, d, f) : m) == null) break e;
								d = yi({}, d, f);
								break e;
							case 2: Fo = !0;
						}
					}
					(f = s.callback) !== null && (e.flags |= 64, p && (e.flags |= 8192), (p = i.callbacks) === null ? i.callbacks = [f] : p.push(f));
				} else p = {
					lane: f,
					tag: s.tag,
					payload: s.payload,
					callback: s.callback,
					next: null
				}, u === null ? (l = u = p, c = d) : u = u.next = p, o |= f;
				if ((s = s.next) === null) {
					if ((s = i.shared.pending) === null) break;
					s = (p = s).next, p.next = null, i.lastBaseUpdate = p, i.shared.pending = null;
				}
			}
			u === null && (c = d), i.baseState = c, i.firstBaseUpdate = l, i.lastBaseUpdate = u, a === null && (i.shared.lanes = 0), Xs |= o, e.lanes = o, e.memoizedState = d;
		}
	}
	function he(e, t) {
		if (typeof e != "function") throw Error(r(191, e));
		e.call(t);
	}
	function L(e, t) {
		var n = e.callbacks;
		if (n !== null) for (e.callbacks = null, e = 0; e < n.length; e++) he(n[e], t);
	}
	function ge(e, t) {
		if (so(e, t)) return !0;
		if (typeof e != "object" || !e || typeof t != "object" || !t) return !1;
		var n = Object.keys(e), r = Object.keys(t);
		if (n.length !== r.length) return !1;
		for (r = 0; r < n.length; r++) {
			var i = n[r];
			if (!Lo.call(t, i) || !so(e[i], t[i])) return !1;
		}
		return !0;
	}
	function _e(e) {
		return (e = e.status) === "fulfilled" || e === "rejected";
	}
	function ve() {}
	function ye(e, t, n) {
		switch ((n = e[n]) === void 0 ? e.push(t) : n !== t && (t.then(ve, ve), t = n), t.status) {
			case "fulfilled": return t.value;
			case "rejected": throw (e = t.reason) === Ro ? Error(r(483)) : e;
			default:
				if (typeof t.status == "string") t.then(ve, ve);
				else {
					if ((e = Vs) !== null && 100 < e.shellSuspendCounter) throw Error(r(482));
					(e = t).status = "pending", e.then((function(e) {
						if (t.status === "pending") {
							var n = t;
							n.status = "fulfilled", n.value = e;
						}
					}), (function(e) {
						if (t.status === "pending") {
							var n = t;
							n.status = "rejected", n.reason = e;
						}
					}));
				}
				switch (t.status) {
					case "fulfilled": return t.value;
					case "rejected": throw (e = t.reason) === Ro ? Error(r(483)) : e;
				}
				throw Vo = t, Ro;
		}
	}
	function be() {
		if (Vo === null) throw Error(r(459));
		var e = Vo;
		return Vo = null, e;
	}
	function R(e) {
		var t = Uo;
		return Uo += 1, Ho === null && (Ho = []), ye(Ho, e, t);
	}
	function xe(e, t, n, r) {
		e = r.props.ref, n.ref = e === void 0 ? null : e;
	}
	function z(e, t) {
		throw t.$$typeof === bi ? Error(r(525)) : (e = Object.prototype.toString.call(t), Error(r(31, e === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : e)));
	}
	function B(e) {
		return (0, e._init)(e._payload);
	}
	function Se(e) {
		function t(t, n) {
			if (e) {
				var r = t.deletions;
				r === null ? (t.deletions = [n], t.flags |= 16) : r.push(n);
			}
		}
		function a(n, r) {
			if (!e) return null;
			for (; r !== null;) t(n, r), r = r.sibling;
			return null;
		}
		function o(e) {
			for (var t = /* @__PURE__ */ new Map(); e !== null;) e.key === null ? t.set(e.index, e) : t.set(e.key, e), e = e.sibling;
			return t;
		}
		function s(e, t) {
			return (e = ai(e, t)).index = 0, e.sibling = null, e;
		}
		function c(t, n, r) {
			return t.index = r, e ? (r = t.alternate) === null || (r = r.index) < n ? (t.flags |= 33554434, n) : r : (t.flags |= 1048576, n);
		}
		function l(t) {
			return e && t.alternate === null && (t.flags |= 33554434), t;
		}
		function u(e, t, n, r) {
			return t === null || t.tag !== 6 ? ((t = ui(n, e.mode, r)).return = e, t) : ((t = s(t, n)).return = e, t);
		}
		function d(e, t, n, r) {
			var i = n.type;
			return i === Ci ? p(e, t, n.props.children, r, n.key) : t !== null && (t.elementType === i || typeof i == "object" && i && i.$$typeof === Ni && B(i) === t.type) ? (xe(e, 0, r = s(t, n.props), n), r.return = e, r) : (xe(e, 0, r = si(n.type, n.key, n.props, null, e.mode, r), n), r.return = e, r);
		}
		function f(e, t, n, r) {
			return t === null || t.tag !== 4 || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation ? ((t = di(n, e.mode, r)).return = e, t) : ((t = s(t, n.children || [])).return = e, t);
		}
		function p(e, t, n, r, i) {
			return t === null || t.tag !== 7 ? ((t = ci(n, e.mode, r, i)).return = e, t) : ((t = s(t, n)).return = e, t);
		}
		function m(e, t, n) {
			if (typeof t == "string" && t !== "" || typeof t == "number" || typeof t == "bigint") return (t = ui("" + t, e.mode, n)).return = e, t;
			if (typeof t == "object" && t) {
				switch (t.$$typeof) {
					case xi: return xe(e, 0, n = si(t.type, t.key, t.props, null, e.mode, n), t), n.return = e, n;
					case Si: return (t = di(t, e.mode, n)).return = e, t;
					case Ni: return m(e, t = (0, t._init)(t._payload), n);
				}
				if (Bi(t) || i(t)) return (t = ci(t, e.mode, n, null)).return = e, t;
				if (typeof t.then == "function") return m(e, R(t), n);
				if (t.$$typeof === Oi) return m(e, On(e, t), n);
				z(e, t);
			}
			return null;
		}
		function h(e, t, n, r) {
			var a = t === null ? null : t.key;
			if (typeof n == "string" && n !== "" || typeof n == "number" || typeof n == "bigint") return a === null ? u(e, t, "" + n, r) : null;
			if (typeof n == "object" && n) {
				switch (n.$$typeof) {
					case xi: return n.key === a ? d(e, t, n, r) : null;
					case Si: return n.key === a ? f(e, t, n, r) : null;
					case Ni: return h(e, t, n = (a = n._init)(n._payload), r);
				}
				if (Bi(n) || i(n)) return a === null ? p(e, t, n, r, null) : null;
				if (typeof n.then == "function") return h(e, t, R(n), r);
				if (n.$$typeof === Oi) return h(e, t, On(e, n), r);
				z(e, n);
			}
			return null;
		}
		function g(e, t, n, r, a) {
			if (typeof r == "string" && r !== "" || typeof r == "number" || typeof r == "bigint") return u(t, e = e.get(n) || null, "" + r, a);
			if (typeof r == "object" && r) {
				switch (r.$$typeof) {
					case xi: return d(t, e = e.get(r.key === null ? n : r.key) || null, r, a);
					case Si: return f(t, e = e.get(r.key === null ? n : r.key) || null, r, a);
					case Ni: return g(e, t, n, r = (0, r._init)(r._payload), a);
				}
				if (Bi(r) || i(r)) return p(t, e = e.get(n) || null, r, a, null);
				if (typeof r.then == "function") return g(e, t, n, R(r), a);
				if (r.$$typeof === Oi) return g(e, t, n, On(t, r), a);
				z(t, r);
			}
			return null;
		}
		function _(n, u, d, f) {
			if (typeof d == "object" && d && d.type === Ci && d.key === null && (d = d.props.children), typeof d == "object" && d) {
				switch (d.$$typeof) {
					case xi:
						e: {
							for (var p = d.key, v = u; v !== null;) {
								if (v.key === p) {
									if ((p = d.type) === Ci) {
										if (v.tag === 7) {
											a(n, v.sibling), (u = s(v, d.props.children)).return = n, n = u;
											break e;
										}
									} else if (v.elementType === p || typeof p == "object" && p && p.$$typeof === Ni && B(p) === v.type) {
										a(n, v.sibling), xe(n, 0, u = s(v, d.props), d), u.return = n, n = u;
										break e;
									}
									a(n, v);
									break;
								}
								t(n, v), v = v.sibling;
							}
							d.type === Ci ? ((u = ci(d.props.children, n.mode, f, d.key)).return = n, n = u) : (xe(n, 0, f = si(d.type, d.key, d.props, null, n.mode, f), d), f.return = n, n = f);
						}
						return l(n);
					case Si:
						e: {
							for (v = d.key; u !== null;) {
								if (u.key === v) {
									if (u.tag === 4 && u.stateNode.containerInfo === d.containerInfo && u.stateNode.implementation === d.implementation) {
										a(n, u.sibling), (u = s(u, d.children || [])).return = n, n = u;
										break e;
									}
									a(n, u);
									break;
								}
								t(n, u), u = u.sibling;
							}
							(u = di(d, n.mode, f)).return = n, n = u;
						}
						return l(n);
					case Ni: return _(n, u, d = (v = d._init)(d._payload), f);
				}
				if (Bi(d)) return function(n, r, i, s) {
					for (var l = null, u = null, d = r, f = r = 0, p = null; d !== null && f < i.length; f++) {
						d.index > f ? (p = d, d = null) : p = d.sibling;
						var _ = h(n, d, i[f], s);
						if (_ === null) {
							d === null && (d = p);
							break;
						}
						e && d && _.alternate === null && t(n, d), r = c(_, r, f), u === null ? l = _ : u.sibling = _, u = _, d = p;
					}
					if (f === i.length) return a(n, d), l;
					if (d === null) {
						for (; f < i.length; f++) (d = m(n, i[f], s)) !== null && (r = c(d, r, f), u === null ? l = d : u.sibling = d, u = d);
						return l;
					}
					for (d = o(d); f < i.length; f++) (p = g(d, n, f, i[f], s)) !== null && (e && p.alternate !== null && d.delete(p.key === null ? f : p.key), r = c(p, r, f), u === null ? l = p : u.sibling = p, u = p);
					return e && d.forEach((function(e) {
						return t(n, e);
					})), l;
				}(n, u, d, f);
				if (i(d)) {
					if (typeof (v = i(d)) != "function") throw Error(r(150));
					return function(n, i, s, l) {
						if (s == null) throw Error(r(151));
						for (var u = null, d = null, f = i, p = i = 0, _ = null, v = s.next(); f !== null && !v.done; p++, v = s.next()) {
							f.index > p ? (_ = f, f = null) : _ = f.sibling;
							var y = h(n, f, v.value, l);
							if (y === null) {
								f === null && (f = _);
								break;
							}
							e && f && y.alternate === null && t(n, f), i = c(y, i, p), d === null ? u = y : d.sibling = y, d = y, f = _;
						}
						if (v.done) return a(n, f), u;
						if (f === null) {
							for (; !v.done; p++, v = s.next()) (v = m(n, v.value, l)) !== null && (i = c(v, i, p), d === null ? u = v : d.sibling = v, d = v);
							return u;
						}
						for (f = o(f); !v.done; p++, v = s.next()) (v = g(f, n, p, v.value, l)) !== null && (e && v.alternate !== null && f.delete(v.key === null ? p : v.key), i = c(v, i, p), d === null ? u = v : d.sibling = v, d = v);
						return e && f.forEach((function(e) {
							return t(n, e);
						})), u;
					}(n, u, d = v.call(d), f);
				}
				if (typeof d.then == "function") return _(n, u, R(d), f);
				if (d.$$typeof === Oi) return _(n, u, On(n, d), f);
				z(n, d);
			}
			return typeof d == "string" && d !== "" || typeof d == "number" || typeof d == "bigint" ? (d = "" + d, u !== null && u.tag === 6 ? (a(n, u.sibling), (u = s(u, d)).return = n, n = u) : (a(n, u), (u = ui(d, n.mode, f)).return = n, n = u), l(n)) : a(n, u);
		}
		return function(e, t, r, i) {
			try {
				Uo = 0;
				var a = _(e, t, r, i);
				return Ho = null, a;
			} catch (t) {
				if (t === Ro) throw t;
				var o = n(29, t, null, e.mode);
				return o.lanes = i, o.return = e, o;
			}
		};
	}
	function Ce(e, t) {
		f(qo, e = Js), f(Ko, t), Js = e | t.baseLanes;
	}
	function we() {
		f(qo, Js), f(Ko, Ko.current);
	}
	function Te() {
		Js = qo.current, d(Ko), d(qo);
	}
	function Ee(e) {
		var t = e.alternate;
		f(Xo, 1 & Xo.current), f(Jo, e), Yo === null && (t === null || Ko.current !== null || t.memoizedState !== null) && (Yo = e);
	}
	function De(e) {
		if (e.tag === 22) {
			if (f(Xo, Xo.current), f(Jo, e), Yo === null) {
				var t = e.alternate;
				t !== null && t.memoizedState !== null && (Yo = e);
			}
		} else Oe();
	}
	function Oe() {
		f(Xo, Xo.current), f(Jo, Jo.current);
	}
	function ke(e) {
		d(Jo), Yo === e && (Yo = null), d(Xo);
	}
	function Ae(e) {
		for (var t = e; t !== null;) {
			if (t.tag === 13) {
				var n = t.memoizedState;
				if (n !== null && ((n = n.dehydrated) === null || ja(n) || Ma(n))) return t;
			} else if (t.tag === 19 && t.memoizedProps.revealOrder !== void 0) {
				if (128 & t.flags) return t;
			} else if (t.child !== null) {
				t.child.return = t, t = t.child;
				continue;
			}
			if (t === e) break;
			for (; t.sibling === null;) {
				if (t.return === null || t.return === e) return null;
				t = t.return;
			}
			t.sibling.return = t.return, t = t.sibling;
		}
		return null;
	}
	function je() {
		throw Error(r(321));
	}
	function Me(e, t) {
		if (t === null) return !1;
		for (var n = 0; n < t.length && n < e.length; n++) if (!so(e[n], t[n])) return !1;
		return !0;
	}
	function Ne(e, t, n, r, i, a) {
		return Zo = a, Qo = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, Ri.H = e === null || e.memoizedState === null ? us : ds, rs = !1, a = n(r, i), rs = !1, ns && (a = Fe(t, n, r, i)), Pe(e), a;
	}
	function Pe(e) {
		Ri.H = ls;
		var t = $o !== null && $o.next !== null;
		if (Zo = 0, es = $o = Qo = null, ts = !1, as = 0, os = null, t) throw Error(r(300));
		e === null || hs || (e = e.dependencies) !== null && Tn(e) && (hs = !0);
	}
	function Fe(e, t, n, i) {
		Qo = e;
		var a = 0;
		do {
			if (ns && (os = null), as = 0, ns = !1, 25 <= a) throw Error(r(301));
			if (a += 1, es = $o = null, e.updateQueue != null) {
				var o = e.updateQueue;
				o.lastEffect = null, o.events = null, o.stores = null, o.memoCache != null && (o.memoCache.index = 0);
			}
			Ri.H = fs, o = t(n, i);
		} while (ns);
		return o;
	}
	function Ie() {
		var e = Ri.H, t = e.useState()[0];
		return t = typeof t.then == "function" ? He(t) : t, e = e.useState()[0], ($o === null ? null : $o.memoizedState) !== e && (Qo.flags |= 1024), t;
	}
	function Le() {
		var e = is !== 0;
		return is = 0, e;
	}
	function Re(e, t, n) {
		t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~n;
	}
	function ze(e) {
		if (ts) {
			for (e = e.memoizedState; e !== null;) {
				var t = e.queue;
				t !== null && (t.pending = null), e = e.next;
			}
			ts = !1;
		}
		Zo = 0, es = $o = Qo = null, ns = !1, as = is = 0, os = null;
	}
	function Be() {
		var e = {
			memoizedState: null,
			baseState: null,
			baseQueue: null,
			queue: null,
			next: null
		};
		return es === null ? Qo.memoizedState = es = e : es = es.next = e, es;
	}
	function Ve() {
		if ($o === null) {
			var e = Qo.alternate;
			e = e === null ? null : e.memoizedState;
		} else e = $o.next;
		var t = es === null ? Qo.memoizedState : es.next;
		if (t !== null) es = t, $o = e;
		else {
			if (e === null) throw Qo.alternate === null ? Error(r(467)) : Error(r(310));
			e = {
				memoizedState: ($o = e).memoizedState,
				baseState: $o.baseState,
				baseQueue: $o.baseQueue,
				queue: $o.queue,
				next: null
			}, es === null ? Qo.memoizedState = es = e : es = es.next = e;
		}
		return es;
	}
	function He(e) {
		var t = as;
		return as += 1, os === null && (os = []), e = ye(os, e, t), t = Qo, (es === null ? t.memoizedState : es.next) === null && (t = t.alternate, Ri.H = t === null || t.memoizedState === null ? us : ds), e;
	}
	function Ue(e) {
		if (typeof e == "object" && e) {
			if (typeof e.then == "function") return He(e);
			if (e.$$typeof === Oi) return Dn(e);
		}
		throw Error(r(438, String(e)));
	}
	function We(e) {
		var t = null, n = Qo.updateQueue;
		if (n !== null && (t = n.memoCache), t == null) {
			var r = Qo.alternate;
			r !== null && (r = r.updateQueue) !== null && (r = r.memoCache) != null && (t = {
				data: r.data.map((function(e) {
					return e.slice();
				})),
				index: 0
			});
		}
		if (t ??= {
			data: [],
			index: 0
		}, n === null && (n = cs(), Qo.updateQueue = n), n.memoCache = t, (n = t.data[t.index]) === void 0) for (n = t.data[t.index] = Array(e), r = 0; r < e; r++) n[r] = Fi;
		return t.index++, n;
	}
	function Ge(e, t) {
		return typeof t == "function" ? t(e) : t;
	}
	function Ke(e) {
		return qe(Ve(), $o, e);
	}
	function qe(e, t, n) {
		var i = e.queue;
		if (i === null) throw Error(r(311));
		i.lastRenderedReducer = n;
		var a = e.baseQueue, o = i.pending;
		if (o !== null) {
			if (a !== null) {
				var s = a.next;
				a.next = o.next, o.next = s;
			}
			t.baseQueue = a = o, i.pending = null;
		}
		if (o = e.baseState, a === null) e.memoizedState = o;
		else {
			var c = s = null, l = null, u = t = a.next, d = !1;
			do {
				var f = -536870913 & u.lane;
				if (f === u.lane ? (Zo & f) === f : (Us & f) === f) {
					var p = u.revertLane;
					if (p === 0) l !== null && (l = l.next = {
						lane: 0,
						revertLane: 0,
						action: u.action,
						hasEagerState: u.hasEagerState,
						eagerState: u.eagerState,
						next: null
					}), f === No && (d = !0);
					else {
						if ((Zo & p) === p) {
							u = u.next, p === No && (d = !0);
							continue;
						}
						f = {
							lane: 0,
							revertLane: u.revertLane,
							action: u.action,
							hasEagerState: u.hasEagerState,
							eagerState: u.eagerState,
							next: null
						}, l === null ? (c = l = f, s = o) : l = l.next = f, Qo.lanes |= p, Xs |= p;
					}
					f = u.action, rs && n(o, f), o = u.hasEagerState ? u.eagerState : n(o, f);
				} else p = {
					lane: f,
					revertLane: u.revertLane,
					action: u.action,
					hasEagerState: u.hasEagerState,
					eagerState: u.eagerState,
					next: null
				}, l === null ? (c = l = p, s = o) : l = l.next = p, Qo.lanes |= f, Xs |= f;
				u = u.next;
			} while (u !== null && u !== t);
			if (l === null ? s = o : l.next = c, !so(o, e.memoizedState) && (hs = !0, d && (n = Po) !== null)) throw n;
			e.memoizedState = o, e.baseState = s, e.baseQueue = l, i.lastRenderedState = o;
		}
		return a === null && (i.lanes = 0), [e.memoizedState, i.dispatch];
	}
	function Je(e) {
		var t = Ve(), n = t.queue;
		if (n === null) throw Error(r(311));
		n.lastRenderedReducer = e;
		var i = n.dispatch, a = n.pending, o = t.memoizedState;
		if (a !== null) {
			n.pending = null;
			var s = a = a.next;
			do
				o = e(o, s.action), s = s.next;
			while (s !== a);
			so(o, t.memoizedState) || (hs = !0), t.memoizedState = o, t.baseQueue === null && (t.baseState = o), n.lastRenderedState = o;
		}
		return [o, i];
	}
	function Ye(e, t, n) {
		var i = Qo, a = Ve();
		n = t();
		var o = !so(($o || a).memoizedState, n);
		if (o && (a.memoizedState = n, hs = !0), a = a.queue, yt(Qe.bind(null, i, a, e), [e]), a.getSnapshot !== t || o || es !== null && 1 & es.memoizedState.tag) {
			if (i.flags |= 2048, ht(9, Ze.bind(null, i, a, n, t), { destroy: void 0 }, null), Vs === null) throw Error(r(349));
			60 & Zo || Xe(i, t, n);
		}
		return n;
	}
	function Xe(e, t, n) {
		e.flags |= 16384, e = {
			getSnapshot: t,
			value: n
		}, (t = Qo.updateQueue) === null ? (t = cs(), Qo.updateQueue = t, t.stores = [e]) : (n = t.stores) === null ? t.stores = [e] : n.push(e);
	}
	function Ze(e, t, n, r) {
		t.value = n, t.getSnapshot = r, $e(t) && et(e);
	}
	function Qe(e, t, n) {
		return n((function() {
			$e(t) && et(e);
		}));
	}
	function $e(e) {
		var t = e.getSnapshot;
		e = e.value;
		try {
			var n = t();
			return !so(e, n);
		} catch {
			return !0;
		}
	}
	function et(e) {
		var t = ee(e, 2);
		t !== null && Er(t, 0, 2);
	}
	function tt(e) {
		var t = Be();
		if (typeof e == "function") {
			var n = e;
			if (e = n(), rs) {
				C(!0);
				try {
					n();
				} finally {
					C(!1);
				}
			}
		}
		return t.memoizedState = t.baseState = e, t.queue = {
			pending: null,
			lanes: 0,
			dispatch: null,
			lastRenderedReducer: Ge,
			lastRenderedState: e
		}, t;
	}
	function nt(e, t, n, r) {
		return e.baseState = n, qe(e, $o, typeof r == "function" ? r : Ge);
	}
	function rt(e, t, n, i, a) {
		if (Rt(e)) throw Error(r(485));
		if ((e = t.action) !== null) {
			var o = {
				payload: a,
				action: e,
				next: null,
				isTransition: !0,
				status: "pending",
				value: null,
				reason: null,
				listeners: [],
				then: function(e) {
					o.listeners.push(e);
				}
			};
			Ri.T === null ? o.isTransition = !1 : n(!0), i(o), (n = t.pending) === null ? (o.next = t.pending = o, it(t, o)) : (o.next = n.next, t.pending = n.next = o);
		}
	}
	function it(e, t) {
		var n = t.action, r = t.payload, i = e.state;
		if (t.isTransition) {
			var a = Ri.T, o = {};
			Ri.T = o;
			try {
				var s = n(i, r), c = Ri.S;
				c !== null && c(o, s), at(e, t, s);
			} catch (n) {
				st(e, t, n);
			} finally {
				Ri.T = a;
			}
		} else try {
			at(e, t, a = n(i, r));
		} catch (n) {
			st(e, t, n);
		}
	}
	function at(e, t, n) {
		typeof n == "object" && n && typeof n.then == "function" ? n.then((function(n) {
			ot(e, t, n);
		}), (function(n) {
			return st(e, t, n);
		})) : ot(e, t, n);
	}
	function ot(e, t, n) {
		t.status = "fulfilled", t.value = n, ct(t), e.state = n, (t = e.pending) !== null && ((n = t.next) === t ? e.pending = null : (n = n.next, t.next = n, it(e, n)));
	}
	function st(e, t, n) {
		var r = e.pending;
		if (e.pending = null, r !== null) {
			r = r.next;
			do
				t.status = "rejected", t.reason = n, ct(t), t = t.next;
			while (t !== r);
		}
		e.action = null;
	}
	function ct(e) {
		e = e.listeners;
		for (var t = 0; t < e.length; t++) (0, e[t])();
	}
	function lt(e, t) {
		return t;
	}
	function ut(e, t) {
		var n, r, i;
		(n = Be()).memoizedState = n.baseState = t, r = {
			pending: null,
			lanes: 0,
			dispatch: null,
			lastRenderedReducer: lt,
			lastRenderedState: t
		}, n.queue = r, n = Ft.bind(null, Qo, r), r.dispatch = n, r = tt(!1);
		var a = Lt.bind(null, Qo, !1, r.queue);
		return i = {
			state: t,
			dispatch: null,
			action: e,
			pending: null
		}, (r = Be()).queue = i, n = rt.bind(null, Qo, i, a, n), i.dispatch = n, r.memoizedState = e, [
			t,
			n,
			!1
		];
	}
	function dt(e) {
		return ft(Ve(), $o, e);
	}
	function ft(e, t, n) {
		t = qe(e, t, lt)[0], e = Ke(Ge)[0], t = typeof t == "object" && t && typeof t.then == "function" ? He(t) : t;
		var r = Ve(), i = r.queue, a = i.dispatch;
		return n !== r.memoizedState && (Qo.flags |= 2048, ht(9, pt.bind(null, i, n), { destroy: void 0 }, null)), [
			t,
			a,
			e
		];
	}
	function pt(e, t) {
		e.action = t;
	}
	function mt(e) {
		var t = Ve(), n = $o;
		if (n !== null) return ft(t, n, e);
		Ve(), t = t.memoizedState;
		var r = (n = Ve()).queue.dispatch;
		return n.memoizedState = e, [
			t,
			r,
			!1
		];
	}
	function ht(e, t, n, r) {
		return e = {
			tag: e,
			create: t,
			inst: n,
			deps: r,
			next: null
		}, (t = Qo.updateQueue) === null && (t = cs(), Qo.updateQueue = t), (n = t.lastEffect) === null ? t.lastEffect = e.next = e : (r = n.next, n.next = e, e.next = r, t.lastEffect = e), e;
	}
	function gt() {
		return Ve().memoizedState;
	}
	function _t(e, t, n, r) {
		var i = Be();
		Qo.flags |= e, i.memoizedState = ht(1 | t, n, { destroy: void 0 }, r === void 0 ? null : r);
	}
	function vt(e, t, n, r) {
		var i = Ve();
		r = r === void 0 ? null : r;
		var a = i.memoizedState.inst;
		$o !== null && r !== null && Me(r, $o.memoizedState.deps) ? i.memoizedState = ht(t, n, a, r) : (Qo.flags |= e, i.memoizedState = ht(1 | t, n, a, r));
	}
	function V(e, t) {
		_t(8390656, 8, e, t);
	}
	function yt(e, t) {
		vt(2048, 8, e, t);
	}
	function bt(e, t) {
		return vt(4, 2, e, t);
	}
	function xt(e, t) {
		return vt(4, 4, e, t);
	}
	function St(e, t) {
		if (typeof t == "function") {
			e = e();
			var n = t(e);
			return function() {
				typeof n == "function" ? n() : t(null);
			};
		}
		if (t != null) return e = e(), t.current = e, function() {
			t.current = null;
		};
	}
	function Ct(e, t, n) {
		n = n == null ? null : n.concat([e]), vt(4, 4, St.bind(null, t, e), n);
	}
	function wt() {}
	function Tt(e, t) {
		var n = Ve();
		t = t === void 0 ? null : t;
		var r = n.memoizedState;
		return t !== null && Me(t, r[1]) ? r[0] : (n.memoizedState = [e, t], e);
	}
	function Et(e, t) {
		var n = Ve();
		t = t === void 0 ? null : t;
		var r = n.memoizedState;
		if (t !== null && Me(t, r[1])) return r[0];
		if (r = e(), rs) {
			C(!0);
			try {
				e();
			} finally {
				C(!1);
			}
		}
		return n.memoizedState = [r, t], r;
	}
	function Dt(e, t, n) {
		return n === void 0 || 1073741824 & Zo ? e.memoizedState = t : (e.memoizedState = n, e = Tr(), Qo.lanes |= e, Xs |= e, n);
	}
	function Ot(e, t, n, r) {
		return so(n, t) ? n : Ko.current === null ? 42 & Zo ? (e = Tr(), Qo.lanes |= e, Xs |= e, t) : (hs = !0, e.memoizedState = n) : (e = Dt(e, n, r), so(e, t) || (hs = !0), e);
	}
	function kt(e, t, n, r, i) {
		var a = ia();
		ra(a !== 0 && 8 > a ? a : 8);
		var o, s, c, l = Ri.T, u = {};
		Ri.T = u, Lt(e, !1, t, n);
		try {
			var d = i(), f = Ri.S;
			f !== null && f(u, d), typeof d == "object" && d && typeof d.then == "function" ? It(e, t, (o = r, s = [], c = {
				status: "pending",
				value: null,
				reason: null,
				then: function(e) {
					s.push(e);
				}
			}, d.then((function() {
				c.status = "fulfilled", c.value = o;
				for (var e = 0; e < s.length; e++) (0, s[e])(o);
			}), (function(e) {
				for (c.status = "rejected", c.reason = e, e = 0; e < s.length; e++) (0, s[e])(void 0);
			})), c), wr()) : It(e, t, r, wr());
		} catch (n) {
			It(e, t, {
				then: function() {},
				status: "rejected",
				reason: n
			}, wr());
		} finally {
			ra(a), Ri.T = l;
		}
	}
	function At() {
		return Dn(ma);
	}
	function jt() {
		return Ve().memoizedState;
	}
	function Mt() {
		return Ve().memoizedState;
	}
	function Nt(e) {
		for (var t = e.return; t !== null;) {
			switch (t.tag) {
				case 24:
				case 3:
					var n = wr(), r = fe(t, e = de(n), n);
					r !== null && (Er(r, 0, n), pe(r, t, n)), t = { cache: An() }, e.payload = t;
					return;
			}
			t = t.return;
		}
	}
	function Pt(e, t, n) {
		var r = wr();
		n = {
			lane: r,
			revertLane: 0,
			action: n,
			hasEagerState: !1,
			eagerState: null,
			next: null
		}, Rt(e) ? zt(t, n) : (n = M(e, t, n, r)) !== null && (Er(n, 0, r), Bt(n, t, r));
	}
	function Ft(e, t, n) {
		It(e, t, n, wr());
	}
	function It(e, t, n, r) {
		var i = {
			lane: r,
			revertLane: 0,
			action: n,
			hasEagerState: !1,
			eagerState: null,
			next: null
		};
		if (Rt(e)) zt(t, i);
		else {
			var a = e.alternate;
			if (e.lanes === 0 && (a === null || a.lanes === 0) && (a = t.lastRenderedReducer) !== null) try {
				var o = t.lastRenderedState, s = a(o, n);
				if (i.hasEagerState = !0, i.eagerState = s, so(s, o)) return j(e, t, i, 0), Vs === null && A(), !1;
			} catch {}
			if ((n = M(e, t, i, r)) !== null) return Er(n, 0, r), Bt(n, t, r), !0;
		}
		return !1;
	}
	function Lt(e, t, n, i) {
		if (i = {
			lane: 2,
			revertLane: le(),
			action: i,
			hasEagerState: !1,
			eagerState: null,
			next: null
		}, Rt(e)) {
			if (t) throw Error(r(479));
		} else (t = M(e, n, i, 2)) !== null && Er(t, 0, 2);
	}
	function Rt(e) {
		var t = e.alternate;
		return e === Qo || t !== null && t === Qo;
	}
	function zt(e, t) {
		ns = ts = !0;
		var n = e.pending;
		n === null ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
	}
	function Bt(e, t, n) {
		if (4194176 & n) {
			var r = t.lanes;
			n |= r &= e.pendingLanes, t.lanes = n, x(e, n);
		}
	}
	function Vt(e, t, n, r) {
		n = (n = n(r, t = e.memoizedState)) == null ? t : yi({}, t, n), e.memoizedState = n, e.lanes === 0 && (e.updateQueue.baseState = n);
	}
	function Ht(e, t, n, r, i, a, o) {
		return typeof (e = e.stateNode).shouldComponentUpdate == "function" ? e.shouldComponentUpdate(r, a, o) : !(t.prototype && t.prototype.isPureReactComponent && ge(n, r) && ge(i, a));
	}
	function Ut(e, t, n, r) {
		e = t.state, typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(n, r), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && ps.enqueueReplaceState(t, t.state, null);
	}
	function Wt(e, t) {
		var n = t;
		if ("ref" in t) for (var r in n = {}, t) r !== "ref" && (n[r] = t[r]);
		if (e = e.defaultProps) for (var i in n === t && (n = yi({}, n)), e) n[i] === void 0 && (n[i] = e[i]);
		return n;
	}
	function Gt(e, t) {
		try {
			(0, e.onUncaughtError)(t.value, { componentStack: t.stack });
		} catch (e) {
			setTimeout((function() {
				throw e;
			}));
		}
	}
	function Kt(e, t, n) {
		try {
			(0, e.onCaughtError)(n.value, {
				componentStack: n.stack,
				errorBoundary: t.tag === 1 ? t.stateNode : null
			});
		} catch (e) {
			setTimeout((function() {
				throw e;
			}));
		}
	}
	function qt(e, t, n) {
		return (n = de(n)).tag = 3, n.payload = { element: null }, n.callback = function() {
			Gt(e, t);
		}, n;
	}
	function Jt(e) {
		return (e = de(e)).tag = 3, e;
	}
	function Yt(e, t, n, r) {
		var i = n.type.getDerivedStateFromError;
		if (typeof i == "function") {
			var a = r.value;
			e.payload = function() {
				return i(a);
			}, e.callback = function() {
				Kt(t, n, r);
			};
		}
		var o = n.stateNode;
		o !== null && typeof o.componentDidCatch == "function" && (e.callback = function() {
			Kt(t, n, r), typeof i != "function" && (sc === null ? sc = new Set([this]) : sc.add(this));
			var e = r.stack;
			this.componentDidCatch(r.value, { componentStack: e === null ? "" : e });
		});
	}
	function Xt(e, t, n, r) {
		t.child = e === null ? Go(t, null, n, r) : Wo(t, e.child, n, r);
	}
	function Zt(e, t, n, r, i) {
		n = n.render;
		var a = t.ref;
		if ("ref" in r) {
			var o = {};
			for (var s in r) s !== "ref" && (o[s] = r[s]);
		} else o = r;
		return En(t), r = Ne(e, t, n, o, a, i), s = Le(), e === null || hs ? (t.flags |= 1, Xt(e, t, r, i), t.child) : (Re(e, t, i), gn(e, t, i));
	}
	function Qt(e, t, n, r, i) {
		if (e === null) {
			var a = n.type;
			return typeof a != "function" || ii(a) || a.defaultProps !== void 0 || n.compare !== null ? ((e = si(n.type, null, r, t, t.mode, i)).ref = t.ref, e.return = t, t.child = e) : (t.tag = 15, t.type = a, $t(e, t, a, r, i));
		}
		if (a = e.child, !_n(e, i)) {
			var o = a.memoizedProps;
			if ((n = (n = n.compare) === null ? ge : n)(o, r) && e.ref === t.ref) return gn(e, t, i);
		}
		return t.flags |= 1, (e = ai(a, r)).ref = t.ref, e.return = t, t.child = e;
	}
	function $t(e, t, n, r, i) {
		if (e !== null) {
			var a = e.memoizedProps;
			if (ge(a, r) && e.ref === t.ref) {
				if (hs = !1, t.pendingProps = r = a, !_n(e, i)) return t.lanes = e.lanes, gn(e, t, i);
				131072 & e.flags && (hs = !0);
			}
		}
		return rn(e, t, n, r, i);
	}
	function en(e, t, n) {
		var r = t.pendingProps, i = r.children, a = (2 & t.stateNode._pendingVisibility) != 0, o = e === null ? null : e.memoizedState;
		if (nn(e, t), r.mode === "hidden" || a) {
			if (128 & t.flags) {
				if (r = o === null ? n : o.baseLanes | n, e !== null) {
					for (i = t.child = e.child, a = 0; i !== null;) a = a | i.lanes | i.childLanes, i = i.sibling;
					t.childLanes = a & ~r;
				} else t.childLanes = 0, t.child = null;
				return tn(e, t, r, n);
			}
			if (!(536870912 & n)) return t.lanes = t.childLanes = 536870912, tn(e, t, o === null ? n : o.baseLanes | n, n);
			t.memoizedState = {
				baseLanes: 0,
				cachePool: null
			}, e !== null && Nn(0, o === null ? null : o.cachePool), o === null ? we() : Ce(t, o), De(t);
		} else o === null ? (e !== null && Nn(0, null), we(), Oe()) : (Nn(0, o.cachePool), Ce(t, o), Oe(), t.memoizedState = null);
		return Xt(e, t, i, n), t.child;
	}
	function tn(e, t, n, r) {
		var i = Mn();
		return i = i === null ? null : {
			parent: ws._currentValue2,
			pool: i
		}, t.memoizedState = {
			baseLanes: n,
			cachePool: i
		}, e !== null && Nn(0, null), we(), De(t), e !== null && wn(e, t, r, !0), null;
	}
	function nn(e, t) {
		var n = t.ref;
		if (n === null) e !== null && e.ref !== null && (t.flags |= 2097664);
		else {
			if (typeof n != "function" && typeof n != "object") throw Error(r(284));
			e !== null && e.ref === n || (t.flags |= 2097664);
		}
	}
	function rn(e, t, n, r, i) {
		return En(t), n = Ne(e, t, n, r, void 0, i), r = Le(), e === null || hs ? (t.flags |= 1, Xt(e, t, n, i), t.child) : (Re(e, t, i), gn(e, t, i));
	}
	function an(e, t, n, r, i, a) {
		return En(t), t.updateQueue = null, n = Fe(t, r, n, i), Pe(e), r = Le(), e === null || hs ? (t.flags |= 1, Xt(e, t, n, a), t.child) : (Re(e, t, a), gn(e, t, a));
	}
	function on(e, t, n, r, i) {
		if (En(t), t.stateNode === null) {
			var a = Ua, o = n.contextType;
			typeof o == "object" && o && (a = Dn(o)), a = new n(r, a), t.memoizedState = a.state !== null && a.state !== void 0 ? a.state : null, a.updater = ps, t.stateNode = a, a._reactInternals = t, (a = t.stateNode).props = r, a.state = t.memoizedState, a.refs = {}, P(t), o = n.contextType, a.context = typeof o == "object" && o ? Dn(o) : Ua, a.state = t.memoizedState, typeof (o = n.getDerivedStateFromProps) == "function" && (Vt(t, n, o, r), a.state = t.memoizedState), typeof n.getDerivedStateFromProps == "function" || typeof a.getSnapshotBeforeUpdate == "function" || typeof a.UNSAFE_componentWillMount != "function" && typeof a.componentWillMount != "function" || (o = a.state, typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount(), o !== a.state && ps.enqueueReplaceState(a, a.state, null), I(t, r, a, i), F(), a.state = t.memoizedState), typeof a.componentDidMount == "function" && (t.flags |= 4194308), r = !0;
		} else if (e === null) {
			a = t.stateNode;
			var s = t.memoizedProps, c = Wt(n, s);
			a.props = c;
			var l = a.context, u = n.contextType;
			o = Ua, typeof u == "object" && u && (o = Dn(u));
			var d = n.getDerivedStateFromProps;
			u = typeof d == "function" || typeof a.getSnapshotBeforeUpdate == "function", s = t.pendingProps !== s, u || typeof a.UNSAFE_componentWillReceiveProps != "function" && typeof a.componentWillReceiveProps != "function" || (s || l !== o) && Ut(t, a, r, o), Fo = !1;
			var f = t.memoizedState;
			a.state = f, I(t, r, a, i), F(), l = t.memoizedState, s || f !== l || Fo ? (typeof d == "function" && (Vt(t, n, d, r), l = t.memoizedState), (c = Fo || Ht(t, n, c, r, f, l, o)) ? (u || typeof a.UNSAFE_componentWillMount != "function" && typeof a.componentWillMount != "function" || (typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount()), typeof a.componentDidMount == "function" && (t.flags |= 4194308)) : (typeof a.componentDidMount == "function" && (t.flags |= 4194308), t.memoizedProps = r, t.memoizedState = l), a.props = r, a.state = l, a.context = o, r = c) : (typeof a.componentDidMount == "function" && (t.flags |= 4194308), r = !1);
		} else {
			a = t.stateNode, ue(e, t), u = Wt(n, o = t.memoizedProps), a.props = u, d = t.pendingProps, f = a.context, l = n.contextType, c = Ua, typeof l == "object" && l && (c = Dn(l)), (l = typeof (s = n.getDerivedStateFromProps) == "function" || typeof a.getSnapshotBeforeUpdate == "function") || typeof a.UNSAFE_componentWillReceiveProps != "function" && typeof a.componentWillReceiveProps != "function" || (o !== d || f !== c) && Ut(t, a, r, c), Fo = !1, f = t.memoizedState, a.state = f, I(t, r, a, i), F();
			var p = t.memoizedState;
			o !== d || f !== p || Fo || e !== null && e.dependencies !== null && Tn(e.dependencies) ? (typeof s == "function" && (Vt(t, n, s, r), p = t.memoizedState), (u = Fo || Ht(t, n, u, r, f, p, c) || e !== null && e.dependencies !== null && Tn(e.dependencies)) ? (l || typeof a.UNSAFE_componentWillUpdate != "function" && typeof a.componentWillUpdate != "function" || (typeof a.componentWillUpdate == "function" && a.componentWillUpdate(r, p, c), typeof a.UNSAFE_componentWillUpdate == "function" && a.UNSAFE_componentWillUpdate(r, p, c)), typeof a.componentDidUpdate == "function" && (t.flags |= 4), typeof a.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof a.componentDidUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), typeof a.getSnapshotBeforeUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), t.memoizedProps = r, t.memoizedState = p), a.props = r, a.state = p, a.context = c, r = u) : (typeof a.componentDidUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), typeof a.getSnapshotBeforeUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), r = !1);
		}
		return a = r, nn(e, t), r = (128 & t.flags) != 0, a || r ? (a = t.stateNode, n = r && typeof n.getDerivedStateFromError != "function" ? null : a.render(), t.flags |= 1, e !== null && r ? (t.child = Wo(t, e.child, null, i), t.child = Wo(t, null, n, i)) : Xt(e, t, n, i), t.memoizedState = a.state, e = t.child) : e = gn(e, t, i), e;
	}
	function sn(e) {
		return {
			baseLanes: e,
			cachePool: Pn()
		};
	}
	function cn(e, t, n) {
		return e = e === null ? 0 : e.childLanes & ~n, t && (e |= $s), e;
	}
	function ln(e, t, n) {
		var i, a, o, s, c = t.pendingProps, l = !1, u = (128 & t.flags) != 0;
		if ((i = u) || (i = (e === null || e.memoizedState !== null) && (2 & Xo.current) != 0), i && (l = !0, t.flags &= -129), i = (32 & t.flags) != 0, t.flags &= -33, e === null) return a = c.children, c = c.fallback, l ? (Oe(), a = dn({
			mode: "hidden",
			children: a
		}, l = t.mode), c = ci(c, l, n, null), a.return = t, c.return = t, a.sibling = c, t.child = a, (l = t.child).memoizedState = sn(n), l.childLanes = cn(e, i, n), t.memoizedState = gs, c) : (Ee(t), un(t, a));
		if ((o = e.memoizedState) !== null && (a = o.dehydrated) !== null) {
			if (u) 256 & t.flags ? (Ee(t), t.flags &= -257, t = fn(e, t, n)) : t.memoizedState === null ? (Oe(), l = c.fallback, a = t.mode, c = dn({
				mode: "visible",
				children: c.children
			}, a), (l = ci(l, a, n, null)).flags |= 2, c.return = t, l.return = t, c.sibling = l, t.child = c, Wo(t, e.child, null, n), (c = t.child).memoizedState = sn(n), c.childLanes = cn(e, i, n), t.memoizedState = gs, t = l) : (Oe(), t.child = e.child, t.flags |= 128, t = null);
			else if (Ee(t), Ma(a)) i = Na(a).digest, (c = Error(r(419))).stack = "", c.digest = i, s = {
				value: c,
				source: null,
				stack: null
			}, xo === null ? xo = [s] : xo.push(s), t = fn(e, t, n);
			else if (hs || wn(e, t, n, !1), i = (n & e.childLanes) != 0, hs || i) {
				if ((i = Vs) !== null) {
					if (42 & (c = n & -n)) c = 1;
					else switch (c) {
						case 2:
							c = 1;
							break;
						case 8:
							c = 4;
							break;
						case 32:
							c = 16;
							break;
						case 128:
						case 256:
						case 512:
						case 1024:
						case 2048:
						case 4096:
						case 8192:
						case 16384:
						case 32768:
						case 65536:
						case 131072:
						case 262144:
						case 524288:
						case 1048576:
						case 2097152:
						case 4194304:
						case 8388608:
						case 16777216:
						case 33554432:
							c = 64;
							break;
						case 268435456:
							c = 134217728;
							break;
						default: c = 0;
					}
					if ((c = (c & (i.suspendedLanes | n)) == 0 ? c : 0) !== 0 && c !== o.retryLane) throw o.retryLane = c, ee(e, c), Er(i, 0, c), ms;
				}
				ja(a) || Rr(), t = fn(e, t, n);
			} else ja(a) ? (t.flags |= 128, t.child = e.child, t = ti.bind(null, e), Pa(a, t), t = null) : (e = o.treeContext, (t = un(t, c.children)).flags |= 4096);
			return t;
		}
		return l ? (Oe(), l = c.fallback, a = t.mode, u = (o = e.child).sibling, (c = ai(o, {
			mode: "hidden",
			children: c.children
		})).subtreeFlags = 31457280 & o.subtreeFlags, u === null ? (l = ci(l, a, n, null)).flags |= 2 : l = ai(u, l), l.return = t, c.return = t, c.sibling = l, t.child = c, c = l, l = t.child, (a = e.child.memoizedState) === null ? a = sn(n) : ((o = a.cachePool) === null ? o = Pn() : (u = ws._currentValue2, o = o.parent === u ? o : {
			parent: u,
			pool: u
		}), a = {
			baseLanes: a.baseLanes | n,
			cachePool: o
		}), l.memoizedState = a, l.childLanes = cn(e, i, n), t.memoizedState = gs, c) : (Ee(t), e = (n = e.child).sibling, (n = ai(n, {
			mode: "visible",
			children: c.children
		})).return = t, n.sibling = null, e !== null && ((i = t.deletions) === null ? (t.deletions = [e], t.flags |= 16) : i.push(e)), t.child = n, t.memoizedState = null, n);
	}
	function un(e, t) {
		return (t = dn({
			mode: "visible",
			children: t
		}, e.mode)).return = e, e.child = t;
	}
	function dn(e, t) {
		return li(e, t, 0, null);
	}
	function fn(e, t, n) {
		return Wo(t, e.child, null, n), (e = un(t, t.pendingProps.children)).flags |= 2, t.memoizedState = null, e;
	}
	function pn(e, t, n) {
		e.lanes |= t;
		var r = e.alternate;
		r !== null && (r.lanes |= t), Sn(e.return, t, n);
	}
	function mn(e, t, n, r, i) {
		var a = e.memoizedState;
		a === null ? e.memoizedState = {
			isBackwards: t,
			rendering: null,
			renderingStartTime: 0,
			last: r,
			tail: n,
			tailMode: i
		} : (a.isBackwards = t, a.rendering = null, a.renderingStartTime = 0, a.last = r, a.tail = n, a.tailMode = i);
	}
	function hn(e, t, n) {
		var r = t.pendingProps, i = r.revealOrder, a = r.tail;
		if (Xt(e, t, r.children, n), 2 & (r = Xo.current)) r = 1 & r | 2, t.flags |= 128;
		else {
			if (e !== null && 128 & e.flags) e: for (e = t.child; e !== null;) {
				if (e.tag === 13) e.memoizedState !== null && pn(e, n, t);
				else if (e.tag === 19) pn(e, n, t);
				else if (e.child !== null) {
					e.child.return = e, e = e.child;
					continue;
				}
				if (e === t) break e;
				for (; e.sibling === null;) {
					if (e.return === null || e.return === t) break e;
					e = e.return;
				}
				e.sibling.return = e.return, e = e.sibling;
			}
			r &= 1;
		}
		switch (f(Xo, r), i) {
			case "forwards":
				for (n = t.child, i = null; n !== null;) (e = n.alternate) !== null && Ae(e) === null && (i = n), n = n.sibling;
				(n = i) === null ? (i = t.child, t.child = null) : (i = n.sibling, n.sibling = null), mn(t, !1, i, n, a);
				break;
			case "backwards":
				for (n = null, i = t.child, t.child = null; i !== null;) {
					if ((e = i.alternate) !== null && Ae(e) === null) {
						t.child = i;
						break;
					}
					e = i.sibling, i.sibling = n, n = i, i = e;
				}
				mn(t, !0, n, null, a);
				break;
			case "together":
				mn(t, !1, null, null, void 0);
				break;
			default: t.memoizedState = null;
		}
		return t.child;
	}
	function gn(e, t, n) {
		if (e !== null && (t.dependencies = e.dependencies), Xs |= t.lanes, (n & t.childLanes) == 0 && (e === null || (wn(e, t, n, !1), (n & t.childLanes) == 0))) return null;
		if (e !== null && t.child !== e.child) throw Error(r(153));
		if (t.child !== null) {
			for (n = ai(e = t.child, e.pendingProps), t.child = n, n.return = t; e.sibling !== null;) e = e.sibling, (n = n.sibling = ai(e, e.pendingProps)).return = t;
			n.sibling = null;
		}
		return t.child;
	}
	function _n(e, t) {
		return (e.lanes & t) != 0 || !((e = e.dependencies) === null || !Tn(e));
	}
	function vn(e, t, n) {
		if (e !== null) if (e.memoizedProps !== t.pendingProps) hs = !0;
		else {
			if (!_n(e, n) && !(128 & t.flags)) return hs = !1, function(e, t, n) {
				switch (t.tag) {
					case 3:
						E(t, t.stateNode.containerInfo), bn(0, ws, e.memoizedState.cache);
						break;
					case 27:
					case 5:
						O(t);
						break;
					case 4:
						E(t, t.stateNode.containerInfo);
						break;
					case 10:
						bn(0, t.type, t.memoizedProps.value);
						break;
					case 13:
						var r = t.memoizedState;
						if (r !== null) return r.dehydrated === null ? (n & t.child.childLanes) == 0 ? (Ee(t), (e = gn(e, t, n)) === null ? null : e.sibling) : ln(e, t, n) : (Ee(t), t.flags |= 128, null);
						Ee(t);
						break;
					case 19:
						var i = (128 & e.flags) != 0;
						if ((r = (n & t.childLanes) != 0) || (wn(e, t, n, !1), r = (n & t.childLanes) != 0), i) {
							if (r) return hn(e, t, n);
							t.flags |= 128;
						}
						if ((i = t.memoizedState) !== null && (i.rendering = null, i.tail = null, i.lastEffect = null), f(Xo, Xo.current), r) break;
						return null;
					case 22:
					case 23: return t.lanes = 0, en(e, t, n);
					case 24: bn(0, ws, e.memoizedState.cache);
				}
				return gn(e, t, n);
			}(e, t, n);
			hs = (131072 & e.flags) != 0;
		}
		else hs = !1;
		switch (t.lanes = 0, t.tag) {
			case 16:
				e: {
					e = t.pendingProps;
					var i = t.elementType, o = i._init;
					if (i = o(i._payload), t.type = i, typeof i != "function") {
						if (i != null) {
							if ((o = i.$$typeof) === ki) {
								t.tag = 11, t = Zt(null, t, i, e, n);
								break e;
							}
							if (o === Mi) {
								t.tag = 14, t = Qt(null, t, i, e, n);
								break e;
							}
						}
						throw t = a(i) || i, Error(r(306, t, ""));
					}
					ii(i) ? (e = Wt(i, e), t.tag = 1, t = on(null, t, i, e, n)) : (t.tag = 0, t = rn(null, t, i, e, n));
				}
				return t;
			case 0: return rn(e, t, t.type, t.pendingProps, n);
			case 1: return on(e, t, i = t.type, o = Wt(i, t.pendingProps), n);
			case 3:
				if (E(t, t.stateNode.containerInfo), e === null) throw Error(r(387));
				var s = t.pendingProps;
				i = (o = t.memoizedState).element, ue(e, t), I(t, s, null, n);
				var c = t.memoizedState;
				return s = c.cache, bn(0, ws, s), s !== o.cache && Cn(t, [ws], n, !0), F(), (s = c.element) === i ? t = gn(e, t, n) : (Xt(e, t, s, n), t = t.child), t;
			case 26:
			case 27:
			case 5: return O(t), o = t.type, s = t.pendingProps, c = e === null ? null : e.memoizedProps, i = s.children, Yi(o, s) ? i = null : c !== null && Yi(o, c) && (t.flags |= 32), t.memoizedState !== null && (o = Ne(e, t, Ie, null, null, n), ma._currentValue2 = o), nn(e, t), Xt(e, t, i, n), t.child;
			case 6: return null;
			case 13: return ln(e, t, n);
			case 4: return E(t, t.stateNode.containerInfo), i = t.pendingProps, e === null ? t.child = Wo(t, null, i, n) : Xt(e, t, i, n), t.child;
			case 11: return Zt(e, t, t.type, t.pendingProps, n);
			case 7: return Xt(e, t, t.pendingProps, n), t.child;
			case 8:
			case 12: return Xt(e, t, t.pendingProps.children, n), t.child;
			case 10: return i = t.pendingProps, bn(0, t.type, i.value), Xt(e, t, i.children, n), t.child;
			case 9: return o = t.type._context, i = t.pendingProps.children, En(t), i = i(o = Dn(o)), t.flags |= 1, Xt(e, t, i, n), t.child;
			case 14: return Qt(e, t, t.type, t.pendingProps, n);
			case 15: return $t(e, t, t.type, t.pendingProps, n);
			case 19: return hn(e, t, n);
			case 22: return en(e, t, n);
			case 24: return En(t), i = Dn(ws), e === null ? ((o = Mn()) === null && (o = Vs, s = An(), o.pooledCache = s, s.refCount++, s !== null && (o.pooledCacheLanes |= n), o = s), t.memoizedState = {
				parent: i,
				cache: o
			}, P(t), bn(0, ws, o)) : ((e.lanes & n) != 0 && (ue(e, t), I(t, null, null, n), F()), o = e.memoizedState, s = t.memoizedState, o.parent === i ? (i = s.cache, bn(0, ws, i), i !== o.cache && Cn(t, [ws], n, !0)) : (o = {
				parent: i,
				cache: i
			}, t.memoizedState = o, t.lanes === 0 && (t.memoizedState = t.updateQueue.baseState = o), bn(0, ws, i))), Xt(e, t, t.pendingProps.children, n), t.child;
			case 29: throw t.pendingProps;
		}
		throw Error(r(156, t.tag));
	}
	function yn() {
		bs = ys = vs = null;
	}
	function bn(e, t, n) {
		f(_s, t._currentValue2), t._currentValue2 = n;
	}
	function xn(e) {
		e._currentValue2 = _s.current, d(_s);
	}
	function Sn(e, t, n) {
		for (; e !== null;) {
			var r = e.alternate;
			if ((e.childLanes & t) === t ? r !== null && (r.childLanes & t) !== t && (r.childLanes |= t) : (e.childLanes |= t, r !== null && (r.childLanes |= t)), e === n) break;
			e = e.return;
		}
	}
	function Cn(e, t, n, i) {
		var a = e.child;
		for (a !== null && (a.return = e); a !== null;) {
			var o = a.dependencies;
			if (o !== null) {
				var s = a.child;
				o = o.firstContext;
				e: for (; o !== null;) {
					var c = o;
					o = a;
					for (var l = 0; l < t.length; l++) if (c.context === t[l]) {
						o.lanes |= n, (c = o.alternate) !== null && (c.lanes |= n), Sn(o.return, n, e), i || (s = null);
						break e;
					}
					o = c.next;
				}
			} else if (a.tag === 18) {
				if ((s = a.return) === null) throw Error(r(341));
				s.lanes |= n, (o = s.alternate) !== null && (o.lanes |= n), Sn(s, n, e), s = null;
			} else s = a.child;
			if (s !== null) s.return = a;
			else for (s = a; s !== null;) {
				if (s === e) {
					s = null;
					break;
				}
				if ((a = s.sibling) !== null) {
					a.return = s.return, s = a;
					break;
				}
				s = s.return;
			}
			a = s;
		}
	}
	function wn(e, t, n, i) {
		e = null;
		for (var a = t, o = !1; a !== null;) {
			if (!o) {
				if (524288 & a.flags) o = !0;
				else if (262144 & a.flags) break;
			}
			if (a.tag === 10) {
				var s = a.alternate;
				if (s === null) throw Error(r(387));
				if ((s = s.memoizedProps) !== null) {
					var c = a.type;
					so(a.pendingProps.value, s.value) || (e === null ? e = [c] : e.push(c));
				}
			} else if (a === yo.current) {
				if ((s = a.alternate) === null) throw Error(r(387));
				s.memoizedState.memoizedState !== a.memoizedState.memoizedState && (e === null ? e = [ma] : e.push(ma));
			}
			a = a.return;
		}
		e !== null && Cn(t, e, n, i), t.flags |= 262144;
	}
	function Tn(e) {
		for (e = e.firstContext; e !== null;) {
			var t = e.context;
			if (!so(t._currentValue2, e.memoizedValue)) return !0;
			e = e.next;
		}
		return !1;
	}
	function En(e) {
		vs = e, bs = ys = null, (e = e.dependencies) !== null && (e.firstContext = null);
	}
	function Dn(e) {
		return kn(vs, e);
	}
	function On(e, t) {
		return vs === null && En(e), kn(e, t);
	}
	function kn(e, t) {
		var n = t._currentValue2;
		if (bs !== t) if (t = {
			context: t,
			memoizedValue: n,
			next: null
		}, ys === null) {
			if (e === null) throw Error(r(308));
			ys = t, e.dependencies = {
				lanes: 0,
				firstContext: t
			}, e.flags |= 524288;
		} else ys = ys.next = t;
		return n;
	}
	function An() {
		return {
			controller: new xs(),
			data: /* @__PURE__ */ new Map(),
			refCount: 0
		};
	}
	function jn(e) {
		e.refCount--, e.refCount === 0 && Ss(Cs, (function() {
			e.controller.abort();
		}));
	}
	function Mn() {
		var e = Es.current;
		return e === null ? Vs.pooledCache : e;
	}
	function Nn(e, t) {
		f(Es, t === null ? Es.current : t.pool);
	}
	function Pn() {
		var e = Mn();
		return e === null ? null : {
			parent: ws._currentValue2,
			pool: e
		};
	}
	function Fn(e) {
		e.flags |= 4;
	}
	function In(e, t) {
		t !== null && (e.flags |= 4), 16384 & e.flags && (t = e.tag === 22 ? 536870912 : _(), e.lanes |= t);
	}
	function Ln(e, t) {
		switch (e.tailMode) {
			case "hidden":
				t = e.tail;
				for (var n = null; t !== null;) t.alternate !== null && (n = t), t = t.sibling;
				n === null ? e.tail = null : n.sibling = null;
				break;
			case "collapsed":
				n = e.tail;
				for (var r = null; n !== null;) n.alternate !== null && (r = n), n = n.sibling;
				r === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : r.sibling = null;
		}
	}
	function Rn(e) {
		var t = e.alternate !== null && e.alternate.child === e.child, n = 0, r = 0;
		if (t) for (var i = e.child; i !== null;) n |= i.lanes | i.childLanes, r |= 31457280 & i.subtreeFlags, r |= 31457280 & i.flags, i.return = e, i = i.sibling;
		else for (i = e.child; i !== null;) n |= i.lanes | i.childLanes, r |= i.subtreeFlags, r |= i.flags, i.return = e, i = i.sibling;
		return e.subtreeFlags |= r, e.childLanes = n, t;
	}
	function zn(e, t, n) {
		var i = t.pendingProps;
		switch (T(t), t.tag) {
			case 16:
			case 15:
			case 0:
			case 11:
			case 7:
			case 8:
			case 12:
			case 9:
			case 14:
			case 1: return Rn(t), null;
			case 3: return n = t.stateNode, i = null, e !== null && (i = e.memoizedState.cache), t.memoizedState.cache !== i && (t.flags |= 2048), xn(ws), D(), n.pendingContext && (n.context = n.pendingContext, n.pendingContext = null), e !== null && e.child !== null || e === null || e.memoizedState.isDehydrated && !(256 & t.flags) || (t.flags |= 1024, xo !== null && (Or(xo), xo = null)), Rn(t), null;
			case 26: var a;
			case 27:
			case 5:
				if (k(t), n = t.type, e !== null && t.stateNode != null) (function(e, t, n, r) {
					e.memoizedProps !== r && Fn(t);
				})(e, t, 0, i);
				else {
					if (!i) {
						if (t.stateNode === null) throw Error(r(166));
						return Rn(t), null;
					}
					e = go.current, function(e, t, n, r) {
						for (n = t.child; n !== null;) {
							if (n.tag === 5 || n.tag === 6) qi(e, n.stateNode);
							else if (n.tag !== 4 && !Ba && n.child !== null) {
								n.child.return = n, n = n.child;
								continue;
							}
							if (n === t) break;
							for (; n.sibling === null;) {
								if (n.return === null || n.return === t) return;
								n = n.return;
							}
							n.sibling.return = n.return, n = n.sibling;
						}
					}(a = Ki(n, i, vo.current, e, t), t, !1), t.stateNode = a, Ji(a, n, i, e) && Fn(t);
				}
				return Rn(t), function(e, t, n) {
					if (ca(t, n)) {
						if (e.flags |= 16777216, !la(t, n)) {
							if (!Fr()) throw Vo = Bo, zo;
							e.flags |= 8192;
						}
					} else e.flags &= -16777217;
				}(t, t.type, t.pendingProps), null;
			case 6:
				if (e && t.stateNode != null) (n = e.memoizedProps) !== i && Fn(t);
				else {
					if (typeof i != "string" && t.stateNode === null) throw Error(r(166));
					e = vo.current, n = go.current, t.stateNode = Xi(i, e, n, t);
				}
				return Rn(t), null;
			case 13:
				if (i = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
					if (a = !1, i !== null && i.dehydrated !== null) {
						if (e === null) throw Error(r(a ? 344 : 318));
						!(128 & t.flags) && (t.memoizedState = null), t.flags |= 4, Rn(t), a = !1;
					} else xo !== null && (Or(xo), xo = null), a = !0;
					if (!a) return 256 & t.flags ? (ke(t), t) : (ke(t), null);
				}
				if (ke(t), 128 & t.flags) return t.lanes = n, t;
				if (n = i !== null, e = e !== null && e.memoizedState !== null, n) {
					a = null, (i = t.child).alternate !== null && i.alternate.memoizedState !== null && i.alternate.memoizedState.cachePool !== null && (a = i.alternate.memoizedState.cachePool.pool);
					var o = null;
					i.memoizedState !== null && i.memoizedState.cachePool !== null && (o = i.memoizedState.cachePool.pool), o !== a && (i.flags |= 2048);
				}
				return n !== e && n && (t.child.flags |= 8192), In(t, t.updateQueue), Rn(t), null;
			case 4: return D(), e === null && na(t.stateNode.containerInfo), Rn(t), null;
			case 10: return xn(t.type), Rn(t), null;
			case 19:
				if (d(Xo), (a = t.memoizedState) === null) return Rn(t), null;
				if (i = (128 & t.flags) != 0, (o = a.rendering) === null) if (i) Ln(a, !1);
				else {
					if (Ys !== 0 || e !== null && 128 & e.flags) for (e = t.child; e !== null;) {
						if ((o = Ae(e)) !== null) {
							for (t.flags |= 128, Ln(a, !1), e = o.updateQueue, t.updateQueue = e, In(t, e), t.subtreeFlags = 0, e = n, n = t.child; n !== null;) oi(n, e), n = n.sibling;
							return f(Xo, 1 & Xo.current | 2), t.child;
						}
						e = e.sibling;
					}
					a.tail !== null && $a() > ac && (t.flags |= 128, i = !0, Ln(a, !1), t.lanes = 4194304);
				}
				else {
					if (!i) if ((e = Ae(o)) !== null) {
						if (t.flags |= 128, i = !0, e = e.updateQueue, t.updateQueue = e, In(t, e), Ln(a, !0), a.tail === null && a.tailMode === "hidden" && !o.alternate) return Rn(t), null;
					} else 2 * $a() - a.renderingStartTime > ac && n !== 536870912 && (t.flags |= 128, i = !0, Ln(a, !1), t.lanes = 4194304);
					a.isBackwards ? (o.sibling = t.child, t.child = o) : ((e = a.last) === null ? t.child = o : e.sibling = o, a.last = o);
				}
				return a.tail === null ? (Rn(t), null) : (t = a.tail, a.rendering = t, a.tail = t.sibling, a.renderingStartTime = $a(), t.sibling = null, e = Xo.current, f(Xo, i ? 1 & e | 2 : 1 & e), t);
			case 22:
			case 23: return ke(t), Te(), i = t.memoizedState !== null, e === null ? i && (t.flags |= 8192) : e.memoizedState !== null !== i && (t.flags |= 8192), i ? 536870912 & n && !(128 & t.flags) && (Rn(t), 6 & t.subtreeFlags && (t.flags |= 8192)) : Rn(t), (n = t.updateQueue) !== null && In(t, n.retryQueue), n = null, e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (n = e.memoizedState.cachePool.pool), i = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (i = t.memoizedState.cachePool.pool), i !== n && (t.flags |= 2048), e !== null && d(Es), null;
			case 24: return n = null, e !== null && (n = e.memoizedState.cache), t.memoizedState.cache !== n && (t.flags |= 2048), xn(ws), Rn(t), null;
			case 25: return null;
		}
		throw Error(r(156, t.tag));
	}
	function Bn(e, t) {
		switch (T(t), t.tag) {
			case 1: return 65536 & (e = t.flags) ? (t.flags = -65537 & e | 128, t) : null;
			case 3: return xn(ws), D(), 65536 & (e = t.flags) && !(128 & e) ? (t.flags = -65537 & e | 128, t) : null;
			case 26:
			case 27:
			case 5: return k(t), null;
			case 13:
				if (ke(t), (e = t.memoizedState) !== null && e.dehydrated !== null && t.alternate === null) throw Error(r(340));
				return 65536 & (e = t.flags) ? (t.flags = -65537 & e | 128, t) : null;
			case 19: return d(Xo), null;
			case 4: return D(), null;
			case 10: return xn(t.type), null;
			case 22:
			case 23: return ke(t), Te(), e !== null && d(Es), 65536 & (e = t.flags) ? (t.flags = -65537 & e | 128, t) : null;
			case 24: return xn(ws), null;
			default: return null;
		}
	}
	function Vn(e, t) {
		switch (T(t), t.tag) {
			case 3:
				xn(ws), D();
				break;
			case 26:
			case 27:
			case 5:
				k(t);
				break;
			case 4:
				D();
				break;
			case 13:
				ke(t);
				break;
			case 19:
				d(Xo);
				break;
			case 10:
				xn(t.type);
				break;
			case 22:
			case 23:
				ke(t), Te(), e !== null && d(Es);
				break;
			case 24: xn(ws);
		}
	}
	function Hn(e, t) {
		try {
			var n = t.updateQueue, r = n === null ? null : n.lastEffect;
			if (r !== null) {
				var i = r.next;
				n = i;
				do {
					if ((n.tag & e) === e) {
						r = void 0;
						var a = n.create, o = n.inst;
						r = a(), o.destroy = r;
					}
					n = n.next;
				} while (n !== i);
			}
		} catch (e) {
			Zr(t, t.return, e);
		}
	}
	function Un(e, t, n) {
		try {
			var r = t.updateQueue, i = r === null ? null : r.lastEffect;
			if (i !== null) {
				var a = i.next;
				r = a;
				do {
					if ((r.tag & e) === e) {
						var o = r.inst, s = o.destroy;
						if (s !== void 0) {
							o.destroy = void 0, i = t;
							var c = n;
							try {
								s();
							} catch (e) {
								Zr(i, c, e);
							}
						}
					}
					r = r.next;
				} while (r !== a);
			}
		} catch (e) {
			Zr(t, t.return, e);
		}
	}
	function Wn(e) {
		var t = e.updateQueue;
		if (t !== null) {
			var n = e.stateNode;
			try {
				L(t, n);
			} catch (t) {
				Zr(e, e.return, t);
			}
		}
	}
	function Gn(e, t, n) {
		n.props = Wt(e.type, e.memoizedProps), n.state = e.memoizedState;
		try {
			n.componentWillUnmount();
		} catch (n) {
			Zr(e, t, n);
		}
	}
	function Kn(e, t) {
		try {
			var n = e.ref;
			if (n !== null) {
				var r = e.stateNode;
				switch (e.tag) {
					case 26:
					case 27:
					case 5:
						var i = Vi(r);
						break;
					default: i = r;
				}
				typeof n == "function" ? e.refCleanup = n(i) : n.current = i;
			}
		} catch (n) {
			Zr(e, t, n);
		}
	}
	function qn(e, t) {
		var n = e.ref, r = e.refCleanup;
		if (n !== null) if (typeof r == "function") try {
			r();
		} catch (n) {
			Zr(e, t, n);
		} finally {
			e.refCleanup = null, (e = e.alternate) != null && (e.refCleanup = null);
		}
		else if (typeof n == "function") try {
			n(null);
		} catch (n) {
			Zr(e, t, n);
		}
		else n.current = null;
	}
	function Jn(e) {
		var t = e.type, n = e.memoizedProps, r = e.stateNode;
		try {
			ya(r, t, n, e);
		} catch (t) {
			Zr(e, e.return, t);
		}
	}
	function Yn(e) {
		return e.tag === 5 || e.tag === 3 || e.tag === 4;
	}
	function Xn(e) {
		e: for (;;) {
			for (; e.sibling === null;) {
				if (e.return === null || Yn(e.return)) return null;
				e = e.return;
			}
			for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18;) {
				if (2 & e.flags || e.child === null || e.tag === 4) continue e;
				e.child.return = e, e = e.child;
			}
			if (!(2 & e.flags)) return e.stateNode;
		}
	}
	function Zn(e, t, n) {
		var r = e.tag;
		if (r === 5 || r === 6) e = e.stateNode, t ? Sa(n, e, t) : _a(n, e);
		else if (r !== 4 && !Ba && (e = e.child) !== null) for (Zn(e, t, n), e = e.sibling; e !== null;) Zn(e, t, n), e = e.sibling;
	}
	function Qn(e, t, n) {
		var r = e.tag;
		if (r === 5 || r === 6) e = e.stateNode, t ? xa(n, e, t) : ga(n, e);
		else if (r !== 4 && !Ba && (e = e.child) !== null) for (Qn(e, t, n), e = e.sibling; e !== null;) Qn(e, t, n), e = e.sibling;
	}
	function $n(e, t, n) {
		var r = n.flags;
		switch (n.tag) {
			case 0:
			case 11:
			case 15:
				cr(e, n), 4 & r && Hn(5, n);
				break;
			case 1:
				if (cr(e, n), 4 & r) if (e = n.stateNode, t === null) try {
					e.componentDidMount();
				} catch (e) {
					Zr(n, n.return, e);
				}
				else {
					var i = Wt(n.type, t.memoizedProps);
					t = t.memoizedState;
					try {
						e.componentDidUpdate(i, t, e.__reactInternalSnapshotBeforeUpdate);
					} catch (e) {
						Zr(n, n.return, e);
					}
				}
				64 & r && Wn(n), 512 & r && Kn(n, n.return);
				break;
			case 3:
				if (cr(e, n), 64 & r && (r = n.updateQueue) !== null) {
					if (e = null, n.child !== null) switch (n.child.tag) {
						case 27:
						case 5:
							e = Vi(n.child.stateNode);
							break;
						case 1: e = n.child.stateNode;
					}
					try {
						L(r, e);
					} catch (e) {
						Zr(n, n.return, e);
					}
				}
				break;
			case 26:
			case 27:
			case 5:
				cr(e, n), t === null && 4 & r && Jn(n), 512 & r && Kn(n, n.return);
				break;
			case 12:
			case 13:
			default:
				cr(e, n);
				break;
			case 22:
				if (!(i = n.memoizedState !== null || Ds)) {
					t = t !== null && t.memoizedState !== null || Os;
					var a = Ds, o = Os;
					Ds = i, (Os = t) && !o ? ur(e, n, (8772 & n.subtreeFlags) != 0) : cr(e, n), Ds = a, Os = o;
				}
				512 & r && (n.memoizedProps.mode === "manual" ? Kn(n, n.return) : qn(n, n.return));
		}
	}
	function er(e) {
		var t = e.alternate;
		t !== null && (e.alternate = null, er(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode) !== null && sa(t), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
	}
	function tr(e, t, n) {
		for (n = n.child; n !== null;) nr(e, t, n), n = n.sibling;
	}
	function nr(e, t, n) {
		switch (n.tag) {
			case 26:
			case 27: var r, i;
			case 5: Os || qn(n, t);
			case 6:
				if (r = Ns, i = Ps, Ns = null, tr(e, t, n), Ps = i, (Ns = r) !== null) if (Ps) try {
					wa(Ns, n.stateNode);
				} catch (e) {
					Zr(n, t, e);
				}
				else try {
					Ca(Ns, n.stateNode);
				} catch (e) {
					Zr(n, t, e);
				}
				break;
			case 18:
				Ns !== null && (Ps ? Ia(Ns, n.stateNode) : Fa(Ns, n.stateNode));
				break;
			case 4:
				r = Ns, i = Ps, Ns = n.stateNode.containerInfo, Ps = !0, tr(e, t, n), Ns = r, Ps = i;
				break;
			case 0:
			case 11:
			case 14:
			case 15:
				Os || Un(2, n, t), Os || Un(4, n, t), tr(e, t, n);
				break;
			case 1:
				Os || (qn(n, t), typeof (r = n.stateNode).componentWillUnmount == "function" && Gn(n, t, r)), tr(e, t, n);
				break;
			case 21:
				tr(e, t, n);
				break;
			case 22:
				qn(n, t), Os = (r = Os) || n.memoizedState !== null, tr(e, t, n), Os = r;
				break;
			default: tr(e, t, n);
		}
	}
	function rr(e, t) {
		var n = function(e) {
			switch (e.tag) {
				case 13:
				case 19:
					var t = e.stateNode;
					return t === null && (t = e.stateNode = new As()), t;
				case 22: return (t = (e = e.stateNode)._retryCache) === null && (t = e._retryCache = new As()), t;
				default: throw Error(r(435, e.tag));
			}
		}(e);
		t.forEach((function(t) {
			var r = ni.bind(null, e, t);
			n.has(t) || (n.add(t), t.then(r, r));
		}));
	}
	function ir(e, t) {
		var n = t.deletions;
		if (n !== null) for (var i = 0; i < n.length; i++) {
			var a = n[i], o = e, s = t, c = s;
			e: for (; c !== null;) {
				switch (c.tag) {
					case 27:
					case 5:
						Ns = c.stateNode, Ps = !1;
						break e;
					case 3:
					case 4:
						Ns = c.stateNode.containerInfo, Ps = !0;
						break e;
				}
				c = c.return;
			}
			if (Ns === null) throw Error(r(160));
			nr(o, s, a), Ns = null, Ps = !1, (o = a.alternate) !== null && (o.return = null), a.return = null;
		}
		if (13878 & t.subtreeFlags) for (t = t.child; t !== null;) ar(t, e), t = t.sibling;
	}
	function ar(e, t) {
		var n = e.alternate, i = e.flags;
		switch (e.tag) {
			case 0:
			case 11:
			case 14:
			case 15:
				ir(t, e), or(e), 4 & i && (Un(3, e, e.return), Hn(3, e), Un(5, e, e.return));
				break;
			case 1:
				ir(t, e), or(e), 512 & i && n !== null && qn(n, n.return), 64 & i && Ds && (e = e.updateQueue) !== null && (i = e.callbacks) !== null && (n = e.shared.hiddenCallbacks, e.shared.hiddenCallbacks = n === null ? i : n.concat(i));
				break;
			case 26: var a;
			case 27: var o;
			case 5:
				if (ir(t, e), or(e), 512 & i && n !== null && qn(n, n.return), 32 & e.flags) {
					t = e.stateNode;
					try {
						Ta(t);
					} catch (t) {
						Zr(e, e.return, t);
					}
				}
				4 & i && e.stateNode != null && function(e, t, n) {
					try {
						ba(e.stateNode, e.type, n, t, e);
					} catch (t) {
						Zr(e, e.return, t);
					}
				}(e, t = e.memoizedProps, n === null ? t : n.memoizedProps), 1024 & i && (ks = !0);
				break;
			case 6:
				if (ir(t, e), or(e), 4 & i && ea) {
					if (e.stateNode === null) throw Error(r(162));
					i = e.memoizedProps, n = n === null ? i : n.memoizedProps, t = e.stateNode;
					try {
						va(t, n, i);
					} catch (t) {
						Zr(e, e.return, t);
					}
				}
				break;
			case 3:
				ir(t, e), or(e), ks && (ks = !1, sr(e));
				break;
			case 4:
			case 12:
				ir(t, e), or(e);
				break;
			case 13:
				ir(t, e), or(e), 8192 & e.child.flags && e.memoizedState !== null != (n !== null && n.memoizedState !== null) && (ic = $a()), 4 & i && (i = e.updateQueue) !== null && (e.updateQueue = null, rr(e, i));
				break;
			case 22:
				512 & i && n !== null && qn(n, n.return), a = e.memoizedState !== null;
				var s = n !== null && n.memoizedState !== null, c = Ds, l = Os;
				if (Ds = c || a, Os = l || s, ir(t, e), Os = l, Ds = c, or(e), (t = e.stateNode)._current = e, t._visibility &= -3, t._visibility |= 2 & t._pendingVisibility, 8192 & i && (t._visibility = a ? -2 & t._visibility : 1 | t._visibility, a && (t = Ds || Os, n === null || s || t || lr(e)), e.memoizedProps === null || e.memoizedProps.mode !== "manual")) {
					e: if (n = null, ea) for (t = e;;) {
						if (t.tag === 5 || La || Ba) {
							if (n === null) {
								s = n = t;
								try {
									o = s.stateNode, a ? Ea(o) : Oa(s.stateNode, s.memoizedProps);
								} catch (e) {
									Zr(s, s.return, e);
								}
							}
						} else if (t.tag === 6) {
							if (n === null) {
								s = t;
								try {
									var u = s.stateNode;
									a ? Da(u) : ka(u, s.memoizedProps);
								} catch (e) {
									Zr(s, s.return, e);
								}
							}
						} else if ((t.tag !== 22 && t.tag !== 23 || t.memoizedState === null || t === e) && t.child !== null) {
							t.child.return = t, t = t.child;
							continue;
						}
						if (t === e) break e;
						for (; t.sibling === null;) {
							if (t.return === null || t.return === e) break e;
							n === t && (n = null), t = t.return;
						}
						n === t && (n = null), t.sibling.return = t.return, t = t.sibling;
					}
				}
				4 & i && (i = e.updateQueue) !== null && (n = i.retryQueue) !== null && (i.retryQueue = null, rr(e, n));
				break;
			case 19:
				ir(t, e), or(e), 4 & i && (i = e.updateQueue) !== null && (e.updateQueue = null, rr(e, i));
				break;
			case 21: break;
			default: ir(t, e), or(e);
		}
	}
	function or(e) {
		var t = e.flags;
		if (2 & t) {
			try {
				if (ea && (!Ba || e.tag !== 27)) {
					e: {
						for (var n = e.return; n !== null;) {
							if (Yn(n)) {
								var i = n;
								break e;
							}
							n = n.return;
						}
						throw Error(r(160));
					}
					switch (i.tag) {
						case 27:
						case 5:
							var a = i.stateNode;
							32 & i.flags && (Ta(a), i.flags &= -33), Qn(e, Xn(e), a);
							break;
						case 3:
						case 4:
							var o = i.stateNode.containerInfo;
							Zn(e, Xn(e), o);
							break;
						default: throw Error(r(161));
					}
				}
			} catch (t) {
				Zr(e, e.return, t);
			}
			e.flags &= -3;
		}
		4096 & t && (e.flags &= -4097);
	}
	function sr(e) {
		if (1024 & e.subtreeFlags) for (e = e.child; e !== null;) {
			var t = e;
			sr(t), t.tag === 5 && 1024 & t.flags && ha(t.stateNode), e = e.sibling;
		}
	}
	function cr(e, t) {
		if (8772 & t.subtreeFlags) for (t = t.child; t !== null;) $n(e, t.alternate, t), t = t.sibling;
	}
	function lr(e) {
		for (e = e.child; e !== null;) {
			var t = e;
			switch (t.tag) {
				case 0:
				case 11:
				case 14:
				case 15:
					Un(4, t, t.return), lr(t);
					break;
				case 1:
					qn(t, t.return);
					var n = t.stateNode;
					typeof n.componentWillUnmount == "function" && Gn(t, t.return, n), lr(t);
					break;
				case 26:
				case 27:
				case 5:
					qn(t, t.return), lr(t);
					break;
				case 22:
					qn(t, t.return), t.memoizedState === null && lr(t);
					break;
				default: lr(t);
			}
			e = e.sibling;
		}
	}
	function ur(e, t, n) {
		for (n &&= (8772 & t.subtreeFlags) != 0, t = t.child; t !== null;) {
			var r = t.alternate, i = e, a = t, o = a.flags;
			switch (a.tag) {
				case 0:
				case 11:
				case 15:
					ur(i, a, n), Hn(4, a);
					break;
				case 1:
					if (ur(i, a, n), typeof (i = (r = a).stateNode).componentDidMount == "function") try {
						i.componentDidMount();
					} catch (e) {
						Zr(r, r.return, e);
					}
					if ((i = (r = a).updateQueue) !== null) {
						var s = r.stateNode;
						try {
							var c = i.shared.hiddenCallbacks;
							if (c !== null) for (i.shared.hiddenCallbacks = null, i = 0; i < c.length; i++) he(c[i], s);
						} catch (e) {
							Zr(r, r.return, e);
						}
					}
					n && 64 & o && Wn(a), Kn(a, a.return);
					break;
				case 26:
				case 27:
				case 5:
					ur(i, a, n), n && r === null && 4 & o && Jn(a), Kn(a, a.return);
					break;
				case 12:
				case 13:
				default:
					ur(i, a, n);
					break;
				case 22: a.memoizedState === null && ur(i, a, n), Kn(a, a.return);
			}
			t = t.sibling;
		}
	}
	function dr(e, t) {
		var n = null;
		e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (n = e.memoizedState.cachePool.pool), e = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (e = t.memoizedState.cachePool.pool), e !== n && (e != null && e.refCount++, n != null && jn(n));
	}
	function fr(e, t) {
		e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), (t = t.memoizedState.cache) !== e && (t.refCount++, e != null && jn(e));
	}
	function pr(e, t, n, r) {
		if (10256 & t.subtreeFlags) for (t = t.child; t !== null;) mr(e, t, n, r), t = t.sibling;
	}
	function mr(e, t, n, r) {
		var i = t.flags;
		switch (t.tag) {
			case 0:
			case 11:
			case 15:
				pr(e, t, n, r), 2048 & i && Hn(9, t);
				break;
			case 3:
				pr(e, t, n, r), 2048 & i && (e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), (t = t.memoizedState.cache) !== e && (t.refCount++, e != null && jn(e)));
				break;
			case 12:
				if (2048 & i) {
					pr(e, t, n, r), e = t.stateNode;
					try {
						var a = t.memoizedProps, o = a.id, s = a.onPostCommit;
						typeof s == "function" && s(o, t.alternate === null ? "mount" : "update", e.passiveEffectDuration, -0);
					} catch (e) {
						Zr(t, t.return, e);
					}
				} else pr(e, t, n, r);
				break;
			case 23: break;
			case 22:
				a = t.stateNode, t.memoizedState === null ? 4 & a._visibility ? pr(e, t, n, r) : (a._visibility |= 4, hr(e, t, n, r, (10256 & t.subtreeFlags) != 0)) : 4 & a._visibility ? pr(e, t, n, r) : gr(e, t), 2048 & i && dr(t.alternate, t);
				break;
			case 24:
				pr(e, t, n, r), 2048 & i && fr(t.alternate, t);
				break;
			default: pr(e, t, n, r);
		}
	}
	function hr(e, t, n, r, i) {
		for (i &&= (10256 & t.subtreeFlags) != 0, t = t.child; t !== null;) {
			var a = e, o = t, s = n, c = r, l = o.flags;
			switch (o.tag) {
				case 0:
				case 11:
				case 15:
					hr(a, o, s, c, i), Hn(8, o);
					break;
				case 23: break;
				case 22:
					var u = o.stateNode;
					o.memoizedState === null ? (u._visibility |= 4, hr(a, o, s, c, i)) : 4 & u._visibility ? hr(a, o, s, c, i) : gr(a, o), i && 2048 & l && dr(o.alternate, o);
					break;
				case 24:
					hr(a, o, s, c, i), i && 2048 & l && fr(o.alternate, o);
					break;
				default: hr(a, o, s, c, i);
			}
			t = t.sibling;
		}
	}
	function gr(e, t) {
		if (10256 & t.subtreeFlags) for (t = t.child; t !== null;) {
			var n = e, r = t, i = r.flags;
			switch (r.tag) {
				case 22:
					gr(n, r), 2048 & i && dr(r.alternate, r);
					break;
				case 24:
					gr(n, r), 2048 & i && fr(r.alternate, r);
					break;
				default: gr(n, r);
			}
			t = t.sibling;
		}
	}
	function _r(e) {
		if (e.subtreeFlags & Is) for (e = e.child; e !== null;) vr(e), e = e.sibling;
	}
	function vr(e) {
		switch (e.tag) {
			case 26:
				_r(e), e.flags & Is && (e.memoizedState === null ? da(e.type, e.memoizedProps) : za(Fs, e.memoizedState, e.memoizedProps));
				break;
			case 5:
				_r(e), e.flags & Is && da(e.type, e.memoizedProps);
				break;
			case 3:
			case 4:
				var t;
				_r(e);
				break;
			case 22:
				e.memoizedState === null && ((t = e.alternate) !== null && t.memoizedState !== null ? (t = Is, Is = 16777216, _r(e), Is = t) : _r(e));
				break;
			default: _r(e);
		}
	}
	function yr(e) {
		var t = e.alternate;
		if (t !== null && (e = t.child) !== null) {
			t.child = null;
			do
				t = e.sibling, e.sibling = null, e = t;
			while (e !== null);
		}
	}
	function br(e) {
		var t = e.deletions;
		if (16 & e.flags) {
			if (t !== null) for (var n = 0; n < t.length; n++) {
				var r = t[n];
				js = r, Cr(r, e);
			}
			yr(e);
		}
		if (10256 & e.subtreeFlags) for (e = e.child; e !== null;) xr(e), e = e.sibling;
	}
	function xr(e) {
		switch (e.tag) {
			case 0:
			case 11:
			case 15:
				br(e), 2048 & e.flags && Un(9, e, e.return);
				break;
			case 3:
			case 12:
			default:
				br(e);
				break;
			case 22:
				var t = e.stateNode;
				e.memoizedState !== null && 4 & t._visibility && (e.return === null || e.return.tag !== 13) ? (t._visibility &= -5, Sr(e)) : br(e);
		}
	}
	function Sr(e) {
		var t = e.deletions;
		if (16 & e.flags) {
			if (t !== null) for (var n = 0; n < t.length; n++) {
				var r = t[n];
				js = r, Cr(r, e);
			}
			yr(e);
		}
		for (e = e.child; e !== null;) {
			switch ((t = e).tag) {
				case 0:
				case 11:
				case 15:
					Un(8, t, t.return), Sr(t);
					break;
				case 22:
					4 & (n = t.stateNode)._visibility && (n._visibility &= -5, Sr(t));
					break;
				default: Sr(t);
			}
			e = e.sibling;
		}
	}
	function Cr(e, t) {
		for (; js !== null;) {
			var n = js;
			switch (n.tag) {
				case 0:
				case 11:
				case 15:
					Un(8, n, t);
					break;
				case 23:
				case 22:
					if (n.memoizedState !== null && n.memoizedState.cachePool !== null) {
						var r = n.memoizedState.cachePool.pool;
						r != null && r.refCount++;
					}
					break;
				case 24: jn(n.memoizedState.cache);
			}
			if ((r = n.child) !== null) r.return = n, js = r;
			else e: for (n = e; js !== null;) {
				var i = (r = js).sibling, a = r.return;
				if (er(r), r === n) {
					js = null;
					break e;
				}
				if (i !== null) {
					i.return = a, js = i;
					break e;
				}
				js = a;
			}
		}
	}
	function wr() {
		return 2 & Bs && Us !== 0 ? Us & -Us : Ri.T === null ? aa() : No === 0 ? le() : No;
	}
	function Tr() {
		$s === 0 && ($s = !(536870912 & Us) || bo ? g() : 536870912);
		var e = Jo.current;
		return e !== null && (e.flags |= 32), $s;
	}
	function Er(e, t, n) {
		(e === Vs && Ws === 2 || e.cancelPendingCommit !== null) && (Nr(e, 0), jr(e, Us, $s)), y(e, n), 2 & Bs && e === Vs || (e === Vs && (!(2 & Bs) && (Zs |= n), Ys === 4 && jr(e, Us, $s)), re(e));
	}
	function Dr(e, t, n) {
		if (6 & Bs) throw Error(r(327));
		var i = (n = !n && (60 & t) == 0 && (t & e.expiredLanes) == 0) ? function(e, t) {
			var n = Bs;
			Bs |= 2;
			var i = Ir(), a = Lr();
			Vs === e && Us === t || (oc = null, ac = $a() + 500, Nr(e, t));
			e: for (;;) try {
				if (Ws !== 0 && Hs !== null) {
					t = Hs;
					var o = Gs;
					n: switch (Ws) {
						case 1:
						case 6:
							Ws = 0, Gs = null, Wr(e, t, o);
							break;
						case 2:
							if (_e(o)) {
								Ws = 0, Gs = null, Ur(t);
								break;
							}
							t = function() {
								Ws === 2 && Vs === e && (Ws = 7), re(e);
							}, o.then(t, t);
							break e;
						case 3:
							Ws = 7;
							break e;
						case 4:
							Ws = 5;
							break e;
						case 7:
							_e(o) ? (Ws = 0, Gs = null, Ur(t)) : (Ws = 0, Gs = null, Wr(e, t, o));
							break;
						case 5:
							var s = null;
							switch (Hs.tag) {
								case 26: s = Hs.memoizedState;
								case 5:
								case 27:
									var c = Hs, l = c.type, u = c.pendingProps;
									if (s ? Ra(s) : la(l, u)) {
										Ws = 0, Gs = null;
										var d = c.sibling;
										if (d !== null) Hs = d;
										else {
											var f = c.return;
											f === null ? Hs = null : (Hs = f, Gr(f));
										}
										break n;
									}
							}
							Ws = 0, Gs = null, Wr(e, t, o);
							break;
						case 8:
							Mr(), Ys = 6;
							break e;
						default: throw Error(r(462));
					}
				}
				Vr();
				break;
			} catch (t) {
				Pr(e, t);
			}
			return yn(), Ri.H = i, Ri.A = a, Bs = n, Hs === null ? (Vs = null, Us = 0, A(), Ys) : 0;
		}(e, t) : zr(e, t);
		if (i !== 0) for (var a = n;;) {
			if (i === 6) jr(e, t, 0);
			else {
				if (n = e.current.alternate, a && !Ar(n)) {
					i = zr(e, t), a = !1;
					continue;
				}
				if (i === 2) {
					if (a = t, e.errorRecoveryDisabledLanes & a) var o = 0;
					else o = (o = -536870913 & e.pendingLanes) == 0 ? 536870912 & o ? 536870912 : 0 : o;
					if (o !== 0) {
						t = o;
						e: {
							var s = e;
							i = tc;
							var c = ta;
							if (c && (Nr(s, o).flags |= 256), (o = zr(s, o)) !== 2) {
								if (qs && !c) {
									s.errorRecoveryDisabledLanes |= a, Zs |= a, i = 4;
									break e;
								}
								a = nc, nc = i, a !== null && Or(a);
							}
							i = o;
						}
						if (a = !1, i !== 2) continue;
					}
				}
				if (i === 1) {
					Nr(e, 0), jr(e, t, 0);
					break;
				}
				e: {
					switch (a = e, i) {
						case 0:
						case 1: throw Error(r(345));
						case 4:
							if ((4194176 & t) === t) {
								jr(a, t, $s);
								break e;
							}
							break;
						case 2:
							nc = null;
							break;
						case 3:
						case 5: break;
						default: throw Error(r(329));
					}
					if (a.finishedWork = n, a.finishedLanes = t, (62914560 & t) === t && 10 < (i = ic + 300 - $a())) {
						if (jr(a, t, $s), m(a, 0) !== 0) break e;
						a.timeoutHandle = Zi(kr.bind(null, a, n, nc, oc, rc, t, $s, Zs, ec, Ks, 2, -0, 0), i);
					} else kr(a, n, nc, oc, rc, t, $s, Zs, ec, Ks, 0, -0, 0);
				}
			}
			break;
		}
		re(e);
	}
	function Or(e) {
		nc === null ? nc = e : nc.push.apply(nc, e);
	}
	function kr(e, t, n, r, i, a, o, s, c, l, u, d, f) {
		if ((8192 & (l = t.subtreeFlags) || (16785408 & l) == 16785408) && (ua(), vr(t), (t = fa()) !== null)) return e.cancelPendingCommit = t(qr.bind(null, e, n, r, i, o, s, c, 1, d, f)), void jr(e, a, o);
		qr(e, n, r, i, o);
	}
	function Ar(e) {
		for (var t = e;;) {
			var n = t.tag;
			if ((n === 0 || n === 11 || n === 15) && 16384 & t.flags && (n = t.updateQueue) !== null && (n = n.stores) !== null) for (var r = 0; r < n.length; r++) {
				var i = n[r], a = i.getSnapshot;
				i = i.value;
				try {
					if (!so(a(), i)) return !1;
				} catch {
					return !1;
				}
			}
			if (n = t.child, 16384 & t.subtreeFlags && n !== null) n.return = t, t = n;
			else {
				if (t === e) break;
				for (; t.sibling === null;) {
					if (t.return === null || t.return === e) return !0;
					t = t.return;
				}
				t.sibling.return = t.return, t = t.sibling;
			}
		}
		return !0;
	}
	function jr(e, t, n) {
		t &= ~Qs, t &= ~Zs, e.suspendedLanes |= t, e.pingedLanes &= ~t;
		for (var r = e.expirationTimes, i = t; 0 < i;) {
			var a = 31 - Wa(i), o = 1 << a;
			r[a] = -1, i &= ~o;
		}
		n !== 0 && b(e, n, t);
	}
	function Mr() {
		if (Hs !== null) {
			if (Ws === 0) var e = Hs.return;
			else e = Hs, yn(), ze(e), Ho = null, Uo = 0, e = Hs;
			for (; e !== null;) Vn(e.alternate, e), e = e.return;
			Hs = null;
		}
	}
	function Nr(e, t) {
		e.finishedWork = null, e.finishedLanes = 0;
		var n = e.timeoutHandle;
		n !== $i && (e.timeoutHandle = $i, Qi(n)), (n = e.cancelPendingCommit) !== null && (e.cancelPendingCommit = null, n()), Mr(), Vs = e, Hs = n = ai(e.current, null), Us = t, Ws = 0, Gs = null, qs = Ks = !1, ec = $s = Qs = Zs = Xs = Ys = 0, nc = tc = null, rc = !1, 8 & t && (t |= 32 & t);
		var r = e.entangledLanes;
		if (r !== 0) for (e = e.entanglements, r &= t; 0 < r;) {
			var i = 31 - Wa(r), a = 1 << i;
			t |= e[i], r &= ~a;
		}
		return Js = t, A(), n;
	}
	function Pr(e, t) {
		Qo = null, Ri.H = ls, t === Ro ? (t = be(), Ws = Fr() && !(134217727 & Xs) && !(134217727 & Zs) ? 2 : 3) : t === zo ? (t = be(), Ws = 4) : Ws = t === ms ? 8 : typeof t == "object" && t && typeof t.then == "function" ? 6 : 1, Gs = t, Hs === null && (Ys = 1, Gt(e, w(t, e.current)));
	}
	function Fr() {
		var e = Jo.current;
		return e === null || ((4194176 & Us) === Us ? Yo === null : ((62914560 & Us) === Us || (536870912 & Us) != 0) && e === Yo);
	}
	function Ir() {
		var e = Ri.H;
		return Ri.H = ls, e === null ? ls : e;
	}
	function Lr() {
		var e = Ri.A;
		return Ri.A = Ls, e;
	}
	function Rr() {
		Ys = 4, !(134217727 & Xs) && !(134217727 & Zs) || Vs === null || jr(Vs, Us, $s);
	}
	function zr(e, t) {
		var n = Bs;
		Bs |= 2;
		var i = Ir(), a = Lr();
		Vs === e && Us === t || (oc = null, Nr(e, t)), t = !1;
		e: for (;;) try {
			if (Ws !== 0 && Hs !== null) {
				var o = Hs, s = Gs;
				switch (Ws) {
					case 8:
						Mr(), Ys = 6;
						break e;
					case 3:
					case 2: t || Jo.current !== null || (t = !0);
					default: Ws = 0, Gs = null, Wr(e, o, s);
				}
			}
			Br();
			break;
		} catch (t) {
			Pr(e, t);
		}
		if (t && e.shellSuspendCounter++, yn(), Bs = n, Ri.H = i, Ri.A = a, Hs !== null) throw Error(r(261));
		return Vs = null, Us = 0, A(), Ys;
	}
	function Br() {
		for (; Hs !== null;) Hr(Hs);
	}
	function Vr() {
		for (; Hs !== null && !Za();) Hr(Hs);
	}
	function Hr(e) {
		var t = vn(e.alternate, e, Js);
		e.memoizedProps = e.pendingProps, t === null ? Gr(e) : Hs = t;
	}
	function Ur(e) {
		var t = e, n = t.alternate;
		switch (t.tag) {
			case 15:
			case 0:
				t = an(n, t, t.pendingProps, t.type, void 0, Us);
				break;
			case 11:
				t = an(n, t, t.pendingProps, t.type.render, t.ref, Us);
				break;
			case 5: ze(t);
			default: Vn(n, t), t = vn(n, t = Hs = oi(t, Js), Js);
		}
		e.memoizedProps = e.pendingProps, t === null ? Gr(e) : Hs = t;
	}
	function Wr(e, t, n) {
		yn(), ze(t), Ho = null, Uo = 0;
		var i = t.return;
		try {
			if (function(e, t, n, i, a) {
				if (n.flags |= 32768, typeof i == "object" && i && typeof i.then == "function") {
					if ((t = n.alternate) !== null && wn(t, n, a, !0), (n = Jo.current) !== null) {
						switch (n.tag) {
							case 13: return Yo === null ? Rr() : n.alternate === null && Ys === 0 && (Ys = 3), n.flags &= -257, n.flags |= 65536, n.lanes = a, i === Bo ? n.flags |= 16384 : ((t = n.updateQueue) === null ? n.updateQueue = new Set([i]) : t.add(i), Qr(e, i, a)), !1;
							case 22: return n.flags |= 65536, i === Bo ? n.flags |= 16384 : ((t = n.updateQueue) === null ? (t = {
								transitions: null,
								markerInstances: null,
								retryQueue: new Set([i])
							}, n.updateQueue = t) : (n = t.retryQueue) === null ? t.retryQueue = new Set([i]) : n.add(i), Qr(e, i, a)), !1;
						}
						throw Error(r(435, n.tag));
					}
					return Qr(e, i, a), Rr(), !1;
				}
				var o = Error(r(520), { cause: i });
				if (o = w(o, n), tc === null ? tc = [o] : tc.push(o), Ys !== 4 && (Ys = 2), t === null) return !0;
				i = w(i, n), n = t;
				do {
					switch (n.tag) {
						case 3: return n.flags |= 65536, e = a & -a, n.lanes |= e, me(n, e = qt(n.stateNode, i, e)), !1;
						case 1: if (t = n.type, o = n.stateNode, !(128 & n.flags) && (typeof t.getDerivedStateFromError == "function" || o !== null && typeof o.componentDidCatch == "function" && (sc === null || !sc.has(o)))) return n.flags |= 65536, a &= -a, n.lanes |= a, Yt(a = Jt(a), e, n, i), me(n, a), !1;
					}
					n = n.return;
				} while (n !== null);
				return !1;
			}(e, i, t, n, Us)) return Ys = 1, Gt(e, w(n, e.current)), void (Hs = null);
		} catch (t) {
			if (i !== null) throw Hs = i, t;
			Ys = 1, Gt(e, w(n, e.current)), Hs = null;
			return;
		}
		32768 & t.flags ? Kr(t, !0) : Gr(t);
	}
	function Gr(e) {
		var t = e;
		do {
			if (32768 & t.flags) return void Kr(t, Ks);
			e = t.return;
			var n = zn(t.alternate, t, Js);
			if (n !== null) return void (Hs = n);
			if ((t = t.sibling) !== null) return void (Hs = t);
			Hs = t = e;
		} while (t !== null);
		Ys === 0 && (Ys = 5);
	}
	function Kr(e, t) {
		do {
			var n = Bn(e.alternate, e);
			if (n !== null) return n.flags &= 32767, void (Hs = n);
			if ((n = e.return) !== null && (n.flags |= 32768, n.subtreeFlags = 0, n.deletions = null), !t && (e = e.sibling) !== null) return void (Hs = e);
			Hs = e = n;
		} while (e !== null);
		Ys = 6, Hs = null;
	}
	function qr(e, t, n, i, a, o, s, c, l, u) {
		var d = Ri.T, f = ia();
		try {
			ra(2), Ri.T = null, function(e, t, n, i, a, o) {
				do
					Yr();
				while (lc !== null);
				if (6 & Bs) throw Error(r(327));
				var s = e.finishedWork;
				if (i = e.finishedLanes, s === null) return null;
				if (e.finishedWork = null, e.finishedLanes = 0, s === e.current) throw Error(r(177));
				e.callbackNode = null, e.callbackPriority = 0, e.cancelPendingCommit = null;
				var c = s.lanes | s.childLanes;
				if (function(e, t, n, r) {
					var i = e.pendingLanes;
					e.pendingLanes = n, e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0, e.expiredLanes &= n, e.entangledLanes &= n, e.errorRecoveryDisabledLanes &= n, e.shellSuspendCounter = 0, t = e.entanglements;
					var a = e.expirationTimes, o = e.hiddenUpdates;
					for (n = i & ~n; 0 < n;) {
						var s = 31 - Wa(n);
						i = 1 << s, t[s] = 0, a[s] = -1;
						var c = o[s];
						if (c !== null) for (o[s] = null, s = 0; s < c.length; s++) {
							var l = c[s];
							l !== null && (l.lane &= -536870913);
						}
						n &= ~i;
					}
					r !== 0 && b(e, r, 0);
				}(e, i, c |= wo, o), e === Vs && (Hs = Vs = null, Us = 0), !(10256 & s.subtreeFlags) && !(10256 & s.flags) || cc || (cc = !0, dc = c, fc = n, Ya(no, (function() {
					return Yr(), null;
				}))), n = (15990 & s.flags) != 0, 15990 & s.subtreeFlags || n) {
					n = Ri.T, Ri.T = null, o = ia(), ra(2);
					var l = Bs;
					Bs |= 4, function(e, t) {
						for (Wi(e.containerInfo), js = t; js !== null;) if (t = (e = js).child, 1028 & e.subtreeFlags && t !== null) t.return = e, js = t;
						else for (; js !== null;) {
							var n = (e = js).alternate;
							switch (t = e.flags, e.tag) {
								case 0:
								case 11:
								case 15:
								case 5:
								case 26:
								case 27:
								case 6:
								case 4:
								case 17: break;
								case 1:
									if (1024 & t && n !== null) {
										t = void 0;
										var i = e, a = n.memoizedProps;
										n = n.memoizedState;
										var o = i.stateNode;
										try {
											var s = Wt(i.type, a, (i.elementType, i.type));
											t = o.getSnapshotBeforeUpdate(s, n), o.__reactInternalSnapshotBeforeUpdate = t;
										} catch (e) {
											Zr(i, i.return, e);
										}
									}
									break;
								case 3:
									1024 & t && ea && Aa(e.stateNode.containerInfo);
									break;
								default: if (1024 & t) throw Error(r(163));
							}
							if ((t = e.sibling) !== null) {
								t.return = e.return, js = t;
								break;
							}
							js = e.return;
						}
						s = Ms, Ms = !1;
					}(e, s), ar(s, e), Gi(e.containerInfo), e.current = s, $n(e, s.alternate, s), Qa(), Bs = l, ra(o), Ri.T = n;
				} else e.current = s;
				if (cc ? (cc = !1, lc = e, uc = i) : Jr(e, c), (c = e.pendingLanes) === 0 && (sc = null), s.stateNode, re(e), t !== null) for (a = e.onRecoverableError, s = 0; s < t.length; s++) a((c = t[s]).value, { componentStack: c.stack });
				3 & uc && Yr(), c = e.pendingLanes, 4194218 & i && 42 & c ? e === mc ? pc++ : (pc = 0, mc = e) : pc = 0, ie(0);
			}(e, t, n, i, f, a);
		} finally {
			Ri.T = d, ra(f);
		}
	}
	function Jr(e, t) {
		(e.pooledCacheLanes &= t) == 0 && (t = e.pooledCache) != null && (e.pooledCache = null, jn(t));
	}
	function Yr() {
		if (lc !== null) {
			var e = lc, t = dc;
			dc = 0;
			var n = S(uc), i = 32 > n ? 32 : n;
			n = Ri.T;
			var a = ia();
			try {
				if (ra(i), Ri.T = null, lc === null) var o = !1;
				else {
					i = fc, fc = null;
					var s = lc, c = uc;
					if (lc = null, uc = 0, 6 & Bs) throw Error(r(331));
					var l = Bs;
					Bs |= 4, xr(s.current), mr(s, s.current, c, i), Bs = l, ie(0), oo && oo.onPostCommitFiberRoot, o = !0;
				}
				return o;
			} finally {
				ra(a), Ri.T = n, Jr(e, t);
			}
		}
		return !1;
	}
	function Xr(e, t, n) {
		t = w(n, t), (e = fe(e, t = qt(e.stateNode, t, 2), 2)) !== null && (y(e, 2), re(e));
	}
	function Zr(e, t, n) {
		if (e.tag === 3) Xr(e, e, n);
		else for (; t !== null;) {
			if (t.tag === 3) {
				Xr(t, e, n);
				break;
			}
			if (t.tag === 1) {
				var r = t.stateNode;
				if (typeof t.type.getDerivedStateFromError == "function" || typeof r.componentDidCatch == "function" && (sc === null || !sc.has(r))) {
					e = w(n, e), (r = fe(t, n = Jt(2), 2)) !== null && (Yt(n, r, t, e), y(r, 2), re(r));
					break;
				}
			}
			t = t.return;
		}
	}
	function Qr(e, t, n) {
		var r = e.pingCache;
		if (r === null) {
			r = e.pingCache = new zs();
			var i = /* @__PURE__ */ new Set();
			r.set(t, i);
		} else (i = r.get(t)) === void 0 && (i = /* @__PURE__ */ new Set(), r.set(t, i));
		i.has(n) || (qs = !0, i.add(n), e = $r.bind(null, e, t, n), t.then(e, e));
	}
	function $r(e, t, n) {
		var r = e.pingCache;
		r !== null && r.delete(t), e.pingedLanes |= e.suspendedLanes & n, e.warmLanes &= ~n, Vs === e && (Us & n) === n && (Ys === 4 || Ys === 3 && (62914560 & Us) === Us && 300 > $a() - ic ? !(2 & Bs) && Nr(e, 0) : Qs |= n, ec === Us && (ec = 0)), re(e);
	}
	function ei(e, t) {
		t === 0 && (t = _()), (e = ee(e, t)) !== null && (y(e, t), re(e));
	}
	function ti(e) {
		var t = e.memoizedState, n = 0;
		t !== null && (n = t.retryLane), ei(e, n);
	}
	function ni(e, t) {
		var n = 0;
		switch (e.tag) {
			case 13:
				var i = e.stateNode, a = e.memoizedState;
				a !== null && (n = a.retryLane);
				break;
			case 19:
				i = e.stateNode;
				break;
			case 22:
				i = e.stateNode._retryCache;
				break;
			default: throw Error(r(314));
		}
		i !== null && i.delete(t), ei(e, n);
	}
	function ri(e, t, n, r) {
		this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
	}
	function ii(e) {
		return !(!(e = e.prototype) || !e.isReactComponent);
	}
	function ai(e, t) {
		var r = e.alternate;
		return r === null ? ((r = n(e.tag, t, e.key, e.mode)).elementType = e.elementType, r.type = e.type, r.stateNode = e.stateNode, r.alternate = e, e.alternate = r) : (r.pendingProps = t, r.type = e.type, r.flags = 0, r.subtreeFlags = 0, r.deletions = null), r.flags = 31457280 & e.flags, r.childLanes = e.childLanes, r.lanes = e.lanes, r.child = e.child, r.memoizedProps = e.memoizedProps, r.memoizedState = e.memoizedState, r.updateQueue = e.updateQueue, t = e.dependencies, r.dependencies = t === null ? null : {
			lanes: t.lanes,
			firstContext: t.firstContext
		}, r.sibling = e.sibling, r.index = e.index, r.ref = e.ref, r.refCleanup = e.refCleanup, r;
	}
	function oi(e, t) {
		e.flags &= 31457282;
		var n = e.alternate;
		return n === null ? (e.childLanes = 0, e.lanes = t, e.child = null, e.subtreeFlags = 0, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null) : (e.childLanes = n.childLanes, e.lanes = n.lanes, e.child = n.child, e.subtreeFlags = 0, e.deletions = null, e.memoizedProps = n.memoizedProps, e.memoizedState = n.memoizedState, e.updateQueue = n.updateQueue, e.type = n.type, t = n.dependencies, e.dependencies = t === null ? null : {
			lanes: t.lanes,
			firstContext: t.firstContext
		}), e;
	}
	function si(e, t, i, a, o, s) {
		var c = 0;
		if (a = e, typeof e == "function") ii(e) && (c = 1);
		else if (typeof e == "string") c = 5;
		else e: switch (e) {
			case Ci: return ci(i.children, o, s, t);
			case wi:
				c = 8, o |= 24;
				break;
			case Ti: return (e = n(12, i, t, 2 | o)).elementType = Ti, e.lanes = s, e;
			case Ai: return (e = n(13, i, t, o)).elementType = Ai, e.lanes = s, e;
			case ji: return (e = n(19, i, t, o)).elementType = ji, e.lanes = s, e;
			case Pi: return li(i, o, s, t);
			default:
				if (typeof e == "object" && e) switch (e.$$typeof) {
					case Ei:
					case Oi:
						c = 10;
						break e;
					case Di:
						c = 9;
						break e;
					case ki:
						c = 11;
						break e;
					case Mi:
						c = 14;
						break e;
					case Ni:
						c = 16, a = null;
						break e;
				}
				c = 29, i = Error(r(130, e === null ? "null" : typeof e, "")), a = null;
		}
		return (t = n(c, i, t, o)).elementType = e, t.type = a, t.lanes = s, t;
	}
	function ci(e, t, r, i) {
		return (e = n(7, e, i, t)).lanes = r, e;
	}
	function li(e, t, i, a) {
		(e = n(22, e, a, t)).elementType = Pi, e.lanes = i;
		var o = {
			_visibility: 1,
			_pendingVisibility: 1,
			_pendingMarkers: null,
			_retryCache: null,
			_transitions: null,
			_current: null,
			detach: function() {
				var e = o._current;
				if (e === null) throw Error(r(456));
				if (!(2 & o._pendingVisibility)) {
					var t = ee(e, 2);
					t !== null && (o._pendingVisibility |= 2, Er(t, 0, 2));
				}
			},
			attach: function() {
				var e = o._current;
				if (e === null) throw Error(r(456));
				if (2 & o._pendingVisibility) {
					var t = ee(e, 2);
					t !== null && (o._pendingVisibility &= -3, Er(t, 0, 2));
				}
			}
		};
		return e.stateNode = o, e;
	}
	function ui(e, t, r) {
		return (e = n(6, e, null, t)).lanes = r, e;
	}
	function di(e, t, r) {
		return (t = n(4, e.children === null ? [] : e.children, e.key, t)).lanes = r, t.stateNode = {
			containerInfo: e.containerInfo,
			pendingChildren: null,
			implementation: e.implementation
		}, t;
	}
	function fi(e, t, n, r, i, a, o, s) {
		this.tag = 1, this.containerInfo = e, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = $i, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = v(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.finishedLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = v(0), this.hiddenUpdates = v(null), this.identifierPrefix = r, this.onUncaughtError = i, this.onCaughtError = a, this.onRecoverableError = o, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = s, this.incompleteTransitions = /* @__PURE__ */ new Map();
	}
	function pi(e, t, n, r, i, a) {
		i = function(e) {
			return e ? e = Ua : Ua;
		}(i), r.context === null ? r.context = i : r.pendingContext = i, (r = de(t)).payload = { element: n }, (a = a === void 0 ? null : a) !== null && (r.callback = a), (n = fe(e, r, t)) !== null && (Er(n, 0, t), pe(n, e, t));
	}
	var mi, hi, gi = {}, _i = t, vi = tae, yi = Object.assign, bi = Symbol.for("react.element"), xi = Symbol.for("react.transitional.element"), Si = Symbol.for("react.portal"), Ci = Symbol.for("react.fragment"), wi = Symbol.for("react.strict_mode"), Ti = Symbol.for("react.profiler"), Ei = Symbol.for("react.provider"), Di = Symbol.for("react.consumer"), Oi = Symbol.for("react.context"), ki = Symbol.for("react.forward_ref"), Ai = Symbol.for("react.suspense"), ji = Symbol.for("react.suspense_list"), Mi = Symbol.for("react.memo"), Ni = Symbol.for("react.lazy"), Pi = Symbol.for("react.offscreen"), Fi = Symbol.for("react.memo_cache_sentinel"), Ii = Symbol.iterator, Li = Symbol.for("react.client.reference"), Ri = _i.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, zi = !1, Bi = Array.isArray, Vi = e.getPublicInstance, Hi = e.getRootHostContext, Ui = e.getChildHostContext, Wi = e.prepareForCommit, Gi = e.resetAfterCommit, Ki = e.createInstance, qi = e.appendInitialChild, Ji = e.finalizeInitialChildren, Yi = e.shouldSetTextContent, Xi = e.createTextInstance, Zi = null, Qi = null, $i = e.noTimeout, ea = !0, ta = null, na = null, ra = e.setCurrentUpdatePriority, ia = e.getCurrentUpdatePriority, aa = e.resolveUpdatePriority, oa = e.shouldAttemptEagerTransition, sa = null;
	e.requestPostPaintCallback;
	var ca = e.maySuspendCommit, la = null, ua = null, da = null, fa = null, pa = null, ma = null, ha = null, ga = e.appendChild, _a = e.appendChildToContainer, va = e.commitTextUpdate, ya = null, ba = e.commitUpdate, xa = e.insertBefore, Sa = null, Ca = e.removeChild, wa = e.removeChildFromContainer, Ta = e.resetTextContent, Ea = null, Da = null, Oa = null, ka = null, Aa = e.clearContainer, ja = null, Ma = null, Na = null, Pa = null, Fa = null, Ia = null, La = null, Ra = null, za = null, Ba = null, Va = [], Ha = -1, Ua = {}, Wa = Math.clz32 ? Math.clz32 : function(e) {
		return (e >>>= 0) == 0 ? 32 : 31 - (Ga(e) / Ka | 0) | 0;
	}, Ga = Math.log, Ka = Math.LN2, qa = 128, Ja = 4194304, Ya = vi.unstable_scheduleCallback, Xa = vi.unstable_cancelCallback, Za = vi.unstable_shouldYield, Qa = vi.unstable_requestPaint, $a = vi.unstable_now, eo = vi.unstable_ImmediatePriority, to = vi.unstable_UserBlockingPriority, no = vi.unstable_NormalPriority, ro = vi.unstable_IdlePriority, io = vi.log, ao = vi.unstable_setDisableYieldValue, oo = null, so = typeof Object.is == "function" ? Object.is : function(e, t) {
		return e === t && (e !== 0 || 1 / e == 1 / t) || e != e && t != t;
	}, co = /* @__PURE__ */ new WeakMap(), lo = [], uo = 0, fo = null, po = [], mo = 0, ho = null, go = u(null), _o = u(null), vo = u(null), yo = u(null), bo = !1, xo = null;
	Error(r(519));
	var So = [], Co = 0, wo = 0, To = null, Eo = null, Do = !1, Oo = !1, ko = !1, Ao = 0, jo = null, Mo = 0, No = 0, Po = null, Fo = !1, Io = !1, Lo = Object.prototype.hasOwnProperty, Ro = Error(r(460)), zo = Error(r(474)), Bo = { then: function() {} }, Vo = null, Ho = null, Uo = 0, Wo = Se(!0), Go = Se(!1), Ko = u(null), qo = u(0), Jo = u(null), Yo = null, Xo = u(0), Zo = 0, Qo = null, $o = null, es = null, ts = !1, ns = !1, rs = !1, is = 0, as = 0, os = null, ss = 0, cs = function() {
		return {
			lastEffect: null,
			events: null,
			stores: null,
			memoCache: null
		};
	}, ls = {
		readContext: Dn,
		use: Ue,
		useCallback: je,
		useContext: je,
		useEffect: je,
		useImperativeHandle: je,
		useLayoutEffect: je,
		useInsertionEffect: je,
		useMemo: je,
		useReducer: je,
		useRef: je,
		useState: je,
		useDebugValue: je,
		useDeferredValue: je,
		useTransition: je,
		useSyncExternalStore: je,
		useId: je
	};
	ls.useCacheRefresh = je, ls.useMemoCache = je, ls.useHostTransitionStatus = je, ls.useFormState = je, ls.useActionState = je, ls.useOptimistic = je;
	var us = {
		readContext: Dn,
		use: Ue,
		useCallback: function(e, t) {
			return Be().memoizedState = [e, t === void 0 ? null : t], e;
		},
		useContext: Dn,
		useEffect: V,
		useImperativeHandle: function(e, t, n) {
			n = n == null ? null : n.concat([e]), _t(4194308, 4, St.bind(null, t, e), n);
		},
		useLayoutEffect: function(e, t) {
			return _t(4194308, 4, e, t);
		},
		useInsertionEffect: function(e, t) {
			_t(4, 2, e, t);
		},
		useMemo: function(e, t) {
			var n = Be();
			t = t === void 0 ? null : t;
			var r = e();
			if (rs) {
				C(!0);
				try {
					e();
				} finally {
					C(!1);
				}
			}
			return n.memoizedState = [r, t], r;
		},
		useReducer: function(e, t, n) {
			var r = Be();
			if (n !== void 0) {
				var i = n(t);
				if (rs) {
					C(!0);
					try {
						n(t);
					} finally {
						C(!1);
					}
				}
			} else i = t;
			return r.memoizedState = r.baseState = i, e = {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: e,
				lastRenderedState: i
			}, r.queue = e, e = e.dispatch = Pt.bind(null, Qo, e), [r.memoizedState, e];
		},
		useRef: function(e) {
			return e = { current: e }, Be().memoizedState = e;
		},
		useState: function(e) {
			var t = (e = tt(e)).queue, n = Ft.bind(null, Qo, t);
			return t.dispatch = n, [e.memoizedState, n];
		},
		useDebugValue: wt,
		useDeferredValue: function(e, t) {
			return Dt(Be(), e, t);
		},
		useTransition: function() {
			var e = tt(!1);
			return e = kt.bind(null, Qo, e.queue, !0, !1), Be().memoizedState = e, [!1, e];
		},
		useSyncExternalStore: function(e, t, n) {
			var i = Qo, a = Be();
			if (n = t(), Vs === null) throw Error(r(349));
			60 & Us || Xe(i, t, n), a.memoizedState = n;
			var o = {
				value: n,
				getSnapshot: t
			};
			return a.queue = o, V(Qe.bind(null, i, o, e), [e]), i.flags |= 2048, ht(9, Ze.bind(null, i, o, n, t), { destroy: void 0 }, null), n;
		},
		useId: function() {
			var e = Be(), t = Vs.identifierPrefix;
			return t = ":" + t + "r" + (ss++).toString(32) + ":", e.memoizedState = t;
		},
		useCacheRefresh: function() {
			return Be().memoizedState = Nt.bind(null, Qo);
		}
	};
	us.useMemoCache = We, us.useHostTransitionStatus = At, us.useFormState = ut, us.useActionState = ut, us.useOptimistic = function(e) {
		var t = Be();
		t.memoizedState = t.baseState = e;
		var n = {
			pending: null,
			lanes: 0,
			dispatch: null,
			lastRenderedReducer: null,
			lastRenderedState: null
		};
		return t.queue = n, t = Lt.bind(null, Qo, !0, n), n.dispatch = t, [e, t];
	};
	var ds = {
		readContext: Dn,
		use: Ue,
		useCallback: Tt,
		useContext: Dn,
		useEffect: yt,
		useImperativeHandle: Ct,
		useInsertionEffect: bt,
		useLayoutEffect: xt,
		useMemo: Et,
		useReducer: Ke,
		useRef: gt,
		useState: function() {
			return Ke(Ge);
		},
		useDebugValue: wt,
		useDeferredValue: function(e, t) {
			return Ot(Ve(), $o.memoizedState, e, t);
		},
		useTransition: function() {
			var e = Ke(Ge)[0], t = Ve().memoizedState;
			return [typeof e == "boolean" ? e : He(e), t];
		},
		useSyncExternalStore: Ye,
		useId: jt
	};
	ds.useCacheRefresh = Mt, ds.useMemoCache = We, ds.useHostTransitionStatus = At, ds.useFormState = dt, ds.useActionState = dt, ds.useOptimistic = function(e, t) {
		return nt(Ve(), 0, e, t);
	};
	var fs = {
		readContext: Dn,
		use: Ue,
		useCallback: Tt,
		useContext: Dn,
		useEffect: yt,
		useImperativeHandle: Ct,
		useInsertionEffect: bt,
		useLayoutEffect: xt,
		useMemo: Et,
		useReducer: Je,
		useRef: gt,
		useState: function() {
			return Je(Ge);
		},
		useDebugValue: wt,
		useDeferredValue: function(e, t) {
			var n = Ve();
			return $o === null ? Dt(n, e, t) : Ot(n, $o.memoizedState, e, t);
		},
		useTransition: function() {
			var e = Je(Ge)[0], t = Ve().memoizedState;
			return [typeof e == "boolean" ? e : He(e), t];
		},
		useSyncExternalStore: Ye,
		useId: jt
	};
	fs.useCacheRefresh = Mt, fs.useMemoCache = We, fs.useHostTransitionStatus = At, fs.useFormState = mt, fs.useActionState = mt, fs.useOptimistic = function(e, t) {
		var n = Ve();
		return $o === null ? (n.baseState = e, [e, n.queue.dispatch]) : nt(n, 0, e, t);
	};
	var ps = {
		isMounted: function(e) {
			return !!(e = e._reactInternals) && function(e) {
				var t = e, n = e;
				if (e.alternate) for (; t.return;) t = t.return;
				else {
					e = t;
					do
						4098 & (t = e).flags && (n = t.return), e = t.return;
					while (e);
				}
				return t.tag === 3 ? n : null;
			}(e) === e;
		},
		enqueueSetState: function(e, t, n) {
			e = e._reactInternals;
			var r = wr(), i = de(r);
			i.payload = t, n != null && (i.callback = n), (t = fe(e, i, r)) !== null && (Er(t, 0, r), pe(t, e, r));
		},
		enqueueReplaceState: function(e, t, n) {
			e = e._reactInternals;
			var r = wr(), i = de(r);
			i.tag = 1, i.payload = t, n != null && (i.callback = n), (t = fe(e, i, r)) !== null && (Er(t, 0, r), pe(t, e, r));
		},
		enqueueForceUpdate: function(e, t) {
			e = e._reactInternals;
			var n = wr(), r = de(n);
			r.tag = 2, t != null && (r.callback = t), (t = fe(e, r, n)) !== null && (Er(t, 0, n), pe(t, e, n));
		}
	}, ms = Error(r(461)), hs = !1, gs = {
		dehydrated: null,
		treeContext: null,
		retryLane: 0
	}, _s = u(null), vs = null, ys = null, bs = null, xs = typeof AbortController < "u" ? AbortController : function() {
		var e = [], t = this.signal = {
			aborted: !1,
			addEventListener: function(t, n) {
				e.push(n);
			}
		};
		this.abort = function() {
			t.aborted = !0, e.forEach((function(e) {
				return e();
			}));
		};
	}, Ss = vi.unstable_scheduleCallback, Cs = vi.unstable_NormalPriority, ws = {
		$$typeof: Oi,
		Consumer: null,
		Provider: null,
		_currentValue: null,
		_currentValue2: null,
		_threadCount: 0
	}, Ts = Ri.S;
	Ri.S = function(e, t) {
		typeof t == "object" && t && typeof t.then == "function" && function(e, t) {
			if (jo === null) {
				var n = jo = [];
				Mo = 0, No = le(), Po = {
					status: "pending",
					value: void 0,
					then: function(e) {
						n.push(e);
					}
				};
			}
			Mo++, t.then(N, N);
		}(0, t), Ts !== null && Ts(e, t);
	};
	var Es = u(null), Ds = !1, Os = !1, ks = !1, As = typeof WeakSet == "function" ? WeakSet : Set, js = null, Ms = !1, Ns = null, Ps = !1, Fs = null, Is = 8192, Ls = { getCacheForType: function(e) {
		var t = Dn(ws), n = t.data.get(e);
		return n === void 0 && (n = e(), t.data.set(e, n)), n;
	} };
	if (typeof Symbol == "function" && Symbol.for) {
		var Rs = Symbol.for;
		Rs("selector.component"), Rs("selector.has_pseudo_class"), Rs("selector.role"), Rs("selector.test_id"), Rs("selector.text");
	}
	var zs = typeof WeakMap == "function" ? WeakMap : Map, Bs = 0, Vs = null, Hs = null, Us = 0, Ws = 0, Gs = null, Ks = !1, qs = !1, Js = 0, Ys = 0, Xs = 0, Zs = 0, Qs = 0, $s = 0, ec = 0, tc = null, nc = null, rc = !1, ic = 0, ac = Infinity, oc = null, sc = null, cc = !1, lc = null, uc = 0, dc = 0, fc = null, pc = 0, mc = null;
	return gi.createContainer = function(e, t, r, i, a, o, s, c, l, u) {
		return function(e, t, r, i, a, o, s, c, l, u, d, f) {
			return e = new fi(e, t, r, s, c, l, u, null), t = 1, !0 === o && (t |= 24), o = n(3, null, null, t), e.current = o, o.stateNode = e, (t = An()).refCount++, e.pooledCache = t, t.refCount++, o.memoizedState = {
				element: i,
				isDehydrated: r,
				cache: t
			}, P(o), e;
		}(e, t, !1, null, 0, i, o, s, c, l);
	}, gi.flushSyncWork = function() {
		return (6 & Bs) != 0 || (ie(0), !1);
	}, gi.updateContainer = function(e, t, n, r) {
		var i = t.current, a = wr();
		return pi(i, a, e, t, n, r), a;
	}, gi.updateContainerSync = function(e, t, n, r) {
		return t.tag === 0 && Yr(), pi(t.current, 2, e, t, n, r), 2;
	}, gi;
}, O8.exports.default = O8.exports, Object.defineProperty(O8.exports, "__esModule", { value: !0 })), D8.exports);
var k8;
$ie(E8.exports);
var A8 = { exports: {} }, j8 = {};
A8.exports = (k8 || (k8 = 1, j8.ConcurrentRoot = 1, j8.ContinuousEventPriority = 8, j8.DefaultEventPriority = 32, j8.DiscreteEventPriority = 2, j8.IdleEventPriority = 268435456, j8.LegacyRoot = 0, j8.NoEventPriority = 0), j8), A8.exports;
var nae = (e, t) => {
	let n = Object.keys(e), r = Object.keys(t);
	if (n.length !== r.length) return !1;
	for (let r = 0; r < n.length; r += 1) {
		let i = n[r];
		if (i === "render" && !e[i] != !t[i]) return !1;
		if (i !== "children" && e[i] !== t[i]) {
			if (typeof e[i] == "object" && typeof t[i] == "object" && nae(e[i], t[i])) continue;
			return !1;
		}
		if (i === "children" && (typeof e[i] == "string" || typeof t[i] == "string")) return e[i] === t[i];
	}
	return !0;
}, rae = /* @__PURE__ */ xt((/* @__PURE__ */ V(((e, t) => {
	var n = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
	function a(e) {
		if (e == null) throw TypeError("Object.assign cannot be called with null or undefined");
		return Object(e);
	}
	function o() {
		try {
			if (!Object.assign) return !1;
			var e = /* @__PURE__ */ new String("abc");
			if (e[5] = "de", Object.getOwnPropertyNames(e)[0] === "5") return !1;
			for (var t = {}, n = 0; n < 10; n++) t["_" + String.fromCharCode(n)] = n;
			if (Object.getOwnPropertyNames(t).map(function(e) {
				return t[e];
			}).join("") !== "0123456789") return !1;
			var r = {};
			return "abcdefghijklmnopqrst".split("").forEach(function(e) {
				r[e] = e;
			}), Object.keys(Object.assign({}, r)).join("") === "abcdefghijklmnopqrst";
		} catch {
			return !1;
		}
	}
	t.exports = o() ? Object.assign : function(e, t) {
		for (var o, s = a(e), c, l = 1; l < arguments.length; l++) {
			for (var u in o = Object(arguments[l]), o) r.call(o, u) && (s[u] = o[u]);
			if (n) {
				c = n(o);
				for (var d = 0; d < c.length; d++) i.call(o, c[d]) && (s[c[d]] = o[c[d]]);
			}
		}
		return s;
	};
})))(), 1);
function iae(e) {
	return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function aae(e) {
	if (e.__esModule) return e;
	var t = e.default;
	if (typeof t == "function") {
		var n = function e() {
			return this instanceof e ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
		};
		n.prototype = t.prototype;
	} else n = {};
	return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach((function(t) {
		var r = Object.getOwnPropertyDescriptor(e, t);
		Object.defineProperty(n, t, r.get ? r : {
			enumerable: !0,
			get: function() {
				return e[t];
			}
		});
	})), n;
}
var M8, N8 = { exports: {} }, oae = aae(w8);
(M8 = N8).exports = function e(n) {
	var r = rae.default, i = t, a = oae;
	function o(e) {
		for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
		return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
	}
	var s = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
	s.hasOwnProperty("ReactCurrentDispatcher") || (s.ReactCurrentDispatcher = { current: null }), s.hasOwnProperty("ReactCurrentBatchConfig") || (s.ReactCurrentBatchConfig = { suspense: null });
	var c = typeof Symbol == "function" && Symbol.for, l = c ? Symbol.for("react.element") : 60103, u = c ? Symbol.for("react.portal") : 60106, d = c ? Symbol.for("react.fragment") : 60107, f = c ? Symbol.for("react.strict_mode") : 60108, p = c ? Symbol.for("react.profiler") : 60114, m = c ? Symbol.for("react.provider") : 60109, h = c ? Symbol.for("react.context") : 60110, g = c ? Symbol.for("react.concurrent_mode") : 60111, _ = c ? Symbol.for("react.forward_ref") : 60112, v = c ? Symbol.for("react.suspense") : 60113, y = c ? Symbol.for("react.suspense_list") : 60120, b = c ? Symbol.for("react.memo") : 60115, x = c ? Symbol.for("react.lazy") : 60116, S = typeof Symbol == "function" && Symbol.iterator;
	function C(e) {
		return typeof e != "object" || !e ? null : typeof (e = S && e[S] || e["@@iterator"]) == "function" ? e : null;
	}
	function w(e) {
		if (e == null) return null;
		if (typeof e == "function") return e.displayName || e.name || null;
		if (typeof e == "string") return e;
		switch (e) {
			case d: return "Fragment";
			case u: return "Portal";
			case p: return "Profiler";
			case f: return "StrictMode";
			case v: return "Suspense";
			case y: return "SuspenseList";
		}
		if (typeof e == "object") switch (e.$$typeof) {
			case h: return "Context.Consumer";
			case m: return "Context.Provider";
			case _:
				var t = e.render;
				return t = t.displayName || t.name || "", e.displayName || (t === "" ? "ForwardRef" : "ForwardRef(" + t + ")");
			case b: return w(e.type);
			case x: if (e = e._status === 1 ? e._result : null) return w(e);
		}
		return null;
	}
	function T(e) {
		var t = e, n = e;
		if (e.alternate) for (; t.return;) t = t.return;
		else {
			e = t;
			do
				1026 & (t = e).effectTag && (n = t.return), e = t.return;
			while (e);
		}
		return t.tag === 3 ? n : null;
	}
	function E(e) {
		if (T(e) !== e) throw Error(o(188));
	}
	function D(e) {
		var t = e.alternate;
		if (!t) {
			if ((t = T(e)) === null) throw Error(o(188));
			return t === e ? e : null;
		}
		for (var n = e, r = t;;) {
			var i = n.return;
			if (i === null) break;
			var a = i.alternate;
			if (a === null) {
				if ((r = i.return) !== null) {
					n = r;
					continue;
				}
				break;
			}
			if (i.child === a.child) {
				for (a = i.child; a;) {
					if (a === n) return E(i), e;
					if (a === r) return E(i), t;
					a = a.sibling;
				}
				throw Error(o(188));
			}
			if (n.return !== r.return) n = i, r = a;
			else {
				for (var s = !1, c = i.child; c;) {
					if (c === n) {
						s = !0, n = i, r = a;
						break;
					}
					if (c === r) {
						s = !0, r = i, n = a;
						break;
					}
					c = c.sibling;
				}
				if (!s) {
					for (c = a.child; c;) {
						if (c === n) {
							s = !0, n = a, r = i;
							break;
						}
						if (c === r) {
							s = !0, r = a, n = i;
							break;
						}
						c = c.sibling;
					}
					if (!s) throw Error(o(189));
				}
			}
			if (n.alternate !== r) throw Error(o(190));
		}
		if (n.tag !== 3) throw Error(o(188));
		return n.stateNode.current === n ? e : t;
	}
	function O(e) {
		if (!(e = D(e))) return null;
		for (var t = e;;) {
			if (t.tag === 5 || t.tag === 6) return t;
			if (t.child) t.child.return = t, t = t.child;
			else {
				if (t === e) break;
				for (; !t.sibling;) {
					if (!t.return || t.return === e) return null;
					t = t.return;
				}
				t.sibling.return = t.return, t = t.sibling;
			}
		}
		return null;
	}
	var k = n.getPublicInstance, A = n.getRootHostContext, j = n.getChildHostContext, M = n.prepareForCommit, ee = n.resetAfterCommit, te = n.createInstance, ne = n.appendInitialChild, re = n.finalizeInitialChildren, ie = n.prepareUpdate, ae = n.shouldSetTextContent, oe = n.createTextInstance, se = null, ce = null, le = n.noTimeout, N = !0, P = null, ue = n.appendChild, de = n.appendChildToContainer, fe = n.commitTextUpdate, pe = null, me = n.commitUpdate, F = n.insertBefore, I = null, he = n.removeChild, L = n.removeChildFromContainer, ge = n.resetTextContent, _e = null, ve = null, ye = null, be = null, R = null, xe = null, z = /^(.*)[\\\/]/;
	function B(e) {
		var t = "";
		do {
			e: switch (e.tag) {
				case 3:
				case 4:
				case 6:
				case 7:
				case 10:
				case 9:
					var n = "";
					break e;
				default:
					var r = e._debugOwner, i = e._debugSource, a = w(e.type);
					n = null, r && (n = w(r.type)), r = a, a = "", i ? a = " (at " + i.fileName.replace(z, "") + ":" + i.lineNumber + ")" : n && (a = " (created by " + n + ")"), n = "\n    in " + (r || "Unknown") + a;
			}
			t += n, e = e.return;
		} while (e);
		return t;
	}
	var Se = [], Ce = -1;
	function we(e) {
		0 > Ce || (e.current = Se[Ce], Se[Ce] = null, Ce--);
	}
	function Te(e, t) {
		Ce++, Se[Ce] = e.current, e.current = t;
	}
	var Ee = {}, De = { current: Ee }, Oe = { current: !1 }, ke = Ee;
	function Ae(e, t) {
		var n = e.type.contextTypes;
		if (!n) return Ee;
		var r = e.stateNode;
		if (r && r.__reactInternalMemoizedUnmaskedChildContext === t) return r.__reactInternalMemoizedMaskedChildContext;
		var i, a = {};
		for (i in n) a[i] = t[i];
		return r && ((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = t, e.__reactInternalMemoizedMaskedChildContext = a), a;
	}
	function je(e) {
		return (e = e.childContextTypes) != null;
	}
	function Me(e) {
		we(Oe), we(De);
	}
	function Ne(e) {
		we(Oe), we(De);
	}
	function Pe(e, t, n) {
		if (De.current !== Ee) throw Error(o(168));
		Te(De, t), Te(Oe, n);
	}
	function Fe(e, t, n) {
		var i = e.stateNode;
		if (e = t.childContextTypes, typeof i.getChildContext != "function") return n;
		for (var a in i = i.getChildContext()) if (!(a in e)) throw Error(o(108, w(t) || "Unknown", a));
		return r({}, n, {}, i);
	}
	function Ie(e) {
		var t = e.stateNode;
		return t = t && t.__reactInternalMemoizedMergedChildContext || Ee, ke = De.current, Te(De, t), Te(Oe, Oe.current), !0;
	}
	function Le(e, t, n) {
		var r = e.stateNode;
		if (!r) throw Error(o(169));
		n ? (t = Fe(e, t, ke), r.__reactInternalMemoizedMergedChildContext = t, we(Oe), we(De), Te(De, t)) : we(Oe), Te(Oe, n);
	}
	var Re = a.unstable_runWithPriority, ze = a.unstable_scheduleCallback, Be = a.unstable_cancelCallback, Ve = a.unstable_shouldYield, He = a.unstable_requestPaint, Ue = a.unstable_now, We = a.unstable_getCurrentPriorityLevel, Ge = a.unstable_ImmediatePriority, Ke = a.unstable_UserBlockingPriority, qe = a.unstable_NormalPriority, Je = a.unstable_LowPriority, Ye = a.unstable_IdlePriority, Xe = {}, Ze = He === void 0 ? function() {} : He, Qe = null, $e = null, et = !1, tt = Ue(), nt = 1e4 > tt ? Ue : function() {
		return Ue() - tt;
	};
	function rt() {
		switch (We()) {
			case Ge: return 99;
			case Ke: return 98;
			case qe: return 97;
			case Je: return 96;
			case Ye: return 95;
			default: throw Error(o(332));
		}
	}
	function it(e) {
		switch (e) {
			case 99: return Ge;
			case 98: return Ke;
			case 97: return qe;
			case 96: return Je;
			case 95: return Ye;
			default: throw Error(o(332));
		}
	}
	function at(e, t) {
		return e = it(e), Re(e, t);
	}
	function ot(e, t, n) {
		return e = it(e), ze(e, t, n);
	}
	function st(e) {
		return Qe === null ? (Qe = [e], $e = ze(Ge, lt)) : Qe.push(e), Xe;
	}
	function ct() {
		if ($e !== null) {
			var e = $e;
			$e = null, Be(e);
		}
		lt();
	}
	function lt() {
		if (!et && Qe !== null) {
			et = !0;
			var e = 0;
			try {
				var t = Qe;
				at(99, (function() {
					for (; e < t.length; e++) {
						var n = t[e];
						do
							n = n(!0);
						while (n !== null);
					}
				})), Qe = null;
			} catch (t) {
				throw Qe !== null && (Qe = Qe.slice(e + 1)), ze(Ge, ct), t;
			} finally {
				et = !1;
			}
		}
	}
	var ut = 3;
	function dt(e, t, n) {
		return 1073741821 - (1 + ((1073741821 - e + t / 10) / (n /= 10) | 0)) * n;
	}
	var ft = typeof Object.is == "function" ? Object.is : function(e, t) {
		return e === t && (e !== 0 || 1 / e == 1 / t) || e != e && t != t;
	}, pt = Object.prototype.hasOwnProperty;
	function mt(e, t) {
		if (ft(e, t)) return !0;
		if (typeof e != "object" || !e || typeof t != "object" || !t) return !1;
		var n = Object.keys(e), r = Object.keys(t);
		if (n.length !== r.length) return !1;
		for (r = 0; r < n.length; r++) if (!pt.call(t, n[r]) || !ft(e[n[r]], t[n[r]])) return !1;
		return !0;
	}
	function ht(e, t) {
		if (e && e.defaultProps) for (var n in t = r({}, t), e = e.defaultProps) t[n] === void 0 && (t[n] = e[n]);
		return t;
	}
	var gt = { current: null }, _t = null, vt = null, V = null;
	function yt() {
		V = vt = _t = null;
	}
	function bt(e, t) {
		var n = e.type._context;
		Te(gt, n._currentValue2), n._currentValue2 = t;
	}
	function xt(e) {
		var t = gt.current;
		we(gt), (e = e.type._context)._currentValue2 = t;
	}
	function St(e, t) {
		for (; e !== null;) {
			var n = e.alternate;
			if (e.childExpirationTime < t) e.childExpirationTime = t, n !== null && n.childExpirationTime < t && (n.childExpirationTime = t);
			else {
				if (!(n !== null && n.childExpirationTime < t)) break;
				n.childExpirationTime = t;
			}
			e = e.return;
		}
	}
	function Ct(e, t) {
		_t = e, V = vt = null, (e = e.dependencies) !== null && e.firstContext !== null && (e.expirationTime >= t && (Yn = !0), e.firstContext = null);
	}
	function wt(e, t) {
		if (V !== e && !1 !== t && t !== 0) if (typeof t == "number" && t !== 1073741823 || (V = e, t = 1073741823), t = {
			context: e,
			observedBits: t,
			next: null
		}, vt === null) {
			if (_t === null) throw Error(o(308));
			vt = t, _t.dependencies = {
				expirationTime: 0,
				firstContext: t,
				responders: null
			};
		} else vt = vt.next = t;
		return e._currentValue2;
	}
	var Tt = !1;
	function Et(e) {
		return {
			baseState: e,
			firstUpdate: null,
			lastUpdate: null,
			firstCapturedUpdate: null,
			lastCapturedUpdate: null,
			firstEffect: null,
			lastEffect: null,
			firstCapturedEffect: null,
			lastCapturedEffect: null
		};
	}
	function Dt(e) {
		return {
			baseState: e.baseState,
			firstUpdate: e.firstUpdate,
			lastUpdate: e.lastUpdate,
			firstCapturedUpdate: null,
			lastCapturedUpdate: null,
			firstEffect: null,
			lastEffect: null,
			firstCapturedEffect: null,
			lastCapturedEffect: null
		};
	}
	function Ot(e, t) {
		return {
			expirationTime: e,
			suspenseConfig: t,
			tag: 0,
			payload: null,
			callback: null,
			next: null,
			nextEffect: null
		};
	}
	function kt(e, t) {
		e.lastUpdate === null ? e.firstUpdate = e.lastUpdate = t : (e.lastUpdate.next = t, e.lastUpdate = t);
	}
	function At(e, t) {
		var n = e.alternate;
		if (n === null) {
			var r = e.updateQueue, i = null;
			r === null && (r = e.updateQueue = Et(e.memoizedState));
		} else r = e.updateQueue, i = n.updateQueue, r === null ? i === null ? (r = e.updateQueue = Et(e.memoizedState), i = n.updateQueue = Et(n.memoizedState)) : r = e.updateQueue = Dt(i) : i === null && (i = n.updateQueue = Dt(r));
		i === null || r === i ? kt(r, t) : r.lastUpdate === null || i.lastUpdate === null ? (kt(r, t), kt(i, t)) : (kt(r, t), i.lastUpdate = t);
	}
	function jt(e, t) {
		var n = e.updateQueue;
		(n = n === null ? e.updateQueue = Et(e.memoizedState) : Mt(e, n)).lastCapturedUpdate === null ? n.firstCapturedUpdate = n.lastCapturedUpdate = t : (n.lastCapturedUpdate.next = t, n.lastCapturedUpdate = t);
	}
	function Mt(e, t) {
		var n = e.alternate;
		return n !== null && t === n.updateQueue && (t = e.updateQueue = Dt(t)), t;
	}
	function Nt(e, t, n, i, a, o) {
		switch (n.tag) {
			case 1: return typeof (e = n.payload) == "function" ? e.call(o, i, a) : e;
			case 3: e.effectTag = -4097 & e.effectTag | 64;
			case 0:
				if ((a = typeof (e = n.payload) == "function" ? e.call(o, i, a) : e) == null) break;
				return r({}, i, a);
			case 2: Tt = !0;
		}
		return i;
	}
	function Pt(e, t, n, r, i) {
		Tt = !1;
		for (var a = (t = Mt(e, t)).baseState, o = null, s = 0, c = t.firstUpdate, l = a; c !== null;) {
			var u = c.expirationTime;
			u < i ? (o === null && (o = c, a = l), s < u && (s = u)) : (ji(u, c.suspenseConfig), l = Nt(e, 0, c, l, n, r), c.callback !== null && (e.effectTag |= 32, c.nextEffect = null, t.lastEffect === null ? t.firstEffect = t.lastEffect = c : (t.lastEffect.nextEffect = c, t.lastEffect = c))), c = c.next;
		}
		for (u = null, c = t.firstCapturedUpdate; c !== null;) {
			var d = c.expirationTime;
			d < i ? (u === null && (u = c, o === null && (a = l)), s < d && (s = d)) : (l = Nt(e, 0, c, l, n, r), c.callback !== null && (e.effectTag |= 32, c.nextEffect = null, t.lastCapturedEffect === null ? t.firstCapturedEffect = t.lastCapturedEffect = c : (t.lastCapturedEffect.nextEffect = c, t.lastCapturedEffect = c))), c = c.next;
		}
		o === null && (t.lastUpdate = null), u === null ? t.lastCapturedUpdate = null : e.effectTag |= 32, o === null && u === null && (a = l), t.baseState = a, t.firstUpdate = o, t.firstCapturedUpdate = u, Mi(s), e.expirationTime = s, e.memoizedState = l;
	}
	function Ft(e, t, n) {
		t.firstCapturedUpdate !== null && (t.lastUpdate !== null && (t.lastUpdate.next = t.firstCapturedUpdate, t.lastUpdate = t.lastCapturedUpdate), t.firstCapturedUpdate = t.lastCapturedUpdate = null), It(t.firstEffect, n), t.firstEffect = t.lastEffect = null, It(t.firstCapturedEffect, n), t.firstCapturedEffect = t.lastCapturedEffect = null;
	}
	function It(e, t) {
		for (; e !== null;) {
			var n = e.callback;
			if (n !== null) {
				e.callback = null;
				var r = t;
				if (typeof n != "function") throw Error(o(191, n));
				n.call(r);
			}
			e = e.nextEffect;
		}
	}
	var Lt = s.ReactCurrentBatchConfig, Rt = new i.Component().refs;
	function zt(e, t, n, i) {
		n = (n = n(i, t = e.memoizedState)) == null ? t : r({}, t, n), e.memoizedState = n, (i = e.updateQueue) !== null && e.expirationTime === 0 && (i.baseState = n);
	}
	var Bt = {
		isMounted: function(e) {
			return !!(e = e._reactInternalFiber) && T(e) === e;
		},
		enqueueSetState: function(e, t, n) {
			e = e._reactInternalFiber;
			var r = yi(), i = Lt.suspense;
			(i = Ot(r = bi(r, e, i), i)).payload = t, n != null && (i.callback = n), At(e, i), xi(e, r);
		},
		enqueueReplaceState: function(e, t, n) {
			e = e._reactInternalFiber;
			var r = yi(), i = Lt.suspense;
			(i = Ot(r = bi(r, e, i), i)).tag = 1, i.payload = t, n != null && (i.callback = n), At(e, i), xi(e, r);
		},
		enqueueForceUpdate: function(e, t) {
			e = e._reactInternalFiber;
			var n = yi(), r = Lt.suspense;
			(r = Ot(n = bi(n, e, r), r)).tag = 2, t != null && (r.callback = t), At(e, r), xi(e, n);
		}
	};
	function Vt(e, t, n, r, i, a, o) {
		return typeof (e = e.stateNode).shouldComponentUpdate == "function" ? e.shouldComponentUpdate(r, a, o) : !(t.prototype && t.prototype.isPureReactComponent && mt(n, r) && mt(i, a));
	}
	function Ht(e, t, n) {
		var r = !1, i = Ee, a = t.contextType;
		return typeof a == "object" && a ? a = wt(a) : (i = je(t) ? ke : De.current, a = (r = (r = t.contextTypes) != null) ? Ae(e, i) : Ee), t = new t(n, a), e.memoizedState = t.state !== null && t.state !== void 0 ? t.state : null, t.updater = Bt, e.stateNode = t, t._reactInternalFiber = e, r && ((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = i, e.__reactInternalMemoizedMaskedChildContext = a), t;
	}
	function Ut(e, t, n, r) {
		e = t.state, typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(n, r), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && Bt.enqueueReplaceState(t, t.state, null);
	}
	function Wt(e, t, n, r) {
		var i = e.stateNode;
		i.props = n, i.state = e.memoizedState, i.refs = Rt;
		var a = t.contextType;
		typeof a == "object" && a ? i.context = wt(a) : (a = je(t) ? ke : De.current, i.context = Ae(e, a)), (a = e.updateQueue) !== null && (Pt(e, a, n, i, r), i.state = e.memoizedState), typeof (a = t.getDerivedStateFromProps) == "function" && (zt(e, t, a, n), i.state = e.memoizedState), typeof t.getDerivedStateFromProps == "function" || typeof i.getSnapshotBeforeUpdate == "function" || typeof i.UNSAFE_componentWillMount != "function" && typeof i.componentWillMount != "function" || (t = i.state, typeof i.componentWillMount == "function" && i.componentWillMount(), typeof i.UNSAFE_componentWillMount == "function" && i.UNSAFE_componentWillMount(), t !== i.state && Bt.enqueueReplaceState(i, i.state, null), (a = e.updateQueue) !== null && (Pt(e, a, n, i, r), i.state = e.memoizedState)), typeof i.componentDidMount == "function" && (e.effectTag |= 4);
	}
	var Gt = Array.isArray;
	function Kt(e, t, n) {
		if ((e = n.ref) !== null && typeof e != "function" && typeof e != "object") {
			if (n._owner) {
				if (n = n._owner) {
					if (n.tag !== 1) throw Error(o(309));
					var r = n.stateNode;
				}
				if (!r) throw Error(o(147, e));
				var i = "" + e;
				return t !== null && t.ref !== null && typeof t.ref == "function" && t.ref._stringRef === i ? t.ref : (t = function(e) {
					var t = r.refs;
					t === Rt && (t = r.refs = {}), e === null ? delete t[i] : t[i] = e;
				}, t._stringRef = i, t);
			}
			if (typeof e != "string") throw Error(o(284));
			if (!n._owner) throw Error(o(290, e));
		}
		return e;
	}
	function qt(e, t) {
		if (e.type !== "textarea") throw Error(o(31, Object.prototype.toString.call(t) === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : t, ""));
	}
	function Jt(e) {
		function t(t, n) {
			if (e) {
				var r = t.lastEffect;
				r === null ? t.firstEffect = t.lastEffect = n : (r.nextEffect = n, t.lastEffect = n), n.nextEffect = null, n.effectTag = 8;
			}
		}
		function n(n, r) {
			if (!e) return null;
			for (; r !== null;) t(n, r), r = r.sibling;
			return null;
		}
		function r(e, t) {
			for (e = /* @__PURE__ */ new Map(); t !== null;) t.key === null ? e.set(t.index, t) : e.set(t.key, t), t = t.sibling;
			return e;
		}
		function i(e, t, n) {
			return (e = Qi(e, t)).index = 0, e.sibling = null, e;
		}
		function a(t, n, r) {
			return t.index = r, e ? (r = t.alternate) === null || (r = r.index) < n ? (t.effectTag = 2, n) : r : n;
		}
		function s(t) {
			return e && t.alternate === null && (t.effectTag = 2), t;
		}
		function c(e, t, n, r) {
			return t === null || t.tag !== 6 ? ((t = ta(n, e.mode, r)).return = e, t) : ((t = i(t, n)).return = e, t);
		}
		function f(e, t, n, r) {
			return t !== null && t.elementType === n.type ? ((r = i(t, n.props)).ref = Kt(e, t, n), r.return = e, r) : ((r = $i(n.type, n.key, n.props, null, e.mode, r)).ref = Kt(e, t, n), r.return = e, r);
		}
		function p(e, t, n, r) {
			return t === null || t.tag !== 4 || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation ? ((t = na(n, e.mode, r)).return = e, t) : ((t = i(t, n.children || [])).return = e, t);
		}
		function m(e, t, n, r, a) {
			return t === null || t.tag !== 7 ? ((t = ea(n, e.mode, r, a)).return = e, t) : ((t = i(t, n)).return = e, t);
		}
		function h(e, t, n) {
			if (typeof t == "string" || typeof t == "number") return (t = ta("" + t, e.mode, n)).return = e, t;
			if (typeof t == "object" && t) {
				switch (t.$$typeof) {
					case l: return (n = $i(t.type, t.key, t.props, null, e.mode, n)).ref = Kt(e, null, t), n.return = e, n;
					case u: return (t = na(t, e.mode, n)).return = e, t;
				}
				if (Gt(t) || C(t)) return (t = ea(t, e.mode, n, null)).return = e, t;
				qt(e, t);
			}
			return null;
		}
		function g(e, t, n, r) {
			var i = t === null ? null : t.key;
			if (typeof n == "string" || typeof n == "number") return i === null ? c(e, t, "" + n, r) : null;
			if (typeof n == "object" && n) {
				switch (n.$$typeof) {
					case l: return n.key === i ? n.type === d ? m(e, t, n.props.children, r, i) : f(e, t, n, r) : null;
					case u: return n.key === i ? p(e, t, n, r) : null;
				}
				if (Gt(n) || C(n)) return i === null ? m(e, t, n, r, null) : null;
				qt(e, n);
			}
			return null;
		}
		function _(e, t, n, r, i) {
			if (typeof r == "string" || typeof r == "number") return c(t, e = e.get(n) || null, "" + r, i);
			if (typeof r == "object" && r) {
				switch (r.$$typeof) {
					case l: return e = e.get(r.key === null ? n : r.key) || null, r.type === d ? m(t, e, r.props.children, i, r.key) : f(t, e, r, i);
					case u: return p(t, e = e.get(r.key === null ? n : r.key) || null, r, i);
				}
				if (Gt(r) || C(r)) return m(t, e = e.get(n) || null, r, i, null);
				qt(t, r);
			}
			return null;
		}
		function v(i, o, s, c) {
			for (var l = null, u = null, d = o, f = o = 0, p = null; d !== null && f < s.length; f++) {
				d.index > f ? (p = d, d = null) : p = d.sibling;
				var m = g(i, d, s[f], c);
				if (m === null) {
					d === null && (d = p);
					break;
				}
				e && d && m.alternate === null && t(i, d), o = a(m, o, f), u === null ? l = m : u.sibling = m, u = m, d = p;
			}
			if (f === s.length) return n(i, d), l;
			if (d === null) {
				for (; f < s.length; f++) (d = h(i, s[f], c)) !== null && (o = a(d, o, f), u === null ? l = d : u.sibling = d, u = d);
				return l;
			}
			for (d = r(i, d); f < s.length; f++) (p = _(d, i, f, s[f], c)) !== null && (e && p.alternate !== null && d.delete(p.key === null ? f : p.key), o = a(p, o, f), u === null ? l = p : u.sibling = p, u = p);
			return e && d.forEach((function(e) {
				return t(i, e);
			})), l;
		}
		function y(i, s, c, l) {
			var u = C(c);
			if (typeof u != "function") throw Error(o(150));
			if ((c = u.call(c)) == null) throw Error(o(151));
			for (var d = u = null, f = s, p = s = 0, m = null, v = c.next(); f !== null && !v.done; p++, v = c.next()) {
				f.index > p ? (m = f, f = null) : m = f.sibling;
				var y = g(i, f, v.value, l);
				if (y === null) {
					f === null && (f = m);
					break;
				}
				e && f && y.alternate === null && t(i, f), s = a(y, s, p), d === null ? u = y : d.sibling = y, d = y, f = m;
			}
			if (v.done) return n(i, f), u;
			if (f === null) {
				for (; !v.done; p++, v = c.next()) (v = h(i, v.value, l)) !== null && (s = a(v, s, p), d === null ? u = v : d.sibling = v, d = v);
				return u;
			}
			for (f = r(i, f); !v.done; p++, v = c.next()) (v = _(f, i, p, v.value, l)) !== null && (e && v.alternate !== null && f.delete(v.key === null ? p : v.key), s = a(v, s, p), d === null ? u = v : d.sibling = v, d = v);
			return e && f.forEach((function(e) {
				return t(i, e);
			})), u;
		}
		return function(e, r, a, c) {
			var f = typeof a == "object" && !!a && a.type === d && a.key === null;
			f && (a = a.props.children);
			var p = typeof a == "object" && !!a;
			if (p) switch (a.$$typeof) {
				case l:
					e: {
						for (p = a.key, f = r; f !== null;) {
							if (f.key === p) {
								if (f.tag === 7 ? a.type === d : f.elementType === a.type) {
									n(e, f.sibling), (r = i(f, a.type === d ? a.props.children : a.props)).ref = Kt(e, f, a), r.return = e, e = r;
									break e;
								}
								n(e, f);
								break;
							}
							t(e, f), f = f.sibling;
						}
						a.type === d ? ((r = ea(a.props.children, e.mode, c, a.key)).return = e, e = r) : ((c = $i(a.type, a.key, a.props, null, e.mode, c)).ref = Kt(e, r, a), c.return = e, e = c);
					}
					return s(e);
				case u:
					e: {
						for (f = a.key; r !== null;) {
							if (r.key === f) {
								if (r.tag === 4 && r.stateNode.containerInfo === a.containerInfo && r.stateNode.implementation === a.implementation) {
									n(e, r.sibling), (r = i(r, a.children || [])).return = e, e = r;
									break e;
								}
								n(e, r);
								break;
							}
							t(e, r), r = r.sibling;
						}
						(r = na(a, e.mode, c)).return = e, e = r;
					}
					return s(e);
			}
			if (typeof a == "string" || typeof a == "number") return a = "" + a, r !== null && r.tag === 6 ? (n(e, r.sibling), (r = i(r, a)).return = e, e = r) : (n(e, r), (r = ta(a, e.mode, c)).return = e, e = r), s(e);
			if (Gt(a)) return v(e, r, a, c);
			if (C(a)) return y(e, r, a, c);
			if (p && qt(e, a), a === void 0 && !f) switch (e.tag) {
				case 1:
				case 0: throw e = e.type, Error(o(152, e.displayName || e.name || "Component"));
			}
			return n(e, r);
		};
	}
	var Yt = Jt(!0), Xt = Jt(!1), Zt = {}, Qt = { current: Zt }, $t = { current: Zt }, en = { current: Zt };
	function tn(e) {
		if (e === Zt) throw Error(o(174));
		return e;
	}
	function nn(e, t) {
		Te(en, t), Te($t, e), Te(Qt, Zt), t = A(t), we(Qt), Te(Qt, t);
	}
	function rn(e) {
		we(Qt), we($t), we(en);
	}
	function an(e) {
		var t = tn(en.current), n = tn(Qt.current);
		n !== (t = j(n, e.type, t)) && (Te($t, e), Te(Qt, t));
	}
	function on(e) {
		$t.current === e && (we(Qt), we($t));
	}
	var sn = { current: 0 };
	function cn(e) {
		for (var t = e; t !== null;) {
			if (t.tag === 13) {
				var n = t.memoizedState;
				if (n !== null && ((n = n.dehydrated) === null || R(n) || xe(n))) return t;
			} else if (t.tag === 19 && t.memoizedProps.revealOrder !== void 0) {
				if (64 & t.effectTag) return t;
			} else if (t.child !== null) {
				t.child.return = t, t = t.child;
				continue;
			}
			if (t === e) break;
			for (; t.sibling === null;) {
				if (t.return === null || t.return === e) return null;
				t = t.return;
			}
			t.sibling.return = t.return, t = t.sibling;
		}
		return null;
	}
	function ln(e, t) {
		return {
			responder: e,
			props: t
		};
	}
	var un = s.ReactCurrentDispatcher, dn = s.ReactCurrentBatchConfig, fn = 0, pn = null, mn = null, hn = null, gn = null, _n = null, vn = null, yn = 0, bn = null, xn = 0, Sn = !1, Cn = null, wn = 0;
	function Tn() {
		throw Error(o(321));
	}
	function En(e, t) {
		if (t === null) return !1;
		for (var n = 0; n < t.length && n < e.length; n++) if (!ft(e[n], t[n])) return !1;
		return !0;
	}
	function Dn(e, t, n, r, i, a) {
		if (fn = a, pn = t, hn = e === null ? null : e.memoizedState, un.current = hn === null ? Kn : qn, t = n(r, i), Sn) {
			do
				Sn = !1, wn += 1, hn = e === null ? null : e.memoizedState, vn = gn, bn = _n = mn = null, un.current = qn, t = n(r, i);
			while (Sn);
			Cn = null, wn = 0;
		}
		if (un.current = Gn, (e = pn).memoizedState = gn, e.expirationTime = yn, e.updateQueue = bn, e.effectTag |= xn, e = mn !== null && mn.next !== null, fn = 0, vn = _n = gn = hn = mn = pn = null, yn = 0, bn = null, xn = 0, e) throw Error(o(300));
		return t;
	}
	function On() {
		un.current = Gn, fn = 0, vn = _n = gn = hn = mn = pn = null, yn = 0, bn = null, xn = 0, Sn = !1, Cn = null, wn = 0;
	}
	function kn() {
		var e = {
			memoizedState: null,
			baseState: null,
			queue: null,
			baseUpdate: null,
			next: null
		};
		return _n === null ? gn = _n = e : _n = _n.next = e, _n;
	}
	function An() {
		if (vn !== null) vn = (_n = vn).next, hn = (mn = hn) === null ? null : mn.next;
		else {
			if (hn === null) throw Error(o(310));
			var e = {
				memoizedState: (mn = hn).memoizedState,
				baseState: mn.baseState,
				queue: mn.queue,
				baseUpdate: mn.baseUpdate,
				next: null
			};
			_n = _n === null ? gn = e : _n.next = e, hn = mn.next;
		}
		return _n;
	}
	function jn(e, t) {
		return typeof t == "function" ? t(e) : t;
	}
	function Mn(e) {
		var t = An(), n = t.queue;
		if (n === null) throw Error(o(311));
		if (n.lastRenderedReducer = e, 0 < wn) {
			var r = n.dispatch;
			if (Cn !== null) {
				var i = Cn.get(n);
				if (i !== void 0) {
					Cn.delete(n);
					var a = t.memoizedState;
					do
						a = e(a, i.action), i = i.next;
					while (i !== null);
					return ft(a, t.memoizedState) || (Yn = !0), t.memoizedState = a, t.baseUpdate === n.last && (t.baseState = a), n.lastRenderedState = a, [a, r];
				}
			}
			return [t.memoizedState, r];
		}
		r = n.last;
		var s = t.baseUpdate;
		if (a = t.baseState, s === null ? r = r === null ? null : r.next : (r !== null && (r.next = null), r = s.next), r !== null) {
			var c = i = null, l = r, u = !1;
			do {
				var d = l.expirationTime;
				d < fn ? (u || (u = !0, c = s, i = a), d > yn && Mi(yn = d)) : (ji(d, l.suspenseConfig), a = l.eagerReducer === e ? l.eagerState : e(a, l.action)), s = l, l = l.next;
			} while (l !== null && l !== r);
			u || (c = s, i = a), ft(a, t.memoizedState) || (Yn = !0), t.memoizedState = a, t.baseUpdate = c, t.baseState = i, n.lastRenderedState = a;
		}
		return [t.memoizedState, n.dispatch];
	}
	function Nn(e) {
		var t = kn();
		return typeof e == "function" && (e = e()), t.memoizedState = t.baseState = e, e = (e = t.queue = {
			last: null,
			dispatch: null,
			lastRenderedReducer: jn,
			lastRenderedState: e
		}).dispatch = Wn.bind(null, pn, e), [t.memoizedState, e];
	}
	function Pn(e) {
		return Mn(jn);
	}
	function Fn(e, t, n, r) {
		return e = {
			tag: e,
			create: t,
			destroy: n,
			deps: r,
			next: null
		}, bn === null ? (bn = { lastEffect: null }).lastEffect = e.next = e : (t = bn.lastEffect) === null ? bn.lastEffect = e.next = e : (n = t.next, t.next = e, e.next = n, bn.lastEffect = e), e;
	}
	function In(e, t, n, r) {
		var i = kn();
		xn |= e, i.memoizedState = Fn(t, n, void 0, r === void 0 ? null : r);
	}
	function Ln(e, t, n, r) {
		var i = An();
		r = r === void 0 ? null : r;
		var a = void 0;
		if (mn !== null) {
			var o = mn.memoizedState;
			if (a = o.destroy, r !== null && En(r, o.deps)) return void Fn(0, n, a, r);
		}
		xn |= e, i.memoizedState = Fn(t, n, a, r);
	}
	function Rn(e, t) {
		return In(516, 192, e, t);
	}
	function zn(e, t) {
		return Ln(516, 192, e, t);
	}
	function Bn(e, t) {
		return typeof t == "function" ? (e = e(), t(e), function() {
			t(null);
		}) : t == null ? void 0 : (e = e(), t.current = e, function() {
			t.current = null;
		});
	}
	function Vn() {}
	function Hn(e, t) {
		return kn().memoizedState = [e, t === void 0 ? null : t], e;
	}
	function Un(e, t) {
		var n = An();
		t = t === void 0 ? null : t;
		var r = n.memoizedState;
		return r !== null && t !== null && En(t, r[1]) ? r[0] : (n.memoizedState = [e, t], e);
	}
	function Wn(e, t, n) {
		if (!(25 > wn)) throw Error(o(301));
		var r = e.alternate;
		if (e === pn || r !== null && r === pn) if (Sn = !0, e = {
			expirationTime: fn,
			suspenseConfig: null,
			action: n,
			eagerReducer: null,
			eagerState: null,
			next: null
		}, Cn === null && (Cn = /* @__PURE__ */ new Map()), (n = Cn.get(t)) === void 0) Cn.set(t, e);
		else {
			for (t = n; t.next !== null;) t = t.next;
			t.next = e;
		}
		else {
			var i = yi(), a = Lt.suspense;
			a = {
				expirationTime: i = bi(i, e, a),
				suspenseConfig: a,
				action: n,
				eagerReducer: null,
				eagerState: null,
				next: null
			};
			var s = t.last;
			if (s === null) a.next = a;
			else {
				var c = s.next;
				c !== null && (a.next = c), s.next = a;
			}
			if (t.last = a, e.expirationTime === 0 && (r === null || r.expirationTime === 0) && (r = t.lastRenderedReducer) !== null) try {
				var l = t.lastRenderedState, u = r(l, n);
				if (a.eagerReducer = r, a.eagerState = u, ft(u, l)) return;
			} catch {}
			xi(e, i);
		}
	}
	var Gn = {
		readContext: wt,
		useCallback: Tn,
		useContext: Tn,
		useEffect: Tn,
		useImperativeHandle: Tn,
		useLayoutEffect: Tn,
		useMemo: Tn,
		useReducer: Tn,
		useRef: Tn,
		useState: Tn,
		useDebugValue: Tn,
		useResponder: Tn,
		useDeferredValue: Tn,
		useTransition: Tn
	}, Kn = {
		readContext: wt,
		useCallback: Hn,
		useContext: wt,
		useEffect: Rn,
		useImperativeHandle: function(e, t, n) {
			return n = n == null ? null : n.concat([e]), In(4, 36, Bn.bind(null, t, e), n);
		},
		useLayoutEffect: function(e, t) {
			return In(4, 36, e, t);
		},
		useMemo: function(e, t) {
			var n = kn();
			return t = t === void 0 ? null : t, e = e(), n.memoizedState = [e, t], e;
		},
		useReducer: function(e, t, n) {
			var r = kn();
			return t = n === void 0 ? t : n(t), r.memoizedState = r.baseState = t, e = (e = r.queue = {
				last: null,
				dispatch: null,
				lastRenderedReducer: e,
				lastRenderedState: t
			}).dispatch = Wn.bind(null, pn, e), [r.memoizedState, e];
		},
		useRef: function(e) {
			return e = { current: e }, kn().memoizedState = e;
		},
		useState: Nn,
		useDebugValue: Vn,
		useResponder: ln,
		useDeferredValue: function(e, t) {
			var n = Nn(e), r = n[0], i = n[1];
			return Rn((function() {
				a.unstable_next((function() {
					var n = dn.suspense;
					dn.suspense = t === void 0 ? null : t;
					try {
						i(e);
					} finally {
						dn.suspense = n;
					}
				}));
			}), [e, t]), r;
		},
		useTransition: function(e) {
			var t = Nn(!1), n = t[0], r = t[1];
			return [Hn((function(t) {
				r(!0), a.unstable_next((function() {
					var n = dn.suspense;
					dn.suspense = e === void 0 ? null : e;
					try {
						r(!1), t();
					} finally {
						dn.suspense = n;
					}
				}));
			}), [e, n]), n];
		}
	}, qn = {
		readContext: wt,
		useCallback: Un,
		useContext: wt,
		useEffect: zn,
		useImperativeHandle: function(e, t, n) {
			return n = n == null ? null : n.concat([e]), Ln(4, 36, Bn.bind(null, t, e), n);
		},
		useLayoutEffect: function(e, t) {
			return Ln(4, 36, e, t);
		},
		useMemo: function(e, t) {
			var n = An();
			t = t === void 0 ? null : t;
			var r = n.memoizedState;
			return r !== null && t !== null && En(t, r[1]) ? r[0] : (e = e(), n.memoizedState = [e, t], e);
		},
		useReducer: Mn,
		useRef: function() {
			return An().memoizedState;
		},
		useState: Pn,
		useDebugValue: Vn,
		useResponder: ln,
		useDeferredValue: function(e, t) {
			var n = Pn(), r = n[0], i = n[1];
			return zn((function() {
				a.unstable_next((function() {
					var n = dn.suspense;
					dn.suspense = t === void 0 ? null : t;
					try {
						i(e);
					} finally {
						dn.suspense = n;
					}
				}));
			}), [e, t]), r;
		},
		useTransition: function(e) {
			var t = Pn(), n = t[0], r = t[1];
			return [Un((function(t) {
				r(!0), a.unstable_next((function() {
					var n = dn.suspense;
					dn.suspense = e === void 0 ? null : e;
					try {
						r(!1), t();
					} finally {
						dn.suspense = n;
					}
				}));
			}), [e, n]), n];
		}
	}, Jn = s.ReactCurrentOwner, Yn = !1;
	function Xn(e, t, n, r) {
		t.child = e === null ? Xt(t, null, n, r) : Yt(t, e.child, n, r);
	}
	function Zn(e, t, n, r, i) {
		n = n.render;
		var a = t.ref;
		return Ct(t, i), r = Dn(e, t, n, r, a, i), e === null || Yn ? (t.effectTag |= 1, Xn(e, t, r, i), t.child) : (t.updateQueue = e.updateQueue, t.effectTag &= -517, e.expirationTime <= i && (e.expirationTime = 0), mr(e, t, i));
	}
	function Qn(e, t, n, r, i, a) {
		if (e === null) {
			var o = n.type;
			return typeof o != "function" || Zi(o) || o.defaultProps !== void 0 || n.compare !== null || n.defaultProps !== void 0 ? ((e = $i(n.type, null, r, null, t.mode, a)).ref = t.ref, e.return = t, t.child = e) : (t.tag = 15, t.type = o, $n(e, t, o, r, i, a));
		}
		return o = e.child, i < a && (i = o.memoizedProps, (n = (n = n.compare) === null ? mt : n)(i, r) && e.ref === t.ref) ? mr(e, t, a) : (t.effectTag |= 1, (e = Qi(o, r)).ref = t.ref, e.return = t, t.child = e);
	}
	function $n(e, t, n, r, i, a) {
		return e !== null && mt(e.memoizedProps, r) && e.ref === t.ref && (Yn = !1, i < a) ? mr(e, t, a) : tr(e, t, n, r, a);
	}
	function er(e, t) {
		var n = t.ref;
		(e === null && n !== null || e !== null && e.ref !== n) && (t.effectTag |= 128);
	}
	function tr(e, t, n, r, i) {
		var a = je(n) ? ke : De.current;
		return a = Ae(t, a), Ct(t, i), n = Dn(e, t, n, r, a, i), e === null || Yn ? (t.effectTag |= 1, Xn(e, t, n, i), t.child) : (t.updateQueue = e.updateQueue, t.effectTag &= -517, e.expirationTime <= i && (e.expirationTime = 0), mr(e, t, i));
	}
	function nr(e, t, n, r, i) {
		if (je(n)) {
			var a = !0;
			Ie(t);
		} else a = !1;
		if (Ct(t, i), t.stateNode === null) e !== null && (e.alternate = null, t.alternate = null, t.effectTag |= 2), Ht(t, n, r), Wt(t, n, r, i), r = !0;
		else if (e === null) {
			var o = t.stateNode, s = t.memoizedProps;
			o.props = s;
			var c = o.context, l = n.contextType;
			l = typeof l == "object" && l ? wt(l) : Ae(t, l = je(n) ? ke : De.current);
			var u = n.getDerivedStateFromProps, d = typeof u == "function" || typeof o.getSnapshotBeforeUpdate == "function";
			d || typeof o.UNSAFE_componentWillReceiveProps != "function" && typeof o.componentWillReceiveProps != "function" || (s !== r || c !== l) && Ut(t, o, r, l), Tt = !1;
			var f = t.memoizedState;
			c = o.state = f;
			var p = t.updateQueue;
			p !== null && (Pt(t, p, r, o, i), c = t.memoizedState), s !== r || f !== c || Oe.current || Tt ? (typeof u == "function" && (zt(t, n, u, r), c = t.memoizedState), (s = Tt || Vt(t, n, s, r, f, c, l)) ? (d || typeof o.UNSAFE_componentWillMount != "function" && typeof o.componentWillMount != "function" || (typeof o.componentWillMount == "function" && o.componentWillMount(), typeof o.UNSAFE_componentWillMount == "function" && o.UNSAFE_componentWillMount()), typeof o.componentDidMount == "function" && (t.effectTag |= 4)) : (typeof o.componentDidMount == "function" && (t.effectTag |= 4), t.memoizedProps = r, t.memoizedState = c), o.props = r, o.state = c, o.context = l, r = s) : (typeof o.componentDidMount == "function" && (t.effectTag |= 4), r = !1);
		} else o = t.stateNode, s = t.memoizedProps, o.props = t.type === t.elementType ? s : ht(t.type, s), c = o.context, l = typeof (l = n.contextType) == "object" && l !== null ? wt(l) : Ae(t, l = je(n) ? ke : De.current), (d = typeof (u = n.getDerivedStateFromProps) == "function" || typeof o.getSnapshotBeforeUpdate == "function") || typeof o.UNSAFE_componentWillReceiveProps != "function" && typeof o.componentWillReceiveProps != "function" || (s !== r || c !== l) && Ut(t, o, r, l), Tt = !1, c = t.memoizedState, f = o.state = c, (p = t.updateQueue) !== null && (Pt(t, p, r, o, i), f = t.memoizedState), s !== r || c !== f || Oe.current || Tt ? (typeof u == "function" && (zt(t, n, u, r), f = t.memoizedState), (u = Tt || Vt(t, n, s, r, c, f, l)) ? (d || typeof o.UNSAFE_componentWillUpdate != "function" && typeof o.componentWillUpdate != "function" || (typeof o.componentWillUpdate == "function" && o.componentWillUpdate(r, f, l), typeof o.UNSAFE_componentWillUpdate == "function" && o.UNSAFE_componentWillUpdate(r, f, l)), typeof o.componentDidUpdate == "function" && (t.effectTag |= 4), typeof o.getSnapshotBeforeUpdate == "function" && (t.effectTag |= 256)) : (typeof o.componentDidUpdate != "function" || s === e.memoizedProps && c === e.memoizedState || (t.effectTag |= 4), typeof o.getSnapshotBeforeUpdate != "function" || s === e.memoizedProps && c === e.memoizedState || (t.effectTag |= 256), t.memoizedProps = r, t.memoizedState = f), o.props = r, o.state = f, o.context = l, r = u) : (typeof o.componentDidUpdate != "function" || s === e.memoizedProps && c === e.memoizedState || (t.effectTag |= 4), typeof o.getSnapshotBeforeUpdate != "function" || s === e.memoizedProps && c === e.memoizedState || (t.effectTag |= 256), r = !1);
		return rr(e, t, n, r, a, i);
	}
	function rr(e, t, n, r, i, a) {
		er(e, t);
		var o = (64 & t.effectTag) != 0;
		if (!r && !o) return i && Le(t, n, !1), mr(e, t, a);
		r = t.stateNode, Jn.current = t;
		var s = o && typeof n.getDerivedStateFromError != "function" ? null : r.render();
		return t.effectTag |= 1, e !== null && o ? (t.child = Yt(t, e.child, null, a), t.child = Yt(t, null, s, a)) : Xn(e, t, s, a), t.memoizedState = r.state, i && Le(t, n, !0), t.child;
	}
	function ir(e) {
		var t = e.stateNode;
		t.pendingContext ? Pe(0, t.pendingContext, t.pendingContext !== t.context) : t.context && Pe(0, t.context, !1), nn(e, t.containerInfo);
	}
	var ar, or, sr, cr, lr = {
		dehydrated: null,
		retryTime: 0
	};
	function ur(e, t, n) {
		var r, i = t.mode, a = t.pendingProps, o = sn.current, s = !1;
		if ((r = (64 & t.effectTag) != 0) || (r = (2 & o) != 0 && (e === null || e.memoizedState !== null)), r ? (s = !0, t.effectTag &= -65) : e !== null && e.memoizedState === null || a.fallback === void 0 || !0 === a.unstable_avoidThisFallback || (o |= 1), Te(sn, 1 & o), e === null) {
			if (a.fallback, s) {
				if (s = a.fallback, (a = ea(null, i, 0, null)).return = t, !(2 & t.mode)) for (e = t.memoizedState === null ? t.child : t.child.child, a.child = e; e !== null;) e.return = a, e = e.sibling;
				return (n = ea(s, i, n, null)).return = t, a.sibling = n, t.memoizedState = lr, t.child = a, n;
			}
			return i = a.children, t.memoizedState = null, t.child = Xt(t, null, i, n);
		}
		if (e.memoizedState !== null) {
			if (i = (e = e.child).sibling, s) {
				if (a = a.fallback, (n = Qi(e, e.pendingProps)).return = t, !(2 & t.mode) && (s = t.memoizedState === null ? t.child : t.child.child) !== e.child) for (n.child = s; s !== null;) s.return = n, s = s.sibling;
				return (i = Qi(i, a, i.expirationTime)).return = t, n.sibling = i, n.childExpirationTime = 0, t.memoizedState = lr, t.child = n, i;
			}
			return n = Yt(t, e.child, a.children, n), t.memoizedState = null, t.child = n;
		}
		if (e = e.child, s) {
			if (s = a.fallback, (a = ea(null, i, 0, null)).return = t, a.child = e, e !== null && (e.return = a), !(2 & t.mode)) for (e = t.memoizedState === null ? t.child : t.child.child, a.child = e; e !== null;) e.return = a, e = e.sibling;
			return (n = ea(s, i, n, null)).return = t, a.sibling = n, n.effectTag |= 2, a.childExpirationTime = 0, t.memoizedState = lr, t.child = a, n;
		}
		return t.memoizedState = null, t.child = Yt(t, e, a.children, n);
	}
	function dr(e, t) {
		e.expirationTime < t && (e.expirationTime = t);
		var n = e.alternate;
		n !== null && n.expirationTime < t && (n.expirationTime = t), St(e.return, t);
	}
	function fr(e, t, n, r, i, a) {
		var o = e.memoizedState;
		o === null ? e.memoizedState = {
			isBackwards: t,
			rendering: null,
			last: r,
			tail: n,
			tailExpiration: 0,
			tailMode: i,
			lastEffect: a
		} : (o.isBackwards = t, o.rendering = null, o.last = r, o.tail = n, o.tailExpiration = 0, o.tailMode = i, o.lastEffect = a);
	}
	function pr(e, t, n) {
		var r = t.pendingProps, i = r.revealOrder, a = r.tail;
		if (Xn(e, t, r.children, n), 2 & (r = sn.current)) r = 1 & r | 2, t.effectTag |= 64;
		else {
			if (e !== null && 64 & e.effectTag) e: for (e = t.child; e !== null;) {
				if (e.tag === 13) e.memoizedState !== null && dr(e, n);
				else if (e.tag === 19) dr(e, n);
				else if (e.child !== null) {
					e.child.return = e, e = e.child;
					continue;
				}
				if (e === t) break e;
				for (; e.sibling === null;) {
					if (e.return === null || e.return === t) break e;
					e = e.return;
				}
				e.sibling.return = e.return, e = e.sibling;
			}
			r &= 1;
		}
		if (Te(sn, r), !(2 & t.mode)) t.memoizedState = null;
		else switch (i) {
			case "forwards":
				for (n = t.child, i = null; n !== null;) (e = n.alternate) !== null && cn(e) === null && (i = n), n = n.sibling;
				(n = i) === null ? (i = t.child, t.child = null) : (i = n.sibling, n.sibling = null), fr(t, !1, i, n, a, t.lastEffect);
				break;
			case "backwards":
				for (n = null, i = t.child, t.child = null; i !== null;) {
					if ((e = i.alternate) !== null && cn(e) === null) {
						t.child = i;
						break;
					}
					e = i.sibling, i.sibling = n, n = i, i = e;
				}
				fr(t, !0, n, null, a, t.lastEffect);
				break;
			case "together":
				fr(t, !1, null, null, void 0, t.lastEffect);
				break;
			default: t.memoizedState = null;
		}
		return t.child;
	}
	function mr(e, t, n) {
		e !== null && (t.dependencies = e.dependencies);
		var r = t.expirationTime;
		if (r !== 0 && Mi(r), t.childExpirationTime < n) return null;
		if (e !== null && t.child !== e.child) throw Error(o(153));
		if (t.child !== null) {
			for (n = Qi(e = t.child, e.pendingProps, e.expirationTime), t.child = n, n.return = t; e.sibling !== null;) e = e.sibling, (n = n.sibling = Qi(e, e.pendingProps, e.expirationTime)).return = t;
			n.sibling = null;
		}
		return t.child;
	}
	function hr(e) {
		e.effectTag |= 4;
	}
	function gr(e, t) {
		switch (e.tailMode) {
			case "hidden":
				t = e.tail;
				for (var n = null; t !== null;) t.alternate !== null && (n = t), t = t.sibling;
				n === null ? e.tail = null : n.sibling = null;
				break;
			case "collapsed":
				n = e.tail;
				for (var r = null; n !== null;) n.alternate !== null && (r = n), n = n.sibling;
				r === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : r.sibling = null;
		}
	}
	function _r(e) {
		switch (e.tag) {
			case 1:
				je(e.type) && Me();
				var t = e.effectTag;
				return 4096 & t ? (e.effectTag = -4097 & t | 64, e) : null;
			case 3:
				if (rn(), Ne(), 64 & (t = e.effectTag)) throw Error(o(285));
				return e.effectTag = -4097 & t | 64, e;
			case 5: return on(e), null;
			case 13: return we(sn), 4096 & (t = e.effectTag) ? (e.effectTag = -4097 & t | 64, e) : null;
			case 19: return we(sn), null;
			case 4: return rn(), null;
			case 10: return xt(e), null;
			default: return null;
		}
	}
	function vr(e, t) {
		return {
			value: e,
			source: t,
			stack: B(t)
		};
	}
	ar = function(e, t) {
		for (var n = t.child; n !== null;) {
			if (n.tag === 5 || n.tag === 6) ne(e, n.stateNode);
			else if (n.tag !== 4 && n.child !== null) {
				n.child.return = n, n = n.child;
				continue;
			}
			if (n === t) break;
			for (; n.sibling === null;) {
				if (n.return === null || n.return === t) return;
				n = n.return;
			}
			n.sibling.return = n.return, n = n.sibling;
		}
	}, or = function() {}, sr = function(e, t, n, r, i) {
		if ((e = e.memoizedProps) !== r) {
			var a = t.stateNode, o = tn(Qt.current);
			n = ie(a, n, e, r, i, o), (t.updateQueue = n) && hr(t);
		}
	}, cr = function(e, t, n, r) {
		n !== r && hr(t);
	};
	var yr = typeof WeakSet == "function" ? WeakSet : Set;
	function br(e, t) {
		var n = t.source, r = t.stack;
		r === null && n !== null && (r = B(n)), n !== null && w(n.type), t = t.value, e !== null && e.tag === 1 && w(e.type);
		try {
			console.error(t);
		} catch (e) {
			setTimeout((function() {
				throw e;
			}));
		}
	}
	function xr(e) {
		var t = e.ref;
		if (t !== null) if (typeof t == "function") try {
			t(null);
		} catch (t) {
			Wi(e, t);
		}
		else t.current = null;
	}
	function Sr(e, t) {
		switch (t.tag) {
			case 0:
			case 11:
			case 15:
				Cr(2, 0, t);
				break;
			case 1:
				if (256 & t.effectTag && e !== null) {
					var n = e.memoizedProps, r = e.memoizedState;
					t = (e = t.stateNode).getSnapshotBeforeUpdate(t.elementType === t.type ? n : ht(t.type, n), r), e.__reactInternalSnapshotBeforeUpdate = t;
				}
				break;
			case 3:
			case 5:
			case 6:
			case 4:
			case 17: break;
			default: throw Error(o(163));
		}
	}
	function Cr(e, t, n) {
		if ((n = (n = n.updateQueue) === null ? null : n.lastEffect) !== null) {
			var r = n = n.next;
			do {
				if ((r.tag & e) != 0) {
					var i = r.destroy;
					r.destroy = void 0, i !== void 0 && i();
				}
				(r.tag & t) != 0 && (i = r.create, r.destroy = i()), r = r.next;
			} while (r !== n);
		}
	}
	function wr(e, t, n) {
		switch (typeof Ji == "function" && Ji(t), t.tag) {
			case 0:
			case 11:
			case 14:
			case 15:
				if ((e = t.updateQueue) !== null && (e = e.lastEffect) !== null) {
					var r = e.next;
					at(97 < n ? 97 : n, (function() {
						var e = r;
						do {
							var n = e.destroy;
							if (n !== void 0) {
								var i = t;
								try {
									n();
								} catch (e) {
									Wi(i, e);
								}
							}
							e = e.next;
						} while (e !== r);
					}));
				}
				break;
			case 1:
				xr(t), typeof (n = t.stateNode).componentWillUnmount == "function" && function(e, t) {
					try {
						t.props = e.memoizedProps, t.state = e.memoizedState, t.componentWillUnmount();
					} catch (t) {
						Wi(e, t);
					}
				}(t, n);
				break;
			case 5:
				xr(t);
				break;
			case 4: kr(e, t, n);
		}
	}
	function Tr(e, t, n) {
		for (var r = t;;) if (wr(e, r, n), r.child === null || r.tag === 4) {
			if (r === t) break;
			for (; r.sibling === null;) {
				if (r.return === null || r.return === t) return;
				r = r.return;
			}
			r.sibling.return = r.return, r = r.sibling;
		} else r.child.return = r, r = r.child;
	}
	function Er(e) {
		var t = e.alternate;
		e.return = null, e.child = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.alternate = null, e.firstEffect = null, e.lastEffect = null, e.pendingProps = null, e.memoizedProps = null, t !== null && Er(t);
	}
	function Dr(e) {
		return e.tag === 5 || e.tag === 3 || e.tag === 4;
	}
	function Or(e) {
		e: {
			for (var t = e.return; t !== null;) {
				if (Dr(t)) {
					var n = t;
					break e;
				}
				t = t.return;
			}
			throw Error(o(160));
		}
		switch (t = n.stateNode, n.tag) {
			case 5:
				var r = !1;
				break;
			case 3:
			case 4:
				t = t.containerInfo, r = !0;
				break;
			default: throw Error(o(161));
		}
		16 & n.effectTag && (ge(t), n.effectTag &= -17);
		e: t: for (n = e;;) {
			for (; n.sibling === null;) {
				if (n.return === null || Dr(n.return)) {
					n = null;
					break e;
				}
				n = n.return;
			}
			for (n.sibling.return = n.return, n = n.sibling; n.tag !== 5 && n.tag !== 6 && n.tag !== 18;) {
				if (2 & n.effectTag || n.child === null || n.tag === 4) continue t;
				n.child.return = n, n = n.child;
			}
			if (!(2 & n.effectTag)) {
				n = n.stateNode;
				break e;
			}
		}
		for (var i = e;;) {
			var a = i.tag === 5 || i.tag === 6;
			if (a) a = a ? i.stateNode : i.stateNode.instance, n ? r ? I(t, a, n) : F(t, a, n) : r ? de(t, a) : ue(t, a);
			else if (i.tag !== 4 && i.child !== null) {
				i.child.return = i, i = i.child;
				continue;
			}
			if (i === e) break;
			for (; i.sibling === null;) {
				if (i.return === null || i.return === e) return;
				i = i.return;
			}
			i.sibling.return = i.return, i = i.sibling;
		}
	}
	function kr(e, t, n) {
		for (var r, i, a = t, s = !1;;) {
			if (!s) {
				s = a.return;
				e: for (;;) {
					if (s === null) throw Error(o(160));
					switch (r = s.stateNode, s.tag) {
						case 5:
							i = !1;
							break e;
						case 3:
						case 4:
							r = r.containerInfo, i = !0;
							break e;
					}
					s = s.return;
				}
				s = !0;
			}
			if (a.tag === 5 || a.tag === 6) Tr(e, a, n), i ? L(r, a.stateNode) : he(r, a.stateNode);
			else if (a.tag === 4) {
				if (a.child !== null) {
					r = a.stateNode.containerInfo, i = !0, a.child.return = a, a = a.child;
					continue;
				}
			} else if (wr(e, a, n), a.child !== null) {
				a.child.return = a, a = a.child;
				continue;
			}
			if (a === t) break;
			for (; a.sibling === null;) {
				if (a.return === null || a.return === t) return;
				(a = a.return).tag === 4 && (s = !1);
			}
			a.sibling.return = a.return, a = a.sibling;
		}
	}
	function Ar(e, t) {
		switch (t.tag) {
			case 0:
			case 11:
			case 14:
			case 15:
				Cr(4, 8, t);
				break;
			case 1:
			case 3:
			case 12:
			case 17:
			case 20:
			case 21: break;
			case 5:
				var n = t.stateNode;
				if (n != null) {
					var r = t.memoizedProps;
					e = e === null ? r : e.memoizedProps;
					var i = t.type, a = t.updateQueue;
					t.updateQueue = null, a !== null && me(n, a, i, e, r, t);
				}
				break;
			case 6:
				if (t.stateNode === null) throw Error(o(162));
				n = t.memoizedProps, fe(t.stateNode, e === null ? n : e.memoizedProps, n);
				break;
			case 13:
				(function(e) {
					var t = e;
					if (e.memoizedState === null) var n = !1;
					else n = !0, t = e.child, oi = nt();
					if (t !== null) {
						e: if (e = t, N) for (t = e;;) {
							if (t.tag === 5) {
								var r = t.stateNode;
								n ? _e(r) : ye(t.stateNode, t.memoizedProps);
							} else if (t.tag === 6) r = t.stateNode, n ? ve(r) : be(r, t.memoizedProps);
							else {
								if (t.tag === 13 && t.memoizedState !== null && t.memoizedState.dehydrated === null) {
									(r = t.child.sibling).return = t, t = r;
									continue;
								}
								if (t.child !== null) {
									t.child.return = t, t = t.child;
									continue;
								}
							}
							if (t === e) break e;
							for (; t.sibling === null;) {
								if (t.return === null || t.return === e) break e;
								t = t.return;
							}
							t.sibling.return = t.return, t = t.sibling;
						}
					}
				})(t), jr(t);
				break;
			case 19:
				jr(t);
				break;
			default: throw Error(o(163));
		}
	}
	function jr(e) {
		var t = e.updateQueue;
		if (t !== null) {
			e.updateQueue = null;
			var n = e.stateNode;
			n === null && (n = e.stateNode = new yr()), t.forEach((function(t) {
				var r = Ki.bind(null, e, t);
				n.has(t) || (n.add(t), t.then(r, r));
			}));
		}
	}
	var Mr = typeof WeakMap == "function" ? WeakMap : Map;
	function Nr(e, t, n) {
		(n = Ot(n, null)).tag = 3, n.payload = { element: null };
		var r = t.value;
		return n.callback = function() {
			li || (li = !0, ui = r), br(e, t);
		}, n;
	}
	function Pr(e, t, n) {
		(n = Ot(n, null)).tag = 3;
		var r = e.type.getDerivedStateFromError;
		if (typeof r == "function") {
			var i = t.value;
			n.payload = function() {
				return br(e, t), r(i);
			};
		}
		var a = e.stateNode;
		return a !== null && typeof a.componentDidCatch == "function" && (n.callback = function() {
			typeof r != "function" && (di === null ? di = new Set([this]) : di.add(this), br(e, t));
			var n = t.stack;
			this.componentDidCatch(t.value, { componentStack: n === null ? "" : n });
		}), n;
	}
	var Fr, Ir = Math.ceil, Lr = s.ReactCurrentDispatcher, Rr = s.ReactCurrentOwner, zr = 0, Br = 8, Vr = 16, Hr = 32, Ur = 0, Wr = 1, Gr = 2, Kr = 3, qr = 4, Jr = 5, Yr = zr, Xr = null, Zr = null, Qr = 0, $r = Ur, ei = null, ti = 1073741823, ni = 1073741823, ri = null, ii = 0, ai = !1, oi = 0, si = 500, ci = null, li = !1, ui = null, di = null, fi = !1, pi = null, mi = 90, hi = null, gi = 0, _i = null, vi = 0;
	function yi() {
		return (Yr & (Vr | Hr)) === zr ? vi === 0 ? vi = 1073741821 - (nt() / 10 | 0) : vi : 1073741821 - (nt() / 10 | 0);
	}
	function bi(e, t, n) {
		if (!(2 & (t = t.mode))) return 1073741823;
		var r = rt();
		if (!(4 & t)) return r === 99 ? 1073741823 : 1073741822;
		if ((Yr & Vr) !== zr) return Qr;
		if (n !== null) e = dt(e, 0 | n.timeoutMs || 5e3, 250);
		else switch (r) {
			case 99:
				e = 1073741823;
				break;
			case 98:
				e = dt(e, 150, 100);
				break;
			case 97:
			case 96:
				e = dt(e, 5e3, 250);
				break;
			case 95:
				e = 2;
				break;
			default: throw Error(o(326));
		}
		return Xr !== null && e === Qr && --e, e;
	}
	function xi(e, t) {
		if (50 < gi) throw gi = 0, _i = null, Error(o(185));
		if ((e = Si(e, t)) !== null) {
			var n = rt();
			t === 1073741823 ? (Yr & Br) !== zr && (Yr & (Vr | Hr)) === zr ? Ei(e) : (wi(e), Yr === zr && ct()) : wi(e), (4 & Yr) === zr || n !== 98 && n !== 99 || (hi === null ? hi = new Map([[e, t]]) : ((n = hi.get(e)) === void 0 || n > t) && hi.set(e, t));
		}
	}
	function Si(e, t) {
		e.expirationTime < t && (e.expirationTime = t);
		var n = e.alternate;
		n !== null && n.expirationTime < t && (n.expirationTime = t);
		var r = e.return, i = null;
		if (r === null && e.tag === 3) i = e.stateNode;
		else for (; r !== null;) {
			if (n = r.alternate, r.childExpirationTime < t && (r.childExpirationTime = t), n !== null && n.childExpirationTime < t && (n.childExpirationTime = t), r.return === null && r.tag === 3) {
				i = r.stateNode;
				break;
			}
			r = r.return;
		}
		return i !== null && (Xr === i && (Mi(t), $r === qr && aa(i, Qr)), oa(i, t)), i;
	}
	function Ci(e) {
		var t = e.lastExpiredTime;
		return t === 0 && ia(e, t = e.firstPendingTime) ? (t = e.lastPingedTime) > (e = e.nextKnownPendingLevel) ? t : e : t;
	}
	function wi(e) {
		if (e.lastExpiredTime !== 0) e.callbackExpirationTime = 1073741823, e.callbackPriority = 99, e.callbackNode = st(Ei.bind(null, e));
		else {
			var t = Ci(e), n = e.callbackNode;
			if (t === 0) n !== null && (e.callbackNode = null, e.callbackExpirationTime = 0, e.callbackPriority = 90);
			else {
				var r = yi();
				if (r = t === 1073741823 ? 99 : t === 1 || t === 2 ? 95 : 0 >= (r = 10 * (1073741821 - t) - 10 * (1073741821 - r)) ? 99 : 250 >= r ? 98 : 5250 >= r ? 97 : 95, n !== null) {
					var i = e.callbackPriority;
					if (e.callbackExpirationTime === t && i >= r) return;
					n !== Xe && Be(n);
				}
				e.callbackExpirationTime = t, e.callbackPriority = r, t = t === 1073741823 ? st(Ei.bind(null, e)) : ot(r, Ti.bind(null, e), { timeout: 10 * (1073741821 - t) - nt() }), e.callbackNode = t;
			}
		}
	}
	function Ti(e, t) {
		if (vi = 0, t) return sa(e, t = yi()), wi(e), null;
		var n = Ci(e);
		if (n !== 0) {
			if (t = e.callbackNode, (Yr & (Vr | Hr)) !== zr) throw Error(o(327));
			if (Vi(), e === Xr && n === Qr || Oi(e, n), Zr !== null) {
				var r = Yr;
				Yr |= Vr;
				for (var i = Ai();;) try {
					Pi();
					break;
				} catch (t) {
					ki(e, t);
				}
				if (yt(), Yr = r, Lr.current = i, $r === Wr) throw t = ei, Oi(e, n), aa(e, n), wi(e), t;
				if (Zr === null) switch (i = e.finishedWork = e.current.alternate, e.finishedExpirationTime = n, r = $r, Xr = null, r) {
					case Ur:
					case Wr: throw Error(o(345));
					case Gr:
						sa(e, 2 < n ? 2 : n);
						break;
					case Kr:
						if (aa(e, n), n === (r = e.lastSuspendedTime) && (e.nextKnownPendingLevel = Li(i)), ti === 1073741823 && 10 < (i = oi + si - nt())) {
							if (ai) {
								var a = e.lastPingedTime;
								if (a === 0 || a >= n) {
									e.lastPingedTime = n, Oi(e, n);
									break;
								}
							}
							if ((a = Ci(e)) !== 0 && a !== n) break;
							if (r !== 0 && r !== n) {
								e.lastPingedTime = r;
								break;
							}
							e.timeoutHandle = se(Ri.bind(null, e), i);
							break;
						}
						Ri(e);
						break;
					case qr:
						if (aa(e, n), n === (r = e.lastSuspendedTime) && (e.nextKnownPendingLevel = Li(i)), ai && ((i = e.lastPingedTime) === 0 || i >= n)) {
							e.lastPingedTime = n, Oi(e, n);
							break;
						}
						if ((i = Ci(e)) !== 0 && i !== n) break;
						if (r !== 0 && r !== n) {
							e.lastPingedTime = r;
							break;
						}
						if (ni === 1073741823 ? ti === 1073741823 ? r = 0 : (r = 10 * (1073741821 - ti) - 5e3, 0 > (r = (i = nt()) - r) && (r = 0), (n = 10 * (1073741821 - n) - i) < (r = (120 > r ? 120 : 480 > r ? 480 : 1080 > r ? 1080 : 1920 > r ? 1920 : 3e3 > r ? 3e3 : 4320 > r ? 4320 : 1960 * Ir(r / 1960)) - r) && (r = n)) : r = 10 * (1073741821 - ni) - nt(), 10 < r) {
							e.timeoutHandle = se(Ri.bind(null, e), r);
							break;
						}
						Ri(e);
						break;
					case Jr:
						if (ti !== 1073741823 && ri !== null) {
							a = ti;
							var s = ri;
							if (0 >= (r = 0 | s.busyMinDurationMs) ? r = 0 : (i = 0 | s.busyDelayMs, r = (a = nt() - (10 * (1073741821 - a) - (0 | s.timeoutMs || 5e3))) <= i ? 0 : i + r - a), 10 < r) {
								aa(e, n), e.timeoutHandle = se(Ri.bind(null, e), r);
								break;
							}
						}
						Ri(e);
						break;
					default: throw Error(o(329));
				}
				if (wi(e), e.callbackNode === t) return Ti.bind(null, e);
			}
		}
		return null;
	}
	function Ei(e) {
		var t = e.lastExpiredTime;
		if (t = t === 0 ? 1073741823 : t, e.finishedExpirationTime === t) Ri(e);
		else {
			if ((Yr & (Vr | Hr)) !== zr) throw Error(o(327));
			if (Vi(), e === Xr && t === Qr || Oi(e, t), Zr !== null) {
				var n = Yr;
				Yr |= Vr;
				for (var r = Ai();;) try {
					Ni();
					break;
				} catch (t) {
					ki(e, t);
				}
				if (yt(), Yr = n, Lr.current = r, $r === Wr) throw n = ei, Oi(e, t), aa(e, t), wi(e), n;
				if (Zr !== null) throw Error(o(261));
				e.finishedWork = e.current.alternate, e.finishedExpirationTime = t, Xr = null, Ri(e), wi(e);
			}
		}
		return null;
	}
	function Di(e, t) {
		if ((Yr & (Vr | Hr)) !== zr) throw Error(o(187));
		var n = Yr;
		Yr |= 1;
		try {
			return at(99, e.bind(null, t));
		} finally {
			Yr = n, ct();
		}
	}
	function Oi(e, t) {
		e.finishedWork = null, e.finishedExpirationTime = 0;
		var n = e.timeoutHandle;
		if (n !== le && (e.timeoutHandle = le, ce(n)), Zr !== null) for (n = Zr.return; n !== null;) {
			var r = n;
			switch (r.tag) {
				case 1:
					r.type.childContextTypes != null && Me();
					break;
				case 3:
					rn(), Ne();
					break;
				case 5:
					on(r);
					break;
				case 4:
					rn();
					break;
				case 13:
				case 19:
					we(sn);
					break;
				case 10: xt(r);
			}
			n = n.return;
		}
		Xr = e, Zr = Qi(e.current, null), Qr = t, $r = Ur, ei = null, ni = ti = 1073741823, ri = null, ii = 0, ai = !1;
	}
	function ki(e, t) {
		for (;;) {
			try {
				if (yt(), On(), Zr === null || Zr.return === null) return $r = Wr, ei = t, null;
				e: {
					var n = e, r = Zr.return, i = Zr, a = t;
					if (t = Qr, i.effectTag |= 2048, i.firstEffect = i.lastEffect = null, typeof a == "object" && a && typeof a.then == "function") {
						var o = a, s = (1 & sn.current) != 0, c = r;
						do {
							var l;
							if (l = c.tag === 13) {
								var u = c.memoizedState;
								if (u !== null) l = u.dehydrated !== null;
								else {
									var d = c.memoizedProps;
									l = d.fallback !== void 0 && (!0 !== d.unstable_avoidThisFallback || !s);
								}
							}
							if (l) {
								var f = c.updateQueue;
								if (f === null) {
									var p = /* @__PURE__ */ new Set();
									p.add(o), c.updateQueue = p;
								} else f.add(o);
								if (!(2 & c.mode)) {
									if (c.effectTag |= 64, i.effectTag &= -2981, i.tag === 1) if (i.alternate === null) i.tag = 17;
									else {
										var m = Ot(1073741823, null);
										m.tag = 2, At(i, m);
									}
									i.expirationTime = 1073741823;
									break e;
								}
								a = void 0, i = t;
								var h = n.pingCache;
								if (h === null ? (h = n.pingCache = new Mr(), a = /* @__PURE__ */ new Set(), h.set(o, a)) : (a = h.get(o)) === void 0 && (a = /* @__PURE__ */ new Set(), h.set(o, a)), !a.has(i)) {
									a.add(i);
									var g = Gi.bind(null, n, o, i);
									o.then(g, g);
								}
								c.effectTag |= 4096, c.expirationTime = t;
								break e;
							}
							c = c.return;
						} while (c !== null);
						a = Error((w(i.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + B(i));
					}
					$r !== Jr && ($r = Gr), a = vr(a, i), c = r;
					do {
						switch (c.tag) {
							case 3:
								o = a, c.effectTag |= 4096, c.expirationTime = t, jt(c, Nr(c, o, t));
								break e;
							case 1:
								o = a;
								var _ = c.type, v = c.stateNode;
								if (!(64 & c.effectTag) && (typeof _.getDerivedStateFromError == "function" || v !== null && typeof v.componentDidCatch == "function" && (di === null || !di.has(v)))) {
									c.effectTag |= 4096, c.expirationTime = t, jt(c, Pr(c, o, t));
									break e;
								}
						}
						c = c.return;
					} while (c !== null);
				}
				Zr = Ii(Zr);
			} catch (e) {
				t = e;
				continue;
			}
			break;
		}
	}
	function Ai() {
		var e = Lr.current;
		return Lr.current = Gn, e === null ? Gn : e;
	}
	function ji(e, t) {
		e < ti && 2 < e && (ti = e), t !== null && e < ni && 2 < e && (ni = e, ri = t);
	}
	function Mi(e) {
		e > ii && (ii = e);
	}
	function Ni() {
		for (; Zr !== null;) Zr = Fi(Zr);
	}
	function Pi() {
		for (; Zr !== null && !Ve();) Zr = Fi(Zr);
	}
	function Fi(e) {
		var t = Fr(e.alternate, e, Qr);
		return e.memoizedProps = e.pendingProps, t === null && (t = Ii(e)), Rr.current = null, t;
	}
	function Ii(e) {
		Zr = e;
		do {
			var t = Zr.alternate;
			if (e = Zr.return, !(2048 & Zr.effectTag)) {
				e: {
					var n = t, r = Qr, i = (t = Zr).pendingProps;
					switch (t.tag) {
						case 2:
						case 16:
						case 15:
						case 0:
						case 11:
						case 7:
						case 8:
						case 12:
						case 9:
						case 14:
						case 20:
						case 21: break;
						case 1:
						case 17:
							je(t.type) && Me();
							break;
						case 3:
							rn(), Ne(), (i = t.stateNode).pendingContext && (i.context = i.pendingContext, i.pendingContext = null), n === null || n.child, or(t);
							break;
						case 5:
							on(t);
							var a = tn(en.current);
							if (r = t.type, n !== null && t.stateNode != null) sr(n, t, r, i, a), n.ref !== t.ref && (t.effectTag |= 128);
							else if (i) {
								n = tn(Qt.current);
								var s = te(r, i, a, n, t);
								ar(s, t, !1, !1), t.stateNode = s, re(s, r, i, a, n) && hr(t), t.ref !== null && (t.effectTag |= 128);
							} else if (t.stateNode === null) throw Error(o(166));
							break;
						case 6:
							if (n && t.stateNode != null) cr(n, t, n.memoizedProps, i);
							else {
								if (typeof i != "string" && t.stateNode === null) throw Error(o(166));
								n = tn(en.current), a = tn(Qt.current), t.stateNode = oe(i, n, a, t);
							}
							break;
						case 13:
							if (we(sn), i = t.memoizedState, 64 & t.effectTag) {
								t.expirationTime = r;
								break e;
							}
							i = i !== null, a = !1, n === null ? t.memoizedProps.fallback : (a = (r = n.memoizedState) !== null, i || r === null || (r = n.child.sibling) !== null && ((s = t.firstEffect) === null ? (t.firstEffect = t.lastEffect = r, r.nextEffect = null) : (t.firstEffect = r, r.nextEffect = s), r.effectTag = 8)), i && !a && 2 & t.mode && (n === null && !0 !== t.memoizedProps.unstable_avoidThisFallback || 1 & sn.current ? $r === Ur && ($r = Kr) : ($r !== Ur && $r !== Kr || ($r = qr), ii !== 0 && Xr !== null && (aa(Xr, Qr), oa(Xr, ii)))), (i || a) && (t.effectTag |= 4);
							break;
						case 4:
							rn(), or(t);
							break;
						case 10:
							xt(t);
							break;
						case 19:
							if (we(sn), (i = t.memoizedState) === null) break;
							if (a = (64 & t.effectTag) != 0, (s = i.rendering) === null) {
								if (a) gr(i, !1);
								else if ($r !== Ur || n !== null && 64 & n.effectTag) for (n = t.child; n !== null;) {
									if ((s = cn(n)) !== null) {
										for (t.effectTag |= 64, gr(i, !1), (n = s.updateQueue) !== null && (t.updateQueue = n, t.effectTag |= 4), i.lastEffect === null && (t.firstEffect = null), t.lastEffect = i.lastEffect, n = r, i = t.child; i !== null;) r = n, (a = i).effectTag &= 2, a.nextEffect = null, a.firstEffect = null, a.lastEffect = null, (s = a.alternate) === null ? (a.childExpirationTime = 0, a.expirationTime = r, a.child = null, a.memoizedProps = null, a.memoizedState = null, a.updateQueue = null, a.dependencies = null) : (a.childExpirationTime = s.childExpirationTime, a.expirationTime = s.expirationTime, a.child = s.child, a.memoizedProps = s.memoizedProps, a.memoizedState = s.memoizedState, a.updateQueue = s.updateQueue, r = s.dependencies, a.dependencies = r === null ? null : {
											expirationTime: r.expirationTime,
											firstContext: r.firstContext,
											responders: r.responders
										}), i = i.sibling;
										Te(sn, 1 & sn.current | 2), t = t.child;
										break e;
									}
									n = n.sibling;
								}
							} else {
								if (!a) if ((n = cn(s)) !== null) {
									if (t.effectTag |= 64, a = !0, (n = n.updateQueue) !== null && (t.updateQueue = n, t.effectTag |= 4), gr(i, !0), i.tail === null && i.tailMode === "hidden") {
										(t = t.lastEffect = i.lastEffect) !== null && (t.nextEffect = null);
										break;
									}
								} else nt() > i.tailExpiration && 1 < r && (t.effectTag |= 64, a = !0, gr(i, !1), t.expirationTime = t.childExpirationTime = r - 1);
								i.isBackwards ? (s.sibling = t.child, t.child = s) : ((n = i.last) === null ? t.child = s : n.sibling = s, i.last = s);
							}
							if (i.tail !== null) {
								i.tailExpiration === 0 && (i.tailExpiration = nt() + 500), n = i.tail, i.rendering = n, i.tail = n.sibling, i.lastEffect = t.lastEffect, n.sibling = null, i = sn.current, Te(sn, i = a ? 1 & i | 2 : 1 & i), t = n;
								break e;
							}
							break;
						default: throw Error(o(156, t.tag));
					}
					t = null;
				}
				if (n = Zr, Qr === 1 || n.childExpirationTime !== 1) {
					for (i = 0, a = n.child; a !== null;) (r = a.expirationTime) > i && (i = r), (s = a.childExpirationTime) > i && (i = s), a = a.sibling;
					n.childExpirationTime = i;
				}
				if (t !== null) return t;
				e !== null && !(2048 & e.effectTag) && (e.firstEffect === null && (e.firstEffect = Zr.firstEffect), Zr.lastEffect !== null && (e.lastEffect !== null && (e.lastEffect.nextEffect = Zr.firstEffect), e.lastEffect = Zr.lastEffect), 1 < Zr.effectTag && (e.lastEffect === null ? e.firstEffect = Zr : e.lastEffect.nextEffect = Zr, e.lastEffect = Zr));
			} else {
				if ((t = _r(Zr)) !== null) return t.effectTag &= 2047, t;
				e !== null && (e.firstEffect = e.lastEffect = null, e.effectTag |= 2048);
			}
			if ((t = Zr.sibling) !== null) return t;
			Zr = e;
		} while (Zr !== null);
		return $r === Ur && ($r = Jr), null;
	}
	function Li(e) {
		var t = e.expirationTime;
		return t > (e = e.childExpirationTime) ? t : e;
	}
	function Ri(e) {
		var t = rt();
		return at(99, zi.bind(null, e, t)), null;
	}
	function zi(e, t) {
		if (Vi(), (Yr & (Vr | Hr)) !== zr) throw Error(o(327));
		var n = e.finishedWork, r = e.finishedExpirationTime;
		if (n === null) return null;
		if (e.finishedWork = null, e.finishedExpirationTime = 0, n === e.current) throw Error(o(177));
		e.callbackNode = null, e.callbackExpirationTime = 0, e.callbackPriority = 90, e.nextKnownPendingLevel = 0;
		var i = Li(n);
		if (e.firstPendingTime = i, r <= e.lastSuspendedTime ? e.firstSuspendedTime = e.lastSuspendedTime = e.nextKnownPendingLevel = 0 : r <= e.firstSuspendedTime && (e.firstSuspendedTime = r - 1), r <= e.lastPingedTime && (e.lastPingedTime = 0), r <= e.lastExpiredTime && (e.lastExpiredTime = 0), e === Xr && (Zr = Xr = null, Qr = 0), 1 < n.effectTag ? n.lastEffect === null ? i = n : (n.lastEffect.nextEffect = n, i = n.firstEffect) : i = n.firstEffect, i !== null) {
			var a = Yr;
			Yr |= Hr, Rr.current = null, M(e.containerInfo), ci = i;
			do
				try {
					Bi();
				} catch (e) {
					if (ci === null) throw Error(o(330));
					Wi(ci, e), ci = ci.nextEffect;
				}
			while (ci !== null);
			ci = i;
			do
				try {
					for (var s = e, c = t; ci !== null;) {
						var l = ci.effectTag;
						if (16 & l && N && ge(ci.stateNode), 128 & l) {
							var u = ci.alternate;
							if (u !== null) {
								var d = u.ref;
								d !== null && (typeof d == "function" ? d(null) : d.current = null);
							}
						}
						switch (1038 & l) {
							case 2:
								Or(ci), ci.effectTag &= -3;
								break;
							case 6:
								Or(ci), ci.effectTag &= -3, Ar(ci.alternate, ci);
								break;
							case 1024:
								ci.effectTag &= -1025;
								break;
							case 1028:
								ci.effectTag &= -1025, Ar(ci.alternate, ci);
								break;
							case 4:
								Ar(ci.alternate, ci);
								break;
							case 8:
								var f = s, p = ci, m = c;
								N ? kr(f, p, m) : Tr(f, p, m), Er(p);
						}
						ci = ci.nextEffect;
					}
				} catch (e) {
					if (ci === null) throw Error(o(330));
					Wi(ci, e), ci = ci.nextEffect;
				}
			while (ci !== null);
			ee(e.containerInfo), e.current = n, ci = i;
			do
				try {
					for (l = r; ci !== null;) {
						var h = ci.effectTag;
						if (36 & h) {
							var g = ci.alternate;
							switch (d = l, (u = ci).tag) {
								case 0:
								case 11:
								case 15:
									Cr(16, 32, u);
									break;
								case 1:
									var _ = u.stateNode;
									if (4 & u.effectTag) if (g === null) _.componentDidMount();
									else {
										var v = u.elementType === u.type ? g.memoizedProps : ht(u.type, g.memoizedProps);
										_.componentDidUpdate(v, g.memoizedState, _.__reactInternalSnapshotBeforeUpdate);
									}
									var y = u.updateQueue;
									y !== null && Ft(0, y, _);
									break;
								case 3:
									var b = u.updateQueue;
									if (b !== null) {
										if (s = null, u.child !== null) switch (u.child.tag) {
											case 5:
												s = k(u.child.stateNode);
												break;
											case 1: s = u.child.stateNode;
										}
										Ft(0, b, s);
									}
									break;
								case 5:
									var x = u.stateNode;
									g === null && 4 & u.effectTag && pe(x, u.type, u.memoizedProps, u);
									break;
								case 6:
								case 4:
								case 12:
								case 19:
								case 17:
								case 20:
								case 21: break;
								case 13:
									P && u.memoizedState;
									break;
								default: throw Error(o(163));
							}
						}
						if (128 & h) {
							u = void 0;
							var S = ci.ref;
							if (S !== null) {
								var C = ci.stateNode;
								u = ci.tag === 5 ? k(C) : C, typeof S == "function" ? S(u) : S.current = u;
							}
						}
						ci = ci.nextEffect;
					}
				} catch (e) {
					if (ci === null) throw Error(o(330));
					Wi(ci, e), ci = ci.nextEffect;
				}
			while (ci !== null);
			ci = null, Ze(), Yr = a;
		} else e.current = n;
		if (fi) fi = !1, pi = e, mi = t;
		else for (ci = i; ci !== null;) t = ci.nextEffect, ci.nextEffect = null, ci = t;
		if ((t = e.firstPendingTime) === 0 && (di = null), t === 1073741823 ? e === _i ? gi++ : (gi = 0, _i = e) : gi = 0, typeof qi == "function" && qi(n.stateNode, r), wi(e), li) throw li = !1, e = ui, ui = null, e;
		return (Yr & Br) !== zr || ct(), null;
	}
	function Bi() {
		for (; ci !== null;) {
			var e = ci.effectTag;
			256 & e && Sr(ci.alternate, ci), !(512 & e) || fi || (fi = !0, ot(97, (function() {
				return Vi(), null;
			}))), ci = ci.nextEffect;
		}
	}
	function Vi() {
		if (mi !== 90) {
			var e = 97 < mi ? 97 : mi;
			return mi = 90, at(e, Hi);
		}
	}
	function Hi() {
		if (pi === null) return !1;
		var e = pi;
		if (pi = null, (Yr & (Vr | Hr)) !== zr) throw Error(o(331));
		var t = Yr;
		for (Yr |= Hr, e = e.current.firstEffect; e !== null;) {
			try {
				var n = e;
				if (512 & n.effectTag) switch (n.tag) {
					case 0:
					case 11:
					case 15: Cr(128, 0, n), Cr(0, 64, n);
				}
			} catch (t) {
				if (e === null) throw Error(o(330));
				Wi(e, t);
			}
			n = e.nextEffect, e.nextEffect = null, e = n;
		}
		return Yr = t, ct(), !0;
	}
	function Ui(e, t, n) {
		At(e, t = Nr(e, t = vr(n, t), 1073741823)), (e = Si(e, 1073741823)) !== null && wi(e);
	}
	function Wi(e, t) {
		if (e.tag === 3) Ui(e, e, t);
		else for (var n = e.return; n !== null;) {
			if (n.tag === 3) {
				Ui(n, e, t);
				break;
			}
			if (n.tag === 1) {
				var r = n.stateNode;
				if (typeof n.type.getDerivedStateFromError == "function" || typeof r.componentDidCatch == "function" && (di === null || !di.has(r))) {
					At(n, e = Pr(n, e = vr(t, e), 1073741823)), (n = Si(n, 1073741823)) !== null && wi(n);
					break;
				}
			}
			n = n.return;
		}
	}
	function Gi(e, t, n) {
		var r = e.pingCache;
		r !== null && r.delete(t), Xr === e && Qr === n ? $r === qr || $r === Kr && ti === 1073741823 && nt() - oi < si ? Oi(e, Qr) : ai = !0 : ia(e, n) && ((t = e.lastPingedTime) !== 0 && t < n || (e.lastPingedTime = n, e.finishedExpirationTime === n && (e.finishedExpirationTime = 0, e.finishedWork = null), wi(e)));
	}
	function Ki(e, t) {
		var n = e.stateNode;
		n !== null && n.delete(t), (t = 0) == 0 && (t = bi(t = yi(), e, null)), (e = Si(e, t)) !== null && wi(e);
	}
	Fr = function(e, t, n) {
		var r = t.expirationTime;
		if (e !== null) {
			var i = t.pendingProps;
			if (e.memoizedProps !== i || Oe.current) Yn = !0;
			else {
				if (r < n) {
					switch (Yn = !1, t.tag) {
						case 3:
							ir(t);
							break;
						case 5:
							if (an(t), 4 & t.mode && n !== 1 && null(t.type, i)) return t.expirationTime = t.childExpirationTime = 1, null;
							break;
						case 1:
							je(t.type) && Ie(t);
							break;
						case 4:
							nn(t, t.stateNode.containerInfo);
							break;
						case 10:
							bt(t, t.memoizedProps.value);
							break;
						case 13:
							if (t.memoizedState !== null) return (r = t.child.childExpirationTime) !== 0 && r >= n ? ur(e, t, n) : (Te(sn, 1 & sn.current), (t = mr(e, t, n)) === null ? null : t.sibling);
							Te(sn, 1 & sn.current);
							break;
						case 19:
							if (r = t.childExpirationTime >= n, 64 & e.effectTag) {
								if (r) return pr(e, t, n);
								t.effectTag |= 64;
							}
							if ((i = t.memoizedState) !== null && (i.rendering = null, i.tail = null), Te(sn, sn.current), !r) return null;
					}
					return mr(e, t, n);
				}
				Yn = !1;
			}
		} else Yn = !1;
		switch (t.expirationTime = 0, t.tag) {
			case 2:
				if (r = t.type, e !== null && (e.alternate = null, t.alternate = null, t.effectTag |= 2), e = t.pendingProps, i = Ae(t, De.current), Ct(t, n), i = Dn(null, t, r, e, i, n), t.effectTag |= 1, typeof i == "object" && i && typeof i.render == "function" && i.$$typeof === void 0) {
					if (t.tag = 1, On(), je(r)) {
						var a = !0;
						Ie(t);
					} else a = !1;
					t.memoizedState = i.state !== null && i.state !== void 0 ? i.state : null;
					var s = r.getDerivedStateFromProps;
					typeof s == "function" && zt(t, r, s, e), i.updater = Bt, t.stateNode = i, i._reactInternalFiber = t, Wt(t, r, e, n), t = rr(null, t, r, !0, a, n);
				} else t.tag = 0, Xn(null, t, i, n), t = t.child;
				return t;
			case 16:
				if (i = t.elementType, e !== null && (e.alternate = null, t.alternate = null, t.effectTag |= 2), e = t.pendingProps, function(e) {
					if (e._status === -1) {
						e._status = 0;
						var t = e._ctor;
						t = t(), e._result = t, t.then((function(t) {
							e._status === 0 && (t = t.default, e._status = 1, e._result = t);
						}), (function(t) {
							e._status === 0 && (e._status = 2, e._result = t);
						}));
					}
				}(i), i._status !== 1) throw i._result;
				switch (i = i._result, t.type = i, a = t.tag = function(e) {
					if (typeof e == "function") return +!!Zi(e);
					if (e != null) {
						if ((e = e.$$typeof) === _) return 11;
						if (e === b) return 14;
					}
					return 2;
				}(i), e = ht(i, e), a) {
					case 0:
						t = tr(null, t, i, e, n);
						break;
					case 1:
						t = nr(null, t, i, e, n);
						break;
					case 11:
						t = Zn(null, t, i, e, n);
						break;
					case 14:
						t = Qn(null, t, i, ht(i.type, e), r, n);
						break;
					default: throw Error(o(306, i, ""));
				}
				return t;
			case 0: return r = t.type, i = t.pendingProps, tr(e, t, r, i = t.elementType === r ? i : ht(r, i), n);
			case 1: return r = t.type, i = t.pendingProps, nr(e, t, r, i = t.elementType === r ? i : ht(r, i), n);
			case 3:
				if (ir(t), (r = t.updateQueue) === null) throw Error(o(282));
				if (i = (i = t.memoizedState) === null ? null : i.element, Pt(t, r, t.pendingProps, null, n), (r = t.memoizedState.element) === i) t = mr(e, t, n);
				else {
					if ((i = t.stateNode.hydrate) && (i = !1), i) for (n = Xt(t, null, r, n), t.child = n; n;) n.effectTag = -3 & n.effectTag | 1024, n = n.sibling;
					else Xn(e, t, r, n);
					t = t.child;
				}
				return t;
			case 5: return an(t), r = t.type, i = t.pendingProps, a = e === null ? null : e.memoizedProps, s = i.children, ae(r, i) ? s = null : a !== null && ae(r, a) && (t.effectTag |= 16), er(e, t), 4 & t.mode && n !== 1 && null(r, i) ? (t.expirationTime = t.childExpirationTime = 1, t = null) : (Xn(e, t, s, n), t = t.child), t;
			case 6: return null;
			case 13: return ur(e, t, n);
			case 4: return nn(t, t.stateNode.containerInfo), r = t.pendingProps, e === null ? t.child = Yt(t, null, r, n) : Xn(e, t, r, n), t.child;
			case 11: return r = t.type, i = t.pendingProps, Zn(e, t, r, i = t.elementType === r ? i : ht(r, i), n);
			case 7: return Xn(e, t, t.pendingProps, n), t.child;
			case 8:
			case 12: return Xn(e, t, t.pendingProps.children, n), t.child;
			case 10:
				e: {
					if (r = t.type._context, i = t.pendingProps, s = t.memoizedProps, bt(t, a = i.value), s !== null) {
						var c = s.value;
						if ((a = ft(c, a) ? 0 : 0 | (typeof r._calculateChangedBits == "function" ? r._calculateChangedBits(c, a) : 1073741823)) == 0) {
							if (s.children === i.children && !Oe.current) {
								t = mr(e, t, n);
								break e;
							}
						} else for ((c = t.child) !== null && (c.return = t); c !== null;) {
							var l = c.dependencies;
							if (l !== null) {
								s = c.child;
								for (var u = l.firstContext; u !== null;) {
									if (u.context === r && (u.observedBits & a) != 0) {
										c.tag === 1 && ((u = Ot(n, null)).tag = 2, At(c, u)), c.expirationTime < n && (c.expirationTime = n), (u = c.alternate) !== null && u.expirationTime < n && (u.expirationTime = n), St(c.return, n), l.expirationTime < n && (l.expirationTime = n);
										break;
									}
									u = u.next;
								}
							} else s = c.tag === 10 && c.type === t.type ? null : c.child;
							if (s !== null) s.return = c;
							else for (s = c; s !== null;) {
								if (s === t) {
									s = null;
									break;
								}
								if ((c = s.sibling) !== null) {
									c.return = s.return, s = c;
									break;
								}
								s = s.return;
							}
							c = s;
						}
					}
					Xn(e, t, i.children, n), t = t.child;
				}
				return t;
			case 9: return i = t.type, r = (a = t.pendingProps).children, Ct(t, n), r = r(i = wt(i, a.unstable_observedBits)), t.effectTag |= 1, Xn(e, t, r, n), t.child;
			case 14: return a = ht(i = t.type, t.pendingProps), Qn(e, t, i, a = ht(i.type, a), r, n);
			case 15: return $n(e, t, t.type, t.pendingProps, r, n);
			case 17: return r = t.type, i = t.pendingProps, i = t.elementType === r ? i : ht(r, i), e !== null && (e.alternate = null, t.alternate = null, t.effectTag |= 2), t.tag = 1, je(r) ? (e = !0, Ie(t)) : e = !1, Ct(t, n), Ht(t, r, i), Wt(t, r, i, n), rr(null, t, r, !0, e, n);
			case 19: return pr(e, t, n);
		}
		throw Error(o(156, t.tag));
	};
	var qi = null, Ji = null;
	function Yi(e, t, n, r) {
		this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.effectTag = 0, this.lastEffect = this.firstEffect = this.nextEffect = null, this.childExpirationTime = this.expirationTime = 0, this.alternate = null;
	}
	function Xi(e, t, n, r) {
		return new Yi(e, t, n, r);
	}
	function Zi(e) {
		return !(!(e = e.prototype) || !e.isReactComponent);
	}
	function Qi(e, t) {
		var n = e.alternate;
		return n === null ? ((n = Xi(e.tag, t, e.key, e.mode)).elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.effectTag = 0, n.nextEffect = null, n.firstEffect = null, n.lastEffect = null), n.childExpirationTime = e.childExpirationTime, n.expirationTime = e.expirationTime, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = t === null ? null : {
			expirationTime: t.expirationTime,
			firstContext: t.firstContext,
			responders: t.responders
		}, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n;
	}
	function $i(e, t, n, r, i, a) {
		var s = 2;
		if (r = e, typeof e == "function") Zi(e) && (s = 1);
		else if (typeof e == "string") s = 5;
		else e: switch (e) {
			case d: return ea(n.children, i, a, t);
			case g:
				s = 8, i |= 7;
				break;
			case f:
				s = 8, i |= 1;
				break;
			case p: return (e = Xi(12, n, t, 8 | i)).elementType = p, e.type = p, e.expirationTime = a, e;
			case v: return (e = Xi(13, n, t, i)).type = v, e.elementType = v, e.expirationTime = a, e;
			case y: return (e = Xi(19, n, t, i)).elementType = y, e.expirationTime = a, e;
			default:
				if (typeof e == "object" && e) switch (e.$$typeof) {
					case m:
						s = 10;
						break e;
					case h:
						s = 9;
						break e;
					case _:
						s = 11;
						break e;
					case b:
						s = 14;
						break e;
					case x:
						s = 16, r = null;
						break e;
				}
				throw Error(o(130, e == null ? e : typeof e, ""));
		}
		return (t = Xi(s, n, t, i)).elementType = e, t.type = r, t.expirationTime = a, t;
	}
	function ea(e, t, n, r) {
		return (e = Xi(7, e, r, t)).expirationTime = n, e;
	}
	function ta(e, t, n) {
		return (e = Xi(6, e, null, t)).expirationTime = n, e;
	}
	function na(e, t, n) {
		return (t = Xi(4, e.children === null ? [] : e.children, e.key, t)).expirationTime = n, t.stateNode = {
			containerInfo: e.containerInfo,
			pendingChildren: null,
			implementation: e.implementation
		}, t;
	}
	function ra(e, t, n) {
		this.tag = t, this.current = null, this.containerInfo = e, this.pingCache = this.pendingChildren = null, this.finishedExpirationTime = 0, this.finishedWork = null, this.timeoutHandle = le, this.pendingContext = this.context = null, this.hydrate = n, this.callbackNode = null, this.callbackPriority = 90, this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
	}
	function ia(e, t) {
		var n = e.firstSuspendedTime;
		return e = e.lastSuspendedTime, n !== 0 && n >= t && e <= t;
	}
	function aa(e, t) {
		var n = e.firstSuspendedTime, r = e.lastSuspendedTime;
		n < t && (e.firstSuspendedTime = t), (r > t || n === 0) && (e.lastSuspendedTime = t), t <= e.lastPingedTime && (e.lastPingedTime = 0), t <= e.lastExpiredTime && (e.lastExpiredTime = 0);
	}
	function oa(e, t) {
		t > e.firstPendingTime && (e.firstPendingTime = t);
		var n = e.firstSuspendedTime;
		n !== 0 && (t >= n ? e.firstSuspendedTime = e.lastSuspendedTime = e.nextKnownPendingLevel = 0 : t >= e.lastSuspendedTime && (e.lastSuspendedTime = t + 1), t > e.nextKnownPendingLevel && (e.nextKnownPendingLevel = t));
	}
	function sa(e, t) {
		var n = e.lastExpiredTime;
		(n === 0 || n > t) && (e.lastExpiredTime = t);
	}
	function ca(e) {
		var t = e._reactInternalFiber;
		if (t === void 0) throw typeof e.render == "function" ? Error(o(188)) : Error(o(268, Object.keys(e)));
		return (e = O(t)) === null ? null : e.stateNode;
	}
	function la(e, t) {
		(e = e.memoizedState) !== null && e.dehydrated !== null && e.retryTime < t && (e.retryTime = t);
	}
	function ua(e, t) {
		la(e, t), (e = e.alternate) && la(e, t);
	}
	var da = {
		createContainer: function(e, t, n) {
			return e = new ra(e, t, n), t = Xi(3, null, null, t === 2 ? 7 : t === 1 ? 3 : 0), e.current = t, t.stateNode = e;
		},
		updateContainer: function(e, t, n, r) {
			var i = t.current, a = yi(), s = Lt.suspense;
			a = bi(a, i, s);
			e: if (n) {
				t: {
					if (T(n = n._reactInternalFiber) !== n || n.tag !== 1) throw Error(o(170));
					var c = n;
					do {
						switch (c.tag) {
							case 3:
								c = c.stateNode.context;
								break t;
							case 1: if (je(c.type)) {
								c = c.stateNode.__reactInternalMemoizedMergedChildContext;
								break t;
							}
						}
						c = c.return;
					} while (c !== null);
					throw Error(o(171));
				}
				if (n.tag === 1) {
					var l = n.type;
					if (je(l)) {
						n = Fe(n, l, c);
						break e;
					}
				}
				n = c;
			} else n = Ee;
			return t.context === null ? t.context = n : t.pendingContext = n, (t = Ot(a, s)).payload = { element: e }, (r = r === void 0 ? null : r) !== null && (t.callback = r), At(i, t), xi(i, a), a;
		},
		batchedEventUpdates: function(e, t) {
			var n = Yr;
			Yr |= 2;
			try {
				return e(t);
			} finally {
				(Yr = n) === zr && ct();
			}
		},
		batchedUpdates: function(e, t) {
			var n = Yr;
			Yr |= 1;
			try {
				return e(t);
			} finally {
				(Yr = n) === zr && ct();
			}
		},
		unbatchedUpdates: function(e, t) {
			var n = Yr;
			Yr &= -2, Yr |= Br;
			try {
				return e(t);
			} finally {
				(Yr = n) === zr && ct();
			}
		},
		deferredUpdates: function(e) {
			return at(97, e);
		},
		syncUpdates: function(e, t, n, r) {
			return at(99, e.bind(null, t, n, r));
		},
		discreteUpdates: function(e, t, n, r) {
			var i = Yr;
			Yr |= 4;
			try {
				return at(98, e.bind(null, t, n, r));
			} finally {
				(Yr = i) === zr && ct();
			}
		},
		flushDiscreteUpdates: function() {
			(Yr & (1 | Vr | Hr)) === zr && (function() {
				if (hi !== null) {
					var e = hi;
					hi = null, e.forEach((function(e, t) {
						sa(t, e), wi(t);
					})), ct();
				}
			}(), Vi());
		},
		flushControlled: function(e) {
			var t = Yr;
			Yr |= 1;
			try {
				at(99, e);
			} finally {
				(Yr = t) === zr && ct();
			}
		},
		flushSync: Di,
		flushPassiveEffects: Vi,
		IsThisRendererActing: { current: !1 },
		getPublicRootInstance: function(e) {
			return (e = e.current).child ? e.child.tag === 5 ? k(e.child.stateNode) : e.child.stateNode : null;
		},
		attemptSynchronousHydration: function(e) {
			switch (e.tag) {
				case 3:
					var t = e.stateNode;
					t.hydrate && function(e, t) {
						sa(e, t), wi(e), (Yr & (Vr | Hr)) === zr && ct();
					}(t, t.firstPendingTime);
					break;
				case 13: Di((function() {
					return xi(e, 1073741823);
				})), t = dt(yi(), 150, 100), ua(e, t);
			}
		},
		attemptUserBlockingHydration: function(e) {
			if (e.tag === 13) {
				var t = dt(yi(), 150, 100);
				xi(e, t), ua(e, t);
			}
		},
		attemptContinuousHydration: function(e) {
			if (e.tag === 13) {
				yi();
				var t = ut++;
				xi(e, t), ua(e, t);
			}
		},
		attemptHydrationAtCurrentPriority: function(e) {
			if (e.tag === 13) {
				var t = yi();
				xi(e, t = bi(t, e, null)), ua(e, t);
			}
		},
		findHostInstance: ca,
		findHostInstanceWithWarning: function(e) {
			return ca(e);
		},
		findHostInstanceWithNoPortals: function(e) {
			return (e = function(e) {
				if (!(e = D(e))) return null;
				for (var t = e;;) {
					if (t.tag === 5 || t.tag === 6) return t;
					if (t.child && t.tag !== 4) t.child.return = t, t = t.child;
					else {
						if (t === e) break;
						for (; !t.sibling;) {
							if (!t.return || t.return === e) return null;
							t = t.return;
						}
						t.sibling.return = t.return, t = t.sibling;
					}
				}
				return null;
			}(e)) === null ? null : e.tag === 20 ? e.stateNode.instance : e.stateNode;
		},
		shouldSuspend: function() {
			return !1;
		},
		injectIntoDevTools: function(e) {
			var t = e.findFiberByHostInstance;
			return function(e) {
				if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u") return !1;
				var t = __REACT_DEVTOOLS_GLOBAL_HOOK__;
				if (t.isDisabled || !t.supportsFiber) return !0;
				try {
					var n = t.inject(e);
					qi = function(e) {
						try {
							t.onCommitFiberRoot(n, e, void 0, (64 & e.current.effectTag) == 64);
						} catch {}
					}, Ji = function(e) {
						try {
							t.onCommitFiberUnmount(n, e);
						} catch {}
					};
				} catch {}
				return !0;
			}(r({}, e, {
				overrideHookState: null,
				overrideProps: null,
				setSuspenseHandler: null,
				scheduleUpdate: null,
				currentDispatcherRef: s.ReactCurrentDispatcher,
				findHostInstanceByFiber: function(e) {
					return (e = O(e)) === null ? null : e.stateNode;
				},
				findFiberByHostInstance: function(e) {
					return t ? t(e) : null;
				},
				findHostInstancesForRefresh: null,
				scheduleRefresh: null,
				scheduleRoot: null,
				setRefreshHandler: null,
				getCurrentFiber: null
			}));
		}
	};
	M8.exports = da.default || da;
	var fa = M8.exports;
	return M8.exports = e, fa;
}, iae(N8.exports);
var sae = (e, t) => {
	let n = Object.keys(e), r = Object.keys(t);
	if (n.length !== r.length) return !1;
	for (let r = 0; r < n.length; r += 1) {
		let i = n[r];
		if (i === "render" && !e[i] != !t[i]) return !1;
		if (i !== "children" && e[i] !== t[i]) {
			if (typeof e[i] == "object" && typeof t[i] == "object" && sae(e[i], t[i])) continue;
			return !1;
		}
		if (i === "children" && (typeof e[i] == "string" || typeof t[i] == "string")) return e[i] === t[i];
	}
	return !0;
};
t.version.startsWith("19");
var { version: cae } = { version: "4.3.0" }, lae = new Zq(), uae = { create: (e) => e };
({ ...kte });
//#endregion
//#region src/pdf-render/initialize-font.ts
var P8 = (e) => {
	e.register({
		family: "Inter",
		src: "https://fonts.gstatic.com/s/inter/v18/UcCO3FwrK3iLTeHuS_nVMrMxCp50yjIw2boKoduKmMEVuLyfMZg.ttf"
	}), e.register({
		family: "Inter-SemiBold",
		src: "https://fonts.gstatic.com/s/inter/v18/UcCO3FwrK3iLTeHuS_nVMrMxCp50yjIw2boKoduKmMEVuGKYMZg.ttf"
	});
}, dae = ({ size: e = "A4", style: n, title: r, ...i }) => {
	t.useEffect(() => {
		P8(lae);
	}, []);
	let a = {
		paddingLeft: "2.5cm",
		paddingRight: "2.5cm",
		paddingTop: "1.15cm",
		paddingBottom: "1.30cm"
	}, o = (Array.isArray(n) ? [a, ...n] : [a, n]).filter((e) => e !== void 0);
	return /* @__PURE__ */ F(sy, {
		author: "https://api.dev.forms.reapit.com.au",
		title: r,
		creationDate: /* @__PURE__ */ new Date(),
		children: /* @__PURE__ */ F(Wv, {
			size: e,
			style: o,
			...i
		})
	});
}, F8 = uae.create({
	page: {
		flexDirection: "column",
		fontFamily: "Inter",
		color: "#222B33"
	},
	title: {
		fontSize: "20px",
		fontFamily: "Inter-SemiBold"
	},
	bold: { fontFamily: "Inter-SemiBold" },
	table: { fontSize: "10px" },
	tableHeader: {
		flexDirection: "column",
		color: "#607890"
	},
	tableBody: { flexDirection: "column" },
	tableRow: {
		flexDirection: "row",
		gap: "12px",
		paddingHorizontal: "6px",
		paddingVertical: "10px",
		borderBottomWidth: "1px",
		borderBottomColor: "#E5E9ED",
		borderBottomStyle: "solid"
	},
	tableColumn: {
		flexDirection: "column",
		gap: "2px"
	},
	tableEmptyMessage: {
		padding: "16px",
		width: "100%",
		alignSelf: "center"
	}
});
//#endregion
//#region src/pdf-render/table/index.tsx
function fae({ headers: e, rows: t, emptyMessage: n = "There's no data to display." }) {
	let r = 100 / e.filter((e) => e.width).length;
	return /* @__PURE__ */ I(Vv, {
		style: F8.table,
		children: [/* @__PURE__ */ F(Vv, {
			minPresenceAhead: 1,
			fixed: !0,
			style: F8.tableHeader,
			children: /* @__PURE__ */ F(Vv, {
				style: [F8.tableRow, F8.bold],
				children: e.map((e) => /* @__PURE__ */ F(Vv, {
					style: { width: e.width ?? `${r}%` },
					children: /* @__PURE__ */ F(Hv, { children: e.title })
				}, e.title))
			})
		}), /* @__PURE__ */ I(Vv, {
			wrap: !0,
			style: F8.tableBody,
			children: [t?.map((t, n) => /* @__PURE__ */ F(Vv, {
				wrap: !1,
				style: F8.tableRow,
				children: e.map((e) => /* @__PURE__ */ F(Vv, {
					style: {
						...F8.tableColumn,
						width: e.width ?? `${r}%`
					},
					children: e.renderText?.(t) ?? /* @__PURE__ */ F("TEXT", { children: t?.[e.key] })
				}, `row-${n}-${e.title}`))
			}, n)), !t?.length && /* @__PURE__ */ F("TEXT", {
				style: [F8.tableEmptyMessage, F8.bold],
				children: n
			})]
		})]
	});
}
//#endregion
//#region src/checkbox/style.tsx
var pae = /*#__PURE__*/ Ft("label")({
	name: "ElCheckbox",
	class: "emjdyxn",
	propsAsIs: !1
}), mae = /*#__PURE__*/ Ft("input")({
	name: "ElCheckboxInput",
	class: "e16x2b1l",
	propsAsIs: !1
}), hae = /*#__PURE__*/ Ft("div")({
	name: "ElCheckboxLabelText",
	class: "ecxiuan",
	propsAsIs: !1
}), gae = /*#__PURE__*/ Ft("div")({
	name: "ElCheckboxSupplementaryInfo",
	class: "e128ob17",
	propsAsIs: !1
}), _ae = /*#__PURE__*/ Ft("svg")({
	name: "ElCheckboxSvgIcon",
	class: "e1dxrykb",
	propsAsIs: !1
}), vae = /*#__PURE__*/ Ft("svg")({
	name: "ElCheckboxSelectedSvgIcon",
	class: "ecka9b5",
	propsAsIs: !1
}), yae = /*#__PURE__*/ Ft("svg")({
	name: "ElCheckboxRemoveAllSvgIcon",
	class: "euwv13g",
	propsAsIs: !1
}), bae = (e) => /* @__PURE__ */ F(_ae, {
	...e,
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	children: /* @__PURE__ */ F("path", {
		fill: "currentColor",
		d: "M20,2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2Zm0,18H4V4H20Z"
	})
}), xae = (e) => /* @__PURE__ */ F(vae, {
	...e,
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	children: /* @__PURE__ */ F("path", {
		fill: "currentColor",
		d: "M20,2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2ZM18,9.17l-7.07,7.07a1,1,0,0,1-.71.3,1,1,0,0,1-.7-.3L6,12.71a1,1,0,0,1,0-1.42,1,1,0,0,1,1.41,0l2.83,2.83L16.6,7.76A1,1,0,0,1,18,9.17Z"
	})
}), Sae = (e) => /* @__PURE__ */ I(yae, {
	...e,
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	children: [/* @__PURE__ */ F("path", {
		fill: "currentColor",
		d: "M20,2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2Zm0,18H4V4H20Z"
	}), /* @__PURE__ */ F("path", {
		fill: "currentColor",
		d: "M8,13h8a1,1,0,0,0,0-2H8a1,1,0,0,0,0,2Z"
	})]
}), Cae = t.forwardRef(({ className: e, asRemoveAll: t, label: n, supplementaryInfo: r, required: i, hasError: a, ...o }, s) => /* @__PURE__ */ I(pae, {
	className: Ct(e, a && "has-error"),
	children: [
		/* @__PURE__ */ F(mae, {
			type: "checkbox",
			ref: s,
			...o,
			"aria-hidden": !0
		}),
		/* @__PURE__ */ F(bae, { "aria-hidden": !0 }),
		!t && /* @__PURE__ */ F(xae, { "aria-hidden": !0 }),
		t && /* @__PURE__ */ F(Sae, { "aria-hidden": !0 }),
		(n || r) && /* @__PURE__ */ I(L, {
			isFlexColumn: !0,
			isFlexNoWrap: !0,
			children: [n && /* @__PURE__ */ F(hae, { children: T(n, i) }), r && /* @__PURE__ */ F(gae, { children: r })]
		})
	]
}));
//#endregion
//#region ../../node_modules/clsx/dist/clsx.mjs
function I8(e) {
	var t, n, r = "";
	if (typeof e == "string" || typeof e == "number") r += e;
	else if (typeof e == "object") if (Array.isArray(e)) {
		var i = e.length;
		for (t = 0; t < i; t++) e[t] && (n = I8(e[t])) && (r && (r += " "), r += n);
	} else for (n in e) e[n] && (r && (r += " "), r += n);
	return r;
}
function L8() {
	for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = I8(e)) && (r && (r += " "), r += t);
	return r;
}
//#endregion
//#region ../../node_modules/date-fns/constants.js
var wae = 365.2425, R8 = 6048e5, Tae = 864e5, z8 = 6e4, B8 = 36e5, Eae = 1e3, V8 = 3600 * 24;
V8 * 7, V8 * wae / 12 * 3;
var H8 = Symbol.for("constructDateFrom");
//#endregion
//#region ../../node_modules/date-fns/constructFrom.js
function U8(e, t) {
	return typeof e == "function" ? e(t) : e && typeof e == "object" && H8 in e ? e[H8](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
//#endregion
//#region ../../node_modules/date-fns/toDate.js
function W8(e, t) {
	return U8(t || e, e);
}
//#endregion
//#region ../../node_modules/date-fns/addDays.js
function G8(e, t, n) {
	let r = W8(e, n?.in);
	return isNaN(t) ? U8(n?.in || e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
//#endregion
//#region ../../node_modules/date-fns/addMonths.js
function K8(e, t, n) {
	let r = W8(e, n?.in);
	if (isNaN(t)) return U8(n?.in || e, NaN);
	if (!t) return r;
	let i = r.getDate(), a = U8(n?.in || e, r.getTime());
	return a.setMonth(r.getMonth() + t + 1, 0), i >= a.getDate() ? a : (r.setFullYear(a.getFullYear(), a.getMonth(), i), r);
}
//#endregion
//#region ../../node_modules/date-fns/addMilliseconds.js
function q8(e, t, n) {
	return U8(n?.in || e, +W8(e) + t);
}
//#endregion
//#region ../../node_modules/date-fns/addHours.js
function Dae(e, t, n) {
	return q8(e, t * B8, n);
}
//#endregion
//#region ../../node_modules/date-fns/_lib/defaultOptions.js
var Oae = {};
function J8() {
	return Oae;
}
//#endregion
//#region ../../node_modules/date-fns/startOfWeek.js
function Y8(e, t) {
	let n = J8(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, i = W8(e, t?.in), a = i.getDay(), o = (a < r ? 7 : 0) + a - r;
	return i.setDate(i.getDate() - o), i.setHours(0, 0, 0, 0), i;
}
//#endregion
//#region ../../node_modules/date-fns/startOfISOWeek.js
function X8(e, t) {
	return Y8(e, {
		...t,
		weekStartsOn: 1
	});
}
//#endregion
//#region ../../node_modules/date-fns/getISOWeekYear.js
function Z8(e, t) {
	let n = W8(e, t?.in), r = n.getFullYear(), i = U8(n, 0);
	i.setFullYear(r + 1, 0, 4), i.setHours(0, 0, 0, 0);
	let a = X8(i), o = U8(n, 0);
	o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0);
	let s = X8(o);
	return n.getTime() >= a.getTime() ? r + 1 : n.getTime() >= s.getTime() ? r : r - 1;
}
//#endregion
//#region ../../node_modules/date-fns/_lib/getTimezoneOffsetInMilliseconds.js
function Q8(e) {
	let t = W8(e), n = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
	return n.setUTCFullYear(t.getFullYear()), e - +n;
}
//#endregion
//#region ../../node_modules/date-fns/_lib/normalizeDates.js
function $8(e, ...t) {
	let n = U8.bind(null, e || t.find((e) => typeof e == "object"));
	return t.map(n);
}
//#endregion
//#region ../../node_modules/date-fns/startOfDay.js
function e5(e, t) {
	let n = W8(e, t?.in);
	return n.setHours(0, 0, 0, 0), n;
}
//#endregion
//#region ../../node_modules/date-fns/differenceInCalendarDays.js
function t5(e, t, n) {
	let [r, i] = $8(n?.in, e, t), a = e5(r), o = e5(i), s = +a - Q8(a), c = +o - Q8(o);
	return Math.round((s - c) / Tae);
}
//#endregion
//#region ../../node_modules/date-fns/startOfISOWeekYear.js
function kae(e, t) {
	let n = Z8(e, t), r = U8(t?.in || e, 0);
	return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), X8(r);
}
//#endregion
//#region ../../node_modules/date-fns/addMinutes.js
function n5(e, t, n) {
	let r = W8(e, n?.in);
	return r.setTime(r.getTime() + t * z8), r;
}
//#endregion
//#region ../../node_modules/date-fns/addQuarters.js
function r5(e, t, n) {
	return K8(e, t * 3, n);
}
//#endregion
//#region ../../node_modules/date-fns/addSeconds.js
function Aae(e, t, n) {
	return q8(e, t * 1e3, n);
}
//#endregion
//#region ../../node_modules/date-fns/addWeeks.js
function i5(e, t, n) {
	return G8(e, t * 7, n);
}
//#endregion
//#region ../../node_modules/date-fns/addYears.js
function a5(e, t, n) {
	return K8(e, t * 12, n);
}
//#endregion
//#region ../../node_modules/date-fns/max.js
function o5(e, t) {
	let n, r = t?.in;
	return e.forEach((e) => {
		!r && typeof e == "object" && (r = U8.bind(null, e));
		let t = W8(e, r);
		(!n || n < t || isNaN(+t)) && (n = t);
	}), U8(r, n || NaN);
}
//#endregion
//#region ../../node_modules/date-fns/min.js
function s5(e, t) {
	let n, r = t?.in;
	return e.forEach((e) => {
		!r && typeof e == "object" && (r = U8.bind(null, e));
		let t = W8(e, r);
		(!n || n > t || isNaN(+t)) && (n = t);
	}), U8(r, n || NaN);
}
//#endregion
//#region ../../node_modules/date-fns/isSameDay.js
function jae(e, t, n) {
	let [r, i] = $8(n?.in, e, t);
	return +e5(r) == +e5(i);
}
//#endregion
//#region ../../node_modules/date-fns/isDate.js
function c5(e) {
	return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
//#endregion
//#region ../../node_modules/date-fns/isValid.js
function l5(e) {
	return !(!c5(e) && typeof e != "number" || isNaN(+W8(e)));
}
//#endregion
//#region ../../node_modules/date-fns/differenceInCalendarMonths.js
function u5(e, t, n) {
	let [r, i] = $8(n?.in, e, t), a = r.getFullYear() - i.getFullYear(), o = r.getMonth() - i.getMonth();
	return a * 12 + o;
}
//#endregion
//#region ../../node_modules/date-fns/getQuarter.js
function d5(e, t) {
	let n = W8(e, t?.in);
	return Math.trunc(n.getMonth() / 3) + 1;
}
//#endregion
//#region ../../node_modules/date-fns/differenceInCalendarQuarters.js
function f5(e, t, n) {
	let [r, i] = $8(n?.in, e, t), a = r.getFullYear() - i.getFullYear(), o = d5(r) - d5(i);
	return a * 4 + o;
}
//#endregion
//#region ../../node_modules/date-fns/differenceInCalendarYears.js
function p5(e, t, n) {
	let [r, i] = $8(n?.in, e, t);
	return r.getFullYear() - i.getFullYear();
}
//#endregion
//#region ../../node_modules/date-fns/differenceInDays.js
function Mae(e, t, n) {
	let [r, i] = $8(n?.in, e, t), a = m5(r, i), o = Math.abs(t5(r, i));
	r.setDate(r.getDate() - a * o);
	let s = a * (o - Number(m5(r, i) === -a));
	return s === 0 ? 0 : s;
}
function m5(e, t) {
	let n = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
	return n < 0 ? -1 : n > 0 ? 1 : n;
}
//#endregion
//#region ../../node_modules/date-fns/endOfDay.js
function h5(e, t) {
	let n = W8(e, t?.in);
	return n.setHours(23, 59, 59, 999), n;
}
//#endregion
//#region ../../node_modules/date-fns/endOfMonth.js
function g5(e, t) {
	let n = W8(e, t?.in), r = n.getMonth();
	return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
//#endregion
//#region ../../node_modules/date-fns/startOfQuarter.js
function _5(e, t) {
	let n = W8(e, t?.in), r = n.getMonth(), i = r - r % 3;
	return n.setMonth(i, 1), n.setHours(0, 0, 0, 0), n;
}
//#endregion
//#region ../../node_modules/date-fns/startOfMonth.js
function v5(e, t) {
	let n = W8(e, t?.in);
	return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
//#endregion
//#region ../../node_modules/date-fns/endOfYear.js
function y5(e, t) {
	let n = W8(e, t?.in), r = n.getFullYear();
	return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
//#endregion
//#region ../../node_modules/date-fns/startOfYear.js
function b5(e, t) {
	let n = W8(e, t?.in);
	return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
//#endregion
//#region ../../node_modules/date-fns/endOfWeek.js
function Nae(e, t) {
	let n = J8(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, i = W8(e, t?.in), a = i.getDay(), o = (a < r ? -7 : 0) + 6 - (a - r);
	return i.setDate(i.getDate() + o), i.setHours(23, 59, 59, 999), i;
}
//#endregion
//#region ../../node_modules/date-fns/locale/en-US/_lib/formatDistance.js
var Pae = {
	lessThanXSeconds: {
		one: "less than a second",
		other: "less than {{count}} seconds"
	},
	xSeconds: {
		one: "1 second",
		other: "{{count}} seconds"
	},
	halfAMinute: "half a minute",
	lessThanXMinutes: {
		one: "less than a minute",
		other: "less than {{count}} minutes"
	},
	xMinutes: {
		one: "1 minute",
		other: "{{count}} minutes"
	},
	aboutXHours: {
		one: "about 1 hour",
		other: "about {{count}} hours"
	},
	xHours: {
		one: "1 hour",
		other: "{{count}} hours"
	},
	xDays: {
		one: "1 day",
		other: "{{count}} days"
	},
	aboutXWeeks: {
		one: "about 1 week",
		other: "about {{count}} weeks"
	},
	xWeeks: {
		one: "1 week",
		other: "{{count}} weeks"
	},
	aboutXMonths: {
		one: "about 1 month",
		other: "about {{count}} months"
	},
	xMonths: {
		one: "1 month",
		other: "{{count}} months"
	},
	aboutXYears: {
		one: "about 1 year",
		other: "about {{count}} years"
	},
	xYears: {
		one: "1 year",
		other: "{{count}} years"
	},
	overXYears: {
		one: "over 1 year",
		other: "over {{count}} years"
	},
	almostXYears: {
		one: "almost 1 year",
		other: "almost {{count}} years"
	}
}, Fae = (e, t, n) => {
	let r, i = Pae[e];
	return r = typeof i == "string" ? i : t === 1 ? i.one : i.other.replace("{{count}}", t.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
//#endregion
//#region ../../node_modules/date-fns/locale/_lib/buildFormatLongFn.js
function x5(e) {
	return (t = {}) => {
		let n = t.width ? String(t.width) : e.defaultWidth;
		return e.formats[n] || e.formats[e.defaultWidth];
	};
}
var Iae = {
	date: x5({
		formats: {
			full: "EEEE, MMMM do, y",
			long: "MMMM do, y",
			medium: "MMM d, y",
			short: "MM/dd/yyyy"
		},
		defaultWidth: "full"
	}),
	time: x5({
		formats: {
			full: "h:mm:ss a zzzz",
			long: "h:mm:ss a z",
			medium: "h:mm:ss a",
			short: "h:mm a"
		},
		defaultWidth: "full"
	}),
	dateTime: x5({
		formats: {
			full: "{{date}} 'at' {{time}}",
			long: "{{date}} 'at' {{time}}",
			medium: "{{date}}, {{time}}",
			short: "{{date}}, {{time}}"
		},
		defaultWidth: "full"
	})
}, Lae = {
	lastWeek: "'last' eeee 'at' p",
	yesterday: "'yesterday at' p",
	today: "'today at' p",
	tomorrow: "'tomorrow at' p",
	nextWeek: "eeee 'at' p",
	other: "P"
}, Rae = (e, t, n, r) => Lae[e];
//#endregion
//#region ../../node_modules/date-fns/locale/_lib/buildLocalizeFn.js
function S5(e) {
	return (t, n) => {
		let r = n?.context ? String(n.context) : "standalone", i;
		if (r === "formatting" && e.formattingValues) {
			let t = e.defaultFormattingWidth || e.defaultWidth, r = n?.width ? String(n.width) : t;
			i = e.formattingValues[r] || e.formattingValues[t];
		} else {
			let t = e.defaultWidth, r = n?.width ? String(n.width) : e.defaultWidth;
			i = e.values[r] || e.values[t];
		}
		let a = e.argumentCallback ? e.argumentCallback(t) : t;
		return i[a];
	};
}
var zae = {
	ordinalNumber: (e, t) => {
		let n = Number(e), r = n % 100;
		if (r > 20 || r < 10) switch (r % 10) {
			case 1: return n + "st";
			case 2: return n + "nd";
			case 3: return n + "rd";
		}
		return n + "th";
	},
	era: S5({
		values: {
			narrow: ["B", "A"],
			abbreviated: ["BC", "AD"],
			wide: ["Before Christ", "Anno Domini"]
		},
		defaultWidth: "wide"
	}),
	quarter: S5({
		values: {
			narrow: [
				"1",
				"2",
				"3",
				"4"
			],
			abbreviated: [
				"Q1",
				"Q2",
				"Q3",
				"Q4"
			],
			wide: [
				"1st quarter",
				"2nd quarter",
				"3rd quarter",
				"4th quarter"
			]
		},
		defaultWidth: "wide",
		argumentCallback: (e) => e - 1
	}),
	month: S5({
		values: {
			narrow: [
				"J",
				"F",
				"M",
				"A",
				"M",
				"J",
				"J",
				"A",
				"S",
				"O",
				"N",
				"D"
			],
			abbreviated: [
				"Jan",
				"Feb",
				"Mar",
				"Apr",
				"May",
				"Jun",
				"Jul",
				"Aug",
				"Sep",
				"Oct",
				"Nov",
				"Dec"
			],
			wide: [
				"January",
				"February",
				"March",
				"April",
				"May",
				"June",
				"July",
				"August",
				"September",
				"October",
				"November",
				"December"
			]
		},
		defaultWidth: "wide"
	}),
	day: S5({
		values: {
			narrow: [
				"S",
				"M",
				"T",
				"W",
				"T",
				"F",
				"S"
			],
			short: [
				"Su",
				"Mo",
				"Tu",
				"We",
				"Th",
				"Fr",
				"Sa"
			],
			abbreviated: [
				"Sun",
				"Mon",
				"Tue",
				"Wed",
				"Thu",
				"Fri",
				"Sat"
			],
			wide: [
				"Sunday",
				"Monday",
				"Tuesday",
				"Wednesday",
				"Thursday",
				"Friday",
				"Saturday"
			]
		},
		defaultWidth: "wide"
	}),
	dayPeriod: S5({
		values: {
			narrow: {
				am: "a",
				pm: "p",
				midnight: "mi",
				noon: "n",
				morning: "morning",
				afternoon: "afternoon",
				evening: "evening",
				night: "night"
			},
			abbreviated: {
				am: "AM",
				pm: "PM",
				midnight: "midnight",
				noon: "noon",
				morning: "morning",
				afternoon: "afternoon",
				evening: "evening",
				night: "night"
			},
			wide: {
				am: "a.m.",
				pm: "p.m.",
				midnight: "midnight",
				noon: "noon",
				morning: "morning",
				afternoon: "afternoon",
				evening: "evening",
				night: "night"
			}
		},
		defaultWidth: "wide",
		formattingValues: {
			narrow: {
				am: "a",
				pm: "p",
				midnight: "mi",
				noon: "n",
				morning: "in the morning",
				afternoon: "in the afternoon",
				evening: "in the evening",
				night: "at night"
			},
			abbreviated: {
				am: "AM",
				pm: "PM",
				midnight: "midnight",
				noon: "noon",
				morning: "in the morning",
				afternoon: "in the afternoon",
				evening: "in the evening",
				night: "at night"
			},
			wide: {
				am: "a.m.",
				pm: "p.m.",
				midnight: "midnight",
				noon: "noon",
				morning: "in the morning",
				afternoon: "in the afternoon",
				evening: "in the evening",
				night: "at night"
			}
		},
		defaultFormattingWidth: "wide"
	})
};
//#endregion
//#region ../../node_modules/date-fns/locale/_lib/buildMatchFn.js
function C5(e) {
	return (t, n = {}) => {
		let r = n.width, i = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = t.match(i);
		if (!a) return null;
		let o = a[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? Vae(s, (e) => e.test(o)) : Bae(s, (e) => e.test(o)), l;
		l = e.valueCallback ? e.valueCallback(c) : c, l = n.valueCallback ? n.valueCallback(l) : l;
		let u = t.slice(o.length);
		return {
			value: l,
			rest: u
		};
	};
}
function Bae(e, t) {
	for (let n in e) if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n])) return n;
}
function Vae(e, t) {
	for (let n = 0; n < e.length; n++) if (t(e[n])) return n;
}
//#endregion
//#region ../../node_modules/date-fns/locale/_lib/buildMatchPatternFn.js
function Hae(e) {
	return (t, n = {}) => {
		let r = t.match(e.matchPattern);
		if (!r) return null;
		let i = r[0], a = t.match(e.parsePattern);
		if (!a) return null;
		let o = e.valueCallback ? e.valueCallback(a[0]) : a[0];
		o = n.valueCallback ? n.valueCallback(o) : o;
		let s = t.slice(i.length);
		return {
			value: o,
			rest: s
		};
	};
}
//#endregion
//#region ../../node_modules/date-fns/locale/en-US.js
var w5 = {
	code: "en-US",
	formatDistance: Fae,
	formatLong: Iae,
	formatRelative: Rae,
	localize: zae,
	match: {
		ordinalNumber: Hae({
			matchPattern: /^(\d+)(th|st|nd|rd)?/i,
			parsePattern: /\d+/i,
			valueCallback: (e) => parseInt(e, 10)
		}),
		era: C5({
			matchPatterns: {
				narrow: /^(b|a)/i,
				abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
				wide: /^(before christ|before common era|anno domini|common era)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [/^b/i, /^(a|c)/i] },
			defaultParseWidth: "any"
		}),
		quarter: C5({
			matchPatterns: {
				narrow: /^[1234]/i,
				abbreviated: /^q[1234]/i,
				wide: /^[1234](th|st|nd|rd)? quarter/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [
				/1/i,
				/2/i,
				/3/i,
				/4/i
			] },
			defaultParseWidth: "any",
			valueCallback: (e) => e + 1
		}),
		month: C5({
			matchPatterns: {
				narrow: /^[jfmasond]/i,
				abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
				wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^j/i,
					/^f/i,
					/^m/i,
					/^a/i,
					/^m/i,
					/^j/i,
					/^j/i,
					/^a/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				],
				any: [
					/^ja/i,
					/^f/i,
					/^mar/i,
					/^ap/i,
					/^may/i,
					/^jun/i,
					/^jul/i,
					/^au/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				]
			},
			defaultParseWidth: "any"
		}),
		day: C5({
			matchPatterns: {
				narrow: /^[smtwf]/i,
				short: /^(su|mo|tu|we|th|fr|sa)/i,
				abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
				wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^s/i,
					/^m/i,
					/^t/i,
					/^w/i,
					/^t/i,
					/^f/i,
					/^s/i
				],
				any: [
					/^su/i,
					/^m/i,
					/^tu/i,
					/^w/i,
					/^th/i,
					/^f/i,
					/^sa/i
				]
			},
			defaultParseWidth: "any"
		}),
		dayPeriod: C5({
			matchPatterns: {
				narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
				any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
			},
			defaultMatchWidth: "any",
			parsePatterns: { any: {
				am: /^a/i,
				pm: /^p/i,
				midnight: /^mi/i,
				noon: /^no/i,
				morning: /morning/i,
				afternoon: /afternoon/i,
				evening: /evening/i,
				night: /night/i
			} },
			defaultParseWidth: "any"
		})
	},
	options: {
		weekStartsOn: 0,
		firstWeekContainsDate: 1
	}
};
//#endregion
//#region ../../node_modules/date-fns/getDayOfYear.js
function Uae(e, t) {
	let n = W8(e, t?.in);
	return t5(n, b5(n)) + 1;
}
//#endregion
//#region ../../node_modules/date-fns/getISOWeek.js
function T5(e, t) {
	let n = W8(e, t?.in), r = X8(n) - +kae(n);
	return Math.round(r / R8) + 1;
}
//#endregion
//#region ../../node_modules/date-fns/getWeekYear.js
function E5(e, t) {
	let n = W8(e, t?.in), r = n.getFullYear(), i = J8(), a = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? i.firstWeekContainsDate ?? i.locale?.options?.firstWeekContainsDate ?? 1, o = U8(t?.in || e, 0);
	o.setFullYear(r + 1, 0, a), o.setHours(0, 0, 0, 0);
	let s = Y8(o, t), c = U8(t?.in || e, 0);
	c.setFullYear(r, 0, a), c.setHours(0, 0, 0, 0);
	let l = Y8(c, t);
	return +n >= +s ? r + 1 : +n >= +l ? r : r - 1;
}
//#endregion
//#region ../../node_modules/date-fns/startOfWeekYear.js
function Wae(e, t) {
	let n = J8(), r = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, i = E5(e, t), a = U8(t?.in || e, 0);
	return a.setFullYear(i, 0, r), a.setHours(0, 0, 0, 0), Y8(a, t);
}
//#endregion
//#region ../../node_modules/date-fns/getWeek.js
function D5(e, t) {
	let n = W8(e, t?.in), r = Y8(n, t) - +Wae(n, t);
	return Math.round(r / R8) + 1;
}
//#endregion
//#region ../../node_modules/date-fns/_lib/addLeadingZeros.js
function O5(e, t) {
	return (e < 0 ? "-" : "") + Math.abs(e).toString().padStart(t, "0");
}
//#endregion
//#region ../../node_modules/date-fns/_lib/format/lightFormatters.js
var k5 = {
	y(e, t) {
		let n = e.getFullYear(), r = n > 0 ? n : 1 - n;
		return O5(t === "yy" ? r % 100 : r, t.length);
	},
	M(e, t) {
		let n = e.getMonth();
		return t === "M" ? String(n + 1) : O5(n + 1, 2);
	},
	d(e, t) {
		return O5(e.getDate(), t.length);
	},
	a(e, t) {
		let n = e.getHours() / 12 >= 1 ? "pm" : "am";
		switch (t) {
			case "a":
			case "aa": return n.toUpperCase();
			case "aaa": return n;
			case "aaaaa": return n[0];
			default: return n === "am" ? "a.m." : "p.m.";
		}
	},
	h(e, t) {
		return O5(e.getHours() % 12 || 12, t.length);
	},
	H(e, t) {
		return O5(e.getHours(), t.length);
	},
	m(e, t) {
		return O5(e.getMinutes(), t.length);
	},
	s(e, t) {
		return O5(e.getSeconds(), t.length);
	},
	S(e, t) {
		let n = t.length, r = e.getMilliseconds();
		return O5(Math.trunc(r * 10 ** (n - 3)), t.length);
	}
}, A5 = {
	am: "am",
	pm: "pm",
	midnight: "midnight",
	noon: "noon",
	morning: "morning",
	afternoon: "afternoon",
	evening: "evening",
	night: "night"
}, j5 = {
	G: function(e, t, n) {
		let r = +(e.getFullYear() > 0);
		switch (t) {
			case "G":
			case "GG":
			case "GGG": return n.era(r, { width: "abbreviated" });
			case "GGGGG": return n.era(r, { width: "narrow" });
			default: return n.era(r, { width: "wide" });
		}
	},
	y: function(e, t, n) {
		if (t === "yo") {
			let t = e.getFullYear(), r = t > 0 ? t : 1 - t;
			return n.ordinalNumber(r, { unit: "year" });
		}
		return k5.y(e, t);
	},
	Y: function(e, t, n, r) {
		let i = E5(e, r), a = i > 0 ? i : 1 - i;
		return t === "YY" ? O5(a % 100, 2) : t === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : O5(a, t.length);
	},
	R: function(e, t) {
		return O5(Z8(e), t.length);
	},
	u: function(e, t) {
		return O5(e.getFullYear(), t.length);
	},
	Q: function(e, t, n) {
		let r = Math.ceil((e.getMonth() + 1) / 3);
		switch (t) {
			case "Q": return String(r);
			case "QQ": return O5(r, 2);
			case "Qo": return n.ordinalNumber(r, { unit: "quarter" });
			case "QQQ": return n.quarter(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "QQQQQ": return n.quarter(r, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.quarter(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	q: function(e, t, n) {
		let r = Math.ceil((e.getMonth() + 1) / 3);
		switch (t) {
			case "q": return String(r);
			case "qq": return O5(r, 2);
			case "qo": return n.ordinalNumber(r, { unit: "quarter" });
			case "qqq": return n.quarter(r, {
				width: "abbreviated",
				context: "standalone"
			});
			case "qqqqq": return n.quarter(r, {
				width: "narrow",
				context: "standalone"
			});
			default: return n.quarter(r, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	M: function(e, t, n) {
		let r = e.getMonth();
		switch (t) {
			case "M":
			case "MM": return k5.M(e, t);
			case "Mo": return n.ordinalNumber(r + 1, { unit: "month" });
			case "MMM": return n.month(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "MMMMM": return n.month(r, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.month(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	L: function(e, t, n) {
		let r = e.getMonth();
		switch (t) {
			case "L": return String(r + 1);
			case "LL": return O5(r + 1, 2);
			case "Lo": return n.ordinalNumber(r + 1, { unit: "month" });
			case "LLL": return n.month(r, {
				width: "abbreviated",
				context: "standalone"
			});
			case "LLLLL": return n.month(r, {
				width: "narrow",
				context: "standalone"
			});
			default: return n.month(r, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	w: function(e, t, n, r) {
		let i = D5(e, r);
		return t === "wo" ? n.ordinalNumber(i, { unit: "week" }) : O5(i, t.length);
	},
	I: function(e, t, n) {
		let r = T5(e);
		return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : O5(r, t.length);
	},
	d: function(e, t, n) {
		return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : k5.d(e, t);
	},
	D: function(e, t, n) {
		let r = Uae(e);
		return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : O5(r, t.length);
	},
	E: function(e, t, n) {
		let r = e.getDay();
		switch (t) {
			case "E":
			case "EE":
			case "EEE": return n.day(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "EEEEE": return n.day(r, {
				width: "narrow",
				context: "formatting"
			});
			case "EEEEEE": return n.day(r, {
				width: "short",
				context: "formatting"
			});
			default: return n.day(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	e: function(e, t, n, r) {
		let i = e.getDay(), a = (i - r.weekStartsOn + 8) % 7 || 7;
		switch (t) {
			case "e": return String(a);
			case "ee": return O5(a, 2);
			case "eo": return n.ordinalNumber(a, { unit: "day" });
			case "eee": return n.day(i, {
				width: "abbreviated",
				context: "formatting"
			});
			case "eeeee": return n.day(i, {
				width: "narrow",
				context: "formatting"
			});
			case "eeeeee": return n.day(i, {
				width: "short",
				context: "formatting"
			});
			default: return n.day(i, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	c: function(e, t, n, r) {
		let i = e.getDay(), a = (i - r.weekStartsOn + 8) % 7 || 7;
		switch (t) {
			case "c": return String(a);
			case "cc": return O5(a, t.length);
			case "co": return n.ordinalNumber(a, { unit: "day" });
			case "ccc": return n.day(i, {
				width: "abbreviated",
				context: "standalone"
			});
			case "ccccc": return n.day(i, {
				width: "narrow",
				context: "standalone"
			});
			case "cccccc": return n.day(i, {
				width: "short",
				context: "standalone"
			});
			default: return n.day(i, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	i: function(e, t, n) {
		let r = e.getDay(), i = r === 0 ? 7 : r;
		switch (t) {
			case "i": return String(i);
			case "ii": return O5(i, t.length);
			case "io": return n.ordinalNumber(i, { unit: "day" });
			case "iii": return n.day(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "iiiii": return n.day(r, {
				width: "narrow",
				context: "formatting"
			});
			case "iiiiii": return n.day(r, {
				width: "short",
				context: "formatting"
			});
			default: return n.day(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	a: function(e, t, n) {
		let r = e.getHours() / 12 >= 1 ? "pm" : "am";
		switch (t) {
			case "a":
			case "aa": return n.dayPeriod(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "aaa": return n.dayPeriod(r, {
				width: "abbreviated",
				context: "formatting"
			}).toLowerCase();
			case "aaaaa": return n.dayPeriod(r, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	b: function(e, t, n) {
		let r = e.getHours(), i;
		switch (i = r === 12 ? A5.noon : r === 0 ? A5.midnight : r / 12 >= 1 ? "pm" : "am", t) {
			case "b":
			case "bb": return n.dayPeriod(i, {
				width: "abbreviated",
				context: "formatting"
			});
			case "bbb": return n.dayPeriod(i, {
				width: "abbreviated",
				context: "formatting"
			}).toLowerCase();
			case "bbbbb": return n.dayPeriod(i, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(i, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	B: function(e, t, n) {
		let r = e.getHours(), i;
		switch (i = r >= 17 ? A5.evening : r >= 12 ? A5.afternoon : r >= 4 ? A5.morning : A5.night, t) {
			case "B":
			case "BB":
			case "BBB": return n.dayPeriod(i, {
				width: "abbreviated",
				context: "formatting"
			});
			case "BBBBB": return n.dayPeriod(i, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(i, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	h: function(e, t, n) {
		if (t === "ho") {
			let t = e.getHours() % 12;
			return t === 0 && (t = 12), n.ordinalNumber(t, { unit: "hour" });
		}
		return k5.h(e, t);
	},
	H: function(e, t, n) {
		return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : k5.H(e, t);
	},
	K: function(e, t, n) {
		let r = e.getHours() % 12;
		return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : O5(r, t.length);
	},
	k: function(e, t, n) {
		let r = e.getHours();
		return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : O5(r, t.length);
	},
	m: function(e, t, n) {
		return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : k5.m(e, t);
	},
	s: function(e, t, n) {
		return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : k5.s(e, t);
	},
	S: function(e, t) {
		return k5.S(e, t);
	},
	X: function(e, t, n) {
		let r = e.getTimezoneOffset();
		if (r === 0) return "Z";
		switch (t) {
			case "X": return N5(r);
			case "XXXX":
			case "XX": return P5(r);
			default: return P5(r, ":");
		}
	},
	x: function(e, t, n) {
		let r = e.getTimezoneOffset();
		switch (t) {
			case "x": return N5(r);
			case "xxxx":
			case "xx": return P5(r);
			default: return P5(r, ":");
		}
	},
	O: function(e, t, n) {
		let r = e.getTimezoneOffset();
		switch (t) {
			case "O":
			case "OO":
			case "OOO": return "GMT" + M5(r, ":");
			default: return "GMT" + P5(r, ":");
		}
	},
	z: function(e, t, n) {
		let r = e.getTimezoneOffset();
		switch (t) {
			case "z":
			case "zz":
			case "zzz": return "GMT" + M5(r, ":");
			default: return "GMT" + P5(r, ":");
		}
	},
	t: function(e, t, n) {
		return O5(Math.trunc(e / 1e3), t.length);
	},
	T: function(e, t, n) {
		return O5(+e, t.length);
	}
};
function M5(e, t = "") {
	let n = e > 0 ? "-" : "+", r = Math.abs(e), i = Math.trunc(r / 60), a = r % 60;
	return a === 0 ? n + String(i) : n + String(i) + t + O5(a, 2);
}
function N5(e, t) {
	return e % 60 == 0 ? (e > 0 ? "-" : "+") + O5(Math.abs(e) / 60, 2) : P5(e, t);
}
function P5(e, t = "") {
	let n = e > 0 ? "-" : "+", r = Math.abs(e), i = O5(Math.trunc(r / 60), 2), a = O5(r % 60, 2);
	return n + i + t + a;
}
//#endregion
//#region ../../node_modules/date-fns/_lib/format/longFormatters.js
var F5 = (e, t) => {
	switch (e) {
		case "P": return t.date({ width: "short" });
		case "PP": return t.date({ width: "medium" });
		case "PPP": return t.date({ width: "long" });
		default: return t.date({ width: "full" });
	}
}, I5 = (e, t) => {
	switch (e) {
		case "p": return t.time({ width: "short" });
		case "pp": return t.time({ width: "medium" });
		case "ppp": return t.time({ width: "long" });
		default: return t.time({ width: "full" });
	}
}, L5 = {
	p: I5,
	P: (e, t) => {
		let n = e.match(/(P+)(p+)?/) || [], r = n[1], i = n[2];
		if (!i) return F5(e, t);
		let a;
		switch (r) {
			case "P":
				a = t.dateTime({ width: "short" });
				break;
			case "PP":
				a = t.dateTime({ width: "medium" });
				break;
			case "PPP":
				a = t.dateTime({ width: "long" });
				break;
			default:
				a = t.dateTime({ width: "full" });
				break;
		}
		return a.replace("{{date}}", F5(r, t)).replace("{{time}}", I5(i, t));
	}
}, Gae = /^D+$/, Kae = /^Y+$/, qae = [
	"D",
	"DD",
	"YY",
	"YYYY"
];
function R5(e) {
	return Gae.test(e);
}
function z5(e) {
	return Kae.test(e);
}
function B5(e, t, n) {
	let r = Jae(e, t, n);
	if (console.warn(r), qae.includes(e)) throw RangeError(r);
}
function Jae(e, t, n) {
	let r = e[0] === "Y" ? "years" : "days of the month";
	return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
//#endregion
//#region ../../node_modules/date-fns/format.js
var Yae = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Xae = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Zae = /^'([^]*?)'?$/, Qae = /''/g, $ae = /[a-zA-Z]/;
function V5(e, t, n) {
	let r = J8(), i = n?.locale ?? r.locale ?? w5, a = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, o = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, s = W8(e, n?.in);
	if (!l5(s)) throw RangeError("Invalid time value");
	let c = t.match(Xae).map((e) => {
		let t = e[0];
		if (t === "p" || t === "P") {
			let n = L5[t];
			return n(e, i.formatLong);
		}
		return e;
	}).join("").match(Yae).map((e) => {
		if (e === "''") return {
			isToken: !1,
			value: "'"
		};
		let t = e[0];
		if (t === "'") return {
			isToken: !1,
			value: eoe(e)
		};
		if (j5[t]) return {
			isToken: !0,
			value: e
		};
		if (t.match($ae)) throw RangeError("Format string contains an unescaped latin alphabet character `" + t + "`");
		return {
			isToken: !1,
			value: e
		};
	});
	i.localize.preprocessor && (c = i.localize.preprocessor(s, c));
	let l = {
		firstWeekContainsDate: a,
		weekStartsOn: o,
		locale: i
	};
	return c.map((r) => {
		if (!r.isToken) return r.value;
		let a = r.value;
		(!n?.useAdditionalWeekYearTokens && z5(a) || !n?.useAdditionalDayOfYearTokens && R5(a)) && B5(a, t, String(e));
		let o = j5[a[0]];
		return o(s, a, i.localize, l);
	}).join("");
}
function eoe(e) {
	let t = e.match(Zae);
	return t ? t[1].replace(Qae, "'") : e;
}
//#endregion
//#region ../../node_modules/date-fns/getDate.js
function H5(e, t) {
	return W8(e, t?.in).getDate();
}
//#endregion
//#region ../../node_modules/date-fns/getDay.js
function toe(e, t) {
	return W8(e, t?.in).getDay();
}
//#endregion
//#region ../../node_modules/date-fns/getDaysInMonth.js
function noe(e, t) {
	let n = W8(e, t?.in), r = n.getFullYear(), i = n.getMonth(), a = U8(n, 0);
	return a.setFullYear(r, i + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
//#endregion
//#region ../../node_modules/date-fns/getDefaultOptions.js
function roe() {
	return Object.assign({}, J8());
}
//#endregion
//#region ../../node_modules/date-fns/getHours.js
function U5(e, t) {
	return W8(e, t?.in).getHours();
}
//#endregion
//#region ../../node_modules/date-fns/getISODay.js
function ioe(e, t) {
	let n = W8(e, t?.in).getDay();
	return n === 0 ? 7 : n;
}
//#endregion
//#region ../../node_modules/date-fns/getMinutes.js
function W5(e, t) {
	return W8(e, t?.in).getMinutes();
}
//#endregion
//#region ../../node_modules/date-fns/getMonth.js
function G5(e, t) {
	return W8(e, t?.in).getMonth();
}
//#endregion
//#region ../../node_modules/date-fns/getSeconds.js
function K5(e) {
	return W8(e).getSeconds();
}
//#endregion
//#region ../../node_modules/date-fns/getTime.js
function q5(e) {
	return +W8(e);
}
//#endregion
//#region ../../node_modules/date-fns/getYear.js
function J5(e, t) {
	return W8(e, t?.in).getFullYear();
}
//#endregion
//#region ../../node_modules/date-fns/isAfter.js
function Y5(e, t) {
	return +W8(e) > +W8(t);
}
//#endregion
//#region ../../node_modules/date-fns/isBefore.js
function X5(e, t) {
	return +W8(e) < +W8(t);
}
//#endregion
//#region ../../node_modules/date-fns/isEqual.js
function aoe(e, t) {
	return +W8(e) == +W8(t);
}
//#endregion
//#region ../../node_modules/date-fns/transpose.js
function ooe(e, t) {
	let n = soe(t) ? new t(0) : U8(t, 0);
	return n.setFullYear(e.getFullYear(), e.getMonth(), e.getDate()), n.setHours(e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()), n;
}
function soe(e) {
	return typeof e == "function" && e.prototype?.constructor === e;
}
//#endregion
//#region ../../node_modules/date-fns/parse/_lib/Setter.js
var coe = 10, Z5 = class {
	subPriority = 0;
	validate(e, t) {
		return !0;
	}
}, loe = class extends Z5 {
	constructor(e, t, n, r, i) {
		super(), this.value = e, this.validateValue = t, this.setValue = n, this.priority = r, i && (this.subPriority = i);
	}
	validate(e, t) {
		return this.validateValue(e, this.value, t);
	}
	set(e, t, n) {
		return this.setValue(e, t, this.value, n);
	}
}, uoe = class extends Z5 {
	priority = coe;
	subPriority = -1;
	constructor(e, t) {
		super(), this.context = e || ((e) => U8(t, e));
	}
	set(e, t) {
		return t.timestampIsSet ? e : U8(e, ooe(e, this.context));
	}
}, Q5 = class {
	run(e, t, n, r) {
		let i = this.parse(e, t, n, r);
		return i ? {
			setter: new loe(i.value, this.validate, this.set, this.priority, this.subPriority),
			rest: i.rest
		} : null;
	}
	validate(e, t, n) {
		return !0;
	}
}, doe = class extends Q5 {
	priority = 140;
	parse(e, t, n) {
		switch (t) {
			case "G":
			case "GG":
			case "GGG": return n.era(e, { width: "abbreviated" }) || n.era(e, { width: "narrow" });
			case "GGGGG": return n.era(e, { width: "narrow" });
			default: return n.era(e, { width: "wide" }) || n.era(e, { width: "abbreviated" }) || n.era(e, { width: "narrow" });
		}
	}
	set(e, t, n) {
		return t.era = n, e.setFullYear(n, 0, 1), e.setHours(0, 0, 0, 0), e;
	}
	incompatibleTokens = [
		"R",
		"u",
		"t",
		"T"
	];
}, $5 = {
	month: /^(1[0-2]|0?\d)/,
	date: /^(3[0-1]|[0-2]?\d)/,
	dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
	week: /^(5[0-3]|[0-4]?\d)/,
	hour23h: /^(2[0-3]|[0-1]?\d)/,
	hour24h: /^(2[0-4]|[0-1]?\d)/,
	hour11h: /^(1[0-1]|0?\d)/,
	hour12h: /^(1[0-2]|0?\d)/,
	minute: /^[0-5]?\d/,
	second: /^[0-5]?\d/,
	singleDigit: /^\d/,
	twoDigits: /^\d{1,2}/,
	threeDigits: /^\d{1,3}/,
	fourDigits: /^\d{1,4}/,
	anyDigitsSigned: /^-?\d+/,
	singleDigitSigned: /^-?\d/,
	twoDigitsSigned: /^-?\d{1,2}/,
	threeDigitsSigned: /^-?\d{1,3}/,
	fourDigitsSigned: /^-?\d{1,4}/
}, e7 = {
	basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
	basic: /^([+-])(\d{2})(\d{2})|Z/,
	basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
	extended: /^([+-])(\d{2}):(\d{2})|Z/,
	extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
//#endregion
//#region ../../node_modules/date-fns/parse/_lib/utils.js
function t7(e, t) {
	return e && {
		value: t(e.value),
		rest: e.rest
	};
}
function n7(e, t) {
	let n = t.match(e);
	return n ? {
		value: parseInt(n[0], 10),
		rest: t.slice(n[0].length)
	} : null;
}
function r7(e, t) {
	let n = t.match(e);
	if (!n) return null;
	if (n[0] === "Z") return {
		value: 0,
		rest: t.slice(1)
	};
	let r = n[1] === "+" ? 1 : -1, i = n[2] ? parseInt(n[2], 10) : 0, a = n[3] ? parseInt(n[3], 10) : 0, o = n[5] ? parseInt(n[5], 10) : 0;
	return {
		value: r * (i * B8 + a * z8 + o * Eae),
		rest: t.slice(n[0].length)
	};
}
function i7(e) {
	return n7($5.anyDigitsSigned, e);
}
function a7(e, t) {
	switch (e) {
		case 1: return n7($5.singleDigit, t);
		case 2: return n7($5.twoDigits, t);
		case 3: return n7($5.threeDigits, t);
		case 4: return n7($5.fourDigits, t);
		default: return n7(RegExp("^\\d{1," + e + "}"), t);
	}
}
function o7(e, t) {
	switch (e) {
		case 1: return n7($5.singleDigitSigned, t);
		case 2: return n7($5.twoDigitsSigned, t);
		case 3: return n7($5.threeDigitsSigned, t);
		case 4: return n7($5.fourDigitsSigned, t);
		default: return n7(RegExp("^-?\\d{1," + e + "}"), t);
	}
}
function s7(e) {
	switch (e) {
		case "morning": return 4;
		case "evening": return 17;
		case "pm":
		case "noon":
		case "afternoon": return 12;
		default: return 0;
	}
}
function c7(e, t) {
	let n = t > 0, r = n ? t : 1 - t, i;
	if (r <= 50) i = e || 100;
	else {
		let t = r + 50, n = Math.trunc(t / 100) * 100, a = e >= t % 100;
		i = e + n - (a ? 100 : 0);
	}
	return n ? i : 1 - i;
}
function l7(e) {
	return e % 400 == 0 || e % 4 == 0 && e % 100 != 0;
}
//#endregion
//#region ../../node_modules/date-fns/parse/_lib/parsers/YearParser.js
var foe = class extends Q5 {
	priority = 130;
	incompatibleTokens = [
		"Y",
		"R",
		"u",
		"w",
		"I",
		"i",
		"e",
		"c",
		"t",
		"T"
	];
	parse(e, t, n) {
		let r = (e) => ({
			year: e,
			isTwoDigitYear: t === "yy"
		});
		switch (t) {
			case "y": return t7(a7(4, e), r);
			case "yo": return t7(n.ordinalNumber(e, { unit: "year" }), r);
			default: return t7(a7(t.length, e), r);
		}
	}
	validate(e, t) {
		return t.isTwoDigitYear || t.year > 0;
	}
	set(e, t, n) {
		let r = e.getFullYear();
		if (n.isTwoDigitYear) {
			let t = c7(n.year, r);
			return e.setFullYear(t, 0, 1), e.setHours(0, 0, 0, 0), e;
		}
		let i = !("era" in t) || t.era === 1 ? n.year : 1 - n.year;
		return e.setFullYear(i, 0, 1), e.setHours(0, 0, 0, 0), e;
	}
}, poe = class extends Q5 {
	priority = 130;
	parse(e, t, n) {
		let r = (e) => ({
			year: e,
			isTwoDigitYear: t === "YY"
		});
		switch (t) {
			case "Y": return t7(a7(4, e), r);
			case "Yo": return t7(n.ordinalNumber(e, { unit: "year" }), r);
			default: return t7(a7(t.length, e), r);
		}
	}
	validate(e, t) {
		return t.isTwoDigitYear || t.year > 0;
	}
	set(e, t, n, r) {
		let i = E5(e, r);
		if (n.isTwoDigitYear) {
			let t = c7(n.year, i);
			return e.setFullYear(t, 0, r.firstWeekContainsDate), e.setHours(0, 0, 0, 0), Y8(e, r);
		}
		let a = !("era" in t) || t.era === 1 ? n.year : 1 - n.year;
		return e.setFullYear(a, 0, r.firstWeekContainsDate), e.setHours(0, 0, 0, 0), Y8(e, r);
	}
	incompatibleTokens = [
		"y",
		"R",
		"u",
		"Q",
		"q",
		"M",
		"L",
		"I",
		"d",
		"D",
		"i",
		"t",
		"T"
	];
}, moe = class extends Q5 {
	priority = 130;
	parse(e, t) {
		return o7(t === "R" ? 4 : t.length, e);
	}
	set(e, t, n) {
		let r = U8(e, 0);
		return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), X8(r);
	}
	incompatibleTokens = [
		"G",
		"y",
		"Y",
		"u",
		"Q",
		"q",
		"M",
		"L",
		"w",
		"d",
		"D",
		"e",
		"c",
		"t",
		"T"
	];
}, hoe = class extends Q5 {
	priority = 130;
	parse(e, t) {
		return o7(t === "u" ? 4 : t.length, e);
	}
	set(e, t, n) {
		return e.setFullYear(n, 0, 1), e.setHours(0, 0, 0, 0), e;
	}
	incompatibleTokens = [
		"G",
		"y",
		"Y",
		"R",
		"w",
		"I",
		"i",
		"e",
		"c",
		"t",
		"T"
	];
}, goe = class extends Q5 {
	priority = 120;
	parse(e, t, n) {
		switch (t) {
			case "Q":
			case "QQ": return a7(t.length, e);
			case "Qo": return n.ordinalNumber(e, { unit: "quarter" });
			case "QQQ": return n.quarter(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.quarter(e, {
				width: "narrow",
				context: "formatting"
			});
			case "QQQQQ": return n.quarter(e, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.quarter(e, {
				width: "wide",
				context: "formatting"
			}) || n.quarter(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.quarter(e, {
				width: "narrow",
				context: "formatting"
			});
		}
	}
	validate(e, t) {
		return t >= 1 && t <= 4;
	}
	set(e, t, n) {
		return e.setMonth((n - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
	}
	incompatibleTokens = [
		"Y",
		"R",
		"q",
		"M",
		"L",
		"w",
		"I",
		"d",
		"D",
		"i",
		"e",
		"c",
		"t",
		"T"
	];
}, _oe = class extends Q5 {
	priority = 120;
	parse(e, t, n) {
		switch (t) {
			case "q":
			case "qq": return a7(t.length, e);
			case "qo": return n.ordinalNumber(e, { unit: "quarter" });
			case "qqq": return n.quarter(e, {
				width: "abbreviated",
				context: "standalone"
			}) || n.quarter(e, {
				width: "narrow",
				context: "standalone"
			});
			case "qqqqq": return n.quarter(e, {
				width: "narrow",
				context: "standalone"
			});
			default: return n.quarter(e, {
				width: "wide",
				context: "standalone"
			}) || n.quarter(e, {
				width: "abbreviated",
				context: "standalone"
			}) || n.quarter(e, {
				width: "narrow",
				context: "standalone"
			});
		}
	}
	validate(e, t) {
		return t >= 1 && t <= 4;
	}
	set(e, t, n) {
		return e.setMonth((n - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
	}
	incompatibleTokens = [
		"Y",
		"R",
		"Q",
		"M",
		"L",
		"w",
		"I",
		"d",
		"D",
		"i",
		"e",
		"c",
		"t",
		"T"
	];
}, voe = class extends Q5 {
	incompatibleTokens = [
		"Y",
		"R",
		"q",
		"Q",
		"L",
		"w",
		"I",
		"D",
		"i",
		"e",
		"c",
		"t",
		"T"
	];
	priority = 110;
	parse(e, t, n) {
		let r = (e) => e - 1;
		switch (t) {
			case "M": return t7(n7($5.month, e), r);
			case "MM": return t7(a7(2, e), r);
			case "Mo": return t7(n.ordinalNumber(e, { unit: "month" }), r);
			case "MMM": return n.month(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.month(e, {
				width: "narrow",
				context: "formatting"
			});
			case "MMMMM": return n.month(e, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.month(e, {
				width: "wide",
				context: "formatting"
			}) || n.month(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.month(e, {
				width: "narrow",
				context: "formatting"
			});
		}
	}
	validate(e, t) {
		return t >= 0 && t <= 11;
	}
	set(e, t, n) {
		return e.setMonth(n, 1), e.setHours(0, 0, 0, 0), e;
	}
}, yoe = class extends Q5 {
	priority = 110;
	parse(e, t, n) {
		let r = (e) => e - 1;
		switch (t) {
			case "L": return t7(n7($5.month, e), r);
			case "LL": return t7(a7(2, e), r);
			case "Lo": return t7(n.ordinalNumber(e, { unit: "month" }), r);
			case "LLL": return n.month(e, {
				width: "abbreviated",
				context: "standalone"
			}) || n.month(e, {
				width: "narrow",
				context: "standalone"
			});
			case "LLLLL": return n.month(e, {
				width: "narrow",
				context: "standalone"
			});
			default: return n.month(e, {
				width: "wide",
				context: "standalone"
			}) || n.month(e, {
				width: "abbreviated",
				context: "standalone"
			}) || n.month(e, {
				width: "narrow",
				context: "standalone"
			});
		}
	}
	validate(e, t) {
		return t >= 0 && t <= 11;
	}
	set(e, t, n) {
		return e.setMonth(n, 1), e.setHours(0, 0, 0, 0), e;
	}
	incompatibleTokens = [
		"Y",
		"R",
		"q",
		"Q",
		"M",
		"w",
		"I",
		"D",
		"i",
		"e",
		"c",
		"t",
		"T"
	];
};
//#endregion
//#region ../../node_modules/date-fns/setWeek.js
function boe(e, t, n) {
	let r = W8(e, n?.in), i = D5(r, n) - t;
	return r.setDate(r.getDate() - i * 7), W8(r, n?.in);
}
//#endregion
//#region ../../node_modules/date-fns/parse/_lib/parsers/LocalWeekParser.js
var xoe = class extends Q5 {
	priority = 100;
	parse(e, t, n) {
		switch (t) {
			case "w": return n7($5.week, e);
			case "wo": return n.ordinalNumber(e, { unit: "week" });
			default: return a7(t.length, e);
		}
	}
	validate(e, t) {
		return t >= 1 && t <= 53;
	}
	set(e, t, n, r) {
		return Y8(boe(e, n, r), r);
	}
	incompatibleTokens = [
		"y",
		"R",
		"u",
		"q",
		"Q",
		"M",
		"L",
		"I",
		"d",
		"D",
		"i",
		"t",
		"T"
	];
};
//#endregion
//#region ../../node_modules/date-fns/setISOWeek.js
function Soe(e, t, n) {
	let r = W8(e, n?.in), i = T5(r, n) - t;
	return r.setDate(r.getDate() - i * 7), r;
}
//#endregion
//#region ../../node_modules/date-fns/parse/_lib/parsers/ISOWeekParser.js
var Coe = class extends Q5 {
	priority = 100;
	parse(e, t, n) {
		switch (t) {
			case "I": return n7($5.week, e);
			case "Io": return n.ordinalNumber(e, { unit: "week" });
			default: return a7(t.length, e);
		}
	}
	validate(e, t) {
		return t >= 1 && t <= 53;
	}
	set(e, t, n) {
		return X8(Soe(e, n));
	}
	incompatibleTokens = [
		"y",
		"Y",
		"u",
		"q",
		"Q",
		"M",
		"L",
		"w",
		"d",
		"D",
		"e",
		"c",
		"t",
		"T"
	];
}, woe = [
	31,
	28,
	31,
	30,
	31,
	30,
	31,
	31,
	30,
	31,
	30,
	31
], Toe = [
	31,
	29,
	31,
	30,
	31,
	30,
	31,
	31,
	30,
	31,
	30,
	31
], Eoe = class extends Q5 {
	priority = 90;
	subPriority = 1;
	parse(e, t, n) {
		switch (t) {
			case "d": return n7($5.date, e);
			case "do": return n.ordinalNumber(e, { unit: "date" });
			default: return a7(t.length, e);
		}
	}
	validate(e, t) {
		let n = l7(e.getFullYear()), r = e.getMonth();
		return n ? t >= 1 && t <= Toe[r] : t >= 1 && t <= woe[r];
	}
	set(e, t, n) {
		return e.setDate(n), e.setHours(0, 0, 0, 0), e;
	}
	incompatibleTokens = [
		"Y",
		"R",
		"q",
		"Q",
		"w",
		"I",
		"D",
		"i",
		"e",
		"c",
		"t",
		"T"
	];
}, Doe = class extends Q5 {
	priority = 90;
	subpriority = 1;
	parse(e, t, n) {
		switch (t) {
			case "D":
			case "DD": return n7($5.dayOfYear, e);
			case "Do": return n.ordinalNumber(e, { unit: "date" });
			default: return a7(t.length, e);
		}
	}
	validate(e, t) {
		return l7(e.getFullYear()) ? t >= 1 && t <= 366 : t >= 1 && t <= 365;
	}
	set(e, t, n) {
		return e.setMonth(0, n), e.setHours(0, 0, 0, 0), e;
	}
	incompatibleTokens = [
		"Y",
		"R",
		"q",
		"Q",
		"M",
		"L",
		"w",
		"I",
		"d",
		"E",
		"i",
		"e",
		"c",
		"t",
		"T"
	];
};
//#endregion
//#region ../../node_modules/date-fns/setDay.js
function u7(e, t, n) {
	let r = J8(), i = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, a = W8(e, n?.in), o = a.getDay(), s = (t % 7 + 7) % 7, c = 7 - i;
	return G8(a, t < 0 || t > 6 ? t - (o + c) % 7 : (s + c) % 7 - (o + c) % 7, n);
}
//#endregion
//#region ../../node_modules/date-fns/parse/_lib/parsers/DayParser.js
var Ooe = class extends Q5 {
	priority = 90;
	parse(e, t, n) {
		switch (t) {
			case "E":
			case "EE":
			case "EEE": return n.day(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.day(e, {
				width: "short",
				context: "formatting"
			}) || n.day(e, {
				width: "narrow",
				context: "formatting"
			});
			case "EEEEE": return n.day(e, {
				width: "narrow",
				context: "formatting"
			});
			case "EEEEEE": return n.day(e, {
				width: "short",
				context: "formatting"
			}) || n.day(e, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.day(e, {
				width: "wide",
				context: "formatting"
			}) || n.day(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.day(e, {
				width: "short",
				context: "formatting"
			}) || n.day(e, {
				width: "narrow",
				context: "formatting"
			});
		}
	}
	validate(e, t) {
		return t >= 0 && t <= 6;
	}
	set(e, t, n, r) {
		return e = u7(e, n, r), e.setHours(0, 0, 0, 0), e;
	}
	incompatibleTokens = [
		"D",
		"i",
		"e",
		"c",
		"t",
		"T"
	];
}, koe = class extends Q5 {
	priority = 90;
	parse(e, t, n, r) {
		let i = (e) => {
			let t = Math.floor((e - 1) / 7) * 7;
			return (e + r.weekStartsOn + 6) % 7 + t;
		};
		switch (t) {
			case "e":
			case "ee": return t7(a7(t.length, e), i);
			case "eo": return t7(n.ordinalNumber(e, { unit: "day" }), i);
			case "eee": return n.day(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.day(e, {
				width: "short",
				context: "formatting"
			}) || n.day(e, {
				width: "narrow",
				context: "formatting"
			});
			case "eeeee": return n.day(e, {
				width: "narrow",
				context: "formatting"
			});
			case "eeeeee": return n.day(e, {
				width: "short",
				context: "formatting"
			}) || n.day(e, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.day(e, {
				width: "wide",
				context: "formatting"
			}) || n.day(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.day(e, {
				width: "short",
				context: "formatting"
			}) || n.day(e, {
				width: "narrow",
				context: "formatting"
			});
		}
	}
	validate(e, t) {
		return t >= 0 && t <= 6;
	}
	set(e, t, n, r) {
		return e = u7(e, n, r), e.setHours(0, 0, 0, 0), e;
	}
	incompatibleTokens = [
		"y",
		"R",
		"u",
		"q",
		"Q",
		"M",
		"L",
		"I",
		"d",
		"D",
		"E",
		"i",
		"c",
		"t",
		"T"
	];
}, Aoe = class extends Q5 {
	priority = 90;
	parse(e, t, n, r) {
		let i = (e) => {
			let t = Math.floor((e - 1) / 7) * 7;
			return (e + r.weekStartsOn + 6) % 7 + t;
		};
		switch (t) {
			case "c":
			case "cc": return t7(a7(t.length, e), i);
			case "co": return t7(n.ordinalNumber(e, { unit: "day" }), i);
			case "ccc": return n.day(e, {
				width: "abbreviated",
				context: "standalone"
			}) || n.day(e, {
				width: "short",
				context: "standalone"
			}) || n.day(e, {
				width: "narrow",
				context: "standalone"
			});
			case "ccccc": return n.day(e, {
				width: "narrow",
				context: "standalone"
			});
			case "cccccc": return n.day(e, {
				width: "short",
				context: "standalone"
			}) || n.day(e, {
				width: "narrow",
				context: "standalone"
			});
			default: return n.day(e, {
				width: "wide",
				context: "standalone"
			}) || n.day(e, {
				width: "abbreviated",
				context: "standalone"
			}) || n.day(e, {
				width: "short",
				context: "standalone"
			}) || n.day(e, {
				width: "narrow",
				context: "standalone"
			});
		}
	}
	validate(e, t) {
		return t >= 0 && t <= 6;
	}
	set(e, t, n, r) {
		return e = u7(e, n, r), e.setHours(0, 0, 0, 0), e;
	}
	incompatibleTokens = [
		"y",
		"R",
		"u",
		"q",
		"Q",
		"M",
		"L",
		"I",
		"d",
		"D",
		"E",
		"i",
		"e",
		"t",
		"T"
	];
};
//#endregion
//#region ../../node_modules/date-fns/setISODay.js
function joe(e, t, n) {
	let r = W8(e, n?.in);
	return G8(r, t - ioe(r, n), n);
}
//#endregion
//#region ../../node_modules/date-fns/parse/_lib/parsers/ISODayParser.js
var Moe = class extends Q5 {
	priority = 90;
	parse(e, t, n) {
		let r = (e) => e === 0 ? 7 : e;
		switch (t) {
			case "i":
			case "ii": return a7(t.length, e);
			case "io": return n.ordinalNumber(e, { unit: "day" });
			case "iii": return t7(n.day(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.day(e, {
				width: "short",
				context: "formatting"
			}) || n.day(e, {
				width: "narrow",
				context: "formatting"
			}), r);
			case "iiiii": return t7(n.day(e, {
				width: "narrow",
				context: "formatting"
			}), r);
			case "iiiiii": return t7(n.day(e, {
				width: "short",
				context: "formatting"
			}) || n.day(e, {
				width: "narrow",
				context: "formatting"
			}), r);
			default: return t7(n.day(e, {
				width: "wide",
				context: "formatting"
			}) || n.day(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.day(e, {
				width: "short",
				context: "formatting"
			}) || n.day(e, {
				width: "narrow",
				context: "formatting"
			}), r);
		}
	}
	validate(e, t) {
		return t >= 1 && t <= 7;
	}
	set(e, t, n) {
		return e = joe(e, n), e.setHours(0, 0, 0, 0), e;
	}
	incompatibleTokens = [
		"y",
		"Y",
		"u",
		"q",
		"Q",
		"M",
		"L",
		"w",
		"d",
		"D",
		"E",
		"e",
		"c",
		"t",
		"T"
	];
}, Noe = class extends Q5 {
	priority = 80;
	parse(e, t, n) {
		switch (t) {
			case "a":
			case "aa":
			case "aaa": return n.dayPeriod(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.dayPeriod(e, {
				width: "narrow",
				context: "formatting"
			});
			case "aaaaa": return n.dayPeriod(e, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(e, {
				width: "wide",
				context: "formatting"
			}) || n.dayPeriod(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.dayPeriod(e, {
				width: "narrow",
				context: "formatting"
			});
		}
	}
	set(e, t, n) {
		return e.setHours(s7(n), 0, 0, 0), e;
	}
	incompatibleTokens = [
		"b",
		"B",
		"H",
		"k",
		"t",
		"T"
	];
}, Poe = class extends Q5 {
	priority = 80;
	parse(e, t, n) {
		switch (t) {
			case "b":
			case "bb":
			case "bbb": return n.dayPeriod(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.dayPeriod(e, {
				width: "narrow",
				context: "formatting"
			});
			case "bbbbb": return n.dayPeriod(e, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(e, {
				width: "wide",
				context: "formatting"
			}) || n.dayPeriod(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.dayPeriod(e, {
				width: "narrow",
				context: "formatting"
			});
		}
	}
	set(e, t, n) {
		return e.setHours(s7(n), 0, 0, 0), e;
	}
	incompatibleTokens = [
		"a",
		"B",
		"H",
		"k",
		"t",
		"T"
	];
}, Foe = class extends Q5 {
	priority = 80;
	parse(e, t, n) {
		switch (t) {
			case "B":
			case "BB":
			case "BBB": return n.dayPeriod(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.dayPeriod(e, {
				width: "narrow",
				context: "formatting"
			});
			case "BBBBB": return n.dayPeriod(e, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(e, {
				width: "wide",
				context: "formatting"
			}) || n.dayPeriod(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.dayPeriod(e, {
				width: "narrow",
				context: "formatting"
			});
		}
	}
	set(e, t, n) {
		return e.setHours(s7(n), 0, 0, 0), e;
	}
	incompatibleTokens = [
		"a",
		"b",
		"t",
		"T"
	];
}, Ioe = class extends Q5 {
	priority = 70;
	parse(e, t, n) {
		switch (t) {
			case "h": return n7($5.hour12h, e);
			case "ho": return n.ordinalNumber(e, { unit: "hour" });
			default: return a7(t.length, e);
		}
	}
	validate(e, t) {
		return t >= 1 && t <= 12;
	}
	set(e, t, n) {
		let r = e.getHours() >= 12;
		return r && n < 12 ? e.setHours(n + 12, 0, 0, 0) : !r && n === 12 ? e.setHours(0, 0, 0, 0) : e.setHours(n, 0, 0, 0), e;
	}
	incompatibleTokens = [
		"H",
		"K",
		"k",
		"t",
		"T"
	];
}, Loe = class extends Q5 {
	priority = 70;
	parse(e, t, n) {
		switch (t) {
			case "H": return n7($5.hour23h, e);
			case "Ho": return n.ordinalNumber(e, { unit: "hour" });
			default: return a7(t.length, e);
		}
	}
	validate(e, t) {
		return t >= 0 && t <= 23;
	}
	set(e, t, n) {
		return e.setHours(n, 0, 0, 0), e;
	}
	incompatibleTokens = [
		"a",
		"b",
		"h",
		"K",
		"k",
		"t",
		"T"
	];
}, Roe = class extends Q5 {
	priority = 70;
	parse(e, t, n) {
		switch (t) {
			case "K": return n7($5.hour11h, e);
			case "Ko": return n.ordinalNumber(e, { unit: "hour" });
			default: return a7(t.length, e);
		}
	}
	validate(e, t) {
		return t >= 0 && t <= 11;
	}
	set(e, t, n) {
		return e.getHours() >= 12 && n < 12 ? e.setHours(n + 12, 0, 0, 0) : e.setHours(n, 0, 0, 0), e;
	}
	incompatibleTokens = [
		"h",
		"H",
		"k",
		"t",
		"T"
	];
}, zoe = class extends Q5 {
	priority = 70;
	parse(e, t, n) {
		switch (t) {
			case "k": return n7($5.hour24h, e);
			case "ko": return n.ordinalNumber(e, { unit: "hour" });
			default: return a7(t.length, e);
		}
	}
	validate(e, t) {
		return t >= 1 && t <= 24;
	}
	set(e, t, n) {
		let r = n <= 24 ? n % 24 : n;
		return e.setHours(r, 0, 0, 0), e;
	}
	incompatibleTokens = [
		"a",
		"b",
		"h",
		"H",
		"K",
		"t",
		"T"
	];
}, Boe = class extends Q5 {
	priority = 60;
	parse(e, t, n) {
		switch (t) {
			case "m": return n7($5.minute, e);
			case "mo": return n.ordinalNumber(e, { unit: "minute" });
			default: return a7(t.length, e);
		}
	}
	validate(e, t) {
		return t >= 0 && t <= 59;
	}
	set(e, t, n) {
		return e.setMinutes(n, 0, 0), e;
	}
	incompatibleTokens = ["t", "T"];
}, Voe = class extends Q5 {
	priority = 50;
	parse(e, t, n) {
		switch (t) {
			case "s": return n7($5.second, e);
			case "so": return n.ordinalNumber(e, { unit: "second" });
			default: return a7(t.length, e);
		}
	}
	validate(e, t) {
		return t >= 0 && t <= 59;
	}
	set(e, t, n) {
		return e.setSeconds(n, 0), e;
	}
	incompatibleTokens = ["t", "T"];
}, Hoe = class extends Q5 {
	priority = 30;
	parse(e, t) {
		return t7(a7(t.length, e), (e) => Math.trunc(e * 10 ** (-t.length + 3)));
	}
	set(e, t, n) {
		return e.setMilliseconds(n), e;
	}
	incompatibleTokens = ["t", "T"];
}, Uoe = class extends Q5 {
	priority = 10;
	parse(e, t) {
		switch (t) {
			case "X": return r7(e7.basicOptionalMinutes, e);
			case "XX": return r7(e7.basic, e);
			case "XXXX": return r7(e7.basicOptionalSeconds, e);
			case "XXXXX": return r7(e7.extendedOptionalSeconds, e);
			default: return r7(e7.extended, e);
		}
	}
	set(e, t, n) {
		return t.timestampIsSet ? e : U8(e, e.getTime() - Q8(e) - n);
	}
	incompatibleTokens = [
		"t",
		"T",
		"x"
	];
}, Woe = class extends Q5 {
	priority = 10;
	parse(e, t) {
		switch (t) {
			case "x": return r7(e7.basicOptionalMinutes, e);
			case "xx": return r7(e7.basic, e);
			case "xxxx": return r7(e7.basicOptionalSeconds, e);
			case "xxxxx": return r7(e7.extendedOptionalSeconds, e);
			default: return r7(e7.extended, e);
		}
	}
	set(e, t, n) {
		return t.timestampIsSet ? e : U8(e, e.getTime() - Q8(e) - n);
	}
	incompatibleTokens = [
		"t",
		"T",
		"X"
	];
}, Goe = class extends Q5 {
	priority = 40;
	parse(e) {
		return i7(e);
	}
	set(e, t, n) {
		return [U8(e, n * 1e3), { timestampIsSet: !0 }];
	}
	incompatibleTokens = "*";
}, Koe = class extends Q5 {
	priority = 20;
	parse(e) {
		return i7(e);
	}
	set(e, t, n) {
		return [U8(e, n), { timestampIsSet: !0 }];
	}
	incompatibleTokens = "*";
}, qoe = {
	G: new doe(),
	y: new foe(),
	Y: new poe(),
	R: new moe(),
	u: new hoe(),
	Q: new goe(),
	q: new _oe(),
	M: new voe(),
	L: new yoe(),
	w: new xoe(),
	I: new Coe(),
	d: new Eoe(),
	D: new Doe(),
	E: new Ooe(),
	e: new koe(),
	c: new Aoe(),
	i: new Moe(),
	a: new Noe(),
	b: new Poe(),
	B: new Foe(),
	h: new Ioe(),
	H: new Loe(),
	K: new Roe(),
	k: new zoe(),
	m: new Boe(),
	s: new Voe(),
	S: new Hoe(),
	X: new Uoe(),
	x: new Woe(),
	t: new Goe(),
	T: new Koe()
}, Joe = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Yoe = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Xoe = /^'([^]*?)'?$/, Zoe = /''/g, Qoe = /\S/, $oe = /[a-zA-Z]/;
function ese(e, t, n, r) {
	let i = () => U8(r?.in || n, NaN), a = roe(), o = r?.locale ?? a.locale ?? w5, s = r?.firstWeekContainsDate ?? r?.locale?.options?.firstWeekContainsDate ?? a.firstWeekContainsDate ?? a.locale?.options?.firstWeekContainsDate ?? 1, c = r?.weekStartsOn ?? r?.locale?.options?.weekStartsOn ?? a.weekStartsOn ?? a.locale?.options?.weekStartsOn ?? 0;
	if (!t) return e ? i() : W8(n, r?.in);
	let l = {
		firstWeekContainsDate: s,
		weekStartsOn: c,
		locale: o
	}, u = [new uoe(r?.in, n)], d = t.match(Yoe).map((e) => {
		let t = e[0];
		if (t in L5) {
			let n = L5[t];
			return n(e, o.formatLong);
		}
		return e;
	}).join("").match(Joe), f = [];
	for (let n of d) {
		!r?.useAdditionalWeekYearTokens && z5(n) && B5(n, t, e), !r?.useAdditionalDayOfYearTokens && R5(n) && B5(n, t, e);
		let a = n[0], s = qoe[a];
		if (s) {
			let { incompatibleTokens: t } = s;
			if (Array.isArray(t)) {
				let e = f.find((e) => t.includes(e.token) || e.token === a);
				if (e) throw RangeError(`The format string mustn't contain \`${e.fullToken}\` and \`${n}\` at the same time`);
			} else if (s.incompatibleTokens === "*" && f.length > 0) throw RangeError(`The format string mustn't contain \`${n}\` and any other token at the same time`);
			f.push({
				token: a,
				fullToken: n
			});
			let r = s.run(e, n, o.match, l);
			if (!r) return i();
			u.push(r.setter), e = r.rest;
		} else {
			if (a.match($oe)) throw RangeError("Format string contains an unescaped latin alphabet character `" + a + "`");
			if (n === "''" ? n = "'" : a === "'" && (n = tse(n)), e.indexOf(n) === 0) e = e.slice(n.length);
			else return i();
		}
	}
	if (e.length > 0 && Qoe.test(e)) return i();
	let p = u.map((e) => e.priority).sort((e, t) => t - e).filter((e, t, n) => n.indexOf(e) === t).map((e) => u.filter((t) => t.priority === e).sort((e, t) => t.subPriority - e.subPriority)).map((e) => e[0]), m = W8(n, r?.in);
	if (isNaN(+m)) return i();
	let h = {};
	for (let e of p) {
		if (!e.validate(m, l)) return i();
		let t = e.set(m, h, l);
		Array.isArray(t) ? (m = t[0], Object.assign(h, t[1])) : m = t;
	}
	return m;
}
function tse(e) {
	return e.match(Xoe)[1].replace(Zoe, "'");
}
//#endregion
//#region ../../node_modules/date-fns/isSameMonth.js
function d7(e, t, n) {
	let [r, i] = $8(n?.in, e, t);
	return r.getFullYear() === i.getFullYear() && r.getMonth() === i.getMonth();
}
//#endregion
//#region ../../node_modules/date-fns/isSameQuarter.js
function nse(e, t, n) {
	let [r, i] = $8(n?.in, e, t);
	return +_5(r) == +_5(i);
}
//#endregion
//#region ../../node_modules/date-fns/isSameYear.js
function rse(e, t, n) {
	let [r, i] = $8(n?.in, e, t);
	return r.getFullYear() === i.getFullYear();
}
//#endregion
//#region ../../node_modules/date-fns/isWithinInterval.js
function f7(e, t, n) {
	let r = +W8(e, n?.in), [i, a] = [+W8(t.start, n?.in), +W8(t.end, n?.in)].sort((e, t) => e - t);
	return r >= i && r <= a;
}
//#endregion
//#region ../../node_modules/date-fns/subDays.js
function ise(e, t, n) {
	return G8(e, -t, n);
}
//#endregion
//#region ../../node_modules/date-fns/parseISO.js
function ase(e, t) {
	let n = () => U8(t?.in, NaN), r = t?.additionalDigits ?? 2, i = lse(e), a;
	if (i.date) {
		let e = use(i.date, r);
		a = dse(e.restDateString, e.year);
	}
	if (!a || isNaN(+a)) return n();
	let o = +a, s = 0, c;
	if (i.time && (s = fse(i.time), isNaN(s))) return n();
	if (i.timezone) {
		if (c = pse(i.timezone), isNaN(c)) return n();
	} else {
		let e = new Date(o + s), n = W8(0, t?.in);
		return n.setFullYear(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate()), n.setHours(e.getUTCHours(), e.getUTCMinutes(), e.getUTCSeconds(), e.getUTCMilliseconds()), n;
	}
	return W8(o + s + c, t?.in);
}
var p7 = {
	dateTimeDelimiter: /[T ]/,
	timeZoneDelimiter: /[Z ]/i,
	timezone: /([Z+-].*)$/
}, ose = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, sse = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, cse = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function lse(e) {
	let t = {}, n = e.split(p7.dateTimeDelimiter), r;
	if (n.length > 2) return t;
	if (/:/.test(n[0]) ? r = n[0] : (t.date = n[0], r = n[1], p7.timeZoneDelimiter.test(t.date) && (t.date = e.split(p7.timeZoneDelimiter)[0], r = e.substr(t.date.length, e.length))), r) {
		let e = p7.timezone.exec(r);
		e ? (t.time = r.replace(e[1], ""), t.timezone = e[1]) : t.time = r;
	}
	return t;
}
function use(e, t) {
	let n = RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"), r = e.match(n);
	if (!r) return {
		year: NaN,
		restDateString: ""
	};
	let i = r[1] ? parseInt(r[1]) : null, a = r[2] ? parseInt(r[2]) : null;
	return {
		year: a === null ? i : a * 100,
		restDateString: e.slice((r[1] || r[2]).length)
	};
}
function dse(e, t) {
	if (t === null) return /* @__PURE__ */ new Date(NaN);
	let n = e.match(ose);
	if (!n) return /* @__PURE__ */ new Date(NaN);
	let r = !!n[4], i = m7(n[1]), a = m7(n[2]) - 1, o = m7(n[3]), s = m7(n[4]), c = m7(n[5]) - 1;
	if (r) return vse(t, s, c) ? mse(t, s, c) : /* @__PURE__ */ new Date(NaN);
	{
		let e = /* @__PURE__ */ new Date(0);
		return !gse(t, a, o) || !_se(t, i) ? /* @__PURE__ */ new Date(NaN) : (e.setUTCFullYear(t, a, Math.max(i, o)), e);
	}
}
function m7(e) {
	return e ? parseInt(e) : 1;
}
function fse(e) {
	let t = e.match(sse);
	if (!t) return NaN;
	let n = h7(t[1]), r = h7(t[2]), i = h7(t[3]);
	return yse(n, r, i) ? n * B8 + r * z8 + i * 1e3 : NaN;
}
function h7(e) {
	return e && parseFloat(e.replace(",", ".")) || 0;
}
function pse(e) {
	if (e === "Z") return 0;
	let t = e.match(cse);
	if (!t) return 0;
	let n = t[1] === "+" ? -1 : 1, r = parseInt(t[2]), i = t[3] && parseInt(t[3]) || 0;
	return bse(r, i) ? n * (r * B8 + i * z8) : NaN;
}
function mse(e, t, n) {
	let r = /* @__PURE__ */ new Date(0);
	r.setUTCFullYear(e, 0, 4);
	let i = r.getUTCDay() || 7, a = (t - 1) * 7 + n + 1 - i;
	return r.setUTCDate(r.getUTCDate() + a), r;
}
var hse = [
	31,
	null,
	31,
	30,
	31,
	30,
	31,
	31,
	30,
	31,
	30,
	31
];
function g7(e) {
	return e % 400 == 0 || e % 4 == 0 && e % 100 != 0;
}
function gse(e, t, n) {
	return t >= 0 && t <= 11 && n >= 1 && n <= (hse[t] || (g7(e) ? 29 : 28));
}
function _se(e, t) {
	return t >= 1 && t <= (g7(e) ? 366 : 365);
}
function vse(e, t, n) {
	return t >= 1 && t <= 53 && n >= 0 && n <= 6;
}
function yse(e, t, n) {
	return e === 24 ? t === 0 && n === 0 : n >= 0 && n < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function bse(e, t) {
	return t >= 0 && t <= 59;
}
//#endregion
//#region ../../node_modules/date-fns/setMonth.js
function _7(e, t, n) {
	let r = W8(e, n?.in), i = r.getFullYear(), a = r.getDate(), o = U8(n?.in || e, 0);
	o.setFullYear(i, t, 15), o.setHours(0, 0, 0, 0);
	let s = noe(o);
	return r.setMonth(t, Math.min(a, s)), r;
}
//#endregion
//#region ../../node_modules/date-fns/setHours.js
function v7(e, t, n) {
	let r = W8(e, n?.in);
	return r.setHours(t), r;
}
//#endregion
//#region ../../node_modules/date-fns/setMinutes.js
function y7(e, t, n) {
	let r = W8(e, n?.in);
	return r.setMinutes(t), r;
}
//#endregion
//#region ../../node_modules/date-fns/setQuarter.js
function b7(e, t, n) {
	let r = W8(e, n?.in), i = t - (Math.trunc(r.getMonth() / 3) + 1);
	return _7(r, r.getMonth() + i * 3);
}
//#endregion
//#region ../../node_modules/date-fns/setSeconds.js
function x7(e, t, n) {
	let r = W8(e, n?.in);
	return r.setSeconds(t), r;
}
//#endregion
//#region ../../node_modules/date-fns/setYear.js
function S7(e, t, n) {
	let r = W8(e, n?.in);
	return isNaN(+r) ? U8(n?.in || e, NaN) : (r.setFullYear(t), r);
}
//#endregion
//#region ../../node_modules/date-fns/subMonths.js
function C7(e, t, n) {
	return K8(e, -t, n);
}
//#endregion
//#region ../../node_modules/date-fns/subQuarters.js
function w7(e, t, n) {
	return r5(e, -t, n);
}
//#endregion
//#region ../../node_modules/date-fns/subWeeks.js
function T7(e, t, n) {
	return i5(e, -t, n);
}
//#endregion
//#region ../../node_modules/date-fns/subYears.js
function E7(e, t, n) {
	return a5(e, -t, n);
}
//#endregion
//#region ../../node_modules/@floating-ui/react/dist/floating-ui.react.utils.mjs
var D7 = typeof document < "u" ? h : function() {}, xse = { ...e }.useInsertionEffect || ((e) => e());
function Sse(t) {
	let n = e.useRef(() => {});
	return xse(() => {
		n.current = t;
	}), e.useCallback(function() {
		var e = [...arguments];
		return n.current == null ? void 0 : n.current(...e);
	}, []);
}
//#endregion
//#region ../../node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.mjs
var O7 = typeof document < "u" ? h : function() {};
function k7(e, t) {
	if (e === t) return !0;
	if (typeof e != typeof t) return !1;
	if (typeof e == "function" && e.toString() === t.toString()) return !0;
	let n, r, i;
	if (e && t && typeof e == "object") {
		if (Array.isArray(e)) {
			if (n = e.length, n !== t.length) return !1;
			for (r = n; r-- !== 0;) if (!k7(e[r], t[r])) return !1;
			return !0;
		}
		if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length) return !1;
		for (r = n; r-- !== 0;) if (!{}.hasOwnProperty.call(t, i[r])) return !1;
		for (r = n; r-- !== 0;) {
			let n = i[r];
			if (!(n === "_owner" && e.$$typeof) && !k7(e[n], t[n])) return !1;
		}
		return !0;
	}
	return e !== e && t !== t;
}
function A7(e) {
	return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function j7(e, t) {
	let n = A7(e);
	return Math.round(t * n) / n;
}
function M7(t) {
	let n = e.useRef(t);
	return O7(() => {
		n.current = t;
	}), n;
}
function Cse(t) {
	t === void 0 && (t = {});
	let { placement: n = "bottom", strategy: r = "absolute", middleware: i = [], platform: a, elements: { reference: o, floating: s } = {}, transform: c = !0, whileElementsMounted: l, open: u } = t, [d, f] = e.useState({
		x: 0,
		y: 0,
		strategy: r,
		placement: n,
		middlewareData: {},
		isPositioned: !1
	}), [p, m] = e.useState(i);
	k7(p, i) || m(i);
	let [h, g] = e.useState(null), [_, v] = e.useState(null), y = e.useCallback((e) => {
		e !== C.current && (C.current = e, g(e));
	}, []), b = e.useCallback((e) => {
		e !== w.current && (w.current = e, v(e));
	}, []), x = o || h, S = s || _, C = e.useRef(null), w = e.useRef(null), T = e.useRef(d), E = l != null, D = M7(l), O = M7(a), k = M7(u), A = e.useCallback(() => {
		if (!C.current || !w.current) return;
		let e = {
			placement: n,
			strategy: r,
			middleware: p
		};
		O.current && (e.platform = O.current), Ep(C.current, w.current, e).then((e) => {
			let t = {
				...e,
				isPositioned: k.current !== !1
			};
			j.current && !k7(T.current, t) && (T.current = t, ze.flushSync(() => {
				f(t);
			}));
		});
	}, [
		p,
		n,
		r,
		O,
		k
	]);
	O7(() => {
		u === !1 && T.current.isPositioned && (T.current.isPositioned = !1, f((e) => ({
			...e,
			isPositioned: !1
		})));
	}, [u]);
	let j = e.useRef(!1);
	O7(() => (j.current = !0, () => {
		j.current = !1;
	}), []), O7(() => {
		if (x && (C.current = x), S && (w.current = S), x && S) {
			if (D.current) return D.current(x, S, A);
			A();
		}
	}, [
		x,
		S,
		A,
		D,
		E
	]);
	let M = e.useMemo(() => ({
		reference: C,
		floating: w,
		setReference: y,
		setFloating: b
	}), [y, b]), ee = e.useMemo(() => ({
		reference: x,
		floating: S
	}), [x, S]), te = e.useMemo(() => {
		let e = {
			position: r,
			left: 0,
			top: 0
		};
		if (!ee.floating) return e;
		let t = j7(ee.floating, d.x), n = j7(ee.floating, d.y);
		return c ? {
			...e,
			transform: "translate(" + t + "px, " + n + "px)",
			...A7(ee.floating) >= 1.5 && { willChange: "transform" }
		} : {
			position: r,
			left: t,
			top: n
		};
	}, [
		r,
		c,
		ee.floating,
		d.x,
		d.y
	]);
	return e.useMemo(() => ({
		...d,
		update: A,
		refs: M,
		elements: ee,
		floatingStyles: te
	}), [
		d,
		A,
		M,
		ee,
		te
	]);
}
var wse = (e) => {
	function t(e) {
		return {}.hasOwnProperty.call(e, "current");
	}
	return {
		name: "arrow",
		options: e,
		fn(n) {
			let { element: r, padding: i } = typeof e == "function" ? e(n) : e;
			return r && t(r) ? r.current == null ? {} : Tp({
				element: r.current,
				padding: i
			}).fn(n) : r ? Tp({
				element: r,
				padding: i
			}).fn(n) : {};
		}
	};
}, Tse = (e, t) => ({
	...Cp(e),
	options: [e, t]
}), Ese = (e, t) => ({
	...wp(e),
	options: [e, t]
}), Dse = (e, t) => ({
	...wse(e),
	options: [e, t]
}), Ose = "ArrowLeft", kse = "ArrowRight", Ase = "ArrowUp", jse = "ArrowDown", Mse = [Ose, kse], Nse = [Ase, jse];
[...Mse, ...Nse];
var Pse = { ...e }, N7 = !1, Fse = 0, P7 = () => "floating-ui-" + Math.random().toString(36).slice(2, 6) + Fse++;
function Ise() {
	let [t, n] = e.useState(() => N7 ? P7() : void 0);
	return D7(() => {
		t ?? n(P7());
	}, []), e.useEffect(() => {
		N7 = !0;
	}, []), t;
}
var F7 = Pse.useId || Ise, Lse = /*#__PURE__*/ e.forwardRef(function(t, n) {
	let { context: { placement: r, elements: { floating: i }, middlewareData: { arrow: a, shift: o } }, width: s = 14, height: c = 7, tipRadius: l = 0, strokeWidth: u = 0, staticOffset: d, stroke: f, d: p, style: { transform: m, ...h } = {}, ...g } = t, _ = F7(), [v, y] = e.useState(!1);
	if (D7(() => {
		i && np(i).direction === "rtl" && y(!0);
	}, [i]), !i) return null;
	let [b, x] = r.split("-"), S = b === "top" || b === "bottom", C = d;
	(S && o != null && o.x || !S && o != null && o.y) && (C = null);
	let w = u * 2, T = w / 2, E = s / 2 * (l / -8 + 1), D = c / 2 * l / 4, O = !!p, k = C && x === "end" ? "bottom" : "top", A = C && x === "end" ? "right" : "left";
	C && v && (A = x === "end" ? "left" : "right");
	let j = a?.x == null ? "" : C || a.x, M = a?.y == null ? "" : C || a.y, ee = p || "M0,0" + (" H" + s) + (" L" + (s - E) + "," + (c - D)) + (" Q" + s / 2 + "," + c + " " + E + "," + (c - D)) + " Z", te = {
		top: O ? "rotate(180deg)" : "",
		left: O ? "rotate(90deg)" : "rotate(-90deg)",
		bottom: O ? "" : "rotate(180deg)",
		right: O ? "rotate(-90deg)" : "rotate(90deg)"
	}[b];
	return /*#__PURE__*/ I("svg", {
		...g,
		"aria-hidden": !0,
		ref: n,
		width: O ? s : s + w,
		height: s,
		viewBox: "0 0 " + s + " " + (c > s ? c : s),
		style: {
			position: "absolute",
			pointerEvents: "none",
			[A]: j,
			[k]: M,
			[b]: S || O ? "100%" : "calc(100% - " + w / 2 + "px)",
			transform: [te, m].filter((e) => !!e).join(" "),
			...h
		},
		children: [
			w > 0 && /*#__PURE__*/ F("path", {
				clipPath: "url(#" + _ + ")",
				fill: "none",
				stroke: f,
				strokeWidth: w + +!p,
				d: ee
			}),
			/*#__PURE__*/ F("path", {
				stroke: w && !p ? g.fill : "none",
				d: ee
			}),
			/*#__PURE__*/ F("clipPath", {
				id: _,
				children: /*#__PURE__*/ F("rect", {
					x: -T,
					y: T * (O ? -1 : 1),
					width: s + w,
					height: s
				})
			})
		]
	});
});
function Rse() {
	let e = /* @__PURE__ */ new Map();
	return {
		emit(t, n) {
			var r;
			(r = e.get(t)) == null || r.forEach((e) => e(n));
		},
		on(t, n) {
			e.has(t) || e.set(t, /* @__PURE__ */ new Set()), e.get(t).add(n);
		},
		off(t, n) {
			var r;
			(r = e.get(t)) == null || r.delete(n);
		}
	};
}
var zse = /*#__PURE__*/ e.createContext(null), Bse = /*#__PURE__*/ e.createContext(null), Vse = () => e.useContext(zse)?.id || null, Hse = () => e.useContext(Bse);
function Use(t) {
	let { open: n = !1, onOpenChange: r, elements: i } = t, a = F7(), o = e.useRef({}), [s] = e.useState(() => Rse()), c = Vse() != null, [l, u] = e.useState(i.reference), d = Sse((e, t, n) => {
		o.current.openEvent = e ? t : void 0, s.emit("openchange", {
			open: e,
			event: t,
			reason: n,
			nested: c
		}), r?.(e, t, n);
	}), f = e.useMemo(() => ({ setPositionReference: u }), []), p = e.useMemo(() => ({
		reference: l || i.reference || null,
		floating: i.floating || null,
		domReference: i.reference
	}), [
		l,
		i.reference,
		i.floating
	]);
	return e.useMemo(() => ({
		dataRef: o,
		open: n,
		onOpenChange: d,
		elements: p,
		events: s,
		floatingId: a,
		refs: f
	}), [
		n,
		d,
		p,
		s,
		a,
		f
	]);
}
function Wse(t) {
	t === void 0 && (t = {});
	let { nodeId: n } = t, r = Use({
		...t,
		elements: {
			reference: null,
			floating: null,
			...t.elements
		}
	}), i = t.rootContext || r, a = i.elements, [o, s] = e.useState(null), [c, l] = e.useState(null), u = a?.domReference || o, d = e.useRef(null), f = Hse();
	D7(() => {
		u && (d.current = u);
	}, [u]);
	let p = Cse({
		...t,
		elements: {
			...a,
			...c && { reference: c }
		}
	}), m = e.useCallback((e) => {
		let t = Jf(e) ? {
			getBoundingClientRect: () => e.getBoundingClientRect(),
			getClientRects: () => e.getClientRects(),
			contextElement: e
		} : e;
		l(t), p.refs.setReference(t);
	}, [p.refs]), h = e.useCallback((e) => {
		(Jf(e) || e === null) && (d.current = e, s(e)), (Jf(p.refs.reference.current) || p.refs.reference.current === null || e !== null && !Jf(e)) && p.refs.setReference(e);
	}, [p.refs]), g = e.useMemo(() => ({
		...p.refs,
		setReference: h,
		setPositionReference: m,
		domReference: d
	}), [
		p.refs,
		h,
		m
	]), _ = e.useMemo(() => ({
		...p.elements,
		domReference: u
	}), [p.elements, u]), v = e.useMemo(() => ({
		...p,
		...i,
		refs: g,
		elements: _,
		nodeId: n
	}), [
		p,
		g,
		_,
		n,
		i
	]);
	return D7(() => {
		i.dataRef.current.floatingContext = v;
		let e = f?.nodesRef.current.find((e) => e.id === n);
		e && (e.context = v);
	}), e.useMemo(() => ({
		...p,
		context: v,
		refs: g,
		elements: _
	}), [
		p,
		g,
		_,
		v
	]);
}
//#endregion
//#region ../../node_modules/react-datepicker/dist/index.es.js
var I7 = function(e, t) {
	return I7 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, t) {
		e.__proto__ = t;
	} || function(e, t) {
		for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
	}, I7(e, t);
};
function L7(e, t) {
	if (typeof t != "function" && t !== null) throw TypeError("Class extends value " + String(t) + " is not a constructor or null");
	I7(e, t);
	function n() {
		this.constructor = e;
	}
	e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var R7 = function() {
	return R7 = Object.assign || function(e) {
		for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n], t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
		return e;
	}, R7.apply(this, arguments);
};
function z7(e, t, n) {
	if (n || arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++) (a || !(r in t)) && (a ||= Array.prototype.slice.call(t, 0, r), a[r] = t[r]);
	return e.concat(a || Array.prototype.slice.call(t));
}
var B7 = function(e) {
	var n = e.showTimeSelectOnly, r = n === void 0 ? !1 : n, i = e.showTime, a = i === void 0 ? !1 : i, o = e.className, s = e.children, c = r ? "Choose Time" : `Choose Date${a ? " and Time" : ""}`;
	return t.createElement("div", {
		className: o,
		role: "dialog",
		"aria-label": c,
		"aria-modal": "true"
	}, s);
}, Gse = function(e, t) {
	var n = v(null), r = v(e);
	r.current = e;
	var i = u(function(e) {
		var i, a = e.composed && e.composedPath && e.composedPath().find(function(e) {
			return e instanceof Node;
		}) || e.target;
		n.current && !n.current.contains(a) && (t && a instanceof HTMLElement && a.classList.contains(t) || (i = r.current) == null || i.call(r, e));
	}, [t]);
	return p(function() {
		return document.addEventListener("mousedown", i), function() {
			document.removeEventListener("mousedown", i);
		};
	}, [i]), n;
}, V7 = function(e) {
	var n = e.children, r = e.onClickOutside, i = e.className, a = e.containerRef, o = e.style, s = e.ignoreClass, c = Gse(r, s);
	return t.createElement("div", {
		className: i,
		style: o,
		ref: function(e) {
			c.current = e, a && (a.current = e);
		}
	}, n);
}, H7;
(function(e) {
	e.ArrowUp = "ArrowUp", e.ArrowDown = "ArrowDown", e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Home = "Home", e.End = "End", e.Enter = "Enter", e.Space = " ", e.Tab = "Tab", e.Escape = "Escape", e.Backspace = "Backspace", e.X = "x";
})(H7 ||= {});
function U7() {
	return typeof window < "u" ? window : globalThis;
}
var W7 = 12;
function G7(e) {
	if (e == null) return /* @__PURE__ */ new Date();
	var t = typeof e == "string" ? ase(e) : W8(e);
	return q7(t) ? t : /* @__PURE__ */ new Date();
}
function K7(e, t, n, r, i) {
	i === void 0 && (i = G7());
	for (var a = f9(n) || f9(d9()), o = Array.isArray(t) ? t : [t], s = 0, c = o; s < c.length; s++) {
		var l = c[s], u = ese(e, l, i, {
			locale: a,
			useAdditionalWeekYearTokens: !0,
			useAdditionalDayOfYearTokens: !0
		});
		if (q7(u) && (!r || e === J7(u, l, n))) return u;
	}
	return null;
}
function q7(e, t) {
	return l5(e) && !X5(e, /* @__PURE__ */ new Date("1/1/1800"));
}
function J7(e, t, n) {
	if (n === "en") return V5(e, t, {
		useAdditionalWeekYearTokens: !0,
		useAdditionalDayOfYearTokens: !0
	});
	var r = n ? f9(n) : void 0;
	return n && !r && console.warn(`A locale object was not found for the provided string ["${n}"].`), r ||= f9(d9()), V5(e, t, {
		locale: r,
		useAdditionalWeekYearTokens: !0,
		useAdditionalDayOfYearTokens: !0
	});
}
function Y7(e, t) {
	var n = t.dateFormat, r = t.locale, i = Array.isArray(n) && n.length > 0 ? n[0] : n;
	return e && J7(e, i, r) || "";
}
var X7 = " - ";
function Kse(e, t, n) {
	if (!e && !t) return "";
	var r = e ? Y7(e, n) : "", i = t ? Y7(t, n) : "";
	return `${r}${n.rangeSeparator || X7}${i}`;
}
function qse(e, t) {
	if (!e?.length) return "";
	var n = e[0] ? Y7(e[0], t) : "";
	return e.length === 1 ? n : e.length === 2 && e[1] ? `${n}, ${Y7(e[1], t)}` : `${n} (+${e.length - 1})`;
}
function Z7(e, t) {
	var n = t.hour, r = n === void 0 ? 0 : n, i = t.minute, a = i === void 0 ? 0 : i, o = t.second;
	return v7(y7(x7(e, o === void 0 ? 0 : o), a), r);
}
function Jse(e) {
	return T5(e);
}
function Yse(e, t) {
	return J7(e, "ddd", t);
}
function Q7(e) {
	return e5(e);
}
function $7(e, t, n) {
	return Y8(e, {
		locale: f9(t || d9()),
		weekStartsOn: n
	});
}
function e9(e) {
	return v5(e);
}
function t9(e) {
	return b5(e);
}
function n9(e) {
	return _5(e);
}
function r9() {
	return e5(G7());
}
function i9(e) {
	return h5(e);
}
function Xse(e) {
	return Nae(e);
}
function Zse(e) {
	return g5(e);
}
function a9(e, t) {
	return e && t ? rse(e, t) : !e && !t;
}
function o9(e, t) {
	return e && t ? d7(e, t) : !e && !t;
}
function s9(e, t) {
	return e && t ? nse(e, t) : !e && !t;
}
function c9(e, t) {
	return e && t ? jae(e, t) : !e && !t;
}
function l9(e, t) {
	return e && t ? aoe(e, t) : !e && !t;
}
function u9(e, t, n) {
	var r, i = e5(t), a = h5(n);
	try {
		r = f7(e, {
			start: i,
			end: a
		});
	} catch {
		r = !1;
	}
	return r;
}
function d9() {
	return U7().__localeId__;
}
function f9(e) {
	if (typeof e == "string") {
		var t = U7();
		return t.__localeData__ ? t.__localeData__[e] : void 0;
	} else return e;
}
function Qse(e, t, n) {
	return t(J7(e, "EEEE", n));
}
function $se(e, t) {
	return J7(e, "EEEEEE", t);
}
function ece(e, t) {
	return J7(e, "EEE", t);
}
function p9(e, t) {
	return J7(_7(G7(), e), "LLLL", t);
}
function m9(e, t) {
	return J7(_7(G7(), e), "LLL", t);
}
function tce(e, t) {
	return J7(b7(G7(), e), "QQQ", t);
}
function h9(e, t) {
	var n = t === void 0 ? {} : t, r = n.minDate, i = n.maxDate, a = n.excludeDates, o = n.excludeDateIntervals, s = n.includeDates, c = n.includeDateIntervals, l = n.filterDate;
	return C9(e, {
		minDate: r,
		maxDate: i
	}) || a && a.some(function(t) {
		return t instanceof Date ? c9(e, t) : c9(e, t.date);
	}) || o && o.some(function(t) {
		var n = t.start, r = t.end;
		return f7(e, {
			start: n,
			end: r
		});
	}) || s && !s.some(function(t) {
		return c9(e, t);
	}) || c && !c.some(function(t) {
		var n = t.start, r = t.end;
		return f7(e, {
			start: n,
			end: r
		});
	}) || l && !l(G7(e)) || !1;
}
function g9(e, t) {
	var n = t === void 0 ? {} : t, r = n.excludeDates, i = n.excludeDateIntervals;
	return i && i.length > 0 ? i.some(function(t) {
		var n = t.start, r = t.end;
		return f7(e, {
			start: n,
			end: r
		});
	}) : r && r.some(function(t) {
		return t instanceof Date ? c9(e, t) : c9(e, t.date ?? /* @__PURE__ */ new Date());
	}) || !1;
}
function _9(e, t) {
	var n = t === void 0 ? {} : t, r = n.minDate, i = n.maxDate, a = n.excludeDates, o = n.includeDates, s = n.filterDate;
	return C9(e, {
		minDate: r ? v5(r) : void 0,
		maxDate: i ? g5(i) : void 0
	}) || a?.some(function(t) {
		return o9(e, t instanceof Date ? t : t.date);
	}) || o && !o.some(function(t) {
		return o9(e, t);
	}) || s && !s(G7(e)) || !1;
}
function v9(e, t, n, r) {
	var i = J5(e), a = G5(e), o = J5(t), s = G5(t), c = J5(r);
	return i === o && i === c ? a <= n && n <= s : i < o ? c === i && a <= n || c === o && s >= n || c < o && c > i : !1;
}
function nce(e, t) {
	var n = t === void 0 ? {} : t, r = n.minDate, i = n.maxDate, a = n.excludeDates, o = n.includeDates;
	return C9(e, {
		minDate: r,
		maxDate: i
	}) || a && a.some(function(t) {
		return o9(t instanceof Date ? t : t.date, e);
	}) || o && !o.some(function(t) {
		return o9(t, e);
	}) || !1;
}
function y9(e, t) {
	var n = t === void 0 ? {} : t, r = n.minDate, i = n.maxDate, a = n.excludeDates, o = n.includeDates, s = n.filterDate;
	return C9(e, {
		minDate: r,
		maxDate: i
	}) || a?.some(function(t) {
		return s9(e, t instanceof Date ? t : t.date);
	}) || o && !o.some(function(t) {
		return s9(e, t);
	}) || s && !s(G7(e)) || !1;
}
function b9(e, t, n) {
	if (!t || !n || !l5(t) || !l5(n)) return !1;
	var r = J5(t), i = J5(n);
	return r <= e && i >= e;
}
function x9(e, t) {
	var n = t === void 0 ? {} : t, r = n.minDate, i = n.maxDate, a = n.excludeDates, o = n.includeDates, s = n.filterDate, c = new Date(e, 0, 1);
	return C9(c, {
		minDate: r ? b5(r) : void 0,
		maxDate: i ? y5(i) : void 0
	}) || a?.some(function(e) {
		return a9(c, e instanceof Date ? e : e.date);
	}) || o && !o.some(function(e) {
		return a9(c, e);
	}) || s && !s(G7(c)) || !1;
}
function S9(e, t, n, r) {
	var i = J5(e), a = d5(e), o = J5(t), s = d5(t), c = J5(r);
	return i === o && i === c ? a <= n && n <= s : i < o ? c === i && a <= n || c === o && s >= n || c < o && c > i : !1;
}
function C9(e, t) {
	var n = t === void 0 ? {} : t, r = n.minDate, i = n.maxDate;
	return (r && t5(e, r) < 0 || i && t5(e, i) > 0) ?? !1;
}
function w9(e, t) {
	return t.some(function(t) {
		return U5(t) === U5(e) && W5(t) === W5(e) && K5(t) === K5(e);
	});
}
function T9(e, t) {
	var n = t === void 0 ? {} : t, r = n.excludeTimes, i = n.includeTimes, a = n.filterTime;
	return r && w9(e, r) || i && !w9(e, i) || a && !a(e) || !1;
}
function E9(e, t) {
	var n = t.minTime, r = t.maxTime;
	if (!n || !r) throw Error("Both minTime and maxTime props required");
	var i = G7();
	i = v7(i, U5(e)), i = y7(i, W5(e)), i = x7(i, K5(e));
	var a = G7();
	a = v7(a, U5(n)), a = y7(a, W5(n)), a = x7(a, K5(n));
	var o = G7();
	o = v7(o, U5(r)), o = y7(o, W5(r)), o = x7(o, K5(r));
	var s;
	try {
		s = !f7(i, {
			start: a,
			end: o
		});
	} catch {
		s = !1;
	}
	return s;
}
function D9(e, t) {
	var n = t === void 0 ? {} : t, r = n.minDate, i = n.includeDates, a = C7(e, 1);
	return r && u5(r, a) > 0 || i && i.every(function(e) {
		return u5(e, a) > 0;
	}) || !1;
}
function O9(e, t) {
	var n = t === void 0 ? {} : t, r = n.maxDate, i = n.includeDates, a = K8(e, 1);
	return r && u5(a, r) > 0 || i && i.every(function(e) {
		return u5(a, e) > 0;
	}) || !1;
}
function rce(e, t) {
	var n = t === void 0 ? {} : t, r = n.minDate, i = n.includeDates, a = w7(b5(e), 1);
	return r && f5(r, a) > 0 || i && i.every(function(e) {
		return f5(e, a) > 0;
	}) || !1;
}
function ice(e, t) {
	var n = t === void 0 ? {} : t, r = n.maxDate, i = n.includeDates, a = r5(y5(e), 1);
	return r && f5(a, r) > 0 || i && i.every(function(e) {
		return f5(a, e) > 0;
	}) || !1;
}
function k9(e, t) {
	var n = t === void 0 ? {} : t, r = n.minDate, i = n.includeDates, a = E7(e, 1);
	return r && p5(r, a) > 0 || i && i.every(function(e) {
		return p5(e, a) > 0;
	}) || !1;
}
function ace(e, t) {
	var n = t === void 0 ? {} : t, r = n.minDate, i = n.yearItemNumber, a = i === void 0 ? W7 : i, o = F9(t9(E7(e, a)), a).endPeriod, s = r && J5(r);
	return s && s > o || !1;
}
function A9(e, t) {
	var n = t === void 0 ? {} : t, r = n.maxDate, i = n.includeDates, a = a5(e, 1);
	return r && p5(a, r) > 0 || i && i.every(function(e) {
		return p5(a, e) > 0;
	}) || !1;
}
function oce(e, t) {
	var n = t === void 0 ? {} : t, r = n.maxDate, i = n.yearItemNumber, a = i === void 0 ? W7 : i, o = F9(a5(e, a), a).startPeriod, s = r && J5(r);
	return s && s < o || !1;
}
function j9(e) {
	var t = e.minDate, n = e.includeDates;
	return n && t ? s5(n.filter(function(e) {
		return t5(e, t) >= 0;
	})) : n ? s5(n) : t;
}
function M9(e) {
	var t = e.maxDate, n = e.includeDates;
	return n && t ? o5(n.filter(function(e) {
		return t5(e, t) <= 0;
	})) : n ? o5(n) : t;
}
function N9(e, t) {
	e === void 0 && (e = []), t === void 0 && (t = "react-datepicker__day--highlighted");
	for (var n = /* @__PURE__ */ new Map(), r = 0, i = e.length; r < i; r++) {
		var a = e[r];
		if (c5(a)) {
			var o = J7(a, "MM.dd.yyyy"), s = n.get(o) || [];
			s.includes(t) || (s.push(t), n.set(o, s));
		} else if (typeof a == "object") {
			var c = Object.keys(a)[0] ?? "", l = a[c];
			if (typeof c == "string" && Array.isArray(l)) for (var u = 0, d = l.length; u < d; u++) {
				var f = l[u];
				if (f) {
					var o = J7(f, "MM.dd.yyyy"), s = n.get(o) || [];
					s.includes(c) || (s.push(c), n.set(o, s));
				}
			}
		}
	}
	return n;
}
function sce(e, t) {
	return e.length === t.length ? e.every(function(e, n) {
		return e === t[n];
	}) : !1;
}
function cce(e, t) {
	e === void 0 && (e = []), t === void 0 && (t = "react-datepicker__day--holidays");
	var n = /* @__PURE__ */ new Map();
	return e.forEach(function(e) {
		var r = e.date, i = e.holidayName;
		if (c5(r)) {
			var a = J7(r, "MM.dd.yyyy"), o = n.get(a) || {
				className: "",
				holidayNames: []
			};
			if (!("className" in o && o.className === t && sce(o.holidayNames, [i]))) {
				o.className = t;
				var s = o.holidayNames;
				o.holidayNames = s ? z7(z7([], s, !0), [i], !1) : [i], n.set(a, o);
			}
		}
	}), n;
}
function lce(e, t, n, r, i) {
	for (var a = i.length, o = [], s = 0; s < a; s++) {
		var c = e, l = i[s];
		l && (c = Dae(c, U5(l)), c = n5(c, W5(l)), c = Aae(c, K5(l)));
		var u = n5(e, (n + 1) * r);
		Y5(c, t) && X5(c, u) && l != null && o.push(l);
	}
	return o;
}
function P9(e) {
	return e < 10 ? `0${e}` : `${e}`;
}
function F9(e, t) {
	t === void 0 && (t = W7);
	var n = Math.ceil(J5(e) / t) * t;
	return {
		startPeriod: n - (t - 1),
		endPeriod: n
	};
}
function uce(e) {
	var t = new Date(e.getFullYear(), e.getMonth(), e.getDate()), n = new Date(e.getFullYear(), e.getMonth(), e.getDate(), 24);
	return Math.round((n - +t) / 36e5);
}
function I9(e) {
	var t = e.getSeconds(), n = e.getMilliseconds();
	return W8(e.getTime() - t * 1e3 - n);
}
function dce(e, t) {
	return I9(e).getTime() === I9(t).getTime();
}
function L9(e) {
	if (!c5(e)) throw Error("Invalid date");
	var t = new Date(e);
	return t.setHours(0, 0, 0, 0), t;
}
function R9(e, t) {
	if (!c5(e) || !c5(t)) throw Error("Invalid date received");
	return X5(L9(e), L9(t));
}
function z9(e) {
	return e.key === H7.Space;
}
var fce = function(e) {
	L7(n, e);
	function n(n) {
		var r = e.call(this, n) || this;
		return r.inputRef = t.createRef(), r.onTimeChange = function(e) {
			var t, n;
			r.setState({ time: e });
			var i = r.props.date, a = i instanceof Date && !isNaN(+i) ? i : /* @__PURE__ */ new Date();
			if (e?.includes(":")) {
				var o = e.split(":"), s = o[0], c = o[1];
				a.setHours(Number(s)), a.setMinutes(Number(c));
			}
			(n = (t = r.props).onChange) == null || n.call(t, a);
		}, r.renderTimeInput = function() {
			var e = r.state.time, n = r.props, a = n.date, o = n.timeString, s = n.customTimeInput;
			return s ? i(s, {
				date: a,
				value: e,
				onChange: r.onTimeChange
			}) : t.createElement("input", {
				type: "time",
				className: "react-datepicker-time__input",
				placeholder: "Time",
				name: "time-input",
				ref: r.inputRef,
				onClick: function() {
					var e;
					(e = r.inputRef.current) == null || e.focus();
				},
				required: !0,
				value: e,
				onChange: function(e) {
					r.onTimeChange(e.target.value || o);
				}
			});
		}, r.state = { time: r.props.timeString }, r;
	}
	return n.getDerivedStateFromProps = function(e, t) {
		return e.timeString === t.time ? null : { time: e.timeString };
	}, n.prototype.render = function() {
		return t.createElement("div", { className: "react-datepicker__input-time-container" }, t.createElement("div", { className: "react-datepicker-time__caption" }, this.props.timeInputLabel), t.createElement("div", { className: "react-datepicker-time__input-container" }, t.createElement("div", { className: "react-datepicker-time__input" }, this.renderTimeInput())));
	}, n;
}(n), pce = function(e) {
	L7(n, e);
	function n() {
		var n = e !== null && e.apply(this, arguments) || this;
		return n.dayEl = s(), n.handleClick = function(e) {
			!n.isDisabled() && n.props.onClick && n.props.onClick(e);
		}, n.handleMouseEnter = function(e) {
			!n.isDisabled() && n.props.onMouseEnter && n.props.onMouseEnter(e);
		}, n.handleOnKeyDown = function(e) {
			var t, r;
			e.key === H7.Space && (e.preventDefault(), e.key = H7.Enter), (r = (t = n.props).handleOnKeyDown) == null || r.call(t, e);
		}, n.isSameDay = function(e) {
			return c9(n.props.day, e);
		}, n.isKeyboardSelected = function() {
			if (n.props.disabledKeyboardNavigation) return !1;
			var e = n.props.selectsMultiple ? n.props.selectedDates?.some(function(e) {
				return n.isSameDayOrWeek(e);
			}) : n.isSameDayOrWeek(n.props.selected), t = n.props.preSelection && n.isDisabled(n.props.preSelection);
			return !e && n.isSameDayOrWeek(n.props.preSelection) && !t;
		}, n.isDisabled = function(e) {
			return e === void 0 && (e = n.props.day), h9(e, {
				minDate: n.props.minDate,
				maxDate: n.props.maxDate,
				excludeDates: n.props.excludeDates,
				excludeDateIntervals: n.props.excludeDateIntervals,
				includeDateIntervals: n.props.includeDateIntervals,
				includeDates: n.props.includeDates,
				filterDate: n.props.filterDate
			});
		}, n.isExcluded = function() {
			return g9(n.props.day, {
				excludeDates: n.props.excludeDates,
				excludeDateIntervals: n.props.excludeDateIntervals
			});
		}, n.isStartOfWeek = function() {
			return c9(n.props.day, $7(n.props.day, n.props.locale, n.props.calendarStartDay));
		}, n.isSameWeek = function(e) {
			return n.props.showWeekPicker && c9(e, $7(n.props.day, n.props.locale, n.props.calendarStartDay));
		}, n.isSameDayOrWeek = function(e) {
			return n.isSameDay(e) || n.isSameWeek(e);
		}, n.getHighLightedClass = function() {
			var e = n.props, t = e.day, r = e.highlightDates;
			if (!r) return !1;
			var i = J7(t, "MM.dd.yyyy");
			return r.get(i);
		}, n.getHolidaysClass = function() {
			var e = n.props, t = e.day, r = e.holidays;
			if (!r) return [void 0];
			var i = J7(t, "MM.dd.yyyy");
			return r.has(i) ? [r.get(i)?.className] : [void 0];
		}, n.isInRange = function() {
			var e = n.props, t = e.day, r = e.startDate, i = e.endDate;
			return !r || !i ? !1 : u9(t, r, i);
		}, n.isInSelectingRange = function() {
			var e = n.props, t = e.day, r = e.selectsStart, i = e.selectsEnd, a = e.selectsRange, o = e.selectsDisabledDaysInRange, s = e.startDate, c = e.swapRange, l = e.endDate, u = n.props.selectingDate ?? n.props.preSelection;
			if (!(r || i || a) || !u || !o && n.isDisabled()) return !1;
			if (r && l && (X5(u, l) || l9(u, l))) return u9(t, u, l);
			if (i && s && (Y5(u, s) || l9(u, s))) return u9(t, s, u);
			if (a && s && !l) {
				if (l9(u, s) || Y5(u, s)) return u9(t, s, u);
				if (c && X5(u, s)) return u9(t, u, s);
			}
			return !1;
		}, n.isSelectingRangeStart = function() {
			if (!n.isInSelectingRange()) return !1;
			var e = n.props, t = e.day, r = e.startDate, i = e.selectsStart, a = e.swapRange, o = e.selectsRange, s = n.props.selectingDate ?? n.props.preSelection;
			return i ? c9(t, s) : o && a && r && s ? c9(t, X5(s, r) ? s : r) : c9(t, r);
		}, n.isSelectingRangeEnd = function() {
			if (!n.isInSelectingRange()) return !1;
			var e = n.props, t = e.day, r = e.endDate, i = e.selectsEnd, a = e.selectsRange, o = e.swapRange, s = e.startDate, c = n.props.selectingDate ?? n.props.preSelection;
			return i ? c9(t, c) : a && o && s && c ? c9(t, X5(c, s) ? s : c) : a ? c9(t, c) : c9(t, r);
		}, n.isRangeStart = function() {
			var e = n.props, t = e.day, r = e.startDate, i = e.endDate;
			return !r || !i ? !1 : c9(r, t);
		}, n.isRangeEnd = function() {
			var e = n.props, t = e.day, r = e.startDate, i = e.endDate;
			return !r || !i ? !1 : c9(i, t);
		}, n.isWeekend = function() {
			var e = toe(n.props.day);
			return e === 0 || e === 6;
		}, n.isAfterMonth = function() {
			return n.props.month !== void 0 && (n.props.month + 1) % 12 === G5(n.props.day);
		}, n.isBeforeMonth = function() {
			return n.props.month !== void 0 && (G5(n.props.day) + 1) % 12 === n.props.month;
		}, n.isCurrentDay = function() {
			return n.isSameDay(G7());
		}, n.isSelected = function() {
			return n.props.selectsMultiple ? n.props.selectedDates?.some(function(e) {
				return n.isSameDayOrWeek(e);
			}) : n.isSameDayOrWeek(n.props.selected);
		}, n.getClassNames = function(e) {
			return L8("react-datepicker__day", n.props.dayClassName ? n.props.dayClassName(e) : void 0, "react-datepicker__day--" + Yse(n.props.day), {
				"react-datepicker__day--disabled": n.isDisabled(),
				"react-datepicker__day--excluded": n.isExcluded(),
				"react-datepicker__day--selected": n.isSelected(),
				"react-datepicker__day--keyboard-selected": n.isKeyboardSelected(),
				"react-datepicker__day--range-start": n.isRangeStart(),
				"react-datepicker__day--range-end": n.isRangeEnd(),
				"react-datepicker__day--in-range": n.isInRange(),
				"react-datepicker__day--in-selecting-range": n.isInSelectingRange(),
				"react-datepicker__day--selecting-range-start": n.isSelectingRangeStart(),
				"react-datepicker__day--selecting-range-end": n.isSelectingRangeEnd(),
				"react-datepicker__day--today": n.isCurrentDay(),
				"react-datepicker__day--weekend": n.isWeekend(),
				"react-datepicker__day--outside-month": n.isAfterMonth() || n.isBeforeMonth()
			}, n.getHighLightedClass(), n.getHolidaysClass());
		}, n.getAriaLabel = function() {
			var e = n.props, t = e.day, r = e.ariaLabelPrefixWhenEnabled, i = r === void 0 ? "Choose" : r, a = e.ariaLabelPrefixWhenDisabled, o = a === void 0 ? "Not available" : a;
			return `${n.isDisabled() || n.isExcluded() ? o : i} ${J7(t, "PPPP", n.props.locale)}`;
		}, n.getTitle = function() {
			var e = n.props, t = e.day, r = e.holidays, i = r === void 0 ? /* @__PURE__ */ new Map() : r, a = e.excludeDates, o = J7(t, "MM.dd.yyyy"), s = [];
			return i.has(o) && s.push.apply(s, i.get(o).holidayNames), n.isExcluded() && s.push(a?.filter(function(e) {
				return e instanceof Date ? c9(e, t) : c9(e?.date, t);
			}).map(function(e) {
				if (!(e instanceof Date)) return e?.message;
			})), s.join(", ");
		}, n.getTabIndex = function() {
			var e = n.props.selected, t = n.props.preSelection;
			return !(n.props.showWeekPicker && (n.props.showWeekNumber || !n.isStartOfWeek())) && (n.isKeyboardSelected() || n.isSameDay(e) && c9(t, e)) ? 0 : -1;
		}, n.handleFocusDay = function() {
			var e;
			n.shouldFocusDay() && ((e = n.dayEl.current) == null || e.focus({ preventScroll: !0 }));
		}, n.renderDayContents = function() {
			return n.props.monthShowsDuplicateDaysEnd && n.isAfterMonth() || n.props.monthShowsDuplicateDaysStart && n.isBeforeMonth() ? null : n.props.renderDayContents ? n.props.renderDayContents(H5(n.props.day), n.props.day) : H5(n.props.day);
		}, n.render = function() {
			return t.createElement("div", {
				ref: n.dayEl,
				className: n.getClassNames(n.props.day),
				onKeyDown: n.handleOnKeyDown,
				onClick: n.handleClick,
				onMouseEnter: n.props.usePointerEvent ? void 0 : n.handleMouseEnter,
				onPointerEnter: n.props.usePointerEvent ? n.handleMouseEnter : void 0,
				tabIndex: n.getTabIndex(),
				"aria-label": n.getAriaLabel(),
				role: "gridcell",
				title: n.getTitle(),
				"aria-disabled": n.isDisabled(),
				"aria-current": n.isCurrentDay() ? "date" : void 0,
				"aria-selected": n.isSelected() || n.isInRange()
			}, n.renderDayContents(), n.getTitle() !== "" && t.createElement("span", { className: "overlay" }, n.getTitle()));
		}, n;
	}
	return n.prototype.componentDidMount = function() {
		this.handleFocusDay();
	}, n.prototype.componentDidUpdate = function() {
		this.handleFocusDay();
	}, n.prototype.shouldFocusDay = function() {
		var e = !1;
		return this.getTabIndex() === 0 && this.isSameDay(this.props.preSelection) && ((!document.activeElement || document.activeElement === document.body) && (e = !0), this.props.inline && !this.props.shouldFocusDayInline && (e = !1), this.isDayActiveElement() && (e = !0), this.isDuplicateDay() && (e = !1)), e;
	}, n.prototype.isDayActiveElement = function() {
		return (this.props.containerRef?.current)?.contains(document.activeElement) && document.activeElement?.classList.contains("react-datepicker__day");
	}, n.prototype.isDuplicateDay = function() {
		return this.props.monthShowsDuplicateDaysEnd && this.isAfterMonth() || this.props.monthShowsDuplicateDaysStart && this.isBeforeMonth();
	}, n;
}(n), mce = function(e) {
	L7(n, e);
	function n() {
		var t = e !== null && e.apply(this, arguments) || this;
		return t.weekNumberEl = s(), t.handleClick = function(e) {
			t.props.onClick && t.props.onClick(e);
		}, t.handleOnKeyDown = function(e) {
			var n, r;
			e.key === H7.Space && (e.preventDefault(), e.key = H7.Enter), (r = (n = t.props).handleOnKeyDown) == null || r.call(n, e);
		}, t.isKeyboardSelected = function() {
			return !t.props.disabledKeyboardNavigation && !c9(t.props.date, t.props.selected) && c9(t.props.date, t.props.preSelection);
		}, t.getTabIndex = function() {
			return t.props.showWeekPicker && t.props.showWeekNumber && (t.isKeyboardSelected() || c9(t.props.date, t.props.selected) && c9(t.props.preSelection, t.props.selected)) ? 0 : -1;
		}, t.handleFocusWeekNumber = function(e) {
			var n = !1;
			t.getTabIndex() === 0 && !e?.isInputFocused && c9(t.props.date, t.props.preSelection) && ((!document.activeElement || document.activeElement === document.body) && (n = !0), t.props.inline && !t.props.shouldFocusDayInline && (n = !1), t.props.containerRef && t.props.containerRef.current && t.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (n = !0)), n && t.weekNumberEl.current && t.weekNumberEl.current.focus({ preventScroll: !0 });
		}, t;
	}
	return Object.defineProperty(n, "defaultProps", {
		get: function() {
			return { ariaLabelPrefix: "week " };
		},
		enumerable: !1,
		configurable: !0
	}), n.prototype.componentDidMount = function() {
		this.handleFocusWeekNumber();
	}, n.prototype.componentDidUpdate = function(e) {
		this.handleFocusWeekNumber(e);
	}, n.prototype.render = function() {
		var e = this.props, r = e.weekNumber, i = e.isWeekDisabled, a = e.ariaLabelPrefix, o = a === void 0 ? n.defaultProps.ariaLabelPrefix : a, s = e.onClick, c = {
			"react-datepicker__week-number": !0,
			"react-datepicker__week-number--clickable": !!s && !i,
			"react-datepicker__week-number--selected": !!s && c9(this.props.date, this.props.selected)
		};
		return t.createElement("div", {
			ref: this.weekNumberEl,
			className: L8(c),
			"aria-label": `${o} ${this.props.weekNumber}`,
			onClick: this.handleClick,
			onKeyDown: this.handleOnKeyDown,
			tabIndex: this.getTabIndex(),
			role: "gridcell"
		}, r);
	}, n;
}(n), hce = function(e) {
	L7(n, e);
	function n() {
		var r = e !== null && e.apply(this, arguments) || this;
		return r.isDisabled = function(e) {
			return h9(e, {
				minDate: r.props.minDate,
				maxDate: r.props.maxDate,
				excludeDates: r.props.excludeDates,
				excludeDateIntervals: r.props.excludeDateIntervals,
				includeDateIntervals: r.props.includeDateIntervals,
				includeDates: r.props.includeDates,
				filterDate: r.props.filterDate
			});
		}, r.handleDayClick = function(e, t) {
			r.props.onDayClick && r.props.onDayClick(e, t);
		}, r.handleDayMouseEnter = function(e) {
			r.props.onDayMouseEnter && r.props.onDayMouseEnter(e);
		}, r.handleWeekClick = function(e, t, i) {
			for (var a, o, s = new Date(e), c = 0; c < 7; c++) {
				var l = new Date(e);
				if (l.setDate(l.getDate() + c), !r.isDisabled(l)) {
					s = l;
					break;
				}
			}
			typeof r.props.onWeekSelect == "function" && r.props.onWeekSelect(s, t, i), r.props.showWeekPicker && r.handleDayClick(s, i), (r.props.shouldCloseOnSelect ?? n.defaultProps.shouldCloseOnSelect) && ((o = (a = r.props).setOpen) == null || o.call(a, !1));
		}, r.formatWeekNumber = function(e) {
			return r.props.formatWeekNumber ? r.props.formatWeekNumber(e) : Jse(e);
		}, r.isWeekDisabled = function() {
			for (var e = r.startOfWeek(), t = G8(e, 6), n = new Date(e); n <= t;) {
				if (!r.isDisabled(n)) return !1;
				n = G8(n, 1);
			}
			return !0;
		}, r.renderDays = function() {
			var e = r.startOfWeek(), i = [], a = r.formatWeekNumber(e);
			if (r.props.showWeekNumber) {
				var o = r.props.onWeekSelect || r.props.showWeekPicker ? r.handleWeekClick.bind(r, e, a) : void 0;
				i.push(t.createElement(mce, R7({ key: "W" }, n.defaultProps, r.props, {
					weekNumber: a,
					isWeekDisabled: r.isWeekDisabled(),
					date: e,
					onClick: o
				})));
			}
			return i.concat([
				0,
				1,
				2,
				3,
				4,
				5,
				6
			].map(function(i) {
				var a = G8(e, i);
				return t.createElement(pce, R7({}, n.defaultProps, r.props, {
					ariaLabelPrefixWhenEnabled: r.props.chooseDayAriaLabelPrefix,
					ariaLabelPrefixWhenDisabled: r.props.disabledDayAriaLabelPrefix,
					key: a.valueOf(),
					day: a,
					onClick: r.handleDayClick.bind(r, a),
					onMouseEnter: r.handleDayMouseEnter.bind(r, a)
				}));
			}));
		}, r.startOfWeek = function() {
			return $7(r.props.day, r.props.locale, r.props.calendarStartDay);
		}, r.isKeyboardSelected = function() {
			return !r.props.disabledKeyboardNavigation && !c9(r.startOfWeek(), r.props.selected) && c9(r.startOfWeek(), r.props.preSelection);
		}, r;
	}
	return Object.defineProperty(n, "defaultProps", {
		get: function() {
			return { shouldCloseOnSelect: !0 };
		},
		enumerable: !1,
		configurable: !0
	}), n.prototype.render = function() {
		var e = {
			"react-datepicker__week": !0,
			"react-datepicker__week--selected": c9(this.startOfWeek(), this.props.selected),
			"react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
		}, n = this.props.weekClassName ? this.props.weekClassName(this.startOfWeek()) : void 0;
		return t.createElement("div", {
			className: L8(e, n),
			role: "row"
		}, this.renderDays());
	}, n;
}(n), B9, gce = 6, V9 = {
	TWO_COLUMNS: "two_columns",
	THREE_COLUMNS: "three_columns",
	FOUR_COLUMNS: "four_columns"
}, H9 = (B9 = {}, B9[V9.TWO_COLUMNS] = {
	grid: [
		[0, 1],
		[2, 3],
		[4, 5],
		[6, 7],
		[8, 9],
		[10, 11]
	],
	verticalNavigationOffset: 2
}, B9[V9.THREE_COLUMNS] = {
	grid: [
		[
			0,
			1,
			2
		],
		[
			3,
			4,
			5
		],
		[
			6,
			7,
			8
		],
		[
			9,
			10,
			11
		]
	],
	verticalNavigationOffset: 3
}, B9[V9.FOUR_COLUMNS] = {
	grid: [
		[
			0,
			1,
			2,
			3
		],
		[
			4,
			5,
			6,
			7
		],
		[
			8,
			9,
			10,
			11
		]
	],
	verticalNavigationOffset: 4
}, B9), U9 = 1;
function W9(e, t) {
	return e ? V9.FOUR_COLUMNS : t ? V9.TWO_COLUMNS : V9.THREE_COLUMNS;
}
var _ce = function(e) {
	L7(n, e);
	function n() {
		var n = e !== null && e.apply(this, arguments) || this;
		return n.MONTH_REFS = z7([], Array(12), !0).map(function() {
			return s();
		}), n.QUARTER_REFS = z7([], [
			,
			,
			,
			,
		], !0).map(function() {
			return s();
		}), n.isDisabled = function(e) {
			return h9(e, {
				minDate: n.props.minDate,
				maxDate: n.props.maxDate,
				excludeDates: n.props.excludeDates,
				excludeDateIntervals: n.props.excludeDateIntervals,
				includeDateIntervals: n.props.includeDateIntervals,
				includeDates: n.props.includeDates,
				filterDate: n.props.filterDate
			});
		}, n.isExcluded = function(e) {
			return g9(e, {
				excludeDates: n.props.excludeDates,
				excludeDateIntervals: n.props.excludeDateIntervals
			});
		}, n.handleDayClick = function(e, t) {
			var r, i;
			(i = (r = n.props).onDayClick) == null || i.call(r, e, t, n.props.orderInDisplay);
		}, n.handleDayMouseEnter = function(e) {
			var t, r;
			(r = (t = n.props).onDayMouseEnter) == null || r.call(t, e);
		}, n.handleMouseLeave = function() {
			var e, t;
			(t = (e = n.props).onMouseLeave) == null || t.call(e);
		}, n.isRangeStartMonth = function(e) {
			var t = n.props, r = t.day, i = t.startDate, a = t.endDate;
			return !i || !a ? !1 : o9(_7(r, e), i);
		}, n.isRangeStartQuarter = function(e) {
			var t = n.props, r = t.day, i = t.startDate, a = t.endDate;
			return !i || !a ? !1 : s9(b7(r, e), i);
		}, n.isRangeEndMonth = function(e) {
			var t = n.props, r = t.day, i = t.startDate, a = t.endDate;
			return !i || !a ? !1 : o9(_7(r, e), a);
		}, n.isRangeEndQuarter = function(e) {
			var t = n.props, r = t.day, i = t.startDate, a = t.endDate;
			return !i || !a ? !1 : s9(b7(r, e), a);
		}, n.isInSelectingRangeMonth = function(e) {
			var t = n.props, r = t.day, i = t.selectsStart, a = t.selectsEnd, o = t.selectsRange, s = t.startDate, c = t.endDate, l = n.props.selectingDate ?? n.props.preSelection;
			return !(i || a || o) || !l ? !1 : i && c ? v9(l, c, e, r) : a && s || o && s && !c ? v9(s, l, e, r) : !1;
		}, n.isSelectingMonthRangeStart = function(e) {
			if (!n.isInSelectingRangeMonth(e)) return !1;
			var t = n.props, r = t.day, i = t.startDate, a = t.selectsStart, o = _7(r, e), s = n.props.selectingDate ?? n.props.preSelection;
			return a ? o9(o, s) : o9(o, i);
		}, n.isSelectingMonthRangeEnd = function(e) {
			if (!n.isInSelectingRangeMonth(e)) return !1;
			var t = n.props, r = t.day, i = t.endDate, a = t.selectsEnd, o = t.selectsRange, s = _7(r, e), c = n.props.selectingDate ?? n.props.preSelection;
			return a || o ? o9(s, c) : o9(s, i);
		}, n.isInSelectingRangeQuarter = function(e) {
			var t = n.props, r = t.day, i = t.selectsStart, a = t.selectsEnd, o = t.selectsRange, s = t.startDate, c = t.endDate, l = n.props.selectingDate ?? n.props.preSelection;
			return !(i || a || o) || !l ? !1 : i && c ? S9(l, c, e, r) : a && s || o && s && !c ? S9(s, l, e, r) : !1;
		}, n.isWeekInMonth = function(e) {
			var t = n.props.day, r = G8(e, 6);
			return o9(e, t) || o9(r, t);
		}, n.isCurrentMonth = function(e, t) {
			return J5(e) === J5(G7()) && t === G5(G7());
		}, n.isCurrentQuarter = function(e, t) {
			return J5(e) === J5(G7()) && t === d5(G7());
		}, n.isSelectedMonth = function(e, t, n) {
			return G5(n) === t && J5(e) === J5(n);
		}, n.isSelectMonthInList = function(e, t, r) {
			return r.some(function(r) {
				return n.isSelectedMonth(e, t, r);
			});
		}, n.isSelectedQuarter = function(e, t, n) {
			return d5(e) === t && J5(e) === J5(n);
		}, n.isMonthSelected = function() {
			var e = n.props, t = e.day, r = e.selected, i = e.selectedDates, a = e.selectsMultiple, o = G5(t);
			return a ? i?.some(function(e) {
				return n.isSelectedMonth(t, o, e);
			}) : !!r && n.isSelectedMonth(t, o, r);
		}, n.renderWeeks = function() {
			for (var e = [], r = n.props.fixedHeight, i = 0, a = !1, o = $7(e9(n.props.day), n.props.locale, n.props.calendarStartDay), s = function(e) {
				return n.props.showWeekPicker ? $7(e, n.props.locale, n.props.calendarStartDay) : n.props.preSelection;
			}, c = n.props.selected ? function(e) {
				return n.props.showWeekPicker ? $7(e, n.props.locale, n.props.calendarStartDay) : n.props.selected;
			}(n.props.selected) : void 0, l = n.props.preSelection ? s(n.props.preSelection) : void 0; e.push(t.createElement(hce, R7({}, n.props, {
				ariaLabelPrefix: n.props.weekAriaLabelPrefix,
				key: i,
				day: o,
				month: G5(n.props.day),
				onDayClick: n.handleDayClick,
				onDayMouseEnter: n.handleDayMouseEnter,
				selected: c,
				preSelection: l,
				showWeekNumber: n.props.showWeekNumbers
			}))), !a;) {
				i++, o = i5(o, 1);
				var u = r && i >= gce, d = !r && !n.isWeekInMonth(o);
				if (u || d) if (n.props.peekNextMonth) a = !0;
				else break;
			}
			return e;
		}, n.onMonthClick = function(e, t) {
			var r = n.isMonthDisabledForLabelDate(t), i = r.isDisabled, a = r.labelDate;
			i || n.handleDayClick(e9(a), e);
		}, n.onMonthMouseEnter = function(e) {
			var t = n.isMonthDisabledForLabelDate(e), r = t.isDisabled, i = t.labelDate;
			r || n.handleDayMouseEnter(e9(i));
		}, n.handleMonthNavigation = function(e, t) {
			var r, i, a;
			(i = (r = n.props).setPreSelection) == null || i.call(r, t), (a = n.MONTH_REFS[e]?.current) == null || a.focus();
		}, n.handleKeyboardNavigation = function(e, t, r) {
			var i = n.props, a = i.selected, o = i.preSelection, s = i.setPreSelection, c = i.minDate, l = i.maxDate, u = i.showFourColumnMonthYearPicker, d = i.showTwoColumnMonthYearPicker;
			if (o) {
				var f = W9(u, d), p = n.getVerticalOffset(f), m = H9[f]?.grid, h = function(e, t, n) {
					var r = t, i = n;
					switch (e) {
						case H7.ArrowRight:
							r = K8(t, U9), i = n === 11 ? 0 : n + U9;
							break;
						case H7.ArrowLeft:
							r = C7(t, U9), i = n === 0 ? 11 : n - U9;
							break;
						case H7.ArrowUp:
							r = C7(t, p), i = (m?.[0])?.includes(n) ? n + 12 - p : n - p;
							break;
						case H7.ArrowDown:
							r = K8(t, p), i = (m?.[m.length - 1])?.includes(n) ? n - 12 + p : n + p;
							break;
					}
					return {
						newCalculatedDate: r,
						newCalculatedMonth: i
					};
				}, g = function(e, t, r) {
					for (var i = 40, a = e, o = !1, s = 0, u = h(a, t, r), d = u.newCalculatedDate, f = u.newCalculatedMonth; !o;) {
						if (s >= i) {
							d = t, f = r;
							break;
						}
						if (c && d < c) {
							a = H7.ArrowRight;
							var p = h(a, d, f);
							d = p.newCalculatedDate, f = p.newCalculatedMonth;
						}
						if (l && d > l) {
							a = H7.ArrowLeft;
							var p = h(a, d, f);
							d = p.newCalculatedDate, f = p.newCalculatedMonth;
						}
						if (nce(d, n.props)) {
							var p = h(a, d, f);
							d = p.newCalculatedDate, f = p.newCalculatedMonth;
						} else o = !0;
						s++;
					}
					return {
						newCalculatedDate: d,
						newCalculatedMonth: f
					};
				};
				if (t === H7.Enter) {
					n.isMonthDisabled(r) || (n.onMonthClick(e, r), s?.(a));
					return;
				}
				var _ = g(t, o, r), v = _.newCalculatedDate, y = _.newCalculatedMonth;
				switch (t) {
					case H7.ArrowRight:
					case H7.ArrowLeft:
					case H7.ArrowUp:
					case H7.ArrowDown:
						n.handleMonthNavigation(y, v);
						break;
				}
			}
		}, n.getVerticalOffset = function(e) {
			return H9[e]?.verticalNavigationOffset ?? 0;
		}, n.onMonthKeyDown = function(e, t) {
			var r = n.props, i = r.disabledKeyboardNavigation, a = r.handleOnMonthKeyDown, o = e.key;
			o !== H7.Tab && e.preventDefault(), i || n.handleKeyboardNavigation(e, o, t), a && a(e);
		}, n.onQuarterClick = function(e, t) {
			var r = b7(n.props.day, t);
			y9(r, n.props) || n.handleDayClick(n9(r), e);
		}, n.onQuarterMouseEnter = function(e) {
			var t = b7(n.props.day, e);
			y9(t, n.props) || n.handleDayMouseEnter(n9(t));
		}, n.handleQuarterNavigation = function(e, t) {
			var r, i, a;
			n.isDisabled(t) || n.isExcluded(t) || ((i = (r = n.props).setPreSelection) == null || i.call(r, t), (a = n.QUARTER_REFS[e - 1]?.current) == null || a.focus());
		}, n.onQuarterKeyDown = function(e, t) {
			var r, i, a = e.key;
			if (!n.props.disabledKeyboardNavigation) switch (a) {
				case H7.Enter:
					n.onQuarterClick(e, t), (i = (r = n.props).setPreSelection) == null || i.call(r, n.props.selected);
					break;
				case H7.ArrowRight:
					if (!n.props.preSelection) break;
					n.handleQuarterNavigation(t === 4 ? 1 : t + 1, r5(n.props.preSelection, 1));
					break;
				case H7.ArrowLeft:
					if (!n.props.preSelection) break;
					n.handleQuarterNavigation(t === 1 ? 4 : t - 1, w7(n.props.preSelection, 1));
					break;
			}
		}, n.isMonthDisabledForLabelDate = function(e) {
			var t = n.props, r = t.day, i = t.minDate, a = t.maxDate, o = t.excludeDates, s = t.includeDates, c = _7(r, e);
			return {
				isDisabled: ((i || a || o || s) && _9(c, n.props)) ?? !1,
				labelDate: c
			};
		}, n.isMonthDisabled = function(e) {
			return n.isMonthDisabledForLabelDate(e).isDisabled;
		}, n.getMonthClassNames = function(e) {
			var t = n.props, r = t.day, i = t.startDate, a = t.endDate, o = t.preSelection, s = t.monthClassName, c = s ? s(_7(r, e)) : void 0, l = n.getSelection();
			return L8("react-datepicker__month-text", `react-datepicker__month-${e}`, c, {
				"react-datepicker__month-text--disabled": n.isMonthDisabled(e),
				"react-datepicker__month-text--selected": l ? n.isSelectMonthInList(r, e, l) : void 0,
				"react-datepicker__month-text--keyboard-selected": !n.props.disabledKeyboardNavigation && o && n.isSelectedMonth(r, e, o) && !n.isMonthSelected() && !n.isMonthDisabled(e),
				"react-datepicker__month-text--in-selecting-range": n.isInSelectingRangeMonth(e),
				"react-datepicker__month-text--in-range": i && a ? v9(i, a, e, r) : void 0,
				"react-datepicker__month-text--range-start": n.isRangeStartMonth(e),
				"react-datepicker__month-text--range-end": n.isRangeEndMonth(e),
				"react-datepicker__month-text--selecting-range-start": n.isSelectingMonthRangeStart(e),
				"react-datepicker__month-text--selecting-range-end": n.isSelectingMonthRangeEnd(e),
				"react-datepicker__month-text--today": n.isCurrentMonth(r, e)
			});
		}, n.getTabIndex = function(e) {
			if (n.props.preSelection == null) return "-1";
			var t = G5(n.props.preSelection), r = n.isMonthDisabledForLabelDate(t).isDisabled;
			return e === t && !(r || n.props.disabledKeyboardNavigation) ? "0" : "-1";
		}, n.getQuarterTabIndex = function(e) {
			if (n.props.preSelection == null) return "-1";
			var t = d5(n.props.preSelection), r = y9(n.props.day, n.props);
			return e === t && !(r || n.props.disabledKeyboardNavigation) ? "0" : "-1";
		}, n.getAriaLabel = function(e) {
			var t = n.props, r = t.chooseDayAriaLabelPrefix, i = r === void 0 ? "Choose" : r, a = t.disabledDayAriaLabelPrefix, o = a === void 0 ? "Not available" : a, s = t.day, c = t.locale, l = _7(s, e);
			return `${n.isDisabled(l) || n.isExcluded(l) ? o : i} ${J7(l, "MMMM yyyy", c)}`;
		}, n.getQuarterClassNames = function(e) {
			var t = n.props, r = t.day, i = t.startDate, a = t.endDate, o = t.selected, s = t.minDate, c = t.maxDate, l = t.excludeDates, u = t.includeDates, d = t.filterDate, f = t.preSelection, p = t.disabledKeyboardNavigation, m = (s || c || l || u || d) && y9(b7(r, e), n.props);
			return L8("react-datepicker__quarter-text", `react-datepicker__quarter-${e}`, {
				"react-datepicker__quarter-text--disabled": m,
				"react-datepicker__quarter-text--selected": o ? n.isSelectedQuarter(r, e, o) : void 0,
				"react-datepicker__quarter-text--keyboard-selected": !p && f && n.isSelectedQuarter(r, e, f) && !m,
				"react-datepicker__quarter-text--in-selecting-range": n.isInSelectingRangeQuarter(e),
				"react-datepicker__quarter-text--in-range": i && a ? S9(i, a, e, r) : void 0,
				"react-datepicker__quarter-text--range-start": n.isRangeStartQuarter(e),
				"react-datepicker__quarter-text--range-end": n.isRangeEndQuarter(e),
				"react-datepicker__quarter-text--today": n.isCurrentQuarter(r, e)
			});
		}, n.getMonthContent = function(e) {
			var t = n.props, r = t.showFullMonthYearPicker, i = t.renderMonthContent, a = t.locale, o = t.day, s = m9(e, a), c = p9(e, a);
			return i ? i(e, s, c, o) : r ? c : s;
		}, n.getQuarterContent = function(e) {
			var t = n.props, r = t.renderQuarterContent, i = t.locale, a = tce(e, i);
			return r?.(e, a) ?? a;
		}, n.renderMonths = function() {
			var e = n.props, r = e.showTwoColumnMonthYearPicker, i = e.showFourColumnMonthYearPicker, a = e.day, o = e.selected;
			return (H9[W9(i, r)]?.grid)?.map(function(e, r) {
				return t.createElement("div", {
					className: "react-datepicker__month-wrapper",
					key: r
				}, e.map(function(e, r) {
					return t.createElement("div", {
						ref: n.MONTH_REFS[e],
						key: r,
						onClick: function(t) {
							n.onMonthClick(t, e);
						},
						onKeyDown: function(t) {
							z9(t) && (t.preventDefault(), t.key = H7.Enter), n.onMonthKeyDown(t, e);
						},
						onMouseEnter: n.props.usePointerEvent ? void 0 : function() {
							return n.onMonthMouseEnter(e);
						},
						onPointerEnter: n.props.usePointerEvent ? function() {
							return n.onMonthMouseEnter(e);
						} : void 0,
						tabIndex: Number(n.getTabIndex(e)),
						className: n.getMonthClassNames(e),
						"aria-disabled": n.isMonthDisabled(e),
						role: "option",
						"aria-label": n.getAriaLabel(e),
						"aria-current": n.isCurrentMonth(a, e) ? "date" : void 0,
						"aria-selected": o ? n.isSelectedMonth(a, e, o) : void 0
					}, n.getMonthContent(e));
				}));
			});
		}, n.renderQuarters = function() {
			var e = n.props, r = e.day, i = e.selected;
			return t.createElement("div", { className: "react-datepicker__quarter-wrapper" }, [
				1,
				2,
				3,
				4
			].map(function(e, a) {
				return t.createElement("div", {
					key: a,
					ref: n.QUARTER_REFS[a],
					role: "option",
					onClick: function(t) {
						n.onQuarterClick(t, e);
					},
					onKeyDown: function(t) {
						n.onQuarterKeyDown(t, e);
					},
					onMouseEnter: n.props.usePointerEvent ? void 0 : function() {
						return n.onQuarterMouseEnter(e);
					},
					onPointerEnter: n.props.usePointerEvent ? function() {
						return n.onQuarterMouseEnter(e);
					} : void 0,
					className: n.getQuarterClassNames(e),
					"aria-selected": i ? n.isSelectedQuarter(r, e, i) : void 0,
					tabIndex: Number(n.getQuarterTabIndex(e)),
					"aria-current": n.isCurrentQuarter(r, e) ? "date" : void 0
				}, n.getQuarterContent(e));
			}));
		}, n.getClassNames = function() {
			var e = n.props, t = e.selectingDate, r = e.selectsStart, i = e.selectsEnd, a = e.showMonthYearPicker, o = e.showQuarterYearPicker, s = e.showWeekPicker;
			return L8("react-datepicker__month", { "react-datepicker__month--selecting-range": t && (r || i) }, { "react-datepicker__monthPicker": a }, { "react-datepicker__quarterPicker": o }, { "react-datepicker__weekPicker": s });
		}, n;
	}
	return n.prototype.getSelection = function() {
		var e = this.props, t = e.selected, n = e.selectedDates;
		if (e.selectsMultiple) return n;
		if (t) return [t];
	}, n.prototype.render = function() {
		var e = this.props, n = e.showMonthYearPicker, r = e.showQuarterYearPicker, i = e.day, a = e.ariaLabelPrefix, o = a === void 0 ? "Month " : a, s = o ? o.trim() + " " : "";
		return n || r ? t.createElement("div", {
			className: this.getClassNames(),
			onMouseLeave: this.props.usePointerEvent ? void 0 : this.handleMouseLeave,
			onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : void 0,
			"aria-label": `${s}${J7(i, "MMMM, yyyy", this.props.locale)}`,
			role: "listbox"
		}, n ? this.renderMonths() : this.renderQuarters()) : t.createElement("div", { role: "table" }, this.props.dayNamesHeader && t.createElement("div", { role: "rowgroup" }, this.props.dayNamesHeader), t.createElement("div", {
			className: this.getClassNames(),
			onMouseLeave: this.props.usePointerEvent ? void 0 : this.handleMouseLeave,
			onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : void 0,
			"aria-label": `${s}${J7(i, "MMMM, yyyy", this.props.locale)}`,
			role: "rowgroup"
		}, this.renderWeeks()));
	}, n;
}(n), vce = function(e) {
	L7(n, e);
	function n() {
		var n = e !== null && e.apply(this, arguments) || this;
		return n.monthOptionButtonsRef = {}, n.isSelectedMonth = function(e) {
			return n.props.month === e;
		}, n.handleOptionKeyDown = function(e, t) {
			var r;
			switch (t.key) {
				case "Enter":
					t.preventDefault(), n.onChange(e);
					break;
				case "Escape":
					t.preventDefault(), n.props.onCancel();
					break;
				case "ArrowUp":
				case "ArrowDown":
					t.preventDefault();
					var i = (e + (t.key === "ArrowUp" ? -1 : 1) + n.props.monthNames.length) % n.props.monthNames.length;
					(r = n.monthOptionButtonsRef[i]) == null || r.focus();
					break;
			}
		}, n.renderOptions = function() {
			return n.monthOptionButtonsRef = {}, n.props.monthNames.map(function(e, r) {
				return t.createElement("div", {
					ref: function(e) {
						n.monthOptionButtonsRef[r] = e, n.isSelectedMonth(r) && e?.focus();
					},
					role: "button",
					tabIndex: 0,
					className: n.isSelectedMonth(r) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
					key: e,
					onClick: n.onChange.bind(n, r),
					onKeyDown: n.handleOptionKeyDown.bind(n, r),
					"aria-selected": n.isSelectedMonth(r) ? "true" : void 0
				}, n.isSelectedMonth(r) ? t.createElement("span", { className: "react-datepicker__month-option--selected" }, "✓") : "", e);
			});
		}, n.onChange = function(e) {
			return n.props.onChange(e);
		}, n.handleClickOutside = function() {
			return n.props.onCancel();
		}, n;
	}
	return n.prototype.render = function() {
		return t.createElement(V7, {
			className: "react-datepicker__month-dropdown",
			onClickOutside: this.handleClickOutside
		}, this.renderOptions());
	}, n;
}(n), yce = function(e) {
	L7(n, e);
	function n() {
		var n = e !== null && e.apply(this, arguments) || this;
		return n.state = { dropdownVisible: !1 }, n.renderSelectOptions = function(e) {
			return e.map(function(e, n) {
				return t.createElement("option", {
					key: e,
					value: n
				}, e);
			});
		}, n.renderSelectMode = function(e) {
			return t.createElement("select", {
				value: n.props.month,
				className: "react-datepicker__month-select",
				onChange: function(e) {
					return n.onChange(parseInt(e.target.value));
				}
			}, n.renderSelectOptions(e));
		}, n.renderReadView = function(e, r) {
			return t.createElement("button", {
				key: "read",
				type: "button",
				style: { visibility: e ? "visible" : "hidden" },
				className: "react-datepicker__month-read-view",
				onClick: n.toggleDropdown
			}, t.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }), t.createElement("span", { className: "react-datepicker__month-read-view--selected-month" }, r[n.props.month]));
		}, n.renderDropdown = function(e) {
			return t.createElement(vce, R7({ key: "dropdown" }, n.props, {
				monthNames: e,
				onChange: n.onChange,
				onCancel: n.toggleDropdown
			}));
		}, n.renderScrollMode = function(e) {
			var t = n.state.dropdownVisible, r = [n.renderReadView(!t, e)];
			return t && r.unshift(n.renderDropdown(e)), r;
		}, n.onChange = function(e) {
			n.toggleDropdown(), e !== n.props.month && n.props.onChange(e);
		}, n.toggleDropdown = function() {
			return n.setState({ dropdownVisible: !n.state.dropdownVisible });
		}, n;
	}
	return n.prototype.render = function() {
		var e = this, n = [
			0,
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			9,
			10,
			11
		].map(this.props.useShortMonthInDropdown ? function(t) {
			return m9(t, e.props.locale);
		} : function(t) {
			return p9(t, e.props.locale);
		}), r;
		switch (this.props.dropdownMode) {
			case "scroll":
				r = this.renderScrollMode(n);
				break;
			case "select":
				r = this.renderSelectMode(n);
				break;
		}
		return t.createElement("div", { className: `react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--${this.props.dropdownMode}` }, r);
	}, n;
}(n);
function bce(e, t) {
	for (var n = [], r = e9(e), i = e9(t); !Y5(r, i);) n.push(G7(r)), r = K8(r, 1);
	return n;
}
var xce = function(e) {
	L7(n, e);
	function n(n) {
		var r = e.call(this, n) || this;
		return r.renderOptions = function() {
			return r.state.monthYearsList.map(function(e) {
				var n = q5(e), i = a9(r.props.date, e) && o9(r.props.date, e);
				return t.createElement("div", {
					className: i ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
					key: n,
					onClick: r.onChange.bind(r, n),
					"aria-selected": i ? "true" : void 0
				}, i ? t.createElement("span", { className: "react-datepicker__month-year-option--selected" }, "✓") : "", J7(e, r.props.dateFormat, r.props.locale));
			});
		}, r.onChange = function(e) {
			return r.props.onChange(e);
		}, r.handleClickOutside = function() {
			r.props.onCancel();
		}, r.state = { monthYearsList: bce(r.props.minDate, r.props.maxDate) }, r;
	}
	return n.prototype.render = function() {
		var e = L8({
			"react-datepicker__month-year-dropdown": !0,
			"react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
		});
		return t.createElement(V7, {
			className: e,
			onClickOutside: this.handleClickOutside
		}, this.renderOptions());
	}, n;
}(n), Sce = function(e) {
	L7(n, e);
	function n() {
		var n = e !== null && e.apply(this, arguments) || this;
		return n.state = { dropdownVisible: !1 }, n.renderSelectOptions = function() {
			for (var e = e9(n.props.minDate), r = e9(n.props.maxDate), i = []; !Y5(e, r);) {
				var a = q5(e);
				i.push(t.createElement("option", {
					key: a,
					value: a
				}, J7(e, n.props.dateFormat, n.props.locale))), e = K8(e, 1);
			}
			return i;
		}, n.onSelectChange = function(e) {
			n.onChange(parseInt(e.target.value));
		}, n.renderSelectMode = function() {
			return t.createElement("select", {
				value: q5(e9(n.props.date)),
				className: "react-datepicker__month-year-select",
				onChange: n.onSelectChange
			}, n.renderSelectOptions());
		}, n.renderReadView = function(e) {
			var r = J7(n.props.date, n.props.dateFormat, n.props.locale);
			return t.createElement("div", {
				key: "read",
				style: { visibility: e ? "visible" : "hidden" },
				className: "react-datepicker__month-year-read-view",
				onClick: n.toggleDropdown
			}, t.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }), t.createElement("span", { className: "react-datepicker__month-year-read-view--selected-month-year" }, r));
		}, n.renderDropdown = function() {
			return t.createElement(xce, R7({ key: "dropdown" }, n.props, {
				onChange: n.onChange,
				onCancel: n.toggleDropdown
			}));
		}, n.renderScrollMode = function() {
			var e = n.state.dropdownVisible, t = [n.renderReadView(!e)];
			return e && t.unshift(n.renderDropdown()), t;
		}, n.onChange = function(e) {
			n.toggleDropdown();
			var t = G7(e);
			a9(n.props.date, t) && o9(n.props.date, t) || n.props.onChange(t);
		}, n.toggleDropdown = function() {
			return n.setState({ dropdownVisible: !n.state.dropdownVisible });
		}, n;
	}
	return n.prototype.render = function() {
		var e;
		switch (this.props.dropdownMode) {
			case "scroll":
				e = this.renderScrollMode();
				break;
			case "select":
				e = this.renderSelectMode();
				break;
		}
		return t.createElement("div", { className: `react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--${this.props.dropdownMode}` }, e);
	}, n;
}(n), Cce = function(e) {
	L7(n, e);
	function n() {
		var r = e !== null && e.apply(this, arguments) || this;
		return r.state = { height: null }, r.scrollToTheSelectedTime = function() {
			requestAnimationFrame(function() {
				r.list && (r.list.scrollTop = (r.centerLi && n.calcCenterPosition(r.props.monthRef ? r.props.monthRef.clientHeight - (r.header?.clientHeight ?? 0) : r.list.clientHeight, r.centerLi)) ?? 0);
			});
		}, r.handleClick = function(e) {
			var t, n;
			(r.props.minTime || r.props.maxTime) && E9(e, r.props) || (r.props.excludeTimes || r.props.includeTimes || r.props.filterTime) && T9(e, r.props) || (n = (t = r.props).onChange) == null || n.call(t, e);
		}, r.isSelectedTime = function(e) {
			return r.props.selected && dce(r.props.selected, e);
		}, r.isDisabledTime = function(e) {
			return (r.props.minTime || r.props.maxTime) && E9(e, r.props) || (r.props.excludeTimes || r.props.includeTimes || r.props.filterTime) && T9(e, r.props);
		}, r.liClasses = function(e) {
			var t = ["react-datepicker__time-list-item", r.props.timeClassName ? r.props.timeClassName(e) : void 0];
			return r.isSelectedTime(e) && t.push("react-datepicker__time-list-item--selected"), r.isDisabledTime(e) && t.push("react-datepicker__time-list-item--disabled"), r.props.injectTimes && (U5(e) * 3600 + W5(e) * 60 + K5(e)) % ((r.props.intervals ?? n.defaultProps.intervals) * 60) != 0 && t.push("react-datepicker__time-list-item--injected"), t.join(" ");
		}, r.handleOnKeyDown = function(e, t) {
			var n, i;
			e.key === H7.Space && (e.preventDefault(), e.key = H7.Enter), (e.key === H7.ArrowUp || e.key === H7.ArrowLeft) && e.target instanceof HTMLElement && e.target.previousSibling && (e.preventDefault(), e.target.previousSibling instanceof HTMLElement && e.target.previousSibling.focus()), (e.key === H7.ArrowDown || e.key === H7.ArrowRight) && e.target instanceof HTMLElement && e.target.nextSibling && (e.preventDefault(), e.target.nextSibling instanceof HTMLElement && e.target.nextSibling.focus()), e.key === H7.Enter && r.handleClick(t), (i = (n = r.props).handleOnKeyDown) == null || i.call(n, e);
		}, r.renderTimes = function() {
			for (var e = [], i = typeof r.props.format == "string" ? r.props.format : "p", a = r.props.intervals ?? n.defaultProps.intervals, o = r.props.selected || r.props.openToDate || G7(), s = Q7(o), c = r.props.injectTimes && r.props.injectTimes.sort(function(e, t) {
				return e.getTime() - t.getTime();
			}), l = 60 * uce(o) / a, u = 0; u < l; u++) {
				var d = n5(s, u * a);
				if (e.push(d), c) {
					var f = lce(s, d, u, a, c);
					e = e.concat(f);
				}
			}
			var p = e.reduce(function(e, t) {
				return t.getTime() <= o.getTime() ? t : e;
			}, e[0]);
			return e.map(function(e) {
				return t.createElement("li", {
					key: e.valueOf(),
					onClick: r.handleClick.bind(r, e),
					className: r.liClasses(e),
					ref: function(t) {
						e === p && (r.centerLi = t);
					},
					onKeyDown: function(t) {
						r.handleOnKeyDown(t, e);
					},
					tabIndex: e === p ? 0 : -1,
					role: "option",
					"aria-selected": r.isSelectedTime(e) ? "true" : void 0,
					"aria-disabled": r.isDisabledTime(e) ? "true" : void 0
				}, J7(e, i, r.props.locale));
			});
		}, r.renderTimeCaption = function() {
			return r.props.showTimeCaption === !1 ? t.createElement(t.Fragment, null) : t.createElement("div", {
				className: `react-datepicker__header react-datepicker__header--time ${r.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""}`,
				ref: function(e) {
					r.header = e;
				}
			}, t.createElement("div", { className: "react-datepicker-time__header" }, r.props.timeCaption));
		}, r;
	}
	return Object.defineProperty(n, "defaultProps", {
		get: function() {
			return {
				intervals: 30,
				todayButton: null,
				timeCaption: "Time",
				showTimeCaption: !0
			};
		},
		enumerable: !1,
		configurable: !0
	}), n.prototype.componentDidMount = function() {
		this.scrollToTheSelectedTime(), this.observeDatePickerHeightChanges();
	}, n.prototype.componentWillUnmount = function() {
		var e;
		(e = this.resizeObserver) == null || e.disconnect();
	}, n.prototype.observeDatePickerHeightChanges = function() {
		var e = this, t = this.props.monthRef;
		this.updateContainerHeight(), t && (this.resizeObserver = new ResizeObserver(function() {
			e.updateContainerHeight();
		}), this.resizeObserver.observe(t));
	}, n.prototype.updateContainerHeight = function() {
		this.props.monthRef && this.header && this.setState({ height: this.props.monthRef.clientHeight - this.header.clientHeight });
	}, n.prototype.render = function() {
		var e = this, r = this.state.height;
		return t.createElement("div", { className: `react-datepicker__time-container ${this.props.todayButton ?? n.defaultProps.todayButton ? "react-datepicker__time-container--with-today-button" : ""}` }, this.renderTimeCaption(), t.createElement("div", { className: "react-datepicker__time" }, t.createElement("div", { className: "react-datepicker__time-box" }, t.createElement("ul", {
			className: "react-datepicker__time-list",
			ref: function(t) {
				e.list = t;
			},
			style: r ? { height: r } : {},
			role: "listbox",
			"aria-label": this.props.timeCaption
		}, this.renderTimes()))));
	}, n.calcCenterPosition = function(e, t) {
		return t.offsetTop - (e / 2 - t.clientHeight / 2);
	}, n;
}(n), G9 = 3, wce = function(e) {
	L7(n, e);
	function n(t) {
		var n = e.call(this, t) || this;
		return n.YEAR_REFS = z7([], Array(n.props.yearItemNumber), !0).map(function() {
			return s();
		}), n.isDisabled = function(e) {
			return h9(e, {
				minDate: n.props.minDate,
				maxDate: n.props.maxDate,
				excludeDates: n.props.excludeDates,
				includeDates: n.props.includeDates,
				filterDate: n.props.filterDate
			});
		}, n.isExcluded = function(e) {
			return g9(e, { excludeDates: n.props.excludeDates });
		}, n.selectingDate = function() {
			return n.props.selectingDate ?? n.props.preSelection;
		}, n.updateFocusOnPaginate = function(e) {
			window.requestAnimationFrame(function() {
				var t;
				(t = n.YEAR_REFS[e]?.current) == null || t.focus();
			});
		}, n.handleYearClick = function(e, t) {
			n.props.onDayClick && n.props.onDayClick(e, t);
		}, n.handleYearNavigation = function(e, t) {
			var r, i, a, o = n.props, s = o.date, c = o.yearItemNumber;
			if (!(s === void 0 || c === void 0)) {
				var l = F9(s, c).startPeriod;
				n.isDisabled(t) || n.isExcluded(t) || ((i = (r = n.props).setPreSelection) == null || i.call(r, t), e - l < 0 ? n.updateFocusOnPaginate(c - (l - e)) : e - l >= c ? n.updateFocusOnPaginate(Math.abs(c - (e - l))) : (a = n.YEAR_REFS[e - l]?.current) == null || a.focus());
			}
		}, n.isSameDay = function(e, t) {
			return c9(e, t);
		}, n.isCurrentYear = function(e) {
			return e === J5(G7());
		}, n.isRangeStart = function(e) {
			return n.props.startDate && n.props.endDate && a9(S7(G7(), e), n.props.startDate);
		}, n.isRangeEnd = function(e) {
			return n.props.startDate && n.props.endDate && a9(S7(G7(), e), n.props.endDate);
		}, n.isInRange = function(e) {
			return b9(e, n.props.startDate, n.props.endDate);
		}, n.isInSelectingRange = function(e) {
			var t = n.props, r = t.selectsStart, i = t.selectsEnd, a = t.selectsRange, o = t.startDate, s = t.endDate;
			return !(r || i || a) || !n.selectingDate() ? !1 : r && s ? b9(e, n.selectingDate(), s) : i && o || a && o && !s ? b9(e, o, n.selectingDate()) : !1;
		}, n.isSelectingRangeStart = function(e) {
			if (!n.isInSelectingRange(e)) return !1;
			var t = n.props, r = t.startDate, i = t.selectsStart, a = S7(G7(), e);
			return i ? a9(a, n.selectingDate() ?? null) : a9(a, r ?? null);
		}, n.isSelectingRangeEnd = function(e) {
			if (!n.isInSelectingRange(e)) return !1;
			var t = n.props, r = t.endDate, i = t.selectsEnd, a = t.selectsRange, o = S7(G7(), e);
			return i || a ? a9(o, n.selectingDate() ?? null) : a9(o, r ?? null);
		}, n.isKeyboardSelected = function(e) {
			if (!(n.props.disabledKeyboardNavigation || n.props.date === void 0 || n.props.preSelection == null)) {
				var t = n.props, r = t.minDate, i = t.maxDate, a = t.excludeDates, o = t.includeDates, s = t.filterDate, c = t.selected, l = t9(S7(n.props.date, e)), u = (r || i || a || o || s) && x9(e, n.props), d = !!c && c9(l, t9(c)), f = c9(l, t9(n.props.preSelection));
				return !n.props.inline && !d && f && !u;
			}
		}, n.isSelectedYear = function(e) {
			var t = n.props, r = t.selectsMultiple, i = t.selected, a = t.selectedDates;
			return r ? a?.some(function(t) {
				return e === J5(t);
			}) : !!i && e === J5(i);
		}, n.onYearClick = function(e, t) {
			var r = n.props.date;
			r !== void 0 && n.handleYearClick(t9(S7(r, t)), e);
		}, n.onYearKeyDown = function(e, t) {
			var r, i, a = e.key, o = n.props, s = o.date, c = o.yearItemNumber, l = o.handleOnKeyDown;
			if (a !== H7.Tab && e.preventDefault(), !n.props.disabledKeyboardNavigation) switch (a) {
				case H7.Enter:
					if (n.props.selected == null) break;
					n.onYearClick(e, t), (i = (r = n.props).setPreSelection) == null || i.call(r, n.props.selected);
					break;
				case H7.ArrowRight:
					if (n.props.preSelection == null) break;
					n.handleYearNavigation(t + 1, a5(n.props.preSelection, 1));
					break;
				case H7.ArrowLeft:
					if (n.props.preSelection == null) break;
					n.handleYearNavigation(t - 1, E7(n.props.preSelection, 1));
					break;
				case H7.ArrowUp:
					if (s === void 0 || c === void 0 || n.props.preSelection == null) break;
					var u = F9(s, c).startPeriod, d = G9, f = t - d;
					if (f < u) {
						var p = c % d;
						t >= u && t < u + p ? d = p : d += p, f = t - d;
					}
					n.handleYearNavigation(f, E7(n.props.preSelection, d));
					break;
				case H7.ArrowDown:
					if (s === void 0 || c === void 0 || n.props.preSelection == null) break;
					var m = F9(s, c).endPeriod, d = G9, f = t + d;
					if (f > m) {
						var p = c % d;
						t <= m && t > m - p ? d = p : d += p, f = t + d;
					}
					n.handleYearNavigation(f, a5(n.props.preSelection, d));
					break;
			}
			l && l(e);
		}, n.getYearClassNames = function(e) {
			var t = n.props, r = t.date, i = t.minDate, a = t.maxDate, o = t.excludeDates, s = t.includeDates, c = t.filterDate, l = t.yearClassName;
			return L8("react-datepicker__year-text", `react-datepicker__year-${e}`, r ? l?.(S7(r, e)) : void 0, {
				"react-datepicker__year-text--selected": n.isSelectedYear(e),
				"react-datepicker__year-text--disabled": (i || a || o || s || c) && x9(e, n.props),
				"react-datepicker__year-text--keyboard-selected": n.isKeyboardSelected(e),
				"react-datepicker__year-text--range-start": n.isRangeStart(e),
				"react-datepicker__year-text--range-end": n.isRangeEnd(e),
				"react-datepicker__year-text--in-range": n.isInRange(e),
				"react-datepicker__year-text--in-selecting-range": n.isInSelectingRange(e),
				"react-datepicker__year-text--selecting-range-start": n.isSelectingRangeStart(e),
				"react-datepicker__year-text--selecting-range-end": n.isSelectingRangeEnd(e),
				"react-datepicker__year-text--today": n.isCurrentYear(e)
			});
		}, n.getYearTabIndex = function(e) {
			if (n.props.disabledKeyboardNavigation || n.props.preSelection == null) return "-1";
			var t = J5(n.props.preSelection), r = x9(e, n.props);
			return e === t && !r ? "0" : "-1";
		}, n.getYearContent = function(e) {
			return n.props.renderYearContent ? n.props.renderYearContent(e) : e;
		}, n;
	}
	return n.prototype.render = function() {
		var e = this, n = [], r = this.props, i = r.date, a = r.yearItemNumber, o = r.onYearMouseEnter, s = r.onYearMouseLeave;
		if (i === void 0) return null;
		for (var c = F9(i, a), l = c.startPeriod, u = c.endPeriod, d = function(r) {
			n.push(t.createElement("div", {
				ref: f.YEAR_REFS[r - l],
				onClick: function(t) {
					e.onYearClick(t, r);
				},
				onKeyDown: function(t) {
					z9(t) && (t.preventDefault(), t.key = H7.Enter), e.onYearKeyDown(t, r);
				},
				tabIndex: Number(f.getYearTabIndex(r)),
				className: f.getYearClassNames(r),
				onMouseEnter: f.props.usePointerEvent ? void 0 : function(e) {
					return o(e, r);
				},
				onPointerEnter: f.props.usePointerEvent ? function(e) {
					return o(e, r);
				} : void 0,
				onMouseLeave: f.props.usePointerEvent ? void 0 : function(e) {
					return s(e, r);
				},
				onPointerLeave: f.props.usePointerEvent ? function(e) {
					return s(e, r);
				} : void 0,
				key: r,
				"aria-current": f.isCurrentYear(r) ? "date" : void 0
			}, f.getYearContent(r)));
		}, f = this, p = l; p <= u; p++) d(p);
		return t.createElement("div", { className: "react-datepicker__year" }, t.createElement("div", {
			className: "react-datepicker__year-wrapper",
			onMouseLeave: this.props.usePointerEvent ? void 0 : this.props.clearSelectingDate,
			onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : void 0
		}, n));
	}, n;
}(n);
function Tce(e, t, n, r) {
	for (var i = [], a = 0; a < 2 * t + 1; a++) {
		var o = e + t - a, s = !0;
		n && (s = J5(n) <= o), r && s && (s = J5(r) >= o), s && i.push(o);
	}
	return i;
}
var Ece = function(e) {
	L7(n, e);
	function n(n) {
		var r = e.call(this, n) || this;
		r.yearOptionButtonsRef = {}, r.handleOptionKeyDown = function(e, t) {
			var n;
			switch (t.key) {
				case "Enter":
					t.preventDefault(), r.onChange(e);
					break;
				case "Escape":
					t.preventDefault(), r.props.onCancel();
					break;
				case "ArrowUp":
				case "ArrowDown":
					t.preventDefault();
					var i = e + (t.key === "ArrowUp" ? 1 : -1);
					r.yearOptionButtonsRef[i] && ((n = r.yearOptionButtonsRef[i]) == null || n.focus());
					break;
			}
		}, r.renderOptions = function() {
			r.yearOptionButtonsRef = {};
			var e = r.props.year, n = r.state.yearsList.map(function(n) {
				return t.createElement("div", {
					ref: function(t) {
						r.yearOptionButtonsRef[n] = t, n === e && t?.focus();
					},
					role: "button",
					tabIndex: 0,
					className: e === n ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
					key: n,
					onClick: r.onChange.bind(r, n),
					onKeyDown: r.handleOptionKeyDown.bind(r, n),
					"aria-selected": e === n ? "true" : void 0
				}, e === n ? t.createElement("span", { className: "react-datepicker__year-option--selected" }, "✓") : "", n);
			}), i = r.props.minDate ? J5(r.props.minDate) : null, a = r.props.maxDate ? J5(r.props.maxDate) : null;
			return (!a || !r.state.yearsList.find(function(e) {
				return e === a;
			})) && n.unshift(t.createElement("div", {
				className: "react-datepicker__year-option",
				key: "upcoming",
				onClick: r.incrementYears
			}, t.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" }))), (!i || !r.state.yearsList.find(function(e) {
				return e === i;
			})) && n.push(t.createElement("div", {
				className: "react-datepicker__year-option",
				key: "previous",
				onClick: r.decrementYears
			}, t.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" }))), n;
		}, r.onChange = function(e) {
			r.props.onChange(e);
		}, r.handleClickOutside = function() {
			r.props.onCancel();
		}, r.shiftYears = function(e) {
			var t = r.state.yearsList.map(function(t) {
				return t + e;
			});
			r.setState({ yearsList: t });
		}, r.incrementYears = function() {
			return r.shiftYears(1);
		}, r.decrementYears = function() {
			return r.shiftYears(-1);
		};
		var i = n.yearDropdownItemNumber, a = n.scrollableYearDropdown, o = i || (a ? 10 : 5);
		return r.state = { yearsList: Tce(r.props.year, o, r.props.minDate, r.props.maxDate) }, r.dropdownRef = s(), r;
	}
	return n.prototype.componentDidMount = function() {
		var e = this.dropdownRef.current;
		if (e) {
			var t = e.children ? Array.from(e.children) : null, n = t ? t.find(function(e) {
				return e.ariaSelected;
			}) : null;
			e.scrollTop = n && n instanceof HTMLElement ? n.offsetTop + (n.clientHeight - e.clientHeight) / 2 : (e.scrollHeight - e.clientHeight) / 2;
		}
	}, n.prototype.render = function() {
		var e = L8({
			"react-datepicker__year-dropdown": !0,
			"react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
		});
		return t.createElement(V7, {
			className: e,
			containerRef: this.dropdownRef,
			onClickOutside: this.handleClickOutside
		}, this.renderOptions());
	}, n;
}(n), Dce = function(e) {
	L7(n, e);
	function n() {
		var n = e !== null && e.apply(this, arguments) || this;
		return n.state = { dropdownVisible: !1 }, n.renderSelectOptions = function() {
			for (var e = n.props.minDate ? J5(n.props.minDate) : 1900, r = n.props.maxDate ? J5(n.props.maxDate) : 2100, i = [], a = e; a <= r; a++) i.push(t.createElement("option", {
				key: a,
				value: a
			}, a));
			return i;
		}, n.onSelectChange = function(e) {
			n.onChange(parseInt(e.target.value));
		}, n.renderSelectMode = function() {
			return t.createElement("select", {
				value: n.props.year,
				className: "react-datepicker__year-select",
				onChange: n.onSelectChange
			}, n.renderSelectOptions());
		}, n.renderReadView = function(e) {
			return t.createElement("button", {
				key: "read",
				type: "button",
				style: { visibility: e ? "visible" : "hidden" },
				className: "react-datepicker__year-read-view",
				onClick: n.toggleDropdown
			}, t.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }), t.createElement("span", { className: "react-datepicker__year-read-view--selected-year" }, n.props.year));
		}, n.renderDropdown = function() {
			return t.createElement(Ece, R7({ key: "dropdown" }, n.props, {
				onChange: n.onChange,
				onCancel: n.toggleDropdown
			}));
		}, n.renderScrollMode = function() {
			var e = n.state.dropdownVisible, t = [n.renderReadView(!e)];
			return e && t.unshift(n.renderDropdown()), t;
		}, n.onChange = function(e) {
			n.toggleDropdown(), e !== n.props.year && n.props.onChange(e);
		}, n.toggleDropdown = function(e) {
			n.setState({ dropdownVisible: !n.state.dropdownVisible }, function() {
				n.props.adjustDateOnChange && n.handleYearChange(n.props.date, e);
			});
		}, n.handleYearChange = function(e, t) {
			var r;
			(r = n.onSelect) == null || r.call(n, e, t), n.setOpen();
		}, n.onSelect = function(e, t) {
			var r, i;
			(i = (r = n.props).onSelect) == null || i.call(r, e, t);
		}, n.setOpen = function() {
			var e, t;
			(t = (e = n.props).setOpen) == null || t.call(e, !0);
		}, n;
	}
	return n.prototype.render = function() {
		var e;
		switch (this.props.dropdownMode) {
			case "scroll":
				e = this.renderScrollMode();
				break;
			case "select":
				e = this.renderSelectMode();
				break;
		}
		return t.createElement("div", { className: `react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--${this.props.dropdownMode}` }, e);
	}, n;
}(n), Oce = [
	"react-datepicker__year-select",
	"react-datepicker__month-select",
	"react-datepicker__month-year-select"
], K9 = "react-datepicker-ignore-onclickoutside", kce = function(e) {
	var t = (e.className || "").split(/\s+/);
	return Oce.some(function(e) {
		return t.indexOf(e) >= 0;
	});
}, Ace = function(e) {
	L7(n, e);
	function n(r) {
		var i = e.call(this, r) || this;
		return i.monthContainer = void 0, i.handleClickOutside = function(e) {
			i.props.onClickOutside(e);
		}, i.setClickOutsideRef = function() {
			return i.containerRef.current;
		}, i.handleDropdownFocus = function(e) {
			var t, n;
			kce(e.target) && ((n = (t = i.props).onDropdownFocus) == null || n.call(t, e));
		}, i.getDateInView = function() {
			var e = i.props, t = e.preSelection, n = e.selected, r = e.openToDate, a = j9(i.props), o = M9(i.props), s = G7();
			return r || n || t || (a && X5(s, a) ? a : o && Y5(s, o) ? o : s);
		}, i.increaseMonth = function() {
			i.setState(function(e) {
				var t = e.date;
				return { date: K8(t, 1) };
			}, function() {
				return i.handleMonthChange(i.state.date);
			});
		}, i.decreaseMonth = function() {
			i.setState(function(e) {
				var t = e.date;
				return { date: C7(t, 1) };
			}, function() {
				return i.handleMonthChange(i.state.date);
			});
		}, i.handleDayClick = function(e, t, n) {
			i.props.onSelect(e, t, n), i.props.setPreSelection && i.props.setPreSelection(e);
		}, i.handleDayMouseEnter = function(e) {
			i.setState({ selectingDate: e }), i.props.onDayMouseEnter && i.props.onDayMouseEnter(e);
		}, i.handleMonthMouseLeave = function() {
			i.setState({ selectingDate: void 0 }), i.props.onMonthMouseLeave && i.props.onMonthMouseLeave();
		}, i.handleYearMouseEnter = function(e, t) {
			i.setState({ selectingDate: S7(G7(), t) }), i.props.onYearMouseEnter && i.props.onYearMouseEnter(e, t);
		}, i.handleYearMouseLeave = function(e, t) {
			i.props.onYearMouseLeave && i.props.onYearMouseLeave(e, t);
		}, i.handleYearChange = function(e) {
			var t, n, r, a;
			(n = (t = i.props).onYearChange) == null || n.call(t, e), i.setState({ isRenderAriaLiveMessage: !0 }), i.props.adjustDateOnChange && (i.props.onSelect(e), (a = (r = i.props).setOpen) == null || a.call(r, !0)), i.props.setPreSelection && i.props.setPreSelection(e);
		}, i.getEnabledPreSelectionDateForMonth = function(e) {
			if (!h9(e, i.props)) return e;
			for (var t = e9(e), n = Mae(Zse(e), t), r = null, a = 0; a <= n; a++) {
				var o = G8(t, a);
				if (!h9(o, i.props)) {
					r = o;
					break;
				}
			}
			return r;
		}, i.handleMonthChange = function(e) {
			var t, n, r = i.getEnabledPreSelectionDateForMonth(e) ?? e;
			i.handleCustomMonthChange(r), i.props.adjustDateOnChange && (i.props.onSelect(r), (n = (t = i.props).setOpen) == null || n.call(t, !0)), i.props.setPreSelection && i.props.setPreSelection(r);
		}, i.handleCustomMonthChange = function(e) {
			var t, n;
			(n = (t = i.props).onMonthChange) == null || n.call(t, e), i.setState({ isRenderAriaLiveMessage: !0 });
		}, i.handleMonthYearChange = function(e) {
			i.handleYearChange(e), i.handleMonthChange(e);
		}, i.changeYear = function(e) {
			i.setState(function(t) {
				var n = t.date;
				return { date: S7(n, Number(e)) };
			}, function() {
				return i.handleYearChange(i.state.date);
			});
		}, i.changeMonth = function(e) {
			i.setState(function(t) {
				var n = t.date;
				return { date: _7(n, Number(e)) };
			}, function() {
				return i.handleMonthChange(i.state.date);
			});
		}, i.changeMonthYear = function(e) {
			i.setState(function(t) {
				var n = t.date;
				return { date: S7(_7(n, G5(e)), J5(e)) };
			}, function() {
				return i.handleMonthYearChange(i.state.date);
			});
		}, i.header = function(e) {
			e === void 0 && (e = i.state.date);
			var n = $7(e, i.props.locale, i.props.calendarStartDay), r = [];
			return i.props.showWeekNumbers && r.push(t.createElement("div", {
				key: "W",
				className: "react-datepicker__day-name",
				role: "columnheader"
			}, t.createElement("span", { className: "react-datepicker__sr-only" }, "Week number"), t.createElement("span", { "aria-hidden": "true" }, i.props.weekLabel || "#"))), r.concat([
				0,
				1,
				2,
				3,
				4,
				5,
				6
			].map(function(e) {
				var r = G8(n, e), a = i.formatWeekday(r, i.props.locale), o = i.props.weekDayClassName ? i.props.weekDayClassName(r) : void 0;
				return t.createElement("div", {
					key: e,
					role: "columnheader",
					className: L8("react-datepicker__day-name", o)
				}, t.createElement("span", { className: "react-datepicker__sr-only" }, J7(r, "EEEE", i.props.locale)), t.createElement("span", { "aria-hidden": "true" }, a));
			}));
		}, i.formatWeekday = function(e, t) {
			return i.props.formatWeekDay ? Qse(e, i.props.formatWeekDay, t) : i.props.useWeekdaysShort ? ece(e, t) : $se(e, t);
		}, i.decreaseYear = function() {
			i.setState(function(e) {
				var t = e.date;
				return { date: E7(t, i.props.showYearPicker ? i.props.yearItemNumber ?? n.defaultProps.yearItemNumber : 1) };
			}, function() {
				return i.handleYearChange(i.state.date);
			});
		}, i.clearSelectingDate = function() {
			i.setState({ selectingDate: void 0 });
		}, i.renderPreviousButton = function() {
			if (!i.props.renderCustomHeader) {
				var e = i.props.monthsShown ?? n.defaultProps.monthsShown, r = i.props.showPreviousMonths ? e - 1 : 0, a = i.props.monthSelectedIn ?? r, o = C7(i.state.date, a), s;
				switch (!0) {
					case i.props.showMonthYearPicker:
						s = k9(i.state.date, i.props);
						break;
					case i.props.showYearPicker:
						s = ace(i.state.date, i.props);
						break;
					case i.props.showQuarterYearPicker:
						s = rce(i.state.date, i.props);
						break;
					default:
						s = D9(o, i.props);
						break;
				}
				if (!(!(i.props.forceShowMonthNavigation ?? n.defaultProps.forceShowMonthNavigation) && !i.props.showDisabledMonthNavigation && s || i.props.showTimeSelectOnly)) {
					var c = ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--previous"], l = ["react-datepicker__navigation", "react-datepicker__navigation--previous"], u = i.decreaseMonth;
					(i.props.showMonthYearPicker || i.props.showQuarterYearPicker || i.props.showYearPicker) && (u = i.decreaseYear), s && i.props.showDisabledMonthNavigation && (l.push("react-datepicker__navigation--previous--disabled"), u = void 0);
					var d = i.props.showMonthYearPicker || i.props.showQuarterYearPicker || i.props.showYearPicker, f = i.props, p = f.previousMonthButtonLabel, m = p === void 0 ? n.defaultProps.previousMonthButtonLabel : p, h = f.previousYearButtonLabel, g = h === void 0 ? n.defaultProps.previousYearButtonLabel : h, _ = i.props, v = _.previousMonthAriaLabel, y = v === void 0 ? typeof m == "string" ? m : "Previous Month" : v, b = _.previousYearAriaLabel, x = b === void 0 ? typeof g == "string" ? g : "Previous Year" : b;
					return t.createElement("button", {
						type: "button",
						className: l.join(" "),
						onClick: u,
						onKeyDown: i.props.handleOnKeyDown,
						"aria-label": d ? x : y
					}, t.createElement("span", { className: c.join(" ") }, d ? g : m));
				}
			}
		}, i.increaseYear = function() {
			i.setState(function(e) {
				var t = e.date;
				return { date: a5(t, i.props.showYearPicker ? i.props.yearItemNumber ?? n.defaultProps.yearItemNumber : 1) };
			}, function() {
				return i.handleYearChange(i.state.date);
			});
		}, i.renderNextButton = function() {
			if (!i.props.renderCustomHeader) {
				var e;
				switch (!0) {
					case i.props.showMonthYearPicker:
						e = A9(i.state.date, i.props);
						break;
					case i.props.showYearPicker:
						e = oce(i.state.date, i.props);
						break;
					case i.props.showQuarterYearPicker:
						e = ice(i.state.date, i.props);
						break;
					default:
						e = O9(i.state.date, i.props);
						break;
				}
				if (!(!(i.props.forceShowMonthNavigation ?? n.defaultProps.forceShowMonthNavigation) && !i.props.showDisabledMonthNavigation && e || i.props.showTimeSelectOnly)) {
					var r = ["react-datepicker__navigation", "react-datepicker__navigation--next"], a = ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--next"];
					i.props.showTimeSelect && r.push("react-datepicker__navigation--next--with-time"), i.props.todayButton && r.push("react-datepicker__navigation--next--with-today-button");
					var o = i.increaseMonth;
					(i.props.showMonthYearPicker || i.props.showQuarterYearPicker || i.props.showYearPicker) && (o = i.increaseYear), e && i.props.showDisabledMonthNavigation && (r.push("react-datepicker__navigation--next--disabled"), o = void 0);
					var s = i.props.showMonthYearPicker || i.props.showQuarterYearPicker || i.props.showYearPicker, c = i.props, l = c.nextMonthButtonLabel, u = l === void 0 ? n.defaultProps.nextMonthButtonLabel : l, d = c.nextYearButtonLabel, f = d === void 0 ? n.defaultProps.nextYearButtonLabel : d, p = i.props, m = p.nextMonthAriaLabel, h = m === void 0 ? typeof u == "string" ? u : "Next Month" : m, g = p.nextYearAriaLabel, _ = g === void 0 ? typeof f == "string" ? f : "Next Year" : g;
					return t.createElement("button", {
						type: "button",
						className: r.join(" "),
						onClick: o,
						onKeyDown: i.props.handleOnKeyDown,
						"aria-label": s ? _ : h
					}, t.createElement("span", { className: a.join(" ") }, s ? f : u));
				}
			}
		}, i.renderCurrentMonth = function(e) {
			e === void 0 && (e = i.state.date);
			var n = ["react-datepicker__current-month"];
			return i.props.showYearDropdown && n.push("react-datepicker__current-month--hasYearDropdown"), i.props.showMonthDropdown && n.push("react-datepicker__current-month--hasMonthDropdown"), i.props.showMonthYearDropdown && n.push("react-datepicker__current-month--hasMonthYearDropdown"), t.createElement("h2", { className: n.join(" ") }, J7(e, i.props.dateFormat, i.props.locale));
		}, i.renderYearDropdown = function(e) {
			if (e === void 0 && (e = !1), !(!i.props.showYearDropdown || e)) return t.createElement(Dce, R7({}, n.defaultProps, i.props, {
				date: i.state.date,
				onChange: i.changeYear,
				year: J5(i.state.date)
			}));
		}, i.renderMonthDropdown = function(e) {
			if (e === void 0 && (e = !1), !(!i.props.showMonthDropdown || e)) return t.createElement(yce, R7({}, n.defaultProps, i.props, {
				month: G5(i.state.date),
				onChange: i.changeMonth
			}));
		}, i.renderMonthYearDropdown = function(e) {
			if (e === void 0 && (e = !1), !(!i.props.showMonthYearDropdown || e)) return t.createElement(Sce, R7({}, n.defaultProps, i.props, {
				date: i.state.date,
				onChange: i.changeMonthYear
			}));
		}, i.handleTodayButtonClick = function(e) {
			i.props.onSelect(r9(), e), i.props.setPreSelection && i.props.setPreSelection(r9());
		}, i.renderTodayButton = function() {
			if (!(!i.props.todayButton || i.props.showTimeSelectOnly)) return t.createElement("div", {
				className: "react-datepicker__today-button",
				onClick: i.handleTodayButtonClick
			}, i.props.todayButton);
		}, i.renderDayNamesHeader = function(e) {
			return t.createElement("div", {
				className: "react-datepicker__day-names",
				role: "row"
			}, i.header(e));
		}, i.renderDefaultHeader = function(e) {
			var n = e.monthDate, r = e.i;
			return t.createElement("div", { className: `react-datepicker__header ${i.props.showTimeSelect ? "react-datepicker__header--has-time-select" : ""}` }, i.renderCurrentMonth(n), t.createElement("div", {
				className: `react-datepicker__header__dropdown react-datepicker__header__dropdown--${i.props.dropdownMode}`,
				onFocus: i.handleDropdownFocus
			}, i.renderMonthDropdown(r !== 0), i.renderMonthYearDropdown(r !== 0), i.renderYearDropdown(r !== 0)));
		}, i.renderCustomHeader = function(e) {
			var n, r = e.monthDate, a = e.i;
			if (i.props.showTimeSelect && !i.state.monthContainer || i.props.showTimeSelectOnly) return null;
			var o = i.props, s = o.showYearPicker, c = o.yearItemNumber, l;
			if (s) {
				var u = F9(r, c);
				l = {
					startYear: u.startPeriod,
					endYear: u.endPeriod
				};
			}
			var d = D9(i.state.date, i.props), f = O9(i.state.date, i.props), p = k9(i.state.date, i.props), m = A9(i.state.date, i.props);
			return t.createElement("div", {
				className: "react-datepicker__header react-datepicker__header--custom",
				onFocus: i.props.onDropdownFocus
			}, (n = i.props).renderCustomHeader?.call(n, R7(R7(R7({}, i.state), s && { visibleYearsRange: l }), {
				customHeaderCount: a,
				monthDate: r,
				changeMonth: i.changeMonth,
				changeYear: i.changeYear,
				decreaseMonth: i.decreaseMonth,
				increaseMonth: i.increaseMonth,
				decreaseYear: i.decreaseYear,
				increaseYear: i.increaseYear,
				prevMonthButtonDisabled: d,
				nextMonthButtonDisabled: f,
				prevYearButtonDisabled: p,
				nextYearButtonDisabled: m
			})));
		}, i.renderYearHeader = function(e) {
			var r = e.monthDate, a = i.props, o = a.showYearPicker, s = a.yearItemNumber, c = F9(r, s === void 0 ? n.defaultProps.yearItemNumber : s), l = c.startPeriod, u = c.endPeriod;
			return t.createElement("div", { className: "react-datepicker__header react-datepicker-year-header" }, o ? `${l} - ${u}` : J5(r));
		}, i.renderHeader = function(e) {
			var t = e.monthDate, n = e.i, r = {
				monthDate: t,
				i: n === void 0 ? 0 : n
			};
			switch (!0) {
				case i.props.renderCustomHeader !== void 0: return i.renderCustomHeader(r);
				case i.props.showMonthYearPicker || i.props.showQuarterYearPicker || i.props.showYearPicker: return i.renderYearHeader(r);
				default: return i.renderDefaultHeader(r);
			}
		}, i.renderMonths = function() {
			if (!(i.props.showTimeSelectOnly || i.props.showYearPicker)) {
				for (var e = [], r = i.props.monthsShown ?? n.defaultProps.monthsShown, a = i.props.showPreviousMonths ? r - 1 : 0, o = i.props.showMonthYearPicker || i.props.showQuarterYearPicker ? a5(i.state.date, a) : C7(i.state.date, a), s = i.props.monthSelectedIn ?? a, c = 0; c < r; ++c) {
					var l = c - s + a, u = i.props.showMonthYearPicker || i.props.showQuarterYearPicker ? a5(o, l) : K8(o, l), d = `month-${c}`, f = c < r - 1, p = c > 0;
					e.push(t.createElement("div", {
						key: d,
						ref: function(e) {
							i.monthContainer = e ?? void 0;
						},
						className: "react-datepicker__month-container"
					}, i.renderHeader({
						monthDate: u,
						i: c
					}), t.createElement(_ce, R7({}, n.defaultProps, i.props, {
						containerRef: i.containerRef,
						ariaLabelPrefix: i.props.monthAriaLabelPrefix,
						day: u,
						onDayClick: i.handleDayClick,
						handleOnKeyDown: i.props.handleOnDayKeyDown,
						handleOnMonthKeyDown: i.props.handleOnKeyDown,
						onDayMouseEnter: i.handleDayMouseEnter,
						onMouseLeave: i.handleMonthMouseLeave,
						orderInDisplay: c,
						selectingDate: i.state.selectingDate,
						monthShowsDuplicateDaysEnd: f,
						monthShowsDuplicateDaysStart: p,
						dayNamesHeader: i.renderDayNamesHeader(u)
					}))));
				}
				return e;
			}
		}, i.renderYears = function() {
			if (!i.props.showTimeSelectOnly && i.props.showYearPicker) return t.createElement("div", { className: "react-datepicker__year--container" }, i.renderHeader({ monthDate: i.state.date }), t.createElement(wce, R7({}, n.defaultProps, i.props, {
				selectingDate: i.state.selectingDate,
				date: i.state.date,
				onDayClick: i.handleDayClick,
				clearSelectingDate: i.clearSelectingDate,
				onYearMouseEnter: i.handleYearMouseEnter,
				onYearMouseLeave: i.handleYearMouseLeave
			})));
		}, i.renderTimeSection = function() {
			if (i.props.showTimeSelect && (i.state.monthContainer || i.props.showTimeSelectOnly)) return t.createElement(Cce, R7({}, n.defaultProps, i.props, {
				onChange: i.props.onTimeChange,
				format: i.props.timeFormat,
				intervals: i.props.timeIntervals,
				monthRef: i.state.monthContainer
			}));
		}, i.renderInputTimeSection = function() {
			var e = i.props.selected ? new Date(i.props.selected) : void 0, r = e && q7(e) && i.props.selected ? `${P9(e.getHours())}:${P9(e.getMinutes())}` : "";
			if (i.props.showTimeInput) return t.createElement(fce, R7({}, n.defaultProps, i.props, {
				date: e,
				timeString: r,
				onChange: i.props.onTimeChange
			}));
		}, i.renderAriaLiveRegion = function() {
			var e = F9(i.state.date, i.props.yearItemNumber ?? n.defaultProps.yearItemNumber), r = e.startPeriod, a = e.endPeriod, o = i.props.showYearPicker ? `${r} - ${a}` : i.props.showMonthYearPicker || i.props.showQuarterYearPicker ? J5(i.state.date) : `${p9(G5(i.state.date), i.props.locale)} ${J5(i.state.date)}`;
			return t.createElement("span", {
				role: "alert",
				"aria-live": "polite",
				className: "react-datepicker__aria-live"
			}, i.state.isRenderAriaLiveMessage && o);
		}, i.renderChildren = function() {
			if (i.props.children) return t.createElement("div", { className: "react-datepicker__children-container" }, i.props.children);
		}, i.containerRef = s(), i.state = {
			date: i.getDateInView(),
			selectingDate: void 0,
			monthContainer: void 0,
			isRenderAriaLiveMessage: !1
		}, i;
	}
	return Object.defineProperty(n, "defaultProps", {
		get: function() {
			return {
				monthsShown: 1,
				forceShowMonthNavigation: !1,
				outsideClickIgnoreClass: K9,
				timeCaption: "Time",
				previousYearButtonLabel: "Previous Year",
				nextYearButtonLabel: "Next Year",
				previousMonthButtonLabel: "Previous Month",
				nextMonthButtonLabel: "Next Month",
				yearItemNumber: W7
			};
		},
		enumerable: !1,
		configurable: !0
	}), n.prototype.componentDidMount = function() {
		var e = this;
		this.props.showTimeSelect && (this.assignMonthContainer = (function() {
			e.setState({ monthContainer: e.monthContainer });
		})());
	}, n.prototype.componentDidUpdate = function(e) {
		var t = this;
		if (this.props.preSelection && (!c9(this.props.preSelection, e.preSelection) || this.props.monthSelectedIn !== e.monthSelectedIn)) {
			var n = !o9(this.state.date, this.props.preSelection);
			this.setState({ date: this.props.preSelection }, function() {
				return n && t.handleCustomMonthChange(t.state.date);
			});
		} else this.props.openToDate && !c9(this.props.openToDate, e.openToDate) && this.setState({ date: this.props.openToDate });
	}, n.prototype.render = function() {
		var e = this.props.container || B7;
		return t.createElement(V7, {
			onClickOutside: this.handleClickOutside,
			style: { display: "contents" },
			ignoreClass: this.props.outsideClickIgnoreClass
		}, t.createElement("div", {
			style: { display: "contents" },
			ref: this.containerRef
		}, t.createElement(e, {
			className: L8("react-datepicker", this.props.className, { "react-datepicker--time-only": this.props.showTimeSelectOnly }),
			showTime: this.props.showTimeSelect || this.props.showTimeInput,
			showTimeSelectOnly: this.props.showTimeSelectOnly
		}, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren())));
	}, n;
}(n), jce = function(e) {
	var n = e.icon, r = e.className, i = r === void 0 ? "" : r, a = e.onClick, o = "react-datepicker__calendar-icon";
	if (typeof n == "string") return t.createElement("i", {
		className: `${o} ${n} ${i}`,
		"aria-hidden": "true",
		onClick: a
	});
	if (t.isValidElement(n)) {
		var s = n;
		return t.cloneElement(s, {
			className: `${s.props.className || ""} ${o} ${i}`,
			onClick: function(e) {
				typeof s.props.onClick == "function" && s.props.onClick(e), typeof a == "function" && a(e);
			}
		});
	}
	return t.createElement("svg", {
		className: `${o} ${i}`,
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 448 512",
		onClick: a
	}, t.createElement("path", { d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z" }));
}, q9 = function(e) {
	L7(t, e);
	function t(t) {
		var n = e.call(this, t) || this;
		return n.portalRoot = null, n.el = document.createElement("div"), n;
	}
	return t.prototype.componentDidMount = function() {
		this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
	}, t.prototype.componentWillUnmount = function() {
		this.portalRoot && this.portalRoot.removeChild(this.el);
	}, t.prototype.render = function() {
		return Be.createPortal(this.props.children, this.el);
	}, t;
}(n), Mce = "[tabindex], a, button, input, select, textarea", Nce = function(e) {
	return (e instanceof HTMLAnchorElement || !e.disabled) && e.tabIndex !== -1;
}, J9 = function(e) {
	L7(n, e);
	function n(t) {
		var n = e.call(this, t) || this;
		return n.getTabChildren = function() {
			return Array.prototype.slice.call(n.tabLoopRef.current?.querySelectorAll(Mce), 1, -1).filter(Nce);
		}, n.handleFocusStart = function() {
			var e = n.getTabChildren();
			e && e.length > 1 && e[e.length - 1].focus();
		}, n.handleFocusEnd = function() {
			var e = n.getTabChildren();
			e && e.length > 1 && e[0].focus();
		}, n.tabLoopRef = s(), n;
	}
	return n.prototype.render = function() {
		return this.props.enableTabLoop ?? n.defaultProps.enableTabLoop ? t.createElement("div", {
			className: "react-datepicker__tab-loop",
			ref: this.tabLoopRef
		}, t.createElement("div", {
			className: "react-datepicker__tab-loop__start",
			tabIndex: 0,
			onFocus: this.handleFocusStart
		}), this.props.children, t.createElement("div", {
			className: "react-datepicker__tab-loop__end",
			tabIndex: 0,
			onFocus: this.handleFocusEnd
		})) : this.props.children;
	}, n.defaultProps = { enableTabLoop: !0 }, n;
}(n);
function Pce(e) {
	function n(n) {
		var r = typeof n.hidePopper == "boolean" ? n.hidePopper : !0, i = v(null), a = Wse(R7({
			open: !r,
			whileElementsMounted: Sp,
			placement: n.popperPlacement,
			middleware: z7([
				Ese({ padding: 15 }),
				Tse(10),
				Dse({ element: i })
			], n.popperModifiers ?? [], !0)
		}, n.popperProps)), o = R7(R7({}, n), {
			hidePopper: r,
			popperProps: R7(R7({}, a), { arrowRef: i })
		});
		return t.createElement(e, R7({}, o));
	}
	return n.displayName = `withFloating(${e.displayName || e.name || "Component"})`, n;
}
var Fce = Pce(function(e) {
	var n = e.className, r = e.wrapperClassName, i = e.hidePopper, a = i === void 0 ? !0 : i, s = e.popperComponent, c = e.targetComponent, l = e.enableTabLoop, u = e.popperOnKeyDown, d = e.portalId, f = e.portalHost, p = e.popperProps, m = e.showArrow, h = void 0;
	if (!a) {
		var g = L8("react-datepicker-popper", n);
		h = t.createElement(J9, { enableTabLoop: l }, t.createElement("div", {
			ref: p.refs.setFloating,
			style: p.floatingStyles,
			className: g,
			"data-placement": p.placement,
			onKeyDown: u
		}, s, m && t.createElement(Lse, {
			ref: p.arrowRef,
			context: p.context,
			fill: "currentColor",
			strokeWidth: 1,
			height: 8,
			width: 16,
			style: { transform: "translateY(-1px)" },
			className: "react-datepicker__triangle"
		})));
	}
	e.popperContainer && (h = o(e.popperContainer, {}, h)), d && !a && (h = t.createElement(q9, {
		portalId: d,
		portalHost: f
	}, h));
	var _ = L8("react-datepicker-wrapper", r);
	return t.createElement(t.Fragment, null, t.createElement("div", {
		ref: p.refs.setReference,
		className: _
	}, c), h);
});
function Ice(e, t) {
	return e && t ? G5(e) !== G5(t) || J5(e) !== J5(t) : e !== t;
}
var Y9 = "Date input not valid.", Lce = function(e) {
	L7(n, e);
	function n(r) {
		var a = e.call(this, r) || this;
		return a.calendar = null, a.input = null, a.getPreSelection = function() {
			return a.props.openToDate ? a.props.openToDate : a.props.selectsEnd && a.props.startDate ? a.props.startDate : a.props.selectsStart && a.props.endDate ? a.props.endDate : G7();
		}, a.modifyHolidays = function() {
			return a.props.holidays?.reduce(function(e, t) {
				var n = new Date(t.date);
				return q7(n) ? z7(z7([], e, !0), [R7(R7({}, t), { date: n })], !1) : e;
			}, []);
		}, a.calcInitialState = function() {
			var e = a.getPreSelection(), t = j9(a.props), n = M9(a.props), r = t && X5(e, Q7(t)) ? t : n && Y5(e, i9(n)) ? n : e;
			return {
				open: a.props.startOpen || !1,
				preventFocus: !1,
				inputValue: null,
				preSelection: (a.props.selectsRange ? a.props.startDate : a.props.selected) ?? r,
				highlightDates: N9(a.props.highlightDates),
				focused: !1,
				shouldFocusDayInline: !1,
				isRenderAriaLiveMessage: !1,
				wasHidden: !1
			};
		}, a.getInputValue = function() {
			var e = a.props, t = e.locale, r = e.startDate, i = e.endDate, o = e.rangeSeparator, s = e.selected, c = e.selectedDates, l = e.selectsMultiple, u = e.selectsRange, d = e.value, f = a.props.dateFormat ?? n.defaultProps.dateFormat, p = a.state.inputValue;
			return typeof d == "string" ? d : typeof p == "string" ? p : u ? Kse(r, i, {
				dateFormat: f,
				locale: t,
				rangeSeparator: o
			}) : l ? qse(c ?? [], {
				dateFormat: f,
				locale: t
			}) : Y7(s, {
				dateFormat: f,
				locale: t
			});
		}, a.resetHiddenStatus = function() {
			a.setState(R7(R7({}, a.state), { wasHidden: !1 }));
		}, a.setHiddenStatus = function() {
			a.setState(R7(R7({}, a.state), { wasHidden: !0 }));
		}, a.setHiddenStateOnVisibilityHidden = function() {
			document.visibilityState === "hidden" && a.setHiddenStatus();
		}, a.clearPreventFocusTimeout = function() {
			a.preventFocusTimeout && clearTimeout(a.preventFocusTimeout);
		}, a.setFocus = function() {
			var e, t;
			(t = (e = a.input)?.focus) == null || t.call(e, { preventScroll: !0 });
		}, a.setBlur = function() {
			var e, t;
			(t = (e = a.input)?.blur) == null || t.call(e), a.cancelFocusInput();
		}, a.deferBlur = function() {
			requestAnimationFrame(function() {
				a.setBlur();
			});
		}, a.setOpen = function(e, t) {
			t === void 0 && (t = !1), a.setState({
				open: e,
				preSelection: e && a.state.open ? a.state.preSelection : a.calcInitialState().preSelection,
				lastPreSelectChange: X9
			}, function() {
				e || a.setState(function(e) {
					return { focused: t ? e.focused : !1 };
				}, function() {
					!t && a.deferBlur(), a.setState({ inputValue: null });
				});
			});
		}, a.inputOk = function() {
			return c5(a.state.preSelection);
		}, a.isCalendarOpen = function() {
			return a.props.open === void 0 ? a.state.open && !a.props.disabled && !a.props.readOnly : a.props.open;
		}, a.handleFocus = function(e) {
			var t, n, r = a.state.wasHidden, i = r ? a.state.open : !0;
			r && a.resetHiddenStatus(), a.state.preventFocus || ((n = (t = a.props).onFocus) == null || n.call(t, e), i && !a.props.preventOpenOnFocus && !a.props.readOnly && a.setOpen(!0)), a.setState({ focused: !0 });
		}, a.sendFocusBackToInput = function() {
			a.preventFocusTimeout && a.clearPreventFocusTimeout(), a.setState({ preventFocus: !0 }, function() {
				a.preventFocusTimeout = setTimeout(function() {
					a.setFocus(), a.setState({ preventFocus: !1 });
				});
			});
		}, a.cancelFocusInput = function() {
			clearTimeout(a.inputFocusTimeout), a.inputFocusTimeout = void 0;
		}, a.deferFocusInput = function() {
			a.cancelFocusInput(), a.inputFocusTimeout = setTimeout(function() {
				return a.setFocus();
			}, 1);
		}, a.handleDropdownFocus = function() {
			a.cancelFocusInput();
		}, a.resetInputValue = function() {
			a.setState(R7(R7({}, a.state), { inputValue: null }));
		}, a.handleBlur = function(e) {
			var t, n;
			(!a.state.open || a.props.withPortal || a.props.showTimeInput) && ((n = (t = a.props).onBlur) == null || n.call(t, e)), a.resetInputValue(), a.state.open && a.props.open === !1 && a.setOpen(!1), a.setState({ focused: !1 });
		}, a.handleCalendarClickOutside = function(e) {
			var t, n;
			a.props.inline || a.setOpen(!1), (n = (t = a.props).onClickOutside) == null || n.call(t, e), a.props.withPortal && e.preventDefault();
		}, a.handleChange = function() {
			for (var e, t, r = [], i = 0; i < arguments.length; i++) r[i] = arguments[i];
			var o = r[0];
			if (!(a.props.onChangeRaw && (a.props.onChangeRaw.apply(a, r), !o || typeof o.isDefaultPrevented != "function" || o.isDefaultPrevented()))) {
				a.setState({
					inputValue: o?.target instanceof HTMLInputElement ? o.target.value : null,
					lastPreSelectChange: Rce
				});
				var s = a.props, c = s.selectsRange, l = s.startDate, u = s.endDate, d = a.props.dateFormat ?? n.defaultProps.dateFormat, f = a.props.strictParsing ?? n.defaultProps.strictParsing, p = o?.target instanceof HTMLInputElement ? o.target.value : "";
				if (c) {
					var m = a.props.rangeSeparator, h = m.trim(), g = p.split(d.includes(h) ? m : h, 2).map(function(e) {
						return e.trim();
					}), _ = g[0], v = g[1], y = K7(_ ?? "", d, a.props.locale, f), b = y ? K7(v ?? "", d, a.props.locale, f) : null, x = l?.getTime() !== y?.getTime(), S = u?.getTime() !== b?.getTime();
					if (!x && !S || y && h9(y, a.props) || b && h9(b, a.props)) return;
					(t = (e = a.props).onChange) == null || t.call(e, [y, b], o);
				} else {
					var C = K7(p, d, a.props.locale, f, a.props.selected ?? void 0);
					(C || !p) && a.setSelected(C, o, !0);
				}
			}
		}, a.handleSelect = function(e, t, n) {
			if (!a.props.readOnly) {
				var r = a.props, i = r.selectsRange, o = r.startDate, s = r.endDate, c = r.swapRange, l = !i || o && !s && (c || !R9(e, o));
				a.props.shouldCloseOnSelect && !a.props.showTimeSelect && l && a.sendFocusBackToInput(), a.props.onChangeRaw && a.props.onChangeRaw(t), a.setSelected(e, t, !1, n), a.props.showDateSelect && a.setState({ isRenderAriaLiveMessage: !0 }), !a.props.shouldCloseOnSelect || a.props.showTimeSelect ? a.setPreSelection(e) : l && a.setOpen(!1);
			}
		}, a.setSelected = function(e, t, n, r) {
			var i, o, s = e;
			if (a.props.showYearPicker) {
				if (s !== null && x9(J5(s), a.props)) return;
			} else if (a.props.showMonthYearPicker) {
				if (s !== null && _9(s, a.props)) return;
			} else if (s !== null && h9(s, a.props)) return;
			var c = a.props, l = c.onChange, u = c.selectsRange, d = c.startDate, f = c.endDate, p = c.selectsMultiple, m = c.selectedDates, h = c.minTime, g = c.swapRange;
			if (!l9(a.props.selected, s) || a.props.allowSameDay || u || p) if (s !== null && (a.props.selected && (!n || !a.props.showTimeSelect && !a.props.showTimeSelectOnly && !a.props.showTimeInput) && (s = Z7(s, {
				hour: U5(a.props.selected),
				minute: W5(a.props.selected),
				second: K5(a.props.selected)
			})), !n && (a.props.showTimeSelect || a.props.showTimeSelectOnly) && h && (s = Z7(s, {
				hour: h.getHours(),
				minute: h.getMinutes(),
				second: h.getSeconds()
			})), a.props.inline || a.setState({ preSelection: s }), a.props.focusSelectedMonth || a.setState({ monthSelectedIn: r })), u) {
				var _ = !d && !f, v = d && !f, y = !d && !!f, b = d && f;
				_ ? l?.([s, null], t) : v ? s === null ? l?.([null, null], t) : R9(s, d) ? g ? l?.([s, d], t) : l?.([s, null], t) : l?.([d, s], t) : y && (s && R9(s, f) ? l?.([s, f], t) : l?.([s, null], t)), b && l?.([s, null], t);
			} else if (p) {
				if (s !== null) if (!m?.length) l?.([s], t);
				else if (m.some(function(e) {
					return c9(e, s);
				})) {
					var x = m.filter(function(e) {
						return !c9(e, s);
					});
					l?.(x, t);
				} else l?.(z7(z7([], m, !0), [s], !1), t);
			} else l?.(s, t);
			n || ((o = (i = a.props).onSelect) == null || o.call(i, s, t), a.setState({ inputValue: null }));
		}, a.setPreSelection = function(e) {
			if (!a.props.readOnly) {
				var t = c5(a.props.minDate), n = c5(a.props.maxDate), r = !0;
				if (e) {
					var i = Q7(e);
					if (t && n) r = u9(e, a.props.minDate, a.props.maxDate);
					else if (t) {
						var o = Q7(a.props.minDate);
						r = Y5(e, o) || l9(i, o);
					} else if (n) {
						var s = i9(a.props.maxDate);
						r = X5(e, s) || l9(i, s);
					}
				}
				r && a.setState({ preSelection: e });
			}
		}, a.toggleCalendar = function() {
			a.setOpen(!a.state.open);
		}, a.handleTimeChange = function(e) {
			var t, n;
			if (!(a.props.selectsRange || a.props.selectsMultiple)) {
				var r = a.props.selected ? a.props.selected : a.getPreSelection(), i = a.props.selected ? e : Z7(r, {
					hour: U5(e),
					minute: W5(e)
				});
				a.setState({ preSelection: i }), (n = (t = a.props).onChange) == null || n.call(t, i), a.props.shouldCloseOnSelect && !a.props.showTimeInput && (a.sendFocusBackToInput(), a.setOpen(!1)), a.props.showTimeInput && a.setOpen(!0), (a.props.showTimeSelectOnly || a.props.showTimeSelect) && a.setState({ isRenderAriaLiveMessage: !0 }), a.setState({ inputValue: null });
			}
		}, a.onInputClick = function() {
			var e, t;
			!a.props.disabled && !a.props.readOnly && a.setOpen(!0), (t = (e = a.props).onInputClick) == null || t.call(e);
		}, a.onInputKeyDown = function(e) {
			var t, n, r, i, o;
			(n = (t = a.props).onKeyDown) == null || n.call(t, e);
			var s = e.key;
			if (!a.state.open && !a.props.inline && !a.props.preventOpenOnFocus) {
				(s === H7.ArrowDown || s === H7.ArrowUp || s === H7.Enter) && ((r = a.onInputClick) == null || r.call(a));
				return;
			}
			if (a.state.open) {
				if (s === H7.ArrowDown || s === H7.ArrowUp) {
					e.preventDefault();
					var c = a.props.showTimeSelectOnly ? ".react-datepicker__time-list-item[tabindex='0']" : a.props.showWeekPicker && a.props.showWeekNumbers ? ".react-datepicker__week-number[tabindex=\"0\"]" : a.props.showFullMonthYearPicker || a.props.showMonthYearPicker ? ".react-datepicker__month-text[tabindex=\"0\"]" : ".react-datepicker__day[tabindex=\"0\"]", l = a.calendar?.containerRef.current instanceof Element && a.calendar.containerRef.current.querySelector(c);
					l instanceof HTMLElement && l.focus({ preventScroll: !0 });
					return;
				}
				var u = G7(a.state.preSelection);
				s === H7.Enter ? (e.preventDefault(), e.target.blur(), a.inputOk() && a.state.lastPreSelectChange === X9 ? (a.handleSelect(u, e), !a.props.shouldCloseOnSelect && a.setPreSelection(u)) : a.setOpen(!1)) : s === H7.Escape ? (e.preventDefault(), e.target.blur(), a.sendFocusBackToInput(), a.setOpen(!1)) : s === H7.Tab && a.setOpen(!1), a.inputOk() || (o = (i = a.props).onInputError) == null || o.call(i, {
					code: 1,
					msg: Y9
				});
			}
		}, a.onPortalKeyDown = function(e) {
			e.key === H7.Escape && (e.preventDefault(), a.setState({ preventFocus: !0 }, function() {
				a.setOpen(!1), setTimeout(function() {
					a.setFocus(), a.setState({ preventFocus: !1 });
				});
			}));
		}, a.onDayKeyDown = function(e) {
			var t, n, r, i, o, s, c = a.props, l = c.minDate, u = c.maxDate, d = c.disabledKeyboardNavigation, f = c.showWeekPicker, p = c.shouldCloseOnSelect, m = c.locale, h = c.calendarStartDay, g = c.adjustDateOnChange, _ = c.inline;
			if ((n = (t = a.props).onKeyDown) == null || n.call(t, e), !d) {
				var v = e.key, y = e.shiftKey, b = G7(a.state.preSelection), x = function(e, t) {
					var n = t;
					switch (e) {
						case H7.ArrowRight:
							n = f ? i5(t, 1) : G8(t, 1);
							break;
						case H7.ArrowLeft:
							n = f ? T7(t, 1) : ise(t, 1);
							break;
						case H7.ArrowUp:
							n = T7(t, 1);
							break;
						case H7.ArrowDown:
							n = i5(t, 1);
							break;
						case H7.PageUp:
							n = y ? E7(t, 1) : C7(t, 1);
							break;
						case H7.PageDown:
							n = y ? a5(t, 1) : K8(t, 1);
							break;
						case H7.Home:
							n = $7(t, m, h);
							break;
						case H7.End:
							n = Xse(t);
							break;
					}
					return n;
				}, S = function(e, t) {
					for (var n = 40, r = e, i = !1, o = 0, s = x(e, t); !i;) {
						if (o >= n) {
							s = t;
							break;
						}
						l && s < l && (r = H7.ArrowRight, s = h9(l, a.props) ? x(r, s) : l), u && s > u && (r = H7.ArrowLeft, s = h9(u, a.props) ? x(r, s) : u), h9(s, a.props) ? ((r === H7.PageUp || r === H7.Home) && (r = H7.ArrowRight), (r === H7.PageDown || r === H7.End) && (r = H7.ArrowLeft), s = x(r, s)) : i = !0, o++;
					}
					return s;
				};
				if (v === H7.Enter) {
					e.preventDefault(), a.handleSelect(b, e), !p && a.setPreSelection(b);
					return;
				} else if (v === H7.Escape) {
					e.preventDefault(), a.setOpen(!1), a.inputOk() || (i = (r = a.props).onInputError) == null || i.call(r, {
						code: 1,
						msg: Y9
					});
					return;
				}
				var C = null;
				switch (v) {
					case H7.ArrowLeft:
					case H7.ArrowRight:
					case H7.ArrowUp:
					case H7.ArrowDown:
					case H7.PageUp:
					case H7.PageDown:
					case H7.Home:
					case H7.End:
						C = S(v, b);
						break;
				}
				if (!C) {
					(s = (o = a.props).onInputError) == null || s.call(o, {
						code: 1,
						msg: Y9
					});
					return;
				}
				if (e.preventDefault(), a.setState({ lastPreSelectChange: X9 }), g && a.setSelected(C), a.setPreSelection(C), _) {
					var w = G5(b), T = G5(C), E = J5(b), D = J5(C);
					w !== T || E !== D ? a.setState({ shouldFocusDayInline: !0 }) : a.setState({ shouldFocusDayInline: !1 });
				}
			}
		}, a.onPopperKeyDown = function(e) {
			e.key === H7.Escape && (e.preventDefault(), a.sendFocusBackToInput(), a.setOpen(!1));
		}, a.onClearClick = function(e) {
			e && e.preventDefault && e.preventDefault(), a.sendFocusBackToInput();
			var t = a.props, n = t.selectsRange, r = t.onChange;
			n ? r?.([null, null], e) : r?.(null, e), a.setState({ inputValue: null });
		}, a.clear = function() {
			a.onClearClick();
		}, a.onScroll = function(e) {
			typeof a.props.closeOnScroll == "boolean" && a.props.closeOnScroll ? (e.target === document || e.target === document.documentElement || e.target === document.body) && a.setOpen(!1) : typeof a.props.closeOnScroll == "function" && a.props.closeOnScroll(e) && a.setOpen(!1);
		}, a.renderCalendar = function() {
			return !a.props.inline && !a.isCalendarOpen() ? null : t.createElement(Ace, R7({
				showMonthYearDropdown: void 0,
				ref: function(e) {
					a.calendar = e;
				}
			}, a.props, a.state, {
				setOpen: a.setOpen,
				dateFormat: a.props.dateFormatCalendar ?? n.defaultProps.dateFormatCalendar,
				onSelect: a.handleSelect,
				onClickOutside: a.handleCalendarClickOutside,
				holidays: cce(a.modifyHolidays()),
				outsideClickIgnoreClass: a.props.outsideClickIgnoreClass,
				onDropdownFocus: a.handleDropdownFocus,
				onTimeChange: a.handleTimeChange,
				className: a.props.calendarClassName,
				container: a.props.calendarContainer,
				handleOnKeyDown: a.props.onKeyDown,
				handleOnDayKeyDown: a.onDayKeyDown,
				setPreSelection: a.setPreSelection,
				dropdownMode: a.props.dropdownMode ?? n.defaultProps.dropdownMode
			}), a.props.children);
		}, a.renderAriaLiveRegion = function() {
			var e = a.props.locale, r = a.props.dateFormat ?? n.defaultProps.dateFormat, i = a.props.showTimeInput || a.props.showTimeSelect ? "PPPPp" : "PPPP", o = a.props.selectsRange ? `Selected start date: ${Y7(a.props.startDate, {
				dateFormat: i,
				locale: e
			})}. ${a.props.endDate ? "End date: " + Y7(a.props.endDate, {
				dateFormat: i,
				locale: e
			}) : ""}` : a.props.showTimeSelectOnly ? `Selected time: ${Y7(a.props.selected, {
				dateFormat: r,
				locale: e
			})}` : a.props.showYearPicker ? `Selected year: ${Y7(a.props.selected, {
				dateFormat: "yyyy",
				locale: e
			})}` : a.props.showMonthYearPicker ? `Selected month: ${Y7(a.props.selected, {
				dateFormat: "MMMM yyyy",
				locale: e
			})}` : a.props.showQuarterYearPicker ? `Selected quarter: ${Y7(a.props.selected, {
				dateFormat: "yyyy, QQQ",
				locale: e
			})}` : `Selected date: ${Y7(a.props.selected, {
				dateFormat: i,
				locale: e
			})}`;
			return t.createElement("span", {
				role: "alert",
				"aria-live": "polite",
				className: "react-datepicker__aria-live"
			}, o);
		}, a.renderDateInput = function() {
			var e, r, o = L8(a.props.className, (e = {}, e[a.props.outsideClickIgnoreClass || n.defaultProps.outsideClickIgnoreClass] = a.state.open, e)), s = a.props.customInput || t.createElement("input", { type: "text" }), c = a.props.customInputRef || "ref";
			return i(s, (r = {}, r[c] = function(e) {
				a.input = e;
			}, r.value = a.getInputValue(), r.onBlur = a.handleBlur, r.onChange = a.handleChange, r.onClick = a.onInputClick, r.onFocus = a.handleFocus, r.onKeyDown = a.onInputKeyDown, r.id = a.props.id, r.name = a.props.name, r.form = a.props.form, r.autoFocus = a.props.autoFocus, r.placeholder = a.props.placeholderText, r.disabled = a.props.disabled, r.autoComplete = a.props.autoComplete, r.className = L8(s.props.className, o), r.title = a.props.title, r.readOnly = a.props.readOnly, r.required = a.props.required, r.tabIndex = a.props.tabIndex, r["aria-describedby"] = a.props.ariaDescribedBy, r["aria-invalid"] = a.props.ariaInvalid, r["aria-labelledby"] = a.props.ariaLabelledBy, r["aria-required"] = a.props.ariaRequired, r));
		}, a.renderClearButton = function() {
			var e = a.props, n = e.isClearable, r = e.disabled, i = e.selected, o = e.startDate, s = e.endDate, c = e.clearButtonTitle, l = e.clearButtonClassName, u = l === void 0 ? "" : l, d = e.ariaLabelClose, f = d === void 0 ? "Close" : d, p = e.selectedDates, m = e.readOnly;
			return n && !m && (i != null || o != null || s != null || p?.length) ? t.createElement("button", {
				type: "button",
				className: L8("react-datepicker__close-icon", u, { "react-datepicker__close-icon--disabled": r }),
				disabled: r,
				"aria-label": f,
				onClick: a.onClearClick,
				title: c,
				tabIndex: -1
			}) : null;
		}, a.state = a.calcInitialState(), a.preventFocusTimeout = void 0, a;
	}
	return Object.defineProperty(n, "defaultProps", {
		get: function() {
			return {
				allowSameDay: !1,
				dateFormat: "MM/dd/yyyy",
				dateFormatCalendar: "LLLL yyyy",
				disabled: !1,
				disabledKeyboardNavigation: !1,
				dropdownMode: "scroll",
				preventOpenOnFocus: !1,
				monthsShown: 1,
				outsideClickIgnoreClass: K9,
				readOnly: !1,
				rangeSeparator: X7,
				withPortal: !1,
				selectsDisabledDaysInRange: !1,
				shouldCloseOnSelect: !0,
				showTimeSelect: !1,
				showTimeInput: !1,
				showPreviousMonths: !1,
				showMonthYearPicker: !1,
				showFullMonthYearPicker: !1,
				showTwoColumnMonthYearPicker: !1,
				showFourColumnMonthYearPicker: !1,
				showYearPicker: !1,
				showQuarterYearPicker: !1,
				showWeekPicker: !1,
				strictParsing: !1,
				swapRange: !1,
				timeIntervals: 30,
				timeCaption: "Time",
				previousMonthAriaLabel: "Previous Month",
				previousMonthButtonLabel: "Previous Month",
				nextMonthAriaLabel: "Next Month",
				nextMonthButtonLabel: "Next Month",
				previousYearAriaLabel: "Previous Year",
				previousYearButtonLabel: "Previous Year",
				nextYearAriaLabel: "Next Year",
				nextYearButtonLabel: "Next Year",
				timeInputLabel: "Time",
				enableTabLoop: !0,
				yearItemNumber: W7,
				focusSelectedMonth: !1,
				showPopperArrow: !0,
				excludeScrollbar: !0,
				customTimeInput: null,
				calendarStartDay: void 0,
				toggleCalendarOnIconClick: !1,
				usePointerEvent: !1
			};
		},
		enumerable: !1,
		configurable: !0
	}), n.prototype.componentDidMount = function() {
		window.addEventListener("scroll", this.onScroll, !0), document.addEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
	}, n.prototype.componentDidUpdate = function(e, t) {
		var n, r, i, a;
		e.inline && Ice(e.selected, this.props.selected) && this.setPreSelection(this.props.selected), this.state.monthSelectedIn !== void 0 && e.monthsShown !== this.props.monthsShown && this.setState({ monthSelectedIn: 0 }), e.highlightDates !== this.props.highlightDates && this.setState({ highlightDates: N9(this.props.highlightDates) }), !t.focused && !l9(e.selected, this.props.selected) && this.setState({ inputValue: null }), t.open !== this.state.open && (t.open === !1 && this.state.open === !0 && ((r = (n = this.props).onCalendarOpen) == null || r.call(n)), t.open === !0 && this.state.open === !1 && ((a = (i = this.props).onCalendarClose) == null || a.call(i)));
	}, n.prototype.componentWillUnmount = function() {
		this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0), document.removeEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
	}, n.prototype.renderInputContainer = function() {
		var e = this.props, n = e.showIcon, r = e.icon, i = e.calendarIconClassname, a = e.calendarIconClassName, o = e.toggleCalendarOnIconClick, s = this.state.open;
		return i && console.warn("calendarIconClassname props is deprecated. should use calendarIconClassName props."), t.createElement("div", { className: `react-datepicker__input-container${n ? " react-datepicker__view-calendar-icon" : ""}` }, n && t.createElement(jce, R7({
			icon: r,
			className: L8(a, !a && i, s && "react-datepicker-ignore-onclickoutside")
		}, o ? { onClick: this.toggleCalendar } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
	}, n.prototype.render = function() {
		var e = this.renderCalendar();
		if (this.props.inline) return e;
		if (this.props.withPortal) {
			var n = this.state.open ? t.createElement(J9, { enableTabLoop: this.props.enableTabLoop }, t.createElement("div", {
				className: "react-datepicker__portal",
				tabIndex: -1,
				onKeyDown: this.onPortalKeyDown
			}, e)) : null;
			return this.state.open && this.props.portalId && (n = t.createElement(q9, R7({ portalId: this.props.portalId }, this.props), n)), t.createElement("div", null, this.renderInputContainer(), n);
		}
		return t.createElement(Fce, R7({}, this.props, {
			className: this.props.popperClassName,
			hidePopper: !this.isCalendarOpen(),
			targetComponent: this.renderInputContainer(),
			popperComponent: e,
			popperOnKeyDown: this.onPopperKeyDown,
			showArrow: this.props.showPopperArrow
		}));
	}, n;
}(n), Rce = "input", X9 = "navigate", zce = /* @__PURE__ */ V(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_customParseFormat = r();
	})(e, (function() {
		var e = {
			LTS: "h:mm:ss A",
			LT: "h:mm A",
			L: "MM/DD/YYYY",
			LL: "MMMM D, YYYY",
			LLL: "MMMM D, YYYY h:mm A",
			LLLL: "dddd, MMMM D, YYYY h:mm A"
		}, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, r = /\d\d/, i = /\d\d?/, a = /\d*[^-_:/,()\s\d]+/, o = {}, s = function(e) {
			return (e = +e) + (e > 68 ? 1900 : 2e3);
		}, c = function(e) {
			return function(t) {
				this[e] = +t;
			};
		}, l = [/[+-]\d\d:?(\d\d)?|Z/, function(e) {
			(this.zone ||= {}).offset = function(e) {
				if (!e || e === "Z") return 0;
				var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
				return n === 0 ? 0 : t[0] === "+" ? -n : n;
			}(e);
		}], u = function(e) {
			var t = o[e];
			return t && (t.indexOf ? t : t.s.concat(t.f));
		}, d = function(e, t) {
			var n, r = o.meridiem;
			if (r) {
				for (var i = 1; i <= 24; i += 1) if (e.indexOf(r(i, 0, t)) > -1) {
					n = i > 12;
					break;
				}
			} else n = e === (t ? "pm" : "PM");
			return n;
		}, f = {
			A: [a, function(e) {
				this.afternoon = d(e, !1);
			}],
			a: [a, function(e) {
				this.afternoon = d(e, !0);
			}],
			Q: [n, function(e) {
				this.month = 3 * (e - 1) + 1;
			}],
			S: [n, function(e) {
				this.milliseconds = 100 * e;
			}],
			SS: [r, function(e) {
				this.milliseconds = 10 * e;
			}],
			SSS: [/\d{3}/, function(e) {
				this.milliseconds = +e;
			}],
			s: [i, c("seconds")],
			ss: [i, c("seconds")],
			m: [i, c("minutes")],
			mm: [i, c("minutes")],
			H: [i, c("hours")],
			h: [i, c("hours")],
			HH: [i, c("hours")],
			hh: [i, c("hours")],
			D: [i, c("day")],
			DD: [r, c("day")],
			Do: [a, function(e) {
				var t = o.ordinal, n = e.match(/\d+/);
				if (this.day = n[0], t) for (var r = 1; r <= 31; r += 1) t(r).replace(/\[|\]/g, "") === e && (this.day = r);
			}],
			w: [i, c("week")],
			ww: [r, c("week")],
			M: [i, c("month")],
			MM: [r, c("month")],
			MMM: [a, function(e) {
				var t = u("months"), n = (u("monthsShort") || t.map((function(e) {
					return e.slice(0, 3);
				}))).indexOf(e) + 1;
				if (n < 1) throw Error();
				this.month = n % 12 || n;
			}],
			MMMM: [a, function(e) {
				var t = u("months").indexOf(e) + 1;
				if (t < 1) throw Error();
				this.month = t % 12 || t;
			}],
			Y: [/[+-]?\d+/, c("year")],
			YY: [r, function(e) {
				this.year = s(e);
			}],
			YYYY: [/\d{4}/, c("year")],
			Z: l,
			ZZ: l
		};
		function p(n) {
			for (var r = n, i = o && o.formats, a = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (function(t, n, r) {
				var a = r && r.toUpperCase();
				return n || i[r] || e[r] || i[a].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (function(e, t, n) {
					return t || n.slice(1);
				}));
			}))).match(t), s = a.length, c = 0; c < s; c += 1) {
				var l = a[c], u = f[l], d = u && u[0], p = u && u[1];
				a[c] = p ? {
					regex: d,
					parser: p
				} : l.replace(/^\[|\]$/g, "");
			}
			return function(e) {
				for (var t = {}, n = 0, r = 0; n < s; n += 1) {
					var i = a[n];
					if (typeof i == "string") r += i.length;
					else {
						var o = i.regex, c = i.parser, l = e.slice(r), u = o.exec(l)[0];
						c.call(t, u), e = e.replace(u, "");
					}
				}
				return function(e) {
					var t = e.afternoon;
					if (t !== void 0) {
						var n = e.hours;
						t ? n < 12 && (e.hours += 12) : n === 12 && (e.hours = 0), delete e.afternoon;
					}
				}(t), t;
			};
		}
		return function(e, t, n) {
			n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (s = e.parseTwoDigitYear);
			var r = t.prototype, i = r.parse;
			r.parse = function(e) {
				var t = e.date, r = e.utc, a = e.args;
				this.$u = r;
				var s = a[1];
				if (typeof s == "string") {
					var c = !0 === a[2], l = !0 === a[3], u = c || l, d = a[2];
					l && (d = a[2]), o = this.$locale(), !c && d && (o = n.Ls[d]), this.$d = function(e, t, n, r) {
						try {
							if (["x", "X"].indexOf(t) > -1) return /* @__PURE__ */ new Date((t === "X" ? 1e3 : 1) * e);
							var i = p(t)(e), a = i.year, o = i.month, s = i.day, c = i.hours, l = i.minutes, u = i.seconds, d = i.milliseconds, f = i.zone, m = i.week, h = /* @__PURE__ */ new Date(), g = s || (a || o ? 1 : h.getDate()), _ = a || h.getFullYear(), v = 0;
							a && !o || (v = o > 0 ? o - 1 : h.getMonth());
							var y, b = c || 0, x = l || 0, S = u || 0, C = d || 0;
							return f ? new Date(Date.UTC(_, v, g, b, x, S, C + 60 * f.offset * 1e3)) : n ? new Date(Date.UTC(_, v, g, b, x, S, C)) : (y = new Date(_, v, g, b, x, S, C), m && (y = r(y).week(m).toDate()), y);
						} catch {
							return /* @__PURE__ */ new Date("");
						}
					}(t, s, r, n), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(s) && (this.$d = /* @__PURE__ */ new Date("")), o = {};
				} else if (s instanceof Array) for (var f = s.length, m = 1; m <= f; m += 1) {
					a[1] = s[m - 1];
					var h = n.apply(this, a);
					if (h.isValid()) {
						this.$d = h.$d, this.$L = h.$L, this.init();
						break;
					}
					m === f && (this.$d = /* @__PURE__ */ new Date(""));
				}
				else i.call(this, e);
			};
		};
	}));
})), Bce = /* @__PURE__ */ V(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs = r();
	})(e, (function() {
		var e = 1e3, t = 6e4, n = 36e5, r = "millisecond", i = "second", a = "minute", o = "hour", s = "day", c = "week", l = "month", u = "quarter", d = "year", f = "date", p = "Invalid Date", m = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, h = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, g = {
			name: "en",
			weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
			months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
			ordinal: function(e) {
				var t = [
					"th",
					"st",
					"nd",
					"rd"
				], n = e % 100;
				return "[" + e + (t[(n - 20) % 10] || t[n] || t[0]) + "]";
			}
		}, _ = function(e, t, n) {
			var r = String(e);
			return !r || r.length >= t ? e : "" + Array(t + 1 - r.length).join(n) + e;
		}, v = {
			s: _,
			z: function(e) {
				var t = -e.utcOffset(), n = Math.abs(t), r = Math.floor(n / 60), i = n % 60;
				return (t <= 0 ? "+" : "-") + _(r, 2, "0") + ":" + _(i, 2, "0");
			},
			m: function e(t, n) {
				if (t.date() < n.date()) return -e(n, t);
				var r = 12 * (n.year() - t.year()) + (n.month() - t.month()), i = t.clone().add(r, l), a = n - i < 0, o = t.clone().add(r + (a ? -1 : 1), l);
				return +(-(r + (n - i) / (a ? i - o : o - i)) || 0);
			},
			a: function(e) {
				return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
			},
			p: function(e) {
				return {
					M: l,
					y: d,
					w: c,
					d: s,
					D: f,
					h: o,
					m: a,
					s: i,
					ms: r,
					Q: u
				}[e] || String(e || "").toLowerCase().replace(/s$/, "");
			},
			u: function(e) {
				return e === void 0;
			}
		}, y = "en", b = {};
		b[y] = g;
		var x = "$isDayjsObject", S = function(e) {
			return e instanceof E || !(!e || !e[x]);
		}, C = function e(t, n, r) {
			var i;
			if (!t) return y;
			if (typeof t == "string") {
				var a = t.toLowerCase();
				b[a] && (i = a), n && (b[a] = n, i = a);
				var o = t.split("-");
				if (!i && o.length > 1) return e(o[0]);
			} else {
				var s = t.name;
				b[s] = t, i = s;
			}
			return !r && i && (y = i), i || !r && y;
		}, w = function(e, t) {
			if (S(e)) return e.clone();
			var n = typeof t == "object" ? t : {};
			return n.date = e, n.args = arguments, new E(n);
		}, T = v;
		T.l = C, T.i = S, T.w = function(e, t) {
			return w(e, {
				locale: t.$L,
				utc: t.$u,
				x: t.$x,
				$offset: t.$offset
			});
		};
		var E = function() {
			function g(e) {
				this.$L = C(e.locale, null, !0), this.parse(e), this.$x = this.$x || e.x || {}, this[x] = !0;
			}
			var _ = g.prototype;
			return _.parse = function(e) {
				this.$d = function(e) {
					var t = e.date, n = e.utc;
					if (t === null) return /* @__PURE__ */ new Date(NaN);
					if (T.u(t)) return /* @__PURE__ */ new Date();
					if (t instanceof Date) return new Date(t);
					if (typeof t == "string" && !/Z$/i.test(t)) {
						var r = t.match(m);
						if (r) {
							var i = r[2] - 1 || 0, a = (r[7] || "0").substring(0, 3);
							return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a);
						}
					}
					return new Date(t);
				}(e), this.init();
			}, _.init = function() {
				var e = this.$d;
				this.$y = e.getFullYear(), this.$M = e.getMonth(), this.$D = e.getDate(), this.$W = e.getDay(), this.$H = e.getHours(), this.$m = e.getMinutes(), this.$s = e.getSeconds(), this.$ms = e.getMilliseconds();
			}, _.$utils = function() {
				return T;
			}, _.isValid = function() {
				return this.$d.toString() !== p;
			}, _.isSame = function(e, t) {
				var n = w(e);
				return this.startOf(t) <= n && n <= this.endOf(t);
			}, _.isAfter = function(e, t) {
				return w(e) < this.startOf(t);
			}, _.isBefore = function(e, t) {
				return this.endOf(t) < w(e);
			}, _.$g = function(e, t, n) {
				return T.u(e) ? this[t] : this.set(n, e);
			}, _.unix = function() {
				return Math.floor(this.valueOf() / 1e3);
			}, _.valueOf = function() {
				return this.$d.getTime();
			}, _.startOf = function(e, t) {
				var n = this, r = !!T.u(t) || t, u = T.p(e), p = function(e, t) {
					var i = T.w(n.$u ? Date.UTC(n.$y, t, e) : new Date(n.$y, t, e), n);
					return r ? i : i.endOf(s);
				}, m = function(e, t) {
					return T.w(n.toDate()[e].apply(n.toDate("s"), (r ? [
						0,
						0,
						0,
						0
					] : [
						23,
						59,
						59,
						999
					]).slice(t)), n);
				}, h = this.$W, g = this.$M, _ = this.$D, v = "set" + (this.$u ? "UTC" : "");
				switch (u) {
					case d: return r ? p(1, 0) : p(31, 11);
					case l: return r ? p(1, g) : p(0, g + 1);
					case c:
						var y = this.$locale().weekStart || 0, b = (h < y ? h + 7 : h) - y;
						return p(r ? _ - b : _ + (6 - b), g);
					case s:
					case f: return m(v + "Hours", 0);
					case o: return m(v + "Minutes", 1);
					case a: return m(v + "Seconds", 2);
					case i: return m(v + "Milliseconds", 3);
					default: return this.clone();
				}
			}, _.endOf = function(e) {
				return this.startOf(e, !1);
			}, _.$set = function(e, t) {
				var n, c = T.p(e), u = "set" + (this.$u ? "UTC" : ""), p = (n = {}, n[s] = u + "Date", n[f] = u + "Date", n[l] = u + "Month", n[d] = u + "FullYear", n[o] = u + "Hours", n[a] = u + "Minutes", n[i] = u + "Seconds", n[r] = u + "Milliseconds", n)[c], m = c === s ? this.$D + (t - this.$W) : t;
				if (c === l || c === d) {
					var h = this.clone().set(f, 1);
					h.$d[p](m), h.init(), this.$d = h.set(f, Math.min(this.$D, h.daysInMonth())).$d;
				} else p && this.$d[p](m);
				return this.init(), this;
			}, _.set = function(e, t) {
				return this.clone().$set(e, t);
			}, _.get = function(e) {
				return this[T.p(e)]();
			}, _.add = function(r, u) {
				var f, p = this;
				r = Number(r);
				var m = T.p(u), h = function(e) {
					var t = w(p);
					return T.w(t.date(t.date() + Math.round(e * r)), p);
				};
				if (m === l) return this.set(l, this.$M + r);
				if (m === d) return this.set(d, this.$y + r);
				if (m === s) return h(1);
				if (m === c) return h(7);
				var g = (f = {}, f[a] = t, f[o] = n, f[i] = e, f)[m] || 1, _ = this.$d.getTime() + r * g;
				return T.w(_, this);
			}, _.subtract = function(e, t) {
				return this.add(-1 * e, t);
			}, _.format = function(e) {
				var t = this, n = this.$locale();
				if (!this.isValid()) return n.invalidDate || p;
				var r = e || "YYYY-MM-DDTHH:mm:ssZ", i = T.z(this), a = this.$H, o = this.$m, s = this.$M, c = n.weekdays, l = n.months, u = n.meridiem, d = function(e, n, i, a) {
					return e && (e[n] || e(t, r)) || i[n].slice(0, a);
				}, f = function(e) {
					return T.s(a % 12 || 12, e, "0");
				}, m = u || function(e, t, n) {
					var r = e < 12 ? "AM" : "PM";
					return n ? r.toLowerCase() : r;
				};
				return r.replace(h, (function(e, r) {
					return r || function(e) {
						switch (e) {
							case "YY": return String(t.$y).slice(-2);
							case "YYYY": return T.s(t.$y, 4, "0");
							case "M": return s + 1;
							case "MM": return T.s(s + 1, 2, "0");
							case "MMM": return d(n.monthsShort, s, l, 3);
							case "MMMM": return d(l, s);
							case "D": return t.$D;
							case "DD": return T.s(t.$D, 2, "0");
							case "d": return String(t.$W);
							case "dd": return d(n.weekdaysMin, t.$W, c, 2);
							case "ddd": return d(n.weekdaysShort, t.$W, c, 3);
							case "dddd": return c[t.$W];
							case "H": return String(a);
							case "HH": return T.s(a, 2, "0");
							case "h": return f(1);
							case "hh": return f(2);
							case "a": return m(a, o, !0);
							case "A": return m(a, o, !1);
							case "m": return String(o);
							case "mm": return T.s(o, 2, "0");
							case "s": return String(t.$s);
							case "ss": return T.s(t.$s, 2, "0");
							case "SSS": return T.s(t.$ms, 3, "0");
							case "Z": return i;
						}
						return null;
					}(e) || i.replace(":", "");
				}));
			}, _.utcOffset = function() {
				return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
			}, _.diff = function(r, f, p) {
				var m, h = this, g = T.p(f), _ = w(r), v = (_.utcOffset() - this.utcOffset()) * t, y = this - _, b = function() {
					return T.m(h, _);
				};
				switch (g) {
					case d:
						m = b() / 12;
						break;
					case l:
						m = b();
						break;
					case u:
						m = b() / 3;
						break;
					case c:
						m = (y - v) / 6048e5;
						break;
					case s:
						m = (y - v) / 864e5;
						break;
					case o:
						m = y / n;
						break;
					case a:
						m = y / t;
						break;
					case i:
						m = y / e;
						break;
					default: m = y;
				}
				return p ? m : T.a(m);
			}, _.daysInMonth = function() {
				return this.endOf(l).$D;
			}, _.$locale = function() {
				return b[this.$L];
			}, _.locale = function(e, t) {
				if (!e) return this.$L;
				var n = this.clone(), r = C(e, t, !0);
				return r && (n.$L = r), n;
			}, _.clone = function() {
				return T.w(this.$d, this);
			}, _.toDate = function() {
				return new Date(this.valueOf());
			}, _.toJSON = function() {
				return this.isValid() ? this.toISOString() : null;
			}, _.toISOString = function() {
				return this.$d.toISOString();
			}, _.toString = function() {
				return this.$d.toUTCString();
			}, g;
		}(), D = E.prototype;
		return w.prototype = D, [
			["$ms", r],
			["$s", i],
			["$m", a],
			["$H", o],
			["$W", s],
			["$M", l],
			["$y", d],
			["$D", f]
		].forEach((function(e) {
			D[e[1]] = function(t) {
				return this.$g(t, e[0], e[1]);
			};
		})), w.extend = function(e, t) {
			return e.$i ||= (e(t, E, w), !0), w;
		}, w.locale = C, w.isDayjs = S, w.unix = function(e) {
			return w(1e3 * e);
		}, w.en = b[y], w.Ls = b, w.p = {}, w;
	}));
})), Vce = /* @__PURE__ */ xt(zce(), 1), Z9 = /* @__PURE__ */ xt(Bce(), 1), Hce = /*#__PURE__*/ Ft("div")({
	name: "CalendarActionsGroupContainer",
	class: "canpgep",
	propsAsIs: !1
}), Uce = /*#__PURE__*/ Ft("div")({
	name: "CalendarHeaderContainer",
	class: "c26uzq8",
	propsAsIs: !1
}), Wce = /*#__PURE__*/ Ft("h1")({
	name: "CalendarHeaderTitle",
	class: "c13ad9vl",
	propsAsIs: !1
}), Gce = "d1397god", Q9 = Object.assign(({ className: e, ...t }) => /* @__PURE__ */ F(Re, {
	className: Ct(Gce, e),
	...t
}), {
	ErrorText: Re.ErrorText,
	Label: Re.Label,
	HelpText: Re.HelpText
}), Kce = ({ onClearDate: e, onSelectToday: t, children: n, ...r }) => /* @__PURE__ */ I(B7, {
	...r,
	children: [/* @__PURE__ */ F("div", {
		style: { position: "relative" },
		children: n
	}), /* @__PURE__ */ I(Hce, { children: [/* @__PURE__ */ F(z, {
		size: "medium",
		onClick: e,
		variant: "tertiary",
		useLinkStyle: !0,
		hasNoPadding: !0,
		children: "Clear"
	}), /* @__PURE__ */ F(z, {
		size: "medium",
		onClick: t,
		variant: "tertiary",
		useLinkStyle: !0,
		hasNoPadding: !0,
		children: "Today"
	})] })]
}), qce = ({ date: e, increaseMonth: t, decreaseMonth: n, nextMonthButtonDisabled: r, prevMonthButtonDisabled: i }) => /* @__PURE__ */ I(Uce, { children: [
	/* @__PURE__ */ F(Wce, { children: (0, Z9.default)(e).format("MMMM YYYY") }),
	/* @__PURE__ */ F(z, {
		size: "medium",
		onClick: n,
		disabled: i,
		variant: "tertiary",
		hasNoPadding: !0,
		type: "button",
		"aria-label": "Previous month",
		children: /* @__PURE__ */ F(lt, { fontSize: "1.5rem" })
	}),
	/* @__PURE__ */ F(z, {
		size: "medium",
		onClick: t,
		disabled: r,
		variant: "tertiary",
		hasNoPadding: !0,
		type: "button",
		"aria-label": "Next month",
		children: /* @__PURE__ */ F(ut, { fontSize: "1.5rem" })
	})
] });
//#endregion
//#region src/date-picker/index.tsx
Z9.default.extend(Vce.default);
var $9 = (e, t) => e ? (0, Z9.default)(e, t).toDate() : null, Jce = t.forwardRef(({ onChange: e, dateFormat: n = "DD/MM/YYYY", label: r, errorMessage: i, className: a, selected: o, value: s, placeholderText: c = "Select date", ...l }, u) => {
	let [d, f] = t.useState(o ?? $9(s, "DD/MM/YYYY")), p = t.useRef(null);
	t.useImperativeHandle(u, () => p.current, []);
	let m = t.useMemo(() => typeof n == "string" ? n : n[0], [n]), h = (t) => {
		if (!t) return f(null), e?.(l.selectsMultiple ? [] : "");
		if (Array.isArray(t)) return e?.(t.map((e) => (0, Z9.default)(e).format(m)));
		e?.((0, Z9.default)(t).format(m)), f(t);
	}, g = () => {
		p.current?.toggleCalendar(), h(null);
	}, _ = () => {
		p.current?.toggleCalendar(), h(/* @__PURE__ */ new Date());
	};
	return /* @__PURE__ */ I(Q9, { children: [
		r && /* @__PURE__ */ F(Q9.Label, { children: r }),
		/* @__PURE__ */ F(Lce, {
			ref: p,
			selected: d,
			dateFormat: "dd/MM/yyyy",
			onChange: h,
			icon: /* @__PURE__ */ F(dt, {
				color: "inherit",
				size: "sm"
			}),
			showIcon: !0,
			popperPlacement: "bottom-start",
			onChangeRaw: (e) => {
				let t = e.target.value, n = (0, Z9.default)(t, "DD/MM/YYYY", !0);
				if (n?.isValid()) {
					let e = n.toDate();
					f(e), h(e);
				}
			},
			calendarContainer: (e) => /* @__PURE__ */ F(Kce, {
				onClearDate: g,
				onSelectToday: _,
				...e
			}),
			renderCustomHeader: (e) => /* @__PURE__ */ F(qce, { ...e }),
			className: Ct("el-input", i && "el-has-input-error", a),
			placeholderText: c,
			...l
		}),
		i && /* @__PURE__ */ F(Q9.ErrorText, {
			id: `${r}-error`,
			children: i
		})
	] });
}), Yce = "e3htjtf", Xce = ({ className: e, children: t, ...n }) => /* @__PURE__ */ F(ft, {
	className: Ct(e, Yce),
	...n,
	children: t
}), Zce = /*#__PURE__*/ Ft("header")({
	name: "ElFragmentNavigation",
	class: "e4uojt9",
	propsAsIs: !1
}), Qce = /*#__PURE__*/ Ft("div")({
	name: "ElFragmentNavigationContentContainer",
	class: "e8x5r66",
	propsAsIs: !1
}), $ce = ({ children: e, ...t }) => /* @__PURE__ */ F(Zce, {
	...t,
	children: /* @__PURE__ */ F(Qce, { children: e })
}), ele = /*#__PURE__*/ Ft("div")({
	name: "TextRight",
	class: "tif2j6k",
	propsAsIs: !1
});
//#endregion
export { za as AddSignature, wt as BrandLogo, Dte as ButtonDropdown, an as ButtonGroup, Ht as CanvasSignature, Xa as Card, Za as CardAction, Ya as CardBodyAdditionalContent, Ja as CardBodyContent, Ka as CardBodySectionWrapper, qa as CardBodyTitle, Ga as CardBodyWrapper, Wa as CardHeader, Cae as Checkbox, Jce as DatePicker, Fa as DialogConfirmation, on as DialogExitAgreement, wa as DialogSignature, Pa as DialogSubmitAgreement, Wt as DialogWrapper, Ote as Drawer, hv as Dropdown, Cv as DropdownButton, yv as DropdownContainer, T_ as DropdownContentItems, bv as DropdownModal, xv as DropdownModalContent, Sv as DropdownTrigger, to as FormIcon, Xce as FormLayout, qo as FormSectionDivider, $ce as FragmentNavigation, h_ as Input, Xl as InputArray, __ as InputCurrency, j_ as InputDuration, Jo as InputFieldGroup, Go as InputFile, g_ as InputGroup, k_ as InputSearch, qt as LoadingSkeleton, fae as PDFTable, Kt as PageWrapper, dae as PdfDocument, F8 as PdfStyle, Et as ReapitMark, ao as RenderHTML, zg as Select, Vg as SelectAsync, N_ as TabContent, Cte as Table, Mv as TableCellCustom, Ste as TableCellSplit, jv as TableHeader, Bv as TableRow, Dv as TableToolbar, lv as Tabs, ele as TextRight, f_ as Tooltip, Vt as calculateScaledSize, bo as elBgTransparent, mo as elBorderBottomLight, Po as elBreakWord, Lo as elButtonGhost, Mo as elColorWhite, go as elCursorDefault, ho as elCursorPointer, ko as elGridGap1, jo as elGridNewRow, Yt as elHFit, Zt as elHFitImportant, po as elHasNoBorder, yo as elJustifySelfCenter, _o as elJustifySelfEnd, vo as elJustifySelfStart, fo as elMb4, uo as elMt4, Co as elOverflowAuto, xo as elOverflowHidden, Eo as elOverflowVisible, wo as elOverflowXAuto, Do as elOverflowXVisible, To as elOverflowYAuto, Oo as elOverflowYVisible, co as elP0Important, lo as elPx9, so as elPy4, oo as elPy9, Io as elTextNoWrap, Fo as elTextPlaceholder, Ao as elTextStart, So as elTileHasError, No as elUnorderedList, Xt as elWFit, Qt as elWFitImportant, $9 as getDateSelected, P8 as initializePdfFonts, Ra as useBaseImage, Na as useDialogSubmitAgreement, vv as useDropdown, _v as useDropdownContext, ro as useDynamicReapitIconImport, no as useDynamicSvgImport };
